/* ===== versoes de css/pages (gerado pelo build) ===== */
window.__ZDVAL_CSS_V = {"academy.css":"c362ce2a","analise.css":"b85e2da8","antitactic-legacy.css":"e3d3e1ba","antitactic-main.css":"edd8fa37","antitactic.css":"1bc43aba","app-modals.css":"d48b986d","home-play.css":"2e19be9e","lineups.css":"bd77751e","map-picker.css":"e7bb580f","maps-manager.css":"3252cbe9","ranked.css":"0f1b5653","settings-map-icons.css":"a45e81e2","tactics.css":"dd4e43ce","team-modals.css":"45c36279","valoplant-icons.css":"e9b0fe5c","valoplant-v2.css":"77eb489b"};

/* ===== js/security.js ===== */
// =====================================================
// ZDVAL - Security Utilities
// Provides sanitization and validation functions
// =====================================================

const SecurityUtils = {
  // Sanitize text to prevent XSS
  escapeHtml(text) {
    if (typeof text !== 'string') return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  },

  // Validate and sanitize URLs
  sanitizeUrl(url) {
    if (!url || typeof url !== 'string') return '';
    
    const trimmedUrl = url.trim();
    
    // Allow only safe protocols
    const safeProtocols = ['http:', 'https:', '/'];
    const isRelative = trimmedUrl.startsWith('/') && !trimmedUrl.startsWith('//');
    
    if (isRelative) {
      // Relative URLs are safe
      return trimmedUrl;
    }
    
    try {
      const parsed = new URL(trimmedUrl);
      if (!['http:', 'https:'].includes(parsed.protocol)) {
        console.warn('Blocked unsafe URL protocol:', parsed.protocol);
        return '';
      }
      return trimmedUrl;
    } catch (e) {
      // Not a valid URL
      return '';
    }
  },

  // Validate YouTube/Vimeo/Twitch URLs for embeds
  validateEmbedUrl(url) {
    if (!url || typeof url !== 'string') return { valid: false, sanitized: '' };
    
    const sanitized = this.sanitizeUrl(url);
    if (!sanitized) return { valid: false, sanitized: '' };
    
    // Allowed embed domains
    const allowedDomains = [
      'youtube.com',
      'www.youtube.com',
      'youtu.be',
      'youtube-nocookie.com',
      'www.youtube-nocookie.com',
      'vimeo.com',
      'player.vimeo.com',
      'twitch.tv',
      'www.twitch.tv',
      'clips.twitch.tv',
      'player.twitch.tv'
    ];
    
    try {
      const parsed = new URL(sanitized);
      const hostname = parsed.hostname.toLowerCase();
      
      if (allowedDomains.some(domain => hostname === domain || hostname.endsWith('.' + domain))) {
        return { valid: true, sanitized };
      }
      
      // Check if it's a local/relative URL (for uploaded videos)
      if (sanitized.startsWith('/uploads/') || sanitized.startsWith('/api/')) {
        return { valid: true, sanitized };
      }
      
      return { valid: false, sanitized: '' };
    } catch (e) {
      // For relative URLs
      if (sanitized.startsWith('/uploads/') || sanitized.startsWith('/api/')) {
        return { valid: true, sanitized };
      }
      return { valid: false, sanitized: '' };
    }
  },

  // Create safe iframe HTML
  createSafeIframe(embedUrl, options = {}) {
    const { valid, sanitized } = this.validateEmbedUrl(embedUrl);
    
    if (!valid) {
      console.warn('Blocked invalid embed URL:', embedUrl);
      return '<div class="embed-error">URL de embed inválida</div>';
    }
    
    const allowAttrs = options.allow || 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    const className = options.className || 'video-embed';
    const sandbox = options.sandbox || 'allow-scripts allow-same-origin allow-presentation allow-popups';
    
    // Use textContent-safe attribute setting
    const iframe = document.createElement('iframe');
    iframe.src = sanitized;
    iframe.className = className;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', allowAttrs);
    iframe.setAttribute('sandbox', sandbox);
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    
    return iframe.outerHTML;
  },

  // Validate file upload
  validateFileUpload(file, options = {}) {
    const {
      maxSize = 10 * 1024 * 1024, // 10MB default
      allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
      allowedExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.gif']
    } = options;
    
    const errors = [];
    
    if (!file) {
      return { valid: false, errors: ['Nenhum arquivo selecionado'] };
    }
    
    // Check file size
    if (file.size > maxSize) {
      errors.push(`Arquivo muito grande. Máximo: ${Math.round(maxSize / 1024 / 1024)}MB`);
    }
    
    // Check MIME type
    if (!allowedTypes.includes(file.type)) {
      errors.push(`Tipo de arquivo não permitido: ${file.type}`);
    }
    
    // Check extension
    const ext = '.' + file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(ext)) {
      errors.push(`Extensão não permitida: ${ext}`);
    }
    
    return {
      valid: errors.length === 0,
      errors
    };
  },

  // Sanitize input for search/filter
  sanitizeInput(input, options = {}) {
    if (typeof input !== 'string') return '';
    
    const {
      maxLength = 200,
      allowedChars = /[a-zA-Z0-9\s\-_@.#]/g
    } = options;
    
    return input
      .slice(0, maxLength)
      .match(allowedChars)?.join('') || '';
  },

  // Generate CSRF-like token for forms
  generateFormToken() {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
  }
};

// Make available globally
window.SecurityUtils = SecurityUtils;


/* ===== js/map-catalog.js ===== */
// =====================================================
// ZDVAL — catalogo de mapas do frontend
//
// Espelha backend/config/mapImages.js. Os UUIDs estavam copiados a mao em
// cinco lugares do frontend (vpro/vpro.js, js/valoplant-v2.js,
// js/analise/format.js, js/ranked.js, js/maps.js), e a copia ja tinha
// divergido: format.js rotulava "corrode" com o UUID do Split, e vpro.js nao
// conhecia o Summit. Uma lista so, e um teste no backend que falha se as duas
// sairem de sincronia (config/mapImages.test.js).
//
// Por que uma copia e nao a resposta da API: /vpro e um app separado, que nao
// carrega o bundle nem o cliente de API; e varias telas precisam da URL da
// imagem antes de qualquer requisicao terminar.
// =====================================================

const MapCatalog = {
  BASE: 'https://media.valorant-api.com/maps',

  UUIDS: {
    abyss: '224b0a95-48b9-f703-1bd8-67aca101a61f',
    ascent: '7eaecc1b-4337-bbf6-6ab9-04b8f06b3319',
    bind: '2c9d57ec-4431-9c5e-2939-8f9ef6dd5cba',
    breeze: '2fb9a4fd-47b8-4e7d-a969-74b4046ebd53',
    corrode: '1c18ab1f-420d-0d8b-71d0-77ad3c439115',
    fracture: 'b529448b-4d60-346e-e89e-00a4c527a405',
    haven: '2bee0dc9-4ffe-519b-1cbd-7fbe763a6047',
    icebox: 'e2ad5c54-4114-a870-9641-8ea21279579a',
    lotus: '2fe4ed3a-450a-948b-6d6b-e89a78e680a9',
    pearl: 'fd267378-4d1d-484f-ff52-77821ed10dc2',
    split: 'd960549e-485c-e861-8d71-aa9d1aed12a2',
    sunset: '92584fbe-486a-b1b2-9faa-39b0f486b498',
    summit: '756da597-416b-c0f2-f47b-afbdf28670bc'
  },

  /** 'Ascent', ' ascent ', 'ASCENT' → 'ascent'. Devolve '' se nao for mapa. */
  chave(nome) {
    const k = String(nome || '').trim().toLowerCase();
    return this.UUIDS[k] ? k : '';
  },

  uuid(nome) {
    const k = this.chave(nome);
    return k ? this.UUIDS[k] : null;
  },

  /** Arte clara e nitida (1920x1080 a 3840x2160, 1,5 a 6,9 MB). Uma por tela. */
  splash(nome) {
    const u = this.uuid(nome);
    return u ? `${this.BASE}/${u}/splash.png` : '';
  },

  /** Variante 2560x1440 por ~400 KB, porem escura — serve de fundo, nao de card claro. */
  card(nome) {
    const u = this.uuid(nome);
    return u ? `${this.BASE}/${u}/stylizedbackgroundimage.png` : '';
  },

  /** 456x100, ~60 KB. Miniatura de lista. */
  listViewIcon(nome) {
    const u = this.uuid(nome);
    return u ? `${this.BASE}/${u}/listviewicon.png` : '';
  },

  /** Desenho do mapa visto de cima, fundo transparente. */
  minimap(nome) {
    const u = this.uuid(nome);
    return u ? `${this.BASE}/${u}/displayicon.png` : '';
  },

  /** Nomes em minusculas, na ordem alfabetica da tabela. */
  nomes() {
    return Object.keys(this.UUIDS);
  },

  /** Nomes como o jogo exibe: Ascent, Bind, ... */
  nomesExibiveis() {
    return this.nomes().map((n) => n.charAt(0).toUpperCase() + n.slice(1));
  }
};

if (typeof window !== 'undefined') window.MapCatalog = MapCatalog;
if (typeof module !== 'undefined' && module.exports) module.exports = MapCatalog;


/* ===== js/utils.js ===== */
// =====================================================
// ZDVAL - Shared Utilities
// Common functions used across multiple modules
// =====================================================

const Utils = {
  /**
   * URL de uma imagem da valorant-api reduzida pelo proxy do backend.
   *
   * Os arquivos de la sao grandes demais para o tamanho em que o site desenha:
   * retrato de agente vem em 1024 px e 400-600 KB para um card de 86 px, e
   * splash de mapa chega a 3840 px e 6,9 MB para uma miniatura de 156 px.
   * O proxy corta na largura pedida e devolve WebP com cache em disco.
   *
   * Nao trocar o splash pelo `stylizedbackgroundimage` para economizar: aquela
   * variante e a que a Riot usa atras de UI, com brilho medio 32 contra 129 do
   * splash — os cards ficam escuros e sem cor.
   *
   * `largura` tem de estar na lista aceita pela rota: 64, 96, 128, 192, 256,
   * 384 ou 512. URL de outra origem volta como veio.
   */
  imagemReduzida(url, largura) {
    if (!url || !String(url).startsWith('https://media.valorant-api.com/')) return url || '';
    return `/api/img?w=${largura}&u=${encodeURIComponent(url)}`;
  },

  // =====================================================
  // CSS DE PAGINA (carregado sob demanda)
  // =====================================================

  /**
   * Injeta a folha de uma pagina uma unica vez, com cache-busting.
   *
   * Nove folhas em css/pages/ eram injetadas por JS em 17 pontos diferentes,
   * todas com o mesmo bloco de cinco linhas copiado e **nenhuma** com `?v=`.
   * O servidor manda `Cache-Control: max-age=7d, immutable` no estatico, e
   * `immutable` significa que o navegador nao revalida dentro desse prazo:
   * uma correcao de CSS simplesmente nao chegava a quem tinha visitado o site
   * nos ultimos sete dias. A versao vem de window.__ZDVAL_CSS_V, que o
   * build.js preenche com o hash de conteudo de cada arquivo.
   *
   * Fora do bundle (o painel admin carrega alguns scripts soltos) o mapa nao
   * existe e o link sai sem versao — o mesmo comportamento de antes.
   */
  loadPageCss(id, arquivo) {
    const existente = document.getElementById(id);
    if (existente) return existente;

    const versao = (typeof window !== 'undefined' && window.__ZDVAL_CSS_V)
      ? window.__ZDVAL_CSS_V[arquivo]
      : null;

    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    // Folha criada por script nao segura a primeira pintura sozinha; enquanto o
    // documento ainda esta sendo parseado, blocking="render" evita o flash de
    // tela crua (ver o mesmo atributo no bloco inline do build).
    if (document.readyState === 'loading') link.setAttribute('blocking', 'render');
    link.href = `/css/pages/${arquivo}${versao ? `?v=${versao}` : ''}`;
    document.head.appendChild(link);
    return link;
  },

  /**
   * Injeta as folhas da rota e resolve quando elas ja estao aplicadas.
   *
   * loadPageCss() cria o <link> e volta na hora; os modulos de pagina
   * renderizavam o HTML na linha seguinte, com a folha ainda na rede, e a tela
   * aparecia crua por alguns frames a cada troca de pagina. No F5 isso nao
   * acontecia porque o build injeta o <link> da rota de entrada dentro do
   * <head>, que bloqueia a primeira pintura — o bug era so na navegacao SPA.
   *
   * O mapa rota -> folhas e o mesmo page-css.json que o build embute no <head>
   * (window.__ZDVAL_PAGE_CSS), entao nao existe segunda lista pra manter em dia.
   * As chamadas de loadPageCss espalhadas pelos modulos viram no-op: o id ja
   * existe quando elas rodam.
   */
  pageCssReady(page) {
    const mapa = (typeof window !== 'undefined' && window.__ZDVAL_PAGE_CSS) || {};

    // link.sheet so fica preenchido depois que a folha e aplicada.
    const pendentes = (mapa[page] || [])
      .map(([id, arquivo]) => this.loadPageCss(id, arquivo))
      .filter((link) => link && !link.sheet);

    if (!pendentes.length) return Promise.resolve();

    // ponytail: teto de 1.5s pra folha travada na rede — a pagina abre crua em
    // vez de nunca abrir. Se um dia isso disparar de verdade, o certo e mostrar
    // erro de rede, nao esperar mais.
    return Promise.race([
      Promise.all(pendentes.map((link) => new Promise((pronto) => {
        link.addEventListener('load', pronto, { once: true });
        link.addEventListener('error', pronto, { once: true });
      }))),
      new Promise((pronto) => setTimeout(pronto, 1500)),
    ]);
  },

  // =====================================================
  // DATE & TIME
  // =====================================================

  formatDate(date) {
    if (!date) return '';
    return new Date(date).toLocaleDateString('pt-BR');
  },

  formatDateTime(date) {
    if (!date) return '';
    return new Date(date).toLocaleString('pt-BR');
  },

  formatRelativeTime(date) {
    const now = new Date();
    const then = new Date(date);
    const diff = Math.floor((now - then) / 1000);

    if (diff < 60) return 'Agora mesmo';
    if (diff < 3600) return `Há ${Math.floor(diff / 60)} minutos`;
    if (diff < 86400) return `Há ${Math.floor(diff / 3600)} horas`;
    if (diff < 604800) return `Há ${Math.floor(diff / 86400)} dias`;
    return then.toLocaleDateString('pt-BR');
  },

  // =====================================================
  // VIDEO & MEDIA
  // =====================================================

  isVideoUrl(url) {
    if (!url) return false;
    const videoPatterns = [
      /youtube\.com/i,
      /youtu\.be/i,
      /vimeo\.com/i,
      /twitch\.tv/i,
      /\.mp4($|\?)/i,
      /\.webm($|\?)/i,
      /\.mov($|\?)/i,
      /\.ogg($|\?)/i
    ];
    return videoPatterns.some(pattern => pattern.test(url));
  },

  getVideoThumbnail(url) {
    if (!url) return null;

    // YouTube
    const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([\w-]+)/);
    if (youtubeMatch) {
      return `https://img.youtube.com/vi/${youtubeMatch[1]}/mqdefault.jpg`;
    }

    return null;
  },

  parseVideoUrl(url) {
    if (!url) return null;

    // YouTube Shorts
    const shortsMatch = url.match(/youtube\.com\/shorts\/([\w-]+)/);
    if (shortsMatch) {
      return {
        type: 'youtube-shorts',
        id: shortsMatch[1],
        thumbnail: `https://img.youtube.com/vi/${shortsMatch[1]}/maxresdefault.jpg`,
        embedUrl: `https://www.youtube.com/embed/${shortsMatch[1]}`,
        watchUrl: url
      };
    }

    // YouTube (watch, youtu.be)
    const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
    if (youtubeMatch) {
      return {
        type: 'youtube',
        id: youtubeMatch[1],
        thumbnail: `https://img.youtube.com/vi/${youtubeMatch[1]}/maxresdefault.jpg`,
        embedUrl: `https://www.youtube.com/embed/${youtubeMatch[1]}`,
        watchUrl: `https://www.youtube.com/watch?v=${youtubeMatch[1]}`
      };
    }

    // Twitch Clip
    const twitchClipMatch = url.match(/clips\.twitch\.tv\/([\w-]+)/);
    if (twitchClipMatch) {
      return {
        type: 'twitch',
        id: twitchClipMatch[1],
        thumbnail: null,
        embedUrl: `https://clips.twitch.tv/embed?clip=${twitchClipMatch[1]}&parent=${window.location.hostname}`,
        watchUrl: url
      };
    }

    // Direct video file
    if (url.match(/\.(mp4|webm|ogg)($|\?)/i) ||
        url.includes('r2.cloudflarestorage.com') ||
        url.includes('r2.dev') ||
        url.startsWith('/uploads/')) {
      return {
        type: 'direct',
        id: null,
        thumbnail: null,
        embedUrl: url,
        watchUrl: url
      };
    }

    return { type: 'unknown', embedUrl: url, watchUrl: url };
  },

  getVideoPlayer(url, height = 350) {
    if (!url) return '';

    // YouTube
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      let embedUrl = url;
      if (url.includes('watch?v=')) {
        embedUrl = url.replace('watch?v=', 'embed/');
      } else if (url.includes('youtu.be/')) {
        embedUrl = url.replace('youtu.be/', 'youtube.com/embed/');
      } else if (url.includes('/shorts/')) {
        embedUrl = url.replace('/shorts/', '/embed/');
      }

      return `
        <iframe 
          width="100%" 
          height="${height}" 
          src="${embedUrl}" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen>
        </iframe>
      `;
    }

    // Direct video
    return `
      <video controls style="width:100%; max-height:${height}px;">
        <source src="${url}">
      </video>
    `;
  }
};

// Make globally accessible
window.Utils = Utils;

console.log('🔧 Utils.js loaded - Shared utilities');


/* ===== js/components/map-picker.js ===== */
/* =====================================================
   ZDVAL — Seletor de mapa (componente compartilhado)

   Banner do mapa atual + dropdown com a grade dos demais mapas +
   botoes de lado. /lineups e /planner tinham duas implementacoes do
   mesmo componente, com markup e CSS proprios (.lu-map-* de um lado,
   .vp2-panel-map-* do outro). Este modulo e a unica fonte do markup;
   o estilo mora em css/pages/map-picker.css.

   As paginas continuam donas do estado e dos handlers: cada uma passa
   `onSelect`/`onBannerClick` como expressao JS (atributo onclick) ou
   omite e usa delegacao de evento no proprio container.
   ===================================================== */
(function () {
  'use strict';

  const esc = (v) => String(v == null ? '' : v)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

  // Atributo de evento so entra quando a pagina pede. Sem isso o markup
  // fica inerte de proposito, pra quem usa listener delegado.
  const on = (handler) => (handler ? ` onclick="${esc(handler)}"` : '');

  const MapPicker = {
    /** Conteudo interno do banner (imagem + nome + check). */
    slide(map) {
      if (!map) return '';
      return `
      <img src="${esc(map.image)}" alt="${esc(map.name)}" decoding="async">
      <div class="lu-map-banner-overlay">
        <span class="lu-map-banner-name">${esc(map.name)}</span>
        <div class="lu-map-selected-check" aria-hidden="true"><i class="fas fa-check"></i></div>
      </div>`;
    },

    /**
     * Banner do mapa selecionado.
     * @param {{map, id, onClick, open, emptyLabel}} opts
     */
    banner({ map, id = 'luMapBanner', onClick = '', open = false, emptyLabel = 'Selecione um Mapa' } = {}) {
      const cls = [
        'lu-map-banner',
        map ? 'lu-map-banner-selected' : '',
        open ? 'lu-map-dropdown-open' : ''
      ].filter(Boolean).join(' ');

      const inner = map
        ? `<div class="lu-map-banner-slide active">${this.slide(map)}</div>`
        : `<div class="lu-map-banner-empty"><i class="fas fa-map-marked-alt"></i> ${esc(emptyLabel)}</div>`;

      return `<div class="${cls}" id="${esc(id)}"${on(onClick)}>${inner}</div>`;
    },

    /** Itens da grade — o mapa atual fica de fora, ja esta no banner. */
    items({ maps = [], selectedId = null, onSelect = null } = {}) {
      return (Array.isArray(maps) ? maps : [])
        .filter((m) => m && m.id !== selectedId)
        .map((m) => `
      <div class="lu-map-item" data-id="${esc(m.id)}" data-map="${esc(m.id)}"${on(onSelect ? onSelect(m) : '')}>
        <img src="${esc(m.thumb || m.image)}" alt="${esc(m.name)}"
             width="240" height="110" loading="lazy" decoding="async">
        <div class="lu-map-item-info">
          <span class="lu-map-item-name">${esc(m.name)}</span>
        </div>
      </div>`)
        .join('');
    },

    /** Painel do dropdown, com a grade dentro. */
    dropdown({ maps = [], selectedId = null, onSelect = null, open = false, id = null } = {}) {
      return `
      <div class="lu-map-dropdown-panel${open ? ' open' : ''}"${id ? ` id="${esc(id)}"` : ''}>
        <div class="lu-map-grid">${this.items({ maps, selectedId, onSelect })}</div>
      </div>`;
    },

    /**
     * Troca o mapa do banner com a transicao de slide: o antigo sai pela
     * esquerda enquanto o novo entra pela direita. Vive aqui porque as duas
     * paginas trocam de mapa e a animacao e do componente, nao da pagina.
     */
    swap(banner, map) {
      if (!banner) return;
      banner.classList.add('lu-map-banner-selected');

      const oldSlide = banner.querySelector('.lu-map-banner-slide');
      const newSlide = document.createElement('div');
      newSlide.className = 'lu-map-banner-slide entering';
      newSlide.innerHTML = this.slide(map);
      banner.appendChild(newSlide);

      // Dois frames: o primeiro aplica o estado inicial, o segundo anima.
      requestAnimationFrame(() => {
        if (oldSlide) {
          oldSlide.classList.remove('active');
          oldSlide.classList.add('exiting');
        }
        requestAnimationFrame(() => {
          newSlide.classList.remove('entering');
          newSlide.classList.add('active');
        });
      });

      setTimeout(() => {
        if (oldSlide) oldSlide.remove();
        banner.querySelector('.lu-map-banner-empty')?.remove();
      }, 500);
    },

    /** Par de botoes Ataque/Defesa. */
    sideControls({ side = 'attack', onSelect = null, labels = {}, label = 'Selecionar lado' } = {}) {
      const btn = (value, text) => {
        const active = side === value;
        const handler = onSelect ? onSelect(value) : '';
        return `
        <button class="lu-map-side-btn ${value}${active ? ' active' : ''}" type="button"
                data-side="${value}" aria-pressed="${active ? 'true' : 'false'}"${on(handler)}>
          ${esc(text)}
        </button>`;
      };
      return `
      <div class="lu-map-side-controls" role="group" aria-label="${esc(label)}">
        ${btn('attack', labels.attack || 'Attacking')}
        ${btn('defense', labels.defense || 'Defending')}
      </div>`;
    }
  };

  window.MapPicker = MapPicker;
})();


/* ===== js/api.js ===== */
// =====================================================
// ZDVAL - API Service
// Handles all HTTP requests to the backend
// =====================================================

class API {
  constructor() {
    this.baseURL = '/api';
    this.refreshPromise = null;
  }

  // O token vive no storage, nao num campo copiado no construtor: quem entra
  // depois desta instancia nascer (o login do /admin, outra aba, o refresh)
  // passa a valer na proxima requisicao sem ninguem precisar sincronizar nada.
  get token() {
    try {
      return localStorage.getItem('zdval_token') || sessionStorage.getItem('zdval_token');
    } catch (_) {
      return null;
    }
  }

  set token(value) {
    try {
      if (value) {
        localStorage.setItem('zdval_token', value);
      } else {
        localStorage.removeItem('zdval_token');
        sessionStorage.removeItem('zdval_token');
      }
    } catch (_) { /* storage indisponivel (modo privado): segue sem token */ }
  }

  async sleep(ms) {
    await new Promise(resolve => setTimeout(resolve, ms));
  }

  isTransientNetworkError(error) {
    return error?.message === 'Failed to fetch'
      || error?.name === 'TypeError'
      || error?.name === 'AbortError'
      || error?.code === 'REQUEST_TIMEOUT'
      || error?.code === 'INVALID_SERVER_RESPONSE';
  }

  // Set auth token
  setToken(token) {
    this.token = token;
  }

  clearSession() {
    this.setToken(null);
    localStorage.removeItem('zdval_refresh_token');
  }

  // Get headers
  getHeaders(includeAuth = true) {
    const headers = {
      'Content-Type': 'application/json'
    };
    if (includeAuth && this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }
    return headers;
  }

  // Generic request method
  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const controller = !options.signal && options.timeoutMs ? new AbortController() : null;
    const timeoutId = controller
      ? setTimeout(() => controller.abort(), options.timeoutMs)
      : null;
    const config = {
      headers: this.getHeaders(options.auth !== false),
      cache: 'no-store', // Avoid 304 responses causing empty body issues
      signal: options.signal || controller?.signal,
      ...options
    };

    try {
      const response = await fetch(url, config);
      
      // Read response as text first, then try to parse as JSON
      const text = await response.text();
      let data;
      
      // Handle empty responses (can happen with 304 or other cached responses)
      if (!text || text.trim() === '') {
        // For empty responses on success status, return empty success object
        if (response.ok) {
          return { success: true, data: {} };
        }
        const emptyResponseError = new Error('Resposta vazia do servidor');
        emptyResponseError.code = 'EMPTY_SERVER_RESPONSE';
        throw emptyResponseError;
      }
      
      try {
        data = JSON.parse(text);
      } catch (jsonError) {
        // If parsing fails, likely HTML was returned
        if (text.startsWith('<')) {
          console.error('Server returned HTML instead of JSON:', text.substring(0, 200));
          const invalidResponseError = new Error('Resposta inválida do servidor');
          invalidResponseError.code = 'INVALID_SERVER_RESPONSE';
          invalidResponseError.status = response.status;
          throw invalidResponseError;
        } else {
          console.error('Failed to parse JSON:', text.substring(0, 200));
          throw new Error('Falha ao analisar resposta do servidor');
        }
      }

      // Auto-retry on 429 (rate limit) — wait then retry once
      if (response.status === 429 && !options._rateLimitRetried) {
        const retryAfter = parseInt(response.headers.get('Retry-After') || '2', 10);
        const wait = Math.min(Math.max(retryAfter, 1), 5) * 1000;
        await this.sleep(wait);
        return this.request(endpoint, { ...options, _rateLimitRetried: true });
      }

      if (!response.ok) {
        // Handle token expiration - try to refresh
        if (response.status === 401 && !options.isRetry && !options.skipAuthRefresh) {
          const refreshed = await this.tryRefreshToken();
          if (refreshed) {
            // Retry original request with new token
            return this.request(endpoint, {
              ...options,
              isRetry: true,
              skipAuthRefresh: true
            });
          }
          // Refresh failed, don't reload - let auth handle it
          this.clearSession();
          throw new Error(data.message || 'Sessão expirada');
        }

        if (response.status === 401) {
          this.clearSession();
        }
        // `code` e `status` viajam junto: quem chama precisa distinguir falha
        // real de recusa esperada (ex.: RSO_CONSENT_REQUIRED, que não é erro —
        // é ausência de autorização do jogador).
        const requestError = new Error(
          data.error || data.message || (data.errors && data.errors.length ? data.errors.map(e => e.msg).join(', ') : null) || 'Erro na requisição'
        );
        requestError.status = response.status;
        requestError.code = data.code || null;
        throw requestError;
      }

      return data;
    } catch (error) {
      if (error?.name === 'AbortError') {
        error = new Error('Tempo limite excedido');
        error.code = 'REQUEST_TIMEOUT';
      }

      const retryCount = Number.isFinite(options.retryCount) ? options.retryCount : 0;
      const shouldRetryInvalidResponse = options.retryOnInvalidResponse && error?.code === 'INVALID_SERVER_RESPONSE';
      if ((config.method || 'GET') === 'GET' && retryCount > 0 && (this.isTransientNetworkError(error) || shouldRetryInvalidResponse)) {
        await this.sleep(options.retryDelay ?? 350);
        return this.request(endpoint, {
          ...options,
          retryCount: retryCount - 1,
          retryDelay: options.retryDelay ?? 350
        });
      }

      if (!options.silent) {
        console.error(`API Error [${endpoint}]:`, error);
      }
      throw error;
    } finally {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    }
  }

  // Try to refresh the access token
  async tryRefreshToken() {
    const refreshToken = localStorage.getItem('zdval_refresh_token');
    if (!refreshToken) return false;

    if (this.refreshPromise) {
      return this.refreshPromise;
    }

    this.refreshPromise = (async () => {
      try {
        const response = await fetch(`${this.baseURL}/auth/refresh`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          cache: 'no-store',
          body: JSON.stringify({ refreshToken })
        });

        const data = await response.json();

        if (!response.ok) {
          this.clearSession();
          return false;
        }

        if (data.success && data.data.accessToken) {
          this.setToken(data.data.accessToken);
          if (data.data.refreshToken) {
            localStorage.setItem('zdval_refresh_token', data.data.refreshToken);
          }
          return true;
        }

        this.clearSession();
        return false;
      } catch (error) {
        console.error('Token refresh failed:', error);
        this.clearSession();
        return false;
      } finally {
        this.refreshPromise = null;
      }
    })();

    return this.refreshPromise;
  }

  // GET request
  async get(endpoint, options = {}) {
    return this.request(endpoint, { method: 'GET', ...options });
  }

  // POST request
  async post(endpoint, body, options = {}) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(body),
      ...options
    });
  }

  // PUT request
  async put(endpoint, body, options = {}) {
    return this.request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(body),
      ...options
    });
  }

  // DELETE request
  async delete(endpoint, options = {}) {
    return this.request(endpoint, { method: 'DELETE', ...options });
  }

  // Upload file (alias: uploadFile)
  async upload(endpoint, formData, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const headers = {};
    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }

    const controller = !options.signal && options.timeoutMs ? new AbortController() : null;
    const timeoutId = controller
      ? setTimeout(() => controller.abort(), options.timeoutMs)
      : null;

    const fetchOptions = { ...options };
    delete fetchOptions.timeoutMs;
    if (controller) delete fetchOptions.signal;

    try {
      const response = await fetch(url, {
        method: options.method || 'POST',
        headers,
        body: formData,
        cache: 'no-store',
        signal: options.signal || controller?.signal,
        ...fetchOptions
      });

      const text = await response.text();
      let data = {};
      if (text && text.trim() !== '') {
        try {
          data = JSON.parse(text);
        } catch (_) {
          throw new Error('Resposta inválida do servidor');
        }
      }

      if (!response.ok) {
        throw new Error(data.message || 'Erro no upload');
      }

      return data;
    } catch (error) {
      if (error?.name === 'AbortError') {
        const timeoutError = new Error('Tempo limite excedido');
        timeoutError.code = 'REQUEST_TIMEOUT';
        throw timeoutError;
      }
      console.error(`Upload Error [${endpoint}]:`, error);
      throw error;
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
    }
  }

  // Alias for upload (used by pov.js and others)
  async uploadFile(endpoint, formData, options = {}) {
    // Strip /api prefix if provided (upload() adds it)
    const cleanEndpoint = endpoint.startsWith('/api') ? endpoint.substring(4) : endpoint;
    return this.upload(cleanEndpoint, formData, options);
  }

  // =====================================================
  // AUTH ENDPOINTS
  // =====================================================


  // Login por senha — sem uso desde a migração pra código por email
  // (requestEmailCode/verifyEmailCode abaixo). Mantido no código, sem
  // chamador no frontend; a rota correspondente também segue viva no
  // backend, só não é mais acionada por aqui.
  async login(email, password) {
    const data = await this.post('/auth/login', { login: email, password }, { auth: false });
    if (data.success && data.data.accessToken) {
      this.setToken(data.data.accessToken);
      if (data.data.refreshToken) {
        localStorage.setItem('zdval_refresh_token', data.data.refreshToken);
      }
    }
    return data;
  }

  // Cadastro por senha — mesma situação do login acima, sem uso.
  async register(displayName, email, password) {
    // Auto-generate username from display_name (lowercase, alphanumeric + underscore only)
    const username = displayName.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '').substring(0, 50) || 'user_' + Date.now();
    const data = await this.post('/auth/register', { username, display_name: displayName, email, password }, { auth: false });
    if (data.success && data.data.accessToken) {
      this.setToken(data.data.accessToken);
      if (data.data.refreshToken) {
        localStorage.setItem('zdval_refresh_token', data.data.refreshToken);
      }
    }
    return data;
  }

  async requestEmailCode(email) {
    return this.post('/auth/email/request-code', { email }, { auth: false });
  }

  async verifyEmailCode(email, code) {
    const data = await this.post('/auth/email/verify-code', { email, code }, { auth: false });
    if (data.success && data.data.accessToken) {
      this.setToken(data.data.accessToken);
      if (data.data.refreshToken) {
        localStorage.setItem('zdval_refresh_token', data.data.refreshToken);
      }
    }
    return data;
  }

  async refreshToken() {
    const refreshToken = localStorage.getItem('zdval_refresh_token');
    if (!refreshToken) throw new Error('No refresh token');
    
    const data = await this.post('/auth/refresh', { refreshToken }, { auth: false });
    if (data.success && data.data.accessToken) {
      this.setToken(data.data.accessToken);
    }
    return data;
  }

  async getProfile() {
    return this.get('/auth/me');
  }

  async updateProfile(updates) {
    return this.put('/auth/profile', updates);
  }

  async disconnectRiotAccount() {
    return this.post('/auth/disconnect-riot', {});
  }

  async uploadAvatar(formData) {
    return this.upload('/upload/avatar', formData);
  }

  async uploadProfileCover(formData, options = {}) {
    return this.upload('/upload/profile-cover', formData, options);
  }

  async uploadMemberAvatar(teamId, memberId, formData) {
    return this.upload(`/teams/${teamId}/members/${memberId}/avatar`, formData);
  }

  async uploadTeamLogo(teamId, formData) {
    return this.upload(`/upload/team-logo/${teamId}`, formData);
  }

  // =====================================================
  // TEAM ENDPOINTS
  // =====================================================

  async getMyTeams() {
    return this.get('/teams');
  }

  async getTeam(teamId) {
    return this.get(`/teams/${teamId}`);
  }

  async createTeam(teamData) {
    return this.post('/teams', teamData);
  }

  async updateTeam(teamId, updates) {
    return this.put(`/teams/${teamId}`, updates);
  }

  async deleteTeam(teamId) {
    return this.delete(`/teams/${teamId}`);
  }

  async getTeamMembers(teamId) {
    return this.get(`/teams/${teamId}/members`);
  }

  async getTeamRoster(teamId) {
    return this.get(`/teams/${teamId}/roster`);
  }

  async generateInviteCode(teamId) {
    return this.post(`/teams/${teamId}/invite`);
  }

  async getTeamInviteCode(teamId) {
    return this.get(`/teams/${teamId}/invite`);
  }

  async regenerateTeamInviteCode(teamId) {
    return this.post(`/teams/${teamId}/invite/regenerate`);
  }

  async joinTeam(inviteCode) {
    return this.post('/teams/join', { invite_code: inviteCode });
  }

  async addTeamMember(teamId, data) {
    return this.post(`/teams/${teamId}/members`, data);
  }

  async updateMemberRole(teamId, userId, role) {
    return this.put(`/teams/${teamId}/members/${userId}/role`, { role });
  }

  async removeTeamMember(teamId, userId) {
    return this.delete(`/teams/${teamId}/members/${userId}`);
  }

  async leaveTeam(teamId) {
    return this.post(`/teams/${teamId}/leave`);
  }

  async transferTeamOwnership(teamId, newOwnerId) {
    return this.post(`/teams/${teamId}/transfer`, { new_owner_id: newOwnerId });
  }

  // =====================================================
  // LINEUP ENDPOINTS
  // =====================================================

  async getLineups(teamId, filters = {}) {
    // Remove null/undefined/empty values from filters
    const cleanFilters = {};
    for (const [key, value] of Object.entries(filters)) {
      if (value !== null && value !== undefined && value !== '') {
        cleanFilters[key] = value;
      }
    }
    const params = new URLSearchParams(cleanFilters).toString();
    const queryString = params ? `?${params}` : '';
    return this.get(`/lineups/team/${teamId}${queryString}`);
  }

  async getMyLineups(filters = {}) {
    const cleanFilters = {};
    for (const [key, value] of Object.entries(filters)) {
      if (value !== null && value !== undefined && value !== '') {
        cleanFilters[key] = value;
      }
    }
    const params = new URLSearchParams(cleanFilters).toString();
    const queryString = params ? `?${params}` : '';
    return this.get(`/lineups/my${queryString}`);
  }

  // Admin-curated lineups, visible to anyone (no auth required)
  async getPublicLineups(filters = {}) {
    const cleanFilters = {};
    for (const [key, value] of Object.entries(filters)) {
      if (value !== null && value !== undefined && value !== '') {
        cleanFilters[key] = value;
      }
    }
    const params = new URLSearchParams(cleanFilters).toString();
    const queryString = params ? `?${params}` : '';
    return this.get(`/lineups/public${queryString}`);
  }

  async getLineup(lineupId) {
    return this.get(`/lineups/${lineupId}`);
  }

  async createLineup(lineupData) {
    return this.post('/lineups', lineupData);
  }

  async updateLineup(lineupId, updates) {
    return this.put(`/lineups/${lineupId}`, updates);
  }

  async deleteLineup(lineupId) {
    return this.delete(`/lineups/${lineupId}`);
  }

  // Admin-curated (public) lineup CRUD — requires super_admin role
  async createAdminLineup(lineupData) {
    return this.post('/lineups/admin', lineupData);
  }

  async updateAdminLineup(lineupId, updates) {
    return this.put(`/lineups/admin/${lineupId}`, updates);
  }

  async deleteAdminLineup(lineupId) {
    return this.delete(`/lineups/admin/${lineupId}`);
  }

  async uploadLineupMedia(lineupId, formData) {
    return this.upload(`/lineups/${lineupId}/upload`, formData);
  }

  async getMaps() {
    return this.get('/lineups/data/maps');
  }

  async getAgents() {
    return this.get('/lineups/data/agents');
  }

  // =====================================================
  // TACTIC ENDPOINTS
  // =====================================================

  // Folder methods
  async getTacticFolders(teamId, filters = {}) {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, v]) => v != null && v !== '')
    );
    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `/tactics/folders/${teamId}?${params}` : `/tactics/folders/${teamId}`;
    return this.get(url);
  }

  async getPersonalTacticFolders(filters = {}) {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, v]) => v != null && v !== '')
    );
    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `/tactics/folders/personal?${params}` : '/tactics/folders/personal';
    return this.get(url);
  }

  async createTacticFolder(folderData) {
    return this.post('/tactics/folders', folderData);
  }

  async updateTacticFolder(folderId, updates) {
    return this.put(`/tactics/folders/${folderId}`, updates);
  }

  async deleteTacticFolder(folderId) {
    return this.delete(`/tactics/folders/${folderId}`);
  }

  // Tactic methods
  async getTactics(teamId, filters = {}) {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, v]) => v != null && v !== '')
    );
    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `/tactics/team/${teamId}?${params}` : `/tactics/team/${teamId}`;
    return this.get(url);
  }

  async getPersonalTactics(filters = {}) {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, v]) => v != null && v !== '')
    );
    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `/tactics/personal?${params}` : '/tactics/personal';
    return this.get(url);
  }

  async getTactic(tacticId) {
    return this.get(`/tactics/${tacticId}`);
  }

  async createTactic(tacticData) {
    return this.post('/tactics', tacticData);
  }

  async updateTactic(tacticId, updates) {
    return this.put(`/tactics/${tacticId}`, updates);
  }

  async deleteTactic(tacticId) {
    return this.delete(`/tactics/${tacticId}`);
  }

  async duplicateTactic(tacticId, name) {
    return this.post(`/tactics/${tacticId}/duplicate`, { name });
  }

  // =====================================================
  // MATCH ENDPOINTS
  // =====================================================

  async getMatches(teamId, filters = {}) {
    const params = new URLSearchParams(filters).toString();
    return this.get(`/matches/team/${teamId}?${params}`);
  }

  async getMatch(matchId) {
    return this.get(`/matches/${matchId}`);
  }

  async createMatch(matchData) {
    return this.post('/matches', matchData);
  }

  async updateMatch(matchId, updates) {
    return this.put(`/matches/${matchId}`, updates);
  }

  async deleteMatch(matchId) {
    return this.delete(`/matches/${matchId}`);
  }

  async addPOV(matchId, povData) {
    return this.post(`/matches/${matchId}/pov`, povData);
  }

  async getMatchStats(teamId, days = null) {
    const params = days ? `?days=${days}` : '';
    return this.get(`/matches/team/${teamId}/stats${params}`);
  }

  async analyzeMatch(matchId) {
    return this.post(`/matches/${matchId}/analyze`);
  }

  // =====================================================
  // SCHEDULE ENDPOINTS
  // =====================================================

  async getScheduleEvents(teamId, filters = {}) {
    const params = new URLSearchParams(filters).toString();
    return this.get(`/schedule/team/${teamId}?${params}`);
  }

  async getUpcomingEvents(teamId, limit = 5) {
    return this.get(`/schedule/team/${teamId}/upcoming?limit=${limit}`);
  }

  async getWeeklySchedule(teamId, date = null) {
    const params = date ? `?date=${date}` : '';
    return this.get(`/schedule/team/${teamId}/week${params}`);
  }

  async createScheduleEvent(eventData) {
    return this.post('/schedule', eventData);
  }

  async updateScheduleEvent(eventId, updates) {
    return this.put(`/schedule/${eventId}`, updates);
  }

  async deleteScheduleEvent(eventId) {
    return this.delete(`/schedule/${eventId}`);
  }

  async respondToEvent(eventId, status) {
    return this.post(`/schedule/${eventId}/respond`, { status });
  }

  // =====================================================
  // CHAT ENDPOINTS
  // =====================================================

  async getConversations(filters = {}) {
    const params = new URLSearchParams(filters).toString();
    return this.get(`/chat?${params}`);
  }

  async createConversation(conversationData) {
    return this.post('/chat', conversationData);
  }

  async getMessages(conversationId, options = {}) {
    const params = new URLSearchParams(options).toString();
    return this.get(`/chat/${conversationId}/messages?${params}`);
  }

  async sendMessage(conversationId, content, messageType = 'text', metadata = null) {
    return this.post(`/chat/${conversationId}/messages`, { content, message_type: messageType, metadata });
  }

  async getAnnouncements(teamId, unreadOnly = false) {
    return this.get(`/chat/announcements/team/${teamId}?unread_only=${unreadOnly}`);
  }

  async createAnnouncement(announcementData) {
    return this.post('/chat/announcements', announcementData);
  }

  async markAnnouncementRead(announcementId) {
    return this.post(`/chat/announcements/${announcementId}/read`);
  }

  async getAnnouncementViews(announcementId) {
    return this.get(`/chat/announcements/${announcementId}/views`);
  }

  // =====================================================
  // KNOWLEDGE BASE ENDPOINTS
  // =====================================================

  async getKnowledgeEntries(teamId, filters = {}) {
    const params = new URLSearchParams(filters).toString();
    return this.get(`/knowledge/team/${teamId}?${params}`);
  }

  async getKnowledgeEntry(entryId) {
    return this.get(`/knowledge/${entryId}`);
  }

  async createKnowledgeEntry(entryData) {
    return this.post('/knowledge', entryData);
  }

  async updateKnowledgeEntry(entryId, updates) {
    return this.put(`/knowledge/${entryId}`, updates);
  }

  async deleteKnowledgeEntry(entryId) {
    return this.delete(`/knowledge/${entryId}`);
  }

  async searchKnowledge(teamId, query, limit = 10) {
    return this.post('/knowledge/search', { team_id: teamId, query, limit });
  }

  async getKnowledgeCategories(teamId) {
    return this.get(`/knowledge/team/${teamId}/categories`);
  }

  // =====================================================
  // LIVE SESSION ENDPOINTS
  // =====================================================

  async getLiveSessions(teamId) {
    return this.get(`/live/team/${teamId}`);
  }

  async getLiveSession(sessionId) {
    return this.get(`/live/${sessionId}`);
  }

  async createLiveSession(sessionData) {
    return this.post('/live', sessionData);
  }

  async updateLiveSessionStatus(sessionId, status) {
    return this.put(`/live/${sessionId}/status`, { status });
  }

  async joinLiveSession(sessionId, data) {
    return this.post(`/live/${sessionId}/join`, data);
  }

  async leaveLiveSession(sessionId) {
    return this.post(`/live/${sessionId}/leave`);
  }

  async updateLiveLayout(sessionId, layout, focusedPlayerId = null, config = null) {
    return this.put(`/live/${sessionId}/layout`, { layout, focused_player_id: focusedPlayerId, config });
  }

  async endLiveSession(sessionId) {
    return this.post(`/live/${sessionId}/end`);
  }

  async getLiveSessionHistory(teamId, limit = 20, offset = 0) {
    return this.get(`/live/team/${teamId}/history?limit=${limit}&offset=${offset}`);
  }

  // =====================================================
  // ANTITACTIC ENDPOINTS
  // =====================================================

  // Opponent Teams
  async getOpponents(teamId) {
    return this.get(`/antitactic/opponents/${teamId}`);
  }

  async createOpponent(data) {
    return this.post('/antitactic/opponents', data);
  }

  async updateOpponent(opponentId, data) {
    return this.put(`/antitactic/opponents/${opponentId}`, data);
  }

  async deleteOpponent(opponentId) {
    return this.delete(`/antitactic/opponents/${opponentId}`);
  }

  // Opponent Players (Análise)
  async getOpponentPlayers(opponentId) {
    return this.get(`/antitactic/players/${opponentId}`);
  }

  async createOpponentPlayer(data) {
    return this.post('/antitactic/players', data);
  }

  async updateOpponentPlayer(playerId, data) {
    return this.put(`/antitactic/players/${playerId}`, data);
  }

  async deleteOpponentPlayer(playerId) {
    return this.delete(`/antitactic/players/${playerId}`);
  }

  // Antitactic Folders
  async getAntitacticFolders(opponentId, filters = {}) {
    const params = new URLSearchParams(filters).toString();
    const url = params ? `/antitactic/folders/${opponentId}?${params}` : `/antitactic/folders/${opponentId}`;
    return this.get(url);
  }

  async createAntitacticFolder(data) {
    return this.post('/antitactic/folders', data);
  }

  async updateAntitacticFolder(folderId, data) {
    return this.put(`/antitactic/folders/${folderId}`, data);
  }

  async deleteAntitacticFolder(folderId) {
    return this.delete(`/antitactic/folders/${folderId}`);
  }

  async getAntitacticContent(folderId) {
    return this.get(`/antitactic/content/${folderId}`);
  }

  async createAntitacticContent(data) {
    return this.post('/antitactic/content', data);
  }

  async updateAntitacticContent(contentId, data) {
    return this.put(`/antitactic/content/${contentId}`, data);
  }

  async deleteAntitacticContent(contentId) {
    return this.delete(`/antitactic/content/${contentId}`);
  }

  // Map Veto
  async getVetoHistory(opponentId) {
    return this.get(`/antitactic/veto/${opponentId}`);
  }

  async saveVeto(data) {
    return this.post('/antitactic/veto', data);
  }

  async deleteVeto(vetoId) {
    return this.delete(`/antitactic/veto/${vetoId}`);
  }

  // =====================================================
  // VALORANT API ENDPOINTS
  // =====================================================

  async getValorantAccount(name, tag) {
    return this.get(`/valorant/account/${encodeURIComponent(name)}/${encodeURIComponent(tag)}`);
  }

  async getValorantMMR(region, name, tag) {
    return this.get(`/valorant/mmr/${region}/${encodeURIComponent(name)}/${encodeURIComponent(tag)}`, {
      retryCount: 1,
      retryDelay: 500,
      retryOnInvalidResponse: true,
      timeoutMs: 15000,
      silent: true
    });
  }

  async getValorantMatches(region, name, tag, mode = 'competitive', size = 20) {
    return this.get(`/valorant/matches/${region}/${encodeURIComponent(name)}/${encodeURIComponent(tag)}?mode=${mode}&size=${size}`, {
      retryCount: 2,
      retryDelay: 500,
      retryOnInvalidResponse: true,
      timeoutMs: 15000,
      silent: true
    });
  }

  async getValorantStoredMatches(region, name, tag, mode = 'competitive', size = 50, page = 1) {
    return this.get(`/valorant/stored-matches/${region}/${encodeURIComponent(name)}/${encodeURIComponent(tag)}?mode=${mode}&size=${size}&page=${page}`, {
      retryCount: 1,
      retryDelay: 500,
      timeoutMs: 20000,
      silent: true
    });
  }

  async getValorantMatch(region, matchId) {
    return this.get(`/valorant/match/${region}/${encodeURIComponent(matchId)}`, {
      retryCount: 1,
      retryDelay: 500,
      timeoutMs: 15000,
      silent: true
    });
  }

  async getValorantAgents() {
    return this.get('/valorant/agents', {
      retryCount: 1,
      retryDelay: 300,
      silent: true
    });
  }

  async getValorantMaps() {
    return this.get('/valorant/maps');
  }

  // Ranking ZDVAL — pontuação de scrim a partir dos scoreboards enviados pelos
  // usuários. Acesso livre, sem plano: não passa pelo paywall.
  async getScoutingRanking(params = {}) {
    const qs = new URLSearchParams({
      page: params.page || 1,
      limit: params.limit || 50
    });
    if (params.search) qs.set('search', params.search);
    return this.get(`/scouting/ranking?${qs.toString()}`);
  }

  async getLeaderboard(region = 'br', params = {}) {
    const qs = new URLSearchParams({
      page: params.page || 1,
      per_page: params.perPage || 50,
      ...(params.search && { search: params.search })
    });
    return this.get(`/valorant/leaderboard/${region}?${qs}`);
  }

  // =====================================================
  // VOD ANALYSIS ENDPOINTS
  // =====================================================

  async getVodAnalyses() {
    return this.get('/vod/analyses');
  }

  async getVodAnalysis(id) {
    return this.get(`/vod/analyses/${id}`);
  }

  async createVodAnalysis(data) {
    return this.post('/vod/analyses', data);
  }

  async deleteVodAnalysis(id) {
    return this.delete(`/vod/analyses/${id}`);
  }

  async getVodStatus(id) {
    return this.get(`/vod/status/${id}`);
  }
}

// Export singleton instance
const api = new API();
// Also expose on window so IIFE-scoped modules (e.g. admin panel) that
// shadow the top-level `api` identifier can still reach the singleton.
if (typeof window !== 'undefined') {
  window.api = api;
}


/* ===== js/auth.js ===== */
// =====================================================
// ZDVAL - Auth Module
// Handles user authentication and session management
// =====================================================

class Auth {
  constructor() {
    this.user = null;
    this.isAuthenticated = false;
    this._checkAuthPromise = null;
    this.authOverlay = document.getElementById('authOverlay');
    this.authStepEmail = document.getElementById('authStepEmail');
    this.authStepCode = document.getElementById('authStepCode');
    this._pendingEmail = null;
    this._resendCooldownInterval = null;

    this.init();
  }

  init() {
    // Setup event listeners
    this.setupEmailAuthFlow();
    this.setupSsoButtons();
    this.setupAuthHeaderButtons();
    this.setupAuthCloseButton();

    // Pick up tokens from an OAuth redirect (#oauth=success&at=...&rt=...)
    // before checking the session, so checkAuth() sees the fresh token.
    this.consumeOAuthRedirect();

    // Check for existing session
    this.checkAuth();
  }

  // Wire "Conta da Riot" / "Google" buttons — plain top-level redirect,
  // required for the OAuth authorization-code flow to work.
  setupSsoButtons() {
    const btnRiot = document.getElementById('btnSsoRiot');
    const btnGoogle = document.getElementById('btnSsoGoogle');
    if (btnGoogle) btnGoogle.addEventListener('click', () => { window.location.href = '/api/auth/google'; });

    if (btnRiot) {
      btnRiot.addEventListener('click', async () => {
        // Riot RSO só existe depois que a Riot aprova o app. Sem ele, logar
        // por Riot ID seria inseguro (a Henrik API confirma que o nick existe,
        // não que é seu), então o botão explica e manda vincular já logado.
        if (await this.isRiotSsoEnabled()) {
          window.location.href = '/api/auth/riot';
          return;
        }
        toast.warning(
          'Login com Riot em aprovação',
          'A Riot ainda não liberou o RSO pro zdval. Entre com Google ou email e vincule seu Riot ID no perfil.'
        );
      });
    }
  }

  // Cacheia o status do RSO — não muda dentro de uma sessão.
  async isRiotSsoEnabled() {
    if (this._riotSsoEnabled === undefined) {
      try {
        const resp = await api.get('/auth/riot/status');
        this._riotSsoEnabled = Boolean(resp?.data?.rso_enabled);
      } catch (_) {
        this._riotSsoEnabled = false;
      }
    }
    return this._riotSsoEnabled;
  }

  // Handle the redirect back from /api/auth/<provider>/callback. Params come in
  // the URL fragment so the tokens never reach the server logs.
  consumeOAuthRedirect() {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const oauth = params.get('oauth');
    if (!oauth) return;

    if (oauth === 'success') {
      const accessToken = params.get('at');
      const refreshToken = params.get('rt');
      if (accessToken) {
        api.setToken(accessToken);
        if (refreshToken) localStorage.setItem('zdval_refresh_token', refreshToken);
      }
    } else if (oauth === 'error') {
      const provider = params.get('provider');
      const reason = params.get('reason');
      const providerLabel = provider === 'riot' ? 'Riot' : provider === 'google' ? 'Google' : 'login';
      const messages = {
        not_configured: provider === 'riot'
          ? 'A Riot ainda não liberou o RSO pro zdval. Entre com Google ou email e vincule seu Riot ID no perfil.'
          : `Login com ${providerLabel} ainda não está configurado.`,
        invalid_state: 'Sessão de login expirou, tenta de novo.',
        token_exchange: `Falha ao conectar com ${providerLabel}.`,
        userinfo: `Falha ao obter dados da conta ${providerLabel}.`,
        no_email: `Sua conta ${providerLabel} não tem um email público — não dá pra usar pra login.`,
        inactive: 'Esta conta está desativada.',
        server_error: 'Erro interno ao processar o login.'
      };
      toast.error('Erro no login', messages[reason] || `Não foi possível entrar com ${providerLabel}.`);
    }

    // Clean the fragment so a refresh doesn't replay tokens/errors.
    window.history.replaceState({}, '', window.location.pathname + window.location.search);
  }

  // Get current path
  getCurrentPath() {
    return window.location.pathname;
  }

  // Navigate to URL
  navigateTo(path) {
    if (window.location.pathname !== path) {
      history.pushState({}, '', path);
    }
  }

  // Login sem senha: passo 1 pede o email e dispara o código; passo 2
  // confirma o código e entra (autocadastro transparente se o email for novo).
  setupEmailAuthFlow() {
    this.authStepEmail.addEventListener('submit', async (e) => {
      e.preventDefault();

      const email = document.getElementById('authEmailInput').value.trim();
      if (!email || !email.includes('@')) {
        toast.error('Erro', 'Informe um email válido');
        return;
      }

      const submitBtn = document.getElementById('authEmailSubmitBtn');
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<div class="spinner" style="width:20px;height:20px;border-width:2px;margin:0 auto;"></div>';

      try {
        const result = await api.requestEmailCode(email);
        if (result.success) {
          this._pendingEmail = email;
          document.getElementById('authCodeEmailLabel').textContent = email;
          document.getElementById('authCodeInput').value = '';
          this.authStepEmail.classList.remove('active');
          this.authStepCode.classList.add('active');
          document.getElementById('authCodeInput').focus();
          this._startResendCooldown();
        }
      } catch (error) {
        toast.error('Erro', error.message);
      } finally {
        submitBtn.disabled = false;
        submitBtn.innerHTML = '<i class="fas fa-arrow-right"></i><span>Continuar</span>';
      }
    });

    this.authStepCode.addEventListener('submit', async (e) => {
      e.preventDefault();

      const code = document.getElementById('authCodeInput').value.trim();
      if (code.length !== 6) {
        toast.error('Erro', 'O código tem 6 dígitos');
        return;
      }

      const submitBtn = document.getElementById('authCodeSubmitBtn');
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<div class="spinner" style="width:20px;height:20px;border-width:2px;margin:0 auto;"></div>';

      try {
        const result = await api.verifyEmailCode(this._pendingEmail, code);

        if (result.success) {
          this.user = result.data.user;
          this.isAuthenticated = true;
          this.hideAuthOverlay();
          this.updateAuthButtons();
          const redirect = this._consumePostLoginRedirect();
          if (redirect) {
            window.location.href = redirect;
            return;
          }
          this.navigateTo('/');
          app.init();
          if (result.data.created) {
            toast.success('Conta criada!', 'Bem-vindo ao ZDVAL');
          } else {
            toast.success('Bem-vindo!', `Olá, ${this.user.display_name}`);
          }
        }
      } catch (error) {
        const code = error.code;
        toast.error('Erro', error.message);
        if (code === 'NO_ACTIVE_CODE' || code === 'TOO_MANY_ATTEMPTS') {
          this._backToEmailStep();
        }
      } finally {
        submitBtn.disabled = false;
        submitBtn.innerHTML = '<i class="fas fa-sign-in-alt"></i><span>Entrar</span>';
      }
    });

    document.getElementById('authBackToEmail').addEventListener('click', () => this._backToEmailStep());

    document.getElementById('authResendBtn').addEventListener('click', async () => {
      if (!this._pendingEmail) return;
      const btn = document.getElementById('authResendBtn');
      if (btn.disabled) return;

      try {
        await api.requestEmailCode(this._pendingEmail);
        toast.info('Código reenviado', `Confira ${this._pendingEmail}`);
        this._startResendCooldown();
      } catch (error) {
        toast.error('Erro', error.message);
      }
    });
  }

  _backToEmailStep() {
    this.authStepCode.classList.remove('active');
    this.authStepEmail.classList.add('active');
    document.getElementById('authCodeInput').value = '';
    if (this._resendCooldownInterval) {
      clearInterval(this._resendCooldownInterval);
      this._resendCooldownInterval = null;
    }
  }

  _startResendCooldown() {
    const btn = document.getElementById('authResendBtn');
    let seconds = 60;
    btn.disabled = true;
    btn.textContent = `Reenviar em ${seconds}s`;

    if (this._resendCooldownInterval) clearInterval(this._resendCooldownInterval);
    this._resendCooldownInterval = setInterval(() => {
      seconds -= 1;
      if (seconds <= 0) {
        clearInterval(this._resendCooldownInterval);
        this._resendCooldownInterval = null;
        btn.disabled = false;
        btn.textContent = 'Reenviar código';
      } else {
        btn.textContent = `Reenviar em ${seconds}s`;
      }
    }, 1000);
  }

  // Check if user is already authenticated
  async checkAuth() {
    if (this._checkAuthPromise) {
      return this._checkAuthPromise;
    }

    this._checkAuthPromise = this._runCheckAuth();

    try {
      return await this._checkAuthPromise;
    } finally {
      this._checkAuthPromise = null;
    }
  }

  async _runCheckAuth() {
    const token = localStorage.getItem('zdval_token');
    const currentPath = this.getCurrentPath();

    console.log('[Auth] Checking auth, token:', !!token, 'path:', currentPath);

    // Legacy: if someone navigates to /login directly, rewrite to home
    // and open the auth modal on the login tab.
    if (currentPath === '/login') {
      this.navigateTo('/');
    }

    if (!token) {
      // No token → show public home. Do NOT force the login overlay.
      this.isAuthenticated = false;
      this.user = null;
      this.hideAuthOverlay();
      this.updateAuthButtons();
      if (typeof app !== 'undefined') {
        app.initPublic?.();
      }
      // Acesso aberto: o modal so abre quando o usuario pede (/login ou botao
      // Entrar). Nenhuma pagina forca login ao ser aberta.
      try { sessionStorage.removeItem('zdval_post_login_redirect'); } catch (_) {}
      if (currentPath === '/login') {
        this.openAuth();
      }
      return;
    }

    try {
      const result = await api.get('/auth/me', { skipAuthRefresh: true, silent: true });
      console.log('[Auth] Profile result:', result);

      if (result.success && result.data && result.data.user) {
        this.user = result.data.user;
        this.isAuthenticated = true;
        this.hideAuthOverlay();
        this.updateAuthButtons();

        // Honor a pending post-login redirect (e.g. came from /vpro/)
        const redirect = this._consumePostLoginRedirect();
        if (redirect) {
          window.location.href = redirect;
          return;
        }

        // If landed on /login, rewrite to the home (/).
        // Authenticated users keep / as the main landing page.
        if (currentPath === '/login') {
          this.navigateTo('/');
        }

        app.init();
      } else {
        // Invalid token → treat as anonymous and show home
        console.log('[Auth] Invalid profile response, falling back to public home');
        api.setToken(null);
        localStorage.removeItem('zdval_refresh_token');
        this.isAuthenticated = false;
        this.user = null;
        this.hideAuthOverlay();
        this.updateAuthButtons();
        if (typeof app !== 'undefined') app.initPublic?.();
      }
    } catch (error) {
      const refreshToken = localStorage.getItem('zdval_refresh_token');
      const hasRefreshToken = Boolean(refreshToken);
      const isExpectedExpiry = ['Sessão expirada', 'Token expirado', 'jwt expired'].includes(error?.message);

      if (hasRefreshToken) {
        console.log('[Auth] Attempting token refresh...');
        const refreshed = await api.tryRefreshToken();
        if (refreshed) {
          try {
            const retryResult = await api.get('/auth/me', { skipAuthRefresh: true, silent: true });
            if (retryResult.success && retryResult.data && retryResult.data.user) {
              this.user = retryResult.data.user;
              this.isAuthenticated = true;
              this.hideAuthOverlay();
              this.updateAuthButtons();

              if (currentPath === '/login') {
                this.navigateTo('/');
              }

              app.init();
              return;
            }
          } catch (retryError) {
            console.error('[Auth] Retry after refresh failed:', retryError);
          }
        }
      } else if (isExpectedExpiry) {
        // Expected: token expired without refresh token, fall through silently
      } else {
        console.error('[Auth] Check failed:', error);
      }

      api.setToken(null);
      localStorage.removeItem('zdval_refresh_token');
      this.isAuthenticated = false;
      this.user = null;
      this.hideAuthOverlay();
      this.updateAuthButtons();
      if (typeof app !== 'undefined') app.initPublic?.();
    }
  }

  // Show auth overlay
  showAuthOverlay() {
    this.authOverlay.classList.remove('hidden');
    this.authOverlay.setAttribute('aria-hidden', 'false');
    // /login e uma pagina (duas colunas, video); em qualquer outra rota o
    // mesmo overlay continua sendo so o cartao, por cima do conteudo.
    this.authOverlay.classList.toggle('is-login-page', window.location.pathname === '/login');
  }

  // Hide auth overlay
  hideAuthOverlay() {
    this.authOverlay.classList.add('hidden');
    this.authOverlay.classList.remove('is-login-page');
    this.authOverlay.setAttribute('aria-hidden', 'true');
    this.updateUserUI();
    if (window.location.pathname === '/login') {
      window.history.pushState({ page: 'home' }, '', '/');
    }
  }

  // Open auth overlay, always starting at the email step — não existe mais
  // conceito de aba login/cadastro separada.
  openAuth() {
    this._backToEmailStep();
    document.getElementById('authEmailInput').value = '';
    if (window.location.pathname !== '/login') {
      window.history.pushState({ page: 'login' }, '', '/login');
    }
    this.showAuthOverlay();
  }

  // Wire "Entrar" button in the header
  setupAuthHeaderButtons() {
    const btnLogin = document.getElementById('btnHeaderLogin');
    if (btnLogin) btnLogin.addEventListener('click', () => this.openAuth());
  }

  // Wire the close button on the auth modal
  setupAuthCloseButton() {
    const closeBtn = document.getElementById('authCloseBtn');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.hideAuthOverlay());
    }
    // Also close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.authOverlay && !this.authOverlay.classList.contains('hidden')) {
        this.hideAuthOverlay();
      }
    });
  }

  // Toggle header area: auth buttons vs profile dropdown
  updateAuthButtons() {
    const authBtns = document.getElementById('headerAuthButtons');
    const profile = document.getElementById('headerProfile');
    const menuToggle = document.getElementById('headerProfileMenuToggle');
    const notificationBtn = document.getElementById('notificationBtn');
    if (this.isAuthenticated) {
      if (authBtns) authBtns.style.display = 'none';
      if (profile) profile.style.display = '';
      if (notificationBtn) notificationBtn.style.display = '';
      // Hamburger menu replaced by hover-open dropdown on the profile pill.
      if (menuToggle) menuToggle.style.display = 'none';
    } else {
      if (authBtns) authBtns.style.display = '';
      if (profile) profile.style.display = 'none';
      if (notificationBtn) notificationBtn.style.display = 'none';
      if (menuToggle) menuToggle.style.display = 'none';
    }
  }

  // Pop a post-login redirect set before coming to the home page.
  // We no longer honor stale /vpro/ hints — regardless of what page the
  // user came from, we always want them to land on the home page after
  // signing in (per product decision).
  _consumePostLoginRedirect() {
    try {
      sessionStorage.removeItem('zdval_post_login_redirect');
    } catch (_) {}
    return null;
  }

  // Update user info in UI
  updateUserUI() {
    if (!this.user) return;

    const userAvatar = document.getElementById('userAvatar');
    const userName = document.getElementById('userName');
    const userRole = document.getElementById('userRole');

    if (userAvatar) {
      userAvatar.src = this.user.avatar_url || '/img/default-avatar.png';
    }

    if (userName) userName.textContent = this.user.display_name;

    // Update header profile
    const headerAvatar = document.getElementById('headerAvatar');
    const headerName = document.getElementById('headerProfileName');
    if (headerAvatar) {
      headerAvatar.src = this.user.avatar_url || '/img/default-avatar.png';
    }
    // Nome real do usuário: o /vpro sempre mostrou o display_name, e a SPA
    // fixava "Meu Perfil" — mesmo cabeçalho com dois textos diferentes.
    if (headerName) {
      headerName.textContent = this.user.display_name || this.user.username || 'Meu Perfil';
    }
  }

  // Logout
  logout() {
    try {
      api.setToken(null);
      this.user = null;
      this.isAuthenticated = false;
      localStorage.removeItem('zdval_token');
      localStorage.removeItem('zdval_refresh_token');
      localStorage.removeItem('zdval_current_team');
      if (typeof socket !== 'undefined' && socket) {
        socket.disconnect();
      }
      toast.info('Até logo!', 'Você foi desconectado');
      // Forçar redirecionamento
      setTimeout(() => {
        window.location.href = '/';
      }, 500);
    } catch (error) {
      console.error('Logout error:', error);
      // Fallback
      localStorage.clear();
      window.location.href = '/';
    }
  }

  // Get current user
  getUser() {
    return this.user;
  }
}

// Initialize auth when DOM is ready
let auth;
document.addEventListener('DOMContentLoaded', () => {
  auth = new Auth();
});


/* ===== js/socket.js ===== */
// =====================================================
// ZDVAL - Socket Module
// Handles real-time communication with Socket.IO
// =====================================================

class SocketManager {
  constructor() {
    this.socket = null;
    this.connected = false;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.listeners = new Map();
  }

  // Connect to socket server
  connect() {
    const token = localStorage.getItem('zdval_token');
    if (!token) {
      console.warn('Socket: No token available');
      return;
    }

    this.socket = io({
      auth: { token },
      reconnection: true,
      reconnectionAttempts: this.maxReconnectAttempts,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000
    });

    this.setupEventHandlers();
  }

  // Setup core event handlers
  setupEventHandlers() {
    // Connection events
    this.socket.on('connect', () => {
      console.log('Socket: Connected');
      this.connected = true;
      this.reconnectAttempts = 0;
      this.onConnected();
    });

    this.socket.on('disconnect', (reason) => {
      console.log('Socket: Disconnected -', reason);
      this.connected = false;
    });

    this.socket.on('connect_error', (error) => {
      this.reconnectAttempts++;
      if (this.reconnectAttempts >= this.maxReconnectAttempts) {
        console.warn('Socket: Connection failed after', this.maxReconnectAttempts, 'attempts');
      }
    });

    // User events
    this.socket.on('user:joined', (data) => {
      this.emit('userJoined', data);
    });

    this.socket.on('user:left', (data) => {
      this.emit('userLeft', data);
    });

    this.socket.on('user:disconnected', (data) => {
      this.emit('userDisconnected', data);
    });

    // Chat events
    this.socket.on('chat:message', (data) => {
      this.emit('chatMessage', data);
    });

    this.socket.on('chat:typing', (data) => {
      this.emit('chatTyping', data);
    });

    this.socket.on('chat:read', (data) => {
      this.emit('chatRead', data);
    });

    // Tactic collaboration events
    this.socket.on('tactic:update', (data) => {
      this.emit('tacticUpdate', data);
    });

    this.socket.on('tactic:cursor', (data) => {
      this.emit('tacticCursor', data);
    });

    this.socket.on('tactic:user:joined', (data) => {
      this.emit('tacticUserJoined', data);
    });

    this.socket.on('tactic:user:left', (data) => {
      this.emit('tacticUserLeft', data);
    });

    // Live streaming events
    this.socket.on('live:user:joined', (data) => {
      this.emit('liveUserJoined', data);
    });

    this.socket.on('live:user:left', (data) => {
      this.emit('liveUserLeft', data);
    });

    this.socket.on('live:stream:started', (data) => {
      this.emit('liveStreamStarted', data);
    });

    this.socket.on('live:stream:stopped', (data) => {
      this.emit('liveStreamStopped', data);
    });

    this.socket.on('live:status', (data) => {
      this.emit('liveStatus', data);
    });

    this.socket.on('live:layout', (data) => {
      this.emit('liveLayout', data);
    });

    // WebRTC signaling
    this.socket.on('rtc:offer', (data) => {
      this.emit('rtcOffer', data);
    });

    this.socket.on('rtc:answer', (data) => {
      this.emit('rtcAnswer', data);
    });

    this.socket.on('rtc:ice-candidate', (data) => {
      this.emit('rtcIceCandidate', data);
    });

    // Notifications
    this.socket.on('notification', (data) => {
      this.emit('notification', data);
      this.showNotification(data);
    });

    this.socket.on('announcement:new', (data) => {
      this.emit('announcementNew', data);
      toast.info('Novo Aviso', data.title);
    });

    this.socket.on('schedule:event', (data) => {
      this.emit('scheduleEvent', data);
    });

    this.socket.on('schedule:reminder', (data) => {
      this.emit('scheduleReminder', data);
      toast.info('Lembrete', `${data.title} começa em breve`);
    });

    // ZDPro collaborative session events
    this.socket.on('zdpro:update', (data) => {
      this.emit('zdproUpdate', data);
    });

    this.socket.on('zdpro:user:joined', (data) => {
      this.emit('zdproUserJoined', data);
    });

    this.socket.on('zdpro:user:left', (data) => {
      this.emit('zdproUserLeft', data);
    });

    this.socket.on('zdpro:peers', (data) => {
      this.emit('zdproPeers', data);
    });

    // ── Scrim Arena: Global premium notification for challenge received ──
    this.socket.on('scrim:challenge', (data) => {
      try {
        const challengerTeam = data.challengerTeam || {};
        const myTeam = {
          name: (typeof app !== 'undefined' && app.currentTeam?.name) || 'Meu Time',
          tag: (typeof app !== 'undefined' && app.currentTeam?.tag) || '',
          logo: (typeof app !== 'undefined' && app.currentTeam?.logo_url) || '/img/default-team.png'
        };

        if (typeof showPremiumNotification === 'function') {
          showPremiumNotification({
            type: 'received',
            title: 'Novo Desafio de Treino!',
            subtitle: `${challengerTeam.name || 'Um time'} quer treinar com você`,
            team1: challengerTeam,
            team2: myTeam,
            maps: data.maps || [],
            hour: data.hour,
            date: data.date || '',
            duration: 8000,
            actionLabel: 'Ver Agenda',
            onAction: () => {
              if (typeof app !== 'undefined') {
                app.navigate('scrim');
                setTimeout(() => {
                  if (typeof scrimArena !== 'undefined') {
                    scrimArena.currentTab = 'agenda';
                    scrimArena.render();
                  }
                }, 500);
              }
            }
          });
        } else {
          toast.info('Novo Treino', `${challengerTeam.name || 'Um time'} quer treinar com você!`);
        }
      } catch (err) {
        console.error('[Socket] scrim:challenge notification error:', err);
        toast.info('Novo Treino', 'Você recebeu uma solicitação de treino!');
      }
    });
  }

  // Called when socket connects
  onConnected() {
    // Join user room
    if (auth && auth.user) {
      this.joinRoom(`user:${auth.user.id}`);
    }

    // Join current team room
    const currentTeam = localStorage.getItem('zdval_current_team');
    if (currentTeam) {
      this.joinRoom(`team:${currentTeam}`);
    }
  }

  // Join a room
  joinRoom(roomId) {
    if (this.socket && this.connected) {
      this.socket.emit('join:room', roomId);
    }
  }

  // Leave a room
  leaveRoom(roomId) {
    if (this.socket && this.connected) {
      this.socket.emit('leave:room', roomId);
    }
  }

  // Disconnect
  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.connected = false;
    }
  }

  // =====================================================
  // CHAT METHODS
  // =====================================================

  joinChat(conversationId) {
    this.joinRoom(`chat:${conversationId}`);
  }

  leaveChat(conversationId) {
    this.leaveRoom(`chat:${conversationId}`);
  }

  sendChatMessage(conversationId, content, messageType = 'text', metadata = null) {
    if (this.socket && this.connected) {
      this.socket.emit('chat:message', {
        conversationId,
        content,
        messageType,
        metadata
      });
    }
  }

  sendTyping(conversationId, isTyping) {
    if (this.socket && this.connected) {
      this.socket.emit('chat:typing', { conversationId, isTyping });
    }
  }

  markChatRead(conversationId) {
    if (this.socket && this.connected) {
      this.socket.emit('chat:read', { conversationId });
    }
  }

  // =====================================================
  // TACTIC COLLABORATION METHODS
  // =====================================================

  joinTactic(tacticId) {
    if (this.socket && this.connected) {
      this.socket.emit('tactic:join', tacticId);
    }
  }

  leaveTactic(tacticId) {
    if (this.socket && this.connected) {
      this.socket.emit('tactic:leave', tacticId);
    }
  }

  updateTactic(tacticId, changes, cursorPosition) {
    if (this.socket && this.connected) {
      this.socket.emit('tactic:update', { tacticId, changes, cursorPosition });
    }
  }

  updateTacticCursor(tacticId, position) {
    if (this.socket && this.connected) {
      this.socket.emit('tactic:cursor', { tacticId, position });
    }
  }

  updateTacticElement(tacticId, elementId, changes) {
    if (this.socket && this.connected) {
      this.socket.emit('tactic:element:update', { tacticId, elementId, changes });
    }
  }

  addTacticElement(tacticId, element) {
    if (this.socket && this.connected) {
      this.socket.emit('tactic:element:add', { tacticId, element });
    }
  }

  removeTacticElement(tacticId, elementId) {
    if (this.socket && this.connected) {
      this.socket.emit('tactic:element:remove', { tacticId, elementId });
    }
  }

  tacticSaved(tacticId) {
    if (this.socket && this.connected) {
      this.socket.emit('tactic:saved', { tacticId });
    }
  }

  // =====================================================
  // ZDPRO COLLABORATIVE SESSION METHODS
  // =====================================================

  joinZdproSession(sessionCode) {
    if (this.socket && this.connected) {
      this.socket.emit('zdpro:join', sessionCode);
    }
  }

  leaveZdproSession(sessionCode) {
    if (this.socket && this.connected) {
      this.socket.emit('zdpro:leave', sessionCode);
    }
  }

  broadcastZdproUpdate(sessionCode, state) {
    if (this.socket && this.connected) {
      this.socket.emit('zdpro:update', { sessionCode, state });
    }
  }

  // =====================================================
  // LIVE STREAMING METHODS
  // =====================================================

  joinLive(sessionId, role, agentId = null, peerId = null) {
    if (this.socket && this.connected) {
      this.socket.emit('live:join', { sessionId, role, agentId, peerId });
    }
  }

  leaveLive(sessionId) {
    if (this.socket && this.connected) {
      this.socket.emit('live:leave', { sessionId });
    }
  }

  startStream(sessionId) {
    if (this.socket && this.connected) {
      this.socket.emit('live:stream:start', { sessionId });
    }
  }

  stopStream(sessionId) {
    if (this.socket && this.connected) {
      this.socket.emit('live:stream:stop', { sessionId });
    }
  }

  updateLiveStatus(sessionId, isAlive, health = null, armor = null, weapon = null, abilities = null) {
    if (this.socket && this.connected) {
      this.socket.emit('live:status', {
        sessionId,
        isAlive,
        health,
        armor,
        weapon,
        abilities
      });
    }
  }

  updateLiveLayout(sessionId, layout, focusedPlayerId = null) {
    if (this.socket && this.connected) {
      this.socket.emit('live:layout', { sessionId, layout, focusedPlayerId });
    }
  }

  // =====================================================
  // WEBRTC SIGNALING METHODS
  // =====================================================

  sendRTCOffer(target, sdp) {
    if (this.socket && this.connected) {
      this.socket.emit('rtc:offer', { target, sdp });
    }
  }

  sendRTCAnswer(target, sdp) {
    if (this.socket && this.connected) {
      this.socket.emit('rtc:answer', { target, sdp });
    }
  }

  sendRTCIceCandidate(target, candidate) {
    if (this.socket && this.connected) {
      this.socket.emit('rtc:ice-candidate', { target, candidate });
    }
  }

  // =====================================================
  // EVENT SYSTEM
  // =====================================================

  // Subscribe to events
  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event).add(callback);
    
    return () => this.off(event, callback);
  }

  // Unsubscribe from events
  off(event, callback) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).delete(callback);
    }
  }

  // Emit local event
  emit(event, data) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error(`Socket event handler error [${event}]:`, error);
        }
      });
    }
  }

  // Show browser notification
  showNotification(data) {
    if (Notification.permission === 'granted') {
      new Notification(data.title, {
        body: data.message,
        icon: '/assets/favicon.svg'
      });
    }
  }
}

// Export singleton instance
const socket = new SocketManager();


/* ===== js/site-header.js ===== */
// =====================================================
// ZDVAL - Site Header (fonte única)
//
// O cabeçalho e o menu do perfil existiam duas vezes: markup estático no
// index.html (SPA) e um segundo, montado em JS, dentro de vpro/vpro.js. Toda
// mudança precisava ser feita nos dois e, na prática, só era feita num — por
// isso o /vpro tinha itens diferentes, sem sino e com ícones antigos.
//
// Aqui mora o HTML do nav e do dropdown. Quem consome:
//   - index.html  → injeta SiteHeader.shellHtml() antes do app.js subir
//   - js/app.js   → dropdown e central de notificações
//   - vpro/vpro.js→ mesmo nav e mesmo dropdown
//
// Este arquivo não tem estado nem faz fetch: só devolve string. Os handlers
// continuam com quem renderiza, que é onde a navegação difere (SPA x /vpro).
// =====================================================

(function (global) {
  const NAV = [
    { key: 'vpro',       href: '/vpro/lobbies', label: 'Jogar' },
    { key: 'lineups',    href: '/lineups',      label: 'Lineups' },
    { key: 'zdpro',      href: '/zdpro',        label: 'ZDPRO' },
    { key: 'tactics',    href: '/tactics',      label: 'Táticas' },
    { key: 'analise',    href: '/analise',      label: 'Análise' },
    { key: 'scrim',      href: '/scrim',        label: 'Scrim Arena' },
    { key: 'academy',    href: '/academy',      label: 'ZDAcademy' },
    { key: 'antitactic', href: '/antitatico',   label: 'AntiTático' }
  ];

  function esc(value) {
    return String(value ?? '').replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[c]);
  }

  /**
   * Itens do menu. `items` permite que o /vpro passe a ordem vinda do
   * site-config do admin; sem ela vale a lista canônica acima.
   */
  function navItemsHtml(options = {}) {
    const configured = Array.isArray(options.items) ? options.items.filter(item => item && item.key) : [];
    const active = options.activePage || '';

    // A config do admin manda em ordem, rótulo e visibilidade — mas item
    // canônico que ela não lista continua no menu (o site-config nunca teve
    // 'antitactic', e a SPA só o exibia porque o markup era estático).
    const configuredKeys = new Set(configured.map(item => item.key));
    const items = configured.length
      ? configured.concat(NAV.filter(item => !configuredKeys.has(item.key)))
      : NAV;

    return items
      .filter(item => item && item.visible !== false && item.href)
      .map(item => {
        const key = item.key || 'home';
        const href = key === 'vpro' ? '/vpro/lobbies' : String(item.href || '/').trim();
        const label = String(item.label || '').trim() || href;
        const isActive = key === active ? ' active' : '';
        return `<li class="nav-item">
              <a href="${esc(href)}" class="nav-link${isActive}" data-page="${esc(key)}" title="${esc(label)}">
                <span>${esc(label)}</span>
              </a>
            </li>`;
      })
      .join('');
  }

  /**
   * Cabeçalho inteiro. `authed` decide o lado direito; o resto do site
   * continua alternando por `style.display`, então os dois blocos vêm
   * sempre no DOM quando `toggleByAuth` é true (comportamento da SPA).
   */
  function shellHtml(options = {}) {
    const user = options.user || null;
    const authed = options.authed !== undefined ? options.authed : !!user;
    const toggleByAuth = options.toggleByAuth !== false;
    const displayName = user?.display_name || user?.username || 'Meu Perfil';
    const avatarUrl = user?.avatar_url || '/img/default-avatar.png';

    const hide = value => (toggleByAuth ? ` style="${value}"` : '');
    const showProfile = toggleByAuth ? 'cursor: pointer; display:none;' : 'cursor: pointer;';

    // Na SPA os dois blocos vêm no DOM e o auth.js alterna por display. Onde
    // o estado já é conhecido na renderização (/vpro), só um dos dois entra —
    // senão o "Entrar" aparecia ao lado do perfil de quem está logado.
    const authButtonsHtml = (toggleByAuth || !authed) ? `
          <div class="header-auth-buttons" id="headerAuthButtons"${hide('display:none;')}>
            <button type="button" class="btn-header-login" id="btnHeaderLogin">Entrar</button>
          </div>` : '';

    const profileHtml = (toggleByAuth || authed) ? `
          <div class="header-profile" id="headerProfile" title="Perfil Frontend" style="${showProfile}">
            <img src="${esc(avatarUrl)}" alt="Avatar" class="header-profile-avatar" id="headerAvatar"
                 onerror="this.src='/img/default-avatar.png'">
            <span class="header-profile-name" id="headerProfileName">${esc(displayName)}</span>
          </div>
          <button class="btn-icon notification-btn header-notification-btn" id="notificationBtn" title="Notificações"${hide('display:none;')}>
            <i class="fas fa-bell"></i>
            <span class="badge badge-notification" id="notificationBadge" style="display: none;">0</span>
          </button>
          <button type="button" class="header-menu-toggle" id="headerProfileMenuToggle" title="Menu"${hide('display:none;')}>
            <i class="fas fa-bars"></i>
          </button>` : '';

    const rightHtml = `${authButtonsHtml}${profileHtml}`;

    return `
      <nav id="sidebar" class="horizontal-nav">
        <div class="horizontal-nav-inner">
          <a href="/" class="nav-brand" id="navBrand" title="ZDVAL — Início" aria-label="Ir para a página inicial">
            <img src="/img/logo-zdval-transparent.png" alt="ZDVAL" class="nav-brand-logo-img">
          </a>

          <div class="nav-group">
            <ul class="nav-menu nav-menu-secondary">
              ${navItemsHtml(options)}
            </ul>
          </div>

          <div class="horizontal-nav-right">
            ${rightHtml}
            <span id="currentTeamName" style="display:none;">Selecionar Time</span>
          </div>

          <div id="userInfo" style="display:none;">
            <img src="/img/default-avatar.png" alt="Avatar" id="userAvatar">
            <span id="userName"></span>
            <span id="userRole"></span>
          </div>
        </div>
      </nav>
    `;
  }

  /**
   * Menu do perfil. Os itens levam href real e `data-action`: a SPA
   * intercepta pelo data-action e o /vpro deixa o href navegar.
   */
  function profileDropdownHtml(options = {}) {
    const user = options.user || {};
    const team = options.team || null;
    const isSuperAdmin = user.role === 'super_admin';
    const welcome = user.display_name || user.username || 'Perfil';
    const riotLabel = user.riot_id && user.riot_tag
      ? `${user.riot_id}#${user.riot_tag}`
      : 'Riot ID não configurado';
    const regionLabel = options.regionLabel || '';
    const countryCode = String(options.countryCode || user.country || 'BR').toLowerCase();

    return `
      <div class="pdd-header">
        <div class="pdd-header-main">
          <div class="pdd-avatar-wrap">
            <img src="${esc(user.avatar_url || '/img/default-avatar.png')}" alt="" class="pdd-avatar"
                 onerror="this.src='/img/default-avatar.png'">
            <span class="pdd-status-dot"></span>
          </div>
          <div class="pdd-info">
            <span class="pdd-name">Bem vindo, ${esc(welcome)}</span>
            <span class="pdd-email">${esc(riotLabel)}</span>
            ${regionLabel ? `
              <span class="pdd-email pdd-region-line">
                <img class="pdd-region-flag" src="https://flagcdn.com/24x18/${esc(countryCode)}.png"
                     alt="" width="16" height="12" onerror="this.style.display='none'">
                ${esc(regionLabel)}
              </span>
            ` : ''}
          </div>
        </div>
      </div>
      <div class="pdd-divider"></div>
      <div class="pdd-section">
        <a href="/profile?mode=edit" class="pdd-item" data-action="profile-edit">
          <div class="pdd-item-icon"><i class="fas fa-user-pen" aria-hidden="true"></i></div>
          <div class="pdd-item-text">
            <span class="pdd-item-label">Editar Perfil</span>
            <span class="pdd-item-desc">Gerenciar dados, social e highlights</span>
          </div>
          <i class="fas fa-chevron-right pdd-item-arrow"></i>
        </a>
        <a href="/ranked" class="pdd-item" data-action="ranked">
          <div class="pdd-item-icon"><i class="fas fa-chart-line" aria-hidden="true"></i></div>
          <div class="pdd-item-text">
            <span class="pdd-item-label">Ranked</span>
            <span class="pdd-item-desc">Estatísticas de ranqueadas</span>
          </div>
          <i class="fas fa-chevron-right pdd-item-arrow"></i>
        </a>
      </div>
      <div class="pdd-divider"></div>
      <div class="pdd-team-section">
        ${team ? `
          <div class="pdd-team-actions">
            <a href="/team" class="pdd-item" data-action="team-home">
              <div class="pdd-item-icon pdd-item-icon-team">
                <img src="${esc(team.logo_url || '/img/default-team-riot.png')}" alt="" class="pdd-item-team-logo"
                     onerror="this.src='/img/default-team-riot.png'">
              </div>
              <div class="pdd-item-text">
                <span class="pdd-item-label">Meu Time</span>
                <span class="pdd-item-desc">Abrir página e central do time</span>
              </div>
              <i class="fas fa-chevron-right pdd-item-arrow"></i>
            </a>
          </div>
        ` : `
          <div class="pdd-team-empty">Você ainda não está em um time.</div>
          <div class="pdd-team-actions">
            <a href="#" class="pdd-item" data-action="create-team">
              <div class="pdd-item-icon"><i class="fas fa-plus" aria-hidden="true"></i></div>
              <div class="pdd-item-text">
                <span class="pdd-item-label">Criar Time</span>
                <span class="pdd-item-desc">Monte a sua estrutura dentro da plataforma</span>
              </div>
              <i class="fas fa-chevron-right pdd-item-arrow"></i>
            </a>
            <a href="#" class="pdd-item" data-action="join-team">
              <div class="pdd-item-icon"><i class="fas fa-sign-in-alt" aria-hidden="true"></i></div>
              <div class="pdd-item-text">
                <span class="pdd-item-label">Entrar em um Time</span>
                <span class="pdd-item-desc">Use um código de convite para entrar</span>
              </div>
              <i class="fas fa-chevron-right pdd-item-arrow"></i>
            </a>
          </div>
        `}
      </div>
      <div class="pdd-divider"></div>
      <div class="pdd-section">
        <a href="/settings" class="pdd-item" data-action="settings">
          <div class="pdd-item-icon"><i class="fas fa-gear" aria-hidden="true"></i></div>
          <div class="pdd-item-text">
            <span class="pdd-item-label">Configurações</span>
            <span class="pdd-item-desc">${isSuperAdmin ? 'Segurança, preferências e usuários' : 'Segurança e preferências'}</span>
          </div>
          <i class="fas fa-chevron-right pdd-item-arrow"></i>
        </a>
      </div>
      <div class="pdd-divider"></div>
      <a href="#" class="pdd-item pdd-logout" data-action="logout">
        <div class="pdd-item-icon"><i class="fas fa-sign-out-alt" aria-hidden="true"></i></div>
        <span class="pdd-item-label">Sair da Conta</span>
      </a>
    `;
  }

  /** Posiciona um painel do cabeçalho (dropdown, notificações) sob o gatilho. */
  function positionUnder(panel, trigger, options = {}) {
    if (!panel) return false;
    const margin = options.margin ?? 16;
    const rect = trigger?.getBoundingClientRect?.();
    panel.style.position = 'fixed';

    if (!rect || (!rect.width && !rect.height)) {
      panel.style.top = 'calc(var(--horizontal-nav-height, 72px) + 8px)';
      panel.style.right = `${margin}px`;
      panel.style.left = 'auto';
      return false;
    }

    panel.style.top = `${rect.bottom + 8}px`;
    panel.style.right = 'auto';
    const width = panel.offsetWidth || 320;
    let left = rect.left + rect.width / 2 - width / 2;
    if (left < margin) left = margin;
    if (left + width > window.innerWidth - margin) left = window.innerWidth - margin - width;
    panel.style.left = `${left}px`;
    return true;
  }


  // ── Gatilho do perfil ──────────────────────────────
  // Abre no clique e no hover, e continua aberto enquanto o cursor estiver
  // sobre o gatilho ou sobre o próprio menu. Vive aqui porque o /vpro só
  // tinha o clique: o mesmo cabeçalho abria de dois jeitos.
  function bindProfileTrigger(trigger, open) {
    if (!trigger || trigger.dataset.headerBound === '1') return;
    trigger.dataset.headerBound = '1';
    trigger.style.cursor = 'pointer';

    const current = () => document.querySelector('.profile-dropdown');
    let hideTimer = null;
    const cancelHide = () => { if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; } };
    const scheduleHide = () => {
      cancelHide();
      hideTimer = setTimeout(() => current()?.remove(), 180);
    };

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      cancelHide();
      open(trigger);
    });

    trigger.addEventListener('mouseenter', () => {
      cancelHide();
      if (!current()) open(trigger);
      const dd = current();
      if (dd && !dd.dataset.hoverWired) {
        dd.dataset.hoverWired = '1';
        dd.addEventListener('mouseenter', cancelHide);
        dd.addEventListener('mouseleave', scheduleHide);
      }
    });

    trigger.addEventListener('mouseleave', scheduleHide);
  }

  // ── Central de notificações ────────────────────────
  // Sem rota no backend: a lista é o que chegou por socket nesta sessão,
  // guardada no navegador de quem está logado. Estava só na SPA — no /vpro
  // o sino existia e não fazia nada.
  const STORAGE_KEY = 'zdval_notifications';
  const Notifications = {
    items: [],

    init() {
      const btn = document.getElementById('notificationBtn');
      if (!btn || btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';

      this.items = this.load();
      this.renderBadge();

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggle();
      });
    },

    load() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list.slice(0, 30) : [];
      } catch {
        return [];
      }
    },

    store() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items.slice(0, 30)));
      } catch {
        // Sem storage (aba anônima, cota cheia): segue só em memória.
      }
    },

    push({ title, message, icon }) {
      this.items.unshift({
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        title,
        message,
        icon: icon || 'fas fa-bell',
        at: Date.now(),
        read: false
      });
      this.items = this.items.slice(0, 30);
      this.store();
      this.renderBadge();

      const panel = document.getElementById('notificationDropdown');
      if (panel) panel.innerHTML = this.panelHtml();
    },

    renderBadge() {
      const badge = document.getElementById('notificationBadge');
      if (!badge) return;
      const unread = this.items.filter(n => !n.read).length;
      badge.textContent = unread > 99 ? '99+' : String(unread);
      badge.style.display = unread ? '' : 'none';
    },

    toggle() {
      const existing = document.getElementById('notificationDropdown');
      if (existing) { existing.remove(); return; }

      const trigger = document.getElementById('notificationBtn');
      const panel = document.createElement('div');
      panel.id = 'notificationDropdown';
      panel.className = 'notification-dropdown';
      panel.innerHTML = this.panelHtml();
      document.body.appendChild(panel);
      positionUnder(panel, trigger);

      panel.addEventListener('click', (e) => {
        if (e.target.closest('[data-notification-clear]')) {
          this.items = [];
          this.store();
          this.renderBadge();
          panel.innerHTML = this.panelHtml();
        }
      });

      // Abrir marca tudo como lido: não há estado de leitura no servidor
      // para sincronizar, o badge só conta o que ainda não foi visto.
      this.items.forEach(n => { n.read = true; });
      this.store();
      this.renderBadge();

      setTimeout(() => {
        document.addEventListener('click', function handler(e) {
          if (!panel.contains(e.target) && !trigger?.contains(e.target)) {
            panel.remove();
            document.removeEventListener('click', handler);
          }
        });
      }, 0);
    },

    panelHtml() {
      if (!this.items.length) {
        return `
        <div class="notification-dropdown-head">
          <span>Notificações</span>
        </div>
        <div class="notification-empty">
          <i class="fas fa-bell-slash" aria-hidden="true"></i>
          <strong>Nenhuma notificação</strong>
          <span>Convites, avisos e desafios de scrim aparecem aqui.</span>
        </div>`;
      }

      return `
        <div class="notification-dropdown-head">
          <span>Notificações</span>
          <button type="button" class="notification-clear" data-notification-clear>Limpar</button>
        </div>
        <div class="notification-list">
          ${this.items.map(n => `
            <div class="notification-item ${n.read ? '' : 'is-unread'}">
              <span class="notification-item-icon"><i class="${esc(n.icon)}" aria-hidden="true"></i></span>
              <div class="notification-item-text">
                <strong>${esc(n.title)}</strong>
                ${n.message ? `<span>${esc(n.message)}</span>` : ''}
                <time>${esc(this.timeLabel(n.at))}</time>
              </div>
            </div>
          `).join('')}
        </div>`;
    },

    timeLabel(at) {
      const diff = Math.max(0, Date.now() - Number(at || 0));
      const minutes = Math.floor(diff / 60000);
      if (minutes < 1) return 'agora';
      if (minutes < 60) return `há ${minutes} min`;
      const hours = Math.floor(minutes / 60);
      if (hours < 24) return `há ${hours} h`;
      return new Date(Number(at)).toLocaleDateString('pt-BR');
    }
  };


  // ── Mega-menu "Jogar" ──────────────────────────────
  // Estava duplicado: uma cópia em js/app.js e outra em vpro/vpro.js, com
  // ícones, textos e cards repetidos nos dois. O markup e os dados moram
  // aqui; quem abre o menu continua com quem tem o gatilho.
  const PLAY_MENU_ICONS = {
  lobby: `
    <svg viewBox="0 0 29 42" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
      <path d="M10.3027 2.96503C10.2855 3.12914 10.277 3.2941 10.2771 3.45919C10.2771 5.91038 12.1638 7.90405 14.5 7.90405C16.8362 7.90405 18.7229 5.91038 18.7229 3.45919C18.7229 3.29208 18.7144 3.12677 18.6973 2.96503H27.231C28.2085 2.96503 29 3.7943 29 4.81749V40.1466C29 41.1702 28.208 42 27.231 42H1.769C0.792008 42 0 41.1702 0 40.1466V4.81749C0 3.7943 0.791529 2.96503 1.769 2.96503H10.3027ZM3.27444 15.8117C4.56579 15.8117 5.61321 14.7054 5.61321 13.3408C5.61321 11.9772 4.56579 10.8709 3.27444 10.8709C1.98224 10.8709 0.935677 11.9772 0.935677 13.3408C0.935677 14.7054 1.98224 15.8117 3.27444 15.8117ZM8.88679 15.8117C10.179 15.8117 11.2256 14.7054 11.2256 13.3408C11.2256 11.9772 10.179 10.8709 8.88679 10.8709C7.59544 10.8709 6.54803 11.9772 6.54803 13.3408C6.54803 14.7054 7.59544 15.8117 8.88679 15.8117ZM14.5 15.8117C15.7914 15.8117 16.8388 14.7054 16.8388 13.3408C16.8388 11.9772 15.7914 10.8709 14.5 10.8709C13.2086 10.8709 12.1612 11.9772 12.1612 13.3408C12.1612 14.7054 13.2086 15.8117 14.5 15.8117ZM20.1124 15.8117C21.4046 15.8117 22.452 14.7054 22.452 13.3408C22.452 11.9772 21.4046 10.8709 20.1132 10.8709C18.821 10.8709 17.7744 11.9772 17.7744 13.3408C17.7744 14.7054 18.821 15.8117 20.1132 15.8117H20.1124ZM25.7256 15.8117C27.0178 15.8117 28.0643 14.7054 28.0643 13.3408C28.0643 11.9772 27.0178 10.8709 25.7256 10.8709C24.4342 10.8709 23.3868 11.9772 23.3868 13.3408C23.3868 14.7054 24.4342 15.8117 25.7256 15.8117ZM14.5 6.91749C12.6918 6.91749 11.2256 5.36885 11.2256 3.45919C11.2256 1.54863 12.6918 0 14.5 0C16.3082 0 17.7744 1.54865 17.7744 3.45831C17.7744 5.36886 16.3082 6.91749 14.5 6.91749ZM3.72735 32.8699C3.12439 32.8699 2.63559 33.382 2.63559 34.0137V39.0305C2.63559 39.6614 3.12518 40.1743 3.72735 40.1743H26.1512C26.7541 40.1743 27.2429 39.6622 27.2429 39.0305V34.0137C27.2429 33.382 26.7541 32.8699 26.1512 32.8699H3.72735Z" fill="currentColor"/>
    </svg>`,
  tournaments: `
    <svg viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18 13.5H15.75V9H56.25V13.5H54V18H61.875V39.5557L53.934 44.0934C53.2597 50.9186 47.5025 56.25 40.5 56.25H38.25V63H47.25V67.5H24.75V63H33.75V56.25H31.5C24.5264 56.25 18.7878 50.9625 18.0746 44.1779L9 39.6406V18H18V13.5ZM22.5 13.5V42.75C22.5 47.7206 26.5294 51.75 31.5 51.75H40.5C45.4706 51.75 49.5 47.7206 49.5 42.75V13.5H22.5ZM18 22.5H13.5V36.8594L18 39.1094V22.5ZM54 38.8728L57.375 36.9443V22.5H54V38.8728Z" fill="currentColor"/>
    </svg>`,
  wipe: `
    <svg viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
      <path d="M46 0H0V46L46 0Z" fill="currentColor"/>
    </svg>`
};

  const PLAY_MENU_CARDS = [
  {
    color: 'lobby',
    title: 'Lobby',
    description: 'Junte seus amigos e desafie outras salas em uma partida 5x5 valendo Rating Points.',
    href: '/vpro/lobbies',
    icon: PLAY_MENU_ICONS.lobby,
    mediaUrl: '',
  },
  {
    color: 'tournaments',
    title: 'Campeonatos',
    description: 'Participe dos campeonatos semanais e comece sua carreira pro nas ligas.',
    href: '/vpro/leaderboard',
    icon: PLAY_MENU_ICONS.tournaments,
    mediaUrl: '',
  }
];

  function escapePlayMenuHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, char => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));
}

  /**
   * Campeonatos ainda nao abriram: o card continua na tela, mas so anuncia.
   * Sem href/role/tabindex, nenhum handler de clique o alcanca.
   */
  function isSoonCard(card) {
    const chave = `${card?.id || ''} ${card?.color || ''} ${card?.title || ''}`.toLowerCase();
    return chave.includes('tournament') || chave.includes('campeonat');
  }

  function resolvePlayMenuMedia(card) {
  return String(card?.mediaUrl || card?.videoUrl || card?.media || card?.imageUrl || '').trim();
}

  function resolvePlayMenuIcon(card) {
  const key = String(card?.color || card?.id || '').toLowerCase();
  if (key.includes('tournament') || key.includes('campeonat')) return PLAY_MENU_ICONS.tournaments;
  return PLAY_MENU_ICONS.lobby;
}

  function renderPlayMenuCardHtml(card) {
  const color = escapePlayMenuHtml(card.color || 'lobby');
  const href = escapePlayMenuHtml(card.href || '/vpro/lobbies');
  const title = escapePlayMenuHtml(card.title || 'Lobby');
  const description = escapePlayMenuHtml(card.description || '');
  const media = resolvePlayMenuMedia(card);
  const mediaHtml = media
    ? `<div class="home-play-card-media"><img class="home-play-card-media-inner" src="${escapePlayMenuHtml(media)}" alt="${title}" loading="lazy" onerror="this.parentElement?.remove();"></div>`
    : '';
  const soon = isSoonCard(card);
  return `
    <div class="home-play-card ${media ? 'has-media' : ''}${soon ? ' is-soon' : ''}" data-color="${color}"${soon ? ' aria-disabled="true"' : ` data-home-play-href="${href}" role="button" tabindex="0"`} aria-label="${title}${soon ? ' (em breve)' : ''}">
      ${mediaHtml}
      <div class="home-play-card-wipe">${PLAY_MENU_ICONS.wipe}</div>
      <div class="home-play-card-icon">${resolvePlayMenuIcon(card)}</div>
      ${soon ? '<span class="home-play-card-soon-badge">Em breve</span>' : ''}
      <h3 class="home-play-card-title">${title}</h3>
      <p class="home-play-card-desc">${description}</p>
      <span class="home-play-card-cta">${soon ? 'Em breve' : 'Entrar <i class="fas fa-chevron-right"></i>'}</span>
    </div>`;
}

  /** Cards do menu: os do site-config do admin, senão os canônicos. */
  function playMenuCards(siteConfig) {
    const cards = siteConfig?.playSection?.cards;
    if (Array.isArray(cards)) {
      const visible = cards
        .filter(card => card && card.visible !== false)
        .map(card => ({
          color: card.color || card.id || 'lobby',
          title: card.title || 'Lobby',
          description: card.description || '',
          href: card.href || '/vpro/lobbies',
          mediaUrl: resolvePlayMenuMedia(card)
        }));
      if (visible.length) return visible;
    }
    return PLAY_MENU_CARDS;
  }

  function playMenuHtml(siteConfig) {
    return `<div class="home-play-cards">${playMenuCards(siteConfig).map(renderPlayMenuCardHtml).join('')}</div>`;
  }

  global.SiteHeader = { NAV, navItemsHtml, shellHtml, profileDropdownHtml, positionUnder, bindProfileTrigger, Notifications, playMenuCards, playMenuHtml, renderPlayMenuCardHtml, isSoonCard, esc };

  // A SPA marca o ponto de montagem no index.html. O bundle é `defer`, então
  // o DOM já existe aqui, e este arquivo vem antes do app.js: quando o boot
  // procurar #headerProfile / #notificationBtn, o cabeçalho já está no lugar.
  const mount = document.getElementById('siteHeaderMount');
  if (mount && !mount.dataset.rendered) {
    mount.outerHTML = shellHtml({ toggleByAuth: true });
  }
})(window);


/* ===== js/app.js ===== */
// =====================================================
// ZDVAL - Main App Module
// Handles navigation, state management, and UI
// =====================================================

// Shared premium page-load screen (used by /ranked, /profile, /team, /settings
// while their initial data is being fetched). The video fills the whole
// viewport behind the loader; the ring keeps showing the account's own avatar.
function renderPremiumPreload(statusText = 'Carregando...', nameLabel = '', avatarUrl = '') {
  return `
    <div class="premium-preload">
      <video class="premium-preload-bg-video" src="/video/preload-loop.mp4" autoplay loop muted playsinline></video>
      <div class="premium-preload-content">
        <div class="premium-preload-avatar-ring">
          <div class="premium-preload-ring-spin"></div>
          ${avatarUrl ? `<img src="${avatarUrl}" alt="" class="premium-preload-avatar" onerror="this.style.display='none'">` : '<div class="premium-preload-avatar-placeholder"><i class="fas fa-user"></i></div>'}
        </div>
        ${nameLabel ? `<span class="premium-preload-name">${nameLabel}</span>` : ''}
        <span class="premium-preload-text">${statusText}</span>
        <div class="premium-preload-dots"><span></span><span></span><span></span></div>
      </div>
    </div>
  `;
}

class App {
  constructor() {
    this.currentPage = 'home';
    this.currentTeam = null;
    this.teams = [];
    this.maps = [];
    this.agents = [];
    this.initialized = false;
    this.pageLoadRetries = new Map();
    this.pendingNavigationFrame = null;
    this.navigationSequence = 0;
    this.siteConfig = null;
    this.siteConfigPromise = null;
  }

  fetchSiteConfig(forceRefresh = false) {
    if (!forceRefresh && this.siteConfig) return Promise.resolve(this.siteConfig);
    if (!forceRefresh && this.siteConfigPromise) return this.siteConfigPromise;
    this.siteConfigPromise = fetch('/api/site-config', { cache: 'no-store' })
      .then(response => response.json().catch(() => ({})))
      .then(payload => {
        this.siteConfig = payload && payload.success && payload.data ? payload.data : null;
        this.applyHeaderNavConfig();
        return this.siteConfig;
      })
      .catch(() => null)
      .finally(() => {
        this.siteConfigPromise = null;
      });
    return this.siteConfigPromise;
  }

  // Hide/show/relabel the static header nav <li> items according to the
  // admin-configured header.nav array (visible flag, label, href). The
  // markup in index.html is static (rendered before this config loads), so
  // without this the header always shows every hardcoded item on refresh
  // regardless of what was toggled off in the admin "Editor da Home".
  //
  // The nav is visible-and-clickable from first paint (see .nav-menu-
  // secondary in style.css) — this only patches labels/visibility once
  // the config arrives; on a slow connection an admin-hidden item can be
  // clickable for a moment before this runs, which is the accepted
  // tradeoff over blocking all nav clicks until the network resolves.
  applyHeaderNavConfig() {
    const menu = document.querySelector('.nav-menu-secondary');
    if (!menu) return;

    // Re-renderiza os itens pela mesma função que o /vpro usa: antes a SPA
    // só corrigia label/visibilidade por cima do markup, então a ORDEM
    // configurada no admin valia no /vpro e não valia aqui.
    const navItems = this.siteConfig?.header?.nav;
    menu.innerHTML = SiteHeader.navItemsHtml({
      items: Array.isArray(navItems) && navItems.length ? navItems : null,
      activePage: this.currentPage
    });
    // Os itens são novos: religa os handlers de clique e o mega-menu.
    this.setupNavigation();
    document.querySelectorAll('.nav-link[data-page]').forEach(link => {
      link.classList.toggle('active', this.normalizePageName(link.dataset.page) === this.normalizePageName(this.currentPage));
    });
  }

  retryLoadPage(page, params) {
    const attempts = this.pageLoadRetries.get(page) || 0;
    if (attempts >= 10) return;

    this.pageLoadRetries.set(page, attempts + 1);
    setTimeout(() => {
      if (this.currentPage === page) {
        this.loadPageContent(page, params);
      }
    }, 50);
  }

  // Initialize app after authentication
  async init() {
    if (this.initialized) return;
    
    try {
      // Apply saved theme
      const savedTheme = localStorage.getItem('zdval_theme') || 'dark';
      document.documentElement.setAttribute('data-theme', savedTheme);

      // Connect socket
      socket.connect();

      // Setup UI
      this.setupNavigation();
      this.setupSidebar();
      this.setupSearch();
      this.setupTeamSelector();
      this.setupProfileDropdown();
      this.setupNotifications();
      this.setupShortcuts();

      // A pagina abre antes dos dados chegarem. Ela ja sabe lidar com
      // teams/maps/agents vazios — e o que o caminho anonimo (initPublic) faz
      // desde sempre — e loadInitialData re-renderiza quando os dados chegam.
      // Esperar aqui somava tres idas ao servidor em serie antes do primeiro
      // pixel de conteudo.
      this.loadCurrentPage();

      // Load initial data
      await this.loadInitialData();

      // Request notification permission
      this.requestNotificationPermission();

      this.initialized = true;
      document.dispatchEvent(new CustomEvent('zdval:page-ready'));
    } catch (error) {
      console.error('App init error:', error);
      // Still mark as initialized to prevent loops
      this.initialized = true;
      // Try to load page anyway
      try {
        this.loadCurrentPage();
      } catch (e) {
        console.error('Failed to load page:', e);
      }
      document.dispatchEvent(new CustomEvent('zdval:page-ready'));
    }
  }

  // Initialize for anonymous visitors (no token). Shows the public
  // home page with only navigation set up — no user-specific data.
  // Also loads maps+agents so the public /lineups page can render
  // exactly like the logged-in version.
  initPublic() {
    if (this.publicInitialized) {
      this.loadCurrentPage();
      document.dispatchEvent(new CustomEvent('zdval:page-ready'));
      return;
    }
    try {
      const savedTheme = localStorage.getItem('zdval_theme') || 'dark';
      document.documentElement.setAttribute('data-theme', savedTheme);
      this.setupNavigation();
      // Fire-and-forget load of public map/agent metadata. Pages that
      // depend on it (lineups, etc.) can re-render once it arrives.
      this.loadPublicMetadata();
      this.loadCurrentPage();
      this.publicInitialized = true;
    } catch (e) {
      console.error('App initPublic error:', e);
    }
    document.dispatchEvent(new CustomEvent('zdval:page-ready'));
  }

  async loadPublicMetadata() {
    try {
      const [mapsResult, agentsResult] = await Promise.all([
        api.getMaps().catch(() => null),
        api.getAgents().catch(() => null)
      ]);
      let changed = false;
      if (mapsResult && mapsResult.success && mapsResult.data?.maps) {
        this.maps = mapsResult.data.maps;
        changed = true;
      }
      if (agentsResult && agentsResult.success && agentsResult.data?.agents) {
        this.agents = agentsResult.data.agents;
        changed = true;
      }
      if (changed) {
        this.rerenderAfterBootData();
        try { this.decorateSidebar(); } catch (_) {}
      }
    } catch (e) {
      console.warn('loadPublicMetadata error:', e);
    }
  }

  // Load initial data
  async loadInitialData() {
    try {
      // As tres sao independentes. Esperar teams pra so entao pedir maps+agents
      // custava uma ida ao servidor inteira em serie, e essa ida ficava no
      // caminho critico do primeiro render. O .catch de maps/agents e pra
      // rejeicao nao ficar sem dono enquanto teams ainda esta pendente.
      const teamsPromise = api.getMyTeams();
      const metaPromise = Promise.all([
        api.getMaps().catch(() => null),
        api.getAgents().catch(() => null),
      ]);

      // Load teams (pode falhar mas não deve bloquear maps/agents)
      try {
        const teamsResult = await teamsPromise;
        console.log('Teams loaded:', teamsResult);
        
        if (teamsResult.success) {
          this.teams = teamsResult.data.teams || [];
          console.log('Teams array:', this.teams);
          
          // Restore last selected team
          const savedTeamId = localStorage.getItem('zdval_current_team');
          if (savedTeamId) {
            this.currentTeam = this.teams.find(t => t.id === savedTeamId);
          }
          
          // Auto-select first team if no team selected
          if (!this.currentTeam && this.teams.length > 0) {
            this.currentTeam = this.teams[0];
            localStorage.setItem('zdval_current_team', this.currentTeam.id);
          }
          
          console.log('Current team:', this.currentTeam);
          
          // Join team room
          if (this.currentTeam) {
            socket.joinRoom(`team:${this.currentTeam.id}`);
          }
          
          this.updateTeamUI();
        }
      } catch (teamsError) {
        console.error('Load teams error:', teamsError);

        const fallbackTeams = Array.isArray(auth?.user?.teams) ? auth.user.teams : [];
        if (fallbackTeams.length) {
          this.teams = fallbackTeams;

          const savedTeamId = localStorage.getItem('zdval_current_team');
          if (savedTeamId) {
            this.currentTeam = this.teams.find(t => t.id === savedTeamId) || null;
          }

          if (!this.currentTeam) {
            this.currentTeam = this.teams[0];
            localStorage.setItem('zdval_current_team', this.currentTeam.id);
          }

          if (this.currentTeam) {
            socket.joinRoom(`team:${this.currentTeam.id}`);
          }

          this.updateTeamUI();
        }
      }

      // Load maps and agents (independente de teams)
      const [mapsResult, agentsResult] = await metaPromise;

      if (mapsResult && mapsResult.success) {
        this.maps = mapsResult.data.maps;
        console.log('Maps loaded:', this.maps.length);
      }
      if (agentsResult && agentsResult.success) {
        this.agents = agentsResult.data.agents;
        console.log('Agents loaded:', this.agents.length);
      }

      // Decorate sidebar with agent icons + map backgrounds
      this.decorateSidebar();

      this.rerenderAfterBootData();
    } catch (error) {
      console.error('Load initial data error:', error);
    }
  }

  /**
   * Re-renderiza a pagina atual depois que teams/maps/agents chegam.
   *
   * A pagina abre antes desses dados existirem (senao nada aparece na tela ate
   * tres idas ao servidor terminarem), e quase toda pagina le app.maps,
   * app.agents ou app.currentTeam. Sem isso, quem abre direto em /lineups ou
   * /scrim ve a tela vazia ate trocar de pagina.
   *
   * ponytail: re-render do boot custa um segundo fetch da pagina. Se isso pesar,
   * o caminho e as paginas aguardarem uma promise app.dataReady em vez de
   * renderizar duas vezes — mas ai sao ~8 modulos pra mexer, nao um.
   */
  rerenderAfterBootData() {
    if (this.bootRerenderDone || !this.currentPage) return;
    this.bootRerenderDone = true;
    // schedulePageLoad espera this.pageCssPromise; quem entra por aqui nao
    // passou pelo navigate(), entao renova a promise da rota atual.
    this.pageCssPromise = Utils.pageCssReady(this.normalizePageName(this.currentPage));
    this.schedulePageLoad(this.currentPage, this.currentParams);
  }

  // Shortcut for toast notifications (compatibility)
  showToast(message, type = 'info') {
    const titles = {
      success: 'Sucesso',
      error: 'Erro',
      warning: 'Atenção',
      info: 'Info'
    };
    toast[type]?.(titles[type] || 'Aviso', message) || toast.info('Aviso', message);
  }

  // Setup navigation
  setupNavigation() {
    const bindComingSoonItem = (element, closeDropdown) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        if (typeof closeDropdown === 'function') closeDropdown();
        const message = element.dataset.soon || 'Disponível em breve.';
        this.showToast(message, 'info');
      });
    };

    const navLinks = document.querySelectorAll('.nav-link[data-page]');
    const soonLinks = document.querySelectorAll('.nav-link[data-soon]');
    const playLink = document.querySelector('.nav-link[data-page="vpro"]');

    // Brand logo → always navigates to home (SPA) for logged and anonymous users
    const navBrand = document.getElementById('navBrand');
    if (navBrand && !navBrand.dataset.bound) {
      navBrand.dataset.bound = '1';
      navBrand.addEventListener('click', (e) => {
        if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) return;
        e.preventDefault();
        this.navigate('home');
      });
    }
    
    navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        // Only handle left-click; let middle-click/ctrl+click use native <a> behavior
        if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) return;
        e.preventDefault();
        const page = link.dataset.page;
        this.navigate(page);
      });
      // Prevent middle-click from triggering SPA navigation
      link.addEventListener('auxclick', (e) => {
        // Let browser handle middle-click natively (open in new tab)
      });
    });

    soonLinks.forEach(link => {
      bindComingSoonItem(link);
    });

    this.fetchSiteConfig();

    if (playLink && !playLink.dataset.playMenuBound) {
      playLink.dataset.playMenuBound = '1';
      this.setupPlayMegaMenu(playLink);
    }

    // Handle browser back/forward
    window.addEventListener('popstate', (e) => {
      const defaultPage = 'home';
      const rawPath = window.location.pathname.slice(1) || defaultPage;
      const isAntitatico = rawPath === 'antitatico' || rawPath.startsWith('antitatico/');
      const isZdproSession = rawPath.startsWith('zdpro-') && rawPath !== 'zdpro-icones';
      const atParts = this._parseAntitaticoParts(rawPath);
      const path = this.normalizePageName(rawPath);
      const queryParams = window.location.search
        ? Object.fromEntries(new URLSearchParams(window.location.search))
        : null;
      let params = isAntitatico
        ? { ...(queryParams || {}), ...(atParts.opponentSlug ? { opponentSlug: atParts.opponentSlug } : {}), ...(atParts.tabSlug ? { atTab: atParts.tabSlug } : {}) }
        : queryParams;
      if (isZdproSession) {
        const sessionCode = rawPath.slice(6);
        params = { ...(params || {}), sessionCode };
      }
      this.navigate(path, params, false);
    });

  }

  setupPlayMegaMenu(trigger) {
    const supportsHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const cancelHide = () => {
      clearTimeout(this._playMegaMenuHideTimer);
      this._playMegaMenuHideTimer = null;
    };
    const scheduleHide = () => {
      cancelHide();
      this._playMegaMenuHideTimer = setTimeout(() => this.hidePlayMegaMenu(), 140);
    };
    const openMenu = async () => {
      cancelHide();
      await this.fetchSiteConfig();
      const menu = this.showPlayMegaMenu(trigger);
      if (menu && !menu.dataset.hoverBound) {
        menu.dataset.hoverBound = '1';
        menu.addEventListener('mouseenter', cancelHide);
        menu.addEventListener('mouseleave', scheduleHide);
      }
    };

    trigger.addEventListener('mouseenter', () => {
      if (!supportsHover()) return;
      openMenu();
    });
    trigger.addEventListener('mouseleave', () => {
      if (!supportsHover()) return;
      scheduleHide();
    });
    trigger.addEventListener('focus', openMenu);
  }

  positionPlayMegaMenu(menu, trigger) {
    if (!menu || !trigger) return;
    const rect = trigger.getBoundingClientRect();
    const margin = 16;
    const width = menu.offsetWidth || 760;
    let left = rect.left + rect.width / 2 - width / 2;
    if (left < margin) left = margin;
    if (left + width > window.innerWidth - margin) {
      left = window.innerWidth - margin - width;
    }
    menu.style.position = 'fixed';
    menu.style.top = `${rect.bottom + 12}px`;
    menu.style.left = `${left}px`;
    menu.style.right = 'auto';
  }

  hidePlayMegaMenu() {
    clearTimeout(this._playMegaMenuHideTimer);
    this._playMegaMenuHideTimer = null;
    document.querySelector('.play-mega-menu')?.remove();
    if (this._playMegaMenuDocHandler) {
      document.removeEventListener('click', this._playMegaMenuDocHandler);
      this._playMegaMenuDocHandler = null;
    }
    if (this._playMegaMenuResizeHandler) {
      window.removeEventListener('resize', this._playMegaMenuResizeHandler);
      this._playMegaMenuResizeHandler = null;
    }
  }

  showPlayMegaMenu(trigger) {
    const current = document.querySelector('.play-mega-menu');
    if (current) {
      current.innerHTML = SiteHeader.playMenuHtml(this.siteConfig);
      this.positionPlayMegaMenu(current, trigger);
      return current;
    }

    const menu = document.createElement('div');
    menu.className = 'play-mega-menu dropdown-menu';
    menu.innerHTML = SiteHeader.playMenuHtml(this.siteConfig);

    menu.addEventListener('click', (event) => {
      const card = event.target.closest('.home-play-card[data-home-play-href]');
      if (!card) return;
      event.preventDefault();
      const href = card.dataset.homePlayHref || '/vpro/lobbies';
      window.location.href = href;
    });

    document.body.appendChild(menu);
    this.positionPlayMegaMenu(menu, trigger);

    this._playMegaMenuResizeHandler = () => this.positionPlayMegaMenu(menu, trigger);
    window.addEventListener('resize', this._playMegaMenuResizeHandler);

    setTimeout(() => {
      this._playMegaMenuDocHandler = (event) => {
        if (!menu.contains(event.target) && !trigger.contains(event.target)) {
          this.hidePlayMegaMenu();
        }
      };
      document.addEventListener('click', this._playMegaMenuDocHandler);
    }, 0);

    return menu;
  }

  normalizePageName(page) {
    if (page === 'zdpro') return 'valoplant'; // /zdpro → planner
    if (page === 'planner') return 'valoplant';
    if (page === 'zdpro-icones') return 'zdpro-icones';
    if (page.startsWith('zdpro-')) return 'valoplant'; // zdpro-<sessionCode>
    if (page === 'scouting') return 'ranked';
    if (page === 'antitatico' || page.startsWith('antitatico/')) return 'antitactic';
    return page;
  }

  // Parse /antitatico/{opponentSlug}/{tabSlug} from raw path
  _parseAntitaticoParts(rawPath) {
    const ANTITATIC_TAB_SLUGS = ['pickban', 'tierlist', 'analise'];
    if (!rawPath.startsWith('antitatico/')) return { opponentSlug: null, tabSlug: null };
    const rest = rawPath.slice('antitatico/'.length); // e.g. "paysandu/pickban" or "paysandu"
    const segments = rest.split('/').filter(Boolean);
    if (segments.length === 0) return { opponentSlug: null, tabSlug: null };
    if (segments.length === 1) {
      // Could be just opponent slug, or just a tab slug if no opponent
      if (ANTITATIC_TAB_SLUGS.includes(segments[0])) {
        return { opponentSlug: null, tabSlug: segments[0] };
      }
      return { opponentSlug: segments[0], tabSlug: null };
    }
    // 2+ segments: last one might be a tab slug
    const last = segments[segments.length - 1];
    if (ANTITATIC_TAB_SLUGS.includes(last)) {
      return { opponentSlug: segments.slice(0, -1).join('/'), tabSlug: last };
    }
    return { opponentSlug: segments.join('/'), tabSlug: null };
  }

  resetTransientUiState() {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';

    const pageContainer = document.getElementById('pageContainer');
    if (pageContainer) {
      pageContainer.style.overflow = '';
      pageContainer.style.height = '';
      pageContainer.style.maxHeight = '';
    }

    // Remove any stray modal overlays appended to body (e.g. antitactic comp modal)
    document.querySelectorAll('body > .modal-overlay').forEach(m => m.remove());
  }

  showPageLoadingState(page) {
    if (!page) return;

    const pageElement = document.getElementById(`page-${page}`);
    if (!pageElement) return;

    pageElement.innerHTML = `
      <div class="loading-placeholder">
        <div class="spinner"></div>
        <span>Carregando...</span>
      </div>
    `;
  }

  showPageErrorState(page, error) {
    if (!page) return;

    const pageElement = document.getElementById(`page-${page}`);
    if (!pageElement) return;

    const message = error?.message || 'Ocorreu um erro ao abrir esta tela.';
    pageElement.innerHTML = `
      <div class="empty-state-full">
        <i class="fas fa-exclamation-triangle"></i>
        <h2>Falha ao abrir a página</h2>
        <p>${message}</p>
        <button class="btn btn-primary" onclick="app.navigate('${page}')">
          <i class="fas fa-rotate-right"></i> Tentar novamente
        </button>
      </div>
    `;
  }

  schedulePageLoad(page, params) {
    const navigationId = ++this.navigationSequence;

    if (this.pendingNavigationFrame) {
      cancelAnimationFrame(this.pendingNavigationFrame);
      this.pendingNavigationFrame = null;
    }

    this.pendingNavigationFrame = requestAnimationFrame(async () => {
      this.pendingNavigationFrame = null;

      setTimeout(async () => {
        if (navigationId !== this.navigationSequence || this.currentPage !== page) {
          return;
        }

        try {
          // A folha da rota precisa estar aplicada antes do HTML aparecer,
          // senao a pagina pinta crua por alguns frames (ver Utils.pageCssReady).
          await this.pageCssPromise;
          if (navigationId !== this.navigationSequence || this.currentPage !== page) {
            return;
          }

          await this.loadPageContent(page, params);
        } catch (err) {
          console.error(`[App] Error loading page "${page}":`, err);
          this.showPageErrorState(page, err);
        }
      }, 0);
    });
  }

  // Navigate to page
  navigate(page, params = null, pushState = true) {
    // VPRO runs in its own standalone app under /vpro/.
    // Do not route it through the main SPA pages map.
    if (page === 'vpro') {
      window.location.href = '/vpro/lobbies';
      return;
    }

    // Admin panel is a separate SPA — route externally
    if (page === 'admin' || page === 'admin-users') {
      window.location.href = '/admin/dashboard';
      return;
    }

    const normalizedPage = this.normalizePageName(page);

    // Cedo de proposito: o <link> comeca a baixar enquanto o resto da navegacao
    // (URL, nav ativa, breadcrumb) acontece.
    this.pageCssPromise = Utils.pageCssReady(normalizedPage);

    this.resetTransientUiState();

    // Update URL
    if (pushState) {
      const publicPage = normalizedPage === 'valoplant' ? 'planner' : normalizedPage;
      const isAntiTatico = normalizedPage === 'antitactic';
      const urlPage = isAntiTatico ? 'antitatico' : publicPage;
      const urlSlug = isAntiTatico && params?.opponentSlug ? `/${params.opponentSlug}` : '';
      const urlTabSlug = isAntiTatico && params?.atTab ? `/${params.atTab}` : '';
      const urlParams = isAntiTatico ? null : params;
      const url = urlParams ? `/${urlPage}${urlSlug}${urlTabSlug}?${new URLSearchParams(urlParams)}` : `/${urlPage}${urlSlug}${urlTabSlug}`;
      window.history.pushState({ page: normalizedPage, params }, '', url);
    }

    // Update active nav link
    document.querySelectorAll('.nav-link[data-page]').forEach(link => {
      link.classList.remove('active');
      const linkPage = this.normalizePageName(link.dataset.page);
      const matchPage = normalizedPage === 'zdpro-icones' ? 'valoplant' : normalizedPage;
      if (linkPage === matchPage) {
        link.classList.add('active');
      }
    });

    // Disclaimer da Riot fica so na home (zdval.site/).
    const riotFooter = document.querySelector('.riot-disclaimer');
    if (riotFooter) riotFooter.hidden = normalizedPage !== 'home';

    // Hide all pages, show target
    document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
    const pageElement = document.getElementById(`page-${normalizedPage}`);
    if (pageElement) {
      pageElement.classList.add('active');
    } else {
      // Page div doesn't exist — always fall back to home
      const fallbackPage = 'home';
      console.warn(`[App] Page "${normalizedPage}" not found, redirecting to ${fallbackPage}`);
      const fallback = document.getElementById(`page-${fallbackPage}`);
      if (fallback) fallback.classList.add('active');
      this.currentPage = fallbackPage;
      if (window.siteLogger) window.siteLogger.logNavigation(fallbackPage);
      if (fallbackPage === 'home' && typeof home !== 'undefined') home.load();
      else if (typeof lineups !== 'undefined') lineups.load();
      return;
    }

    // Scroll to top on page switch
    const pc = document.getElementById('pageContainer');
    if (pc) pc.scrollTop = 0;

    // Update breadcrumb
    this.updateBreadcrumb(normalizedPage);

    // Show immediate feedback, then load heavy page content on the next frame.
    this.currentPage = normalizedPage;
    this.currentParams = params;
    if (window.siteLogger) window.siteLogger.logNavigation(normalizedPage);
    this.showPageLoadingState(normalizedPage);
    this.schedulePageLoad(normalizedPage, params);
  }

  // Load page content
  async loadPageContent(page, params) {
    // ACESSO ABERTO: nenhuma página do frontend exige login ou time para abrir.
    // Não há mais lista de páginas públicas nem de páginas de time — o que
    // sobrava (TEAM_PAGES, showNoTeamMessage) já não era chamado por ninguém e
    // saiu junto.
    //
    // O backend continua exigindo token nos endpoints privados, e é ele que
    // mantém dado de um usuário longe de outro. O front trata a ausência de
    // token como "sem dados": a página abre no estado vazio, com o CTA de
    // login, em vez de mostrar erro.

    switch (page) {
      case 'home':
        if (typeof home !== 'undefined') {
          this.pageLoadRetries.delete(page);
          home.load(params);
        }
        else this.retryLoadPage(page, params);
        break;
      case 'lineups':
        if (typeof lineups !== 'undefined') {
          this.pageLoadRetries.delete(page);
          await lineups.load(params);
        }
        else this.retryLoadPage(page, params);
        break;
      case 'tactics':
        if (typeof tactics !== 'undefined') {
          this.pageLoadRetries.delete(page);
          await tactics.load(params);
        }
        else this.retryLoadPage(page, params);
        break;
      case 'antitactic':
        if (typeof antitactic !== 'undefined') {
          this.pageLoadRetries.delete(page);
          await antitactic.load(params);
        }
        else this.retryLoadPage(page, params);
        break;
      case 'valoplant':
        // ValoPlant v2 - Advanced Strategy Planner
        console.log('🎯 Navigating to ValoPlant, ValoPlantV2 defined:', typeof ValoPlantV2 !== 'undefined');
        if (typeof ValoPlantV2 !== 'undefined') {
          this.pageLoadRetries.delete(page);
          if (!window.valoplantInstance) {
            console.log('  Creating new ValoPlantV2 instance...');
            window.valoplantInstance = new ValoPlantV2();
          }
          console.log('  Calling load()...');
          await window.valoplantInstance.load(params);
        } else {
          console.error('  ❌ ValoPlantV2 is not defined!');
          this.retryLoadPage(page, params);
        }
        break;
      case 'zdpro-icones':
        if (typeof ValoPlantV2 !== 'undefined') {
          this.pageLoadRetries.delete(page);
          if (!window.valoplantInstance) {
            window.valoplantInstance = new ValoPlantV2();
          }
          await window.valoplantInstance.loadIconsPage(params);
        } else {
          this.retryLoadPage(page, params);
        }
        break;
      case 'analise':
        if (typeof analise !== 'undefined') {
          this.pageLoadRetries.delete(page);
          await analise.load(params);
        }
        else this.retryLoadPage(page, params);
        break;
      case 'ranked':
        if (typeof rankedStats !== 'undefined') {
          this.pageLoadRetries.delete(page);
          await rankedStats.load(params);
        }
        else this.retryLoadPage(page, params);
        break;
      case 'chat':
        if (typeof chat !== 'undefined') {
          this.pageLoadRetries.delete(page);
          chat.load(params);
        }
        else this.retryLoadPage(page, params);
        break;
      case 'team':
        if (typeof team !== 'undefined') {
          this.pageLoadRetries.delete(page);
          await team.load();
        }
        else this.retryLoadPage(page, params);
        break;
      case 'settings':
        if (typeof settings !== 'undefined') {
          this.pageLoadRetries.delete(page);
          await settings.load(params);
        }
        else this.retryLoadPage(page, params);
        break;
      case 'profile':
        if (typeof profile !== 'undefined') {
          this.pageLoadRetries.delete(page);
          await profile.load(params);
        }
        else this.retryLoadPage(page, params);
        break;
      case 'maps':
        // Maps is now integrated into Settings
        this.navigate('settings');
        return;
      case 'mymatches':
        // Legacy route — merged into Scrim Arena → Matches tab
        this.navigate('scrim');
        setTimeout(() => { if (typeof scrimArena !== 'undefined') scrimArena.switchTab('matches'); }, 300);
        return;
      case 'admin-users':
      case 'admin':
        // Admin panel lives in the dedicated standalone SPA at /admin/
        // (users, permissions, audit, logs, maps, icons)
        window.location.href = '/admin/dashboard';
        return;
      case 'scrim':
        if (typeof scrimArena !== 'undefined') {
          this.pageLoadRetries.delete(page);
          await scrimArena.load();
        }
        else this.retryLoadPage(page, params);
        break;
      case 'academy':
        if (typeof academy !== 'undefined') {
          this.pageLoadRetries.delete(page);
          await academy.load(params || {});
        }
        else this.retryLoadPage(page, params);
        break;
    }
  }

  // Load current page from URL
  loadCurrentPage() {
    const defaultPage = 'home';
    let rawPath = window.location.pathname.slice(1) || defaultPage;
    // /login has its own URL: render home underneath, then open the auth modal in login mode
    if (rawPath === 'login') {
      rawPath = 'home';
      setTimeout(() => {
        if (typeof auth !== 'undefined' && auth) auth.openAuth('login');
      }, 0);
    }
    // Trim trailing slash for non-antitatico paths
    if (rawPath.endsWith('/') && !rawPath.startsWith('antitatico')) {
      rawPath = rawPath.replace(/\/+$/, '') || defaultPage;
    }
    const isAntitatico = rawPath === 'antitatico' || rawPath.startsWith('antitatico/');
    const isZdproSession = rawPath.startsWith('zdpro-') && rawPath !== 'zdpro-icones';
    const atParts = this._parseAntitaticoParts(rawPath);
    const path = this.normalizePageName(rawPath);
    const queryString = window.location.search.slice(1);
    const queryParams = queryString ? Object.fromEntries(new URLSearchParams(queryString)) : null;
    let params = isAntitatico
      ? { ...(queryParams || {}), ...(atParts.opponentSlug ? { opponentSlug: atParts.opponentSlug } : {}), ...(atParts.tabSlug ? { atTab: atParts.tabSlug } : {}) }
      : queryParams;
    if (isZdproSession) {
      const sessionCode = rawPath.slice(6); // after 'zdpro-'
      params = { ...(params || {}), sessionCode };
    }
    this.navigate(path || defaultPage, params, false);
  }

  // Update breadcrumb
  updateBreadcrumb(page) {
    const breadcrumb = document.getElementById('breadcrumb');
    if (!breadcrumb) return;
    const pageNames = {
      lineups: 'Lineups',
      tactics: 'Táticas',
      knowledge: 'Base de Conhecimento',
      schedule: 'Cronograma',
      chat: 'Chat',
      team: 'Meu Time',
      settings: 'Configurações',
      profile: 'Meu Perfil',
      valoplant: 'ZDPRO',
      replay2d: 'Replay 2D',
      telemetry: 'Telemetria',
      ranked: 'Minhas Ranqueadas',
      maps: 'Mapas',
      analise: 'Análise',
      scrim: 'Scrim Arena'
    };
    
    breadcrumb.innerHTML = `<span class="breadcrumb-item">${pageNames[page] || page}</span>`;
  }

  // Setup sidebar (now horizontal nav)
  setupSidebar() {
    const sidebar = document.getElementById('sidebar');

    // Logout button
    const logoutBtn = document.getElementById('logoutBtn');
    if (logoutBtn) {
      logoutBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (typeof auth !== 'undefined' && auth) {
          auth.logout();
        }
      });
    }
  }

  // Decorate sidebar nav items with agent icons + map backgrounds
  decorateSidebar() {
    const agents = this.agents || [];
    const maps = this.getMaps() || [];

    const findSplash = (name) => {
      const m = maps.find(x => x.display_name?.toLowerCase() === name.toLowerCase());
      return m?.splash || m?.listViewIcon || '';
    };

    const findAgent = (name) => {
      return agents.find(a => a.displayName === name || a.displayName?.toLowerCase() === name.toLowerCase());
    };

    const navConfig = {
      maps:       { agent: 'Brimstone', map: 'Bind' },
      lineups:    { agent: 'Sova',      map: 'Split' },
      tactics:    { agent: 'Jett',      map: 'Breeze' },
      antitactic: { agent: 'Cypher',    map: 'Pearl' },
      valoplant:  { agent: 'Astra',     map: 'Abyss' },
      ranked:     { agent: 'Fade',      map: 'Haven' },
      team:       { agent: 'Phoenix',   map: 'Breeze' },
      settings:   { agent: 'Killjoy',   map: 'Bind' }
    };

    document.querySelectorAll('.nav-link[data-page]').forEach(link => {
      const page = link.dataset.page;
      const cfg = navConfig[page];
      if (!cfg) return;

      // Agent icon only (map bg disabled for performance)
      const agent = findAgent(cfg.agent);
      const iconContainer = link.querySelector('.nav-agent-icon');
      if (iconContainer && agent?.displayIcon) {
        iconContainer.innerHTML = '';
        iconContainer.style.backgroundImage = `url(${agent.displayIcon})`;
        iconContainer.classList.add('nav-agent-loaded');
      }
    });
  }

  // Setup search
  setupSearch() {
    const searchInput = document.getElementById('globalSearch');
    
    // Guard: elemento pode não existir
    if (!searchInput) return;
    
    searchInput.addEventListener('focus', () => {
      // TODO: Show search modal with recent searches
    });

    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const query = searchInput.value.trim();
        if (query) {
          this.performSearch(query);
        }
      }
    });
  }

  // Perform global search
  async performSearch(query) {
    // TODO: Implement global search
    console.log('Search:', query);
  }

  // Setup team selector (now inside profile dropdown, no separate element needed)
  setupTeamSelector() {
    // Team selector is now merged into profile dropdown - no standalone element
  }

  // Show team selector dropdown
  showTeamSelector() {
    const existing = document.querySelector('.team-dropdown');
    if (existing) {
      existing.remove();
      return;
    }

    const dropdown = document.createElement('div');
    dropdown.className = 'team-dropdown dropdown-menu';
    
    const hasTeam = this.teams.length > 0;
    
    let teamsHTML = '';
    
    if (hasTeam) {
      // Verificar se usuário é super_admin
      const isSuperAdmin = auth.user && auth.user.role === 'super_admin';
      
      // Mostrar o time atual
      teamsHTML = this.teams.map(team => `
        <div class="dropdown-item team-item active" data-team-id="${team.id}">
          <img src="${team.logo_url || '/img/default-team.png'}" alt="${team.name}" class="team-logo">
          <span>${team.name}</span>
          <i class="fas fa-check"></i>
        </div>
      `).join('');
      
      dropdown.innerHTML = `
        ${teamsHTML}
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item" data-action="manage-team">
          <i class="fas fa-users-cog"></i> Gerenciar Membros
        </a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item text-danger" data-action="leave-team">
          <i class="fas fa-sign-out-alt"></i> Sair do Time
        </a>
        ${isSuperAdmin ? `
        <a href="#" class="dropdown-item text-danger" data-action="delete-team">
          <i class="fas fa-trash-alt"></i> Excluir Time (Admin)
        </a>
        ` : ''}
      `;
    } else {
      // Sem time - mostrar opções de criar ou entrar
      dropdown.innerHTML = `
        <div class="dropdown-item-empty">Você não está em nenhum time</div>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item" data-action="create-team">
          <i class="fas fa-plus"></i> Criar Time
        </a>
        <a href="#" class="dropdown-item" data-action="join-team">
          <i class="fas fa-sign-in-alt"></i> Entrar em um Time
        </a>
      `;
    }

    // Position dropdown
    const selector = document.getElementById('teamSelector');
    const rect = selector.getBoundingClientRect();
    dropdown.style.position = 'fixed';
    dropdown.style.top = `${rect.bottom + 5}px`;
    dropdown.style.right = `${window.innerWidth - rect.right}px`;
    dropdown.style.minWidth = '250px';

    document.body.appendChild(dropdown);

    // Handle clicks
    dropdown.addEventListener('click', async (e) => {
      e.preventDefault();
      const action = e.target.closest('.dropdown-item')?.dataset.action;
      
      if (action === 'create-team') {
        this.showCreateTeamModal();
      } else if (action === 'join-team') {
        this.showJoinTeamModal();
      } else if (action === 'manage-team') {
        this.showManageTeamModal();
      } else if (action === 'leave-team') {
        this.confirmLeaveTeam();
      } else if (action === 'delete-team') {
        this.confirmDeleteTeam();
      }
      
      dropdown.remove();
    });

    // Close on outside click
    setTimeout(() => {
      document.addEventListener('click', function handler(e) {
        if (!dropdown.contains(e.target) && !selector.contains(e.target)) {
          dropdown.remove();
          document.removeEventListener('click', handler);
        }
      });
    }, 0);
  }


  // Central de notificações: implementação em js/site-header.js, para o
  // /vpro ter o mesmo sino em vez de um botão inerte.
  setupNotifications() {
    SiteHeader.Notifications.init();
    socket.on('notification', (data) => SiteHeader.Notifications.push({
      title: data?.title || 'Notificação',
      message: data?.message || data?.body || '',
      icon: data?.icon || 'fas fa-bell'
    }));
    socket.on('announcementNew', (data) => SiteHeader.Notifications.push({
      title: 'Novo aviso',
      message: data?.title || '',
      icon: 'fas fa-bullhorn'
    }));
  }

  // Setup header profile dropdown trigger
  setupProfileDropdown() {
    SiteHeader.bindProfileTrigger(
      document.getElementById('headerProfile'),
      () => this.showProfileDropdown()
    );

    // Legacy hamburger menu toggle: hidden by CSS now, but keep the click
    // handler as a no-op safety net in case markup resurfaces elsewhere.
    const menuToggle = document.getElementById('headerProfileMenuToggle');
    if (menuToggle) {
      menuToggle.style.display = 'none';
      menuToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        this.showProfileDropdown();
      });
    }
  }

  // Show profile dropdown (like team selector)
  showProfileDropdown() {
    const existing = document.querySelector('.profile-dropdown');
    if (existing) {
      existing.remove();
      return;
    }

    const user = auth.user || {};
    const currentTeam = this.currentTeam;
    const pddRegionLabels = {
      'america-sul': 'América do Sul',
      'america-norte': 'América do Norte',
      europa: 'Europa',
      asia: 'Ásia',
      oceania: 'Oceania',
      africa: 'África',
      'oriente-medio': 'Oriente Médio'
    };
    const pddCountryCode = (user.country || 'BR').toUpperCase();
    const pddRegionLabel = pddRegionLabels[user.region] || 'Região não definida';
    const dropdown = document.createElement('div');
    dropdown.className = 'profile-dropdown dropdown-menu';

    // Markup em js/site-header.js: o /vpro monta o mesmo menu a partir dali.
    dropdown.innerHTML = SiteHeader.profileDropdownHtml({
      user,
      team: currentTeam,
      regionLabel: pddRegionLabel,
      countryCode: pddCountryCode
    });

    // Position dropdown centered below the header profile element
    const trigger = document.getElementById('headerProfile') || document.getElementById('headerProfileMenuToggle');
    if (!trigger) return;
    const rect = trigger.getBoundingClientRect();
    dropdown.style.position = 'fixed';
    dropdown.style.top = `${rect.bottom + 8}px`;
    dropdown.style.right = 'auto';
    // Mount first so we can measure its width, then clamp to the viewport.
    document.body.appendChild(dropdown);
    const ddWidth = dropdown.offsetWidth || 320;
    const triggerCenter = rect.left + rect.width / 2;
    let left = triggerCenter - ddWidth / 2;
    const margin = 16;
    if (left < margin) left = margin;
    if (left + ddWidth > window.innerWidth - margin) {
      left = window.innerWidth - margin - ddWidth;
    }
    dropdown.style.left = `${left}px`;

    // Handle clicks
    dropdown.addEventListener('click', (e) => {
      e.preventDefault();
      const item = e.target.closest('.pdd-item');
      if (!item) return;
      const action = item.dataset.action;

      switch (action) {
        case 'team-home':
          this.navigate('team');
          break;
        case 'ranked':
          this.navigate('ranked');
          break;
        case 'profile-edit':
          this.navigate('profile', { mode: 'edit' });
          break;
        case 'settings':
          this.navigate('settings');
          break;
        case 'create-team':
          this.showCreateTeamModal();
          break;
        case 'join-team':
          this.showJoinTeamModal();
          break;
        case 'logout':
          if (typeof auth !== 'undefined') auth.logout();
          break;
      }
      dropdown.remove();
    });

    // Close on outside click
    setTimeout(() => {
      document.addEventListener('click', function handler(e) {
        if (!dropdown.contains(e.target) && !trigger.contains(e.target)) {
          dropdown.remove();
          document.removeEventListener('click', handler);
        }
      });
    }, 0);
  }

  // Select team
  async selectTeam(teamId) {
    const team = this.teams.find(t => t.id === teamId);
    if (!team) return;

    // Leave old team room
    if (this.currentTeam) {
      socket.leaveRoom(`team:${this.currentTeam.id}`);
    }

    this.currentTeam = team;
    localStorage.setItem('zdval_current_team', teamId);

    // Join new team room
    socket.joinRoom(`team:${teamId}`);

    this.updateTeamUI();

    // Reload current page
    this.loadPageContent(this.currentPage);

    toast.success('Time alterado', `Agora você está visualizando ${team.name}`);
  }

  updateTeamUI() {
    const logo = document.getElementById('currentTeamLogo');
    const name = document.getElementById('currentTeamName');

    if (this.currentTeam) {
      if (logo) logo.src = this.currentTeam.logo_url || '/img/default-team.png';
      if (name) name.textContent = this.currentTeam.name;
    } else {
      if (logo) logo.src = '/img/default-team.png';
      if (name) name.textContent = 'Selecionar Time';
    }

    // Toggle dim on team nav section
    const teamMenu = document.getElementById('navMenuTeam');
    if (teamMenu) {
      teamMenu.classList.toggle('nav-menu-no-team', !this.currentTeam);
    }
  }

  // Show create team modal
  showCreateTeamModal() {
    this.injectCreateTeamStyles();
    const modal = this.createModal('Criar Time', `
      <form id="createTeamForm" class="create-team-form">
        <div class="form-group">
          <label for="teamName">Nome do Time</label>
          <input type="text" id="teamName" class="form-input" placeholder="Ex: Team Phoenix" required>
        </div>
        <div class="form-group">
          <label for="teamTag">Tag (3-5 caracteres)</label>
          <input type="text" id="teamTag" class="form-input" placeholder="Ex: PHX" maxlength="5" required>
        </div>
        <div class="form-group">
          <label for="teamDescription">Descrição (opcional)</label>
          <textarea id="teamDescription" class="form-input" rows="3" placeholder="Sobre o time..."></textarea>
        </div>
        <div class="form-group">
          <label for="teamOwnerRole">Sua função no time</label>
          <select id="teamOwnerRole" class="form-input" required>
            <option value="player">🎮 Jogador</option>
            <option value="igl">👑 IGL</option>
            <option value="coach">🎯 Coach</option>
            <option value="analyst">📊 Analista</option>
            <option value="manager">📋 Manager</option>
          </select>
        </div>
        <div class="form-actions">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="submit" class="btn btn-primary">Criar Time</button>
        </div>
      </form>
    `, { modalClass: 'create-team-modal-premium' });

    const form = modal.querySelector('#createTeamForm');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const name = document.getElementById('teamName').value;
      const tag = document.getElementById('teamTag').value;
      const description = document.getElementById('teamDescription').value;
      const role = document.getElementById('teamOwnerRole').value;

      try {
        const result = await api.createTeam({ name, tag, description, role });
        if (result.success) {
          this.teams.push(result.data.team);
          await this.selectTeam(result.data.team.id);
          modal.remove();
          toast.success('Time criado!', 'Seu time foi criado com sucesso');
        }
      } catch (error) {
        toast.error('Erro', error.message);
      }
    });
  }

  // Show join team modal
  showJoinTeamModal() {
    const modal = this.createModal('Entrar em um Time', `
      <form id="joinTeamForm" class="join-team-form">
        <div class="form-group">
          <label for="inviteCode">Código de Convite</label>
          <input type="text" id="inviteCode" class="form-input" placeholder="Cole o código aqui" required>
        </div>
        <div class="form-actions">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="submit" class="btn btn-primary">Entrar</button>
        </div>
      </form>
    `, { modalClass: 'join-team-modal-premium' });

    this.injectJoinTeamStyles();

    const form = modal.querySelector('#joinTeamForm');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const inviteCode = document.getElementById('inviteCode').value;
      
      try {
        const result = await api.joinTeam(inviteCode);
        if (result.success) {
          this.teams.push(result.data.team);
          await this.selectTeam(result.data.team.id);
          modal.remove();
          toast.success('Bem-vindo!', `Você entrou no time ${result.data.team.name}`);
        }
      } catch (error) {
        toast.error('Erro', error.message);
      }
    });
  }

  // Show manage team modal (add members)
  async showManageTeamModal() {
    if (!this.currentTeam) return;
    
    // Load team members
    let members = [];
    try {
      const result = await api.getTeam(this.currentTeam.id);
      if (result.success) {
        members = result.data.members || [];
      }
    } catch (error) {
      console.error('Error loading team members:', error);
    }
    
    const roleLabels = {
      'coach': '🎯 Coach',
      'analyst': '📊 Analista',
      'player': '🎮 Jogador',
      'igl': '👑 IGL',
      'psychologist': '🧠 Psicólogo',
      'manager': '📋 Manager'
    };
    
    const membersHTML = members.map(m => `
      <div class="member-item">
        <div class="member-avatar-wrapper">
          <img src="${m.avatar_url || '/img/default-avatar.png'}" alt="${m.display_name}" class="member-avatar" id="avatar-${m.id}">
          ${m.id === auth.user.id ? `
            <label class="avatar-upload-btn" title="Trocar foto">
              <i class="fas fa-camera"></i>
              <input type="file" accept="image/*" onchange="app.uploadAvatar(this, '${m.id}')" hidden>
            </label>
          ` : ''}
        </div>
        <div class="member-info">
          <span class="member-name">${m.display_name || m.username}</span>
          <span class="member-role">${roleLabels[m.role] || m.role}</span>
        </div>
        ${m.id !== auth.user.id ? `
          <button class="btn btn-icon btn-sm text-danger" onclick="app.removeMember('${m.id}')" title="Remover">
            <i class="fas fa-times"></i>
          </button>
        ` : '<span class="badge badge-primary">Você</span>'}
      </div>
    `).join('');
    
    const modal = this.createModal('Gerenciar Membros', `
      <div class="manage-members">
        <div class="section-title">Membros Atuais (${members.length})</div>
        <div class="members-list">
          ${membersHTML || '<p class="text-muted">Nenhum membro encontrado</p>'}
        </div>
        
        <div class="dropdown-divider" style="margin: 1rem 0;"></div>
        
        <div class="section-title">Adicionar Novo Membro</div>
        <form id="addMemberForm">
          <div class="form-group">
            <label>Email do Usuário</label>
            <input type="email" id="memberEmail" class="form-input" placeholder="email@exemplo.com" required>
          </div>
          <div class="form-group">
            <label>Função</label>
            <select id="memberRole" class="form-input">
              <option value="player">🎮 Jogador</option>
              <option value="igl">👑 IGL (In-Game Leader)</option>
              <option value="coach">🎯 Coach</option>
              <option value="analyst">📊 Analista</option>
              <option value="psychologist">🧠 Psicólogo</option>
              <option value="manager">📋 Manager</option>
            </select>
          </div>
          <div class="form-actions">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <button type="submit" class="btn btn-primary">
              <i class="fas fa-user-plus"></i> Adicionar
            </button>
          </div>
        </form>
      </div>
      <style>
        .manage-members .section-title {
          font-weight: 600;
          margin-bottom: 0.75rem;
          color: var(--text-primary);
        }
        .members-list {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          max-height: 200px;
          overflow-y: auto;
        }
        .member-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 0.5rem;
          background: var(--bg-input);
          border-radius: var(--radius-md);
        }
        .member-avatar-wrapper {
          position: relative;
          width: 36px;
          height: 36px;
        }
        .member-avatar {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          object-fit: cover;
        }
        .avatar-upload-btn {
          position: absolute;
          bottom: -4px;
          right: -4px;
          width: 20px;
          height: 20px;
          background: var(--primary);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
          border: 2px solid var(--bg-card);
        }
        .avatar-upload-btn:hover {
          background: var(--primary-dark);
          transform: scale(1.1);
        }
        .avatar-upload-btn i {
          font-size: 10px;
          color: white;
        }
        .member-info {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .member-name {
          font-weight: 500;
        }
        .member-role {
          font-size: 0.8rem;
          color: var(--text-muted);
        }
        .btn-sm {
          padding: 0.25rem 0.5rem;
          font-size: 0.8rem;
        }
        .badge {
          padding: 0.25rem 0.5rem;
          font-size: 0.7rem;
          border-radius: var(--radius-sm);
        }
        .badge-primary {
          background: var(--primary);
          color: white;
        }
      </style>
    `);

    const form = modal.querySelector('#addMemberForm');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const email = document.getElementById('memberEmail').value;
      const role = document.getElementById('memberRole').value;
      
      try {
        const result = await api.addTeamMember(this.currentTeam.id, { email, role });
        if (result.success) {
          modal.remove();
          toast.success('Membro adicionado!', `Convite enviado para ${email}`);
          // Reabrir modal para mostrar atualização
          this.showManageTeamModal();
        }
      } catch (error) {
        toast.error('Erro', error.message);
      }
    });
  }

  // Upload avatar
  async uploadAvatar(input, userId) {
    const file = input.files[0];
    if (!file) return;

    // Validar tipo de arquivo
    if (!file.type.startsWith('image/')) {
      toast.error('Erro', 'Selecione uma imagem válida');
      return;
    }

    // Validar tamanho (máx 5MB)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Erro', 'A imagem deve ter no máximo 5MB');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('avatar', file);

      const result = await api.uploadAvatar(formData);
      
      if (result.success) {
        // Atualizar imagem no modal
        const avatarImg = document.getElementById(`avatar-${userId}`);
        if (avatarImg) {
          avatarImg.src = result.data.avatar_url + '?t=' + Date.now();
        }
        
        // Atualizar auth.user
        if (auth.user) {
          auth.user.avatar_url = result.data.avatar_url;
        }
        
        // Atualizar avatar no header
        const headerAvatar = document.querySelector('.user-profile img');
        if (headerAvatar) {
          headerAvatar.src = result.data.avatar_url + '?t=' + Date.now();
        }

        toast.success('Foto atualizada!', 'Seu avatar foi alterado com sucesso');
      }
    } catch (error) {
      toast.error('Erro ao enviar', error.message);
    }
  }

  // Remove member from team
  async removeMember(userId) {
    if (!this.currentTeam) return;
    
    const confirmed = await team.showConfirm(
      'Remover Membro',
      'O membro perde o acesso ao time imediatamente. Ele pode voltar com um novo convite.',
      'Remover', 'Cancelar', 'fas fa-user-minus'
    );
    if (!confirmed) return;
    
    try {
      const result = await api.removeTeamMember(this.currentTeam.id, userId);
      if (result.success) {
        toast.success('Membro removido', 'O membro foi removido do time');
        // Recarregar modal
        document.querySelector('.app-modal-overlay')?.remove();
        this.showManageTeamModal();
      }
    } catch (error) {
      toast.error('Erro', error.message);
    }
  }

  // Show team settings modal
  showTeamSettingsModal() {
    if (!this.currentTeam) return;
    
    const currentLogo = this.currentTeam.logo_url || '/img/default-team-riot.png';
    
    const modal = this.createModal('Configurações do Time', `
      <div class="team-settings-auth">
        <form id="teamSettingsForm" class="auth-form active" style="display:block;">
          <div class="form-group tsa-logo-group">
            <label>Logo do Time</label>
            <div class="team-logo-upload">
              <div class="logo-preview-container">
                <img id="teamLogoPreview" src="${currentLogo}" alt="Logo do time" class="team-logo-preview" onerror="this.src='/img/default-team-riot.png'">
                <div class="logo-overlay" onclick="document.getElementById('teamLogoInput').click()">
                  <i class="fas fa-camera"></i>
                  <span>Alterar</span>
                </div>
              </div>
              <input type="file" id="teamLogoInput" accept="image/*" style="display: none;">
              <p class="tsa-hint">Clique na imagem para alterar. Recomendado: 256x256px</p>
            </div>
          </div>
          <div class="form-group">
            <label for="editTeamName">Nome do Time</label>
            <div class="input-icon">
              <i class="fas fa-users"></i>
              <input type="text" id="editTeamName" placeholder="Nome do time" value="${this.currentTeam.name}" required>
            </div>
          </div>
          <div class="form-group">
            <label for="editTeamTag">Tag</label>
            <div class="input-icon">
              <i class="fas fa-tag"></i>
              <input type="text" id="editTeamTag" placeholder="TAG" value="${this.currentTeam.tag || ''}" maxlength="5">
            </div>
          </div>
          <div class="form-group">
            <label for="editTeamDescription">Descrição</label>
            <div class="input-icon tsa-textarea-icon">
              <i class="fas fa-align-left"></i>
              <textarea id="editTeamDescription" placeholder="Fale um pouco sobre o time" rows="3" maxlength="200">${this.currentTeam.description || ''}</textarea>
            </div>
          </div>
          <div class="form-group">
            <label for="inviteCodeDisplay">Código de Convite</label>
            <div class="tsa-invite-group">
              <div class="input-icon">
                <i class="fas fa-key"></i>
                <input type="text" id="inviteCodeDisplay" value="${this.currentTeam.invite_code || 'Gerando...'}" readonly>
              </div>
              <button type="button" class="btn-icon tsa-invite-btn" onclick="app.copyInviteCode()" title="Copiar código">
                <i class="fas fa-copy"></i>
              </button>
              <button type="button" class="btn-icon tsa-invite-btn" onclick="app.regenerateInviteCode()" title="Gerar novo código">
                <i class="fas fa-sync"></i>
              </button>
            </div>
          </div>
          <div class="tsa-actions">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button type="submit" class="btn btn-primary">
              <i class="fas fa-check"></i>
              <span>Salvar</span>
            </button>
          </div>
        </form>
      </div>
    `, { modalClass: 'team-settings-modal' });

    this.injectTeamSettingsStyles();

    // Setup logo upload handler
    const logoInput = modal.querySelector('#teamLogoInput');
    const logoPreview = modal.querySelector('#teamLogoPreview');
    
    logoInput.addEventListener('change', async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      
      // Validar tipo
      if (!file.type.startsWith('image/')) {
        toast.error('Erro', 'Selecione uma imagem válida');
        return;
      }
      
      // Validar tamanho (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error('Erro', 'Imagem deve ter no máximo 5MB');
        return;
      }
      
      // Preview imediato
      const reader = new FileReader();
      reader.onload = (e) => {
        logoPreview.src = e.target.result;
      };
      reader.readAsDataURL(file);
      
      // Upload
      try {
        const formData = new FormData();
        formData.append('logo', file);
        
        toast.info('Enviando...', 'Fazendo upload do logo');
        
        const result = await api.uploadTeamLogo(this.currentTeam.id, formData);
        
        if (result.success) {
          this.currentTeam.logo_url = result.data.logo_url;
          this.updateTeamUI();
          toast.success('Sucesso!', 'Logo atualizado');
        }
      } catch (error) {
        toast.error('Erro', error.message);
        // Reverter preview
        logoPreview.src = currentLogo;
      }
    });

    // Load invite code if not present
    if (!this.currentTeam.invite_code) {
      this.loadInviteCode();
    }

    const form = modal.querySelector('#teamSettingsForm');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const updates = {
        name: document.getElementById('editTeamName').value,
        tag: document.getElementById('editTeamTag').value,
        description: document.getElementById('editTeamDescription').value
      };
      
      try {
        const result = await api.updateTeam(this.currentTeam.id, updates);
        if (result.success) {
          // Update local data
          Object.assign(this.currentTeam, updates);
          this.updateTeamUI();
          modal.remove();
          toast.success('Salvo!', 'Configurações atualizadas');
        }
      } catch (error) {
        toast.error('Erro', error.message);
      }
    });
  }

  // Load invite code
  async loadInviteCode() {
    try {
      const result = await api.getTeamInviteCode(this.currentTeam.id);
      if (result.success) {
        this.currentTeam.invite_code = result.data.invite_code;
        const input = document.getElementById('inviteCodeDisplay');
        if (input) input.value = result.data.invite_code;
      }
    } catch (error) {
      console.error('Error loading invite code:', error);
    }
  }

  // Copy invite code
  copyInviteCode() {
    const code = document.getElementById('inviteCodeDisplay')?.value;
    if (code) {
      navigator.clipboard.writeText(code);
      toast.success('Copiado!', 'Código de convite copiado');
    }
  }

  // Regenerate invite code
  async regenerateInviteCode() {
    // O confirm() nativo do navegador quebrava o desenho do modal escuro;
    // team.showConfirm() é a caixa premium que o resto do time já usa.
    const confirmed = await team.showConfirm(
      'Gerar Novo Código',
      'O código atual será <strong>invalidado permanentemente</strong>. Qualquer link ou código compartilhado anteriormente deixará de funcionar.',
      'Gerar Novo', 'Cancelar', 'fas fa-sync-alt'
    );
    if (!confirmed) return;
    
    try {
      const result = await api.regenerateTeamInviteCode(this.currentTeam.id);
      if (result.success) {
        this.currentTeam.invite_code = result.data.invite_code;
        document.getElementById('inviteCodeDisplay').value = result.data.invite_code;
        toast.success('Novo código gerado!', 'Compartilhe com seus membros');
      }
    } catch (error) {
      toast.error('Erro', error.message);
    }
  }

  // Confirm leave team
  confirmLeaveTeam() {
    if (!this.currentTeam) return;
    
    const modal = this.createModal('Sair do Time', `
      <div class="confirm-leave">
        <i class="fas fa-exclamation-triangle text-warning" style="font-size: 3rem; margin-bottom: 1rem;"></i>
        <p>Tem certeza que deseja sair do time <strong>${this.currentTeam.name}</strong>?</p>
        <p class="text-muted">Você perderá acesso a todas as táticas, lineups e dados do time.</p>
        <div class="form-actions" style="justify-content: center;">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" onclick="app.leaveTeam()">
            <i class="fas fa-sign-out-alt"></i> Sair do Time
          </button>
        </div>
      </div>
      <style>
        .confirm-leave {
          text-align: center;
          padding: 1rem 0;
        }
        .text-warning {
          color: var(--warning);
        }
      </style>
    `);
  }

  // Leave team
  async leaveTeam() {
    if (!this.currentTeam) return;
    
    try {
      const result = await api.leaveTeam(this.currentTeam.id);
      if (result.success) {
        // Remove team from list
        this.teams = this.teams.filter(t => t.id !== this.currentTeam.id);
        
        // Clear current team
        socket.leaveRoom(`team:${this.currentTeam.id}`);
        this.currentTeam = null;
        localStorage.removeItem('zdval_current_team');
        
        this.updateTeamUI();
        
        // Close modal
        document.querySelector('.app-modal-overlay')?.remove();
        
        toast.success('Você saiu do time', 'Crie ou entre em um novo time');
        
        // Reload page
        this.loadPageContent(this.currentPage);
      }
    } catch (error) {
      toast.error('Erro', error.message);
    }
  }

  // Confirm delete team (Super Admin only)
  confirmDeleteTeam() {
    if (!this.currentTeam) return;
    
    // Check if user is super_admin
    if (!auth.user || auth.user.role !== 'super_admin') {
      toast.error('Acesso Negado', 'Apenas administradores podem excluir times');
      return;
    }
    
    const modal = this.createModal('⚠️ Excluir Time', `
      <div class="confirm-delete">
        <i class="fas fa-exclamation-triangle text-danger" style="font-size: 3rem; margin-bottom: 1rem;"></i>
        <p><strong>ATENÇÃO!</strong> Esta ação é <strong>IRREVERSÍVEL</strong>!</p>
        <p>Você está prestes a excluir permanentemente o time <strong style="color: var(--danger);">${this.currentTeam.name}</strong>.</p>
        <p class="text-muted">Isso irá remover:</p>
        <ul style="text-align: left; color: var(--text-muted); font-size: 0.9rem;">
          <li>Todas as táticas do time</li>
          <li>Todos os lineups</li>
          <li>Todas as partidas</li>
          <li>Todos os membros serão desvinculados</li>
          <li>Todos os arquivos associados</li>
        </ul>
        <div class="form-group" style="margin-top: 1rem;">
          <label>Digite o nome do time para confirmar:</label>
          <input type="text" id="confirmTeamName" class="form-input" placeholder="${this.currentTeam.name}">
        </div>
        <div class="form-actions" style="justify-content: center;">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" id="btnConfirmDelete" disabled>
            <i class="fas fa-trash-alt"></i> Excluir Permanentemente
          </button>
        </div>
      </div>
      <style>
        .confirm-delete {
          text-align: center;
          padding: 1rem 0;
        }
        .text-danger {
          color: var(--danger);
        }
        #btnConfirmDelete:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      </style>
    `);

    const confirmInput = modal.querySelector('#confirmTeamName');
    const deleteBtn = modal.querySelector('#btnConfirmDelete');
    
    confirmInput.addEventListener('input', () => {
      deleteBtn.disabled = confirmInput.value !== this.currentTeam.name;
    });
    
    deleteBtn.addEventListener('click', () => {
      if (confirmInput.value === this.currentTeam.name) {
        this.deleteTeam();
      }
    });
  }

  // Delete team (Super Admin only)
  async deleteTeam() {
    if (!this.currentTeam) return;
    
    // Check if user is super_admin
    if (!auth.user || auth.user.role !== 'super_admin') {
      toast.error('Acesso Negado', 'Apenas administradores podem excluir times');
      return;
    }
    
    try {
      const result = await api.deleteTeam(this.currentTeam.id);
      if (result.success) {
        // Remove team from list
        this.teams = this.teams.filter(t => t.id !== this.currentTeam.id);
        
        // Clear current team
        socket.leaveRoom(`team:${this.currentTeam.id}`);
        this.currentTeam = null;
        localStorage.removeItem('zdval_current_team');
        
        this.updateTeamUI();
        
        // Close modal
        document.querySelector('.app-modal-overlay')?.remove();
        
        toast.success('Time Excluído', 'O time foi removido permanentemente');
        
        // Reload page
        this.loadPageContent(this.currentPage);
      }
    } catch (error) {
      toast.error('Erro ao excluir', error.message);
    }
  }

  // Create modal helper
  createModal(title, content, options = {}) {
    const size = options.size || 'default';
    const sizeClass = size === 'medium' ? 'modal-medium' : size === 'large' ? 'modal-large' : '';
    const extraClass = options.modalClass || '';

    const modal = document.createElement('div');
    modal.className = 'modal-overlay app-modal-overlay';
    modal.innerHTML = `
      <div class="modal ${sizeClass} ${extraClass}">
        <div class="modal-header">
          <h3>${title}</h3>
          <button class="btn-icon" data-dismiss="modal">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          ${content}
        </div>
      </div>
    `;

    // O CSS mora em css/pages/app-modals.css. Ficava aqui como template string,
    // somando peso ao bundle de JS e impedindo que a folha fosse cacheada
    // e minificada em separado. Segue carregando sob demanda, como antes.
    if (!document.getElementById('app-modal-styles')) {
      Utils.loadPageCss('app-modal-styles', 'app-modals.css');
    }

    document.body.appendChild(modal);

    // Handle dismiss
    modal.querySelectorAll('[data-dismiss="modal"]').forEach(btn => {
      btn.addEventListener('click', () => modal.remove());
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal) modal.remove();
    });

    return modal;
  }

  // Injects team settings modal styles once (auth-container light theme reused)
  injectTeamSettingsStyles() {
    // O CSS mora em css/pages/app-modals.css. Ficava aqui como template string,
    // somando peso ao bundle de JS e impedindo que a folha fosse cacheada
    // e minificada em separado. Segue carregando sob demanda, como antes.
    if (!document.getElementById('team-settings-modal-styles')) {
      Utils.loadPageCss('team-settings-modal-styles', 'app-modals.css');
    }
  }

  // Injects "Criar Time" premium modal styles (white bg, black text, light outline)
  injectCreateTeamStyles() {
    // O CSS mora em css/pages/app-modals.css. Ficava aqui como template string,
    // somando peso ao bundle de JS e impedindo que a folha fosse cacheada
    // e minificada em separado. Segue carregando sob demanda, como antes.
    if (!document.getElementById('create-team-modal-styles')) {
      Utils.loadPageCss('create-team-modal-styles', 'app-modals.css');
    }
  }

  // Injects "Entrar em um Time" premium modal styles (white bg, black text, light outline)
  injectJoinTeamStyles() {
    // O CSS mora em css/pages/app-modals.css. Ficava aqui como template string,
    // somando peso ao bundle de JS e impedindo que a folha fosse cacheada
    // e minificada em separado. Segue carregando sob demanda, como antes.
    if (!document.getElementById('join-team-modal-styles')) {
      Utils.loadPageCss('join-team-modal-styles', 'app-modals.css');
    }
  }

  // Close all modals helper (only Pattern A modals created by createModal)
  closeModal() {
    const modal = document.querySelector('.app-modal-overlay');
    if (modal) modal.remove();
  }

  // Setup keyboard shortcuts
  setupShortcuts() {
    document.addEventListener('keydown', (e) => {
      // Ctrl+K - Focus search
      if (e.ctrlKey && e.key === 'k') {
        e.preventDefault();
        document.getElementById('globalSearch').focus();
      }
      
      // Escape - Close modals (only Pattern A modals from createModal)
      if (e.key === 'Escape') {
        const modal = document.querySelector('.app-modal-overlay');
        if (modal) modal.remove();
      }
    });
  }

  // Request notification permission
  requestNotificationPermission() {
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }

  // Get current team
  getCurrentTeam() {
    return this.currentTeam;
  }

  // Get maps (only active)
  getMaps() {
    return (this.maps || []).filter(m => m.is_active !== false);
  }

  // Get all maps (including inactive)
  getAllMaps() {
    return this.maps || [];
  }

  // Update maps cache
  setMaps(maps) {
    this.maps = maps;
  }

  // Reload maps from API
  async reloadMaps() {
    try {
      const result = await api.getMaps();
      if (result.success) {
        this.maps = result.data.maps;
        console.log('Maps reloaded:', this.maps.length);
      }
    } catch (error) {
      console.error('Reload maps error:', error);
    }
  }

  // Get agents
  getAgents() {
    return this.agents;
  }

  // Get agent by ID
  getAgent(id) {
    return this.agents.find(a => a.id === id);
  }

  // Get map by ID
  getMap(id) {
    return this.maps.find(m => m.id === id);
  }
}

// Toast notification system
const toast = {
  container: null,
  
  init() {
    this.container = document.getElementById('toastContainer');
  },
  
  show(type, title, message, duration = 4000) {
    if (!this.container) this.init();
    
    const icons = {
      success: 'fa-check',
      error: 'fa-times',
      warning: 'fa-exclamation',
      info: 'fa-info'
    };
    
    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;
    toast.innerHTML = `
      <div class="toast-icon">
        <i class="fas ${icons[type]}"></i>
      </div>
      <div class="toast-content">
        <div class="toast-title">${title}</div>
        ${message ? `<div class="toast-message">${message}</div>` : ''}
      </div>
      <button class="btn-icon toast-close">
        <i class="fas fa-times"></i>
      </button>
    `;
    
    this.container.appendChild(toast);
    
    // Close button
    toast.querySelector('.toast-close').addEventListener('click', () => {
      this.close(toast);
    });
    
    // Auto close
    if (duration > 0) {
      setTimeout(() => this.close(toast), duration);
    }
    
    return toast;
  },
  
  close(toast) {
    toast.classList.add('toast-exit');
    setTimeout(() => toast.remove(), 300);
  },
  
  success(title, message) { return this.show('success', title, message); },
  error(title, message) { return this.show('error', title, message, 6000); },
  warning(title, message) { return this.show('warning', title, message, 5000); },
  info(title, message) { return this.show('info', title, message); }
};

// Initialize app instance
const app = new App();
window.app = app;


/* ===== js/home.js ===== */
// =====================================================
// ZDVAL - Home (Landing) Page
// Public page shown to visitors (logged in or not).
// Hero + sponsors + news placeholders.
// Content is intentionally minimal here — the admin will
// add designs, sponsors and news via future admin tools.
// =====================================================

// SVG icons reused by the "Jogo Competitivo" cards.
const HOME_PLAY_ICONS = {
  lobby: `
    <svg viewBox="0 0 29 42" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
      <path d="M10.3027 2.96503C10.2855 3.12914 10.277 3.2941 10.2771 3.45919C10.2771 5.91038 12.1638 7.90405 14.5 7.90405C16.8362 7.90405 18.7229 5.91038 18.7229 3.45919C18.7229 3.29208 18.7144 3.12677 18.6973 2.96503H27.231C28.2085 2.96503 29 3.7943 29 4.81749V40.1466C29 41.1702 28.208 42 27.231 42H1.769C0.792008 42 0 41.1702 0 40.1466V4.81749C0 3.7943 0.791529 2.96503 1.769 2.96503H10.3027ZM3.27444 15.8117C4.56579 15.8117 5.61321 14.7054 5.61321 13.3408C5.61321 11.9772 4.56579 10.8709 3.27444 10.8709C1.98224 10.8709 0.935677 11.9772 0.935677 13.3408C0.935677 14.7054 1.98224 15.8117 3.27444 15.8117ZM8.88679 15.8117C10.179 15.8117 11.2256 14.7054 11.2256 13.3408C11.2256 11.9772 10.179 10.8709 8.88679 10.8709C7.59544 10.8709 6.54803 11.9772 6.54803 13.3408C6.54803 14.7054 7.59544 15.8117 8.88679 15.8117ZM14.5 15.8117C15.7914 15.8117 16.8388 14.7054 16.8388 13.3408C16.8388 11.9772 15.7914 10.8709 14.5 10.8709C13.2086 10.8709 12.1612 11.9772 12.1612 13.3408C12.1612 14.7054 13.2086 15.8117 14.5 15.8117ZM20.1124 15.8117C21.4046 15.8117 22.452 14.7054 22.452 13.3408C22.452 11.9772 21.4046 10.8709 20.1132 10.8709C18.821 10.8709 17.7744 11.9772 17.7744 13.3408C17.7744 14.7054 18.821 15.8117 20.1132 15.8117H20.1124ZM25.7256 15.8117C27.0178 15.8117 28.0643 14.7054 28.0643 13.3408C28.0643 11.9772 27.0178 10.8709 25.7256 10.8709C24.4342 10.8709 23.3868 11.9772 23.3868 13.3408C23.3868 14.7054 24.4342 15.8117 25.7256 15.8117ZM14.5 6.91749C12.6918 6.91749 11.2256 5.36885 11.2256 3.45919C11.2256 1.54863 12.6918 0 14.5 0C16.3082 0 17.7744 1.54865 17.7744 3.45831C17.7744 5.36886 16.3082 6.91749 14.5 6.91749ZM3.72735 32.8699C3.12439 32.8699 2.63559 33.382 2.63559 34.0137V39.0305C2.63559 39.6614 3.12518 40.1743 3.72735 40.1743H26.1512C26.7541 40.1743 27.2429 39.6622 27.2429 39.0305V34.0137C27.2429 33.382 26.7541 32.8699 26.1512 32.8699H3.72735Z" fill="currentColor"/>
    </svg>`,
  tournaments: `
    <svg viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18 13.5H15.75V9H56.25V13.5H54V18H61.875V39.5557L53.934 44.0934C53.2597 50.9186 47.5025 56.25 40.5 56.25H38.25V63H47.25V67.5H24.75V63H33.75V56.25H31.5C24.5264 56.25 18.7878 50.9625 18.0746 44.1779L9 39.6406V18H18V13.5ZM22.5 13.5V42.75C22.5 47.7206 26.5294 51.75 31.5 51.75H40.5C45.4706 51.75 49.5 47.7206 49.5 42.75V13.5H22.5ZM18 22.5H13.5V36.8594L18 39.1094V22.5ZM54 38.8728L57.375 36.9443V22.5H54V38.8728Z" fill="currentColor"/>
    </svg>`,
  wipe: `
    <svg viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
      <path d="M46 0H0V46L46 0Z" fill="currentColor"/>
    </svg>`
};

const HOME_PLAY_MODES = [
  {
    id: 'lobby',
    color: 'lobby',
    title: 'Lobby',
    description: 'Junte seus amigos e desafie outras salas em uma partida 5x5 valendo Rating Points.',
    icon: HOME_PLAY_ICONS.lobby,
    href: '/vpro'
  },
  {
    id: 'tournaments',
    color: 'tournaments',
    title: 'Campeonatos',
    description: 'Participe dos campeonatos semanais e comece sua carreira pro nas ligas.',
    icon: HOME_PLAY_ICONS.tournaments,
    href: '/vpro/leaderboard'
  }
];

const HOME_PLAY_STYLE_ID = 'home-play-modes-styles';

function ensureHomePlayStyles() {
  Utils.loadPageCss(HOME_PLAY_STYLE_ID, 'home-play.css');
}

function escHome(s) {
  return String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

function isHomeVideoUrl(url) {
  return /\.(mp4|webm|ogg|mov|m4v|mkv)(\?|#|$)/i.test(String(url || '').trim());
}

function getHomeYoutubeId(url) {
  const media = String(url || '').trim();
  const match = media.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/i);
  return match ? match[1] : '';
}

function buildHomeYoutubeQuery({ autoplay, muted, loop, controls, minimalControls = false, ytId = '' } = {}) {
  const params = [
    `autoplay=${autoplay ? 1 : 0}`,
    `mute=${muted ? 1 : 0}`,
    `controls=${controls ? 1 : 0}`,
    `loop=${loop ? 1 : 0}`,
    'modestbranding=1',
    'rel=0',
    'playsinline=1'
  ];

  if (loop && ytId) params.push(`playlist=${encodeURIComponent(ytId)}`);

  // YouTube does not support fully custom controls in iframe embeds.
  // These flags reduce non-essential UI to approximate volume + seekbar behavior.
  if (minimalControls && controls) {
    params.push('fs=0');
    params.push('cc_load_policy=0');
    params.push('iv_load_policy=3');
    params.push('disablekb=1');
  }

  return params.join('&');
}

// ------------------------------------------------------------------
// Minimal YouTube player (mute button + seek bar only)
// Uses the YT IFrame JS API with controls=0 and a custom HTML overlay,
// because YouTube's embed params cannot selectively hide controls.
// ------------------------------------------------------------------
let _homeYtMinUid = 0;
function renderHomeMinimalYoutube({ ytId, wrapperClass = '', mediaClass = '', alt = '', autoplay = true, muted = true, loop = false }) {
  const uid = 'home-yt-min-' + (++_homeYtMinUid);
  return `<div class="${wrapperClass} home-yt-minimal is-paused"
       data-yt-id="${escHome(ytId)}"
       data-yt-autoplay="${autoplay ? 1 : 0}"
       data-yt-muted="${muted ? 1 : 0}"
       data-yt-loop="${loop ? 1 : 0}"
       data-yt-target="${uid}">
    <div id="${uid}" class="${mediaClass} home-yt-minimal-target" title="${escHome(alt)}"></div>
    <div class="home-yt-minimal-shield" aria-hidden="true"></div>
    <div class="home-yt-minimal-controls">
      <button type="button" class="home-yt-minimal-playpause" aria-label="Reproduzir/Pausar">
        <i class="fas fa-play"></i>
      </button>
      <div class="home-yt-minimal-volume">
        <button type="button" class="home-yt-minimal-mute" aria-label="Ativar/desativar som" aria-pressed="true">
          <i class="fas fa-volume-mute"></i>
        </button>
        <div class="home-yt-minimal-volume-slider" role="slider" aria-label="Volume" tabindex="0" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
          <div class="home-yt-minimal-volume-track">
            <div class="home-yt-minimal-volume-fill"></div>
          </div>
        </div>
      </div>
      <div class="home-yt-minimal-seek" role="slider" aria-label="Barra do vídeo" tabindex="0" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
        <div class="home-yt-minimal-seek-track">
          <div class="home-yt-minimal-seek-buffer"></div>
          <div class="home-yt-minimal-seek-played"></div>
        </div>
      </div>
      <button type="button" class="home-yt-minimal-fullscreen" aria-label="Tela cheia" aria-pressed="false">
        <i class="fas fa-expand"></i>
      </button>
    </div>
  </div>`;
}

function _homeLoadYtApi() {
  if (window.YT && window.YT.Player) return Promise.resolve();
  if (window._homeYtApiPromise) return window._homeYtApiPromise;
  window._homeYtApiPromise = new Promise((resolve) => {
    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prev === 'function') { try { prev(); } catch (_) {} }
      resolve();
    };
    const s = document.createElement('script');
    s.src = 'https://www.youtube.com/iframe_api';
    s.async = true;
    document.head.appendChild(s);
  });
  return window._homeYtApiPromise;
}

function _homeCreateMinimalPlayer(host) {
  const target = host.querySelector('.home-yt-minimal-target');
  if (!target) return;
  const ytId = host.dataset.ytId;
  if (!ytId) return;
  const autoplay = host.dataset.ytAutoplay === '1';
  const muted = host.dataset.ytMuted === '1';
  const loop = host.dataset.ytLoop === '1';

  const muteBtn = host.querySelector('.home-yt-minimal-mute');
  const playBtn = host.querySelector('.home-yt-minimal-playpause');
  const fullscreenBtn = host.querySelector('.home-yt-minimal-fullscreen');
  const shield = host.querySelector('.home-yt-minimal-shield');
  const volSlider = host.querySelector('.home-yt-minimal-volume-slider');
  const volFill = host.querySelector('.home-yt-minimal-volume-fill');
  const seek = host.querySelector('.home-yt-minimal-seek');
  const seekPlayed = host.querySelector('.home-yt-minimal-seek-played');
  const seekBuffer = host.querySelector('.home-yt-minimal-seek-buffer');
  const fullscreenTarget = host.closest('.az-player') || host;

  host.style.setProperty('--home-yt-poster', `url("https://i.ytimg.com/vi/${encodeURIComponent(ytId)}/hqdefault.jpg")`);

  const player = new YT.Player(target, {
    videoId: ytId,
    host: 'https://www.youtube-nocookie.com',
    playerVars: {
      autoplay: autoplay ? 1 : 0,
      mute: muted ? 1 : 0,
      controls: 0,
      disablekb: 1,
      modestbranding: 1,
      rel: 0,
      playsinline: 1,
      fs: 0,
      iv_load_policy: 3,
      cc_load_policy: 0,
      loop: loop ? 1 : 0,
      playlist: loop ? ytId : undefined
    },
    events: {
      onReady: () => {
        updateMuteIcon();
        updateVolumeUi();
        updatePlayIcon();
        updateSurfaceState();
        tick();
        if (autoplay) { try { player.playVideo(); } catch (_) {} }
      },
      onStateChange: () => {
        updateMuteIcon();
        updatePlayIcon();
        updateSurfaceState();
      }
    }
  });

  const isMuted = () => { try { return player.isMuted(); } catch (_) { return muted; } };
  const getVolume = () => { try { return player.getVolume(); } catch (_) { return 0; } };
  const updateMuteIcon = () => {
    if (!muteBtn) return;
    const m = isMuted() || getVolume() === 0;
    muteBtn.setAttribute('aria-pressed', m ? 'true' : 'false');
    const icon = muteBtn.querySelector('i');
    if (icon) {
      if (m) icon.className = 'fas fa-volume-mute';
      else if (getVolume() < 50) icon.className = 'fas fa-volume-down';
      else icon.className = 'fas fa-volume-up';
    }
  };
  const updateVolumeUi = () => {
    if (!volFill || !volSlider) return;
    const v = isMuted() ? 0 : getVolume();
    volFill.style.height = v + '%';
    volSlider.setAttribute('aria-valuenow', Math.round(v));
  };
  const updatePlayIcon = () => {
    if (!playBtn) return;
    let state = -1;
    try { state = player.getPlayerState(); } catch (_) {}
    const playing = state === YT.PlayerState.PLAYING || state === YT.PlayerState.BUFFERING;
    const icon = playBtn.querySelector('i');
    if (icon) icon.className = playing ? 'fas fa-pause' : 'fas fa-play';
    playBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
  };
  const updateFullscreenIcon = () => {
    if (!fullscreenBtn) return;
    const active = !!document.fullscreenElement;
    fullscreenBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
    fullscreenBtn.setAttribute('aria-label', active ? 'Sair da tela cheia' : 'Tela cheia');
    const icon = fullscreenBtn.querySelector('i');
    if (icon) icon.className = active ? 'fas fa-compress' : 'fas fa-expand';
  };
  const updateSurfaceState = () => {
    let state = -1;
    try { state = player.getPlayerState(); } catch (_) {}
    const playing = state === YT.PlayerState.PLAYING || state === YT.PlayerState.BUFFERING;
    host.classList.toggle('is-playing', playing);
    host.classList.toggle('is-paused', !playing);
    if (shield) shield.setAttribute('aria-hidden', playing ? 'true' : 'false');
  };

  if (playBtn) {
    playBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      try {
        const state = player.getPlayerState();
        if (state === YT.PlayerState.PLAYING || state === YT.PlayerState.BUFFERING) player.pauseVideo();
        else player.playVideo();
      } catch (_) {}
      setTimeout(() => { updatePlayIcon(); updateSurfaceState(); }, 60);
    });
  }

  if (shield) {
    shield.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      try {
        const state = player.getPlayerState();
        if (state === YT.PlayerState.PLAYING || state === YT.PlayerState.BUFFERING) player.pauseVideo();
        else player.playVideo();
      } catch (_) {}
      setTimeout(() => { updatePlayIcon(); updateSurfaceState(); }, 60);
    });
  }

  if (muteBtn) {
    muteBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      try {
        if (isMuted()) {
          player.unMute();
          if (getVolume() === 0) player.setVolume(60);
        } else {
          player.mute();
        }
      } catch (_) {}
      setTimeout(() => { updateMuteIcon(); updateVolumeUi(); }, 60);
    });
  }

  if (fullscreenBtn) {
    fullscreenBtn.addEventListener('click', async (e) => {
      e.stopPropagation();
      e.preventDefault();
      try {
        if (document.fullscreenElement) {
          await document.exitFullscreen();
        } else if (fullscreenTarget.requestFullscreen) {
          await fullscreenTarget.requestFullscreen();
        }
      } catch (_) {}
      setTimeout(updateFullscreenIcon, 60);
    });
  }

  const setVolFromY = (clientY) => {
    if (!volSlider) return;
    const rect = volSlider.getBoundingClientRect();
    // bottom of slider = 0%, top = 100%
    const pct = Math.max(0, Math.min(1, 1 - (clientY - rect.top) / rect.height));
    const v = Math.round(pct * 100);
    try {
      if (v > 0 && isMuted()) player.unMute();
      player.setVolume(v);
      if (v === 0) player.mute();
    } catch (_) {}
    if (volFill) volFill.style.height = v + '%';
    volSlider.setAttribute('aria-valuenow', v);
    updateMuteIcon();
  };
  let volDragging = false;
  if (volSlider) {
    volSlider.addEventListener('pointerdown', (e) => {
      e.stopPropagation();
      volDragging = true;
      try { volSlider.setPointerCapture(e.pointerId); } catch (_) {}
      setVolFromY(e.clientY);
    });
    volSlider.addEventListener('pointermove', (e) => { if (volDragging) setVolFromY(e.clientY); });
    const endVol = (e) => {
      volDragging = false;
      try { if (e && e.pointerId != null) volSlider.releasePointerCapture(e.pointerId); } catch (_) {}
    };
    volSlider.addEventListener('pointerup', endVol);
    volSlider.addEventListener('pointercancel', endVol);
  }

  const seekTo = (clientX) => {
    if (!seek) return;
    const rect = seek.getBoundingClientRect();
    const pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    try {
      const dur = player.getDuration() || 0;
      if (dur > 0) player.seekTo(dur * pct, true);
      if (seekPlayed) seekPlayed.style.width = (pct * 100).toFixed(3) + '%';
      seek.setAttribute('aria-valuenow', Math.round(pct * 100));
    } catch (_) {}
  };
  let dragging = false;
  if (seek) {
    seek.addEventListener('pointerdown', (e) => {
      dragging = true;
      try { seek.setPointerCapture(e.pointerId); } catch (_) {}
      seekTo(e.clientX);
    });
    seek.addEventListener('pointermove', (e) => { if (dragging) seekTo(e.clientX); });
    const endDrag = (e) => {
      dragging = false;
      try { if (e && e.pointerId != null) seek.releasePointerCapture(e.pointerId); } catch (_) {}
    };
    seek.addEventListener('pointerup', endDrag);
    seek.addEventListener('pointercancel', endDrag);
  }

  const tick = () => {
    if (dragging) return;
    try {
      const dur = player.getDuration && player.getDuration() || 0;
      const cur = player.getCurrentTime && player.getCurrentTime() || 0;
      const pct = dur > 0 ? (cur / dur) * 100 : 0;
      if (seekPlayed) seekPlayed.style.width = pct.toFixed(3) + '%';
      const loaded = (player.getVideoLoadedFraction && player.getVideoLoadedFraction()) || 0;
      if (seekBuffer) seekBuffer.style.width = (loaded * 100).toFixed(2) + '%';
      if (seek) seek.setAttribute('aria-valuenow', Math.round(pct));
    } catch (_) {}
  };
  const timer = setInterval(tick, 250);
  const onFullscreenChange = () => updateFullscreenIcon();
  document.addEventListener('fullscreenchange', onFullscreenChange);
  updateFullscreenIcon();
  host._homeYtCleanup = () => {
    clearInterval(timer);
    document.removeEventListener('fullscreenchange', onFullscreenChange);
    try { player.destroy(); } catch (_) {}
  };
}

function initHomeMinimalYoutube(root) {
  const scope = root || document;
  const hosts = [...scope.querySelectorAll('.home-yt-minimal[data-yt-id]')]
    .filter(h => !h.dataset.ytInited);
  if (!hosts.length) return;
  hosts.forEach(h => { h.dataset.ytInited = '1'; });
  _homeLoadYtApi().then(() => hosts.forEach(_homeCreateMinimalPlayer));
}

function renderHomeMediaBg(mediaUrl, {
  wrapperClass,
  mediaClass,
  alt = 'mídia de fundo',
  autoplay = true,
  muted = true,
  loop = true,
  controls = false,
  minimalControls = false
} = {}) {
  const media = String(mediaUrl || '').trim();
  if (!media) return '';

  const ytId = getHomeYoutubeId(media);
  const outerClass = wrapperClass || '';
  const innerClass = mediaClass || '';

  if (ytId) {
    if (minimalControls) {
      return renderHomeMinimalYoutube({ ytId, wrapperClass: outerClass, mediaClass: innerClass, alt, autoplay, muted, loop });
    }
    const q = buildHomeYoutubeQuery({ autoplay, muted, loop, controls, minimalControls, ytId });
    return `<div class="${outerClass}"><iframe class="${innerClass}" src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(ytId)}?${q}" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" loading="lazy" title="${escHome(alt)}"></iframe></div>`;
  }

  if (isHomeVideoUrl(media)) {
    return `<div class="${outerClass}"><video class="${innerClass}" src="${escHome(media)}" autoplay muted loop playsinline preload="metadata"></video></div>`;
  }

  return `<div class="${outerClass}"><img class="${innerClass}" src="${escHome(media)}" alt="${escHome(alt)}" loading="lazy" onerror="this.parentElement?.remove();"></div>`;
}

function renderHomeShowcaseMedia(mediaUrl, {
  wrapperClass,
  mediaClass,
  alt = 'mídia',
  autoplay = false,
  muted = false,
  loop = false,
  controls = true,
  minimalControls = false
} = {}) {
  const media = String(mediaUrl || '').trim();
  if (!media) return '';

  const ytId = getHomeYoutubeId(media);
  const outerClass = wrapperClass || '';
  const innerClass = mediaClass || '';

  if (ytId) {
    if (minimalControls) {
      return renderHomeMinimalYoutube({ ytId, wrapperClass: outerClass, mediaClass: innerClass, alt, autoplay, muted, loop });
    }
    const q = buildHomeYoutubeQuery({ autoplay, muted, loop, controls, minimalControls, ytId });
    return `<div class="${outerClass}"><iframe class="${innerClass}" src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(ytId)}?${q}" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" loading="lazy" title="${escHome(alt)}"></iframe></div>`;
  }

  if (isHomeVideoUrl(media)) {
    return `<div class="${outerClass}"><video class="${innerClass}" src="${escHome(media)}" ${controls ? 'controls' : ''} ${autoplay ? 'autoplay' : ''} ${muted ? 'muted' : ''} ${loop ? 'loop' : ''} playsinline preload="metadata"></video></div>`;
  }

  return `<div class="${outerClass}"><img class="${innerClass}" src="${escHome(media)}" alt="${escHome(alt)}" loading="lazy" onerror="this.parentElement?.remove();"></div>`;
}

function isHomeSoonCard(card) {
  return SiteHeader.isSoonCard(card);
}

function renderHomePlayCard(mode) {
  const soon = isHomeSoonCard(mode);
  return `
    <div class="home-play-card${soon ? ' is-soon' : ''}" data-color="${mode.color}"${soon ? ' aria-disabled="true"' : ` data-home-play="${mode.id}" role="button" tabindex="0"`} aria-label="${escHome(mode.title)}${soon ? ' (em breve)' : ''}">
      <div class="home-play-card-wipe">${HOME_PLAY_ICONS.wipe}</div>
      <div class="home-play-card-icon">${mode.icon}</div>
      ${soon ? '<span class="home-play-card-soon-badge">Em breve</span>' : ''}
      <h3 class="home-play-card-title">${escHome(mode.title)}</h3>
      <p class="home-play-card-desc">${escHome(mode.description)}</p>
      <span class="home-play-card-cta">${soon ? 'Em breve' : 'Entrar <i class="fas fa-chevron-right"></i>'}</span>
    </div>
  `;
}

function resolveHomeCardMedia(card) {
  return String(card?.mediaUrl || card?.videoUrl || card?.media || card?.imageUrl || '').trim();
}

const home = {
  _config: null,

  async _fetchConfig(forceRefresh = false) {
    if (!forceRefresh && this._config) return this._config;
    try {
      const r = await fetch('/api/site-config', { cache: 'no-store' });
      const j = await r.json();
      if (j && j.success && j.data) this._config = j.data;
    } catch (_) { /* ignore, use defaults */ }
    if (!this._config) this._config = window.HOME_DEFAULT_CONFIG || {};
    return this._config;
  },

  applyHeader(cfg) {
    if (!cfg || !cfg.header) return;
    // Brand text
    const brandEl = document.querySelector('.nav-brand-text');
    if (brandEl && cfg.header.brandText) brandEl.textContent = cfg.header.brandText;

    const ul = document.querySelector('.horizontal-nav-inner .nav-menu-secondary');
    if (!ul) return;

    // Index existing <li> by their link's key/page/href so we can reorder +
    // rewrite labels without destroying the DOM (keeps click handlers, etc).
    const items = [...ul.querySelectorAll('.nav-item')];
    const byKey = {};
    items.forEach(li => {
      const a = li.querySelector('.nav-link');
      if (!a) return;
      const href = (a.getAttribute('href') || '').replace(/^\//, '').replace(/\/$/, '');
      const k = a.dataset.page || href;
      if (k) byKey[k] = li;
      // also index by the normalized href as fallback
      if (href && !byKey[href]) byKey[href] = li;
    });

    // Apply configured order. Hidden items get display:none; unknown keys are
    // ignored. Items not in config stay at the end in their original order.
    const seen = new Set();
    (cfg.header.nav || []).forEach(n => {
      if (!n.key) return;
      const li = byKey[n.key] || byKey[(n.href || '').replace(/^\//, '').replace(/\/$/, '')];
      if (!li) return;
      seen.add(li);
      const a = li.querySelector('.nav-link');
      if (n.visible === false) { li.style.display = 'none'; return; }
      li.style.display = '';
      const span = a && a.querySelector('span');
      if (span && n.label) span.textContent = n.label;
      if (a && n.href) a.setAttribute('href', n.href);
      if (a) a.setAttribute('title', n.label || '');
      ul.appendChild(li); // reorder
    });
    // Preserve unseen at the end (already in DOM order)
    items.forEach(li => { if (!seen.has(li)) ul.appendChild(li); });
  },

  async _fetchTemplates() {
    try {
      const r = await fetch('/api/banner-templates/public?section=home', { cache: 'no-store' });
      const j = await r.json();
      return (j && j.success && Array.isArray(j.data)) ? j.data : [];
    } catch { return []; }
  },

  // Renders a single banner template node given its definition.
  _renderTemplate(t) {
    const imgs = (t.images || []).filter(Boolean);
    if (!imgs.length) return '';
    const links = t.links || [];
    const interval = Math.max(1, Math.min(60, Number(t.slideInterval) || 3));

    const link = (i, innerHtml) => {
      const href = links[i];
      if (!href) return `<div class="home-tpl-img">${innerHtml}</div>`;
      return `<a href="${escHome(href)}" class="home-tpl-img">${innerHtml}</a>`;
    };
    const imgTag = (src, i) => {
      const s = src || '';
      // YouTube: accept watch?v=, youtu.be/, shorts/, embed/
      const ytMatch = s.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/i);
      if (ytMatch) {
        const id = ytMatch[1];
        const q = `autoplay=1&mute=1&loop=1&controls=0&modestbranding=1&rel=0&playsinline=1&playlist=${id}`;
        return `<iframe class="home-tpl-yt" src="https://www.youtube.com/embed/${encodeURIComponent(id)}?${q}" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy" title="${escHome(t.name || 'banner')}"></iframe>`;
      }
      const isVideo = /\.(mp4|webm|ogg|mov)(\?|#|$)/i.test(s);
      if (isVideo) {
        return `<video src="${escHome(s)}" autoplay muted loop playsinline preload="metadata" aria-label="${escHome(t.name || 'banner')}"></video>`;
      }
      return `<img src="${escHome(s)}" alt="${escHome(t.name || 'banner')}" loading="lazy" onerror="this.closest('.home-tpl-img,.home-tpl')?.classList.add('is-broken'); this.remove();">`;
    };

    switch (t.type) {
      case 'horizontal-full':
        return `<section class="home-tpl home-tpl-horizontal-full">${link(0, imgTag(imgs[0], 0))}</section>`;
      case 'horizontal-duo':
        return `<section class="home-tpl home-tpl-horizontal-duo">
          ${link(0, imgTag(imgs[0], 0))}
          ${imgs[1] ? link(1, imgTag(imgs[1], 1)) : ''}
        </section>`;
      case 'triplo':
        return `<section class="home-tpl home-tpl-triplo">
          ${imgs.slice(0, 3).map((src, i) => link(i, imgTag(src, i))).join('')}
        </section>`;
      case 'triplo-vertical':
        return `<section class="home-tpl home-tpl-triplo-vertical">
          ${imgs.slice(0, 3).map((src, i) => link(i, imgTag(src, i))).join('')}
        </section>`;
      case 'banner-lateral':
      case 'lateral-left':
      case 'lateral-right':
        return `<section class="home-tpl home-tpl-lateral">${link(0, imgTag(imgs[0], 0))}</section>`;
      case 'carousel': {
        const slides = imgs.map((src, i) => `<div class="home-tpl-carousel-slide" data-i="${i}" ${i === 0 ? 'data-active' : ''}>${link(i, imgTag(src, i))}</div>`).join('');
        const dots = imgs.map((_, i) => `<button class="home-tpl-carousel-dot" data-to="${i}" ${i === 0 ? 'data-active' : ''} aria-label="Slide ${i + 1}"></button>`).join('');
        return `<section class="home-tpl home-tpl-carousel" data-interval="${interval}">
          <div class="home-tpl-carousel-track">${slides}</div>
          <div class="home-tpl-carousel-dots">${dots}</div>
          <button class="home-tpl-carousel-arrow is-prev" data-dir="-1" aria-label="Anterior"><i class="fas fa-chevron-left"></i></button>
          <button class="home-tpl-carousel-arrow is-next" data-dir="1" aria-label="Próximo"><i class="fas fa-chevron-right"></i></button>
        </section>`;
      }
      default: return '';
    }
  },

  _initCarousels(scope) {
    scope.querySelectorAll('.home-tpl-carousel').forEach(car => {
      const slides = [...car.querySelectorAll('.home-tpl-carousel-slide')];
      const dots   = [...car.querySelectorAll('.home-tpl-carousel-dot')];
      if (slides.length <= 1) return;
      let idx = 0;
      const interval = (Number(car.dataset.interval) || 3) * 1000;
      const go = (n) => {
        idx = (n + slides.length) % slides.length;
        slides.forEach((s, i) => s.toggleAttribute('data-active', i === idx));
        dots.forEach((d, i)  => d.toggleAttribute('data-active', i === idx));
      };
      let timer = setInterval(() => go(idx + 1), interval);
      const reset = () => { clearInterval(timer); timer = setInterval(() => go(idx + 1), interval); };
      dots.forEach(d => d.addEventListener('click', () => { go(Number(d.dataset.to)); reset(); }));
      car.querySelectorAll('[data-dir]').forEach(a => a.addEventListener('click', () => { go(idx + Number(a.dataset.dir)); reset(); }));
      car.addEventListener('mouseenter', () => clearInterval(timer));
      car.addEventListener('mouseleave', reset);
    });
  },

  async load() {
    const el = document.getElementById('page-home');
    if (!el) return;

    ensureHomePlayStyles();

    const cfg = await this._fetchConfig(true);
    this.applyHeader(cfg);
    const templates = await this._fetchTemplates();
    const templatesById = Object.fromEntries(templates.map(t => [t.id, t]));

    const isLogged = typeof auth !== 'undefined' && auth && auth.isAuthenticated;
    const hero = cfg.hero || {};
    const play = cfg.playSection || {};
    const feats = cfg.featuresSection || {};
    const academy = cfg.academySection || {};
    const al = cfg.asideLeft || {};
    const ar = cfg.asideRight || {};
    const featureNavById = {
      lineups: 'lineups',
      zdpro: 'zdpro',
      tactics: 'tactics',
      taticas: 'tactics',
      analise: 'analise',
      'analise-de-vod': 'analise',
      scrim: 'scrim',
      jogar: 'vpro',
      vpro: 'vpro',
      academy: 'academy',
      'liga-zdpro': 'zdpro',
      liga: 'zdpro'
    };
    const secOrder = (cfg.sectionsOrder && cfg.sectionsOrder.order) || ['hero', 'playSection', 'featuresSection', 'academySection'];
    const secHidden = new Set(((cfg.sectionsOrder && cfg.sectionsOrder.hidden) || []));
    // Laterals are controlled by BOTH their own `visible` flag and the
    // "Ordenar Seções" hide toggle in admin.
    const alShown = al.visible !== false && !secHidden.has('asideLeft');
    const arShown = ar.visible !== false && !secHidden.has('asideRight');

    const playCards = (play.cards || []).filter(c => c.visible !== false).map(c => {
      const iconSvg = HOME_PLAY_ICONS[c.color] || HOME_PLAY_ICONS.lobby;
      const mediaUrl = resolveHomeCardMedia(c);
      const mediaHtml = renderHomeMediaBg(mediaUrl, {
        wrapperClass: 'home-play-card-media',
        mediaClass: 'home-play-card-media-inner',
        alt: c.title || 'card'
      });
      const soon = isHomeSoonCard(c);
      return `
        <div class="home-play-card ${mediaHtml ? 'has-media' : ''}${soon ? ' is-soon' : ''}" data-color="${escHome(c.color)}"${soon ? ' aria-disabled="true"' : ` data-home-play-href="${escHome(c.href)}" role="button" tabindex="0"`} aria-label="${escHome(c.title)}${soon ? ' (em breve)' : ''}">
          ${mediaHtml}
          <div class="home-play-card-wipe">${HOME_PLAY_ICONS.wipe}</div>
          <div class="home-play-card-icon">${iconSvg}</div>
          ${soon ? '<span class="home-play-card-soon-badge">Em breve</span>' : ''}
          <h3 class="home-play-card-title">${escHome(c.title)}</h3>
          <p class="home-play-card-desc">${escHome(c.description)}</p>
          <span class="home-play-card-cta">${soon ? 'Em breve' : 'Entrar <i class="fas fa-chevron-right"></i>'}</span>
        </div>
      `;
    }).join('');

    const featuresCards = (feats.cards || []).filter(c => c.visible !== false).map(c => {
      const mediaUrl = resolveHomeCardMedia(c);
      return `
      <div class="home-feature-card ${mediaUrl ? 'has-media' : ''}" data-home-feature-nav="${escHome(featureNavById[c.id] || '')}" role="button" tabindex="0" aria-label="${escHome(c.title)}">
        ${renderHomeMediaBg(mediaUrl, {
          wrapperClass: 'home-feature-card-media',
          mediaClass: 'home-feature-card-media-inner',
          alt: c.title || 'card'
        })}
        <h3>${escHome(c.title)}</h3>
        <p>${escHome(c.description)}</p>
      </div>
    `;
    }).join('');

    const playHtml = play.visible === false ? '' : `
            <section class="home-section" data-sec="playSection">
              <div class="home-play-tabs" role="tablist">
                <div class="home-play-tab" role="tab" aria-selected="true">${escHome(play.title || 'Jogo Competitivo')}</div>
              </div>
              <div class="home-play-cards">
                ${playCards}
              </div>
            </section>`;

    const featsHtml = feats.visible === false ? '' : `
            <section class="home-section" data-sec="featuresSection">
              <h2 class="home-section-title">${escHome(feats.title || 'Ferramentas para seu time')}</h2>
              <div class="home-features-grid">
                ${featuresCards}
              </div>
            </section>`;

    const academyCards = (Array.isArray(academy.sideCards) ? academy.sideCards : [])
      .filter((card) => card.visible !== false)
      .slice(0, 2)
      .map((card, idx) => {
        const mediaUrl = resolveHomeCardMedia(card);
        const isYoutubeSideCard = !!getHomeYoutubeId(mediaUrl);
        const href = String(card.href || '/academy').trim();
        const cardInner = `
          ${renderHomeMediaBg(mediaUrl, {
            wrapperClass: 'home-academy-side-media',
            mediaClass: 'home-academy-side-media-inner',
            alt: card.title || `card-${idx + 1}`,
            autoplay: true,
            muted: true,
            loop: false,
            controls: isYoutubeSideCard,
            minimalControls: isYoutubeSideCard
          })}
          ${isYoutubeSideCard ? '' : `
          <div class="home-academy-side-overlay">
            <h3>${escHome(card.title || (idx === 0 ? 'Aulas Completas' : 'Academy Shorts'))}</h3>
          </div>
          `}
        `;

        if (href && !isYoutubeSideCard) {
          return `<a class="home-academy-side-card" href="${escHome(href)}">${cardInner}</a>`;
        }

        return `<div class="home-academy-side-card ${isYoutubeSideCard ? 'is-youtube' : ''}">${cardInner}</div>`;
      })
      .join('');

    const academyMainMediaUrl = academy.mainMediaUrl || academy.videoUrl || '';
    const academyMainIsYoutube = !!getHomeYoutubeId(academyMainMediaUrl);
    const academyMainMedia = renderHomeShowcaseMedia(academyMainMediaUrl, {
      wrapperClass: 'home-academy-main-media-wrap',
      mediaClass: 'home-academy-main-media',
      alt: academy.mainTitle || 'ZD Academy',
      autoplay: academyMainIsYoutube,
      muted: academyMainIsYoutube,
      loop: academyMainIsYoutube,
      controls: true,
      minimalControls: academyMainIsYoutube
    });

    const academyHtml = academy.visible === false ? '' : `
      <section class="home-section home-academy" data-sec="academySection">
        <div class="home-academy-head">
          <h2 class="home-academy-heading">${escHome(academy.title || 'Veja um pouco do nosso conteudo Valorant')}</h2>
        </div>
        <div class="home-academy-layout">
          <div class="home-academy-side">
            ${academyCards}
          </div>
          <article class="home-academy-main ${academyMainIsYoutube ? 'is-video-only' : ''}">
            ${academyMainMedia || '<div class="home-academy-main-empty"><i class="fas fa-photo-film"></i><span>Adicione uma midia principal no Admin</span></div>'}
            ${academyMainIsYoutube ? '' : `
            <div class="home-academy-main-copy">
              <h3>${escHome(academy.mainTitle || 'Confia na Tatica')}</h3>
              <p>${escHome(academy.mainSubtitle || 'Dominando a composicao de equipe e execucoes de bomb')}</p>
              ${academy.mainCtaLabel ? `<a class="home-academy-main-cta" href="${escHome(academy.mainCtaHref || '/academy')}">${escHome(academy.mainCtaLabel)}</a>` : ''}
            </div>
            `}
          </article>
        </div>
      </section>`;

    const heroVideoHtml = renderHomeMediaBg(hero.mediaUrl || hero.videoUrl || '', {
      wrapperClass: 'home-hero-video-wrap',
      mediaClass: 'home-hero-video',
      alt: hero.titleLine1 || 'Hero'
    });

    const heroHtml = hero.visible === false ? '' : `
      <section class="home-hero ${heroVideoHtml ? 'has-video' : ''}" data-sec="hero">
          ${heroVideoHtml}
          <div class="home-hero-inner">
            ${hero.badge ? `
            <div class="home-hero-badge">
              <i class="fas fa-trophy"></i> ${escHome(hero.badge)}
            </div>` : ''}
            <h1 class="home-hero-title">
              ${hero.titleLine1 || ''}${hero.titleLine2 ? '<br>' + hero.titleLine2 : ''}
            </h1>
            ${hero.subtitle ? `<p class="home-hero-sub">${escHome(hero.subtitle)}</p>` : ''}
            ${isLogged && (hero.primaryLabel || hero.secondaryLabel) ? `
            <div class="home-hero-actions">
              ${hero.primaryLabel ? `
                <button class="btn-home-primary" data-home-nav="${escHome(hero.primaryTarget || 'lineups')}">
                  <i class="fas fa-rocket"></i> ${escHome(hero.primaryLabel)}
                </button>` : ''}
              ${hero.secondaryLabel ? `
                <button class="btn-home-ghost" data-home-nav="${escHome(hero.secondaryTarget || 'vpro')}">
                  <i class="fas fa-trophy"></i> ${escHome(hero.secondaryLabel)}
                </button>` : ''}
            </div>` : ''}
          </div>
        </section>`;

    // Build ordered sections. Hero renders ABOVE the layout (full-bleed).
    // Lateral banners are routed into the left/right asides; everything else
    // goes into .home-main in `sectionsOrder` order.
    const lateralLeftHtml = [];
    const lateralRightHtml = [];
    const renderSection = (id) => {
      if (secHidden.has(id)) return '';
      if (id === 'hero') return ''; // hero handled separately above layout
      if (id === 'asideLeft' || id === 'asideRight') return ''; // asides live in side columns
      if (id === 'playSection') return playHtml;
      if (id === 'featuresSection') return featsHtml;
      if (id === 'academySection') return academyHtml;
      if (id.startsWith('tpl:')) {
        const t = templatesById[id.slice(4)];
        if (!t) return '';
        if (t.type === 'lateral-left')  { lateralLeftHtml.push(this._renderTemplate(t));  return ''; }
        if (t.type === 'lateral-right') { lateralRightHtml.push(this._renderTemplate(t)); return ''; }
        return this._renderTemplate(t);
      }
      return '';
    };
    // Any template not listed in order falls back to the end (safety).
    const orderedIds = [...secOrder];
    if (!orderedIds.includes('academySection')) {
      const featuresIndex = orderedIds.indexOf('featuresSection');
      if (featuresIndex >= 0) orderedIds.splice(featuresIndex + 1, 0, 'academySection');
      else orderedIds.push('academySection');
    }
    for (const t of templates) {
      const tid = 'tpl:' + t.id;
      if (!orderedIds.includes(tid)) orderedIds.push(tid);
    }
    const mainHtml = orderedIds.map(renderSection).join('');
    const heroRender = (secHidden.has('hero') ? '' : heroHtml);

    // Aside media (image / .mp4/.webm / YouTube URL) — falls back to icon.
    const renderAsideMedia = (a) => {
      const media = (a && a.media) || '';
      const link  = (a && a.mediaLink) || '';
      const icon  = `<i class="fas ${escHome(a.icon || 'fa-handshake')}"></i>`;
      if (!media) return icon;
      const ytMatch = media.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/i);
      let inner;
      if (ytMatch) {
        const id = ytMatch[1];
        const q = `autoplay=1&mute=1&loop=1&controls=0&modestbranding=1&rel=0&playsinline=1&playlist=${id}`;
        inner = `<iframe class="home-aside-media" src="https://www.youtube.com/embed/${encodeURIComponent(id)}?${q}" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>`;
      } else if (/\.(mp4|webm|ogg|mov|m4v|mkv)(\?|#|$)/i.test(media)) {
        inner = `<video class="home-aside-media" src="${escHome(media)}" autoplay muted loop playsinline preload="metadata"></video>`;
      } else {
        inner = `<img class="home-aside-media" src="${escHome(media)}" alt="${escHome(a.title || 'banner')}" loading="lazy" onerror="this.remove();">`;
      }
      return link ? `<a href="${escHome(link)}" class="home-aside-media-wrap">${inner}</a>` : `<div class="home-aside-media-wrap">${inner}</div>`;
    };

    el.innerHTML = `
      <div class="home-root">

        ${heroRender}

        <div class="home-layout">

          ${!alShown && !lateralLeftHtml.length ? '<div></div>' : `
          <aside class="home-aside home-aside--left">
            ${!alShown ? '' : `
            <div class="home-aside-label">${escHome(al.label || 'Publicidade')}</div>
            <div class="home-aside-card ${al.media ? 'has-media' : ''}">
              ${renderAsideMedia(al)}
              <h4>${escHome(al.title || '')}</h4>
              <p>${escHome(al.description || '')}</p>
            </div>`}
            ${lateralLeftHtml.join('')}
          </aside>`}

          <div class="home-main">
            ${mainHtml}
          </div>

          ${!arShown && !lateralRightHtml.length ? '<div></div>' : `
          <aside class="home-aside home-aside--right">
            ${!arShown ? '' : `
            <div class="home-aside-label">${escHome(ar.label || 'Publicidade')}</div>
            <div class="home-aside-card ${ar.media ? 'has-media' : ''}">
              ${renderAsideMedia(ar)}
              <h4>${escHome(ar.title || '')}</h4>
              <p>${escHome(ar.description || '')}</p>
            </div>`}
            ${lateralRightHtml.join('')}
          </aside>`}

        </div>

      </div>
    `;

    this._initCarousels(el);
    initHomeMinimalYoutube(el);

    // Unescape allowed span markup inside the hero title (sanitised by backend).
    const titleEl = el.querySelector('.home-hero-title');
    if (titleEl && hero.titleLine1) {
      titleEl.innerHTML = (hero.titleLine1 || '') + (hero.titleLine2 ? '<br>' + hero.titleLine2 : '');
    }

    el.querySelectorAll('[data-home-nav]').forEach(b => {
      b.addEventListener('click', () => {
        const target = b.dataset.homeNav;
        if (target === 'vpro') {
          window.location.href = '/vpro/';
        } else if (typeof app !== 'undefined') {
          app.navigate(target);
        }
      });
    });

    el.querySelectorAll('[data-home-play-href]').forEach(card => {
      const href = card.dataset.homePlayHref;
      if (!href) return;
      const go = () => { window.location.href = href; };
      card.addEventListener('click', go);
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
      });
    });

    el.querySelectorAll('[data-home-feature-nav]').forEach(card => {
      const target = card.dataset.homeFeatureNav;
      if (!target) return;
      const go = () => {
        if (typeof app !== 'undefined') {
          app.navigate(target);
        }
      };
      card.addEventListener('click', go);
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          go();
        }
      });
    });
  }
};

// Expose a loader also available before /page-home loads (used by app.js to
// theme the header even when navigating to other pages first).
(async function applyHeaderEarly() {
  try {
    const r = await fetch('/api/site-config', { cache: 'no-store' });
    const j = await r.json();
    if (j && j.success && j.data) {
      home._config = j.data;
      home.applyHeader(j.data);
    }
  } catch (_) { /* noop */ }
})();

// Make it available globally like other page modules
window.home = home;



/* ===== js/lineups.js ===== */
// =====================================================
// ZDVAL - Lineups Module v30 - Interactive Minimap
// Layout: Side Panel + Minimap + Markers + Player
// =====================================================

class Lineups {
  constructor() {
    this.lineups = [];
    this.filters = { map_id: null, agent_id: null, side: 'attack', ability: null };
    this.selectedMap = null;
    this.selectedAgent = null;
    this.currentAgentRole = null;
    this.selectedLineup = null;
    this.hoveredGroup = null;
    this.groups = [];
    this.isMapDropdownOpen = false;
    this.loaded = false;
    // When true, CRUD operations hit the admin (public) endpoints and the page
    // is driven by the admin panel shell. Controlled by the /admin/lineups view.
    this.adminMode = false;
    // Scope of lineups shown on the public /lineups page:
    //  - 'global': admin-curated lineups (read-only for regular users)
    //  - 'mine':   the logged-in user's team lineups (full CRUD if owner)
    // Defaults to 'global' so anonymous and fresh logins always land on the
    // admin-curated content first; logged-in users can flip via the toggle.
    this.scope = 'global';
    this._formPinMode = 'launch';
    this._formLaunch = null;
    this._formLand = null;
    this._editPinMode = 'launch';
    this._editLaunch = null;
    this._editLand = null;

    // Zoom & pan state
    this.defaultZoomLevel = 1.1;
    this.zoomLevel = this.defaultZoomLevel;
    this.panX = 0;
    this.panY = 0;
    this._isPanning = false;
    this._panStart = null;
    this._zoomIndicatorTimer = null;

    // Map rotations (same as valoplant)
    this.mapRotations = {
      'abyss':    { baseRotation: 90, flipForDefense: true },
      'ascent':   { baseRotation: 90, flipForDefense: true },
      'bind':     { baseRotation: 0,  flipForDefense: true },
      'breeze':   { baseRotation: 0,  flipForDefense: true },
      'corrode':  { baseRotation: 90, flipForDefense: true },
      'fracture': { baseRotation: 0,  flipForDefense: true },
      'haven':    { baseRotation: 90, flipForDefense: true },
      'lotus':    { baseRotation: 0,  flipForDefense: true },
      'pearl':    { baseRotation: 0,  flipForDefense: true },
      'split':    { baseRotation: 90, flipForDefense: true }
    };
  }

  // ── Load ──────────────────────────────────────
  async load() {
    const container = document.getElementById('page-lineups');
    if (!container) return;
    this.selectedLineup = null;
    this.hoveredGroup = null;
    this.groups = [];
    // Pick a sensible default scope for the viewer:
    //  - admin panel: forced to 'global' (the only thing admin manages here)
    //  - logged-in user on /lineups: 'mine' (their own team/private lineups)
    //  - anonymous visitor: 'global' (admin-curated lineups)
    if (!this._scopeTouched) {
      const isLogged = typeof auth !== 'undefined' && auth && auth.isAuthenticated;
      this.scope = (this.adminMode || !isLogged) ? 'global' : 'mine';
    }
    await this._loadAgentGradients();
    this.render();
    this.addStyles();
    this.setupEvents();
    this._syncMapSideToggleButton();
    this.loaded = true;
    // Auto-load lineups if map selected
    if (this.filters.map_id) {
      this.loadLineups();
    }
  }

  async _loadAgentGradients() {
    if (this._agentGradients) return;
    try {
      const data = await api.getValorantAgents();
      if (data.status === 200 && data.data) {
        this._agentGradients = {};
        this._agentPortraits = {};
        data.data.filter(a => a.isPlayableCharacter).forEach(a => {
          const key = (a.displayName || '').toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]/g, '');
          const gc = a.backgroundGradientColors || [];
          this._agentGradients[key] = {
            g0: gc[0] ? '#' + gc[0].slice(0, 6) : '#1a1a2e',
            g1: gc[1] ? '#' + gc[1].slice(0, 6) : '#0f1923',
            g2: gc[2] ? '#' + gc[2].slice(0, 6) : '#1a1a2e'
          };
          // A barra lateral desenha isso com ~86 px de lado, mas o arquivo da
          // valorant-api tem 1024 px e 400-600 KB — e `displayIconSmall`
          // aponta para o MESMO arquivo do `displayIcon`, entao preferir um
          // sobre o outro nao muda um byte. Quem corta e o proxy do backend.
          this._agentPortraits[key] = Utils.imagemReduzida(
            a.displayIconSmall || a.displayIcon || a.bustPortrait || '', 192)
        });
      }
    } catch (e) {
      this._agentGradients = {};
      this._agentPortraits = {};
    }
  }

  _getAgentKey(name) {
    return (name || '').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }

  getCanonicalAgentRoleKey(rawRole) {
    const normalized = String(rawRole || '').trim().toLowerCase();
    const aliasMap = {
      initiator: 'initiator',
      iniciador: 'initiator',
      duelist: 'duelist',
      duelista: 'duelist',
      controller: 'controller',
      controlador: 'controller',
      sentinel: 'sentinel',
      sentinela: 'sentinel'
    };

    return aliasMap[normalized] || normalized;
  }

  getAgentRoleKey(agent) {
    return this.getCanonicalAgentRoleKey(agent?.role?.displayName || agent?.role || '');
  }

  getAgentRoleMeta(roleKey) {
    const roleMeta = {
      initiator: {
        label: 'Iniciador',
        order: 0,
        icon: 'https://media.valorant-api.com/agents/roles/1b47567f-8f7b-444b-aae3-b0c634622d10/displayicon.png'
      },
      duelist: {
        label: 'Duelista',
        order: 1,
        icon: 'https://media.valorant-api.com/agents/roles/dbe8757e-9e92-4ed4-b39f-9dfc589691d4/displayicon.png'
      },
      controller: {
        label: 'Controlador',
        order: 2,
        icon: 'https://media.valorant-api.com/agents/roles/4ee40330-ecdd-4f2f-98a8-eb1243428373/displayicon.png'
      },
      sentinel: {
        label: 'Sentinela',
        order: 3,
        icon: 'https://media.valorant-api.com/agents/roles/5fc02f99-4091-4486-a531-98459a3e95e9/displayicon.png'
      }
    };

    return roleMeta[roleKey] || {
      label: roleKey,
      order: 99,
      icon: ''
    };
  }

  getAgentRoleOptions(agents = this.getAgents()) {
    const roles = new Map();

    (Array.isArray(agents) ? agents : []).forEach((agent) => {
      const roleKey = this.getAgentRoleKey(agent);
      if (!roleKey || roles.has(roleKey)) return;

      const meta = this.getAgentRoleMeta(roleKey);
      roles.set(roleKey, {
        key: roleKey,
        label: meta.label,
        order: meta.order,
        icon: agent?.role?.displayIcon || meta.icon
      });
    });

    return Array.from(roles.values()).sort((left, right) => left.order - right.order || left.label.localeCompare(right.label));
  }

  getFilteredAgentsByRole(agents = this.getAgents()) {
    const source = Array.isArray(agents) ? agents : [];
    if (!this.currentAgentRole) return source;
    return source.filter((agent) => this.getAgentRoleKey(agent) === this.currentAgentRole);
  }

  // ── Core Data ─────────────────────────────────
  getMaps() { return app.getMaps() || []; }
  getAgents() { return app.getAgents() || []; }

  // Decide whether the current viewer can edit/delete a lineup.
  // - Admin mode (/admin/lineups): yes, always.
  // - Public /lineups page: only if authenticated, viewing 'mine' scope AND the
  //   lineup belongs to the user's team. Global (admin-created) lineups are
  //   never editable from /lineups — they must be managed via /admin/lineups.
  _canManageLineup(lineup) {
    if (this.adminMode) return true;
    if (this.scope !== 'mine') return false;
    const isLogged = typeof auth !== 'undefined' && auth && auth.isAuthenticated;
    if (!isLogged) return false;
    if (!lineup || !lineup.team_id) return false;
    const team = (typeof app !== 'undefined' && app.getCurrentTeam) ? app.getCurrentTeam() : null;
    return !!(team && team.id === lineup.team_id);
  }

  // Whether the current viewer can create a lineup right now.
  // Anonymous visitors and users viewing the 'global' scope cannot.
  _canCreateLineup() {
    if (this.adminMode) return true;
    if (this.scope !== 'mine') return false;
    return typeof auth !== 'undefined' && auth && auth.isAuthenticated;
  }

  // Scope selector (global vs. mine). Only rendered on the public /lineups
  // page for authenticated users. Anonymous viewers always stay on 'global'.
  _renderScopeToggle() {
    if (this.adminMode) return '';
    const isLogged = typeof auth !== 'undefined' && auth && auth.isAuthenticated;
    if (!isLogged) return '';
    const active = this.scope === 'mine' ? 'mine' : 'global';
    return `
      <div class="lu-scope-toggle" id="luScopeToggle" role="tablist" aria-label="Origem das lineups">
        <button type="button" class="lu-scope-btn ${active === 'global' ? 'active' : ''}"
                data-scope="global" onclick="lineups.setScope('global')"
                role="tab" aria-selected="${active === 'global'}">
          <i class="fas fa-globe"></i><span>Lineup Global</span>
        </button>
        <button type="button" class="lu-scope-btn ${active === 'mine' ? 'active' : ''}"
                data-scope="mine" onclick="lineups.setScope('mine')"
                role="tab" aria-selected="${active === 'mine'}">
          <i class="fas fa-user"></i><span>Lineups</span>
        </button>
      </div>`;
  }

  setScope(scope) {
    const next = scope === 'mine' ? 'mine' : 'global';
    if (this.scope === next) return;
    this.scope = next;
    this._scopeTouched = true;
    this.selectedLineup = null;
    this.closePlayer?.();
    this.render();
    this.setupEvents();
    this._syncMapSideToggleButton();
    if (this.filters.map_id) this.loadLineups();
  }
  getAbilities(agentId) {
    const agent = this.getAgents().find(a => a.id === agentId);
    return agent?.abilities || [];
  }
  getMapMinimap(mapId) {
    const m = this.getMaps().find(x => x.id === mapId);
    return m?.minimap || m?.minimap_url || m?.displayicon || '';
  }
  /**
   * Imagem de mapa para card pequeno (item do dropdown, banner).
   *
   * Tres tamanhos existem no valorant-api, e nenhum extremo serve:
   *   splash                   1920x1080 a 3840x2160, 1,5 a 6,9 MB — decodificar
   *                            isso sete vezes era o que travava o dropdown
   *   listviewicon             456x100, ~60 KB — leve, mas com 100 px de altura
   *                            fica borrado no banner e no card vertical
   *   stylizedbackgroundimage  2560x1440, ~400 KB — resolucao de sobra pelos
   *                            dois lados, e e este que o backend manda em `card`
   */
  getMapCardImage(mapId) {
    const m = this.getMaps().find((x) => x.id === mapId);
    return this._imagemDeBanner(m);
  }

  /**
   * Banner do mapa selecionado — um por vez, e o elemento grande da coluna.
   * Aqui vale o `splash`: e a arte clara e nitida. O `stylizedbackgroundimage`
   * tem mais resolucao, mas e a variante escura que a Riot usa atras de UI
   * (brilho medio 32 contra 129 do splash), entao serve de reserva, nao de
   * primeira escolha.
   */
  _imagemDeBanner(m) {
    return m?.splash || m?.card || m?.listViewIcon || '';
  }

  /**
   * Miniatura do dropdown — seis de uma vez, desenhadas a 57x110.
   * `listViewIcon` tem o mesmo tratamento de cor do splash por 60 KB, contra
   * ate 6,9 MB. Puxar splash aqui era o que fazia a pagina baixar 38 MB.
   */
  _imagemDeMiniatura(m) {
    return m?.listViewIcon || m?.card || m?.splash || '';
  }

  getMapSplash(mapId) {
    const m = this.getMaps().find(x => x.id === mapId);
    return m?.splash || m?.listViewIcon || '';
  }
  _getMapTransform() {
    const name = this.selectedMap?.name?.toLowerCase();
    const rot = this.mapRotations[name];
    let deg = rot?.baseRotation || 0;
    const shouldFlipForDefense = rot ? !!rot.flipForDefense : true;
    if (this.filters.side === 'defense' && shouldFlipForDefense) deg += 180;
    // Order: rotate first (inherent map orientation), then scale, then translate on top
    // CSS transforms apply right-to-left, so we write: translate scale rotate
    // This means: first rotate the map, then scale it, then pan in screen-space
    const parts = [];
    if (this.panX || this.panY) parts.push(`translate(${this.panX}px, ${this.panY}px)`);
    parts.push(`scale(${this.zoomLevel})`);
    if (deg) parts.push(`rotate(${deg}deg)`);
    return parts.join(' ');
  }
  _applyMapTransform(smooth) {
    const inner = document.getElementById('luMinimapInner');
    if (!inner) return;
    if (smooth) {
      // Remove no-transition so CSS transition kicks in
      inner.classList.remove('lu-no-transition');
    } else {
      // Disable transitions for instant change
      inner.classList.add('lu-no-transition');
    }
    inner.style.transform = this._getMapTransform();
  }
  resetZoom(smooth) {
    this.zoomLevel = this.defaultZoomLevel;
    this.panX = 0;
    this.panY = 0;
    this._applyMapTransform(smooth);
  }
  _clampPan() {
    const box = document.getElementById('luMinimap');
    if (!box) return;
    const bw = box.offsetWidth;
    const bh = box.offsetHeight;
    const maxX = bw * 0.5;
    const maxY = bh * 0.5;
    this.panX = Math.max(-maxX, Math.min(maxX, this.panX));
    this.panY = Math.max(-maxY, Math.min(maxY, this.panY));
  }

  _showZoomIndicator() {
    let el = document.getElementById('luZoomIndicator');
    if (!el) {
      el = document.createElement('div');
      el.id = 'luZoomIndicator';
      el.className = 'lu-zoom-indicator';
      document.getElementById('luMinimapWrapper')?.appendChild(el);
    }
    el.textContent = Math.round(this.zoomLevel * 100) + '%';
    el.classList.add('visible');
    clearTimeout(this._zoomIndicatorTimer);
    this._zoomIndicatorTimer = setTimeout(() => el.classList.remove('visible'), 1200);
  }

  // ── Main Render ───────────────────────────────
  render() {
    const container = document.getElementById('page-lineups');
    if (!container) return;
    const maps = this.getMaps();
    const agents = this.getAgents();

    // Auto-select first map
    if (!this.selectedMap && maps.length) {
      this.selectedMap = maps[0];
      this.filters.map_id = maps[0].id;
    }

    container.innerHTML = `
      <div class="lu-layout">
        <!-- LEFT PANEL -->
        <div class="lu-panel" id="luPanel">
          ${this._renderPanel(maps, agents)}
        </div>
        <!-- CENTER: MINIMAP + PLAYER -->
        <div class="lu-main">
          <div class="lu-minimap-wrapper" id="luMinimapWrapper">
            <div class="lu-minimap" id="luMinimap">
              <div class="lu-minimap-inner" id="luMinimapInner" style="transform: ${this._getMapTransform()}">
                <img class="lu-minimap-img" id="luMinimapImg"
                     src="${this.getMapMinimap(this.filters.map_id)}"
                     alt="Minimap" draggable="false">
                <svg class="lu-svg-overlay" id="luSvgOverlay"></svg>
                <div class="lu-markers" id="luMarkers"></div>
              </div>
            </div>
            <div class="lu-minimap-empty ${this.filters.map_id ? 'hidden' : ''}" id="luMinimapEmpty">
              <i class="fas fa-map-marked-alt"></i>
              <span>Selecione um mapa</span>
            </div>
            <div class="lu-player hidden" id="luPlayer"></div>
            <div class="lu-panel-actions lu-panel-actions-overlay" id="luPanelActionsOverlay">
              ${this._renderScopeToggle()}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // ── Left Panel ────────────────────────────────
  _renderPanel(maps, agents) {
    const selMapName = this.selectedMap?.display_name || '';
    const roleOptions = this.getAgentRoleOptions(agents);
    const visibleAgents = this.getFilteredAgentsByRole(agents);

    return `
      <!-- Top Row: Map Banner (componente compartilhado com /planner) -->
      <div class="lu-top-row">
        ${MapPicker.banner({
          map: this.selectedMap
            ? { image: this.getMapCardImage(this.selectedMap.id), name: selMapName }
            : null,
          onClick: 'lineups.handleMapBannerClick(event)'
        })}
        ${this._renderMapDropdownControl(maps)}
        <div class="lu-map-side-row">
          ${this._renderMapSideControls()}
        </div>
      </div>

      <!-- Agents -->
      <div class="lu-section">
        ${roleOptions.length
          ? `<div class="lu-role-filter-wrap" id="luRoleFilterSection">
               <div class="lu-role-filter-grid" id="luRoleFilterGrid">
                 ${this._renderRoleFilterButtons(roleOptions)}
               </div>
             </div>`
          : ''}
        <div class="lu-agents-grid" id="luAgentsGrid">
          ${this._renderAgents(visibleAgents)}
        </div>
      </div>
    `;
  }

  _renderRoleFilterButtons(roleOptions) {
    return roleOptions.map((role) => `
      <button class="lu-role-filter-btn ${this.currentAgentRole === role.key ? 'active' : ''}"
              data-role-key="${role.key}"
              data-role-label="${this._escAttr(role.label)}"
              title="${this._escAttr(role.label)}"
              type="button">
        ${role.icon
          ? `<img src="${role.icon}" alt="${this._escAttr(role.label)}" loading="lazy" draggable="false">`
          : `<i class="fas fa-shield-alt" aria-hidden="true"></i>`}
      </button>
    `).join('');
  }

  setAgentRoleFilter(roleKey) {
    const normalized = this.getCanonicalAgentRoleKey(roleKey);
    if (!normalized) return;

    this.currentAgentRole = this.currentAgentRole === normalized ? null : normalized;

    const allAgents = this.getAgents();
    const roleGrid = document.getElementById('luRoleFilterGrid');
    if (roleGrid) {
      roleGrid.innerHTML = this._renderRoleFilterButtons(this.getAgentRoleOptions(allAgents));
    }

    const agentsGrid = document.getElementById('luAgentsGrid');
    if (agentsGrid) {
      agentsGrid.innerHTML = this._renderAgents(this.getFilteredAgentsByRole(allAgents));
    }

    const pickerRoleGrid = document.getElementById('luPickerRoleFilterGrid');
    if (pickerRoleGrid) {
      pickerRoleGrid.innerHTML = this._renderRoleFilterButtons(this.getAgentRoleOptions(allAgents));
    }
    const pickerAgentsGrid = document.getElementById('luPickerAgentsGrid');
    if (pickerAgentsGrid) {
      pickerAgentsGrid.innerHTML = this._renderAgents(this.getFilteredAgentsByRole(allAgents));
    }

    this._hideAgentAbilitiesPopup();
  }

  _renderAgents(agents) {
    if (!Array.isArray(agents) || !agents.length) {
      return '<div class="lu-agents-empty">Nenhum agente nessa função</div>';
    }

    return agents.map(a => {
      const icon = a.display_icon || `https://media.valorant-api.com/agents/${a.id}/displayiconsmall.png`;
      const act = a.id === this.filters.agent_id;
      const key = this._getAgentKey(a.display_name || a.name);
      const gc = this._agentGradients?.[key] || { g0: '#1a1a2e', g1: '#0f1923', g2: '#1a1a2e' };
      const portrait = this._agentPortraits?.[key] || icon;
      return `
        <div class="lu-agent ${act ? 'active' : ''}" data-id="${a.id}" title="${this._escAttr(a.display_name)}" onclick="lineups.selectAgent('${a.id}')"
             style="--agent-g0: ${gc.g0}; --agent-g1: ${gc.g1}; --agent-g2: ${gc.g2};">
          <div class="lu-agent-frame">
            <img src="${portrait}" alt="${a.display_name}" loading="lazy">
            <div class="lu-agent-veil"></div>
          </div>
          <span>${a.display_name}</span>
        </div>`;
    }).join('');
  }

  /**
   * Arrastar o agente da lista para o mapa.
   *
   * Soltar o retrato sobre o minimapa seleciona aquele agente, entra em modo
   * de criacao e ja marca ali o ponto de onde a habilidade sai — o passo
   * seguinte (onde ela cai) segue como antes, por arrasto ou clique.
   *
   * Fica em pointer events, e nao no drag-and-drop nativo do HTML, porque o
   * nativo nao dispara em toque e nao deixa desenhar o fantasma do jeito que
   * a lista de agentes ja e desenhada.
   */
  _configurarArrastoDeAgente() {
    const grid = document.getElementById('luAgentsGrid');
    const minimap = document.getElementById('luMinimap');
    if (!grid || !minimap) return;

    const LIMIAR = 5;
    let arrasto = null;

    // ESC no meio do trajeto: some com o fantasma e o pointerup nao larga nada.
    this._cancelarArrastoDeAgente = () => {
      if (!arrasto) return false;
      soltarFantasma();
      return true;
    };

    const soltarFantasma = () => {
      arrasto?.fantasma?.remove();
      document.body.classList.remove('lu-arrastando-agente');
      minimap.classList.remove('lu-alvo-de-agente');
      arrasto = null;
    };

    grid.addEventListener('pointerdown', (e) => {
      if (e.button !== 0) return;
      const el = e.target.closest('.lu-agent');
      if (!el) return;
      arrasto = { id: el.dataset.id, el, x0: e.clientX, y0: e.clientY, ativo: false, fantasma: null };
    });

    this._agenteArrastoMove = (e) => {
      if (!arrasto) return;
      if (!arrasto.ativo) {
        if (Math.hypot(e.clientX - arrasto.x0, e.clientY - arrasto.y0) < LIMIAR) return;
        arrasto.ativo = true;
        this._hideAgentAbilitiesPopup?.();
        const img = arrasto.el.querySelector('img');
        const f = document.createElement('div');
        f.className = 'lu-agente-fantasma';
        // Mesmo anel do marcador que vai nascer no mapa, na cor do agente.
        const agente = this.getAgents().find(a => a.id === arrasto.id);
        f.style.setProperty('--mc', this._agentColor(agente));
        f.innerHTML = `<img src="${img?.src || ''}" alt="">`;
        document.body.appendChild(f);
        arrasto.fantasma = f;
        document.body.classList.add('lu-arrastando-agente');
      }
      arrasto.fantasma.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
      const sobreMapa = !!document.elementFromPoint(e.clientX, e.clientY)?.closest('#luMinimap');
      minimap.classList.toggle('lu-alvo-de-agente', sobreMapa);
    };

    this._agenteArrastoFim = (e) => {
      if (!arrasto) return;
      const foiArrasto = arrasto.ativo;
      const id = arrasto.id;
      const sobreMapa = !!document.elementFromPoint(e.clientX, e.clientY)?.closest('#luMinimap');
      soltarFantasma();
      if (!foiArrasto) return;               // clique simples: o onclick da lista resolve

      // Houve arrasto: o clique que vem depois nao deve alternar a selecao.
      this._ignorarProximoCliqueAgente = true;
      if (!sobreMapa) return;
      this._largarAgenteNoMapa(id, e);
    };

    document.addEventListener('pointermove', this._agenteArrastoMove);
    document.addEventListener('pointerup', this._agenteArrastoFim);
    document.addEventListener('pointercancel', this._agenteArrastoFim);

    // O onclick inline de cada agente roda depois do pointerup do arrasto.
    grid.addEventListener('click', (e) => {
      if (!this._ignorarProximoCliqueAgente) return;
      this._ignorarProximoCliqueAgente = false;
      e.stopPropagation();
      e.preventDefault();
    }, true);
  }

  /** Solta o agente no mapa: seleciona, entra em criacao e marca a origem. */
  _largarAgenteNoMapa(agentId, e) {
    if (!this.filters.map_id) {
      if (typeof toast !== 'undefined') toast.warning('Selecione um mapa primeiro');
      return;
    }
    if (!this.adminMode && typeof auth !== 'undefined' && auth && !auth.isAuthenticated) {
      if (typeof toast !== 'undefined') toast.info('Entre para criar seus próprios lineups');
      if (typeof auth.openAuth === 'function') auth.openAuth('login');
      return;
    }

    const ponto = this._pontoDoMinimap(e);
    if (!ponto) return;

    // selectAgent() sai do modo de criacao, entao a selecao vem antes de entrar nele.
    if (this.filters.agent_id !== agentId) {
      this.filters.agent_id = agentId;
      this.selectedAgent = this.getAgents().find(a => a.id === agentId);
      this.filters.ability = null;
      this.selectedLineup = null;
      document.querySelectorAll('.lu-agent').forEach(el =>
        el.classList.toggle('active', el.dataset.id === agentId));
      this.closePlayer?.();
    }

    this.enterCreateMode();
    if (!this._createMode) return;          // enterCreateMode barrou (sem mapa/agente)

    this._createData.launch = { top: ponto.top.toFixed(2), left: ponto.left.toFixed(2) };
    this._createStep = 'land';
    // Origem ja marcada: a mira do cursor cumpriu o papel dela, volta a seta.
    document.getElementById('luMinimap')?.classList.add('lu-sem-mira');
    this._updateCreatePreview();
    this._showCreateHint('Agora arraste ou clique onde a habilidade vai aterrissar', 'fa-bullseye');
  }

  _ensureAgentAbilitiesPopup() {
    if (this._agentAbilitiesPopup) return;
    const popup = document.createElement('div');
    popup.className = 'lu-agent-abilities-popup';
    document.body.appendChild(popup);
    this._agentAbilitiesPopup = popup;

    popup.addEventListener('mouseenter', () => {
      clearTimeout(this._agentPopupHideTimer);
    });

    popup.addEventListener('mouseleave', () => {
      this._scheduleAgentAbilitiesPopupHide();
    });

    popup.addEventListener('click', (e) => {
      const abilityIcon = e.target.closest('.lu-ability-popup-icon');
      if (!abilityIcon) return;
      e.preventDefault();
      e.stopPropagation();
      const abilityName = abilityIcon.dataset.abilityName || '';
      if (!abilityName) return;
      this.toggleAbility(abilityName);
      if (this._popupHoverAgent) this._showAgentAbilitiesPopup(this._popupHoverAgent);
    });
  }

  _hideAgentAbilitiesPopup() {
    clearTimeout(this._agentPopupHideTimer);
    if (!this._agentAbilitiesPopup) return;
    this._agentAbilitiesPopup.classList.remove('visible', 'lu-below');
    this._popupHoverAgent = null;
  }

  _scheduleAgentAbilitiesPopupHide() {
    clearTimeout(this._agentPopupHideTimer);
    this._agentPopupHideTimer = setTimeout(() => {
      const hoveredAgent = document.querySelector('#luAgentsGrid .lu-agent:hover');
      const popupHovered = this._agentAbilitiesPopup?.matches(':hover');
      if (hoveredAgent || popupHovered) return;
      this._hideAgentAbilitiesPopup();
    }, 220);
  }

  _showAgentAbilitiesPopup(agentEl) {
    if (!agentEl) return;
    this._ensureAgentAbilitiesPopup();

    const agentId = agentEl.dataset.id;
    const agent = this.getAgents().find(a => a.id === agentId);
    if (!agent) return;

    const abilities = this._getAgentHoverAbilities(agentId);
    if (!abilities.length) {
      this._hideAgentAbilitiesPopup();
      return;
    }

    const key = this._getAgentKey(agent?.display_name || agent?.name);
    const gc = this._agentGradients?.[key] || { g0: '#1a1a2e', g1: '#0f1923', g2: '#1a1a2e' };
    const fallbackIcon = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28"><rect fill="%23333" width="28" height="28" rx="4"/></svg>';

    const popupHtml = `
      <div class="lu-agent-abilities-popup-row">
        ${abilities.map((ab) => {
          const abNameRaw = ab.displayName || ab.name || 'Habilidade';
          const abName = this._escAttr(abNameRaw);
          const iconUrl = ab.displayIcon || fallbackIcon;
          const isActive = this.filters.ability === abNameRaw;
          return `<button class="lu-ability-popup-icon ${isActive ? 'active' : ''}" type="button"
            data-ability-name="${abName}" title="${abName}"
            style="--agent-g0: ${gc.g0}; --agent-g1: ${gc.g1}; --agent-g2: ${gc.g2};">
            <img src="${iconUrl}" alt="${abName}" loading="lazy" draggable="false">
          </button>`;
        }).join('')}
      </div>
    `;

    this._agentAbilitiesPopup.innerHTML = popupHtml;
    this._agentAbilitiesPopup.classList.add('visible');
    this._popupHoverAgent = agentEl;

    const rect = agentEl.getBoundingClientRect();
    this._agentAbilitiesPopup.style.left = `${rect.left + rect.width / 2}px`;
    this._agentAbilitiesPopup.style.top = `${rect.top - 4}px`;
    this._agentAbilitiesPopup.style.transform = 'translate(-50%, -100%)';

    requestAnimationFrame(() => {
      if (!this._agentAbilitiesPopup) return;
      const pr = this._agentAbilitiesPopup.getBoundingClientRect();
      let left = rect.left + (rect.width / 2);

      if (pr.left < 4) left += (4 - pr.left);
      if (pr.right > window.innerWidth - 4) left -= (pr.right - (window.innerWidth - 4));

      this._agentAbilitiesPopup.style.left = `${left}px`;

      if (pr.top < 4) {
        this._agentAbilitiesPopup.classList.add('lu-below');
        this._agentAbilitiesPopup.style.top = `${rect.bottom + 6}px`;
        this._agentAbilitiesPopup.style.transform = 'translate(-50%, 0)';
      } else {
        this._agentAbilitiesPopup.classList.remove('lu-below');
      }
    });
  }

  _setupAgentHoverAbilitiesEvents() {
    const grid = document.getElementById('luAgentsGrid');
    if (!grid) return;
    this._ensureAgentAbilitiesPopup();

    if (this._agentGridMouseOverHandler) grid.removeEventListener('mouseover', this._agentGridMouseOverHandler);
    if (this._agentGridMouseOutHandler) grid.removeEventListener('mouseout', this._agentGridMouseOutHandler);

    this._agentGridMouseOverHandler = (e) => {
      const agentEl = e.target.closest('.lu-agent');
      if (!agentEl || !grid.contains(agentEl)) return;
      clearTimeout(this._agentPopupHideTimer);
      this._showAgentAbilitiesPopup(agentEl);
    };

    this._agentGridMouseOutHandler = (e) => {
      const agentEl = e.target.closest('.lu-agent');
      if (!agentEl || !grid.contains(agentEl)) return;
      const related = e.relatedTarget;
      if (related && (agentEl.contains(related) || this._agentAbilitiesPopup?.contains(related))) return;
      this._scheduleAgentAbilitiesPopupHide();
    };

    grid.addEventListener('mouseover', this._agentGridMouseOverHandler);
    grid.addEventListener('mouseout', this._agentGridMouseOutHandler);
  }

  _getAgentHoverAbilities(agentId) {
    const order = { Grenade: 0, Grenade_Alt: 0.5, Ability1: 1, Ability2: 2, Ultimate: 4, Passive: 5 };
    const abilities = Array.isArray(this.getAbilities(agentId)) ? this.getAbilities(agentId) : [];

    return [...abilities]
      .filter((ab) => ab && !(ab.slot === 'Passive' && !ab.displayIcon))
      .sort((a, b) => (order[a?.slot] ?? 9) - (order[b?.slot] ?? 9));
  }

  toggleAbility(name) {
    const abilityName = String(name || '').trim();
    this.filters.ability = this.filters.ability === abilityName ? null : abilityName;
    this.selectedLineup = null;
    this.closePlayer();
    this.loadLineups();
  }

  _sideToggleMeta() {
    const isDefense = this.filters.side === 'defense';
    return {
      sideClass: isDefense ? 'defense' : 'attack',
      icon: isDefense ? 'fa-shield-alt' : 'fa-crosshairs',
      label: isDefense ? 'Defesa' : 'Ataque'
    };
  }

  _renderMapSideControls() {
    return MapPicker.sideControls({
      side: this.filters.side === 'defense' ? 'defense' : 'attack',
      onSelect: (side) => `lineups.setSide('${side}')`
    });
  }

  _renderMapDropdownControl(maps) {
    return MapPicker.dropdown({
      ...this._mapPickerData(maps),
      open: this.isMapDropdownOpen
    });
  }

  _renderMapDropdownItems(maps = this.getMaps()) {
    return MapPicker.items(this._mapPickerData(maps));
  }

  /** Traduz os mapas da API pro formato do componente compartilhado. */
  _mapPickerData(maps = this.getMaps()) {
    return {
      maps: (Array.isArray(maps) ? maps : []).map((m) => ({
        id: m.id,
        name: m.display_name,
        thumb: this._imagemDeMiniatura(m)
      })),
      selectedId: this.filters.map_id,
      onSelect: (m) => `lineups.selectMap('${m.id}')`
    };
  }

  _refreshMapDropdownGrid() {
    const { grid } = this._getMapDropdownElements();
    if (!grid) return;
    grid.innerHTML = this._renderMapDropdownItems(this.getMaps());
  }

  _renderMapBannerSlide(mapId, mapName) {
    return MapPicker.slide({ image: this.getMapCardImage(mapId), name: mapName });
  }

  _getActiveMapBannerSlide() {
    const banner = document.getElementById('luMapBanner');
    if (!banner) return null;
    return banner.querySelector('.lu-map-banner-slide.active')
      || banner.querySelector('.lu-map-banner-slide:not(.exiting)')
      || banner.querySelector('.lu-map-banner-slide');
  }

  _getMapDropdownElements() {
    const topRow = document.querySelector('#luPanel .lu-top-row');
    return {
      panel: topRow?.querySelector('.lu-map-dropdown-panel') || null,
      grid: topRow?.querySelector('.lu-map-grid') || null
    };
  }

  _syncMapSideVisualOrientation() {
    const panel = document.getElementById('luPanel');
    if (!panel) return;
    const isDefense = this.filters.side === 'defense';
    panel.classList.toggle('lu-side-defense', isDefense);
    panel.classList.toggle('lu-side-attack', !isDefense);
  }

  _syncMapSideToggleButton() {
    document.querySelectorAll('.lu-map-side-btn').forEach((btn) => {
      const side = btn.dataset.side;
      const active = side === this.filters.side;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    this._syncMapSideVisualOrientation();
  }

  _escAttr(s) { return (s || '').replace(/'/g, "\\'").replace(/"/g, '&quot;'); }

  // ── Panel Interactions ────────────────────────
  _setMapDropdownState(isOpen) {
    this.isMapDropdownOpen = !!isOpen;
    const { panel } = this._getMapDropdownElements();
    const banner = document.getElementById('luMapBanner');
    const topRow = banner?.closest('.lu-top-row') || null;
    if (banner) {
      banner.classList.toggle('lu-map-dropdown-open', this.isMapDropdownOpen);
    }
    if (topRow) {
      topRow.classList.toggle('lu-map-dropdown-open', this.isMapDropdownOpen);
    }
    if (panel) {
      panel.classList.toggle('open', this.isMapDropdownOpen);
    }
  }

  toggleMapSelector() {
    this._setMapDropdownState(!this.isMapDropdownOpen);
  }

  handleMapBannerClick(event) {
    const target = event?.target;
    if (!target) return;

    this.toggleMapSelector();
  }

  toggleSide() {
    const next = this.filters.side === 'attack' ? 'defense' : 'attack';
    this.setSide(next);
  }

  selectMap(mapId) {
    if (this._createMode) this.exitCreateMode();
    this._hideAgentAbilitiesPopup();
    const m = this.getMaps().find(x => x.id === mapId);
    if (!m) return;
    this.selectedMap = m;
    this.filters.map_id = mapId;
    this._setMapDropdownState(false);
    this.selectedLineup = null;
    this.hoveredGroup = null;

    // Reset agent filter so ALL lineups for this map are shown
    this.filters.agent_id = null;
    this.selectedAgent = null;
    this.filters.ability = null;
    document.querySelectorAll('.lu-agent').forEach(el => el.classList.remove('active'));

    // UI: troca do banner com slide — a animacao mora no componente
    MapPicker.swap(document.getElementById('luMapBanner'), {
      image: this.getMapCardImage(mapId),
      name: m.display_name
    });

    // UI: refresh dropdown list so selected map is excluded and previous one returns
    this._refreshMapDropdownGrid();

    // Update minimap
    const img = document.getElementById('luMinimapImg');
    if (img) img.src = this.getMapMinimap(mapId);
    document.getElementById('luMinimapEmpty')?.classList.add('hidden');

    // Apply map rotation instantly (no transition — image already changed)
    this.zoomLevel = this.defaultZoomLevel; this.panX = 0; this.panY = 0;
    this._applyMapTransform(false);

    this.closePlayer();
    this.loadLineups();
  }

  setSide(side) {
    if (this._createMode) this.exitCreateMode();
    if (this.filters.side === side) return;
    this._hideAgentAbilitiesPopup();
    this.filters.side = side;
    this.selectedLineup = null;
    this._syncMapSideToggleButton();
    this.zoomLevel = this.defaultZoomLevel; this.panX = 0; this.panY = 0;
    this._applyMapTransform(true);
    this.closePlayer();
    this.loadLineups();
  }

  selectAgent(agentId) {
    if (this._createMode) this.exitCreateMode();
    this._hideAgentAbilitiesPopup();
    if (this.filters.agent_id === agentId) {
      this.filters.agent_id = null;
      this.selectedAgent = null;
      this.filters.ability = null;
    } else {
      this.filters.agent_id = agentId;
      this.selectedAgent = this.getAgents().find(a => a.id === agentId);
      this.filters.ability = null;
    }
    this.selectedLineup = null;

    document.querySelectorAll('.lu-agent').forEach(el =>
      el.classList.toggle('active', el.dataset.id === this.filters.agent_id));
    this.closePlayer();

    this.loadLineups();
  }

  // ── API: Load Lineups ─────────────────────────
  async loadLineups() {
    if (!this.filters.map_id) { this.clearMarkers(); return; }

    try {
      const isLogged = typeof auth !== 'undefined' && auth && auth.isAuthenticated;
      const team = (!this.adminMode && isLogged) ? app.getCurrentTeam() : null;
      const params = {};
      if (this.filters.map_id) params.map_id = this.filters.map_id;
      if (this.filters.agent_id) params.agent_id = this.filters.agent_id;
      if (this.filters.side) params.side = this.filters.side;

      // Scope-aware loading:
      //  - adminMode:       only public (admin-curated) lineups.
      //  - scope 'global':  only public lineups (anonymous or logged-in viewing shared content).
      //  - scope 'mine':    only the user's team/private lineups (never mix in the admin ones).
      const wantPublic  = this.adminMode || this.scope === 'global';
      const wantPrivate = !this.adminMode && this.scope === 'mine' && isLogged;

      const publicPromise = wantPublic
        ? api.getPublicLineups(params).catch(() => null)
        : Promise.resolve(null);
      const privatePromise = wantPrivate
        ? (team ? api.getLineups(team.id, params).catch(() => null)
                : api.getMyLineups(params).catch(() => null))
        : Promise.resolve(null);

      const [pubRes, privRes] = await Promise.all([publicPromise, privatePromise]);
      const publicLineups = pubRes?.success ? (pubRes.data?.lineups || []) : [];
      const privateLineups = privRes?.success ? (privRes.data?.lineups || []) : [];

      // Tag sources so UI can differentiate if needed
      publicLineups.forEach(l => { l._source = 'public'; });
      privateLineups.forEach(l => { l._source = 'private'; });

      // De-duplicate by id (private takes precedence)
      const byId = new Map();
      publicLineups.forEach(l => byId.set(l.id, l));
      privateLineups.forEach(l => byId.set(l.id, l));
      let lineups = Array.from(byId.values());

      if (this.filters.ability) {
        lineups = lineups.filter(l => l.ability_type === this.filters.ability);
      }

      this.lineups = lineups;
      this.buildGroups();
      this.renderMarkers();
    } catch (err) {
      console.error('[Lineups] loadLineups error:', err);
      this.lineups = [];
      this.clearMarkers();
    }
  }

  // ── Group by proximity ────────────────────────
  buildGroups() {
    const THRESHOLD = 5;
    this.groups = [];

    this.lineups.forEach(lineup => {
      const pos = this._parsePosField(lineup.landing_position)
        || this._parsePosField(lineup.launch_position);
      lineup._pos = pos || { top: 15 + Math.random() * 70, left: 15 + Math.random() * 70 };

      let placed = false;
      for (const g of this.groups) {
        const d = Math.sqrt(Math.pow(g.top - lineup._pos.top, 2) + Math.pow(g.left - lineup._pos.left, 2));
        if (d < THRESHOLD) {
          g.lineups.push(lineup);
          g.top = g.lineups.reduce((s, l) => s + l._pos.top, 0) / g.lineups.length;
          g.left = g.lineups.reduce((s, l) => s + l._pos.left, 0) / g.lineups.length;
          placed = true;
          break;
        }
      }
      if (!placed) {
        this.groups.push({ top: lineup._pos.top, left: lineup._pos.left, lineups: [lineup] });
      }
    });

    // Also build launch groups (for de-duplicating agent markers)
    this._buildLaunchGroups();
  }

  _buildLaunchGroups() {
    const THRESHOLD = 3;
    this._launchGroups = [];

    this.lineups.forEach(lineup => {
      const launch = this._parsePosField(lineup.launch_position);
      if (!launch) {
        // No launch — standalone group with landing as position
        const land = this._parsePosField(lineup.landing_position);
        this._launchGroups.push({ launch: land, lineups: [lineup] });
        return;
      }

      let placed = false;
      for (const g of this._launchGroups) {
        if (!g.launch) continue;
        const d = Math.sqrt(Math.pow(g.launch.top - launch.top, 2) + Math.pow(g.launch.left - launch.left, 2));
        // Same launch position AND same agent
        if (d < THRESHOLD && g.lineups[0].agent_id === lineup.agent_id) {
          g.lineups.push(lineup);
          // Average the launch position
          g.launch.top = g.lineups.reduce((s, l) => {
            const p = this._parsePosField(l.launch_position);
            return s + (p ? p.top : g.launch.top);
          }, 0) / g.lineups.length;
          g.launch.left = g.lineups.reduce((s, l) => {
            const p = this._parsePosField(l.launch_position);
            return s + (p ? p.left : g.launch.left);
          }, 0) / g.lineups.length;
          placed = true;
          break;
        }
      }
      if (!placed) {
        this._launchGroups.push({ launch: { ...launch }, lineups: [lineup] });
      }
    });
  }

  _parsePosField(field) {
    if (!field) return null;
    try {
      const obj = typeof field === 'string' ? JSON.parse(field) : field;
      if (obj && obj.top != null && obj.left != null) return { top: parseFloat(obj.top), left: parseFloat(obj.left) };
    } catch { }
    return null;
  }

  // ── Render Markers ────────────────────────────
  renderMarkers() {
    const container = document.getElementById('luMarkers');
    const svg = document.getElementById('luSvgOverlay');
    if (!container || !svg) return;
    container.innerHTML = '';
    svg.innerHTML = '';

    // Os pinos da lineup em construcao moram no mesmo container. Uma carga que
    // termina depois (trocar de agente dispara loadLineups) chegava aqui e
    // apagava o ponto de origem que o usuario acabara de marcar.
    if (!this.lineups.length) { if (this._createMode) this._updateCreatePreview(); return; }

    const counterRot = this._getMarkerCounterRotation();
    const groups = this._launchGroups || [];

    // Track rendered landing positions to avoid stacking duplicate land markers
    const LAND_THRESHOLD = 2; // % distance to consider same landing spot
    const renderedLands = []; // [{top, left, agent_id, el, lineups}]

    groups.forEach((group, gIdx) => {
      const firstLineup = group.lineups[0];
      const agent = this.getAgents().find(a => a.id === firstLineup.agent_id);
      const color = this._agentColor(agent);
      const agentIcon = agent?.display_icon || agent?.icon_url || 
        `https://media.valorant-api.com/agents/${firstLineup.agent_id}/displayicon.png`;

      // Render lines + land markers for each lineup in group
      group.lineups.forEach(lineup => {
        const idx = this.lineups.indexOf(lineup);
        const abilityIcon = this._getAbilityIcon(agent, lineup.ability_type);
        const launch = this._parsePosField(lineup.launch_position);
        const land = this._parsePosField(lineup.landing_position);

        // SVG connection line
        if (launch && land) {
          const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
          line.setAttribute('x1', `${launch.left}%`);
          line.setAttribute('y1', `${launch.top}%`);
          line.setAttribute('x2', `${land.left}%`);
          line.setAttribute('y2', `${land.top}%`);
          line.setAttribute('stroke', color);
          line.setAttribute('stroke-width', '3');
          line.setAttribute('opacity', '0.85');
          line.setAttribute('stroke-linecap', 'round');
          line.dataset.idx = idx;
          line.dataset.group = gIdx;
          line.classList.add('lu-line');
          svg.appendChild(line);
        }

        // Landing marker (ability icon) — deduplicate overlapping positions (same agent only)
        if (land) {
          const existing = renderedLands.find(rl =>
            rl.agent_id === firstLineup.agent_id &&
            Math.sqrt(Math.pow(rl.top - land.top, 2) + Math.pow(rl.left - land.left, 2)) < LAND_THRESHOLD
          );
          if (existing) {
            // Same agent, same landing spot — just add this lineup to its list
            existing.lineups.push(lineup);
          } else {
            const landMk = document.createElement('div');
            landMk.className = 'lu-land-marker';
            landMk.style.top = `${land.top}%`;
            landMk.style.left = `${land.left}%`;
            landMk.style.setProperty('--mc', color);
            const agentKey2 = this._getAgentKey(agent?.display_name || agent?.name);
            const gc2 = this._agentGradients?.[agentKey2] || { g0: '#1a1a2e', g1: '#0f1923', g2: '#1a1a2e' };
            landMk.style.setProperty('--agent-g0', gc2.g0);
            landMk.style.setProperty('--agent-g1', gc2.g1);
            landMk.style.setProperty('--agent-g2', gc2.g2);
            landMk.dataset.idx = idx;
            landMk.dataset.group = gIdx;
            landMk.innerHTML = abilityIcon 
              ? `<div style="transform:${counterRot}"><img src="${abilityIcon}" alt="" class="lu-land-icon"></div>`
              : `<div class="lu-land-dot"></div>`;

            const landEntry = { top: land.top, left: land.left, agent_id: firstLineup.agent_id, el: landMk, lineups: [lineup] };
            renderedLands.push(landEntry);

            landMk.addEventListener('click', (e) => {
              // In create mode, let the click propagate to the minimap handler for pin placement
              if (this._createMode) return;
              e.stopPropagation();
              // If multiple lineups share this landing spot, select the first one
              const lineupsAtSpot = landEntry.lineups;
              if (lineupsAtSpot.length === 1) {
                this.selectLineup(lineupsAtSpot[0]);
              } else {
                this.selectLineup(lineupsAtSpot[0]);
              }
            });
            landMk.addEventListener('mouseenter', () => this._highlightLineup(idx));
            landMk.addEventListener('mouseleave', () => this._unhighlightLineup());
            container.appendChild(landMk);
          }
        }
      });

      // ONE agent marker per launch group
      const launchPos = group.launch;
      if (launchPos) {
        const launchMk = document.createElement('div');
        launchMk.className = 'lu-agent-marker';
        launchMk.style.top = `${launchPos.top}%`;
        launchMk.style.left = `${launchPos.left}%`;
        launchMk.style.setProperty('--mc', color);
        launchMk.dataset.group = gIdx;

        // Badge for multiple variations
        const badge = group.lineups.length > 1 
          ? `<span class="lu-var-badge" style="transform:${counterRot}">${group.lineups.length}</span>` 
          : '';

        launchMk.innerHTML = `
          <div class="lu-agent-ring" style="transform:${counterRot}">
            <img src="${agentIcon}" alt="${agent?.display_name || ''}" class="lu-agent-icon">
          </div>${badge}`;

        launchMk.addEventListener('click', (e) => {
          // In create mode during 'land' step, let click propagate to minimap for pin placement
          if (this._createMode && this._createStep === 'land') return;
          e.stopPropagation();
          // In create mode → use this position as launch for a variation
          if (this._createMode && this._createStep === 'launch' && group.launch) {
            this._createData.launch = { top: group.launch.top.toFixed(2), left: group.launch.left.toFixed(2) };
            this._createStep = 'land';
            this._updateCreatePreview();
            this._showCreateHint('Agora clique onde a habilidade vai aterrissar (variação)', 'fa-bullseye');
            return;
          }
          if (group.lineups.length === 1) {
            this.selectLineup(group.lineups[0]);
          } else {
            this._selectLaunchGroup(gIdx);
          }
        });
        launchMk.addEventListener('mouseenter', () => this._highlightGroup(gIdx));
        launchMk.addEventListener('mouseleave', () => this._unhighlightLineup());
        container.appendChild(launchMk);
      }
    });
    // Mesma razao do retorno antecipado la em cima: o preview volta por cima.
    if (this._createMode) this._updateCreatePreview();
  }

  _getAbilityIcon(agent, abilityType) {
    if (!agent || !abilityType) return null;
    const abilities = agent.abilities || [];
    const ab = abilities.find(a => a.name === abilityType || a.displayName === abilityType);
    return ab?.displayIcon || null;
  }

  _highlightLineup(idx) {
    // Find which group this lineup belongs to
    const lineup = this.lineups[idx];
    let targetGroup = -1;
    if (lineup && this._launchGroups) {
      targetGroup = this._launchGroups.findIndex(g => g.lineups.includes(lineup));
    }
    // Fade all others — match by idx for land/line, by group for agent markers
    document.querySelectorAll('.lu-agent-marker, .lu-land-marker, .lu-line').forEach(el => {
      const elIdx = parseInt(el.dataset?.idx ?? '-1');
      const elGroup = parseInt(el.dataset?.group ?? '-1');
      const isAgentMarker = el.classList.contains('lu-agent-marker');
      const keep = isAgentMarker ? (elGroup === targetGroup) : (elIdx === idx);
      if (!keep) el.classList.add('faded');
    });
  }

  _highlightGroup(gIdx) {
    // Fade everything NOT in this launch group
    document.querySelectorAll('.lu-agent-marker, .lu-land-marker, .lu-line').forEach(el => {
      const elGroup = parseInt(el.dataset?.group ?? '-1');
      if (elGroup !== gIdx) el.classList.add('faded');
    });
  }

  _unhighlightLineup() {
    document.querySelectorAll('.lu-agent-marker, .lu-land-marker, .lu-line').forEach(el => {
      el.classList.remove('faded');
    });
  }

  clearMarkers() {
    const c = document.getElementById('luMarkers');
    const s = document.getElementById('luSvgOverlay');
    if (c) c.innerHTML = '';
    if (s) s.innerHTML = '';
    if (this._createMode) this._updateCreatePreview();
  }

  _agentColor(agent) {
    if (!agent) return '#ff4655';
    return { duelist: '#ff4655', controller: '#00d4ff', initiator: '#00ff88', sentinel: '#ffd600' }[agent.role] || '#ff4655';
  }

  // ── Marker Hover/Click ────────────────────────
  // (Handled directly in renderMarkers via per-lineup events)

  // ── Select Lineup ─────────────────────────────
  _selectedGroup = null;
  _selectedGroupPage = 0;

  selectLineupById(id) {
    const l = this.lineups.find(x => x.id === id);
    if (l) this.selectLineup(l);
  }

  selectLineup(lineup) {
    if (!lineup) return;
    this.selectedLineup = lineup;
    this._selectedGroup = null;
    this._selectedGroupPage = 0;
    const idx = this.lineups.indexOf(lineup);

    // Highlight selected, fade others
    document.querySelectorAll('.lu-agent-marker, .lu-land-marker').forEach(el => {
      const elIdx = parseInt(el.dataset.idx);
      el.classList.toggle('selected', elIdx === idx);
      el.classList.remove('faded');
    });
    document.querySelectorAll('.lu-line').forEach(el => {
      const elIdx = parseInt(el.dataset.idx);
      el.classList.toggle('selected', elIdx === idx);
      el.classList.remove('faded');
    });

    // Premium zoom towards the lineup position
    this._zoomToLineup(lineup);
    this._showPlayer(lineup);
  }

  _selectLaunchGroup(gIdx) {
    const groups = this._launchGroups;
    if (!groups || !groups[gIdx]) return;
    const group = groups[gIdx];

    if (group.lineups.length === 1) {
      this.selectLineup(group.lineups[0]);
      return;
    }

    // Store group state
    this._selectedGroup = group.lineups;
    this._selectedGroupPage = 0;
    this.selectedLineup = group.lineups[0];

    // Highlight ALL markers + lines in this group
    document.querySelectorAll('.lu-agent-marker').forEach(el => {
      const elGroup = parseInt(el.dataset.group ?? '-1');
      el.classList.toggle('selected', elGroup === gIdx);
      el.classList.remove('faded');
    });
    document.querySelectorAll('.lu-land-marker, .lu-line').forEach(el => {
      const elGroup = parseInt(el.dataset.group ?? '-1');
      el.classList.toggle('selected', elGroup === gIdx);
      el.classList.remove('faded');
    });

    // Zoom to group center
    this._zoomToGroup(group);
    // Show player card with navigation
    this._showGroupPlayer(group, 0);
  }

  _zoomToGroup(group) {
    const minimap = document.getElementById('luMinimap');
    const wrapper = document.getElementById('luMinimapWrapper');
    if (!minimap) return;

    // Calculate bounding box of all positions
    let allX = [], allY = [];
    group.lineups.forEach(l => {
      const launch = this._parsePosField(l.launch_position);
      const land = this._parsePosField(l.landing_position);
      if (launch) { allX.push(launch.left); allY.push(launch.top); }
      if (land) { allX.push(land.left); allY.push(land.top); }
    });
    if (!allX.length) return;

    const cx = allX.reduce((a, b) => a + b, 0) / allX.length;
    const cy = allY.reduce((a, b) => a + b, 0) / allY.length;

    const margin = 20;
    const ox = Math.max(margin, Math.min(100 - margin, cx));
    const oy = Math.max(margin, Math.min(100 - margin, cy));

    minimap.style.transformOrigin = `${ox}% ${oy}%`;
    minimap.style.transform = 'scale(1.2)';
    minimap.classList.add('lu-zoomed');
    if (wrapper) wrapper.classList.add('lu-viewing');
  }

  _showGroupPlayer(group, page) {
    if (!group || !group.lineups.length) return;
    const lineup = group.lineups[page];
    if (!lineup) return;

    this._selectedGroupPage = page;
    this.selectedLineup = lineup;

    const player = document.getElementById('luPlayer');
    if (!player) return;

    const total = group.lineups.length;
    const agent = this.getAgents().find(a => a.id === lineup.agent_id);
    const agentIcon = agent?.display_icon || `https://media.valorant-api.com/agents/${lineup.agent_id}/displayicon.png`;
    const abilityIcon = this._getAbilityIcon(agent, lineup.ability_type);
    const firstImg = this._getFirstImage(lineup);
    const hasVideo = !!lineup.video_url;
    const hasImg = !!firstImg;
    const showTabs = hasVideo && hasImg;

    // Navigation bar for variations
    const navHtml = `
      <div class="lu-pl-var-nav">
        <button class="lu-pl-var-btn ${page === 0 ? 'disabled' : ''}" onclick="lineups._groupNavPrev()" ${page === 0 ? 'disabled' : ''}>
          <i class="fas fa-chevron-left"></i>
        </button>
        <span class="lu-pl-var-label">Variação ${page + 1} / ${total}</span>
        <button class="lu-pl-var-btn ${page >= total - 1 ? 'disabled' : ''}" onclick="lineups._groupNavNext()" ${page >= total - 1 ? 'disabled' : ''}>
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>`;

    let tabsHtml = '';
    if (showTabs) {
      tabsHtml = `
        <div class="lu-pl-tabs">
          <button class="lu-pl-tab active" data-tab="video" onclick="lineups._switchTab('video')">VIDEO</button>
          <button class="lu-pl-tab" data-tab="image" onclick="lineups._switchTab('image')">LINEUP</button>
        </div>`;
    }

    let mediaHtml = '';
    if (showTabs) {
      mediaHtml = `
        <div class="lu-ptab-c active" data-tab="video">${this._embedHtml(lineup.video_url)}</div>
        <div class="lu-ptab-c" data-tab="image"><img src="${firstImg}" alt="" class="lu-pl-img"></div>`;
    } else if (hasVideo) {
      mediaHtml = this._embedHtml(lineup.video_url);
    } else if (hasImg) {
      mediaHtml = `<img src="${firstImg}" alt="${lineup.title}" class="lu-pl-img">`;
    } else {
      mediaHtml = '<div class="lu-pl-empty"><i class="fas fa-photo-video"></i><span>Sem mídia</span></div>';
    }

    player.innerHTML = `
      <div class="lu-pl-card">
        <button class="lu-pl-close" onclick="lineups.closePlayer()"><i class="fas fa-times"></i></button>
        ${navHtml}
        ${tabsHtml}
        <div class="lu-pl-media" id="luPlayerMedia">
          ${mediaHtml}
        </div>
        <div class="lu-pl-info">
          <div class="lu-pl-title">${lineup.title || ''}</div>
          <div class="lu-pl-meta">
            <img src="${agentIcon}" alt="" class="lu-pl-agent-icon">
            <span class="lu-pl-agent-name">${agent?.display_name || ''}</span>
            <span class="lu-pl-dot">·</span>
            <span class="lu-pl-side ${lineup.side}">${lineup.side === 'attack' ? 'Ataque' : 'Defesa'}</span>
            ${lineup.ability_type ? `
              <span class="lu-pl-dot">·</span>
              ${abilityIcon ? `<img src="${abilityIcon}" class="lu-pl-ability-icon">` : ''}
              <span>${lineup.ability_type}</span>
            ` : ''}
          </div>
          ${lineup.description ? `<div class="lu-pl-desc">${lineup.description}</div>` : ''}
        </div>
        ${this._canManageLineup(lineup) ? `<div class="lu-pl-actions">
          <button class="lu-pl-btn edit" onclick="lineups.editLineup('${lineup.id}')" title="Editar"><i class="fas fa-edit"></i></button>
          <button class="lu-pl-btn delete" onclick="lineups.deleteLineup('${lineup.id}')" title="Excluir"><i class="fas fa-trash"></i></button>
        </div>` : ''}
      </div>`;

    player.classList.remove('hidden');

    // Load TikTok embed script if needed
    this._initTikTokEmbed();
    this._initIgReplay();

    // Slide out left panel
    const panel = document.getElementById('luPanel');
    if (panel) panel.classList.add('lu-panel-collapsed');

    // Highlight current variation's land marker
    this._highlightGroupVariation(page);
  }

  _highlightGroupVariation(page) {
    if (!this._selectedGroup) return;
    const lineup = this._selectedGroup[page];
    if (!lineup) return;
    const idx = this.lineups.indexOf(lineup);

    document.querySelectorAll('.lu-land-marker, .lu-line').forEach(el => {
      const elIdx = parseInt(el.dataset.idx);
      if (el.dataset.group !== undefined) {
        // Dim non-current variations slightly
        const isCurrent = elIdx === idx;
        el.style.opacity = isCurrent ? '' : '0.45';
        el.style.filter = isCurrent ? '' : 'saturate(0.5)';
      }
    });
  }

  _groupNavPrev() {
    if (!this._selectedGroup || this._selectedGroupPage <= 0) return;
    const groups = this._launchGroups;
    const gIdx = groups?.findIndex(g => g.lineups === this._selectedGroup);
    if (gIdx == null) return;
    const group = groups[gIdx];
    this._showGroupPlayer(group, this._selectedGroupPage - 1);
  }

  _groupNavNext() {
    if (!this._selectedGroup || this._selectedGroupPage >= this._selectedGroup.length - 1) return;
    const groups = this._launchGroups;
    const gIdx = groups?.findIndex(g => g.lineups === this._selectedGroup);
    if (gIdx == null) return;
    const group = groups[gIdx];
    this._showGroupPlayer(group, this._selectedGroupPage + 1);
  }

  _zoomToLineup(lineup) {
    const minimap = document.getElementById('luMinimap');
    const wrapper = document.getElementById('luMinimapWrapper');
    if (!minimap) return;

    const land = this._parsePosField(lineup.landing_position);
    const launch = this._parsePosField(lineup.launch_position);
    const pos = land || launch;
    if (!pos) return;

    // Calculate center of the lineup markers
    let cx = parseFloat(pos.left);
    let cy = parseFloat(pos.top);
    if (land && launch) {
      cx = (parseFloat(land.left) + parseFloat(launch.left)) / 2;
      cy = (parseFloat(land.top) + parseFloat(launch.top)) / 2;
    }

    // Clamp origin so zoomed map doesn't go out of bounds
    const margin = 20;
    const ox = Math.max(margin, Math.min(100 - margin, cx));
    const oy = Math.max(margin, Math.min(100 - margin, cy));

    minimap.style.transformOrigin = `${ox}% ${oy}%`;
    minimap.style.transform = 'scale(1.2)';
    minimap.classList.add('lu-zoomed');
    if (wrapper) wrapper.classList.add('lu-viewing');
  }

  _unzoomMinimap() {
    const minimap = document.getElementById('luMinimap');
    const wrapper = document.getElementById('luMinimapWrapper');
    if (!minimap) return;
    minimap.style.transform = '';
    minimap.style.transformOrigin = 'center center';
    minimap.classList.remove('lu-zoomed');
    if (wrapper) wrapper.classList.remove('lu-viewing');
  }

  // ── Player (floating overlay card like strats.gg) ─────────────
  _showPlayer(lineup) {
    const player = document.getElementById('luPlayer');
    if (!player) return;

    const agent = this.getAgents().find(a => a.id === lineup.agent_id);
    const agentIcon = agent?.display_icon || `https://media.valorant-api.com/agents/${lineup.agent_id}/displayicon.png`;
    const abilityIcon = this._getAbilityIcon(agent, lineup.ability_type);
    const firstImg = this._getFirstImage(lineup);
    const hasVideo = !!lineup.video_url;
    const hasImg = !!firstImg;
    const showTabs = hasVideo && hasImg;

    // Build tab buttons
    let tabsHtml = '';
    if (showTabs) {
      tabsHtml = `
        <div class="lu-pl-tabs">
          <button class="lu-pl-tab active" data-tab="video" onclick="lineups._switchTab('video')">VIDEO</button>
          <button class="lu-pl-tab" data-tab="image" onclick="lineups._switchTab('image')">LINEUP</button>
        </div>`;
    }

    // Build media
    let mediaHtml = '';
    if (showTabs) {
      mediaHtml = `
        <div class="lu-ptab-c active" data-tab="video">${this._embedHtml(lineup.video_url)}</div>
        <div class="lu-ptab-c" data-tab="image"><img src="${firstImg}" alt="" class="lu-pl-img"></div>`;
    } else if (hasVideo) {
      mediaHtml = this._embedHtml(lineup.video_url);
    } else if (hasImg) {
      mediaHtml = `<img src="${firstImg}" alt="${lineup.title}" class="lu-pl-img">`;
    } else {
      mediaHtml = '<div class="lu-pl-empty"><i class="fas fa-photo-video"></i><span>Sem mídia</span></div>';
    }

    player.innerHTML = `
      <div class="lu-pl-card">
        <button class="lu-pl-close" onclick="lineups.closePlayer()"><i class="fas fa-times"></i></button>
        ${tabsHtml}
        <div class="lu-pl-media" id="luPlayerMedia">
          ${mediaHtml}
        </div>
        <div class="lu-pl-info">
          <div class="lu-pl-title">${lineup.title || ''}</div>
          <div class="lu-pl-meta">
            <img src="${agentIcon}" alt="" class="lu-pl-agent-icon">
            <span class="lu-pl-agent-name">${agent?.display_name || ''}</span>
            <span class="lu-pl-dot">·</span>
            <span class="lu-pl-side ${lineup.side}">${lineup.side === 'attack' ? 'Ataque' : 'Defesa'}</span>
            ${lineup.ability_type ? `
              <span class="lu-pl-dot">·</span>
              ${abilityIcon ? `<img src="${abilityIcon}" class="lu-pl-ability-icon">` : ''}
              <span>${lineup.ability_type}</span>
            ` : ''}
          </div>
          ${lineup.description ? `<div class="lu-pl-desc">${lineup.description}</div>` : ''}
        </div>
        ${this._canManageLineup(lineup) ? `<div class="lu-pl-actions">
          <button class="lu-pl-btn edit" onclick="lineups.editLineup('${lineup.id}')" title="Editar"><i class="fas fa-edit"></i></button>
          <button class="lu-pl-btn delete" onclick="lineups.deleteLineup('${lineup.id}')" title="Excluir"><i class="fas fa-trash"></i></button>
        </div>` : ''}
      </div>`;

    player.classList.remove('hidden');

    // Load TikTok embed script if needed
    this._initTikTokEmbed();
    this._initIgReplay();

    // Slide out left panel for full-screen feel
    const panel = document.getElementById('luPanel');
    if (panel) panel.classList.add('lu-panel-collapsed');
  }

  _switchTab(tab) {
    document.querySelectorAll('.lu-pl-tab').forEach(t => t.classList.toggle('active', t.dataset.tab === tab));
    document.querySelectorAll('.lu-ptab-c').forEach(c => c.classList.toggle('active', c.dataset.tab === tab));
  }

  closePlayer() {
    const p = document.getElementById('luPlayer');
    if (p) { p.classList.add('hidden'); p.innerHTML = ''; }
    this.selectedLineup = null;
    this._selectedGroup = null;
    this._selectedGroupPage = 0;
    this._unzoomMinimap();

    // Slide left panel back in
    const panel = document.getElementById('luPanel');
    if (panel) panel.classList.remove('lu-panel-collapsed');

    document.querySelectorAll('.lu-agent-marker, .lu-land-marker').forEach(m => {
      m.classList.remove('selected');
      m.style.opacity = '';
      m.style.filter = '';
    });
    document.querySelectorAll('.lu-line').forEach(l => {
      l.classList.remove('selected');
      l.style.opacity = '';
      l.style.filter = '';
    });
  }

  _getFirstImage(lineup) {
    if (!lineup.images || !lineup.images.length) return null;
    const img = lineup.images[0];
    return typeof img === 'string' ? img : img?.url || null;
  }

  _embedHtml(url) {
    if (!url) return '';
    // YouTube
    const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]+)/);
    if (yt) return `<iframe src="https://www.youtube.com/embed/${yt[1]}?rel=0&modestbranding=1" frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      allowfullscreen class="lu-player-iframe"></iframe>`;
    // Twitter/X — stream video via backend proxy (same as TikTok)
    const tw = url.match(/(?:twitter\.com|x\.com)\/\w+\/status\/(\d+)/);
    if (tw) return `<div class="lu-tiktok-wrap" data-tiktok-url="${url}">
      <div class="lu-tiktok-loading"><i class="fas fa-spinner fa-spin"></i> Carregando vídeo...</div>
    </div>`;
    // TikTok — extract direct video URL via backend proxy
    const tt = url.match(/tiktok\.com\/@([\w.-]+)\/video\/(\d+)/);
    if (tt) return `<div class="lu-tiktok-wrap" data-tiktok-url="${url}">
      <div class="lu-tiktok-loading"><i class="fas fa-spinner fa-spin"></i> Carregando TikTok...</div>
    </div>`;
    // Instagram Reels/Posts — iframe embed with custom controls
    const ig = url.match(/instagram\.com\/(?:reels?|p)\/([\w-]+)/);
    if (ig) {
      const embedUrl = `https://www.instagram.com/reel/${ig[1]}/embed/`;
      const postUrl = `https://www.instagram.com/reel/${ig[1]}/`;
      return `<div class="lu-ig-wrap" data-ig-src="${embedUrl}" data-ig-shortcode="${ig[1]}" data-ig-post="${postUrl}">
        <iframe src="${embedUrl}" frameborder="0"
          sandbox="allow-scripts allow-same-origin allow-presentation"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          scrolling="no" class="lu-player-iframe lu-ig-player"></iframe>
        <div class="lu-ig-replay-overlay lu-ig-hidden">
          <i class="fas fa-redo-alt"></i>
          <span>Clique para repetir</span>
        </div>
        <div class="lu-ig-controls">
          <div class="lu-ig-ctrl-spacer"></div>
          <a class="lu-ig-ctrl-btn lu-ig-open" href="${postUrl}" target="_blank" rel="noopener" title="Abrir no Instagram">
            <i class="fab fa-instagram"></i>
          </a>
          <button class="lu-ig-ctrl-btn lu-ig-reload" title="Repetir vídeo">
            <i class="fas fa-redo-alt"></i>
          </button>
          <button class="lu-ig-ctrl-btn lu-ig-close" onclick="lineups.closePlayer()" title="Fechar">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>`;
    }
    // Direct video files
    if (url.match(/\.(mp4|webm|ogg)($|\?)/i) || url.includes('r2.') || url.includes('/uploads/'))
      return `<video src="${url}" controls class="lu-player-video"></video>`;
    return `<iframe src="${url}" frameborder="0" allowfullscreen class="lu-player-iframe"></iframe>`;
  }

  /** After inserting video placeholder into DOM, use stream proxy (TikTok, Twitter/X) */
  _initTikTokEmbed() {
    const wrap = document.querySelector('.lu-tiktok-wrap[data-tiktok-url]');
    if (!wrap) return;
    const url = wrap.dataset.tiktokUrl;
    const streamUrl = `/api/video-stream?url=${encodeURIComponent(url)}`;
    wrap.innerHTML = `<video src="${streamUrl}" controls playsinline class="lu-player-video lu-tiktok-video"></video>`;
  }

  /** Instagram controls init */
  _initIgReplay() {
    const wrap = document.querySelector('.lu-ig-wrap');
    if (!wrap) return;
    const iframe = wrap.querySelector('iframe');
    const overlay = wrap.querySelector('.lu-ig-replay-overlay');
    const reloadBtn = wrap.querySelector('.lu-ig-reload');
    if (!iframe) return;

    // Hide the original close button when IG embed is active (we have one in the control bar)
    const origClose = wrap.closest('.lu-pl-card')?.querySelector('.lu-pl-close');
    if (origClose) origClose.style.display = 'none';

    // Reload = replay
    if (reloadBtn) {
      reloadBtn.addEventListener('click', () => {
        iframe.src = wrap.dataset.igSrc;
        if (overlay) overlay.classList.add('lu-ig-hidden');
      });
    }

    // Overlay click to replay
    if (overlay) {
      overlay.addEventListener('click', () => {
        iframe.src = wrap.dataset.igSrc;
        overlay.classList.add('lu-ig-hidden');
      });

      // Listen for postMessage from Instagram embed (video ended)
      window.addEventListener('message', (e) => {
        if (!e.origin.includes('instagram.com')) return;
        try {
          const data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
          if (data?.type === 'video' && data?.event === 'ended') {
            overlay.classList.remove('lu-ig-hidden');
          }
        } catch(_) {}
      });
    }
  }

  _isVideoUrl(url) {
    return /youtube\.com|youtu\.be|vimeo\.com|twitch\.tv|twitter\.com|x\.com|tiktok\.com|instagram\.com\/(?:reels?|p)\/|\.mp4$|\.webm$|\.mov$/i.test(url);
  }

  // ── Create Inline (strats.gg style) ────────────
  _createMode = false;
  _createStep = 'launch'; // 'launch' | 'land' | 'done'
  _createData = { launch: null, land: null, ability: null };

  enterCreateMode() {
    // Anonymous users cannot create lineups — open login modal.
    // Admin mode always allows (super_admin is already authenticated).
    if (!this.adminMode && typeof auth !== 'undefined' && auth && !auth.isAuthenticated) {
      if (typeof toast !== 'undefined') toast.info('Entre para criar seus próprios lineups');
      if (typeof auth.openAuth === 'function') auth.openAuth('login');
      return;
    }
    // Creating always happens under 'mine' — switch out of 'global' first.
    if (!this.adminMode && this.scope !== 'mine') {
      this.setScope('mine');
    }
    if (!this.filters.map_id) {
      if (typeof toast !== 'undefined') toast.warning('Selecione um mapa primeiro');
      return;
    }
    if (!this.filters.agent_id) {
      if (typeof toast !== 'undefined') toast.warning('Selecione um agente primeiro');
      return;
    }

    this._createMode = true;
    this._createStep = 'launch';
    this._createData = { launch: null, land: null, ability: null };

    // Fade land markers and lines, but keep agent markers visible (for variation click)
    document.querySelectorAll('.lu-land-marker, .lu-line').forEach(el => el.classList.add('faded'));
    document.querySelectorAll('.lu-agent-marker').forEach(el => el.classList.add('lu-create-clickable'));

    // Cursor crosshair
    const minimap = document.getElementById('luMinimap');
    if (minimap) minimap.classList.remove('lu-sem-mira');
    if (minimap) minimap.classList.add('lu-create-mode');

    // Show hint
    this._showCreateHint('Arraste de onde a habilidade sai até onde ela cai — ou clique em cada um dos dois pontos', 'fa-location-arrow');
  }

  exitCreateMode() {
    this._createMode = false;
    this._createStep = 'launch';
    this._createData = { launch: null, land: null, ability: null };

    document.getElementById('luCreateHint')?.remove();
    document.getElementById('luCreateSavePanel')?.remove();
    document.getElementById('luAbilityPicker')?.remove();
    document.querySelectorAll('.lu-create-pin, .lu-create-line').forEach(el => el.remove());

    document.querySelectorAll('.lu-agent-marker, .lu-land-marker, .lu-line').forEach(el => {
      el.classList.remove('faded');
      el.classList.remove('lu-create-clickable');
    });

    const minimap = document.getElementById('luMinimap');
    if (minimap) minimap.classList.remove('lu-create-mode', 'lu-sem-mira');
  }

  _showCreateHint(text, icon) {
    document.getElementById('luCreateHint')?.remove();
    const hint = document.createElement('div');
    hint.id = 'luCreateHint';
    hint.className = 'lu-create-hint';
    hint.innerHTML = `
      <div class="lu-ch-content">
        <i class="fas ${icon}"></i>
        <span>${text}</span>
      </div>
      <button class="lu-ch-cancel" onclick="lineups.exitCreateMode()">
        <i class="fas fa-times"></i>
      </button>`;
    const host = document.querySelector('#page-lineups .lu-layout') || document.getElementById('page-lineups') || document.body;
    host.appendChild(hint);
  }

  /**
   * Posicao do cursor em % da imagem do minimapa, desfazendo a rotacao do mapa.
   * Usada tanto pelo clique quanto pelo arrasto — antes so existia dentro do
   * handler de clique.
   */
  _pontoDoMinimap(e) {
    const minimap = document.getElementById('luMinimap');
    if (!minimap) return null;

    // O calculo e sobre a imagem nao rotacionada
    const img = document.getElementById('luMinimapImg');
    const target = img || minimap;
    const rect = target.getBoundingClientRect();

    const screenX = e.clientX - rect.left;
    const screenY = e.clientY - rect.top;
    const w = rect.width;
    const h = rect.height;

    const deg = this._getCurrentRotationDeg();
    const { x: imgX, y: imgY } = this._screenToImgCoords(screenX, screenY, w, h, deg);

    // Desfeita a rotacao, as dimensoes originais podem estar trocadas
    const isSwapped = (deg === 90 || deg === 270);
    const origW = isSwapped ? h : w;
    const origH = isSwapped ? w : h;

    return {
      left: Math.max(0, Math.min(100, (imgX / origW) * 100)),
      top:  Math.max(0, Math.min(100, (imgY / origH) * 100))
    };
  }

  _onMinimapCreateClick(e) {
    if (!this._createMode) return;
    const ponto = this._pontoDoMinimap(e);
    if (!ponto) return;
    const { left, top } = ponto;

    if (this._createStep === 'launch') {
      this._createData.launch = { top: top.toFixed(2), left: left.toFixed(2) };
      this._createStep = 'land';
      this._updateCreatePreview();
      this._showCreateHint('Agora clique onde a habilidade vai aterrissar', 'fa-bullseye');
    } else if (this._createStep === 'land') {
      this._createData.land = { top: top.toFixed(2), left: left.toFixed(2) };
      this._createStep = 'pick_ability';
      this._updateCreatePreview();
      document.getElementById('luCreateHint')?.remove();
      this._showAbilityPicker(left, top);
    }
  }

  _getCurrentRotationDeg() {
    const name = this.selectedMap?.name?.toLowerCase();
    const rot = this.mapRotations[name];
    let deg = rot?.baseRotation || 0;
    const shouldFlipForDefense = rot ? !!rot.flipForDefense : true;
    if (this.filters.side === 'defense' && shouldFlipForDefense) deg += 180;
    return ((deg % 360) + 360) % 360;
  }

  // Reverse CSS rotation to get original image coordinates
  _screenToImgCoords(sx, sy, w, h, deg) {
    // CSS transform-origin is center (w/2, h/2)
    // We need to reverse the rotation around the center of the bounding box
    const cx = w / 2;
    const cy = h / 2;
    const dx = sx - cx;
    const dy = sy - cy;
    const rad = -(deg * Math.PI) / 180; // negative to reverse
    const rx = dx * Math.cos(rad) - dy * Math.sin(rad);
    const ry = dx * Math.sin(rad) + dy * Math.cos(rad);
    // For 90/270, the original image center is at (h/2, w/2) mapped to (w/2, h/2)
    const isSwapped = (deg === 90 || deg === 270);
    const ocx = isSwapped ? h / 2 : w / 2;
    const ocy = isSwapped ? w / 2 : h / 2;
    return { x: rx + ocx, y: ry + ocy };
  }

  // Get counter-rotation CSS for markers to stay upright
  _getMarkerCounterRotation() {
    const deg = this._getCurrentRotationDeg();
    return deg ? `rotate(${-deg}deg)` : '';
  }

  _updateCreatePreview() {
    document.querySelectorAll('.lu-create-pin, .lu-create-line').forEach(el => el.remove());

    const container = document.getElementById('luMarkers');
    const svg = document.getElementById('luSvgOverlay');
    if (!container || !svg) return;

    const agent = this.selectedAgent;
    const color = this._agentColor(agent);
    const agentIcon = agent?.display_icon || `https://media.valorant-api.com/agents/${agent?.id}/displayicon.png`;
    const abilityIcon = this._getAbilityIcon(agent, this._createData.ability);
    const { launch, land } = this._createData;

    const counterRot = this._getMarkerCounterRotation();

    if (launch) {
      const mk = document.createElement('div');
      mk.className = 'lu-agent-marker lu-create-pin selected';
      mk.style.cssText = `top:${launch.top}%;left:${launch.left}%;--mc:${color};--counter-rot:${counterRot || 'none'}`;
      mk.innerHTML = `<div class="lu-agent-ring" style="transform:${counterRot}"><img src="${agentIcon}" alt="" class="lu-agent-icon"></div>`;
      container.appendChild(mk);
    }

    if (land) {
      const mk = document.createElement('div');
      mk.className = 'lu-land-marker lu-create-pin selected';
      const agentKeyP = this._getAgentKey(agent?.display_name || agent?.name);
      const gcP = this._agentGradients?.[agentKeyP] || { g0: '#1a1a2e', g1: '#0f1923', g2: '#1a1a2e' };
      mk.style.cssText = `top:${land.top}%;left:${land.left}%;--mc:${color};--agent-g0:${gcP.g0};--agent-g1:${gcP.g1};--agent-g2:${gcP.g2}`;
      mk.innerHTML = abilityIcon
        ? `<div style="transform:${counterRot}"><img src="${abilityIcon}" alt="" class="lu-land-icon"></div>`
        : `<div class="lu-land-dot"></div>`;
      container.appendChild(mk);
    }

    if (launch && land) {
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', `${launch.left}%`);
      line.setAttribute('y1', `${launch.top}%`);
      line.setAttribute('x2', `${land.left}%`);
      line.setAttribute('y2', `${land.top}%`);
      line.setAttribute('stroke', color);
      line.setAttribute('stroke-width', '3.5');
      line.setAttribute('opacity', '1');
      line.setAttribute('stroke-linecap', 'round');
      line.classList.add('lu-line', 'lu-create-line', 'selected');
      svg.appendChild(line);
    }
  }

  // ── Ability Picker (4 icons near the land marker) ─────────
  _showAbilityPicker(landLeft, landTop) {
    document.getElementById('luAbilityPicker')?.remove();
    const agent = this.selectedAgent;
    const abilities = agent?.abilities || [];
    if (!abilities.length) { this._pickAbility(null); return; }

    const key = this._getAgentKey(agent?.display_name || agent?.name);
    const gc = this._agentGradients?.[key] || { g0: '#1a1a2e', g1: '#0f1923', g2: '#1a1a2e' };

    const picker = document.createElement('div');
    picker.id = 'luAbilityPicker';
    picker.className = 'lu-ability-picker';
    picker.style.setProperty('--agent-g0', gc.g0);
    picker.style.setProperty('--agent-g1', gc.g1);
    picker.style.setProperty('--agent-g2', gc.g2);

    picker.innerHTML = `
      <div class="lu-ap-inner">
        <span class="lu-ap-label">Escolha a habilidade</span>
        ${abilities.map(ab => {
          const icon = ab.displayIcon || '';
          if (!icon) return '';
          const rotulo = this._escAttr(ab.displayName || ab.name);
          // `data-nome` alimenta o balao de CSS; sem `title` pra nao duplicar
          // com o tooltip nativo do navegador.
          return `<div class="lu-ap-item" onclick="lineups._pickAbility('${this._escAttr(ab.name)}')" data-nome="${rotulo}" aria-label="${rotulo}">
            <img src="${icon}" alt="${ab.displayName || ab.name}">
          </div>`;
        }).join('')}
      </div>
    `;

    // Sempre no mesmo lugar: rodape do minimapa. Antes ficava colado no pino de
    // aterrissagem, entao mudava de posicao a cada lineup e ainda precisava ser
    // empurrado de volta para dentro do mapa.
    const host = document.getElementById('luMinimapWrapper')
      || document.getElementById('luMinimap')
      || document.querySelector('.lu-panel-actions');
    host?.appendChild(picker);
  }

  _pickAbility(abilityName) {
    document.getElementById('luAbilityPicker')?.remove();
    this._createData.ability = abilityName;
    this._createStep = 'done';
    this._updateCreatePreview();
    this._showSavePanel();
  }

  _showSavePanel() {
    document.getElementById('luCreateSavePanel')?.remove();

    const agent = this.selectedAgent;
    const agentKey = this._getAgentKey(agent?.display_name || agent?.name);
    const gc = this._agentGradients?.[agentKey] || { g0: '#1a1a2e', g1: '#0f1923', g2: '#1a1a2e' };

    const panel = document.createElement('div');
    panel.id = 'luCreateSavePanel';
    panel.className = 'lu-save-panel';
    panel.style.setProperty('--agent-g0', gc.g0);
    panel.style.setProperty('--agent-g1', gc.g1);
    panel.style.setProperty('--agent-g2', gc.g2);
    panel.style.setProperty('--mc', this._agentColor(agent));
    panel.innerHTML = `
      <div class="lu-sp-media-row">
        <input type="url" id="luSpMediaUrl" class="lu-sp-input" placeholder="Cole a URL do vídeo ou imagem..." autofocus>
        <label class="lu-sp-upload-btn" title="Upload de arquivo">
          <i class="fas fa-upload"></i>
          <input type="file" id="luSpFileUpload" accept="video/*,image/*" style="display:none" onchange="lineups._onCreateFileSelect(event)">
        </label>
      </div>
      <div class="lu-sp-file-name hidden" id="luSpFileName"></div>
      <div class="lu-sp-actions">
        <button class="lu-sp-btn cancel" onclick="lineups.exitCreateMode()">Cancelar</button>
        <button class="lu-sp-btn save" id="luSpSaveBtn" onclick="lineups._submitCreateInline()">
          <i class="fas fa-check"></i> Salvar
        </button>
      </div>
    `;

    document.getElementById('luMinimapWrapper')?.appendChild(panel);
    setTimeout(() => document.getElementById('luSpMediaUrl')?.focus(), 100);
  }

  _createFileData = null;

  _onCreateFileSelect(e) {
    const file = e.target?.files?.[0];
    if (!file) return;
    this._createFileData = file;
    const nameEl = document.getElementById('luSpFileName');
    if (nameEl) {
      nameEl.textContent = file.name;
      nameEl.classList.remove('hidden');
    }
    // Clear URL input since file was selected
    const urlInput = document.getElementById('luSpMediaUrl');
    if (urlInput) urlInput.value = '';
  }

  _undoToLand() {
    this._createData.land = null;
    this._createData.ability = null;
    this._createStep = 'land';
    document.getElementById('luCreateSavePanel')?.remove();
    document.getElementById('luAbilityPicker')?.remove();
    this._updateCreatePreview();
    this._showCreateHint('Agora clique onde a habilidade vai aterrissar', 'fa-bullseye');
  }

  async _submitCreateInline() {
    const team = app.getCurrentTeam();
    let mediaUrl = document.getElementById('luSpMediaUrl')?.value?.trim() || null;
    const agent = this.selectedAgent;
    const abilityName = this._createData.ability || null;

    // Auto-generate title from agent + ability
    const agentName = agent?.display_name || 'Lineup';
    const title = abilityName ? `${agentName} - ${abilityName}` : agentName;

    const btn = document.getElementById('luSpSaveBtn');
    if (btn) { btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'; }

    try {
      // If a file was selected, upload it first
      if (this._createFileData) {
        const formData = new FormData();
        formData.append('file', this._createFileData);
        formData.append('type', 'lineups');
        const uploadRes = await fetch('/api/upload', {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${localStorage.getItem('zdval_token')}` },
          body: formData
        });
        const uploadData = await uploadRes.json();
        if (uploadData?.url) {
          mediaUrl = uploadData.url;
        }
      }

      const isVideo = mediaUrl && this._isVideoUrl(mediaUrl);
      const data = {
        team_id: team ? team.id : null,
        map_id: this.filters.map_id,
        agent_id: this.filters.agent_id,
        title,
        description: '',
        side: this.filters.side || 'attack',
        ability_type: abilityName,
        launch_position: this._createData.launch,
        landing_position: this._createData.land,
        video_url: isVideo ? mediaUrl : null,
        image_url: !isVideo && mediaUrl ? mediaUrl : null,
        status: 'learning'
      };

      const result = this.adminMode
        ? await api.createAdminLineup(data)
        : await api.createLineup(data);
      if (result.success) {
        this._createFileData = null;
        this.exitCreateMode();
        if (typeof toast !== 'undefined') toast.success('Lineup criado!');
        this.loadLineups();
      } else {
        if (typeof toast !== 'undefined') toast.error('Erro', result.message || 'Falha ao criar');
        if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fas fa-check"></i> Salvar'; }
      }
    } catch (err) {
      if (typeof toast !== 'undefined') toast.error('Erro', err.message);
      if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fas fa-check"></i> Salvar'; }
    }
  }

  // ── Edit Modal ────────────────────────────────
  async editLineup(id) {
    try {
      const result = await api.getLineup(id);
      if (!result?.success) { if (typeof toast !== 'undefined') toast.error('Erro', 'Lineup não encontrado'); return; }
      const lineup = result.data?.lineup || result.data;

      const maps = this.getMaps();
      const agents = this.getAgents();
      const launchPos = this._parsePosField(lineup.launch_position);
      const landPos = this._parsePosField(lineup.landing_position);
      const firstImg = this._getFirstImage(lineup);

      const modal = app.createModal('Editar Lineup', `
        <form id="luEditForm" class="lu-form">
          <input type="hidden" id="luEditMap" value="${lineup.map_id}">
          <input type="hidden" id="luEditAgent" value="${lineup.agent_id}">
          <input type="hidden" id="luEditSide" value="${lineup.side || 'attack'}">
          <input type="hidden" id="luEditTitle" value="${(lineup.title || '').replace(/"/g, '&quot;')}">
          <input type="hidden" id="luEditDesc" value="${(lineup.description || '').replace(/"/g, '&quot;')}">
          <input type="hidden" id="luEditAbility" value="${lineup.ability_type || ''}">
          <div class="form-group">
            <label>Posição no Mapa</label>
            <div class="lu-form-minimap-wrap">
              <div class="lu-form-minimap" id="luEditMinimap">
                <img src="${this.getMapMinimap(lineup.map_id)}" alt="Minimap" id="luEditMinimapImg">
                <div class="lu-form-pin lu-pin-launch ${launchPos ? '' : 'hidden'}" id="luEditPinLaunch"
                     style="${launchPos ? `top:${launchPos.top}%;left:${launchPos.left}%` : ''}">
                  <i class="fas fa-location-arrow"></i></div>
                <div class="lu-form-pin lu-pin-land ${landPos ? '' : 'hidden'}" id="luEditPinLand"
                     style="${landPos ? `top:${landPos.top}%;left:${landPos.left}%` : ''}">
                  <i class="fas fa-bullseye"></i></div>
                <svg class="lu-form-svg" id="luEditSvg"></svg>
              </div>
            </div>
            <input type="hidden" id="luEditLaunchPos" value="${launchPos ? JSON.stringify(launchPos) : ''}">
            <input type="hidden" id="luEditLandPos" value="${landPos ? JSON.stringify(landPos) : ''}">
          </div>
          <div class="form-group">
            <label>Mídia (URL)</label>
            <input type="text" id="luEditMediaUrl" class="form-input" value="${lineup.video_url || firstImg || ''}" placeholder="URL de vídeo ou imagem">
          </div>
          <div class="form-actions">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button type="submit" class="btn btn-primary"><i class="fas fa-save"></i> Salvar</button>
          </div>
        </form>
      `);

      // Edit pin state — clicking minimap sets launch first, then land
      this._editPinMode = 'launch';
      this._editLaunch = launchPos;
      this._editLand = landPos;

      // Minimap click
      modal.querySelector('#luEditMinimap').addEventListener('click', (e) => {
        const cont = document.getElementById('luEditMinimap');
        const rect = cont.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        if (this._editPinMode === 'launch') {
          this._editLaunch = { top: y.toFixed(2), left: x.toFixed(2) };
          const pin = document.getElementById('luEditPinLaunch');
          if (pin) { pin.style.top = `${y}%`; pin.style.left = `${x}%`; pin.classList.remove('hidden'); }
          document.getElementById('luEditLaunchPos').value = JSON.stringify(this._editLaunch);
          this.setEditPinMode('land');
        } else {
          this._editLand = { top: y.toFixed(2), left: x.toFixed(2) };
          const pin = document.getElementById('luEditPinLand');
          if (pin) { pin.style.top = `${y}%`; pin.style.left = `${x}%`; pin.classList.remove('hidden'); }
          document.getElementById('luEditLandPos').value = JSON.stringify(this._editLand);
        }
        const svg = document.getElementById('luEditSvg');
        if (svg && this._editLaunch && this._editLand) {
          svg.innerHTML = `
            <line x1="${this._editLaunch.left}%" y1="${this._editLaunch.top}%"
                  x2="${this._editLand.left}%" y2="${this._editLand.top}%"
                  stroke="#ff4655" stroke-width="2" stroke-dasharray="6 3" opacity="0.8"/>
            <circle cx="${this._editLand.left}%" cy="${this._editLand.top}%" r="4" fill="#ff4655"/>`;
        }
      });

      // Draw initial line
      if (launchPos && landPos) {
        const svg = modal.querySelector('#luEditSvg');
        if (svg) svg.innerHTML = `
          <line x1="${launchPos.left}%" y1="${launchPos.top}%"
                x2="${landPos.left}%" y2="${landPos.top}%"
                stroke="#ff4655" stroke-width="2" stroke-dasharray="6 3" opacity="0.8"/>
          <circle cx="${landPos.left}%" cy="${landPos.top}%" r="4" fill="#ff4655"/>`;
      }

      // Submit
      modal.querySelector('#luEditForm').addEventListener('submit', async (e) => {
        e.preventDefault();
        await this._submitEdit(id, modal);
      });
    } catch (err) {
      if (typeof toast !== 'undefined') toast.error('Erro', err.message);
    }
  }

  setEditPinMode(mode) {
    this._editPinMode = mode;
    document.getElementById('luEditPinLaunchBtn')?.classList.toggle('active', mode === 'launch');
    document.getElementById('luEditPinLandBtn')?.classList.toggle('active', mode === 'land');
  }

  clearEditPins() {
    this._editLaunch = null;
    this._editLand = null;
    this._editPinMode = 'launch';
    document.getElementById('luEditPinLaunch')?.classList.add('hidden');
    document.getElementById('luEditPinLand')?.classList.add('hidden');
    const svg = document.getElementById('luEditSvg'); if (svg) svg.innerHTML = '';
    const lp = document.getElementById('luEditLaunchPos'); if (lp) lp.value = '';
    const ld = document.getElementById('luEditLandPos'); if (ld) ld.value = '';
    this.setEditPinMode('launch');
  }

  async _submitEdit(id, modal) {
    const mediaUrl = document.getElementById('luEditMediaUrl')?.value?.trim() || null;
    const isVideo = mediaUrl && this._isVideoUrl(mediaUrl);
    const side = document.getElementById('luEditSide')?.value || 'attack';
    const launchVal = document.getElementById('luEditLaunchPos')?.value || null;
    const landVal = document.getElementById('luEditLandPos')?.value || null;

    const data = {
      map_id: document.getElementById('luEditMap').value,
      agent_id: document.getElementById('luEditAgent').value || null,
      title: document.getElementById('luEditTitle').value.trim(),
      description: document.getElementById('luEditDesc').value.trim(),
      side,
      ability_type: document.getElementById('luEditAbility').value || null,
      launch_position: launchVal ? JSON.parse(launchVal) : null,
      landing_position: landVal ? JSON.parse(landVal) : null,
      video_url: isVideo ? mediaUrl : null,
      images: !isVideo && mediaUrl ? [mediaUrl] : [],
      status: 'learning'
    };

    const btn = modal.querySelector('button[type="submit"]');
    btn.disabled = true;
    btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Salvando...';

    try {
      const result = this.adminMode
        ? await api.updateAdminLineup(id, data)
        : await api.updateLineup(id, data);
      if (result.success) {
        modal.remove();
        document.querySelector('.app-modal-overlay')?.remove();
        if (typeof toast !== 'undefined') toast.success('Lineup atualizado!');
        this.closePlayer();
        this.loadLineups();
      } else {
        if (typeof toast !== 'undefined') toast.error('Erro', result.message || 'Falha ao salvar');
        btn.disabled = false;
        btn.innerHTML = '<i class="fas fa-save"></i> Salvar';
      }
    } catch (err) {
      if (typeof toast !== 'undefined') toast.error('Erro', err.message);
      btn.disabled = false;
      btn.innerHTML = '<i class="fas fa-save"></i> Salvar';
    }
  }

  // ── Delete ────────────────────────────────────
  async deleteLineup(id) {
    const overlay = document.createElement('div');
    overlay.className = 'lu-confirm-overlay';
    overlay.innerHTML = `
      <div class="lu-confirm-dialog">
        <div class="lu-confirm-icon"><i class="fas fa-exclamation-triangle"></i></div>
        <h3>Excluir Lineup?</h3>
        <p>Esta ação não pode ser desfeita.</p>
        <div class="lu-confirm-actions">
          <button class="btn btn-secondary" id="luCancelDel">Cancelar</button>
          <button class="btn btn-danger" id="luConfirmDel"><i class="fas fa-trash"></i> Excluir</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);

    return new Promise(resolve => {
      overlay.querySelector('#luCancelDel').onclick = () => { overlay.remove(); resolve(false); };
      overlay.querySelector('#luConfirmDel').onclick = async () => {
        const btn = overlay.querySelector('#luConfirmDel');
        btn.disabled = true;
        btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
        try {
          const result = this.adminMode
            ? await api.deleteAdminLineup(id)
            : await api.deleteLineup(id);
          if (result.success) {
            overlay.remove();
            document.querySelector('.app-modal-overlay')?.remove();
            if (typeof toast !== 'undefined') toast.success('Lineup excluído!');
            this.closePlayer();
            this.loadLineups();
          }
        } catch (err) {
          if (typeof toast !== 'undefined') toast.error('Erro', err.message);
          btn.disabled = false;
          btn.innerHTML = '<i class="fas fa-trash"></i> Excluir';
        }
        resolve(true);
      };
      overlay.onclick = (e) => { if (e.target === overlay) { overlay.remove(); resolve(false); } };
    });
  }

  // ── Global Events ─────────────────────────────
  setupEvents() {
    // Remove previous document-level handlers to prevent duplicates
    if (this._docKeyDown) document.removeEventListener('keydown', this._docKeyDown);
    if (this._agenteArrastoMove) document.removeEventListener('pointermove', this._agenteArrastoMove);
    if (this._agenteArrastoFim) {
      document.removeEventListener('pointerup', this._agenteArrastoFim);
      document.removeEventListener('pointercancel', this._agenteArrastoFim);
    }
    if (this._roleFilterClickHandler && this._roleFilterGridEl) {
      this._roleFilterGridEl.removeEventListener('click', this._roleFilterClickHandler);
    }
    if (this._luPanelScrollHandler && this._luPanelEl) {
      this._luPanelEl.removeEventListener('scroll', this._luPanelScrollHandler);
    }

    const minimap = document.getElementById('luMinimap');
    const wrapper = document.getElementById('luMinimapWrapper');
    const panel = document.getElementById('luPanel');

    minimap?.addEventListener('click', (e) => {
      // Clique sintetizado no fim de um arrasto: o ponto ja foi marcado.
      if (this._ignorarProximoClique) { this._ignorarProximoClique = false; return; }
      // If in create mode, handle pin placement
      if (this._createMode) {
        // Don't place pins if clicking on toolbar or save form
        if (e.target.closest('.lu-create-toolbar, .lu-save-form, .lu-ability-picker, .lu-save-panel')) return;

        // If clicking on an existing agent marker during launch step → start variation
        const existingAgentMk = e.target.closest('.lu-agent-marker:not(.lu-create-pin)');
        if (existingAgentMk && this._createStep === 'launch') {
          const gIdx = parseInt(existingAgentMk.dataset.group);
          const group = (this._launchGroups || [])[gIdx];
          if (group && group.launch) {
            // Reuse existing launch position for variation
            this._createData.launch = { top: group.launch.top.toFixed(2), left: group.launch.left.toFixed(2) };
            this._createStep = 'land';
            this._updateCreatePreview();
            this._showCreateHint('Agora clique onde a habilidade vai aterrissar (variação)', 'fa-bullseye');
            return;
          }
        }

        // Don't place pins if clicking on existing non-preview land markers (except during 'land' step — allow same position)
        const existingLandMk = e.target.closest('.lu-land-marker:not(.lu-create-pin)');
        if (existingLandMk && this._createStep !== 'land') return;

        this._onMinimapCreateClick(e);
        return;
      }
      // Normal mode: deselect on background click
      if (e.target === minimap || e.target.classList.contains('lu-minimap-img') || e.target.tagName === 'svg') {
        this.closePlayer();
      }
    });

    wrapper?.addEventListener('wheel', (e) => {
      e.preventDefault();
    }, { passive: false });

    wrapper?.addEventListener('auxclick', (e) => { if (e.button === 1) e.preventDefault(); });

    // ── Criar arrastando: aperta na origem, solta no destino ──────────
    //
    // O fluxo era dois cliques soltos (um marca de onde sai, outro onde cai) e
    // nada ligava um ao outro enquanto se escolhia — a linha so aparecia
    // depois do segundo clique. Arrastando, a linha acompanha o cursor.
    //
    // O clique-clique continua valendo: soltar sem sair do lugar (menos de
    // ARRASTO_MINIMO px) cai no mesmo caminho de antes, que e o que funciona
    // no toque e quando se quer mirar com calma.
    const ARRASTO_MINIMO = 6;

    minimap?.addEventListener('pointerdown', (e) => {
      if (!this._createMode || e.button !== 0) return;
      // 'launch': o arrasto marca origem e destino de uma vez.
      // 'land': a origem ja veio (agente largado no mapa ou primeiro clique),
      //         entao o arrasto so acerta onde a habilidade cai.
      if (this._createStep !== 'launch' && this._createStep !== 'land') return;
      if (e.target.closest('.lu-create-toolbar, .lu-save-form, .lu-ability-picker, .lu-save-panel')) return;
      // Clicar num agente ja existente inicia variacao — caminho do handler de click.
      if (e.target.closest('.lu-agent-marker:not(.lu-create-pin)')) return;

      const ponto = this._pontoDoMinimap(e);
      if (!ponto) return;

      this._arrasto = { x0: e.clientX, y0: e.clientY, moveu: false, ponto, passo: this._createStep };
      minimap.setPointerCapture?.(e.pointerId);
    });

    minimap?.addEventListener('pointermove', (e) => {
      const a = this._arrasto;
      if (!a) return;
      if (!a.moveu && Math.hypot(e.clientX - a.x0, e.clientY - a.y0) < ARRASTO_MINIMO) return;

      // Passou do limiar: vira arrasto de verdade. Só no passo 'launch' o ponto
      // de onde se apertou vira a origem — no 'land' ela já existe.
      if (!a.moveu) {
        a.moveu = true;
        if (a.passo === 'launch') {
          this._createData.launch = { top: a.ponto.top.toFixed(2), left: a.ponto.left.toFixed(2) };
        }
        document.getElementById('luCreateHint')?.remove();
      }
      const p = this._pontoDoMinimap(e);
      if (!p) return;
      a.ultimo = p;
      this._createData.land = { top: p.top.toFixed(2), left: p.left.toFixed(2) };
      this._updateCreatePreview();
    });

    // `cancelado`: o pointercancel chega com clientX/clientY zerados, e converter
    // isso dava o canto do mapa (0/100 depois do clamp) em vez do ponto onde o
    // cursor estava. Nesse caminho vale a ultima posicao vista no movimento.
    const encerrarArrasto = (e, cancelado = false) => {
      const a = this._arrasto;
      if (!a) return;
      this._arrasto = null;
      if (e?.pointerId != null) minimap?.releasePointerCapture?.(e.pointerId);
      if (!a.moveu) return;               // foi clique: deixa o handler de click agir

      const p = (cancelado ? null : (e && this._pontoDoMinimap(e))) || a.ultimo || a.ponto;
      this._createData.land = { top: p.top.toFixed(2), left: p.left.toFixed(2) };
      this._createStep = 'pick_ability';
      this._updateCreatePreview();
      // O 'click' vem logo depois do 'pointerup' e marcaria um ponto a mais.
      this._ignorarProximoClique = true;
      this._showAbilityPicker(p.left, p.top);
    };
    minimap?.addEventListener('pointerup', encerrarArrasto);
    // `pointercancel` nao e excecao aqui: o preview remove e recria os pinos a
    // cada quadro, e quando o pino que recebeu o pointerdown sai do DOM o
    // navegador cancela o ponteiro no meio do arrasto. Descartar nesse ponto
    // jogaria fora um trajeto ja desenhado — entao termina com a ultima
    // posicao vista, que e onde o cursor estava.
    minimap?.addEventListener('pointercancel', (e) => encerrarArrasto(e, true));

    this._configurarArrastoDeAgente();

    wrapper?.addEventListener('dblclick', (e) => {
      e.preventDefault();
    });

    // ESC key to exit create mode
    this._docKeyDown = (e) => {
      if (e.key !== 'Escape') return;
      // Arrasto em andamento tem prioridade: cancela so ele, sem sair do modo.
      if (this._cancelarArrastoDeAgente?.()) return;
      if (this._arrasto) {
        this._arrasto = null;
        this._createData.land = null;
        if (this._createStep === 'launch') this._createData.launch = null;
        this._updateCreatePreview();
        return;
      }
      if (this._createMode) this.exitCreateMode();
    };
    document.addEventListener('keydown', this._docKeyDown);

    const roleFilterGrid = document.getElementById('luRoleFilterGrid');
    this._roleFilterGridEl = roleFilterGrid || null;
    if (roleFilterGrid) {
      this._roleFilterClickHandler = (e) => {
        const btn = e.target.closest('.lu-role-filter-btn');
        if (!btn?.dataset.roleKey) return;
        this.setAgentRoleFilter(btn.dataset.roleKey);
      };
      roleFilterGrid.addEventListener('click', this._roleFilterClickHandler);
    }

    this._setupAgentHoverAbilitiesEvents();

    this._luPanelEl = panel;
    this._luPanelScrollHandler = () => {
      this._hideAgentAbilitiesPopup();
    };
    panel?.addEventListener('scroll', this._luPanelScrollHandler, { passive: true });
  }

  // ══════════════════════════════════════════════
  // STYLES
  // ══════════════════════════════════════════════
  addStyles() {
    if (document.getElementById('lu-v30-css')) return;

    // O CSS mora em css/pages/lineups.css. Ficava aqui dentro como template
    // string, o que somava peso ao bundle de JS e impedia o navegador de
    // cachear ou o build de minificar a folha de estilo separadamente.
    // Continua carregando sob demanda, como antes.
    Utils.loadPageCss('map-picker-css', 'map-picker.css');
    Utils.loadPageCss('lu-v30-css', 'lineups.css');
  }
}

// Initialize
const lineups = new Lineups();
// Expose on window so admin panel (which loads this script dynamically)
// shares the same singleton — inline `onclick="lineups.xxx"` handlers
// generated by render() must hit the instance we just configured.
if (typeof window !== 'undefined') window.lineups = lineups;


/* ===== js/tactics/tactics-store.js ===== */
// =====================================================
// ZDVAL - Tactics Store
// State + data loading + tree model for /tactics
//
// Hierarchy rendered by the sidebar:
//   Map > Composition (max 5 per map) > Side > Folder? > Tactic
// A folder row only appears when a composition/side holds more than one
// folder, so the common single-folder case reads as Side > Tactic.
// =====================================================

class TacticsStore {
  static MAX_COMPS_PER_MAP = 5;
  static SIDES = [
    { id: 'attack', label: 'Ataque' },
    { id: 'defense', label: 'Defesa' }
  ];

  constructor() {
    this.reset();
  }

  reset() {
    this.teamId = undefined;
    this.folders = [];
    this.tactics = [];
    this.loading = false;
    this.error = null;

    // Tree expansion state, keyed by node id. Persisted per team.
    this.expanded = new Set();

    // Favorite/current composition per map, keyed by comp node id. Persisted per team.
    this.favoriteComps = new Set();

    // Currently open tactic (main content) and its ancestry.
    this.selectedTacticId = null;
    this.selectedMapId = null;
    this.selectedCompKey = null;
    this.selectedSide = null;

    this.search = '';
  }

  // ---------------------------------------------------
  // Loading
  // ---------------------------------------------------

  /**
   * teamId real -> modo time. teamId === null -> modo pessoal explícito
   * (sem time, escopado por usuário). Só undefined (nunca chamado) deixa
   * o estado como está — não existe mais "sem time = página vazia".
   */
  async load(teamId) {
    const modeChanged = this.teamId !== teamId;
    this.teamId = teamId;
    this.loading = true;
    this.error = null;

    if (modeChanged) {
      this.expanded = this.readExpanded(this.storageScope());
      this.favoriteComps = this.readFavoriteComps(this.storageScope());
      this.selectedTacticId = null;
    }

    try {
      const [foldersRes, tacticsRes] = teamId
        ? await Promise.all([api.getTacticFolders(teamId), api.getTactics(teamId)])
        : await Promise.all([api.getPersonalTacticFolders(), api.getPersonalTactics()]);

      this.folders = foldersRes?.data?.folders || [];
      this.tactics = tacticsRes?.data?.tactics || [];
    } catch (err) {
      console.error('[tactics] load failed', err);
      this.error = 'Não foi possível carregar as táticas.';
      this.folders = [];
      this.tactics = [];
    } finally {
      this.loading = false;
    }
  }

  // ---------------------------------------------------
  // Expansion state (persisted so the tree survives reloads)
  // ---------------------------------------------------

  /** Sentinel fixo pro modo pessoal — teamId real usa o próprio id. */
  storageScope() {
    return this.teamId || 'personal';
  }

  storageKey(scope = this.storageScope()) {
    return `zdval:tactics:expanded:${scope}`;
  }

  readExpanded(scope) {
    try {
      const raw = localStorage.getItem(this.storageKey(scope));
      return new Set(raw ? JSON.parse(raw) : []);
    } catch {
      return new Set();
    }
  }

  persistExpanded() {
    if (this.teamId === undefined) return;
    try {
      localStorage.setItem(this.storageKey(), JSON.stringify([...this.expanded]));
    } catch {
      /* quota or private mode — expansion is not worth failing over */
    }
  }

  isExpanded(nodeId) {
    return this.expanded.has(nodeId);
  }

  // ---------------------------------------------------
  // Favorite composition per map (persisted so it survives reloads)
  // ---------------------------------------------------

  favoriteStorageKey(scope = this.storageScope()) {
    return `zdval:tactics:favorites:${scope}`;
  }

  readFavoriteComps(scope) {
    try {
      const raw = localStorage.getItem(this.favoriteStorageKey(scope));
      return new Set(raw ? JSON.parse(raw) : []);
    } catch {
      return new Set();
    }
  }

  persistFavoriteComps() {
    if (this.teamId === undefined) return;
    try {
      localStorage.setItem(this.favoriteStorageKey(), JSON.stringify([...this.favoriteComps]));
    } catch {
      /* quota or private mode — favorite marker is not worth failing over */
    }
  }

  isFavoriteComp(compNodeId) {
    return this.favoriteComps.has(compNodeId);
  }

  /** Only one favorite per map — starring a comp unstars its siblings. */
  toggleFavoriteComp(compNodeId, mapId) {
    const isFav = this.favoriteComps.has(compNodeId);
    for (const id of [...this.favoriteComps]) {
      if (id.startsWith(`comp:${mapId}:`)) this.favoriteComps.delete(id);
    }
    if (!isFav) this.favoriteComps.add(compNodeId);
    this.persistFavoriteComps();
  }

  toggleExpanded(nodeId) {
    if (this.expanded.has(nodeId)) this.expanded.delete(nodeId);
    else this.expanded.add(nodeId);
    this.persistExpanded();
  }

  expand(nodeId) {
    if (!this.expanded.has(nodeId)) {
      this.expanded.add(nodeId);
      this.persistExpanded();
    }
  }

  /** Open every ancestor of a tactic so it becomes visible in the tree. */
  revealTactic(tacticId) {
    const path = this.findTacticPath(tacticId);
    if (!path) return;
    this.expand(TacticsStore.mapNodeId(path.mapId));
    this.expand(TacticsStore.compNodeId(path.mapId, path.compKey));
    this.expand(TacticsStore.sideNodeId(path.mapId, path.compKey, path.side));
    if (path.folderId) {
      this.expand(TacticsStore.folderNodeId(path.folderId));
    }
  }

  // ---------------------------------------------------
  // Node ids — stable strings used as DOM ids and expansion keys
  // ---------------------------------------------------

  static mapNodeId(mapId) { return `map:${mapId}`; }
  static compNodeId(mapId, compKey) { return `comp:${mapId}:${compKey}`; }
  static sideNodeId(mapId, compKey, side) { return `side:${mapId}:${compKey}:${side}`; }
  static folderNodeId(folderId) { return `folder:${folderId}`; }

  // ---------------------------------------------------
  // Composition helpers
  // ---------------------------------------------------

  /** Stable key for a composition, independent of agent order. */
  static compKey(composition) {
    if (!Array.isArray(composition) || composition.length === 0) return 'no-comp';
    return composition
      .map(a => String(a?.id ?? a?.name ?? a))
      .sort()
      .join('|');
  }

  /** Human label: "Jett • Yoru • Breach • Chamber • Cypher" */
  static compLabel(composition) {
    if (!Array.isArray(composition) || composition.length === 0) return 'Sem composição';
    return composition.map(a => a?.name || a?.displayName || '?').join(' • ');
  }

  // ---------------------------------------------------
  // Agents
  //
  // Two shapes reach the frontend and they do not agree:
  //   /lineups/data/agents (banco)  -> snake_case: display_name, icon_url
  //   /valorant/agents (valorant-api) -> camelCase: displayName, displayIcon
  // Everything downstream reads the normalised shape below.
  // ---------------------------------------------------

  static ROLES = [
    { key: 'duelist',    label: 'Duelistas' },
    { key: 'initiator',  label: 'Iniciadores' },
    { key: 'controller', label: 'Controladores' },
    { key: 'sentinel',   label: 'Sentinelas' }
  ];

  static ROLE_ALIASES = {
    duelist: 'duelist',       duelista: 'duelist',
    initiator: 'initiator',   iniciador: 'initiator',
    controller: 'controller', controlador: 'controller',
    sentinel: 'sentinel',     sentinela: 'sentinel'
  };

  static roleKey(raw) {
    const value = String(raw?.displayName || raw || '').trim().toLowerCase();
    return TacticsStore.ROLE_ALIASES[value] || value || 'other';
  }

  static normalizeAgent(raw) {
    if (!raw) return null;
    const name = raw.display_name || raw.displayName || raw.name || '?';
    return {
      id: raw.id,
      slug: raw.name || raw.developerName || '',
      name,
      icon: raw.custom_icon_url || raw.icon_url || raw.display_icon || raw.displayIcon || raw.icon || TacticsStore.agentIconFor(name),
      role: TacticsStore.roleKey(raw.role),
      abilities: (raw.custom_abilities?.length ? raw.custom_abilities : raw.abilities) || [],
      gradient: TacticsStore.agentGradientFor(name)
    };
  }

  // ---------------------------------------------------
  // Agent background gradients — same visual language as /lineups.
  // The DB-backed agent list has no gradient data, so it's fetched once
  // from valorant-api (mirrors lineups.js _loadAgentGradients) and cached
  // on the class so every store instance shares one lookup.
  // ---------------------------------------------------

  static _gradientKey(name) {
    return String(name || '').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }

  static agentGradientFor(name) {
    const key = TacticsStore._gradientKey(name);
    return (TacticsStore._agentGradients && TacticsStore._agentGradients[key])
      || { g0: '#1a1a2e', g1: '#0f1923', g2: '#1a1a2e' };
  }

  /**
   * Habilidades reais (nome em PT-BR + ícone) pro agente — o /lineups/data/
   * agents (banco) só tem {key, name em inglês, type, description}, sem
   * displayIcon nenhum. O valorant-api (/valorant/agents, mesma chamada
   * que já traz os gradientes) tem tudo isso pronto — cacheado junto.
   */
  static agentAbilitiesFor(name) {
    const key = TacticsStore._gradientKey(name);
    return (TacticsStore._agentAbilities && TacticsStore._agentAbilities[key]) || [];
  }

  /** Ícone oficial do agente (valorant-api) — fallback pra quando icon_url do banco vier vazio. */
  static agentIconFor(name) {
    const key = TacticsStore._gradientKey(name);
    return (TacticsStore._agentIcons && TacticsStore._agentIcons[key]) || '';
  }

  static async loadAgentGradients() {
    if (TacticsStore._agentGradients) return;
    try {
      const data = await api.getValorantAgents();
      if (data.status === 200 && data.data) {
        const gradients = {};
        const abilities = {};
        const icons = {};
        data.data.filter(a => a.isPlayableCharacter).forEach(a => {
          const key = TacticsStore._gradientKey(a.displayName);
          const gc = a.backgroundGradientColors || [];
          gradients[key] = {
            g0: gc[0] ? '#' + gc[0].slice(0, 6) : '#1a1a2e',
            g1: gc[1] ? '#' + gc[1].slice(0, 6) : '#0f1923',
            g2: gc[2] ? '#' + gc[2].slice(0, 6) : '#1a1a2e'
          };
          icons[key] = a.displayIcon || a.displayIconSmall || '';
          const order = { Grenade: 0, Ability1: 1, Ability2: 2, Grenade_Alt: 3, Ultimate: 4 };
          abilities[key] = (a.abilities || [])
            .filter(ab => ab && ab.displayIcon && ab.slot !== 'Passive')
            .sort((x, y) => (order[x.slot] ?? 9) - (order[y.slot] ?? 9))
            .map(ab => ({ key: ab.slot, displayName: ab.displayName, displayIcon: ab.displayIcon }));
        });
        TacticsStore._agentGradients = gradients;
        TacticsStore._agentAbilities = abilities;
        TacticsStore._agentIcons = icons;
      }
    } catch {
      TacticsStore._agentGradients = {};
      TacticsStore._agentAbilities = {};
      TacticsStore._agentIcons = {};
    }
  }

  /** All agents, normalised and grouped by role in canonical order. */
  static agentsByRole() {
    const raw = (typeof app !== 'undefined' && app.getAgents) ? (app.getAgents() || []) : [];
    const agents = raw.map(TacticsStore.normalizeAgent).filter(Boolean);

    const groups = TacticsStore.ROLES.map(role => ({
      ...role,
      agents: agents
        .filter(a => a.role === role.key)
        .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'))
    }));

    // Agentes sem função reconhecida não podem sumir da grade.
    const known = new Set(TacticsStore.ROLES.map(r => r.key));
    const rest = agents.filter(a => !known.has(a.role));
    if (rest.length) groups.push({ key: 'other', label: 'Outros', agents: rest });

    return groups.filter(g => g.agents.length);
  }

  /**
   * Habilidades do agente com nome (PT-BR) e ícone reais, em ordem
   * C/Q/E/E2/X. O objeto `agent` (vindo de normalizeAgent) carrega
   * `agent.abilities` no formato cru do banco — sem displayIcon, nome em
   * inglês — então a fonte de verdade é sempre o cache carregado por
   * loadAgentGradients() (valorant-api), buscado aqui pelo nome.
   */
  static agentAbilities(agent) {
    return TacticsStore.agentAbilitiesFor(agent?.name);
  }

  /**
   * Folder.composition arrives as JSON from Postgres — normalise to an array.
   *
   * O que foi gravado carrega só {id, name, icon}, e o `icon` pode ter vindo
   * vazio (comp criada antes do cache do valorant-api chegar, ou agente sem
   * icon_url no banco). Passar por normalizeAgent devolve o ícone pelo nome,
   * senão a árvore cai no texto do agente no lugar da imagem.
   */
  static parseComposition(raw) {
    const list = Array.isArray(raw)
      ? raw
      : (typeof raw === 'string' ? TacticsStore._parseJsonArray(raw) : []);
    return list.map(TacticsStore.normalizeAgent).filter(Boolean);
  }

  static _parseJsonArray(raw) {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  // ---------------------------------------------------
  // Tree model
  // ---------------------------------------------------

  /**
   * Build the full tree from folders + tactics.
   * Every map is listed, even with no content, so the sidebar is a stable
   * index of the map pool rather than a list that jumps around.
   */
  buildTree() {
    const maps = (typeof app !== 'undefined' && app.getMaps) ? (app.getMaps() || []) : [];
    const tacticsByFolder = new Map();

    for (const tactic of this.tactics) {
      const key = String(tactic.folder_id ?? 'orphan');
      if (!tacticsByFolder.has(key)) tacticsByFolder.set(key, []);
      tacticsByFolder.get(key).push(tactic);
    }

    const foldersByMap = new Map();
    for (const folder of this.folders) {
      const key = String(folder.map_id);
      if (!foldersByMap.has(key)) foldersByMap.set(key, []);
      foldersByMap.get(key).push(folder);
    }

    return maps.map(map => this.buildMapNode(map, foldersByMap.get(String(map.id)) || [], tacticsByFolder));
  }

  buildMapNode(map, mapFolders, tacticsByFolder) {
    const compGroups = new Map();

    for (const folder of mapFolders) {
      const composition = TacticsStore.parseComposition(folder.composition);
      const key = TacticsStore.compKey(composition);

      if (!compGroups.has(key)) {
        compGroups.set(key, {
          key,
          composition,
          label: TacticsStore.compLabel(composition),
          folders: [],
          createdAt: 0
        });
      }

      const group = compGroups.get(key);
      group.folders.push(folder);
      const created = new Date(folder.created_at || 0).getTime();
      if (created > group.createdAt) group.createdAt = created;

      // A group built from an empty composition still needs a label.
      if (group.composition.length === 0 && composition.length > 0) {
        group.composition = composition;
        group.label = TacticsStore.compLabel(composition);
      }
    }

    // Oldest first: composition slots read as a stable numbered roster
    // (slot 1 stays slot 1 when a new comp is added).
    const groups = [...compGroups.values()].sort((a, b) => a.createdAt - b.createdAt);

    const comps = groups.map(group => this.buildCompNode(map, group, tacticsByFolder));

    return {
      type: 'map',
      id: TacticsStore.mapNodeId(map.id),
      mapId: map.id,
      name: map.display_name || map.name,
      slug: map.name,
      splash: map.splash || map.listViewIcon || '',
      comps,
      compCount: comps.length,
      tacticCount: comps.reduce((sum, c) => sum + c.tacticCount, 0),
      canAddComp: comps.length < TacticsStore.MAX_COMPS_PER_MAP
    };
  }

  buildCompNode(map, group, tacticsByFolder) {
    const sides = TacticsStore.SIDES.map(side => {
      const sideFolders = group.folders
        .filter(f => (f.side || 'attack') === side.id)
        .map(folder => ({
          type: 'folder',
          id: TacticsStore.folderNodeId(folder.id),
          folderId: folder.id,
          name: folder.name || 'Sem nome',
          tactics: (tacticsByFolder.get(String(folder.id)) || [])
            .slice()
            .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
        }))
        .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));

      const tacticCount = sideFolders.reduce((sum, f) => sum + f.tactics.length, 0);

      return {
        type: 'side',
        id: TacticsStore.sideNodeId(map.id, group.key, side.id),
        side: side.id,
        label: side.label,
        mapId: map.id,
        compKey: group.key,
        folders: sideFolders,
        // Collapse the folder level away when it carries no information.
        flat: sideFolders.length <= 1,
        tacticCount
      };
    });

    return {
      type: 'comp',
      id: TacticsStore.compNodeId(map.id, group.key),
      key: group.key,
      mapId: map.id,
      composition: group.composition,
      label: group.label,
      agents: group.composition,
      folders: group.folders,
      sides,
      tacticCount: sides.reduce((sum, s) => sum + s.tacticCount, 0)
    };
  }

  // ---------------------------------------------------
  // Filtering
  // ---------------------------------------------------

  /**
   * Filter a tree by free text, keeping any branch that leads to a match.
   * Matching a map or composition keeps its whole subtree.
   */
  filterTree(tree, query) {
    const q = (query || '').trim().toLowerCase();
    if (!q) return tree;

    const matches = (text) => String(text || '').toLowerCase().includes(q);

    return tree
      .map(mapNode => {
        if (matches(mapNode.name)) return mapNode;

        const comps = mapNode.comps
          .map(comp => {
            if (matches(comp.label)) return comp;

            const sides = comp.sides
              .map(side => {
                const folders = side.folders
                  .map(folder => {
                    if (matches(folder.name)) return folder;
                    const tactics = folder.tactics.filter(t => matches(t.title));
                    return tactics.length ? { ...folder, tactics } : null;
                  })
                  .filter(Boolean);

                if (!folders.length) return null;
                return {
                  ...side,
                  folders,
                  flat: folders.length <= 1,
                  tacticCount: folders.reduce((sum, f) => sum + f.tactics.length, 0)
                };
              })
              .filter(Boolean);

            if (!sides.length) return null;
            return { ...comp, sides, tacticCount: sides.reduce((s, x) => s + x.tacticCount, 0) };
          })
          .filter(Boolean);

        if (!comps.length) return null;
        return { ...mapNode, comps, tacticCount: comps.reduce((s, c) => s + c.tacticCount, 0) };
      })
      .filter(Boolean);
  }

  // ---------------------------------------------------
  // Lookups
  // ---------------------------------------------------

  getTactic(tacticId) {
    return this.tactics.find(t => String(t.id) === String(tacticId)) || null;
  }

  getFolder(folderId) {
    return this.folders.find(f => String(f.id) === String(folderId)) || null;
  }

  /** Resolve the full ancestry of a tactic: map, composition, side, folder. */
  findTacticPath(tacticId) {
    const tactic = this.getTactic(tacticId);
    if (!tactic) return null;

    const folder = this.getFolder(tactic.folder_id);
    const composition = folder ? TacticsStore.parseComposition(folder.composition) : [];

    return {
      tactic,
      folder,
      folderId: folder?.id ?? null,
      mapId: folder?.map_id ?? tactic.map_id,
      compKey: TacticsStore.compKey(composition),
      compLabel: TacticsStore.compLabel(composition),
      side: folder?.side || tactic.side || 'attack'
    };
  }

  /** Folders belonging to one composition slot on one map. */
  foldersFor(mapId, compKey, side = null) {
    return this.folders.filter(f => {
      if (String(f.map_id) !== String(mapId)) return false;
      if (TacticsStore.compKey(TacticsStore.parseComposition(f.composition)) !== compKey) return false;
      if (side && (f.side || 'attack') !== side) return false;
      return true;
    });
  }

  /** Distinct composition keys already used on a map — enforces the 5 limit. */
  compKeysForMap(mapId) {
    const keys = new Set();
    for (const folder of this.folders) {
      if (String(folder.map_id) !== String(mapId)) continue;
      keys.add(TacticsStore.compKey(TacticsStore.parseComposition(folder.composition)));
    }
    return [...keys];
  }

  canAddCompToMap(mapId) {
    return this.compKeysForMap(mapId).length < TacticsStore.MAX_COMPS_PER_MAP;
  }
}


/* ===== js/tactics/tactics-tree.js ===== */
// =====================================================
// ZDVAL - Tactics Tree
// 280px sidebar: maps > compositions > sides > tactics.
//
// Rendering is pure (state in -> HTML out) and all interaction goes through
// one delegated listener reading data-tc-action, so re-rendering never leaves
// stale handlers behind.
// =====================================================

class TacticsTree {
  constructor(store, controller) {
    this.store = store;
    this.controller = controller;
    this.root = null;
    // Pasta com o campo inline de nova tática aberto (null = nenhum).
    this.draftFolderId = null;
    // Nó com o campo inline de renomear aberto: { kind:'folder'|'tactic', id }.
    this.renaming = null;
    // Modo sanfona: abrir um nó fecha os irmãos. Ligado só onde faz sentido
    // (modal "Enviar para Táticas" do /zdpro); em /tactics fica desligado.
    this.accordion = false;
  }

  // ---------------------------------------------------
  // Sanfona (accordion)
  // ---------------------------------------------------

  /** Ao abrir `nodeId`, fecha os nós irmãos e tudo que estava aberto dentro. */
  collapseSiblings(nodeId) {
    const found = this._findWithSiblings(this.store.buildTree(), nodeId);
    if (!found) return;
    for (const sib of found.siblings) {
      if (String(sib.id) !== String(nodeId)) this._collapseSubtree(sib);
    }
    this.store.persistExpanded();
  }

  _findWithSiblings(list, id) {
    for (const n of list) {
      if (String(n.id) === String(id)) return { node: n, siblings: list };
      const kids = n.comps || n.sides || n.folders;
      if (kids && kids.length) {
        const r = this._findWithSiblings(kids, id);
        if (r) return r;
      }
    }
    return null;
  }

  _collapseSubtree(node) {
    this.store.expanded.delete(node.id);
    (node.comps || node.sides || node.folders || []).forEach(k => this._collapseSubtree(k));
  }

  // ---------------------------------------------------
  // Mount
  // ---------------------------------------------------

  mount(root) {
    this.root = root;
    // renderShell() rebuilds #tcSidebarTree from scratch on every page
    // load/section switch, so `root` is a fresh node each time — always
    // bind to it (the old node and its listeners are discarded).
    this.root.addEventListener('click', (e) => this.onClick(e));
    this.root.addEventListener('dblclick', (e) => this.onDblClick(e));
    this.root.addEventListener('input', (e) => this.onInput(e));
    this.root.addEventListener('keydown', (e) => this.onKeydown(e));
    this.root.addEventListener('focusout', (e) => {
      // relatedTarget nulo = clicou fora da árvore; em ambos os casos o
      // rascunho não sobrevive ao foco perdido.
      if (e.target.matches?.('[data-tc-draft]')) {
        setTimeout(() => {
          if (this.root?.contains(document.activeElement)) return;
          this.cancelDraft();
        }, 0);
        return;
      }
      // Renomear salva no blur (se mudou) em vez de descartar.
      if (e.target.matches?.('[data-tc-rename]')) {
        const input = e.target;
        setTimeout(() => {
          if (this.root?.contains(document.activeElement)) return;
          if (this.renaming) this.submitRename(input);
        }, 0);
      }
    });
    this.render();
  }

  render() {
    if (!this.root) return;
    const tree = this.store.filterTree(this.store.buildTree(), this.store.search);
    this.root.innerHTML = this.template(tree);
  }

  // ---------------------------------------------------
  // Template
  // ---------------------------------------------------

  template(tree) {
    return `
      <header class="tc-side-head">
        <div class="tc-side-brand">
          <span class="tc-side-brand-mark" aria-hidden="true"></span>
          <h1 class="tc-side-title">Táticas</h1>
        </div>
        <button class="tc-icon-btn" data-tc-action="collapse-all" title="Recolher tudo" aria-label="Recolher tudo">
          <i class="fas fa-chevron-up"></i>
        </button>
      </header>

      <div class="tc-side-search">
        <i class="fas fa-search" aria-hidden="true"></i>
        <input
          type="search"
          class="tc-side-search-input"
          placeholder="Buscar mapa, comp ou tática"
          value="${this.escape(this.store.search)}"
          data-tc-action="search"
          aria-label="Buscar táticas">
      </div>

      <nav class="tc-tree" role="tree" aria-label="Mapas e táticas">
        ${tree.length ? tree.map(node => this.mapNode(node)).join('') : this.emptySearch()}
      </nav>
    `;
  }

  emptySearch() {
    return `
      <div class="tc-tree-empty">
        <i class="fas fa-inbox" aria-hidden="true"></i>
        <p>Nada encontrado para “${this.escape(this.store.search)}”.</p>
      </div>
    `;
  }

  mapNode(node) {
    const open = this.store.isExpanded(node.id);
    return `
      <section class="tc-map ${open ? 'is-open' : ''}" data-node-id="${node.id}">
        <div class="tc-row tc-row--map" role="treeitem" aria-expanded="${open}" tabindex="0"
             data-tc-action="toggle" data-node-id="${node.id}">
          <i class="fas fa-chevron-right tc-caret" aria-hidden="true"></i>
          <span class="tc-map-name">${this.escape(node.name)}</span>
          ${node.tacticCount ? `<span class="tc-count">${node.tacticCount}</span>` : ''}
          <button class="tc-row-action" title="Nova composição em ${this.escape(node.name)}"
                  aria-label="Nova composição em ${this.escape(node.name)}"
                  data-tc-action="new-comp" data-map-id="${node.mapId}"
                  ${node.canAddComp ? '' : 'disabled'}>
            <i class="fas fa-plus"></i>
          </button>
        </div>

        ${open ? `
          <div class="tc-map-body">
            ${node.comps.length
              ? node.comps.map((comp, i) => this.compNode(comp, i)).join('')
              : this.emptyMap(node)}
            ${node.comps.length && !node.canAddComp
              ? `<p class="tc-limit-note">Limite de ${TacticsStore.MAX_COMPS_PER_MAP} composições atingido.</p>`
              : ''}
          </div>
        ` : ''}
      </section>
    `;
  }

  emptyMap(node) {
    return `
      <div class="tc-empty-branch">
        <p>Nenhuma composição em ${this.escape(node.name)}.</p>
        <button class="tc-ghost-btn" data-tc-action="new-comp" data-map-id="${node.mapId}">
          <i class="fas fa-plus"></i> Criar composição
        </button>
      </div>
    `;
  }

  compNode(comp, index) {
    const open = this.store.isExpanded(comp.id);
    const isFav = this.store.isFavoriteComp(comp.id);
    return `
      <div class="tc-comp ${open ? 'is-open' : ''}" data-node-id="${comp.id}">
        <div class="tc-row tc-row--comp" role="treeitem" aria-expanded="${open}" tabindex="0"
             data-tc-action="toggle" data-node-id="${comp.id}">
          <i class="fas fa-chevron-right tc-caret" aria-hidden="true"></i>
          <span class="tc-comp-slot">${index + 1}</span>
          <span class="tc-comp-label" title="${this.escape(comp.label)}">
            ${this.agentChips(comp)}
            <button class="tc-fav-btn ${isFav ? 'is-fav' : ''}"
                    title="${isFav ? 'Remover como favorita' : 'Marcar como favorita/atual'}"
                    aria-label="${isFav ? 'Remover como favorita' : 'Marcar como favorita/atual'}"
                    aria-pressed="${isFav}"
                    data-tc-action="toggle-fav-comp" data-map-id="${comp.mapId}" data-node-id="${comp.id}">
              <i class="${isFav ? 'fas' : 'far'} fa-star"></i>
            </button>
          </span>
          <button class="tc-row-action" title="Excluir composição" aria-label="Excluir composição"
                  data-tc-action="delete-comp" data-map-id="${comp.mapId}" data-comp-key="${this.escape(comp.key)}">
            <i class="fas fa-trash"></i>
          </button>
        </div>

        ${open ? `
          <div class="tc-comp-body">
            ${comp.sides.map(side => this.sideNode(side, comp)).join('')}
          </div>
        ` : ''}
      </div>
    `;
  }

  agentChips(comp) {
    if (!comp.agents?.length) return '<span class="tc-comp-empty">Sem composição</span>';
    return comp.agents
      .map(a => {
        const name = this.escape(a?.name || a?.displayName || '?');
        const icon = a?.icon || a?.displayIcon || '';
        const gc = a?.gradient || TacticsStore.agentGradientFor(a?.name || a?.displayName);
        const style = `--agent-g0:${gc.g0};--agent-g1:${gc.g1};--agent-g2:${gc.g2}`;
        return icon
          ? `<span class="tc-agent tc-agent--icon" title="${name}" style="${style}"><img src="${this.escape(icon)}" alt="${name}" loading="lazy"></span>`
          : `<span class="tc-agent" title="${name}">${name}</span>`;
      })
      .join('');
  }

  sideNode(side, comp) {
    const open = this.store.isExpanded(side.id);
    return `
      <div class="tc-side-group tc-side-group--${side.side} ${open ? 'is-open' : ''}" data-node-id="${side.id}">
        <div class="tc-row tc-row--side" role="treeitem" aria-expanded="${open}" tabindex="0"
             data-tc-action="toggle" data-node-id="${side.id}">
          <i class="fas fa-chevron-right tc-caret" aria-hidden="true"></i>
          <span class="tc-side-dot" aria-hidden="true"></span>
          <span class="tc-side-label">${side.label}</span>
          ${side.tacticCount ? `<span class="tc-count">${side.tacticCount}</span>` : ''}
          <button class="tc-row-action" title="Nova pasta em ${side.label}"
                  aria-label="Nova pasta em ${side.label}"
                  data-tc-action="new-folder"
                  data-map-id="${comp.mapId}" data-comp-key="${this.escape(comp.key)}" data-side="${side.side}">
            <i class="fas fa-plus"></i>
          </button>
        </div>

        ${open ? `
          <div class="tc-side-body">
            ${this.sideContent(side, comp)}
          </div>
        ` : ''}
      </div>
    `;
  }

  sideContent(side, comp) {
    if (!side.folders.length) {
      return `<p class="tc-empty-leaf">Nenhuma pasta aqui ainda.</p>`;
    }

    // A pasta é sempre desenhada, mesmo sozinha: é a linha que carrega o +
    // de nova tática.
    return side.folders.map(folder => this.folderNode(folder, comp, side)).join('');
  }

  folderNode(folder, comp, side) {
    const open = this.store.isExpanded(folder.id);
    return `
      <div class="tc-folder ${open ? 'is-open' : ''}" data-node-id="${folder.id}">
        <div class="tc-row tc-row--folder" role="treeitem" aria-expanded="${open}" tabindex="0"
             data-tc-action="toggle" data-node-id="${folder.id}">
          <i class="fas fa-chevron-right tc-caret" aria-hidden="true"></i>
          <i class="fas fa-folder tc-folder-icon" aria-hidden="true"></i>
          ${this.isRenaming('folder', folder.folderId)
            ? this.renameInput(folder.name)
            : `<span class="tc-folder-name">${this.escape(folder.name)}</span>`}
          ${folder.tactics.length ? `<span class="tc-count">${folder.tactics.length}</span>` : ''}
          <button class="tc-row-action" title="Nova tática em ${this.escape(folder.name)}"
                  aria-label="Nova tática em ${this.escape(folder.name)}"
                  data-tc-action="new-tactic" data-folder-id="${folder.folderId}">
            <i class="fas fa-plus"></i>
          </button>
          <button class="tc-row-action" title="Excluir pasta" aria-label="Excluir pasta"
                  data-tc-action="delete-folder" data-folder-id="${folder.folderId}">
            <i class="fas fa-trash"></i>
          </button>
        </div>
        ${open ? `
          <div class="tc-folder-body">
            ${folder.tactics.length
              ? folder.tactics.map(t => this.tacticNode(t, comp, side)).join('')
              : (this.isDrafting(folder) ? '' : `<p class="tc-empty-leaf">Pasta vazia.</p>`)}
            ${this.isDrafting(folder) ? this.draftRow() : ''}
          </div>
        ` : ''}
      </div>
    `;
  }

  /** Rascunho aberto nesta pasta? Só uma linha de rascunho existe por vez. */
  isDrafting(folder) {
    return String(this.draftFolderId ?? '') === String(folder.folderId);
  }

  draftRow() {
    return `
      <div class="tc-row tc-row--tactic tc-row--draft">
        <i class="far fa-file-alt tc-tactic-icon" aria-hidden="true"></i>
        <input type="text" class="tc-tactic-draft-input" data-tc-draft
               placeholder="Nome da tática" maxlength="120" autocomplete="off"
               aria-label="Nome da nova tática">
      </div>
    `;
  }

  /** Abre o campo inline na pasta e devolve o foco pro input. */
  startDraft(folderId) {
    this.draftFolderId = folderId;
    this.store.expand(TacticsStore.folderNodeId(folderId));
    this.render();
    this.focusDraft();
  }

  cancelDraft() {
    if (this.draftFolderId == null) return;
    this.draftFolderId = null;
    this.render();
  }

  focusDraft() {
    const input = this.root?.querySelector('[data-tc-draft]');
    if (!input) return;
    input.focus();
    input.select();
  }

  async submitDraft(input) {
    const title = input.value.trim();
    const folderId = this.draftFolderId;
    if (!title) { this.cancelDraft(); return; }

    // Trava o campo enquanto grava — Enter repetido criaria duplicatas.
    input.disabled = true;
    this.draftFolderId = null;
    const ok = await this.controller.createTacticInFolder(folderId, title);
    if (!ok) {
      this.draftFolderId = folderId;
      this.render();
      this.focusDraft();
    }
  }

  // ---------------------------------------------------
  // Renomear inline (duplo clique na linha)
  // ---------------------------------------------------

  isRenaming(kind, id) {
    return !!this.renaming
      && this.renaming.kind === kind
      && String(this.renaming.id) === String(id);
  }

  renameInput(value) {
    return `<input type="text" class="tc-tactic-draft-input" data-tc-rename
                   value="${this.escape(value)}" maxlength="120" autocomplete="off"
                   aria-label="Novo nome">`;
  }

  startRename(kind, id) {
    if (this.isRenaming(kind, id)) return;
    this.draftFolderId = null;
    this.renaming = { kind, id };
    this.render();
    const input = this.root?.querySelector('[data-tc-rename]');
    if (input) { input.focus(); input.select(); }
  }

  cancelRename() {
    if (!this.renaming) return;
    this.renaming = null;
    this.render();
  }

  async submitRename(input) {
    const value = input.value.trim();
    const ren = this.renaming;
    this.renaming = null;
    if (!ren || !value) { this.render(); return; }

    input.disabled = true;
    if (ren.kind === 'folder') await this.controller.renameFolder(ren.id, value);
    else await this.controller.renameTactic(ren.id, value);
    this.render();
  }

  tacticNode(tactic, comp, side) {
    const active = String(this.store.selectedTacticId) === String(tactic.id);
    return `
      <div class="tc-row tc-row--tactic ${active ? 'is-active' : ''}" role="treeitem" tabindex="0"
           aria-current="${active ? 'true' : 'false'}"
           data-tc-action="open-tactic" data-tactic-id="${tactic.id}">
        <i class="far fa-file-alt tc-tactic-icon" aria-hidden="true"></i>
        ${this.isRenaming('tactic', tactic.id)
          ? this.renameInput(tactic.title || '')
          : `<span class="tc-tactic-name">${this.escape(tactic.title || 'Sem título')}</span>`}
        ${tactic.video_url ? '<i class="fas fa-video tc-tactic-flag" title="Tem vídeo"></i>' : ''}
        <button class="tc-row-action" title="Excluir tática" aria-label="Excluir tática"
                data-tc-action="delete-tactic" data-tactic-id="${tactic.id}">
          <i class="fas fa-trash"></i>
        </button>
      </div>
    `;
  }

  // ---------------------------------------------------
  // Events
  // ---------------------------------------------------

  onClick(e) {
    // Cliques dentro do campo inline (renomear/rascunho) não mexem na linha.
    if (e.target.closest('[data-tc-rename], [data-tc-draft]')) return;

    const el = e.target.closest('[data-tc-action]');
    if (!el || !this.root.contains(el)) return;
    if (el.disabled) return;

    const action = el.dataset.tcAction;
    // Row actions live inside clickable rows — stop the row from also firing.
    e.stopPropagation();

    // Duplo clique manual: 'open-tactic' e 'toggle' re-renderizam a árvore
    // entre os dois cliques, então o evento 'dblclick' nativo nunca dispara.
    if (action === 'open-tactic' || action === 'toggle') {
      const key = `${action}:${el.dataset.tacticId || el.dataset.nodeId || ''}`;
      const now = Date.now();
      if (this._lastClickKey === key && now - (this._lastClickAt || 0) < 350) {
        this._lastClickKey = null;
        this.onDblClick(e);
        return;
      }
      this._lastClickKey = key;
      this._lastClickAt = now;
    }

    switch (action) {
      case 'toggle':
        if (this.accordion && !this.store.isExpanded(el.dataset.nodeId)) {
          this.collapseSiblings(el.dataset.nodeId);
        }
        this.store.toggleExpanded(el.dataset.nodeId);
        this.render();
        break;

      case 'collapse-all':
        this.store.expanded.clear();
        this.store.persistExpanded();
        this.render();
        break;

      case 'open-tactic':
        this.controller.openTactic(el.dataset.tacticId);
        break;

      case 'new-comp':
        this.controller.promptNewComposition(el.dataset.mapId);
        break;

      case 'delete-comp':
        this.controller.confirmDeleteComposition(el.dataset.mapId, el.dataset.compKey);
        break;

      case 'toggle-fav-comp':
        this.store.toggleFavoriteComp(el.dataset.nodeId, el.dataset.mapId);
        this.render();
        break;

      case 'new-folder':
        this.controller.promptNewFolder({
          mapId: el.dataset.mapId,
          compKey: el.dataset.compKey,
          side: el.dataset.side
        });
        break;

      case 'new-tactic':
        this.startDraft(el.dataset.folderId);
        break;

      case 'delete-folder':
        this.controller.confirmDeleteFolder(el.dataset.folderId);
        break;

      case 'delete-tactic':
        this.controller.confirmDeleteTactic(el.dataset.tacticId);
        break;
    }
  }

  /** Duplo clique numa linha de pasta ou tática abre o campo de renomear. */
  onDblClick(e) {
    if (e.target.closest('.tc-row-action') || e.target.matches('input')) return;

    const tacticRow = e.target.closest('.tc-row--tactic');
    if (tacticRow?.dataset.tacticId) {
      this.startRename('tactic', tacticRow.dataset.tacticId);
      return;
    }

    const folderRow = e.target.closest('.tc-row--folder');
    const folderId = folderRow?.querySelector('[data-folder-id]')?.dataset.folderId;
    if (folderId) this.startRename('folder', folderId);
  }

  onInput(e) {
    if (e.target.dataset.tcAction !== 'search') return;
    // Buscar durante um rascunho joga o campo fora — descarta o rascunho.
    this.draftFolderId = null;
    this.store.search = e.target.value;

    // Re-render replaces the input, so restore focus and caret.
    const caret = e.target.selectionStart;
    this.render();
    const input = this.root.querySelector('[data-tc-action="search"]');
    if (input) {
      input.focus();
      input.setSelectionRange(caret, caret);
    }
  }

  onKeydown(e) {
    // O rascunho inline responde antes da navegação da árvore: Enter grava,
    // Esc desiste.
    if (e.target.matches?.('[data-tc-draft]')) {
      if (e.key === 'Enter') { e.preventDefault(); this.submitDraft(e.target); }
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); this.cancelDraft(); }
      return;
    }

    if (e.target.matches?.('[data-tc-rename]')) {
      if (e.key === 'Enter') { e.preventDefault(); this.submitRename(e.target); }
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); this.cancelRename(); }
      return;
    }

    const row = e.target.closest('.tc-row');
    if (!row) return;

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      row.click();
    }
  }

  // ---------------------------------------------------
  // Utils
  // ---------------------------------------------------

  escape(value) {
    return String(value ?? '').replace(/[&<>"']/g, ch => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[ch]));
  }
}


/* ===== js/tactics/tactics-drawing.js ===== */
// =====================================================
// ZDVAL - Tactics Drawing
// Editor interativo do Modo Tático: canvas 2D puro sobreposto à imagem do
// mapa, com caneta, borracha, linha, seta, texto e imagem — replica as
// ferramentas do zdpro (valoplant-v2.js), reduzidas ao essencial (sem
// agentes/abilities/timeline).
//
// Elementos são salvos em coordenadas percentuais (0-100) relativas ao
// canvas, não pixels absolutos — assim o desenho escala com qualquer
// tamanho de tela. Persistência: tactic.drawing_data (array JSON),
// autosave feito pelo TacticsEditor que possui esta instância.
// =====================================================

class TacticsDrawing {
  static COLORS = ['#ff4655', '#46a0ff', '#2ecc71', '#f5c518', '#ffffff', '#111318'];
  static WIDTHS = [2, 3, 5, 8];

  static toolbarTemplate() {
    return `
      <div class="tc-draw-toolbar" data-draw-toolbar>
        <div class="tc-draw-group" data-draw-tools>
          <button class="tc-draw-tool" data-draw-tool="pointer" title="Ponteiro (nenhuma ferramenta)" aria-label="Ponteiro">
            <i class="fas fa-mouse-pointer"></i>
          </button>
          <button class="tc-draw-tool is-active" data-draw-tool="pen" title="Caneta" aria-label="Caneta">
            <i class="fas fa-pen"></i>
          </button>
          <button class="tc-draw-tool" data-draw-tool="eraser" title="Apagar" aria-label="Apagar">
            <i class="fas fa-eraser"></i>
          </button>
          <button class="tc-draw-tool" data-draw-tool="line" title="Linha" aria-label="Linha">
            <i class="fas fa-minus"></i>
          </button>
          <button class="tc-draw-tool" data-draw-tool="arrow" title="Seta" aria-label="Seta">
            <i class="fas fa-long-arrow-alt-right"></i>
          </button>
          <button class="tc-draw-tool" data-draw-tool="text" title="Texto" aria-label="Texto">
            <i class="fas fa-font"></i>
          </button>
          <button class="tc-draw-tool" data-draw-tool="image" title="Imagem" aria-label="Imagem">
            <i class="fas fa-image"></i>
          </button>
        </div>

        <div class="tc-draw-group" data-draw-colors>
          ${TacticsDrawing.COLORS.map((c, i) => `
            <button class="tc-draw-color ${i === 0 ? 'is-active' : ''}" data-draw-color="${c}"
                    style="--swatch:${c}" title="Cor" aria-label="Cor ${c}"></button>
          `).join('')}
        </div>

        <select class="tc-draw-width" data-draw-width aria-label="Espessura do traço">
          ${TacticsDrawing.WIDTHS.map(w => `<option value="${w}" ${w === 3 ? 'selected' : ''}>${w}px</option>`).join('')}
        </select>

        <div class="tc-draw-group">
          <button class="tc-icon-btn" data-draw-undo title="Desfazer (Ctrl+Z)" aria-label="Desfazer" disabled>
            <i class="fas fa-undo"></i>
          </button>
          <button class="tc-icon-btn" data-draw-redo title="Refazer (Ctrl+Shift+Z)" aria-label="Refazer" disabled>
            <i class="fas fa-redo"></i>
          </button>
          <button class="tc-icon-btn" data-draw-clear title="Limpar tudo" aria-label="Limpar tudo">
            <i class="fas fa-trash-alt"></i>
          </button>
        </div>
      </div>
    `;
  }

  constructor(editor) {
    this.editor = editor;
    this.canvas = null;
    this.ctx = null;
    this.container = null;
    this.toolbar = null;
    this.onChange = null;

    this.elements = [];
    this.undoStack = [];
    this.redoStack = [];

    this.tool = 'pen';
    this.color = TacticsDrawing.COLORS[0];
    this.width = 3;

    this.isDrawing = false;
    this.activeElement = null;

    // Seleção de imagem: arrastar move, alças nos cantos redimensionam.
    this.selectedElement = null;
    this.dragMode = null; // 'move' | 'resize-<corner>'
    this.dragStart = null;
    this.dragOrigin = null;

    this._resizeObserver = null;
    this._bound = false;

    // Zoom por scroll (100%–300%) + pan por arrasto (botão do meio / Espaço).
    // A escala é um transform CSS no .tc-focus-media; a matemática de
    // coordenadas usa clientWidth/clientHeight (caixa de layout, imune ao
    // transform) e divide por this.zoom onde parte de clientX/Y.
    this.zoom = 1;
    this.panX = 0;
    this.panY = 0;
    this._spaceHeld = false;
    this._panning = false;
  }

  static ZOOM_MIN = 1;
  static ZOOM_MAX = 3;

  // ---------------------------------------------------
  // Mount / lifecycle
  // ---------------------------------------------------

  mount(canvas, toolbarRoot, tactic, onChange) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.container = canvas.closest('[data-draw-container]');
    // Camada que recebe o transform de zoom/pan (img + canvas + overlay). O
    // container fica parado — é a referência estável das coordenadas.
    this.layer = this.container.querySelector('[data-zoom-layer]') || this.container;
    this.image = this.container.querySelector('.tc-draw-src') || this.container.querySelector('img');
    this.trash = this.container.querySelector('[data-draw-trash]');
    this.toolbar = toolbarRoot;
    this.tactic = tactic;
    this.onChange = onChange;

    this.elements = this.editor.parseJson(tactic.drawing_data);
    this.undoStack = [];
    this.redoStack = [];
    this.tool = 'pen';
    this.color = TacticsDrawing.COLORS[0];
    this.width = 3;
    this.selectedElement = null;

    this.ensureOverlay();
    this.resize();
    this.render();
    this.bindEvents();
    this.syncToolbarState();
    this.updateCursor();

    // getImageRect() depende de naturalWidth/naturalHeight — se a imagem
    // ainda não carregou quando o mount roda, o primeiro render cai no
    // fallback (container inteiro) e fica desalinhado até isto disparar.
    if (this.image && !this.image.complete) {
      this.image.addEventListener('load', () => { this.render(); this.syncHandles(); }, { once: true });
    }

    this._resizeObserver?.disconnect();
    this._resizeObserver = new ResizeObserver(() => { this.resize(); this.render(); this.syncHandles(); });
    this._resizeObserver.observe(this.container);
  }

  /** Camada HTML por cima do canvas: alças de resize e input de texto inline. */
  ensureOverlay() {
    const host = this.layer || this.container;
    this.overlay = host.querySelector('.tc-draw-overlay');
    if (!this.overlay) {
      this.overlay = document.createElement('div');
      this.overlay.className = 'tc-draw-overlay';
      host.appendChild(this.overlay);
    }
    this.overlay.innerHTML = '';
  }

  destroy() {
    this._resizeObserver?.disconnect();
    this._resizeObserver = null;
    if (this._keyHandler) document.removeEventListener('keydown', this._keyHandler);
    if (this._spaceDown) document.removeEventListener('keydown', this._spaceDown);
    if (this._spaceUp) document.removeEventListener('keyup', this._spaceUp);
    if (this._wheelHandler && this.container) this.container.removeEventListener('wheel', this._wheelHandler);
    if (this.layer && this.layer !== this.container) this.layer.style.transform = '';
    this.zoom = 1; this.panX = 0; this.panY = 0;
    this._bound = false;
  }

  getElements() {
    return this.elements;
  }

  resize() {
    if (!this.canvas || !this.container) return;
    // Backing store SEMPRE na resolução nativa da tela (w*dpr). O zoom NÃO
    // entra aqui — quem escala é o ctx no render(), então só a fatia visível
    // é rasterizada, na resolução do device: sem perda ao ampliar.
    const w = this.container.clientWidth;
    const h = this.container.clientHeight;
    const dpr = window.devicePixelRatio || 1;
    this.canvas.width = Math.round(w * dpr);
    this.canvas.height = Math.round(h * dpr);
    this.canvas.style.width = `${w}px`;
    this.canvas.style.height = `${h}px`;
    if (this.zoom > 1) this.clampPan();
  }

  // ---------------------------------------------------
  // Coordenadas — sempre em % (0-100) da ÁREA REAL DA IMAGEM, não do
  // container. A imagem usa object-fit:contain (aparece inteira, sem
  // corte/zoom), então sobra faixa vazia nas bordas quando a proporção
  // não bate 1:1 com o container — se as coordenadas fossem relativas ao
  // container inteiro, clicar nessa faixa não corresponderia a lugar
  // nenhum na imagem, e o desenho ficaria desalinhado dela (bug relatado:
  // "a imagem parece se mover" quando na verdade era o sistema de
  // coordenadas errado). getImageRect() calcula o retângulo exato onde a
  // imagem é desenhada dentro do container, e toPercent/render usam esse
  // retângulo como referência 0-100%, não o container.
  // ---------------------------------------------------

  /** Retângulo real da imagem dentro do container (contain), em px relativos ao container. */
  getImageRect() {
    // Layout box (imune ao transform de zoom) — ver resize().
    const cw = this.container.clientWidth;
    const ch = this.container.clientHeight;

    if (!this.image || !this.image.naturalWidth) {
      return { x: 0, y: 0, width: cw, height: ch };
    }

    const iw = this.image.naturalWidth;
    const ih = this.image.naturalHeight;
    const containerRatio = cw / ch;
    const imageRatio = iw / ih;

    let width, height;
    if (imageRatio > containerRatio) {
      // Imagem mais "larga" que o container — barras vazias em cima/baixo.
      width = cw;
      height = cw / imageRatio;
    } else {
      // Imagem mais "alta" — barras vazias nas laterais.
      height = ch;
      width = ch * imageRatio;
    }

    return { x: (cw - width) / 2, y: (ch - height) / 2, width, height };
  }

  toPercent(clientX, clientY) {
    // O container fica parado; o transform (pan + zoom) está na .layer.
    // Tira o pan, divide pelo zoom → caixa de layout, onde img.x/width vivem.
    const containerRect = this.container.getBoundingClientRect();
    const z = this.zoom || 1;
    const img = this.getImageRect();
    const localX = (clientX - containerRect.left - this.panX) / z - img.x;
    const localY = (clientY - containerRect.top - this.panY) / z - img.y;
    return {
      x: (localX / img.width) * 100,
      y: (localY / img.height) * 100
    };
  }

  // ---------------------------------------------------
  // Events
  // ---------------------------------------------------

  bindEvents() {
    if (this._bound) return;
    this._bound = true;

    this.canvas.addEventListener('pointerdown', (e) => this.onPointerDown(e));
    this.canvas.addEventListener('pointermove', (e) => this.onPointerMove(e));
    window.addEventListener('pointerup', (e) => this.onPointerUp(e));
    this.canvas.addEventListener('dblclick', (e) => this.onDoubleClick(e));

    this.toolbar?.addEventListener('click', (e) => this.onToolbarClick(e));
    this.toolbar?.querySelector('[data-draw-width]')?.addEventListener('change', (e) => {
      this.width = Number(e.target.value);
    });

    this._keyHandler = (e) => this.onKeyDown(e);
    document.addEventListener('keydown', this._keyHandler);

    // Zoom por scroll (100%–300%), centrado no cursor.
    this._wheelHandler = (e) => this.onWheel(e);
    this.container.addEventListener('wheel', this._wheelHandler, { passive: false });

    // Espaço segura = modo pan (solta a caneta enquanto anda com o mapa).
    this._spaceDown = (e) => {
      if (e.code === 'Space' && !['INPUT', 'TEXTAREA'].includes(document.activeElement?.tagName)) {
        this._spaceHeld = true;
        this.updateCursor();
      }
    };
    this._spaceUp = (e) => {
      if (e.code === 'Space') { this._spaceHeld = false; this.updateCursor(); }
    };
    document.addEventListener('keydown', this._spaceDown);
    document.addEventListener('keyup', this._spaceUp);
  }

  // ---------------------------------------------------
  // Zoom + pan
  // ---------------------------------------------------

  applyTransform() {
    // A camada só carrega o overlay (alças/input de texto) — segue por CSS.
    // O mapa + desenho são redesenhados pelo ctx, na resolução do device.
    if (this.layer && this.layer !== this.container) {
      this.layer.style.transformOrigin = '0 0';
      this.layer.style.transform = `translate(${this.panX}px, ${this.panY}px) scale(${this.zoom})`;
    }
    this.render();
  }

  clampPan() {
    const w = this.container.clientWidth;
    const h = this.container.clientHeight;
    const minX = w * (1 - this.zoom); // = w - w*zoom
    const minY = h * (1 - this.zoom);
    this.panX = Math.min(0, Math.max(minX, this.panX));
    this.panY = Math.min(0, Math.max(minY, this.panY));
  }

  showZoomHint() {
    let el = this.container.querySelector('.tc-draw-zoom');
    if (!el) {
      el = document.createElement('div');
      el.className = 'tc-draw-zoom';
      this.container.appendChild(el);
    }
    el.textContent = `${Math.round(this.zoom * 100)}%`;
    el.classList.add('is-visible');
    clearTimeout(this._zoomHintT);
    this._zoomHintT = setTimeout(() => el.classList.remove('is-visible'), 900);
  }

  onWheel(e) {
    e.preventDefault();
    const rect = this.container.getBoundingClientRect(); // container fica parado
    const prev = this.zoom;
    const factor = e.deltaY < 0 ? 1.2 : 1 / 1.2;
    this.zoom = Math.min(TacticsDrawing.ZOOM_MAX, Math.max(TacticsDrawing.ZOOM_MIN, prev * factor));
    if (this.zoom === prev) return;

    if (this.zoom <= 1) {
      this.zoom = 1;
      this.panX = 0;
      this.panY = 0;
    } else {
      // Ponto sob o cursor fica fixo. d = cursor relativo ao container;
      // pan' = d*(1 - z'/z) + pan*z'/z
      const dx = e.clientX - rect.left;
      const dy = e.clientY - rect.top;
      const r = this.zoom / prev;
      this.panX = dx * (1 - r) + this.panX * r;
      this.panY = dy * (1 - r) + this.panY * r;
      this.clampPan();
    }

    this.applyTransform();
    this.showZoomHint();
    this.updateCursor();
  }

  /** Botão do meio ou Espaço+arrasto = pan, com qualquer ferramenta. */
  _maybeStartPan(e) {
    const trigger = e.button === 1 || (e.button === 0 && this._spaceHeld);
    if (!trigger || this.zoom <= 1) return false;
    this._startPan(e);
    return true;
  }

  _startPan(e) {
    e.preventDefault();
    this._panning = true;
    this._panLast = { x: e.clientX, y: e.clientY };
    this.canvas.setPointerCapture(e.pointerId);
    this.updateCursor();
  }

  _panMove(e) {
    this.panX += e.clientX - this._panLast.x;
    this.panY += e.clientY - this._panLast.y;
    this._panLast = { x: e.clientX, y: e.clientY };
    this.clampPan();
    this.applyTransform();
  }

  _panEnd() {
    this._panning = false;
    this.updateCursor();
  }

  onToolbarClick(e) {
    const toolBtn = e.target.closest('[data-draw-tool]');
    if (toolBtn) {
      const clicked = toolBtn.dataset.drawTool;
      // Clicar na ferramenta já ativa desmarca — volta pro ponteiro, sem
      // ferramenta nenhuma armada (nada de ficar preso com a caneta armada
      // sem jeito de "desclicar").
      this.tool = (clicked !== 'pointer' && clicked === this.tool) ? 'pointer' : clicked;
      this.syncToolbarState();
      this.updateCursor();
      if (this.tool === 'image') this.pickImage();
      return;
    }

    const colorBtn = e.target.closest('[data-draw-color]');
    if (colorBtn) {
      this.color = colorBtn.dataset.drawColor;
      this.syncToolbarState();
      return;
    }

    if (e.target.closest('[data-draw-undo]')) return this.undo();
    if (e.target.closest('[data-draw-redo]')) return this.redo();
    if (e.target.closest('[data-draw-clear]')) return this.clearAll();
  }

  onKeyDown(e) {
    if (!this.canvas || !document.body.contains(this.canvas)) return;
    const meta = e.ctrlKey || e.metaKey;
    if (!meta || e.key.toLowerCase() !== 'z') return;
    if (['INPUT', 'TEXTAREA'].includes(document.activeElement?.tagName)) return;
    e.preventDefault();
    if (e.shiftKey) this.redo();
    else this.undo();
  }

  /** Duplo-clique num texto já colocado reabre pra editar, com o valor atual. */
  onDoubleClick(e) {
    const pt = this.toPercent(e.clientX, e.clientY);
    const el = this.elements.find(x => x.type === 'text' && x._box
      && pt.x >= x._box.x && pt.x <= x._box.x + x._box.width
      && pt.y >= x._box.y && pt.y <= x._box.y + x._box.height);
    if (!el) return;

    if (this.selectedElement) this.selectElement(null);
    this.openTextEditor({ x: el.x, y: el.y }, el);
  }

  syncToolbarState() {
    if (!this.toolbar) return;
    this.toolbar.querySelectorAll('[data-draw-tool]').forEach(btn => {
      btn.classList.toggle('is-active', btn.dataset.drawTool === this.tool);
    });
    this.toolbar.querySelectorAll('[data-draw-color]').forEach(btn => {
      btn.classList.toggle('is-active', btn.dataset.drawColor === this.color);
    });
    const undoBtn = this.toolbar.querySelector('[data-draw-undo]');
    const redoBtn = this.toolbar.querySelector('[data-draw-redo]');
    if (undoBtn) undoBtn.disabled = this.undoStack.length === 0;
    if (redoBtn) redoBtn.disabled = this.redoStack.length === 0;
  }

  /** Cursor do mouse reflete a ferramenta armada — caneta, borracha, etc.
   * Ponteiro + zoom > 1: mãozinha de arrastar (pan), igual /zdpro. */
  updateCursor() {
    if (!this.canvas) return;
    this.canvas.dataset.cursorTool = this.tool;
    if (this.tool === 'pointer' && this.zoom > 1) {
      this.canvas.style.cursor = this._panning ? 'grabbing' : 'grab';
    } else if (this._spaceHeld && this.zoom > 1) {
      this.canvas.style.cursor = this._panning ? 'grabbing' : 'grab';
    } else {
      this.canvas.style.cursor = '';
    }
  }

  // ---------------------------------------------------
  // Pointer handling por ferramenta
  // ---------------------------------------------------

  onPointerDown(e) {
    if (this._maybeStartPan(e)) return;
    if (this.tool === 'image') return;
    const pt = this.toPercent(e.clientX, e.clientY);

    // Clicar em cima de uma imagem ou texto existente sempre seleciona/
    // arrasta — não depende da ferramenta ativa, igual a qualquer editor
    // visual. Soltar em cima da lixeira exclui (ver onPointerUp).
    const dragIndex = this.findDraggableAt(pt);
    if (dragIndex !== -1) {
      this.canvas.setPointerCapture(e.pointerId);
      this.selectElement(this.elements[dragIndex]);
      this.pushUndoSnapshot();
      this.dragMode = 'move';
      this.dragStart = pt;
      this.dragOrigin = { x: this.selectedElement.x, y: this.selectedElement.y };
      return;
    }

    if (this.selectedElement) this.selectElement(null);

    // Ponteiro + zoom > 1 + área vazia = arrastar move a imagem (padrão /zdpro).
    if (this.tool === 'pointer' && e.button === 0 && this.zoom > 1) {
      this._startPan(e);
      return;
    }

    if (this.tool === 'eraser') {
      this.canvas.setPointerCapture(e.pointerId);
      this.pushUndoSnapshot();
      this.isErasing = true;
      this.eraseAt(pt);
      return;
    }

    if (this.tool === 'text') {
      e.preventDefault();
      this.openTextEditor(pt);
      return;
    }

    this.canvas.setPointerCapture(e.pointerId);
    this.pushUndoSnapshot();
    this.isDrawing = true;

    if (this.tool === 'pen') {
      this.activeElement = { type: 'pen', points: [pt], color: this.color, width: this.width };
      this.elements.push(this.activeElement);
    } else if (this.tool === 'line' || this.tool === 'arrow') {
      this.activeElement = { type: this.tool, x: pt.x, y: pt.y, endX: pt.x, endY: pt.y, color: this.color, width: this.width };
      this.elements.push(this.activeElement);
    }
  }

  onPointerMove(e) {
    if (this._panning) { this._panMove(e); return; }
    if (this.dragMode === 'move' && this.selectedElement) {
      const pt = this.toPercent(e.clientX, e.clientY);
      this.selectedElement.x = this.dragOrigin.x + (pt.x - this.dragStart.x);
      this.selectedElement.y = this.dragOrigin.y + (pt.y - this.dragStart.y);
      this.render();
      this.syncHandles();
      this.updateTrashHover(e);
      return;
    }

    if (this.isErasing) {
      const pt = this.toPercent(e.clientX, e.clientY);
      this.eraseAt(pt);
      return;
    }

    if (!this.isDrawing || !this.activeElement) return;
    const pt = this.toPercent(e.clientX, e.clientY);

    if (this.activeElement.type === 'pen') {
      this.activeElement.points.push(pt);
    } else {
      this.activeElement.endX = pt.x;
      this.activeElement.endY = pt.y;
    }
    this.render();
  }

  onPointerUp(e) {
    if (this._panning) { this._panEnd(e); return; }
    if (this.dragMode) {
      const droppedOnTrash = this.isOverTrash(e);
      this.dragMode = null;
      this.dragStart = null;
      this.dragOrigin = null;
      this.trash?.classList.remove('is-hover');

      if (droppedOnTrash && this.selectedElement) {
        const el = this.selectedElement;
        this.elements = this.elements.filter(x => x !== el);
        this.selectElement(null);
        this.commitChange();
      } else {
        this.commitChange();
      }
      return;
    }
    if (this.isErasing) {
      this.isErasing = false;
      this.commitChange();
      return;
    }
    if (!this.isDrawing) return;
    this.isDrawing = false;
    this.activeElement = null;
    this.commitChange();
  }

  // ---------------------------------------------------
  // Lixeira — arrastar imagem/texto até o canto superior direito exclui,
  // mesmo padrão do zdpro (vp2-trash-bin): sempre visível, realce no
  // hover durante o arrasto, exclusão imediata no soltar.
  // ---------------------------------------------------

  isOverTrash(e) {
    if (!this.trash) return false;
    const r = this.trash.getBoundingClientRect();
    return e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
  }

  updateTrashHover(e) {
    this.trash?.classList.toggle('is-hover', this.isOverTrash(e));
  }

  /**
   * Remove todo elemento sob o ponto — chamado a cada pointermove enquanto
   * a borracha está pressionada, então arrastar apaga tudo no caminho, não
   * só o que estava embaixo do clique inicial. O snapshot de undo é
   * empilhado uma única vez por gesto (no pointerdown), não por elemento.
   */
  eraseAt(pt) {
    let hitIndex = this.findElementAt(pt);
    if (hitIndex === -1) return;
    while (hitIndex !== -1) {
      this.elements.splice(hitIndex, 1);
      hitIndex = this.findElementAt(pt);
    }
    this.render();
    this.syncToolbarState();
    this.tactic.drawing_data = this.elements;
  }

  /** Hit-test simples: distância ao ponto/segmento mais próximo, em %. */
  findElementAt(pt) {
    const threshold = 2.2;
    for (let i = this.elements.length - 1; i >= 0; i--) {
      const el = this.elements[i];
      if (el.type === 'pen') {
        if (el.points.some(p => this.distance(p, pt) < threshold)) return i;
      } else if (el.type === 'line' || el.type === 'arrow') {
        if (this.distanceToSegment(pt, { x: el.x, y: el.y }, { x: el.endX, y: el.endY }) < threshold) return i;
      } else if (el.type === 'text' || el.type === 'image') {
        const w = el.width || 12, h = el.height || 6;
        if (pt.x >= el.x && pt.x <= el.x + w && pt.y >= el.y && pt.y <= el.y + h) return i;
      }
    }
    return -1;
  }

  /**
   * Imagem e texto — usado pra seleção/arrastar, independente da
   * ferramenta ativa (igual clicar num objeto em qualquer editor visual).
   */
  findDraggableAt(pt) {
    for (let i = this.elements.length - 1; i >= 0; i--) {
      const el = this.elements[i];
      if (el.type === 'image') {
        if (pt.x >= el.x && pt.x <= el.x + el.width && pt.y >= el.y && pt.y <= el.y + el.height) return i;
      } else if (el.type === 'text' && el._box) {
        const b = el._box;
        if (pt.x >= b.x && pt.x <= b.x + b.width && pt.y >= b.y && pt.y <= b.y + b.height) return i;
      }
    }
    return -1;
  }

  distance(a, b) {
    return Math.hypot(a.x - b.x, a.y - b.y);
  }

  distanceToSegment(p, a, b) {
    const dx = b.x - a.x, dy = b.y - a.y;
    const lenSq = dx * dx + dy * dy;
    if (lenSq === 0) return this.distance(p, a);
    let t = ((p.x - a.x) * dx + (p.y - a.y) * dy) / lenSq;
    t = Math.max(0, Math.min(1, t));
    return this.distance(p, { x: a.x + t * dx, y: a.y + t * dy });
  }

  // ---------------------------------------------------
  // Texto — campo solto sobre o canvas, sem modal. Enter ou clicar fora
  // confirma; Esc cancela.
  // ---------------------------------------------------

  /**
   * Cria um texto novo em `pt`, ou — se `existingEl` for passado (duplo-
   * clique num texto já colocado) — edita o texto dele no lugar, mantendo
   * posição e cor originais.
   */
  openTextEditor(pt, existingEl = null) {
    this.overlay.querySelector('.tc-draw-text-input')?.remove();

    const cw = this.container.clientWidth;
    const ch = this.container.clientHeight;
    const img = this.getImageRect();
    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'tc-draw-text-input';
    input.placeholder = 'Digite e pressione Enter…';

    // Posição em px relativos ao container (overlay cobre o container
    // inteiro), somando o offset da imagem — pt.x/y são % da imagem, não
    // do container. Clampa pra nunca estourar as bordas do container.
    const inputMinWidth = 160;
    const inputHeight = 32;
    const rawLeft = img.x + (pt.x / 100) * img.width;
    const rawTop = img.y + (pt.y / 100) * img.height - 16;
    const left = Math.min(rawLeft, cw - inputMinWidth - 8);
    const top = Math.min(rawTop, ch - inputHeight - 8);
    input.style.left = `${Math.max(8, left)}px`;
    input.style.top = `${Math.max(8, top)}px`;
    input.style.color = existingEl?.color || this.color;
    if (existingEl) {
      input.value = existingEl.text;
      this.hideCanvasText(existingEl);
    }

    const commit = () => {
      const text = input.value.trim();
      input.remove();
      this.showCanvasText(existingEl);

      if (!text) {
        if (existingEl) {
          this.pushUndoSnapshot();
          this.elements = this.elements.filter(x => x !== existingEl);
          this.commitChange();
        }
        return;
      }

      this.pushUndoSnapshot();
      if (existingEl) {
        existingEl.text = text;
      } else {
        this.elements.push({ type: 'text', x: pt.x, y: pt.y, text, color: this.color });
      }
      this.commitChange();
    };

    input.addEventListener('pointerdown', (e) => e.stopPropagation());
    input.addEventListener('keydown', (e) => {
      e.stopPropagation();
      if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
      if (e.key === 'Escape') { input.value = ''; input.blur(); }
    });

    this.overlay.appendChild(input);
    if (existingEl) input.select();

    // O pointerdown que abriu o editor ainda está em curso quando este
    // método roda — dar blur/focus no mesmo gesto pode disparar o commit
    // antes do usuário digitar qualquer coisa. Só liga o listener de blur
    // (e dá foco de fato) depois que o gesto de clique termina.
    setTimeout(() => {
      input.addEventListener('blur', commit, { once: true });
      input.focus();
    }, 0);
  }

  /** Some com o texto no canvas enquanto o input de edição está por cima dele. */
  hideCanvasText(el) {
    el._editing = true;
    this.render();
  }

  showCanvasText(el) {
    if (!el) return;
    el._editing = false;
    this.render();
  }

  // ---------------------------------------------------
  // Imagem — escolhe arquivo, faz upload, posiciona centralizada com
  // tamanho proporcional fixo. Depois de colocada, clicar nela seleciona:
  // arrastar move, alças nos cantos redimensionam.
  // ---------------------------------------------------

  pickImage() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.addEventListener('change', async () => {
      const file = input.files?.[0];
      this.tool = 'pen';
      this.syncToolbarState();
      if (!file) return;

      try {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('type', 'tactics');
        const result = await api.upload('/upload/image', formData);
        if (!result?.url) throw new Error(result?.message || 'Falha no upload');

        this.pushUndoSnapshot();
        const el = { type: 'image', x: 35, y: 35, width: 30, height: 30, url: result.url };
        this.elements.push(el);
        this.commitChange();
        this.selectElement(el);
      } catch (err) {
        console.error('[tactics-drawing] image upload failed', err);
        app?.showToast?.('Falha ao enviar imagem', 'error');
      }
    });
    input.click();
  }

  // --- Seleção / resize de imagem -----------------------

  selectElement(el) {
    this.selectedElement = el;
    this.syncHandles();
  }

  syncHandles() {
    this.overlay.querySelectorAll('.tc-draw-handles').forEach(n => n.remove());
    if (!this.selectedElement || this.selectedElement.type !== 'image') return;

    // Alças posicionadas em px do container (overlay é relativo a ele),
    // convertendo a partir de % da imagem — não do container.
    const img = this.getImageRect();
    const el = this.selectedElement;
    const box = document.createElement('div');
    box.className = 'tc-draw-handles';
    box.style.left = `${img.x + (el.x / 100) * img.width}px`;
    box.style.top = `${img.y + (el.y / 100) * img.height}px`;
    box.style.width = `${(el.width / 100) * img.width}px`;
    box.style.height = `${(el.height / 100) * img.height}px`;

    ['nw', 'ne', 'sw', 'se'].forEach(corner => {
      const handle = document.createElement('div');
      handle.className = `tc-draw-handle tc-draw-handle--${corner}`;
      handle.addEventListener('pointerdown', (e) => this.startResize(e, corner));
      box.appendChild(handle);
    });

    this.overlay.appendChild(box);
  }

  startResize(e, corner) {
    e.stopPropagation();
    e.preventDefault();
    e.target.setPointerCapture(e.pointerId);

    this.pushUndoSnapshot();
    const el = this.selectedElement;
    const start = this.toPercent(e.clientX, e.clientY);
    const origin = { x: el.x, y: el.y, width: el.width, height: el.height };
    const minSize = 4;

    const onMove = (ev) => {
      const pt = this.toPercent(ev.clientX, ev.clientY);
      const dx = pt.x - start.x;
      const dy = pt.y - start.y;

      if (corner.includes('e')) el.width = Math.max(minSize, origin.width + dx);
      if (corner.includes('s')) el.height = Math.max(minSize, origin.height + dy);
      if (corner.includes('w')) {
        const newWidth = Math.max(minSize, origin.width - dx);
        el.x = origin.x + (origin.width - newWidth);
        el.width = newWidth;
      }
      if (corner.includes('n')) {
        const newHeight = Math.max(minSize, origin.height - dy);
        el.y = origin.y + (origin.height - newHeight);
        el.height = newHeight;
      }

      this.render();
      this.syncHandles();
    };

    const onUp = () => {
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      this.commitChange();
    };

    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
  }

  // ---------------------------------------------------
  // Undo / Redo
  // ---------------------------------------------------

  pushUndoSnapshot() {
    this.undoStack.push(JSON.stringify(this.elements));
    if (this.undoStack.length > 50) this.undoStack.shift();
    this.redoStack = [];
  }

  undo() {
    if (!this.undoStack.length) return;
    this.redoStack.push(JSON.stringify(this.elements));
    this.elements = JSON.parse(this.undoStack.pop());
    this.commitChange();
  }

  redo() {
    if (!this.redoStack.length) return;
    this.undoStack.push(JSON.stringify(this.elements));
    this.elements = JSON.parse(this.redoStack.pop());
    this.commitChange();
  }

  clearAll() {
    if (!this.elements.length) return;
    this.pushUndoSnapshot();
    this.elements = [];
    this.commitChange();
  }

  commitChange() {
    this.render();
    this.syncToolbarState();
    this.tactic.drawing_data = this.elements;
    this.onChange?.();
  }

  // ---------------------------------------------------
  // Render — puro, a partir de this.elements.
  // ---------------------------------------------------

  render() {
    if (!this.ctx || !this.canvas) return;
    const dpr = window.devicePixelRatio || 1;
    const z = this.zoom || 1;

    this.ctx.setTransform(1, 0, 0, 1, 0, 0);
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    // px de layout -> device: device = (px*z + panScreen) * dpr.
    this.ctx.setTransform(z * dpr, 0, 0, z * dpr, this.panX * dpr, this.panY * dpr);
    this.ctx.imageSmoothingEnabled = true;
    this.ctx.imageSmoothingQuality = 'high';

    const img = this.getImageRect();
    if (this.image && this.image.complete && this.image.naturalWidth) {
      this.ctx.drawImage(this.image, img.x, img.y, img.width, img.height);
    }
    this.elements.forEach(el => this.renderElement(this.ctx, el, img));
  }

  /** `rect` aqui é a área real da imagem (getImageRect), não o container. */
  renderElement(ctx, el, rect) {
    const toPx = (pt) => ({ x: rect.x + (pt.x / 100) * rect.width, y: rect.y + (pt.y / 100) * rect.height });

    if (el.type === 'pen') {
      if (!el.points?.length) return;
      ctx.strokeStyle = el.color;
      ctx.lineWidth = el.width || 3;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      const first = toPx(el.points[0]);
      ctx.moveTo(first.x, first.y);
      el.points.slice(1).forEach(p => {
        const px = toPx(p);
        ctx.lineTo(px.x, px.y);
      });
      ctx.stroke();
      return;
    }

    if (el.type === 'line' || el.type === 'arrow') {
      const a = toPx({ x: el.x, y: el.y });
      const b = toPx({ x: el.endX, y: el.endY });
      ctx.strokeStyle = el.color;
      ctx.fillStyle = el.color;
      ctx.lineWidth = el.width || 3;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x, b.y);
      ctx.stroke();

      if (el.type === 'arrow') {
        const angle = Math.atan2(b.y - a.y, b.x - a.x);
        const headLen = 12 + (el.width || 3);
        ctx.beginPath();
        ctx.moveTo(b.x, b.y);
        ctx.lineTo(b.x - headLen * Math.cos(angle - Math.PI / 6), b.y - headLen * Math.sin(angle - Math.PI / 6));
        ctx.lineTo(b.x - headLen * Math.cos(angle + Math.PI / 6), b.y - headLen * Math.sin(angle + Math.PI / 6));
        ctx.closePath();
        ctx.fill();
      }
      return;
    }

    if (el.type === 'text') {
      if (el._editing) return;
      const p = toPx({ x: el.x, y: el.y });
      ctx.font = '600 14px Inter, system-ui, sans-serif';
      const paddingX = 8, paddingY = 6;
      const textWidth = ctx.measureText(el.text).width;
      const boxX = p.x - paddingX;
      const boxY = p.y - 14 - paddingY;
      const boxW = textWidth + paddingX * 2;
      const boxH = 14 + paddingY * 2;

      ctx.fillStyle = 'rgba(10, 12, 16, 0.82)';
      ctx.beginPath();
      ctx.roundRect(boxX, boxY, boxW, boxH, 6);
      ctx.fill();

      ctx.fillStyle = el.color || '#fff';
      ctx.textBaseline = 'alphabetic';
      ctx.fillText(el.text, p.x, p.y);

      // Caixa em % — recalculada a cada render, usada pra hit-test/drag
      // (não persiste; a fonte da verdade é sempre el.x/el.y + o texto).
      el._box = {
        x: (boxX / rect.width) * 100,
        y: (boxY / rect.height) * 100,
        width: (boxW / rect.width) * 100,
        height: (boxH / rect.height) * 100
      };
      return;
    }

    if (el.type === 'image') {
      const p = toPx({ x: el.x, y: el.y });
      const size = toPx({ x: el.width, y: el.height });

      if (!el._img) {
        el._img = new Image();
        el._img.src = el.url;
        el._img.onload = () => this.render();
        return;
      }
      if (!el._img.complete) return;
      ctx.drawImage(el._img, p.x, p.y, size.x, size.y);
    }
  }
}


/* ===== js/tactics/tactics-editor.js ===== */
// =====================================================
// ZDVAL - Tactics Editor
// Main content pane: breadcrumb header + the tactical document.
//
// Editing is Notion-style: fields are edited in place and saved on blur,
// with a debounced autosave for the long-form text areas.
// =====================================================

class TacticsEditor {
  static AUTOSAVE_MS = 900;

  constructor(store, controller) {
    this.store = store;
    this.controller = controller;
    this.root = null;
    this.saveTimer = null;
    this.saveState = 'idle'; // idle | saving | saved | error
    this.focusMode = false;
    this.mapSlideIndex = 0;
    // Vídeo: link (YouTube/Twitch) é o caminho principal; arquivo é a exceção.
    // videoInput = 'url' | 'file'; videoEditing força o input mesmo com vídeo já
    // salvo. Mapa é só arquivo — não tem opção de URL.
    this.videoInput = 'url';
    this.videoEditing = false;
  }

  mount(root) {
    this.root = root;
    // renderShell() rebuilds #tcMain from scratch on every page load/section
    // switch, so `root` is a fresh node each time — always bind to it (the
    // old node and its listeners are discarded).
    this.root.addEventListener('click', (e) => this.onClick(e));
    this.root.addEventListener('keydown', (e) => this.onActionKeydown(e));
    this.root.addEventListener('input', (e) => this.onInput(e));
    this.root.addEventListener('change', (e) => this.onChange(e));
    this.root.addEventListener('blur', (e) => this.onBlur(e), true);
    this.root.addEventListener('dblclick', (e) => this.onDblClick(e));
    this.root.addEventListener('dragover', (e) => this.onMediaDragOver(e));
    this.root.addEventListener('dragleave', (e) => this.onMediaDragLeave(e));
    this.root.addEventListener('drop', (e) => this.onMediaDrop(e));
    this.render();
  }

  render() {
    if (!this.root) return;

    const tactic = this.store.selectedTacticId
      ? this.store.getTactic(this.store.selectedTacticId)
      : null;

    if (tactic?.id !== this._lastRenderedTacticId) this.mapSlideIndex = 0;
    this._lastRenderedTacticId = tactic?.id ?? null;

    this.root.innerHTML = tactic ? this.documentTemplate(tactic) : this.emptyTemplate();
    this.autoGrowAll();
  }

  // ---------------------------------------------------
  // Empty state
  // ---------------------------------------------------

  emptyTemplate() {
    const total = this.store.tactics.length;
    return `
      <div class="tc-empty-main">
        <h2>Nenhuma tática aberta</h2>
        <p>
          ${total
            ? 'Escolha uma tática na árvore à esquerda para abrir o editor.'
            : 'Crie sua primeira composição em um mapa para começar a montar o playbook do time.'}
        </p>
      </div>
    `;
  }

  // ---------------------------------------------------
  // Document
  // ---------------------------------------------------

  documentTemplate(tactic) {
    const path = this.store.findTacticPath(tactic.id) || {};
    const map = (typeof app !== 'undefined' && app.getMaps)
      ? (app.getMaps() || []).find(m => String(m.id) === String(path.mapId))
      : null;

    return `
      ${this.headerTemplate(tactic, path, map)}
      <div class="tc-doc" data-tactic-id="${tactic.id}">
        <div class="tc-doc-row">
          ${this.mapSection(tactic, map)}
          ${this.videoSection(tactic)}
        </div>
        ${this.notesCard(tactic)}
      </div>
      ${this.focusModeOverlay(tactic, map)}
    `;
  }

  // --- Modo tático -------------------------------------
  // Tela cheia com só o essencial pra estudo: mapa, imagens extras e vídeo
  // empilhados, sem sidebar, header ou qualquer outro ruído da página.

  focusModeOverlay(tactic, map) {
    const mapImage = tactic.image_url || map?.minimap_url || map?.splash || '';
    const videoUrl = tactic.video_url || '';
    const embed = videoUrl ? this.videoEmbed(videoUrl) : '';

    // Mesmo padrão da view normal: mapa e vídeo lado a lado na mesma linha
    // (.tc-doc-row). O editor de desenho (caneta/borracha/linha/seta/texto)
    // vive só aqui, por cima da imagem do mapa.
    const mapPane = mapImage
      ? `<div class="tc-focus-media" data-draw-container>
           <img class="tc-draw-src" src="${this.escape(mapImage)}" alt="Mapa da tática">
           <canvas class="tc-draw-canvas" data-draw-canvas></canvas>
           <div class="tc-focus-zoom-layer" data-zoom-layer></div>
           <div class="tc-draw-trash" data-draw-trash>
             <i class="fas fa-trash-alt" aria-hidden="true"></i>
           </div>
         </div>`
      : `<div class="tc-focus-media tc-focus-media--empty"><i class="fas fa-map" aria-hidden="true"></i><p>Sem imagem de mapa</p></div>`;

    const videoPane = embed
      ? `<div class="tc-focus-media tc-focus-media--video">${embed}</div>`
      : `<div class="tc-focus-media tc-focus-media--empty"><i class="fas fa-play-circle" aria-hidden="true"></i><p>Nenhum vídeo vinculado</p></div>`;

    return `
      <div class="tc-focus-overlay ${this.focusMode ? 'is-open' : ''}" role="dialog" aria-modal="true"
           aria-label="Modo tático — ${this.escape(tactic.title || 'Sem título')}">
        <header class="tc-focus-head">
          <span class="tc-focus-title">${this.escape(tactic.title || 'Sem título')}</span>
          <button class="tc-icon-btn" data-tc-action="exit-focus" title="Sair do modo tático" aria-label="Sair do modo tático">
            <i class="fas fa-times"></i>
          </button>
        </header>
        <div class="tc-focus-body">
          <div class="tc-focus-row">
            ${mapPane}
            ${videoPane}
          </div>
        </div>
        ${mapImage ? TacticsDrawing.toolbarTemplate() : ''}
      </div>
    `;
  }

  headerTemplate(tactic, path, map) {
    const sideLabel = path.side === 'defense' ? 'Defesa' : 'Ataque';
    return `
      <header class="tc-main-head">
        <nav class="tc-crumbs" aria-label="Trilha">
          <span class="tc-crumb">${this.escape(map?.display_name || 'Mapa')}</span>
          <i class="fas fa-chevron-right" aria-hidden="true"></i>
          <span class="tc-crumb tc-crumb--comp" title="${this.escape(path.compLabel || '')}">
            ${this.escape(path.compLabel || 'Sem composição')}
          </span>
          <i class="fas fa-chevron-right" aria-hidden="true"></i>
          <span class="tc-crumb tc-crumb--side tc-crumb--${path.side || 'attack'}">${sideLabel}</span>
          <i class="fas fa-chevron-right" aria-hidden="true"></i>
          <input class="tc-crumb tc-crumb--current tc-crumb-title" type="text"
                 value="${this.escape(tactic.title || '')}"
                 placeholder="Nome da tática"
                 data-tc-field="title"
                 aria-label="Nome da tática"
                 size="1">
        </nav>

        <div class="tc-main-actions">
          <span class="tc-save-state tc-save-state--${this.saveState}">${this.saveLabel()}</span>
          <button class="tc-btn tc-btn--primary" data-tc-action="new-tactic-here">
            <i class="fas fa-plus"></i> Nova tática
          </button>
          <button class="tc-icon-btn" data-tc-action="focus-search" title="Buscar" aria-label="Buscar">
            <i class="fas fa-search"></i>
          </button>
          <button class="tc-focus-trigger" data-tc-action="enter-focus" title="Entrar em modo tático"
                  aria-label="Entrar em modo tático">
            <i class="fas fa-expand" aria-hidden="true"></i> Modo tático
          </button>
          <div class="tc-menu-wrap">
            <button class="tc-icon-btn" data-tc-action="toggle-menu" title="Mais" aria-label="Mais opções" aria-haspopup="true">
              <i class="fas fa-ellipsis-h"></i>
            </button>
            <div class="tc-menu" data-tc-menu hidden>
              <button class="tc-menu-item tc-menu-item--danger" data-tc-action="delete-tactic">
                <i class="far fa-trash-alt"></i> Excluir
              </button>
            </div>
          </div>
        </div>
      </header>
    `;
  }

  saveLabel() {
    return {
      idle: '',
      saving: 'Salvando…',
      saved: 'Salvo',
      error: 'Falha ao salvar'
    }[this.saveState] || '';
  }

  /**
   * Mapa e vídeo usam um cabeçalho FORA e ACIMA do card da mídia — não
   * dentro dele — para não empurrar/cobrir a imagem. O título só aparece
   * no hover, com um fade puro de opacidade (mesma animação da estrela e
   * da lixeira nas linhas da árvore lateral), sem colapsar altura.
   */
  mediaPane(id, icon, title, body, actions, { fill = false } = {}) {
    return `
      <div class="tc-media-pane" data-section="${id}">
        <div class="tc-media-pane-head">
          <h3 class="tc-card-title"><i class="${icon}" aria-hidden="true"></i> ${title}</h3>
          ${actions}
        </div>
        <section class="tc-card">
          <div class="tc-card-body ${fill ? 'tc-card-body--fill' : ''}">${body}</div>
        </section>
      </div>
    `;
  }

  // --- Interactive map -------------------------------

  /** A imagem do mapa da tática (0 ou 1). Mantido como lista porque o
   * carrossel/goToMapSlide ainda consome esse formato. */
  mapSlides(tactic) {
    return tactic.image_url
      ? [{ url: tactic.image_url, title: tactic.title || 'Sem título', isMap: true }]
      : [];
  }

  mapSection(tactic, map) {
    const slides = this.mapSlides(tactic);
    this.mapSlideIndex = Math.min(this.mapSlideIndex || 0, Math.max(slides.length - 1, 0));
    const paneTitle = this.escape(slides.length ? slides[this.mapSlideIndex].title : (tactic.title || 'Sem título'));

    if (!slides.length) {
      return this.mediaPane('map', 'fas fa-map-marked-alt', paneTitle,
        this.mediaDropBody('map'), this.mapHeadActions(false), { fill: true });
    }

    const active = slides[this.mapSlideIndex];
    const body = `
      <div class="tc-map-carousel">
        <div class="tc-map-canvas tc-map-canvas--clickable" data-tc-action="enter-focus"
             title="Abrir modo tático" role="button" tabindex="0" aria-label="Abrir modo tático">
          ${slides.map((s, i) => `
            <img src="${this.escape(s.url)}" alt="${this.escape(s.title)}" loading="lazy"
                 class="tc-map-carousel-img ${i === this.mapSlideIndex ? 'is-active' : ''}" data-slide-index="${i}">
          `).join('')}
        </div>
        ${slides.length > 1 ? `
          <button class="tc-map-carousel-arrow tc-map-carousel-arrow--prev" type="button"
                  data-tc-action="map-slide-prev" aria-label="Imagem anterior">
            <i class="fas fa-chevron-left"></i>
          </button>
          <button class="tc-map-carousel-arrow tc-map-carousel-arrow--next" type="button"
                  data-tc-action="map-slide-next" aria-label="Próxima imagem">
            <i class="fas fa-chevron-right"></i>
          </button>
          <div class="tc-map-carousel-dots">
            ${slides.map((_, i) => `
              <button class="tc-map-carousel-dot ${i === this.mapSlideIndex ? 'is-active' : ''}" type="button"
                      data-tc-action="map-slide-go" data-slide-index="${i}" aria-label="Ir para imagem ${i + 1}"></button>
            `).join('')}
          </div>
        ` : ''}
      </div>
    `;

    return this.mediaPane('map', 'fas fa-map-marked-alt', paneTitle, body,
      this.mapHeadActions(active.isMap), { fill: true });
  }

  /** Troca de slide sem re-render completo — só atualiza classes/título,
   * pra não perder foco/scroll do resto da página. */
  goToMapSlide(tactic, index) {
    const slides = this.mapSlides(tactic);
    if (!slides.length) return;
    const clamped = ((index % slides.length) + slides.length) % slides.length;
    this.mapSlideIndex = clamped;
    const active = slides[clamped];

    const pane = this.root?.querySelector('.tc-media-pane[data-section="map"]');
    if (!pane) return;

    pane.querySelectorAll('.tc-map-carousel-img').forEach((img, i) => {
      img.classList.toggle('is-active', i === clamped);
    });
    pane.querySelectorAll('.tc-map-carousel-dot').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === clamped);
    });

    const titleEl = pane.querySelector('.tc-media-pane-head .tc-card-title');
    if (titleEl) {
      titleEl.innerHTML = `<i class="fas fa-map-marked-alt" aria-hidden="true"></i> ${this.escape(active.title)}`;
    }

    const clearBtn = pane.querySelector('[data-tc-action="media-clear"]');
    const actionsWrap = pane.querySelector('.tc-media-pane-head');
    if (actionsWrap) {
      if (active.isMap && !clearBtn) {
        actionsWrap.insertAdjacentHTML('beforeend', `
          <button class="tc-icon-btn" type="button" data-tc-action="media-clear" data-media="map" title="Remover" aria-label="Remover imagem do mapa">
            <i class="fas fa-trash"></i>
          </button>
        `);
      } else if (!active.isMap && clearBtn) {
        clearBtn.remove();
      }
    }
  }

  // --- Notes -----------------------------------------
  // Card centralizado abaixo do mapa/vídeo, sempre aberto. Autosave cobre a
  // gravação — sem botão "Salvar".

  static NOTES_MAX_LENGTH = 200;

  notesCard(tactic) {
    const notes = tactic.notes || '';
    return `
      <section class="tc-notes-card">
        <h3 class="tc-notes-card-title"><i class="far fa-sticky-note" aria-hidden="true"></i> Notas</h3>
        <textarea class="tc-notes" rows="3" maxlength="${TacticsEditor.NOTES_MAX_LENGTH}"
                  placeholder="Observações do coach, leituras, ajustes por rodada…"
                  data-tc-field="notes"
                  data-tc-action="notes-input"
                  aria-label="Notas">${this.escape(notes)}</textarea>
        <span class="tc-notes-count" data-notes-count>${notes.length}/${TacticsEditor.NOTES_MAX_LENGTH}</span>
      </section>
    `;
  }

  // --- Video -----------------------------------------

  videoSection(tactic) {
    const url = tactic.video_url || '';
    const editing = !url || this.videoEditing;

    let body;
    if (editing && this.videoInput === 'file') body = this.mediaDropBody('video');
    else if (editing) body = this.videoUrlBody(url);
    else body = this.videoEmbed(url);

    return this.mediaPane('video', 'fas fa-play-circle', 'Referência da Tática', body,
      this.videoHeadActions(editing), { fill: true });
  }

  // --- Mídia: dropzone inline + barra de URL (sem modal) ---------------

  mapHeadActions(filled) {
    return filled
      ? `<button class="tc-icon-btn" type="button" data-tc-action="media-clear" data-media="map"
                 title="Remover" aria-label="Remover imagem do mapa"><i class="fas fa-trash"></i></button>`
      : '';
  }

  videoHeadActions(editing) {
    if (editing) return '';
    return `
      <button class="tc-icon-btn" type="button" data-tc-action="video-edit"
              title="Trocar vídeo" aria-label="Trocar vídeo">
        <i class="fas fa-pen"></i>
      </button>
      <button class="tc-icon-btn" type="button" data-tc-action="media-clear" data-media="video"
              title="Remover" aria-label="Remover vídeo">
        <i class="fas fa-trash"></i>
      </button>
    `;
  }

  mediaDropBody(kind) {
    const isMap = kind === 'map';
    return `
      <div class="tc-media-drop" data-media-drop="${kind}" role="button" tabindex="0"
           aria-label="Enviar ${isMap ? 'imagem do mapa' : 'vídeo de referência'} — clique ou arraste aqui">
        <input type="file" accept="${isMap ? 'image/*' : 'video/*'}" hidden data-media-file="${kind}">
        <i class="fas fa-cloud-upload-alt" aria-hidden="true"></i>
        <p><strong>Clique para enviar</strong> ou arraste ${isMap ? 'uma imagem' : 'um vídeo'} aqui</p>
        <span class="tc-media-drop-status" data-media-status="${kind}"></span>
        ${isMap ? '' : `
          <button class="tc-linklike" type="button" data-tc-action="video-input-url">
            <i class="fas fa-link"></i> ou colar um link do YouTube / Twitch
          </button>
        `}
      </div>
    `;
  }

  /** Vídeo: link é o principal. Input grande, com atalho pra enviar arquivo. */
  videoUrlBody(current) {
    return `
      <div class="tc-video-input">
        <div class="tc-video-input-row">
          <i class="fab fa-youtube" aria-hidden="true"></i>
          <input type="url" class="tc-media-url-input" data-media-url="video"
                 placeholder="Cole o link do YouTube ou Twitch" autocomplete="off"
                 value="${this.escape(current || '')}">
          <button class="tc-btn tc-btn--primary" type="button" data-tc-action="media-url-apply" data-media="video">
            <i class="fas fa-check"></i> Adicionar
          </button>
        </div>
        <button class="tc-linklike" type="button" data-tc-action="video-input-file">
          <i class="fas fa-cloud-upload-alt"></i> ou enviar um arquivo de vídeo
        </button>
      </div>
    `;
  }

  setVideoInput(mode) {
    this.videoInput = mode;
    this.render();
    if (mode === 'url') this.root?.querySelector('[data-media-url="video"]')?.focus();
  }

  editVideo() {
    this.videoEditing = true;
    this.videoInput = 'url';
    this.render();
    this.root?.querySelector('[data-media-url="video"]')?.focus();
  }

  applyMediaUrl(kind) {
    const input = this.root?.querySelector(`[data-media-url="${kind}"]`);
    this.setMediaUrl(kind, input ? input.value : '');
  }

  setMediaUrl(kind, url) {
    const tactic = this.currentTactic();
    if (!tactic) return;
    const clean = (url || '').trim();
    if (kind === 'map') tactic.image_url = clean;
    else tactic.video_url = clean;
    this.videoEditing = false;
    this.videoInput = 'url';
    this.render();
    this.flushSave();
  }

  async uploadMedia(kind, file) {
    if (!file) return;
    const tactic = this.currentTactic();
    if (!tactic) return;

    const drop = this.root?.querySelector(`[data-media-drop="${kind}"]`);
    const status = this.root?.querySelector(`[data-media-status="${kind}"]`);
    drop?.classList.add('is-uploading');
    if (status) status.textContent = `Enviando ${file.name}…`;

    try {
      const fd = new FormData();
      fd.append(kind === 'map' ? 'image' : 'video', file);
      fd.append('type', 'tactics');
      const res = await api.upload(kind === 'map' ? '/upload/image' : '/upload/video', fd);
      if (!res?.url) throw new Error(res?.message || 'Falha no upload');
      this.setMediaUrl(kind, res.url);
    } catch (err) {
      console.error('[tactics] media upload failed', err);
      drop?.classList.remove('is-uploading');
      if (status) status.textContent = 'Falha no upload — tente colar o link.';
    }
  }

  /** Build a player for the supported hosts; falls back to a plain link. */
  videoEmbed(url) {
    const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/);
    if (yt) {
      return `<div class="tc-video"><iframe src="https://www.youtube.com/embed/${yt[1]}"
                title="Vídeo de referência" allowfullscreen loading="lazy"></iframe></div>`;
    }

    const twitch = url.match(/twitch\.tv\/videos\/(\d+)/);
    if (twitch) {
      return `<div class="tc-video"><iframe
                src="https://player.twitch.tv/?video=${twitch[1]}&parent=${location.hostname}"
                title="Vídeo de referência" allowfullscreen loading="lazy"></iframe></div>`;
    }

    if (/\.(mp4|webm|ogg)(\?|$)/i.test(url)) {
      return `<div class="tc-video"><video src="${this.escape(url)}" controls preload="metadata"></video></div>`;
    }

    return `<a class="tc-video-link" href="${this.escape(url)}" target="_blank" rel="noopener noreferrer">
              <i class="fas fa-external-link-alt"></i> Abrir vídeo
            </a>`;
  }

  // ---------------------------------------------------
  // Events
  // ---------------------------------------------------

  /** Ativa por teclado (Enter/Espaço) elementos não-button com role="button". */
  onActionKeydown(e) {
    // Barra de URL da mídia: Enter aplica, Esc fecha.
    if (e.target.matches?.('[data-media-url]')) {
      if (e.key === 'Enter') { e.preventDefault(); this.setMediaUrl(e.target.dataset.mediaUrl, e.target.value); }
      if (e.key === 'Escape') { e.preventDefault(); this.videoEditing = false; this.render(); }
      return;
    }

    if (e.key !== 'Enter' && e.key !== ' ') return;

    // Dropzone: Enter/Espaço abre o seletor de arquivo.
    const drop = e.target.closest('[data-media-drop]');
    if (drop && this.root.contains(drop)) {
      e.preventDefault();
      drop.querySelector('input[type="file"]')?.click();
      return;
    }

    const el = e.target.closest('[role="button"][data-tc-action]');
    if (!el || !this.root.contains(el)) return;
    e.preventDefault();
    el.click();
  }

  onClick(e) {
    // Dropzone inline: clicar em área vazia abre o seletor de arquivo (mas não
    // quando o clique foi num botão dentro dela, ex. "ou colar um link").
    const drop = e.target.closest('[data-media-drop]');
    if (drop && this.root.contains(drop) && !e.target.closest('[data-tc-action]')) {
      drop.querySelector('input[type="file"]')?.click();
      return;
    }

    const el = e.target.closest('[data-tc-action]');
    if (!el || !this.root.contains(el)) return;

    const action = el.dataset.tcAction;

    // Any click outside the menu closes it.
    if (action !== 'toggle-menu') this.closeMenu();

    switch (action) {
      case 'toggle-menu': {
        const menu = this.root.querySelector('[data-tc-menu]');
        if (menu) menu.hidden = !menu.hidden;
        break;
      }
      case 'focus-search':
        this.controller.focusSearch();
        break;
      case 'new-tactic-here':
        this.controller.promptNewTacticNextTo(this.store.selectedTacticId);
        break;
      case 'delete-tactic':
        this.controller.confirmDeleteTactic(this.store.selectedTacticId);
        break;
      case 'media-url-apply':
        this.applyMediaUrl(el.dataset.media);
        break;
      case 'media-clear':
        this.setMediaUrl(el.dataset.media, '');
        break;
      case 'video-edit':
        this.editVideo();
        break;
      case 'video-input-url':
        this.setVideoInput('url');
        break;
      case 'video-input-file':
        this.setVideoInput('file');
        break;
      case 'map-slide-prev':
        this.goToMapSlide(this.currentTactic(), this.mapSlideIndex - 1);
        break;
      case 'map-slide-next':
        this.goToMapSlide(this.currentTactic(), this.mapSlideIndex + 1);
        break;
      case 'map-slide-go':
        this.goToMapSlide(this.currentTactic(), Number(el.dataset.slideIndex));
        break;
      case 'enter-focus':
        this.setFocusMode(true);
        break;
      case 'exit-focus':
        this.setFocusMode(false);
        break;
    }
  }

  /** iframes (YouTube/Twitch) não têm pause() sem o SDK deles — reatribuir o
   * próprio src recarrega o frame, o que para a reprodução. <video> local só
   * precisa de .pause(). Chamado ao trocar de/para modo tático, porque o
   * painel de vídeo que sai de vista (normal ou do overlay) só é escondido
   * via CSS, nunca desmontado, e continuaria tocando escondido. */
  stopAllVideos() {
    this.root?.querySelectorAll('.tc-video iframe').forEach(f => { f.src = f.src; });
    this.root?.querySelectorAll('.tc-video video').forEach(v => v.pause());
  }

  setFocusMode(open) {
    this.stopAllVideos();
    this.focusMode = open;
    const overlay = this.root?.querySelector('.tc-focus-overlay');
    overlay?.classList.toggle('is-open', open);
    document.body.classList.toggle('tc-focus-active', open);

    this._escFocusHandler = this._escFocusHandler || ((e) => {
      if (e.key === 'Escape' && this.focusMode) this.setFocusMode(false);
    });

    if (open) {
      document.addEventListener('keydown', this._escFocusHandler);
      // Depois da transição de abertura o container já tem as dimensões
      // finais — monta o canvas de desenho sobre a imagem do mapa.
      requestAnimationFrame(() => this.mountFocusDrawing());
    } else {
      document.removeEventListener('keydown', this._escFocusHandler);
      this.focusDrawing?.destroy();
      this.focusDrawing = null;
    }
  }

  mountFocusDrawing() {
    const tactic = this.currentTactic();
    const canvas = this.root?.querySelector('.tc-focus-overlay [data-draw-canvas]');
    const toolbar = this.root?.querySelector('.tc-focus-overlay [data-draw-toolbar]');
    if (!tactic || !canvas) return;

    if (!this.focusDrawing) this.focusDrawing = new TacticsDrawing(this);
    this.focusDrawing.mount(canvas, toolbar, tactic, () => this.flushSave());
  }

  closeMenu() {
    const menu = this.root?.querySelector('[data-tc-menu]');
    if (menu) menu.hidden = true;
  }

  onInput(e) {
    const el = e.target;
    if (el.tagName === 'TEXTAREA') this.autoGrow(el);
    if (el.dataset.tcAction === 'notes-input') this.updateNotesCount(el);
    if (el.dataset.tcField || el.dataset.tcList) this.scheduleSave();
  }

  updateNotesCount(textarea) {
    const counter = textarea.parentElement?.querySelector('[data-notes-count]');
    if (counter) counter.textContent = `${textarea.value.length}/${TacticsEditor.NOTES_MAX_LENGTH}`;
  }

  onChange(e) {
    if (e.target.matches?.('[data-media-file]')) {
      this.uploadMedia(e.target.dataset.mediaFile, e.target.files?.[0]);
      return;
    }
    if (e.target.dataset.tcField || e.target.dataset.tcList) this.scheduleSave();
  }

  /** Duplo clique no título do painel de mapa abre a edição do nome da tática. */
  onDblClick(e) {
    const h3 = e.target.closest('.tc-media-pane[data-section="map"] .tc-card-title');
    if (h3) this.startTitleEdit(h3);
  }

  startTitleEdit(h3) {
    const tactic = this.currentTactic();
    if (!tactic || h3.querySelector('input')) return;

    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'tc-media-title-input';
    input.maxLength = 120;
    input.value = tactic.title || '';
    h3.replaceWith(input);
    input.focus();
    input.select();

    const commit = () => {
      const v = input.value.trim();
      const changed = v && v !== tactic.title;
      if (changed) tactic.title = v;
      this.render();
      if (changed) { this.flushSave(); this.controller.refreshTree(); }
    };

    input.addEventListener('keydown', (ev) => {
      if (ev.key === 'Enter') { ev.preventDefault(); commit(); }
      if (ev.key === 'Escape') { ev.preventDefault(); this.render(); }
    });
    input.addEventListener('blur', commit);
  }

  // --- Mídia: soltar arquivo direto no painel de mapa/vídeo -----------

  onMediaDragOver(e) {
    const pane = e.target.closest?.('.tc-media-pane[data-section="map"], .tc-media-pane[data-section="video"]');
    if (!pane || !e.dataTransfer?.types?.includes('Files')) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
    pane.classList.add('is-file-dragover');
  }

  onMediaDragLeave(e) {
    e.target.closest?.('.tc-media-pane')?.classList.remove('is-file-dragover');
  }

  onMediaDrop(e) {
    const pane = e.target.closest?.('.tc-media-pane[data-section="map"], .tc-media-pane[data-section="video"]');
    if (!pane) return;
    const file = e.dataTransfer?.files?.[0];
    if (!file) return;
    e.preventDefault();
    pane.classList.remove('is-file-dragover');
    this.uploadMedia(pane.dataset.section, file);
  }

  onBlur(e) {
    if (e.target.dataset.tcField || e.target.dataset.tcList) this.flushSave();
  }

  // ---------------------------------------------------
  // Saving
  // ---------------------------------------------------

  currentTactic() {
    return this.store.selectedTacticId ? this.store.getTactic(this.store.selectedTacticId) : null;
  }

  /** Read every editable field in the DOM back into the tactic object. */
  collect() {
    const tactic = this.currentTactic();
    if (!tactic || !this.root) return null;

    this.root.querySelectorAll('[data-tc-field]').forEach(el => {
      tactic[el.dataset.tcField] = el.value;
    });

    return tactic;
  }

  scheduleSave() {
    clearTimeout(this.saveTimer);
    this.saveTimer = setTimeout(() => this.flushSave(), TacticsEditor.AUTOSAVE_MS);
  }

  async flushSave() {
    clearTimeout(this.saveTimer);

    const tactic = this.collect();
    if (!tactic) return;

    this.setSaveState('saving');

    try {
      await api.updateTactic(tactic.id, {
        title: tactic.title,
        notes: tactic.notes,
        image_url: tactic.image_url || null,
        video_url: tactic.video_url || null,
        drawing_data: this.focusDrawing ? this.focusDrawing.getElements() : this.parseJson(tactic.drawing_data)
      });

      this.setSaveState('saved');
      // The title shows up in the tree (the breadcrumb input already reflects itself).
      this.controller.refreshTree();
    } catch (err) {
      console.error('[tactics] save failed', err);
      this.setSaveState('error');
    }
  }

  setSaveState(state) {
    this.saveState = state;
    const el = this.root?.querySelector('.tc-save-state');
    if (el) {
      el.className = `tc-save-state tc-save-state--${state}`;
      el.textContent = this.saveLabel();
    }
    if (state === 'saved') {
      setTimeout(() => {
        if (this.saveState === 'saved') this.setSaveState('idle');
      }, 2000);
    }
  }

  // ---------------------------------------------------
  // Utils
  // ---------------------------------------------------

  parseJson(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  }

  autoGrow(el) {
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  }

  autoGrowAll() {
    this.root?.querySelectorAll('textarea').forEach(el => this.autoGrow(el));
  }

  escape(value) {
    return String(value ?? '').replace(/[&<>"']/g, ch => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[ch]));
  }
}


/* ===== js/tactics/tactics-modals.js ===== */
// =====================================================
// ZDVAL - Tactics Modals
// Composition picker, tactic creation, destructive confirms.
//
// Every modal resolves a promise, so callers read as plain async code:
//   const comp = await modals.composition({ mapName });
// =====================================================

class TacticsModals {
  static COMP_SIZE = 5;

  constructor() {
    this.host = null;
    this.escHandler = null;
  }

  // ---------------------------------------------------
  // Shell
  // ---------------------------------------------------

  /**
   * `onCancel` roda no X, no backdrop e no Esc. Recebido aqui — e não
   * atribuído em this.reject antes de chamar open() — porque open() começa
   * fechando o modal anterior, o que limpava o callback recém-definido.
   */
  open({ title, subtitle = '', body, footer, width = 480, onMount, onCancel }) {
    this.close();
    this.reject = onCancel || null;

    const host = document.createElement('div');
    host.className = 'tc-modal-overlay';
    host.innerHTML = `
      <div class="tc-modal" style="--tc-modal-w:${width}px" role="dialog" aria-modal="true"
           aria-label="${this.escape(title)}">
        <header class="tc-modal-head">
          <div>
            <h2 class="tc-modal-title">${this.escape(title)}</h2>
            ${subtitle ? `<p class="tc-modal-sub">${this.escape(subtitle)}</p>` : ''}
          </div>
          <button class="tc-icon-btn" data-tc-close aria-label="Fechar"><i class="fas fa-times"></i></button>
        </header>
        <div class="tc-modal-body">${body}</div>
        <footer class="tc-modal-foot">${footer}</footer>
      </div>
    `;

    document.body.appendChild(host);
    this.host = host;

    // Backdrop click and the X both cancel.
    host.addEventListener('click', (e) => {
      if (e.target === host || e.target.closest('[data-tc-close]')) this.reject?.();
    });

    this.escHandler = (e) => {
      if (e.key === 'Escape') { e.stopPropagation(); this.reject?.(); }
    };
    document.addEventListener('keydown', this.escHandler);

    requestAnimationFrame(() => {
      host.classList.add('is-open');
      onMount?.(host);
    });

    return host;
  }

  close() {
    if (this.escHandler) {
      document.removeEventListener('keydown', this.escHandler);
      this.escHandler = null;
    }
    this.host?.remove();
    this.host = null;
    this.reject = null;
  }

  // ---------------------------------------------------
  // Composition picker
  // ---------------------------------------------------

  /**
   * Pick exactly 5 agents. Resolves with the agent array, or null if cancelled.
   */
  composition({ mapName, slot }) {
    return new Promise((resolve) => {
      const groups = TacticsStore.agentsByRole();
      const byId = new Map();
      groups.forEach(g => g.agents.forEach(a => byId.set(String(a.id), a)));

      const selected = [];
      const done = (value) => { this.close(); resolve(value); };

      const host = this.open({
        title: 'Nova composição',
        subtitle: `${mapName} • slot ${slot} de ${TacticsStore.MAX_COMPS_PER_MAP}`,
        width: 860,
        onCancel: () => done(null),
        body: `
          <p class="tc-modal-hint">
            Selecione ${TacticsModals.COMP_SIZE} agentes. Passe o mouse para ver as habilidades.
          </p>
          <div class="tc-roster" data-roster>
            ${groups.length
              ? groups.map(g => this.roleGroup(g)).join('')
              : '<p class="tc-list-empty">Nenhum agente carregado.</p>'}
          </div>
        `,
        footer: `
          <div class="tc-picked" data-picked></div>
          <div class="tc-modal-btns">
            <button class="tc-btn" data-tc-close>Cancelar</button>
            <button class="tc-btn tc-btn--primary" data-confirm disabled>Criar composição</button>
          </div>
        `
      });

      const picked = host.querySelector('[data-picked]');
      const confirm = host.querySelector('[data-confirm]');

      const syncFooter = () => {
        const slots = Array.from({ length: TacticsModals.COMP_SIZE }, (_, i) => {
          const agent = selected[i];
          return agent
            ? `<span class="tc-picked-slot is-filled" title="${this.escape(agent.name)}">
                 <img src="${this.escape(agent.icon)}" alt="${this.escape(agent.name)}">
               </span>`
            : '<span class="tc-picked-slot"></span>';
        }).join('');

        picked.innerHTML = `
          ${slots}
          <span class="tc-modal-counter">${selected.length} / ${TacticsModals.COMP_SIZE}</span>
        `;
        confirm.disabled = selected.length !== TacticsModals.COMP_SIZE;
      };

      host.querySelector('[data-roster]')?.addEventListener('click', (e) => {
        const card = e.target.closest('.tc-agent-card');
        if (!card) return;

        const id = card.dataset.agentId;
        const index = selected.findIndex(a => String(a.id) === String(id));

        if (index >= 0) {
          selected.splice(index, 1);
          card.classList.remove('is-selected');
        } else {
          if (selected.length >= TacticsModals.COMP_SIZE) return;
          const agent = byId.get(String(id));
          if (!agent) return;
          // Guardado no banco: só o necessário para rotular a composição.
          selected.push({ id: agent.id, name: agent.name, icon: agent.icon });
          card.classList.add('is-selected');
        }

        // Cheio: o que não foi escolhido apaga, em vez de fingir ser clicável.
        host.querySelector('[data-roster]')
            .classList.toggle('is-full', selected.length >= TacticsModals.COMP_SIZE);

        syncFooter();
      });

      confirm.addEventListener('click', () => done(selected.slice()));
      syncFooter();
    });
  }

  roleGroup(group) {
    return `
      <section class="tc-role">
        <h4 class="tc-role-title">
          <span class="tc-role-dot tc-role-dot--${group.key}" aria-hidden="true"></span>
          ${this.escape(group.label)}
          <span class="tc-role-count">${group.agents.length}</span>
        </h4>
        <div class="tc-agent-grid">${group.agents.map(a => this.agentCard(a)).join('')}</div>
      </section>
    `;
  }

  agentCard(agent) {
    const abilities = TacticsStore.agentAbilities(agent);
    const gc = agent.gradient || {};
    const gradientStyle = gc.g0 ? `style="--agent-g0: ${this.escape(gc.g0)}; --agent-g1: ${this.escape(gc.g1)}; --agent-g2: ${this.escape(gc.g2)};"` : '';
    return `
      <button type="button" class="tc-agent-card" data-agent-id="${this.escape(agent.id)}"
              title="${this.escape(agent.name)}" ${gradientStyle}>
        <span class="tc-agent-portrait">
          ${agent.icon
            ? `<img src="${this.escape(agent.icon)}" alt="" loading="lazy">`
            : '<i class="fas fa-user-secret" aria-hidden="true"></i>'}
          <span class="tc-agent-check" aria-hidden="true"><i class="fas fa-check"></i></span>
        </span>
        <span class="tc-agent-name">${this.escape(agent.name)}</span>
        ${abilities.length ? `
          <span class="tc-agent-abilities">
            ${abilities.map(ab => `
              <span class="tc-ability" title="${this.escape(ab.displayName || ab.name)} (${this.escape(ab.key || '')})">
                <img src="${this.escape(ab.displayIcon)}" alt="" loading="lazy">
              </span>
            `).join('')}
          </span>
        ` : ''}
      </button>
    `;
  }

  // ---------------------------------------------------
  // Nova pasta
  // ---------------------------------------------------

  /** Ask for a folder name. Resolves the trimmed name, or null if cancelled. */
  newFolder({ compLabel = '', sideLabel = '' } = {}) {
    return new Promise((resolve) => {
      const done = (value) => { this.close(); resolve(value); };

      const host = this.open({
        title: 'Nova pasta',
        subtitle: [compLabel, sideLabel].filter(Boolean).join(' • '),
        onCancel: () => done(null),
        body: `
          <label class="tc-field">
            <span>Nome</span>
            <input type="text" data-name placeholder="Ex: Anti-eco, Pistol, Retake" maxlength="80" autocomplete="off">
          </label>
        `,
        footer: `
          <div class="tc-modal-btns">
            <button class="tc-btn" data-tc-close>Cancelar</button>
            <button class="tc-btn tc-btn--primary" data-confirm>Criar pasta</button>
          </div>
        `,
        onMount: (h) => h.querySelector('[data-name]')?.focus()
      });

      const submit = () => {
        const name = host.querySelector('[data-name]').value.trim();
        if (!name) { host.querySelector('[data-name]').focus(); return; }
        done(name);
      };

      host.querySelector('[data-confirm]').addEventListener('click', submit);
      host.querySelector('[data-name]').addEventListener('keydown', (e) => {
        if (e.key === 'Enter') submit();
      });
    });
  }

  // ---------------------------------------------------
  // Opponent team (Antitático) — mesmo shell, form próprio.
  // ---------------------------------------------------

  /**
   * Ask for opponent team name/tag. Resolves { name, tag } or null.
   * `initial` prefills the fields for editing.
   */
  opponent({ title = 'Adicionar Time Adversário', confirmLabel = 'Adicionar Time', initial = {} } = {}) {
    return new Promise((resolve) => {
      const done = (value) => { this.close(); resolve(value); };

      const host = this.open({
        title,
        onCancel: () => done(null),
        body: `
          <label class="tc-field">
            <span>Nome do time</span>
            <input type="text" data-name-input placeholder="Ex: LOUD, FURIA..." autocomplete="off" value="${this.escape(initial.name || '')}">
          </label>
          <label class="tc-field">
            <span>Tag <em>opcional</em></span>
            <input type="text" data-tag-input placeholder="Ex: LOUD" maxlength="10" autocomplete="off" value="${this.escape(initial.tag || '')}">
          </label>
        `,
        footer: `
          <div class="tc-modal-btns">
            <button class="tc-btn" data-tc-close>Cancelar</button>
            <button class="tc-btn tc-btn--primary" data-confirm>${this.escape(confirmLabel)}</button>
          </div>
        `,
        onMount: (h) => h.querySelector('[data-name-input]')?.focus()
      });

      const nameInput = host.querySelector('[data-name-input]');

      const submit = () => {
        const name = nameInput.value.trim();
        if (!name) { nameInput.focus(); return; }
        done({
          name,
          tag: host.querySelector('[data-tag-input]').value.trim() || null
        });
      };

      host.querySelector('[data-confirm]').addEventListener('click', submit);
      host.querySelectorAll('input').forEach(inp => inp.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') submit();
      }));
    });
  }

  // ---------------------------------------------------
  // Confirm
  // ---------------------------------------------------

  /** Destructive confirmation. Resolves true only on explicit confirm. */
  confirm({ title, message, confirmLabel = 'Excluir' }) {
    return new Promise((resolve) => {
      const done = (value) => { this.close(); resolve(value); };

      const host = this.open({
        title,
        width: 420,
        onCancel: () => done(false),
        body: `<p class="tc-modal-message">${this.escape(message)}</p>`,
        footer: `
          <div class="tc-modal-btns">
            <button class="tc-btn" data-tc-close>Cancelar</button>
            <button class="tc-btn tc-btn--danger" data-confirm>${this.escape(confirmLabel)}</button>
          </div>
        `,
        onMount: (h) => h.querySelector('[data-confirm]')?.focus()
      });

      host.querySelector('[data-confirm]').addEventListener('click', () => done(true));
    });
  }

  escape(value) {
    return String(value ?? '').replace(/[&<>"']/g, ch => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[ch]));
  }
}


/* ===== js/tactics/tactics.js ===== */
// =====================================================
// ZDVAL - Tactics
// Orchestrator for /tactics. Owns the page shell and wires together
// store (data), tree (sidebar), editor (document) and modals.
//
// Loaded after tactics-store.js / tactics-tree.js / tactics-editor.js /
// tactics-modals.js — see index.html.
// =====================================================

class Tactics {
  constructor() {
    this.store = new TacticsStore();
    this.modals = new TacticsModals();
    this.tree = new TacticsTree(this.store, this);
    this.editor = new TacticsEditor(this.store, this);

    this.currentSection = 'tactics';
    this.mounted = false;
  }

  /**
   * A página é pública só para leitura. Deslogado, uma ação de escrita bateria
   * 401 e sujaria o console — barra antes e avisa.
   */
  requireLogin() {
    const logged = typeof auth !== 'undefined' && auth && auth.isAuthenticated;
    if (!logged) {
      app.showToast('Entre na sua conta para criar ou editar táticas.', 'info');
      return false;
    }
    return true;
  }

  // ---------------------------------------------------
  // Page lifecycle
  // ---------------------------------------------------

  async load(params = null) {
    // Folha desta pagina, sob demanda. Estava no <head> do index.html, ou seja,
    // baixada em toda visita a qualquer pagina do site.
    Utils.loadPageCss('tactics-page-css', 'tactics.css');
    Utils.loadPageCss('antitactic-legacy-css', 'antitactic-legacy.css');

    this.renderShell();

    // Modo Time/Pessoal: time só é uma opção quando existe; sem time, cai
    // direto em pessoal. Preferência lembrada por navegador (não por time).
    const team = app.currentTeam;
    const savedMode = localStorage.getItem('zdval:tactics:mode');
    this.mode = (team && savedMode !== 'personal') ? 'team' : 'personal';
    if (!team) this.mode = 'personal';

    this.renderModeToggle();

    this.setLoading(true);
    await this.store.load(this.mode === 'team' ? team.id : null);
    this.setLoading(false);

    // O editor é uma instância única (não recriada por navegação) — sem
    // isso, voltar pra /tactics depois de sair pelo menu reabre com o modo
    // tático ainda ligado de uma visita anterior. Usa o método (não a
    // propriedade crua) pra também remover o listener de Esc e a classe
    // tc-focus-active do body, senão ficam presos.
    if (this.editor.focusMode) this.editor.setFocusMode(false);

    this.tree.render();
    this.editor.render();

    // Fundo dos ícones de agente e as habilidades reais (nome/ícone) da
    // Sequência de Utilitárias reusam esse mesmo cache (valorant-api) —
    // carrega em paralelo e re-renderiza árvore + editor quando chegar
    // (não trava a UI, mas sem isso os dropdowns de habilidade abririam
    // vazios na primeiríssima carga da página).
    TacticsStore.loadAgentGradients().then(() => {
      this.tree.render();
      this.editor.render();
    });

    if (params?.tactic) this.openTactic(params.tactic);
  }

  renderShell() {
    const page = document.getElementById('page-tactics');
    if (!page) return;

    // app.js controla a classe .active para mostrar/esconder a página —
    // nunca sobrescrever className aqui, só alternar a nossa própria classe.
    page.classList.add('tc-page');
    page.innerHTML = `
      <aside class="tc-sidebar" id="tcSidebar">
        <div class="tc-mode-toggle" id="tcModeToggle"></div>
        <div class="tc-sidebar-tree" id="tcSidebarTree"></div>
      </aside>
      <main class="tc-main" id="tcMain"></main>
      <div class="tc-loading" id="tcLoading" hidden><span class="tc-spinner"></span></div>
    `;

    this.tree.mount(document.getElementById('tcSidebarTree'));
    this.editor.mount(document.getElementById('tcMain'));
    this.mounted = true;
  }

  setLoading(on) {
    const el = document.getElementById('tcLoading');
    if (el) el.hidden = !on;
  }

  /** Alternador Time/Pessoal — só aparece quando o usuário tem time; sem
   * time, o usuário já está sempre em modo pessoal, sem escolha a fazer. */
  renderModeToggle() {
    const el = document.getElementById('tcModeToggle');
    if (!el) return;

    const team = app.currentTeam;
    if (!team) {
      el.innerHTML = '';
      el.hidden = true;
      return;
    }

    el.hidden = false;
    el.innerHTML = `
      <button type="button" class="tc-mode-btn ${this.mode === 'team' ? 'active' : ''}" data-tc-mode="team">
        <i class="fas fa-users"></i> Time
      </button>
      <button type="button" class="tc-mode-btn ${this.mode === 'personal' ? 'active' : ''}" data-tc-mode="personal">
        <i class="fas fa-user"></i> Pessoal
      </button>
    `;
    el.querySelectorAll('[data-tc-mode]').forEach(btn => {
      btn.addEventListener('click', () => this.setMode(btn.dataset.tcMode));
    });
  }

  async setMode(mode) {
    if (this.mode === mode) return;
    this.mode = mode;
    localStorage.setItem('zdval:tactics:mode', mode);
    this.renderModeToggle();

    const team = app.currentTeam;
    this.setLoading(true);
    await this.store.load(mode === 'team' ? team?.id : null);
    this.setLoading(false);
    this.store.selectedTacticId = null;
    this.tree.render();
    this.editor.render();
  }

  /**
   * AntiTático virou página própria (/antitatico, item do cabeçalho).
   * Mantido como atalho de navegação para chamadas legadas em antitactic.js.
   */
  switchSection(section) {
    app.navigate(section === 'antitactic' ? 'antitactic' : 'tactics');
  }

  // ---------------------------------------------------
  // Tree / editor coordination
  // ---------------------------------------------------

  refreshTree() {
    this.tree.render();
  }

  focusSearch() {
    document.querySelector('[data-tc-action="search"]')?.focus();
  }

  openTactic(tacticId) {
    const tactic = this.store.getTactic(tacticId);
    if (!tactic) return;

    this.store.selectedTacticId = tactic.id;
    this.store.revealTactic(tactic.id);
    this.tree.render();
    this.editor.render();
  }

  // ---------------------------------------------------
  // Compositions
  // ---------------------------------------------------

  async promptNewComposition(mapId) {
    if (!this.requireLogin()) return;
    if (!this.store.canAddCompToMap(mapId)) {
      app.showToast(`Limite de ${TacticsStore.MAX_COMPS_PER_MAP} composições por mapa.`, 'warning');
      return;
    }

    const map = (app.getMaps() || []).find(m => String(m.id) === String(mapId));
    const slot = this.store.compKeysForMap(mapId).length + 1;

    const composition = await this.modals.composition({
      mapName: map?.display_name || 'Mapa',
      slot
    });
    if (!composition) return;

    // A composition is materialised as its two side folders. Without them
    // there is nowhere to hang tactics, and the group would vanish on reload.
    try {
      await Promise.all(TacticsStore.SIDES.map(side =>
        api.createTacticFolder({
          team_id: this.store.teamId,
          map_id: mapId,
          side: side.id,
          name: 'Default',
          composition
        })
      ));

      await this.reload();
      this.store.expand(TacticsStore.mapNodeId(mapId));
      this.store.expand(TacticsStore.compNodeId(mapId, TacticsStore.compKey(composition)));
      this.tree.render();
      app.showToast('Composição criada', 'success');
    } catch (err) {
      console.error('[tactics] create composition failed', err);
      app.showToast('Erro ao criar composição', 'error');
    }
  }

  async confirmDeleteComposition(mapId, compKey) {
    if (!this.requireLogin()) return;
    const folders = this.store.foldersFor(mapId, compKey);
    const tacticCount = this.store.tactics.filter(t =>
      folders.some(f => String(f.id) === String(t.folder_id))
    ).length;

    const ok = await this.modals.confirm({
      title: 'Excluir composição',
      message: tacticCount
        ? `Isso apaga a composição e suas ${tacticCount} tática(s). Não dá para desfazer.`
        : 'Isso apaga a composição. Não dá para desfazer.',
      confirmLabel: 'Excluir composição'
    });
    if (!ok) return;

    try {
      // Deleting a folder cascades to its tactics on the backend.
      await Promise.all(folders.map(f => api.deleteTacticFolder(f.id)));

      if (this.store.selectedTacticId) {
        const stillThere = this.store.tactics.some(t =>
          String(t.id) === String(this.store.selectedTacticId) &&
          !folders.some(f => String(f.id) === String(t.folder_id))
        );
        if (!stillThere) this.store.selectedTacticId = null;
      }

      await this.reload();
      this.tree.render();
      this.editor.render();
      app.showToast('Composição excluída', 'success');
    } catch (err) {
      console.error('[tactics] delete composition failed', err);
      app.showToast('Erro ao excluir composição', 'error');
    }
  }

  // ---------------------------------------------------
  // Tactics
  // ---------------------------------------------------

  /**
   * Nova pasta dentro de uma composição/lado. Vale nos dois modos: em pessoal
   * o teamId é null e a rota grava a pasta no dono logado.
   */
  async promptNewFolder({ mapId, compKey, side }) {
    if (!this.requireLogin()) return;
    const folders = this.store.foldersFor(mapId, compKey, side);
    const base = folders[0] || this.store.foldersFor(mapId, compKey)[0];

    if (!base) {
      app.showToast('Composição sem pasta para este lado.', 'error');
      return;
    }

    // A pasta nova pertence à mesma composição — sem isso ela viraria um
    // grupo separado na árvore.
    const composition = TacticsStore.parseComposition(base.composition);
    const sideLabel = TacticsStore.SIDES.find(s => s.id === side)?.label || '';
    const name = await this.modals.newFolder({
      compLabel: TacticsStore.compLabel(composition),
      sideLabel
    });
    if (!name) return;

    try {
      await api.createTacticFolder({
        team_id: this.store.teamId,
        map_id: mapId,
        side,
        name,
        composition
      });

      await this.reload();
      this.store.expand(TacticsStore.sideNodeId(mapId, compKey, side));
      this.tree.render();
      app.showToast('Pasta criada', 'success');
    } catch (err) {
      console.error('[tactics] create folder failed', err);
      app.showToast('Erro ao criar pasta', 'error');
    }
  }

  /**
   * Cria a tática direto, sem modal. O lado e a composição vêm da própria
   * pasta. `title` vazio → nome padrão (o usuário renomeia com 2 cliques).
   * Devolve true no sucesso — a árvore usa pra fechar o rascunho inline.
   */
  async createTacticInFolder(folderId, title) {
    if (!this.requireLogin()) return false;
    const folder = this.store.getFolder(folderId);
    if (!folder) {
      app.showToast('Pasta não encontrada.', 'error');
      return false;
    }

    try {
      const res = await api.createTactic({
        team_id: this.store.teamId,
        map_id: folder.map_id,
        folder_id: folder.id,
        side: folder.side || 'attack',
        title: (title || '').trim() || 'Nova tática',
        attachments: []
      });

      await this.reload();

      const created = res?.data?.tactic;
      if (created) this.openTactic(created.id);
      else this.tree.render();

      app.showToast('Tática criada', 'success');
      return true;
    } catch (err) {
      console.error('[tactics] create tactic in folder failed', err);
      app.showToast('Erro ao criar tática', 'error');
      return false;
    }
  }

  /** "+ Nova tática" no header — cria na mesma pasta/lado da tática aberta. */
  promptNewTacticNextTo(tacticId) {
    const path = this.store.findTacticPath(tacticId);
    if (!path?.folderId) {
      app.showToast('Abra uma tática ou use o + na árvore.', 'info');
      return;
    }
    return this.createTacticInFolder(path.folderId, '');
  }

  async confirmDeleteTactic(tacticId) {
    if (!this.requireLogin()) return;
    const tactic = this.store.getTactic(tacticId);
    if (!tactic) return;

    const ok = await this.modals.confirm({
      title: 'Excluir tática',
      message: `“${tactic.title || 'Sem título'}” será apagada. Não dá para desfazer.`
    });
    if (!ok) return;

    try {
      await api.deleteTactic(tacticId);
      if (String(this.store.selectedTacticId) === String(tacticId)) {
        this.store.selectedTacticId = null;
      }
      await this.reload();
      this.tree.render();
      this.editor.render();
      app.showToast('Tática excluída', 'success');
    } catch (err) {
      console.error('[tactics] delete failed', err);
      app.showToast('Erro ao excluir', 'error');
    }
  }

  async confirmDeleteFolder(folderId) {
    if (!this.requireLogin()) return;
    const folder = this.store.getFolder(folderId);
    if (!folder) return;

    const count = this.store.tactics.filter(
      t => String(t.folder_id) === String(folderId)
    ).length;

    const ok = await this.modals.confirm({
      title: 'Excluir pasta',
      message: count
        ? `“${folder.name}” e as ${count} tática(s) dentro dela serão apagadas. Não dá para desfazer.`
        : `“${folder.name}” será apagada. Não dá para desfazer.`,
      confirmLabel: 'Excluir pasta'
    });
    if (!ok) return;

    try {
      await api.deleteTacticFolder(folderId);
      if (this.store.selectedTacticId) {
        const gone = this.store.tactics.some(t =>
          String(t.id) === String(this.store.selectedTacticId) &&
          String(t.folder_id) === String(folderId));
        if (gone) this.store.selectedTacticId = null;
      }
      await this.reload();
      this.tree.render();
      this.editor.render();
      app.showToast('Pasta excluída', 'success');
    } catch (err) {
      console.error('[tactics] delete folder failed', err);
      app.showToast('Erro ao excluir pasta', 'error');
    }
  }

  async renameFolder(folderId, name) {
    if (!this.requireLogin()) return;
    const folder = this.store.getFolder(folderId);
    if (!folder || !name || name === folder.name) return;

    try {
      await api.updateTacticFolder(folderId, { name });
      await this.reload();
      this.tree.render();
      app.showToast('Pasta renomeada', 'success');
    } catch (err) {
      console.error('[tactics] rename folder failed', err);
      app.showToast('Erro ao renomear pasta', 'error');
    }
  }

  async renameTactic(tacticId, title) {
    if (!this.requireLogin()) return;
    const tactic = this.store.getTactic(tacticId);
    if (!tactic || !title || title === tactic.title) return;

    try {
      await api.updateTactic(tacticId, { title });
      await this.reload();
      this.tree.render();
      this.editor.render();
      app.showToast('Tática renomeada', 'success');
    } catch (err) {
      console.error('[tactics] rename tactic failed', err);
      app.showToast('Erro ao renomear', 'error');
    }
  }

  // ---------------------------------------------------
  // Data
  // ---------------------------------------------------

  async reload() {
    await this.store.load(this.store.teamId);
  }

}

// Initialize tactics module
const tactics = new Tactics();
window.tactics = tactics;


/* ===== js/antitactic-tree.js ===== */
// =====================================================
// ZDVAL - Antitactic Tree
// Sidebar de /antitatico. Mesmo padrão arquitetural de TacticsTree
// (tactics-tree.js): um único listener delegado lendo data-at-action,
// render() puro a partir do estado do controller.
//
// Estrutura: time > seção (Pick/Ban/Tierlist/Análise) — folhas simples,
// clicar seleciona o time e troca de aba.
//
// Toda mutação de estado (toggle, seleção, CRUD de time) continua vivendo
// no controller (Antitactic, em antitactic.js); esta classe só desenha e
// traduz cliques em chamadas pro controller.
// =====================================================

class AntitacticTree {
  static SECTIONS = [
    { key: 'veto', label: 'Pick/Ban', icon: 'fas fa-ban' },
    { key: 'tierlist', label: 'Tierlist', icon: 'fas fa-layer-group' },
    { key: 'analysis', label: 'Análise', icon: 'fas fa-chart-line' }
  ];

  constructor(controller) {
    this.controller = controller;
  }

  // ---------------------------------------------------
  // Template
  // ---------------------------------------------------

  template() {
    const c = this.controller;
    return `
      <header class="tc-side-head">
        <div class="tc-side-brand">
          <span class="tc-side-brand-mark" aria-hidden="true"></span>
          <h1 class="tc-side-title">Adversário</h1>
        </div>
        <button class="tc-icon-btn" data-at-action="add-team" title="Novo time" aria-label="Novo time">
          <i class="fas fa-plus"></i>
        </button>
      </header>
      <nav class="tc-tree" role="tree" aria-label="Times adversários">
        ${c.opponents.length
          ? c.opponents.map(o => this.teamNode(o)).join('')
          : `<div class="tc-tree-empty"><i class="fas fa-users-slash" aria-hidden="true"></i><p>Nenhum time cadastrado.</p></div>`}
      </nav>
    `;
  }

  teamNode(o) {
    const c = this.controller;
    const nodeId = `team:${o.id}`;
    const open = c._atTreeExpanded.has(nodeId);
    return `
      <section class="tc-map ${open ? 'is-open' : ''}" data-node-id="${nodeId}">
        <div class="tc-row tc-row--map" role="treeitem" aria-expanded="${open}" tabindex="0"
             data-at-action="toggle-team" data-opponent-id="${o.id}">
          <i class="fas fa-chevron-right tc-caret" aria-hidden="true"></i>
          <span class="tc-map-name">${c.escapeHtml(o.name)}</span>
          <button class="tc-row-action" title="Excluir time" aria-label="Excluir time ${c.escapeHtml(o.name)}"
                  data-at-action="delete-team" data-opponent-id="${o.id}">
            <i class="fas fa-trash"></i>
          </button>
        </div>
        ${open ? `<div class="tc-map-body">${AntitacticTree.SECTIONS.map(s => this.sectionNode(o, s)).join('')}</div>` : ''}
      </section>
    `;
  }

  sectionNode(o, s) {
    const c = this.controller;
    const isActive = String(c.selectedOpponent?.id) === String(o.id) && (c._activeTab || 'veto') === s.key;
    return `
      <div class="tc-row tc-row--side ${isActive ? 'is-active' : ''}" role="treeitem" tabindex="0"
           data-at-action="select-section" data-opponent-id="${o.id}" data-section="${s.key}">
        <i class="${s.icon} tc-side-dot" aria-hidden="true"></i>
        <span class="tc-side-label">${s.label}</span>
      </div>
    `;
  }

  // ---------------------------------------------------
  // Events — um listener delegado só, igual TacticsTree.
  // ---------------------------------------------------

  onClick(e) {
    const el = e.target.closest('[data-at-action]');
    if (!el) return;
    e.stopPropagation();

    const c = this.controller;
    const action = el.dataset.atAction;
    switch (action) {
      case 'add-team':
        c.showAddOpponentModal();
        break;
      case 'delete-team':
        c.deleteOpponent(el.dataset.opponentId);
        break;
      case 'toggle-team':
        c.atToggleTeamNode(el.dataset.opponentId);
        break;
      case 'select-section':
        c.atTreeSelectSection(el.dataset.opponentId, el.dataset.section);
        break;
    }
  }

  onDblClick() {}
  onInput() {}
}


/* ===== js/antitactic.js ===== */
// =====================================================
// ZDVAL - Antitactic Module
// Análise de adversários + Map Pick/Ban
// =====================================================



class Antitactic {
  constructor() {
    this.tree = new AntitacticTree(this);
    this.containerId = 'page-antitactic';
    this.isEmbedded = false;
    this.opponents = [];
    this.selectedOpponent = null;
    this.showOpponentPicker = true;
    this.selectedOpponentMenuOpen = false;
    this.vetoState = { us: [], them: [], available: [] };

    // Analysis state
    this.opponentPlayers = [];
    this.agentsData = null;
    this.mapsData = null;
    this.mapsCallouts = {};
    this.mapsMultipliers = {};
    this.playerAnalysis = new Map();
    this.analysisLoading = false;
    this._atTreeExpanded = new Set();
  }

  async load(params = null) {
    // Folha desta pagina, sob demanda. Estava no <head> do index.html, ou seja,
    // baixada em toda visita a qualquer pagina do site.
    // tactics.css e dona das classes tc-* da arvore (.tc-tree, .tc-row,
    // .tc-side-head). Sem ela a sidebar de /antitatico vinha sem estilo.
    Utils.loadPageCss('tactics-page-css', 'tactics.css');
    Utils.loadPageCss('antitactic-page-css', 'antitactic.css');
    Utils.loadPageCss('antitactic-legacy-css', 'antitactic-legacy.css');

    this.containerId = params?.containerId || 'page-antitactic';
    this.isEmbedded = !!params?.embedded || this.containerId !== 'page-antitactic';
    this.resetEntryState();
    this.addStyles();
    this._bindTreeEvents();

    // Garantir que os mapas estejam carregados ANTES de renderizar
    if (!app.getMaps() || app.getMaps().length === 0) {

      try {
        const mapsResult = await api.getMaps();
        if (mapsResult.success) {
          app.setMaps(mapsResult.data.maps);

        }
      } catch (e) {
        console.error('Failed to load maps:', e);
      }
    }
    
    // Carregar agentes também se necessário
    if (!app.getAgents() || app.getAgents().length === 0) {
      try {
        const agentsResult = await api.getAgents();
        if (agentsResult.success) {
          app.agents = agentsResult.data.agents;
        }
      } catch (e) {
        console.error('Failed to load agents:', e);
      }
    }
    
    await this.loadOpponents();
    const opponentSlug = params?.opponentSlug;
    if (opponentSlug) {
      const match = this.opponents.find(o => this.slugify(o.name) === opponentSlug);
      if (match) {
        this.selectedOpponent = match;
        this.showOpponentPicker = false;
        this.selectedOpponentMenuOpen = false;
      } else {
        // Slug not found — auto-select first opponent
        this.selectedOpponent = this.opponents.length > 0 ? this.opponents[0] : null;
        this.showOpponentPicker = false;
        this.selectedOpponentMenuOpen = false;
      }
    } else {
      // No slug — auto-select first opponent
      this.selectedOpponent = this.opponents.length > 0 ? this.opponents[0] : null;
      this.showOpponentPicker = false;
      this.selectedOpponentMenuOpen = false;
    }

    // Restore tab from URL
    const tabFromUrl = this._tabSlugToInternal(params?.atTab);
    if (tabFromUrl) {
      this._activeTab = tabFromUrl;
    }

    // Time auto-selecionado abre já expandido na árvore, com a seção ativa visível.
    if (this.selectedOpponent) {
      this._atTreeExpanded.add(`team:${this.selectedOpponent.id}`);
      if ((this._activeTab || 'strats') === 'strats') {
        this._atTreeExpanded.add(`team:${this.selectedOpponent.id}:strats`);
      }
    }

    this.renderPage();
  }

  resetEntryState() {
    this.selectedOpponent = null;
    this.showOpponentPicker = true;
    this.selectedOpponentMenuOpen = false;
    this._atTreeExpanded = new Set();
  }

  /** Listener único delegado da árvore (AntitacticTree) — vinculado uma vez
   * no container estável da página. #page-antitactic (ou o container de
   * embed) sobrevive a re-renders (só o innerHTML muda), então ligar de
   * novo a cada load() duplicaria o listener; o dataset marca que já foi
   * feito. */
  _bindTreeEvents() {
    const container = document.getElementById(this.containerId);
    if (!container || container.dataset.atTreeBound) return;
    container.addEventListener('click', (e) => this.tree.onClick(e));
    container.addEventListener('dblclick', (e) => this.tree.onDblClick(e));
    container.addEventListener('input', (e) => this.tree.onInput(e));
    container.dataset.atTreeBound = '1';
  }


  async loadOpponents() {
    const team = app.getCurrentTeam();
    // Acesso aberto: sem time (ou deslogado) a página abre vazia em vez de
    // quebrar — o backend segue exigindo time/token pra qualquer ação.
    if (!team) {
      this.opponents = [];
      return;
    }
    try {
      const result = await api.getOpponents(team.id);
      if (result.success) this.opponents = (result.data.opponents || []).map(opponent => this.normalizeOpponent(opponent));
    } catch (e) {
      console.error('Load opponents error:', e);
    }
  }

  slugify(name) {
    return (name || '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // Tab internal name → URL slug
  _tabToSlug(tab) {
    const map = { veto: 'pickban', tierlist: 'tierlist', analysis: 'analise' };
    return map[tab] || 'pickban';
  }

  // URL slug → tab internal name
  _tabSlugToInternal(slug) {
    const map = { pickban: 'veto', tierlist: 'tierlist', analise: 'analysis' };
    return slug ? (map[slug] || 'veto') : null;
  }

  // Build the full antitatico URL for current state
  _buildAntitaticUrl(tabOverride) {
    const tab = tabOverride || this._activeTab || 'veto';
    const tabSlug = this._tabToSlug(tab);
    const oppSlug = this.selectedOpponent ? this.slugify(this.selectedOpponent.name) : null;
    if (oppSlug) {
      return `/antitatico/${oppSlug}/${tabSlug}`;
    }
    return '/antitatico';
  }

  looksLikeImageUrl(value) {
    if (!value || typeof value !== 'string') return false;
    const normalizedValue = value.trim().toLowerCase();
    return normalizedValue.startsWith('http://')
      || normalizedValue.startsWith('https://')
      || normalizedValue.startsWith('data:image/')
      || normalizedValue.startsWith('/uploads/')
      || normalizedValue.startsWith('uploads/');
  }

  normalizeOpponent(opponent) {
    if (!opponent) return opponent;

    const normalizedOpponent = { ...opponent };
    normalizedOpponent.name = typeof normalizedOpponent.name === 'string' ? normalizedOpponent.name.trim() : '';
    normalizedOpponent.tag = typeof normalizedOpponent.tag === 'string' ? normalizedOpponent.tag.trim() : normalizedOpponent.tag;
    normalizedOpponent.logo_url = typeof normalizedOpponent.logo_url === 'string' ? normalizedOpponent.logo_url.trim() : normalizedOpponent.logo_url;

    const nameLooksLikeUrl = this.looksLikeImageUrl(normalizedOpponent.name);
    const logoLooksLikeUrl = this.looksLikeImageUrl(normalizedOpponent.logo_url);

    if (nameLooksLikeUrl && !logoLooksLikeUrl) {
      const previousName = normalizedOpponent.name;
      normalizedOpponent.name = normalizedOpponent.logo_url || 'Time adversário';
      normalizedOpponent.logo_url = previousName;
    }

    if (this.looksLikeImageUrl(normalizedOpponent.name)) {
      normalizedOpponent.logo_url = normalizedOpponent.logo_url || normalizedOpponent.name;
      normalizedOpponent.name = normalizedOpponent.tag || 'Time adversário';
    }

    if (!normalizedOpponent.name || this.looksLikeImageUrl(normalizedOpponent.name)) {
      normalizedOpponent.name = normalizedOpponent.tag || 'Time adversário';
    }

    if (!this.looksLikeImageUrl(normalizedOpponent.logo_url)) {
      normalizedOpponent.logo_url = null;
    }

    return normalizedOpponent;
  }

  sanitizeLogoUrl(value) {
    const normalizedValue = typeof value === 'string' ? value.trim() : '';
    return this.looksLikeImageUrl(normalizedValue) ? normalizedValue : null;
  }


  renderVetoTeamMarker(teamKey) {
    const isUs = teamKey === 'us';
    const teamData = isUs ? app.getCurrentTeam() : this.selectedOpponent;
    const teamName = teamData?.name || (isUs ? 'Nosso Time' : 'Adversario');
    const logoUrl = this.sanitizeLogoUrl(teamData?.logo_url);
    const iconClass = isUs ? 'fa-home' : 'fa-users-slash';
    const teamClass = isUs ? 'us' : 'them';
    const safeInitials = (teamData?.tag || teamName || '?').trim().substring(0, 2).toUpperCase() || '?';

    if (logoUrl) {
      return `
        <span class="veto-map-owner-badge ${teamClass}">
          <span class="veto-map-owner-logo-wrap">
            <img src="${logoUrl}" alt="${teamName}" class="veto-map-owner-logo" onerror="this.style.display='none';this.nextElementSibling.style.display='inline-flex';">
            <span class="veto-map-owner-icon fallback" style="display:none;"><i class="fas ${iconClass}"></i></span>
          </span>
          <span class="veto-map-owner-name">${teamName}</span>
        </span>
      `;
    }

    return `
      <span class="veto-map-owner-badge ${teamClass}">
        <span class="veto-map-owner-icon"><i class="fas ${iconClass}"></i></span>
        <span class="veto-map-owner-name">${teamName || safeInitials}</span>
      </span>
    `;
  }

  renderPage() {
    const container = document.getElementById(this.containerId);
    if (!container) return;
    // Shell escuro da página (tokens em css/pages/antitactic.css). Só na
    // página própria — quando embutida, o shell é de quem hospeda.
    if (this.containerId === 'page-antitactic') container.classList.add('at-page');
    container.innerHTML = `
      <div class="antitactic-container${this.containerId !== 'page-antitactic' ? ' antitactic-embedded' : ''} has-opponent">
        <!-- Main Content -->
        <div class="antitactic-main" id="antitacticMain">
          ${this.renderOpponentContent()}
        </div>
      </div>
    `;
  }

  renderOpponentContent() {
    const activeTab = this._activeTab || 'veto';

    return `
      <div class="at-strats-layout">
        <!-- LEFT: árvore de times -->
        <aside class="tc-sidebar">
          <div class="tc-sidebar-tree">${this.tree.template()}</div>
        </aside>

        <!-- RIGHT: Tab Content -->
        <div class="wizard-tactics-area tc-full" id="tabContent">
          ${this._renderTabContent(activeTab)}
        </div>
      </div>
    `;
  }

  // ---------------------------------------------------
  // Árvore de times — o desenho vive em AntitacticTree (antitactic-tree.js,
  // mesmo padrão de TacticsTree). Daqui pra baixo só a lógica de estado:
  // toggle/seleção de nó e CRUD, que a árvore chama de volta via
  // data-at-action.
  // ---------------------------------------------------

  atToggleTeamNode(opponentId) {
    this._atTreeExpanded = this._atTreeExpanded || new Set();
    const nodeId = `team:${opponentId}`;
    const wasSelected = String(this.selectedOpponent?.id) === String(opponentId);

    if (this._atTreeExpanded.has(nodeId)) this._atTreeExpanded.delete(nodeId);
    else this._atTreeExpanded.add(nodeId);

    if (wasSelected) {
      this.renderPage();
    } else {
      this.atSwitchOpponent(opponentId);
    }
  }

  atTreeSelectSection(opponentId, sectionKey) {
    this._atTreeExpanded = this._atTreeExpanded || new Set();
    const opp = this.opponents.find(o => String(o.id) === String(opponentId));
    if (!opp) return;

    if (String(this.selectedOpponent?.id) !== String(opponentId)) {
      this.selectedOpponent = opp;
      if (!this.isEmbedded) window.history.pushState({}, '', this._buildAntitaticUrl());
    }

    this._activeTab = sectionKey;
    this._atTreeExpanded.add(`team:${opponentId}`);
    this.renderPage();
    if (sectionKey === 'veto') this.loadVetoHistory();
  }

  escapeHtml(value) {
    return String(value ?? '').replace(/[&<>"']/g, ch => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[ch]));
  }

  _renderTabContent(tab) {
    // O markup sozinho não basta: veto e análise só ganham dados quando
    // alguém dispara o load. showTab() fazia isso, mas renderPage() (entrada
    // direta por URL, troca de adversário) não — a análise ficava presa no
    // "Carregando jogadores..." pra sempre. O load roda depois do innerHTML.
    if (tab === 'veto') {
      // #vetoResult é preenchido fora do template (checkVetoComplete),
      // então some sempre que a aba re-renderiza — troca de time, volta
      // pela URL etc. Se o veto já estava completo, recalcula aqui.
      setTimeout(() => {
        this.loadVetoHistory();
        this.checkVetoComplete();
      }, 0);
      return this.renderVetoTab();
    }
    if (tab === 'analysis') {
      setTimeout(() => this.loadAnalysisContent(), 0);
      return this.renderAnalysisTab();
    }
    if (tab === 'tierlist') return this.renderTierlistTab();
    return '';
  }


  // =====================================================
  // MAP VETO SYSTEM
  // =====================================================

  renderVetoTab() {
    const maps = app.getMaps() || [];
    const team = app.getCurrentTeam();
    const teamName = team?.name || 'Nosso Time';
    const teamLogo = this.sanitizeLogoUrl(team?.logo_url);
    const opponentName = (this.selectedOpponent?.name || 'Adversário').toUpperCase();
    const opponentLogo = this.sanitizeLogoUrl(this.selectedOpponent?.logo_url);
    
    // Default: Time A (we pick last map)
    this.vetoRole = this.vetoRole || 'A';
    
    const sequence = this.getVetoSequence();
    const step = this.vetoState.step || 0;
    const totalSteps = sequence.length;
    const currentStep = sequence[step];
    const isComplete = step >= totalSteps;
    const turnTeam = currentStep ? (currentStep.team === 'us' ? teamName : opponentName) : '';
    const turnAction = currentStep ? (currentStep.action === 'ban' ? 'BANE' : currentStep.action === 'pick' ? 'ESCOLHE' : 'ESCOLHE LADO') : '';
    
    // Se não houver mapas, mostrar mensagem
    if (maps.length === 0) {
      return `
        <div class="empty-state" style="padding: 2rem; text-align: center;">
          <i class="fas fa-map" style="font-size: 3rem; color: var(--text-muted); margin-bottom: 1rem;"></i>
          <h3>Carregando mapas...</h3>
          <p style="color: var(--text-muted);">Aguarde os mapas serem carregados ou recarregue a página.</p>
          <button class="btn btn-primary" onclick="location.reload()" style="margin-top: 1rem;">
            <i class="fas fa-sync"></i> Recarregar
          </button>
        </div>
      `;
    }

    // Build map cards with slot labels 
    const mapSlotLabels = this._getVetoSlotLabels();
    
    return `
      <div class="veto-section veto-v2">
        <!-- Top Header Bar -->
        <div class="veto-v2-header">
          <div class="veto-v2-team veto-v2-team-us">
            ${teamLogo ? `<img src="${teamLogo}" class="veto-v2-team-logo" onerror="this.style.display='none'">` : ''}
            <span class="veto-v2-team-name">${teamName.toUpperCase()}</span>
          </div>
          <div class="veto-v2-title-block">
            <h3 class="veto-v2-title">MAP VETO</h3>
            <div class="veto-v2-role-switch">
              <button class="veto-v2-role-btn ${this.vetoRole === 'A' ? 'active' : ''}" onclick="antitactic.setVetoRole('A')">Time A</button>
              <button class="veto-v2-role-btn ${this.vetoRole === 'B' ? 'active' : ''}" onclick="antitactic.setVetoRole('B')">Time B</button>
            </div>
          </div>
          <div class="veto-v2-team veto-v2-team-them">
            <span class="veto-v2-team-name">${opponentName.toUpperCase()}</span>
            ${opponentLogo ? `<img src="${opponentLogo}" class="veto-v2-team-logo" onerror="this.style.display='none'">` : ''}
          </div>
        </div>

        <!-- Map Cards Strip -->
        <div class="veto-v2-maps" id="vetoMaps">
          ${maps.map((m, idx) => {
            const slot = mapSlotLabels[m.id];
            const actionClass = slot ? (slot.action === 'ban' ? 'banned' : 'picked') : 'available';
            const deciderClass = slot?.isDecider ? 'decider' : '';
            const slotTeam = slot ? (slot.team === 'us' ? team : this.selectedOpponent) : null;
            const slotLogo = slotTeam ? this.sanitizeLogoUrl(slotTeam.logo_url) : '';
            return `
            <div class="veto-v2-map-slot ${actionClass} ${deciderClass}" data-map-slot="${m.id}">
              <span class="veto-v2-map-name">${m.display_name.toUpperCase()}</span>
              <div class="veto-v2-map-card ${actionClass} ${deciderClass}" data-map="${m.id}" onclick="antitactic.selectMapForVeto('${m.id}', '${m.display_name}')">
                <img src="${Utils.imagemReduzida(m.splash || m.listViewIcon, 384)}" alt="${m.display_name}" loading="lazy">
                <div class="veto-v2-map-overlay"></div>
                <div class="veto-v2-map-team-logo">${slotLogo ? `<img src="${slotLogo}" onerror="this.style.display='none'">` : ''}</div>
              </div>
              <div class="veto-v2-map-label ${actionClass} ${deciderClass}" data-team="${slot?.team || ''}">${slot?.text || ''}</div>
            </div>
          `}).join('')}
        </div>

        <!-- Turn Indicator -->
        <div class="veto-v2-turn" id="vetoTurnIndicator">
          ${isComplete ? `
            <span class="veto-v2-turn-text complete">VETO COMPLETO</span>
          ` : `
            <span class="veto-v2-turn-text" data-team="${currentStep?.team || 'us'}">${turnTeam.toUpperCase()} ${turnAction}</span>
          `}
        </div>
        <div class="veto-v2-step-counter">${step} de ${totalSteps}</div>

        <!-- Controls -->
        <div class="veto-v2-controls">
          <button class="veto-v2-reset-btn" onclick="antitactic.resetVeto()">
            <i class="fas fa-redo"></i> Resetar
          </button>
        </div>

        <div class="veto-result" id="vetoResult" style="display:none;">
          <h4>Mapas Selecionados</h4>
          <div class="result-maps" id="resultMaps"></div>
          <div class="veto-result-actions">
            <button class="btn btn-primary" onclick="antitactic.saveVetoHistory()">
              <i class="fas fa-save"></i> Salvar no Histórico
            </button>
            <button class="btn btn-danger veto-result-delete-btn" onclick="antitactic.discardCurrentVeto()" title="Descartar veto">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>

        <div class="veto-history">
          <h4>Histórico de Vetos</h4>
          <div id="vetoHistoryList"></div>
        </div>
      </div>
    `;
  }

  /** Estado de cada mapa (banido/escolhido/quem/decider) a partir de
   * vetoState.sequence — usado pelo template do card pra renderizar o
   * resultado certo em QUALQUER render, não só no instante do clique
   * (selectMapForVeto mexe no DOM na hora, mas isso se perde assim que a
   * aba re-renderiza — troca de aba, de adversário, volta pela URL). */
  _getVetoSlotLabels() {
    const labels = {};
    const seq = this.vetoState.sequence || [];
    seq.forEach(s => {
      if (s.mapId && (s.action === 'ban' || s.action === 'pick')) {
        labels[s.mapId] = {
          action: s.action,
          isDecider: !!s.isDecider,
          team: s.team,
          text: s.action === 'ban' ? 'BAN' : (s.isDecider ? 'DECIDER' : 'PICK')
        };
      }
    });
    return labels;
  }

  _updateVetoTurnIndicator() {
    const turnEl = document.getElementById('vetoTurnIndicator');
    const stepCounter = document.querySelector('.veto-v2-step-counter');
    if (!turnEl) return;
    
    const step = this.vetoState.step || 0;
    const sequence = this.getVetoSequence();
    const totalSteps = sequence.length;
    const isComplete = step >= totalSteps;
    
    if (isComplete) {
      turnEl.innerHTML = '<span class="veto-v2-turn-text complete">VETO COMPLETO</span>';
    } else {
      const current = sequence[step];
      const team = app.getCurrentTeam();
      const teamName = current.team === 'us' ? (team?.name || 'Nosso Time') : (this.selectedOpponent?.name || 'Adversário');
      const action = current.action === 'ban' ? 'BANE' : current.action === 'pick' ? 'ESCOLHE' : 'ESCOLHE LADO';
      turnEl.innerHTML = `<span class="veto-v2-turn-text" data-team="${current.team}">${teamName.toUpperCase()} ${action}</span>`;
    }
    
    if (stepCounter) {
      stepCounter.textContent = `${step} de ${totalSteps}`;
    }
  }

  // =====================================================
  // TIERLIST TAB
  // =====================================================

  renderTierlistTab() {
    const teamName = app.getCurrentTeam()?.name || 'Meu Time';
    const opponentName = this.selectedOpponent?.name || 'Adversário';

    return `
      <div class="veto-section">
        <div class="tierlist-compact">
          <div class="tierlist-header">
            <span class="tierlist-title"><i class="fas fa-layer-group"></i> Tierlist de Mapas</span>
            <div class="tierlist-actions">
              <button class="btn btn-primary btn-sm" onclick="antitactic.saveTierlistHistory()">
                <i class="fas fa-save"></i> Salvar Tierlist
              </button>
              <button class="btn btn-secondary btn-sm" onclick="antitactic.resetTierlists()">
                <i class="fas fa-rotate-left"></i> Resetar
              </button>
            </div>
          </div>
          <div class="tierlist-compare-grid">
            ${this.renderTierlistPanel('opponent', opponentName, 'Adversário')}
            ${this.renderTierlistPanel('team', teamName, 'Meu time')}
          </div>
          <div class="tierlist-history">
            <div class="tierlist-history-header">
              <h4><i class="fas fa-clock-rotate-left"></i> Histórico da Tierlist</h4>
            </div>
            <div class="tierlist-history-list">
              ${this.renderTierlistHistory()}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  getTierDefinitions() {
    return [
      { id: 's', label: 'S', color: '#ff4655' },
      { id: 'a', label: 'A', color: '#ff8c42' },
      { id: 'b', label: 'B', color: '#ffc837' },
      { id: 'c', label: 'C', color: '#38bdf8' }
    ];
  }

  renderTierlistPanel(scope, title, eyebrow) {
    return `
      <section class="tierlist-panel tierlist-panel-${scope}">
        <div class="tierlist-panel-header">
          <span class="tierlist-panel-eyebrow">${eyebrow}</span>
          <h3>${title}</h3>
        </div>
        <div class="tierlist-rows" id="tierlistRows-${scope}">
          ${this.renderTierlist(scope)}
        </div>
      </section>
    `;
  }

  getTierlistStorageKey(scope = 'opponent') {
    const teamId = app.getCurrentTeam()?.id || 'no-team';
    if (scope === 'team') {
      return `antitactic-tierlist-team:${teamId}`;
    }
    const opponentId = this.selectedOpponent?.id || 'no-opponent';
    return `antitactic-tierlist-opponent:${teamId}:${opponentId}`;
  }

  getTierlistHistoryStorageKey() {
    const teamId = app.getCurrentTeam()?.id || 'no-team';
    const opponentId = this.selectedOpponent?.id || 'no-opponent';
    return `antitactic-tierlist-history:${teamId}:${opponentId}`;
  }

  getTierlistData(scope = 'opponent') {
    try {
      let rawValue = localStorage.getItem(this.getTierlistStorageKey(scope));

      if (!rawValue && scope === 'opponent') {
        const teamId = app.getCurrentTeam()?.id || 'no-team';
        const opponentId = this.selectedOpponent?.id || 'no-opponent';
        const legacyKey = `antitactic-tierlist:${teamId}:${opponentId}`;
        rawValue = localStorage.getItem(legacyKey);

        if (rawValue) {
          localStorage.setItem(this.getTierlistStorageKey(scope), rawValue);
        }
      }

      return rawValue ? JSON.parse(rawValue) : {};
    } catch (error) {
      console.warn('Failed to parse tierlist from storage', error);
      return {};
    }
  }

  saveTierlistData(scope = 'opponent', tierlist = {}) {
    localStorage.setItem(this.getTierlistStorageKey(scope), JSON.stringify(tierlist || {}));
  }

  getTierlistHistory() {
    try {
      const rawValue = localStorage.getItem(this.getTierlistHistoryStorageKey());
      return rawValue ? JSON.parse(rawValue) : [];
    } catch (error) {
      console.warn('Failed to parse tierlist history', error);
      return [];
    }
  }

  saveTierlistHistoryData(historyEntries) {
    localStorage.setItem(this.getTierlistHistoryStorageKey(), JSON.stringify(historyEntries || []));
  }

  renderTierlist(scope = 'opponent') {
    const maps = app.getMaps() || [];
    const tierlist = this.getTierlistData(scope);
    const tiers = this.getTierDefinitions();

    return tiers.map(tier => `
      <div class="tier-row" data-tier="${tier.id}" style="--tier-color: ${tier.color};" ondragover="antitactic.tierDragOver(event)" ondrop="antitactic.tierDrop(event, '${tier.id}', '${scope}')">
        <div class="tier-badge">
          <span class="tier-label">${tier.label}</span>
        </div>
        <div class="tier-maps">
          ${maps.filter(map => tierlist[map.id] === tier.id).map(map => {
            const diffMeta = this.getTierlistDiffMeta(map.id, scope);
            const mapTheme = this.getTierlistMapTheme(map);
            return `
            <div class="tier-map ${diffMeta ? 'tier-map-different' : ''}" draggable="true" data-map-id="${map.id}" ondragstart="antitactic.tierDragStart(event, '${map.id}', '${scope}')" title="${map.display_name}${diffMeta ? ` | ${diffMeta.label}` : ''}" style="--map-accent:${mapTheme.accent}; --map-accent-soft:${mapTheme.soft}; --map-surface:${mapTheme.surface};">
              <img src="${map.listViewIcon || map.splash || ''}" alt="${map.display_name}" onerror="this.src='/img/maps/default.jpg'">
              <span class="tier-map-name">${map.display_name}</span>
            </div>
          `;
          }).join('')}
        </div>
      </div>
    `).join('') + `
      <div class="tier-row tier-unranked" data-tier="none" ondragover="antitactic.tierDragOver(event)" ondrop="antitactic.tierDrop(event, 'none', '${scope}')">
        <div class="tier-badge unranked">
          <span class="tier-label">?</span>
        </div>
        <div class="tier-maps">
          ${maps.filter(map => !tierlist[map.id]).map(map => {
            const diffMeta = this.getTierlistDiffMeta(map.id, scope);
            const mapTheme = this.getTierlistMapTheme(map);
            return `
            <div class="tier-map ${diffMeta ? 'tier-map-different' : ''}" draggable="true" data-map-id="${map.id}" ondragstart="antitactic.tierDragStart(event, '${map.id}', '${scope}')" title="${map.display_name}${diffMeta ? ` | ${diffMeta.label}` : ''}" style="--map-accent:${mapTheme.accent}; --map-accent-soft:${mapTheme.soft}; --map-surface:${mapTheme.surface};">
              <img src="${map.listViewIcon || map.splash || ''}" alt="${map.display_name}" onerror="this.src='/img/maps/default.jpg'">
              <span class="tier-map-name">${map.display_name}</span>
            </div>
            `;
          }).join('')}
        </div>
      </div>
    `;
  }

  getTierlistMapTheme(map) {
    const mapName = (map?.display_name || '').toLowerCase();
    const themeByMap = {
      abyss: { accent: '#22c55e', soft: 'rgba(34, 197, 94, 0.22)', surface: 'linear-gradient(180deg, rgba(8, 32, 21, 0.96), rgba(7, 17, 14, 0.94))' },
      bind: { accent: '#f59e0b', soft: 'rgba(245, 158, 11, 0.24)', surface: 'linear-gradient(180deg, rgba(52, 31, 8, 0.96), rgba(20, 13, 6, 0.94))' },
      breeze: { accent: '#38bdf8', soft: 'rgba(56, 189, 248, 0.24)', surface: 'linear-gradient(180deg, rgba(8, 34, 45, 0.96), rgba(7, 17, 23, 0.94))' },
      corrode: { accent: '#a78bfa', soft: 'rgba(167, 139, 250, 0.24)', surface: 'linear-gradient(180deg, rgba(27, 17, 49, 0.96), rgba(14, 10, 24, 0.94))' },
      fracture: { accent: '#84cc16', soft: 'rgba(132, 204, 22, 0.24)', surface: 'linear-gradient(180deg, rgba(24, 36, 7, 0.96), rgba(15, 19, 7, 0.94))' },
      haven: { accent: '#fb7185', soft: 'rgba(251, 113, 133, 0.24)', surface: 'linear-gradient(180deg, rgba(55, 17, 22, 0.96), rgba(20, 10, 11, 0.94))' },
      lotus: { accent: '#eab308', soft: 'rgba(234, 179, 8, 0.24)', surface: 'linear-gradient(180deg, rgba(47, 38, 7, 0.96), rgba(20, 18, 8, 0.94))' },
      pearl: { accent: '#06b6d4', soft: 'rgba(6, 182, 212, 0.24)', surface: 'linear-gradient(180deg, rgba(8, 29, 38, 0.96), rgba(7, 16, 20, 0.94))' },
      split: { accent: '#f97316', soft: 'rgba(249, 115, 22, 0.24)', surface: 'linear-gradient(180deg, rgba(51, 24, 8, 0.96), rgba(22, 13, 7, 0.94))' },
      ascent: { accent: '#ef4444', soft: 'rgba(239, 68, 68, 0.24)', surface: 'linear-gradient(180deg, rgba(48, 13, 13, 0.96), rgba(21, 9, 9, 0.94))' },
      sunset: { accent: '#f97316', soft: 'rgba(249, 115, 22, 0.24)', surface: 'linear-gradient(180deg, rgba(53, 24, 10, 0.96), rgba(24, 12, 8, 0.94))' },
      icebox: { accent: '#60a5fa', soft: 'rgba(96, 165, 250, 0.24)', surface: 'linear-gradient(180deg, rgba(10, 24, 49, 0.96), rgba(8, 12, 24, 0.94))' }
    };

    return themeByMap[mapName] || {
      accent: '#ff8c42',
      soft: 'rgba(255, 140, 66, 0.22)',
      surface: 'linear-gradient(180deg, rgba(33, 17, 9, 0.96), rgba(16, 12, 9, 0.94))'
    };
  }

  getTierlistDiffMeta(mapId, scope) {
    const currentTierlist = this.getTierlistData(scope);
    const otherScope = scope === 'opponent' ? 'team' : 'opponent';
    const otherTierlist = this.getTierlistData(otherScope);
    const currentTier = currentTierlist?.[mapId] || 'none';
    const otherTier = otherTierlist?.[mapId] || 'none';

    if (currentTier === otherTier) {
      return null;
    }

    const otherLabel = this.getTierLabel(otherTier);
    const sideLabel = otherScope === 'team' ? 'Meu time' : 'Adversário';
    return {
      shortLabel: `${sideLabel === 'Meu time' ? 'MT' : 'ADV'} ${otherLabel}`,
      label: `${sideLabel}: ${otherLabel}`
    };
  }

  getTierLabel(tierId) {
    if (!tierId || tierId === 'none') return '?';
    return this.getTierDefinitions().find(tier => tier.id === tierId)?.label || '?';
  }

  getTierlistMd3PairScore(primaryTierId, secondaryTierId) {
    const tierA = primaryTierId || 'none';
    const tierB = secondaryTierId || 'none';
    const pairKey = [tierA, tierB].sort().join(':');
    const pairScores = {
      's:s': 1000,
      'a:s': 180,
      'a:a': 72,
      'b:s': 34,
      'a:b': 18,
      'b:b': 8,
      'c:s': 5,
      'a:c': 3,
      'b:c': 1.5,
      'c:c': 0.8,
      'none:s': 0.35,
      'a:none': 0.2,
      'b:none': 0.08,
      'c:none': 0.03,
      'none:none': 0.01
    };

    return pairScores[pairKey] ?? 0.01;
  }

  getTierlistMapProbabilities(primaryTierlist, secondaryTierlist) {
    const maps = app.getMaps() || [];
    const mapEntries = maps.map(map => {
      const primaryTier = primaryTierlist?.[map.id] || 'none';
      const secondaryTier = secondaryTierlist?.[map.id] || 'none';

      return {
        mapId: map.id,
        primaryTier,
        secondaryTier,
        score: this.getTierlistMd3PairScore(primaryTier, secondaryTier)
      };
    });

    const doubleSMaps = mapEntries.filter(entry => entry.primaryTier === 's' && entry.secondaryTier === 's');

    if (doubleSMaps.length === 1) {
      const probabilityByMapId = {};
      mapEntries.forEach(entry => {
        probabilityByMapId[entry.mapId] = entry.mapId === doubleSMaps[0].mapId ? 100 : 0;
      });
      return probabilityByMapId;
    }

    const totalScore = mapEntries.reduce((sum, entry) => sum + entry.score, 0) || 1;
    const probabilityByMapId = {};

    mapEntries.forEach(entry => {
      probabilityByMapId[entry.mapId] = (entry.score / totalScore) * 100;
    });

    return probabilityByMapId;
  }

  renderTierlistHistory() {
    const historyEntries = this.getTierlistHistory();

    if (!historyEntries.length) {
      return `
        <div class="tierlist-history-empty">
          <i class="fas fa-clock"></i>
          <span>Nenhuma tierlist salva ainda.</span>
        </div>
      `;
    }

    return historyEntries.map(entry => `
      <article class="tierlist-history-card">
        <div class="tierlist-history-meta">
          <div class="tierlist-history-meta-main">
            <span class="tierlist-history-date">${new Date(entry.createdAt).toLocaleString('pt-BR')}</span>
            <strong>${entry.opponentName}</strong>
          </div>
          <div class="tierlist-history-actions">
            <button class="btn btn-secondary btn-sm" onclick="antitactic.restoreTierlistHistoryEntry('${entry.id}')" title="Restaurar tierlist salva">
              <i class="fas fa-rotate-left"></i> Restaurar
            </button>
            <button class="btn-icon-sm btn-danger" onclick="antitactic.deleteTierlistHistoryEntry('${entry.id}')" title="Excluir tierlist salva">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>
        <div class="tierlist-history-compare">
          ${this.renderTierlistHistorySummary(entry.opponentTierlist, entry.teamTierlist, 'Adversário')}
          ${this.renderTierlistHistorySummary(entry.teamTierlist, entry.opponentTierlist, 'Meu time')}
        </div>
      </article>
    `).join('');
  }

  renderTierlistHistorySummary(tierlist, otherTierlist, title) {
    const maps = app.getMaps() || [];
    const tiers = this.getTierDefinitions();
    const probabilityByMapId = this.getTierlistMapProbabilities(tierlist, otherTierlist);

    return `
      <div class="tierlist-history-column">
        <span class="tierlist-history-column-title">${title}</span>
        ${tiers.map(tier => {
          const mapsInTier = maps.filter(map => tierlist?.[map.id] === tier.id);
          return `
            <div class="tierlist-history-tier-row ${this.historyTierHasDifference(tier.id, tierlist, otherTierlist, maps) ? 'tierlist-history-tier-row-different' : ''}">
              <span class="tierlist-history-tier-badge" style="--tier-color: ${tier.color};">${tier.label}</span>
              <span class="tierlist-history-tier-values">${mapsInTier.length ? mapsInTier.map(map => this.renderTierlistHistoryMapProbabilityChip(map, probabilityByMapId[map.id])).join('') : '<span class="tierlist-history-empty-label">Sem mapas</span>'}</span>
            </div>
          `;
        }).join('')}
      </div>
    `;
  }

  renderTierlistHistoryMapProbabilityChip(map, probability) {
    const probabilityLabel = `${Math.round((probability || 0) * 10) / 10}%`;
    const mapTheme = this.getTierlistMapTheme(map);

    return `
      <span class="tierlist-history-map-chip" style="--map-accent:${mapTheme.accent}; --map-accent-soft:${mapTheme.soft}; --map-surface:${mapTheme.surface};" title="Probabilidade estimada no campeonato baseada nas duas tierlists">
        <span class="tierlist-history-map-name">${map.display_name}</span>
        <span class="tierlist-history-map-probability">${probabilityLabel}</span>
      </span>
    `;
  }

  historyTierHasDifference(tierId, tierlist, otherTierlist, maps) {
    return maps.some(map => {
      const currentTier = tierlist?.[map.id] || 'none';
      const otherTier = otherTierlist?.[map.id] || 'none';
      return currentTier !== otherTier && (currentTier === tierId || otherTier === tierId);
    });
  }

  tierDragStart(e, mapId, scope) {
    e.dataTransfer.setData('text/plain', JSON.stringify({ mapId, scope }));
    e.currentTarget.classList.add('dragging');
  }

  tierDragOver(e) {
    e.preventDefault();
    e.currentTarget.classList.add('drag-over');
  }

  tierDrop(e, tierId, scope) {
    e.preventDefault();
    e.currentTarget.classList.remove('drag-over');
    let dragData;

    try {
      dragData = JSON.parse(e.dataTransfer.getData('text/plain'));
    } catch {
      dragData = { mapId: e.dataTransfer.getData('text/plain'), scope };
    }

    if (!dragData?.mapId || dragData.scope !== scope) {
      document.querySelectorAll('.tier-map.dragging').forEach(el => el.classList.remove('dragging'));
      return;
    }

    const tierlist = this.getTierlistData(scope);

    if (tierId === 'none') {
      delete tierlist[dragData.mapId];
    } else {
      tierlist[dragData.mapId] = tierId;
    }

    this.saveTierlistData(scope, tierlist);
    this.refreshTierlistBoards();
    document.querySelectorAll('.tier-map.dragging').forEach(el => el.classList.remove('dragging'));
  }

  saveTierlistHistory() {
    const historyEntries = this.getTierlistHistory();
    const entry = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      createdAt: new Date().toISOString(),
      opponentName: this.selectedOpponent?.name || 'Adversário',
      opponentTierlist: this.getTierlistData('opponent'),
      teamTierlist: this.getTierlistData('team')
    };

    historyEntries.unshift(entry);
    this.saveTierlistHistoryData(historyEntries.slice(0, 20));
    toast.success('Sucesso', 'Tierlist salva no histórico');
    this.refreshTierlistTab();
  }

  resetTierlists() {
    this.saveTierlistData('opponent', {});
    this.saveTierlistData('team', {});
    toast.success('Sucesso', 'Tierlists resetadas');
    this.refreshTierlistTab();
  }

  deleteTierlistHistoryEntry(entryId) {
    if (!confirm('Excluir esta tierlist do histórico?')) return;

    const filteredEntries = this.getTierlistHistory().filter(entry => entry.id !== entryId);
    this.saveTierlistHistoryData(filteredEntries);
    toast.success('Sucesso', 'Tierlist removida do histórico');
    this.refreshTierlistTab();
  }

  restoreTierlistHistoryEntry(entryId) {
    const entry = this.getTierlistHistory().find(item => item.id === entryId);
    if (!entry) {
      toast.error('Erro', 'Tierlist salva não encontrada');
      return;
    }

    this.saveTierlistData('opponent', entry.opponentTierlist || {});
    this.saveTierlistData('team', entry.teamTierlist || {});
    toast.success('Sucesso', 'Tierlist restaurada');
    this.refreshTierlistTab();
  }

  refreshTierlistBoards() {
    const opponentRows = document.getElementById('tierlistRows-opponent');
    const teamRows = document.getElementById('tierlistRows-team');

    if (opponentRows) {
      opponentRows.innerHTML = this.renderTierlist('opponent');
    }

    if (teamRows) {
      teamRows.innerHTML = this.renderTierlist('team');
    }
  }

  refreshTierlistTab() {
    const tabContent = document.getElementById('tabContent');
    if (tabContent) {
      tabContent.innerHTML = this.renderTierlistTab();
    }
  }

  resetVeto() {
    this.vetoState = { us: [], them: [], sequence: [], step: 0 };
    document.querySelectorAll('.veto-map').forEach(m => {
      m.className = 'veto-map wizard-map-card available';
      const mapNameEl = m.querySelector('.wizard-map-name');
      if (mapNameEl) {
        mapNameEl.textContent = mapNameEl.textContent.replace(/ \(.*\)$/, '');
      }
      const slotEl = m.closest('.veto-map-slot');
      if (slotEl) {
        slotEl.className = 'veto-map-slot available';
        const ownerEl = slotEl.querySelector('.veto-map-owner');
        if (ownerEl) ownerEl.innerHTML = '';
      }
    });
    document.getElementById('vetoResult').style.display = 'none';
  }

  setVetoRole(role) {
    this.vetoRole = role;
    this.resetVeto();
    document.getElementById('tabContent').innerHTML = this.renderVetoTab();
    this.loadVetoHistory();
  }


  getVetoSequence() {
    const team = app.getCurrentTeam();
    const teamName = team?.name || 'Nosso Time';
    const opponentName = (this.selectedOpponent?.name || 'Adversário');
    
    // Time A escolhe último mapa, Time B escolhe último lado
    if (this.vetoRole === 'A') {
      // Somos Time A
      return [
        { team: 'them', action: 'ban', label: `${opponentName} BAN` },
        { team: 'us', action: 'ban', label: `${teamName} BAN` },
        { team: 'them', action: 'pick', label: `${opponentName} PICK`, subtext: 'Mapa 1' },
        { team: 'us', action: 'side', label: `${teamName} LADO`, forMap: 0 },
        { team: 'us', action: 'pick', label: `${teamName} PICK`, subtext: 'Mapa 2' },
        { team: 'them', action: 'side', label: `${opponentName} LADO`, forMap: 1 },
        { team: 'them', action: 'ban', label: `${opponentName} BAN` },
        { team: 'us', action: 'ban', label: `${teamName} BAN` },
        { team: 'us', action: 'pick', label: `${teamName} PICK`, subtext: 'Decider', isDecider: true },
        { team: 'them', action: 'side', label: `${opponentName} LADO`, forMap: 2 }
      ];
    } else {
      // Somos Time B
      return [
        { team: 'us', action: 'ban', label: `${teamName} BAN` },
        { team: 'them', action: 'ban', label: `${opponentName} BAN` },
        { team: 'us', action: 'pick', label: `${teamName} PICK`, subtext: 'Mapa 1' },
        { team: 'them', action: 'side', label: `${opponentName} LADO`, forMap: 0 },
        { team: 'them', action: 'pick', label: `${opponentName} PICK`, subtext: 'Mapa 2' },
        { team: 'us', action: 'side', label: `${teamName} LADO`, forMap: 1 },
        { team: 'us', action: 'ban', label: `${teamName} BAN` },
        { team: 'them', action: 'ban', label: `${opponentName} BAN` },
        { team: 'them', action: 'pick', label: `${opponentName} PICK`, subtext: 'Decider', isDecider: true },
        { team: 'us', action: 'side', label: `${teamName} LADO`, forMap: 2 }
      ];
    }
  }


  selectMapForVeto(mapId, mapName) {
    const step = this.vetoState.step || 0;
    const sequence = this.getVetoSequence();
    
    if (step >= sequence.length) return;
    
    const current = sequence[step];
    
    // If current step is side selection, show side picker instead
    if (current.action === 'side') {
      this.showSidePicker(current, step);
      return;
    }

    // Support both v2 and legacy selectors
    const mapEl = document.querySelector(`.veto-v2-map-card[data-map="${mapId}"]`) || document.querySelector(`.veto-map[data-map="${mapId}"]`);
    if (!mapEl || !mapEl.classList.contains('available')) return;
    const slotEl = mapEl.closest('.veto-v2-map-slot') || mapEl.closest('.veto-map-slot');

    // Update map visual
    mapEl.classList.remove('available');
    const actionClass = current.action === 'ban' ? 'banned' : 'picked';
    mapEl.classList.add(actionClass);
    if (current.isDecider) mapEl.classList.add('decider');
    if (slotEl) {
      slotEl.classList.remove('available');
      slotEl.classList.add(actionClass);
      if (current.isDecider) slotEl.classList.add('decider');
      
      // V2: add team logo and label to card
      const logoContainer = slotEl.querySelector('.veto-v2-map-team-logo');
      if (logoContainer) {
        const team = current.team === 'us' ? app.getCurrentTeam() : this.selectedOpponent;
        const logoUrl = this.sanitizeLogoUrl(team?.logo_url);
        logoContainer.innerHTML = logoUrl ? `<img src="${logoUrl}" onerror="this.style.display='none'">` : '';
      }
      const labelEl = slotEl.querySelector('.veto-v2-map-label');
      if (labelEl) {
        const labelText = current.action === 'ban' ? 'BAN' : (current.isDecider ? 'DECIDER' : 'PICK');
        labelEl.textContent = labelText;
        labelEl.className = `veto-v2-map-label ${actionClass}`;
        if (current.isDecider) labelEl.classList.add('decider');
        labelEl.dataset.team = current.team;
      }
      
      // Legacy fallback
      const ownerEl = slotEl.querySelector('.veto-map-owner');
      if (ownerEl) {
        ownerEl.innerHTML = this.renderVetoTeamMarker(current.team);
      }
    }

    // Save to state
    this.vetoState.sequence = this.vetoState.sequence || [];
    this.vetoState.sequence.push({ team: current.team, action: current.action, map: mapName, mapId, isDecider: current.isDecider });
    this.vetoState.step = step + 1;

    // Update turn indicator
    this._updateVetoTurnIndicator();

    // Check if next step is side selection
    const nextStep = sequence[step + 1];
    if (nextStep && nextStep.action === 'side') {
      setTimeout(() => this.showSidePicker(nextStep, step + 1), 300);
    }

    // Decider não é escolha de verdade — sobrou 1 mapa só. Resolve sozinho
    // em vez de esperar clique num card que não tem outra opção.
    if (nextStep && nextStep.action === 'pick' && nextStep.isDecider) {
      const availableCards = document.querySelectorAll('.veto-v2-map-card.available, .veto-map.available');
      if (availableCards.length === 1) {
        const lastMapId = availableCards[0].dataset.map;
        const lastMap = (app.getMaps() || []).find(m => String(m.id) === String(lastMapId));
        if (lastMap) {
          setTimeout(() => this.selectMapForVeto(lastMapId, lastMap.display_name), 400);
        }
      }
    }

    // Check if complete
    this.checkVetoComplete();
  }

  showSidePicker(stepInfo, stepIndex) {
    // Prevent multiple modals
    if (this.currentSideModal) {
      this.currentSideModal.remove();
      this.currentSideModal = null;
    }
    
    // Check if this step was already completed
    const existingSide = this.vetoState.sequence.find(s => s.action === 'side' && s.stepIndex === stepIndex);
    if (existingSide) return;
    
    const picks = this.vetoState.sequence.filter(s => s.action === 'pick');
    const mapForSide = picks[stepInfo.forMap];
    if (!mapForSide) return;

    const team = stepInfo.team === 'us' ? (app.getCurrentTeam()?.name || 'Nosso Time') : (this.selectedOpponent?.name || 'Adversário');
    const mapData = (app.getMaps() || []).find(m => String(m.id) === String(mapForSide.mapId));
    const mapSplash = Utils.imagemReduzida(mapData?.splash || mapData?.listViewIcon || '', 512);

    const modal = app.createModal(`${team} escolhe o lado`, `
      <div class="side-picker-content">
        <p class="side-map-name"><strong>${mapForSide.map}</strong></p>
        <div class="side-buttons">
          <button class="side-btn attack" onclick="antitactic.selectSide('attack', '${mapForSide.map}', ${stepIndex})">
            <i class="fas fa-crosshairs"></i>
            <span>Ataque</span>
          </button>
          <button class="side-btn defense" onclick="antitactic.selectSide('defense', '${mapForSide.map}', ${stepIndex})">
            <i class="fas fa-shield-alt"></i>
            <span>Defesa</span>
          </button>
        </div>
      </div>
    `, { modalClass: 'side-picker-modal' });

    if (mapSplash) {
      const modalEl = modal.querySelector('.modal');
      if (modalEl) modalEl.style.setProperty('--side-picker-bg', `url('${mapSplash}')`);
    }

    this.currentSideModal = modal;
  }

  selectSide(side, mapName, stepIndex) {
    // Prevent double selection - close modal first
    if (this.currentSideModal) {
      this.currentSideModal.remove();
      this.currentSideModal = null;
    }
    
    // Check if this step was already completed
    const existingSide = this.vetoState.sequence.find(s => s.action === 'side' && s.stepIndex === stepIndex);
    if (existingSide) {

      return;
    }
    
    const sequence = this.getVetoSequence();
    const current = sequence[stepIndex];
    
    const sideText = side === 'attack' ? 'ATK' : 'DEF';

    // Save to state with stepIndex to prevent duplicates
    this.vetoState.sequence.push({ 
      team: current.team, 
      action: 'side', 
      side: side,
      map: mapName,
      stepIndex: stepIndex
    });
    this.vetoState.step = stepIndex + 1;

    // Update turn indicator
    this._updateVetoTurnIndicator();

    // Check if complete
    this.checkVetoComplete();
  }

  checkVetoComplete() {
    const sequence = this.getVetoSequence();
    if (this.vetoState.step >= sequence.length) {
      const picks = this.vetoState.sequence.filter(s => s.action === 'pick');
      const sides = this.vetoState.sequence.filter(s => s.action === 'side');
      const maps = app.getMaps() || [];
      
      const getMapImage = (mapName) => {
        const map = maps.find(m => m.display_name.toLowerCase() === mapName.toLowerCase());
        return map ? Utils.imagemReduzida(map.splash || map.listViewIcon, 384) || '/img/maps/default.jpg' : '/img/maps/default.jpg';
      };
      
      const team = app.getCurrentTeam();
      const teamName = team?.name || 'Nosso Time';
      const opponentName = this.selectedOpponent?.name || 'Adversário';
      
      document.getElementById('vetoResult').style.display = 'block';
      document.getElementById('resultMaps').innerHTML = picks.map((p, i) => {
        const sideInfo = sides[i];
        const sideText = sideInfo ? (sideInfo.side === 'attack' ? 'ATK' : 'DEF') : '';
        const sideTeam = sideInfo ? (sideInfo.team === 'us' ? teamName : opponentName) : '';
        const pickerTeam = p.team === 'us' ? teamName : opponentName;
        const mapImg = getMapImage(p.map);
        const mapNumber = i === 0 ? 'MAPA 1' : (i === 1 ? 'MAPA 2' : 'MAPA 3');
        
        return `
          <div class="result-map-card ${p.isDecider ? 'decider' : ''} ${i === 0 ? 'first' : (i === 1 ? 'second' : 'third')}">
            <div class="result-map-img-wrapper">
              <img src="${mapImg}" alt="${p.map}" onerror="this.src='/img/maps/default.jpg'">
              <div class="result-map-number">${p.isDecider ? '⭐ DECIDER' : mapNumber}</div>
              ${sideInfo ? `
                <div class="result-side-badge ${sideInfo.side}">
                  <i class="fas fa-${sideInfo.side === 'attack' ? 'crosshairs' : 'shield-alt'}"></i>
                  ${sideText}
                </div>
              ` : ''}
            </div>
            <div class="result-map-info">
              <h3 class="result-map-name">${p.map}</h3>
              <div class="result-map-details">
                <div class="result-picker">
                  <span class="label">Pick:</span>
                  <span class="value ${p.team === 'us' ? 'our-team' : 'their-team'}">${pickerTeam}</span>
                </div>
                ${sideInfo ? `
                  <div class="result-side">
                    <span class="label">Lado:</span>
                    <span class="value">${sideTeam} joga <strong class="${sideInfo.side}">${sideText}</strong></span>
                  </div>
                ` : ''}
              </div>
            </div>
          </div>
        `;
      }).join('');
    }
  }

  async saveVetoHistory() {
    const team = app.getCurrentTeam();
    try {
      const picks = this.vetoState.sequence.filter(s => s.action === 'pick' || s.action === 'decider');
      await api.saveVeto({
        team_id: team.id,
        opponent_id: this.selectedOpponent.id,
        veto_order: this.vetoState.sequence,
        final_map: picks[picks.length - 1]?.map,
        match_date: new Date().toISOString()
      });
      toast.success('Veto salvo!');
      this.loadVetoHistory();
    } catch (e) {
      toast.error('Erro', e.message);
    }
  }

  discardCurrentVeto() {
    if (!confirm('Descartar o veto atual?')) return;
    this.resetVeto();
    const mapsSection = document.getElementById('vetoMaps');
    mapsSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

 async loadVetoHistory() {
 try {
 if (!this.selectedOpponent?.id) return;
 const result = await api.getVetoHistory(this.selectedOpponent.id);
      const container = document.getElementById('vetoHistoryList');
      if (!container) return;
      
      const maps = app.getMaps() || [];
      const getMapImage = (mapName) => {
        const map = maps.find(m => m.display_name.toLowerCase() === mapName.toLowerCase());
        return map ? Utils.imagemReduzida(map.splash || map.listViewIcon, 384) || '/img/maps/default.jpg' : '/img/maps/default.jpg';
      };
      
      const team = app.getCurrentTeam();
      const teamName = team?.name || 'Nosso Time';
      const opponentName = this.selectedOpponent?.name || 'Adversário';
      
      if (result.success && result.data.vetos.length > 0) {
        container.innerHTML = result.data.vetos.map(v => {
          // Parse veto_order to show all picks and bans
          let vetoOrder = [];
          try {
            vetoOrder = typeof v.veto_order === 'string' ? JSON.parse(v.veto_order) : (v.veto_order || []);
          } catch(e) { vetoOrder = []; }
          
          // Extract actions with maps
          const mapActions = vetoOrder.filter(s => s.map && (s.action === 'ban' || s.action === 'pick' || s.action === 'decider'));
          const sides = vetoOrder.filter(s => s.action === 'side');
          
          // Build premium map cards
          const mapCards = mapActions.map((action, idx) => {
            const isBan = action.action === 'ban';
            const isPick = action.action === 'pick' || action.action === 'decider';
            const isDecider = action.action === 'decider' || action.isDecider;
            const actionTeam = action.team === 'us' ? teamName : opponentName;
            const mapImg = getMapImage(action.map);
            
            // Find side info for this pick
            let sideInfo = null;
            if (isPick) {
              const pickIndex = vetoOrder.filter(s => s.action === 'pick' || s.action === 'decider').indexOf(action);
              sideInfo = sides[pickIndex];
            }
            
            const sideTeam = sideInfo ? (sideInfo.team === 'us' ? teamName : opponentName) : null;
            const sideText = sideInfo ? (sideInfo.side === 'attack' ? 'ATK' : 'DEF') : null;
            
            return `
              <div class="veto-history-map-card ${isBan ? 'banned' : 'picked'} ${isDecider ? 'decider' : ''}">
                <div class="veto-map-img-wrapper">
                  <img src="${mapImg}" alt="${action.map}" onerror="this.src='/img/maps/default.jpg'">
                  <div class="veto-map-overlay ${isBan ? 'ban-overlay' : 'pick-overlay'}">
                    <span class="veto-action-badge">${isBan ? 'BAN' : (isDecider ? 'DECIDER' : 'PICK')}</span>
                  </div>
                  ${sideInfo ? `
                    <div class="veto-side-badge ${sideInfo.side}">
                      <i class="fas fa-${sideInfo.side === 'attack' ? 'crosshairs' : 'shield-alt'}"></i>
                      ${sideText}
                    </div>
                  ` : ''}
                </div>
                <div class="veto-map-info">
                  <span class="veto-map-name">${action.map}</span>
                  <span class="veto-map-team ${action.team === 'us' ? 'our-team' : 'their-team'}">
                    <i class="fas fa-${action.team === 'us' ? 'home' : 'users-slash'}"></i>
                    ${actionTeam}
                  </span>
                  ${sideInfo ? `
                    <span class="veto-side-team">
                      ${sideTeam} joga ${sideText}
                    </span>
                  ` : ''}
                </div>
              </div>
            `;
          }).join('');
          
          return `
            <div class="veto-history-card">
              <div class="veto-history-card-header">
                <div class="veto-history-meta">
                  <span class="veto-date-badge">
                    <i class="fas fa-calendar"></i>
                    ${new Date(v.created_at).toLocaleDateString('pt-BR')}
                  </span>
                  <span class="veto-vs-badge">
                    ${teamName} vs ${opponentName}
                  </span>
                </div>
                <button class="btn-icon-sm btn-danger" onclick="antitactic.deleteVetoHistory('${v.id}')" title="Excluir">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
              <div class="veto-history-maps-grid">
                ${mapCards}
              </div>
            </div>
          `;
        }).join('');
      } else {
        container.innerHTML = `
          <div class="empty-veto-history">
            <i class="fas fa-history"></i>
            <p>Nenhum histórico de veto</p>
            <span>Complete uma simulação e salve para ver aqui</span>
          </div>
        `;
      }
    } catch (e) {
      console.error('Load veto history error:', e);
    }
  }

  async deleteVetoHistory(vetoId) {
    if (!confirm('Excluir este veto?')) return;
    try {
      await api.deleteVeto(vetoId);
      this.loadVetoHistory();
    } catch (e) {
      toast.error('Erro', e.message);
    }
  }

  // =====================================================
  // MODALS
  // =====================================================

  async showAddOpponentModal() {
    const team = app.getCurrentTeam();
    if (!team?.id) {
      toast.error('Nenhum time selecionado', 'Crie ou entre em um time zdval antes de cadastrar adversários.');
      return;
    }

    const result = await tactics.modals.opponent({ title: 'Adicionar Time Adversário', confirmLabel: 'Adicionar Time' });
    if (!result) return;

    try {
      await api.createOpponent({
        team_id: team.id,
        name: result.name,
        tag: result.tag,
        logo_url: null,
        notes: null
      });
      toast.success('Time adicionado!');
      await this.loadOpponents();
      // Auto-select the newly created opponent
      const newOpp = this.opponents.find(o => o.name === result.name);
      if (newOpp) {
        this.selectedOpponent = newOpp;
        if (!this.isEmbedded) {
          window.history.pushState({}, '', this._buildAntitaticUrl());
        }
      }
      this.renderPage();
    } catch (err) {
      toast.error('Erro', err.message);
    }
  }

  async editOpponent(id) {
    this.selectedOpponentMenuOpen = false;
    const o = this.opponents.find(op => op.id === id);
    if (!o) return;

    const result = await tactics.modals.opponent({
      title: 'Editar Time',
      confirmLabel: 'Salvar Alterações',
      initial: { name: o.name, tag: o.tag }
    });
    if (!result) return;

    try {
      await api.updateOpponent(id, {
        name: result.name,
        tag: result.tag,
        logo_url: this.sanitizeLogoUrl(o.logo_url)
      });
      toast.success('Atualizado!');
      await this.loadOpponents();
      this.renderPage();
    } catch (err) {
      toast.error('Erro', err.message);
    }
  }

  async deleteOpponent(id) {
    const ok = await tactics.modals.confirm({
      title: 'Excluir time adversário',
      message: 'Todos os dados deste time (estratégias, pick/ban, análises) serão perdidos. Não dá para desfazer.',
      confirmLabel: 'Excluir time'
    });
    if (!ok) return;
    try {
      this.selectedOpponentMenuOpen = false;
      await api.deleteOpponent(id);
      if (this.selectedOpponent?.id === id) {
        this.selectedOpponent = null;
        this.showOpponentPicker = true;
      }
      await this.loadOpponents();
      this.renderPage();
      toast.success('Time excluído!');
    } catch (e) {
      toast.error('Erro', e.message);
    }
  }

  async atSwitchOpponent(id) {
    const opp = this.opponents.find(o => String(o.id) === String(id));
    if (!opp || opp.id === this.selectedOpponent?.id) return;
    this.selectedOpponent = opp;
    if (!this.isEmbedded) {
      window.history.pushState({}, '', this._buildAntitaticUrl());
    }
    this.renderPage();
    this.loadVetoHistory();
  }


  // =====================================================
  // ANALYSIS TAB - Player Stats (like Ranked)
  // =====================================================

  renderAnalysisTab() {
    return `
      <div class="analysis-section">
        <div class="analysis-header">
          <h3><i class="fas fa-chart-line"></i> Análise de Jogadores</h3>
          <div class="analysis-actions">
            <button class="btn-premium-refresh" onclick="antitactic.refreshAnalysis()">
              <div class="btn-premium-refresh-inner">
                <i class="fas fa-sync-alt"></i>
                <span>Atualizar</span>
              </div>
            </button>
            <button class="btn btn-primary" onclick="antitactic.showAddPlayerModal()">
              <i class="fas fa-plus"></i> Adicionar Jogador
            </button>
          </div>
        </div>
        
        <div class="analysis-players-grid" id="analysisPlayersGrid">
          <div class="loading-state">
            <div class="spinner"></div>
            <p>Carregando jogadores...</p>
          </div>
        </div>
      </div>
      
      <!-- Fullscreen Analysis Modal -->
      <div id="opponentAnalysisModal" class="ranked-fullscreen-analysis" style="display: none;">
        <div id="opponentAnalysisContent" class="ranked-fullscreen-content"></div>
      </div>
    `;
  }

  async loadAnalysisContent() {
    if (!this.selectedOpponent) {
      document.getElementById('analysisPlayersGrid').innerHTML = `
        <div class="empty-state">
          <i class="fas fa-users"></i>
          <p>Selecione um adversário</p>
        </div>
      `;
      return;
    }
    try {
      // Load static data (agents/maps) if not already loaded
      await this.loadAnalysisStaticData();
      
      // Load opponent players
      const result = await api.getOpponentPlayers(this.selectedOpponent.id);
      // A API responde { success:false } sem lançar (ex.: 401 sem login).
      // Sem este else o spinner ficava girando pra sempre.
      if (!result?.success) throw new Error(result?.message || 'Falha ao carregar jogadores');

      this.opponentPlayers = result.data.players;
      this.renderAnalysisPlayersGrid();

      // Load stats for each player
      this.loadAllOpponentPlayersStats();
    } catch (error) {
      console.error('Load analysis error:', error);
      const grid = document.getElementById('analysisPlayersGrid');
      if (!grid) return;
      const needsLogin = !auth?.isAuthenticated;
      grid.innerHTML = `
        <div class="empty-state">
          <i class="fas fa-${needsLogin ? 'lock' : 'exclamation-circle'}"></i>
          <p>${needsLogin
            ? 'Entre na sua conta para ver a análise dos jogadores.'
            : 'Não foi possível carregar os jogadores.'}</p>
          ${needsLogin
            ? '<button class="btn btn-primary" onclick="auth.openAuth(\'login\')">Entrar</button>'
            : '<button class="btn btn-secondary" onclick="antitactic.loadAnalysisContent()">Tentar de novo</button>'}
        </div>
      `;
    }
  }

  async loadAnalysisStaticData() {
    if (this.agentsData && this.mapsData) return;
    
    try {
      const [agentsResult, mapsResult] = await Promise.all([
        api.getValorantAgents(),
        api.getValorantMaps()
      ]);
      
      if (agentsResult.data) {
        this.agentsData = {};
        agentsResult.data.forEach(agent => {
          this.agentsData[agent.displayName.toLowerCase()] = agent;
        });
      }
      
      if (mapsResult.data) {
        this.mapsData = {};
        this.mapsCallouts = {};
        this.mapsMultipliers = {};
        
        mapsResult.data.forEach(map => {
          const mapKey = map.displayName.toLowerCase();
          this.mapsData[mapKey] = map;
          
          if (map.callouts) {
            this.mapsCallouts[mapKey] = map.callouts;
          }
          
          const xMult = map.xMultiplier || 0;
          const yMult = map.yMultiplier || 0;
          const xAdd = map.xScalarToAdd || 0;
          const yAdd = map.yScalarToAdd || 0;
          
          let minX = Infinity, maxX = -Infinity;
          let minY = Infinity, maxY = -Infinity;
          
          if (map.callouts && map.callouts.length > 0 && xMult !== 0) {
            map.callouts.forEach(callout => {
              const loc = callout.location;
              if (loc && loc.x !== undefined && loc.y !== undefined) {
                const normX = loc.x * xMult + xAdd;
                const normY = loc.y * yMult + yAdd;
                minX = Math.min(minX, normX);
                maxX = Math.max(maxX, normX);
                minY = Math.min(minY, normY);
                maxY = Math.max(maxY, normY);
              }
            });
            
            const rangeX = maxX - minX;
            const rangeY = maxY - minY;
            minX -= rangeX * 0.10;
            maxX += rangeX * 0.10;
            minY -= rangeY * 0.10;
            maxY += rangeY * 0.10;
          } else {
            minX = 0; maxX = 1; minY = 0; maxY = 1;
          }
          
          this.mapsMultipliers[mapKey] = {
            xMultiplier: xMult,
            yMultiplier: yMult,
            xScalarToAdd: xAdd,
            yScalarToAdd: yAdd,
            minX, maxX, minY, maxY,
            displayIcon: map.displayIcon
          };
        });
      }
    } catch (error) {
      console.warn('Could not load static data:', error);
    }
  }

  renderAnalysisPlayersGrid() {
    const grid = document.getElementById('analysisPlayersGrid');
    
    if (this.opponentPlayers.length === 0) {
      grid.innerHTML = '';
      return;
    }

    grid.innerHTML = this.opponentPlayers.map(player => this.renderOpponentPlayerCard(player)).join('');
  }

  renderOpponentPlayerCard(player) {
    const hasAvatar = player.avatar_url && player.avatar_url !== '' && player.avatar_url !== 'null';
    const playerInitial = (player.display_name || '?').charAt(0).toUpperCase();
    const isIGL = player.role === 'igl';
    
    const roleLabels = {
      player: { label: 'Player', icon: '🎮', color: 'danger' },
      igl: { label: 'IGL', icon: '👑', color: 'warning' }
    };
    
    const roleInfo = roleLabels[player.role] || { label: player.role, icon: '👤', color: 'secondary' };
    const hasRiotId = player.riot_id && player.riot_tag;
    const fullRiotId = hasRiotId ? `${player.riot_id}#${player.riot_tag}` : null;

    return `
      <div class="ranked-player-card opponent-player-card ${isIGL ? 'is-igl' : ''}" data-player-id="${player.id}">
        <div class="ranked-card-glow opponent-glow"></div>
        <div class="ranked-card-content">
          
          <div class="ranked-card-header">
            <div class="ranked-avatar-wrapper">
              <div class="ranked-avatar-ring ${isIGL ? 'ring-gold' : 'ring-red'}">
                ${hasAvatar ? `
                  <img src="${player.avatar_url}" 
                       alt="${player.display_name}" 
                       class="ranked-avatar-img"
                       onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
                  <div class="ranked-avatar-fallback opponent-fallback" style="display:none;">
                    <span>${playerInitial}</span>
                  </div>
                ` : `
                  <div class="ranked-avatar-fallback opponent-fallback">
                    <span>${playerInitial}</span>
                  </div>
                `}
              </div>
            </div>
            
            <div class="ranked-player-info">
              <h3 class="ranked-player-name">${player.display_name}</h3>
              ${hasRiotId ? `<span class="ranked-riot-id">${fullRiotId}</span>` : '<span class="ranked-riot-id no-riot">Sem Riot ID</span>'}
              <div class="ranked-role-badge badge-${roleInfo.color}">
                <span class="role-icon">${roleInfo.icon}</span>
                <span class="role-label">${roleInfo.label}</span>
              </div>
            </div>
            
            <div class="opponent-card-actions">
              <button class="btn-icon-sm" onclick="event.stopPropagation(); antitactic.editOpponentPlayer('${player.id}')" title="Editar">
                <i class="fas fa-edit"></i>
              </button>
              <button class="btn-icon-sm btn-danger" onclick="event.stopPropagation(); antitactic.deleteOpponentPlayer('${player.id}')" title="Excluir">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
          
          <div class="ranked-stats-preview">
            <div class="ranked-stat-item">
              <i class="fas fa-trophy"></i>
              <span class="stat-label">Rank</span>
              <span class="stat-value stat-pending" id="opp-rank-${player.id}">--</span>
            </div>
            <div class="ranked-stat-item">
              <i class="fas fa-crosshairs"></i>
              <span class="stat-label">K/D</span>
              <span class="stat-value stat-pending" id="opp-kd-${player.id}">--</span>
            </div>
            <div class="ranked-stat-item">
              <i class="fas fa-percentage"></i>
              <span class="stat-label">Win%</span>
              <span class="stat-value stat-pending" id="opp-winrate-${player.id}">--</span>
            </div>
          </div>
          
          <div class="ranked-card-actions">
            ${hasRiotId ? `
              <button class="btn-ranked-action btn-view-profile opponent-view" onclick="antitactic.viewOpponentAnalysis('${player.id}')" title="Ver Análise Completa">
                <i class="fas fa-chart-line"></i>
                <span>Ver Análise</span>
              </button>
            ` : `
              <button class="btn-ranked-action btn-no-riot" disabled title="Riot ID não configurado">
                <i class="fas fa-exclamation-circle"></i>
                <span>Sem Riot ID</span>
              </button>
            `}
          </div>
          
        </div>
      </div>
    `;
  }

  async loadAllOpponentPlayersStats() {
    for (const player of this.opponentPlayers) {
      if (player.riot_id && player.riot_tag) {
        await this.loadOpponentPlayerQuickStats(player);
        await new Promise(resolve => setTimeout(resolve, 2500));
      }
    }
  }

  async loadOpponentPlayerQuickStats(player, retryCount = 0) {
    const maxRetries = 3;
    
    try {
      const region = player.region || 'br';
      const name = player.riot_id;
      const tag = player.riot_tag;

      this.updateAnalysisStatElement(`opp-rank-${player.id}`, '...', 'loading');
      this.updateAnalysisStatElement(`opp-kd-${player.id}`, '...', 'loading');
      this.updateAnalysisStatElement(`opp-winrate-${player.id}`, '...', 'loading');

      let mmrResult = null;
      let matchesResult = null;
      
      try {
        mmrResult = await api.getValorantMMR(region, name, tag);
      } catch (e) {

      }
      
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      try {
        matchesResult = await api.getValorantMatches(region, name, tag, 'competitive', 20);
      } catch (e) {

      }

      if (mmrResult?.success && mmrResult?.data?.currenttierpatched) {
        const rank = this.simplifyRank(mmrResult.data.currenttierpatched);
        const rankImage = mmrResult.data.images?.small || '';
        this.updateAnalysisRankElement(`opp-rank-${player.id}`, rank, rankImage);
      } else if (retryCount < maxRetries) {

        await new Promise(resolve => setTimeout(resolve, 5000));
        return this.loadOpponentPlayerQuickStats(player, retryCount + 1);
      } else {
        this.updateAnalysisStatElement(`opp-rank-${player.id}`, 'N/A', 'error');
      }

      if (matchesResult?.success && matchesResult?.data?.matches?.length > 0) {
        const matches = matchesResult.data.matches;
        let totalKills = 0;
        let totalDeaths = 0;
        let wins = 0;

        matches.forEach(match => {
          const matchPlayer = match.player;
          if (!matchPlayer) return;

          totalKills += matchPlayer.stats?.kills || 0;
          totalDeaths += matchPlayer.stats?.deaths || 0;

          const playerTeamId = (matchPlayer.team_id || matchPlayer.team || '').toLowerCase();
          
          let playerWon = false;
          if (Array.isArray(match.teams)) {
            const playerTeamData = match.teams.find(t => t.team_id?.toLowerCase() === playerTeamId);
            playerWon = playerTeamData?.won === true;
          } else if (match.teams) {
            const teamData = match.teams[playerTeamId];
            playerWon = teamData?.has_won === true || teamData?.won === true;
          }
          
          if (playerWon) {
            wins++;
          }
        });

        const kd = totalDeaths > 0 ? (totalKills / totalDeaths).toFixed(2) : totalKills.toFixed(2);
        const kdColor = parseFloat(kd) >= 1.2 ? '#4ade80' : (parseFloat(kd) < 1.0 ? '#ef4444' : '#fbbf24');
        this.updateAnalysisStatElement(`opp-kd-${player.id}`, kd, 'success', kdColor);

        const winRate = Math.round((wins / matches.length) * 100);
        const winColor = winRate >= 55 ? '#4ade80' : (winRate < 45 ? '#ef4444' : '#fbbf24');
        this.updateAnalysisStatElement(`opp-winrate-${player.id}`, `${winRate}%`, 'success', winColor);
      } else {
        this.updateAnalysisStatElement(`opp-kd-${player.id}`, 'N/A', 'error');
        this.updateAnalysisStatElement(`opp-winrate-${player.id}`, 'N/A', 'error');
      }
    } catch (error) {
      console.warn(`Failed to load stats for ${player.display_name}:`, error);
      this.updateAnalysisStatElement(`opp-rank-${player.id}`, 'Erro', 'error');
      this.updateAnalysisStatElement(`opp-kd-${player.id}`, 'Erro', 'error');
      this.updateAnalysisStatElement(`opp-winrate-${player.id}`, 'Erro', 'error');
    }
  }

  simplifyRank(rankName) {
    if (!rankName) return '--';
    
    const rankMap = {
      'Iron': 'I',
      'Bronze': 'B',
      'Silver': 'S',
      'Gold': 'G',
      'Platinum': 'P',
      'Diamond': 'D',
      'Ascendant': 'A',
      'Immortal': 'IM',
      'Radiant': 'RAD'
    };

    const parts = rankName.split(' ');
    if (parts.length >= 2) {
      const tier = rankMap[parts[0]] || parts[0].charAt(0);
      return `${tier}${parts[1]}`;
    }
    
    return rankMap[rankName] || rankName;
  }

  updateAnalysisRankElement(id, rankText, rankImage) {
    const el = document.getElementById(id);
    if (!el) return;
    
    el.classList.remove('stat-pending', 'stat-loading', 'stat-error');
    
    if (rankImage) {
      el.innerHTML = `<img src="${rankImage}" alt="${rankText}" class="rank-icon" title="${rankText}"><span class="rank-text">${rankText}</span>`;
    } else {
      el.textContent = rankText;
    }
  }

  updateAnalysisStatElement(id, value, status, color = null) {
    const el = document.getElementById(id);
    if (!el) return;
    
    el.textContent = value;
    el.classList.remove('stat-pending', 'stat-loading', 'stat-error');
    
    if (status === 'loading') {
      el.classList.add('stat-loading');
      el.style.color = '#888';
    } else if (status === 'error') {
      el.classList.add('stat-error');
      el.style.color = '#888';
    } else if (status === 'success' && color) {
      el.style.color = color;
    }
  }

  async refreshAnalysis() {
    if (this.analysisLoading) return;
    this.analysisLoading = true;
    toast.info('Atualizando...', 'Sincronizando dados de ranked');
    this.playerAnalysis.clear();
    await this.loadAllOpponentPlayersStats();
    this.analysisLoading = false;
    toast.success('Atualizado', 'Dados de ranked sincronizados');
  }

  // Add/Edit/Delete Opponent Players
  showAddPlayerModal() {
    // Criar modal premium para adicionar jogador adversário
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'modal-overlay';
    modalOverlay.id = 'addOpponentPlayerModal';
    modalOverlay.innerHTML = `
      <div class="modal add-opponent-modal">
        <div class="modal-header">
          <div class="header-content">
            <div class="header-icon opponent-icon">
              <i class="fas fa-user-plus"></i>
            </div>
            <div class="header-text">
              <h3>Adicionar Jogador Adversário</h3>
              <p>Busque pelo Riot ID ou adicione manualmente</p>
            </div>
          </div>
          <button class="btn-icon modal-close-btn">
            <i class="fas fa-times"></i>
          </button>
        </div>
        
        <div class="modal-body">
          <!-- Busca por Riot ID - Destaque Premium -->
          <div class="search-section opponent-search">
            <div class="search-header">
              <i class="fab fa-riot-games"></i>
              <span>Buscar por Riot ID</span>
              <span class="badge-auto opponent-badge">Automático</span>
            </div>
            <div class="riot-search-container">
              <div class="search-input-wrapper">
                <input type="text" id="oppRiotIdSearch" class="form-input" placeholder="Player#BR1">
              </div>
              <button type="button" class="btn btn-primary btn-glow opponent-glow" id="searchOppPlayerBtn">
                <i class="fas fa-search"></i>
              </button>
            </div>
            <div id="oppSearchResult" style="display:none;"></div>
          </div>
          
          <div class="divider"><span>ou preencha manualmente</span></div>
          
          <form id="addOpponentPlayerForm">
            <div class="form-row">
              <div class="form-group" style="grid-column:1/-1">
                <label for="oppPlayerRole"><i class="fas fa-crown"></i> Cargo</label>
                <div class="custom-select-wrapper" id="oppRoleSelectWrapper">
                  <div class="custom-select-trigger" id="oppRoleTrigger">
                    <span class="selected-icon">🎮</span>
                    <span class="selected-text">Jogador</span>
                    <i class="fas fa-chevron-down"></i>
                  </div>
                  <div class="custom-select-options" id="oppRoleOptions">
                    <div class="custom-option selected" data-value="player">
                      <span class="option-icon">🎮</span>
                      <span class="option-text">Jogador</span>
                    </div>
                    <div class="custom-option" data-value="igl">
                      <span class="option-icon">👑</span>
                      <span class="option-text">IGL</span>
                    </div>
                  </div>
                  <input type="hidden" id="oppPlayerRole" value="player">
                </div>
              </div>
            </div>
            
            <div class="form-row">
              <div class="form-group" style="grid-column:1/-1">
                <label><i class="fas fa-globe"></i> Região</label>
                <select class="form-input" id="oppPlayerRegion">
                  <option value="br">Brasil (BR)</option>
                  <option value="na">North America (NA)</option>
                  <option value="eu">Europe (EU)</option>
                  <option value="kr">Korea (KR)</option>
                  <option value="ap">Asia Pacific (AP)</option>
                  <option value="latam">Latin America (LATAM)</option>
                </select>
              </div>
            </div>
            
            <input type="hidden" id="oppPlayerName" value="">
            <input type="hidden" id="oppPlayerNotes" value="">
            <input type="hidden" id="oppPlayerRiotId" value="">
            <input type="hidden" id="oppPlayerRiotTag" value="">
            <input type="hidden" id="oppPlayerAvatar" value="">
            
            <div class="form-actions">
              <button type="button" class="btn btn-ghost modal-close-btn">
                <i class="fas fa-times"></i> Cancelar
              </button>
              <button type="submit" class="btn btn-primary btn-glow opponent-glow" id="addOppPlayerBtn">
                <i class="fas fa-plus"></i> Adicionar Jogador
              </button>
            </div>
          </form>
        </div>
      </div>
    `;

    // Estilos do modal Premium
    // O CSS mora em css/pages/antitactic-main.css. Ficava aqui como template string,
    // somando peso ao bundle de JS e impedindo que a folha fosse cacheada
    // e minificada em separado. Segue carregando sob demanda, como antes.
    Utils.loadPageCss('addOpponentPlayerModalStyles', 'antitactic-main.css');
    document.body.appendChild(modalOverlay);

    // Event listeners
    const closeModal = () => {
      modalOverlay.remove();
      style.remove();
    };

    modalOverlay.querySelectorAll('.modal-close-btn').forEach(btn => {
      btn.addEventListener('click', closeModal);
    });

    modalOverlay.addEventListener('click', (e) => {
      if (e.target === modalOverlay) closeModal();
    });

    // Custom Select Dropdown
    const roleTrigger = document.getElementById('oppRoleTrigger');
    const roleOptions = document.getElementById('oppRoleOptions');
    const roleInput = document.getElementById('oppPlayerRole');
    
    roleTrigger.addEventListener('click', (e) => {
      e.stopPropagation();
      roleTrigger.classList.toggle('open');
      roleOptions.classList.toggle('open');
    });
    
    roleOptions.querySelectorAll('.custom-option').forEach(option => {
      option.addEventListener('click', () => {
        const value = option.dataset.value;
        const icon = option.querySelector('.option-icon').textContent;
        const text = option.querySelector('.option-text').textContent;
        
        roleInput.value = value;
        roleTrigger.querySelector('.selected-icon').textContent = icon;
        roleTrigger.querySelector('.selected-text').textContent = text;
        
        roleOptions.querySelectorAll('.custom-option').forEach(o => o.classList.remove('selected'));
        option.classList.add('selected');
        
        roleTrigger.classList.remove('open');
        roleOptions.classList.remove('open');
      });
    });
    
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.custom-select-wrapper')) {
        roleTrigger.classList.remove('open');
        roleOptions.classList.remove('open');
      }
    });

    // Buscar jogador pelo Riot ID
    const searchBtn = document.getElementById('searchOppPlayerBtn');
    const searchInput = document.getElementById('oppRiotIdSearch');
    const searchResult = document.getElementById('oppSearchResult');
    
    const searchPlayer = async () => {
      const riotId = searchInput.value.trim();
      if (!riotId || !riotId.includes('#')) {
        toast.error('Erro', 'Digite o Riot ID no formato Nome#TAG');
        return;
      }
      
      const [name, tag] = riotId.split('#');
      
      searchResult.style.display = 'block';
      searchResult.className = 'search-result loading';
      searchResult.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Buscando jogador...';
      
      try {
        const data = await api.get(`/valorant/account/${encodeURIComponent(name)}/${encodeURIComponent(tag)}`);
        
        if (data.success && data.data) {
          const player = data.data;
          searchResult.className = 'search-result';
          searchResult.innerHTML = `
            <div class="player-found">
              <img src="${player.card || '/img/default-avatar.png'}" alt="${player.name}" class="player-card-img" onerror="this.src='/img/default-avatar.png'">
              <div class="player-info">
                <div class="player-name">${player.name}<span class="player-tag">#${player.tag}</span></div>
                <div class="player-details">
                  <span><i class="fas fa-globe"></i> ${player.region?.toUpperCase() || 'BR'}</span>
                  <span><i class="fas fa-star"></i> Nível ${player.account_level || '?'}</span>
                </div>
              </div>
              <button type="button" class="btn-add-found" onclick="antitactic.addFoundOpponentPlayer('${(player.name || '').replace(/'/g, "\\'").replace(/"/g, '&quot;')}', '${(player.tag || '').replace(/'/g, "\\'").replace(/"/g, '&quot;')}', '${(player.card || '').replace(/'/g, "\\'").replace(/"/g, '&quot;')}', '${(player.region || 'br').replace(/'/g, "\\'").replace(/"/g, '&quot;')}')">
                <i class="fas fa-plus"></i> Adicionar
              </button>
            </div>
          `;
        } else {
          const errorMsg = data.error || 'Jogador não encontrado';
          searchResult.className = 'search-result error';
          searchResult.innerHTML = `<i class="fas fa-exclamation-circle"></i> ${errorMsg}`;
          // Auto-preenche o form manual
          document.getElementById('oppPlayerName').value = name;
          document.getElementById('oppPlayerRiotId').value = name;
          document.getElementById('oppPlayerRiotTag').value = tag;
        }
      } catch (error) {
        searchResult.className = 'search-result error';
        searchResult.innerHTML = '<i class="fas fa-exclamation-circle"></i> Erro ao buscar jogador';
      }
    };
    
    searchBtn.addEventListener('click', searchPlayer);
    searchInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        searchPlayer();
      }
    });

    // Form submit
    const form = modalOverlay.querySelector('#addOpponentPlayerForm');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const name = document.getElementById('oppPlayerName').value;
      const riotId = document.getElementById('oppPlayerRiotId').value;
      const riotTag = document.getElementById('oppPlayerRiotTag').value;
      const region = document.getElementById('oppPlayerRegion').value;
      const role = document.getElementById('oppPlayerRole').value;
      const notes = document.getElementById('oppPlayerNotes').value;
      const avatar = document.getElementById('oppPlayerAvatar').value;
      
      if (!riotId && !name) {
        toast.error('Erro', 'Busque um jogador pelo Riot ID');
        return;
      }
      
      try {
        const result = await api.createOpponentPlayer({
          opponent_id: this.selectedOpponent.id,
          display_name: name,
          riot_id: riotId || null,
          riot_tag: riotTag || null,
          region: region,
          role: role,
          avatar_url: avatar || null,
          notes: notes || null
        });
        
        if (result.success) {
          toast.success('Sucesso', 'Jogador adicionado com sucesso!');
          closeModal();
          this.loadAnalysisContent();
        }
      } catch (error) {
        toast.error('Erro', error.message || 'Falha ao adicionar jogador');
      }
    });
  }

  // Adicionar jogador encontrado pela busca
  async addFoundOpponentPlayer(name, tag, cardUrl, region) {
    const role = document.getElementById('oppPlayerRole')?.value || 'player';
    
    try {
      const result = await api.createOpponentPlayer({
        opponent_id: this.selectedOpponent.id,
        display_name: name,
        riot_id: name,
        riot_tag: tag,
        region: region || 'br',
        role: role,
        avatar_url: cardUrl || null,
        notes: null
      });
      
      if (result.success) {
        toast.success('Sucesso', `${name}#${tag} adicionado!`);
        const modal = document.getElementById('addOpponentPlayerModal');
        const style = document.getElementById('addOpponentPlayerModalStyles');
        if (modal) modal.remove();
        if (style) style.remove();
        this.loadAnalysisContent();
      }
    } catch (error) {
      toast.error('Erro', error.message || 'Falha ao adicionar jogador');
    }
  }


  editOpponentPlayer(playerId) {
    const player = this.opponentPlayers.find(p => p.id === playerId);
    if (!player) return;
    
    const modal = app.createModal('Editar Jogador Adversário', `
        <form id="editOpponentPlayerForm" class="form-premium">
          <div class="form-group">
            <label><i class="fas fa-user"></i> Nome do Jogador *</label>
            <input type="text" class="form-control" name="display_name" required value="${player.display_name || ''}">
          </div>
          
          <div class="form-row">
            <div class="form-group flex-2">
              <label><i class="fab fa-riot-games"></i> Riot ID</label>
              <input type="text" class="form-control" name="riot_id" value="${player.riot_id || ''}">
            </div>
            <div class="form-group flex-1">
              <label># Tag</label>
              <input type="text" class="form-control" name="riot_tag" value="${player.riot_tag || ''}" maxlength="10">
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label><i class="fas fa-globe"></i> Região</label>
              <select class="form-control" name="region">
                <option value="br" ${player.region === 'br' ? 'selected' : ''}>Brasil (BR)</option>
                <option value="na" ${player.region === 'na' ? 'selected' : ''}>North America (NA)</option>
                <option value="eu" ${player.region === 'eu' ? 'selected' : ''}>Europe (EU)</option>
                <option value="kr" ${player.region === 'kr' ? 'selected' : ''}>Korea (KR)</option>
                <option value="ap" ${player.region === 'ap' ? 'selected' : ''}>Asia Pacific (AP)</option>
                <option value="latam" ${player.region === 'latam' ? 'selected' : ''}>Latin America (LATAM)</option>
              </select>
            </div>
            <div class="form-group">
              <label><i class="fas fa-crown"></i> Função</label>
              <select class="form-control" name="role">
                <option value="player" ${player.role === 'player' ? 'selected' : ''}>Player</option>
                <option value="igl" ${player.role === 'igl' ? 'selected' : ''}>IGL</option>
              </select>
            </div>
          </div>
          
          <div class="form-group">
            <label><i class="fas fa-sticky-note"></i> Notas</label>
            <textarea class="form-control" name="notes" rows="2">${player.notes || ''}</textarea>
          </div>

          <div class="form-actions">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button type="submit" class="btn btn-primary">Salvar</button>
          </div>
        </form>
      `, {
      size: 'medium'
    });

    const form = modal.querySelector('#editOpponentPlayerForm');
    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        await this.submitEditPlayer(playerId);
      });
    }
  }

  async submitEditPlayer(playerId) {
    const form = document.getElementById('editOpponentPlayerForm');
    const formData = new FormData(form);
    
    const data = {
      display_name: formData.get('display_name'),
      riot_id: formData.get('riot_id') || null,
      riot_tag: formData.get('riot_tag') || null,
      region: formData.get('region'),
      role: formData.get('role'),
      notes: formData.get('notes') || null
    };
    
    try {
      const result = await api.updateOpponentPlayer(playerId, data);
      if (result.success) {
        toast.success('Sucesso', 'Jogador atualizado');
        app.closeModal();
        this.loadAnalysisContent();
      }
    } catch (error) {
      toast.error('Erro', error.message);
    }
  }

  async deleteOpponentPlayer(playerId) {
    const player = this.opponentPlayers.find(p => p.id === playerId);
    if (!player) return;
    
    if (!confirm(`Tem certeza que deseja excluir o jogador "${player.display_name}"?`)) return;
    
    try {
      const result = await api.deleteOpponentPlayer(playerId);
      if (result.success) {
        toast.success('Sucesso', 'Jogador excluído');
        this.loadAnalysisContent();
      }
    } catch (error) {
      toast.error('Erro', error.message);
    }
  }

  // Full Player Analysis View
  async viewOpponentAnalysis(playerId) {
    const player = this.opponentPlayers.find(p => p.id === playerId);
    if (!player) return;

    if (!player.riot_id || !player.riot_tag) {
      toast.error('Erro', 'Este jogador não possui Riot ID configurado');
      return;
    }

    const hasAvatar = player.avatar_url && player.avatar_url !== '' && player.avatar_url !== 'null';
    const playerInitial = (player.display_name || '?').charAt(0).toUpperCase();

    const modal = document.getElementById('opponentAnalysisModal');
    const content = document.getElementById('opponentAnalysisContent');
    modal.style.display = 'flex';
    modal.classList.add('show');
    document.body.style.overflow = 'hidden';
    
    content.innerHTML = `
      <div class="fullscreen-loading-container">
        <div class="premium-loading-card opponent-loading">
          <div class="loading-avatar-wrapper">
            ${hasAvatar ? `
              <img src="${player.avatar_url}" alt="${player.display_name}" class="loading-avatar-img">
            ` : `
              <div class="loading-avatar-fallback opponent-fallback"><span>${playerInitial}</span></div>
            `}
            <div class="loading-avatar-ring opponent-ring"></div>
          </div>
          <h2 class="loading-player-name">${player.display_name}</h2>
          <span class="loading-riot-id">${player.riot_id}#${player.riot_tag}</span>
          <div class="loading-progress-container">
            <div class="loading-progress-bar">
              <div class="loading-progress-fill opponent-fill"></div>
            </div>
            <p class="loading-status">Carregando dados de ranqueadas...</p>
          </div>
          <div class="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    `;

    try {
      const name = player.riot_id;
      const tag = player.riot_tag;
      const region = player.region || 'br';

      const matchesResult = await api.getValorantMatches(region, name, tag, 'competitive', 50);
      
      if (!matchesResult.success || !matchesResult.data.matches.length) {
        content.innerHTML = this.renderNoMatchesFoundOpponent(player);
        return;
      }

      const matches = matchesResult.data.matches;
      const analysis = this.analyzeOpponentMatches(matches, name);
      
      this.playerAnalysis.set(playerId, { ...analysis, rawMatches: matches, playerName: name });
      
      content.innerHTML = this.renderOpponentAnalysisContent(player, analysis, matches, name);
      
      this.setupOpponentPeriodTabs(playerId, matches, name);
      
    } catch (error) {
      console.error('Error loading player analysis:', error);
      const isRateLimit = error.message?.includes('429') || error.message?.includes('Muitas requisições');
      content.innerHTML = `
        <div class="fullscreen-analysis-header">
          <button class="btn-back-premium opponent-back" onclick="antitactic.closeOpponentAnalysisModal()">
            <i class="fas fa-arrow-left"></i>
            <span>Voltar</span>
          </button>
        </div>
        <div class="fullscreen-analysis-body">
          <div class="premium-empty-state error">
            <i class="fas fa-${isRateLimit ? 'clock' : 'exclamation-triangle'}"></i>
            <h3>${isRateLimit ? 'Limite de requisições atingido' : 'Erro ao carregar dados'}</h3>
            <p>${isRateLimit ? 'Aguarde alguns segundos e tente novamente.' : (error.message || 'Não foi possível buscar o histórico de partidas')}</p>
            <button class="btn btn-primary" style="margin-top: 15px;" onclick="antitactic.viewOpponentAnalysis('${playerId}')">
              <i class="fas fa-redo"></i> Tentar novamente
            </button>
          </div>
        </div>
      `;
    }
  }

  closeOpponentAnalysisModal() {
    const modal = document.getElementById('opponentAnalysisModal');
    if (modal) {
      modal.style.display = 'none';
      modal.classList.remove('show');
      document.body.style.overflow = '';
    }
  }

  analyzeOpponentMatches(matches) {
    const now = new Date();
    const dayAgo = new Date(now - 24 * 60 * 60 * 1000);
    const weekAgo = new Date(now - 7 * 24 * 60 * 60 * 1000);
    const monthAgo = new Date(now - 30 * 24 * 60 * 60 * 1000);

    const getMatchDate = (m) => {
      if (m.metadata?.started_at) {
        return new Date(m.metadata.started_at);
      }
      if (m.game_start) {
        return new Date(m.game_start * 1000);
      }
      if (m.game_start_patched) {
        return new Date(m.game_start_patched);
      }
      return new Date(0);
    };

    const analysis = {
      all: this.processOpponentMatchesForPeriod(matches),
      day: this.processOpponentMatchesForPeriod(matches.filter(m => getMatchDate(m) >= dayAgo)),
      week: this.processOpponentMatchesForPeriod(matches.filter(m => getMatchDate(m) >= weekAgo)),
      month: this.processOpponentMatchesForPeriod(matches.filter(m => getMatchDate(m) >= monthAgo))
    };

    return analysis;
  }

  processOpponentMatchesForPeriod(matches) {
    if (!matches.length) {
      return {
        totalMatches: 0,
        wins: 0,
        losses: 0,
        winRate: 0,
        avgKills: 0,
        avgDeaths: 0,
        avgAssists: 0,
        kd: 0,
        topAgents: [],
        agentsByMap: {}
      };
    }

    let wins = 0;
    let totalKills = 0;
    let totalDeaths = 0;
    let totalAssists = 0;
    const agentCount = {};
    const agentsByMap = {};

    matches.forEach(match => {
      const player = match.player;
      if (!player) return;

      const playerTeamId = (player.team_id || player.team || '').toLowerCase();
      
      let playerWon = false;
      if (Array.isArray(match.teams)) {
        const playerTeamData = match.teams.find(t => t.team_id?.toLowerCase() === playerTeamId);
        playerWon = playerTeamData?.won === true;
      } else if (match.teams) {
        const teamData = match.teams[playerTeamId];
        playerWon = teamData?.has_won === true || teamData?.won === true;
      }
      
      if (playerWon) {
        wins++;
      }

      totalKills += player.stats?.kills || 0;
      totalDeaths += player.stats?.deaths || 0;
      totalAssists += player.stats?.assists || 0;

      const agentRaw = player.agent?.name || player.agent || 'unknown';
      const agent = (typeof agentRaw === 'string' ? agentRaw : 'unknown').toLowerCase();
      agentCount[agent] = (agentCount[agent] || 0) + 1;

      const mapName = match.metadata?.map?.name || match.map || 'unknown';
      const map = (typeof mapName === 'string' ? mapName : 'unknown').toLowerCase();
      if (!agentsByMap[map]) {
        agentsByMap[map] = {};
      }
      agentsByMap[map][agent] = (agentsByMap[map][agent] || 0) + 1;
    });

    const topAgents = Object.entries(agentCount)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5)
      .map(([agent, count]) => ({
        agent,
        count,
        percentage: Math.round((count / matches.length) * 100)
      }));

    const processedAgentsByMap = {};
    Object.entries(agentsByMap).forEach(([map, agents]) => {
      processedAgentsByMap[map] = Object.entries(agents)
        .sort((a, b) => b[1] - a[1])
        .map(([agent, count]) => ({
          agent,
          count,
          percentage: Math.round((count / Object.values(agents).reduce((a, b) => a + b, 0)) * 100)
        }));
    });

    return {
      totalMatches: matches.length,
      wins,
      losses: matches.length - wins,
      winRate: Math.round((wins / matches.length) * 100),
      avgKills: (totalKills / matches.length).toFixed(1),
      avgDeaths: (totalDeaths / matches.length).toFixed(1),
      avgAssists: (totalAssists / matches.length).toFixed(1),
      kd: totalDeaths > 0 ? (totalKills / totalDeaths).toFixed(2) : totalKills.toFixed(2),
      topAgents,
      agentsByMap: processedAgentsByMap
    };
  }

  renderNoMatchesFoundOpponent(player) {
    const hasAvatar = player.avatar_url && player.avatar_url !== '' && player.avatar_url !== 'null';
    const playerInitial = (player.display_name || '?').charAt(0).toUpperCase();
    
    return `
      <div class="fullscreen-analysis-header">
        <button class="btn-back-premium opponent-back" onclick="antitactic.closeOpponentAnalysisModal()">
          <i class="fas fa-arrow-left"></i>
          <span>Voltar</span>
        </button>
        <div class="fullscreen-player-info">
          <div class="fullscreen-avatar opponent-avatar">
            ${hasAvatar ? `
              <img src="${player.avatar_url}" alt="${player.display_name}">
            ` : `
              <div class="avatar-fallback-lg opponent-fallback"><span>${playerInitial}</span></div>
            `}
          </div>
          <div class="fullscreen-player-details">
            <h1>${player.display_name}</h1>
            <span class="fullscreen-riot-id">${player.riot_id}#${player.riot_tag}</span>
          </div>
        </div>
      </div>
      <div class="fullscreen-analysis-body">
        <div class="empty-state premium-empty">
          <div class="empty-icon"><i class="fas fa-gamepad"></i></div>
          <h3>Nenhuma partida encontrada</h3>
          <p>Não foram encontradas partidas ranqueadas recentes para este jogador</p>
        </div>
      </div>
    `;
  }

  renderOpponentAnalysisContent(player, analysis, rawMatches, playerName) {
    const hasAvatar = player.avatar_url && player.avatar_url !== '' && player.avatar_url !== 'null';
    const playerInitial = (player.display_name || '?').charAt(0).toUpperCase();
    const monthData = analysis.month;
    
    const now = new Date();
    const monthAgo = new Date(now - 30 * 24 * 60 * 60 * 1000);
    const monthMatches = rawMatches.filter(m => new Date(m.metadata?.started_at || m.game_start * 1000) >= monthAgo);

    return `
      <div class="fullscreen-analysis-header">
        <button class="btn-back-premium opponent-back" onclick="antitactic.closeOpponentAnalysisModal()">
          <i class="fas fa-arrow-left"></i>
          <span>Voltar</span>
        </button>
        <div class="fullscreen-player-info">
          <div class="fullscreen-avatar opponent-avatar">
            ${hasAvatar ? `
              <img src="${player.avatar_url}" alt="${player.display_name}"
                   onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
              <div class="avatar-fallback-lg opponent-fallback" style="display:none;"><span>${playerInitial}</span></div>
            ` : `
              <div class="avatar-fallback-lg opponent-fallback"><span>${playerInitial}</span></div>
            `}
          </div>
          <div class="fullscreen-player-details">
            <h1>${player.display_name}</h1>
            <span class="fullscreen-riot-id">${player.riot_id}#${player.riot_tag}</span>
            <span class="opponent-team-badge"><i class="fas fa-users-slash"></i> ${this.selectedOpponent.name}</span>
          </div>
        </div>
      </div>
      
      <div class="fullscreen-analysis-body">
        <div class="opponent-analysis-layout">
          <div class="period-tabs-premium opponent-tabs">
            <button class="period-tab-premium active" data-period="month">
              <i class="fas fa-calendar-alt"></i>
              <span>Mês</span>
            </button>
            <button class="period-tab-premium" data-period="week">
              <i class="fas fa-calendar-week"></i>
              <span>Semana</span>
            </button>
            <button class="period-tab-premium" data-period="day">
              <i class="fas fa-sun"></i>
              <span>Hoje</span>
            </button>
          </div>
          
          <div class="premium-stats-grid opponent-stats" id="opponentStatsOverview">
            ${this.renderOpponentStatsOverview(monthData)}
          </div>
          
          <div class="analysis-columns opponent-analysis-columns">
            <div class="analysis-column opponent-analysis-column">
              <div class="premium-section-header opponent-section">
                <div class="section-icon"><i class="fas fa-user-ninja"></i></div>
                <h2>Top 5 Agentes</h2>
              </div>
              <div class="top-agents-premium opponent-agents" id="opponentTopAgentsGrid">
                ${this.renderOpponentTopAgents(monthData.topAgents)}
              </div>
            </div>
            
            <div class="analysis-column opponent-analysis-column">
              <div class="premium-section-header opponent-section">
                <div class="section-icon"><i class="fas fa-map-marked-alt"></i></div>
                <h2>Agentes por Mapa</h2>
              </div>
              <div class="agents-by-map-premium opponent-map-agents" id="opponentAgentsByMapGrid">
                ${this.renderOpponentAgentsByMap(monthData.agentsByMap)}
              </div>
            </div>
          </div>
          
          <div class="matches-list-section opponent-matches">
            <div class="premium-section-header opponent-section">
              <div class="section-icon"><i class="fas fa-list"></i></div>
              <h2>Histórico de Partidas</h2>
            </div>
            <div class="matches-table-container" id="opponentMatchesTableContainer">
              ${this.renderOpponentMatchesTable(monthMatches, playerName)}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  renderOpponentStatsOverview(data) {
    const kdColor = parseFloat(data.kd) >= 1.2 ? '#4ade80' : (parseFloat(data.kd) < 1.0 ? '#ef4444' : '#fbbf24');
    const winRateColor = data.winRate >= 55 ? '#4ade80' : (data.winRate < 45 ? '#ef4444' : '#fbbf24');
    
    return `
      <div class="premium-stat-card opponent-card">
        <div class="stat-card-icon"><i class="fas fa-gamepad"></i></div>
        <div class="stat-card-value">${data.totalMatches}</div>
        <div class="stat-card-label">Partidas</div>
      </div>
      <div class="premium-stat-card opponent-card">
        <div class="stat-card-icon"><i class="fas fa-trophy"></i></div>
        <div class="stat-card-value">${data.wins}/${data.losses}</div>
        <div class="stat-card-label">V/D</div>
      </div>
      <div class="premium-stat-card opponent-card">
        <div class="stat-card-icon"><i class="fas fa-percentage"></i></div>
        <div class="stat-card-value" style="color: ${winRateColor}">${data.winRate}%</div>
        <div class="stat-card-label">Win Rate</div>
      </div>
      <div class="premium-stat-card opponent-card">
        <div class="stat-card-icon"><i class="fas fa-crosshairs"></i></div>
        <div class="stat-card-value" style="color: ${kdColor}">${data.kd}</div>
        <div class="stat-card-label">K/D</div>
      </div>
      <div class="premium-stat-card opponent-card">
        <div class="stat-card-icon"><i class="fas fa-skull"></i></div>
        <div class="stat-card-value">${data.avgKills}</div>
        <div class="stat-card-label">Média Kills</div>
      </div>
      <div class="premium-stat-card opponent-card">
        <div class="stat-card-icon"><i class="fas fa-heart-broken"></i></div>
        <div class="stat-card-value">${data.avgDeaths}</div>
        <div class="stat-card-label">Média Deaths</div>
      </div>
    `;
  }

  renderOpponentTopAgents(topAgents) {
    if (!topAgents || topAgents.length === 0) {
      return '<div class="premium-empty-state"><p>Sem dados de agentes</p></div>';
    }

    return topAgents.map((ag, index) => {
      const agentData = this.agentsData?.[ag.agent.toLowerCase()];
      const agentIcon = agentData?.displayIcon || `/img/agents/${ag.agent.toLowerCase()}.png`;
      
      return `
        <div class="top-agent-card opponent-agent-card">
          <div class="agent-rank">#${index + 1}</div>
          <img src="${agentIcon}" alt="${ag.agent}" class="agent-icon" onerror="this.style.display='none'">
          <div class="agent-info">
            <span class="agent-name">${ag.agent}</span>
            <span class="agent-count">${ag.count} partidas</span>
          </div>
          <div class="agent-percentage">${ag.percentage}%</div>
        </div>
      `;
    }).join('');
  }

  renderOpponentAgentsByMap(agentsByMap) {
    if (!agentsByMap || Object.keys(agentsByMap).length === 0) {
      return '<div class="premium-empty-state"><p>Sem dados de mapas</p></div>';
    }

    return Object.entries(agentsByMap).map(([mapName, agents]) => {
      const mapData = this.mapsData?.[mapName.toLowerCase()];
      const mapImage = mapData?.listViewIcon || `/img/maps/${mapName.toLowerCase()}_preview.jpg`;
      
      return `
        <div class="map-agents-card opponent-map-card">
          <div class="map-header">
            <img src="${mapImage}" alt="${mapName}" class="map-thumb" onerror="this.src='/img/maps/default-preview.jpg'">
            <span class="map-name">${mapName}</span>
          </div>
          <div class="map-agents-list">
            ${agents.slice(0, 3).map(ag => {
              const agentData = this.agentsData?.[ag.agent.toLowerCase()];
              const agentIcon = agentData?.displayIcon || `/img/agents/${ag.agent.toLowerCase()}.png`;
              return `
                <div class="map-agent">
                  <img src="${agentIcon}" alt="${ag.agent}" class="agent-icon-sm" onerror="this.style.display='none'">
                  <div class="map-agent-meta">
                    <span class="map-agent-name">${ag.agent}</span>
                    <span class="map-agent-count">${ag.count} partidas</span>
                  </div>
                  <span class="map-agent-percentage">${ag.percentage}%</span>
                </div>
              `;
            }).join('')}
          </div>
        </div>
      `;
    }).join('');
  }

  renderOpponentMatchesTable(matches, playerName) {
    if (!matches.length) {
      return '<div class="premium-empty-state"><i class="fas fa-gamepad"></i><p>Sem partidas neste período</p></div>';
    }

    return `
      <table class="matches-table opponent-table">
        <thead>
          <tr>
            <th class="th-result">R</th>
            <th class="th-agent">Agente</th>
            <th class="th-map">Mapa</th>
            <th class="th-score">Score</th>
            <th>ACS</th>
            <th>K</th>
            <th>D</th>
            <th>A</th>
            <th>+/-</th>
            <th>K/D</th>
            <th>ADR</th>
            <th>HS%</th>
          </tr>
        </thead>
        <tbody>
          ${matches.map(match => this.renderOpponentMatchRow(match, playerName)).join('')}
        </tbody>
      </table>
    `;
  }

  renderOpponentMatchRow(match, playerName) {
    const players = match.players || [];
    const player = players.find(p => p.name?.toLowerCase() === playerName?.toLowerCase()) || match.player;
    
    if (!player) return '';
    
    const stats = player.stats || {};
    const agent = player.agent?.name || player.agent || 'Unknown';
    const agentIcon = this.agentsData?.[agent.toLowerCase()]?.displayIcon || `/img/agents/${agent.toLowerCase()}.png`;
    const mapName = match.metadata?.map?.name || match.map || 'Unknown';
    
    const kills = stats.kills || 0;
    const deaths = stats.deaths || 0;
    const assists = stats.assists || 0;
    const score = stats.score || 0;
    const headshots = stats.headshots || 0;
    const bodyshots = stats.bodyshots || 0;
    const legshots = stats.legshots || 0;
    const totalShots = headshots + bodyshots + legshots;
    const hsPercent = totalShots > 0 ? Math.round((headshots / totalShots) * 100) : 0;
    const damageDealt = stats.damage?.dealt || 0;
    
    let teams = match.teams || [];
    if (!Array.isArray(teams)) {
      teams = Object.entries(teams).map(([key, value]) => ({
        team_id: key.charAt(0).toUpperCase() + key.slice(1),
        ...value
      }));
    }
    
    const playerTeamId = (player.team_id || player.team || '').toLowerCase();
    const playerTeam = teams.find(t => (t.team_id || '').toLowerCase() === playerTeamId) || {};
    
    const roundsWon = playerTeam.rounds?.won ?? playerTeam.rounds_won ?? 0;
    const roundsLost = playerTeam.rounds?.lost ?? playerTeam.rounds_lost ?? 0;
    const totalRounds = roundsWon + roundsLost || 1;
    const won = playerTeam.won ?? playerTeam.has_won ?? false;
    
    const acs = Math.round(score / totalRounds);
    const adr = Math.round(damageDealt / totalRounds);
    const kd = deaths > 0 ? (kills / deaths).toFixed(2) : kills.toFixed(2);
    const plusMinus = kills - deaths;
    const plusMinusStr = plusMinus >= 0 ? `+${plusMinus}` : `${plusMinus}`;

    return `
      <tr class="match-row ${won ? 'win' : 'loss'}">
        <td class="td-result">
          <span class="result-badge ${won ? 'win' : 'loss'}">${won ? 'V' : 'D'}</span>
        </td>
        <td class="td-agent">
          <img src="${agentIcon}" alt="${agent}" class="agent-icon-small" onerror="this.style.display='none'">
        </td>
        <td class="td-map">${mapName}</td>
        <td class="td-score">${roundsWon}-${roundsLost}</td>
        <td class="td-acs ${acs >= 250 ? 'high' : acs >= 200 ? 'medium' : ''}">${acs}</td>
        <td>${kills}</td>
        <td>${deaths}</td>
        <td>${assists}</td>
        <td class="td-plusminus ${plusMinus >= 0 ? 'positive' : 'negative'}">${plusMinusStr}</td>
        <td class="td-kd ${parseFloat(kd) >= 1.5 ? 'high' : parseFloat(kd) >= 1.0 ? 'medium' : 'low'}">${kd}</td>
        <td class="td-adr ${adr >= 160 ? 'high' : adr >= 130 ? 'medium' : ''}">${adr}</td>
        <td class="td-hs ${hsPercent >= 30 ? 'high' : hsPercent >= 20 ? 'medium' : ''}">${hsPercent}%</td>
      </tr>
    `;
  }

  setupOpponentPeriodTabs(playerId, matches, playerName) {
    const tabs = document.querySelectorAll('.period-tab-premium');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        
        const period = tab.dataset.period;
        const cached = this.playerAnalysis.get(playerId);
        
        if (cached) {
          const periodData = cached[period];
          
          document.getElementById('opponentStatsOverview').innerHTML = this.renderOpponentStatsOverview(periodData);
          document.getElementById('opponentTopAgentsGrid').innerHTML = this.renderOpponentTopAgents(periodData.topAgents);
          document.getElementById('opponentAgentsByMapGrid').innerHTML = this.renderOpponentAgentsByMap(periodData.agentsByMap);
          
          const now = new Date();
          const periodMs = period === 'day' ? 24 * 60 * 60 * 1000 : 
                          period === 'week' ? 7 * 24 * 60 * 60 * 1000 : 
                          30 * 24 * 60 * 60 * 1000;
          const periodAgo = new Date(now - periodMs);
          const periodMatches = matches.filter(m => new Date(m.metadata?.started_at || m.game_start * 1000) >= periodAgo);
          
          document.getElementById('opponentMatchesTableContainer').innerHTML = this.renderOpponentMatchesTable(periodMatches, playerName);
        }
      });
    });
  }

  // =====================================================
  // STYLES
  // =====================================================

  addStyles() {
    if (document.getElementById('antitactic-styles')) return;
    // O CSS mora em css/pages/antitactic-main.css. Ficava aqui como template string,
    // somando peso ao bundle de JS e impedindo que a folha fosse cacheada
    // e minificada em separado. Segue carregando sob demanda, como antes.
    Utils.loadPageCss('antitactic-styles', 'antitactic-main.css');
  }
}

const antitactic = new Antitactic();


/* ===== js/valoplant-v2.js ===== */
// =====================================================
// ZDVAL - ValoPlant v2.0 - Advanced 2D Strategy Planner
// Inspired by rib.gg and valoplant.gg
// Features: Timeline Animation, Keyframes, Playback, Path Drawing
// =====================================================

console.log('🎯 ValoPlant v2.0 - Advanced Strategy Planner with Path System');

class ValoPlantV2 {
  constructor() {
    // Canvas & Rendering
    this.canvas = null;
    this.ctx = null;
    this.mapImage = null;
    this.imageCache = new Map();
    this._windowResizeHandler = null;
    this._documentClickHandler = null;
    this._documentMouseUpHandler = null;
    this._documentMouseMoveHandler = null;
    this._documentKeyDownHandler = null;
    this._loadRequestId = 0;
    this._isLoading = false;
    
    // Map dimensions (square map centered inside larger canvas)
    this._mapSize = 200; // updated by resizeCanvas
    this._mapOffsetX = 0;
    this._mapOffsetY = 0;
    
    // State
    this.currentMap = 'abyss';
    this.currentSide = 'attack';
    this.currentTacticId = null;
    this.currentTacticTitle = '';
    this.mapDropdownOpen = false;
    this.currentTool = null;
    this.isPlaying = false;
    this.playbackSpeed = 1;
    
    // Team composition - like rib.gg
    this.teams = this.createBaseTeamState();
    this.currentSelectingSlot = null; // {team, slot} when modal is open
    this.currentAgentRole = null; // Current role filter for agent bar
    this.currentAgentSearch = ''; // Current search filter for agent bar
    
    // Elements on map
    this.elements = [];
    this.selectedElement = null;
    this.selectedElements = []; // For multi-select
    
    // PATH SYSTEM - Trajetórias dos agentes
    this.pathMode = false; // Modo de desenho de trajetória
    this.pathDrawingAgent = null; // Agente que está tendo trajetória desenhada
    this.agentPaths = new Map(); // Map de elementId -> [{x, y, time}]
    this.showPaths = true; // Mostrar trajetórias visualmente
    this.isDrawingPath = false; // Está arrastando para desenhar trajetória
    this.pathDrawStartTime = 0; // Tempo inicial do desenho

    
    // ABILITY MARKERS - Marcadores de habilidades na timeline (como rib.gg)
    this.abilityMarkers = new Map(); // Map de agentId -> [{time, ability, mapPosition?}]
    this.pendingAbilityMarker = null; // {agentId, time} - aguardando seleção de habilidade
    this.abilityPlacementMode = null; // {agentId, timeMs, ability} - aguardando clique no mapa para posicionar
    
    // PATH ABILITY WAYPOINTS - Habilidades ancoradas em pontos da trajetória
    this.pathAbilityWaypoints = new Map(); // Map de agentId -> [{x, y, pathX, pathY, distanceAlongPath, timeMs, ability}]
    this.draggingPathWaypoint = null; // {agentId, waypointIndex, waypoint} quando arrastando
    
    // Velocidade do Valorant com Vandal: 5.4 m/s
    // Mapa tem aproximadamente 100m de largura
    // Canvas ~800px = ~100m, então 1px ≈ 0.125m
    // Velocidade: 5.4 m/s = 43.2 px/s
    this.VANDAL_SPEED_PX_PER_SEC = 43.2; // pixels por segundo
    this.MIN_PATH_POINT_DISTANCE = 8; // distância mínima entre pontos para evitar excesso

    // Cores compartilhadas das trajetórias (usadas em paths, waypoints e habilidades no mapa)
    this.PATH_COLORS = [
      'rgba(34, 211, 238, 0.85)',   // ciano
      'rgba(251, 191, 36, 0.85)',   // dourado
      'rgba(74, 222, 128, 0.85)',   // verde
      'rgba(251, 113, 133, 0.85)',  // rosa
      'rgba(167, 139, 250, 0.85)',  // lilás
      'rgba(251, 146, 60, 0.85)',   // laranja
      'rgba(255, 255, 255, 0.85)',  // branco
      'rgba(56, 189, 248, 0.85)',   // azul claro
      'rgba(240, 171, 252, 0.85)',  // magenta claro
      'rgba(134, 239, 172, 0.85)',  // verde menta
    ];
    
    // Timeline & Animation
    this.timeline = {
      duration: 100000, // 1:40 round time (Valorant standard)
      currentTime: 0,
      keyframes: [], // Array of {time, elementId, x, y, rotation, action}
      markers: [] // Named markers for phases
    };
    this.animationFrame = null;
    this.lastFrameTime = 0;
    
    // Z-order layer counter (abilities/agents moved last render on top)
    this._nextLayer = 1;

    // Drawing state
    this.isDrawing = false;
    this.isDragging = false;
    this.dragMoved = false;
    this.isPanning = false;
    this.isRotating = false;
    this.isAdjustingBend = false;
    this.mapLocked = false;
    this.startX = 0;
    this.startY = 0;
    this.dragOffsetX = 0;
    this.dragOffsetY = 0;
    this.bendingElement = null;
    
    // Drag preview (live preview while dragging ability from sidebar)
    this.dragPreview = null; // { abilityName, agentUuid, team, x, y }
    
    // Marquee selection
    this.isMarqueeSelecting = false;
    this.marqueeStart = null;
    this.marqueeEnd = null;
    

    
    // View
    this.zoomLevel = 1;
    this.panX = 0;
    this.panY = 0;
    
    // History
    this.undoStack = [];
    this.redoStack = [];
    
    // Tool settings
    this.settings = {
      strokeColor: '#ff4655',
      fillColor: 'rgba(255, 70, 85, 0.2)',
      strokeWidth: 3,
      fontSize: 14
    };
    
    // Player colors
    this.playerColors = {
      ally: ['#22d3ee', '#34d399', '#a78bfa', '#f472b6', '#fbbf24'],
      enemy: ['#ef4444', '#f97316', '#dc2626', '#b91c1c', '#991b1b']
    };
    
    // Map rotations for proper orientation (same as lineups.js)
    this.mapRotations = {
      'abyss':    { baseRotation: 90, flipForDefense: true },
      'ascent':   { baseRotation: 90, flipForDefense: true },
      'bind':     { baseRotation: 0,  flipForDefense: true },
      'breeze':   { baseRotation: 0,  flipForDefense: true },
      'corrode':  { baseRotation: 90, flipForDefense: true },
      'fracture': { baseRotation: 0,  flipForDefense: true },
      'haven':    { baseRotation: 90, flipForDefense: true },
      'lotus':    { baseRotation: 0,  flipForDefense: true },
      'pearl':    { baseRotation: 0,  flipForDefense: true },
      'split':    { baseRotation: 90, flipForDefense: true }
    };
    
    // Ability visual configurations (accurate to game)
    this.abilityShapes = this.initAbilityShapes();
    
    // Calibracao por mapa. mapScale = |xMultiplier| da Valorant API, converte
    // unidade de jogo em fracao 0-1 do minimapa; rangeScaleAdjust corrige mapas
    // cujo displayicon vem com moldura extra. Esses numeros sao medidos, nao
    // derivados — ficam aqui a mao de proposito.
    //
    // O uuid de cada mapa saiu daqui: era a quinta copia da mesma tabela no
    // frontend. Vem do MapCatalog agora, e a calibracao continua sendo o unico
    // dado desta tabela.
    const calibracaoPorMapa = {
      abyss:     { mapScale: 8.1e-05 },
      ascent:    { mapScale: 7.3e-05 },
      bind:      { mapScale: 5.9e-05, rangeScaleAdjust: 0.78 },
      breeze:    { mapScale: 7e-05 },
      corrode:   { mapScale: 7e-05 },
      fracture:  { mapScale: 7.8e-05 },
      haven:     { mapScale: 7.5e-05 },
      icebox:    { mapScale: 7.2e-05 },
      lotus:     { mapScale: 7.1e-05 },
      pearl:     { mapScale: 7.8e-05 },
      split:     { mapScale: 7.8e-05 },
      sunset:    { mapScale: 7.4e-05 },
      summit:    { mapScale: 7.5e-05 }
    };
    this.mapScales = Object.fromEntries(
      Object.entries(calibracaoPorMapa).map(([nome, cal]) => [nome, { uuid: MapCatalog.uuid(nome), ...cal }])
    );

    // Maps — synced from Settings active maps on load()
    this.maps = [];
    
    // Agents (loaded from API)
    this.agents = [];
    this.selectedAgent = null;
    
    // Custom ability icons cache: { "agentName:Slot": "/uploads/abilities/agent/Slot.png" or false }
    this._customAbilityIcons = {};
    
    // Tamanho dos ícones de habilidade no mapa (carregado do localStorage)
    this._abilityIconSize = parseInt(localStorage.getItem('vp2_abilityIconSize')) || 26;
    this._uploadAbilityIconSize = parseInt(localStorage.getItem('vp2_uploadAbilityIconSize')) || 46;
    
    // Toggle de tempo de habilidade no mapa
    this._showAbilityDuration = localStorage.getItem('vp2_showAbilityDuration') !== 'false';

    // Debug: visualizar hitbox em laranja para habilidades, bolinha e losango
    this._showHitboxDebug = false;

    // Tamanhos individuais por habilidade: { "agentFolder:slot": size }
    this._abilityIconSizes = JSON.parse(localStorage.getItem('vp2_abilityIconSizes') || '{}');

    // Tamanhos individuais por agente no mapa: { "agentFolder": size }
    this._agentIconSizes = JSON.parse(localStorage.getItem('vp2_agentIconSizes') || '{}');
    this._agentByUuidCache = null;
    this._agentByUuidCacheSize = 0;
    this._currentMapScale = 7.5e-05;
    this._currentMapScaleId = null;
    this._currentMapScaleMapsLength = 0;
    this.abilitySlotMap = {
      'Ability1': 'Q',
      'Ability2': 'E',
      'Grenade': 'C',
      'Grenade_Alt': 'E2',
      'Ultimate': 'X',
      'Passive': 'P'
    };

    // Tamanho global dos agentes no mapa
    this._agentIconSize = parseInt(localStorage.getItem('vp2_agentIconSize')) || 35;

    // =====================================================
    // SEQUENCE SYSTEM - Passos da tática
    // =====================================================
    this.sequences = new Map(); // seqId -> snapshot {elements, teams, agentPaths, abilityMarkers, pathAbilityWaypoints, keyframes}
    this.currentSequence = 1;
    this.totalSequences = 1;
    this.maxSequences = 4;
    // Initialize first sequence as empty
    this.sequences.set(1, this._createEmptySnapshot());
  }

  waitForNextFrame() {
    return new Promise(resolve => requestAnimationFrame(() => resolve()));
  }

  createBaseTeamState() {
    return {
      ally: [null, null, null, null, null],
      enemy: [null, null, null, null, null]
    };
  }

  getNextTeamSlot(team) {
    const slotIndex = this.teams[team].findIndex(agent => agent === null);
    if (slotIndex !== -1) return slotIndex;
    this.teams[team].push(null);
    return this.teams[team].length - 1;
  }

  // Ordena habilidades pelo slot padrão do Valorant: C, C(alt), Q, E, X, P
  _sortAbilitiesBySlot(abilities) {
    const order = { Grenade: 0, Grenade_Alt: 0.5, Ability1: 1, Ability2: 2, Ultimate: 4, Passive: 5 };
    // Habilidades que devem aparecer primeiro (antes do slot padrão)
    const nameFirst = { 'Forma Astral': -1, 'Astral Form': -1, 'Drift': -1, 'Deriva': -1 };
    return [...abilities].sort((a, b) => {
      const oa = nameFirst[a.displayName] ?? order[a.slot] ?? 9;
      const ob = nameFirst[b.displayName] ?? order[b.slot] ?? 9;
      return oa - ob;
    });
  }

  getAbilitySlotKey(slot) {
    return this.abilitySlotMap[slot] || slot || '';
  }

  getDisplayAbilities(agent, options = {}) {
    const { requireVisibleIcon = false } = options;
    const abilities = Array.isArray(agent?.abilities) ? agent.abilities : [];

    return this._sortAbilitiesBySlot(abilities.filter(ab => {
      const hasCustom = !!this.getCustomAbilityIcon(agent.displayName, ab.slot);
      if (ab.slot === 'Passive' && !ab.displayIcon && !hasCustom) return false;
      if (requireVisibleIcon && !ab.displayIcon && !hasCustom) return false;
      return true;
    }));
  }

  // Retorna o tamanho de uma habilidade específica (individual > custom/api default)
  // Custom uploads: 46px, API icons: uses global slider value (default 26px)
  getAbilityIconSize(agentFolder, slot) {
    const key = `${agentFolder}:${slot}`;
    if (this._abilityIconSizes[key]) return this._abilityIconSizes[key];
    // Check if has custom upload — different default size
    const cacheKey = `${agentFolder}:${slot}`;
    const hasCustom = this._customAbilityIcons[cacheKey] && this._customAbilityIcons[cacheKey] !== false;
    return hasCustom ? (this._uploadAbilityIconSize || 46) : (this._abilityIconSize || 26);
  }

  setAbilityIconSize(agentFolder, slot, size) {
    const key = `${agentFolder}:${slot}`;
    this._abilityIconSizes[key] = size;
    localStorage.setItem('vp2_abilityIconSizes', JSON.stringify(this._abilityIconSizes));
    this.render();
  }

  // Retorna o tamanho de um agente específico no mapa (individual > global > 25)
  getAgentIconSize(agentFolder) {
    if (this._agentIconSizes[agentFolder]) return this._agentIconSizes[agentFolder];
    return this._agentIconSize || 35;
  }

  setAgentIconSize(agentFolder, size) {
    this._agentIconSizes[agentFolder] = size;
    localStorage.setItem('vp2_agentIconSizes', JSON.stringify(this._agentIconSizes));
    this.render();
  }

  getAgentByUuid(uuid) {
    if (!uuid) return null;
    if (!this._agentByUuidCache || this._agentByUuidCacheSize !== this.agents.length) {
      this._agentByUuidCache = new Map(this.agents.map(agent => [agent.uuid, agent]));
      this._agentByUuidCacheSize = this.agents.length;
    }
    return this._agentByUuidCache.get(uuid) || null;
  }

  getCurrentMapScale() {
    if (this._currentMapScaleId !== this.currentMap || this._currentMapScaleMapsLength !== this.maps.length) {
      const currentMap = this.maps.find(m => m.id === this.currentMap);
      const baseScale = currentMap ? currentMap.mapScale : 7.5e-05;
      const rangeAdjust = (currentMap && typeof currentMap.rangeScaleAdjust === 'number')
        ? currentMap.rangeScaleAdjust
        : 1;
      this._currentMapScale = baseScale * rangeAdjust;
      this._currentMapScaleId = this.currentMap;
      this._currentMapScaleMapsLength = this.maps.length;
    }
    return this._currentMapScale;
  }

  getSourceMapData(mapId, fallbackMap = null) {
    const appMaps = (typeof app !== 'undefined' && app.getMaps) ? (app.getMaps() || []) : [];
    const normalizedId = String(mapId || '').toLowerCase();
    const fallbackUuid = String(fallbackMap?.uuid || '').toLowerCase();

    return appMaps.find((item) => {
      const itemId = String(item?.id || '').toLowerCase();
      const itemName = String(item?.name || '').toLowerCase();
      const itemDisplayName = String(item?.display_name || item?.displayName || '').toLowerCase();
      const itemUuid = String(item?.uuid || '').toLowerCase();
      return itemId === normalizedId
        || itemName === normalizedId
        || itemDisplayName === normalizedId
        || (fallbackUuid && itemUuid === fallbackUuid);
    }) || fallbackMap || null;
  }

  getMapImageCandidates(mapId, fallbackMap = null) {
    const sourceMap = this.getSourceMapData(mapId, fallbackMap);
    const fallbackUuid = sourceMap?.uuid || fallbackMap?.uuid || '';

    return Array.from(new Set([
      sourceMap?.minimap,
      sourceMap?.minimap_url,
      sourceMap?.displayicon,
      sourceMap?.displayIcon,
      fallbackMap?.minimap,
      fallbackMap?.minimap_url,
      fallbackMap?.displayicon,
      fallbackMap?.displayIcon,
      fallbackUuid ? `https://media.valorant-api.com/maps/${fallbackUuid}/displayicon.png` : ''
    ].filter(Boolean)));
  }

  // Retorna a cor da trajetória para um agente baseado no seu índice
  getAgentPathColor(agentUuid) {
    const agentElements = this.elements.filter(el => el.type === 'agent' || el.type === 'player');
    const idx = agentElements.findIndex(el => el.agentUuid === agentUuid);
    if (idx >= 0) return this.PATH_COLORS[idx % this.PATH_COLORS.length];
    return this.PATH_COLORS[0];
  }

  getSelectedElementIds() {
    const selectedArray = Array.isArray(this.selectedElements) ? this.selectedElements : [];
    if (this._selectedIdsCacheSource !== selectedArray || this._selectedIdsCacheSingle !== this.selectedElement) {
      const ids = new Set();
      selectedArray.forEach(el => { if (el?.id) ids.add(el.id); });
      if (this.selectedElement?.id) ids.add(this.selectedElement.id);
      this._selectedIdsCache = ids;
      this._selectedIdsCacheSource = selectedArray;
      this._selectedIdsCacheSingle = this.selectedElement;
    }
    return this._selectedIdsCache || new Set();
  }

  isElementSelected(el) {
    return !!el?.id && this.getSelectedElementIds().has(el.id);
  }

  getAgentDisplayIcon(agentOrUuid) {
    const agent = typeof agentOrUuid === 'string' ? this.getAgentByUuid(agentOrUuid) : agentOrUuid;
    return agent?.displayIcon || agent?.displayIconSmall || '';
  }

  getAgentBarPortrait(agentOrUuid) {
    const agent = typeof agentOrUuid === 'string' ? this.getAgentByUuid(agentOrUuid) : agentOrUuid;
    return agent?.displayIcon || agent?.displayIconSmall || '';
  }

  getForcedAbilityRenderName(agent, abilityName, abilitySlot) {
    const agentName = agent?.displayName || '';
    const rawName = abilityName || '';
    const slotKey = this.getAbilitySlotKey(abilitySlot);

    if (agentName === 'Cypher' && slotKey === 'C') {
      return 'Trapwire';
    }

    if (agentName === 'Viper' && /^(Toxic Screen|Cortina Tóxica)$/i.test(rawName)) {
      return 'Toxic Screen';
    }

    if (agentName === 'Deadlock' && /^(Barrier Mesh|Barreira de Contenção|Rede de Barreira)$/i.test(rawName)) {
      return 'Barreira de Contenção';
    }

    if (agentName === 'Neon' && /^(Fast Lane|Via Expressa|Pista Rápida)$/i.test(rawName)) {
      return 'Via Expressa';
    }

    if (agentName === 'Neon' && /^(Relay Bolt|Ricochete Elétrico|Ricochete Eletrico|Disparo Elétrico|Disparo Eletrico)$/i.test(rawName)) {
      return 'Ricochete Elétrico';
    }

    if (agentName === 'Astra' && /Divisa[\s\n]+C[oó]smica|Cosmic\s*Divide/i.test(rawName)) {
      return 'Forma Astral / Divisa Cósmica';
    }

    return rawName;
  }

  resolveAbilityVisual({ agentUuid, abilityName, abilitySlot, fallbackIcon }) {
    const agent = agentUuid ? this.getAgentByUuid(agentUuid) : null;
    const ability = agent?.abilities?.find(ab => (
      (abilitySlot && ab.slot === abilitySlot) ||
      (abilityName && ab.displayName === abilityName)
    )) || null;
    const resolvedSlot = ability?.slot || abilitySlot || '';
    const resolvedName = this.getForcedAbilityRenderName(agent, ability?.displayName || abilityName || '', resolvedSlot);
    const customIcon = agent && resolvedSlot ? this.getCustomAbilityIcon(agent.displayName, resolvedSlot) : null;
    const apiIcon = ability?.displayIcon || '';

    return {
      agent,
      ability,
      abilityName: resolvedName,
      abilitySlot: resolvedSlot,
      abilityIcon: customIcon || fallbackIcon || apiIcon || '',
      abilityDuration: ability?.duration || null,
      abilityType: ability?.abilityType || null
    };
  }

  refreshAbilityRuntimeVisual(agentUuid, abilityState) {
    if (!abilityState) return null;

    const resolved = this.resolveAbilityVisual({
      agentUuid,
      abilityName: abilityState.name || abilityState.displayName || abilityState.abilityName,
      abilitySlot: abilityState.slot || abilityState.abilitySlot,
      fallbackIcon: abilityState.icon || abilityState.abilityIcon || ''
    });

    if (resolved.abilityName) {
      if ('name' in abilityState) abilityState.name = resolved.abilityName;
      if ('abilityName' in abilityState) abilityState.abilityName = resolved.abilityName;
    }

    if (resolved.abilitySlot) {
      if ('slot' in abilityState) abilityState.slot = resolved.abilitySlot;
      if ('abilitySlot' in abilityState) abilityState.abilitySlot = resolved.abilitySlot;
    }

    if (resolved.abilityDuration != null) {
      if ('duration' in abilityState) abilityState.duration = resolved.abilityDuration;
      if ('abilityDuration' in abilityState) abilityState.abilityDuration = resolved.abilityDuration;
    }

    if (resolved.abilityType != null) {
      if ('abilityType' in abilityState) abilityState.abilityType = resolved.abilityType;
    }

    const nextIcon = resolved.abilityIcon || '';
    if (!nextIcon) return resolved;

    const currentIcon = 'icon' in abilityState ? abilityState.icon : abilityState.abilityIcon;
    if (currentIcon !== nextIcon) {
      if ('icon' in abilityState) abilityState.icon = nextIcon;
      if ('abilityIcon' in abilityState) abilityState.abilityIcon = nextIcon;
      if ('customIconImage' in abilityState) abilityState.customIconImage = null;
      if ('_trimmedIcon' in abilityState) abilityState._trimmedIcon = null;
      if ('_abilityImg' in abilityState) abilityState._abilityImg = null;
      if ('_abilityImgFailed' in abilityState) abilityState._abilityImgFailed = false;
      if ('image' in abilityState) {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => this.requestRender();
        img.onerror = () => this.requestRender();
        img.src = nextIcon;
        abilityState.image = img;
      }
    }

    return resolved;
  }

  

    getAbilityShapeLength(shape) {
      if (!shape) return 0;
      if (shape.gameLength) return shape.gameLength * 100 * this.getCurrentMapScale() * this._mapSize;
      if (shape.length) return shape.length;
      return this._mapSize * 3 / (this.zoomLevel || 1);
    }

    getViperWallMetrics(shape) {
      const length = Math.max(260, this.getAbilityShapeLength(shape));
      const width = Math.max(8, Math.min(12, length * 0.025));
      return { length, width };
    }

    getVyseWallMetrics(shape) {
      const length = shape?.gameLength
        ? shape.gameLength * 100 * this.getCurrentMapScale() * this._mapSize
        : this.getAbilityShapeLength(shape);
      const width = shape?.gameWidth
        ? shape.gameWidth * 100 * this.getCurrentMapScale() * this._mapSize
        : (shape?.width || 4);
      return { length, width };
    }

    getPhoenixWallMetrics(shape, el = null) {
      const baseLength = Math.max(160, this.getAbilityShapeLength(shape));
      const scale = (shape?.scalable && el?.abilityScale != null) ? el.abilityScale : 1;
      const length = baseLength * scale;
      const width = shape?.gameWidth
        ? Math.max(7, shape.gameWidth * 100 * this.getCurrentMapScale() * this._mapSize)
        : Math.max(7, shape?.width || 9);
      return { length, width };
    }

    getPhoenixWallCurveLimit(length) {
      return Math.max(36, length * 0.42);
    }

    getPhoenixWallCurveOffset(shape, el = null) {
      const { length } = this.getPhoenixWallMetrics(shape, el);
      const limit = this.getPhoenixWallCurveLimit(length);
      const requested = el?.phoenixCurveOffset || 0;
      return Math.max(-limit, Math.min(limit, requested));
    }

    getPhoenixWallControlPoint(shape, el = null) {
      const { length } = this.getPhoenixWallMetrics(shape, el);
      return {
        x: this.getPhoenixWallCurveOffset(shape, el),
        y: -length * 0.52
      };
    }

    getPhoenixWallPoint(shape, el = null, t = 0.5) {
      const { length } = this.getPhoenixWallMetrics(shape, el);
      const control = this.getPhoenixWallControlPoint(shape, el);
      const invT = 1 - t;
      return {
        x: 2 * invT * t * control.x,
        y: 2 * invT * t * control.y + t * t * -length
      };
    }

    getFastLaneMetrics(shape, el = null) {
      const scale = (shape?.scalable && el?.abilityScale != null) ? el.abilityScale : 1.0;
      const hasGameLength = !!shape?.gameLength;
      const baseLength = hasGameLength
        ? shape.gameLength * 100 * this.getCurrentMapScale() * this._mapSize
        : Math.max(200, this.getAbilityShapeLength(shape));
      const totalLength = baseLength * scale;
      const backLength = hasGameLength
        ? (shape.gameBackLength || 0) * 100 * this.getCurrentMapScale() * this._mapSize * scale
        : 0;
      const length = Math.max(24, totalLength - backLength);
      const gap = shape.gameGap
        ? Math.max(6, shape.gameGap * 100 * this.getCurrentMapScale() * this._mapSize)
        : 14;
      const width = Math.max(4, Math.min(8, length * 0.015));
      return { length, backLength, gap, width };
    }

    getHarborWallMetrics(shape, el = null) {
      const scale = (shape?.scalable && el?.abilityScale != null) ? el.abilityScale : 1.0;
      const baseLength = shape?.gameLength
        ? shape.gameLength * 100 * this.getCurrentMapScale() * this._mapSize
        : Math.max(260, this.getAbilityShapeLength(shape));
      const length = Math.max(140, baseLength * scale);
      const width = shape?.gameWidth
        ? Math.max(8, shape.gameWidth * 100 * this.getCurrentMapScale() * this._mapSize)
        : Math.max(8, Math.min(14, length * 0.024));
      return { length, width };
    }

    getHarborWallCurveLimit(length) {
      return Math.max(36, length * 0.42);
    }

    getHarborWallCurveOffset(shape, el = null) {
      const { length } = this.getHarborWallMetrics(shape, el);
      const limit = this.getHarborWallCurveLimit(length);
      const requested = el?.harborCurveOffset || 0;
      return Math.max(-limit, Math.min(limit, requested));
    }

    getHarborWallControlPoint(shape, el = null) {
      const { length } = this.getHarborWallMetrics(shape, el);
      return {
        x: this.getHarborWallCurveOffset(shape, el),
        y: -length * 0.52
      };
    }

    getHarborWallPoint(shape, el = null, t = 0.5) {
      const { length } = this.getHarborWallMetrics(shape, el);
      const control = this.getHarborWallControlPoint(shape, el);
      const invT = 1 - t;
      return {
        x: 2 * invT * t * control.x,
        y: 2 * invT * t * control.y + t * t * -length
      };
    }

    getBarrierMeshMetrics(shape) {
      const armLength = (shape.showRange && shape.gameArmLength)
        ? shape.gameArmLength * 100 * this.getCurrentMapScale() * this._mapSize
        : 70;
      const d = armLength / Math.SQRT2; // diagonal offset per axis for 45° arms
      const lineWidth = Math.max(2.5, Math.min(4, armLength * 0.02));
      return { armLength, d, lineWidth };
    }

    getCyberCageMetrics(shape) {
      const radius = (shape.gameRadius)
        ? shape.gameRadius * 100 * this.getCurrentMapScale() * this._mapSize
        : Math.max(18, shape.radius || 35);
      const rimWidth = Math.max(2.4, radius * 0.1);
      return { radius, rimWidth };
    }

    getRelayBoltMetrics(shape) {
      const radius = (shape.gameRadius)
        ? shape.gameRadius * 100 * this.getCurrentMapScale() * this._mapSize
        : Math.max(20, shape.radius || 46);
      const ringWidth = Math.max(2.2, radius * 0.09);
      const coreRadius = Math.max(8, radius * 0.62);
      return { radius, ringWidth, coreRadius };
    }

    drawSimpleBarrierMesh(ctx, shape, opacity = 1) {
      const { d, lineWidth } = this.getBarrierMeshMetrics(shape);
      const blue = '#4db8ff';

      const arms = [
        [{ x: -d, y: -d }, { x:  d, y:  d }],
        [{ x:  d, y: -d }, { x: -d, y:  d }],
      ];
      const tips = [
        { x:  d, y: -d }, { x: -d, y: -d },
        { x:  d, y:  d }, { x: -d, y:  d },
      ];

      const armWidth = Math.max(3, d * 0.045);
      const tipRadius = Math.max(5, d * 0.065);
      const centerRadius = Math.max(6, d * 0.08);

      ctx.save();
      ctx.globalAlpha = opacity;

      // Arm lines
      for (const [from, to] of arms) {
        ctx.strokeStyle = blue;
        ctx.lineWidth = armWidth;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
      }

      // Tip circles
      for (const tip of tips) {
        ctx.beginPath();
        ctx.arc(tip.x, tip.y, tipRadius, 0, Math.PI * 2);
        ctx.fillStyle = blue;
        ctx.fill();
      }

      // Center white circle
      ctx.beginPath();
      ctx.arc(0, 0, centerRadius, 0, Math.PI * 2);
      ctx.fillStyle = '#ffffff';
      ctx.fill();

      ctx.restore();
    }

    drawSimpleCyberCage(ctx, shape, opacity = 1, el = null) {
      const { radius, rimWidth } = this.getCyberCageMetrics(shape);

      ctx.save();
      ctx.globalAlpha = opacity;

      const glow = ctx.createRadialGradient(0, 0, radius * 0.55, 0, 0, radius * 1.25);
      glow.addColorStop(0, 'rgba(120, 210, 255, 0.12)');
      glow.addColorStop(1, 'rgba(120, 210, 255, 0)');
      ctx.fillStyle = glow;
      ctx.beginPath();
      ctx.arc(0, 0, radius * 1.25, 0, Math.PI * 2);
      ctx.fill();

      // Bright cyan rim
      ctx.beginPath();
      ctx.arc(0, 0, radius, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(208, 240, 255, 0.95)';
      ctx.lineWidth = rimWidth;
      ctx.stroke();

      // Draw API/custom ability icon in the center of the cage
      const iconSrc = el?.abilityIcon || '';
      if (iconSrc) {
        if (!el._abilityImg || el._abilityImgSrc !== iconSrc) {
          el._abilityImg = new Image();
          el._abilityImg.crossOrigin = 'anonymous';
          el._abilityImg.onload = () => this.render();
          el._abilityImg.onerror = () => { el._abilityImgFailed = true; this.render(); };
          el._abilityImgSrc = iconSrc;
          el._abilityImgFailed = false;
          el._abilityImg.src = iconSrc;
        }

        if (el._abilityImg && el._abilityImg.complete && el._abilityImg.naturalWidth > 0) {
          const iconSize = Math.max(12, radius * 1.18);
          const iconHalf = iconSize / 2;
          const clipRadius = Math.max(7, radius - rimWidth * 2.4);

          ctx.save();
          ctx.beginPath();
          ctx.arc(0, 0, clipRadius, 0, Math.PI * 2);
          ctx.clip();
          ctx.drawImage(el._abilityImg, -iconHalf, -iconHalf, iconSize, iconSize);
          ctx.restore();
        }
      }

      ctx.restore();
    }

    drawSimpleRelayBolt(ctx, shape, opacity = 1, el = null) {
      const { radius } = this.getRelayBoltMetrics(shape);
      const blue = 'rgba(80, 170, 255, 0.9)';
      const borderWidth = Math.max(3, radius * 0.07);

      // Electric arc around the circle border
      const drawElectricRing = (seed, color, lineWidth, alphaMul = 1) => {
        const steps = 48;
        ctx.beginPath();
        for (let i = 0; i <= steps; i++) {
          const t = i / steps;
          const angle = t * Math.PI * 2;
          const waveA = Math.sin((t * 14 + seed) * Math.PI * 2) * borderWidth * 0.6;
          const waveB = Math.sin((t * 32 + seed * 1.7) * Math.PI * 2) * borderWidth * 0.25;
          const r = radius + waveA + waveB;
          const x = Math.cos(angle) * r;
          const y = Math.sin(angle) * r;
          if (i === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        }
        ctx.closePath();
        ctx.globalAlpha = opacity * alphaMul;
        ctx.strokeStyle = color;
        ctx.lineWidth = lineWidth;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.stroke();
      };

      ctx.save();
      ctx.globalAlpha = opacity;

      // Solid filled circle — blue concussion zone
      ctx.beginPath();
      ctx.arc(0, 0, radius, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(60, 130, 200, 0.55)';
      ctx.fill();

      // Soft glow behind the electric border
      ctx.beginPath();
      ctx.arc(0, 0, radius, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(80, 160, 255, 0.25)';
      ctx.lineWidth = borderWidth + 8;
      ctx.stroke();

      // Electric border arcs (layered like Fast Lane)
      ctx.shadowColor = 'rgba(80, 170, 255, 0.7)';
      ctx.shadowBlur = 8;
      drawElectricRing(0.0, 'rgba(80, 160, 255, 0.45)', Math.max(2.5, borderWidth * 0.9), 0.7);
      drawElectricRing(0.33, 'rgba(80, 160, 255, 0.45)', Math.max(2.5, borderWidth * 0.9), 0.7);
      drawElectricRing(0.66, 'rgba(80, 160, 255, 0.45)', Math.max(2.5, borderWidth * 0.9), 0.7);
      ctx.shadowBlur = 0;
      drawElectricRing(0.0, blue, Math.max(1.5, borderWidth * 0.45), 1);
      drawElectricRing(0.33, blue, Math.max(1.5, borderWidth * 0.45), 1);
      drawElectricRing(0.66, blue, Math.max(1.5, borderWidth * 0.45), 1);

      // Bright inner edge
      drawElectricRing(0.15, 'rgba(180, 220, 255, 0.6)', Math.max(1, borderWidth * 0.25), 0.9);

      // Ability icon in the center
      ctx.globalAlpha = opacity;
      const iconSrc = el?.abilityIcon || '';
      if (iconSrc) {
        if (!el._abilityImg || el._abilityImgSrc !== iconSrc) {
          el._abilityImg = new Image();
          el._abilityImg.crossOrigin = 'anonymous';
          el._abilityImg.onload = () => this.render();
          el._abilityImg.onerror = () => { el._abilityImgFailed = true; this.render(); };
          el._abilityImgSrc = iconSrc;
          el._abilityImgFailed = false;
          el._abilityImg.src = iconSrc;
        }

        if (el._abilityImg && el._abilityImg.complete && el._abilityImg.naturalWidth > 0) {
          const agent = el.agentUuid ? this.getAgentByUuid(el.agentUuid) : null;
          const folder = agent ? this._normalizeAgentFolder(agent.displayName) : '';
          const slotKey = this.getAbilitySlotKey(el.abilitySlot);
          const iconSize = this.getAbilityIconSize(folder, slotKey);
          const half = iconSize / 2;
          ctx.save();
          ctx.shadowColor = 'rgba(80, 170, 255, 0.6)';
          ctx.shadowBlur = 6;
          ctx.drawImage(el._abilityImg, -half, -half, iconSize, iconSize);
          ctx.shadowBlur = 0;
          ctx.restore();
        }
      }

      ctx.globalAlpha = opacity;
      ctx.restore();
    }

    drawSimpleTripwire(ctx, shape, opacity = 1, el = null) {
      const { length, width } = this.getTripwireMetrics(shape, el);
      const topY = -length;
      const bottomY = 0;
      const coreWidth = Math.max(1.5, width * 0.42);
      const bottomRadius = Math.max(5, width * 2.1);
      const diamondSize = Math.max(7, width * 2.4);

      ctx.save();
      ctx.globalAlpha = opacity;

      // Soft glow behind the wire
      ctx.strokeStyle = 'rgba(255, 173, 214, 0.18)';
      ctx.lineWidth = width + 5;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(0, topY);
      ctx.lineTo(0, bottomY);
      ctx.stroke();

      // Main white wire
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.96)';
      ctx.lineWidth = width;
      ctx.beginPath();
      ctx.moveTo(0, topY + diamondSize * 0.6);
      ctx.lineTo(0, bottomY - bottomRadius * 0.8);
      ctx.stroke();

      // Thin inner core for clarity
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.85)';
      ctx.lineWidth = coreWidth;
      ctx.beginPath();
      ctx.moveTo(0, topY + diamondSize * 0.75);
      ctx.lineTo(0, bottomY - bottomRadius * 0.9);
      ctx.stroke();

      // Bottom anchor circle (standard white handle)
      this._drawWhiteHandleMarker(ctx, bottomY);

      ctx.restore();
    }

    getTripwireMetrics(shape, el = null) {
      const scale = (shape.scalable && el?.abilityScale != null) ? el.abilityScale : 1.0;
      const rawLength = (shape.showRange && shape.gameLength)
        ? shape.gameLength * 100 * this.getCurrentMapScale() * this._mapSize * scale
        : Math.max(70, shape.length || 70) * scale;
      const length = Math.max(20, rawLength);
      const width = Math.max(3.5, Math.min(5, length * 0.03));
      return { length, width };
    }

    drawSimpleVyseWall(ctx, shape, opacity = 1) {
      const { length, width } = this.getVyseWallMetrics(shape);
      const topY = -length;
      const bottomY = 0;
      const barWidth = Math.max(2, width);
      const halfBar = barWidth / 2;
      const bottomRadius = Math.max(4, width * 1.1);
      const vysePurple = 'rgba(148, 72, 240, 0.96)';

      ctx.save();
      ctx.globalAlpha = opacity;

      // Main wall bar (flat vertical filament style)
      ctx.fillStyle = vysePurple;
      ctx.beginPath();
      ctx.roundRect(-halfBar, topY, barWidth, length, 1.5);
      ctx.fill();

      // Bottom anchor circle (standard white handle)
      this._drawWhiteHandleMarker(ctx, bottomY);

      ctx.restore();
    }

    drawSimpleViperWall(ctx, shape, opacity = 1) {
      const { length, width } = this.getViperWallMetrics(shape);
      const topY = -length;
      const bottomY = 0;
      const barWidth = Math.max(2, width);
      const halfBar = barWidth / 2;
      const bottomRadius = Math.max(4, width * 1.1);
      const viperGreen = 'rgba(30, 180, 90, 0.96)';

      ctx.save();
      ctx.globalAlpha = opacity;

      // Main wall bar (flat vertical filament style)
      ctx.fillStyle = viperGreen;
      ctx.beginPath();
      ctx.roundRect(-halfBar, topY, barWidth, length, 1.5);
      ctx.fill();

      // Bottom anchor circle (standard white handle)
      this._drawWhiteHandleMarker(ctx, bottomY);

      ctx.restore();
    }

    drawSimplePhoenixWall(ctx, shape, el, opacity = 1) {
      const { length, width } = this.getPhoenixWallMetrics(shape, el);
      const control = this.getPhoenixWallControlPoint(shape, el);
      const tipPoint = { x: 0, y: -length };
      const handlePoint = this.getPhoenixWallPoint(shape, el, 0.5);
      const softWidth = width + 12;
      const coreWidth = Math.max(2, width * 0.28);

      const tracePath = () => {
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.quadraticCurveTo(control.x, control.y, tipPoint.x, tipPoint.y);
      };

      ctx.save();
      ctx.globalAlpha = opacity;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';

      // Soft outer glow
      ctx.strokeStyle = 'rgba(255, 110, 10, 0.18)';
      ctx.lineWidth = softWidth;
      tracePath();
      ctx.stroke();

      // Main fire wall
      ctx.strokeStyle = 'rgba(255, 140, 40, 0.9)';
      ctx.lineWidth = width;
      tracePath();
      ctx.stroke();

      // Bright core
      ctx.strokeStyle = 'rgba(255, 228, 150, 0.8)';
      ctx.lineWidth = coreWidth;
      tracePath();
      ctx.stroke();

      // Tip marker
      const tipRadius = Math.max(4, width * 0.42);
      ctx.beginPath();
      ctx.arc(tipPoint.x, tipPoint.y, tipRadius, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255, 220, 120, 0.88)';
      ctx.fill();

      // Origin handle (white circle at bottom)
      this._drawWhiteHandleMarker(ctx, 0);

      // Bend handle (orange themed)
      this._drawPhoenixWallBendHandle(ctx, handlePoint.x, handlePoint.y);

      ctx.restore();
    }

    _drawPhoenixWallBendHandle(ctx, x, y) {
      ctx.save();
      ctx.translate(x, y);

      ctx.beginPath();
      ctx.arc(0, 0, 8, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(40, 16, 6, 0.92)';
      ctx.fill();
      ctx.strokeStyle = 'rgba(255, 160, 50, 0.95)';
      ctx.lineWidth = 2;
      ctx.stroke();

      ctx.beginPath();
      ctx.arc(0, 0, 3.2, 0, Math.PI * 2);
      ctx.fillStyle = '#ffffff';
      ctx.shadowColor = 'rgba(255, 180, 80, 0.75)';
      ctx.shadowBlur = 8;
      ctx.fill();

      ctx.restore();
    }

    drawSimpleFastLane(ctx, shape, opacity = 1, el = null) {
      const { length, backLength, gap, width } = this.getFastLaneMetrics(shape, el);
      const halfGap = gap / 2;
      const topY = -length;
      const bottomY = backLength;
      const blue = shape.color || '#4d7bff';
      const wallWidth = Math.max(6, gap * 0.24);
      const drawWallBolt = (side, seed, color, lineWidth, alphaMul = 1) => {
        const steps = 16;
        const wallX = side * halfGap;
        ctx.beginPath();
        for (let i = 0; i <= steps; i++) {
          const t = i / steps;
          const y = topY + (bottomY - topY) * t;
          const waveA = Math.sin((t * 10 + seed) * Math.PI * 2) * wallWidth * 0.34;
          const waveB = Math.sin((t * 24 + seed * 1.7) * Math.PI * 2) * wallWidth * 0.15;
          const x = wallX + waveA + waveB;
          if (i === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        }
        ctx.strokeStyle = color;
        ctx.globalAlpha = opacity * alphaMul;
        ctx.lineWidth = lineWidth;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.stroke();
      };

      ctx.save();
      ctx.globalAlpha = opacity;

      // Soft outer aura around each wall line
      ctx.lineCap = 'round';
      ctx.strokeStyle = 'rgba(88, 138, 255, 0.28)';
      ctx.lineWidth = wallWidth + 12;
      ctx.beginPath();
      ctx.moveTo(-halfGap, topY);
      ctx.lineTo(-halfGap, bottomY);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(halfGap, topY);
      ctx.lineTo(halfGap, bottomY);
      ctx.stroke();

      // Left wall
      ctx.strokeStyle = blue;
      ctx.lineWidth = wallWidth;
      ctx.beginPath();
      ctx.moveTo(-halfGap, topY);
      ctx.lineTo(-halfGap, bottomY);
      ctx.stroke();

      // Right wall
      ctx.beginPath();
      ctx.moveTo(halfGap, topY);
      ctx.lineTo(halfGap, bottomY);
      ctx.stroke();

      // Bright wall edges
      ctx.strokeStyle = 'rgba(182, 218, 255, 0.78)';
      ctx.lineWidth = Math.max(1.4, wallWidth * 0.18);
      ctx.beginPath();
      ctx.moveTo(-halfGap, topY);
      ctx.lineTo(-halfGap, bottomY);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(halfGap, topY);
      ctx.lineTo(halfGap, bottomY);
      ctx.stroke();

      // Electric bolts hugging the wall bars (not in the middle)
      ctx.shadowColor = 'rgba(120, 220, 255, 0.8)';
      ctx.shadowBlur = 8;
      drawWallBolt(-1, 0.17, 'rgba(126, 220, 255, 0.5)', Math.max(2.6, wallWidth * 0.28), 0.75);
      drawWallBolt(1, 0.47, 'rgba(126, 220, 255, 0.5)', Math.max(2.6, wallWidth * 0.28), 0.75);
      ctx.shadowBlur = 0;
      drawWallBolt(-1, 0.17, 'rgba(190, 245, 255, 0.95)', Math.max(1.1, wallWidth * 0.11), 1);
      drawWallBolt(1, 0.47, 'rgba(170, 236, 255, 0.9)', Math.max(1.1, wallWidth * 0.11), 1);

      // Bottom white circle
      const circleR = Math.max(7, wallWidth * 1.35);
      ctx.globalAlpha = opacity;

      // Bottom anchor circle (standard white handle)
      this._drawWhiteHandleMarker(ctx, bottomY);

      ctx.restore();
    }

    drawSimpleHarborWall(ctx, shape, el, opacity = 1) {
      const { length, width } = this.getHarborWallMetrics(shape, el);
      const control = this.getHarborWallControlPoint(shape, el);
      const tipPoint = { x: 0, y: -length };
      const handlePoint = this.getHarborWallPoint(shape, el, 0.5);
      const softWidth = width + 16;
      const coreWidth = Math.max(2.4, width * 0.38);
      const foamWidth = Math.max(1.4, width * 0.14);

      const tracePath = () => {
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.quadraticCurveTo(control.x, control.y, tipPoint.x, tipPoint.y);
      };

      ctx.save();
      ctx.globalAlpha = opacity;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';

      ctx.strokeStyle = 'rgba(49, 179, 255, 0.16)';
      ctx.lineWidth = softWidth;
      tracePath();
      ctx.stroke();

      ctx.strokeStyle = 'rgba(0, 154, 255, 0.52)';
      ctx.lineWidth = width;
      tracePath();
      ctx.stroke();

      ctx.strokeStyle = 'rgba(180, 236, 255, 0.95)';
      ctx.lineWidth = coreWidth;
      tracePath();
      ctx.stroke();

      ctx.strokeStyle = 'rgba(230, 248, 255, 0.75)';
      ctx.lineWidth = foamWidth;
      tracePath();
      ctx.stroke();

      this._drawWhiteHandleMarker(ctx, 0);
      this._drawHarborWallBendHandle(ctx, handlePoint.x, handlePoint.y);

      ctx.restore();
    }

    _drawHarborWallBendHandle(ctx, x, y) {
      ctx.save();
      ctx.translate(x, y);

      ctx.beginPath();
      ctx.arc(0, 0, 8, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(6, 26, 40, 0.92)';
      ctx.fill();
      ctx.strokeStyle = 'rgba(88, 212, 255, 0.95)';
      ctx.lineWidth = 2;
      ctx.stroke();

      ctx.beginPath();
      ctx.arc(0, 0, 3.2, 0, Math.PI * 2);
      ctx.fillStyle = '#ffffff';
      ctx.shadowColor = 'rgba(120, 224, 255, 0.75)';
      ctx.shadowBlur = 8;
      ctx.fill();

      ctx.restore();
    }

    _ensureViperWallAsset(target) {
      if (!target) return null;
      const src = '/img/abilities/viper-toxic-screen.svg';
      if (!target._viperWallImg || target._viperWallImgSrc !== src) {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => this.requestRender();
        img.onerror = () => {
          target._viperWallImgFailed = true;
          this.requestRender();
        };
        img.src = src;
        target._viperWallImg = img;
        target._viperWallImgSrc = src;
        target._viperWallImgFailed = false;
      }
      return target._viperWallImg;
    }

  // Cria drag image customizada para habilidades com ícone uploadado
  _setCustomDragImage(e, iconPath, team, domImg) {
    if (!this._transparentDragImage) {
      const canvas = document.createElement('canvas');
      canvas.width = 2;
      canvas.height = 2;
      canvas.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;pointer-events:none;';
      document.body.appendChild(canvas);
      this._transparentDragImage = canvas;
    }

    // Use an invisible native drag image and rely only on the canvas preview.
    e.dataTransfer.setDragImage(this._transparentDragImage, 0, 0);
  }

  _setPlannerDragPayload(dataTransfer, payload = {}) {
    if (!dataTransfer) return;

    const normalized = Object.entries(payload).reduce((acc, [key, value]) => {
      if (value === undefined || value === null || value === '') return acc;
      acc[key] = String(value);
      return acc;
    }, {});

    Object.entries(normalized).forEach(([key, value]) => {
      dataTransfer.setData(key, value);
    });

    // Firefox/Linux can ignore custom drag types unless a standard MIME type is present.
    try {
      dataTransfer.setData('text/plain', `vp2:${JSON.stringify(normalized)}`);
    } catch (error) {
      console.warn('Failed to set text/plain drag payload:', error);
    }
  }

  _getPlannerDragPayload(dataTransfer) {
    if (!dataTransfer) return {};

    const payload = {
      dragType: dataTransfer.getData('drag-type') || '',
      abilityName: dataTransfer.getData('ability-name') || '',
      abilitySlot: dataTransfer.getData('ability-slot') || '',
      abilityIcon: dataTransfer.getData('ability-icon') || '',
      agentUuid: dataTransfer.getData('agent-uuid') || '',
      agentName: dataTransfer.getData('agent-name') || '',
      team: dataTransfer.getData('team') || '',
      markerType: dataTransfer.getData('marker-type') || '',
      playerNum: dataTransfer.getData('player-num') || '',
      playerTeam: dataTransfer.getData('player-team') || ''
    };

    if (Object.values(payload).some(Boolean)) {
      return payload;
    }

    const fallback = dataTransfer.getData('text/plain') || '';
    if (!fallback.startsWith('vp2:')) {
      return payload;
    }

    try {
      const parsed = JSON.parse(fallback.slice(4));
      return {
        ...payload,
        dragType: parsed['drag-type'] || parsed.dragType || '',
        abilityName: parsed['ability-name'] || parsed.abilityName || '',
        abilitySlot: parsed['ability-slot'] || parsed.abilitySlot || '',
        abilityIcon: parsed['ability-icon'] || parsed.abilityIcon || '',
        agentUuid: parsed['agent-uuid'] || parsed.agentUuid || '',
        agentName: parsed['agent-name'] || parsed.agentName || '',
        team: parsed.team || '',
        markerType: parsed['marker-type'] || parsed.markerType || '',
        playerNum: parsed['player-num'] || parsed.playerNum || '',
        playerTeam: parsed['player-team'] || parsed.playerTeam || ''
      };
    } catch (error) {
      console.warn('Failed to parse fallback drag payload:', error);
      return payload;
    }
  }

  // Custom mousedown-based drag for abilities (bypasses HTML5 DnD entirely, no ghost)
  _initCustomAbilityDrag(e, data, onDragStartCb) {
    if (e.button !== 0) return; // left-click only
    e.preventDefault();

    const startX = e.clientX;
    const startY = e.clientY;
    let dragging = false;
    let preventClick = false;
    const canvas = this.canvas;
    const mousedownTarget = e.target;

    const getMapPos = (clientX, clientY) => {
      const r = this._canvasRect();
      const cx = Math.max(r.left, Math.min(clientX, r.right));
      const cy = Math.max(r.top, Math.min(clientY, r.bottom));
      const rawX = (cx - r.left - this.panX) / this.zoomLevel - this._mapOffsetX;
      const rawY = (cy - r.top - this.panY) / this.zoomLevel - this._mapOffsetY;
      return this.mapInverseTransformPoint(rawX, rawY);
    };

    const getTrashBin = () => document.getElementById('vp2-trash-bin');
    const isOverTrashBin = (clientX, clientY) => {
      const trashBin = getTrashBin();
      if (!trashBin) return false;
      const rect = trashBin.getBoundingClientRect();
      return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
    };

    const setTrashHover = (clientX, clientY) => {
      const trashBin = getTrashBin();
      if (!trashBin) return;
      if (isOverTrashBin(clientX, clientY)) {
        trashBin.classList.add('drag-hover');
      } else {
        trashBin.classList.remove('drag-hover');
      }
    };

    const clearTrashHover = () => {
      const trashBin = getTrashBin();
      if (trashBin) trashBin.classList.remove('drag-hover');
    };

    const onMouseMove = (ev) => {
      if (!dragging) {
        const dx = ev.clientX - startX;
        const dy = ev.clientY - startY;
        if (dx * dx + dy * dy < 25) return;
        dragging = true;
        preventClick = true;
        this.dragPreview = { type: 'ability', ...data };
        if (onDragStartCb) onDragStartCb();
      }
      setTrashHover(ev.clientX, ev.clientY);
      const pos = getMapPos(ev.clientX, ev.clientY);
      this.dragPreview.x = pos.x;
      this.dragPreview.y = pos.y;
      this.requestRender();
    };

    const onMouseUp = (ev) => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);

      if (dragging) {
        const droppedOnTrash = isOverTrashBin(ev.clientX, ev.clientY);
        const r = canvas.getBoundingClientRect();
        const overCanvas = ev.clientX >= r.left && ev.clientX <= r.right &&
                           ev.clientY >= r.top && ev.clientY <= r.bottom;
        if (!droppedOnTrash && overCanvas) {
          const pos = getMapPos(ev.clientX, ev.clientY);
          this._placeAbilityAtPosition(data, pos.x, pos.y);
        }
        this.dragPreview = null;
        clearTrashHover();
        this.requestRender();
      }

      if (preventClick) {
        const stopClick = (ce) => { ce.stopPropagation(); ce.preventDefault(); };
        mousedownTarget.addEventListener('click', stopClick, { once: true, capture: true });
      }
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  }

  _placeAbilityAtPosition(data, x, y) {
    const resolved = this.resolveAbilityVisual({
      agentUuid: data.agentUuid,
      abilityName: data.abilityName,
      abilitySlot: data.slot,
      fallbackIcon: data.icon
    });
    const abilityName = resolved.abilityName || data.abilityName;
    const abilitySlot = resolved.abilitySlot || data.slot;
    const abilityIcon = resolved.abilityIcon || data.icon || '';
    const agentUuid = data.agentUuid;
    const team = data.team;
    const shape = this.abilityShapes[abilityName];
    const newElement = {
      id: this.generateId(),
      type: 'ability',
      abilityName,
      abilitySlot,
      abilityIcon,
      abilityDuration: resolved.abilityDuration,
      abilityType: resolved.abilityType,
      agentUuid,
      team: team || 'ally',
      x, y,
      rotation: 0,
      abilityScale: (shape && shape.scalable) ? (shape.defaultScale || shape.maxScale || 1.0) : undefined,
      harborCurveOffset: (shape && shape.bendable) ? 0 : undefined,
      opacity: 1,
      layer: this.elements.length
    };
    this.elements.push(newElement);
    this.saveState();
    this.render();
  }

  _initCustomAgentDrag(e, data, onDragStartCb) {
    if (e.button !== 0) return;
    e.preventDefault();

    const startX = e.clientX;
    const startY = e.clientY;
    let dragging = false;
    let preventClick = false;
    const canvas = this.canvas;
    const mousedownTarget = e.target;

    const getMapPos = (clientX, clientY) => {
      const r = this._canvasRect();
      const cx = Math.max(r.left, Math.min(clientX, r.right));
      const cy = Math.max(r.top, Math.min(clientY, r.bottom));
      const rawX = (cx - r.left - this.panX) / this.zoomLevel - this._mapOffsetX;
      const rawY = (cy - r.top - this.panY) / this.zoomLevel - this._mapOffsetY;
      return this.mapInverseTransformPoint(rawX, rawY);
    };

    const onMouseMove = (ev) => {
      if (!dragging) {
        const dx = ev.clientX - startX;
        const dy = ev.clientY - startY;
        if (dx * dx + dy * dy < 25) return;
        dragging = true;
        preventClick = true;
        this._agentBarDragged = true;
        this.dragPreview = { type: 'agent', ...data };
        if (onDragStartCb) onDragStartCb();
      }

      const pos = getMapPos(ev.clientX, ev.clientY);
      this.dragPreview.x = pos.x;
      this.dragPreview.y = pos.y;
      this.requestRender();
    };

    const onMouseUp = (ev) => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);

      if (dragging) {
        const r = canvas.getBoundingClientRect();
        const overCanvas = ev.clientX >= r.left && ev.clientX <= r.right &&
          ev.clientY >= r.top && ev.clientY <= r.bottom;

        if (overCanvas) {
          const pos = getMapPos(ev.clientX, ev.clientY);
          this._placeAgentAtPosition(data, pos.x, pos.y);
        }

        this.dragPreview = null;
        this._agentBarDragged = false;
        this.requestRender();
      }

      if (preventClick) {
        const stopClick = (ce) => { ce.stopPropagation(); ce.preventDefault(); };
        mousedownTarget.addEventListener('click', stopClick, { once: true, capture: true });
      }
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  }

  _placeAgentAtPosition(data, x, y) {
    const agent = this.agents.find(a => a.uuid === data.agentUuid);
    if (!agent) return;

    const team = data.team || 'ally';
    const slotIndex = this.getNextTeamSlot(team);
    this.teams[team][slotIndex] = agent;

    const newElement = {
      id: this.generateId(),
      type: 'agent',
      agentUuid: agent.uuid,
      agentName: agent.displayName,
      team,
      teamSlot: slotIndex,
      x,
      y,
      direction: team === 'enemy' ? 180 : 0,
      layer: this.elements.length
    };

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      newElement.image = img;
      this.render();
      this.renderAbilityTracks();
    };
    img.src = this.getAgentDisplayIcon(agent);

    this.elements.push(newElement);
    this.renderAgentsBar();
    this.saveState();
    this.render();
    this.renderAbilityTracks();
  }

  /**
   * Mantido porque ~8 pontos chamam por este nome. O agendamento agora vive
   * dentro de render(), entao aqui e so um alias — dois agendadores para o
   * mesmo canvas so davam um frame extra de atraso e mais estado para errar.
   */
  requestRender() {
    this.render();
  }

  isCanvasImageObject(source) {
    if (!source || typeof source !== 'object') return false;
    if (typeof HTMLImageElement !== 'undefined' && source instanceof HTMLImageElement) return true;
    if (typeof HTMLCanvasElement !== 'undefined' && source instanceof HTMLCanvasElement) return true;
    if (typeof ImageBitmap !== 'undefined' && source instanceof ImageBitmap) return true;
    if (typeof OffscreenCanvas !== 'undefined' && source instanceof OffscreenCanvas) return true;
    if (typeof SVGImageElement !== 'undefined' && source instanceof SVGImageElement) return true;
    if (typeof HTMLVideoElement !== 'undefined' && source instanceof HTMLVideoElement) return true;
    if (typeof VideoFrame !== 'undefined' && source instanceof VideoFrame) return true;
    return false;
  }

  isCanvasImageReady(source) {
    if (!this.isCanvasImageObject(source)) return false;
    if (typeof HTMLImageElement !== 'undefined' && source instanceof HTMLImageElement) {
      return source.complete && source.naturalWidth > 0;
    }
    if (typeof HTMLCanvasElement !== 'undefined' && source instanceof HTMLCanvasElement) {
      return source.width > 0 && source.height > 0;
    }
    if (typeof OffscreenCanvas !== 'undefined' && source instanceof OffscreenCanvas) {
      return source.width > 0 && source.height > 0;
    }
    if (typeof ImageBitmap !== 'undefined' && source instanceof ImageBitmap) {
      return source.width > 0 && source.height > 0;
    }
    if (typeof HTMLVideoElement !== 'undefined' && source instanceof HTMLVideoElement) {
      return source.readyState >= 2;
    }
    return true;
  }

  // Normalize agent name to folder name (lowercase, no special chars)
  _normalizeAgentFolder(name) {
    return name.toLowerCase()
      .replace(/\//g, '')    // KAY/O → kayo
      .replace(/\s+/g, '')   // Remove spaces
      .normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // Remove accents
  }

  // Get custom ability icon path (returns path or null)
  getCustomAbilityIcon(agentName, slot) {
    const slotMap = { 'Ability1': 'Q', 'Ability2': 'E', 'Grenade': 'C', 'Grenade_Alt': 'E2', 'Ultimate': 'X', 'Passive': 'P', 'Passive': 'P', 'Passive': 'P' };
    const key = slotMap[slot] || slot;
    const folder = this._normalizeAgentFolder(agentName);
    const cacheKey = `${folder}:${key}`;
    
    if (cacheKey in this._customAbilityIcons) {
      return this._customAbilityIcons[cacheKey] || null;
    }
    return null; // Not yet checked
  }

  // Preload custom ability icons for all agents
  async preloadCustomAbilityIcons() {
    try {
      const resp = await fetch('/api/ability-icons', { cache: 'no-store' });
      const data = await resp.json();
      const icons = data?.icons || {};
      this._customAbilityIcons = {};

      Object.entries(icons).forEach(([agentFolder, slotMap]) => {
        Object.entries(slotMap || {}).forEach(([slot, iconPath]) => {
          this._customAbilityIcons[`${agentFolder}:${slot}`] = iconPath;
        });
      });
    } catch (error) {
      console.error('Error preloading custom ability icons:', error);
    }
  }

  // Sync ability icons everywhere (map elements + trajectory waypoints) after upload/remove/size change
  _syncAbilityIconsEverywhere(agentFolder, slot) {
    // Map slot key (Q/E/C/X) to API slot names
    const keyToSlot = { 'Q': 'Ability1', 'E': 'Ability2', 'E2': 'Grenade_Alt', 'C': 'Grenade', 'X': 'Ultimate', 'P': 'Passive', 'P': 'Passive' };
    const slotToKey = { 'Ability1': 'Q', 'Ability2': 'E', 'Grenade': 'C', 'Grenade_Alt': 'E2', 'Ultimate': 'X', 'Passive': 'P', 'Passive': 'P' };
    const apiSlot = keyToSlot[slot] || slot;
    const slotKey = slotToKey[slot] || slot;

    // Find the agent data
    const agentData = this.agents.find(a => this._normalizeAgentFolder(a.displayName) === agentFolder);
    if (!agentData) return;

    const resolved = this.resolveAbilityVisual({
      agentUuid: agentData.uuid,
      abilitySlot: apiSlot
    });
    const newIconSrc = resolved.abilityIcon;

    // --- 1. Update map-placed ability elements ---
    this.elements.forEach(el => {
      if (el.type !== 'ability' || el.agentUuid !== agentData.uuid) return;
      const elKey = slotToKey[el.abilitySlot] || el.abilitySlot;
      if (elKey !== slotKey) return;

      el.abilityIcon = newIconSrc;
      // Clear cached images so they reload on next render
      el.customIconImage = null;
      el._trimmedIcon = null;
      el._abilityImg = null;
      el._abilityImgFailed = false;
      el.iconImage = null;
      el._iconImgFailed = false;
    });

    // --- 2. Update trajectory waypoints ---
    this.pathAbilityWaypoints.forEach((waypoints, agentId) => {
      const agent = this.elements.find(e => e.id === agentId && e.type === 'agent');
      if (!agent || agent.agentUuid !== agentData.uuid) return;

      waypoints.forEach(wp => {
        if (!wp.ability) return;
        const wpKey = slotToKey[wp.ability.slot] || wp.ability.slot;
        if (wpKey !== slotKey) return;

        wp.ability.icon = newIconSrc;
        // Reload image
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => this.render();
        img.src = newIconSrc + '?t=' + Date.now();
        wp.ability.image = img;
      });
    });

    // --- 3. Update ability markers (timeline) ---
    this.abilityMarkers.forEach((markers, agentId) => {
      const agent = this.elements.find(e => e.id === agentId && e.type === 'agent');
      if (!agent || agent.agentUuid !== agentData.uuid) return;

      markers.forEach(marker => {
        if (!marker.ability) return;
        const mKey = slotToKey[marker.ability.slot] || marker.ability.slot;
        if (mKey !== slotKey) return;

        marker.ability.icon = newIconSrc;
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => { this.renderAbilityTracks(); this.render(); };
        img.src = newIconSrc + '?t=' + Date.now();
        marker.ability.image = img;
      });
    });

    this.render();
  }

  // Sync abilityScale from a map-placed ability element to all matching trajectory waypoints
  _syncAbilityScaleToWaypoints(el) {
    if (!el.agentUuid || !el.abilitySlot) return;
    const slotToKey = { 'Ability1': 'Q', 'Ability2': 'E', 'Grenade': 'C', 'Grenade_Alt': 'E2', 'Ultimate': 'X', 'Passive': 'P' };
    const elSlotKey = slotToKey[el.abilitySlot] || el.abilitySlot;
    this.pathAbilityWaypoints.forEach((waypoints, agentId) => {
      const agent = this.elements.find(e => e.id === agentId);
      if (!agent || agent.agentUuid !== el.agentUuid) return;
      waypoints.forEach(wp => {
        if (!wp.ability) return;
        const wpKey = slotToKey[wp.ability.slot] || wp.ability.slot;
        if (wpKey === elSlotKey) {
          wp.ability.abilityScale = el.abilityScale;
          if (el.harborCurveOffset != null) wp.ability.harborCurveOffset = el.harborCurveOffset;
        }
      });
    });
  }

  // Initialize ability shapes with accurate game data
  

  // Sync maps from Settings (app.getMaps returns only active maps)
  syncMaps() {
    const activeMaps = (typeof app !== 'undefined' && app.getMaps()) || [];
    if (!activeMaps.length) {
      // App map metadata not loaded yet (e.g. public page still fetching).
      // Fall back to the built-in map list so renderPage() always has data.
      if (!this.maps.length) {
        this.maps = Object.keys(this.mapScales).map(key => {
          const info = this.mapScales[key];
          return {
            id: key,
            name: key.charAt(0).toUpperCase() + key.slice(1),
            uuid: info.uuid || '',
            mapScale: info.mapScale || 7e-05,
            rangeScaleAdjust: typeof info.rangeScaleAdjust === 'number' ? info.rangeScaleAdjust : 1,
            defaultZoom: info.defaultZoom || 1,
            splash: `https://media.valorant-api.com/maps/${info.uuid || ''}/splash.png`,
            minimap: '',
            minimap_url: '',
            displayicon: '',
            displayIcon: ''
          };
        });
      }
      return;
    }

    this.maps = activeMaps.map(m => {
      const key = (m.name || '').toLowerCase();
      const info = this.mapScales[key] || {};
      return {
        id: key || m.id,
        name: m.display_name || m.name,
        uuid: info.uuid || m.uuid || '',
        mapScale: info.mapScale || 7e-05,
        rangeScaleAdjust: typeof info.rangeScaleAdjust === 'number' ? info.rangeScaleAdjust : 1,
        defaultZoom: info.defaultZoom || 1,
        splash: m.splash || `https://media.valorant-api.com/maps/${info.uuid || ''}/splash.png`,
        minimap: m.minimap || m.minimap_url || m.displayicon || m.displayIcon || '',
        minimap_url: m.minimap_url || m.minimap || '',
        displayicon: m.displayicon || m.displayIcon || '',
        displayIcon: m.displayIcon || m.displayicon || ''
      };
    });

    // If current map is no longer in the active list, switch to the first available
    if (this.maps.length && !this.maps.find(m => m.id === this.currentMap)) {
      this.currentMap = this.maps[0].id;
    }
  }

  // =====================================================
  // LOAD & RENDER PAGE
  // =====================================================

  async load(params = null) {
    console.log('🎯 ValoPlant v2 - Loading...');
    const container = document.getElementById('page-valoplant');
    console.log('  Container:', container ? 'found' : 'NOT FOUND');
    if (!container) return;

    const requestId = ++this._loadRequestId;
    this._isLoading = true;
    
    // Sync maps from Settings
    this.syncMaps();

    try {
      await this.waitForNextFrame();

      if (requestId !== this._loadRequestId) {
        return;
      }

      // A folha da pagina (105 KB) precisa estar aplicada antes do HTML
      // aparecer, senao o painel pinta cru — os <img> de icone sem CSS nascem
      // em tamanho natural e tomam a tela inteira.
      this.addStyles();
      await Utils.pageCssReady('valoplant');

      if (requestId !== this._loadRequestId) {
        return;
      }

      // Render HTML
      console.log('  Rendering page...');
      container.innerHTML = this.renderPage();

      this.blockPageZoom();
      
      // Initialize canvas
      console.log('  Initializing canvas...');
      this.initCanvas();

      await this.waitForNextFrame();

      if (requestId !== this._loadRequestId) {
        return;
      }
      
      // Load agents from API
      console.log('  Loading agents...');
      await this.loadAgents();

      if (requestId !== this._loadRequestId) {
        return;
      }
      
      // Setup events
      console.log('  Setting up events...');
      this.setupEventListeners();

      await this.waitForNextFrame();

      if (requestId !== this._loadRequestId) {
        return;
      }
      
      // Load default map or persisted tactic
      console.log('  Loading default map...');
      await this.loadMap(this.currentMap);

      if (params?.tacticId) {
        console.log('  Loading saved tactic...', params.tacticId);
        await this.loadSavedTactic(params.tacticId);
      }

      // Session URL: init or restore
      await this._initSession(params?.sessionCode || null);

      console.log('✅ ValoPlant v2 - Loaded successfully!');
    } catch (error) {
      console.error('❌ ValoPlant v2 - Error loading:', error);
    } finally {
      if (requestId === this._loadRequestId) {
        this._isLoading = false;
      }
    }
  }

  

  // =====================================================
  // BLOCK PAGE ZOOM - Lock at 100%
  // =====================================================

  blockPageZoom() {
    if (this._zoomBlocked) return;
    this._zoomBlocked = true;

    // Update viewport meta to prevent mobile pinch zoom
    let meta = document.querySelector('meta[name="viewport"]');
    if (meta) {
      meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no');
    }

    // Block Ctrl+scroll wheel zoom
    document.addEventListener('wheel', (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    }, { passive: false });

    // Block Ctrl+Plus / Ctrl+Minus / Ctrl+0 keyboard zoom
    document.addEventListener('keydown', (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '=' || e.key === '0')) {
        e.preventDefault();
      }
    });

    // Block pinch-to-zoom on touch devices
    document.addEventListener('touchstart', (e) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    }, { passive: false });

    // CSS: disable touch zoom gestures
    document.body.style.touchAction = 'manipulation';

    // Reset zoom to 100% if browser is already zoomed
    document.body.style.zoom = '1';
  }

  // =====================================================
  // CSS STYLES - PREMIUM DESIGN
  // =====================================================

  addStyles() {
    if (document.getElementById('vp2-styles')) return;

    // O CSS mora em css/pages/valoplant-v2.css. Ficava aqui dentro como template
    // string, o que somava peso ao bundle de JS e impedia o navegador de
    // cachear ou o build de minificar a folha de estilo separadamente.
    // Continua carregando sob demanda, como antes.
    Utils.loadPageCss('map-picker-css', 'map-picker.css');
    Utils.loadPageCss('vp2-styles', 'valoplant-v2.css');
  }

  // =====================================================
  // CANVAS INITIALIZATION
  // =====================================================

  

  updateBottomAgentBarLayout() {
    const row = document.getElementById('vp2-agents-row');
    if (!row) return;

    const items = row.querySelectorAll('.vp2-agent-bar-item:not(.vp2-agent-hidden)');
    const visibleCount = items.length;
    if (!visibleCount) return;

    const availableWidth = row.clientWidth || row.parentElement?.clientWidth || 0;
    if (!availableWidth) return;

    const gap = 6;
    const baseCount = Math.max(this.agents?.length || visibleCount, visibleCount);
    const size = Math.floor((availableWidth - (gap * Math.max(baseCount - 1, 0))) / baseCount);
    const cardWidth = Math.max(Math.min(size, 86), 72);
    const nameSize = cardWidth >= 84 ? '0.66rem' : cardWidth >= 78 ? '0.62rem' : cardWidth >= 72 ? '0.58rem' : '0.54rem';
    const namePadTop = '0px';

    row.style.setProperty('--vp2-agent-gap', `${gap}px`);
    row.style.setProperty('--vp2-agent-card-width', `${cardWidth}px`);
    row.style.setProperty('--vp2-agent-name-size', nameSize);
    row.style.setProperty('--vp2-agent-name-pad-top', namePadTop);
  }

  positionZoomIndicator() {
    const indicator = document.getElementById('vp2-zoom-indicator');
    if (!indicator) return;
    const indicatorWidth = indicator.offsetWidth || 56;
    const leftInset = Math.max(12, Math.floor((this._mapOffsetX || 0) - indicatorWidth - 12));
    const topInset = Math.max(12, Math.floor((this._mapOffsetY || 0) + 8));
    indicator.style.left = `${leftInset}px`;
    indicator.style.right = 'auto';
    indicator.style.top = `${topInset}px`;
  }

  resizeCanvas() {
    const wrapper = document.getElementById('vp2-canvas-wrapper');
    const area = document.querySelector('.vp2-canvas-container');
    const trashBin = document.getElementById('vp2-trash-bin');
    
    if (!wrapper || !area) return;
    
    // Canvas fills the entire container
    const style = getComputedStyle(area);
    const padX = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    const padY = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const fullW = Math.floor(Math.max(area.clientWidth - padX, 200));
    const fullH = Math.floor(Math.max(area.clientHeight - padY, 200));
    
    // Map is a centered square that fills the available space
    const mapInset = 2;
    const mapSize = Math.max(Math.min(fullW, fullH) - mapInset, 200);
    this._mapSize = mapSize;
    this._mapOffsetX = (fullW - mapSize) / 2;
    this._mapOffsetY = Math.max(0, (fullH - mapSize) / 2);
    
    const dpr = window.devicePixelRatio || 1;
    this._dpr = dpr;
    this._cssPxW = fullW;
    this._cssPxH = fullH;
    this.canvas.width = fullW * dpr;
    this.canvas.height = fullH * dpr;
    this.canvas.style.width = fullW + 'px';
    this.canvas.style.height = fullH + 'px';
    
    // Wrapper fills entire area
    wrapper.style.width = fullW + 'px';
    wrapper.style.height = fullH + 'px';

    if (trashBin) {
      trashBin.style.top = '12px';
      trashBin.style.right = '12px';
      trashBin.style.left = 'auto';
    }

    this.positionZoomIndicator();

    // Center pan for default zoom so map is fully visible
    if (this.zoomLevel > 1 && this.panX === 0 && this.panY === 0) {
      this.panX = fullW / 2 * (1 - this.zoomLevel);
      this.panY = fullH / 2 * (1 - this.zoomLevel);
    }
    
    // Redraw
    this.render();
  }

  // =====================================================
  // LOAD AGENTS FROM API
  // =====================================================

  async loadAgents() {
    try {
      // Load agents from Valorant API
      const data = await api.getValorantAgents();
      
      if (data.status === 200 && data.data) {
        // Filter playable agents and sort by name
        this.agents = data.data
          .filter(a => a.isPlayableCharacter)
          .sort((a, b) => a.displayName.localeCompare(b.displayName));
        
        this.renderAgentsModal();
        this.renderRoleFilterBar();
        // Render all agents in the bar immediately
        this.renderAgentsBar();
        // Preload custom ability icons
        await this.preloadCustomAbilityIcons();
      }
    } catch (error) {
      if (!api.isTransientNetworkError?.(error)) {
        console.error('Erro ao carregar agentes:', error);
      }
      // Use cached agents if API fails
      this.agents = [];
    }
    
    // Setup agent bar events
    this.setupAgentBarEvents();
  }

  

  

  

  

  

  updateModalDisabledAgents() {
    // Permite agentes duplicados — nenhum agente é desabilitado
    document.querySelectorAll('.vp2-agent-modal-item').forEach(item => {
      item.classList.remove('disabled');
    });
  }

  filterAgentsByRole(role) {
    document.querySelectorAll('.vp2-agent-modal-item').forEach(item => {
      if (role === 'all') {
        item.style.display = '';
      } else {
        const agentRole = item.dataset.agentRole;
        item.style.display = agentRole === role ? '' : 'none';
      }
    });
  }

  normalizeAgentRoleKey(roleValue) {
    return String(roleValue || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z]/g, '');
  }

  getCanonicalAgentRoleKey(roleValue) {
    const normalized = this.normalizeAgentRoleKey(roleValue);
    const aliasMap = {
      initiator: 'initiator',
      iniciador: 'initiator',
      duelist: 'duelist',
      duelista: 'duelist',
      controller: 'controller',
      controlador: 'controller',
      sentinel: 'sentinel',
      sentinela: 'sentinel'
    };

    return aliasMap[normalized] || normalized;
  }

  getAgentRoleMeta(roleKey) {
    const roleMeta = {
      initiator: { label: 'Iniciador', order: 0 },
      duelist: { label: 'Duelista', order: 1 },
      controller: { label: 'Controlador', order: 2 },
      sentinel: { label: 'Sentinela', order: 3 }
    };

    return roleMeta[roleKey] || { label: roleKey, order: 99 };
  }

  getAgentRoleKey(agent) {
    return this.getCanonicalAgentRoleKey(agent?.role?.displayName || agent?.role?.uuid || '');
  }

  getAgentRoleOptions() {
    const roles = new Map();

    this.agents.forEach(agent => {
      const roleKey = this.getAgentRoleKey(agent);
      if (!roleKey || roles.has(roleKey)) return;

      const meta = this.getAgentRoleMeta(roleKey);
      roles.set(roleKey, {
        key: roleKey,
        label: meta.label,
        order: meta.order,
        icon: agent?.role?.displayIcon || ''
      });
    });

    return Array.from(roles.values()).sort((left, right) => left.order - right.order || left.label.localeCompare(right.label));
  }

  

  setAgentRoleFilter(roleKey) {
    this.currentAgentRole = this.currentAgentRole === roleKey ? null : roleKey;
    this.renderRoleFilterBar();
    this.renderAgentsBar();
  }

  selectAgentForSlot(uuid) {
    if (!this.currentSelectingSlot) return;
    
    const { team, slot } = this.currentSelectingSlot;
    const agent = this.agents.find(a => a.uuid === uuid);
    
    if (!agent) return;
    
    // Store agent in team slot
    this.teams[team][slot] = agent;
    
    // Close modal
    this.closeAgentModal();
    
    // Update UI
    this.renderTeamSlot(team, slot);
    this.updateTeamCounts();
    
    // Add agent to map at default position
    this.addAgentToMap(agent, team, slot);
  }

  removeAgentFromSlot(team, slotIndex) {
    const agent = this.teams[team][slotIndex];
    if (!agent) return;
    
    // Remove from team
    this.teams[team][slotIndex] = null;
    
    // Remove from map
    this.elements = this.elements.filter(el => 
      !(el.type === 'agent' && el.teamSlot === slotIndex && el.team === team)
    );
    
    // Update UI
    this.renderTeamSlot(team, slotIndex);
    this.updateTeamCounts();
    this.renderAgentsBar();
    this.render();
  }

  

  updateTeamCounts() {
    ['ally', 'enemy'].forEach(team => {
      const count = this.teams[team].filter(a => a !== null).length;
      const countEl = document.getElementById(`vp2-${team}-count`);
      if (countEl) {
        countEl.textContent = count;
      }
    });
  }

  addAgentToMap(agent, team, slotIndex) {
    // Default positions based on slot and team
    const baseX = this._mapSize / 2;
    const baseY = team === 'ally' ? this._mapSize * 0.8 : this._mapSize * 0.2;
    const columnIndex = slotIndex % 5;
    const rowIndex = Math.floor(slotIndex / 5);
    const offsetX = (columnIndex - 2) * 40;
    const offsetY = rowIndex * 38 * (team === 'ally' ? -1 : 1);
    
    const newElement = {
      id: this.generateId(),
      type: 'agent',
      agentUuid: agent.uuid,
      agentName: agent.displayName,
      team: team,
      teamSlot: slotIndex,
      x: baseX + offsetX,
      y: baseY + offsetY,
      direction: team === 'ally' ? 0 : 180, // Direction indicator, not image rotation
      layer: this.elements.length
    };
    
    // Load agent image
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      newElement.image = img;
      this.render();
      this.renderAbilityTracks(); // Atualiza tracks de habilidade
    };
    img.src = this.getAgentDisplayIcon(agent);
    
    this.elements.push(newElement);
    this.saveState();
    this.render();
    this.renderAbilityTracks(); // Atualiza tracks de habilidade
  }

  addAbilityToMap(abilityName, agentUuid, team) {
    const agent = this.getAgentByUuid(agentUuid);
    if (!agent) return;
    const resolved = this.resolveAbilityVisual({ agentUuid, abilityName });
    const ability = resolved.ability;
    
    // Find agent position on map to place ability near it
    const agentEl = this.elements.find(el => 
      el.type === 'agent' && el.agentUuid === agentUuid && el.team === team
    );
    
    // Se o agente está no mapa, mostra a habilidade acima dele por 1 segundo
    if (agentEl && ability) {
      this.useAbilityOnAgent(agentEl.id, {
        name: resolved.abilityName || abilityName,
        slot: resolved.abilitySlot || (ability ? ability.slot : ''),
        icon: resolved.abilityIcon || (ability ? ability.displayIcon : '') || ''
      });
    }
    
    let x, y;
    if (agentEl) {
      x = agentEl.x + 30;
      y = agentEl.y;
    } else {
      // Place at center of visible map, offset by existing abilities count
      const centerX = (this._cssPxW / 2 - this.panX) / this.zoomLevel - this._mapOffsetX;
      const centerY = (this._cssPxH / 2 - this.panY) / this.zoomLevel - this._mapOffsetY;
      const abilityCount = this.elements.filter(el => el.type === 'ability').length;
      const spacing = 45;
      const cols = Math.floor(Math.sqrt(abilityCount + 1));
      const col = abilityCount % Math.max(cols, 3);
      const row = Math.floor(abilityCount / Math.max(cols, 3));
      x = centerX + (col - 1) * spacing;
      y = centerY + (row) * spacing;
    }
    
    const newElement = {
      id: this.generateId(),
      type: 'ability',
      abilityName: resolved.abilityName || abilityName,
      abilitySlot: resolved.abilitySlot || (ability ? ability.slot : ''),
      abilityIcon: resolved.abilityIcon || '',
      abilityDuration: resolved.abilityDuration,
      abilityType: resolved.abilityType,
      agentUuid: agentUuid,
      team: team,
      x: x,
      y: y,
      rotation: 0,
      opacity: 1,
      layer: this.elements.length
    };
    
    this.elements.push(newElement);
    this.saveState();
    this.render();
    
    // Select the new ability
    this.selectedElement = newElement;
    this.showProperties(newElement);
  }

  // Legacy function - keep for compatibility
  selectAgent(uuid) {
    const agent = this.agents.find(a => a.uuid === uuid);
    if (!agent) return;
    
    this.selectedAgent = agent;
    
    // Show abilities in left sidebar
    const section = document.getElementById('vp2-abilities-section');
    const nameSpan = document.getElementById('vp2-selected-agent-name');
    const grid = document.getElementById('vp2-abilities');
    
    if (section && nameSpan && grid) {
      section.style.display = 'block';
      nameSpan.textContent = `(${agent.displayName})`;
      
      grid.innerHTML = this.getDisplayAbilities(agent)
        .map(ab => {
          const durVal = ab.duration;
          const durTag = durVal != null ? `<span class="vp2-ability-dur">${durVal % 1 === 0 ? durVal + 's' : durVal.toFixed(1) + 's'}</span>` : '';
          return `
          <div class="vp2-ability-item" 
               data-ability-name="${ab.displayName}"
               data-ability-slot="${ab.slot}"
               data-agent-uuid="${uuid}"
               title="${ab.displayName}: ${ab.description || ''}${durVal != null ? ' — Duração: ' + durVal + 's' : ''}">
            <img src="${ab.displayIcon || 'data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\"><rect fill=\"%23333\" width=\"28\" height=\"28\" rx=\"4\"/></svg>'}" 
                 alt="${ab.displayName}" 
                 onerror="this.src='data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\"><rect fill=\"%23333\" width=\"28\" height=\"28\" rx=\"4\"/></svg>'">
            <span>${ab.displayName}</span>
            ${durTag}
          </div>
        `;}).join('');
    }
  }

  // =====================================================
  // BOTTOM AGENT BAR - New Layout System
  // =====================================================

  

  

  addAgentFromBar(uuid, team) {
    const agent = this.agents.find(a => a.uuid === uuid);
    if (!agent) return;
    this.selectedAgent = agent;

    // Find next available slot (expands beyond the base 5 UI slots if needed)
    const slotIndex = this.getNextTeamSlot(team);

    // Add to team
    this.teams[team][slotIndex] = agent;

    // Add to map
    this.addAgentToMap(agent, team, slotIndex);

    // Update agent bar visual
    this.renderAgentsBar();
  }

  // =====================================================
  // LOAD MAP
  // =====================================================

  async loadMap(mapId) {
    this.currentMap = mapId;
    
    const map = this.maps.find(m => m.id === mapId);
    if (!map) return;

    // Per-map default zoom (e.g. Bind at 110%)
    const key = (mapId || '').toLowerCase();
    const info = this.mapScales[key];
    const dz = (info && info.defaultZoom) ? info.defaultZoom : 1;
    this.zoomLevel = dz;
    this.panX = 0;
    this.panY = 0;
    
    // Check cache
    if (this.imageCache.has(mapId)) {
      this.mapImage = this.imageCache.get(mapId);
      this.render();
      return;
    }
    
    // Load from API
    try {
      const urls = this.getMapImageCandidates(mapId, map);
      let img = null;
      let lastError = null;

      for (const url of urls) {
        const candidate = new Image();
        candidate.crossOrigin = 'anonymous';

        try {
          await new Promise((resolve, reject) => {
            candidate.onload = resolve;
            candidate.onerror = reject;
            candidate.src = url;
          });
          img = candidate;
          break;
        } catch (error) {
          lastError = error;
        }
      }

      if (!img) {
        throw lastError || new Error(`Failed to load map image for ${mapId}`);
      }
      
      this.imageCache.set(mapId, img);
      this.mapImage = img;
      this.render();
      
    } catch (error) {
      console.error('Erro ao carregar mapa:', error);
      this.mapImage = null;
      this.render();
    }
  }

  // =====================================================
  // RENDER
  // =====================================================

  

  

  

  
  
  // Usa uma habilidade no agente (mostra por 1.5 segundos)
  useAbilityOnAgent(agentId, abilityData) {
    const agent = this.elements.find(el => el.id === agentId && el.type === 'agent');
    if (!agent) return;
    const resolved = this.resolveAbilityVisual({
      agentUuid: agent.agentUuid,
      abilityName: abilityData.name,
      abilitySlot: abilityData.slot,
      fallbackIcon: abilityData.icon
    });
    
    // Carrega imagem da habilidade
    const abilityImage = new Image();
    abilityImage.crossOrigin = 'anonymous';
    abilityImage.src = resolved.abilityIcon || abilityData.icon || '';
    
    agent.activeAbility = {
      name: resolved.abilityName || abilityData.name,
      image: abilityImage
    };
    agent.activeAbilityTime = Date.now();
    
    this.render();
    
    // Agenda re-render para limpar após 1.5 segundos
    setTimeout(() => this.render(), 1600);
  }
  
  // Adiciona marcador de habilidade na timeline
  addAbilityMarker(agentId, timeMs, ability, mapPosition) {
    if (!this.abilityMarkers.has(agentId)) {
      this.abilityMarkers.set(agentId, []);
    }
    
    const markers = this.abilityMarkers.get(agentId);
    const agentEl = this.elements.find(el => el.id === agentId && el.type === 'agent');
    const resolved = this.resolveAbilityVisual({
      agentUuid: agentEl?.agentUuid,
      abilityName: ability.displayName,
      abilitySlot: ability.slot,
      fallbackIcon: ability.displayIcon
    });
    
    // Carrega imagem da habilidade
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => { this.renderAbilityTracks(); this.render(); };
    img.src = resolved.abilityIcon || '';
    
    markers.push({
      time: timeMs,
      ability: {
        name: resolved.abilityName || ability.displayName,
        slot: resolved.abilitySlot || ability.slot,
        icon: resolved.abilityIcon || '',
        duration: resolved.abilityDuration,
        abilityType: resolved.abilityType,
        image: img
      },
      mapPosition: mapPosition || null, // {x, y} onde a habilidade cai no mapa
      triggered: false,
      activatedAt: null // timestamp de quando foi ativada (para countdown)
    });
    
    // Ordena por tempo
    markers.sort((a, b) => a.time - b.time);
    
    this.renderAbilityTracks();
    this.render();
    const posInfo = mapPosition ? ` em (${Math.round(mapPosition.x)}, ${Math.round(mapPosition.y)})` : '';
    console.log(`🎯 Marcador de habilidade adicionado: ${ability.displayName} em ${Math.round(timeMs/1000)}s${posInfo}`);
  }
  
  // Remove marcador de habilidade
  removeAbilityMarker(agentId, markerIndex) {
    const markers = this.abilityMarkers.get(agentId);
    if (markers && markers[markerIndex] !== undefined) {
      markers.splice(markerIndex, 1);
      this.renderAbilityTracks();
    }
  }
  
  // Renderiza os tracks de habilidade na timeline
  
  
  // Mostra menu de seleção de habilidade para a timeline
  

  // Sub-menu: "Posicionar no mapa" ou "Sem posição"
  

  // Ativa modo de posicionamento: clique no mapa para definir onde a habilidade cai
  startAbilityPlacement(agentId, timeMs, ability) {
    this.abilityPlacementMode = { agentId, timeMs, ability };

    // Muda cursor
    if (this.canvas) this.canvas.style.cursor = 'crosshair';

    // Mostra instrução flutuante
    this.showPlacementInstruction(ability.displayName);
  }

  // Instrução flutuante durante placement mode
  

  // Cancela placement mode
  cancelAbilityPlacement() {
    this.abilityPlacementMode = null;
    if (this.canvas) this.canvas.style.cursor = 'default';
    const instr = document.getElementById('vp2-placement-instruction');
    if (instr) instr.remove();
  }

  // Renderiza habilidades posicionadas no mapa (da timeline com mapPosition)
  

  

  _drawRotationHandle(ctx, shape, el = null) {
    if (!shape || !shape.rotation) return;
    if (shape.noRotationHandle) return;
    const handleInfo = this._getRotationHandleOffset(shape, el);
    if (!handleInfo) return;
    const handleDistanceFactor = (shape.shape === 'tripwire' || shape.shape === 'phoenix-wall' || shape.shape === 'harbor-wall') ? 1.0 : 0.82;
    const adjustedHandleInfo = {
      x: handleInfo.x * handleDistanceFactor,
      y: handleInfo.y * handleDistanceFactor
    };

    ctx.save();
    ctx.globalAlpha = 1.0;
    ctx.translate(adjustedHandleInfo.x, adjustedHandleInfo.y);
    ctx.rotate(Math.PI / 4);
    const ds = 5;
    ctx.fillStyle = 'rgba(140, 20, 30, 0.95)';
    ctx.fillRect(-ds, -ds, ds * 2, ds * 2);
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.6)';
    ctx.lineWidth = 1.5;
    ctx.strokeRect(-ds, -ds, ds * 2, ds * 2);
    ctx.restore();
  }

  // Premium single-chevron direction indicator
  // Draws a single V chevron pointing upward from the icon edge
  _drawChevronIndicator(ctx, iconHalf, options = {}) {
    const chevW = options.width ?? 10;       // half-width of each chevron arm
    const chevH = options.height ?? 6;        // height of each V
    const strokeW = options.strokeWidth ?? 2.8;    // line thickness
    const startX = options.offsetX ?? 0;
    const startY = options.offsetY != null ? -options.offsetY : -(iconHalf + 3); // default just outside icon edge

    ctx.save();
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.lineWidth = strokeW;

    // Outer glow
    ctx.shadowColor = 'rgba(255, 255, 255, 0.5)';
    ctx.shadowBlur = 4;

    // Single chevron — ^ shape pointing away
    const y1 = startY;
    ctx.beginPath();
    ctx.moveTo(startX - chevW, y1);
    ctx.lineTo(startX, y1 - chevH);
    ctx.lineTo(startX + chevW, y1);
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.9)';
    ctx.stroke();

    ctx.shadowBlur = 0;
    ctx.restore();
  }

  _drawWhiteHandleMarker(ctx, yOffset = 0) {
    ctx.save();
    ctx.translate(0, yOffset);
    ctx.beginPath();
    ctx.arc(0, 0, 7, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(255, 255, 255, 0.95)';
    ctx.shadowColor = 'rgba(255, 255, 255, 0.8)';
    ctx.shadowBlur = 8;
    ctx.fill();
    ctx.shadowBlur = 0;
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.5)';
    ctx.lineWidth = 1.5;
    ctx.stroke();
    ctx.restore();
  }

  _drawDragHandle(ctx, shape, el) {
    if (!shape) return;
    if (shape.noDragHandle) return;
    // Gate: draw bolinha for shapes with rotation, scalable, originAtBottom, or special types
    if (!shape.rotation && !shape.scalable && !shape.originAtBottom && shape.shape !== 'tripwire' && shape.shape !== 'barrier-mesh' && shape.shape !== 'astra-wall' && !(shape.shape === 'cone' && shape.dedicatedRender)) return;
    // Shapes that draw their own bolinha internally — skip
    if (shape.shape === 'tripwire') return;
    if (shape.shape === 'phoenix-wall') return;
    if (shape.shape === 'fast-lane') return;
    if (shape.shape === 'harbor-wall') return;
    if (shape.shape === 'astra-wall') return;
    if (shape.shape === 'vyse-wall') return;
    if (shape.shape === 'viper-wall') return;
    // For originAtBottom: Breach is at local (0,0), dy=0.
    // For centered scalable shapes: white circle at bottom edge = +halfH.
    let dy = 0;
    if (shape.scalable && !shape.originAtBottom && shape.shape === 'rect') {
      dy = this._getActualHalfHeight(shape, el);
    }
    this._drawWhiteHandleMarker(ctx, dy);
  }

  // Debug: draw orange hitbox overlays for ability element, bolinha and losango
  _drawHitboxDebug(ctx, shape, el) {
    if (!this._showHitboxDebug) return;
    if (!el || el.type !== 'ability') return;

    const hitboxColor = 'rgba(255, 165, 0, 0.30)';
    const hitboxStroke = 'rgba(255, 140, 0, 0.80)';

    // --- 1. Ability element hitbox (area you click to select/drag the ability) ---
    ctx.save();
    if (shape && shape.shape === 'rect' && shape.originAtBottom && shape.showRange && shape.gameWidth && shape.gameHeight) {
      // Rotated rectangle hitbox
      const mapScale = this.getCurrentMapScale();
      const mapSize = this._mapSize;
      const sc = el.abilityScale != null ? el.abilityScale : 1.0;
      const rw = shape.gameWidth * 100 * mapScale * mapSize;
      const rh = shape.gameHeight * 100 * mapScale * mapSize * sc;
      const _offPx = shape.originOffset ? shape.originOffset * 100 * mapScale * mapSize : 0;
      const _rectY = -rh - _offPx;
      ctx.globalAlpha = 1;
      ctx.fillStyle = hitboxColor;
      ctx.strokeStyle = hitboxStroke;
      ctx.lineWidth = 1.5;
      ctx.fillRect(-rw / 2, _rectY, rw, rh);
      ctx.strokeRect(-rw / 2, _rectY, rw, rh);
    } else {
      // Circular hitbox (icon size)
      const agent = el.agentUuid ? this.getAgentByUuid(el.agentUuid) : null;
      const folder = agent ? this._normalizeAgentFolder(agent.displayName) : '';
      const slotKey = this.getAbilitySlotKey(el.abilitySlot);
      const half = this.getAbilityIconSize(folder, slotKey) / 2;
      ctx.globalAlpha = 1;
      ctx.beginPath();
      ctx.arc(0, 0, half, 0, Math.PI * 2);
      ctx.fillStyle = hitboxColor;
      ctx.fill();
      ctx.strokeStyle = hitboxStroke;
      ctx.lineWidth = 1.5;
      ctx.stroke();
    }
    ctx.restore();

    // --- 2. Bolinha (drag handle) hitbox ---
    if (shape) {
      const hasBolinha = shape.rotation || shape.scalable || shape.originAtBottom ||
        shape.shape === 'tripwire' || shape.shape === 'barrier-mesh' ||
        shape.shape === 'astra-wall' || (shape.shape === 'cone' && shape.dedicatedRender);
      if (hasBolinha) {
        let bdy = 0;
        if (shape.scalable && !shape.originAtBottom && shape.shape === 'rect') {
          bdy = this._getActualHalfHeight(shape, el);
        }
        ctx.save();
        ctx.translate(0, bdy);
        ctx.globalAlpha = 1;
        ctx.beginPath();
        ctx.arc(0, 0, 7, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255, 165, 0, 0.35)';
        ctx.fill();
        ctx.strokeStyle = hitboxStroke;
        ctx.lineWidth = 1.5;
        ctx.stroke();
        ctx.restore();
      }
    }

    // --- 3. Losango (rotation handle) hitbox ---
    if (shape && shape.rotation) {
      const handleInfo = this._getRotationHandleOffset(shape, el);
      if (handleInfo) {
        const handleDistanceFactor = (shape.shape === 'tripwire' || shape.shape === 'phoenix-wall' || shape.shape === 'harbor-wall') ? 1.0 : 0.82;
        const ax = handleInfo.x * handleDistanceFactor;
        const ay = handleInfo.y * handleDistanceFactor;
        ctx.save();
        ctx.translate(ax, ay);
        ctx.globalAlpha = 1;
        ctx.beginPath();
        ctx.arc(0, 0, 7, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255, 165, 0, 0.35)';
        ctx.fill();
        ctx.strokeStyle = hitboxStroke;
        ctx.lineWidth = 1.5;
        ctx.stroke();
        ctx.restore();
      }
    }
  }

  // Check if a canvas position hits a drag handle (white circle at origin of scalable/originAtBottom ability)
  getDragHandleAtPosition(cx, cy) {
    const hitR = 7;
    const hitRSq = hitR * hitR;
    for (let i = this.elements.length - 1; i >= 0; i--) {
      const el = this.elements[i];
      if (el.type !== 'ability') continue;
      const shape = this.abilityShapes[el.abilityName];
      if (!shape || shape.noDragHandle) continue;
      // Gate: detect bolinha for shapes with rotation, scalable, originAtBottom, or special types
      if (!shape.rotation && !shape.scalable && !shape.originAtBottom && shape.shape !== 'tripwire' && shape.shape !== 'barrier-mesh' && shape.shape !== 'cone' && shape.shape !== 'astra-wall') continue;
      if (shape.shape === 'cone') {
        // Cone drag via white anchor at origin
        if (!shape.dedicatedRender || !shape.gameLength) continue;
        const dx = cx - el.x, dy = cy - el.y;
        if (dx * dx + dy * dy <= hitRSq) return el;
        continue;
      }
      // Walls with bolinha at origin
      if (shape.shape === 'phoenix-wall' || shape.shape === 'harbor-wall' ||
          shape.shape === 'astra-wall' || shape.shape === 'vyse-wall' ||
          shape.shape === 'viper-wall') {
        const dx = cx - el.x, dy = cy - el.y;
        if (dx * dx + dy * dy <= hitRSq) return el;
        continue;
      }
      // All other abilities: bolinha at center or at offset position
      let offY = 0;
      if (shape.scalable && !shape.originAtBottom && shape.shape === 'rect') {
        offY = this._getActualHalfHeight(shape, el);
      }
      const rot = this._getEffectiveRotation(el) * Math.PI / 180;
      const cosR = Math.cos(rot), sinR = Math.sin(rot);
      const hx = el.x - offY * sinR;
      const hy = el.y + offY * cosR;
      const dx = cx - hx, dy = cy - hy;
      if (dx * dx + dy * dy <= hitRSq) return el;
    }
    return null;
  }

  getBendHandleAtPosition(cx, cy) {
    for (let i = this.elements.length - 1; i >= 0; i--) {
      const el = this.elements[i];
      if (el.type !== 'ability') continue;
      const shape = this.abilityShapes[el.abilityName];
      if (!shape || !shape.bendable) continue;
      if (shape.shape !== 'harbor-wall' && shape.shape !== 'phoenix-wall') continue;

      const handle = shape.shape === 'phoenix-wall'
        ? this.getPhoenixWallPoint(shape, el, 0.5)
        : this.getHarborWallPoint(shape, el, 0.5);
      const rot = this._getEffectiveRotation(el) * Math.PI / 180;
      const cosR = Math.cos(rot), sinR = Math.sin(rot);
      const hx = el.x + handle.x * cosR - handle.y * sinR;
      const hy = el.y + handle.x * sinR + handle.y * cosR;
      const dx = cx - hx;
      const dy = cy - hy;
      const bendHitR = 16;
      if (dx * dx + dy * dy <= bendHitR * bendHitR) return el;
    }
    return null;
  }

  // Returns the actual visual half-height of a shape in canvas logical units.
  // For custom-upload abilities with gameHeight, uses the game-unit → pixel conversion.
  _getActualHalfHeight(shape, el) {
    if (shape.showRange && shape.gameHeight) {
      const sc = (shape.scalable && el?.abilityScale != null) ? el.abilityScale : 1.0;
      return shape.gameHeight * 100 * this.getCurrentMapScale() * this._mapSize * sc / 2;
    }
    const sc = (el?.abilityScale != null) ? el.abilityScale : 1.0;
    return (shape.height || 0) * sc / 2;
  }

  // Get offset (x,y) from center to the rotation handle in local shape coords
  _getRotationHandleOffset(shape, el = null) {
    if (!shape || !shape.rotation) return null;

    // Helper: get icon half-size for this ability
    const _getIconHalf = () => {
      if (!el) return 13;
      const _ag = el.agentUuid ? this.getAgentByUuid(el.agentUuid) : null;
      const _fl = _ag ? this._normalizeAgentFolder(_ag.displayName) : '';
      const _slm = { 'Ability1': 'Q', 'Ability2': 'E', 'Grenade': 'C', 'Grenade_Alt': 'E2', 'Ultimate': 'X', 'Passive': 'P' };
      const _sk = _slm[el.abilitySlot] || el.abilitySlot || '';
      return this.getAbilityIconSize(_fl, _sk) / 2;
    };
    const _gap = 12; // fixed gap between icon edge and diamond

    switch (shape.shape) {
      // Shapes drawn along Y axis (vertical line)
      case 'astra-wall': return { x: 0, y: -120 };
      case 'viper-wall': {
        const wallLength = this.getAbilityShapeLength(shape);
        return { x: 0, y: -(wallLength / 2) };
      }
      case 'phoenix-wall': {
        const phxLength = this.getPhoenixWallMetrics(shape, el).length;
        const phxTip = this.getPhoenixWallPoint(shape, el, 1.0);
        return { x: phxTip.x, y: phxTip.y };
      }
      case 'vyse-wall': {
        const vyseWallLength = this.getVyseWallMetrics(shape).length;
        return { x: 0, y: -(vyseWallLength / 2) };
      }
      case 'fast-lane': {
        const flLength = this.getFastLaneMetrics(shape, el).length;
        return { x: 0, y: -flLength };
      }
      case 'harbor-wall': {
        const harborTip = this.getHarborWallPoint(shape, el, 1.0);
        return { x: harborTip.x, y: harborTip.y };
      }
      // Shapes drawn along X axis (horizontal)
      case 'wall': return { x: (shape.length || 100) / 2 + 15, y: 0 };
      case 'rect': {
        const halfH = this._getActualHalfHeight(shape, el);
        const _offPx = shape.originOffset && shape.showRange && shape.gameWidth ? shape.originOffset * 100 * this.getCurrentMapScale() * this._mapSize : 0;
        if (shape.originAtBottom) return { x: 0, y: -(halfH * 2) - _offPx };
        return { x: 0, y: -(_getIconHalf() + _gap) };
      }
      case 'cone': {
        return { x: 0, y: -(_getIconHalf() + _gap) };
      }
      case 'chevron': {
        return { x: 0, y: -(_getIconHalf() + _gap) };
      }
      case 'creature': {
        return { x: 0, y: -(_getIconHalf() + _gap) };
      }
      case 'dash': return { x: (shape.length || 60) + 15, y: 0 };
      case 'tripwire': {
        const twLen = this.getTripwireMetrics(shape, el).length;
        return { x: 0, y: -twLen };
      }
      case 'barrier-mesh': {
        const { d: bmD } = this.getBarrierMeshMetrics(shape);
        return { x: bmD, y: -bmD }; // top-right arm tip
      }
      case 'circle': {
        return { x: 0, y: -(_getIconHalf() + _gap) };
      }
      case 'flash': return { x: 0, y: -(_getIconHalf() + _gap) };
      default: return { x: 0, y: -(_getIconHalf() + _gap) };
    }
  }

  // Get effective rotation in logical coords (accounts for map counter-rotation)
  _getEffectiveRotation(el) {
    let angle = el.rotation || 0;
    const mapRot = this.mapRotations[this.currentMap];
    if (mapRot) {
      angle -= (mapRot.baseRotation || 0);
      if (mapRot.flipForDefense && this.currentSide === 'defense') {
        angle += 180;
      }
    }
    return angle;
  }

  // Check if a canvas position hits a rotation handle, returns the element or null
  getRotationHandleAtPosition(cx, cy) {
    for (let i = this.elements.length - 1; i >= 0; i--) {
      const el = this.elements[i];
      if (el.type !== 'ability') continue;
      const shape = this.abilityShapes[el.abilityName];
      if (!shape || !shape.rotation) continue;
      if (shape.noRotationHandle) continue;
      const offset = this._getRotationHandleOffset(shape, el);
      if (!offset) continue;
      const handleDistanceFactor = (shape.shape === 'tripwire' || shape.shape === 'phoenix-wall' || shape.shape === 'harbor-wall') ? 1.0 : 0.82;
      const adjustedOffset = {
        x: offset.x * handleDistanceFactor,
        y: offset.y * handleDistanceFactor
      };
      
      // Handle position in logical coords: use effective rotation (accounts for map rotation)
      const rot = this._getEffectiveRotation(el) * Math.PI / 180;
      const cosR = Math.cos(rot), sinR = Math.sin(rot);
      const hx = el.x + adjustedOffset.x * cosR - adjustedOffset.y * sinR;
      const hy = el.y + adjustedOffset.x * sinR + adjustedOffset.y * cosR;
      const dx = cx - hx, dy = cy - hy;
      const zoom = this.zoomLevel || 1;
      const hitR = Math.min(12, Math.max(7, 21 / zoom));
      if (dx * dx + dy * dy <= hitR * hitR) return el;
    }
    return null;
  }

  // Returns corner name ('tl','tr','bl','br') if pos hits a resize handle of a selected image element
  getImageResizeCorner(x, y) {
    const el = this.selectedElement;
    if (!el || el.type !== 'image') return null;
    const w = el.width || 200;
    const h = el.height || 150;
    const hw = w / 2, hh = h / 2;
    const cL = el.cropLeft || 0, cT = el.cropTop || 0;
    const cR = el.cropRight || 0, cB = el.cropBottom || 0;
    const cropX = -hw + cL * w, cropY = -hh + cT * h;
    const cropW = w * (1 - cL - cR), cropH = h * (1 - cT - cB);
    const HANDLE_R = 8 / (this.zoomLevel || 1);
    const rot = this.mapRotations[this.currentMap];
    const R = rot ? (rot.baseRotation || 0) * Math.PI / 180 : 0;
    const f = (rot && rot.flipForDefense && this.currentSide === 'defense') ? -1 : 1;
    const cosR = Math.cos(R), sinR = Math.sin(R);
    const corners = [
      { name: 'tl', lx: cropX,          ly: cropY },
      { name: 'tr', lx: cropX + cropW,  ly: cropY },
      { name: 'bl', lx: cropX,          ly: cropY + cropH },
      { name: 'br', lx: cropX + cropW,  ly: cropY + cropH },
    ];
    for (const c of corners) {
      const cx = el.x + f * c.lx * cosR + f * c.ly * sinR;
      const cy = el.y + f * (-c.lx * sinR + c.ly * cosR);
      const dx = x - cx, dy = y - cy;
      if (dx * dx + dy * dy <= HANDLE_R * HANDLE_R) return c.name;
    }
    return null;
  }

  getImageCropHandle(x, y) {
    const el = this.selectedElement;
    if (!el || el.type !== 'image') return null;
    const w = el.width || 200;
    const h = el.height || 150;
    const hw = w / 2, hh = h / 2;
    const cL = el.cropLeft || 0;
    const cT = el.cropTop || 0;
    const cR = el.cropRight || 0;
    const cB = el.cropBottom || 0;
    const HANDLE_R = 10 / (this.zoomLevel || 1);
    const rot = this.mapRotations[this.currentMap];
    const R = rot ? (rot.baseRotation || 0) * Math.PI / 180 : 0;
    const f = (rot && rot.flipForDefense && this.currentSide === 'defense') ? -1 : 1;
    const cosR = Math.cos(R), sinR = Math.sin(R);
    const cropX = -hw + cL * w;
    const cropY = -hh + cT * h;
    const cropW = w * (1 - cL - cR);
    const cropH = h * (1 - cT - cB);
    const pts = [
      { name: 'top',    lx: cropX + cropW / 2, ly: cropY },
      { name: 'bottom', lx: cropX + cropW / 2, ly: cropY + cropH },
      { name: 'left',   lx: cropX,             ly: cropY + cropH / 2 },
      { name: 'right',  lx: cropX + cropW,     ly: cropY + cropH / 2 },
    ];
    for (const pt of pts) {
      const wx = el.x + f * pt.lx * cosR + f * pt.ly * sinR;
      const wy = el.y + f * (-pt.lx * sinR + pt.ly * cosR);
      const dx = x - wx, dy = y - wy;
      if (dx * dx + dy * dy <= HANDLE_R * HANDLE_R) return pt.name;
    }
    return null;
  }

  // Check if a canvas position hits a scale handle (cyan diamond at tip), returns element or null
  getScaleHandleAtPosition(cx, cy) {
    for (let i = this.elements.length - 1; i >= 0; i--) {
      const el = this.elements[i];
      if (el.type !== 'ability') continue;
      const shape = this.abilityShapes[el.abilityName];
      if (!shape || !shape.scalable) continue;
      const sc = el.abilityScale != null ? el.abilityScale : 1.0;
      const tipY = -(shape.height * sc / 2);
      const rot = this._getEffectiveRotation(el) * Math.PI / 180;
      const cosR = Math.cos(rot), sinR = Math.sin(rot);
      // tipY offset in local coords (0, tipY) → world: x = -tipY*sinR, y = tipY*cosR
      const hx = el.x - tipY * sinR;
      const hy = el.y + tipY * cosR;
      const dx = cx - hx, dy = cy - hy;
      if (dx * dx + dy * dy <= 225) return el; // 15px hit radius
    }
    return null;
  }

  

  

  

  

  

  

  

  

  getElementBounds(el) {
    switch (el.type) {
      case 'player':
        return { width: 28, height: 28 };
      case 'agent':
        const agentFolder = this._normalizeAgentFolder(el.agentName || '');
        const agentSz = this.getAgentIconSize(agentFolder);
        return { width: agentSz, height: agentSz };
      case 'ability':
        const shape = this.abilityShapes[el.abilityName];
        if (shape) {
          if (shape.shape === 'astra-wall') return { width: 250, height: 250 };
          if (shape.shape === 'viper-wall') {
            const { length, width } = this.getViperWallMetrics(shape);
            return { width: width + 36, height: length + 36 };
          }
          if (shape.shape === 'phoenix-wall') {
            const { length, width } = this.getPhoenixWallMetrics(shape, el);
            const phxCurveSpan = this.getPhoenixWallCurveLimit(length);
            return { width: phxCurveSpan * 2 + width + 48, height: length + 48 };
          }
          if (shape.shape === 'vyse-wall') {
            const { length, width } = this.getVyseWallMetrics(shape);
            return { width: width + 36, height: length + 36 };
          }
          if (shape.shape === 'fast-lane') {
            const { length, backLength, gap } = this.getFastLaneMetrics(shape, el);
            return { width: gap + 36, height: length + backLength + 36 };
          }
          if (shape.shape === 'harbor-wall') {
            const { length, width } = this.getHarborWallMetrics(shape, el);
            const curveSpan = this.getHarborWallCurveLimit(length);
            return { width: curveSpan * 2 + width + 48, height: length + 48 };
          }
          if (shape.shape === 'cyber-cage') {
            const { radius } = this.getCyberCageMetrics(shape);
            return { width: radius * 2 + 22, height: radius * 2 + 22 };
          }
          if (shape.shape === 'relay-bolt') {
            const { radius } = this.getRelayBoltMetrics(shape);
            return { width: radius * 2 + 30, height: radius * 2 + 30 };
          }
          if (shape.shape === 'tripwire') {
            const twm = this.getTripwireMetrics(shape, el);
            return { width: twm.width + 28, height: twm.length + 28 };
          }
          if (shape.shape === 'barrier-mesh') {
            const { d: bmBnd } = this.getBarrierMeshMetrics(shape);
            const span = bmBnd * 2 + 28;
            return { width: span, height: span };
          }
          const agent = el.agentUuid ? this.getAgentByUuid(el.agentUuid) : null;
          const folder = agent ? this._normalizeAgentFolder(agent.displayName) : '';
          const slotKey = this.getAbilitySlotKey(el.abilitySlot);
          const iconSize = this.getAbilityIconSize(folder, slotKey);
          return { width: iconSize + 4, height: iconSize + 4 };
        }
        return { width: 30, height: 30 };
      case 'marker':
        const mdef = this.markerDefs[el.markerType];
        const mr = mdef ? Math.max(mdef.radius, 14) : 20;
        return { width: mr * 2, height: mr * 2 };
      case 'circle':
        return { width: (el.radius || 20) * 2, height: (el.radius || 20) * 2 };
      case 'text':
        const fs = el.fontSize || 16;
        const tLines = (el.text || '').split('\n');
        const tw = Math.max(40, Math.max(...tLines.map(l => l.length)) * fs * 0.62 + 16);
        const th = fs * 1.4 * tLines.length + 10;
        return { width: tw, height: th };
      case 'image':
        return { width: el.width || 200, height: el.height || 150 };
      default:
        return { width: 30, height: 30 };
    }
  }

  // =====================================================
  // MAP DROPDOWN METHODS
  // =====================================================

  selectMapFromStrip(mapId) {
    this.selectMapFromDropdown(mapId);
  }

  /** Mapas no formato do componente compartilhado (js/components/map-picker.js). */
  mapPickerMaps() {
    return this.maps.map(m => ({
      id: m.id,
      name: m.name,
      image: m.splash,
      // Miniatura leve na grade; o splash fica so no banner.
      thumb: (typeof MapCatalog !== 'undefined' && MapCatalog.listViewIcon(m.name)) || m.splash
    }));
  }

  buildMapDropdownItemsHtml() {
    return `<div class="lu-map-grid">${MapPicker.items({
      maps: this.mapPickerMaps(),
      selectedId: this.currentMap
    })}</div>`;
  }

  

  selectMapFromDropdown(mapId, e) {
    if (e) { e.stopPropagation(); e.preventDefault(); }
    if (this.currentMap === mapId) {
      const dd = document.getElementById('vp2-map-dropdown');
      const mcSame = document.getElementById('vp2-map-current');
      if (dd) dd.classList.remove('open');
      if (mcSame) mcSame.classList.remove('lu-map-dropdown-open');
      this.mapDropdownOpen = false;
      return;
    }

    // Limpar todos os elementos e estado ao trocar de mapa
    this.elements = [];
    this.selectedElement = null;
    this.selectedElements = [];
    this.timeline.keyframes = [];
    this.teams = this.createBaseTeamState();
    this.agentPaths.clear();
    this.pathAbilityWaypoints.clear();
    this.abilityMarkers.clear();
    if (this.isPlaying) this.stopPlayback();

    this.currentMap = mapId;
    const dd = document.getElementById('vp2-map-dropdown');
    const mc = document.getElementById('vp2-map-current');
    // Update current map display
    const map = this.maps.find(m => m.id === mapId);
    if (map && mc) MapPicker.swap(mc, { image: map.splash, name: map.name });
    if (dd) {
      dd.innerHTML = this.buildMapDropdownItemsHtml();
      dd.classList.remove('open');
    }
    if (mc) mc.classList.remove('lu-map-dropdown-open');
    this.mapDropdownOpen = false;
    this.hideProperties();
    this.updateElementsList();
    this.undoStack = [];
    this.redoStack = [];
    this.renderAgentsBar();
    this.renderAbilityTracks();
    this.loadMap(mapId);
    this.saveState();
  }

  // =====================================================
  // EVENT LISTENERS
  // =====================================================

  

  

  

  

  // =====================================================
  // PANEL TOOLS, MARKERS & PLAYERS
  // =====================================================

  

  // Marker definitions for rendering
  get markerDefs() {
    return {
      smoke:    { icon: '\uf0c2', color: 'rgba(128,128,128,0.7)', radius: 35, label: 'Smoke' },
      flash:    { icon: '\uf0e7', color: 'rgba(255,200,50,0.7)',  radius: 28, label: 'Flash' },
      molly:    { icon: '\uf06d', color: 'rgba(239,68,68,0.7)',   radius: 30, label: 'Molly' },
      wall:     { icon: '\uf7a4', color: 'rgba(34,211,238,0.7)',  radius: 20, label: 'Wall' },
      recon:    { icon: '\uf7c0', color: 'rgba(168,85,247,0.7)',  radius: 25, label: 'Recon' },
      location: { icon: '\uf3c5', color: 'rgba(34,197,94,0.7)',   radius: 12, label: 'Local' },
      flag:     { icon: '\uf024', color: 'rgba(251,146,60,0.7)',  radius: 12, label: 'Flag' },
      danger:   { icon: '\uf071', color: 'rgba(234,179,8,0.7)',   radius: 12, label: 'Danger' },
      target:   { icon: '\uf05b', color: 'rgba(255,70,85,0.7)',   radius: 15, label: 'Target' },
      star:     { icon: '\uf005', color: 'rgba(250,204,21,0.7)',  radius: 12, label: 'Star' },
    };
  }

  addMarkerToMap(markerType, x, y) {
    const def = this.markerDefs[markerType];
    if (!def) return;
    const newElement = {
      id: this.generateId(),
      type: 'marker',
      markerType: markerType,
      x: x,
      y: y,
      rotation: 0,
      opacity: 0.85,
      layer: this.elements.length
    };
    this.elements.push(newElement);
    this.saveState();
    this.render();
  }

  addPlayerToMap(num, team, x, y) {
    const newElement = {
      id: this.generateId(),
      type: 'player',
      team: team,
      number: num,
      x: x,
      y: y,
      rotation: 0,
      layer: this.elements.length
    };
    this.elements.push(newElement);
    this.saveState();
    this.render();
  }

  // Update "delete selected" button state
  updateDeleteSelectedBtn() {
    const btn = document.getElementById('vp2-panel-delete-selected');
    if (btn) btn.disabled = !this.selectedElement;
  }
  
  

  

  selectTool(tool) {
    this.currentTool = tool;
    document.querySelectorAll('.vp2-tool').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.tool === tool);
    });
    if (!tool && this.canvas) {
      this.canvas.style.cursor = 'default';
    }
  }

  

  

  // =====================================================
  // HELPER METHODS
  // =====================================================

  getCanvasPosition(e) {
    // Uma medida por frame: isto roda em todo mousemove de arrasto e rotacao.
    const rect = this._canvasRect();
    const rawX = (e.clientX - rect.left - this.panX) / this.zoomLevel - this._mapOffsetX;
    const rawY = (e.clientY - rect.top - this.panY) / this.zoomLevel - this._mapOffsetY;
    return this.mapInverseTransformPoint(rawX, rawY);
  }

  // Transform element coordinates to canvas coordinates (for rendering)
  mapTransformPoint(x, y) {
    const w = this._mapSize;
    const h = this._mapSize;
    const rotation = this.mapRotations[this.currentMap];
    if (!rotation) return { x, y };
    
    // Translate to center
    let px = x - w/2;
    let py = y - h/2;
    
    // Apply rotation
    if (rotation.baseRotation) {
      const rad = rotation.baseRotation * Math.PI / 180;
      const cos = Math.cos(rad);
      const sin = Math.sin(rad);
      const nx = px * cos - py * sin;
      const ny = px * sin + py * cos;
      px = nx;
      py = ny;
    }
    
    // Flip for defense
    if (rotation.flipForDefense && this.currentSide === 'defense') {
      px = -px;
      py = -py;
    }
    
    return { x: px + w/2, y: py + h/2 };
  }

  // Transform canvas/screen coordinates back to element coordinates (for interaction)
  mapInverseTransformPoint(x, y) {
    const w = this._mapSize;
    const h = this._mapSize;
    const rotation = this.mapRotations[this.currentMap];
    if (!rotation) return { x, y };
    
    // Translate to center
    let px = x - w/2;
    let py = y - h/2;
    
    // Inverse flip for defense (flip is its own inverse)
    if (rotation.flipForDefense && this.currentSide === 'defense') {
      px = -px;
      py = -py;
    }
    
    // Inverse rotation
    if (rotation.baseRotation) {
      const rad = -rotation.baseRotation * Math.PI / 180;
      const cos = Math.cos(rad);
      const sin = Math.sin(rad);
      const nx = px * cos - py * sin;
      const ny = px * sin + py * cos;
      px = nx;
      py = ny;
    }
    
    return { x: px + w/2, y: py + h/2 };
  }

  _updateMapSidebars() {
    const allyPanel = document.getElementById('vp2-map-agents-ally');
    const enemyPanel = document.getElementById('vp2-map-agents-enemy');
    if (!allyPanel || !enemyPanel) return;

    const slotLabels = { Ability1: 'Q', Ability2: 'E', Grenade: 'C', Grenade_Alt: 'E2', Ultimate: 'X', Passive: 'P', Passive: 'P' };

    const buildPanel = (team, panel) => {
      const teamAgents = (this.teams[team] || []).filter(a => a !== null);
      if (!teamAgents.length) {
        panel.innerHTML = '';
        panel.classList.remove('has-agents');
        return;
      }
      panel.classList.add('has-agents');

      // Check if content actually changed to avoid unnecessary re-renders
      const agentIds = teamAgents.map(a => a.uuid).join(',');
      if (panel.dataset.agentIds === agentIds) return;
      panel.dataset.agentIds = agentIds;

      const html = teamAgents.map(agent => {
        const icon = agent.displayIcon || agent.displayIconSmall || '';
        const abilities = this.getDisplayAbilities(agent, { requireVisibleIcon: true });
        const abilitiesHtml = abilities.map(ab => {
          const iconSrc = ab.displayIcon || '';
          return `<button class="ability-btn"
            data-ability-name="${ab.displayName}"
            data-ability-slot="${ab.slot}"
            data-ability-icon="${ab.displayIcon || ''}"
            data-agent-uuid="${agent.uuid}"
            data-team="${team}"
            title="${ab.displayName} [${slotLabels[ab.slot] || ab.slot}]">
            <img src="${iconSrc}" alt="${ab.displayName}" draggable="false">
          </button>`;
        }).join('');

        return `<div class="vp2-map-agent-card" data-agent-uuid="${agent.uuid}" data-team="${team}">
          <img class="agent-icon" src="${icon}" alt="${agent.displayName}" draggable="false">
          <span class="agent-name">${agent.displayName}</span>
          <div class="abilities-row">${abilitiesHtml}</div>
        </div>`;
      }).join('');

      panel.innerHTML = html;
    };

    buildPanel('ally', allyPanel);
    buildPanel('enemy', enemyPanel);

    // Wire events (delegated)
    if (!this._mapSidebarEventsWired) {
      this._mapSidebarEventsWired = true;

      const handleClick = (e) => {
        const btn = e.target.closest('.ability-btn');
        if (!btn) return;
        this.addAbilityToMap(btn.dataset.abilityName, btn.dataset.agentUuid, btn.dataset.team);
      };

      // Block native drag for abilities
      const handleDragStart = (e) => {
        const btn = e.target.closest('.ability-btn');
        if (btn) { e.preventDefault(); return; }
      };

      const handleDragEnd = () => {
        if (this.dragPreview) { this.dragPreview = null; this.render(); }
      };

      // Custom mousedown drag for sidebar abilities (no ghost image)
      const handleMouseDown = (e) => {
        const btn = e.target.closest('.ability-btn');
        if (!btn) return;
        const agentUuid = btn.dataset.agentUuid;
        const agent = this.agents.find(a => a.uuid === agentUuid);
        const agentName = agent ? agent.displayName : '';
        const customIcon = this.getCustomAbilityIcon(agentName, btn.dataset.abilitySlot);
        this._initCustomAbilityDrag(e, {
          abilityName: btn.dataset.abilityName,
          slot: btn.dataset.abilitySlot,
          icon: customIcon || btn.dataset.abilityIcon || '',
          agentUuid: agentUuid,
          team: btn.dataset.team || 'ally'
        });
      };

      allyPanel.addEventListener('click', handleClick);
      allyPanel.addEventListener('dragstart', handleDragStart);
      allyPanel.addEventListener('dragend', handleDragEnd);
      allyPanel.addEventListener('mousedown', handleMouseDown);
      enemyPanel.addEventListener('click', handleClick);
      enemyPanel.addEventListener('dragstart', handleDragStart);
      enemyPanel.addEventListener('dragend', handleDragEnd);
      enemyPanel.addEventListener('mousedown', handleMouseDown);
    }
  }

  _updateHoverHud(el) {
    const hud = document.getElementById('vp2-hover-hud');
    if (!hud) return;

    if (!el || (el.type !== 'agent' && el.type !== 'ability')) {
      if (this._hoveredElId) {
        hud.classList.remove('visible');
        this._hoveredElId = null;
      }
      return;
    }

    if (el.id === this._hoveredElId) return;
    this._hoveredElId = el.id;

    if (el.type === 'agent') {
      const agent = this.agents.find(a => a.uuid === el.agentUuid);
      const name = agent ? agent.displayName : 'Agente';
      const icon = agent ? (agent.displayIcon || agent.displayIconSmall || '') : '';
      const teamLabel = el.team === 'enemy' ? 'Inimigo' : 'Aliado';
      hud.innerHTML = `
        ${icon ? `<img class="vp2-hover-hud-icon" src="${icon}" alt="">` : ''}
        <div class="vp2-hover-hud-info">
          <span class="vp2-hover-hud-name">${name}</span>
          <span class="vp2-hover-hud-sub">${teamLabel}</span>
        </div>`;
    } else if (el.type === 'ability') {
      const agent = this.agents.find(a => a.uuid === el.agentUuid);
      const agentName = agent ? agent.displayName : '';
      const slotMap = { 'Ability1': 'Q', 'Ability2': 'E', 'Grenade': 'C', 'Grenade_Alt': 'E2', 'Ultimate': 'X', 'Passive': 'P', 'Passive': 'P' };
      const key = slotMap[el.abilitySlot] || el.abilitySlot || '';
      const abilityName = el.abilityName || 'Habilidade';
      const icon = el.abilityIcon || '';
      hud.innerHTML = `
        ${icon ? `<img class="vp2-hover-hud-icon" src="${icon}" alt="">` : ''}
        <div class="vp2-hover-hud-info">
          <span class="vp2-hover-hud-name">${abilityName} <span style="opacity:0.5;font-size:0.6rem">[${key}]</span></span>
          <span class="vp2-hover-hud-sub">${agentName}</span>
        </div>`;
    }
    hud.classList.add('visible');
  }

  getElementAtPosition(x, y) {
    const HIT = 12 / (this.zoomLevel || 1); // hit tolerance scaled for zoom

    // Pass 1: agents and players always take priority over abilities/other elements
    for (let i = this.elements.length - 1; i >= 0; i--) {
      const el = this.elements[i];
      if (el.type !== 'agent' && el.type !== 'player') continue;
      const bounds = this.getElementBounds(el);
      if (x >= el.x - bounds.width/2 && x <= el.x + bounds.width/2 &&
          y >= el.y - bounds.height/2 && y <= el.y + bounds.height/2) {
        return el;
      }
    }

    // Pass 2: everything else
    for (let i = this.elements.length - 1; i >= 0; i--) {
      const el = this.elements[i];

      // Already handled in pass 1
      if (el.type === 'agent' || el.type === 'player') continue;

      if (el.type === 'pen' && el.points && el.points.length > 1) {
        // Check distance to each segment of the pen path
        for (let j = 0; j < el.points.length - 1; j++) {
          if (this._distToSegment(x, y, el.points[j].x, el.points[j].y, el.points[j+1].x, el.points[j+1].y) <= HIT) return el;
        }
        continue;
      }

      if ((el.type === 'line' || el.type === 'arrow') && el.endX !== undefined) {
        if (this._distToSegment(x, y, el.x, el.y, el.endX, el.endY) <= HIT) return el;
        continue;
      }

      // Abilities: hitbox matches visual shape
      if (el.type === 'ability') {
        const shape = this.abilityShapes[el.abilityName];
        // Custom uploaded icons: hitbox = upload icon size (same as Astra image shapes)
        const _agHit = el.agentUuid ? this.getAgentByUuid(el.agentUuid) : null;
        const _folHit = _agHit ? this._normalizeAgentFolder(_agHit.displayName) : '';
        const _slkHit = this.getAbilitySlotKey(el.abilitySlot);
        const _hasUpload = this._customAbilityIcons[`${_folHit}:${_slkHit}`] && this._customAbilityIcons[`${_folHit}:${_slkHit}`] !== false;
        if (_hasUpload) {
          const _halfUp = this.getAbilityIconSize(_folHit, _slkHit) / 2;
          const dx = x - el.x, dy = y - el.y;
          if (dx * dx + dy * dy <= _halfUp * _halfUp) return el;
          continue;
        }
        // Dedicated-render rect (originAtBottom + showRange): only bolinha/losango move/rotate
        // Skip large rect hitbox — use small icon hitbox at origin so only bolinha area drags
        if (shape && shape.shape === 'rect' && shape.originAtBottom && shape.showRange && shape.gameWidth && shape.gameHeight) {
          const agent = el.agentUuid ? this.getAgentByUuid(el.agentUuid) : null;
          const folder = agent ? this._normalizeAgentFolder(agent.displayName) : '';
          const slotKey = this.getAbilitySlotKey(el.abilitySlot);
          const half = this.getAbilityIconSize(folder, slotKey) / 2;
          const dx = x - el.x, dy = y - el.y;
          if (dx * dx + dy * dy <= half * half) return el;
          continue;
        }
        // Dedicated-render cone: use fan sector hitbox
        if (shape && shape.shape === 'cone' && shape.dedicatedRender && shape.gameLength && shape.gameAngle) {
          const coneLen = shape.gameLength * 100 * this.getCurrentMapScale() * this._mapSize;
          const dx = x - el.x, dy = y - el.y;
          const distSq = dx * dx + dy * dy;
          if (distSq <= coneLen * coneLen) {
            const rot = this._getEffectiveRotation(el) * Math.PI / 180;
            const cosR = Math.cos(-rot), sinR = Math.sin(-rot);
            const lx = dx * cosR - dy * sinR;
            const ly = dx * sinR + dy * cosR;
            const halfAngle = (shape.gameAngle / 2) * Math.PI / 180;
            // local forward is -Y axis (cone points up in local space)
            const angle = Math.atan2(Math.abs(lx), -ly);
            if (ly <= 0 && angle <= halfAngle) return el;
          }
          continue;
        }
        const agent = el.agentUuid ? this.getAgentByUuid(el.agentUuid) : null;
        const folder = agent ? this._normalizeAgentFolder(agent.displayName) : '';
        const slotKey = this.getAbilitySlotKey(el.abilitySlot);
        const half = this.getAbilityIconSize(folder, slotKey) / 2;
        const dx = x - el.x, dy = y - el.y;
        if (dx * dx + dy * dy <= half * half) return el;
        continue;
      }

      const bounds = this.getElementBounds(el);
      if (x >= el.x - bounds.width/2 && x <= el.x + bounds.width/2 &&
          y >= el.y - bounds.height/2 && y <= el.y + bounds.height/2) {
        return el;
      }
    }
    return null;
  }

  _distToSegment(px, py, ax, ay, bx, by) {
    const dx = bx - ax, dy = by - ay;
    const lenSq = dx*dx + dy*dy;
    let t = lenSq > 0 ? ((px-ax)*dx + (py-ay)*dy) / lenSq : 0;
    t = Math.max(0, Math.min(1, t));
    const nx = ax + t*dx, ny = ay + t*dy;
    return Math.sqrt((px-nx)**2 + (py-ny)**2);
  }

  generateId() {
    return 'el_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  // =====================================================
  // VIEW (Discrete zoom levels)
  // =====================================================

  resetView() {
    this.zoomLevel = 1;
    // Center the zoom so map stays fully visible
    const cw = this._cssPxW || (this.canvas ? this.canvas.width : 0);
    const ch = this._cssPxH || (this.canvas ? this.canvas.height : 0);
    this.panX = cw / 2 * (1 - this.zoomLevel);
    this.panY = ch / 2 * (1 - this.zoomLevel);
    this.render();
    this.showZoomIndicator();
  }

  _clampPan() {
    if (!this.canvas) return;
    const cw = this._cssPxW || this.canvas.width;
    const ch = this._cssPxH || this.canvas.height;
    // Center pan for the default 100% zoom
    const centerX = cw / 2 * (1 - this.zoomLevel);
    const centerY = ch / 2 * (1 - this.zoomLevel);
    // Allow movement proportional to how much extra zoom beyond 100%
    const extra = Math.max(0, this.zoomLevel - 1);
    const maxDrift = Math.min(cw, ch) * extra * 0.5;
    this.panX = Math.max(centerX - maxDrift, Math.min(centerX + maxDrift, this.panX));
    this.panY = Math.max(centerY - maxDrift, Math.min(centerY + maxDrift, this.panY));
  }

  

  // =====================================================
  // HISTORY (Undo/Redo)
  // =====================================================

  saveState() {
    // Deep clone elements but exclude image objects (can't be serialized)
    const elementsToSave = this.elements.map(el => {
      const clone = { ...el };
      delete clone.image;
      delete clone._abilityImg;
      delete clone._customAbilityIcon;
      delete clone.iconImage;
      delete clone._fallbackImg;
      delete clone._abilityImgFailed;
      delete clone._iconImgFailed;
      delete clone._fallbackImgFailed;
      delete clone._customIconFailed;
      // image elements: strip DOM Image object so JSON.parse restores them cleanly
      delete clone._img;
      delete clone._imgLoaded;
      delete clone._imgFailed;
      return clone;
    });

    // Serialize agentPaths
    const pathsToSave = {};
    this.agentPaths.forEach((path, agentId) => {
      pathsToSave[agentId] = path;
    });

    // Serialize pathAbilityWaypoints (exclude image objects)
    const waypointsToSave = {};
    this.pathAbilityWaypoints.forEach((wps, agentId) => {
      waypointsToSave[agentId] = wps.map(wp => ({
        x: wp.x, y: wp.y,
        pathX: wp.pathX != null ? wp.pathX : wp.x,
        pathY: wp.pathY != null ? wp.pathY : wp.y,
        distanceAlongPath: wp.distanceAlongPath,
        timeMs: wp.timeMs,
        ability: {
          name: wp.ability.name,
          slot: wp.ability.slot,
          icon: wp.ability.icon,
          duration: wp.ability.duration,
          abilityType: wp.ability.abilityType
        },
        triggered: wp.triggered
      }));
    });

    // Serialize teams (exclude non-serializable fields)
    const teamsToSave = {
      ally: this.teams.ally.map(a => a ? { uuid: a.uuid, displayName: a.displayName } : null),
      enemy: this.teams.enemy.map(a => a ? { uuid: a.uuid, displayName: a.displayName } : null)
    };

    // Serialize abilityMarkers (exclude image objects)
    const markersToSave = {};
    this.abilityMarkers.forEach((markers, agentId) => {
      markersToSave[agentId] = markers.map(m => ({
        time: m.time,
        ability: {
          name: m.ability.name,
          slot: m.ability.slot,
          icon: m.ability.icon,
          duration: m.ability.duration,
          abilityType: m.ability.abilityType
        },
        mapPosition: m.mapPosition || null
      }));
    });

    const state = JSON.stringify({
      elements: elementsToSave,
      agentPaths: pathsToSave,
      pathAbilityWaypoints: waypointsToSave,
      teams: teamsToSave,
      abilityMarkers: markersToSave
    });
    this.undoStack.push(state);
    this.redoStack = [];
    
    // Keep sequence snapshot in sync
    this.sequences.set(this.currentSequence, this._captureCurrentSnapshot());
    
    // Limit history
    if (this.undoStack.length > 50) {
      this.undoStack.shift();
    }

    // Auto-sync to backend session
    this._scheduleSyncSession?.();
  }

  _restoreUndoRedoState(stateStr) {
    const parsed = JSON.parse(stateStr);
    // Support both old format (array) and new format (object)
    if (Array.isArray(parsed)) {
      this.elements = parsed;
    } else {
      this.elements = parsed.elements || [];
      // Restore agentPaths
      this.agentPaths = new Map();
      if (parsed.agentPaths) {
        Object.entries(parsed.agentPaths).forEach(([id, path]) => {
          this.agentPaths.set(id, path);
        });
      }
      // Restore pathAbilityWaypoints (reload images)
      this.pathAbilityWaypoints = new Map();
      if (parsed.pathAbilityWaypoints) {
        Object.entries(parsed.pathAbilityWaypoints).forEach(([id, wps]) => {
          this.pathAbilityWaypoints.set(id, wps.map(wp => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => this.render();
            if (wp.ability.icon) img.src = wp.ability.icon;
            return { ...wp, ability: { ...wp.ability, image: img } };
          }));
        });
      }
      // Restore teams
      if (parsed.teams) {
        this.teams = {
          ally: (parsed.teams.ally || this.createBaseTeamState().ally).map(t => {
            if (!t) return null;
            return this.agents.find(a => a.uuid === t.uuid) || null;
          }),
          enemy: (parsed.teams.enemy || this.createBaseTeamState().enemy).map(t => {
            if (!t) return null;
            return this.agents.find(a => a.uuid === t.uuid) || null;
          })
        };
      }
      // Restore abilityMarkers (reload images)
      this.abilityMarkers = new Map();
      if (parsed.abilityMarkers) {
        Object.entries(parsed.abilityMarkers).forEach(([agentId, markers]) => {
          this.abilityMarkers.set(agentId, markers.map(m => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => this.render();
            if (m.ability.icon) img.src = m.ability.icon;
            return { ...m, ability: { ...m.ability, image: img } };
          }));
        });
      }
    }
    this.selectedElement = null;
    this.selectedElements = [];
    this.reloadElementImages();
    this.updateElementsList();
    this.renderAgentsBar();
    this.renderAbilityTracks();
    this.render();
  }

  undo() {
    if (this.undoStack.length > 1) {
      this.redoStack.push(this.undoStack.pop());
      const previousState = this.undoStack[this.undoStack.length - 1];
      this._restoreUndoRedoState(previousState);
    }
  }

  redo() {
    if (this.redoStack.length > 0) {
      const nextState = this.redoStack.pop();
      this.undoStack.push(nextState);
      this._restoreUndoRedoState(nextState);
    }
  }
  
  reloadElementImages() {
    // Reload images for agent elements
    this.elements.forEach(el => {
      if (el.type === 'agent' && el.agentUuid) {
        const agent = this.agents.find(a => a.uuid === el.agentUuid);
        if (agent) {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = () => {
            el.image = img;
            this.render();
          };
          img.src = this.getAgentDisplayIcon(agent);
        }
      }
      // Reload images for image elements (after undo/restore)
      if (el.type === 'image' && el.src && !el._img) {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        el._img = img;
        el._imgLoaded = false;
        el._imgFailed = false;
        img.onload = () => { el._imgLoaded = true; this.render(); };
        img.onerror = () => { el._imgFailed = true; this.render(); };
        img.src = el.src;
      }
    });
  }

  // =====================================================
  // ELEMENT MANAGEMENT
  // =====================================================

  deleteElement(element) {
    const index = this.elements.indexOf(element);
    if (index > -1) {
      this.elements.splice(index, 1);
      this.selectedElement = null;
      this.selectedElements = [];
      this.hideProperties();
      this.updateElementsList();
      this.saveState();
      this.render();
    }
  }

  // Remove agente do mapa e retorna para o slot do time
  removeAgentFromMap(agent) {
    if (!agent || agent.type !== 'agent') return;
    
    // Remove a trajetória do agente se existir
    if (this.agentPaths.has(agent.id)) {
      this.agentPaths.delete(agent.id);
    }
    
    // Remove waypoints de habilidade na trajetória
    if (this.pathAbilityWaypoints.has(agent.id)) {
      this.pathAbilityWaypoints.delete(agent.id);
    }
    
    // Remove marcadores de habilidade do agente
    if (this.abilityMarkers.has(agent.id)) {
      this.abilityMarkers.delete(agent.id);
    }
    
    // Remove from team slot
    if (agent.team && agent.teamSlot !== undefined) {
      this.teams[agent.team][agent.teamSlot] = null;
    }
    
    // Remove dos elementos
    const index = this.elements.indexOf(agent);
    if (index > -1) {
      this.elements.splice(index, 1);
    }
    
    // Limpa seleção
    this.selectedElement = null;
    this.selectedElements = [];
    
    // Atualiza interface
    this.updateElementsList();
    this.renderAbilityTracks();
    this.renderAgentsBar();
    this.saveState();
    this.render();
    
    console.log('🗑️ Agente removido do mapa:', agent.agentName);
  }

  // =====================================================
  // SEQUENCE SYSTEM - Gerenciamento de Sequências
  // =====================================================

  _createEmptySnapshot() {
    return {
      elements: [],
      teams: this.createBaseTeamState(),
      agentPaths: [],
      abilityMarkers: [],
      pathAbilityWaypoints: [],
      keyframes: []
    };
  }

  _captureCurrentSnapshot() {
    // Deep clone elements without image refs
    const elements = this.elements.map(el => {
      const clone = { ...el };
      delete clone.image;
      return clone;
    });
    
    // Deep clone teams
    const teams = {
      ally: this.teams.ally.map(a => a ? { ...a } : null),
      enemy: this.teams.enemy.map(a => a ? { ...a } : null)
    };
    // Remove image refs from team slots
    teams.ally.forEach(a => { if (a) delete a.image; });
    teams.enemy.forEach(a => { if (a) delete a.image; });

    // Convert Maps to arrays for serialization
    const agentPaths = [];
    this.agentPaths.forEach((val, key) => agentPaths.push([key, JSON.parse(JSON.stringify(val))]));
    
    const abilityMarkers = [];
    this.abilityMarkers.forEach((markers, key) => {
      const cleaned = markers.map(m => ({
        time: m.time,
        ability: {
          name: m.ability.name,
          slot: m.ability.slot,
          icon: m.ability.icon,
          duration: m.ability.duration
        },
        mapPosition: m.mapPosition ? { ...m.mapPosition } : null,
        triggered: m.triggered,
        activatedAt: m.activatedAt
      }));
      abilityMarkers.push([key, cleaned]);
    });
    
    const pathAbilityWaypoints = [];
    this.pathAbilityWaypoints.forEach((wps, key) => {
      const cleaned = wps.map(wp => ({
        x: wp.x, y: wp.y,
        pathX: wp.pathX != null ? wp.pathX : wp.x,
        pathY: wp.pathY != null ? wp.pathY : wp.y,
        distanceAlongPath: wp.distanceAlongPath,
        timeMs: wp.timeMs,
        ability: {
          name: wp.ability.name,
          slot: wp.ability.slot,
          icon: wp.ability.icon,
          duration: wp.ability.duration,
          abilityType: wp.ability.abilityType
        },
        triggered: wp.triggered
      }));
      pathAbilityWaypoints.push([key, cleaned]);
    });

    return {
      elements,
      teams,
      agentPaths,
      abilityMarkers,
      pathAbilityWaypoints,
      keyframes: JSON.parse(JSON.stringify(this.timeline.keyframes))
    };
  }

  _restoreSnapshot(snapshot) {
    if (!snapshot) return;

    // Restore elements
    this.elements = (snapshot.elements || []).map(el => ({ ...el }));
    
    // Restore teams
    this.teams = {
      ally: (snapshot.teams?.ally || this.createBaseTeamState().ally).map(a => a ? { ...a } : null),
      enemy: (snapshot.teams?.enemy || this.createBaseTeamState().enemy).map(a => a ? { ...a } : null)
    };

    // Restore Maps
    this.agentPaths = new Map(snapshot.agentPaths || []);
    
    // Restore abilityMarkers and reload images
    this.abilityMarkers = new Map();
    (snapshot.abilityMarkers || []).forEach(([agentId, markers]) => {
      this.abilityMarkers.set(agentId, markers.map(m => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => { this.renderAbilityTracks(); this.render(); };
        if (m.ability.icon) img.src = m.ability.icon;
        return { ...m, ability: { ...m.ability, image: img } };
      }));
    });
    
    // Restore pathAbilityWaypoints and reload images
    this.pathAbilityWaypoints = new Map();
    (snapshot.pathAbilityWaypoints || []).forEach(([agentId, wps]) => {
      this.pathAbilityWaypoints.set(agentId, wps.map(wp => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => this.render();
        if (wp.ability.icon) img.src = wp.ability.icon;
        return { ...wp, ability: { ...wp.ability, image: img } };
      }));
    });
    
    this.timeline.keyframes = snapshot.keyframes || [];

    // Clear selection
    this.selectedElement = null;
    this.selectedElements = [];

    // Reload images for agents
    this.reloadElementImages();

    // Refresh UI
    this.hideProperties();
    this.updateElementsList();
    this.renderAgentsBar();
    this.renderAbilityTracks();
    this.renderKeyframes();
    this.render();
  }

  switchSequence(seqNum) {
    if (seqNum === this.currentSequence) return;
    if (seqNum < 1 || seqNum > this.maxSequences) return;

    if (seqNum > this.totalSequences) {
      this.expandSequencesTo(seqNum);
    }

    // Save current sequence state
    this.sequences.set(this.currentSequence, this._captureCurrentSnapshot());

    // Switch
    this.currentSequence = seqNum;

    // Restore target sequence
    const snapshot = this.sequences.get(seqNum);
    if (snapshot) {
      this._restoreSnapshot(snapshot);
    } else {
      this._restoreSnapshot(this._createEmptySnapshot());
    }

    // Update UI
    this._updateSequenceUI();
  }

  expandSequencesTo(targetSeq) {
    const nextTarget = Math.min(this.maxSequences, Math.max(1, targetSeq));
    while (this.totalSequences < nextTarget) {
      this.totalSequences += 1;
      if (!this.sequences.has(this.totalSequences)) {
        this.sequences.set(this.totalSequences, this._createEmptySnapshot());
      }
    }
  }

  addSequence() {
    if (this.totalSequences >= this.maxSequences) return;
    this.totalSequences++;
    const newSeq = this.totalSequences;
    
    // Save current before switching
    this.sequences.set(this.currentSequence, this._captureCurrentSnapshot());
    
    // Create new empty sequence
    this.sequences.set(newSeq, this._createEmptySnapshot());
    
    // Switch to new sequence
    this.currentSequence = newSeq;
    this._restoreSnapshot(this._createEmptySnapshot());
    this._updateSequenceUI();
  }

  removeLastSequence() {
    if (this.totalSequences <= 1) return;

    // If currently on the last sequence, switch to previous first
    if (this.currentSequence === this.totalSequences) {
      this.sequences.set(this.currentSequence, this._captureCurrentSnapshot());
      this.currentSequence = this.totalSequences - 1;
      const snapshot = this.sequences.get(this.currentSequence);
      if (snapshot) this._restoreSnapshot(snapshot);
    }

    // Remove last sequence
    this.sequences.delete(this.totalSequences);
    this.totalSequences--;

    this._updateSequenceUI();
  }

  _updateSequenceUI() {
    // Update active button
    document.querySelectorAll('.vp2-seq-btn').forEach(btn => {
      const seqNum = parseInt(btn.dataset.seq);
      btn.classList.toggle('active', seqNum === this.currentSequence);
      btn.classList.toggle('vp2-seq-available', seqNum <= this.totalSequences);
    });

    // Update info
    const currentEl = document.getElementById('vp2-seq-current');
    const totalEl = document.getElementById('vp2-seq-total');
    if (currentEl) currentEl.textContent = this.currentSequence;
    if (totalEl) totalEl.textContent = this.totalSequences;

  }

  

  clearAll() {
    if (confirm('Deseja limpar todos os elementos?')) {
      this.elements = [];
      this.selectedElement = null;
      this.selectedElements = [];
      this.timeline.keyframes = [];
      this.teams = this.createBaseTeamState();
      this.agentPaths.clear();
      this.pathAbilityWaypoints.clear();
      this.abilityMarkers.clear();
      // Also update current sequence snapshot
      this.sequences.set(this.currentSequence, this._createEmptySnapshot());
      this.hideProperties();
      this.updateElementsList();
      this.renderAgentsBar();
      this.renderAbilityTracks();
      this.saveState();
      this.render();
      this.renderKeyframes();
    }
  }

  updateElementsList() {
    const list = document.getElementById('vp2-elements-list');
    if (!list) return;
    
    if (this.elements.length === 0) {
      list.innerHTML = '<div class="vp2-elements-empty">Arraste jogadores, agentes ou habilidades para o mapa</div>';
      return;
    }
    
    list.innerHTML = this.elements.map(el => {
      let icon = '';
      let name = '';
      let color = '#888';
      
      switch (el.type) {
        case 'player':
          icon = el.number;
          name = `Jogador ${el.number} (${el.team === 'ally' ? 'Aliado' : 'Inimigo'})`;
          color = el.team === 'ally' ? '#22d3ee' : '#ef4444';
          break;
        case 'agent':
          icon = '<i class="fas fa-user"></i>';
          name = el.agentName || 'Agente';
          break;
        case 'ability':
          icon = '<i class="fas fa-bolt"></i>';
          name = el.abilityName || 'Habilidade';
          break;
        case 'pen':
          icon = '<i class="fas fa-pen"></i>';
          name = 'Desenho';
          break;
        case 'line':
          icon = '—';
          name = 'Linha';
          break;
        case 'arrow':
          icon = '→';
          name = 'Seta';
          break;
        case 'circle':
          icon = '○';
          name = 'Círculo';
          break;
        case 'text':
          icon = 'T';
          name = el.text || 'Texto';
          break;
        default:
          icon = '?';
          name = 'Elemento';
      }
      
      const isSelected = this.selectedElement === el || this.selectedElements.includes(el);
      
      return `
        <div class="vp2-element-item ${isSelected ? 'selected' : ''}" data-id="${el.id}">
          <div class="vp2-element-icon" style="background: ${color}; color: white;">${icon}</div>
          <span class="vp2-element-name">${name}</span>
          <button class="vp2-element-delete" data-id="${el.id}">
            <i class="fas fa-times"></i>
          </button>
        </div>
      `;
    }).join('');
    
    // Add click handlers
    list.querySelectorAll('.vp2-element-item').forEach(item => {
      item.addEventListener('click', (e) => {
        if (e.target.closest('.vp2-element-delete')) {
          const el = this.elements.find(el => el.id === item.dataset.id);
          if (el) this.deleteElement(el);
        } else {
          const el = this.elements.find(el => el.id === item.dataset.id);
          if (el) {
            this.selectedElement = el;
            this.selectedElements = [el];
            this.showProperties(el);
            this.updateElementsList();
            this.render();
          }
        }
      });
    });
  }

  

  hideProperties() {
    // Properties panel removed
  }

  // =====================================================
  // TIMELINE & ANIMATION
  // =====================================================

  getElementPosition(element) {
    // Primeiro, verifica se tem trajetória (PATH SYSTEM)
    if (this.isPlaying && element.type === 'agent' && this.agentPaths.has(element.id)) {
      const path = this.agentPaths.get(element.id);
      if (path && path.length > 1) {
        return this.interpolatePathPosition(path, this.timeline.currentTime);
      }
    }
    
    // Fallback para keyframes ou posição estática
    if (!this.isPlaying || this.timeline.keyframes.length === 0) {
      return { x: element.x, y: element.y };
    }
    
    // Find keyframes for this element
    const elementKeyframes = this.timeline.keyframes
      .filter(kf => kf.elementId === element.id)
      .sort((a, b) => a.time - b.time);
    
    if (elementKeyframes.length === 0) {
      return { x: element.x, y: element.y };
    }
    
    const currentTime = this.timeline.currentTime;
    
    // Find surrounding keyframes
    let prevKf = null;
    let nextKf = null;
    
    for (const kf of elementKeyframes) {
      if (kf.time <= currentTime) {
        prevKf = kf;
      } else if (!nextKf && kf.time > currentTime) {
        nextKf = kf;
        break;
      }
    }
    
    if (!prevKf) {
      return { x: element.x, y: element.y };
    }
    
    if (!nextKf) {
      return { x: prevKf.x, y: prevKf.y };
    }
    
    // Interpolate between keyframes
    const t = (currentTime - prevKf.time) / (nextKf.time - prevKf.time);
    
    return {
      x: prevKf.x + (nextKf.x - prevKf.x) * t,
      y: prevKf.y + (nextKf.y - prevKf.y) * t
    };
  }

  // Interpola posição ao longo da trajetória baseado no tempo
  // Usa velocidade real do Vandal: 5.4 m/s = 43.2 px/s
  interpolatePathPosition(path, currentTime) {
    if (!path || path.length === 0) return { x: 0, y: 0 };
    if (path.length === 1) return { x: path[0].x, y: path[0].y };
    
    // Calcula distância total do path
    let totalDistance = 0;
    const distances = [0]; // Distância acumulada em cada ponto
    
    for (let i = 1; i < path.length; i++) {
      const dx = path[i].x - path[i-1].x;
      const dy = path[i].y - path[i-1].y;
      totalDistance += Math.sqrt(dx * dx + dy * dy);
      distances.push(totalDistance);
    }
    
    if (totalDistance === 0) return { x: path[0].x, y: path[0].y };
    
    // Velocidade Vandal: 5.4 m/s = 43.2 px/s
    // Duração = distância / velocidade (em ms)
    const pathDuration = (totalDistance / this.VANDAL_SPEED_PX_PER_SEC) * 1000;
    
    // Progress baseado no tempo atual
    const progress = Math.min(currentTime / pathDuration, 1);
    const targetDistance = progress * totalDistance;
    
    // Encontra em qual segmento estamos
    let segmentIndex = 0;
    for (let i = 1; i < distances.length; i++) {
      if (distances[i] >= targetDistance) {
        segmentIndex = i - 1;
        break;
      }
      segmentIndex = i - 1;
    }
    
    // Se chegou ao final
    if (segmentIndex >= path.length - 1 || progress >= 1) {
      return { x: path[path.length - 1].x, y: path[path.length - 1].y };
    }
    
    // Interpolação dentro do segmento
    const segmentStart = distances[segmentIndex];
    const segmentEnd = distances[segmentIndex + 1];
    const segmentLength = segmentEnd - segmentStart;
    
    if (segmentLength === 0) {
      return { x: path[segmentIndex].x, y: path[segmentIndex].y };
    }
    
    const t = (targetDistance - segmentStart) / segmentLength;
    
    return {
      x: path[segmentIndex].x + (path[segmentIndex + 1].x - path[segmentIndex].x) * t,
      y: path[segmentIndex].y + (path[segmentIndex + 1].y - path[segmentIndex].y) * t
    };
  }
  
  // Calcula a duração total baseada na trajetória mais longa
  calculatePathsDuration() {
    let maxDuration = 0;
    
    this.agentPaths.forEach((path, agentId) => {
      if (path.length < 2) return;
      
      // Calcula distância total
      let totalDistance = 0;
      for (let i = 1; i < path.length; i++) {
        const dx = path[i].x - path[i-1].x;
        const dy = path[i].y - path[i-1].y;
        totalDistance += Math.sqrt(dx * dx + dy * dy);
      }
      
      // Duração = distância / velocidade
      const duration = (totalDistance / this.VANDAL_SPEED_PX_PER_SEC) * 1000;
      if (duration > maxDuration) {
        maxDuration = duration;
      }
    });
    
    return maxDuration > 0 ? maxDuration : this.timeline.duration;
  }

  

  startPlayback() {
    // Calcula duração baseada nas trajetórias
    const pathsDuration = this.calculatePathsDuration();
    if (pathsDuration > 0) {
      this.timeline.duration = pathsDuration;
    }

    // Oculta trajetórias durante a reprodução
    this.showPaths = false;
    const toggleIcon = document.querySelector('#vp2-toggle-paths i');
    if (toggleIcon) toggleIcon.className = 'fas fa-eye-slash';

    // Reinicia do início
    this.timeline.currentTime = 0;

    this.isPlaying = true;
    
    const playIcon = document.getElementById('vp2-play-icon');
    if (playIcon) {
      playIcon.className = 'fas fa-pause';
    }
    
    this.lastFrameTime = performance.now();
    this.animationFrame = requestAnimationFrame((t) => this.animationLoop(t));
  }

  pausePlayback() {
    this.isPlaying = false;

    // Restaura visibilidade das trajetórias
    this.showPaths = true;
    const toggleIcon = document.querySelector('#vp2-toggle-paths i');
    if (toggleIcon) toggleIcon.className = 'fas fa-eye';
    
    const playIcon = document.getElementById('vp2-play-icon');
    if (playIcon) {
      playIcon.className = 'fas fa-play';
    }
    
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
  }

  stopPlayback() {
    this.pausePlayback();
    this.timeline.currentTime = 0;
    this.resetAbilityMarkers(); // Reseta triggers
    this.updateTimeDisplay();
    this.updatePlayhead();
    this.render();
  }

  animationLoop(timestamp) {
    if (!this.isPlaying) return;
    
    const deltaTime = timestamp - this.lastFrameTime;
    this.lastFrameTime = timestamp;
    
    // Advance time
    this.timeline.currentTime += deltaTime * this.playbackSpeed;
    
    // Verifica marcadores de habilidade
    this.checkAbilityMarkers();
    
    // Para quando terminar (sem loop)
    if (this.timeline.currentTime >= this.timeline.duration) {
      this.timeline.currentTime = this.timeline.duration;
      this.updateTimeDisplay();
      this.updatePlayhead();
      this.render();
      this.pausePlayback(); // Para automaticamente
      this.resetAbilityMarkers(); // Reseta triggers para próximo play
      return;
    }
    
    this.updateTimeDisplay();
    this.updatePlayhead();
    this.render();
    
    this.animationFrame = requestAnimationFrame((t) => this.animationLoop(t));
  }
  
  // Verifica marcadores de habilidade baseados no tempo
  checkAbilityMarkers() {
    const currentTime = this.timeline.currentTime;
    
    // Timeline markers (existing system)
    this.abilityMarkers.forEach((markers, agentId) => {
      if (!markers || markers.length === 0) return;
      
      const agent = this.elements.find(el => el.id === agentId);
      if (!agent) return;
      
      markers.forEach(marker => {
        if (!marker.triggered && currentTime >= marker.time) {
          marker.triggered = true;
          this.useAbilityOnAgent(agentId, {
            name: marker.ability.name,
            icon: marker.ability.icon
          });
          console.log(`🎯 Habilidade ativada: ${marker.ability.name} em ${Math.round(marker.time/1000)}s`);
        }
      });
    });

    // Path ability waypoints — trigger when agent reaches the point
    this.pathAbilityWaypoints.forEach((waypoints, agentId) => {
      if (!waypoints || waypoints.length === 0) return;

      const agent = this.elements.find(el => el.id === agentId);
      if (!agent) return;

      waypoints.forEach(wp => {
        if (!wp.triggered && currentTime >= wp.timeMs) {
          wp.triggered = true;
          this.useAbilityOnAgent(agentId, {
            name: wp.ability.name,
            icon: wp.ability.icon
          });
          console.log(`🛤️ Habilidade na trajetória ativada: ${wp.ability.name} em ${(wp.timeMs/1000).toFixed(1)}s`);
        }
      });
    });
  }
  
  // Reseta os triggers dos marcadores para o próximo playback
  resetAbilityMarkers() {
    this.abilityMarkers.forEach(markers => {
      markers.forEach(marker => {
        marker.triggered = false;
      });
    });
    // Also reset path ability waypoints
    this.pathAbilityWaypoints.forEach(waypoints => {
      waypoints.forEach(wp => {
        wp.triggered = false;
      });
    });
  }

  seekTo(time) {
    this.timeline.currentTime = Math.max(0, Math.min(time, this.timeline.duration));
    
    // Se voltou para o início, reseta marcadores de habilidade
    if (time === 0) {
      this.resetAbilityMarkers();
    }
    
    this.updateTimeDisplay();
    this.updatePlayhead();
    this.render();
  }

  updateTimeDisplay() {
    const display = document.getElementById('vp2-time-display');
    if (!display) return;
    
    const remaining = this.formatTime(this.timeline.currentTime);
    display.textContent = remaining;
  }

  updatePlayhead() {
    const playhead = document.getElementById('vp2-playhead');
    if (!playhead) return;
    
    const progress = (this.timeline.currentTime / this.timeline.duration) * 100;
    playhead.style.left = progress + '%';
  }

  formatTime(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${minutes}:${String(secs).padStart(2, '0')}`;
  }

  // Recording mode
  isRecording = false;

  

  addKeyframe() {
    if (!this.selectedElement) {
      alert('Selecione um elemento primeiro');
      return;
    }
    
    this.addKeyframeForElement(this.selectedElement);
  }

  addKeyframeForElement(element) {
    const keyframe = {
      id: this.generateId(),
      elementId: element.id,
      time: this.timeline.currentTime,
      x: element.x,
      y: element.y,
      rotation: element.rotation || 0
    };
    
    // Remove existing keyframe at same time for same element
    this.timeline.keyframes = this.timeline.keyframes.filter(
      kf => !(kf.elementId === element.id && Math.abs(kf.time - keyframe.time) < 100)
    );
    
    this.timeline.keyframes.push(keyframe);
    this.renderKeyframes();
  }

  clearKeyframes() {
    if (confirm('Limpar todos os keyframes?')) {
      this.timeline.keyframes = [];
      this.renderKeyframes();
    }
  }

  

  // =====================================================
  // PATH SYSTEM - Sistema de Trajetórias
  // =====================================================

  // Ativa/desativa modo de desenho de trajetória
  
  
  // Mostra instrução quando modo trajetória está ativo (desativado - removido)
  

  // Mostra/oculta trajetórias
  

  // Busca agente em uma posição (para seleção)
  getAgentAtPosition(x, y) {
    const agents = this.elements.filter(el => el.type === 'agent');
    const radius = 20; // Raio de detecção
    
    for (let i = agents.length - 1; i >= 0; i--) {
      const agent = agents[i];
      const dx = x - agent.x;
      const dy = y - agent.y;
      const distance = Math.sqrt(dx * dx + dy * dy);
      
      if (distance <= radius) {
        return agent;
      }
    }
    return null;
  }

  // Adiciona ponto à trajetória durante arrasto - 100% manual
  addPathPointFromDrag(agentId, x, y, skipRender) {
    let path = this.agentPaths.get(agentId);
    if (!path || path.length === 0) return;
    
    // Adiciona TODOS os pontos exatamente como desenhado (sem filtro de distância)
    path.push({
      x: x,
      y: y
    });
    
    if (!skipRender) this.requestRender();
  }
  
  // Otimiza path removendo pontos redundantes (Douglas-Peucker simplificado)
  optimizePath(agentId) {
    const path = this.agentPaths.get(agentId);
    if (!path || path.length < 3) return;
    
    const tolerance = 3; // pixels - tolerância menor para manter mais detalhes
    const optimized = [path[0]];
    
    for (let i = 1; i < path.length - 1; i++) {
      const prev = optimized[optimized.length - 1];
      const curr = path[i];
      const next = path[i + 1];
      
      // Calcula distância perpendicular do ponto à linha prev-next
      const dx = next.x - prev.x;
      const dy = next.y - prev.y;
      const len = Math.sqrt(dx * dx + dy * dy);
      
      if (len > 0) {
        const dist = Math.abs((curr.y - prev.y) * dx - (curr.x - prev.x) * dy) / len;
        
        // Mantém ponto se distância significativa (curva)
        if (dist > tolerance) {
          optimized.push(curr);
        }
      }
    }
    
    // Sempre mantém último ponto
    optimized.push(path[path.length - 1]);
    
    this.agentPaths.set(agentId, optimized);
  }

  // =====================================================
  // PATH ABILITY WAYPOINTS - Habilidades na trajetória
  // =====================================================

  // Detecta se um clique está sobre uma linha de trajetória
  // Retorna { agentId, x, y, distanceAlongPath, timeMs } ou null
  getPathAtPosition(clickX, clickY) {
    const hitRadius = 10; // pixels de tolerância
    let bestHit = null;
    let bestDist = hitRadius;

    this.agentPaths.forEach((path, agentId) => {
      if (path.length < 2) return;

      let cumulativeDist = 0;

      for (let i = 0; i < path.length - 1; i++) {
        const ax = path[i].x, ay = path[i].y;
        const bx = path[i + 1].x, by = path[i + 1].y;

        // Distância do ponto ao segmento de reta
        const segLen = Math.sqrt((bx - ax) ** 2 + (by - ay) ** 2);
        if (segLen === 0) {
          cumulativeDist += segLen;
          continue;
        }

        // Parâmetro t na reta (0=A, 1=B)
        let t = ((clickX - ax) * (bx - ax) + (clickY - ay) * (by - ay)) / (segLen * segLen);
        t = Math.max(0, Math.min(1, t));

        // Ponto mais próximo no segmento
        const nearX = ax + t * (bx - ax);
        const nearY = ay + t * (by - ay);

        const dist = Math.sqrt((clickX - nearX) ** 2 + (clickY - nearY) ** 2);

        if (dist < bestDist) {
          bestDist = dist;
          const distAlongSeg = t * segLen;
          const totalDist = cumulativeDist + distAlongSeg;
          bestHit = {
            agentId,
            x: nearX,
            y: nearY,
            distanceAlongPath: totalDist,
            timeMs: (totalDist / this.VANDAL_SPEED_PX_PER_SEC) * 1000
          };
        }

        cumulativeDist += segLen;
      }
    });

    return bestHit;
  }

  // Mostra menu de habilidades ao clicar com botão direito na trajetória
  

  // Adiciona um waypoint de habilidade em um ponto da trajetória
  addPathAbilityWaypoint(agentId, hitInfo, abilityData) {
    if (!this.pathAbilityWaypoints.has(agentId)) {
      this.pathAbilityWaypoints.set(agentId, []);
    }

    const waypoints = this.pathAbilityWaypoints.get(agentId);

    // Carrega imagem
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => this.render();
    img.onerror = () => { console.warn('Failed to load ability icon:', abilityData.icon); this.render(); };
    if (abilityData.icon) img.src = abilityData.icon;

    waypoints.push({
      x: hitInfo.x,
      y: hitInfo.y,
      pathX: hitInfo.x, // posição original na trajetória (âncora)
      pathY: hitInfo.y,
      distanceAlongPath: hitInfo.distanceAlongPath,
      timeMs: hitInfo.timeMs,
      ability: {
        name: abilityData.name,
        slot: abilityData.slot,
        icon: abilityData.icon,
        duration: abilityData.duration,
        abilityType: abilityData.abilityType,
        image: img
      },
      triggered: false
    });

    // Ordena por distância
    waypoints.sort((a, b) => a.distanceAlongPath - b.distanceAlongPath);

    this.render();
    console.log(`🎯 Habilidade na trajetória: ${abilityData.name} em ${(hitInfo.timeMs / 1000).toFixed(1)}s (${abilityData.duration ? abilityData.duration + 's duração' : 'instantânea'})`);
  }

  // Remove um waypoint de habilidade da trajetória (botão direito no marcador)
  removePathAbilityWaypoint(agentId, waypointIndex) {
    const waypoints = this.pathAbilityWaypoints.get(agentId);
    if (waypoints && waypoints[waypointIndex] !== undefined) {
      waypoints.splice(waypointIndex, 1);
      this.render();
    }
  }

  // Detecta se um clique está sobre um marcador de habilidade no path
  // Retorna { agentId, waypointIndex } ou null
  getPathAbilityWaypointAtPosition(clickX, clickY) {
    const hitRadius = 22; // área generosa para facilitar o arraste
    let bestHit = null;
    let bestDist = hitRadius;

    this.pathAbilityWaypoints.forEach((waypoints, agentId) => {
      waypoints.forEach((wp, idx) => {
        const dist = Math.sqrt((clickX - wp.x) ** 2 + (clickY - wp.y) ** 2);
        if (dist < bestDist) {
          bestDist = dist;
          bestHit = { agentId, waypointIndex: idx };
        }
      });
    });

    return bestHit;
  }

  // Limpa trajetória do agente selecionado
  clearSelectedAgentPath() {
    // Accept left-click selected agent OR the last right-click path agent
    const target = (this.selectedElement?.type === 'agent' ? this.selectedElement : null)
                   || this.pathDrawingAgent;

    if (!target) return;

    if (this.agentPaths.has(target.id)) {
      this.agentPaths.delete(target.id);
      this.pathAbilityWaypoints.delete(target.id);
      this.saveState();
      this.render();
    }
  }

  // Limpa todas as trajetórias
  clearAllPaths() {
    this.agentPaths.clear();
    this.pathAbilityWaypoints.clear();
    this.pathDrawingAgent = null;
    this.saveState();
    this.render();
  }

  // Renderiza trajetórias no canvas (chamado pelo render principal)
  

  // Renderiza os marcadores de habilidade ancorados nas trajetórias
  

  // =====================================================
  // SAVE/LOAD
  // =====================================================

  serializeForPersistence() {
    const elements = this.elements.map(el => {
      const clone = { ...el };
      delete clone.image;
      delete clone._abilityImg;
      delete clone._customAbilityIcon;
      delete clone.iconImage;
      delete clone._fallbackImg;
      delete clone._abilityImgFailed;
      delete clone._iconImgFailed;
      delete clone._fallbackImgFailed;
      delete clone._customIconFailed;
      delete clone.customIconImage;
      delete clone._trimmedIcon;
      // Image element: strip runtime fields (keep src, width, height)
      if (el.type === 'image') {
        delete clone._img;
        delete clone._imgLoaded;
        delete clone._imgFailed;
      }
      return clone;
    });

    const agentPaths = Object.fromEntries(this.agentPaths.entries());
    const pathAbilityWaypoints = Object.fromEntries(
      Array.from(this.pathAbilityWaypoints.entries()).map(([id, waypoints]) => [id, waypoints.map(wp => ({
        x: wp.x,
        y: wp.y,
        pathX: wp.pathX != null ? wp.pathX : wp.x,
        pathY: wp.pathY != null ? wp.pathY : wp.y,
        distanceAlongPath: wp.distanceAlongPath,
        timeMs: wp.timeMs,
        ability: {
          name: wp.ability.name,
          slot: wp.ability.slot,
          icon: wp.ability.icon,
          duration: wp.ability.duration,
          abilityType: wp.ability.abilityType
        },
        triggered: wp.triggered
      }))])
    );

    const abilityMarkers = Object.fromEntries(
      Array.from(this.abilityMarkers.entries()).map(([id, markers]) => [id, markers.map(m => ({
        time: m.time,
        ability: {
          name: m.ability.name,
          slot: m.ability.slot,
          icon: m.ability.icon,
          duration: m.ability.duration,
          abilityType: m.ability.abilityType
        },
        mapPosition: m.mapPosition || null,
        triggered: m.triggered,
        activatedAt: m.activatedAt
      }))])
    );

    const teamComposition = {
      ally: this.teams.ally.map(a => a ? { uuid: a.uuid, displayName: a.displayName } : null),
      enemy: this.teams.enemy.map(a => a ? { uuid: a.uuid, displayName: a.displayName } : null)
    };

    const sequences = Array.from(this.sequences.entries()).map(([seq, snapshot]) => [seq, snapshot]);

    return {
      teamComposition,
      mapElements: elements,
      playerPaths: {
        agentPaths,
        pathAbilityWaypoints,
        sequences,
        currentSequence: this.currentSequence,
        totalSequences: this.totalSequences
      },
      abilitiesUsed: {
        abilityMarkers,
        keyframes: this.timeline.keyframes,
        duration: this.timeline.duration,
        currentTime: this.timeline.currentTime
      }
    };
  }

  async loadSavedTactic(tacticId) {
    try {
      const result = await api.getTactic(tacticId);
      if (!result?.success || !result.data?.tactic) {
        throw new Error('Tática não encontrada');
      }

      const tactic = result.data.tactic;
      this.currentTacticId = tactic.id;
      this.currentTacticTitle = tactic.title || '';
      const persistedMapId = tactic.map_id || this.currentMap;
      if (persistedMapId && persistedMapId !== this.currentMap) {
        await this.loadMap(persistedMapId);
      }

      this.currentSide = tactic.side || this.currentSide;
      this.syncPersistedStrategyUi();
      this.restoreFromPersistence({
        teamComposition: tactic.team_composition,
        mapElements: tactic.map_elements,
        playerPaths: tactic.player_paths,
        abilitiesUsed: tactic.abilities_used
      });
    } catch (error) {
      console.error('Erro ao carregar tática salva do ValoPlant:', error);
      toast.error('Erro', 'Não foi possível carregar a tática salva.');
    }
  }

  syncPersistedStrategyUi() {
    const map = this.maps.find(m => m.id === this.currentMap);
    const currentMapEl = document.getElementById('vp2-map-current');
    const dropdown = document.getElementById('vp2-map-dropdown');

    if (map && currentMapEl) {
      MapPicker.swap(currentMapEl, { image: map.splash, name: map.name });
    }

    if (dropdown) {
      dropdown.innerHTML = this.buildMapDropdownItemsHtml();
    }

    document.querySelectorAll('.lu-map-side-btn').forEach(btn => {
      const on = btn.dataset.side === this.currentSide;
      btn.classList.toggle('active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  restoreFromPersistence(payload = {}) {
    const teamComposition = payload.teamComposition || { ally: [], enemy: [] };
    const mapElements = Array.isArray(payload.mapElements) ? payload.mapElements : [];
    const playerPaths = payload.playerPaths || {};
    const abilitiesUsed = payload.abilitiesUsed || {};

    this.elements = mapElements.map(el => ({ ...el }));

    this.teams = {
      ally: (teamComposition.ally || this.createBaseTeamState().ally).map(t => t ? (this.agents.find(a => a.uuid === t.uuid) || null) : null),
      enemy: (teamComposition.enemy || this.createBaseTeamState().enemy).map(t => t ? (this.agents.find(a => a.uuid === t.uuid) || null) : null)
    };

    this.agentPaths = new Map(Object.entries(playerPaths.agentPaths || {}));

    this.pathAbilityWaypoints = new Map();
    Object.entries(playerPaths.pathAbilityWaypoints || {}).forEach(([agentId, waypoints]) => {
      this.pathAbilityWaypoints.set(agentId, (waypoints || []).map(wp => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => this.render();
        if (wp.ability?.icon) img.src = wp.ability.icon;
        return { ...wp, ability: { ...wp.ability, image: img } };
      }));
    });

    this.abilityMarkers = new Map();
    Object.entries(abilitiesUsed.abilityMarkers || {}).forEach(([agentId, markers]) => {
      this.abilityMarkers.set(agentId, (markers || []).map(m => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => { this.renderAbilityTracks(); this.render(); };
        if (m.ability?.icon) img.src = m.ability.icon;
        return { ...m, ability: { ...m.ability, image: img } };
      }));
    });

    this.timeline.keyframes = abilitiesUsed.keyframes || [];
    this.timeline.duration = abilitiesUsed.duration || this.timeline.duration;
    this.timeline.currentTime = abilitiesUsed.currentTime || 0;

    this.sequences = new Map(playerPaths.sequences || [[1, this._captureCurrentSnapshot()]]);
    this.currentSequence = playerPaths.currentSequence || 1;
    this.totalSequences = Math.min(this.maxSequences, playerPaths.totalSequences || Math.max(1, this.sequences.size));
    this.currentSequence = Math.min(this.currentSequence, this.totalSequences);
    for (const seqKey of [...this.sequences.keys()]) {
      if (seqKey > this.maxSequences) this.sequences.delete(seqKey);
    }
    this.expandSequencesTo(this.totalSequences);

    this.selectedElement = null;
    this.selectedElements = [];
    this.reloadElementImages();
    this.updateElementsList();
    this.renderAgentsBar();
    this.renderAbilityTracks();
    this.renderKeyframes();
    this._updateSequenceUI();
    this.render();
    this.saveState();
  }

  async saveStrategy() {
    const name = prompt('Nome da estratégia:', this.currentTacticTitle || '');
    if (!name) return;
    const team = app.getCurrentTeam();
    if (!team?.id) {
      toast.error('Erro', 'Selecione um time antes de salvar.');
      return;
    }

    const persisted = this.serializeForPersistence();
    
    try {
      const payload = {
        team_id: team.id,
        map_id: this.currentMap,
        title: name,
        description: 'Estratégia criada no ValoPlant',
        side: this.currentSide,
        tactic_type: 'valoplant',
        team_composition: persisted.teamComposition,
        map_elements: persisted.mapElements,
        player_paths: persisted.playerPaths,
        abilities_used: persisted.abilitiesUsed,
        duration_seconds: Math.round((this.timeline.duration || 0) / 1000),
        notes: 'Persistido pelo ValoPlant'
      };

      const result = this.currentTacticId
        ? await api.updateTactic(this.currentTacticId, payload)
        : await api.createTactic(payload);

      const tacticId = result?.data?.tactic?.id;
      this.currentTacticId = tacticId || this.currentTacticId;
      this.currentTacticTitle = name;
      toast.success('Sucesso', 'Estratégia salva com sucesso!');
      if (tacticId) {
        window.history.replaceState({ page: 'valoplant', params: { tacticId } }, '', `/valoplant?tacticId=${tacticId}`);
      }
    } catch (error) {
      console.error('Erro ao salvar:', error);
      toast.error('Erro', 'Erro ao salvar estratégia');
    }
  }

  exportAsImage() {
    // Desenho e agendado por rAF: sem o flush, a exportacao pega o frame anterior.
    this.flushRender();
    const dataUrl = this.canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.download = `valoplant_${this.currentMap}_${Date.now()}.png`;
    link.href = dataUrl;
    link.click();
  }

  // =====================================================
  // SAVE TACTIC TO FOLDER (SYNC WITH TACTICS PAGE)
  // =====================================================

  

  

  getStmAgentGradientStyle(agent) {
    if (!agent) return '';
    let resolved = null;
    if (agent.id) resolved = this.agents.find(a => a.uuid === agent.id);
    if (!resolved && agent.uuid) resolved = this.agents.find(a => a.uuid === agent.uuid);
    if (!resolved && agent.name) {
      const target = String(agent.name).toLowerCase();
      resolved = this.agents.find(a => String(a.displayName || '').toLowerCase() === target);
    }
    const gc = resolved?.backgroundGradientColors || agent.backgroundGradientColors || [];
    const g0 = gc[0] ? '#' + String(gc[0]).slice(0, 6) : '#1a1a2e';
    const g1 = gc[1] ? '#' + String(gc[1]).slice(0, 6) : '#0f1923';
    const g2 = gc[2] ? '#' + String(gc[2]).slice(0, 6) : '#1a1a2e';
    return `background: radial-gradient(circle at 30% 25%, ${g0} 0%, ${g1} 55%, ${g2} 100%);`;
  }

  

  _groupFoldersByComp(folders) {
    const groups = new Map();
    const noCompGroup = { key: 'no-comp', composition: [], folders: [], isNoComp: true };

    folders.forEach(f => {
      const comp = this._parseComposition(f.composition);
      if (!comp.length) {
        noCompGroup.folders.push(f);
        return;
      }
      const key = comp.map(c => c.id).sort().join('|');
      if (!groups.has(key)) {
        groups.set(key, { key, composition: comp, folders: [] });
      }
      groups.get(key).folders.push(f);
    });

    const result = Array.from(groups.values());
    if (noCompGroup.folders.length) result.push(noCompGroup);
    return result;
  }

  /**
   * Composicoes do mapa como lista visivel, no lugar do dropdown.
   * A arvore de /tactics mostra todas as comps de um mapa abertas; aqui vale
   * o mesmo — o usuario escolhe entre o que ja existe, e cria pelo botao da
   * secao quando nenhuma serve.
   */
  _renderStmCompDropdown(overlay) {
    const lista = overlay.querySelector('#vp2StmCompOptions');
    if (!lista) return;
    const groups = this._stmCompGroups;

    if (!groups.length) {
      lista.innerHTML = `<div class="vp2-stm-no-folders"><span>Nenhuma composição aqui ainda.<small>Use "+ Nova" para criar uma.</small></span></div>`;
      return;
    }

    lista.innerHTML = groups.map((g, i) => {
      const agents = g.isNoComp ? [] : g.composition;
      const chips = agents.length
        ? agents.map(a => {
            const icon = a.icon_url || a.displayIcon || `https://media.valorant-api.com/agents/${a.id}/displayicon.png`;
            const gs = this.getStmAgentGradientStyle(a);
            return `<span class="vp2-stm-agent-chip" style="${gs}" title="${this._stmEsc(a.name || '')}"><img src="${this._stmEsc(icon)}" alt="${this._stmEsc(a.name || '')}" loading="lazy"></span>`;
          }).join('')
        : '<span class="vp2-stm-comp-vazia">Sem composição</span>';
      const rotulo = g.isNoComp ? 'Sem composição' : (agents.map(a => a.name || a.displayName || '').join(', ') || 'Composição');
      const ativa = g.key === this._stmSelectedCompKey;
      return `
        <div class="vp2-stm-tree-row vp2-stm-comp-item${ativa ? ' selected' : ''}" role="option" aria-selected="${ativa}"
             data-comp-key="${this._stmEsc(g.key)}" title="${this._stmEsc(rotulo)}">
          <span class="vp2-stm-comp-slot">${i + 1}</span>
          <div class="vp2-stm-comp-item-agents">${chips}</div>
          <span class="vp2-stm-comp-item-count">${g.folders.length}</span>
        </div>`;
    }).join('');

    lista.querySelectorAll('.vp2-stm-comp-item').forEach(item => {
      item.addEventListener('click', () => {
        this._stmSelectedCompKey = item.dataset.compKey;
        this._stmSelectedFolderId = null;
        this._stmSyncSaveButton(overlay);
        this._renderStmCompDropdown(overlay);
        this._renderStmFilteredFolders(overlay);
      });
    });
  }

  _renderStmFilteredFolders(overlay) {
    const foldersList = overlay.querySelector('#vp2StmFoldersList');
    if (!foldersList) return;

    let folders = this._stmAllFolders;

    // Filter by selected composition
    if (this._stmSelectedCompKey) {
      if (this._stmSelectedCompKey === 'no-comp') {
        folders = folders.filter(f => {
          const comp = this._parseComposition(f.composition);
          return !comp.length;
        });
      } else {
        folders = folders.filter(f => {
          const comp = this._parseComposition(f.composition);
          if (!comp.length) return false;
          const key = comp.map(c => c.id).sort().join('|');
          return key === this._stmSelectedCompKey;
        });
      }
    }

    if (!folders.length) {
      foldersList.innerHTML = `
        <div class="vp2-stm-no-folders">
          <span>Nenhuma pasta aqui ainda.<small>Use "+ Nova" para criar uma.</small></span>
        </div>
      `;
      this._stmSelectedFolderId = null;
      overlay.querySelector('#vp2StmSave').disabled = true;
      return;
    }

    // Determine primary folder: keep current selection if still available, else first
    let primary = folders.find(f => f.id === this._stmSelectedFolderId);
    if (!primary) primary = folders[0];
    const others = folders.filter(f => f.id !== primary.id);

    this._stmSelectedFolderId = primary.id;
    this._stmSyncSaveButton(overlay);

    foldersList.innerHTML = `
      <div class="vp2-stm-folders-dropdown" id="vp2StmFoldersDropdown">
        <div class="vp2-stm-folder-primary">
          ${this._renderStmFolderItem(primary, true)}
          ${others.length ? `<div class="vp2-stm-folder-toggle" id="vp2StmFolderToggle" title="Ver outras pastas"><i class="fas fa-chevron-down"></i></div>` : ''}
        </div>
        ${others.length ? `<div class="vp2-stm-folder-others">${others.map(f => this._renderStmFolderItem(f, false)).join('')}</div>` : ''}
      </div>
    `;

    const dropdown = foldersList.querySelector('.vp2-stm-folders-dropdown');
    const toggle = foldersList.querySelector('#vp2StmFolderToggle');
    if (toggle) {
      toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const abriu = dropdown.classList.toggle('open');
        const painel = dropdown.querySelector('.vp2-stm-folder-others');
        if (abriu) this._stmAncorar(painel, dropdown.querySelector('.vp2-stm-folder-primary'));
        else this._stmDesancorar(painel);
      });
    }

    // Fecha o dropdown ao clicar em qualquer outro ponto do modal. A flag mora
    // no proprio overlay: guardada em `this`, a closure segurava o overlay da
    // abertura anterior e o handler nao encontrava mais o dropdown atual.
    if (!overlay._stmFolderOutsideBound) {
      overlay._stmFolderOutsideBound = true;
      overlay.addEventListener('click', (e) => {
        const d = overlay.querySelector('.vp2-stm-folders-dropdown');
        if (!d) return;
        if (!e.target.closest('.vp2-stm-folders-dropdown') && !e.target.closest('.vp2-stm-folder-others')) {
          d.classList.remove('open');
          this._stmDesancorar(d.querySelector('.vp2-stm-folder-others'));
        }
      });
    }

    // Folder click events — selecting makes it the new primary
    foldersList.querySelectorAll('.vp2-stm-folder-item').forEach(item => {
      const deleteBtn = item.querySelector('.delete-btn');

      item.addEventListener('click', (e) => {
        if (e.target.closest('.vp2-stm-folder-toggle')) return;
        this._stmSelectedFolderId = item.dataset.folderId;
        this._stmSyncSaveButton(overlay);
        // Re-render so the new primary shows up and dropdown updates
        this._renderStmFilteredFolders(overlay);
      });

      if (deleteBtn) {
        deleteBtn.addEventListener('click', async (e) => {
          e.stopPropagation();
          await this._stmDeleteFolder(item.dataset.folderId, overlay);
        });
      }
    });
  }

  _renderStmFolderItem(folder, isPrimary = false) {
    return `
      <div class="vp2-stm-tree-row vp2-stm-folder-item${isPrimary ? ' selected' : ''}" data-folder-id="${this._stmEsc(folder.id)}" data-folder-side="${this._stmEsc(folder.side)}">
        <div class="folder-info">
          <i class="fas fa-folder folder-icon"></i>
          <div class="folder-name" title="${this._stmEsc(folder.name)}">${this._stmEsc(folder.name)}</div>
        </div>
        <div class="folder-actions">
          <div class="folder-check"><i class="fas fa-check"></i></div>
        </div>
      </div>
    `;
  }

  

  

  

  

  

  

  /** Texto vindo do servidor (nome de pasta, de agente) entra em innerHTML. */
  _stmEsc(v) {
    if (v === null || v === undefined) return '';
    return typeof SecurityUtils !== 'undefined'
      ? SecurityUtils.escapeHtml(String(v))
      : String(v).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  /**
   * Prende um painel suspenso ao gatilho usando coordenadas de tela.
   * O corpo do modal rola (`overflow-y: auto`), entao um painel `absolute`
   * dentro dele era cortado na borda — era o que decepava a lista de
   * composicoes no meio da segunda fileira.
   */
  _stmAncorar(painel, gatilho) {
    if (!painel || !gatilho) return;
    // O modal tem `transform`, e transform vira bloco-contenedor de
    // `position: fixed` — ancorado dentro dele, o painel ia parar 200px
    // abaixo do lugar. Por isso ele sobe pro <body> enquanto esta aberto.
    if (!painel._stmPai) {
      painel._stmPai = painel.parentElement;
      painel._stmIrmao = painel.nextElementSibling;
    }
    document.body.appendChild(painel);
    const r = gatilho.getBoundingClientRect();
    painel.classList.add('vp2-stm-ancorado');
    painel.style.width = `${r.width}px`;
    painel.style.left = `${r.left}px`;
    painel.style.top = `${r.bottom + 4}px`;
    // A altura so vale depois que o navegador desenhou o painel — medida no
    // mesmo quadro em que ele deixa de ser `display: none`, vem zero, e o
    // painel ficava aberto pra baixo passando da borda da tela.
    requestAnimationFrame(() => {
      if (!painel.classList.contains('vp2-stm-ancorado')) return;
      const altura = painel.getBoundingClientRect().height;
      if (r.bottom + 4 + altura > window.innerHeight - 8) {
        painel.style.top = `${Math.max(8, r.top - 4 - altura)}px`;
      }
    });
  }

  _stmDesancorar(painel) {
    if (!painel) return;
    painel.classList.remove('vp2-stm-ancorado');
    painel.style.width = painel.style.left = painel.style.top = '';
    if (painel._stmPai) {
      painel._stmPai.insertBefore(painel, painel._stmIrmao || null);
      painel._stmPai = painel._stmIrmao = null;
    }
  }

  /** Habilita o Enviar so quando ha nome E pasta. */
  _stmSyncSaveButton(overlay) {
    const btn = overlay.querySelector('#vp2StmSave');
    if (!btn) return;
    const temNome = !!overlay.querySelector('#vp2StmTitle')?.value.trim();
    btn.disabled = !(temNome && this._stmSelectedFolderId);
  }

  _parseComposition(comp) {
    if (!comp) return [];
    if (typeof comp === 'string') {
      try { return JSON.parse(comp); } catch { return []; }
    }
    return Array.isArray(comp) ? comp : [];
  }

  _getMapDbId(mapSlug) {
    const maps = app.getMaps() || [];
    const slug = (mapSlug || '').toLowerCase();
    const m = maps.find(x => (x.name || '').toLowerCase() === slug || String(x.id) === slug);
    return m?.id || mapSlug;
  }

  async _executeSaveTacticToFolder(overlay, closeFn) {
    const titleInput = overlay.querySelector('#vp2StmTitle');
    const saveBtn = overlay.querySelector('#vp2StmSave');
    const title = titleInput?.value?.trim();

    if (!title) {
      titleInput?.focus();
      toast.error('Erro', 'Digite um nome para a tática.');
      return;
    }
    if (!this._stmSelectedFolderId) {
      toast.error('Erro', 'Selecione uma pasta.');
      return;
    }

    if (!this._stmIsPersonal() && !app.getCurrentTeam()?.id) return;

    // A URL do video vai crua pro card da tatica; barra o que nao for http(s).
    const videoUrl = overlay.querySelector('#vp2StmVideoUrl')?.value?.trim() || '';
    if (videoUrl && !/^https?:\/\//i.test(videoUrl)) {
      overlay.querySelector('#vp2StmVideoUrl')?.focus();
      toast.error('Erro', 'O link do vídeo precisa começar com http:// ou https://');
      return;
    }

    saveBtn.disabled = true;
    saveBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Salvando...';

    try {
      // A captura do canvas sobe em paralelo com o preenchimento do form. Sem
      // esperar aqui, salvar rapido gravava a tatica sem imagem, em silencio.
      await this._stmCaptureReady;

      const persisted = this.serializeForPersistence();
      const folderSide = overlay.querySelector(`.vp2-stm-folder-item.selected`)?.dataset.folderSide || this._stmCurrentSide || this.currentSide;

      const payload = {
        team_id: this._stmTeamId(),
        map_id: this._getMapDbId(this.currentMap),
        folder_id: this._stmSelectedFolderId,
        title,
        description: 'Estratégia criada no ZDPRO',
        side: folderSide,
        tactic_type: 'valoplant',
        team_composition: persisted.teamComposition,
        map_elements: persisted.mapElements,
        player_paths: persisted.playerPaths,
        abilities_used: persisted.abilitiesUsed,
        video_url: videoUrl || null,
        image_url: overlay.querySelector('#vp2StmImageUrl')?.value?.trim() || null,
        duration_seconds: Math.round((this.timeline.duration || 0) / 1000),
        notes: ''
      };

      const result = await api.createTactic(payload);

      if (result?.success) {
        const tacticId = result.data?.tactic?.id;
        toast.success('Sucesso', 'Tática enviada com sucesso!');
        closeFn();

        // Navigate to tactics page with the map + folder pre-selected
        const curMap = this.maps.find(m => m.id === this.currentMap);
        setTimeout(() => {
          app.navigate('tactics', {
            fromZdpro: true,
            mapId: this._getMapDbId(this.currentMap),
            mapName: curMap?.name || this.currentMap,
            mapSlug: this.currentMap,
            folderId: this._stmSelectedFolderId,
            folderSide: folderSide,
            tacticId
          });
        }, 400);
      } else {
        throw new Error(result?.message || 'Falha ao salvar');
      }
    } catch (error) {
      console.error('Save tactic to folder error:', error);
      toast.error('Erro', error.message || 'Erro ao salvar tática');
      saveBtn.disabled = false;
      saveBtn.innerHTML = '<i class="fas fa-paper-plane"></i> Enviar para Táticas';
    }
  }

  // =====================================================
  // ABILITY ICONS MANAGER
  // =====================================================

  

  

  uploadAbilityIcon(agentFolder, slot) {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/png,image/webp';
    
    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('icon', file);

      try {
        const resp = await fetch(`/api/ability-icons/${agentFolder}/${slot}`, {
          method: 'POST',
          body: formData
        });
        const data = await resp.json();
        
        if (data.success) {
          // Refresh the cache
          const cacheKey = `${agentFolder}:${slot}`;
          this._customAbilityIcons[cacheKey] = data.path;
          
          // Sync all abilities everywhere (map + trajectory + timeline)
          this._syncAbilityIconsEverywhere(agentFolder, slot);
          
          // Refresh modal to show new icon
          this.openAbilityManager();
          return;
        } else {
          alert(data.error || 'Erro ao fazer upload');
        }
      } catch (err) {
        console.error('Upload error:', err);
        alert('Erro ao fazer upload do ícone');
      }
    };
    
    input.click();
  }

  async removeAbilityIcon(agentFolder, slot) {
    try {
      const resp = await fetch(`/api/ability-icons/${agentFolder}/${slot}`, {
        method: 'DELETE'
      });
      const data = await resp.json();
      
      if (data.success) {
        // Remove from cache
        const cacheKey = `${agentFolder}:${slot}`;
        this._customAbilityIcons[cacheKey] = false;
        
        // Sync all abilities everywhere (map + trajectory + timeline)
        this._syncAbilityIconsEverywhere(agentFolder, slot);
        
        // Refresh modal
        this.openAbilityManager();
      }
    } catch (err) {
      console.error('Delete error:', err);
      alert('Erro ao remover ícone');
    }
  }

  // =====================================================
  // ICONS PAGE (separate /zdpro-icones page)
  // =====================================================

  async loadIconsPage(params) {
    const container = document.getElementById('page-zdpro-icones');
    if (!container) return;

    // Ensure base styles (for .vp2-pi-* classes) are loaded
    this.addStyles();

    // Ensure agents are loaded
    if (!this.agents || !this.agents.length) {
      try {
        const data = await api.getValorantAgents();
        if (data && data.status === 200 && Array.isArray(data.data)) {
          this.agents = data.data
            .filter(a => a.isPlayableCharacter)
            .sort((a, b) => a.displayName.localeCompare(b.displayName));
        }
      } catch (e) {
        console.error('Failed to load agents for icons page:', e);
      }
    }

    // Get current map info
    this.syncMaps();
    const curMap = this.maps.find(m => m.id === this.currentMap) || this.maps[0];

    container.innerHTML = `
      <div class="vp2-iconspage-shell">
        <div class="vp2-iconspage-hero">
          <div class="vp2-iconspage-hero-content">
            <button class="vp2-iconspage-back" id="vp2-iconspage-back">
              <i class="fas fa-arrow-left"></i>
            </button>
            <div class="vp2-iconspage-title-group">
              <h1><i class="fas fa-images"></i> Ícones do Mapa</h1>
              <p>${curMap?.name?.toUpperCase() || 'ZDPRO'}</p>
            </div>
          </div>
        </div>

        <div class="vp2-iconspage-controls">
          <div class="vp2-iconspage-controls-grid">
            <div class="vp2-iconspage-control-card">
              <div class="vp2-iconspage-control-icon"><i class="fas fa-expand-arrows-alt"></i></div>
              <div class="vp2-iconspage-control-info">
                <label>Habilidades API</label>
                <div class="vp2-iconspage-slider-row">
                  <input type="range" id="vp2-ico-ability-size" min="10" max="120" value="${this._abilityIconSize || 26}" step="1">
                  <span class="vp2-iconspage-size-val" id="vp2-ico-ability-val">${this._abilityIconSize || 26}px</span>
                </div>
              </div>
            </div>
            <div class="vp2-iconspage-control-card">
              <div class="vp2-iconspage-control-icon"><i class="fas fa-upload"></i></div>
              <div class="vp2-iconspage-control-info">
                <label>Habilidades Upload</label>
                <div class="vp2-iconspage-slider-row">
                  <input type="range" id="vp2-ico-upload-size" min="10" max="120" value="${this._uploadAbilityIconSize || 46}" step="1">
                  <span class="vp2-iconspage-size-val" id="vp2-ico-upload-val">${this._uploadAbilityIconSize || 46}px</span>
                </div>
              </div>
            </div>
            <div class="vp2-iconspage-control-card">
              <div class="vp2-iconspage-control-icon"><i class="fas fa-user-alt"></i></div>
              <div class="vp2-iconspage-control-info">
                <label>Agentes</label>
                <div class="vp2-iconspage-slider-row">
                  <input type="range" id="vp2-ico-agent-size" min="15" max="80" value="${this._agentIconSize || 35}" step="1">
                  <span class="vp2-iconspage-size-val" id="vp2-ico-agent-val">${this._agentIconSize || 35}px</span>
                </div>
              </div>
            </div>
            <div class="vp2-iconspage-control-card">
              <div class="vp2-iconspage-control-icon"><i class="fas fa-clock"></i></div>
              <div class="vp2-iconspage-control-info">
                <label>Tempo de Habilidade</label>
                <div class="vp2-iconspage-toggle-wrap">
                  <input type="checkbox" id="vp2-ico-duration-toggle" ${this._showAbilityDuration ? 'checked' : ''}>
                  <label for="vp2-ico-duration-toggle" class="vp2-icons-toggle-label"></label>
                </div>
              </div>
            </div>
          </div>
          <div class="vp2-iconspage-action-btns">
            <button class="vp2-iconspage-save-btn" id="vp2-ico-save">
              <i class="fas fa-save"></i> Salvar Alterações
            </button>
            <button class="vp2-iconspage-restore-btn" id="vp2-ico-restore">
              <i class="fas fa-undo"></i> Restaurar Padrão
            </button>
          </div>
        </div>

        <div class="vp2-iconspage-agents-grid" id="vp2-icons-grid">
          <div style="text-align:center;padding:40px;color:rgba(255,255,255,0.3);">
            <i class="fas fa-spinner fa-spin" style="font-size:1.5rem;"></i>
            <p style="margin-top:12px;">Carregando agentes...</p>
          </div>
        </div>
      </div>
    `;

    this.addIconsPageStyles();
    this.bindIconsPageEvents();
    await this.loadPanelIcons();
  }

  addIconsPageStyles() {
    if (document.getElementById('vp2-iconspage-styles')) return;
    // O CSS mora em css/pages/valoplant-icons.css. Ficava aqui como template string,
    // somando peso ao bundle de JS e impedindo que a folha fosse cacheada
    // e minificada em separado. Segue carregando sob demanda, como antes.
    Utils.loadPageCss('vp2-iconspage-styles', 'valoplant-icons.css');
  }

  

  async loadPanelIcons() {
    const grid = document.getElementById('vp2-icons-grid');
    if (!grid) return;

    let customIcons = {};
    try {
      const resp = await fetch('/api/ability-icons');
      const data = await resp.json();
      customIcons = data.icons || {};
    } catch (e) {
      console.error('Error fetching custom icons for panel:', e);
    }
    this._panelCustomIcons = customIcons;
    this.renderPanelIconsGrid();
  }

  

  

  async uploadPanelIcon(agentFolder, slot) {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/png,image/webp,image/jpeg';
    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return;
      const formData = new FormData();
      formData.append('icon', file);
      try {
        const resp = await fetch(`/api/ability-icons/${encodeURIComponent(agentFolder)}/${encodeURIComponent(slot)}`, { method: 'POST', body: formData });
        const data = await resp.json();
        if (!data.success) { if (typeof toast !== 'undefined') toast.error('Erro', data.error || 'Falha no upload'); return; }
        if (!this._panelCustomIcons[agentFolder]) this._panelCustomIcons[agentFolder] = {};
        this._panelCustomIcons[agentFolder][slot] = data.path;
        // Sync with map canvas
        const cacheKey = `${agentFolder}:${slot}`;
        this._customAbilityIcons[cacheKey] = data.path;
        this._syncAbilityIconsEverywhere(agentFolder, slot);
        this.renderPanelIconsGrid();
        if (typeof toast !== 'undefined') toast.success('Sucesso', 'Ícone atualizado');
      } catch (err) {
        console.error('Panel upload error:', err);
        if (typeof toast !== 'undefined') toast.error('Erro', 'Falha no upload');
      }
    };
    input.click();
  }

  async removePanelIcon(agentFolder, slot) {
    try {
      const resp = await fetch(`/api/ability-icons/${encodeURIComponent(agentFolder)}/${encodeURIComponent(slot)}`, { method: 'DELETE' });
      const data = await resp.json();
      if (!data.success) { if (typeof toast !== 'undefined') toast.error('Erro', data.error || 'Falha ao remover'); return; }
      if (this._panelCustomIcons[agentFolder]) delete this._panelCustomIcons[agentFolder][slot];
      const cacheKey = `${agentFolder}:${slot}`;
      this._customAbilityIcons[cacheKey] = false;
      this._syncAbilityIconsEverywhere(agentFolder, slot);
      this.renderPanelIconsGrid();
      if (typeof toast !== 'undefined') toast.success('Sucesso', 'Ícone removido');
    } catch (err) {
      console.error('Panel delete error:', err);
      if (typeof toast !== 'undefined') toast.error('Erro', 'Falha ao remover');
    }
  }

  // =====================================================
  // SESSION MANAGEMENT — unique URL per zdpro session
  // =====================================================

  async _initSession(existingCode) {
    if (existingCode) {
      // Always clear canvas first — session owns its own state
      this._clearCanvas();
      this._sessionCode = existingCode;
      try {
        const resp = await fetch(`/api/zdpro/sessions/${existingCode}`);
        const data = await resp.json();
        if (data.success && data.state) {
          this._restoreSessionState(data.state);
        }
      } catch (err) {
        console.warn('Could not load session state:', err);
      }
      window.history.replaceState({}, '', `/zdpro-${existingCode}`);
    } else {
      // New visit — clear canvas and create a fresh session
      this._clearCanvas();
      try {
        const resp = await fetch('/api/zdpro/sessions', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
        const data = await resp.json();
        if (data.success && data.code) {
          this._sessionCode = data.code;
          window.history.replaceState({}, '', `/zdpro-${data.code}`);
        }
      } catch (err) {
        console.warn('Could not create session:', err);
      }
    }
    // Update share URL input if panel exists
    const input = document.getElementById('vp2-share-url-input');
    if (input && this._sessionCode) {
      input.value = `${window.location.origin}/zdpro-${this._sessionCode}`;
    }
    // Join real-time collaboration room
    this._setupSessionSocket();
  }

  _clearCanvas() {
    // Leave current socket room before clearing
    if (this._sessionCode && typeof socket !== 'undefined') {
      socket.leaveZdproSession(this._sessionCode);
    }
    this._sessionCode = null;
    this._socketListenersSet = false;
    this._applyingRemoteState = false;
    // Reset collaborators HUD
    const hud = document.getElementById('vp2-collab-hud');
    if (hud) hud.classList.remove('active');
    this._collaborators = {};
    this.elements = [];
    this.selectedElement = null;
    this.selectedElements = [];
    this.agentPaths = new Map();
    this.pathAbilityWaypoints = new Map();
    this.abilityMarkers = new Map();
    this.undoStack = [];
    this.redoStack = [];
    this.teams = this.createBaseTeamState?.() || { ally: Array(5).fill(null), enemy: Array(5).fill(null) };
    this.render?.();
  }

  // =====================================================
  // REAL-TIME COLLABORATION (Socket.IO)
  // =====================================================

  _setupSessionSocket() {
    if (!this._sessionCode || typeof socket === 'undefined') return;
    const code = this._sessionCode;

    // Register global listeners once per instance lifetime
    if (!this._socketListenersSet) {
      this._collaborators = this._collaborators || {};

      // Receive state from a collaborator who just saved
      socket.on('zdproUpdate', (data) => {
        if (!data || !data.state || this._applyingRemoteState) return;
        this._applyingRemoteState = true;
        try {
          this._restoreSessionState(data.state);
        } finally {
          this._applyingRemoteState = false;
        }
        if (data.userId) {
          this._collaborators[data.userId] = { displayName: data.displayName || 'Alguém' };
          this._renderCollabHUD();
        }
      });

      socket.on('zdproUserJoined', (data) => {
        if (!data || !data.userId) return;
        this._collaborators[data.userId] = { displayName: data.displayName || 'Alguém' };
        this._renderCollabHUD();
      });

      socket.on('zdproUserLeft', (data) => {
        if (!data || !data.userId) return;
        delete this._collaborators[data.userId];
        this._renderCollabHUD();
      });

      socket.on('zdproPeers', (data) => {
        // On join, server tells us how many others are already in the room
        // We keep _collaborators map for named display; peer count is a fallback
        this._peerCount = data?.count || 0;
        this._renderCollabHUD();
      });

      this._socketListenersSet = true;
    }

    // Join room — retry once connected if not yet
    if (socket.connected) {
      socket.joinZdproSession(code);
    } else {
      const tryJoin = () => {
        if (this._sessionCode === code) socket.joinZdproSession(code);
      };
      socket.on('userJoined', tryJoin); // fires after auth login
      // Also attempt on next tick in case socket connects very soon
      setTimeout(() => { if (this._sessionCode === code && socket.connected) socket.joinZdproSession(code); }, 2000);
    }
  }

  _renderCollabHUD() {
    const hud = document.getElementById('vp2-collab-hud');
    const label = document.getElementById('vp2-collab-label');
    if (!hud || !label) return;
    const names = Object.values(this._collaborators || {}).map(c => c.displayName);
    const count = names.length + (this._peerCount > names.length ? this._peerCount - names.length : 0);
    if (names.length > 0) {
      const display = names.slice(0, 2).join(', ') + (names.length > 2 ? ` +${names.length - 2}` : '');
      label.textContent = display;
      hud.classList.add('active');
    } else if (count > 0) {
      label.textContent = `${count} pessoa${count > 1 ? 's' : ''} ao vivo`;
      hud.classList.add('active');
    } else {
      hud.classList.remove('active');
    }
  }

  _restoreSessionState(state) {
    if (!state) return;
    try {
      if (state.elements && Array.isArray(state.elements)) {
        const runtimeImageKeys = [
          'image', '_abilityImg', '_customAbilityIcon', 'iconImage', '_fallbackImg',
          '_abilityImgFailed', '_iconImgFailed', '_fallbackImgFailed', '_customIconFailed',
          'customIconImage', '_trimmedIcon', '_rangeIconImg', '_rangeIconSrc', '_rangeIconFailed',
          '_coneIconImg', '_coneIconSrc', '_coneIconFailed', '_img', '_imgLoaded', '_imgFailed'
        ];
        this.elements = state.elements.map((el) => {
          const restored = { ...el };
          runtimeImageKeys.forEach((k) => { delete restored[k]; });
          return restored;
        });
        this.reloadElementImages?.();
      }
      if (state.agentPaths && typeof state.agentPaths === 'object') {
        this.agentPaths = new Map(Object.entries(state.agentPaths));
      }
      if (state.pathAbilityWaypoints && typeof state.pathAbilityWaypoints === 'object') {
        this.pathAbilityWaypoints = new Map(Object.entries(state.pathAbilityWaypoints));
      }
      if (state.teams) {
        // Re-hydrate teams from saved UUIDs
        const hydrateSlots = (slots) => slots.map(s => {
          if (!s) return null;
          const found = this.agents?.find(a => a.uuid === s.uuid);
          return found || s;
        });
        if (state.teams.ally) this.teams.ally = hydrateSlots(state.teams.ally);
        if (state.teams.enemy) this.teams.enemy = hydrateSlots(state.teams.enemy);
      }
      this.render?.();
    } catch (err) {
      console.warn('Could not restore session state:', err);
    }
  }

  _getSerializableState() {
    const elementsToSave = this.elements.map(el => {
      const clone = { ...el };
      delete clone.image;
      delete clone._abilityImg;
      delete clone._customAbilityIcon;
      delete clone.iconImage;
      delete clone._fallbackImg;
      delete clone._abilityImgFailed;
      delete clone._iconImgFailed;
      delete clone._fallbackImgFailed;
      delete clone._customIconFailed;
      delete clone.customIconImage;
      delete clone._trimmedIcon;
      delete clone._rangeIconImg;
      delete clone._rangeIconSrc;
      delete clone._rangeIconFailed;
      delete clone._coneIconImg;
      delete clone._coneIconSrc;
      delete clone._coneIconFailed;
      delete clone._img;
      delete clone._imgLoaded;
      delete clone._imgFailed;
      return clone;
    });
    const pathsToSave = {};
    this.agentPaths.forEach((path, agentId) => { pathsToSave[agentId] = path; });
    const waypointsToSave = {};
    this.pathAbilityWaypoints.forEach((wps, agentId) => {
      waypointsToSave[agentId] = wps.map(wp => ({
        x: wp.x, y: wp.y,
        pathX: wp.pathX != null ? wp.pathX : wp.x,
        pathY: wp.pathY != null ? wp.pathY : wp.y,
        distanceAlongPath: wp.distanceAlongPath,
        timeMs: wp.timeMs,
        ability: { name: wp.ability.name, slot: wp.ability.slot, icon: wp.ability.icon, duration: wp.ability.duration, abilityType: wp.ability.abilityType },
        triggered: wp.triggered
      }));
    });
    const teamsToSave = {
      ally: this.teams.ally.map(a => a ? { uuid: a.uuid, displayName: a.displayName } : null),
      enemy: this.teams.enemy.map(a => a ? { uuid: a.uuid, displayName: a.displayName } : null)
    };
    return { elements: elementsToSave, agentPaths: pathsToSave, pathAbilityWaypoints: waypointsToSave, teams: teamsToSave };
  }

  _scheduleSyncSession() {
    if (!this._sessionCode) return;
    clearTimeout(this._sessionSyncTimer);
    this._sessionSyncTimer = setTimeout(() => this._syncSessionToBackend(), 1500);
  }

  async _syncSessionToBackend() {
    if (!this._sessionCode) return;
    try {
      const state = this._getSerializableState();
      // Save to DB
      await fetch(`/api/zdpro/sessions/${this._sessionCode}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ state })
      });
      // Broadcast to collaborators via Socket.IO (skip if we're applying someone else's state)
      if (!this._applyingRemoteState && typeof socket !== 'undefined') {
        socket.broadcastZdproUpdate(this._sessionCode, state);
      }
    } catch (err) {
      console.warn('Session sync error:', err);
    }
  }

  // =====================================================
  // SHARE PANEL
  // =====================================================

  

  copyShareLink() {
    const url = this._sessionCode ? `${window.location.origin}/zdpro-${this._sessionCode}` : window.location.href;
    navigator.clipboard.writeText(url).then(() => {
      const btn = document.getElementById('vp2-share-copy-btn');
      if (btn) {
        const orig = btn.innerHTML;
        btn.innerHTML = '<i class="fas fa-check"></i>';
        btn.style.color = '#4ade80';
        setTimeout(() => { btn.innerHTML = orig; btn.style.color = ''; }, 1800);
      }
      if (typeof toast !== 'undefined') toast.success('Copiado!', 'Link copiado para a área de transferência');
    }).catch(() => {
      const input = document.getElementById('vp2-share-url-input');
      if (input) { input.select(); document.execCommand('copy'); }
      if (typeof toast !== 'undefined') toast.success('Copiado!', 'Link copiado');
    });
  }

  shareOn(platform) {
    const url = this._sessionCode ? `${window.location.origin}/zdpro-${this._sessionCode}` : window.location.href;
    const text = encodeURIComponent('Confira minha tática no ZDVAL ZDPro!');
    const encodedUrl = encodeURIComponent(url);
    const shareUrls = {
      whatsapp:  `https://wa.me/?text=${text}%20${encodedUrl}`,
      twitter:   `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${text}`,
      telegram:  `https://t.me/share/url?url=${encodedUrl}&text=${text}`,
      instagram: null // Instagram doesn't support direct URL sharing on web
    };
    if (platform === 'instagram') {
      this.copyShareLink();
      if (typeof toast !== 'undefined') toast.info('Instagram', 'Link copiado! Cole no Instagram para compartilhar.');
      return;
    }
    const shareUrl = shareUrls[platform];
    if (shareUrl) window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=500');
  }
}

// Export for use in app.js
window.ValoPlantV2 = ValoPlantV2;

/* ===== js/valoplant-render.js ===== */
/**
 * ValoPlantV2 — renderizacao
 *
 * Estes 25 metodos vinham da classe em valoplant-v2.js, que passava de
 * 12 mil linhas num arquivo so. Continuam sendo metodos da mesma classe: sao
 * instalados no prototype, entao `this` e o comportamento nao mudam.
 *
 * Precisa carregar DEPOIS de valoplant-v2.js — a ordem esta em scripts.json.
 *
 * getOwnPropertyDescriptors e nao Object.assign de proposito: assign copiaria
 * o *valor* de um getter em vez do getter.
 */
Object.defineProperties(ValoPlantV2.prototype, Object.getOwnPropertyDescriptors({
  renderAbilityRangeOverlay(ctx, abilityName, opacity = 0.8, scaleH = 1.0) {
      const shape = this.abilityShapes[abilityName];
      if (!shape || !shape.showRange) return;
      // relay-bolt draws its own filled circle — skip redundant overlay
      if (shape.shape === 'relay-bolt') return;

      const mapScale = this.getCurrentMapScale();
      const mapSize = this._mapSize;

      const circleRanges = Array.isArray(shape.rangeOverlays) && shape.rangeOverlays.length
        ? shape.rangeOverlays
        : (shape.gameRadius ? [{
            gameRadius: shape.gameRadius,
            color: shape.color,
            ringOnly: shape.ringOnly,
            ringWidth: shape.ringWidth
          }] : []);

      for (const range of circleRanges) {
        if (!range || !range.gameRadius) continue;
        const realRadius = range.gameRadius * 100 * mapScale * mapSize;

        ctx.save();
        ctx.beginPath();
        ctx.arc(0, 0, realRadius, 0, Math.PI * 2);
        if (range.ringOnly) {
          ctx.globalAlpha = 1;
          ctx.strokeStyle = range.color || shape.color || 'rgba(34, 211, 238, 0.9)';
          ctx.lineWidth = range.ringWidth || shape.ringWidth || 6;
          ctx.stroke();
        } else {
          // Fill the circle if shape has filled: true
          if (shape.filled) {
            ctx.globalAlpha = 1;
            ctx.fillStyle = shape.color || range.color || 'rgba(255, 50, 0, 0.15)';
            ctx.fill();
          }
          if (!range.noStroke) {
            ctx.globalAlpha = 1;
            const strokeColor = range.strokeColor
              || (range.color ? range.color.replace(/[\d.]+\)$/, '0.8)') : null)
              || (shape.color ? shape.color.replace(/[\d.]+\)$/, '0.8)') : 'rgba(34, 211, 238, 0.8)');
            ctx.strokeStyle = strokeColor;
            ctx.lineWidth = 2;
            ctx.stroke();
          }
        }
        ctx.restore();
      }

      if (circleRanges.length && !shape.hideAnchorDot) {
        ctx.save();
        ctx.beginPath();
        ctx.arc(0, 0, 5, 0, Math.PI * 2);
        ctx.fillStyle = '#fff';
        ctx.globalAlpha = 1;
        ctx.fill();
        ctx.strokeStyle = 'rgba(0,0,0,0.5)';
        ctx.lineWidth = 1;
        ctx.stroke();
        ctx.restore();
      }

      if (shape.shape === 'cone' && shape.gameLength && shape.gameAngle && !shape.dedicatedRender) {
        const realLength = shape.gameLength * 100 * mapScale * mapSize * scaleH;
        const halfAngleRad = ((shape.gameAngle || 60) * Math.PI / 180) / 2;
        const halfWidth = Math.max(8, Math.tan(halfAngleRad) * realLength);

        ctx.save();
        ctx.beginPath();
        if (shape.originAtBottom) {
          ctx.moveTo(0, -realLength);
          ctx.lineTo(-halfWidth, 0);
          ctx.lineTo(halfWidth, 0);
        } else {
          ctx.moveTo(0, 0);
          ctx.lineTo(-halfWidth, -realLength);
          ctx.lineTo(halfWidth, -realLength);
        }
        ctx.closePath();
        ctx.globalAlpha = 1;
        ctx.strokeStyle = shape.color ? shape.color.replace(/[\d.]+\)$/, '0.9)') : 'rgba(188, 171, 87, 0.9)';
        ctx.lineWidth = 2;
        ctx.stroke();

        if (shape.showCenterDiamond) {
          const centerY = shape.originAtBottom ? -(realLength * 0.45) : -(realLength * 0.45);
          ctx.save();
          ctx.translate(0, centerY);
          ctx.rotate(Math.PI / 4);
          const ds = 10;
          ctx.fillStyle = shape.diamondColor || 'rgba(207, 122, 75, 0.95)';
          ctx.fillRect(-ds, -ds, ds * 2, ds * 2);
          ctx.strokeStyle = 'rgba(255, 235, 210, 0.75)';
          ctx.lineWidth = 1.5;
          ctx.strokeRect(-ds, -ds, ds * 2, ds * 2);
          ctx.restore();
        }

        if (shape.showAnchorMarker) {
          ctx.beginPath();
          ctx.arc(0, 0, 10, 0, Math.PI * 2);
          ctx.fillStyle = shape.anchorColor || 'rgba(245, 247, 250, 0.98)';
          ctx.fill();
        }

        ctx.restore();
      }

      if (shape.gameWidth && shape.gameHeight) {
        const realW = shape.gameWidth * 100 * mapScale * mapSize;
        const realH = shape.gameHeight * 100 * mapScale * mapSize * scaleH;
        const _offsetPx = shape.originOffset ? shape.originOffset * 100 * mapScale * mapSize : 0;
        const _rangeY = shape.originAtBottom ? -realH - _offsetPx : -realH / 2;
        const _cornerR = shape.roundedCorners ? (typeof shape.roundedCorners === 'number' ? shape.roundedCorners : Math.min(realW, realH) * 0.5) : 0;
        ctx.save();
        if (false && !shape.outlineOnly) {
          ctx.globalAlpha = 1;
          ctx.fillStyle = shape.color || 'rgba(200, 160, 40, 0.3)';
          if (_cornerR > 0) {
            ctx.beginPath();
            ctx.roundRect(-realW / 2, _rangeY, realW, realH, _cornerR);
            ctx.fill();
          } else {
            ctx.fillRect(-realW / 2, _rangeY, realW, realH);
          }
        }
        if (!shape.noRangeStroke) {
          ctx.globalAlpha = 1;
          ctx.strokeStyle = shape.color ? shape.color.replace(/[\d.]+\)$/, '0.8)') : 'rgba(200, 160, 40, 0.8)';
          ctx.lineWidth = 2;
          if (_cornerR > 0) {
            ctx.beginPath();
            ctx.roundRect(-realW / 2, _rangeY, realW, realH, _cornerR);
            ctx.stroke();
          } else {
            ctx.strokeRect(-realW / 2, _rangeY, realW, realH);
          }
        }
        ctx.restore();
      }
    },

  renderPage() {
      console.log('  -> renderPage() called, maps:', this.maps?.length);
      const curMap = this.maps.find(m => m.id === this.currentMap) || this.maps[0];
      return `
      <div class="valoplant-v2">

        <!-- Layout: Sidebar + Main + Bottom Bar -->
        <div class="vp2-body-layout">
          <!-- LEFT PANEL (lineups-style) -->
          <div class="vp2-panel" id="vp2Panel">
            <!-- Map Selector -->
            <div class="vp2-panel-section vp2-panel-map-section">
              ${MapPicker.banner({
                id: 'vp2-map-current',
                map: { image: curMap.splash, name: curMap.name }
              })}
              ${MapPicker.dropdown({
                id: 'vp2-map-dropdown',
                maps: this.mapPickerMaps(),
                selectedId: this.currentMap
              })}
            </div>

            <!-- Side Toggle (mesmo botao da /lineups) -->
            <div class="vp2-panel-section vp2-panel-side-section">
              ${MapPicker.sideControls({
                side: this.currentSide === 'defense' ? 'defense' : 'attack'
              })}
            </div>

            <!-- Agents moved to bottom bar -->
            <!-- TRAJETÓRIA 2D -->
            <div class="vp2-ms-section">
              <div class="vp2-ms-label vp2-section-label-tooltip" data-tooltip="Simule movimentação 2D dos agentes no mapa com play/pause e habilidades ao longo do caminho"><i class="fas fa-route"></i><span>Trajetória 2D</span></div>
              <div class="vp2-ms-group">
                <button class="vp2-timeline-btn" id="vp2-play" title="Play/Pause" data-tooltip="Play/Pause"><i class="fas fa-play" id="vp2-play-icon"></i></button>
                <button class="vp2-timeline-btn" id="vp2-stop" title="Parar" data-tooltip="Parar"><i class="fas fa-stop"></i></button>
                <button class="vp2-timeline-btn vp2-clear-path-btn" id="vp2-clear-paths" title="Limpar Trajetória Selecionada" data-tooltip="Limpar Trajetória"><img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22white%22%3E%0A%20%20%3Cpath%20d%3D%22M16.24%203.56%2021.19%208.5c.78.78.78%202.05%200%202.83L12%2020.53a4.008%204.008%200%200%201-5.66%200L2.81%2017c-.78-.78-.78-2.05%200-2.83l10.6-10.6c.79-.79%202.05-.79%202.83%200zM4.22%2015.58l3.54%203.53c.78.79%202.04.79%202.83%200l3.53-3.53-4.95-4.95-4.95%204.95z%22/%3E%0A%3C/svg%3E%0A" alt="Limpar" class="vp2-icon-img" style="filter:none"></button>
                <button class="vp2-timeline-btn vp2-clear-all-timeline-btn" id="vp2-clear-all-paths" title="Limpar Todas Trajetórias" data-tooltip="Limpar Tudo"><i class="fas fa-trash-alt"></i></button>
              </div>
              <select class="vp2-speed-select" id="vp2-speed" title="Velocidade" style="display:none">
                <option value="0.25">0.25x</option><option value="0.5">0.5x</option><option value="1" selected>1x</option><option value="2">2x</option><option value="4">4x</option>
              </select>
            </div>

            <!-- FERRAMENTAS -->
            <div class="vp2-ms-section">
              <div class="vp2-ms-label vp2-section-label-tooltip" data-tooltip="Desenhe no mapa com caneta, linhas, setas e textos para anotar jogadas"><i class="fas fa-tools"></i><span>Ferramentas</span></div>
              <div class="vp2-ms-group" id="vp2-drawing-toolbar">
                <button class="vp2-tool" data-tool="pen" data-tooltip="Caneta"><i class="fas fa-pen"></i></button>
                <button class="vp2-tool" data-tool="eraser" data-tooltip="Apagar"><img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22white%22%3E%0A%20%20%3Cpath%20d%3D%22M16.24%203.56%2021.19%208.5c.78.78.78%202.05%200%202.83L12%2020.53a4.008%204.008%200%200%201-5.66%200L2.81%2017c-.78-.78-.78-2.05%200-2.83l10.6-10.6c.79-.79%202.05-.79%202.83%200zM4.22%2015.58l3.54%203.53c.78.79%202.04.79%202.83%200l3.53-3.53-4.95-4.95-4.95%204.95z%22/%3E%0A%3C/svg%3E%0A" alt="Apagar" class="vp2-icon-img" style="filter:none"></button>
                <button class="vp2-tool" data-tool="line" data-tooltip="Linha"><i class="fas fa-minus"></i></button>
                <button class="vp2-tool" data-tool="arrow" data-tooltip="Seta"><i class="fas fa-long-arrow-alt-right"></i></button>
                <button class="vp2-tool" data-tool="text" data-tooltip="Texto"><i class="fas fa-font"></i></button>
                <button class="vp2-tool" data-tool="image" data-tooltip="Imagem"><i class="fas fa-image"></i></button>
              </div>
            </div>

            <!-- DELETAR -->
            <div class="vp2-ms-section">
              <div class="vp2-ms-label vp2-section-label-tooltip" data-tooltip="Remova elementos do mapa por tipo: agentes, habilidades, linhas, textos ou tudo de uma vez"><i class="fas fa-trash-alt"></i><span>Deletar</span></div>
              <div class="vp2-ms-group">
                <button class="vp2-type-del-btn" id="vp2-del-agents" title="Apagar agentes" data-tooltip="Agentes"><i class="fas fa-user"></i></button>
                <button class="vp2-type-del-btn" id="vp2-del-abilities" title="Apagar habilidades" data-tooltip="Habilidades"><i class="fas fa-shapes"></i></button>
                <button class="vp2-type-del-btn" id="vp2-del-lines" title="Apagar linhas" data-tooltip="Linhas"><i class="fas fa-pen"></i></button>
                <button class="vp2-type-del-btn" id="vp2-del-texts" title="Apagar textos" data-tooltip="Textos"><i class="fas fa-font"></i></button>
                <button class="vp2-type-del-btn vp2-del-all-btn" id="vp2-del-all" title="Apagar tudo" data-tooltip="Apagar Tudo"><img src="https://cdn-icons-png.flaticon.com/512/73/73806.png" alt="Apagar tudo" class="vp2-icon-img"></button>
              </div>
            </div>

            <!-- SEQUÊNCIAS -->
            <div class="vp2-ms-section">
              <div class="vp2-ms-label vp2-section-label-tooltip" data-tooltip="Alterne entre etapas da tática para mostrar diferentes momentos da jogada"><i class="fas fa-layer-group"></i><span>Sequência</span></div>
              <div class="vp2-ms-group" id="vp2-sequence-bar">
                <div class="vp2-seq-steps" id="vp2-seq-steps">
                  <button class="vp2-seq-btn active" data-seq="1"><span class="vp2-seq-num">1</span></button>
                  <button class="vp2-seq-btn" data-seq="2"><span class="vp2-seq-num">2</span></button>
                  <button class="vp2-seq-btn" data-seq="3"><span class="vp2-seq-num">3</span></button>
                  <button class="vp2-seq-btn" data-seq="4"><span class="vp2-seq-num">4</span></button>
                </div>
              </div>
            </div>

            <!-- AGENT FILTER (same line as bottom bar) -->
            <div class="vp2-agent-filter-panel" id="vp2-role-filter-section" style="display:none;">
              <div class="vp2-agent-search-wrap">
                <i class="fas fa-search vp2-agent-search-icon"></i>
                <input type="text" id="vp2-agent-search" class="vp2-agent-search-input" placeholder="Pesquise o agente" autocomplete="off" spellcheck="false">
              </div>
              <div class="vp2-role-filter-grid" id="vp2-role-filter-grid"></div>
            </div>

          </div>

          <div class="vp2-workspace">
            <div class="vp2-workspace-main">
              <div class="vp2-main-column">
                <!-- Main Canvas Area -->
                <div class="vp2-main">
                  <!-- Ally Sidebar -->
                  <div class="vp2-map-agents-panel ally" id="vp2-map-agents-ally"></div>
                  <div class="vp2-canvas-container">

                    <!-- Inline Text Notepad -->
                    <textarea id="vp2-text-notepad" class="vp2-text-notepad" style="display:none" placeholder="Digite aqui..."></textarea>

                    <!-- Image Add Modal -->
                    <div id="vp2-image-modal" class="vp2-image-modal" style="display:none">
                      <div class="vp2-image-modal-header"><i class="fas fa-image"></i> Adicionar Imagem</div>
                      <input id="vp2-image-url" type="text" class="vp2-image-url-input" placeholder="Cole a URL da imagem...">
                      <div class="vp2-image-paste-hint"><i class="fas fa-paste"></i> ou pressione <kbd>Ctrl+V</kbd> para colar imagem</div>
                      <div class="vp2-image-modal-btns">
                        <button id="vp2-image-confirm" class="vp2-image-modal-btn confirm"><i class="fas fa-check"></i> Adicionar</button>
                        <button id="vp2-image-cancel" class="vp2-image-modal-btn cancel"><i class="fas fa-times"></i> Cancelar</button>
                      </div>
                    </div>

                    <div class="vp2-canvas-wrapper" id="vp2-canvas-wrapper">
                      <canvas id="vp2-canvas"></canvas>
                      <div class="vp2-trash-bin" id="vp2-trash-bin">
                        <i class="fas fa-trash-alt"></i>
                      </div>
                      <div class="vp2-hover-hud" id="vp2-hover-hud"></div>
                      <div class="vp2-zoom-indicator" id="vp2-zoom-indicator">100%</div>
                      <!-- Lock Button -->
                      <button class="vp2-map-lock-btn vp2-lock-btn" id="vp2-map-lock" title="Travar/Destravar mapa">
                        <i class="fas fa-lock" id="vp2-lock-icon"></i>
                      </button>

                      <!-- Collaborators HUD -->
                      <div class="vp2-collab-hud" id="vp2-collab-hud">
                        <span class="vp2-collab-dot"></span>
                        <span class="vp2-collab-label" id="vp2-collab-label">ao vivo</span>
                      </div>

                    </div>
                  </div>
                <!-- Enemy Sidebar -->
                  <div class="vp2-map-agents-panel enemy" id="vp2-map-agents-enemy"></div>
                </div>

                <!-- Bottom Agents Bar -->
                <div class="vp2-bottom-agents-bar" id="vp2-bottom-agents-bar">
                  <div class="vp2-bottom-agents-scroll" id="vp2-agents-row">
                    <!-- Agents loaded dynamically -->
                  </div>
                </div>
              </div>

              <div class="vp2-panel vp2-panel-right" id="vp2RightPanel">
                <div class="vp2-panel-right-content" id="vp2-right-panel-content">
                  <!-- SALVAR TÁTICA -->
                  <div class="vp2-ms-section vp2-save-section">
                    <button class="vp2-save-tactic-btn" id="vp2-save-tactic-btn">
                      <i class="fas fa-paper-plane"></i>
                      <span>Enviar para Táticas</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        
      </div>
      `;
    },

  renderAgentsModal() {
      const container = document.getElementById('vp2-agents-modal-grid');
      if (!container) return;
      
      container.innerHTML = this.agents.map(agent => `
        <div class="vp2-agent-modal-item" 
             data-agent-uuid="${agent.uuid}" 
             data-agent-name="${agent.displayName}"
             data-agent-role="${agent.role?.displayName || ''}"
             title="${agent.displayName}">
          <img src="${agent.displayIcon || agent.displayIconSmall}" alt="${agent.displayName}" loading="lazy">
          <span class="vp2-agent-modal-name">${agent.displayName}</span>
          ${agent.role?.displayIcon ? `
            <div class="vp2-agent-role">
              <img src="${agent.role.displayIcon}" alt="${agent.role.displayName}">
            </div>
          ` : ''}
        </div>
      `).join('');
    },

  renderRoleFilterBar() {
      const section = document.getElementById('vp2-role-filter-section');
      const container = document.getElementById('vp2-role-filter-grid');
      if (!section || !container) return;

      const roles = this.getAgentRoleOptions();
      if (!roles.length) {
        section.style.display = 'none';
        container.innerHTML = '';
        return;
      }

      container.innerHTML = roles.map(role => `
        <button class="vp2-role-filter-btn ${this.currentAgentRole === role.key ? 'active' : ''}" data-role-key="${role.key}" data-role-label="${role.label}" title="${role.label}">
          <img src="${role.icon}" alt="${role.label}" loading="lazy">
        </button>
      `).join('');
      section.style.display = '';
    },

  renderTeamSlot(team, slotIndex) {
      const container = document.getElementById(`vp2-${team}-slots`);
      if (!container) return;
      
      const slotEl = container.querySelector(`[data-slot="${slotIndex + 1}"]`);
      if (!slotEl) return;
      
      const agent = this.teams[team][slotIndex];
      
      if (agent) {
        // Render filled slot with draggable agent and abilities
        slotEl.innerHTML = `
          <div class="vp2-slot-content filled">
            <img class="vp2-slot-agent-img" 
                 src="${agent.displayIcon || agent.displayIconSmall}" 
                 alt="${agent.displayName}"
                 draggable="true"
                 data-drag-type="agent"
                 data-agent-uuid="${agent.uuid}"
                 data-agent-name="${agent.displayName}"
                 data-team="${team}"
                 title="Arraste para o mapa">
            <div class="vp2-slot-info">
              <div class="vp2-slot-agent-name">${agent.displayName}</div>
              <div class="vp2-slot-abilities">
                ${this.getDisplayAbilities(agent).map(ab => {
                  const iconSrc = ab.displayIcon || '';
                  return `
                  <div class="vp2-slot-ability-icon" 
                       data-drag-type="ability"
                       data-ability-name="${ab.displayName}"
                       data-ability-slot="${ab.slot}"
                       data-ability-icon="${ab.displayIcon || ''}"
                       data-agent-uuid="${agent.uuid}"
                     data-team="${team}"
                     title="${ab.displayName}">
                    <img src="${iconSrc}" alt="${ab.displayName}" 
                         onerror="this.style.display='none'"
                         draggable="false">
                  </div>
                `}).join('')}
              </div>
            </div>
            <button class="vp2-slot-remove" title="Remover">
              <i class="fas fa-times"></i>
            </button>
          </div>
        `;
      } else {
        // Render empty slot
        slotEl.innerHTML = `
          <div class="vp2-slot-content empty">
            <div class="vp2-slot-add">
              <i class="fas fa-plus"></i>
            </div>
            <span class="vp2-slot-label">Adicionar Agente</span>
          </div>
        `;
      }
    },

  renderAgentsBar() {
      const row = document.getElementById('vp2-agents-row');
      if (!row || !this.agents.length) return;

      const filtered = this.currentAgentRole
        ? this.agents.filter(agent => this.getAgentRoleKey(agent) === this.currentAgentRole)
        : this.agents;

      const searchFiltered = this.currentAgentSearch
        ? filtered.filter(agent => agent.displayName.toLowerCase().includes(this.currentAgentSearch.toLowerCase()))
        : filtered;

      const isFiltered = (!!this.currentAgentRole || !!this.currentAgentSearch) && searchFiltered.length < this.agents.length;
      row.classList.toggle('is-filtered', isFiltered);
      const selectedUuid = this.selectedAgent?.uuid || searchFiltered[0]?.uuid || null;
      
      // Get all placed agent UUIDs and their teams
      const placedAgents = new Map();
      ['ally', 'enemy'].forEach(team => {
        this.teams[team].forEach(agent => {
          if (agent) placedAgents.set(agent.uuid, team);
        });
      });

      row.innerHTML = searchFiltered.map(agent => {
        const team = placedAgents.get(agent.uuid);
        const placed = !!team;
        const teamClass = team === 'ally' ? 'ally-placed' : (team === 'enemy' ? 'enemy-placed' : '');
        const selectedClass = selectedUuid === agent.uuid ? 'selected' : '';
        
        const gc = agent.backgroundGradientColors || [];
        const g0 = gc[0] ? '#' + gc[0].slice(0, 6) : '#1a1a2e';
        const g1 = gc[1] ? '#' + gc[1].slice(0, 6) : '#0f1923';
        const g2 = gc[2] ? '#' + gc[2].slice(0, 6) : '#1a1a2e';

        return `
          <div class="vp2-agent-bar-item ${teamClass} ${placed ? 'placed' : ''} ${selectedClass}" 
               data-agent-uuid="${agent.uuid}" 
               data-agent-name="${agent.displayName}"
               data-agent-role="${this.getAgentRoleKey(agent)}"
               draggable="false">
            <div class="vp2-agent-bar-portrait">
              <div class="vp2-agent-bar-frame" style="--agent-g0: ${g0}; --agent-g1: ${g1}; --agent-g2: ${g2};">
                <img src="${this.getAgentBarPortrait(agent)}" alt="${agent.displayName}" loading="lazy" draggable="false" onerror="if(this.dataset.fallbackApplied)return;this.dataset.fallbackApplied='1';this.src='${agent.displayIcon || agent.displayIconSmall || ''}';">
                <div class="vp2-agent-bar-veil"></div>
              </div>
            </div>
            <span class="vp2-agent-bar-name">${agent.displayName}</span>
          </div>
        `;
      }).join('');

      this.updateBottomAgentBarLayout();
      this._updateMapSidebars();
    },

  /**
   * Agenda um desenho para o proximo frame.
   *
   * Havia 115 chamadas de `render()` espalhadas pelos handlers, e uma unica
   * interacao dispara varias em sequencia (mover agente redesenha no mousemove,
   * no hover-test e de novo no mouseup). Cada uma redesenhava o canvas inteiro
   * de forma sincrona, dentro do handler — era isso que deixava botao e arrasto
   * pesados. Agora N chamadas no mesmo frame viram um desenho so.
   *
   * Quem precisa do pixel na hora (exportar imagem) chama `flushRender()`.
   */
  render() {
      if (!this.ctx || !this.canvas) return;
      if (this._renderRafId) return;
      this._renderRafId = requestAnimationFrame(() => {
        this._renderRafId = null;
        try { this._renderNow(); } catch (err) { console.error('[VP2] render error:', err); }
      });
    },

  /** Desenha ja, descartando o frame agendado. Para leitura de pixel. */
  flushRender() {
      if (this._renderRafId) {
        cancelAnimationFrame(this._renderRafId);
        this._renderRafId = null;
      }
      this._renderNow();
    },

  _renderNow() {
      if (!this.ctx || !this.canvas) return;
      
      const ctx = this.ctx;
      const cw = this.canvas.width;
      const ch = this.canvas.height;
      const ms = this._mapSize;
      const ox = this._mapOffsetX;
      const oy = this._mapOffsetY;
      
      // Clear full canvas (physical pixels)
      ctx.clearRect(0, 0, cw, ch);
      
      // Save context for transformations
      ctx.save();
      
      // Scale for device pixel ratio (makes canvas crisp on HiDPI/retina screens)
      const dpr = this._dpr || 1;
      ctx.scale(dpr, dpr);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      
      // Apply zoom and pan
      ctx.translate(this.panX, this.panY);
      ctx.scale(this.zoomLevel, this.zoomLevel);
      
      // Offset to map origin (centers the square map in the canvas)
      ctx.translate(ox, oy);
      
      // Draw map background
      if (this.mapImage) {
        const rotation = this.mapRotations[this.currentMap];
        
        ctx.save();
        ctx.translate(ms/2, ms/2);
        
        // Apply rotation
        if (rotation && rotation.baseRotation) {
          ctx.rotate(rotation.baseRotation * Math.PI / 180);
        }
        
        // Flip for defense if needed
        if (rotation && rotation.flipForDefense && this.currentSide === 'defense') {
          ctx.scale(-1, -1);
        }
        ctx.drawImage(this.mapImage, -ms/2, -ms/2, ms, ms);

        ctx.restore();
      }
      
      // Apply map rotation/flip transform so all elements render in correct orientation
      {
        const rotation = this.mapRotations[this.currentMap];
        if (rotation) {
          ctx.translate(ms/2, ms/2);
          if (rotation.baseRotation) {
            ctx.rotate(rotation.baseRotation * Math.PI / 180);
          }
          if (rotation.flipForDefense && this.currentSide === 'defense') {
            ctx.scale(-1, -1);
          }
          ctx.translate(-ms/2, -ms/2);
        }
      }
      
      // Draw paths BEFORE elements so they appear below agents
      this.renderPaths();
      
      // Renderiza marcadores de habilidade nas trajetórias (SEMPRE, inclusive durante playback)
      this.renderPathAbilityWaypoints(this.ctx);
      
      // Draw placed ability markers (from timeline) on the map
      this.renderPlacedAbilities();
      
      // Draw all elements
      this.renderElements();
      
      // Draw drag preview (live preview while dragging ability from sidebar)
      if (this.dragPreview && this.dragPreview.x != null) {
        this.renderDragPreview(ctx);
      }
      
      ctx.restore();
    },

  renderElements() {
      const ctx = this.ctx;
      
      // Sort elements: large-range abilities at bottom, then icon abilities (same level as agents), then agents on top
      const sorted = [...this.elements].sort((a, b) => {
        const aIsAgent = (a.type === 'agent' || a.type === 'player') ? 1 : 0;
        const bIsAgent = (b.type === 'agent' || b.type === 'player') ? 1 : 0;
        if (aIsAgent !== bIsAgent) return aIsAgent - bIsAgent;
        // Abilities with large dedicated range shapes render BELOW normal (icon) abilities
        if (a.type === 'ability' && b.type === 'ability') {
          const sa = this.abilityShapes[a.abilityName];
          const sb = this.abilityShapes[b.abilityName];
          const aLargeRange = sa?.showRange && (sa?.originAtBottom || sa?.dedicatedRender) ? 1 : 0;
          const bLargeRange = sb?.showRange && (sb?.originAtBottom || sb?.dedicatedRender) ? 1 : 0;
          if (aLargeRange !== bLargeRange) return bLargeRange - aLargeRange;
        }
        return (a.layer || 0) - (b.layer || 0);
      });

      // All abilities render at full opacity
      this._abilityOverlapOpacity = null;
      
      // Two-pass rendering for abilities: first draw all range overlays (below),
      // then draw all icons (above). This ensures a moved ability's icon is never
      // covered by another ability's range circle.
      // Pass 1: range overlays only
      this._renderPass = 'range';
      sorted.forEach(el => {
        if (el.type !== 'ability') return;
        if (el.side && el.side !== this.currentSide) return;
        const pos = this.getElementPosition(el);
        ctx.save();
        ctx.translate(pos.x, pos.y);
        // For range shapes, only undo the baseRotation (NOT the defense flip).
        // The defense flip (scale -1,-1) should remain so shapes follow the map orientation.
        const rot = this.mapRotations[this.currentMap];
        if (rot && rot.baseRotation) {
          ctx.rotate(-rot.baseRotation * Math.PI / 180);
        }
        if (el.rotation) {
          ctx.rotate(el.rotation * Math.PI / 180);
        }
        this.renderAbility(ctx, el);
        ctx.restore();
      });

      // Pass 2: icons and everything else
      this._renderPass = 'icon';
      sorted.forEach(el => {
        // Drawing elements (pen/line/arrow/circle/text) always show on both sides,
        // appearing mirrored on the opposite side (same as agents/abilities).
        // No side filter here — the global canvas flip transform handles mirroring.

        // Get current position (interpolated during playback)
        const pos = this.getElementPosition(el);
        
        ctx.save();
        ctx.translate(pos.x, pos.y);
        
        // Counter-rotate for visual elements so they appear upright on rotated/flipped maps
        const needsUpright = ['player', 'agent', 'ability', 'text', 'marker', 'image'].includes(el.type);
        if (needsUpright) {
          const rot = this.mapRotations[this.currentMap];
          if (rot) {
            // Undo flip first (flip is applied after rotation in the parent transform)
            // For abilities: DON'T undo the defense flip so shapes follow the map orientation.
            // Only undo for non-ability elements (agents, text, markers, images).
            if (rot.flipForDefense && this.currentSide === 'defense' && el.type !== 'ability') {
              ctx.scale(-1, -1);
            }
            // Undo rotation
            if (rot.baseRotation) {
              ctx.rotate(-rot.baseRotation * Math.PI / 180);
            }
          }
        }
        
        // Apply rotation only for elements that need direction (not agent images)
        if (el.rotation && el.type !== 'agent' && el.type !== 'player') {
          ctx.rotate(el.rotation * Math.PI / 180);
        }
        
        switch (el.type) {
          case 'player':
            this.renderPlayer(ctx, el);
            break;
          case 'agent':
            this.renderAgent(ctx, el);
            break;
          case 'ability':
            // Playback sync: sincronizar habilidades no mapa com a trajetória do agente
            if (this.isPlaying && el.agentUuid) {
              const syncAgent = this.elements.find(a => (a.type === 'agent' || a.type === 'player') && a.agentUuid === el.agentUuid && a.team === el.team);
              if (syncAgent) {
                const syncPath = this.agentPaths.get(syncAgent.id);
                if (syncPath && syncPath.length >= 2) {
                  // Calcular distância total do path
                  let totalDist = 0;
                  const segDists = [0];
                  for (let si = 1; si < syncPath.length; si++) {
                    totalDist += Math.sqrt((syncPath[si].x - syncPath[si-1].x) ** 2 + (syncPath[si].y - syncPath[si-1].y) ** 2);
                    segDists.push(totalDist);
                  }
                  const pathDuration = (totalDist / this.VANDAL_SPEED_PX_PER_SEC) * 1000;
                  const progress = Math.min(this.timeline.currentTime / pathDuration, 1);
                  const agentDistNow = progress * totalDist;

                  // Encontrar ponto mais próximo da habilidade no path
                  let minDist = Infinity, closestPathDist = 0;
                  for (let si = 1; si < syncPath.length; si++) {
                    const ax = syncPath[si-1].x, ay = syncPath[si-1].y;
                    const bx = syncPath[si].x, by = syncPath[si].y;
                    const dx = bx - ax, dy = by - ay;
                    const lenSq = dx*dx + dy*dy;
                    let t = lenSq > 0 ? ((el.x - ax)*dx + (el.y - ay)*dy) / lenSq : 0;
                    t = Math.max(0, Math.min(1, t));
                    const px = ax + t*dx, py = ay + t*dy;
                    const d = Math.sqrt((el.x - px)**2 + (el.y - py)**2);
                    if (d < minDist) {
                      minDist = d;
                      closestPathDist = segDists[si-1] + t * Math.sqrt(lenSq);
                    }
                  }

                  // Aplicar alpha baseado na posição do agente
                  if (agentDistNow < closestPathDist - 5) {
                    el._playbackActive = false;
                    el._playbackExpired = false;
                  } else if (el.abilityDuration) {
                    const passedTime = (agentDistNow - closestPathDist) / this.VANDAL_SPEED_PX_PER_SEC;
                    if (passedTime <= el.abilityDuration) {
                      el._playbackActive = true;
                      el._playbackExpired = false;
                      el._playbackRemaining = el.abilityDuration - passedTime;
                    } else {
                      el._playbackActive = false;
                      el._playbackExpired = true;
                    }
                  } else {
                    el._playbackActive = true;
                    el._playbackExpired = false;
                  }
                }
              }
            } else {
              el._playbackActive = false;
              el._playbackExpired = false;
              el._playbackRemaining = 0;
            }
            this.renderAbility(ctx, el);
            // Debug: orange hitbox overlay
            if (this._showHitboxDebug) {
              const _hbShape = this.abilityShapes[el.abilityName];
              this._drawHitboxDebug(ctx, _hbShape, el);
            }
            // Draw duration badge below ability icon
            if (this._showAbilityDuration && el.abilityDuration && !(this.abilityShapes[el.abilityName] || {}).noDuration) {
              this.renderAbilityDuration(ctx, el);
            }
            // Countdown durante playback (estilo trajetória)
            if (this._showAbilityDuration && this.isPlaying && el._playbackActive && el._playbackRemaining > 0) {
              const _agentFold = this.getAgentByUuid(el.agentUuid);
              const _fold = _agentFold ? this._normalizeAgentFolder(_agentFold.displayName) : '';
              const _sk = this.abilitySlotMap[el.abilitySlot] || el.abilitySlot || '';
              const _is = this.getAbilityIconSize(_fold, _sk);
              const _h = _is / 2;
              const dispText = el._playbackRemaining.toFixed(1) + 's';
              ctx.font = 'bold 9px Arial';
              const tw = ctx.measureText(dispText).width;
              const bW = tw + 8, bH = 14, bX = -bW/2, bY = _h + 4, r = 3;
              ctx.fillStyle = 'rgba(34, 211, 238, 0.25)';
              ctx.beginPath();
              ctx.moveTo(bX + r, bY);
              ctx.lineTo(bX + bW - r, bY);
              ctx.quadraticCurveTo(bX + bW, bY, bX + bW, bY + r);
              ctx.lineTo(bX + bW, bY + bH - r);
              ctx.quadraticCurveTo(bX + bW, bY + bH, bX + bW - r, bY + bH);
              ctx.lineTo(bX + r, bY + bH);
              ctx.quadraticCurveTo(bX, bY + bH, bX, bY + bH - r);
              ctx.lineTo(bX, bY + r);
              ctx.quadraticCurveTo(bX, bY, bX + r, bY);
              ctx.closePath();
              ctx.fill();
              ctx.fillStyle = '#fff';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillText(dispText, 0, bY + bH / 2);
            }
            break;
          case 'pen':
            this.renderPenPath(ctx, el);
            break;
          case 'line':
          case 'arrow':
            this.renderLineOrArrow(ctx, el);
            break;
          case 'circle':
            this.renderCircle(ctx, el);
            break;
          case 'text':
            this.renderText(ctx, el);
            break;
          case 'image':
            this.renderImageElement(ctx, el);
            break;
          case 'marker':
            this.renderMarker(ctx, el);
            break;
        }
        
        ctx.restore();
      });
      this._renderPass = null;
    },

  renderPlayer(ctx, el) {
      const size = 28;
      const isAlly = el.team === 'ally';
      const isSelected = this.isElementSelected(el);
      
      // Outer glow when selected
      if (isSelected) {
        ctx.shadowColor = isAlly ? 'rgba(34, 211, 238, 0.8)' : 'rgba(239, 68, 68, 0.8)';
        ctx.shadowBlur = 20;
      }
      
      // Circle background with premium gradient
      ctx.beginPath();
      ctx.arc(0, 0, size / 2, 0, Math.PI * 2);
      
      if (isAlly) {
        const gradient = ctx.createRadialGradient(0, -size/4, 0, 0, 0, size/2);
        gradient.addColorStop(0, '#38bdf8');
        gradient.addColorStop(0.7, '#22d3ee');
        gradient.addColorStop(1, '#0ea5e9');
        ctx.fillStyle = gradient;
      } else {
        const gradient = ctx.createRadialGradient(0, -size/4, 0, 0, 0, size/2);
        gradient.addColorStop(0, '#f87171');
        gradient.addColorStop(0.7, '#ef4444');
        gradient.addColorStop(1, '#dc2626');
        ctx.fillStyle = gradient;
      }
      ctx.fill();
      
      // Reset shadow
      ctx.shadowColor = 'transparent';
      ctx.shadowBlur = 0;
      
      // Premium border with double ring
      ctx.strokeStyle = isAlly ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.9)';
      ctx.lineWidth = 2;
      ctx.stroke();
      
      // Outer subtle ring
      ctx.beginPath();
      ctx.arc(0, 0, size / 2 + 3, 0, Math.PI * 2);
      ctx.strokeStyle = isAlly ? 'rgba(34, 211, 238, 0.3)' : 'rgba(239, 68, 68, 0.3)';
      ctx.lineWidth = 1;
      ctx.stroke();
      
      // Player number with premium font
      ctx.fillStyle = 'white';
      ctx.font = '700 13px Inter, Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
      ctx.shadowBlur = 4;
      ctx.fillText(el.number || '?', 0, 1);
      ctx.shadowBlur = 0;
      
      // Direction indicator if has rotation
      if (el.showDirection !== false) {
        ctx.save();
        const arrowDist = size/2 + 6;
        const arrowLen = 14;
        const arrowW = 5;
        
        // Glow effect
        ctx.shadowColor = 'rgba(255, 255, 255, 0.6)';
        ctx.shadowBlur = 8;
        
        // Sleek chevron arrow
        ctx.beginPath();
        ctx.moveTo(arrowDist, 0);
        ctx.lineTo(arrowDist + arrowLen * 0.5, -arrowW);
        ctx.lineTo(arrowDist + arrowLen, 0);
        ctx.lineTo(arrowDist + arrowLen * 0.5, arrowW);
        ctx.closePath();
        
        const arrowGrad = ctx.createLinearGradient(arrowDist, 0, arrowDist + arrowLen, 0);
        arrowGrad.addColorStop(0, 'rgba(255, 255, 255, 0.5)');
        arrowGrad.addColorStop(1, 'rgba(255, 255, 255, 0.95)');
        ctx.fillStyle = arrowGrad;
        ctx.fill();
        
        ctx.shadowBlur = 0;
        ctx.restore();
      }
    },

  renderAgent(ctx, el) {
      const folder = this._normalizeAgentFolder(el.agentName || '');
      const size = this.getAgentIconSize(folder);
      const isSelected = !this.isPlaying && !this.isDrawingPath && this.isElementSelected(el);
      
      const half = size / 2;
      const imgSize = size;
      const imgHalf = imgSize / 2;
      const cornerRadius = 6;

      // Helper: rounded rectangle path
      const roundedRect = (x, y, w, h, r) => {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.lineTo(x + w - r, y);
        ctx.quadraticCurveTo(x + w, y, x + w, y + r);
        ctx.lineTo(x + w, y + h - r);
        ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
        ctx.lineTo(x + r, y + h);
        ctx.quadraticCurveTo(x, y + h, x, y + h - r);
        ctx.lineTo(x, y + r);
        ctx.quadraticCurveTo(x, y, x + r, y);
        ctx.closePath();
      };

      // Fundo colorido por time (azul aliado, vermelho inimigo)
      const isAllyAgent = el.team === 'ally';
      const bgColor = isAllyAgent ? 'rgba(30, 80, 180, 0.85)' : 'rgba(180, 30, 30, 0.85)';
      ctx.save();
      roundedRect(-half, -half, size, size, cornerRadius);
      ctx.fillStyle = bgColor;
      ctx.fill();
      ctx.restore();

      // Ícone do agente dentro (clipped com rounded rect)
      if (el.image) {
        ctx.save();
        roundedRect(-half, -half, size, size, cornerRadius);
        ctx.clip();
        ctx.drawImage(el.image, -imgHalf, -imgHalf, imgSize, imgSize);
        ctx.restore();
      } else {
        // Placeholder texto
        ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
        ctx.font = '600 11px Inter, Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(el.agentName?.substring(0, 2).toUpperCase() || '?', 0, 1);
      }
      
      // ÍCONE DA HABILIDADE USADA - aparece ao lado do personagem
      if (el.activeAbility && el.activeAbilityTime) {
        const elapsed = Date.now() - el.activeAbilityTime;
        if (elapsed < 1500) {
          const iconSize = 22;
          const xPos = size/2 + 10;
          const yPos = -size/2;
          
          ctx.save();
          if (elapsed > 1000) {
            ctx.globalAlpha = 1 - (elapsed - 1000) / 500;
          }
          
          // Premium ability indicator
          ctx.beginPath();
          ctx.arc(xPos, yPos, iconSize/2 + 3, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(10, 15, 25, 1)';
          ctx.fill();
          ctx.strokeStyle = isAllyAgent ? 'rgba(56, 189, 248, 0.8)' : 'rgba(255, 70, 85, 0.8)';
          ctx.lineWidth = 2;
          ctx.stroke();
          
          if (el.activeAbility.image && el.activeAbility.image.complete) {
            ctx.drawImage(el.activeAbility.image, xPos - iconSize/2, yPos - iconSize/2, iconSize, iconSize);
          }
          
          ctx.restore();
        } else {
          el.activeAbility = null;
          el.activeAbilityTime = null;
        }
      }
      
      // (X button removed — use trash bin to delete agents)
    },

  renderAbilityTracks() {
      const container = document.getElementById('vp2-ability-tracks');
      if (!container) return;
      
      // Pega agentes que estão no mapa
      const agentsOnMap = this.elements.filter(el => el.type === 'agent');
      
      if (agentsOnMap.length === 0) {
        container.innerHTML = '<div style="color: #666; font-size: 0.75rem; padding: 8px; text-align: center;">Adicione agentes ao mapa para criar marcadores de habilidade</div>';
        return;
      }
      
      container.innerHTML = agentsOnMap.map(agent => {
        const agentData = this.getAgentByUuid(agent.agentUuid);
        const markers = this.abilityMarkers.get(agent.id) || [];
        markers.forEach(marker => this.refreshAbilityRuntimeVisual(agent.agentUuid, marker.ability));
        
        return `
          <div class="vp2-ability-track" data-agent-id="${agent.id}">
            <div class="vp2-ability-track-agent ${agent.team}" title="${agent.agentName}">
              <img src="${this.getAgentDisplayIcon(agentData) || agent.image?.src || ''}" alt="${agent.agentName}">
            </div>
            <div class="vp2-ability-track-timeline" data-agent-id="${agent.id}">
              ${markers.map((m, idx) => {
                const leftPercent = (m.time / this.timeline.duration) * 100;
                const hasPos = m.mapPosition ? ' style="border-color: #22d3ee;"' : '';
                const posInfo = m.mapPosition ? ' 📍 Posicionada no mapa' : '';
                const durInfo = m.ability.duration ? ` (${m.ability.duration}s)` : '';
                return `
                  <div class="vp2-ability-marker" 
                       style="left: ${leftPercent}%${m.mapPosition ? '; border-color: #22d3ee;' : ''}"
                       data-marker-index="${idx}"
                       data-agent-id="${agent.id}"
                       title="${m.ability.name}${durInfo} - ${Math.round(m.time/1000)}s${posInfo} (clique direito para remover)">
                    <img src="${m.ability.icon || ''}" onerror="this.style.display='none'">
                    ${m.mapPosition ? '<span style="position:absolute;bottom:-3px;right:-3px;width:6px;height:6px;background:#22d3ee;border-radius:50%;"></span>' : ''}
                  </div>
                `;
              }).join('')}
            </div>
          </div>
        `;
      }).join('');
      
      // Adiciona eventos de clique nas timelines
      container.querySelectorAll('.vp2-ability-track-timeline').forEach(timeline => {
        // Clique esquerdo = adicionar marcador
        timeline.addEventListener('click', (e) => {
          if (e.target.closest('.vp2-ability-marker')) return; // Ignora clique em marcador existente
          
          const agentId = timeline.dataset.agentId;
          const rect = timeline.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          const percent = clickX / rect.width;
          const timeMs = percent * this.timeline.duration;
          
          this.showAbilityMenuForTimeline(agentId, timeMs, e.clientX, e.clientY);
        });
      });
      
      // Clique direito em marcador = remover
      container.querySelectorAll('.vp2-ability-marker').forEach(marker => {
        marker.addEventListener('contextmenu', (e) => {
          e.preventDefault();
          const agentId = marker.dataset.agentId;
          const markerIndex = parseInt(marker.dataset.markerIndex);
          this.removeAbilityMarker(agentId, markerIndex);
        });
      });
    },

  renderPlacedAbilities() {
      const ctx = this.ctx;
      const currentTime = this.timeline.currentTime;
      const isPlaying = this.isPlaying;

      this.abilityMarkers.forEach((markers, agentId) => {
        if (!markers) return;

        // Determine agent path color for ring (sincronizado com trajetória)
        const agentEl = this.elements.find(el => el.id === agentId && el.type === 'agent');
        const ringColor = agentEl?.agentUuid ? this.getAgentPathColor(agentEl.agentUuid) : (agentEl?.team === 'enemy' ? '#ef4444' : '#22d3ee');

        markers.forEach(marker => {
          if (!marker.mapPosition) return; // Só renderiza se tem posição no mapa
          this.refreshAbilityRuntimeVisual(agentEl?.agentUuid, marker.ability);

          const pos = marker.mapPosition;
          const ability = marker.ability;
          const duration = ability.duration;
          const agentFolder = agentEl?.agentName ? this._normalizeAgentFolder(agentEl.agentName) : '';
          const slotKey = this.getAbilitySlotKey(ability.slot);
          const iconSize = this.getAbilityIconSize(agentFolder, slotKey);
          const half = iconSize / 2;

          // Determinar visibilidade e estado
          let alpha = 1;
          let isActive = false;
          let isExpired = false;
          let showCountdown = false;
          let remaining = duration;

          if (isPlaying) {
            if (currentTime < marker.time) {
              // Ainda não ativou — mostrar fantasma
              alpha = 0.25;
            } else if (duration && currentTime <= marker.time + (duration * 1000)) {
              // Ativo — está dentro da duração
              isActive = true;
              showCountdown = true;
              remaining = duration - (currentTime - marker.time) / 1000;
            } else if (duration && currentTime > marker.time + (duration * 1000)) {
              // Expirou — manter visível mas como finalizado
              isExpired = true;
              alpha = 0.35;
            } else if (!duration && currentTime >= marker.time) {
              // Sem duração — permanece ativo
              isActive = true;
            }
          }

          ctx.save();
          ctx.globalAlpha = alpha;
          
          // Counter-rotate at the ability position so shapes follow the map
          ctx.translate(pos.x, pos.y);
          const _rot = this.mapRotations[this.currentMap];
          if (_rot) {
            // Don't undo flip for abilities — shapes should follow map orientation
            if (_rot.baseRotation) ctx.rotate(-_rot.baseRotation * Math.PI / 180);
          }

          this.renderAbilityRangeOverlay(ctx, ability.name || ability.displayName, alpha);

          const _abilityShape = this.abilityShapes[ability.name || ability.displayName];
          const _hasRange = _abilityShape?.showRange && (_abilityShape?.gameRadius || (_abilityShape?.gameWidth && _abilityShape?.gameHeight));

          // Active glow (sem fundo preto)
          if (isActive && duration) {
            ctx.beginPath();
            ctx.arc(0, 0, half + 8, 0, Math.PI * 2);
            ctx.strokeStyle = ringColor.replace(/[\d.]+\)$/, '0.25)');
            ctx.lineWidth = 2;
            ctx.stroke();
            ctx.closePath();

            // Progress ring (countdown arc)
            if (showCountdown && remaining > 0) {
              const progress = remaining / duration;
              ctx.beginPath();
              ctx.arc(0, 0, half + 4, -Math.PI / 2, -Math.PI / 2 + (Math.PI * 2 * progress), false);
              ctx.strokeStyle = ringColor;
              ctx.lineWidth = 3;
              ctx.lineCap = 'round';
              ctx.stroke();
            }
          }

          // Dark circle background (lineups style)
          ctx.beginPath();
          ctx.arc(0, 0, half + 2, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(0, 0, 0, 0.9)';
          ctx.fill();
          ctx.closePath();

          // Colored border ring (lineups style) — skip for abilities with range overlay
          if (!isExpired && !_hasRange) {
            ctx.beginPath();
            ctx.arc(0, 0, half + 2, 0, Math.PI * 2);
            ctx.strokeStyle = ringColor;
            ctx.lineWidth = 2.5;
            ctx.stroke();
            ctx.closePath();

            // Subtle glow
            ctx.shadowColor = ringColor;
            ctx.shadowBlur = 6;
            ctx.beginPath();
            ctx.arc(0, 0, half + 2, 0, Math.PI * 2);
            ctx.strokeStyle = 'transparent';
            ctx.stroke();
            ctx.shadowBlur = 0;
            ctx.shadowColor = 'transparent';
          }

          // Ability icon (clipped to circle)
          if (ability.image && ability.image.complete && ability.image.naturalWidth > 0) {
            ctx.save();
            ctx.beginPath();
            ctx.arc(0, 0, half - 1, 0, Math.PI * 2);
            ctx.clip();
            ctx.drawImage(ability.image, -half + 1, -half + 1, iconSize - 2, iconSize - 2);
            ctx.restore();
          } else {
            ctx.fillStyle = '#fff';
            ctx.font = 'bold 12px Arial';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(ability.slot || '?', 0, 0);
          }

          // Duration countdown — só durante playback quando ativa
          if (isPlaying && showCountdown && duration && remaining > 0) {
            const displayText = remaining.toFixed(1) + 's';

            ctx.font = 'bold 9px Arial';
            const tw = ctx.measureText(displayText).width;
            const badgeW = tw + 8;
            const badgeH = 14;
            const badgeX = -badgeW / 2;
            const badgeY = half + 5;

            ctx.fillStyle = ringColor.replace(/[\d.]+\)$/, '0.25)');
            ctx.beginPath();
            const r = 3;
            ctx.moveTo(badgeX + r, badgeY);
            ctx.lineTo(badgeX + badgeW - r, badgeY);
            ctx.quadraticCurveTo(badgeX + badgeW, badgeY, badgeX + badgeW, badgeY + r);
            ctx.lineTo(badgeX + badgeW, badgeY + badgeH - r);
            ctx.quadraticCurveTo(badgeX + badgeW, badgeY + badgeH, badgeX + badgeW - r, badgeY + badgeH);
            ctx.lineTo(badgeX + r, badgeY + badgeH);
            ctx.quadraticCurveTo(badgeX, badgeY + badgeH, badgeX, badgeY + badgeH - r);
            ctx.lineTo(badgeX, badgeY + r);
            ctx.quadraticCurveTo(badgeX, badgeY, badgeX + r, badgeY);
            ctx.closePath();
            ctx.fill();

            ctx.fillStyle = '#fff';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(displayText, 0, badgeY + badgeH / 2);
          }

          ctx.restore();
        });
      });

      // Placement mode preview — show crosshair at cursor
      if (this.abilityPlacementMode && this._lastCanvasMousePos) {
        ctx.save();
        const mp = this._lastCanvasMousePos;
        ctx.strokeStyle = 'rgba(34, 211, 238, 0.6)';
        ctx.lineWidth = 1;
        ctx.setLineDash([4, 4]);
        // Crosshair
        ctx.beginPath();
        ctx.moveTo(mp.x - 15, mp.y);
        ctx.lineTo(mp.x + 15, mp.y);
        ctx.moveTo(mp.x, mp.y - 15);
        ctx.lineTo(mp.x, mp.y + 15);
        ctx.stroke();
        ctx.setLineDash([]);
        // Circle
        ctx.beginPath();
        ctx.arc(mp.x, mp.y, 20, 0, Math.PI * 2);
        ctx.stroke();
        ctx.restore();
      }


    },

  renderAbility(ctx, el) {
      // Force full opacity for all abilities
      ctx.globalAlpha = 1;
      const shape = this.abilityShapes[el.abilityName];
      const mapScale = this.getCurrentMapScale();
      const abilityOpacity = (this._abilityOverlapOpacity && this._abilityOverlapOpacity.has(el.id))
        ? this._abilityOverlapOpacity.get(el.id) : 1;
      const isDraggingThisAbility = this.isDragging && this.selectedElement && this.selectedElement.id === el.id;
        const usesDedicatedShapeRender =
          shape?.dedicatedRender === true ||
          shape?.shape === 'astra-wall' ||
          shape?.shape === 'viper-wall' ||
          shape?.shape === 'phoenix-wall' ||
          shape?.shape === 'tripwire' ||
          shape?.shape === 'barrier-mesh' ||
          shape?.shape === 'cyber-cage' ||
          shape?.shape === 'relay-bolt' ||
          shape?.shape === 'vyse-wall' ||
          shape?.shape === 'fast-lane' ||
          shape?.shape === 'harbor-wall' ||
          (shape?.shape === 'rect' && shape?.originAtBottom && shape?.showRange);
      
      // Draw real-scale range circle BEFORE the ability icon (game-accurate per-map)
        if (shape && !el._isDragPreview) {
          if (this._renderPass === 'range') {
            this.renderAbilityRangeOverlay(ctx, el.abilityName, abilityOpacity, el.abilityScale || 1.0);
            return; // Range pass done — icon will be drawn in 'icon' pass
          }
        } else if (this._renderPass === 'range') {
          return; // Nothing to draw in range pass
        }
      
      const agent = el.agentUuid ? this.getAgentByUuid(el.agentUuid) : null;
      const agentName = agent ? agent.displayName : '';
      const shapeType = shape && shape.shape;
      const slotKey = this.getAbilitySlotKey(el.abilitySlot);
      const forceKayOApiCenterIcon = agentName === 'KAY/O' && (el.abilityName === 'ZERO/point' || el.abilityName === 'NULL/cmd' || el.abilityName === 'PONTO/zero' || el.abilityName === 'ANULAR/cmd');

      if (forceKayOApiCenterIcon && agent?.abilities?.length) {
        const apiAbility = agent.abilities.find(ab => ab.slot === el.abilitySlot);
        if (apiAbility?.displayIcon) {
          if (el.abilityIcon !== apiAbility.displayIcon) {
            el.abilityIcon = apiAbility.displayIcon;
            el._abilityImg = null;
            el._abilityImgFailed = false;
          }
          el.customIconImage = null;
          el._trimmedIcon = null;
        }
      }

      // Check if this ability has a custom uploaded icon (from /uploads path)
      // Also dynamically check for custom uploads even if el.abilityIcon is an API URL
      let hasCustomUploadedIcon = !forceKayOApiCenterIcon && el.abilityIcon && el.abilityIcon.startsWith('/uploads/');
      if (!hasCustomUploadedIcon && agentName && el.abilitySlot) {
        const customIcon = this.getCustomAbilityIcon(agentName, el.abilitySlot);
        if (customIcon && !forceKayOApiCenterIcon) {
          el.abilityIcon = customIcon;
          hasCustomUploadedIcon = true;
        }
      }
      
      // Shapes with dedicated gameplay rendering must not be overridden by uploaded icons.
      if (usesDedicatedShapeRender) {
        hasCustomUploadedIcon = false;
      }
      
      // Check if this ability has an external icon URL (e.g. valorant-api.com)
      const hasExternalIcon = !hasCustomUploadedIcon && !usesDedicatedShapeRender && el.abilityIcon && (el.abilityIcon.startsWith('http://') || el.abilityIcon.startsWith('https://'));
      
      // Se tiver imagem personalizada uploadada, desenhar sem contorno (área de efeito custom)
      if (hasCustomUploadedIcon) {
        const folder = agent ? this._normalizeAgentFolder(agent.displayName) : '';
        const size = this.getAbilityIconSize(folder, slotKey);
        const preserveRawUpload = agentName === 'Sage' && slotKey === 'C';

        // Session restore can bring plain objects in runtime image fields.
        if (el.customIconImage && !this.isCanvasImageObject(el.customIconImage)) {
          el.customIconImage = null;
        }
        if (el._trimmedIcon && !this.isCanvasImageObject(el._trimmedIcon)) {
          el._trimmedIcon = null;
        }
        
        if (!el.customIconImage) {
          el.customIconImage = new Image();
          el.customIconImage.crossOrigin = 'anonymous';
          el.customIconImage.onload = () => {
            try {
              if (preserveRawUpload) {
                this.render();
                return;
              }
              const img = el.customIconImage;
              const tc = document.createElement('canvas');
              tc.width = img.naturalWidth;
              tc.height = img.naturalHeight;
              const tctx = tc.getContext('2d');
              tctx.drawImage(img, 0, 0);
              const idata = tctx.getImageData(0, 0, tc.width, tc.height);
              const d = idata.data;
              const w = tc.width, h = tc.height;

              const cornerPixels = [];
              const sampleSize = Math.max(3, Math.floor(Math.min(w, h) * 0.05));
              for (let sy = 0; sy < sampleSize; sy++) {
                for (let sx = 0; sx < sampleSize; sx++) {
                  cornerPixels.push((sy * w + sx) * 4);
                  cornerPixels.push((sy * w + (w - 1 - sx)) * 4);
                  cornerPixels.push(((h - 1 - sy) * w + sx) * 4);
                  cornerPixels.push(((h - 1 - sy) * w + (w - 1 - sx)) * 4);
                }
              }
              
              let rSum = 0, gSum = 0, bSum = 0, count = 0;
              for (const idx of cornerPixels) {
                if (d[idx + 3] > 100) {
                  rSum += d[idx]; gSum += d[idx + 1]; bSum += d[idx + 2];
                  count++;
                }
              }
              
              if (count > 0) {
                const bgR = rSum / count, bgG = gSum / count, bgB = bSum / count;
                const brightness = (bgR + bgG + bgB) / 3;
                
                if (brightness > 160) {
                  const tolerance = 60;
                  for (let i = 0; i < d.length; i += 4) {
                    const r = d[i], g = d[i + 1], b = d[i + 2], a = d[i + 3];
                    if (a < 10) continue;
                    const dr = Math.abs(r - bgR);
                    const dg = Math.abs(g - bgG);
                    const db = Math.abs(b - bgB);
                    if (dr < tolerance && dg < tolerance && db < tolerance) {
                      d[i + 3] = 0;
                    } else if (dr < tolerance * 1.5 && dg < tolerance * 1.5 && db < tolerance * 1.5) {
                      const maxDiff = Math.max(dr, dg, db);
                      const factor = Math.min(1, (maxDiff - tolerance) / (tolerance * 0.5));
                      d[i + 3] = Math.round(a * factor);
                    }
                  }
                  tctx.putImageData(idata, 0, 0);
                }
              }
              
              const idata2 = tctx.getImageData(0, 0, w, h);
              const d2 = idata2.data;
              let top = h, left = w, bottom = 0, right = 0;
              for (let y = 0; y < h; y++) {
                for (let x = 0; x < w; x++) {
                  if (d2[(y * w + x) * 4 + 3] > 20) {
                    if (y < top) top = y;
                    if (y > bottom) bottom = y;
                    if (x < left) left = x;
                    if (x > right) right = x;
                  }
                }
              }
              
              if (bottom >= top && right >= left) {
                const tw = right - left + 1;
                const th = bottom - top + 1;
                const trimmed = document.createElement('canvas');
                trimmed.width = tw;
                trimmed.height = th;
                const trimCtx = trimmed.getContext('2d');
                trimCtx.putImageData(tctx.getImageData(left, top, tw, th), 0, 0);
                el._trimmedIcon = trimmed;
              }
            } catch(e) {
              console.warn('Image processing failed:', e);
            }
            this.render();
          };
          el.customIconImage.onerror = () => {
            console.error('Failed to load custom icon:', el.abilityIcon);
            el._customIconFailed = true;
            el.customIconImage = null;
            this.render();
          };
          el.customIconImage.src = el.abilityIcon;
        }

        // If custom icon failed, fall through to external/shape rendering
        if (el._customIconFailed) {
          // Restore API icon and let the code below handle it
          const apiAbility = agent?.abilities?.find(ab => ab.slot === el.abilitySlot);
          if (apiAbility?.displayIcon) {
            el.abilityIcon = apiAbility.displayIcon;
          }
          // Reset flags so we don't loop
          el._customIconFailed = false;
          // Clear image caches so external path creates fresh Image
          el._abilityImg = null;
          el._abilityImgFailed = false;
          el._fallbackImg = null;
          el._fallbackImgFailed = false;
          // Fall through — don't return
        } else {
        const customIconSource = this.isCanvasImageReady(el.customIconImage) ? el.customIconImage : null;
        const trimmedIconSource = this.isCanvasImageReady(el._trimmedIcon) ? el._trimmedIcon : null;
        const src = preserveRawUpload
          ? customIconSource
          : (trimmedIconSource || customIconSource);
        if (src) {
          const half = size / 2;

          // When the icon fills the full range area, reduce opacity to avoid cluttering the map
          const _fillsRange = !!(shape?.showRange && (shape?.gameWidth && shape?.gameHeight));
          ctx.save();
          ctx.globalAlpha = 1;

          // Small icons (≤ 200px) get ring outline like API icons
          const origW = el.customIconImage?.naturalWidth || 0;
          const origH = el.customIconImage?.naturalHeight || 0;
          const isAbilityManagerUpload = !!el.abilityIcon && el.abilityIcon.startsWith('/uploads/abilities/');
          const preserveUploadedAspect = (agentName === 'Sage' && slotKey === 'C') || (agentName === 'Breach' && (slotKey === 'C' || slotKey === 'E'));
          const isSmallIcon = !preserveUploadedAspect && (isAbilityManagerUpload || (origW > 0 && origW <= 200 && origH > 0 && origH <= 200));

          if (isSmallIcon) {
            if (isAbilityManagerUpload) {
              if (shape?.iconBg) {
                // Dark rounded background when iconBg is set
                const _radU = Math.max(4, half * 0.25);
                ctx.beginPath();
                ctx.moveTo(-half - 1 + _radU, -half - 1);
                ctx.arcTo(half + 1, -half - 1, half + 1, half + 1, _radU);
                ctx.arcTo(half + 1, half + 1, -half - 1, half + 1, _radU);
                ctx.arcTo(-half - 1, half + 1, -half - 1, -half - 1, _radU);
                ctx.arcTo(-half - 1, -half - 1, half + 1, -half - 1, _radU);
                ctx.closePath();
                ctx.fillStyle = 'rgba(10, 15, 25, 1)';
                ctx.fill();
                ctx.shadowColor = 'rgba(255, 255, 255, 0.5)';
                ctx.shadowBlur = 6;
                ctx.drawImage(src, -half, -half, size, size);
                ctx.shadowBlur = 0;
              } else {
              // Uploaded icons (valoplant.gg) — no ring, just icon clipped to circle
              ctx.beginPath();
              ctx.arc(0, 0, half, 0, Math.PI * 2);
              ctx.clip();
              ctx.drawImage(src, -half, -half, size, size);
              }
            } else {
            const ringColor = this.getAgentPathColor(el.agentUuid);
            const _hasRangeSmall = shape?.showRange && (shape?.gameRadius || (shape?.gameWidth && shape?.gameHeight));

            // Dark rounded background
            const _radS = Math.max(4, half * 0.25);
            ctx.beginPath();
            ctx.moveTo(-half - 1 + _radS, -half - 1);
            ctx.arcTo(half + 1, -half - 1, half + 1, half + 1, _radS);
            ctx.arcTo(half + 1, half + 1, -half - 1, half + 1, _radS);
            ctx.arcTo(-half - 1, half + 1, -half - 1, -half - 1, _radS);
            ctx.arcTo(-half - 1, -half - 1, half + 1, -half - 1, _radS);
            ctx.closePath();
            ctx.fillStyle = 'rgba(10, 15, 25, 1)';
            ctx.fill();

            // Premium white glow
            ctx.shadowColor = 'rgba(255, 255, 255, 0.5)';
            ctx.shadowBlur = 6;
            // Icon at full size
            ctx.drawImage(src, -half, -half, size, size);
            ctx.shadowBlur = 0;
            }
          } else {
            let drawWidth = size;
            let drawHeight = size;

            if (preserveUploadedAspect) {
              const srcWidth = src.width || origW || size;
              const srcHeight = src.height || origH || size;
              const aspect = srcHeight > 0 ? (srcWidth / srcHeight) : 1;
              const maxDimension = Math.max(shape?.width || 0, shape?.height || 0, size);
              if (aspect >= 1) {
                drawWidth = maxDimension;
                drawHeight = maxDimension / aspect;
              } else {
                drawHeight = maxDimension;
                drawWidth = maxDimension * aspect;
              }
            } else

            if (shape?.showRange && shape?.gameWidth && shape?.gameHeight) {
              const mapSize = this._mapSize;
              drawWidth = shape.gameWidth * 100 * mapScale * mapSize;
              drawHeight = shape.gameHeight * 100 * mapScale * mapSize;
            } else if (shapeType === 'circle' && shape?.gameRadius && !(shape?.showRange && Array.isArray(shape?.rangeOverlays) && shape.rangeOverlays.length)) {
              const mapSize = this._mapSize;
              const diameter = shape.gameRadius * 2 * 100 * mapScale * mapSize;
              drawWidth = diameter;
              drawHeight = diameter;
            } else if (shapeType === 'rect' && shape?.width && shape?.height) {
              const _scaleR = size / 26;
              drawWidth = shape.width * _scaleR;
              drawHeight = shape.height * _scaleR;
            } else if (shapeType === 'wall' && shape?.length && shape?.width) {
              const _scaleW = size / 26;
              drawWidth = shape.length * _scaleW;
              drawHeight = shape.width * _scaleW;
            } else if (shapeType === 'cone' && shape?.width && shape?.height) {
              const _scaleC = size / 26;
              drawWidth = shape.width * _scaleC;
              drawHeight = shape.height * _scaleC;
            }

            if (shape?.scalable && el.abilityScale != null && el.abilityScale !== 1.0) {
              drawHeight *= el.abilityScale;
            }
            if (shape?.originAtBottom) {
              ctx.drawImage(src, -drawWidth / 2, -drawHeight, drawWidth, drawHeight);
            } else {
              ctx.drawImage(src, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);
            }
          }

          this._drawDragHandle(ctx, shape, el);
          ctx.globalAlpha = 1;
          ctx.restore();
          // Draw rotation handle AFTER restore so it's not clipped by the icon circle
          this._drawRotationHandle(ctx, shape, el);
        }
        return;
        } // end else (_customIconFailed)
      }

      // Re-check external icon after possible custom→API fallback
      const hasExternalIconFb = !usesDedicatedShapeRender && el.abilityIcon && (el.abilityIcon.startsWith('http://') || el.abilityIcon.startsWith('https://'));
      
      // Se tiver URL de ícone externo (valorant-api ou outro) — renderizar com design de lineups
      if (hasExternalIcon || hasExternalIconFb) {
        const _agent = this.getAgentByUuid(el.agentUuid);
        const _folder = _agent ? this._normalizeAgentFolder(_agent.displayName) : '';
        const _slotKey = this.getAbilitySlotKey(el.abilitySlot);
        const iconSize = this.getAbilityIconSize(_folder, _slotKey);
        const half = iconSize / 2;
        const ringColor = this.getAgentPathColor(el.agentUuid);
        
        // Carregar imagem se ainda não foi carregada
        if (!el._abilityImg) {
          el._abilityImg = new Image();
          el._abilityImg.crossOrigin = 'anonymous';
          el._abilityImg.onload = () => this.render();
          el._abilityImg.onerror = () => { el._abilityImgFailed = true; this.render(); };
          el._abilityImg.src = el.abilityIcon;
        }
        
        const _hasRangeExt = shape?.showRange && (shape?.gameRadius || (shape?.gameWidth && shape?.gameHeight));
        const _skipBgExt = shape?.noBgBox;

        ctx.save();
        ctx.globalAlpha = 1;
        
        // Dark rounded background for ability icon (skip if has range overlay or noBgBox)
        if (!_skipBgExt) {
          const _rad = Math.max(4, half * 0.25);
          ctx.beginPath();
          ctx.moveTo(-half - 1 + _rad, -half - 1);
          ctx.arcTo(half + 1, -half - 1, half + 1, half + 1, _rad);
          ctx.arcTo(half + 1, half + 1, -half - 1, half + 1, _rad);
          ctx.arcTo(-half - 1, half + 1, -half - 1, -half - 1, _rad);
          ctx.arcTo(-half - 1, -half - 1, half + 1, -half - 1, _rad);
          ctx.closePath();
          ctx.fillStyle = shape?.lightBg ? 'rgba(10, 15, 25, 0.1)' : 'rgba(10, 15, 25, 1)';
          ctx.fill();
        }
        
        // Icon at full size with premium white glow
        if (el._abilityImg && el._abilityImg.complete && el._abilityImg.naturalWidth > 0) {
          ctx.shadowColor = 'rgba(255, 255, 255, 0.5)';
          ctx.shadowBlur = 6;
          ctx.drawImage(el._abilityImg, -half, -half, iconSize, iconSize);
          ctx.shadowBlur = 0;
        } else if (!el._abilityImgFailed) {
          // Loading placeholder
          ctx.fillStyle = 'rgba(255, 255, 255, 0.3)';
          ctx.font = 'bold 10px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText('...', 0, 0);
        } else {
          // Failed — show slot letter
          ctx.fillStyle = '#fff';
          ctx.font = 'bold 12px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(this.abilitySlotMap[el.abilitySlot] || '?', 0, 0);
        }
        
        ctx.globalAlpha = 1;
        ctx.restore();

        // Draw shape outline for non-dedicated rect/flash/dash/circle abilities
        // so the user can see the ability's area of effect and orientation
        if (shape && shape.shape === 'rect' && shape.width && shape.height && !shape.showRange) {
          const _agSz = this.getAgentByUuid(el.agentUuid);
          const _flSz = _agSz ? this._normalizeAgentFolder(_agSz.displayName) : '';
          const _skSz = this.getAbilitySlotKey(el.abilitySlot);
          const _szR = this.getAbilityIconSize(_flSz, _skSz) / 26;
          const _rwO = shape.width * _szR;
          const _rhO = shape.height * _szR;
          ctx.save();
          ctx.strokeStyle = shape.color ? shape.color.replace(/[\d.]+\)$/, '0.6)') : 'rgba(200, 200, 200, 0.6)';
          ctx.lineWidth = 2;
          ctx.strokeRect(-_rwO / 2, -_rhO / 2, _rwO, _rhO);
          ctx.restore();
        }

        // Draw rotation/drag handles for all rotatable/scalable abilities
        this._drawRotationHandle(ctx, shape, el);
        this._drawDragHandle(ctx, shape, el);
        return;
      }
      
      // Se tiver imagem do ícone da habilidade com shape icon-image, renderizar com ring style
      if (el.abilityIcon && shape?.shape === 'icon-image') {
        const _agentSh = this.getAgentByUuid(el.agentUuid);
        const _folderSh = _agentSh ? this._normalizeAgentFolder(_agentSh.displayName) : '';
        const _slotKeySh = this.getAbilitySlotKey(el.abilitySlot);
        const iconSize = this.getAbilityIconSize(_folderSh, _slotKeySh);
        const half = iconSize / 2;
        const ringColor = this.getAgentPathColor(el.agentUuid);
        
        if (!el.iconImage) {
          el.iconImage = new Image();
          el.iconImage.crossOrigin = 'anonymous';
          el.iconImage.onload = () => this.render();
          el.iconImage.onerror = () => { el._iconImgFailed = true; this.render(); };
          el.iconImage.src = el.abilityIcon;
        }
        
        const _hasRangeIcon = shape?.showRange && (shape?.gameRadius || (shape?.gameWidth && shape?.gameHeight));

        ctx.save();
        ctx.globalAlpha = 1;
        
        if (!_hasRangeIcon) {
          const _radI = Math.max(4, half * 0.25);
          ctx.beginPath();
          ctx.moveTo(-half - 1 + _radI, -half - 1);
          ctx.arcTo(half + 1, -half - 1, half + 1, half + 1, _radI);
          ctx.arcTo(half + 1, half + 1, -half - 1, half + 1, _radI);
          ctx.arcTo(-half - 1, half + 1, -half - 1, -half - 1, _radI);
          ctx.arcTo(-half - 1, -half - 1, half + 1, -half - 1, _radI);
          ctx.closePath();
          ctx.fillStyle = 'rgba(10, 15, 25, 1)';
          ctx.fill();
        }
        
        if (el.iconImage && el.iconImage.complete && el.iconImage.naturalWidth > 0) {
          ctx.shadowColor = 'rgba(255, 255, 255, 0.5)';
          ctx.shadowBlur = 6;
          ctx.drawImage(el.iconImage, -half, -half, iconSize, iconSize);
          ctx.shadowBlur = 0;
        } else if (el._iconImgFailed) {
          ctx.fillStyle = '#fff';
          ctx.font = 'bold 12px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(this.abilitySlotMap[el.abilitySlot] || '?', 0, 0);
        }
        
        ctx.globalAlpha = 1;
        ctx.restore();
        return;
      }
      
      if (!shape) {
        // Default ring style for unknown abilities (lineups design)
        const _agentFb = this.getAgentByUuid(el.agentUuid);
        const _folderFb = _agentFb ? this._normalizeAgentFolder(_agentFb.displayName) : '';
        const _slotKeyFb = this.getAbilitySlotKey(el.abilitySlot);
        const iconSize = this.getAbilityIconSize(_folderFb, _slotKeyFb);
        const half = iconSize / 2;
        const ringColor = this.getAgentPathColor(el.agentUuid);
        
        ctx.save();
        ctx.globalAlpha = 1;
        
        // Dark rounded background
        const _radF = Math.max(4, half * 0.25);
        ctx.beginPath();
        ctx.moveTo(-half - 1 + _radF, -half - 1);
        ctx.arcTo(half + 1, -half - 1, half + 1, half + 1, _radF);
        ctx.arcTo(half + 1, half + 1, -half - 1, half + 1, _radF);
        ctx.arcTo(-half - 1, half + 1, -half - 1, -half - 1, _radF);
        ctx.arcTo(-half - 1, -half - 1, half + 1, -half - 1, _radF);
        ctx.closePath();
        ctx.fillStyle = 'rgba(10, 15, 25, 1)';
        ctx.fill();
        
        // Try loading icon if available
        if (el.abilityIcon && !el._fallbackImg) {
          el._fallbackImg = new Image();
          el._fallbackImg.crossOrigin = 'anonymous';
          el._fallbackImg.onload = () => this.render();
          el._fallbackImg.onerror = () => { el._fallbackImgFailed = true; this.render(); };
          el._fallbackImg.src = el.abilityIcon;
        }
        
        if (el._fallbackImg && el._fallbackImg.complete && el._fallbackImg.naturalWidth > 0) {
          ctx.shadowColor = 'rgba(255, 255, 255, 0.5)';
          ctx.shadowBlur = 6;
          ctx.drawImage(el._fallbackImg, -half, -half, iconSize, iconSize);
          ctx.shadowBlur = 0;
        } else {
          // Slot letter fallback
          ctx.fillStyle = '#fff';
          ctx.font = 'bold 12px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(this.abilitySlotMap[el.abilitySlot] || '?', 0, 0);
        }
        
        ctx.globalAlpha = 1;
        ctx.restore();
        return;
      }
      
      // Draw game-accurate rect range for abilities with gameWidth/gameHeight
      if (shape.gameWidth && shape.gameHeight && shape.showRange && !usesDedicatedShapeRender && !el._isDragPreview && !isDraggingThisAbility) {
        const mapSize = this._mapSize;
        const rw = shape.gameWidth * 100 * mapScale * mapSize;
        const rh = shape.gameHeight * 100 * mapScale * mapSize;
        ctx.save();
        ctx.globalAlpha = 1;
        ctx.fillStyle = shape.color || 'rgba(200, 160, 40, 0.3)';
        ctx.fillRect(-rw/2, -rh/2, rw, rh);
        ctx.globalAlpha = 1;
        ctx.strokeStyle = shape.color ? shape.color.replace(/[\d.]+\)$/, '0.8)') : 'rgba(200, 160, 40, 0.8)';
        ctx.lineWidth = 2;
        ctx.strokeRect(-rw/2, -rh/2, rw, rh);
        ctx.restore();
      }

      ctx.globalAlpha = 1;
      
      // Force dark-bg icon style for all non-dedicated abilities
      // This ensures all abilities look like the Alarme Robô style (dark bg + white glow icon)
      if (!usesDedicatedShapeRender) {
        const _agFb2 = this.getAgentByUuid(el.agentUuid);
        const _flFb2 = _agFb2 ? this._normalizeAgentFolder(_agFb2.displayName) : '';
        const _skFb2 = this.getAbilitySlotKey(el.abilitySlot);
        const _isFb2 = this.getAbilityIconSize(_flFb2, _skFb2);
        const _hfFb2 = _isFb2 / 2;
        // Resolve icon: prefer API icon (el.abilityIcon), fallback to ability API data
        let _iconUrl = el.abilityIcon || '';
        if (!_iconUrl && _agFb2?.abilities) {
          const _abData = _agFb2.abilities.find(ab => ab.slot === el.abilitySlot);
          if (_abData?.displayIcon) _iconUrl = _abData.displayIcon;
        }
        if (!el._abilityImg || el._abilityImgSrc2 !== _iconUrl) {
          el._abilityImg = new Image();
          el._abilityImg.crossOrigin = 'anonymous';
          el._abilityImg.onload = () => this.render();
          el._abilityImg.onerror = () => { el._abilityImgFailed = true; this.render(); };
          el._abilityImgSrc2 = _iconUrl;
          if (_iconUrl) el._abilityImg.src = _iconUrl;
        }
        ctx.save();
        ctx.globalAlpha = 1;
        // Skip dark bg box for abilities with noBgBox flag or circle shapes with game-scale range
        const _shapeForBg = this.abilityShapes[el.abilityName] || shape;
        const _hasBigRange = _shapeForBg && _shapeForBg.gameRadius && _shapeForBg.showRange;
        const _skipBgBox = (_shapeForBg && _shapeForBg.noBgBox);
        if (_skipBgBox) {
          // No bg box — icon rendered directly over the range overlay
        } else {
          const _rad = Math.max(4, _hfFb2 * 0.25);
          ctx.beginPath();
          ctx.moveTo(-_hfFb2 - 1 + _rad, -_hfFb2 - 1);
          ctx.arcTo(_hfFb2 + 1, -_hfFb2 - 1, _hfFb2 + 1, _hfFb2 + 1, _rad);
          ctx.arcTo(_hfFb2 + 1, _hfFb2 + 1, -_hfFb2 - 1, _hfFb2 + 1, _rad);
          ctx.arcTo(-_hfFb2 - 1, _hfFb2 + 1, -_hfFb2 - 1, -_hfFb2 - 1, _rad);
          ctx.arcTo(-_hfFb2 - 1, -_hfFb2 - 1, _hfFb2 + 1, -_hfFb2 - 1, _rad);
          ctx.closePath();
          ctx.fillStyle = (_shapeForBg && _shapeForBg.lightBg) ? 'rgba(10, 15, 25, 0.1)' : 'rgba(10, 15, 25, 1)';
          ctx.fill();
        }
        if (el._abilityImg && el._abilityImg.complete && el._abilityImg.naturalWidth > 0) {
          ctx.shadowColor = 'rgba(255, 255, 255, 0.5)';
          ctx.shadowBlur = 6;
          ctx.drawImage(el._abilityImg, -_hfFb2, -_hfFb2, _isFb2, _isFb2);
          ctx.shadowBlur = 0;
        } else if (el._abilityImgFailed) {
          ctx.fillStyle = '#fff';
          ctx.font = 'bold 12px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(this.abilitySlotMap[el.abilitySlot] || '?', 0, 0);
        }
        ctx.globalAlpha = 1;
        ctx.restore();
        this._drawRotationHandle(ctx, shape, el);
        this._drawDragHandle(ctx, shape, el);
        return;
      }

      switch (shape.shape) {
        case 'circle':
          // Skip small fixed-size circle if gameRadius already drew the real-scale range
          if (shape.gameRadius) break;
          ctx.beginPath();
          ctx.arc(0, 0, shape.radius, 0, Math.PI * 2);
          if (shape.filled) {
            ctx.fillStyle = shape.color;
            ctx.fill();
          }
          if (shape.dashed) {
            ctx.setLineDash([5, 5]);
            ctx.strokeStyle = shape.color.replace(/[^,]+\)/, '0.6)');
            ctx.lineWidth = 2;
            ctx.stroke();
            ctx.setLineDash([]);
          }
          break;
        
        case 'image':
          // Handled by catch-all dark-bg icon style above
          break;
        
        case 'star':
          // Handled by catch-all dark-bg icon style above
          break;
        
        case 'astra-gravity':
          // Handled by catch-all dark-bg icon style above
          break;
        
        case 'astra-nebula':
          // Handled by catch-all dark-bg icon style above
          break;
        
        case 'astra-nova':
          // Handled by catch-all dark-bg icon style above
          break;
        
        // Astra - Cosmic Divide (parede que cruza o mapa inteiro, estilo valoplant.gg)
        case 'astra-wall': {
          // Line spans entire map diagonally (use large length to ensure full coverage)
          const wallLen = this._mapSize * 3 / (this.zoomLevel || 1);
          
          // Glow externo largo magenta
          ctx.strokeStyle = 'rgba(255, 50, 200, 0.08)';
          ctx.lineWidth = 40;
          ctx.lineCap = 'butt';
          ctx.beginPath();
          ctx.moveTo(0, -wallLen / 2);
          ctx.lineTo(0, wallLen / 2);
          ctx.stroke();
          
          // Glow médio
          ctx.strokeStyle = 'rgba(255, 50, 200, 0.15)';
          ctx.lineWidth = 18;
          ctx.beginPath();
          ctx.moveTo(0, -wallLen / 2);
          ctx.lineTo(0, wallLen / 2);
          ctx.stroke();
          
          // Glow interno
          ctx.strokeStyle = 'rgba(255, 80, 220, 0.35)';
          ctx.lineWidth = 8;
          ctx.beginPath();
          ctx.moveTo(0, -wallLen / 2);
          ctx.lineTo(0, wallLen / 2);
          ctx.stroke();
          
          // Linha principal magenta brilhante
          ctx.strokeStyle = 'rgba(255, 100, 240, 0.95)';
          ctx.lineWidth = 3;
          ctx.beginPath();
          ctx.moveTo(0, -wallLen / 2);
          ctx.lineTo(0, wallLen / 2);
          ctx.stroke();
          
          // Linha central branca fina
          ctx.strokeStyle = 'rgba(255, 255, 255, 0.6)';
          ctx.lineWidth = 1;
          ctx.beginPath();
          ctx.moveTo(0, -wallLen / 2);
          ctx.lineTo(0, wallLen / 2);
          ctx.stroke();
          
          // Centro handle dot (standard white handle)
          this._drawWhiteHandleMarker(ctx, 0);
          break;
        }

        // Viper - Toxic Screen (parede verde que cruza o mapa)
        case 'viper-wall': {
          this.drawSimpleViperWall(ctx, shape, el.opacity || 0.9);
          break;
        }

        case 'phoenix-wall': {
          this.drawSimplePhoenixWall(ctx, shape, el, el.opacity || 0.9);
          break;
        }

        // Vyse - Razorvine / Cerca-Viva (parede roxa)
        case 'vyse-wall': {
          this.drawSimpleVyseWall(ctx, shape, el.opacity || 0.9);
          break;
        }

        // Neon - Fast Lane / Pista Rápida (corredor com duas paredes paralelas)
        case 'fast-lane': {
          this.drawSimpleFastLane(ctx, shape, el.opacity || 0.9, el);
          break;
        }

        case 'harbor-wall': {
          this.drawSimpleHarborWall(ctx, shape, el, el.opacity || 0.9);
          break;
        }
          
        case 'rect': {
          const _rs = el.abilityScale != null ? el.abilityScale : 1.0;
          // Use game-accurate dimensions when available, so fallback looks correct too
          let _rw, _rh;
          if (shape.showRange && shape.gameWidth && shape.gameHeight) {
            const _mapScale = this.getCurrentMapScale();
            const _mapSize = this._mapSize;
            _rw = shape.gameWidth * 100 * _mapScale * _mapSize;
            _rh = shape.gameHeight * 100 * _mapScale * _mapSize * _rs;
          } else {
            _rw = shape.width;
            _rh = shape.height * _rs;
          }
          const _offsetPxR = shape.originOffset && shape.showRange && shape.gameWidth ? shape.originOffset * 100 * this.getCurrentMapScale() * this._mapSize : 0;
          const _rectY = shape.originAtBottom ? -_rh - _offsetPxR : -_rh / 2;
          const _rCorner = shape.roundedCorners ? (typeof shape.roundedCorners === 'number' ? shape.roundedCorners : Math.min(_rw, _rh) * 0.5) : 0;
          ctx.save();
          if (shape.outlineOnly) {
            if (shape.dashed) ctx.setLineDash([5, 5]);
            ctx.strokeStyle = shape.color.replace(/[^,]+\)/, '0.8)');
            ctx.lineWidth = 2;
            if (_rCorner > 0) {
              ctx.beginPath();
              ctx.roundRect(-_rw / 2, _rectY, _rw, _rh, _rCorner);
              ctx.stroke();
            } else {
              ctx.strokeRect(-_rw / 2, _rectY, _rw, _rh);
            }
            ctx.setLineDash([]);
          } else {
            ctx.fillStyle = shape.color;
            if (_rCorner > 0) {
              ctx.beginPath();
              ctx.roundRect(-_rw / 2, _rectY, _rw, _rh, _rCorner);
              ctx.fill();
            } else {
              ctx.fillRect(-_rw / 2, _rectY, _rw, _rh);
            }
            if (shape.dashed) ctx.setLineDash([5, 5]);
            ctx.strokeStyle = shape.color.replace(/[^,]+\)/, '0.8)');
            ctx.lineWidth = 2;
            if (_rCorner > 0) {
              ctx.beginPath();
              ctx.roundRect(-_rw / 2, _rectY, _rw, _rh, _rCorner);
              ctx.stroke();
            } else {
              ctx.strokeRect(-_rw / 2, _rectY, _rw, _rh);
            }
            ctx.setLineDash([]);
          }

          // Draw ability icon image inside the rect range (e.g. Breach Fault Line / Rolling Thunder)
          let rangeIconSrc = el.abilityIcon || '';
          if (shape.originAtBottom && shape.showRange) {
            const rangeAgent = this.getAgentByUuid(el.agentUuid);
            if (rangeAgent?.displayName === 'Breach') {
              const rangeName = (el.abilityName || '').toLowerCase();
              const isFaultLine =
                /falha tectônica|fault line/.test(rangeName) ||
                (shape.scalable && (shape.gameWidth || 0) <= 9);
              const isRollingThunder =
                /onda trovejante|rolling thunder/.test(rangeName) ||
                (!isFaultLine && !shape.scalable && (shape.gameWidth || 0) >= 12);

              // Breach range icon logic requested: first = Fault Line (E), second = Rolling Thunder (X).
              let preferredSlot = '';
              if (isFaultLine) preferredSlot = 'Ability2';
              else if (isRollingThunder) preferredSlot = 'Ultimate';

              if (preferredSlot) {
                const preferredAbility = (rangeAgent.abilities || []).find(ab => ab.slot === preferredSlot);
                if (preferredAbility?.displayIcon) {
                  rangeIconSrc = preferredAbility.displayIcon;
                }
              }
            }
          }

          if (shape.originAtBottom && shape.showRange && rangeIconSrc) {
            if (!el._rangeIconImg || el._rangeIconSrc !== rangeIconSrc) {
              el._rangeIconImg = new Image();
              el._rangeIconImg.crossOrigin = 'anonymous';
              el._rangeIconImg.onload = () => this.render();
              el._rangeIconImg.onerror = () => { el._rangeIconFailed = true; };
              el._rangeIconSrc = rangeIconSrc;
              el._rangeIconImg.src = rangeIconSrc;
            }
            if (el._rangeIconImg && el._rangeIconImg.complete && el._rangeIconImg.naturalWidth > 0) {
              const iconDim = Math.min(_rw * 0.7, _rh * 0.25);
              const iconCx = 0;
              const iconCy = _rectY + _rh * 0.45;
              ctx.globalAlpha = 0.25;
              ctx.drawImage(el._rangeIconImg, iconCx - iconDim / 2, iconCy - iconDim / 2, iconDim, iconDim);
              ctx.globalAlpha = 1;
            }
          }

          ctx.restore();

          break;
        }
          
        case 'cone': {
          let cw;
          let ch;
          const isGameCone = shape.showRange && shape.gameLength && shape.gameAngle;
          if (isGameCone) {
            ch = shape.gameLength * 100 * this.getCurrentMapScale() * this._mapSize;
            const halfAngleRad = ((shape.gameAngle || 60) * Math.PI / 180) / 2;
            cw = Math.max(16, Math.tan(halfAngleRad) * ch * 2);
          } else {
            const _agentCone = this.agents.find(a => a.uuid === el.agentUuid);
            const _folderCone = _agentCone ? this._normalizeAgentFolder(_agentCone.displayName) : '';
            const _slotMapCone = { 'Ability1': 'Q', 'Ability2': 'E', 'Grenade': 'C', 'Grenade_Alt': 'E2', 'Ultimate': 'X', 'Passive': 'P' };
            const _slotKeyCone = _slotMapCone[el.abilitySlot] || el.abilitySlot || '';
            const coneIconSize = this.getAbilityIconSize(_folderCone, _slotKeyCone);
            const coneScale = coneIconSize / 26;
            cw = shape.width * coneScale;
            ch = shape.height * coneScale;
          }

          // Draw cone with curved arc at the wide end
          const halfAngle = isGameCone ? ((shape.gameAngle || 60) * Math.PI / 180) / 2 : Math.atan2(cw / 2, ch);
          ctx.beginPath();
          ctx.moveTo(0, 0);
          // Arc from right side to left side at distance ch
          ctx.arc(0, 0, ch, -(Math.PI / 2 + halfAngle), -(Math.PI / 2 - halfAngle));
          ctx.closePath();
          ctx.fillStyle = shape.color;
          ctx.fill();
          ctx.strokeStyle = shape.color.replace(/[^,]+\)/, '0.8)');
          ctx.lineWidth = 2;
          ctx.stroke();

          // Draw ability icon inside the cone
          if (isGameCone && el.abilityIcon) {
            if (!el._coneIconImg || el._coneIconSrc !== el.abilityIcon) {
              el._coneIconImg = new Image();
              el._coneIconImg.crossOrigin = 'anonymous';
              el._coneIconImg.onload = () => this.render();
              el._coneIconImg.onerror = () => { el._coneIconFailed = true; };
              el._coneIconSrc = el.abilityIcon;
              el._coneIconImg.src = el.abilityIcon;
            }
            if (el._coneIconImg && el._coneIconImg.complete && el._coneIconImg.naturalWidth > 0) {
              const iconDim = Math.min(cw * 0.3, ch * 0.2);
              const iconCy = -(ch * 0.45);
              ctx.globalAlpha = 0.85;
              ctx.drawImage(el._coneIconImg, -iconDim / 2, iconCy - iconDim / 2, iconDim, iconDim);
              ctx.globalAlpha = 1;
            }
          }

          break;
        }
          
        case 'wall':
          ctx.save();
          ctx.strokeStyle = shape.color;
          ctx.lineWidth = shape.width;
          ctx.lineCap = 'round';
          ctx.beginPath();
          ctx.moveTo(-shape.length/2, 0);
          ctx.lineTo(shape.length/2, 0);
          ctx.stroke();
          ctx.restore();
          break;
          
        case 'flash':
          ctx.beginPath();
          ctx.arc(0, 0, shape.radius, 0, Math.PI * 2);
          const gradient = ctx.createRadialGradient(0, 0, 0, 0, 0, shape.radius);
          gradient.addColorStop(0, 'rgba(255, 255, 200, 0.8)');
          gradient.addColorStop(0.5, shape.color);
          gradient.addColorStop(1, 'rgba(255, 255, 0, 0)');
          ctx.fillStyle = gradient;
          ctx.fill();
          break;
          
        case 'teleport':
          ctx.beginPath();
          ctx.arc(0, 0, shape.size/2, 0, Math.PI * 2);
          ctx.strokeStyle = shape.color;
          ctx.lineWidth = 2;
          if (shape.dashed) {
            ctx.setLineDash([3, 3]);
          }
          ctx.stroke();
          ctx.setLineDash([]);
          
          // Inner icon
          ctx.beginPath();
          ctx.arc(0, 0, shape.size/4, 0, Math.PI * 2);
          ctx.fillStyle = shape.color;
          ctx.fill();
          break;
          
        case 'tripwire': {
          this.drawSimpleTripwire(ctx, shape, el.opacity || 0.9, el);
          break;
        }

        case 'barrier-mesh': {
          this.drawSimpleBarrierMesh(ctx, shape, el.opacity || 0.9);
          break;
        }

        case 'cyber-cage': {
          this.drawSimpleCyberCage(ctx, shape, el.opacity || 0.9, el);
          break;
        }

        case 'relay-bolt': {
          this.drawSimpleRelayBolt(ctx, shape, el.opacity || 0.9, el);
          break;
        }
          
        case 'creature': {
          const creatureR = shape.size / 2;
          ctx.beginPath();
          ctx.arc(0, 0, creatureR, 0, Math.PI * 2);
          ctx.fillStyle = shape.color;
          ctx.fill();
          ctx.strokeStyle = 'rgba(255,255,255,0.5)';
          ctx.lineWidth = 2;
          ctx.stroke();
          
          // Eyes
          ctx.fillStyle = 'white';
          ctx.beginPath();
          ctx.arc(-3, -2, 3, 0, Math.PI * 2);
          ctx.arc(3, -2, 3, 0, Math.PI * 2);
          ctx.fill();

          break;
        }
          
        case 'dash':
          ctx.strokeStyle = shape.color;
          ctx.lineWidth = 3;
          ctx.setLineDash([8, 4]);
          ctx.beginPath();
          ctx.moveTo(0, 0);
          ctx.lineTo(shape.length, 0);
          ctx.stroke();
          ctx.setLineDash([]);
          
          // Arrow at end
          ctx.beginPath();
          ctx.moveTo(shape.length, 0);
          ctx.lineTo(shape.length - 8, -4);
          ctx.lineTo(shape.length - 8, 4);
          ctx.closePath();
          ctx.fillStyle = shape.color;
          ctx.fill();
          break;
          
        case 'icon':
        default:
          // Small icon representation
          ctx.beginPath();
          ctx.arc(0, 0, (shape.size || 16)/2, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(255, 70, 85, 0.5)';
          ctx.fill();
          ctx.strokeStyle = '#ff4655';
          ctx.lineWidth = 2;
          ctx.stroke();
          break;
      }
      
      // Draw rotation handle (red diamond) for rotatable abilities
      this._drawRotationHandle(ctx, shape, el);
      // Draw drag handle (white circle) for scalable abilities to indicate drag point
      this._drawDragHandle(ctx, shape, el);

      ctx.globalAlpha = 1;
    },

  renderDragPreview(ctx) {
      const dp = this.dragPreview;
      if (!dp || dp.x == null) return;

      if (dp.type === 'agent') {
        ctx.save();
        ctx.translate(dp.x, dp.y);

        const rot = this.mapRotations[this.currentMap];
        if (rot) {
          if (rot.flipForDefense && this.currentSide === 'defense') ctx.scale(-1, -1);
          if (rot.baseRotation) ctx.rotate(-rot.baseRotation * Math.PI / 180);
        }

        if (dp.icon && (!dp._img || dp._imgSrc !== dp.icon)) {
          dp._img = new Image();
          dp._img.crossOrigin = 'anonymous';
          dp._img.src = dp.icon;
          dp._imgSrc = dp.icon;
        }

        this.renderAgent(ctx, {
          id: '__drag_preview_agent__',
          type: 'agent',
          agentUuid: dp.agentUuid,
          agentName: dp.agentName,
          team: dp.team || 'ally',
          image: dp._img && dp._img.complete && dp._img.naturalWidth > 0 ? dp._img : null,
          activeAbility: null,
          activeAbilityTime: null
        });

        ctx.restore();
        return;
      }
      
      const resolved = this.resolveAbilityVisual({
        agentUuid: dp.agentUuid,
        abilityName: dp.abilityName,
        abilitySlot: dp.slot,
        fallbackIcon: dp.icon
      });
      const previewAbilityName = resolved.abilityName || dp.abilityName;
      const previewAbilitySlot = resolved.abilitySlot || dp.slot;
      const previewAbilityIcon = resolved.abilityIcon || dp.icon;
      const shape = this.abilityShapes[previewAbilityName] || this.abilityShapes[dp.abilityName];
      
      ctx.save();
      ctx.translate(dp.x, dp.y);
      
      // Counter-rotate for rotated/flipped maps
      // Don't undo flip for abilities — shapes should follow map orientation
      const rot = this.mapRotations[this.currentMap];
      if (rot) {
        if (rot.baseRotation) ctx.rotate(-rot.baseRotation * Math.PI / 180);
      }
      
      ctx.globalAlpha = 0.75;

      if (resolved.agent?.displayName === 'Viper' && /^(Toxic Screen|Cortina Tóxica)$/i.test(previewAbilityName)) {
        this.drawSimpleViperWall(ctx, shape, 0.78);
        ctx.restore();
        return;
      }

      if (shape?.shape === 'fast-lane') {
        this.drawSimpleFastLane(ctx, shape, 0.78);
        ctx.restore();
        return;
      }

      // Build a synthetic ability element and delegate to renderAbility()
      // Cache image objects on dp to avoid re-creating every frame
      if (!dp._syntheticEl || dp._syntheticEl.abilityIcon !== previewAbilityIcon || dp._syntheticEl.abilityName !== previewAbilityName || dp._syntheticEl.abilitySlot !== previewAbilitySlot) {
        dp._syntheticEl = {
          id: '__drag_preview_ability__',
          type: 'ability',
          abilityName: previewAbilityName,
          abilitySlot: previewAbilitySlot,
          abilityIcon: previewAbilityIcon,
          agentUuid: dp.agentUuid,
          team: dp.team || 'ally',
          x: 0,
          y: 0,
          rotation: 0,
          opacity: 0.75
          // NOTE: _isDragPreview removed — let renderAbility draw range overlay + full appearance
        };
      }

      // Inject pre-loaded image so it renders on frame 1, no flash
      if (dp._img && dp._img.complete && dp._img.naturalWidth > 0) {
        if (!dp._syntheticEl.customIconImage || !dp._syntheticEl.customIconImage.complete) {
          dp._syntheticEl.customIconImage = dp._img;
        }
      }

      // Draw range overlay first, then icon on top
      this._renderPass = 'range';
      this.renderAbility(ctx, dp._syntheticEl);
      this._renderPass = 'icon';
      this.renderAbility(ctx, dp._syntheticEl);
      this._renderPass = null;
      
      ctx.restore();
    },

  renderAbilityDuration(ctx, el) {
      const dur = el.abilityDuration;
      if (!dur) return;

      // Determine size of the ability icon to position the badge
      const agent = this.agents.find(a => a.uuid === el.agentUuid);
      const folder = agent ? this._normalizeAgentFolder(agent.displayName) : '';
      const slotMap = { 'Ability1': 'Q', 'Ability2': 'E', 'Grenade': 'C', 'Grenade_Alt': 'E2', 'Ultimate': 'X', 'Passive': 'P', 'Passive': 'P' };
      const slotKey = slotMap[el.abilitySlot] || el.abilitySlot || '';
      const iconSize = this.getAbilityIconSize(folder, slotKey);
      const half = iconSize / 2;

      // Format duration text
      const durText = dur % 1 === 0 ? dur + 's' : dur.toFixed(1) + 's';

      // Badge dimensions
      ctx.font = 'bold 9px Arial, sans-serif';
      const textWidth = ctx.measureText(durText).width;
      const badgeW = textWidth + 6;
      const badgeH = 13;
      const badgeX = -badgeW / 2;
      const badgeY = half + 2;
      const r = 3;

      // Badge background — dark rounded rect
      ctx.globalAlpha = 0.85;
      ctx.fillStyle = 'rgba(0, 0, 0, 0.75)';
      ctx.beginPath();
      ctx.moveTo(badgeX + r, badgeY);
      ctx.lineTo(badgeX + badgeW - r, badgeY);
      ctx.arcTo(badgeX + badgeW, badgeY, badgeX + badgeW, badgeY + r, r);
      ctx.lineTo(badgeX + badgeW, badgeY + badgeH - r);
      ctx.arcTo(badgeX + badgeW, badgeY + badgeH, badgeX + badgeW - r, badgeY + badgeH, r);
      ctx.lineTo(badgeX + r, badgeY + badgeH);
      ctx.arcTo(badgeX, badgeY + badgeH, badgeX, badgeY + badgeH - r, r);
      ctx.lineTo(badgeX, badgeY + r);
      ctx.arcTo(badgeX, badgeY, badgeX + r, badgeY, r);
      ctx.closePath();
      ctx.fill();

      // Border
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.2)';
      ctx.lineWidth = 0.5;
      ctx.stroke();

      // Text
      ctx.globalAlpha = 1;
      ctx.fillStyle = '#22d3ee';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(durText, 0, badgeY + badgeH / 2);
    },

  renderPenPath(ctx, el) {
      if (!el.points || el.points.length < 2) return;
      
      ctx.strokeStyle = el.color || this.settings.strokeColor;
      ctx.lineWidth = el.width || this.settings.strokeWidth;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      
      ctx.beginPath();
      ctx.moveTo(el.points[0].x - el.x, el.points[0].y - el.y);
      
      for (let i = 1; i < el.points.length; i++) {
        ctx.lineTo(el.points[i].x - el.x, el.points[i].y - el.y);
      }
      
      ctx.stroke();
    },

  renderLineOrArrow(ctx, el) {
      ctx.strokeStyle = el.color || this.settings.strokeColor;
      ctx.lineWidth = el.width || this.settings.strokeWidth;
      ctx.lineCap = 'round';
      
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(el.endX - el.x, el.endY - el.y);
      ctx.stroke();
      
      // Draw arrow head if arrow type
      if (el.type === 'arrow') {
        const dx = el.endX - el.x;
        const dy = el.endY - el.y;
        const angle = Math.atan2(dy, dx);
        const headLength = 12;
        
        ctx.save();
        ctx.translate(dx, dy);
        ctx.rotate(angle);
        
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(-headLength, -headLength/2);
        ctx.lineTo(-headLength, headLength/2);
        ctx.closePath();
        ctx.fillStyle = el.color || this.settings.strokeColor;
        ctx.fill();
        
        ctx.restore();
      }
    },

  renderCircle(ctx, el) {
      ctx.beginPath();
      ctx.arc(0, 0, el.radius || 20, 0, Math.PI * 2);
      
      if (el.filled) {
        ctx.fillStyle = this.settings.fillColor;
        ctx.fill();
      }
      
      ctx.strokeStyle = el.color || this.settings.strokeColor;
      ctx.lineWidth = el.width || this.settings.strokeWidth;
      ctx.stroke();
    },

  renderText(ctx, el) {
      const fontSize = el.fontSize || this.settings.fontSize;
      ctx.font = `bold ${fontSize}px Arial`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      const text = el.text || '';
      const lines = text.split('\n');
      const lineHeight = fontSize * 1.4;
      const padX = 8, padY = 5;

      // Measure widest line
      let maxW = 0;
      for (const line of lines) {
        const lw = ctx.measureText(line).width;
        if (lw > maxW) maxW = lw;
      }
      const w = maxW + padX * 2;
      const h = lineHeight * lines.length + padY * 2;

      // Black background
      ctx.fillStyle = 'rgba(0,0,0,0.85)';
      ctx.beginPath();
      ctx.roundRect(-w / 2, -h / 2, w, h, 6);
      ctx.fill();

      // White text (each line)
      ctx.fillStyle = '#ffffff';
      const startY = -((lines.length - 1) * lineHeight) / 2;
      for (let i = 0; i < lines.length; i++) {
        ctx.fillText(lines[i], 0, startY + i * lineHeight);
      }
    },

  renderImageElement(ctx, el) {
      const w = el.width || 200;
      const h = el.height || 150;
      const hw = w / 2, hh = h / 2;
      const isSelected = this.isElementSelected(el);
      const cL = el.cropLeft || 0;
      const cT = el.cropTop || 0;
      const cR = el.cropRight || 0;
      const cB = el.cropBottom || 0;

      if (el._img && el._imgLoaded) {
        const imgW = el._img.naturalWidth;
        const imgH = el._img.naturalHeight;
        const srcX = cL * imgW;
        const srcY = cT * imgH;
        const srcW = Math.max(1, (1 - cL - cR) * imgW);
        const srcH = Math.max(1, (1 - cT - cB) * imgH);
        const dX = -hw + cL * w;
        const dY = -hh + cT * h;
        const dW = Math.max(1, w * (1 - cL - cR));
        const dH = Math.max(1, h * (1 - cT - cB));
        ctx.drawImage(el._img, srcX, srcY, srcW, srcH, dX, dY, dW, dH);
      } else if (el._imgFailed) {
        ctx.fillStyle = 'rgba(255,70,85,0.12)';
        ctx.strokeStyle = 'rgba(255,70,85,0.5)';
        ctx.lineWidth = 1.5;
        ctx.beginPath(); ctx.roundRect(-hw, -hh, w, h, 6); ctx.fill(); ctx.stroke();
        ctx.fillStyle = 'rgba(255,255,255,0.45)';
        ctx.font = '11px Arial'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText('Erro ao carregar', 0, 0);
      } else {
        ctx.fillStyle = 'rgba(255,255,255,0.04)';
        ctx.strokeStyle = 'rgba(255,255,255,0.15)';
        ctx.lineWidth = 1;
        ctx.setLineDash([4, 3]);
        ctx.beginPath(); ctx.roundRect(-hw, -hh, w, h, 6); ctx.fill(); ctx.stroke();
        ctx.setLineDash([]);
        ctx.fillStyle = 'rgba(255,255,255,0.25)';
        ctx.font = '11px Arial'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText('Carregando...', 0, 0);
      }

      if (isSelected) {
        // Crop boundary — bright dashed outline
        const cropX = -hw + cL * w;
        const cropY = -hh + cT * h;
        const cropW = w * (1 - cL - cR);
        const cropH = h * (1 - cT - cB);
        ctx.strokeStyle = 'rgba(255,70,85,0.85)';
        ctx.lineWidth = 1.5;
        ctx.setLineDash([5, 3]);
        ctx.strokeRect(cropX, cropY, cropW, cropH);
        ctx.setLineDash([]);
        // Corner resize handles — cyan squares at cropped area corners
        const HSIZ = 5;
        const corners = [
          [cropX,          cropY],
          [cropX + cropW,  cropY],
          [cropX,          cropY + cropH],
          [cropX + cropW,  cropY + cropH],
        ];
        corners.forEach(([cx, cy]) => {
          ctx.fillStyle = '#22d3ee';
          ctx.fillRect(cx - HSIZ, cy - HSIZ, HSIZ * 2, HSIZ * 2);
          ctx.strokeStyle = 'rgba(255,255,255,0.85)';
          ctx.lineWidth = 1;
          ctx.strokeRect(cx - HSIZ, cy - HSIZ, HSIZ * 2, HSIZ * 2);
        });
        // Crop handles — white circles at visible edge midpoints
        const cropMids = [
          [cropX + cropW / 2, cropY],
          [cropX + cropW / 2, cropY + cropH],
          [cropX,             cropY + cropH / 2],
          [cropX + cropW,     cropY + cropH / 2],
        ];
        cropMids.forEach(([mx, my]) => {
          ctx.beginPath();
          ctx.arc(mx, my, 5, 0, Math.PI * 2);
          ctx.fillStyle = '#fff';
          ctx.fill();
          ctx.strokeStyle = 'rgba(255,70,85,0.9)';
          ctx.lineWidth = 1.5;
          ctx.stroke();
        });
      }
    },

  renderMarker(ctx, el) {
      const def = this.markerDefs[el.markerType];
      if (!def) return;
      const isSelected = this.isElementSelected(el);
      ctx.globalAlpha = el.opacity || 0.85;

      // Area markers (smoke, flash, molly, wall, recon) — draw filled area
      if (def.radius > 15) {
        ctx.beginPath();
        ctx.arc(0, 0, def.radius, 0, Math.PI * 2);
        ctx.fillStyle = def.color;
        ctx.fill();
        ctx.strokeStyle = def.color.replace(/[\d.]+\)$/, '1)');
        ctx.lineWidth = isSelected ? 3 : 1.5;
        ctx.stroke();
      }

      // Icon circle
      const iconR = def.radius > 15 ? 12 : 14;
      ctx.beginPath();
      ctx.arc(0, 0, iconR, 0, Math.PI * 2);
      ctx.fillStyle = def.color.replace(/[\d.]+\)$/, '0.95)');
      ctx.fill();
      if (isSelected) {
        ctx.strokeStyle = '#fbbf24';
        ctx.lineWidth = 2.5;
        ctx.stroke();
      }

      // Font Awesome icon via Unicode
      ctx.fillStyle = '#fff';
      ctx.font = '900 11px "Font Awesome 5 Free"';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(def.icon, 0, 1);

      // Label below
      ctx.font = '600 8px Inter, Arial';
      ctx.fillStyle = 'rgba(255,255,255,0.8)';
      ctx.fillText(def.label, 0, iconR + 10);

      ctx.globalAlpha = 1;
    },

  renderKeyframes() {
      const container = document.getElementById('vp2-keyframes');
      if (!container) return;
      
      container.innerHTML = this.timeline.keyframes.map(kf => {
        const left = (kf.time / this.timeline.duration) * 100;
        const element = this.elements.find(el => el.id === kf.elementId);
        const color = element?.team === 'ally' ? '#22d3ee' : (element?.team === 'enemy' ? '#ef4444' : '#fbbf24');
        
        return `
          <div class="vp2-keyframe" 
               style="left: ${left}%; background: ${color};"
               data-id="${kf.id}"
               title="${this.formatTime(kf.time)}">
          </div>
        `;
      }).join('');
    },

  renderPaths() {
      if (!this.showPaths) return;
      
      const ctx = this.ctx;

      // Usar cores compartilhadas das trajetórias
      const PATH_COLORS = this.PATH_COLORS;

      // Mapeia cada agentId para um índice de cor estável
      const agentElements = this.elements.filter(el => el.type === 'agent' || el.type === 'player');
      const agentColorIndex = new Map();
      agentElements.forEach((el, idx) => {
        agentColorIndex.set(el.id, idx % PATH_COLORS.length);
      });
      
      // Mostrar trajetória apenas do agente selecionado ou do agente sendo desenhado
      const selectedId = this.selectedElement?.id || null;
      const drawingAgentId = this.pathDrawingAgent?.id || null;
      this.agentPaths.forEach((path, agentId) => {
        if (path.length < 2) return;
        
        const agent = this.elements.find(el => el.id === agentId);
        if (!agent) return;

        // Se está desenhando trajetória, só mostra a do agente sendo desenhado
        if (this.isDrawingPath && drawingAgentId && agentId !== drawingAgentId) return;
        // Se está em pathMode (mas não desenhando), mostra a do agente selecionado
        else if (this.pathMode && !this.isDrawingPath && selectedId && agentId !== selectedId) return;
        // Se não está em pathMode, mostra apenas do agente selecionado
        else if (!this.pathMode && !this.isDrawingPath) {
          if (!selectedId || agentId !== selectedId) return;
        }
        
        const colorIdx = agentColorIndex.get(agentId) ?? 0;
        const pathColor = PATH_COLORS[colorIdx];
        
        ctx.save();
        
        ctx.beginPath();
        ctx.moveTo(path[0].x, path[0].y);
        
        for (let i = 1; i < path.length; i++) {
          ctx.lineTo(path[i].x, path[i].y);
        }
        
        // Drop shadow da linha (estilo lineups)
        ctx.shadowColor = 'rgba(0,0,0,0.4)';
        ctx.shadowBlur = 3;
        ctx.strokeStyle = pathColor;
        ctx.lineWidth = 3;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.stroke();
        
        ctx.restore();
      });
      
      // Destaca agente sendo editado
      if (this.pathMode && this.pathDrawingAgent) {
        ctx.save();
        ctx.beginPath();
        ctx.arc(this.pathDrawingAgent.x, this.pathDrawingAgent.y, 24, 0, Math.PI * 2);
        ctx.strokeStyle = '#fbbf24';
        ctx.lineWidth = 3;
        ctx.setLineDash([5, 5]);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.restore();
      }


    },

  renderPathAbilityWaypoints(ctx) {
      try {
      const isPlaying = this.isPlaying;

      // Usar cores compartilhadas das trajetórias (sincronizado com renderPaths e renderAbility)
      const PATH_COLORS = this.PATH_COLORS;

      // Counter-rotation para manter ícones e textos na vertical em mapas rotacionados
      const _mapRot = this.mapRotations[this.currentMap];
      const counterRotate = (ctx) => {
        if (_mapRot) {
          if (_mapRot.flipForDefense && this.currentSide === 'defense') ctx.scale(-1, -1);
          if (_mapRot.baseRotation) ctx.rotate(-_mapRot.baseRotation * Math.PI / 180);
        }
      };
      // For ability shapes: only undo rotation, NOT flip (shapes follow map orientation)
      const counterRotateShape = (ctx) => {
        if (_mapRot) {
          if (_mapRot.baseRotation) ctx.rotate(-_mapRot.baseRotation * Math.PI / 180);
        }
      };
      const agentElements = this.elements.filter(el => el.type === 'agent' || el.type === 'player');
      const agentColorIndex = new Map();
      agentElements.forEach((el, idx) => {
        agentColorIndex.set(el.id, idx % PATH_COLORS.length);
      });

      // Mostrar waypoints apenas do agente selecionado (ou todos durante playback/pathMode)
      const wpSelectedId = this.selectedElement?.id || null;
      const wpShowAll = isPlaying || this.pathMode || this.isDrawingPath;

      this.pathAbilityWaypoints.forEach((waypoints, agentId) => {
        if (!waypoints || waypoints.length === 0) return;

        const path = this.agentPaths.get(agentId);
        if (!path || path.length < 2) return;

        const agent = this.elements.find(el => el.id === agentId);
        if (!agent) return;

        // Só renderiza se for o agente selecionado, durante playback, ou em modo path
        if (!wpShowAll && wpSelectedId && agentId !== wpSelectedId) return;
        if (!wpShowAll && !wpSelectedId) return;

        // Cor do agente (mesma da trajetória)
        const colorIdx = agentColorIndex.get(agentId) ?? 0;
        const agentColor = PATH_COLORS[colorIdx];

        // During playback, calculate agent's current distance along path
        let agentDistNow = null;
        if (isPlaying) {
          // Calcula distância total
          let totalDist = 0;
          for (let i = 1; i < path.length; i++) {
            totalDist += Math.sqrt((path[i].x - path[i-1].x) ** 2 + (path[i].y - path[i-1].y) ** 2);
          }
          const pathDuration = (totalDist / this.VANDAL_SPEED_PX_PER_SEC) * 1000;
          const progress = Math.min(this.timeline.currentTime / pathDuration, 1);
          agentDistNow = progress * totalDist;
        }

        waypoints.forEach((wp, idx) => {
          ctx.save();
          this.refreshAbilityRuntimeVisual(agent.agentUuid, wp.ability);

          // Tamanho padronizado do ícone da habilidade
          const pathX = wp.pathX != null ? wp.pathX : wp.x;
          const pathY = wp.pathY != null ? wp.pathY : wp.y;
          const dragDist = Math.sqrt((wp.x - pathX) ** 2 + (wp.y - pathY) ** 2);
          const isDragged = dragDist > 3;
          // Buscar tamanho padronizado (individual > global > default)
          const _slotToKeyWP = { 'Ability1': 'Q', 'Ability2': 'E', 'Grenade': 'C', 'Grenade_Alt': 'E2', 'Ultimate': 'X', 'Passive': 'P', 'Passive': 'P' };
          let agentFolder = agent && agent.agentName ? this._normalizeAgentFolder(agent.agentName) : '';
          let slotKey = wp.ability && wp.ability.slot ? (_slotToKeyWP[wp.ability.slot] || wp.ability.slot) : '';
          const iconSize = this.getAbilityIconSize(agentFolder, slotKey);
          const half = iconSize / 2;

          // During playback: controlar visibilidade baseado na posição do agente
          let alpha = 1;
          let isActive = false;
          let isExpired = false;
          let remaining = 0;
          if (isPlaying && agentDistNow !== null) {
            if (agentDistNow < wp.distanceAlongPath - 5) {
              // Agente ainda não chegou — mostrar fantasma (habilidade ainda não ativada)
              alpha = isDragged ? 0.3 : 0.5;
            } else if (wp.ability.duration) {
              // Agente chegou ou passou — calcular tempo passado
              const passedTime = (agentDistNow - wp.distanceAlongPath) / this.VANDAL_SPEED_PX_PER_SEC;
              if (passedTime <= wp.ability.duration) {
                isActive = true;
                remaining = wp.ability.duration - passedTime;
              } else {
                // Expirou — manter visível mas como utilizada
                isExpired = true;
                alpha = 0.35;
              }
            } else {
              // Sem duração — permanece ativo após ativação
              isActive = true;
            }
          }

          ctx.globalAlpha = alpha;

          // ===== ESTILO LINEUPS: Agente (ponto de ativação) → Linha → Habilidade (destino) =====
          if (isDragged) {
            // Durante playback: ocultar linha e marcador do agente, mostrar apenas a habilidade
            if (!isPlaying) {
              // --- Linha sólida conectando ponto de ativação ao destino (estilo lineups SVG line) ---
              ctx.save();
              ctx.beginPath();
              ctx.moveTo(pathX, pathY);
              ctx.lineTo(wp.x, wp.y);
              ctx.strokeStyle = agentColor;
              ctx.lineWidth = 3;
              ctx.globalAlpha = alpha * 0.85;
              ctx.lineCap = 'round';
              ctx.shadowColor = 'rgba(0,0,0,0.4)';
              ctx.shadowBlur = 3;
              ctx.stroke();
              ctx.restore();
              ctx.globalAlpha = alpha;

              // --- Marcador do agente no ponto de ativação (lu-agent-ring) ---
              const agentRingRadius = 13;
              const agentImgSize = 22;
              const agentHalf = agentImgSize / 2;

              // Drop shadow + ring exterior
              ctx.save();
              ctx.shadowColor = 'rgba(0,0,0,0.6)';
              ctx.shadowBlur = 6;
              ctx.shadowOffsetY = 2;
              ctx.beginPath();
              ctx.arc(pathX, pathY, agentRingRadius, 0, Math.PI * 2);
              ctx.fillStyle = '#000';
              ctx.fill();
              ctx.strokeStyle = agentColor;
              ctx.lineWidth = 2;
              ctx.stroke();
              ctx.closePath();
              ctx.restore();

              // Ícone do agente dentro do ring (circular clip + counter-rotation)
              if (agent.image && agent.image.complete && agent.image.naturalWidth > 0) {
                ctx.save();
                ctx.beginPath();
                ctx.arc(pathX, pathY, agentRingRadius - 2, 0, Math.PI * 2);
                ctx.clip();
                ctx.translate(pathX, pathY);
                counterRotate(ctx);
                ctx.drawImage(agent.image, -agentHalf, -agentHalf, agentImgSize, agentImgSize);
                ctx.restore();
              }
            }

            // --- Marcador de destino (lu-land-icon estilo lineups) ---
            ctx.save();
            ctx.translate(wp.x, wp.y);
            counterRotateShape(ctx);
            this.renderAbilityRangeOverlay(ctx, wp.ability.name, alpha, wp.ability.abilityScale || 1.0);
            ctx.restore();

            const isCustomUploadDest = wp.ability.icon && wp.ability.icon.startsWith('/uploads/');
            const _wpShapeDest = this.abilityShapes[wp.ability.name];
            const _wpHasRangeDest = _wpShapeDest?.showRange && (_wpShapeDest?.gameRadius || (_wpShapeDest?.gameWidth && _wpShapeDest?.gameHeight));
            if (wp.ability.image && wp.ability.image.complete && wp.ability.image.naturalWidth > 0) {
              ctx.save();
              ctx.globalAlpha = alpha;
              ctx.translate(wp.x, wp.y);
              counterRotate(ctx);
              if (isCustomUploadDest) {
                // Custom upload — render plain image
                ctx.drawImage(wp.ability.image, -half, -half, iconSize, iconSize);
              } else {
                // API icon — render with ring design (same as renderAbility)
                const ringSize = iconSize;
                const ringHalf = ringSize / 2;
                // Dark circle background
                ctx.beginPath();
                ctx.arc(0, 0, ringHalf + 2, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(0, 0, 0, 0.9)';
                ctx.fill();
                // Colored ring — skip for abilities with range overlay
                if (!_wpHasRangeDest) {
                ctx.strokeStyle = agentColor;
                ctx.lineWidth = 2.5;
                ctx.stroke();
                ctx.closePath();
                // Subtle glow
                ctx.shadowColor = agentColor;
                ctx.shadowBlur = 6;
                ctx.beginPath();
                ctx.arc(0, 0, ringHalf + 2, 0, Math.PI * 2);
                ctx.strokeStyle = 'transparent';
                ctx.stroke();
                ctx.shadowBlur = 0;
                ctx.shadowColor = 'transparent';
                }
                // Icon clipped to circle
                ctx.beginPath();
                ctx.arc(0, 0, ringHalf - 1, 0, Math.PI * 2);
                ctx.clip();
                ctx.drawImage(wp.ability.image, -ringHalf + 1, -ringHalf + 1, ringSize - 2, ringSize - 2);
              }
              ctx.restore();
            } else {
              ctx.save();
              ctx.translate(wp.x, wp.y);
              counterRotate(ctx);
              ctx.fillStyle = '#fff';
              ctx.font = 'bold 12px Arial';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillText(wp.ability.slot || '?', 0, 0);
              ctx.restore();
            }

            // Duration countdown no destino (counter-rotated)
            if (isPlaying && isActive && remaining > 0) {
              ctx.save();
              ctx.translate(wp.x, wp.y);
              counterRotate(ctx);
              const displayText = remaining.toFixed(1) + 's';
              ctx.font = 'bold 9px Arial';
              const tw = ctx.measureText(displayText).width;
              const badgeW = tw + 8;
              const badgeH = 14;
              const badgeX = -badgeW / 2;
              const badgeY = half + 4;
              ctx.fillStyle = 'rgba(34, 211, 238, 0.25)';
              ctx.beginPath();
              const r = 3;
              ctx.moveTo(badgeX + r, badgeY);
              ctx.lineTo(badgeX + badgeW - r, badgeY);
              ctx.quadraticCurveTo(badgeX + badgeW, badgeY, badgeX + badgeW, badgeY + r);
              ctx.lineTo(badgeX + badgeW, badgeY + badgeH - r);
              ctx.quadraticCurveTo(badgeX + badgeW, badgeY + badgeH, badgeX + badgeW - r, badgeY + badgeH);
              ctx.lineTo(badgeX + r, badgeY + badgeH);
              ctx.quadraticCurveTo(badgeX, badgeY + badgeH, badgeX, badgeY + badgeH - r);
              ctx.lineTo(badgeX, badgeY + r);
              ctx.quadraticCurveTo(badgeX, badgeY, badgeX + r, badgeY);
              ctx.closePath();
              ctx.fill();
              ctx.fillStyle = '#fff';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillText(displayText, 0, badgeY + badgeH / 2);
              ctx.restore();
            }
          } else {
            // ===== NÃO ARRASTADA: renderizar apenas o ícone da habilidade no ponto da trajetória =====
            ctx.save();
            ctx.translate(wp.x, wp.y);
            counterRotateShape(ctx);
            this.renderAbilityRangeOverlay(ctx, wp.ability.name, alpha, wp.ability.abilityScale || 1.0);
            ctx.restore();

            const isCustomUploadInline = wp.ability.icon && wp.ability.icon.startsWith('/uploads/');
            const _wpShapeInline = this.abilityShapes[wp.ability.name];
            const _wpHasRangeInline = _wpShapeInline?.showRange && (_wpShapeInline?.gameRadius || (_wpShapeInline?.gameWidth && _wpShapeInline?.gameHeight));
            if (wp.ability.image && wp.ability.image.complete && wp.ability.image.naturalWidth > 0) {
              ctx.save();
              ctx.globalAlpha = alpha;
              ctx.translate(wp.x, wp.y);
              counterRotate(ctx);
              if (isCustomUploadInline) {
                // Custom upload — render plain image
                ctx.drawImage(wp.ability.image, -half, -half, iconSize, iconSize);
              } else {
                // API icon — render with ring design (same as renderAbility)
                const ringSize = iconSize;
                const ringHalf = ringSize / 2;
                // Dark circle background
                ctx.beginPath();
                ctx.arc(0, 0, ringHalf + 2, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(0, 0, 0, 0.9)';
                ctx.fill();
                // Colored ring — skip for abilities with range overlay
                if (!_wpHasRangeInline) {
                ctx.strokeStyle = agentColor;
                ctx.lineWidth = 2.5;
                ctx.stroke();
                ctx.closePath();
                // Subtle glow
                ctx.shadowColor = agentColor;
                ctx.shadowBlur = 6;
                ctx.beginPath();
                ctx.arc(0, 0, ringHalf + 2, 0, Math.PI * 2);
                ctx.strokeStyle = 'transparent';
                ctx.stroke();
                ctx.shadowBlur = 0;
                ctx.shadowColor = 'transparent';
                }
                // Icon clipped to circle
                ctx.beginPath();
                ctx.arc(0, 0, ringHalf - 1, 0, Math.PI * 2);
                ctx.clip();
                ctx.drawImage(wp.ability.image, -ringHalf + 1, -ringHalf + 1, ringSize - 2, ringSize - 2);
              }
              ctx.restore();
            } else {
              ctx.save();
              ctx.translate(wp.x, wp.y);
              counterRotate(ctx);
              ctx.fillStyle = '#fff';
              ctx.font = 'bold 12px Arial';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillText(wp.ability.slot || '?', 0, 0);
              ctx.restore();
            }

            // Duration countdown (counter-rotated)
            if (isPlaying && isActive && remaining > 0) {
              ctx.save();
              ctx.translate(wp.x, wp.y);
              counterRotate(ctx);
              const displayText = remaining.toFixed(1) + 's';
              ctx.font = 'bold 9px Arial';
              const tw = ctx.measureText(displayText).width;
              const badgeW = tw + 8;
              const badgeH = 14;
              const badgeX = -badgeW / 2;
              const badgeY = half + 4;
              ctx.fillStyle = 'rgba(34, 211, 238, 0.25)';
              ctx.beginPath();
              const r = 3;
              ctx.moveTo(badgeX + r, badgeY);
              ctx.lineTo(badgeX + badgeW - r, badgeY);
              ctx.quadraticCurveTo(badgeX + badgeW, badgeY, badgeX + badgeW, badgeY + r);
              ctx.lineTo(badgeX + badgeW, badgeY + badgeH - r);
              ctx.quadraticCurveTo(badgeX + badgeW, badgeY + badgeH, badgeX + badgeW - r, badgeY + badgeH);
              ctx.lineTo(badgeX + r, badgeY + badgeH);
              ctx.quadraticCurveTo(badgeX, badgeY + badgeH, badgeX, badgeY + badgeH - r);
              ctx.lineTo(badgeX, badgeY + r);
              ctx.quadraticCurveTo(badgeX, badgeY, badgeX + r, badgeY);
              ctx.closePath();
              ctx.fill();
              ctx.fillStyle = '#fff';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillText(displayText, 0, badgeY + badgeH / 2);
              ctx.restore();
            }
          }

          ctx.restore();
        });
      });
      } catch (err) {
        console.error('renderPathAbilityWaypoints error:', err);
      }
    },

  renderPanelIconsGrid() {
      const grid = document.getElementById('vp2-icons-grid');
      if (!grid) return;

      const customIcons = this._panelCustomIcons || {};

      grid.innerHTML = this.agents.map(agent => {
        const folder = this._normalizeAgentFolder(agent.displayName);
        const abilities = this.getDisplayAbilities(agent);
        const agentCustom = customIcons[folder] || {};

        const abilitiesHtml = abilities.map(ab => {
          const key = this.getAbilitySlotKey(ab.slot);
          const hasCustom = !!agentCustom[key];
          const iconSrc = hasCustom ? agentCustom[key] + '?t=' + Date.now() : (ab.displayIcon || '');
          const abilitySize = this.getAbilityIconSize(folder, key);

          return `
            <div class="vp2-pi-ability">
              <div class="vp2-pi-ability-wrap ${hasCustom ? 'has-custom' : ''}"
                   data-agent-folder="${folder}" data-slot="${key}" title="${ab.displayName}">
                <img src="${iconSrc}" alt="${ab.displayName}" onerror="this.style.display='none'">
                <div class="vp2-pi-upload-hint"><i class="fas ${hasCustom ? 'fa-sync-alt' : 'fa-upload'}"></i></div>
                ${hasCustom ? `<button class="vp2-pi-remove" data-agent-folder="${folder}" data-slot="${key}"><i class="fas fa-times"></i></button>` : ''}
              </div>
              <div class="vp2-pi-size-popup">
                <label>Tamanho</label>
                <div class="vp2-pi-size-row">
                  <input type="range" class="vp2-pi-size-input" min="10" max="120" value="${abilitySize}" step="1"
                         data-agent-folder="${folder}" data-slot="${key}">
                  <span class="vp2-pi-size-val">${abilitySize}</span>
                </div>
              </div>
            </div>
          `;
        }).join('');

        const agentSize = this.getAgentIconSize(folder);
        return `
          <div class="vp2-pi-agent">
            <div class="vp2-pi-portrait" data-agent-folder="${folder}">
              <img src="${agent.displayIcon || agent.displayIconSmall}" alt="${agent.displayName}" loading="lazy">
              <div class="vp2-pi-agent-size-popup">
                <label>Tamanho</label>
                <div class="vp2-pi-size-row">
                  <input type="range" class="vp2-pi-agent-size-input" min="15" max="80" value="${agentSize}" step="1"
                         data-agent-folder="${folder}">
                  <span class="vp2-pi-size-val">${agentSize}</span>
                </div>
              </div>
            </div>
            <div class="vp2-pi-name">${agent.displayName}</div>
            <div class="vp2-pi-abilities">${abilitiesHtml}</div>
          </div>
        `;
      }).join('');

      this.bindPanelIconsEvents();
    },
}));


/* ===== js/valoplant-events.js ===== */
/**
 * ValoPlantV2 — ligacao de eventos e inicializacao
 *
 * Estes 16 metodos vinham da classe em valoplant-v2.js, que passava de
 * 12 mil linhas num arquivo so. Continuam sendo metodos da mesma classe: sao
 * instalados no prototype, entao `this` e o comportamento nao mudam.
 *
 * Precisa carregar DEPOIS de valoplant-v2.js — a ordem esta em scripts.json.
 *
 * getOwnPropertyDescriptors e nao Object.assign de proposito: assign copiaria
 * o *valor* de um getter em vez do getter.
 */
Object.defineProperties(ValoPlantV2.prototype, Object.getOwnPropertyDescriptors({
  initAbilityShapes() {
      return {
        // ===== CONTROLLERS =====
        // Brimstone
        'Fumaça Celeste': { shape: 'circle', radius: 40, color: 'rgba(128, 128, 128, 0.6)', filled: true, gameRadius: 4.15 },
        'Sky Smoke': { shape: 'circle', radius: 40, color: 'rgba(128, 128, 128, 0.6)', filled: true, gameRadius: 4.15 },
        'Incendiário': { shape: 'circle', radius: 28, color: 'rgba(255, 100, 0, 0.5)', filled: true, gameRadius: 4.5 },
        'Incendiary': { shape: 'circle', radius: 28, color: 'rgba(255, 100, 0, 0.5)', filled: true, gameRadius: 4.5 },
        'Sinalizador Estimulante': { shape: 'circle', radius: 22, color: 'rgba(0, 255, 100, 0.1)', filled: true, gameRadius: 6, showRange: true, lightBg: true, hideAnchorDot: true },
        'Stim Beacon': { shape: 'circle', radius: 22, color: 'rgba(0, 255, 100, 0.1)', filled: true, gameRadius: 6, showRange: true, lightBg: true, hideAnchorDot: true },
        'Ataque Orbital': { shape: 'circle', radius: 50, color: 'rgba(255, 50, 0, 0.18)', filled: true, dashed: true, gameRadius: 9, showRange: true, lightBg: true, hideAnchorDot: true },
        'Orbital Strike': { shape: 'circle', radius: 50, color: 'rgba(255, 50, 0, 0.18)', filled: true, dashed: true, gameRadius: 9, showRange: true, lightBg: true, hideAnchorDot: true },
        
        // Omen
        'Manto Sombrio': { shape: 'circle', radius: 40, color: 'rgba(100, 50, 200, 0.5)', filled: true, gameRadius: 4.1 },
        'Dark Cover': { shape: 'circle', radius: 40, color: 'rgba(100, 50, 200, 0.5)', filled: true, gameRadius: 4.1 },
        'Paranoia': { shape: 'rect', width: 30, height: 100, color: 'rgba(100, 50, 200, 0.5)', rotation: true, originAtBottom: true, gameWidth: 8.6, gameHeight: 25, showRange: true },
        'Passos Tenebrosos': { shape: 'teleport', size: 20, color: '#8844ff' },
        'Shrouded Step': { shape: 'teleport', size: 20, color: '#8844ff' },
        'Salto das Sombras': { shape: 'teleport', size: 30, color: '#8844ff', dashed: true },
        'From the Shadows': { shape: 'teleport', size: 30, color: '#8844ff', dashed: true },
        
        // Viper
          'Cortina Tóxica': { shape: 'viper-wall', color: 'rgba(26, 95, 70, 0.96)', width: 4, rotation: true, gameLength: 60 },
          'Toxic Screen': { shape: 'viper-wall', color: 'rgba(26, 95, 70, 0.96)', width: 4, rotation: true, gameLength: 60 },
        'Veneno de Cobra': { shape: 'circle', radius: 22, color: 'rgba(0, 200, 50, 0.5)', filled: true, gameRadius: 4.5 },
        'Snake Bite': { shape: 'circle', radius: 22, color: 'rgba(0, 200, 50, 0.5)', filled: true, gameRadius: 4.5 },
        'Nuvem Venenosa': { shape: 'circle', radius: 32, color: 'rgba(80, 210, 80, 0.4)', filled: true, gameRadius: 5.5 },
        'Poison Cloud': { shape: 'circle', radius: 32, color: 'rgba(80, 210, 80, 0.4)', filled: true, gameRadius: 5.5 },
        'Poço Peçonhento': { shape: 'circle', radius: 65, color: 'rgba(80, 210, 80, 0.18)', filled: true, gameRadius: 9, showRange: true, noBgBox: true, hideAnchorDot: true },
        "Viper's Pit": { shape: 'circle', radius: 65, color: 'rgba(80, 210, 80, 0.18)', filled: true, gameRadius: 9, showRange: true, noBgBox: true, hideAnchorDot: true },

        
        // Astra abilities - use custom images from /img/abilities/
        'Nebulosa': { shape: 'image', image: '/img/abilities/astra-nebula.png', size: 50 },
        'Nebula': { shape: 'image', image: '/img/abilities/astra-nebula.png', size: 50 },
        'Nebulosa / Dissipar': { shape: 'image', image: '/img/abilities/astra-nebula.png', size: 50 },
        'Pulso Nova': { shape: 'image', image: '/img/abilities/astra-nova.png', size: 50 },
        'Nova Pulse': { shape: 'image', image: '/img/abilities/astra-nova.png', size: 50 },
        'Poço Gravitacional': { shape: 'image', image: '/img/abilities/astra-gravity.png', size: 50 },
        'Gravity Well': { shape: 'image', image: '/img/abilities/astra-gravity.png', size: 50 },
        'Divisa Cósmica': { shape: 'astra-wall', color: 'rgba(255, 50, 200, 0.8)', width: 4, rotation: true },
        'Cosmic Divide': { shape: 'astra-wall', color: 'rgba(255, 50, 200, 0.8)', width: 4, rotation: true },
        'Forma Astral / Divisa Cósmica': { shape: 'astra-wall', color: 'rgba(255, 50, 200, 0.8)', width: 4, rotation: true },
        
        // Harbor
        'Maré Alta': { shape: 'harbor-wall', color: 'rgba(0, 150, 255, 0.5)', rotation: true, scalable: true, bendable: true, gameLength: 60, gameWidth: 1.8, minScale: 0.2, maxScale: 1.0, defaultScale: 1.0 },
        'High Tide': { shape: 'harbor-wall', color: 'rgba(0, 150, 255, 0.5)', rotation: true, scalable: true, bendable: true, gameLength: 60, gameWidth: 1.8, minScale: 0.2, maxScale: 1.0, defaultScale: 1.0 },
        'Abrigo': { shape: 'circle', radius: 35, color: 'rgba(0, 150, 255, 0.4)', filled: true, gameRadius: 4.6 },
        'Cove': { shape: 'circle', radius: 35, color: 'rgba(0, 150, 255, 0.4)', filled: true, gameRadius: 4.6 },
        'Cascata': { shape: 'rect', width: 25, height: 80, color: 'rgba(0, 150, 255, 0.5)', rotation: true },
        'Cascade': { shape: 'rect', width: 25, height: 80, color: 'rgba(0, 150, 255, 0.5)', rotation: true },
        'Julgamento': { shape: 'rect', width: 120, height: 200, color: 'rgba(0, 160, 255, 0.38)', rotation: true, originAtBottom: true, gameWidth: 18.33, gameHeight: 34.71, showRange: true },
        'Acerto de Contas': { shape: 'rect', width: 120, height: 200, color: 'rgba(0, 160, 255, 0.38)', rotation: true, originAtBottom: true, gameWidth: 18.33, gameHeight: 34.71, showRange: true },
        'Reckoning': { shape: 'rect', width: 120, height: 200, color: 'rgba(0, 160, 255, 0.38)', rotation: true, originAtBottom: true, gameWidth: 18.33, gameHeight: 34.71, showRange: true },
        
        // Clove
        'Ruse': { shape: 'circle', radius: 40, color: 'rgba(255, 100, 200, 0.5)', filled: true, gameRadius: 4 },
        'Meddle': { shape: 'circle', radius: 35, color: 'rgba(255, 100, 200, 0.4)', filled: true, gameRadius: 6 },
        'Pick-Me-Up': { shape: 'icon', size: 24 },
        'Not Dead Yet': { shape: 'circle', radius: 50, color: 'rgba(255, 100, 200, 0.3)', dashed: true },
        
        // ===== INITIATORS =====
        // Sova
        'Flecha Rastreadora': { shape: 'circle', radius: 55, color: 'rgba(0, 170, 255, 0.3)', dashed: true, gameRadius: 30, showRange: true, hideAnchorDot: true },
        'Recon Bolt': { shape: 'circle', radius: 55, color: 'rgba(0, 170, 255, 0.3)', dashed: true, gameRadius: 30, showRange: true, hideAnchorDot: true },
        'Drone Coruja': { shape: 'cone', width: 80, height: 120, color: 'rgba(0, 170, 255, 0.25)', rotation: false },
        'Owl Drone': { shape: 'cone', width: 80, height: 120, color: 'rgba(0, 170, 255, 0.25)', rotation: false },
        'Flecha de Choque': { shape: 'circle', radius: 20, color: 'rgba(0, 170, 255, 0.5)', filled: true, gameRadius: 4 },
        'Shock Bolt': { shape: 'circle', radius: 20, color: 'rgba(0, 170, 255, 0.5)', filled: true, gameRadius: 4 },
        'Fúria do Caçador': { shape: 'rect', width: 25, height: 300, color: 'rgba(0, 170, 255, 0.4)', rotation: true, originAtBottom: true, gameWidth: 3.52, gameHeight: 66, showRange: true },
        "Hunter's Fury": { shape: 'rect', width: 25, height: 300, color: 'rgba(0, 170, 255, 0.4)', rotation: true, originAtBottom: true, gameWidth: 3.52, gameHeight: 66, showRange: true },
        
        // Breach
        'Onda Trovejante': { shape: 'rect', width: 120, height: 200, color: 'rgba(255, 200, 80, 0.45)', rotation: true, originAtBottom: true, gameWidth: 18, gameHeight: 32, showRange: true, roundedCorners: 8, originOffset: 8 },
        'Rolling Thunder': { shape: 'rect', width: 120, height: 200, color: 'rgba(255, 200, 80, 0.45)', rotation: true, originAtBottom: true, gameWidth: 18, gameHeight: 32, showRange: true, roundedCorners: 8, originOffset: 8 },
        'Falha Tectônica': { shape: 'rect', width: 30, height: 140, color: 'rgba(190, 155, 50, 0.55)', rotation: true, scalable: true, originAtBottom: true, gameWidth: 8, gameHeight: 40, showRange: true, minScale: 0.2, maxScale: 1.0, roundedCorners: 8, originOffset: 8 },
        'Fault Line': { shape: 'rect', width: 30, height: 140, color: 'rgba(190, 155, 50, 0.55)', rotation: true, scalable: true, originAtBottom: true, gameWidth: 8, gameHeight: 40, showRange: true, minScale: 0.2, maxScale: 1.0, roundedCorners: 8, originOffset: 8 },
        'Pós-choque': { shape: 'rect', width: 25, height: 60, color: 'rgba(255, 100, 50, 0.5)', rotation: true, noDragHandle: true },
        'Aftershock': { shape: 'rect', width: 25, height: 60, color: 'rgba(255, 100, 50, 0.5)', rotation: true, noDragHandle: true },
        'Estopim': { shape: 'flash', radius: 30, color: 'rgba(255, 255, 100, 0.6)' },
        'Flashpoint': { shape: 'flash', radius: 30, color: 'rgba(255, 255, 100, 0.6)' },
        
        // Skye
        'Luz Guia': { shape: 'flash', radius: 35, color: 'rgba(100, 255, 100, 0.5)', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Luz Desbravadora': { shape: 'flash', radius: 35, color: 'rgba(100, 255, 100, 0.5)', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Guiding Light': { shape: 'flash', radius: 35, color: 'rgba(100, 255, 100, 0.5)', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Desbravador': { shape: 'creature', size: 22, color: '#44ff44' },
        'Predador Explosivo': { shape: 'creature', size: 22, color: '#44ff44' },
        'Trailblazer': { shape: 'creature', size: 22, color: '#44ff44' },
        'Reflorescer': { shape: 'circle', radius: 40, color: 'rgba(100, 255, 100, 0.1)', filled: true, gameRadius: 18, showRange: true },
        'Regrowth': { shape: 'circle', radius: 40, color: 'rgba(100, 255, 100, 0.1)', filled: true, gameRadius: 18, showRange: true },
        'Rastreadores': { shape: 'creature', size: 18, color: '#44ff44' },
        'Seekers': { shape: 'creature', size: 18, color: '#44ff44' },
        
        // KAY/O
        'FLASH/drive': { shape: 'flash', radius: 35, color: 'rgba(100, 200, 255, 0.5)', hideAnchorDot: true },
        'GRANADA/clarão': { shape: 'flash', radius: 35, color: 'rgba(100, 200, 255, 0.5)', hideAnchorDot: true },
        'FRAG/ment': { shape: 'circle', radius: 30, color: 'rgba(255, 100, 50, 0.5)', filled: true, gameRadius: 4 },
        'FRAG/mento': { shape: 'circle', radius: 30, color: 'rgba(255, 100, 50, 0.5)', filled: true, gameRadius: 4 },
        'ZERO/point': { shape: 'circle', radius: 45, color: 'rgba(100, 200, 255, 0.1)', filled: true, dashed: true, gameRadius: 15, showRange: true },
        'PONTO/zero': { shape: 'circle', radius: 45, color: 'rgba(100, 200, 255, 0.1)', filled: true, dashed: true, gameRadius: 15, showRange: true },
        'NULL/cmd': { shape: 'circle', radius: 55, color: 'rgba(100, 200, 255, 0.1)', filled: true, dashed: true, gameRadius: 42.5, showRange: true, hideAnchorDot: true },
        'ANULAR/cmd': { shape: 'circle', radius: 55, color: 'rgba(100, 200, 255, 0.1)', filled: true, dashed: true, gameRadius: 42.5, showRange: true, hideAnchorDot: true },
        
        // Fade
        'Assombrar': { shape: 'circle', radius: 55, color: 'rgba(80, 50, 150, 0.3)', dashed: true, gameRadius: 30, showRange: true, lightBg: true },
        'Haunt': { shape: 'circle', radius: 55, color: 'rgba(80, 50, 150, 0.3)', dashed: true, gameRadius: 30, showRange: true, lightBg: true },
        'Clausura': { shape: 'circle', radius: 30, color: 'rgba(80, 50, 150, 0.15)', filled: true, gameRadius: 6.58, showRange: true, hideAnchorDot: true, lightBg: true },
        'Seize': { shape: 'circle', radius: 30, color: 'rgba(80, 50, 150, 0.15)', filled: true, gameRadius: 6.58, showRange: true, hideAnchorDot: true, lightBg: true },
        'Espreitador': { shape: 'creature', size: 20, color: '#4400ff', rotation: true, hideDirectionIndicator: true, noDragHandle: true },
        'Prowler': { shape: 'creature', size: 20, color: '#4400ff', rotation: true, hideDirectionIndicator: true, noDragHandle: true },
        'Véu da Noite': { shape: 'rect', width: 120, height: 200, color: 'rgba(20, 10, 30, 0.45)', rotation: true, originAtBottom: true, gameWidth: 20, gameHeight: 40, showRange: true },
        'Nightfall': { shape: 'rect', width: 120, height: 200, color: 'rgba(20, 10, 30, 0.45)', rotation: true, originAtBottom: true, gameWidth: 20, gameHeight: 40, showRange: true },
        
        // Gekko
        'Dizzy': { shape: 'chevron', rotation: true, hideDirectionIndicator: true, noDragHandle: true },
        'Wingman': { shape: 'chevron', rotation: true, noDragHandle: true },
        'Mosh Pit': { shape: 'circle', radius: 35, color: 'rgba(150, 255, 50, 0.5)', filled: true, gameRadius: 6.2 },
        'Thrash': { shape: 'creature', size: 22, color: '#88ff00', rotation: true, indicatorOffsetY: 10, indicatorWidth: 7, indicatorHeight: 5, indicatorStrokeWidth: 2.2, noDragHandle: true },

        // Miks
        'Pulso M': { shape: 'circle', radius: 28, color: 'rgba(90, 230, 190, 0.35)', filled: true, noDragHandle: true, gameRadius: 5.5 },
        'M-pulse': { shape: 'circle', radius: 28, color: 'rgba(90, 230, 190, 0.35)', filled: true, noDragHandle: true, gameRadius: 5.5 },
        'M-pulse Curar': { shape: 'circle', radius: 28, color: 'rgba(90, 230, 190, 0.95)', gameRadius: 5.5, showRange: true, ringOnly: true, ringWidth: 6, lightBg: true },
        'Bassquake': { shape: 'cone', color: 'rgba(188, 171, 87, 0.72)', rotation: true, showRange: true, dedicatedRender: true, gameLength: 40, gameAngle: 60, showAnchorMarker: true, showCenterDiamond: true, diamondColor: 'rgba(207, 122, 75, 0.95)', anchorColor: 'rgba(245, 247, 250, 0.98)' },
        'Melodia Sísmica': { shape: 'cone', color: 'rgba(188, 171, 87, 0.72)', rotation: true, showRange: true, dedicatedRender: true, gameLength: 40, gameAngle: 60, showAnchorMarker: true, showCenterDiamond: true, diamondColor: 'rgba(207, 122, 75, 0.95)', anchorColor: 'rgba(245, 247, 250, 0.98)' },
        'Melodia Sismica': { shape: 'cone', color: 'rgba(188, 171, 87, 0.72)', rotation: true, showRange: true, dedicatedRender: true, gameLength: 40, gameAngle: 60, showAnchorMarker: true, showCenterDiamond: true, diamondColor: 'rgba(207, 122, 75, 0.95)', anchorColor: 'rgba(245, 247, 250, 0.98)' },
        'Harmonia': { shape: 'flash', radius: 22, color: 'rgba(90, 230, 190, 0.4)', iconBg: true },
        'Harmony': { shape: 'flash', radius: 22, color: 'rgba(90, 230, 190, 0.4)', iconBg: true },
        'Ressonância': { shape: 'flash', radius: 22, color: 'rgba(90, 230, 190, 0.4)' },
        'Waveform': { shape: 'flash', radius: 22, color: 'rgba(90, 230, 190, 0.4)' },
        
        // Tejo
        'Guiado por Dados': { shape: 'rect', width: 150, height: 30, color: 'rgba(255, 200, 50, 0.4)', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Rajada Guiada': { shape: 'rect', width: 150, height: 30, color: 'rgba(255, 200, 50, 0.4)', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Guided Salvo': { shape: 'rect', width: 150, height: 30, color: 'rgba(255, 200, 50, 0.4)', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Onda Especial': { shape: 'circle', radius: 35, color: 'rgba(255, 200, 50, 0.4)', filled: true, gameRadius: 5.25 },
        'Entrega Especial': { shape: 'circle', radius: 35, color: 'rgba(255, 200, 50, 0.4)', filled: true, gameRadius: 5.25 },
        'Special Delivery': { shape: 'circle', radius: 35, color: 'rgba(255, 200, 50, 0.4)', filled: true, gameRadius: 5.25 },
        'Bloqueio do Fumante': { shape: 'circle', radius: 55, color: 'rgba(255, 200, 50, 0.3)', dashed: true, gameRadius: 20, showRange: true },
        'Drone Furtivo': { shape: 'circle', radius: 55, color: 'rgba(255, 200, 50, 0.3)', dashed: true, gameRadius: 20, showRange: true },
        'Stealth Drone': { shape: 'circle', radius: 55, color: 'rgba(255, 200, 50, 0.3)', dashed: true, gameRadius: 20, showRange: true },
        'Archangel\'s Ult': { shape: 'rect', width: 200, height: 40, color: 'rgba(255, 200, 50, 0.5)', rotation: true },
        'Armageddon': { shape: 'rect', width: 100, height: 200, color: 'rgba(255, 200, 50, 0.5)', rotation: true, originAtBottom: true, gameWidth: 12, gameHeight: 32, showRange: true },
        'Armagedom': { shape: 'rect', width: 100, height: 200, color: 'rgba(255, 200, 50, 0.5)', rotation: true, originAtBottom: true, gameWidth: 12, gameHeight: 32, showRange: true },
        
        // Veto
        'Travessia': { shape: 'circle', radius: 55, color: 'rgba(0, 180, 140, 0.3)', dashed: true, gameRadius: 24, showRange: true, hideAnchorDot: true },
        'Crosscut': { shape: 'circle', radius: 55, color: 'rgba(0, 180, 140, 0.3)', dashed: true, gameRadius: 24, showRange: true, hideAnchorDot: true },
        'Imobilidade': { shape: 'circle', radius: 30, color: 'rgba(0, 180, 140, 0.3)', dashed: true, gameRadius: 6.58, showRange: true, hideAnchorDot: true },
        'Chokehold': { shape: 'circle', radius: 30, color: 'rgba(0, 180, 140, 0.3)', dashed: true, gameRadius: 6.58, showRange: true, hideAnchorDot: true },
        'Interceptador': { shape: 'circle', radius: 50, color: 'rgba(0, 180, 140, 0.3)', dashed: true, gameRadius: 18, showRange: true, hideAnchorDot: true },
        'Interceptor': { shape: 'circle', radius: 50, color: 'rgba(0, 180, 140, 0.3)', dashed: true, gameRadius: 18, showRange: true, hideAnchorDot: true },
        'Evolução': { shape: 'flash', radius: 28, color: 'rgba(0, 180, 140, 0.5)', noDragHandle: true },
        'Evolution': { shape: 'flash', radius: 28, color: 'rgba(0, 180, 140, 0.5)', noDragHandle: true },
        
        // ===== SENTINELS =====
        // Sage
        'Orbe de Barreira': { shape: 'rect', width: 70, height: 14, color: 'rgba(0, 255, 200, 0.7)', rotation: true, noDragHandle: true },
        'Barrier Orb': { shape: 'rect', width: 70, height: 14, color: 'rgba(0, 255, 200, 0.7)', rotation: true, noDragHandle: true },
        'Orbe de Lentidão': { shape: 'circle', radius: 35, color: 'rgba(0, 255, 200, 0.4)', filled: true, gameRadius: 5 },
        'Slow Orb': { shape: 'circle', radius: 35, color: 'rgba(0, 255, 200, 0.4)', filled: true, gameRadius: 5 },
        'Orbe Curativo': { shape: 'flash', radius: 25, color: 'rgba(0, 255, 200, 0.4)', noDragHandle: true },
        'Healing Orb': { shape: 'flash', radius: 25, color: 'rgba(0, 255, 200, 0.4)', noDragHandle: true },
        'Ressurreição': { shape: 'flash', radius: 28, color: 'rgba(0, 255, 200, 0.4)', noDragHandle: true },
        'Resurrection': { shape: 'flash', radius: 28, color: 'rgba(0, 255, 200, 0.4)', noDragHandle: true },
        
        // Killjoy
        'Nanoenxame': { shape: 'circle', radius: 25, color: 'rgba(255, 255, 0, 0.5)', filled: true, gameRadius: 4.5 },
        'Nanoswarm': { shape: 'circle', radius: 25, color: 'rgba(255, 255, 0, 0.5)', filled: true, gameRadius: 4.5 },
        'Torreta': { shape: 'circle', radius: 40, color: 'rgba(255, 255, 0, 0.25)', rotation: true, noDragHandle: true, gameRadius: 9.5, showRange: true, rangeOverlays: [
          { gameRadius: 40, color: 'rgba(255, 232, 120, 0.72)', ringOnly: true, ringWidth: 2.5 }
        ] },
        'Turret': { shape: 'circle', radius: 40, color: 'rgba(255, 255, 0, 0.25)', rotation: true, noDragHandle: true, gameRadius: 9.5, showRange: true, rangeOverlays: [
          { gameRadius: 40, color: 'rgba(255, 232, 120, 0.72)', ringOnly: true, ringWidth: 2.5 }
        ] },
        'Robô de Alarme': { shape: 'circle', radius: 35, color: 'rgba(255, 255, 0, 0.25)', dashed: true, gameRadius: 5.5, showRange: true, hideAnchorDot: true, rangeOverlays: [
          { gameRadius: 5.5, color: 'rgba(255, 214, 102, 0.88)', ringOnly: true, ringWidth: 2 },
          { gameRadius: 40, color: 'rgba(255, 232, 120, 0.72)', ringOnly: true, ringWidth: 2.5 }
        ] },
        'Alarmbot': { shape: 'circle', radius: 35, color: 'rgba(255, 255, 0, 0.25)', dashed: true, gameRadius: 5.5, showRange: true, hideAnchorDot: true, rangeOverlays: [
          { gameRadius: 5.5, color: 'rgba(255, 214, 102, 0.88)', ringOnly: true, ringWidth: 2 },
          { gameRadius: 40, color: 'rgba(255, 232, 120, 0.72)', ringOnly: true, ringWidth: 2.5 }
        ] },
        'Confinamento': { shape: 'circle', radius: 55, color: 'rgba(255, 255, 0, 0.1)', filled: true, dashed: true, gameRadius: 32.5, showRange: true },
        'Lockdown': { shape: 'circle', radius: 55, color: 'rgba(255, 255, 0, 0.1)', filled: true, dashed: true, gameRadius: 32.5, showRange: true },
        
        // Cypher
        'Câmera Espiã': { shape: 'cone', width: 80, height: 100, color: 'rgba(0, 255, 255, 0.25)', rotation: true },
        'Spycam': { shape: 'cone', width: 80, height: 100, color: 'rgba(0, 255, 255, 0.25)', rotation: true },
        'Fio-Armadilha': { shape: 'tripwire', length: 70, color: '#00ffff', rotation: true, gameLength: 7, showRange: true, scalable: true, minScale: 0.15, maxScale: 2.14, defaultScale: 1.0 },
        'Trapwire': { shape: 'tripwire', length: 70, color: '#00ffff', rotation: true, gameLength: 7, showRange: true, scalable: true, minScale: 0.15, maxScale: 2.14, defaultScale: 1.0 },
        'Jaula Cibernética': { shape: 'cyber-cage', radius: 35, color: 'rgba(0, 255, 255, 0.4)', gameRadius: 3.72 },
        'Jaula Cibernetica': { shape: 'cyber-cage', radius: 35, color: 'rgba(0, 255, 255, 0.4)', gameRadius: 3.72 },
        'Gaiola Virtual': { shape: 'cyber-cage', radius: 35, color: 'rgba(0, 255, 255, 0.4)', gameRadius: 3.72 },
        'Cyber Cage': { shape: 'cyber-cage', radius: 35, color: 'rgba(0, 255, 255, 0.4)', gameRadius: 3.72 },
        'Rastreio Neural': { shape: 'icon', size: 28 },
        'Neural Theft': { shape: 'icon', size: 28 },
        
        // Chamber
        'Encontro': { shape: 'circle', radius: 20, color: 'rgba(255, 204, 0, 0.25)', dashed: true, gameRadius: 18, showRange: true, noDuration: true },
        'Rendezvous': { shape: 'circle', radius: 20, color: 'rgba(255, 204, 0, 0.25)', dashed: true, gameRadius: 18, showRange: true, noDuration: true },
        'Marca Registrada': { shape: 'circle', radius: 40, color: 'rgba(255, 200, 0, 0.25)', dashed: true, gameRadius: 10, showRange: true, hideAnchorDot: true },
        'Trademark': { shape: 'circle', radius: 40, color: 'rgba(255, 200, 0, 0.25)', dashed: true, gameRadius: 10, showRange: true, hideAnchorDot: true },
        'Headhunter': { shape: 'icon', size: 22 },
        'Tour De Force': { shape: 'icon', size: 26 },
        
        // Deadlock
        'Barreira de Contenção': { shape: 'barrier-mesh', color: '#4db8ff', rotation: true, gameArmLength: 5.5, showRange: true },
        'Rede de Barreira': { shape: 'barrier-mesh', color: '#4db8ff', rotation: true, gameArmLength: 5.5, showRange: true },
        'Barrier Mesh': { shape: 'barrier-mesh', color: '#4db8ff', rotation: true, gameArmLength: 5.5, showRange: true },
        'Sensor Sônico': { shape: 'rect', width: 60, height: 80, color: 'rgba(0, 255, 255, 0.3)', rotation: true, originAtBottom: true, gameWidth: 8, gameHeight: 9, showRange: true },
        'Sonic Sensor': { shape: 'rect', width: 60, height: 80, color: 'rgba(0, 255, 255, 0.3)', rotation: true, originAtBottom: true, gameWidth: 8, gameHeight: 9, showRange: true },
        'Casulo de Captura': { shape: 'circle', radius: 28, color: 'rgba(0, 255, 255, 0.5)', filled: true, gameRadius: 6.5 },
        'GravNet': { shape: 'circle', radius: 28, color: 'rgba(0, 255, 255, 0.5)', filled: true, gameRadius: 6.5 },
        // 'Aniquilação': removido por solicitação
        // 'Annihilation': removido por solicitação
        
        // Vyse
        'Shear': { shape: 'vyse-wall', color: 'rgba(148, 72, 240, 0.96)', width: 4, rotation: true, gameLength: 12, gameWidth: 1, showRange: true },
        'Cerca-Viva': { shape: 'vyse-wall', color: 'rgba(148, 72, 240, 0.96)', width: 4, rotation: true, gameLength: 12, gameWidth: 1, showRange: true },
        'Razorvine': { shape: 'circle', color: 'rgba(160, 80, 220, 0.25)', gameRadius: 6, filled: true },
        'Espinheiro Cortante': { shape: 'circle', color: 'rgba(160, 80, 220, 0.25)', gameRadius: 6, filled: true },
        'Arc Rose': { shape: 'circle', radius: 30, color: 'rgba(200, 150, 50, 0.4)', dashed: true, gameRadius: 10 },
        'Rosa Arcana': { shape: 'circle', radius: 30, color: 'rgba(200, 150, 50, 0.4)', dashed: true, gameRadius: 10 },
        'Steel Garden': { shape: 'circle', radius: 50, color: 'rgba(200, 150, 50, 0.1)', filled: true, dashed: true, gameRadius: 28, showRange: true, hideAnchorDot: true },
        'Jardim de Aço': { shape: 'circle', radius: 50, color: 'rgba(200, 150, 50, 0.1)', filled: true, dashed: true, gameRadius: 28, showRange: true, hideAnchorDot: true },
        
        // ===== DUELISTS =====
        // Jett
        'Deriva': { shape: 'flash', radius: 20, color: 'rgba(0, 200, 255, 0.4)' },
        'Drift': { shape: 'flash', radius: 20, color: 'rgba(0, 200, 255, 0.4)' },
        'Corrente Ascendente': { shape: 'flash', radius: 20, color: 'rgba(0, 200, 255, 0.4)' },
        'Updraft': { shape: 'flash', radius: 20, color: 'rgba(0, 200, 255, 0.4)' },
        'Brisa Veloz': { shape: 'dash', length: 60, color: '#00ccff', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Brisa de Impulso': { shape: 'dash', length: 60, color: '#00ccff', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Tailwind': { shape: 'dash', length: 60, color: '#00ccff', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Erupção Nebulosa': { shape: 'circle', radius: 30, color: 'rgba(0, 200, 255, 0.5)', filled: true, gameRadius: 3.35 },
        'Cloudburst': { shape: 'circle', radius: 30, color: 'rgba(0, 200, 255, 0.5)', filled: true, gameRadius: 3.35 },
        'Tormenta de Aço': { shape: 'flash', radius: 24, color: 'rgba(0, 200, 255, 0.4)' },
        'Blade Storm': { shape: 'flash', radius: 24, color: 'rgba(0, 200, 255, 0.4)' },
        
        // Phoenix
        'Mãos Quentes': { shape: 'circle', radius: 25, color: 'rgba(255, 100, 0, 0.5)', filled: true, gameRadius: 4.5 },
        'Hot Hands': { shape: 'circle', radius: 25, color: 'rgba(255, 100, 0, 0.5)', filled: true, gameRadius: 4.5 },
        'Curva de Luz': { shape: 'flash', radius: 35, color: 'rgba(255, 255, 100, 0.5)', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Bola Curva': { shape: 'flash', radius: 35, color: 'rgba(255, 255, 100, 0.5)', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Curveball': { shape: 'flash', radius: 35, color: 'rgba(255, 255, 100, 0.5)', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Labareda': { shape: 'phoenix-wall', color: 'rgba(255, 120, 20, 0.82)', width: 9, rotation: true, scalable: true, bendable: true, minScale: 0.33, maxScale: 1.0, gameLength: 21, gameWidth: 1.6 },
        'Blaze': { shape: 'phoenix-wall', color: 'rgba(255, 120, 20, 0.82)', width: 9, rotation: true, scalable: true, bendable: true, minScale: 0.33, maxScale: 1.0, gameLength: 21, gameWidth: 1.6 },
        'Renascimento': { shape: 'flash', radius: 26, color: 'rgba(255, 100, 0, 0.4)', noDragHandle: true },
        'Run It Back': { shape: 'flash', radius: 26, color: 'rgba(255, 100, 0, 0.4)', noDragHandle: true },
        
        // Raze
        'Cartuchos de Tinta': { shape: 'circle', radius: 30, color: 'rgba(255, 70, 0, 0.5)', filled: true, gameRadius: 5.5 },
        'Paint Shells': { shape: 'circle', radius: 30, color: 'rgba(255, 70, 0, 0.5)', filled: true, gameRadius: 5.5 },
        'Bumba': { shape: 'chevron', rotation: true, noDragHandle: true },
        'Boom Bot': { shape: 'chevron', rotation: true, noDragHandle: true },
        'Carga Explosiva': { shape: 'circle', radius: 20, color: 'rgba(255, 70, 0, 0.5)', filled: true, gameRadius: 5 },
        'Carga de Explosivos': { shape: 'circle', radius: 20, color: 'rgba(255, 70, 0, 0.5)', filled: true, gameRadius: 5 },
        'Blast Pack': { shape: 'circle', radius: 20, color: 'rgba(255, 70, 0, 0.5)', filled: true, gameRadius: 5 },
        'Estraga-Prazeres': { shape: 'circle', radius: 40, color: 'rgba(255, 70, 0, 0.4)', filled: true, gameRadius: 7 },
        'Estraga-prazeres': { shape: 'circle', radius: 40, color: 'rgba(255, 70, 0, 0.4)', filled: true, gameRadius: 7 },
        'Showstopper': { shape: 'circle', radius: 40, color: 'rgba(255, 70, 0, 0.4)', filled: true, gameRadius: 7 },
        
        // Reyna
        'Olhar Voraz': { shape: 'flash', radius: 30, color: 'rgba(255, 0, 200, 0.5)' },
        'Leer': { shape: 'flash', radius: 30, color: 'rgba(255, 0, 200, 0.5)' },
        'Devorar': { shape: 'flash', radius: 22, color: 'rgba(255, 0, 200, 0.4)', noDragHandle: true },
        'Devour': { shape: 'flash', radius: 22, color: 'rgba(255, 0, 200, 0.4)', noDragHandle: true },
        'Dispensar': { shape: 'flash', radius: 22, color: 'rgba(255, 0, 200, 0.4)', noDragHandle: true },
        'Dismiss': { shape: 'flash', radius: 22, color: 'rgba(255, 0, 200, 0.4)', noDragHandle: true },
        'Imperatriz': { shape: 'circle', radius: 45, color: 'rgba(255, 0, 200, 0.25)', dashed: true },
        'Empress': { shape: 'circle', radius: 45, color: 'rgba(255, 0, 200, 0.25)', dashed: true },
        
        // Yoru
        'Fenda Dimensional': { shape: 'teleport', size: 22, color: '#0044ff' },
        'Passagem Dimensional': { shape: 'teleport', size: 22, color: '#0044ff' },
        'Gatecrash': { shape: 'teleport', size: 22, color: '#0044ff' },
        'Ponto Cego': { shape: 'flash', radius: 30, color: 'rgba(255, 255, 100, 0.5)' },
        'Blindside': { shape: 'flash', radius: 30, color: 'rgba(255, 255, 100, 0.5)' },
        'Fakeout': { shape: 'creature', size: 18, color: '#0044ff' },
        'Distração': { shape: 'creature', size: 18, color: '#0044ff' },
        'Falcatrua': { shape: 'creature', size: 18, color: '#0044ff' },
        'Salto Dimensional': { shape: 'flash', radius: 26, color: 'rgba(0, 68, 255, 0.4)', noDragHandle: true },
        'Espionagem Dimensional': { shape: 'flash', radius: 26, color: 'rgba(0, 68, 255, 0.4)', noDragHandle: true },
        'Dimensional Drift': { shape: 'flash', radius: 26, color: 'rgba(0, 68, 255, 0.4)', noDragHandle: true },
        
        // Neon
        'Via Expressa': { shape: 'fast-lane', color: '#4d7bff', rotation: true, gameLength: 24, gameBackLength: 1, gameGap: 3.5, scalable: true, minScale: 0.2, maxScale: 1.6, defaultScale: 1.0 },
        'Pista Rápida': { shape: 'fast-lane', color: '#4d7bff', rotation: true, gameLength: 24, gameBackLength: 1, gameGap: 3.5, scalable: true, minScale: 0.2, maxScale: 1.6, defaultScale: 1.0 },
        'Fast Lane': { shape: 'fast-lane', color: '#4d7bff', rotation: true, gameLength: 24, gameBackLength: 1, gameGap: 3.5, scalable: true, minScale: 0.2, maxScale: 1.6, defaultScale: 1.0 },
        'Ricochete Elétrico': { shape: 'relay-bolt', radius: 50, color: 'rgba(60, 130, 200, 0.55)', gameRadius: 5, showRange: true },
        'Ricochete Eletrico': { shape: 'relay-bolt', radius: 50, color: 'rgba(60, 130, 200, 0.55)', gameRadius: 5, showRange: true },
        'Disparo Elétrico': { shape: 'relay-bolt', radius: 50, color: 'rgba(60, 130, 200, 0.55)', gameRadius: 5, showRange: true },
        'Disparo Eletrico': { shape: 'relay-bolt', radius: 50, color: 'rgba(60, 130, 200, 0.55)', gameRadius: 5, showRange: true },
        'Relay Bolt': { shape: 'relay-bolt', radius: 50, color: 'rgba(60, 130, 200, 0.55)', gameRadius: 5, showRange: true },
        'Equipamento Voltaico': { shape: 'dash', length: 50, color: '#00ffff', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Alta Velocidade': { shape: 'dash', length: 50, color: '#00ffff', rotation: true, noDragHandle: true, noRotationHandle: true },
        'High Gear': { shape: 'dash', length: 50, color: '#00ffff', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Sobrecarga': { shape: 'dash', length: 50, color: '#00ffff', rotation: true, noDragHandle: true, noRotationHandle: true },
        'Overdrive': { shape: 'dash', length: 50, color: '#00ffff', rotation: true, noDragHandle: true, noRotationHandle: true },
        
        // Iso
        'Contingência': { shape: 'rect', width: 120, height: 200, color: 'rgba(140, 20, 255, 0.35)', rotation: true, originAtBottom: true, gameWidth: 9, gameHeight: 27.5, showRange: true },
        'Contingency': { shape: 'rect', width: 120, height: 200, color: 'rgba(140, 20, 255, 0.35)', rotation: true, originAtBottom: true, gameWidth: 9, gameHeight: 27.5, showRange: true },
        'Centelha Debilitante': { shape: 'rect', width: 120, height: 200, color: 'rgba(140, 20, 255, 0.30)', rotation: true, originAtBottom: true, gameWidth: 6, gameHeight: 34.88, showRange: true },
        'Submersão': { shape: 'rect', width: 120, height: 200, color: 'rgba(140, 20, 255, 0.30)', rotation: true, originAtBottom: true, gameWidth: 6, gameHeight: 34.88, showRange: true },
        'Undercut': { shape: 'rect', width: 120, height: 200, color: 'rgba(140, 20, 255, 0.30)', rotation: true, originAtBottom: true, gameWidth: 6, gameHeight: 34.88, showRange: true },
        'Escudo Duplo': { shape: 'icon', size: 22 },
        'Double Tap': { shape: 'icon', size: 22 },
        'Fluxo Protetor': { shape: 'flash', radius: 22, color: 'rgba(140, 20, 255, 0.45)' },
        'Protective Flow': { shape: 'flash', radius: 22, color: 'rgba(140, 20, 255, 0.45)' },
        'Contrato de Abate': { shape: 'rect', width: 120, height: 200, color: 'rgba(140, 20, 255, 0.35)', rotation: true, originAtBottom: true, gameWidth: 15, gameHeight: 36, showRange: true },
        'Contrato de Morte': { shape: 'rect', width: 120, height: 200, color: 'rgba(140, 20, 255, 0.35)', rotation: true, originAtBottom: true, gameWidth: 15, gameHeight: 36, showRange: true },
        'Kill Contract': { shape: 'rect', width: 120, height: 200, color: 'rgba(140, 20, 255, 0.35)', rotation: true, originAtBottom: true, gameWidth: 15, gameHeight: 36, showRange: true },
        
        // Waylay (newest agent)
        'Patch Prowl': { shape: 'creature', size: 20, color: '#ff8844' },
        'Saturate': { shape: 'creature', size: 20, color: '#ff8844' },
        'Saturação': { shape: 'creature', size: 20, color: '#ff8844' },
        'Shroud Sight': { shape: 'cone', width: 80, height: 100, color: 'rgba(255, 136, 68, 0.3)' },
        'Lightspeed': { shape: 'cone', width: 80, height: 100, color: 'rgba(255, 136, 68, 0.3)' },
        'Velocidade da Luz': { shape: 'cone', width: 80, height: 100, color: 'rgba(255, 136, 68, 0.3)' },
        'Flash Grenade': { shape: 'flash', radius: 30, color: 'rgba(255, 255, 100, 0.5)' },
        'Refract': { shape: 'flash', radius: 30, color: 'rgba(255, 255, 100, 0.5)' },
        'Refração': { shape: 'flash', radius: 30, color: 'rgba(255, 255, 100, 0.5)' },
        'Recon Pulse': { shape: 'rect', width: 120, height: 200, color: 'rgba(255, 136, 68, 0.3)', rotation: true, originAtBottom: true, gameWidth: 13.50, gameHeight: 36, showRange: true },
        'Convergent Paths': { shape: 'rect', width: 120, height: 200, color: 'rgba(255, 136, 68, 0.3)', rotation: true, originAtBottom: true, gameWidth: 13.50, gameHeight: 36, showRange: true },
        'Caminhos Convergentes': { shape: 'rect', width: 120, height: 200, color: 'rgba(255, 136, 68, 0.3)', rotation: true, originAtBottom: true, gameWidth: 13.50, gameHeight: 36, showRange: true }
      };
    },

  /**
   * Cache de icones ja reduzidos ao tamanho de tela.
   *
   * Os icones de agente e habilidade vem da valorant-api em 1024px e sao
   * desenhados com ~35px de lado. Com `imageSmoothingQuality: 'high'` cada
   * drawImage desses refaz um downscale de 29x, e o render refaz isso para
   * todo elemento, todo frame — medido com 51 elementos, drawImage sozinho e
   * 90% do frame (17.5ms caem para 1.8ms sem ele). Guardando cada icone ja
   * reduzido num canvas offscreen: 18.2ms -> 3.1ms por frame (5.9x), com 32
   * entradas de cache.
   *
   * O patch fica no contexto, nao nas ~170 chamadas espalhadas pelo render:
   * vale para todas de uma vez, inclusive as que vierem depois.
   *
   * ponytail: LRU por contagem. Se a lista de icones crescer muito, trocar o
   * limite por soma de bytes (w*h*4).
   */
  _instalarCacheDeIcones(ctx) {
      if (!ctx || ctx.__zdIconCache) return;
      const cache = new Map();
      const MAX = 240;        // ~1 entrada por icone x nivel de zoom usado
      const RAZAO_MIN = 1.6;  // abaixo disso o downscale nao paga o cache
      const desenhar = ctx.drawImage.bind(ctx);
      ctx.__zdIconCache = cache;

      // `...args` e obrigatorio: drawImage tem forma de 3, 5 e 9 argumentos, e
      // uma assinatura fixa de 5 comeria os quatro ultimos da forma de 9.
      ctx.drawImage = (...args) => {
        if (args.length !== 5) return desenhar(...args);
        const [img, dx, dy, dw, dh] = args;
        if (!img || !dw || !dh) return desenhar(...args);
        // So <img> com src entra no cache. O render tambem desenha canvas
        // temporarios (recorte, trim de icone customizado), e canvas nao tem
        // `.src`: a chave virava `undefined|WxH` para todos eles e um icone
        // aparecia no lugar do outro. Sem src nao ha identidade, sem
        // identidade nao ha cache.
        if (!(img instanceof HTMLImageElement) || !img.src) return desenhar(...args);
        if (!img.complete) return desenhar(...args);  // carregando: desenha direto
        const nw = img.naturalWidth || 0;
        if (!nw) return desenhar(...args);
        if (nw / dw < RAZAO_MIN) return desenhar(...args);

        // O tamanho em pixels de tela depende do zoom e do dpr — sem eles na
        // chave, um zoom novo reusaria um tile borrado. O 2x extra e
        // supersampling: no tamanho exato de tela o tile perde nitidez contra
        // o downscale direto (visivel ao ampliar), e guardar o dobro sai de
        // graca — medido, o tile maior ficou ate um pouco mais rapido.
        const escala = (this.zoomLevel || 1) * (this._dpr || 1) * 2;
        const kw = Math.max(1, Math.round(dw * escala));
        const kh = Math.max(1, Math.round(dh * escala));
        if (kw >= nw) return desenhar(...args);

        const chave = img.src + '|' + kw + 'x' + kh;
        let tile = cache.get(chave);
        if (tile) {
          cache.delete(chave);   // LRU: reinsere no fim
        } else {
          tile = document.createElement('canvas');
          tile.width = kw;
          tile.height = kh;
          const tctx = tile.getContext('2d');
          tctx.imageSmoothingEnabled = true;
          tctx.imageSmoothingQuality = 'high';
          tctx.drawImage(img, 0, 0, kw, kh);
          if (cache.size >= MAX) cache.delete(cache.keys().next().value);
        }
        cache.set(chave, tile);
        return desenhar(tile, dx, dy, dw, dh);
      };
    },

  initCanvas() {
      this.canvas = document.getElementById('vp2-canvas');
      this.ctx = this.canvas.getContext('2d');
      this._instalarCacheDeIcones(this.ctx);

      // Primeira medida. Nesse instante o layout costuma nao estar fechado
      // ainda (barra de agentes, fontes, imagens do mapa), entao clientHeight
      // vem menor do que o valor final — e como o mapa e um quadrado de lado
      // min(largura, altura), ele nascia pequeno. Abrir o DevTools disparava
      // 'resize' e so ai a medida certa entrava. O ResizeObserver abaixo e o
      // que fecha isso: mede de novo quando o container realmente assenta,
      // seja por layout tardio, DevTools, zoom ou rotacao de tela.
      this.resizeCanvas();

      if (this._windowResizeHandler) {
        window.removeEventListener('resize', this._windowResizeHandler);
      }
      this._windowResizeHandler = () => {
        this.resizeCanvas();
        this.updateBottomAgentBarLayout();
      };
      window.addEventListener('resize', this._windowResizeHandler);

      this._observeCanvasArea();
    },

  /**
   * Remede o canvas sempre que o container muda de tamanho de verdade.
   *
   * Guarda o ultimo tamanho aplicado porque resizeCanvas() escreve largura e
   * altura no wrapper e no canvas, que sao filhos do elemento observado: sem a
   * comparacao, uma medida realimentaria a proxima em loop.
   */
  /**
   * getBoundingClientRect() no maximo uma vez por frame, por elemento.
   *
   * Os pontos que consultam rect ficam dentro de handlers de mousemove, e
   * getBoundingClientRect() forca o layout. O mouse dispara varias vezes por
   * frame durante um arrasto, entao era um recalculo de layout por evento —
   * um so para decidir se a lixeira acende, outro em toda conversao de
   * coordenada do cursor. Nem a lixeira nem o canvas se movem no meio de um
   * frame; medir uma vez por frame da o mesmo resultado.
   */
  _rectPorFrame(el, slot) {
      if (!el) return null;

      // `this[slot] &&` nao e defensividade: sem ele o cache "acerta" antes de
      // existir. Os dois campos nascem undefined, entao a primeira chamada caia
      // em `undefined === undefined` e devolvia o cache vazio — e como o token
      // so avanca no caminho que erra o cache, ele nunca avancava e TODA
      // chamada devolvia undefined. Quem le `.left` direto dentro de um mouseup
      // estourava antes de zerar `isDragging`: o arrasto ficava preso no cursor
      // e cada mousemove seguinte lancava de novo.
      if (this[slot] && this[slot + 'Frame'] === this._frameToken) {
        return this[slot];
      }

      this._frameToken = this._frameToken || 0;
      this[slot] = el.getBoundingClientRect();
      this[slot + 'Frame'] = this._frameToken;
      if (!this._frameTokenScheduled) {
        this._frameTokenScheduled = true;
        requestAnimationFrame(() => {
          this._frameToken = (this._frameToken || 0) + 1;
          this._frameTokenScheduled = false;
        });
      }
      return this[slot];
    },

  _trashBinRect() {
      return this._rectPorFrame(document.getElementById('vp2-trash-bin'), '_trashRectCache');
    },

  /** Rect do canvas — lido em toda conversao de coordenada do cursor. */
  _canvasRect() {
      return this._rectPorFrame(this.canvas, '_canvasRectCache');
    },

  _observeCanvasArea() {
      const area = document.querySelector('.vp2-canvas-container');
      if (!area || typeof ResizeObserver === 'undefined') return;

      this._canvasAreaObserver?.disconnect();
      this._lastAreaSize = null;

      this._canvasAreaObserver = new ResizeObserver(() => {
        const w = Math.floor(area.clientWidth);
        const h = Math.floor(area.clientHeight);
        if (!w || !h) return;
        if (this._lastAreaSize && this._lastAreaSize.w === w && this._lastAreaSize.h === h) return;
        this._lastAreaSize = { w, h };

        // Coalesce: o observer pode disparar varias vezes enquanto o layout
        // assenta, e cada resizeCanvas() e uma medida forcada.
        if (this._areaResizeRaf) cancelAnimationFrame(this._areaResizeRaf);
        this._areaResizeRaf = requestAnimationFrame(() => {
          this._areaResizeRaf = null;
          this.resizeCanvas();
          this.updateBottomAgentBarLayout();
        });
      });

      this._canvasAreaObserver.observe(area);
    },

  setupTeamSlotEvents() {
      console.log('🎯 Setting up team slot events...');
      
      // Setup slot click events for both teams
      ['ally', 'enemy'].forEach(team => {
        const container = document.getElementById(`vp2-${team}-slots`);
        console.log(`  Container vp2-${team}-slots:`, container ? 'found' : 'NOT FOUND');
        if (!container) return;
        
        // Remove old event listeners by cloning (to avoid duplicates)
        const newContainer = container.cloneNode(true);
        container.parentNode.replaceChild(newContainer, container);
        
        // Re-add drag events after cloning (agents only — abilities use custom mousedown drag)
        newContainer.addEventListener('dragstart', (e) => {
          const agentImg = e.target.closest('.vp2-slot-agent-img');
          const abilityIcon = e.target.closest('.vp2-slot-ability-icon');
          
          if (abilityIcon) { e.preventDefault(); return; } // block native drag for abilities
          
          if (agentImg) {
            this._setPlannerDragPayload(e.dataTransfer, {
              'drag-type': 'agent',
              'agent-uuid': agentImg.dataset.agentUuid,
              'agent-name': agentImg.dataset.agentName,
              team: agentImg.dataset.team
            });
            e.dataTransfer.effectAllowed = 'move';
            const dragAgent = this.agents.find(a => a.uuid === agentImg.dataset.agentUuid);
            this.dragPreview = {
              type: 'agent',
              agentUuid: agentImg.dataset.agentUuid,
              agentName: agentImg.dataset.agentName,
              team: agentImg.dataset.team || 'ally',
              icon: dragAgent?.displayIcon || dragAgent?.displayIconSmall || ''
            };
          }
        });
        
        newContainer.addEventListener('dragend', () => {
          if (this.dragPreview) { this.dragPreview = null; this.render(); }
        });

        // Custom mousedown drag for abilities (no ghost image)
        newContainer.addEventListener('mousedown', (e) => {
          const abilityIcon = e.target.closest('.vp2-slot-ability-icon');
          if (!abilityIcon) return;
          const agentUuid = abilityIcon.dataset.agentUuid;
          const agent = this.agents.find(a => a.uuid === agentUuid);
          const agentName = agent ? agent.displayName : '';
          const customIcon = this.getCustomAbilityIcon(agentName, abilityIcon.dataset.abilitySlot);
          this._initCustomAbilityDrag(e, {
            abilityName: abilityIcon.dataset.abilityName,
            slot: abilityIcon.dataset.abilitySlot,
            icon: customIcon || abilityIcon.dataset.abilityIcon || '',
            agentUuid: agentUuid,
            team: abilityIcon.dataset.team
          });
        });
        
        newContainer.addEventListener('click', (e) => {
          console.log('🖱️ Click in slots container', team, e.target);
          const slot = e.target.closest('.vp2-team-slot');
          const removeBtn = e.target.closest('.vp2-slot-remove');
          const abilityIcon = e.target.closest('.vp2-slot-ability-icon');
          
          if (removeBtn) {
            // Remove agent from slot
            const slotNum = parseInt(slot.dataset.slot) - 1;
            console.log('  Removing agent from slot', slotNum);
            this.removeAgentFromSlot(team, slotNum);
            e.stopPropagation();
          } else if (abilityIcon) {
            // Add ability to map
            const abilityName = abilityIcon.dataset.abilityName;
            const agentUuid = abilityIcon.dataset.agentUuid;
            console.log('  Adding ability to map:', abilityName);
            this.addAbilityToMap(abilityName, agentUuid, team);
            e.stopPropagation();
          } else if (slot) {
            // Open modal to select agent
            const slotNum = parseInt(slot.dataset.slot) - 1;
            console.log('  Opening modal for slot', slotNum);
            this.openAgentModal(team, slotNum);
          }
        });
      });
      
      // Setup modal events
      this.setupModalEvents();
      console.log('✅ Team slot events setup complete');
    },

  setupModalEvents() {
      console.log('🎯 Setting up modal events...');
      const modal = document.getElementById('vp2-agent-modal');
      const closeBtn = document.getElementById('vp2-modal-close');
      const overlay = modal?.querySelector('.vp2-modal-overlay');
      const grid = document.getElementById('vp2-agents-modal-grid');
      
      console.log('  Modal:', modal ? 'found' : 'NOT FOUND');
      console.log('  Close btn:', closeBtn ? 'found' : 'NOT FOUND');
      console.log('  Grid:', grid ? 'found' : 'NOT FOUND');
      console.log('  Grid children:', grid?.children?.length || 0);
      
      // Close modal
      closeBtn?.addEventListener('click', () => this.closeAgentModal());
      overlay?.addEventListener('click', () => this.closeAgentModal());
      
      // Category filter
      document.querySelectorAll('.vp2-category-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          document.querySelectorAll('.vp2-category-btn').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          this.filterAgentsByRole(btn.dataset.role);
        });
      });
      
      // Agent selection in modal
      grid?.addEventListener('click', (e) => {
        console.log('🖱️ Click in grid', e.target);
        const item = e.target.closest('.vp2-agent-modal-item');
        console.log('  Item:', item);
        if (item) {
          const uuid = item.dataset.agentUuid;
          console.log('  Selecting agent:', uuid);
          this.selectAgentForSlot(uuid);
        }
      });
      console.log('✅ Modal events setup complete');
    },

  setupAgentBarEvents() {
      // Agent bar clicks - left = ally, right = enemy
      const row = document.getElementById('vp2-agents-row');
      if (!row) return;

      const scheduleAbilitiesPopupHide = () => {
        clearTimeout(this._popupHideTimer);
        this._popupHideTimer = setTimeout(() => {
          const hoveredAgent = document.querySelector('.vp2-agent-bar-item:hover');
          const popupHovered = this._abilitiesPopup?.matches(':hover');
          if (hoveredAgent || popupHovered) return;
          if (this._abilitiesPopup) this._abilitiesPopup.classList.remove('visible');
          this._popupHoverAgent = null;
        }, 420);
      };

      if (!row.dataset.wheelBound) {
        row.dataset.wheelBound = 'true';
        this._agentBarWheelState = this._agentBarWheelState || { delta: 0, rafId: 0 };
        row.addEventListener('wheel', (e) => {
          if (row.scrollWidth <= row.clientWidth) return;
          const delta = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
          if (!delta) return;
          e.preventDefault();
          this._agentBarWheelState.delta += delta;
          if (this._agentBarWheelState.rafId) return;
          this._agentBarWheelState.rafId = requestAnimationFrame(() => {
            row.scrollLeft += this._agentBarWheelState.delta;
            this._agentBarWheelState.delta = 0;
            this._agentBarWheelState.rafId = 0;
          });
        }, { passive: false });
      }

      row.addEventListener('click', (e) => {
        if (this._agentBarDragged) { this._agentBarDragged = false; return; }
        const item = e.target.closest('.vp2-agent-bar-item');
        if (!item) return;
        this.addAgentFromBar(item.dataset.agentUuid, 'ally');
      });

      row.addEventListener('contextmenu', (e) => {
        e.preventDefault();
        const item = e.target.closest('.vp2-agent-bar-item');
        if (!item) return;
        this.addAgentFromBar(item.dataset.agentUuid, 'enemy');
      });

      row.addEventListener('mousedown', (e) => {
        const item = e.target.closest('.vp2-agent-bar-item');
        if (!item || e.button !== 0) return;
        const uuid = item.dataset.agentUuid;
        const agent = this.agents.find(a => a.uuid === uuid);
        if (!agent) return;
        this._initCustomAgentDrag(e, {
          agentUuid: uuid,
          agentName: agent.displayName,
          team: 'ally',
          icon: agent.displayIcon || agent.displayIconSmall || ''
        });
      });

      // Drag agent from bar to map
      row.addEventListener('dragstart', (e) => {
        const item = e.target.closest('.vp2-agent-bar-item');
        if (!item) return;
        e.preventDefault();
      });

      row.addEventListener('dragend', () => {
        // Reset drag flag after a short delay so click handler can check it
        setTimeout(() => { this._agentBarDragged = false; }, 50);
      });

      // === Portal abilities popup ===
      if (!this._abilitiesPopup) {
        const popup = document.createElement('div');
        popup.className = 'vp2-agent-abilities-popup';
        document.body.appendChild(popup);
        this._abilitiesPopup = popup;
        this._popupHoverAgent = null;
        this._popupHideTimer = null;
        this._agentAbilityPopupCache = this._agentAbilityPopupCache || new Map();

        // Keep popup open when mouse enters it
        popup.addEventListener('mouseenter', () => {
          clearTimeout(this._popupHideTimer);
        });
        popup.addEventListener('mouseleave', () => {
          scheduleAbilitiesPopupHide();
        });

        // Block native drag for popup abilities (custom mousedown drag below)
        popup.addEventListener('dragstart', (e) => {
          const icon = e.target.closest('.vp2-ability-popup-icon');
          if (icon) { e.preventDefault(); return; }
        });

        popup.addEventListener('dragend', () => {
          if (this.dragPreview) { this.dragPreview = null; this.render(); }
        });

        // Custom mousedown drag for popup abilities (no ghost image)
        popup.addEventListener('mousedown', (e) => {
          const icon = e.target.closest('.vp2-ability-popup-icon');
          if (!icon) return;
          const agentUuid = icon.dataset.agentUuid;
          const agent = this.agents.find(a => a.uuid === agentUuid);
          const agentName = agent ? agent.displayName : '';
          const customIcon = this.getCustomAbilityIcon(agentName, icon.dataset.abilitySlot);
          this._initCustomAbilityDrag(e, {
            abilityName: icon.dataset.abilityName,
            slot: icon.dataset.abilitySlot,
            icon: customIcon || icon.dataset.abilityIcon || '',
            agentUuid: agentUuid,
            team: icon.dataset.team || 'ally'
          }, () => {
            // Hide popup when drag starts
            popup.classList.remove('visible');
            this._popupHoverAgent = null;
          });
        });

        // Click support - place ability on map center
        popup.addEventListener('click', (e) => {
          const icon = e.target.closest('.vp2-ability-popup-icon');
          if (!icon) return;
          const agentUuid = icon.dataset.agentUuid;
          const team = icon.dataset.team || 'ally';
          const abilityName = icon.dataset.abilityName;
          this.addAbilityToMap(abilityName, agentUuid, team);
          // Hide popup after click
          popup.classList.remove('visible');
          this._popupHoverAgent = null;
        });
      }

      row.addEventListener('mouseover', (e) => {
        const item = e.target.closest('.vp2-agent-bar-item');
        if (!item) return;
        const uuid = item.dataset.agentUuid;
        if (uuid === this._popupHoverAgent) {
          // Same agent — just clear the hide timer and keep popup open
          clearTimeout(this._popupHideTimer);
          return;
        }
        const agent = this.agents.find(a => a.uuid === uuid);
        if (!agent) return;

        clearTimeout(this._popupHideTimer);
        this._popupHoverAgent = uuid;

        const abilities = this.getDisplayAbilities(agent, { requireVisibleIcon: true });
        if (!abilities.length) return;

        // Determine team for drag data
        const team = item.classList.contains('ally-placed') ? 'ally' : 
                     item.classList.contains('enemy-placed') ? 'enemy' : 'ally';

        const cacheKey = `${uuid}:${team}:${abilities.map(ab => `${ab.slot}:${ab.displayIcon || ''}`).join('|')}`;
        let popupHtml = this._agentAbilityPopupCache.get(cacheKey);
        if (!popupHtml) {
          const gc = agent.backgroundGradientColors || [];
          const g0 = gc[0] ? '#' + gc[0].slice(0, 6) : '#1a1a2e';
          const g1 = gc[1] ? '#' + gc[1].slice(0, 6) : '#0f1923';
          const g2 = gc[2] ? '#' + gc[2].slice(0, 6) : '#1a1a2e';

          const abilitiesHtml = abilities.map(ab => {
            const iconSrc = ab.displayIcon || '';
            return `
          <div class="vp2-ability-popup-icon"
               data-ability-name="${ab.displayName}"
               data-ability-slot="${ab.slot}"
               data-ability-icon="${ab.displayIcon || ''}"
               data-agent-uuid="${uuid}"
               data-team="${team}"
               style="--agent-g0: ${g0}; --agent-g1: ${g1}; --agent-g2: ${g2};"
               title="${ab.displayName}">
            <img src="${iconSrc}" alt="${ab.displayName}" loading="lazy" draggable="false">
          </div>
        `;
          }).join('');
          popupHtml = `<div class="vp2-agent-abilities-popup-row">${abilitiesHtml}</div>`;
          this._agentAbilityPopupCache.set(cacheKey, popupHtml);
        }

        this._abilitiesPopup.innerHTML = popupHtml;

        // Position ABOVE the agent item
        const rect = item.getBoundingClientRect();
        const popupW = this._abilitiesPopup.offsetWidth || 180;
        let left = rect.left + rect.width / 2;
        this._abilitiesPopup.style.left = left + 'px';
        this._abilitiesPopup.style.top = (rect.top - 4) + 'px';
        this._abilitiesPopup.style.transform = 'translate(-50%, -100%)';
        this._abilitiesPopup.classList.add('visible');

        // Clamp to viewport after render
        requestAnimationFrame(() => {
          const pr = this._abilitiesPopup.getBoundingClientRect();
          if (pr.left < 4) {
            this._abilitiesPopup.style.left = (4 + pr.width / 2) + 'px';
          }
          if (pr.right > window.innerWidth - 4) {
            this._abilitiesPopup.style.left = (window.innerWidth - 4 - pr.width / 2) + 'px';
          }
          if (pr.top < 4) {
            // If no room above, show below instead
            this._abilitiesPopup.style.top = (rect.bottom + 8) + 'px';
            this._abilitiesPopup.style.transform = 'translate(-50%, 0)';
          }
        });
      });

      row.addEventListener('mouseout', (e) => {
        const related = e.relatedTarget;
        // Stay open if moving to another agent item or into the popup itself
        if (related && related.closest) {
          if (related.closest('.vp2-agent-bar-item') || related.closest('.vp2-agent-abilities-popup')) return;
        }
        scheduleAbilitiesPopupHide();
      });

      // Also hide when mouse leaves the row entirely
      row.addEventListener('mouseleave', (e) => {
        const related = e.relatedTarget;
        if (related && related.closest && related.closest('.vp2-agent-abilities-popup')) return;
        scheduleAbilitiesPopupHide();
      });

    },

  setupEventListeners() {
      // Map selector in panel
      const mapCurrent = document.getElementById('vp2-map-current');
      if (mapCurrent) {
        mapCurrent.addEventListener('click', (e) => this.toggleMapDropdown(e));
      }
      const mapDropdown = document.getElementById('vp2-map-dropdown');
      if (mapDropdown) {
        mapDropdown.addEventListener('click', (e) => {
          const item = e.target.closest('.lu-map-item');
          if (item && item.dataset.map) {
            this.selectMapFromDropdown(item.dataset.map, e);
          }
        });
      }

      // Close map grid on outside click
      if (this._documentClickHandler) {
        document.removeEventListener('click', this._documentClickHandler);
      }
      this._documentClickHandler = (e) => {
        if (this._justOpenedDropdown) return;
        if (this.mapDropdownOpen && !e.target.closest('.vp2-panel-section')) {
          this.mapDropdownOpen = false;
          const grid = document.getElementById('vp2-map-dropdown');
          if (grid) grid.classList.remove('open');
          document.getElementById('vp2-map-current')?.classList.remove('lu-map-dropdown-open');
        }
      };
      document.addEventListener('click', this._documentClickHandler);
      
      // Side toggle — o botao vem do componente compartilhado (.lu-map-side-*),
      // sem id proprio: delega no grupo.
      const sideControls = document.querySelector('.vp2-panel-side-section .lu-map-side-controls');
      if (sideControls) {
        sideControls.addEventListener('click', (e) => {
          const btn = e.target.closest('.lu-map-side-btn');
          const side = btn?.dataset.side;
          if (!side || this.currentSide === side) return;
          this.currentSide = side;
          sideControls.querySelectorAll('.lu-map-side-btn').forEach((b) => {
            const on = b.dataset.side === side;
            b.classList.toggle('active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          // Vira o mapa como na /lineups; o redesenho acontece no fim do giro.
          this.animateSideFlip(() => this.render());
        });
      }

      const roleFilterGrid = document.getElementById('vp2-role-filter-grid');
      if (roleFilterGrid) {
        roleFilterGrid.addEventListener('click', (e) => {
          const button = e.target.closest('.vp2-role-filter-btn');
          if (!button?.dataset.roleKey) return;
          this.setAgentRoleFilter(button.dataset.roleKey);
        });
      }

      const agentSearchInput = document.getElementById('vp2-agent-search');
      if (agentSearchInput) {
        agentSearchInput.addEventListener('input', (e) => {
          this.currentAgentSearch = e.target.value.trim();
          this.renderAgentsBar();
        });
      }
      
      // Tool buttons
      document.querySelectorAll('.vp2-tool').forEach(btn => {
        btn.addEventListener('click', () => {
          const tool = btn.dataset.tool;
          
          if (tool === 'zoom-in') {
            this.zoomIn();
          } else if (tool === 'zoom-out') {
            this.zoomOut();
          } else if (tool === 'reset-view') {
            this.resetView();
          } else if (tool === 'text') {
            // Text tool: always open modal, never stays active
            const canvas = this.canvas;
            if (canvas) {
              const centerX = (this._cssPxW / 2 - this.panX) / this.zoomLevel - this._mapOffsetX;
              const centerY = (this._cssPxH / 2 - this.panY) / this.zoomLevel - this._mapOffsetY;
              this.showTextInputModal(centerX, centerY);
            }
          } else if (tool === 'image') {
            // Image tool: always open modal immediately, no persistent active state
            this.showImageModal();
          } else {
            // Toggle: click active tool to deactivate, click inactive to activate
            const canvas = this.canvas;
            if (this.currentTool === tool) {
              // Deactivate
              btn.classList.remove('active');
              this.currentTool = null;
              if (canvas) canvas.style.cursor = 'default';
            } else {
              // Activate
              document.querySelectorAll('.vp2-tool').forEach(b => b.classList.remove('active'));
              btn.classList.add('active');
              this.currentTool = tool;
              if (canvas) {
                const cursors = {
                  'pen': 'crosshair',
                  'line': 'crosshair',
                  'arrow': 'crosshair',
                  'circle': 'crosshair',
                  'eraser': 'not-allowed'
                };
                canvas.style.cursor = cursors[tool] || 'default';
              }
            }
          }
        });
      });
      
      // Color/style pickers
      const strokeColorInput = document.getElementById('vp2-stroke-color');
      if (strokeColorInput) {
        strokeColorInput.addEventListener('input', (e) => {
          this.settings.strokeColor = e.target.value;
        });
      }
      
      const strokeWidthInput = document.getElementById('vp2-stroke-width');
      if (strokeWidthInput) {
        strokeWidthInput.addEventListener('input', (e) => {
          this.settings.strokeWidth = parseInt(e.target.value);
        });
      }

      // Fixed tooltip for section labels (bypasses panel overflow:hidden clipping)
      let _fixedTip = document.getElementById('vp2-fixed-tooltip');
      if (!_fixedTip) {
        _fixedTip = document.createElement('div');
        _fixedTip.id = 'vp2-fixed-tooltip';
        document.body.appendChild(_fixedTip);
      }
      let _fixedTipTimer = null;
      document.querySelectorAll('.vp2-section-label-tooltip[data-tooltip]').forEach(el => {
        el.addEventListener('mouseenter', (e) => {
          clearTimeout(_fixedTipTimer);
          _fixedTip.textContent = el.dataset.tooltip;
          const rect = el.getBoundingClientRect();
          // Position: to the right of the element, vertically centered
          let left = rect.right + 12;
          let top = rect.top + rect.height / 2;
          // Clamp horizontally so it never overflows viewport
          const tipW = 220;
          if (left + tipW > window.innerWidth - 8) {
            left = rect.left - tipW - 12;
          }
          _fixedTip.style.left = left + 'px';
          _fixedTip.style.top = top + 'px';
          _fixedTip.style.transform = 'translateY(-50%)';
          _fixedTip.classList.add('visible');
        });
        el.addEventListener('mouseleave', () => {
          _fixedTipTimer = setTimeout(() => _fixedTip.classList.remove('visible'), 80);
        });
      });
      
      // Header buttons
      document.getElementById('vp2-clear')?.addEventListener('click', () => this.clearAll());
      document.getElementById('vp2-clear-all-paths')?.addEventListener('click', () => this.clearAllPaths());
      document.getElementById('vp2-map-lock')?.addEventListener('click', () => {
        this.mapLocked = !this.mapLocked;
        const icon = document.getElementById('vp2-lock-icon');
        const btn = document.getElementById('vp2-map-lock');
        if (this.mapLocked) {
          icon?.classList.replace('fa-lock-open', 'fa-lock');
          btn?.classList.remove('vp2-lock-open');
        } else {
          icon?.classList.replace('fa-lock', 'fa-lock-open');
          btn?.classList.add('vp2-lock-open');
        }
      });
      document.getElementById('vp2-undo')?.addEventListener('click', () => this.undo());
      document.getElementById('vp2-redo')?.addEventListener('click', () => this.redo());
      document.getElementById('vp2-save')?.addEventListener('click', () => this.saveStrategy());
      document.getElementById('vp2-save-tactic-btn')?.addEventListener('click', () => this.showSaveTacticModal());

      // If user is not logged in, hint visually that "Enviar para Táticas" requires login
      try {
        const _logged = typeof auth !== 'undefined' && auth && auth.isAuthenticated;
        const _saveBtn = document.getElementById('vp2-save-tactic-btn');
        if (_saveBtn && !_logged) {
          _saveBtn.classList.add('vp2-requires-auth');
          _saveBtn.title = 'Entre em uma conta para enviar para Táticas';
          const _label = _saveBtn.querySelector('span');
          if (_label) _label.textContent = 'Entrar para Enviar';
          const _icon = _saveBtn.querySelector('i');
          if (_icon) { _icon.className = 'fas fa-lock'; }
        }
      } catch (_) {}
      
      // Timeline controls
      document.getElementById('vp2-play')?.addEventListener('click', () => this.togglePlay());
      document.getElementById('vp2-stop')?.addEventListener('click', () => {
        this.stopPlayback();
        // Prevent confusion: reset pathDrawingAgent so stop never clears paths
        // (only the eraser button should clear)
      });
      document.getElementById('vp2-speed')?.addEventListener('change', (e) => {
        this.playbackSpeed = parseFloat(e.target.value);
      });
      
      // PATH SYSTEM - Botões de trajetória
      document.getElementById('vp2-toggle-paths')?.addEventListener('click', () => this.toggleShowPaths());
      document.getElementById('vp2-clear-paths')?.addEventListener('click', () => this.clearSelectedAgentPath());
      
      // Timeline track click
      const track = document.getElementById('vp2-timeline-track');
      if (track) {
        track.addEventListener('click', (e) => {
          const rect = track.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const progress = x / rect.width;
          this.seekTo(progress * this.timeline.duration);
        });
      }
      
      // Canvas events
      this.setupCanvasEvents();
      
      // Drag and drop events
      this.setupDragDrop();
      
      // Keyboard shortcuts
      this.setupKeyboardShortcuts();
      
    },

  setupCanvasEvents() {
      const canvas = this.canvas;
      if (!canvas) return;
      
      // Mouse down
      canvas.addEventListener('mousedown', (e) => {
        try {
        const pos = this.getCanvasPosition(e);
        // ABILITY PLACEMENT MODE — clique no mapa para posicionar habilidade
        if (this.abilityPlacementMode && e.button === 0) {
          const pm = this.abilityPlacementMode;
          this.cancelAbilityPlacement();
          this.addAbilityMarker(pm.agentId, pm.timeMs, pm.ability, { x: pos.x, y: pos.y });
          return;
        }

        // Right-click is handled by its own listener below
        if (e.button === 2) return;

        if (e.button === 1 || (e.button === 0 && e.altKey)) {
          // Middle click or Alt+Left click = pan (only when zoomed beyond default)
          if (!this.mapLocked && this.zoomLevel > 1) {
            this.isPanning = true;
            this.startX = e.clientX - this.panX;
            this.startY = e.clientY - this.panY;
            canvas.style.cursor = 'grabbing';
          }
          return;
        }
        
        // PATH MODE - Modo de criação de trajetória com ARRASTO
        if (this.pathMode) {
          // PRIORIDADE 1: Verifica waypoints de habilidade primeiro (para arrastar)
          const waypointHit = this.getPathAbilityWaypointAtPosition(pos.x, pos.y);
          if (waypointHit) {
            const wps = this.pathAbilityWaypoints.get(waypointHit.agentId);
            if (wps && wps[waypointHit.waypointIndex]) {
              this.draggingPathWaypoint = {
                agentId: waypointHit.agentId,
                waypointIndex: waypointHit.waypointIndex,
                waypoint: wps[waypointHit.waypointIndex]
              };
              canvas.style.cursor = 'grabbing';
              this.render();
            }
            return;
          }

          // PRIORIDADE 2: Verifica agente (para desenhar trajetória)
          const clickedAgent = this.getAgentAtPosition(pos.x, pos.y);
          
          if (clickedAgent) {
            // Clicou em um agente - seleciona e inicia arrasto de trajetória
            this.pathDrawingAgent = clickedAgent;
            this.selectedElement = clickedAgent;
            this.selectedElements = [clickedAgent];
            this.isDrawingPath = true;
            
            // Limpa trajetória anterior e cria nova com posição inicial
            this.agentPaths.set(clickedAgent.id, [{
              x: clickedAgent.x,
              y: clickedAgent.y,
              time: 0
            }]);
            console.log('🎯 Arraste para desenhar trajetória de:', clickedAgent.agentName);
            
            canvas.style.cursor = 'crosshair';
            
            this.render();
          } else {
            // PRIORIDADE 3: Verifica se clicou na linha da trajetória
            const pathHit = this.getPathAtPosition(pos.x, pos.y);
            if (pathHit) {
              this.showAbilityMenuForPath(pathHit.agentId, pathHit, e.clientX, e.clientY);
            } else {
              // PRIORIDADE 4: Clicou no espaço vazio com agente selecionado → trajetória automática
              const selectedAgents = this.selectedElements.filter(el =>
                el.type === 'agent' || el.type === 'player'
              );
              if (selectedAgents.length === 1) {
                this.pathDrawingAgent = selectedAgents[0];
                this.isDrawingPath = true;
                this.agentPaths.set(selectedAgents[0].id, [{
                  x: selectedAgents[0].x, y: selectedAgents[0].y, time: 0
                }]);
                console.log('🎯 Trajetória iniciada do espaço vazio:', selectedAgents[0].agentName);
                canvas.style.cursor = 'crosshair';
                this.render();
              }
            }
          }
          return;
        }
        
        // (X button click detection removed — use trash bin to delete agents)
        
        if (this.currentTool === 'select' || this.currentTool === null) {
          const bendHandle = this.getBendHandleAtPosition(pos.x, pos.y);
          if (bendHandle) {
            this.isAdjustingBend = true;
            this.bendingElement = bendHandle;
            this.selectedElement = bendHandle;
            this.selectedElements = [bendHandle];
            canvas.style.cursor = 'grab';
            this.showProperties(bendHandle);
            this.updateElementsList();
            this.updateDeleteSelectedBtn();
            this.render();
            return;
          }

          // 0b) Check if clicked on an image resize corner handle
          const imgCorner = this.getImageResizeCorner(pos.x, pos.y);
          if (imgCorner) {
            const el = this.selectedElement;
            const w = el.width || 200, h = el.height || 150;
            const hw = w / 2, hh = h / 2;
            const cL = el.cropLeft || 0, cT = el.cropTop || 0;
            const cR = el.cropRight || 0, cB = el.cropBottom || 0;
            const cropX = -hw + cL * w, cropY = -hh + cT * h;
            const cropW = w * (1 - cL - cR), cropH = h * (1 - cT - cB);
            // Fixed corner is the opposite one of the cropped area
            const rot = this.mapRotations[this.currentMap];
            const R = rot ? (rot.baseRotation || 0) * Math.PI / 180 : 0;
            const f = (rot && rot.flipForDefense && this.currentSide === 'defense') ? -1 : 1;
            const cosR = Math.cos(R), sinR = Math.sin(R);
            const fixedLx = imgCorner.includes('l') ? cropX + cropW : cropX;
            const fixedLy = imgCorner.includes('t') ? cropY + cropH : cropY;
            this._resizingImage = true;
            this._resizingImageEl = el;
            this._resizingImageCorner = imgCorner;
            this._resizingImageFixedX = el.x + f * fixedLx * cosR + f * fixedLy * sinR;
            this._resizingImageFixedY = el.y + f * (-fixedLx * sinR + fixedLy * cosR);
            this._resizingImageOrigAR = (el.width || 200) / (el.height || 150);
            canvas.style.cursor = 'nwse-resize';
            return;
          }

          // 0c) Check if clicked on an image crop edge handle (cyan squares)
          const cropHandleSide = this.getImageCropHandle(pos.x, pos.y);
          if (cropHandleSide) {
            this._croppingImage = true;
            this._croppingImageEl = this.selectedElement;
            this._croppingHandleSide = cropHandleSide;
            canvas.style.cursor = 'crosshair';
            return;
          }

          // 0a) Check if clicked on drag handle (white circle at origin) — initiate move
          const dragHandle = this.getDragHandleAtPosition(pos.x, pos.y);
          if (dragHandle) {
            this.selectedElement = dragHandle;
            this.selectedElements = [dragHandle];
            this.isDragging = true;
            this.dragMoved = false;
            this.dragOffsetX = pos.x - dragHandle.x;
            this.dragOffsetY = pos.y - dragHandle.y;
            canvas.style.cursor = 'grabbing';
            this.showProperties(dragHandle);
            this.updateElementsList();
            this.updateDeleteSelectedBtn();
            this.render();
            return;
          }

          // 0) Check if clicked on a rotation handle (red diamond — also handles scale for scalable abilities)
          // Skip rotation handle only if a DIFFERENT element (not the handle's own ability) is on top
          const _elemAtRot = this.getElementAtPosition(pos.x, pos.y);
          const _rotHandleCandidate = this.getRotationHandleAtPosition(pos.x, pos.y);
          // Allow rotation handle if no overlapping element, or if the overlapping element IS the handle's owner,
          // or if the ability is a dedicated rect (originAtBottom+showRange) whose hitbox is at origin — losango is far from origin
          const _rotShape = _rotHandleCandidate ? this.abilityShapes[_rotHandleCandidate.abilityName] : null;
          const _isDedRect = _rotShape && _rotShape.shape === 'rect' && _rotShape.originAtBottom && _rotShape.showRange && _rotShape.gameWidth && _rotShape.gameHeight;
          const rotHandle = (!_elemAtRot || _elemAtRot === _rotHandleCandidate || _isDedRect) ? _rotHandleCandidate : null;
          if (rotHandle) {
            this.isRotating = true;
            this.rotatingElement = rotHandle;
            this.selectedElement = rotHandle;
            this.selectedElements = [rotHandle];
            // Store initial angle so rotation is relative, not absolute
            this._rotStartAngle = Math.atan2(pos.y - rotHandle.y, pos.x - rotHandle.x) * 180 / Math.PI;
            this._rotStartRotation = rotHandle.rotation || 0;
            canvas.style.cursor = 'default';
            return;
          }

          // 1) Verifica se clicou em um marcador de habilidade na trajetória (para arrastar)
          const waypointHit = this.getPathAbilityWaypointAtPosition(pos.x, pos.y);
          if (waypointHit) {
            const wps = this.pathAbilityWaypoints.get(waypointHit.agentId);
            if (wps && wps[waypointHit.waypointIndex]) {
              this.draggingPathWaypoint = {
                agentId: waypointHit.agentId,
                waypointIndex: waypointHit.waypointIndex,
                waypoint: wps[waypointHit.waypointIndex]
              };
              canvas.style.cursor = 'grabbing';
              this.render();
            }
            return;
          }

          const element = this.getElementAtPosition(pos.x, pos.y);
          
          if (element) {
            if (e.shiftKey) {
              // Multi-select
              if (this.selectedElements.includes(element)) {
                this.selectedElements = this.selectedElements.filter(el => el !== element);
              } else {
                this.selectedElements.push(element);
              }
              this.selectedElement = element;
            } else {
              this.selectedElement = element;
              this.selectedElements = [element];
            }
            
            this.isDragging = true;
            this.dragMoved = false;
            this.dragOffsetX = pos.x - element.x;
            this.dragOffsetY = pos.y - element.y;
            
            this.updateElementsList();
            this.showProperties(element);
            this.updateDeleteSelectedBtn();
          } else {
            // 2) Verifica se clicou em uma linha de trajetória (para adicionar habilidade)
            const pathHit = this.getPathAtPosition(pos.x, pos.y);
            if (pathHit) {
              this.showAbilityMenuForPath(pathHit.agentId, pathHit, e.clientX, e.clientY);
              return;
            }

            // Click on empty space — clear selection and allow marquee/pan
            if (!e.shiftKey) {
              this.selectedElement = null;
              this.selectedElements = [];
            }
            this.hideProperties();
            this.updateElementsList();
            this.updateDeleteSelectedBtn();
          
            if (!this.mapLocked && this.zoomLevel > 1) {
              // Zoomed beyond default = pan
              this.isPanning = true;
              this.startX = e.clientX - this.panX;
              this.startY = e.clientY - this.panY;
              canvas.style.cursor = 'grabbing';
            }
          }
          
          this.render();
        } else if (this.currentTool === 'pen') {
          this.isDrawing = true;
          const newElement = {
            id: this.generateId(),
            type: 'pen',
            x: pos.x,
            y: pos.y,
            points: [{ x: pos.x, y: pos.y }],
            color: this.settings.strokeColor,
            width: this.settings.strokeWidth,
            side: this.currentSide,
            layer: this.elements.length
          };
          this.elements.push(newElement);
          this.saveState();
        } else if (['line', 'arrow', 'circle'].includes(this.currentTool)) {
          this.isDrawing = true;
          this.startX = pos.x;
          this.startY = pos.y;
          
          const newElement = {
            id: this.generateId(),
            type: this.currentTool,
            x: pos.x,
            y: pos.y,
            endX: pos.x,
            endY: pos.y,
            radius: 0,
            color: this.settings.strokeColor,
            width: this.settings.strokeWidth,
            side: this.currentSide,
            layer: this.elements.length
          };
          this.elements.push(newElement);
        } else if (this.currentTool === 'text') {
          this.showTextInputModal(pos.x, pos.y);
        } else if (this.currentTool === 'eraser') {
          // Eraser: remove element under cursor
          this.isErasing = true;
          const element = this.getElementAtPosition(pos.x, pos.y);
          if (element) {
            if (element.type === 'agent') {
              this.removeAgentFromMap(element);
            } else {
              this.elements = this.elements.filter(el => el.id !== element.id);
              this.saveState();
              this.updateElementsList();
              this.render();
            }
          }
        }
        } catch (err) { console.error('[VP2] mousedown error:', err); }
      });
      
      // Mouse move
      canvas.addEventListener('mousemove', (e) => {
        try {
        const pos = this.getCanvasPosition(e);

        // Track mouse for placement mode preview
        if (this.abilityPlacementMode) {
          this._lastCanvasMousePos = { x: pos.x, y: pos.y };
          this.requestRender();
          return;
        }

        // Habilidade seguindo cursor até confirmar posição — REMOVIDO, usa drag direto

        // Image resize handle drag
        if (this._resizingImage && this._resizingImageEl) {
          const el = this._resizingImageEl;
          const fixedX = this._resizingImageFixedX;
          const fixedY = this._resizingImageFixedY;
          const rot = this.mapRotations[this.currentMap];
          const R = rot ? (rot.baseRotation || 0) * Math.PI / 180 : 0;
          const f = (rot && rot.flipForDefense && this.currentSide === 'defense') ? -1 : 1;
          const cosR = Math.cos(R), sinR = Math.sin(R);
          const dx = pos.x - fixedX;
          const dy = pos.y - fixedY;
          // newCropW/H = new visible (cropped) dimensions
          const newCropW = Math.max(20, Math.abs(dx * cosR - dy * sinR));
          const newCropH = Math.max(20, Math.abs(dx * sinR + dy * cosR));
          // Back-calculate full image dimensions preserving crop fractions
          const cL = el.cropLeft || 0, cR2 = el.cropRight || 0;
          const cT = el.cropTop || 0, cB = el.cropBottom || 0;
          el.width  = newCropW / Math.max(0.01, 1 - cL - cR2);
          el.height = newCropH / Math.max(0.01, 1 - cT - cB);
          // Center of visible area in world coords = midpoint of drag and fixed corners
          const cropCX = (pos.x + fixedX) / 2;
          const cropCY = (pos.y + fixedY) / 2;
          // Offset from full image center to crop center (in local image space)
          const offLx = (cL - cR2) * el.width  / 2;
          const offLy = (cT - cB)  * el.height / 2;
          // Convert offset to world space and subtract to get full image center
          el.x = cropCX - f * (offLx * cosR + offLy * sinR);
          el.y = cropCY - f * (-offLx * sinR + offLy * cosR);
          this.requestRender();
          return;
        }

        // Image crop edge handle drag
        if (this._croppingImage && this._croppingImageEl) {
          const el = this._croppingImageEl;
          const w = el.width || 200;
          const h = el.height || 150;
          const hw = w / 2, hh = h / 2;
          const rot = this.mapRotations[this.currentMap];
          const R = rot ? (rot.baseRotation || 0) * Math.PI / 180 : 0;
          const f = (rot && rot.flipForDefense && this.currentSide === 'defense') ? -1 : 1;
          const cosR = Math.cos(R), sinR = Math.sin(R);
          const dx = pos.x - el.x, dy = pos.y - el.y;
          // Convert logical drag pos to image-local coords (undo map rotation/flip)
          const lx = f * (dx * cosR - dy * sinR);
          const ly = f * (dx * sinR + dy * cosR);
          const MIN_VIS = 0.05;
          switch (this._croppingHandleSide) {
            case 'top':
              el.cropTop = Math.max(0, Math.min(1 - (el.cropBottom || 0) - MIN_VIS, (ly + hh) / h));
              break;
            case 'bottom':
              el.cropBottom = Math.max(0, Math.min(1 - (el.cropTop || 0) - MIN_VIS, (hh - ly) / h));
              break;
            case 'left':
              el.cropLeft = Math.max(0, Math.min(1 - (el.cropRight || 0) - MIN_VIS, (lx + hw) / w));
              break;
            case 'right':
              el.cropRight = Math.max(0, Math.min(1 - (el.cropLeft || 0) - MIN_VIS, (hw - lx) / w));
              break;
          }
          this.requestRender();
          return;
        }

        // Rotation handle drag — red diamond: rotate for all, also scale for scalable abilities
        if (this.isRotating && this.rotatingElement) {
          const el = this.rotatingElement;
          const shape = this.abilityShapes[el.abilityName];
          const dx = pos.x - el.x;
          const dy = pos.y - el.y;
          if (shape && shape.shape === 'phoenix-wall') {
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist > 2) {
              const newEffRot = Math.atan2(dx, -dy) * 180 / Math.PI;
              const mapRot = this.mapRotations[this.currentMap];
              let adjust = mapRot ? (mapRot.baseRotation || 0) : 0;
              if (mapRot && mapRot.flipForDefense && this.currentSide === 'defense') adjust -= 180;
              el.rotation = newEffRot + adjust;
              const baseLength = this.getPhoenixWallMetrics(shape).length;
              const rawScale = dist / Math.max(baseLength, 1);
              const minSc = shape.minScale || 0.1;
              const maxSc = shape.maxScale || 2.5;
              el.abilityScale = Math.max(minSc, Math.min(maxSc, rawScale));
              this._syncAbilityScaleToWaypoints(el);
            }
          } else if (shape && shape.shape === 'tripwire' && shape.scalable) {
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist > 2) {
              const newEffRot = Math.atan2(dx, -dy) * 180 / Math.PI;
              const mapRot = this.mapRotations[this.currentMap];
              let adjust = mapRot ? (mapRot.baseRotation || 0) : 0;
              if (mapRot && mapRot.flipForDefense && this.currentSide === 'defense') adjust -= 180;
              el.rotation = newEffRot + adjust;
              const baseLength = this.getTripwireMetrics(shape).length;
              const rawScale = dist / Math.max(baseLength, 1);
              const minSc = shape.minScale || 0.15;
              const maxSc = shape.maxScale || 1.0;
              el.abilityScale = Math.max(minSc, Math.min(maxSc, rawScale));
              this._syncAbilityScaleToWaypoints(el);
            }
          } else if (shape && shape.shape === 'fast-lane' && shape.scalable) {
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist > 2) {
              const newEffRot = Math.atan2(dx, -dy) * 180 / Math.PI;
              const mapRot = this.mapRotations[this.currentMap];
              let adjust = mapRot ? (mapRot.baseRotation || 0) : 0;
              if (mapRot && mapRot.flipForDefense && this.currentSide === 'defense') adjust -= 180;
              el.rotation = newEffRot + adjust;
              const baseLength = this.getFastLaneMetrics(shape).length;
              const rawScale = dist / Math.max(baseLength, 1);
              const minSc = shape.minScale || 0.2;
              const maxSc = shape.maxScale || 2.14;
              el.abilityScale = Math.max(minSc, Math.min(maxSc, rawScale));
              this._syncAbilityScaleToWaypoints(el);
            }
          } else if (shape && shape.shape === 'harbor-wall' && shape.scalable) {
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist > 2) {
              const newEffRot = Math.atan2(dx, -dy) * 180 / Math.PI;
              const mapRot = this.mapRotations[this.currentMap];
              let adjust = mapRot ? (mapRot.baseRotation || 0) : 0;
              if (mapRot && mapRot.flipForDefense && this.currentSide === 'defense') adjust -= 180;
              el.rotation = newEffRot + adjust;
              const baseLength = this.getHarborWallMetrics(shape).length;
              const rawScale = dist / Math.max(baseLength, 1);
              const minSc = shape.minScale || 0.2;
              const maxSc = shape.maxScale || 1.0;
              el.abilityScale = Math.max(minSc, Math.min(maxSc, rawScale));
              this._syncAbilityScaleToWaypoints(el);
            }
          } else if (shape && shape.scalable) {
            // Combined rotate+scale: drag tip to cursor position
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist > 2) {
              const newEffRot = Math.atan2(dx, -dy) * 180 / Math.PI;
              const mapRot = this.mapRotations[this.currentMap];
              let adjust = mapRot ? (mapRot.baseRotation || 0) : 0;
              if (mapRot && mapRot.flipForDefense && this.currentSide === 'defense') adjust -= 180;
              el.rotation = newEffRot + adjust;
              // Use game-accurate full height for scale calculation
              let fullH;
              if (shape.showRange && shape.gameHeight) {
                fullH = shape.gameHeight * 100 * this.getCurrentMapScale() * this._mapSize;
              } else {
                fullH = shape.height;
              }
              const offsetPx = shape.originOffset && shape.showRange && shape.gameWidth ? shape.originOffset * 100 * this.getCurrentMapScale() * this._mapSize : 0;
              const rawScale = (dist - offsetPx) / Math.max(fullH, 1);
              const minSc = shape.minScale || 0.1;
              const maxSc = shape.maxScale || 2.5;
              el.abilityScale = Math.max(minSc, Math.min(maxSc, rawScale));
              this._syncAbilityScaleToWaypoints(el);
            }
          } else {
            const angle = Math.atan2(dy, dx) * 180 / Math.PI;
            const delta = angle - (this._rotStartAngle || 0);
            el.rotation = (this._rotStartRotation || 0) + delta;
          }
          this.requestRender();
          return;
        }

        if (this.isAdjustingBend && this.bendingElement) {
          const el = this.bendingElement;
          const shape = this.abilityShapes[el.abilityName];
          if (shape?.shape === 'harbor-wall' || shape?.shape === 'phoenix-wall') {
            const dx = pos.x - el.x;
            const dy = pos.y - el.y;
            const rot = this._getEffectiveRotation(el) * Math.PI / 180;
            const cosR = Math.cos(rot);
            const sinR = Math.sin(rot);
            const localX = dx * cosR + dy * sinR;
            if (shape.shape === 'phoenix-wall') {
              const { length } = this.getPhoenixWallMetrics(shape, el);
              const limit = this.getPhoenixWallCurveLimit(length);
              el.phoenixCurveOffset = Math.max(-limit, Math.min(limit, localX));
            } else {
              const { length } = this.getHarborWallMetrics(shape, el);
              const limit = this.getHarborWallCurveLimit(length);
              el.harborCurveOffset = Math.max(-limit, Math.min(limit, localX));
            }
            this._syncAbilityScaleToWaypoints(el);
          }
          this.requestRender();
          return;
        }

        // Arrastar marcador de habilidade na trajetória
        if (this.draggingPathWaypoint) {
          const wp = this.draggingPathWaypoint.waypoint;
          wp.x = pos.x;
          wp.y = pos.y;
          this.requestRender();
          return;
        }

        if (this.isPanning) {
          this.panX = e.clientX - this.startX;
          this.panY = e.clientY - this.startY;
          // Clamp pan to a limited area around center
          this._clampPan();
          this.requestRender();
          return;
        }
        
        // PATH MODE - Arrasto contínuo para desenhar trajetória
        if (this.isDrawingPath && this.pathDrawingAgent) {
          this.addPathPointFromDrag(this.pathDrawingAgent.id, pos.x, pos.y);
          return;
        }
        
        // Erase while dragging
        if (this.isErasing) {
          const element = this.getElementAtPosition(pos.x, pos.y);
          if (element) {
            if (element.type === 'agent') {
              this.removeAgentFromMap(element);
            } else {
              this.elements = this.elements.filter(el => el.id !== element.id);
              this.updateElementsList();
              this.requestRender();
            }
          }
          return;
        }

        if (this.isDragging && this.selectedElement) {
          const newX = pos.x - this.dragOffsetX;
          const newY = pos.y - this.dragOffsetY;
          
          this.dragMoved = true;

          // Clear path on first move for agents
          if (this.selectedElement.type === 'agent' && this.agentPaths.has(this.selectedElement.id)) {
            this.agentPaths.delete(this.selectedElement.id);
            this.pathAbilityWaypoints.delete(this.selectedElement.id);
          }

          // Move all selected elements
          const dx = newX - this.selectedElement.x;
          const dy = newY - this.selectedElement.y;
          
          this.selectedElements.forEach(el => {
            el.x += dx;
            el.y += dy;
          });
          
          // If recording, add keyframe
          if (this.isRecording) {
            this.addKeyframeForElement(this.selectedElement);
          }
          
          // Highlight trash bin when hovering over it during drag
          const trashBin = document.getElementById('vp2-trash-bin');
          if (trashBin) {
            const trashRect = this._trashBinRect();
            if (e.clientX >= trashRect.left && e.clientX <= trashRect.right &&
                e.clientY >= trashRect.top && e.clientY <= trashRect.bottom) {
              trashBin.classList.add('drag-hover');
            } else {
              trashBin.classList.remove('drag-hover');
            }
          }
          
          this.requestRender();
        } else if (this.isDrawing) {
          const lastElement = this.elements[this.elements.length - 1];
          
          if (lastElement) {
            if (lastElement.type === 'pen') {
              lastElement.points.push({ x: pos.x, y: pos.y });
            } else if (['line', 'arrow'].includes(lastElement.type)) {
              lastElement.endX = pos.x;
              lastElement.endY = pos.y;
            } else if (lastElement.type === 'circle') {
              const dx = pos.x - this.startX;
              const dy = pos.y - this.startY;
              lastElement.radius = Math.sqrt(dx * dx + dy * dy);
            }
            
            this.requestRender();
          }
        } else if ((this.currentTool === 'select' || this.currentTool === null) && !this.isDragging) {
          // Hover cursor
          const bendHover = this.getBendHandleAtPosition(pos.x, pos.y);
          if (bendHover) {
            canvas.style.cursor = 'pointer';
          } else {
            const dragHover = this.getDragHandleAtPosition(pos.x, pos.y);
            if (dragHover) {
            canvas.style.cursor = 'pointer';
          } else {
            const rotHover = this.getRotationHandleAtPosition(pos.x, pos.y);
            if (rotHover) {
              canvas.style.cursor = 'pointer';
              if (this._hoveredRotHandleId !== rotHover.id) {
                this._hoveredRotHandleId = rotHover.id;
                this.requestRender();
              }
            } else {
              if (this._hoveredRotHandleId) {
                this._hoveredRotHandleId = null;
                this.requestRender();
              }
              const hoverEl = this.getElementAtPosition(pos.x, pos.y);
              const imgCornerHover = this.getImageResizeCorner(pos.x, pos.y);
              const imgCropHover = !imgCornerHover && this.getImageCropHandle(pos.x, pos.y);
              canvas.style.cursor = imgCornerHover ? 'nwse-resize' : (imgCropHover ? 'crosshair' : (hoverEl ? 'pointer' : 'default'));
            }
          }
          }
        }
        } catch (err) { console.error('[VP2] mousemove error:', err); }
      });
      
      // Mouse up
      canvas.addEventListener('mouseup', (e) => {
        // End image resize — keep image selected so handles remain visible
        if (this._resizingImage) {
          this._resizingImage = false;
          this._resizingImageCorner = null;
          canvas.style.cursor = 'default';
          this.saveState();
          this.render();
          return;
        }

        // End image crop
        if (this._croppingImage) {
          this._croppingImage = false;
          this._croppingHandleSide = null;
          canvas.style.cursor = 'default';
          this.saveState();
          this.render();
          return;
        }

        // End rotation handle drag (also ends combined rotate+scale for scalable abilities)
        if (this.isRotating) {
          this.isRotating = false;
          this.rotatingElement = null;
          this.selectedElement = null;
          this.selectedElements = [];
          canvas.style.cursor = 'default';
          this.saveState();
          this.render();
          return;
        }

        if (this.isAdjustingBend) {
          this.isAdjustingBend = false;
          this.bendingElement = null;
          this.selectedElement = null;
          this.selectedElements = [];
          canvas.style.cursor = 'default';
          this.saveState();
          this.render();
          return;
        }

        if (this.isPanning) {
          this.isPanning = false;
          canvas.style.cursor = 'default';
        }
        
        // Finaliza arrasto de trajetória
        if (this.isDrawingPath) {
          this.isDrawingPath = false;
          canvas.style.cursor = this.pathMode ? 'crosshair' : 'default';
          
          if (this.pathDrawingAgent) {
            const path = this.agentPaths.get(this.pathDrawingAgent.id);
            if (path) {
              console.log(`✅ Trajetória finalizada: ${path.length} pontos`);
            }
            // Seleciona o agente para que a trajetória continue visível
            this.selectedElement = this.pathDrawingAgent;
            this.selectedElements = [this.pathDrawingAgent];
          }
          this.render();
        }
        
        // Finaliza arrasto de marcador de habilidade
        if (this.draggingPathWaypoint) {
          this.draggingPathWaypoint = null;
          canvas.style.cursor = 'default';
          this.saveState();
          this.render();
        }

        if (this.isDragging) {
          // Check if dropped onto the trash bin
          const trashBin = document.getElementById('vp2-trash-bin');
          if (trashBin && this.selectedElement) {
            const trashRect = this._trashBinRect();
            if (e.clientX >= trashRect.left && e.clientX <= trashRect.right &&
                e.clientY >= trashRect.top && e.clientY <= trashRect.bottom) {
              // Dropped on trash — delete element
              if (this.selectedElement.type === 'agent') {
                this.removeAgentFromMap(this.selectedElement);
              } else {
                this.deleteElement(this.selectedElement);
              }
              this.isDragging = false;
              this.selectedElement = null;
              this.selectedElements = [];
              trashBin.classList.remove('drag-hover');
              return;
            }
          }
          
          // Paths já foram limpos no mousemove na primeira movimentação
          // Click without drag on a text element → open editor
          if (!this.dragMoved && this.selectedElement && this.selectedElement.type === 'text') {
            const el = this.selectedElement;
            this.isDragging = false;
            this.selectedElement = null;
            this.selectedElements = [];
            this.showTextInputModal(el.x, el.y, el);
            return;
          }
          // Keep image elements selected so resize handles stay visible
          if (this.selectedElement && this.selectedElement.type === 'image') {
            this.isDragging = false;
            this.saveState();
            this.render();
            return;
          }
          // Bump layer so the moved element renders on top of others
          if (this.selectedElement && (this.selectedElement.type === 'ability' || this.selectedElement.type === 'agent' || this.selectedElement.type === 'player')) {
            this.selectedElement.layer = this._nextLayer++;
          }
          this.isDragging = false;
          this.selectedElement = null;
          this.selectedElements = [];
          this.saveState();
          this.render();
        }
        
        if (this.isDrawing) {
          this.isDrawing = false;
          this.saveState();
          this.updateElementsList();
        }

        if (this.isErasing) {
          this.isErasing = false;
          this.saveState();
        }
      });
      
      // Mouse leave — keep isDragging, isRotating, isAdjustingBend alive.
      // Document-level mousemove/mouseup handlers will continue to update and clean up.
      canvas.addEventListener('mouseleave', () => {
        this.isPanning = false;
        this._updateHoverHud(null);
        if (this.isErasing) {
          this.isErasing = false;
          this.saveState();
        }

        // Do NOT cancel isRotating or isAdjustingBend here — let document-level
        // handlers continue the operation smoothly even when the cursor briefly
        // exits the canvas (common for elements near the edges).
        
        // Finaliza desenho de trajetória se estava desenhando (sem otimização)
        if (this.isDrawingPath && this.pathDrawingAgent) {
          this.isDrawingPath = false;
          // Seleciona o agente para que a trajetória continue visível
          this.selectedElement = this.pathDrawingAgent;
          this.selectedElements = [this.pathDrawingAgent];
          this.render();
        }
        
        if (!this.isRotating && !this.isAdjustingBend && !this.isDragging) {
          canvas.style.cursor = this.pathMode ? 'crosshair' : 'default';
        }
      });

      // Document-level mouseup — catches drag releases over the trash bin or outside canvas
      if (this._documentMouseUpHandler) {
        document.removeEventListener('mouseup', this._documentMouseUpHandler);
      }
      this._documentMouseUpHandler = (e) => {
        // Clean up rotation/bend state if released outside canvas
        if (this.isRotating) {
          this.isRotating = false;
          this.rotatingElement = null;
          this.selectedElement = null;
          this.selectedElements = [];
          canvas.style.cursor = 'default';
          this.saveState();
          this.render();
          return;
        }
        if (this.isAdjustingBend) {
          this.isAdjustingBend = false;
          this.bendingElement = null;
          this.selectedElement = null;
          this.selectedElements = [];
          canvas.style.cursor = 'default';
          this.saveState();
          this.render();
          return;
        }
        if (!this.isDragging || !this.selectedElement) return;
        const trashBin = document.getElementById('vp2-trash-bin');
        if (trashBin) {
          const r = this._trashBinRect();
          if (e.clientX >= r.left && e.clientX <= r.right &&
              e.clientY >= r.top && e.clientY <= r.bottom) {
            if (this.selectedElement.type === 'agent') {
              this.removeAgentFromMap(this.selectedElement);
            } else {
              this.deleteElement(this.selectedElement);
            }
            this.isDragging = false;
            trashBin.classList.remove('drag-hover');
            return;
          }
        }
        // Released outside canvas and not on trash — clean up drag state
        this.isDragging = false;
        this.saveState();
        this.render();
      };
      document.addEventListener('mouseup', this._documentMouseUpHandler);

      // Document-level mousemove — highlight trash bin even when mouse left canvas during drag
      if (this._documentMouseMoveHandler) {
        document.removeEventListener('mousemove', this._documentMouseMoveHandler);
      }
      this._documentMouseMoveHandler = (e) => {
        // Skip if cursor is over the canvas — canvas handler handles this case
        if (e.target === this.canvas) return;
        // Handle rotation outside canvas — continue rotation smoothly
        if (this.isRotating && this.rotatingElement) {
          try {
            const pos = this.getCanvasPosition(e);
            const el = this.rotatingElement;
            const shape = this.abilityShapes[el.abilityName];
            const dx = pos.x - el.x;
            const dy = pos.y - el.y;
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist > 2) {
              if (shape && shape.scalable) {
                const newEffRot = Math.atan2(dx, -dy) * 180 / Math.PI;
                const mapRot = this.mapRotations[this.currentMap];
                let adjust = mapRot ? (mapRot.baseRotation || 0) : 0;
                if (mapRot && mapRot.flipForDefense && this.currentSide === 'defense') adjust -= 180;
                el.rotation = newEffRot + adjust;
                let baseLength = 1;
                if (shape.shape === 'phoenix-wall') baseLength = this.getPhoenixWallMetrics(shape).length;
                else if (shape.shape === 'tripwire') baseLength = this.getTripwireMetrics(shape).length;
                else if (shape.shape === 'fast-lane') baseLength = this.getFastLaneMetrics(shape).length;
                else if (shape.shape === 'harbor-wall') baseLength = this.getHarborWallMetrics(shape).length;
                else if (shape.showRange && shape.gameHeight) baseLength = shape.gameHeight * 100 * this.getCurrentMapScale() * this._mapSize;
                else baseLength = shape.height || 1;
                const offsetPx = shape.originOffset && shape.showRange && shape.gameWidth ? shape.originOffset * 100 * this.getCurrentMapScale() * this._mapSize : 0;
                const rawScale = (shape.shape === 'phoenix-wall' || shape.shape === 'tripwire' || shape.shape === 'fast-lane' || shape.shape === 'harbor-wall') ? dist / Math.max(baseLength, 1) : (dist - offsetPx) / Math.max(baseLength, 1);
                const minSc = shape.minScale || 0.1;
                const maxSc = shape.maxScale || 2.5;
                el.abilityScale = Math.max(minSc, Math.min(maxSc, rawScale));
                this._syncAbilityScaleToWaypoints(el);
              } else {
                // Pure rotation (non-scalable) — delta from start angle
                const angle = Math.atan2(dy, dx) * 180 / Math.PI;
                const delta = angle - (this._rotStartAngle || 0);
                el.rotation = (this._rotStartRotation || 0) + delta;
              }
            }
            this.requestRender();
          } catch (err) { console.error('[VP2] doc mousemove rotation error:', err); }
          return;
        }
        // Handle bend adjustment outside canvas
        if (this.isAdjustingBend && this.bendingElement) {
          try {
            const pos = this.getCanvasPosition(e);
            const el = this.bendingElement;
            const shape = this.abilityShapes[el.abilityName];
            if (shape?.shape === 'harbor-wall' || shape?.shape === 'phoenix-wall') {
              const dx = pos.x - el.x;
              const dy = pos.y - el.y;
              const rot = this._getEffectiveRotation(el) * Math.PI / 180;
              const cosR = Math.cos(rot);
              const sinR = Math.sin(rot);
              const localX = dx * cosR + dy * sinR;
              if (shape.shape === 'phoenix-wall') {
                const { length } = this.getPhoenixWallMetrics(shape, el);
                const limit = this.getPhoenixWallCurveLimit(length);
                el.phoenixCurveOffset = Math.max(-limit, Math.min(limit, localX));
              } else {
                const { length } = this.getHarborWallMetrics(shape, el);
                const limit = this.getHarborWallCurveLimit(length);
                el.harborCurveOffset = Math.max(-limit, Math.min(limit, localX));
              }
              this._syncAbilityScaleToWaypoints(el);
            }
            this.requestRender();
          } catch (err) { console.error('[VP2] doc mousemove bend error:', err); }
          return;
        }
        // Handle drag outside canvas — continue moving element smoothly
        if (this.isDragging && this.selectedElement) {
          try {
            const pos = this.getCanvasPosition(e);
            const newX = pos.x - this.dragOffsetX;
            const newY = pos.y - this.dragOffsetY;
            this.dragMoved = true;
            if (this.selectedElement.type === 'agent' && this.agentPaths.has(this.selectedElement.id)) {
              this.agentPaths.delete(this.selectedElement.id);
              this.pathAbilityWaypoints.delete(this.selectedElement.id);
            }
            const ddx = newX - this.selectedElement.x;
            const ddy = newY - this.selectedElement.y;
            this.selectedElements.forEach(el => { el.x += ddx; el.y += ddy; });
            this.requestRender();
          } catch (err) { console.error('[VP2] doc mousemove drag error:', err); }
        }
        // Trash bin highlight (works for drag)
        if (this.isDragging && this.selectedElement) {
          const trashBin = document.getElementById('vp2-trash-bin');
          if (trashBin) {
            const r = this._trashBinRect();
            if (e.clientX >= r.left && e.clientX <= r.right &&
                e.clientY >= r.top && e.clientY <= r.bottom) {
              trashBin.classList.add('drag-hover');
            } else {
              trashBin.classList.remove('drag-hover');
            }
          }
        }
      };
      document.addEventListener('mousemove', this._documentMouseMoveHandler);

      // Right-click on agent = start path drawing
      canvas.addEventListener('contextmenu', (e) => {
        e.preventDefault();
      });

      canvas.addEventListener('mousedown', (e) => {
        if (e.button === 2) {
          const pos = this.getCanvasPosition(e);
          const clickedAgent = this.getAgentAtPosition(pos.x, pos.y);
          
          if (clickedAgent) {
            // Right-click on agent = start path drawing
            e.preventDefault();
            this.pathDrawingAgent = clickedAgent;
            this.selectedElement = clickedAgent;
            this.selectedElements = [clickedAgent];
            this.isDrawingPath = true;
            
            this.agentPaths.set(clickedAgent.id, [{
              x: clickedAgent.x, y: clickedAgent.y, time: 0
            }]);
            this.pathAbilityWaypoints.delete(clickedAgent.id);
            console.log('🎯 Botão direito: desenhando trajetória de', clickedAgent.agentName);
            
            canvas.style.cursor = 'crosshair';
            this.render();
          } else {
            // Right-click NOT on agent — check if on existing waypoint marker to delete
            const waypointHit = this.getPathAbilityWaypointAtPosition(pos.x, pos.y);
            if (waypointHit) {
              e.preventDefault();
              this.removePathAbilityWaypoint(waypointHit.agentId, waypointHit.waypointIndex);
            }
          }
        }
      });
      
      // Mouse wheel zoom
      canvas.addEventListener('wheel', (e) => {
        e.preventDefault();
        if (this.mapLocked) return;

        const rect = this._canvasRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        const prevZoom = this.zoomLevel;
        const zoomSteps = [1, 2, 3];
        const currentIndex = Math.max(0, zoomSteps.indexOf(prevZoom));
        const nextIndex = e.deltaY < 0
          ? Math.min(currentIndex + 1, zoomSteps.length - 1)
          : Math.max(currentIndex - 1, 0);
        this.zoomLevel = zoomSteps[nextIndex];

        if (this.zoomLevel === prevZoom) {
          this.showZoomIndicator();
          return;
        }

        if (this.zoomLevel <= 1) {
          // Reset pan centered when back to 100%
          const cw = this._cssPxW || this.canvas.width;
          const ch = this._cssPxH || this.canvas.height;
          this.panX = cw / 2 * (1 - this.zoomLevel);
          this.panY = ch / 2 * (1 - this.zoomLevel);
        } else {
          // Adjust pan so zoom is centered on cursor position
          const ratio = this.zoomLevel / prevZoom;
          this.panX = mouseX - ratio * (mouseX - this.panX);
          this.panY = mouseY - ratio * (mouseY - this.panY);
          this._clampPan();
        }

        this.render();
        this.showZoomIndicator();
      }, { passive: false });

      // Double click to rotate
      canvas.addEventListener('dblclick', (e) => {
        const pos = this.getCanvasPosition(e);
        const element = this.getElementAtPosition(pos.x, pos.y);
        
        if (element && (element.type === 'player' || element.type === 'agent' || element.type === 'ability')) {
          element.rotation = (element.rotation || 0) + 45;
          this.render();
          this.saveState();
        }
      });
    },

  setupDragDrop() {
      const canvas = this.canvas;
      const container = document.querySelector('.vp2-canvas-container');
      
      if (!canvas || !container) return;

      // Helper: clamp drop coordinates to canvas bounds
      const clampToCanvas = (clientX, clientY) => {
        const rect = canvas.getBoundingClientRect();
        const cx = Math.max(rect.left, Math.min(clientX, rect.right));
        const cy = Math.max(rect.top, Math.min(clientY, rect.bottom));
        const rawX = (cx - rect.left - this.panX) / this.zoomLevel - this._mapOffsetX;
        const rawY = (cy - rect.top - this.panY) / this.zoomLevel - this._mapOffsetY;
        return this.mapInverseTransformPoint(rawX, rawY);
      };
      
      // Prevent default drag behavior & show live preview
      container.addEventListener('dragover', (e) => {
        e.preventDefault();
        const dragType = this.dragPreview?.type || e.dataTransfer.getData('drag-type');
        e.dataTransfer.dropEffect = dragType === 'agent' ? 'move' : 'copy';
        
        // Update drag preview position (clamped to canvas bounds)
        if (this.dragPreview) {
          const pos = clampToCanvas(e.clientX, e.clientY);
          this.dragPreview.x = pos.x;
          this.dragPreview.y = pos.y;
          this.requestRender();
        }
      });
      
      // Clear preview when drag leaves
      container.addEventListener('dragleave', (e) => {
        // Only clear if actually leaving the container (not entering a child)
        if (!container.contains(e.relatedTarget)) {
          if (this.dragPreview) {
            this.dragPreview = null;
            this.requestRender();
          }
        }
      });
      
      // Handle drops (for agents and abilities dragged from sidebar)
      container.addEventListener('drop', (e) => {
        e.preventDefault();
        const dragPreview = this.dragPreview;
        const { x, y } = clampToCanvas(e.clientX, e.clientY);
        const dragData = this._getPlannerDragPayload(e.dataTransfer);
        
        // Check what was dropped
        const dragType = dragData.dragType || dragPreview?.type || '';
        const abilityName = dragData.abilityName || dragPreview?.abilityName || '';
        const abilitySlot = dragData.abilitySlot || dragPreview?.slot || '';
        const abilityIcon = dragData.abilityIcon || dragPreview?.icon || '';
        const agentUuid = dragData.agentUuid || dragPreview?.agentUuid || '';
        const agentName = dragData.agentName || dragPreview?.agentName || '';
        const team = dragData.team || dragPreview?.team || '';
        this.dragPreview = null;
        
        if (dragType === 'agent' && agentUuid) {
          // Agent icon dropped - create new agent on map
          const agent = this.agents.find(a => a.uuid === agentUuid);
          if (agent) {
            const agentTeam = team || 'ally';
            // Find next available team slot (expands beyond the base 5 UI slots if needed)
            const slotIndex = this.getNextTeamSlot(agentTeam);

            // Register in team
            this.teams[agentTeam][slotIndex] = agent;

            const newElement = {
              id: this.generateId(),
              type: 'agent',
              agentUuid: agentUuid,
              agentName: agentName || agent.displayName,
              team: agentTeam,
              teamSlot: slotIndex,
              x: x,
              y: y,
              direction: agentTeam === 'enemy' ? 180 : 0,
              layer: this.elements.length
            };
            
            // Load agent image
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => {
              newElement.image = img;
              this.render();
            };
            img.src = this.getAgentDisplayIcon(agent);
            
            this.elements.push(newElement);
            this.renderAgentsBar();
            this.saveState();
            this.render();
            this.renderAbilityTracks();
          }
        } else if (abilityName || dragType === 'ability') {
          // Ability dropped - create new ability on map
          const resolved = this.resolveAbilityVisual({
            agentUuid,
            abilityName,
            abilitySlot,
            fallbackIcon: abilityIcon
          });
          const shape = this.abilityShapes[resolved.abilityName || abilityName];
          const newElement = {
            id: this.generateId(),
            type: 'ability',
            abilityName: resolved.abilityName || abilityName,
            abilitySlot: resolved.abilitySlot || abilitySlot,
            abilityIcon: resolved.abilityIcon || abilityIcon,
            abilityDuration: resolved.abilityDuration,
            abilityType: resolved.abilityType,
            agentUuid: agentUuid,
            team: team || 'ally',
            x: x,
            y: y,
            rotation: 0,
            opacity: 1,
            layer: this.elements.length
          };
          this.elements.push(newElement);
          this.saveState();
          this.render();
        } else if (dragType === 'marker') {
          // Strategy marker dropped on map
          const markerType = dragData.markerType || e.dataTransfer.getData('marker-type');
          this.addMarkerToMap(markerType, x, y);
        } else if (dragType === 'player') {
          // Numbered player token dropped on map
          const playerNum = parseInt(dragData.playerNum || e.dataTransfer.getData('player-num'));
          const playerTeam = dragData.playerTeam || e.dataTransfer.getData('player-team');
          this.addPlayerToMap(playerNum, playerTeam, x, y);
        }
      });
      
      // Setup drag events for team slots (both ally and enemy)
      this.setupSlotDragEvents();
      
      // Setup trash bin drag-and-drop (for HTML drag events: abilities etc.)
      this.setupTrashBin();
      
      // Setup panel tools, markers & players
      this.setupPanelExtras();

      // Setup sequence bar events
      this.setupSequenceEvents();
    },

  setupTrashBin() {
      const trashBin = document.getElementById('vp2-trash-bin');
      if (!trashBin) return;
      
      // Highlight on dragover (HTML drag API — abilities dragged from sidebar)
      trashBin.addEventListener('dragover', (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        trashBin.classList.add('drag-hover');
      });
      trashBin.addEventListener('dragleave', () => {
        trashBin.classList.remove('drag-hover');
      });
      trashBin.addEventListener('drop', (e) => {
        e.preventDefault();
        trashBin.classList.remove('drag-hover');
        // If an element is currently selected, delete it
        if (this.selectedElement) {
          if (this.selectedElement.type === 'agent') {
            this.removeAgentFromMap(this.selectedElement);
          } else {
            this.deleteElement(this.selectedElement);
          }
        }
      });

      // Direct mouseup on trash bin — catches canvas-drag-to-trash
      // (canvas mouseup doesn't fire because the trash bin DOM intercepts the event)
      trashBin.addEventListener('mouseup', () => {
        if (this.isDragging && this.selectedElement) {
          if (this.selectedElement.type === 'agent') {
            this.removeAgentFromMap(this.selectedElement);
          } else {
            this.deleteElement(this.selectedElement);
          }
          this.isDragging = false;
          trashBin.classList.remove('drag-hover');
        }
      });
    },

  setupPanelExtras() {
      // --- Delete buttons ---
      document.getElementById('vp2-panel-clear-all')?.addEventListener('click', () => this.clearAll());

      // --- Type-specific delete buttons ---
      document.getElementById('vp2-del-agents')?.addEventListener('click', () => {
        this.elements = this.elements.filter(el => el.type !== 'agent');
        // Limpar slots dos times para permitir adicionar novos agentes
        this.teams = this.createBaseTeamState();
        this.agentPaths.clear();
        this.pathAbilityWaypoints.clear();
        this.selectedElement = null;
        this.updateElementsList();
        this.renderAgentsBar();
        this.render();
        this.saveState();
      });
      document.getElementById('vp2-del-abilities')?.addEventListener('click', () => {
        this.elements = this.elements.filter(el => el.type !== 'ability');
        this.selectedElement = null;
        this.updateElementsList();
        this.render();
        this.saveState();
      });
      document.getElementById('vp2-del-lines')?.addEventListener('click', () => {
        this.elements = this.elements.filter(el => el.type !== 'line' && el.type !== 'arrow' && el.type !== 'pen');
        this.selectedElement = null;
        this.updateElementsList();
        this.render();
        this.saveState();
      });
      document.getElementById('vp2-del-texts')?.addEventListener('click', () => {
        this.elements = this.elements.filter(el => el.type !== 'text');
        this.selectedElement = null;
        this.updateElementsList();
        this.render();
        this.saveState();
      });
      document.getElementById('vp2-del-all')?.addEventListener('click', () => {
        this.elements = [];
        this.teams = this.createBaseTeamState();
        this.agentPaths.clear();
        this.pathAbilityWaypoints.clear();
        this.selectedElement = null;
        this.updateElementsList();
        this.renderAgentsBar();
        this.render();
        this.saveState();
      });
      document.getElementById('vp2-panel-delete-selected')?.addEventListener('click', () => {
        if (this.selectedElement) {
          if (this.selectedElement.type === 'agent') {
            this.removeAgentFromMap(this.selectedElement);
          } else {
            this.deleteElement(this.selectedElement);
          }
        }
      });

      // --- Marker drag start ---
      document.querySelectorAll('.vp2-side-marker').forEach(el => {
        el.addEventListener('dragstart', (e) => {
          this._setPlannerDragPayload(e.dataTransfer, {
            'drag-type': 'marker',
            'marker-type': el.dataset.marker
          });
          e.dataTransfer.effectAllowed = 'copy';
        });
      });

      // --- Player token drag start ---
      document.querySelectorAll('.vp2-panel-player-token').forEach(el => {
        el.addEventListener('dragstart', (e) => {
          this._setPlannerDragPayload(e.dataTransfer, {
            'drag-type': 'player',
            'player-num': el.dataset.playerNum,
            'player-team': el.dataset.playerTeam
          });
          e.dataTransfer.effectAllowed = 'copy';
        });
      });
    },

  setupSlotDragEvents() {
      // Listen for dragstart on both team containers (agents only — abilities use custom mousedown drag)
      ['ally', 'enemy'].forEach(team => {
        const container = document.getElementById(`vp2-${team}-slots`);
        if (!container) return;
        
        container.addEventListener('dragstart', (e) => {
          const agentImg = e.target.closest('.vp2-slot-agent-img');
          const abilityIcon = e.target.closest('.vp2-slot-ability-icon');
          
          if (abilityIcon) { e.preventDefault(); return; } // block native drag for abilities
          
          if (agentImg) {
            e.dataTransfer.setData('drag-type', 'agent');
            e.dataTransfer.setData('agent-uuid', agentImg.dataset.agentUuid);
            e.dataTransfer.setData('agent-name', agentImg.dataset.agentName);
            e.dataTransfer.setData('team', agentImg.dataset.team);
            e.dataTransfer.effectAllowed = 'move';
            const dragAgent = this.agents.find(a => a.uuid === agentImg.dataset.agentUuid);
            this.dragPreview = {
              type: 'agent',
              agentUuid: agentImg.dataset.agentUuid,
              agentName: agentImg.dataset.agentName,
              team: agentImg.dataset.team || 'ally',
              icon: dragAgent?.displayIcon || dragAgent?.displayIconSmall || ''
            };
          }
        });
        
        container.addEventListener('dragend', () => {
          if (this.dragPreview) { this.dragPreview = null; this.render(); }
        });

        // Custom mousedown drag for abilities (no ghost image)
        container.addEventListener('mousedown', (e) => {
          const abilityIcon = e.target.closest('.vp2-slot-ability-icon');
          if (!abilityIcon) return;
          const agentUuid = abilityIcon.dataset.agentUuid;
          const agent = this.agents.find(a => a.uuid === agentUuid);
          const agentName = agent ? agent.displayName : '';
          const customIcon = this.getCustomAbilityIcon(agentName, abilityIcon.dataset.abilitySlot);
          this._initCustomAbilityDrag(e, {
            abilityName: abilityIcon.dataset.abilityName,
            slot: abilityIcon.dataset.abilitySlot,
            icon: customIcon || abilityIcon.dataset.abilityIcon || '',
            agentUuid: agentUuid,
            team: abilityIcon.dataset.team
          });
        });
      });
    },

  setupKeyboardShortcuts() {
      if (this._documentKeyDownHandler) {
        document.removeEventListener('keydown', this._documentKeyDownHandler);
      }
      this._documentKeyDownHandler = (e) => {
        // Only handle if ValoPlant page is active
        if (app.currentPage !== 'valoplant') return;
        // Only handle if not typing in input
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
        
        switch (e.key.toLowerCase()) {
          case 'delete':
          case 'backspace':
            if (this.selectedElement) {
              if (this.selectedElement.type === 'agent') {
                this.removeAgentFromMap(this.selectedElement);
              } else {
                this.deleteElement(this.selectedElement);
              }
            }
            break;
          case 'z':
            if (e.ctrlKey || e.metaKey) {
              if (e.shiftKey) {
                this.redo();
              } else {
                this.undo();
              }
              e.preventDefault();
            }
            break;
          case ' ':
            this.togglePlay();
            e.preventDefault();
            break;
          case 'escape':
            // Cancel ability placement mode if active
            if (this.abilityPlacementMode) {
              this.cancelAbilityPlacement();
              break;
            }
            this.selectedElement = null;
            this.selectedElements = [];
            this.hideProperties();
            this.render();
            break;
        }
      };
      document.addEventListener('keydown', this._documentKeyDownHandler);
    },

  setupSequenceEvents() {
      // Sequence buttons
      document.querySelectorAll('.vp2-seq-btn').forEach(btn => {
        btn.addEventListener('click', () => this.switchSequence(parseInt(btn.dataset.seq)));
      });
    },

  setupAbilityManager() {
      const openBtn = document.getElementById('vp2-open-ability-manager');
      const modal = document.getElementById('vp2-ability-modal');
      const closeBtn = document.getElementById('vp2-ability-modal-close');

      if (!openBtn || !modal) return;

      openBtn.addEventListener('click', () => {
        this.openAbilityManager();
      });

      closeBtn?.addEventListener('click', () => {
        modal.style.display = 'none';
      });

      modal.addEventListener('click', (e) => {
        if (e.target === modal) modal.style.display = 'none';
      });

      // Size slider - API abilities
      const sizeSlider = document.getElementById('vp2-ability-size-slider');
      const sizeValue = document.getElementById('vp2-ability-size-value');
      if (sizeSlider) {
        sizeSlider.value = this._abilityIconSize;
        if (sizeValue) sizeValue.textContent = this._abilityIconSize + 'px';

        sizeSlider.addEventListener('input', (e) => {
          const val = parseInt(e.target.value);
          this._abilityIconSize = val;
          localStorage.setItem('vp2_abilityIconSize', val);
          if (sizeValue) sizeValue.textContent = val + 'px';
          this.render();
        });
      }

      // Size slider - uploaded abilities
      const uploadSizeSlider = document.getElementById('vp2-upload-ability-size-slider');
      const uploadSizeValue = document.getElementById('vp2-upload-ability-size-value');
      if (uploadSizeSlider) {
        uploadSizeSlider.value = this._uploadAbilityIconSize;
        if (uploadSizeValue) uploadSizeValue.textContent = this._uploadAbilityIconSize + 'px';

        uploadSizeSlider.addEventListener('input', (e) => {
          const val = parseInt(e.target.value);
          this._uploadAbilityIconSize = val;
          localStorage.setItem('vp2_uploadAbilityIconSize', val);
          if (uploadSizeValue) uploadSizeValue.textContent = val + 'px';
          this.render();
        });
      }

      // Size slider - agents
      const agentSizeSlider = document.getElementById('vp2-agent-size-slider');
      const agentSizeValue = document.getElementById('vp2-agent-size-value');
      if (agentSizeSlider) {
        agentSizeSlider.value = this._agentIconSize;
        if (agentSizeValue) agentSizeValue.textContent = this._agentIconSize + 'px';

        agentSizeSlider.addEventListener('input', (e) => {
          const val = parseInt(e.target.value);
          this._agentIconSize = val;
          localStorage.setItem('vp2_agentIconSize', val);
          if (agentSizeValue) agentSizeValue.textContent = val + 'px';
          this.render();
        });
      }

      // Restore defaults button
      document.getElementById('vp2-restore-defaults')?.addEventListener('click', () => {
        // Reset global sizes
        this._abilityIconSize = 26;
        this._uploadAbilityIconSize = 46;
        this._agentIconSize = 35;
        localStorage.setItem('vp2_abilityIconSize', 26);
        localStorage.setItem('vp2_uploadAbilityIconSize', 46);
        localStorage.setItem('vp2_agentIconSize', 35);

        // Reset individual sizes
        this._abilityIconSizes = {};
        this._agentIconSizes = {};
        localStorage.removeItem('vp2_abilityIconSizes');
        localStorage.removeItem('vp2_agentIconSizes');

        // Update sliders
        const abSlider = document.getElementById('vp2-ability-size-slider');
        const abVal = document.getElementById('vp2-ability-size-value');
        if (abSlider) abSlider.value = 26;
        if (abVal) abVal.textContent = '26px';

        const upAbSlider = document.getElementById('vp2-upload-ability-size-slider');
        const upAbVal = document.getElementById('vp2-upload-ability-size-value');
        if (upAbSlider) upAbSlider.value = 46;
        if (upAbVal) upAbVal.textContent = '46px';

        const agSlider = document.getElementById('vp2-agent-size-slider');
        const agVal = document.getElementById('vp2-agent-size-value');
        if (agSlider) agSlider.value = 35;
        if (agVal) agVal.textContent = '35px';

        // Update per-ability sliders in the modal
        document.querySelectorAll('.vp2-aim-ability-size-input').forEach(s => {
          s.value = 50;
          const valSpan = s.parentElement.querySelector('.vp2-aim-ability-size-val');
          if (valSpan) valSpan.textContent = '50';
        });
        document.querySelectorAll('.vp2-aim-agent-size-input').forEach(s => {
          s.value = 35;
          const valSpan = s.parentElement.querySelector('.vp2-aim-agent-size-val');
          if (valSpan) valSpan.textContent = '35';
        });

        this.render();
      });
    },

  bindIconsPageEvents() {
      // Back button — return to planner
      document.getElementById('vp2-iconspage-back')?.addEventListener('click', () => {
        app.navigate('zdpro');
      });

      const _markDirty = () => {
        const btn = document.getElementById('vp2-ico-save');
        if (btn) btn.classList.add('has-changes');
      };

      // Slider bindings — update in-memory + UI only; persisted via Salvar Alterações
      const abilitySlider = document.getElementById('vp2-ico-ability-size');
      const abilityVal = document.getElementById('vp2-ico-ability-val');
      abilitySlider?.addEventListener('input', (e) => {
        const v = parseInt(e.target.value);
        this._abilityIconSize = v;
        if (abilityVal) abilityVal.textContent = v + 'px';
        _markDirty();
      });

      const uploadSlider = document.getElementById('vp2-ico-upload-size');
      const uploadVal = document.getElementById('vp2-ico-upload-val');
      uploadSlider?.addEventListener('input', (e) => {
        const v = parseInt(e.target.value);
        this._uploadAbilityIconSize = v;
        if (uploadVal) uploadVal.textContent = v + 'px';
        _markDirty();
      });

      const agentSlider = document.getElementById('vp2-ico-agent-size');
      const agentVal = document.getElementById('vp2-ico-agent-val');
      agentSlider?.addEventListener('input', (e) => {
        const v = parseInt(e.target.value);
        this._agentIconSize = v;
        if (agentVal) agentVal.textContent = v + 'px';
        _markDirty();
      });

      const durationToggle = document.getElementById('vp2-ico-duration-toggle');
      durationToggle?.addEventListener('change', (e) => {
        this._showAbilityDuration = e.target.checked;
        _markDirty();
      });

      // Salvar Alterações — persists all current settings to localStorage
      document.getElementById('vp2-ico-save')?.addEventListener('click', () => {
        localStorage.setItem('vp2_abilityIconSize', this._abilityIconSize);
        localStorage.setItem('vp2_uploadAbilityIconSize', this._uploadAbilityIconSize);
        localStorage.setItem('vp2_agentIconSize', this._agentIconSize);
        localStorage.setItem('vp2_showAbilityDuration', this._showAbilityDuration);
        localStorage.setItem('vp2_abilityIconSizes', JSON.stringify(this._abilityIconSizes));
        localStorage.setItem('vp2_agentIconSizes', JSON.stringify(this._agentIconSizes));
        const btn = document.getElementById('vp2-ico-save');
        if (btn) btn.classList.remove('has-changes');
        if (typeof toast !== 'undefined') toast.success('Sucesso', 'Alterações salvas');
      });

      document.getElementById('vp2-ico-restore')?.addEventListener('click', () => {
        this._abilityIconSize = 50;
        this._uploadAbilityIconSize = 50;
        this._agentIconSize = 50;
        this._abilityIconSizes = {};
        this._agentIconSizes = {};
        this._showAbilityDuration = true;
        localStorage.setItem('vp2_abilityIconSize', 50);
        localStorage.setItem('vp2_uploadAbilityIconSize', 50);
        localStorage.setItem('vp2_agentIconSize', 50);
        localStorage.removeItem('vp2_abilityIconSizes');
        localStorage.removeItem('vp2_agentIconSizes');
        localStorage.removeItem('vp2_showAbilityDuration');
        const as = document.getElementById('vp2-ico-ability-size');
        const us = document.getElementById('vp2-ico-upload-size');
        const gs = document.getElementById('vp2-ico-agent-size');
        const av = document.getElementById('vp2-ico-ability-val');
        const uv = document.getElementById('vp2-ico-upload-val');
        const gv = document.getElementById('vp2-ico-agent-val');
        const dt = document.getElementById('vp2-ico-duration-toggle');
        const saveBtn = document.getElementById('vp2-ico-save');
        if (as) as.value = 50;
        if (us) us.value = 50;
        if (gs) gs.value = 50;
        if (av) av.textContent = '50px';
        if (uv) uv.textContent = '50px';
        if (gv) gv.textContent = '50px';
        if (dt) dt.checked = true;
        if (saveBtn) saveBtn.classList.remove('has-changes');
        this.renderPanelIconsGrid();
        if (typeof toast !== 'undefined') toast.success('Sucesso', 'Padrões restaurados');
      });
    },

  bindPanelIconsEvents() {
      const grid = document.getElementById('vp2-icons-grid');
      if (!grid) return;

      // Upload click
      grid.querySelectorAll('.vp2-pi-ability-wrap').forEach(wrap => {
        wrap.addEventListener('click', (e) => {
          if (e.target.closest('.vp2-pi-remove')) return;
          this.uploadPanelIcon(wrap.dataset.agentFolder, wrap.dataset.slot);
        });
      });

      // Per-ability size sliders
      grid.querySelectorAll('.vp2-pi-size-input').forEach(slider => {
        slider.addEventListener('input', (e) => {
          e.stopPropagation();
          const val = parseInt(e.target.value);
          this.setAbilityIconSize(e.target.dataset.agentFolder, e.target.dataset.slot, val);
          const sp = e.target.parentElement.querySelector('.vp2-pi-size-val');
          if (sp) sp.textContent = val;
        });
        slider.addEventListener('click', (e) => e.stopPropagation());
        slider.addEventListener('mousedown', (e) => e.stopPropagation());
      });

      // Per-agent size sliders
      grid.querySelectorAll('.vp2-pi-agent-size-input').forEach(slider => {
        slider.addEventListener('input', (e) => {
          e.stopPropagation();
          const val = parseInt(e.target.value);
          this.setAgentIconSize(e.target.dataset.agentFolder, val);
          const sp = e.target.parentElement.querySelector('.vp2-pi-size-val');
          if (sp) sp.textContent = val;
        });
        slider.addEventListener('click', (e) => e.stopPropagation());
        slider.addEventListener('mousedown', (e) => e.stopPropagation());
      });

      // Hover persistence for size popups
      grid.querySelectorAll('.vp2-pi-ability').forEach(ability => {
        const popup = ability.querySelector('.vp2-pi-size-popup');
        if (!popup) return;
        let leaveTimer;
        const showPopup = () => { clearTimeout(leaveTimer); popup.classList.add('popup-open'); };
        const hidePopup = () => { leaveTimer = setTimeout(() => popup.classList.remove('popup-open'), 80); };
        ability.addEventListener('mouseenter', showPopup);
        ability.addEventListener('mouseleave', hidePopup);
        popup.addEventListener('mouseenter', showPopup);
        popup.addEventListener('mouseleave', hidePopup);
      });
      grid.querySelectorAll('.vp2-pi-portrait').forEach(portrait => {
        const popup = portrait.querySelector('.vp2-pi-agent-size-popup');
        if (!popup) return;
        let leaveTimer;
        const showPopup = () => { clearTimeout(leaveTimer); popup.classList.add('popup-open'); };
        const hidePopup = () => { leaveTimer = setTimeout(() => popup.classList.remove('popup-open'), 80); };
        portrait.addEventListener('mouseenter', showPopup);
        portrait.addEventListener('mouseleave', hidePopup);
        popup.addEventListener('mouseenter', showPopup);
        popup.addEventListener('mouseleave', hidePopup);
      });

      // Stop popup propagation
      grid.querySelectorAll('.vp2-pi-size-popup, .vp2-pi-agent-size-popup').forEach(p => {
        p.addEventListener('click', (e) => e.stopPropagation());
        p.addEventListener('mousedown', (e) => e.stopPropagation());
      });

      // Remove buttons
      grid.querySelectorAll('.vp2-pi-remove').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.stopPropagation();
          await this.removePanelIcon(btn.dataset.agentFolder, btn.dataset.slot);
        });
      });
    },
}));


/* ===== js/valoplant-ui.js ===== */
/**
 * ValoPlantV2 — modais e paineis
 *
 * Estes 27 metodos vinham da classe em valoplant-v2.js, que passava de
 * 12 mil linhas num arquivo so. Continuam sendo metodos da mesma classe: sao
 * instalados no prototype, entao `this` e o comportamento nao mudam.
 *
 * Precisa carregar DEPOIS de valoplant-v2.js — a ordem esta em scripts.json.
 *
 * getOwnPropertyDescriptors e nao Object.assign de proposito: assign copiaria
 * o *valor* de um getter em vez do getter.
 */
Object.defineProperties(ValoPlantV2.prototype, Object.getOwnPropertyDescriptors({
  openAgentModal(team, slotIndex) {
      console.log('📋 Opening modal for team:', team, 'slot:', slotIndex);
      this.currentSelectingSlot = { team, slot: slotIndex };
      
      const modal = document.getElementById('vp2-agent-modal');
      console.log('  Modal element:', modal);
      if (modal) {
        modal.style.display = 'flex';
        console.log('  Modal display set to flex');
        this.updateModalDisabledAgents();
      } else {
        console.error('  ❌ Modal not found!');
      }
    },

  closeAgentModal() {
      const modal = document.getElementById('vp2-agent-modal');
      if (modal) {
        modal.style.display = 'none';
      }
      this.currentSelectingSlot = null;
    },

  showAbilityMenuForTimeline(agentId, timeMs, screenX, screenY) {
      const agent = this.elements.find(el => el.id === agentId && el.type === 'agent');
      if (!agent) return;
      
      const agentData = this.agents.find(a => a.uuid === agent.agentUuid);
      if (!agentData || !agentData.abilities) return;
      
      // Remove menu anterior se existir
      const oldMenu = document.getElementById('vp2-ability-marker-menu');
      if (oldMenu) oldMenu.remove();
      
      // Cria menu popup — mesmo design do popup de agentes
      const menu = document.createElement('div');
      menu.id = 'vp2-ability-marker-menu';
      menu.style.cssText = `
        position: fixed;
        left: ${screenX}px;
        top: ${screenY - 50}px;
        background: #000000;
        border: 1px solid rgba(255, 70, 85, 0.18);
        border-radius: 8px;
        padding: 6px 8px;
        z-index: 10000;
        display: flex;
        flex-direction: column;
        gap: 4px;
        box-shadow: 0 8px 32px rgba(0,0,0,0.9), 0 0 0 1px rgba(255,255,255,0.04);
        white-space: nowrap;
      `;

      // Header
      const header = document.createElement('div');
      header.style.cssText = 'font-size: 0.65rem; font-weight: 700; color: var(--vp-text, #e8edf5); text-align: center; letter-spacing: 0.5px; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 4px;';
      header.textContent = `${agent.agentName} — ${(timeMs/1000).toFixed(1)}s`;
      menu.appendChild(header);

      // Ability row
      const row = document.createElement('div');
      row.style.cssText = 'display: flex; gap: 4px; justify-content: center;';
      
      // Adiciona habilidades (exceto passiva)
      this.getDisplayAbilities(agentData).forEach(ability => {
        const iconSrc = ability.displayIcon || '';
        const durVal = ability.duration;
        const btn = document.createElement('div');
        btn.className = 'vp2-ability-popup-icon';
        btn.dataset.abilityName = ability.displayName;
        btn.style.cursor = 'pointer';
        btn.innerHTML = `
          <img src="${iconSrc}" alt="${ability.displayName}" loading="lazy" draggable="false" onerror="this.style.display='none'">
          ${durVal ? `<span style="color: #22d3ee; font-size: 0.5rem; font-weight: 700; line-height: 1; pointer-events: none;">${durVal}s</span>` : ''}
        `;
        
        btn.onclick = () => {
          menu.remove();
          this.showPlacementChoice(agentId, timeMs, ability, screenX, screenY);
        };
        
        row.appendChild(btn);
      });
      menu.appendChild(row);
      
      document.body.appendChild(menu);

      // Keep on screen
      requestAnimationFrame(() => {
        const r = menu.getBoundingClientRect();
        if (r.right > window.innerWidth) menu.style.left = (window.innerWidth - r.width - 8) + 'px';
        if (r.top < 0) menu.style.top = '8px';
      });
      
      // Fecha ao clicar fora
      const closeHandler = (e) => {
        if (!menu.contains(e.target)) {
          menu.remove();
          document.removeEventListener('mousedown', closeHandler);
        }
      };
      setTimeout(() => document.addEventListener('mousedown', closeHandler), 10);
    },

  showPlacementChoice(agentId, timeMs, ability, screenX, screenY) {
      const oldMenu = document.getElementById('vp2-ability-placement-menu');
      if (oldMenu) oldMenu.remove();
      const agentEl = this.elements.find(el => el.id === agentId && el.type === 'agent');
      const resolved = this.resolveAbilityVisual({
        agentUuid: agentEl?.agentUuid,
        abilityName: ability.displayName,
        abilitySlot: ability.slot,
        fallbackIcon: ability.displayIcon
      });

      const menu = document.createElement('div');
      menu.id = 'vp2-ability-placement-menu';
      menu.style.cssText = `
        position: fixed;
        left: ${screenX}px;
        top: ${screenY - 40}px;
        background: rgba(10, 10, 15, 0.97);
        border: 1px solid rgba(34, 211, 238, 0.5);
        border-radius: 10px;
        padding: 10px 14px;
        z-index: 10000;
        display: flex;
        flex-direction: column;
        gap: 8px;
        box-shadow: 0 4px 24px rgba(0,0,0,0.7);
        min-width: 200px;
      `;

      // Header with ability info
      const durationValue = resolved.abilityDuration || ability.duration;
      const durText = durationValue ? ` (${durationValue}s)` : '';
      const header = document.createElement('div');
      header.style.cssText = 'display: flex; align-items: center; gap: 8px;';
      header.innerHTML = `
        <img src="${resolved.abilityIcon || ''}" style="width: 24px; height: 24px; object-fit: contain;" onerror="this.style.display='none'">
        <span style="color: #fff; font-size: 0.75rem; font-weight: 600;">${resolved.abilityName || ability.displayName}${durText}</span>
      `;
      menu.appendChild(header);

      // Botão: Posicionar no mapa
      const placeBtn = document.createElement('div');
      placeBtn.style.cssText = `
        display: flex; align-items: center; gap: 8px; padding: 8px 12px;
        background: rgba(34, 211, 238, 0.1); border: 1px solid rgba(34, 211, 238, 0.4);
        border-radius: 8px; cursor: pointer; transition: all 0.15s;
      `;
      placeBtn.innerHTML = `
        <i class="fas fa-crosshairs" style="color: #22d3ee; font-size: 14px;"></i>
        <span style="color: #22d3ee; font-size: 0.75rem; font-weight: 600;">Posicionar no mapa</span>
      `;
      placeBtn.onmouseenter = () => { placeBtn.style.background = 'rgba(34,211,238,0.2)'; };
      placeBtn.onmouseleave = () => { placeBtn.style.background = 'rgba(34,211,238,0.1)'; };
      placeBtn.onclick = () => {
        menu.remove();
        this.startAbilityPlacement(agentId, timeMs, ability);
      };
      menu.appendChild(placeBtn);

      // Botão: Sem posição (apenas no agente)
      const noPlaceBtn = document.createElement('div');
      noPlaceBtn.style.cssText = `
        display: flex; align-items: center; gap: 8px; padding: 8px 12px;
        background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.15);
        border-radius: 8px; cursor: pointer; transition: all 0.15s;
      `;
      noPlaceBtn.innerHTML = `
        <i class="fas fa-user" style="color: #999; font-size: 14px;"></i>
        <span style="color: #999; font-size: 0.75rem;">Sem posição (no agente)</span>
      `;
      noPlaceBtn.onmouseenter = () => { noPlaceBtn.style.background = 'rgba(255,255,255,0.1)'; };
      noPlaceBtn.onmouseleave = () => { noPlaceBtn.style.background = 'rgba(255,255,255,0.05)'; };
      noPlaceBtn.onclick = () => {
        menu.remove();
        this.addAbilityMarker(agentId, timeMs, ability, null);
      };
      menu.appendChild(noPlaceBtn);

      document.body.appendChild(menu);

      requestAnimationFrame(() => {
        const r = menu.getBoundingClientRect();
        if (r.right > window.innerWidth) menu.style.left = (window.innerWidth - r.width - 8) + 'px';
        if (r.top < 0) menu.style.top = '8px';
      });

      const closeHandler = (e) => {
        if (!menu.contains(e.target)) {
          menu.remove();
          document.removeEventListener('mousedown', closeHandler);
        }
      };
      setTimeout(() => document.addEventListener('mousedown', closeHandler), 10);
    },

  showPlacementInstruction(abilityName) {
      const old = document.getElementById('vp2-placement-instruction');
      if (old) old.remove();

      const el = document.createElement('div');
      el.id = 'vp2-placement-instruction';
      el.style.cssText = `
        position: fixed;
        top: 12px;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(10, 10, 15, 0.95);
        border: 1px solid rgba(34, 211, 238, 0.6);
        border-radius: 10px;
        padding: 10px 20px;
        z-index: 10001;
        display: flex;
        align-items: center;
        gap: 10px;
        box-shadow: 0 4px 24px rgba(0,0,0,0.5);
        animation: vp2FadeIn 0.2s ease;
      `;
      el.innerHTML = `
        <i class="fas fa-crosshairs" style="color: #22d3ee; font-size: 16px;"></i>
        <span style="color: #fff; font-size: 0.8rem;">Clique no mapa para posicionar <strong style="color: #22d3ee;">${abilityName}</strong></span>
        <span style="color: #666; font-size: 0.7rem; margin-left: 8px;">(ESC para cancelar)</span>
      `;

      document.body.appendChild(el);
    },

  /**
   * Vira o mapa ao trocar de lado com a mesma transicao da /lineups: 0.6s
   * cubic-bezier(0.16, 1, 0.3, 1), 180 graus.
   *
   * Na /lineups o mapa e um <img> e a rotacao mora no CSS. Aqui e canvas, e o
   * flip esta assado no transform do contexto — redesenhar troca o lado num
   * frame so. Entao a animacao gira o proprio <canvas>, e no fim do giro
   * zera o transform e redesenha: o conteudo novo ja nasce na orientacao pra
   * onde a animacao apontou, e a troca nao aparece.
   */
  animateSideFlip(done) {
      const canvas = document.getElementById('vp2-canvas');
      const rot = this.mapRotations[this.currentMap];
      // Mapa que nao vira de lado (nem todos viram) troca sem animacao.
      if (!canvas || !rot || !rot.flipForDefense) { done(); return; }

      if (this._sideFlipTimer) {
        clearTimeout(this._sideFlipTimer);
        canvas.style.transition = 'none';
        canvas.style.transform = '';
      }

      canvas.style.transition = 'transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)';
      // Dois frames: o primeiro fixa o estado inicial, o segundo anima.
      requestAnimationFrame(() => {
        canvas.style.transform = 'rotate(180deg)';
      });

      this._sideFlipTimer = setTimeout(() => {
        this._sideFlipTimer = null;
        canvas.style.transition = 'none';
        canvas.style.transform = '';
        done();
        requestAnimationFrame(() => { canvas.style.transition = ''; });
      }, 600);
    },

  toggleMapDropdown(e) {
      if (e) { e.stopPropagation(); e.preventDefault(); }
      const dd = document.getElementById('vp2-map-dropdown');
      const current = document.getElementById('vp2-map-current');
      this.mapDropdownOpen = !this.mapDropdownOpen;
      // Mesmas classes do componente compartilhado (.lu-map-*), como na /lineups.
      if (dd) dd.classList.toggle('open', this.mapDropdownOpen);
      if (current) current.classList.toggle('lu-map-dropdown-open', this.mapDropdownOpen);
    },

  showTextInputModal(x, y, editingEl = null) {
      const notepad = document.getElementById('vp2-text-notepad');
      if (!notepad) return;

      notepad.value = editingEl ? (editingEl.text || '') : '';
      notepad.style.display = 'block';
      setTimeout(() => { notepad.focus(); notepad.select(); }, 30);

      const doConfirm = () => {
        const text = notepad.value.trim();
        notepad.style.display = 'none';
        cleanup();
        if (editingEl) {
          // Edit existing element
          if (text) {
            editingEl.text = text;
          } else {
            // If cleared, delete the element
            this.elements = this.elements.filter(el => el.id !== editingEl.id);
          }
          this.saveState();
          this.updateElementsList();
          this.render();
        } else {
          if (text) {
            const newElement = {
              id: this.generateId(),
              type: 'text',
              x, y,
              text,
              color: this.settings.strokeColor,
              fontSize: this.settings.fontSize,
              side: this.currentSide,
              layer: this.elements.length
            };
            this.elements.push(newElement);
            this.saveState();
            this.updateElementsList();
            this.render();
          }
          this.selectTool(null);
        }
      };

      const doCancel = () => {
        notepad.style.display = 'none';
        cleanup();
        if (!editingEl) this.selectTool(null);
      };

      const onKeydown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); doConfirm(); }
        if (e.key === 'Escape') doCancel();
      };

      const onBlur = () => {
        setTimeout(() => {
          if (notepad.style.display !== 'none') doConfirm();
        }, 100);
      };

      const cleanup = () => {
        notepad.removeEventListener('keydown', onKeydown);
        notepad.removeEventListener('blur', onBlur);
      };

      notepad.addEventListener('keydown', onKeydown);
      notepad.addEventListener('blur', onBlur);
    },

  showImageModal() {
      const modal = document.getElementById('vp2-image-modal');
      const urlInput = document.getElementById('vp2-image-url');
      const confirmBtn = document.getElementById('vp2-image-confirm');
      const cancelBtn = document.getElementById('vp2-image-cancel');
      if (!modal) return;

      urlInput.value = '';
      modal.style.display = 'block';
      setTimeout(() => urlInput.focus(), 30);

      const doAdd = (src) => {
        if (!src) return;
        modal.style.display = 'none';
        cleanup();
        const img = new Image();
        img.crossOrigin = 'anonymous';
        const _rawCX = (this._cssPxW / 2 - this.panX) / this.zoomLevel - this._mapOffsetX;
        const _rawCY = (this._cssPxH / 2 - this.panY) / this.zoomLevel - this._mapOffsetY;
        const _logCenter = this.mapInverseTransformPoint(_rawCX, _rawCY);
        const centerX = _logCenter.x;
        const centerY = _logCenter.y;
        const newEl = {
          id: this.generateId(),
          type: 'image',
          x: centerX,
          y: centerY,
          width: 200,
          height: 150,
          src,
          _img: img,
          _imgLoaded: false,
          _imgFailed: false,
          layer: this._nextLayer++,
          side: null
        };
        img.onload = () => {
          const ar = img.naturalWidth / (img.naturalHeight || 1);
          newEl.width = 200;
          newEl.height = Math.max(20, Math.round(200 / ar));
          newEl._imgLoaded = true;
          this.render();
        };
        img.onerror = () => { newEl._imgFailed = true; this.render(); };
        img.src = src;
        this.elements.push(newEl);
        this.saveState();
        this.render();
      };

      const doCancel = () => {
        modal.style.display = 'none';
        cleanup();
      };

      const onConfirmClick = () => doAdd(urlInput.value.trim());
      const onCancelClick = () => doCancel();

      const onKeydown = (e) => {
        if (e.key === 'Enter') { e.preventDefault(); doAdd(urlInput.value.trim()); }
        if (e.key === 'Escape') doCancel();
      };

      const onPaste = (e) => {
        const items = e.clipboardData?.items;
        if (!items) return;
        for (const item of items) {
          if (item.type.startsWith('image/')) {
            e.preventDefault();
            const blob = item.getAsFile();
            const reader = new FileReader();
            reader.onload = (ev) => doAdd(ev.target.result);
            reader.readAsDataURL(blob);
            return;
          }
        }
      };

      const cleanup = () => {
        confirmBtn.removeEventListener('click', onConfirmClick);
        cancelBtn.removeEventListener('click', onCancelClick);
        urlInput.removeEventListener('keydown', onKeydown);
        document.removeEventListener('paste', onPaste);
      };

      confirmBtn.addEventListener('click', onConfirmClick);
      cancelBtn.addEventListener('click', onCancelClick);
      urlInput.addEventListener('keydown', onKeydown);
      document.addEventListener('paste', onPaste);
    },

  showZoomIndicator() {
      const indicator = document.getElementById('vp2-zoom-indicator');
      if (!indicator) return;
      indicator.textContent = Math.round(this.zoomLevel * 100) + '%';
      this.positionZoomIndicator();
      indicator.classList.add('visible');
      clearTimeout(this._zoomIndicatorTimer);
      this._zoomIndicatorTimer = setTimeout(() => {
        indicator.classList.remove('visible');
      }, 1200);
    },

  showProperties(element) {
      // Properties panel removed - elements have fixed size
      // Use Delete/Backspace key to remove selected elements
    },

  togglePlay() {
      if (this.isPlaying) {
        this.pausePlayback();
      } else {
        this.startPlayback();
      }
    },

  toggleRecording() {
      this.isRecording = !this.isRecording;
      
      const recordBtn = document.getElementById('vp2-record');
      const container = document.querySelector('.valoplant-v2');
      
      if (this.isRecording) {
        recordBtn?.classList.add('recording');
        container?.classList.add('vp2-recording');
        
        // Start playback if not playing
        if (!this.isPlaying) {
          this.startPlayback();
        }
      } else {
        recordBtn?.classList.remove('recording');
        container?.classList.remove('vp2-recording');
      }
    },

  togglePathMode() {
      this.pathMode = !this.pathMode;
      this.pathDrawingAgent = null;
      
      const btn = document.getElementById('vp2-path-mode');
      if (btn) {
        btn.classList.toggle('active', this.pathMode);
      }
      
      // Muda cursor do canvas
      if (this.canvas) {
        this.canvas.style.cursor = this.pathMode ? 'crosshair' : 'default';
      }
      
      // Mostra/esconde instrução
      this.showPathModeInstruction(this.pathMode);
      
      if (this.pathMode) {
        console.log('🛤️ Modo Trajetória ATIVADO - Clique em um agente para selecionar, depois clique no mapa para criar waypoints');
      } else {
        console.log('🛤️ Modo Trajetória DESATIVADO');
      }
      
      this.render();
    },

  showPathModeInstruction(show) {
      // Notificação removida conforme solicitado
      // Apenas deixa o botão da timeline indicar o estado
    },

  toggleShowPaths() {
      this.showPaths = !this.showPaths;
      
      const btn = document.getElementById('vp2-toggle-paths');
      if (btn) {
        const icon = btn.querySelector('i');
        if (icon) {
          icon.className = this.showPaths ? 'fas fa-eye' : 'fas fa-eye-slash';
        }
      }
      
      this.render();
    },

  showAbilityMenuForPath(agentId, hitInfo, screenX, screenY) {
      const agent = this.elements.find(el => el.id === agentId && el.type === 'agent');
      if (!agent) return;

      const agentData = this.agents.find(a => a.uuid === agent.agentUuid);
      if (!agentData || !agentData.abilities) return;

      // Remove menu anterior se existir
      const oldMenu = document.getElementById('vp2-path-ability-menu');
      if (oldMenu) oldMenu.remove();

      const timeStr = (hitInfo.timeMs / 1000).toFixed(1) + 's';
      const menu = document.createElement('div');
      menu.id = 'vp2-path-ability-menu';
      menu.style.cssText = `
        position: fixed;
        left: ${screenX}px;
        top: ${screenY - 60}px;
        background: #000000;
        border: 1px solid rgba(255, 70, 85, 0.18);
        border-radius: 8px;
        padding: 6px 8px;
        z-index: 10000;
        display: flex;
        flex-direction: column;
        gap: 4px;
        box-shadow: 0 8px 32px rgba(0,0,0,0.9), 0 0 0 1px rgba(255,255,255,0.04);
        white-space: nowrap;
      `;

      // Header
      const header = document.createElement('div');
      header.style.cssText = 'font-size: 0.65rem; font-weight: 700; color: var(--vp-text, #e8edf5); text-align: center; letter-spacing: 0.5px; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 4px;';
      header.textContent = `${agent.agentName} — ${timeStr}`;
      menu.appendChild(header);

      // Ability buttons row
      const row = document.createElement('div');
      row.style.cssText = 'display: flex; gap: 4px; justify-content: center;';

      this.getDisplayAbilities(agentData).forEach(ability => {
        const customIcon = this.getCustomAbilityIcon(agentData.displayName, ability.slot);
        const iconSrc = ability.displayIcon || '';
        const mapIconSrc = customIcon || ability.displayIcon || '';
        const durVal = ability.duration;
        const btn = document.createElement('div');
        btn.className = 'vp2-ability-popup-icon';
        btn.dataset.abilityName = ability.displayName;
        btn.style.cursor = 'pointer';
        btn.innerHTML = `
          <img src="${iconSrc}" alt="${ability.displayName}" loading="lazy" draggable="false" onerror="this.style.display='none'">
          ${durVal ? `<span style="color: #22d3ee; font-size: 0.5rem; font-weight: 700; line-height: 1; pointer-events: none;">${durVal}s</span>` : ''}
        `;

        btn.onclick = () => {
          this.addPathAbilityWaypoint(agentId, hitInfo, {
            name: ability.displayName,
            slot: ability.slot,
            icon: mapIconSrc,
            duration: ability.duration,
            abilityType: ability.abilityType || null
          });
          menu.remove();
        };

        row.appendChild(btn);
      });

      menu.appendChild(row);

      document.body.appendChild(menu);

      // Keep menu on screen
      requestAnimationFrame(() => {
        const r = menu.getBoundingClientRect();
        if (r.right > window.innerWidth) menu.style.left = (window.innerWidth - r.width - 8) + 'px';
        if (r.top < 0) menu.style.top = '8px';
      });

      // Close on click outside
      const closeHandler = (e) => {
        if (!menu.contains(e.target)) {
          menu.remove();
          document.removeEventListener('mousedown', closeHandler);
        }
      };
      setTimeout(() => document.addEventListener('mousedown', closeHandler), 10);
    },

  // =====================================================
  // ENVIAR PARA TÁTICAS — reusa a árvore real de /tactics (TacticsTree +
  // TacticsStore + TacticsModals). O usuário abre comp > lado > pasta e cria
  // a tática ali pelo + da pasta. Só o mapa aberto no zdpro aparece.
  // =====================================================

  async showSaveTacticModal() {
    const isLogged = typeof auth !== 'undefined' && auth && auth.isAuthenticated;
    if (!isLogged) {
      toast.info?.('Login necessário', 'Entre para enviar esta estratégia para suas Táticas.');
      if (typeof auth?.openAuth === 'function') auth.openAuth('login');
      return;
    }

    const curMap = this.maps.find(m => m.id === this.currentMap);
    if (!curMap) { toast.error('Erro', 'Nenhum mapa selecionado.'); return; }

    const hasTeam = !!app.getCurrentTeam()?.id;
    this._stmMode = hasTeam
      ? (localStorage.getItem('zdval:tactics:mode') === 'personal' ? 'personal' : 'team')
      : 'personal';

    // A árvore de /tactics precisa de tactics.css (não carregada em /zdpro).
    if (typeof Utils !== 'undefined' && Utils.loadPageCss) {
      Utils.loadPageCss('tactics-page-css', 'tactics.css');
    }
    if (typeof TacticsStore !== 'undefined' && TacticsStore.loadAgentGradients) {
      TacticsStore.loadAgentGradients().catch(() => {});
    }

    const overlay = document.createElement('div');
    overlay.className = 'vp2-stm-overlay';
    // Trava o essencial inline — nada de folha injetada tarde ou camada do
    // canvas do zdpro empurrar o modal pra trás.
    overlay.style.cssText = 'position:fixed;inset:0;z-index:10250;display:flex;align-items:center;justify-content:center;background:rgba(4,6,10,0.9)';
    overlay.innerHTML = `
      <div class="vp2-stm-modal vp2-stm-modal--tree" role="dialog" aria-modal="true" aria-label="Enviar para Táticas">
        <div class="vp2-stm-header">
          <div class="vp2-stm-header-icon"><i class="fas fa-satellite-dish"></i></div>
          <div class="vp2-stm-header-text">
            <h3>Enviar para Táticas</h3>
            <p>Abra a composição e o lado, e crie a tática na pasta com o <i class="fas fa-plus"></i></p>
          </div>
          <button class="vp2-stm-close" id="vp2StmClose" aria-label="Fechar"><i class="fas fa-times"></i></button>
        </div>
        <div class="vp2-stm-body vp2-stm-body--tree">
          <input type="hidden" id="vp2StmImageUrl">
          ${hasTeam ? `
          <div class="tc-mode-toggle" id="vp2StmModeToggle">
            <button type="button" class="tc-mode-btn${this._stmMode === 'team' ? ' active' : ''}" data-mode="team">
              <i class="fas fa-users"></i> Time
            </button>
            <button type="button" class="tc-mode-btn${this._stmMode === 'personal' ? ' active' : ''}" data-mode="personal">
              <i class="fas fa-user"></i> Pessoal
            </button>
          </div>` : ''}
          <div class="tc-sidebar-tree" id="vp2StmTree"></div>
        </div>
        <div class="vp2-stm-footer">
          <button class="vp2-stm-btn vp2-stm-btn-cancel" id="vp2StmCloseFooter">Fechar</button>
          <button class="vp2-stm-btn vp2-stm-btn-save" id="vp2StmOpenTactic" disabled>
            <i class="fas fa-paper-plane"></i> Salvar Tática
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    requestAnimationFrame(() => overlay.classList.add('visible'));
    this._stmOverlay = overlay;

    const close = () => {
      document.removeEventListener('keydown', onKey, true);
      overlay.classList.remove('visible');
      setTimeout(() => overlay.remove(), 300);
      this._stmOverlay = null;
      this._stmTreeCtrl = null;
    };
    this._stmClose = close;
    const onKey = (e) => {
      if (document.querySelector('.tc-modal-overlay')) return; // submodal comp/pasta por cima
      if (e.key === 'Escape') { e.stopPropagation(); close(); }
    };
    document.addEventListener('keydown', onKey, true);
    overlay.querySelector('#vp2StmClose').addEventListener('click', close);
    overlay.querySelector('#vp2StmCloseFooter').addEventListener('click', close);
    // Clique fora NÃO fecha — só Esc, o X ou o botão "Fechar".

    this._stmLastCreated = null;
    overlay.querySelector('#vp2StmOpenTactic').addEventListener('click', () => {
      const c = this._stmLastCreated;
      close();
      if (c) setTimeout(() => app.navigate('tactics', { fromZdpro: true, ...c }), 300);
    });

    // Captura do board sobe em paralelo — _stmSendToFolder espera por ela.
    this._stmCaptureReady = this._stmCaptureCanvasImage(overlay);

    const ctrl = this._stmBuildTreeController(curMap);
    this._stmTreeCtrl = ctrl;
    ctrl.tree.mount(overlay.querySelector('#vp2StmTree'));
    await ctrl.reload();
    ctrl.store.expand(TacticsStore.mapNodeId(this._getMapDbId(this.currentMap)));
    ctrl.tree.render();

    overlay.querySelector('#vp2StmModeToggle')?.addEventListener('click', async (e) => {
      const btn = e.target.closest('.tc-mode-btn');
      if (!btn || btn.dataset.mode === this._stmMode) return;
      this._stmMode = btn.dataset.mode;
      try { localStorage.setItem('zdval:tactics:mode', this._stmMode); } catch (_) {}
      overlay.querySelectorAll('.tc-mode-btn').forEach(b =>
        b.classList.toggle('active', b.dataset.mode === this._stmMode));
      await ctrl.reload();
      ctrl.store.expand(TacticsStore.mapNodeId(this._getMapDbId(this.currentMap)));
      ctrl.tree.render();
    });
  },

  _stmBuildTreeController(curMap) {
    const self = this;
    const mapDbId = String(this._getMapDbId(this.currentMap));
    const store = new TacticsStore();

    // Só o mapa atual do zdpro aparece na árvore.
    const origBuild = store.buildTree.bind(store);
    store.buildTree = () => origBuild().filter(n => String(n.mapId) === mapDbId);

    const noop = { render() {}, mount() {} };
    const ctrl = {
      store,
      modals: new TacticsModals(),
      editor: noop,
      tree: null,
      requireLogin: () => true,
      reload: () => store.load(self._stmTeamId()),
      refreshTree: () => ctrl.tree && ctrl.tree.render(),
      openTactic: () => toast.info?.('Táticas', 'Essa tática já está no playbook — abra em /tactics.'),
      renameTactic: () => {},
      confirmDeleteTactic: () => toast.info?.('Táticas', 'Exclua a tática na página de Táticas.'),

      async createTacticInFolder(folderId, title) {
        return self._stmSendToFolder(folderId, title, ctrl);
      },

      async promptNewComposition(mapId) {
        if (!store.canAddCompToMap(mapId)) {
          toast.error('Táticas', `Limite de ${TacticsStore.MAX_COMPS_PER_MAP} composições por mapa.`);
          return;
        }
        const map = (app.getMaps() || []).find(m => String(m.id) === String(mapId));
        const composition = await ctrl.modals.composition({
          mapName: map?.display_name || curMap.name || 'Mapa',
          slot: store.compKeysForMap(mapId).length + 1
        });
        if (!composition) return;
        try {
          await Promise.all(TacticsStore.SIDES.map(side => api.createTacticFolder({
            team_id: store.teamId, map_id: mapId, side: side.id, name: 'Default', composition
          })));
          await ctrl.reload();
          store.expand(TacticsStore.mapNodeId(mapId));
          store.expand(TacticsStore.compNodeId(mapId, TacticsStore.compKey(composition)));
          ctrl.tree.render();
          toast.success('Sucesso', 'Composição criada.');
        } catch (err) {
          console.error('[zdpro] create composition', err);
          toast.error('Erro', 'Falha ao criar composição.');
        }
      },

      async promptNewFolder({ mapId, compKey, side }) {
        const base = store.foldersFor(mapId, compKey, side)[0] || store.foldersFor(mapId, compKey)[0];
        if (!base) { toast.error('Erro', 'Composição sem pasta para este lado.'); return; }
        const composition = TacticsStore.parseComposition(base.composition);
        const name = await ctrl.modals.newFolder({
          compLabel: TacticsStore.compLabel(composition),
          sideLabel: (TacticsStore.SIDES.find(s => s.id === side) || {}).label || ''
        });
        if (!name) return;
        try {
          await api.createTacticFolder({ team_id: store.teamId, map_id: mapId, side, name, composition });
          await ctrl.reload();
          store.expand(TacticsStore.sideNodeId(mapId, compKey, side));
          ctrl.tree.render();
          toast.success('Sucesso', 'Pasta criada.');
        } catch (err) {
          console.error('[zdpro] create folder', err);
          toast.error('Erro', 'Falha ao criar pasta.');
        }
      },

      async confirmDeleteComposition(mapId, compKey) {
        const folders = store.foldersFor(mapId, compKey);
        const ok = await ctrl.modals.confirm({
          title: 'Excluir composição',
          message: 'Isso apaga a composição e todas as suas táticas. Não dá para desfazer.',
          confirmLabel: 'Excluir composição'
        });
        if (!ok) return;
        try {
          await Promise.all(folders.map(f => api.deleteTacticFolder(f.id)));
          await ctrl.reload();
          ctrl.tree.render();
          toast.success('Sucesso', 'Composição excluída.');
        } catch (err) { console.error(err); toast.error('Erro', 'Falha ao excluir.'); }
      },

      async confirmDeleteFolder(folderId) {
        const folder = store.getFolder(folderId);
        if (!folder) return;
        const ok = await ctrl.modals.confirm({
          title: 'Excluir pasta',
          message: `"${folder.name}" e as táticas dentro dela serão apagadas. Não dá para desfazer.`,
          confirmLabel: 'Excluir pasta'
        });
        if (!ok) return;
        try {
          await api.deleteTacticFolder(folderId);
          await ctrl.reload();
          ctrl.tree.render();
          toast.success('Sucesso', 'Pasta excluída.');
        } catch (err) { console.error(err); toast.error('Erro', 'Falha ao excluir.'); }
      },

      async renameFolder(folderId, name) {
        const folder = store.getFolder(folderId);
        if (!folder || !name || name === folder.name) return;
        try {
          await api.updateTacticFolder(folderId, { name });
          await ctrl.reload();
          ctrl.tree.render();
        } catch (err) { console.error(err); toast.error('Erro', 'Falha ao renomear.'); }
      },
    };

    ctrl.tree = new TacticsTree(store, ctrl);
    ctrl.tree.accordion = true; // abrir um dropdown fecha os demais
    return ctrl;
  },

  async _stmSendToFolder(folderId, title, ctrl) {
    const folder = ctrl.store.getFolder(folderId);
    if (!folder) { toast.error('Erro', 'Pasta não encontrada.'); return false; }
    try {
      await this._stmCaptureReady;
      const persisted = this.serializeForPersistence();
      const result = await api.createTactic({
        team_id: ctrl.store.teamId,
        map_id: folder.map_id,
        folder_id: folder.id,
        title: (title || '').trim() || 'Estratégia ZDPRO',
        description: 'Estratégia criada no ZDPRO',
        side: folder.side || 'attack',
        tactic_type: 'valoplant',
        team_composition: persisted.teamComposition,
        map_elements: persisted.mapElements,
        player_paths: persisted.playerPaths,
        abilities_used: persisted.abilitiesUsed,
        image_url: this._stmOverlay?.querySelector('#vp2StmImageUrl')?.value?.trim() || null,
        duration_seconds: Math.round((this.timeline.duration || 0) / 1000),
        notes: ''
      });
      if (!result?.success) throw new Error(result?.message || 'Falha ao salvar');
      const tacticId = result.data?.tactic?.id;
      const curMap = this.maps.find(m => m.id === this.currentMap);

      // Fica na mesma página — só recarrega a árvore com a nova tática marcada.
      this._stmLastCreated = {
        mapId: folder.map_id,
        mapName: curMap?.name || this.currentMap,
        mapSlug: this.currentMap,
        folderId: folder.id,
        folderSide: folder.side || 'attack',
        tacticId
      };
      await ctrl.reload();
      if (tacticId) { ctrl.store.selectedTacticId = tacticId; ctrl.store.revealTactic?.(tacticId); }
      ctrl.tree.render();

      const openBtn = this._stmOverlay?.querySelector('#vp2StmOpenTactic');
      if (openBtn) openBtn.disabled = false;

      toast.success('Sucesso', 'Tática criada.');
      return true;
    } catch (err) {
      console.error('[zdpro] send to folder failed', err);
      toast.error('Erro', err.message || 'Erro ao enviar tática');
      return false;
    }
  },

  async _stmCaptureCanvasImage(overlay) {
      const hiddenInput = overlay.querySelector('#vp2StmImageUrl');
      try {
        const canvas = document.getElementById('vp2-canvas');
        if (!canvas) throw new Error('Canvas não encontrado');

        // Desenho e agendado por rAF: sem o flush, a captura pega o frame anterior.
        this.flushRender();
        // `toBlob` no lugar de `fetch(canvas.toDataURL())`: o CSP do site nao
        // tem `data:` em connect-src, entao aquele fetch morria com "Failed to
        // fetch" e toda tatica ia pro banco sem imagem, em silencio.
        const blob = await new Promise((resolve, reject) => {
          canvas.toBlob(b => b ? resolve(b) : reject(new Error('toBlob vazio')), 'image/png');
        });
        const file = new File([blob], `zdpro_${Date.now()}.png`, { type: 'image/png' });

        const formData = new FormData();
        formData.append('image', file);
        formData.append('type', 'tactics');

        const result = await api.upload('/upload/image', formData);
        const url = result.url || result.data?.url;
        if (!url) throw new Error('URL não retornada');

        if (hiddenInput) hiddenInput.value = url;
      } catch (err) {
        console.error('Canvas capture error:', err);
      }
    },

  _stmIsPersonal() { return this._stmMode === 'personal'; },
  _stmTeamId() { return this._stmIsPersonal() ? null : (app.getCurrentTeam()?.id || null); },

  async _stmLoadFoldersForSide(overlay) {
      if (!this._stmIsPersonal() && !app.getCurrentTeam()?.id) return;

      this._stmSelectedFolderId = null;
      this._stmSelectedCompKey = null;
      overlay.querySelector('#vp2StmSave').disabled = true;

      const foldersList = overlay.querySelector('#vp2StmFoldersList');
      if (foldersList) foldersList.innerHTML = `<div class="vp2-stm-no-folders"><i class="fas fa-spinner fa-spin"></i> Carregando pastas...</div>`;
      const compList = overlay.querySelector('#vp2StmCompOptions');
      if (compList) compList.innerHTML = `<div class="vp2-stm-no-folders"><i class="fas fa-spinner fa-spin"></i> Carregando composições...</div>`;

      try {
        const filtros = {
          map_id: this._getMapDbId(this.currentMap),
          side: this._stmCurrentSide
        };
        const result = this._stmIsPersonal()
          ? await api.getPersonalTacticFolders(filtros)
          : await api.getTacticFolders(app.getCurrentTeam().id, filtros);

        const folders = (result.success ? result.data.folders : []).filter(f => f.name !== '_comp_placeholder_');
        this._stmAllFolders = folders;

        // Group by composition
        this._stmCompGroups = this._groupFoldersByComp(this._stmAllFolders);

        // Default to the first existing composition from the backend.
        // Do NOT auto-create a composition from the board — that only happens via the "+ Criar" button.
        if (this._stmCompGroups.length > 0) {
          this._stmSelectedCompKey = this._stmCompGroups[0].key;
        }

        // Render composition dropdown
        this._renderStmCompDropdown(overlay);

        // Render filtered folders
        this._renderStmFilteredFolders(overlay);

      } catch (err) {
        console.error('Error loading folders:', err);
        if (foldersList) foldersList.innerHTML = `<div class="vp2-stm-no-folders"><i class="fas fa-exclamation-triangle"></i> Erro ao carregar pastas</div>`;
      }
    },

  async _stmDeleteFolder(folderId, overlay) {
      if (!confirm('Excluir esta pasta? Todas as táticas dentro dela serão perdidas.')) return;
      try {
        await api.deleteTacticFolder(folderId);
        toast.success('Sucesso', 'Pasta excluída.');
        this._stmAllFolders = this._stmAllFolders.filter(f => f.id !== folderId);
        this._stmCompGroups = this._groupFoldersByComp(this._stmAllFolders);
        
        // Update UI without closing modal
        this._renderStmCompDropdown(overlay);
        this._renderStmFilteredFolders(overlay);
      } catch(e) {
        console.error(e);
        toast.error('Erro', 'Falha ao excluir pasta.');
      }
    },

  _stmGetBoardComposition() {
      const agentElements = (this.elements || []).filter(e => e.type === 'agent' && e.team === 'ally');
      const boardAgents = agentElements.map(e => this.agents.find(a => a.uuid === e.agentUuid)).filter(Boolean);
      const uniqueAgents = [...new Map(boardAgents.map(a => [a.uuid, a])).values()];
      if (!uniqueAgents.length) return null;
      const key = uniqueAgents.map(a => a.uuid).sort().join('|');
      const composition = uniqueAgents.map(a => ({
        id: a.uuid,
        name: a.displayName || a.display_name,
        icon_url: a.displayIcon
      }));
      return { key, composition };
    },

  _stmCreateComposition(overlay) {
      this._stmShowCreateCompModal(overlay);
    },

  _stmShowCreateCompModal(parentOverlay) {
      const agents = (this.agents || []).slice().sort((a, b) => {
        const an = (a.displayName || a.display_name || '').toLowerCase();
        const bn = (b.displayName || b.display_name || '').toLowerCase();
        return an.localeCompare(bn);
      });

      if (!agents.length) {
        toast.error('Erro', 'Nenhum agente carregado.');
        return;
      }

      const slots = [null, null, null, null, null];
      let currentSlot = 0;

      const sub = document.createElement('div');
      sub.className = 'vp2-stm-subcomp-overlay';
      sub.innerHTML = `
        <div class="vp2-stm-subcomp-modal">
          <div class="vp2-stm-subcomp-header">
            <h3>Nova Composição</h3>
            <button class="vp2-stm-subcomp-close" id="vp2StmSubcompClose"><i class="fas fa-times"></i></button>
          </div>
          <div class="vp2-stm-subcomp-body">
            <div class="vp2-stm-subcomp-slots" id="vp2StmSubcompSlots"></div>
            <div class="vp2-stm-subcomp-grid" id="vp2StmSubcompGrid"></div>
          </div>
          <div class="vp2-stm-subcomp-footer">
            <button class="vp2-stm-btn vp2-stm-btn-cancel" id="vp2StmSubcompCancel">Cancelar</button>
            <button class="vp2-stm-btn vp2-stm-btn-save" id="vp2StmSubcompSave"><i class="fas fa-check"></i> Criar Composição</button>
          </div>
        </div>
      `;

      document.body.appendChild(sub);
      requestAnimationFrame(() => sub.classList.add('visible'));

      const close = () => {
        document.removeEventListener('keydown', onKey, true);
        sub.classList.remove('visible');
        setTimeout(() => sub.remove(), 220);
      };
      // ESC fecha so o submodal — o handler do modal de baixo se cala enquanto
      // este existe no DOM.
      const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); close(); } };
      document.addEventListener('keydown', onKey, true);

      const slotsEl = sub.querySelector('#vp2StmSubcompSlots');
      const gridEl = sub.querySelector('#vp2StmSubcompGrid');

      const renderSlots = () => {
        slotsEl.innerHTML = slots.map((a, i) => {
          const isSelecting = i === currentSlot;
          if (!a) {
            return `<div class="vp2-stm-subcomp-slot${isSelecting ? ' selecting' : ''}" data-slot="${i}"><i class="fas fa-plus"></i></div>`;
          }
          const gs = this.getStmAgentGradientStyle({ id: a.uuid, name: a.displayName });
          return `
            <div class="vp2-stm-subcomp-slot filled${isSelecting ? ' selecting' : ''}" data-slot="${i}" style="${gs}">
              <img src="${a.displayIcon}" alt="${a.displayName}">
              <div class="agent-option-veil"></div>
              <span class="vp2-stm-subcomp-slot-remove" data-slot-remove="${i}"><i class="fas fa-times"></i></span>
            </div>
          `;
        }).join('');
        slotsEl.querySelectorAll('[data-slot]').forEach(el => {
          el.addEventListener('click', (e) => {
            if (e.target.closest('[data-slot-remove]')) return;
            currentSlot = parseInt(el.dataset.slot, 10);
            renderSlots();
          });
        });
        slotsEl.querySelectorAll('[data-slot-remove]').forEach(el => {
          el.addEventListener('click', (e) => {
            e.stopPropagation();
            const i = parseInt(el.dataset.slotRemove, 10);
            slots[i] = null;
            currentSlot = i;
            renderAll();
          });
        });
      };

      const renderGrid = () => {
        gridEl.innerHTML = agents.map(a => {
          const isSelected = slots.some(s => s && s.uuid === a.uuid);
          const gs = this.getStmAgentGradientStyle({ id: a.uuid, name: a.displayName });
          return `
            <div class="vp2-stm-subcomp-agent${isSelected ? ' selected' : ''}" data-agent-uuid="${a.uuid}" title="${a.displayName}" style="${gs}">
              <img src="${a.displayIcon}" alt="${a.displayName}">
              <div class="agent-option-veil"></div>
            </div>
          `;
        }).join('');
        gridEl.querySelectorAll('[data-agent-uuid]').forEach(el => {
          el.addEventListener('click', () => {
            const uuid = el.dataset.agentUuid;
            const agent = agents.find(a => a.uuid === uuid);
            if (!agent) return;

            const existingIndex = slots.findIndex(s => s && s.uuid === uuid);
            if (existingIndex !== -1) {
              slots[existingIndex] = null;
              currentSlot = existingIndex;
              renderAll();
              return;
            }

            if (slots[currentSlot]) {
              const firstEmpty = slots.findIndex(s => !s);
              if (firstEmpty === -1) {
                toast.warning('Composição cheia', 'Remova um agente primeiro.');
                return;
              }
              currentSlot = firstEmpty;
            }

            slots[currentSlot] = agent;
            const nextEmpty = slots.findIndex((s, i) => !s && i > currentSlot);
            currentSlot = nextEmpty !== -1 ? nextEmpty : slots.findIndex(s => !s);
            if (currentSlot === -1) currentSlot = 4;
            renderAll();
          });
        });
      };

      const renderAll = () => {
        renderSlots();
        renderGrid();
      };

      renderAll();

      sub.querySelector('#vp2StmSubcompClose').addEventListener('click', close);
      sub.querySelector('#vp2StmSubcompCancel').addEventListener('click', close);
      sub.addEventListener('click', (e) => { if (e.target === sub) close(); });

      sub.querySelector('#vp2StmSubcompSave').addEventListener('click', async () => {
        const selected = slots.filter(Boolean);
        if (!selected.length) {
          toast.error('Atenção', 'Selecione pelo menos um agente.');
          return;
        }

        const key = selected.map(a => a.uuid).sort().join('|');

        if (this._stmCompGroups.some(g => g.key === key)) {
          toast.info('Info', 'Essa composição já existe nas opções.');
          this._stmSelectedCompKey = key;
          this._renderStmCompDropdown(parentOverlay);
          this._renderStmFilteredFolders(parentOverlay);
          close();
          return;
        }

        const composition = selected.map(a => ({
          id: a.uuid,
          name: a.displayName || a.display_name,
          icon_url: a.displayIcon
        }));

        const teamId = this._stmTeamId();
        const mapId = this._getMapDbId(this.currentMap);

        // Persist composition to the backend (same flow as tactics page)
        const saveBtn = sub.querySelector('#vp2StmSubcompSave');
        if (saveBtn) { saveBtn.disabled = true; saveBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Criando...'; }

        try {
          // Create placeholder folder to establish the composition
          const result = await api.createTacticFolder({
            team_id: teamId,
            map_id: mapId,
            side: 'attack',
            name: '_comp_placeholder_',
            description: '',
            composition,
            is_placeholder: true
          });

          if (result.success) {
            // Create default attack + defense folders
            try {
              await Promise.all([
                api.createTacticFolder({
                  team_id: teamId,
                  map_id: mapId,
                  side: 'attack',
                  name: 'Default',
                  description: '',
                  composition
                }),
                api.createTacticFolder({
                  team_id: teamId,
                  map_id: mapId,
                  side: 'defense',
                  name: 'Default',
                  description: '',
                  composition
                })
              ]);
            } catch (err) {
              console.warn('Erro criando pastas padrão:', err);
            }

            toast.success('Composição criada!', 'Pastas padrão criadas');
            // Reload folders from server so the new composition appears
            await this._stmLoadFoldersForSide(parentOverlay);
          } else {
            toast.error('Erro', result.message || 'Falha ao criar composição');
          }
        } catch (error) {
          console.error('Create composition error:', error);
          toast.error('Erro', error.message || 'Erro ao criar composição');
        }

        if (saveBtn) { saveBtn.disabled = false; saveBtn.innerHTML = '<i class="fas fa-check"></i> Criar Composição'; }
        close();
      });
    },

  async _stmDeleteComposition(overlay) {
      const key = this._stmSelectedCompKey;
      if (!key || key === 'no-comp') {
        toast.error('Atenção', 'Selecione uma composição válida para excluir.');
        return;
      }
      
      const group = this._stmCompGroups.find(g => g.key === key);
      if (!group) return;
      
      if (group.folders.length > 0) {
        if (!confirm(`Tem certeza que deseja excluir esta composição e TODAS as suas ${group.folders.length} pastas?`)) return;
      } else {
        if (!confirm('Remover esta composição vazia?')) return;
      }

      const btn = overlay.querySelector('#vp2StmDeleteCompBtn');
      if (btn) { btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'; }

      try {
        for (const f of group.folders) {
          await api.deleteTacticFolder(f.id);
        }
        toast.success('Sucesso', 'Composição excluída.');
        this._stmAllFolders = this._stmAllFolders.filter(f => !group.folders.some(gf => gf.id === f.id));
        this._stmCompGroups = this._stmCompGroups.filter(g => g.key !== key);
        if (this._stmCompGroups.length > 0) {
          this._stmSelectedCompKey = this._stmCompGroups[0].key;
        } else {
          this._stmSelectedCompKey = 'no-comp';
        }
        this._renderStmCompDropdown(overlay);
        this._renderStmFilteredFolders(overlay);
      } catch(e) {
        console.error(e);
        toast.error('Erro', 'Falha ao excluir composição.');
      } finally {
        if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fas fa-trash"></i>'; }
      }
    },

  _stmShowCreateFolderInline(overlay) {
      const foldersList = overlay.querySelector('#vp2StmFoldersList');
      if (!foldersList) return;

      // Avoid duplicate inline form
      if (foldersList.querySelector('.vp2-stm-new-folder-form')) return;

      const form = document.createElement('div');
      form.className = 'vp2-stm-new-folder-form';
      form.innerHTML = `
        <input type="text" class="vp2-stm-new-folder-input" placeholder="Nome da pasta..." maxlength="80">
        <button class="vp2-stm-new-folder-confirm" title="Criar"><i class="fas fa-check"></i></button>
        <button class="vp2-stm-new-folder-cancel" title="Cancelar"><i class="fas fa-times"></i></button>
      `;
      foldersList.prepend(form);
      const input = form.querySelector('.vp2-stm-new-folder-input');
      input.focus();

      const cancel = () => form.remove();

      const confirm = async () => {
        const name = input.value.trim();
        if (!name) { input.focus(); return; }

        if (!this._stmIsPersonal() && !app.getCurrentTeam()?.id) return;

        const confirmBtn = form.querySelector('.vp2-stm-new-folder-confirm');
        confirmBtn.disabled = true;
        confirmBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';

        // Build composition from currently selected comp key
        let composition = [];
        if (this._stmSelectedCompKey && this._stmSelectedCompKey !== 'no-comp') {
          const appAgents = (typeof app !== 'undefined' && app.getAgents) ? app.getAgents() : [];
          const localAgents = this.agents || [];
          
          composition = this._stmSelectedCompKey.split('|').map(id => {
            const agent = appAgents.find(a => a.id === id || a.uuid === id) || localAgents.find(a => a.uuid === id || a.id === id);
            if (agent) {
              return {
                id: agent.id || agent.uuid,
                name: agent.display_name || agent.displayName || agent.name,
                icon_url: agent.icon_url || agent.displayIcon
              };
            }
            return null;
          }).filter(Boolean);
        }

        try {
          const result = await api.createTacticFolder({
            team_id: this._stmTeamId(),
            map_id: this._getMapDbId(this.currentMap),
            side: this._stmCurrentSide,
            name,
            description: '',
            composition
          });

          if (result?.success) {
            const newFolderId = result.data?.folder?.id;
            form.remove();
            // Promote the newly created folder to primary before re-rendering
            if (newFolderId) this._stmSelectedFolderId = newFolderId;
            await this._stmLoadFoldersForSide(overlay);
          } else {
            toast.error('Erro', result?.message || 'Falha ao criar pasta.');
            confirmBtn.disabled = false;
            confirmBtn.innerHTML = '<i class="fas fa-check"></i>';
          }
        } catch (err) {
          toast.error('Erro', err.message || 'Falha ao criar pasta.');
          confirmBtn.disabled = false;
          confirmBtn.innerHTML = '<i class="fas fa-check"></i>';
        }
      };

      form.querySelector('.vp2-stm-new-folder-cancel').addEventListener('click', cancel);
      form.querySelector('.vp2-stm-new-folder-confirm').addEventListener('click', confirm);
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') confirm();
        if (e.key === 'Escape') cancel();
      });
    },

  async openAbilityManager() {
      const modal = document.getElementById('vp2-ability-modal');
      const grid = document.getElementById('vp2-ability-modal-grid');
      if (!modal || !grid) return;

      modal.style.display = 'flex';

      // Fetch current custom icons from server
      let customIcons = {};
      try {
        const resp = await fetch('/api/ability-icons');
        const data = await resp.json();
        customIcons = data.icons || {};
      } catch (e) {
        console.error('Error fetching custom icons:', e);
      }

      grid.innerHTML = this.agents.map(agent => {
        const folder = this._normalizeAgentFolder(agent.displayName);
        const abilities = this.getDisplayAbilities(agent);
        const agentCustom = customIcons[folder] || {};

        const abilitiesHtml = abilities.map(ab => {
          const key = this.getAbilitySlotKey(ab.slot);
          const hasCustom = !!agentCustom[key];
          const iconSrc = hasCustom 
            ? agentCustom[key] + '?t=' + Date.now()
            : (ab.displayIcon || '');

          const abilitySize = this.getAbilityIconSize(folder, key);
          const durVal = ab.duration;
          const durDisplay = durVal != null ? (durVal % 1 === 0 ? durVal + 's' : durVal.toFixed(1) + 's') : null;

          return `
            <div class="vp2-aim-ability">
              <div class="vp2-aim-ability-icon-wrap ${hasCustom ? 'has-custom' : ''}"
                   data-agent-folder="${folder}"
                   data-slot="${key}"
                   data-ability-name="${ab.displayName}"
                   title="${ab.displayName + (durDisplay ? ' — Duração: ' + durDisplay : '') + ' — Clique para upload'}">
                <img src="${iconSrc}" alt="${ab.displayName}" 
                     onerror="this.style.display='none'">
                <div class="vp2-aim-upload-hint">
                  <i class="fas ${hasCustom ? 'fa-sync-alt' : 'fa-upload'}"></i>
                </div>
                ${hasCustom ? `<button class="vp2-aim-remove-btn" data-agent-folder="${folder}" data-slot="${key}" title="Remover ícone custom"><i class="fas fa-times"></i></button>` : ''}
              </div>
              <div class="vp2-aim-ability-size-popup" data-agent-folder="${folder}" data-slot="${key}">
                <label>Tamanho</label>
                <div class="vp2-aim-ability-size-row">
                  <input type="range" class="vp2-aim-ability-size-input" min="10" max="120" value="${abilitySize}" step="1"
                         data-agent-folder="${folder}" data-slot="${key}">
                  <span class="vp2-aim-ability-size-val">${abilitySize}</span>
                </div>
              </div>
              <span class="vp2-aim-ability-name">${ab.displayName}</span>
              ${durDisplay ? `<span class="vp2-aim-ability-duration"><i class="fas fa-clock"></i> ${durDisplay}</span>` : ''}
            </div>
          `;
        }).join('');

        const agentSize = this.getAgentIconSize(folder);
        return `
          <div class="vp2-aim-agent-card" data-agent-name="${agent.displayName}">
            <div class="vp2-aim-agent-portrait">
              <img src="${agent.displayIcon || agent.displayIconSmall}" alt="${agent.displayName}" loading="lazy">
              <div class="vp2-aim-agent-size-popup" data-agent-folder="${folder}">
                <label>Tamanho</label>
                <div class="vp2-aim-agent-size-row">
                  <input type="range" class="vp2-aim-agent-size-input" min="15" max="80" value="${agentSize}" step="1"
                         data-agent-folder="${folder}">
                  <span class="vp2-aim-agent-size-val">${agentSize}</span>
                </div>
              </div>
            </div>
            <div class="vp2-aim-agent-name">${agent.displayName}</div>
            <div class="vp2-aim-abilities">${abilitiesHtml}</div>
          </div>
        `;
      }).join('');

      // Attach click events for upload
      grid.querySelectorAll('.vp2-aim-ability-icon-wrap').forEach(wrap => {
        wrap.addEventListener('click', (e) => {
          // Don't trigger upload when clicking remove button
          if (e.target.closest('.vp2-aim-remove-btn')) return;

          this.uploadAbilityIcon(wrap.dataset.agentFolder, wrap.dataset.slot);
        });
      });

      // Attach per-ability size slider events
      grid.querySelectorAll('.vp2-aim-ability-size-input').forEach(slider => {
        slider.addEventListener('input', (e) => {
          e.stopPropagation();
          const val = parseInt(e.target.value);
          const af = e.target.dataset.agentFolder;
          const sl = e.target.dataset.slot;
          const valSpan = e.target.parentElement.querySelector('.vp2-aim-ability-size-val');
          if (valSpan) valSpan.textContent = val;
          this.setAbilityIconSize(af, sl, val);
        });
        slider.addEventListener('click', (e) => e.stopPropagation());
        slider.addEventListener('mousedown', (e) => e.stopPropagation());
      });

      // Stop popup clicks from triggering upload
      grid.querySelectorAll('.vp2-aim-ability-size-popup').forEach(popup => {
        popup.addEventListener('click', (e) => e.stopPropagation());
        popup.addEventListener('mousedown', (e) => e.stopPropagation());
      });

      // Attach per-agent size slider events
      grid.querySelectorAll('.vp2-aim-agent-size-input').forEach(slider => {
        slider.addEventListener('input', (e) => {
          e.stopPropagation();
          const val = parseInt(e.target.value);
          const af = e.target.dataset.agentFolder;
          const valSpan = e.target.parentElement.querySelector('.vp2-aim-agent-size-val');
          if (valSpan) valSpan.textContent = val;
          this.setAgentIconSize(af, val);
        });
        slider.addEventListener('click', (e) => e.stopPropagation());
        slider.addEventListener('mousedown', (e) => e.stopPropagation());
      });

      // Stop agent size popup clicks from propagating
      grid.querySelectorAll('.vp2-aim-agent-size-popup').forEach(popup => {
        popup.addEventListener('click', (e) => e.stopPropagation());
        popup.addEventListener('mousedown', (e) => e.stopPropagation());
      });

      // Attach remove events
      grid.querySelectorAll('.vp2-aim-remove-btn').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.stopPropagation();
          await this.removeAbilityIcon(btn.dataset.agentFolder, btn.dataset.slot);
        });
      });


    },

  toggleSharePanel() {
      const panel = document.getElementById('vp2-share-panel');
      const btn = document.getElementById('vp2-share-btn');
      if (!panel) return;
      const isOpen = panel.classList.toggle('open');
      btn?.classList.toggle('active', isOpen);
      if (isOpen) {
        const input = document.getElementById('vp2-share-url-input');
        if (input) {
          if (this._sessionCode) {
            input.value = `${window.location.origin}/zdpro-${this._sessionCode}`;
          } else {
            input.value = 'Gerando link...';
            this._initSession(null).then(() => {
              if (input && this._sessionCode) {
                input.value = `${window.location.origin}/zdpro-${this._sessionCode}`;
              }
            });
          }
        }
      }
    },
}));


/* ===== js/team.js ===== */
// =====================================================
// ZDVAL - Team Module
// Manages team page with members and settings
// =====================================================

class Team {
  constructor() {
    this.team = null;
    this.members = [];
    this.initialized = false;
  }

  async load() {
    const container = document.getElementById('page-team');
    if (!container) return;

    // Check if team is selected
    if (!app.currentTeam) {
      container.innerHTML = `
        <div class="page-content">
          <div class="empty-state">
            <i class="fas fa-users"></i>
            <h3>Nenhum Time Selecionado</h3>
            <p>Você precisa criar ou entrar em um time para ver esta página</p>
            <div class="empty-actions">
              <button class="btn btn-primary" onclick="app.showCreateTeamModal()">
                <i class="fas fa-plus"></i> Criar Time
              </button>
              <button class="btn btn-secondary" onclick="app.showJoinTeamModal()">
                <i class="fas fa-sign-in-alt"></i> Entrar em um Time
              </button>
            </div>
          </div>
        </div>
      `;
      return;
    }

    container.innerHTML = `
      <div class="page-content">
        ${renderPremiumPreload('Carregando time...')}
      </div>
    `;

    await this.loadTeamData();
    this.render();
  }

  async loadTeamData() {
    // O guard de `load()` nao cobre todo mundo: `loadTeamData()` tem oito
    // chamadores, e a aba "Meu Time" da /scrim chama direto. Sem time
    // selecionado (visitante deslogado, por exemplo) isso estourava em
    // `app.currentTeam.id` e ainda mostrava "Nao foi possivel carregar os
    // dados do time" — erro de carga para quem so nao tem time.
    if (!app.currentTeam) {
      this.team = null;
      this.members = [];
      return;
    }

    try {
      const result = await api.getTeam(app.currentTeam.id);
      if (result.success) {
        this.team = result.data.team;
        this.members = result.data.members || [];
      }
    } catch (error) {
      console.error('Error loading team data:', error);
      toast.error('Erro', 'Não foi possível carregar os dados do time');
    }
  }

  render() {
    const container = document.getElementById('page-team');
    if (!container || !this.team) return;

    container.innerHTML = this.renderPageContent();
  }

  renderPageContent(extraClass = '') {
    if (!this.team) return '';

    const roleLabels = {
      'owner': { label: 'Dono', icon: '👑', color: 'warning', order: 0 },
      'coach': { label: 'Coach', icon: '🎯', color: 'primary', order: 1 },
      'analyst': { label: 'Analista', icon: '📊', color: 'info', order: 2 },
      'igl': { label: 'IGL', icon: '⭐', color: 'warning', order: 3 },
      'player': { label: 'Jogador', icon: '🎮', color: 'success', order: 4 },
      'manager': { label: 'Manager', icon: '📋', color: 'secondary', order: 5 },
      'psychologist': { label: 'Psicólogo', icon: '🧠', color: 'purple', order: 6 }
    };

    // Categorias para agrupar membros
    const categories = [
      { id: 'staff', title: 'Staff', subtitle: 'Liderança e Suporte', icon: 'fas fa-crown', roles: ['owner', 'coach', 'analyst', 'manager', 'psychologist'] },
      { id: 'players', title: 'Jogadores', subtitle: 'Lineup Competitivo', icon: 'fas fa-gamepad', roles: ['igl', 'player'] }
    ];

    // Verifica se o usuário tem permissão de gerenciamento (owner, coach ou super_admin)
    const currentMember = this.members.find(m => m.id === auth.user?.id);
    const isAdmin = auth.user?.role === 'super_admin';
    // Quem cria o time entra em team_members como 'player': sem o owner_id
    // aqui, o dono ficava sem engrenagem, sem convite e sem trocar o logo.
    const isTeamOwner = Boolean(auth.user?.id) && this.team.owner_id === auth.user.id;
    const isCoach = currentMember?.role === 'coach' || currentMember?.role === 'owner' || isTeamOwner || isAdmin;

    // Função para gerar card de membro
    const renderMemberCard = (member) => {
      const roleInfo = roleLabels[member.role] || { label: member.role, icon: '👤', color: 'secondary' };
      const isCurrentUser = member.id === auth.user?.id;
      const isOwner = member.role === 'owner' || member.id === this.team.owner_id;
      const hasAvatar = member.avatar_url && member.avatar_url !== '' && member.avatar_url !== 'null';
      const canEditAvatar = isCurrentUser || isCoach;
      const memberInitial = (member.display_name || member.username || '?').charAt(0).toUpperCase();
      
      return `
        <div class="team-member-card ${isOwner ? 'is-owner' : ''} ${isCurrentUser ? 'is-you' : ''}">
          <div class="member-card-glow"></div>
          <div class="member-card-content">
            <div class="member-avatar-wrapper">
              <div class="member-avatar-ring ${isOwner ? 'ring-gold' : ''}">
                ${hasAvatar ? `
                  <img src="${member.avatar_url}" 
                       alt="${member.display_name}" 
                       class="member-avatar-lg"
                       onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
                  <div class="member-avatar-fallback" style="display:none;">
                    <span>${memberInitial}</span>
                  </div>
                ` : `
                  <div class="member-avatar-fallback">
                    <span>${memberInitial}</span>
                  </div>
                `}
              </div>
              ${canEditAvatar ? `
                <label class="avatar-edit-btn" title="Trocar foto">
                  <i class="fas fa-camera"></i>
                  <input type="file" accept="image/*" onchange="team.uploadMemberAvatarFor(this, '${member.id}')" hidden>
                </label>
              ` : ''}
            </div>
            
            <div class="member-info">
              <div class="member-header">
                <h3 class="member-name">${member.display_name || member.username}</h3>
                ${isCurrentUser ? '<span class="badge-you">Você</span>' : ''}
              </div>
              <div class="member-role-badge badge-${roleInfo.color}">
                <span class="role-icon">${roleInfo.icon}</span>
                <span class="role-label">${roleInfo.label}</span>
              </div>
            </div>
            
            ${isCoach && !isCurrentUser ? `
              <div class="member-actions">
                <button class="btn-action btn-action-edit" onclick="team.editMemberRole('${member.id}', '${member.role}')" title="Alterar cargo">
                  <i class="fas fa-user-cog"></i>
                </button>
                <button class="btn-action btn-action-delete" onclick="team.removeMember('${member.id}', '${member.display_name || member.username}')" title="Remover do time">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </div>
            ` : ''}
          </div>
        </div>
      `;
    };

    // Gerar seções por categoria
    const categorySections = categories.map(cat => {
      const categoryMembers = this.members.filter(m => cat.roles.includes(m.role));
      if (categoryMembers.length === 0) return '';
      
      // Ordenar membros dentro da categoria
      categoryMembers.sort((a, b) => {
        const orderA = roleLabels[a.role]?.order ?? 99;
        const orderB = roleLabels[b.role]?.order ?? 99;
        return orderA - orderB;
      });
      
      return `
        <div class="members-category" data-category="${cat.id}">
          <div class="category-header">
            <div class="category-icon">
              <i class="${cat.icon}"></i>
            </div>
            <div class="category-info">
              <h4 class="category-title">${cat.title}</h4>
              <span class="category-subtitle">${cat.subtitle}</span>
            </div>
            <span class="category-count">${categoryMembers.length}</span>
          </div>
          <div class="category-members">
            ${categoryMembers.map(renderMemberCard).join('')}
          </div>
        </div>
      `;
    }).join('');

    return `
      <div class="page-content ${extraClass}">

        <!-- Unified Team Card -->
        <div class="card team-unified-card">
          <div class="team-info-card">
            <div class="team-header">
              <div class="team-logo-container">
                <img src="${this.team.logo_url || '/img/default-team-riot.png'}"
                     alt="${this.team.name}"
                     class="team-logo-lg"
                     onerror="this.src='/img/default-team-riot.png'">
                ${isCoach ? `
                  <label class="logo-edit-btn" title="Trocar logo">
                    <i class="fas fa-camera"></i>
                    <input type="file" accept="image/*" onchange="team.uploadTeamLogo(this)" hidden>
                  </label>
                ` : ''}
              </div>
              <div class="team-info">
                <div class="team-name-row">
                  <h2 class="team-name">
                    ${this.team.name} <span class="team-tag">[${this.team.tag || '---'}]</span>
                    ${isCoach ? `
                      <button type="button" class="team-gear" onclick="app.showTeamSettingsModal()"
                              title="Configurações do time" aria-label="Configurações do time">
                        <i class="fas fa-cog" aria-hidden="true"></i>
                      </button>
                    ` : ''}
                  </h2>
                </div>
                <p class="team-description">${this.team.description || 'Sem descrição'}</p>
              </div>
            </div>
          </div>

          <!-- Members Section -->
          <div class="card-header">
            <h3><i class="fas fa-user-friends"></i> Membros do Time (${this.members.length})</h3>
            ${isCoach ? `
              <button class="btn btn-primary btn-sm" onclick="team.showInviteModal()">
                <i class="fas fa-user-plus"></i> Convidar
              </button>
            ` : ''}
          </div>
          <div class="card-body members-categories">
            ${categorySections || '<p class="text-muted">Nenhum membro encontrado</p>'}
          </div>

        </div>
      </div>
    `;
  }

  async uploadMemberAvatar(input) {
    if (!input.files || !input.files[0]) return;

    const file = input.files[0];
    const formData = new FormData();
    formData.append('avatar', file);

    try {
      toast.info('Enviando...', 'Fazendo upload da imagem');
      const result = await api.uploadAvatar(formData);
      
      if (result.success) {
        toast.success('Sucesso', 'Avatar atualizado com sucesso');
        await this.loadTeamData();
        this.render();
      }
    } catch (error) {
      toast.error('Erro', error.message || 'Falha ao enviar imagem');
    }
  }

  // Upload de avatar para qualquer membro (coach/admin)
  async uploadMemberAvatarFor(input, memberId) {
    if (!input.files || !input.files[0] || !app.currentTeam) return;

    const file = input.files[0];
    const formData = new FormData();
    formData.append('avatar', file);

    // Se é o próprio usuário, usa a função normal
    if (memberId === auth.user?.id) {
      return this.uploadMemberAvatar(input);
    }

    try {
      toast.info('Enviando...', 'Fazendo upload da imagem do membro');
      const result = await api.uploadMemberAvatar(app.currentTeam.id, memberId, formData);
      
      if (result.success) {
        toast.success('Sucesso', 'Avatar do membro atualizado');
        await this.loadTeamData();
        this.render();
      }
    } catch (error) {
      toast.error('Erro', error.message || 'Falha ao enviar imagem');
    }
  }

  async uploadTeamLogo(input) {
    if (!input.files || !input.files[0] || !app.currentTeam) return;

    const file = input.files[0];
    const formData = new FormData();
    formData.append('logo', file);

    try {
      toast.info('Enviando...', 'Fazendo upload do logo');
      const result = await api.uploadTeamLogo(app.currentTeam.id, formData);
      
      if (result.success) {
        toast.success('Sucesso', 'Logo atualizado com sucesso');
        await this.loadTeamData();
        this.render();
        app.updateTeamUI();
      }
    } catch (error) {
      toast.error('Erro', error.message || 'Falha ao enviar logo');
    }
  }

  async showInviteModal() {
    // O card pode abrir o modal antes de loadTeamData terminar (ou o GET do
    // time pode vir sem o código): busca na rota dedicada antes de exibir.
    if (!this.team?.invite_code && app.currentTeam?.id) {
      try {
        const result = await api.getTeamInviteCode(app.currentTeam.id);
        if (result.success && result.data?.invite_code) {
          this.team = { ...(this.team || {}), invite_code: result.data.invite_code };
        }
      } catch (error) {
        console.error('Error loading invite code:', error);
      }
    }

    const inviteCode = this.team?.invite_code || 'Não disponível';
    const inviteLink = `${window.location.origin}/team?invite=${inviteCode}`;

    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'modal-overlay';
    modalOverlay.id = 'inviteMemberModal';
    modalOverlay.innerHTML = `
      <div class="modal invite-member-modal">
        <div class="modal-header">
          <div class="header-content">
            <div class="header-icon">
              <i class="fas fa-user-plus"></i>
            </div>
            <div class="header-text">
              <h3>Convidar Membros</h3>
              <p>Compartilhe o código ou link de convite</p>
            </div>
          </div>
          <button class="btn-icon modal-close-btn">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <!-- Código de Convite -->
          <div class="inv-section">
            <div class="inv-label"><i class="fas fa-key"></i> Código de Convite</div>
            <div class="inv-row">
              <code class="inv-code" id="invCodeDisplay">${inviteCode}</code>
              <button class="btn btn-secondary btn-sm" id="btnCopyCode"><i class="fas fa-copy"></i> Copiar</button>
            </div>
          </div>

          <div class="divider"><span>ou</span></div>

          <!-- Link de Convite -->
          <div class="inv-section">
            <div class="inv-label"><i class="fas fa-link"></i> Link de Convite</div>
            <div class="inv-row">
              <input type="text" class="form-input inv-link" id="invLinkDisplay" value="${inviteLink}" readonly>
              <button class="btn btn-secondary btn-sm" id="btnCopyLink"><i class="fas fa-copy"></i> Copiar</button>
            </div>
          </div>

          <div class="inv-regen">
            <button class="btn btn-ghost btn-sm" id="btnRegenCode"><i class="fas fa-sync-alt"></i> Gerar novo código</button>
          </div>

          <div class="form-actions">
            <button type="button" class="btn btn-ghost modal-close-btn"><i class="fas fa-times"></i> Fechar</button>
          </div>
        </div>
      </div>
    `;

    if (!document.getElementById('inviteMemberModalStyles')) {
      // O CSS mora em css/pages/team-modals.css. Ficava aqui como template
      // string, somando peso ao bundle de JS e impedindo que a folha fosse
      // cacheada e minificada em separado. Segue sob demanda, como antes.
      Utils.loadPageCss('inviteMemberModalStyles', 'team-modals.css');
    }
    document.body.appendChild(modalOverlay);

    // Close handlers
    const closeModal = () => modalOverlay.remove();
    modalOverlay.querySelectorAll('.modal-close-btn').forEach(b => b.addEventListener('click', closeModal));
    modalOverlay.addEventListener('click', e => { if (e.target === modalOverlay) closeModal(); });

    // Copy code
    document.getElementById('btnCopyCode').addEventListener('click', async () => {
      await this.copyToClipboard(document.getElementById('invCodeDisplay').textContent.trim());
      toast.success('Copiado!', 'Código de convite copiado');
    });

    // Copy link
    document.getElementById('btnCopyLink').addEventListener('click', async () => {
      await this.copyToClipboard(document.getElementById('invLinkDisplay').value);
      toast.success('Copiado!', 'Link de convite copiado');
    });

    // Regenerate
    document.getElementById('btnRegenCode').addEventListener('click', async () => {
      const confirmed = await this.showConfirm(
        'Gerar Novo Código',
        'O código atual será <strong>invalidado permanentemente</strong>. Qualquer link ou código compartilhado anteriormente deixará de funcionar.',
        'Gerar Novo', 'Cancelar', 'fas fa-sync-alt'
      );
      if (!confirmed) return;
      try {
        const result = await api.regenerateTeamInviteCode(app.currentTeam.id);
        if (result.success) {
          const newCode = result.data.invite_code;
          this.team.invite_code = newCode;
          const newLink = `${window.location.origin}/team?invite=${newCode}`;
          document.getElementById('invCodeDisplay').textContent = newCode;
          document.getElementById('invLinkDisplay').value = newLink;
          toast.success('Sucesso', 'Novo código gerado');
        }
      } catch (err) {
        toast.error('Erro', err.message || 'Falha ao gerar novo código');
      }
    });
  }

  async copyToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
  }

  // Premium confirmation modal (replaces native confirm())
  showConfirm(title, message, confirmText = 'Confirmar', cancelText = 'Cancelar', icon = 'fas fa-exclamation-triangle') {
    return new Promise(resolve => {
      const existing = document.getElementById('zdConfirmOverlay');
      if (existing) existing.remove();

      const overlay = document.createElement('div');
      overlay.id = 'zdConfirmOverlay';
      overlay.innerHTML = `
        <div class="zd-confirm-card">
          <div class="zd-confirm-icon-ring">
            <i class="${icon}"></i>
          </div>
          <h3 class="zd-confirm-title">${title}</h3>
          <p class="zd-confirm-msg">${message}</p>
          <div class="zd-confirm-actions">
            <button class="zd-confirm-btn zd-confirm-cancel" id="zdConfirmCancel">${cancelText}</button>
            <button class="zd-confirm-btn zd-confirm-ok" id="zdConfirmOk"><i class="${icon}" style="font-size:.85rem"></i> ${confirmText}</button>
          </div>
        </div>
      `;

      if (!document.getElementById('zdConfirmStyles')) {
        // O CSS mora em css/pages/team-modals.css. Ficava aqui como template
        // string, somando peso ao bundle de JS e impedindo que a folha fosse
        // cacheada e minificada em separado. Segue sob demanda, como antes.
        Utils.loadPageCss('zdConfirmStyles', 'team-modals.css');
      }
      document.body.appendChild(overlay);

      const cleanup = (val) => { overlay.remove(); resolve(val); };
      document.getElementById('zdConfirmOk').addEventListener('click', () => cleanup(true));
      document.getElementById('zdConfirmCancel').addEventListener('click', () => cleanup(false));
      overlay.addEventListener('click', e => { if (e.target === overlay) cleanup(false); });
    });
  }

  editMemberRole(memberId, currentRole) {
    const roles = [
      { value: 'player', icon: '🎮', label: 'Jogador', desc: 'Membro padrão do time' },
      { value: 'igl', icon: '👑', label: 'IGL', desc: 'Líder de jogo' },
      { value: 'analyst', icon: '📊', label: 'Analista', desc: 'Analisa partidas e estratégias' },
      { value: 'coach', icon: '🎯', label: 'Coach', desc: 'Treinador do time' },
      { value: 'manager', icon: '📋', label: 'Manager', desc: 'Gerencia operações do time' },
      { value: 'psychologist', icon: '🧠', label: 'Psicólogo', desc: 'Suporte mental' }
    ];
    
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'modal-overlay';
    modalOverlay.id = 'editRoleModal';
    modalOverlay.innerHTML = `
      <div class="modal edit-role-modal">
        <div class="modal-header">
          <div class="header-content">
            <div class="header-icon">
              <i class="fas fa-user-tag"></i>
            </div>
            <div class="header-text">
              <h3>Alterar Cargo</h3>
              <p>Selecione o novo cargo do membro</p>
            </div>
          </div>
          <button class="btn-icon modal-close-btn">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="role-options-grid">
            ${roles.map(r => `
              <div class="role-option ${currentRole === r.value ? 'selected' : ''}" data-value="${r.value}">
                <div class="role-option-icon">${r.icon}</div>
                <div class="role-option-info">
                  <div class="role-option-label">${r.label}</div>
                  <div class="role-option-desc">${r.desc}</div>
                </div>
                <div class="role-option-check"><i class="fas fa-check"></i></div>
              </div>
            `).join('')}
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-ghost modal-close-btn">
            <i class="fas fa-times"></i> Cancelar
          </button>
          <button type="button" class="btn btn-primary btn-glow" id="saveRoleBtn">
            <i class="fas fa-save"></i> Salvar Alteração
          </button>
        </div>
      </div>
    `;
    
    // O CSS mora em css/pages/team-modals.css. Ficava aqui como template string,
    // somando peso ao bundle de JS e impedindo que a folha fosse cacheada
    // e minificada em separado. Segue carregando sob demanda, como antes.
    if (!document.getElementById('editRoleModalStyles')) {
      Utils.loadPageCss('editRoleModalStyles', 'team-modals.css');
    }
    document.body.appendChild(modalOverlay);
    
    let selectedRole = currentRole;
    
    const closeModal = () => {
      modalOverlay.remove();
    };
    
    modalOverlay.querySelectorAll('.modal-close-btn').forEach(btn => {
      btn.addEventListener('click', closeModal);
    });
    
    modalOverlay.addEventListener('click', (e) => {
      if (e.target === modalOverlay) closeModal();
    });
    
    modalOverlay.querySelectorAll('.role-option').forEach(option => {
      option.addEventListener('click', () => {
        modalOverlay.querySelectorAll('.role-option').forEach(o => o.classList.remove('selected'));
        option.classList.add('selected');
        selectedRole = option.dataset.value;
      });
    });
    
    document.getElementById('saveRoleBtn').addEventListener('click', async () => {
      try {
        const result = await api.updateMemberRole(app.currentTeam.id, memberId, selectedRole);
        if (result.success) {
          toast.success('Sucesso', 'Cargo atualizado com sucesso');
          closeModal();
          await this.loadTeamData();
          this.render();
        }
      } catch (error) {
        toast.error('Erro', error.message || 'Falha ao atualizar cargo');
      }
    });
  }

  async removeMember(memberId, memberName) {
    // Modal de confirmação premium
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'modal-overlay';
    modalOverlay.id = 'confirmRemoveModal';
    modalOverlay.innerHTML = `
      <div class="modal confirm-modal">
        <div class="confirm-icon-wrapper">
          <div class="confirm-icon">
            <i class="fas fa-user-slash"></i>
          </div>
          <div class="confirm-icon-pulse"></div>
        </div>
        <h3 class="confirm-title">Remover Membro</h3>
        <p class="confirm-message">Tem certeza que deseja remover <strong>${memberName}</strong> do time?</p>
        <p class="confirm-warning"><i class="fas fa-exclamation-triangle"></i> Esta ação não pode ser desfeita</p>
        <div class="confirm-actions">
          <button type="button" class="btn btn-ghost" id="cancelRemoveBtn">
            <i class="fas fa-times"></i> Cancelar
          </button>
          <button type="button" class="btn btn-danger" id="confirmRemoveBtn">
            <i class="fas fa-trash-alt"></i> Remover
          </button>
        </div>
      </div>
    `;
    
    // O CSS mora em css/pages/team-modals.css. Ficava aqui como template string,
    // somando peso ao bundle de JS e impedindo que a folha fosse cacheada
    // e minificada em separado. Segue carregando sob demanda, como antes.
    if (!document.getElementById('confirmRemoveModalStyles')) {
      Utils.loadPageCss('confirmRemoveModalStyles', 'team-modals.css');
    }
    document.body.appendChild(modalOverlay);
    
    const closeModal = () => {
      modalOverlay.remove();
    };
    
    document.getElementById('cancelRemoveBtn').addEventListener('click', closeModal);
    
    modalOverlay.addEventListener('click', (e) => {
      if (e.target === modalOverlay) closeModal();
    });
    
    document.getElementById('confirmRemoveBtn').addEventListener('click', async () => {
      try {
        const result = await api.removeTeamMember(app.currentTeam.id, memberId);
        if (result.success) {
          closeModal();
          toast.success('Sucesso', 'Membro removido com sucesso');
          await this.loadTeamData();
          this.render();
        }
      } catch (error) {
        toast.error('Erro', error.message || 'Falha ao remover membro');
      }
    });
  }

  confirmDeleteTeam() {
    if (!this.team) return;
    const modal = app.createModal('Excluir Time', `
      <div class="team-delete-confirm">
        <div class="team-delete-icon"><i class="fas fa-triangle-exclamation"></i></div>
        <h4 class="team-delete-title">Tem certeza que deseja excluir <span class="team-delete-name">${this.team.name}</span>?</h4>
        <p class="team-delete-subtitle">Esta ação é <strong>irreversível</strong>. Todos os dados do time (membros, táticas, lineups, scrims, histórico) serão apagados permanentemente.</p>
        <div class="team-delete-actions">
          <button type="button" class="btn btn-ghost" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger-solid" id="confirmDeleteTeamBtn">
            <i class="fas fa-trash-alt"></i> Excluir permanentemente
          </button>
        </div>
      </div>
    `);

    // Inject once per SPA session
    if (!document.getElementById('team-delete-modal-styles')) {
      // O CSS mora em css/pages/team-modals.css. Ficava aqui como template
      // string, somando peso ao bundle de JS e impedindo que a folha fosse
      // cacheada e minificada em separado. Segue sob demanda, como antes.
      Utils.loadPageCss('team-delete-modal-styles', 'team-modals.css');
    }

    const btn = modal.querySelector('#confirmDeleteTeamBtn');
    btn.addEventListener('click', async () => {
      btn.disabled = true;
      btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Excluindo...';
      try {
        const res = await fetch(`/api/teams/${this.team.id}`, {
          method: 'DELETE',
          headers: { 'Authorization': `Bearer ${localStorage.getItem('zdval_token')}` }
        });
        const data = await res.json().catch(() => ({}));
        if (res.ok && data.success) {
          toast.success('Time excluído', 'O time foi removido com sucesso');
          modal.remove();
          localStorage.removeItem('currentTeamId');
          app.currentTeam = null;
          app.updateTeamUI();
          app.navigate('lineups');
        } else {
          btn.disabled = false;
          btn.innerHTML = '<i class="fas fa-trash-alt"></i> Excluir permanentemente';
          toast.error('Erro', data.message || 'Falha ao excluir o time');
        }
      } catch (err) {
        btn.disabled = false;
        btn.innerHTML = '<i class="fas fa-trash-alt"></i> Excluir permanentemente';
        toast.error('Erro', 'Falha ao excluir o time');
      }
    });
  }

  showEditTeamModal() {
    if (!this.team) return;

    const modal = app.createModal('Editar Time', `
      <form id="editTeamForm">
        <div class="form-group">
          <label for="editTeamName">Nome do Time</label>
          <input type="text" id="editTeamName" class="form-input" value="${this.team.name || ''}" required>
        </div>
        <div class="form-group">
          <label for="editTeamTag">Tag (3-5 caracteres)</label>
          <input type="text" id="editTeamTag" class="form-input" value="${this.team.tag || ''}" maxlength="5">
        </div>
        <div class="form-group">
          <label for="editTeamDescription">Descrição</label>
          <textarea id="editTeamDescription" class="form-input" rows="3" maxlength="200">${this.team.description || ''}</textarea>
        </div>
        <div class="form-actions">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="submit" class="btn btn-primary">Salvar</button>
        </div>
      </form>
    `);

    const form = modal.querySelector('#editTeamForm');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const name = document.getElementById('editTeamName').value;
      const tag = document.getElementById('editTeamTag').value;
      const description = document.getElementById('editTeamDescription').value;

      try {
        const result = await api.updateTeam(app.currentTeam.id, { name, tag, description });
        if (result.success) {
          toast.success('Sucesso', 'Time atualizado com sucesso');
          modal.remove();
          
          // Update app state
          app.currentTeam.name = name;
          app.currentTeam.tag = tag;
          app.updateTeamUI();
          
          await this.loadTeamData();
          this.render();
        }
      } catch (error) {
        toast.error('Erro', error.message || 'Falha ao atualizar time');
      }
    });
  }
}

// Global instance
const team = new Team();


/* ===== js/settings.js ===== */
// =====================================================
// ZDVAL - Settings Module
// Manages user profile and app settings
// =====================================================

class Settings {
  constructor() {
    this.user = null;
    this.initialized = false;
    this.currentView = 'overview';
    this._logFilter = 'all';
    this._logSearch = '';
    this._logAutoScroll = true;
    this._logUnsubscribe = null;
    this.abilityAgents = [];
    this._customAbilityIcons = {};
    this._abilityIconSize = 26;
    this._uploadAbilityIconSize = 46;
    this._agentIconSize = 35;
    this._abilityIconSizes = {};
    this._agentIconSizes = {};
  }

  async load(params = null) {
    const container = document.getElementById('page-settings');
    if (!container) return;

    this.currentView = params?.view === 'map-icons' ? 'map-icons' : 'overview';
    this.injectStyles();
    this._initAbilityManagerState();

    container.innerHTML = `
      <div class="page-content">
        ${renderPremiumPreload('Carregando configurações...')}
      </div>
    `;

    await this.loadUserData();
    this.render();

    if (this.currentView === 'map-icons') {
      await this.loadAbilityManagerData();
      return;
    }
  }

  async loadUserData() {
    try {
      const result = await api.getProfile();
      if (result.success) {
        this.user = result.data.user;
      }
    } catch (error) {
      console.error('Error loading user data:', error);
      toast.error('Erro', 'Não foi possível carregar os dados do usuário');
    }
  }

  render() {
    const container = document.getElementById('page-settings');
    if (!container) return;

    if (this.currentView === 'map-icons') {
      this.renderMapIconsPage();
      return;
    }

    const user = this.user || auth.user || {};

    container.innerHTML = `
      <div class="settings-premium">

        <!-- Preferences Section -->
        <div class="settings-section">
          <div class="settings-section-header">
            <div class="settings-section-icon"><i class="fas fa-sliders-h"></i></div>
            <div>
              <h2>PREFERÊNCIAS</h2>
              <p>Configure a interface do aplicativo</p>
            </div>
          </div>
          <div class="settings-section-body">
            <div class="settings-prefs-grid">
              <div class="preference-item">
                <div class="preference-info">
                  <span class="preference-label">Notificações do Navegador</span>
                  <span class="preference-description">Receba notificações quando houver novidades</span>
                </div>
                <label class="toggle-switch">
                  <input type="checkbox" id="notificationsEnabled" 
                         ${Notification.permission === 'granted' ? 'checked' : ''} 
                         onchange="settings.toggleNotifications(this)">
                  <span class="toggle-slider"></span>
                </label>
              </div>

              <div class="preference-item">
                <div class="preference-info">
                  <span class="preference-label">Tema da Interface</span>
                  <span class="preference-description">A plataforma usa o tema escuro do cabeçalho em todas as páginas</span>
                </div>
                <div class="theme-selector theme-selector-fixed" aria-label="Tema escuro fixo">
                  <button class="theme-btn active" type="button" data-theme="dark" title="Tema Escuro" aria-pressed="true">
                    <i class="fas fa-moon"></i>
                  </button>
                </div>
              </div>

              <div class="preference-item" style="display:none">
                <div class="preference-info">
                  <span class="preference-label">Sidebar Compacta</span>
                  <span class="preference-description">Manter a sidebar minimizada</span>
                </div>
                <label class="toggle-switch">
                  <input type="checkbox" id="compactSidebar" 
                         ${localStorage.getItem('zdval_sidebar_collapsed') === 'true' ? 'checked' : ''} 
                         onchange="settings.toggleSidebar(this)">
                  <span class="toggle-slider"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="settings-section">
          <div class="settings-section-header">
            <div class="settings-section-icon"><i class="fas fa-user-cog"></i></div>
            <div>
              <h2>CONTA</h2>
              <p>Informações e ações da conta</p>
            </div>
          </div>
          <div class="settings-section-body">
            <div class="settings-account-grid">
              <div class="settings-account-info-card">
                <div class="info-item">
                  <span class="info-label">Conta criada em:</span>
                  <span class="info-value">${user.created_at ? new Date(user.created_at).toLocaleDateString('pt-BR') : '--'}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Tipo de conta:</span>
                  <span class="info-value badge badge-${user.role === 'super_admin' ? 'danger' : 'primary'}">${user.role === 'super_admin' ? 'Super Admin' : 'Usuário'}</span>
                </div>
              </div>

              <div class="account-actions">
                ${user.role === 'super_admin' ? `
                <button class="btn btn-primary" onclick="window.location.href='/admin/dashboard'">
                  <i class="fas fa-shield-alt"></i> Painel do Admin
                </button>` : ''}
                <button class="btn btn-secondary" onclick="settings.exportData()">
                  <i class="fas fa-download"></i> Exportar Meus Dados
                </button>
                <button class="btn btn-logout-premium" onclick="auth.logout()">
                  <i class="fas fa-sign-out-alt"></i> Sair da Conta
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

  }

  renderMapIconsPage() {
    const container = document.getElementById('page-settings');
    if (!container) return;

    container.innerHTML = `
      <div class="settings-premium settings-subpage-layout">
        <div class="settings-subpage-hero">
          <button class="settings-back-btn" id="settingsMapIconsBack">
            <i class="fas fa-arrow-left"></i> Voltar para Configurações
          </button>
          <div class="settings-subpage-copy">
            <span class="settings-subpage-eyebrow">ZDPRO</span>
            <h1>Ícones do Mapa</h1>
            <p>Faça upload dos ícones usados no mapa, remova customizações e ajuste o tamanho global de habilidades e agentes.</p>
          </div>
        </div>

        <div class="settings-section settings-map-icons-shell">
          <div class="settings-section-header">
            <div class="settings-section-icon"><i class="fas fa-images"></i></div>
            <div>
              <h2>GERENCIADOR DE ÍCONES</h2>
              <p>As alterações são persistidas para o ZDPRO e reaproveitadas no mapa.</p>
            </div>
          </div>
          <div class="settings-section-body settings-map-icons-body">
            <div class="settings-aim-controls">
              <div class="settings-aim-size-control">
                <label class="settings-aim-size-label"><i class="fas fa-expand-arrows-alt"></i> Tamanho das Habilidades de API</label>
                <div class="settings-aim-size-slider-wrap">
                  <span class="settings-aim-size-min">10</span>
                  <input type="range" id="settings-ability-size-slider" min="10" max="80" value="${this._abilityIconSize}" step="1">
                  <span class="settings-aim-size-max">80</span>
                </div>
                <span class="settings-aim-size-value" id="settings-ability-size-value">${this._abilityIconSize}px</span>
              </div>

              <div class="settings-aim-size-control">
                <label class="settings-aim-size-label"><i class="fas fa-upload"></i> Tamanho das Habilidades com Upload</label>
                <div class="settings-aim-size-slider-wrap">
                  <span class="settings-aim-size-min">10</span>
                  <input type="range" id="settings-upload-ability-size-slider" min="10" max="80" value="${this._uploadAbilityIconSize}" step="1">
                  <span class="settings-aim-size-max">80</span>
                </div>
                <span class="settings-aim-size-value" id="settings-upload-ability-size-value">${this._uploadAbilityIconSize}px</span>
              </div>

              <div class="settings-aim-size-control">
                <label class="settings-aim-size-label"><i class="fas fa-user-alt"></i> Tamanho dos Agentes</label>
                <div class="settings-aim-size-slider-wrap">
                  <span class="settings-aim-size-min">15</span>
                  <input type="range" id="settings-agent-size-slider" min="15" max="80" value="${this._agentIconSize}" step="1">
                  <span class="settings-aim-size-max">80</span>
                </div>
                <span class="settings-aim-size-value" id="settings-agent-size-value">${this._agentIconSize}px</span>
              </div>

              <div class="settings-aim-actions">
                <button class="btn btn-secondary" id="settings-restore-map-icon-defaults">
                  <i class="fas fa-undo"></i> Restaurar Padrão
                </button>
              </div>
            </div>

            <div class="settings-aim-grid" id="settingsAbilityIconsGrid">
              <div class="loading-container compact">
                <div class="spinner"></div>
                <span>Carregando agentes e ícones...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    this.bindMapIconsPageControls();
  }

  toggleNotifications(checkbox) {
    if (checkbox.checked) {
      app.requestNotificationPermission();
    } else {
      toast.info('Info', 'As notificações foram desativadas');
    }
  }

  toggleSidebar(checkbox) {
    const sidebar = document.getElementById('sidebar');
    if (checkbox.checked) {
      sidebar.classList.add('collapsed');
      localStorage.setItem('zdval_sidebar_collapsed', 'true');
    } else {
      sidebar.classList.remove('collapsed');
      localStorage.setItem('zdval_sidebar_collapsed', 'false');
    }
  }

  setTheme(theme = 'light') {
    const appliedTheme = 'light';
    localStorage.setItem('zdval_theme', appliedTheme);
    document.documentElement.setAttribute('data-theme', appliedTheme);

    document.querySelectorAll('#page-settings .theme-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.theme === appliedTheme);
    });

    if (typeof app !== 'undefined' && app.showToast) {
      app.showToast('Tema claro ativado', 'success');
    }
  }

  exportData() {
    toast.info('Em breve', 'Esta funcionalidade estará disponível em breve');
  }

  injectStyles() {
    if (document.getElementById('settings-map-icons-styles')) return;

    // O CSS mora em css/pages/settings-map-icons.css. Ficava aqui como template string,
    // somando peso ao bundle de JS e impedindo que a folha fosse cacheada
    // e minificada em separado. Segue carregando sob demanda, como antes.
    Utils.loadPageCss('settings-map-icons-styles', 'settings-map-icons.css');
  }

  _initAbilityManagerState() {
    this._abilityIconSize = parseInt(localStorage.getItem('vp2_abilityIconSize')) || 26;
    this._uploadAbilityIconSize = parseInt(localStorage.getItem('vp2_uploadAbilityIconSize')) || 46;
    this._agentIconSize = parseInt(localStorage.getItem('vp2_agentIconSize')) || 35;
    this._abilityIconSizes = JSON.parse(localStorage.getItem('vp2_abilityIconSizes') || '{}');
    this._agentIconSizes = JSON.parse(localStorage.getItem('vp2_agentIconSizes') || '{}');
  }

  _normalizeAgentFolder(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/\s+/g, '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  getAbilitySlotKey(slot) {
    const slotMap = { Ability1: 'Q', Ability2: 'E', Grenade: 'C', Grenade_Alt: 'E2', Ultimate: 'X', Passive: 'P' };
    return slotMap[slot] || slot || '';
  }

  getDisplayAbilities(agent) {
    const abilities = Array.isArray(agent?.abilities) ? agent.abilities : [];
    const order = { Grenade: 0, Grenade_Alt: 0.5, Ability1: 1, Ability2: 2, Ultimate: 4, Passive: 5 };

    return [...abilities]
      .filter(ab => ab.slot !== 'Passive' || ab.displayIcon)
      .sort((left, right) => (order[left.slot] ?? 9) - (order[right.slot] ?? 9));
  }

  getAbilityIconSize(agentFolder, slot) {
    return this._abilityIconSizes[`${agentFolder}:${slot}`] || 50;
  }

  setAbilityIconSize(agentFolder, slot, size) {
    this._abilityIconSizes[`${agentFolder}:${slot}`] = size;
    localStorage.setItem('vp2_abilityIconSizes', JSON.stringify(this._abilityIconSizes));
  }

  getAgentIconSize(agentFolder) {
    return this._agentIconSizes[agentFolder] || this._agentIconSize;
  }

  setAgentIconSize(agentFolder, size) {
    this._agentIconSizes[agentFolder] = size;
    localStorage.setItem('vp2_agentIconSizes', JSON.stringify(this._agentIconSizes));
  }

  bindMapIconsPageControls() {
    document.getElementById('settingsMapIconsBack')?.addEventListener('click', () => {
      app.navigate('settings');
    });

    const abilitySizeSlider = document.getElementById('settings-ability-size-slider');
    const abilitySizeValue = document.getElementById('settings-ability-size-value');
    abilitySizeSlider?.addEventListener('input', (e) => {
      const value = parseInt(e.target.value);
      this._abilityIconSize = value;
      localStorage.setItem('vp2_abilityIconSize', value);
      if (abilitySizeValue) abilitySizeValue.textContent = `${value}px`;
    });

    const uploadAbilitySlider = document.getElementById('settings-upload-ability-size-slider');
    const uploadAbilityValue = document.getElementById('settings-upload-ability-size-value');
    uploadAbilitySlider?.addEventListener('input', (e) => {
      const value = parseInt(e.target.value);
      this._uploadAbilityIconSize = value;
      localStorage.setItem('vp2_uploadAbilityIconSize', value);
      if (uploadAbilityValue) uploadAbilityValue.textContent = `${value}px`;
    });

    const agentSizeSlider = document.getElementById('settings-agent-size-slider');
    const agentSizeValue = document.getElementById('settings-agent-size-value');
    agentSizeSlider?.addEventListener('input', (e) => {
      const value = parseInt(e.target.value);
      this._agentIconSize = value;
      localStorage.setItem('vp2_agentIconSize', value);
      if (agentSizeValue) agentSizeValue.textContent = `${value}px`;
    });

    document.getElementById('settings-restore-map-icon-defaults')?.addEventListener('click', () => {
      this.restoreAbilityManagerDefaults();
    });
  }

  async loadAbilityManagerData() {
    try {
      const [agentsResp, iconsResp] = await Promise.all([
        api.getValorantAgents(),
        fetch('/api/ability-icons', { cache: 'no-store' }).then(resp => resp.json())
      ]);

      this.abilityAgents = (agentsResp?.status === 200 && Array.isArray(agentsResp.data))
        ? agentsResp.data.filter(agent => agent.isPlayableCharacter).sort((left, right) => left.displayName.localeCompare(right.displayName))
        : [];
      this._customAbilityIcons = iconsResp?.icons || {};

      this.renderAbilityManagerGrid();
    } catch (error) {
      console.error('Error loading map icon manager:', error);
      const grid = document.getElementById('settingsAbilityIconsGrid');
      if (grid) {
        grid.innerHTML = `
          <div class="empty-state-full">
            <i class="fas fa-triangle-exclamation"></i>
            <h2>Falha ao carregar o gerenciador</h2>
            <p>Não foi possível carregar os agentes e os ícones customizados.</p>
          </div>
        `;
      }
    }
  }

  renderAbilityManagerGrid() {
    const grid = document.getElementById('settingsAbilityIconsGrid');
    if (!grid) return;

    grid.innerHTML = this.abilityAgents.map(agent => {
      const folder = this._normalizeAgentFolder(agent.displayName);
      const abilities = this.getDisplayAbilities(agent);
      const agentCustom = this._customAbilityIcons[folder] || {};

      const abilitiesHtml = abilities.map(ab => {
        const key = this.getAbilitySlotKey(ab.slot);
        const hasCustom = !!agentCustom[key];
        const iconSrc = hasCustom ? `${agentCustom[key]}?t=${Date.now()}` : (ab.displayIcon || '');
        const abilitySize = this.getAbilityIconSize(folder, key);
        const durVal = ab.duration;
        const durDisplay = durVal != null ? (durVal % 1 === 0 ? `${durVal}s` : `${durVal.toFixed(1)}s`) : null;

        return `
          <div class="settings-aim-ability">
            <div class="settings-aim-ability-icon-wrap ${hasCustom ? 'has-custom' : ''}" data-agent-folder="${folder}" data-slot="${key}" title="${ab.displayName}">
              <img src="${iconSrc}" alt="${ab.displayName}" onerror="this.style.display='none'">
              <div class="settings-aim-upload-hint"><i class="fas ${hasCustom ? 'fa-sync-alt' : 'fa-upload'}"></i></div>
              ${hasCustom ? `<button class="settings-aim-remove-btn" data-agent-folder="${folder}" data-slot="${key}" title="Remover ícone"><i class="fas fa-times"></i></button>` : ''}
            </div>
            <div class="settings-aim-ability-size-popup">
              <label>Tamanho</label>
              <div class="settings-aim-ability-size-row">
                <input type="range" class="settings-aim-ability-size-input" min="10" max="80" value="${abilitySize}" step="1" data-agent-folder="${folder}" data-slot="${key}">
                <span class="settings-aim-ability-size-val">${abilitySize}</span>
              </div>
            </div>
            <span class="settings-aim-ability-name">${ab.displayName}</span>
            ${durDisplay ? `<span class="settings-aim-ability-duration"><i class="fas fa-clock"></i> ${durDisplay}</span>` : ''}
          </div>
        `;
      }).join('');

      const agentSize = this.getAgentIconSize(folder);
      return `
        <div class="settings-aim-agent-card">
          <div class="settings-aim-agent-portrait">
            <img src="${agent.displayIcon || agent.displayIconSmall}" alt="${agent.displayName}" loading="lazy">
            <div class="settings-aim-agent-size-popup">
              <label>Tamanho</label>
              <div class="settings-aim-agent-size-row">
                <input type="range" class="settings-aim-agent-size-input" min="15" max="80" value="${agentSize}" step="1" data-agent-folder="${folder}">
                <span class="settings-aim-agent-size-val">${agentSize}</span>
              </div>
            </div>
          </div>
          <div class="settings-aim-agent-name">${agent.displayName}</div>
          <div class="settings-aim-abilities">${abilitiesHtml}</div>
        </div>
      `;
    }).join('');

    this.bindAbilityManagerGridEvents();
  }

  bindAbilityManagerGridEvents() {
    const grid = document.getElementById('settingsAbilityIconsGrid');
    if (!grid) return;

    grid.querySelectorAll('.settings-aim-ability-icon-wrap').forEach(wrap => {
      wrap.addEventListener('click', (e) => {
        if (e.target.closest('.settings-aim-remove-btn')) return;
        this.uploadAbilityIcon(wrap.dataset.agentFolder, wrap.dataset.slot);
      });
    });

    grid.querySelectorAll('.settings-aim-ability-size-input').forEach(slider => {
      slider.addEventListener('input', (e) => {
        const value = parseInt(e.target.value);
        this.setAbilityIconSize(e.target.dataset.agentFolder, e.target.dataset.slot, value);
        const valueEl = e.target.parentElement.querySelector('.settings-aim-ability-size-val');
        if (valueEl) valueEl.textContent = value;
      });
      slider.addEventListener('click', (e) => e.stopPropagation());
      slider.addEventListener('mousedown', (e) => e.stopPropagation());
    });

    grid.querySelectorAll('.settings-aim-agent-size-input').forEach(slider => {
      slider.addEventListener('input', (e) => {
        const value = parseInt(e.target.value);
        this.setAgentIconSize(e.target.dataset.agentFolder, value);
        const valueEl = e.target.parentElement.querySelector('.settings-aim-agent-size-val');
        if (valueEl) valueEl.textContent = value;
      });
      slider.addEventListener('click', (e) => e.stopPropagation());
      slider.addEventListener('mousedown', (e) => e.stopPropagation());
    });

    grid.querySelectorAll('.settings-aim-remove-btn').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.stopPropagation();
        await this.removeAbilityIcon(btn.dataset.agentFolder, btn.dataset.slot);
      });
    });
  }

  restoreAbilityManagerDefaults() {
    this._abilityIconSize = 26;
    this._uploadAbilityIconSize = 46;
    this._agentIconSize = 35;
    this._abilityIconSizes = {};
    this._agentIconSizes = {};

    localStorage.setItem('vp2_abilityIconSize', 26);
    localStorage.setItem('vp2_uploadAbilityIconSize', 46);
    localStorage.setItem('vp2_agentIconSize', 35);
    localStorage.removeItem('vp2_abilityIconSizes');
    localStorage.removeItem('vp2_agentIconSizes');

    const ability = document.getElementById('settings-ability-size-slider');
    const upload = document.getElementById('settings-upload-ability-size-slider');
    const agent = document.getElementById('settings-agent-size-slider');
    const abilityValue = document.getElementById('settings-ability-size-value');
    const uploadValue = document.getElementById('settings-upload-ability-size-value');
    const agentValue = document.getElementById('settings-agent-size-value');

    if (ability) ability.value = 26;
    if (upload) upload.value = 46;
    if (agent) agent.value = 35;
    if (abilityValue) abilityValue.textContent = '26px';
    if (uploadValue) uploadValue.textContent = '46px';
    if (agentValue) agentValue.textContent = '35px';

    this.renderAbilityManagerGrid();
    toast.success('Sucesso', 'Padrões restaurados com sucesso');
  }

  async uploadAbilityIcon(agentFolder, slot) {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/png,image/webp,image/jpeg';

    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('icon', file);

      try {
        const response = await fetch(`/api/ability-icons/${agentFolder}/${slot}`, {
          method: 'POST',
          body: formData
        });
        const data = await response.json();

        if (!data.success) {
          toast.error('Erro', data.error || 'Falha ao fazer upload do ícone');
          return;
        }

        if (!this._customAbilityIcons[agentFolder]) this._customAbilityIcons[agentFolder] = {};
        this._customAbilityIcons[agentFolder][slot] = data.path;
        this.renderAbilityManagerGrid();
        toast.success('Sucesso', 'Ícone atualizado com sucesso');
      } catch (error) {
        console.error('Upload error:', error);
        toast.error('Erro', 'Falha ao fazer upload do ícone');
      }
    };

    input.click();
  }

  async removeAbilityIcon(agentFolder, slot) {
    try {
      const response = await fetch(`/api/ability-icons/${agentFolder}/${slot}`, {
        method: 'DELETE'
      });
      const data = await response.json();

      if (!data.success) {
        toast.error('Erro', data.error || 'Falha ao remover o ícone');
        return;
      }

      if (this._customAbilityIcons[agentFolder]) {
        delete this._customAbilityIcons[agentFolder][slot];
      }
      this.renderAbilityManagerGrid();
      toast.success('Sucesso', 'Ícone removido com sucesso');
    } catch (error) {
      console.error('Delete error:', error);
      toast.error('Erro', 'Falha ao remover o ícone');
    }
  }

  // =====================================================
  // LOG VIEWER
  // =====================================================

  _initLogViewer() {
    // Unsubscribe previous listener
    if (this._logUnsubscribe) this._logUnsubscribe();

    this.renderLogs();
    this._updateLogStats();

    // Live updates
    this._logUnsubscribe = window.siteLogger?.onLog((entry) => {
      if (this._matchesFilter(entry)) {
        this._appendLogEntry(entry);
      }
      this._updateLogStats();
    });
  }

  renderLogs() {
    const viewer = document.getElementById('logViewer');
    if (!viewer || !window.siteLogger) return;

    const logs = this._getFilteredLogs();
    viewer.innerHTML = logs.map(l => this._logEntryHtml(l)).join('');

    const countEl = document.getElementById('logCount');
    if (countEl) countEl.textContent = `${logs.length} entradas`;

    if (this._logAutoScroll) viewer.scrollTop = viewer.scrollHeight;
  }

  _appendLogEntry(entry) {
    const viewer = document.getElementById('logViewer');
    if (!viewer) return;

    viewer.insertAdjacentHTML('beforeend', this._logEntryHtml(entry));

    // Trim DOM if too many
    while (viewer.children.length > 500) viewer.removeChild(viewer.firstChild);

    const countEl = document.getElementById('logCount');
    if (countEl) countEl.textContent = `${viewer.children.length} entradas`;

    if (this._logAutoScroll) viewer.scrollTop = viewer.scrollHeight;
  }

  _logEntryHtml(l) {
    const time = new Date(l.time).toLocaleTimeString('pt-BR', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
    const typeClass = l.type;
    const icons = {
      error: 'fas fa-times-circle',
      warn: 'fas fa-exclamation-triangle',
      network: 'fas fa-wifi',
      load: 'fas fa-download',
      slow: 'fas fa-clock',
      resource: 'fas fa-image',
      nav: 'fas fa-route',
      info: 'fas fa-info-circle'
    };
    const icon = icons[l.type] || 'fas fa-circle';
    const escapedMsg = SecurityUtils.escapeHtml(l.message);
    const stackHtml = l.stack
      ? `<div class="log-stack">${SecurityUtils.escapeHtml(l.stack)}</div>`
      : '';

    return `<div class="log-entry log-${typeClass}">
      <span class="log-time">${time}</span>
      <span class="log-type-badge"><i class="${icon}"></i></span>
      <span class="log-msg">${escapedMsg}</span>
      ${stackHtml}
    </div>`;
  }

  _getFilteredLogs() {
    let logs = window.siteLogger?.getAll() || [];
    if (this._logFilter !== 'all') {
      logs = logs.filter(l => l.type === this._logFilter);
    }
    if (this._logSearch) {
      const q = this._logSearch.toLowerCase();
      logs = logs.filter(l => l.message.toLowerCase().includes(q) || (l.stack && l.stack.toLowerCase().includes(q)));
    }
    return logs;
  }

  _matchesFilter(entry) {
    if (this._logFilter !== 'all' && entry.type !== this._logFilter) return false;
    if (this._logSearch) {
      const q = this._logSearch.toLowerCase();
      if (!entry.message.toLowerCase().includes(q) && !(entry.stack && entry.stack.toLowerCase().includes(q))) return false;
    }
    return true;
  }

  _updateLogStats() {
    const el = document.getElementById('logHeaderStats');
    if (!el || !window.siteLogger) return;
    const s = window.siteLogger.stats;
    const parts = [];
    if (s.error) parts.push(`<span class="log-stat error">${s.error} erros</span>`);
    if (s.warn) parts.push(`<span class="log-stat warn">${s.warn} avisos</span>`);
    if (s.network) parts.push(`<span class="log-stat network">${s.network} rede</span>`);
    if (s.resource) parts.push(`<span class="log-stat resource">${s.resource} recursos</span>`);
    if (s.slow) parts.push(`<span class="log-stat slow">${s.slow} lentos</span>`);
    el.innerHTML = parts.join('');
  }

  setLogFilter(type) {
    this._logFilter = type;
    document.querySelectorAll('.log-filter-btn').forEach(b => b.classList.toggle('active', b.dataset.filter === type));
    this.renderLogs();
  }

  onLogSearch(value) {
    this._logSearch = value.trim();
    this.renderLogs();
  }

  clearLogs() {
    if (!window.siteLogger) return;
    window.siteLogger.clear();
    this.renderLogs();
    this._updateLogStats();
    toast.success('Logs limpos', 'Todos os registros foram removidos');
  }

  exportLogs() {
    if (!window.siteLogger) return;
    const text = window.siteLogger.exportText();
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `zdval-logs-${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  }
}

// Global instance
const settings = new Settings();


/* ===== js/profile.js ===== */
// =====================================================
// ZDVAL - Profile Module
// User profile page with tabs: Perfil, Social
// =====================================================

const COUNTRIES = [
  {code:'AF',name:'Afeganistão'},{code:'ZA',name:'África do Sul'},{code:'AL',name:'Albânia'},{code:'DE',name:'Alemanha'},
  {code:'AD',name:'Andorra'},{code:'AO',name:'Angola'},{code:'AG',name:'Antígua e Barbuda'},{code:'SA',name:'Arábia Saudita'},
  {code:'DZ',name:'Argélia'},{code:'AR',name:'Argentina'},{code:'AM',name:'Armênia'},{code:'AU',name:'Austrália'},
  {code:'AT',name:'Áustria'},{code:'AZ',name:'Azerbaijão'},{code:'BS',name:'Bahamas'},{code:'BD',name:'Bangladesh'},
  {code:'BB',name:'Barbados'},{code:'BH',name:'Bahrein'},{code:'BE',name:'Bélgica'},{code:'BZ',name:'Belize'},
  {code:'BJ',name:'Benin'},{code:'BY',name:'Bielorrússia'},{code:'BO',name:'Bolívia'},{code:'BA',name:'Bósnia e Herzegovina'},
  {code:'BW',name:'Botsuana'},{code:'BR',name:'Brasil'},{code:'BN',name:'Brunei'},{code:'BG',name:'Bulgária'},
  {code:'BF',name:'Burkina Faso'},{code:'BI',name:'Burundi'},{code:'BT',name:'Butão'},{code:'CV',name:'Cabo Verde'},
  {code:'CM',name:'Camarões'},{code:'KH',name:'Camboja'},{code:'CA',name:'Canadá'},{code:'QA',name:'Catar'},
  {code:'KZ',name:'Cazaquistão'},{code:'TD',name:'Chade'},{code:'CL',name:'Chile'},{code:'CN',name:'China'},
  {code:'CY',name:'Chipre'},{code:'CO',name:'Colômbia'},{code:'KM',name:'Comores'},{code:'CG',name:'Congo'},
  {code:'KP',name:'Coreia do Norte'},{code:'KR',name:'Coreia do Sul'},{code:'CI',name:'Costa do Marfim'},
  {code:'CR',name:'Costa Rica'},{code:'HR',name:'Croácia'},{code:'CU',name:'Cuba'},{code:'DK',name:'Dinamarca'},
  {code:'DJ',name:'Djibuti'},{code:'DM',name:'Dominica'},{code:'EG',name:'Egito'},{code:'SV',name:'El Salvador'},
  {code:'AE',name:'Emirados Árabes'},{code:'EC',name:'Equador'},{code:'ER',name:'Eritreia'},{code:'SK',name:'Eslováquia'},
  {code:'SI',name:'Eslovênia'},{code:'ES',name:'Espanha'},{code:'US',name:'Estados Unidos'},{code:'EE',name:'Estônia'},
  {code:'SZ',name:'Eswatini'},{code:'ET',name:'Etiópia'},{code:'FJ',name:'Fiji'},{code:'PH',name:'Filipinas'},
  {code:'FI',name:'Finlândia'},{code:'FR',name:'França'},{code:'GA',name:'Gabão'},{code:'GM',name:'Gâmbia'},
  {code:'GH',name:'Gana'},{code:'GE',name:'Geórgia'},{code:'GR',name:'Grécia'},{code:'GD',name:'Granada'},
  {code:'GT',name:'Guatemala'},{code:'GY',name:'Guiana'},{code:'GN',name:'Guiné'},{code:'GQ',name:'Guiné Equatorial'},
  {code:'GW',name:'Guiné-Bissau'},{code:'HT',name:'Haiti'},{code:'HN',name:'Honduras'},{code:'HU',name:'Hungria'},
  {code:'YE',name:'Iémen'},{code:'MH',name:'Ilhas Marshall'},{code:'SB',name:'Ilhas Salomão'},{code:'IN',name:'Índia'},
  {code:'ID',name:'Indonésia'},{code:'IR',name:'Irã'},{code:'IQ',name:'Iraque'},{code:'IE',name:'Irlanda'},
  {code:'IS',name:'Islândia'},{code:'IL',name:'Israel'},{code:'IT',name:'Itália'},{code:'JM',name:'Jamaica'},
  {code:'JP',name:'Japão'},{code:'JO',name:'Jordânia'},{code:'KW',name:'Kuwait'},{code:'LA',name:'Laos'},
  {code:'LS',name:'Lesoto'},{code:'LV',name:'Letônia'},{code:'LB',name:'Líbano'},{code:'LR',name:'Libéria'},
  {code:'LY',name:'Líbia'},{code:'LI',name:'Liechtenstein'},{code:'LT',name:'Lituânia'},{code:'LU',name:'Luxemburgo'},
  {code:'MK',name:'Macedônia do Norte'},{code:'MG',name:'Madagascar'},{code:'MY',name:'Malásia'},{code:'MW',name:'Malawi'},
  {code:'MV',name:'Maldivas'},{code:'ML',name:'Mali'},{code:'MT',name:'Malta'},{code:'MA',name:'Marrocos'},
  {code:'MU',name:'Maurício'},{code:'MR',name:'Mauritânia'},{code:'MX',name:'México'},{code:'MM',name:'Mianmar'},
  {code:'FM',name:'Micronésia'},{code:'MZ',name:'Moçambique'},{code:'MD',name:'Moldávia'},{code:'MC',name:'Mônaco'},
  {code:'MN',name:'Mongólia'},{code:'ME',name:'Montenegro'},{code:'NA',name:'Namíbia'},{code:'NR',name:'Nauru'},
  {code:'NP',name:'Nepal'},{code:'NI',name:'Nicarágua'},{code:'NE',name:'Níger'},{code:'NG',name:'Nigéria'},
  {code:'NO',name:'Noruega'},{code:'NZ',name:'Nova Zelândia'},{code:'OM',name:'Omã'},{code:'NL',name:'Países Baixos'},
  {code:'PW',name:'Palau'},{code:'PA',name:'Panamá'},{code:'PG',name:'Papua Nova Guiné'},{code:'PK',name:'Paquistão'},
  {code:'PY',name:'Paraguai'},{code:'PE',name:'Peru'},{code:'PL',name:'Polônia'},{code:'PT',name:'Portugal'},
  {code:'KE',name:'Quênia'},{code:'KG',name:'Quirguistão'},{code:'KI',name:'Quiribati'},{code:'GB',name:'Reino Unido'},
  {code:'CF',name:'República Centro-Africana'},{code:'CD',name:'República Dem. do Congo'},{code:'DO',name:'República Dominicana'},
  {code:'CZ',name:'República Tcheca'},{code:'RO',name:'Romênia'},{code:'RW',name:'Ruanda'},{code:'RU',name:'Rússia'},
  {code:'WS',name:'Samoa'},{code:'SM',name:'San Marino'},{code:'LC',name:'Santa Lúcia'},{code:'KN',name:'São Cristóvão e Névis'},
  {code:'ST',name:'São Tomé e Príncipe'},{code:'VC',name:'São Vicente e Granadinas'},{code:'SC',name:'Seicheles'},
  {code:'SN',name:'Senegal'},{code:'SL',name:'Serra Leoa'},{code:'RS',name:'Sérvia'},{code:'SG',name:'Singapura'},
  {code:'SY',name:'Síria'},{code:'SO',name:'Somália'},{code:'LK',name:'Sri Lanka'},{code:'SD',name:'Sudão'},
  {code:'SS',name:'Sudão do Sul'},{code:'SE',name:'Suécia'},{code:'CH',name:'Suíça'},{code:'SR',name:'Suriname'},
  {code:'TJ',name:'Tajiquistão'},{code:'TH',name:'Tailândia'},{code:'TW',name:'Taiwan'},{code:'TZ',name:'Tanzânia'},
  {code:'TL',name:'Timor-Leste'},{code:'TG',name:'Togo'},{code:'TO',name:'Tonga'},{code:'TT',name:'Trinidad e Tobago'},
  {code:'TN',name:'Tunísia'},{code:'TM',name:'Turcomenistão'},{code:'TR',name:'Turquia'},{code:'TV',name:'Tuvalu'},
  {code:'UA',name:'Ucrânia'},{code:'UG',name:'Uganda'},{code:'UY',name:'Uruguai'},{code:'UZ',name:'Uzbequistão'},
  {code:'VU',name:'Vanuatu'},{code:'VA',name:'Vaticano'},{code:'VE',name:'Venezuela'},{code:'VN',name:'Vietnã'},
  {code:'ZM',name:'Zâmbia'},{code:'ZW',name:'Zimbábue'}
];

const COUNTRY_DIAL_CODE_FALLBACKS = {
  AF: '+93', ZA: '+27', AL: '+355', DE: '+49', AD: '+376', AO: '+244', AG: '+1', SA: '+966',
  DZ: '+213', AR: '+54', AM: '+374', AU: '+61', AT: '+43', AZ: '+994', BS: '+1', BD: '+880',
  BB: '+1', BH: '+973', BE: '+32', BZ: '+501', BJ: '+229', BY: '+375', BO: '+591', BA: '+387',
  BW: '+267', BR: '+55', BN: '+673', BG: '+359', BF: '+226', BI: '+257', BT: '+975', CV: '+238',
  CM: '+237', KH: '+855', CA: '+1', QA: '+974', KZ: '+7', TD: '+235', CL: '+56', CN: '+86',
  CY: '+357', CO: '+57', KM: '+269', CG: '+242', KP: '+850', KR: '+82', CI: '+225', CR: '+506',
  HR: '+385', CU: '+53', DK: '+45', DJ: '+253', DM: '+1', EG: '+20', SV: '+503', AE: '+971',
  EC: '+593', ER: '+291', SK: '+421', SI: '+386', ES: '+34', US: '+1', EE: '+372', SZ: '+268',
  ET: '+251', FJ: '+679', PH: '+63', FI: '+358', FR: '+33', GA: '+241', GM: '+220', GH: '+233',
  GE: '+995', GR: '+30', GD: '+1', GT: '+502', GY: '+592', GN: '+224', GQ: '+240', GW: '+245',
  HT: '+509', HN: '+504', HU: '+36', YE: '+967', MH: '+692', SB: '+677', IN: '+91', ID: '+62',
  IR: '+98', IQ: '+964', IE: '+353', IS: '+354', IL: '+972', IT: '+39', JM: '+1', JP: '+81',
  JO: '+962', KW: '+965', LA: '+856', LS: '+266', LV: '+371', LB: '+961', LR: '+231', LY: '+218',
  LI: '+423', LT: '+370', LU: '+352', MK: '+389', MG: '+261', MY: '+60', MW: '+265', MV: '+960',
  ML: '+223', MT: '+356', MA: '+212', MU: '+230', MR: '+222', MX: '+52', MM: '+95', FM: '+691',
  MZ: '+258', MD: '+373', MC: '+377', MN: '+976', ME: '+382', NA: '+264', NR: '+674', NP: '+977',
  NI: '+505', NE: '+227', NG: '+234', NO: '+47', NZ: '+64', OM: '+968', NL: '+31', PW: '+680',
  PA: '+507', PG: '+675', PK: '+92', PY: '+595', PE: '+51', PL: '+48', PT: '+351', KE: '+254',
  KG: '+996', KI: '+686', GB: '+44', CF: '+236', CD: '+243', DO: '+1', CZ: '+420', RO: '+40',
  RW: '+250', RU: '+7', WS: '+685', SM: '+378', LC: '+1', KN: '+1', ST: '+239', VC: '+1',
  SC: '+248', SN: '+221', SL: '+232', RS: '+381', SG: '+65', SY: '+963', SO: '+252', LK: '+94',
  SD: '+249', SS: '+211', SE: '+46', CH: '+41', SR: '+597', TJ: '+992', TH: '+66', TW: '+886',
  TZ: '+255', TL: '+670', TG: '+228', TO: '+676', TT: '+1', TN: '+216', TM: '+993', TR: '+90',
  TV: '+688', UA: '+380', UG: '+256', UY: '+598', UZ: '+998', VU: '+678', VA: '+379', VE: '+58',
  VN: '+84', ZM: '+260', ZW: '+263'
};

const ALL_PHONE_DIAL_CODES = [...new Set(Object.values(COUNTRY_DIAL_CODE_FALLBACKS))]
  .sort((left, right) => Number(left.slice(1)) - Number(right.slice(1)) || left.localeCompare(right));

const PHONE_DIAL_CODES_DESC = [...ALL_PHONE_DIAL_CODES]
  .sort((left, right) => right.length - left.length || left.localeCompare(right));

function countryCodeToFlag(code) {
  if (!code || code.length !== 2) return '🏳️';
  return String.fromCodePoint(...[...code.toUpperCase()].map(c => 0x1F1E6 + c.charCodeAt(0) - 65));
}

function countryName(code) {
  const c = COUNTRIES.find(c => c.code === (code || '').toUpperCase());
  return c ? c.name : code || 'Desconhecido';
}

class Profile {
  /**
   * Catálogo das redes do editor. `field` é a coluna que o backend já tem —
   * o seletor é só a camada de UI por cima dessas colunas fixas.
   */
  static SOCIAL_NETWORKS = [
    { key: 'twitch',    field: 'twitch_username', label: 'Twitch',      icon: 'fab fa-twitch',    color: '#9146ff', base: 'https://twitch.tv/',     placeholder: 'https://twitch.tv/seu_canal' },
    { key: 'twitter',   field: 'twitter_url',     label: 'X / Twitter', icon: 'fab fa-x-twitter', color: '#e7e9ea', base: 'https://x.com/',         placeholder: 'https://x.com/seu_user' },
    { key: 'instagram', field: 'instagram_url',   label: 'Instagram',   icon: 'fab fa-instagram', color: '#e1306c', base: 'https://instagram.com/', placeholder: 'https://instagram.com/seu_user' },
    { key: 'tiktok',    field: 'tiktok_url',      label: 'TikTok',      icon: 'fab fa-tiktok',    color: '#e9ecf1', base: 'https://tiktok.com/@',   placeholder: 'https://tiktok.com/@seu_user' },
    { key: 'youtube',   field: 'youtube_url',     label: 'YouTube',     icon: 'fab fa-youtube',   color: '#ff0000', base: 'https://youtube.com/@',  placeholder: 'https://youtube.com/@seu_canal' },
    { key: 'facebook',  field: 'facebook_url',    label: 'Facebook',    icon: 'fab fa-facebook',  color: '#1877f2', base: 'https://facebook.com/',  placeholder: 'https://facebook.com/seu_perfil' }
  ];

  constructor() {
    this.user = null;
    this.mode = 'view';
    this.activeViewTab = 'overview';
    this.valorantAssets = {
      agents: null,
      maps: null
    };
    this.rankedOverview = null;
    this.rankedLoading = false;
    this.rankedError = null;
    this.profileTeams = null;
    this.rankedPeriod = 'act';
    this.rankedPeriodDropdownOpen = false;
    this.rankedNeedsRefresh = false;
    this.rankedAutoRefreshTimer = null;
    this.rankedAutoRefreshMs = 60000;
    this.rankedRequestTimeoutMs = 15000;
    this.rankedCacheVersion = 3;
    this.countryDialCodeCache = new Map();
    this.publicMediaSyncFrame = null;

    this.handlePublicMediaResize = () => {
      const profilePage = document.getElementById('page-profile');
      this.schedulePublicMediaCardSync(profilePage || document);
    };

    window.addEventListener('resize', this.handlePublicMediaResize);

    document.addEventListener('click', (event) => {
      const dropdown = document.getElementById('profileRankedPeriodDropdown');
      if (!this.rankedPeriodDropdownOpen || !dropdown || dropdown.contains(event.target)) {
        return;
      }

      this.rankedPeriodDropdownOpen = false;
      this.refreshRankedPanel();
    });
  }

  async load(params = null) {
    const container = document.getElementById('page-profile');
    if (!container) return;

    this.applyRouteState(params);

    container.innerHTML = `
      <div class="page-content">
        ${renderPremiumPreload('Carregando perfil...')}
      </div>
    `;

    if (!this.user) {
      await this.loadUserData();
    }

    this.render();
  }

  async loadUserData() {
    try {
      const result = await api.getProfile();
      if (result.success) {
        this.user = result.data.user;
      }
    } catch (error) {
      console.error('Error loading user data:', error);
      toast.error('Erro', 'Não foi possível carregar os dados do usuário');
    }
  }

  render() {
    const container = document.getElementById('page-profile');
    if (!container) return;

    const user = this.user || auth.user || {};
    if (this.mode === 'view' && !this.rankedOverview && user?.riot_id && user?.riot_tag) {
      this.restoreRankedOverviewCache(user);
    }
    const socialLinks = this.getSocialLinks(user);
    const highlightLinks = this.getHighlightLinks(user);
    const eyebrow = this.mode === 'edit' ? 'Editor de Perfil' : 'Player Profile';
    const heroIdentity = this.buildHeroIdentity(user, this.rankedOverview);

    container.innerHTML = `
      <div class="settings-premium profile-premium-compact player-profile-hub ${this.mode === 'view' ? 'player-profile-public' : 'player-profile-editor'}">
        ${this.mode === 'view' ? this.renderPublicHero(user, socialLinks, heroIdentity, eyebrow) : ''}
        ${this.mode === 'view' ? this.renderViewPanels(user, socialLinks, highlightLinks) : this.renderEditPanels(user)}

      </div>
    `;

    this.setupFormHandlers();
    this.initProfileMediaEmbeds(container);
    this.schedulePublicMediaCardSync(container);
    if (this.mode === 'edit') {
      this.syncPhoneDialCode();
    }
    if (this.mode === 'view') {
      if (!this.profileTeams) this.loadProfileTeams();
      this.syncRankedAutoRefresh();
    } else {
      this.syncRankedAutoRefresh();
    }

    const bioEl = document.getElementById('profileBio');
    if (bioEl) {
      bioEl.addEventListener('input', () => {
        const counter = bioEl.parentElement?.querySelector('[data-bio-counter]');
        if (counter) counter.textContent = `${bioEl.value.length}/200`;
      });
    }

    if (this.mode === 'view' && user?.riot_id && user?.riot_tag && (!this.rankedOverview || this.rankedNeedsRefresh) && !this.rankedLoading) {
      this.loadRankedOverview(Boolean(this.rankedNeedsRefresh));
    }
  }

  applyRouteState(params = null) {
    const nextMode = params?.mode === 'edit' ? 'edit' : 'view';
    this.mode = nextMode;

    if (nextMode === 'view') {
      this.activeViewTab = 'overview';
    }
  }

  setMode(mode) {
    const nextMode = mode === 'edit' ? 'edit' : 'view';
    this.mode = nextMode;

    if (nextMode === 'view') {
      this.activeViewTab = 'overview';
    }

    this.pushRouteState();
    this.render();
  }

  pushRouteState() {
    const params = new URLSearchParams(
      this.mode === 'view' ? { mode: 'view', tab: this.activeViewTab } : { mode: 'edit' }
    );

    window.history.pushState({
      page: 'profile',
      params: Object.fromEntries(params)
    }, '', `/profile?${params.toString()}`);
  }

  renderViewMenu() {
    return `
      <div class="profile-player-menu profile-view-menu">
        <button class="profile-player-menu-btn ${this.activeViewTab === 'overview' ? 'active' : ''}" type="button" data-tab-id="overview" onclick="profile.switchViewTab('overview')">
          <i class="fas fa-id-card"></i>
          <span>Perfil</span>
        </button>
        <button class="profile-player-menu-btn ${this.activeViewTab === 'social' ? 'active' : ''}" type="button" data-tab-id="social" onclick="profile.switchViewTab('social')">
          <i class="fas fa-share-alt"></i>
          <span>Social</span>
        </button>
        <button class="profile-player-menu-btn ${this.activeViewTab === 'highlights' ? 'active' : ''}" type="button" data-tab-id="highlights" onclick="profile.switchViewTab('highlights')">
          <i class="fab fa-youtube"></i>
          <span>Highlights</span>
        </button>
      </div>
    `;
  }

  renderViewSectionNav() {
    return `
      <div class="profile-view-sections-nav">
        <button class="profile-view-section-chip ${this.activeViewTab === 'overview' ? 'active' : ''}" type="button" onclick="profile.switchViewTab('overview')">
          <span>Perfil</span>
        </button>
      </div>
    `;
  }

  renderPublicMediaSection(links) {
    const primaryLink = links[0] || null;

    if (!links.length) {
      return `
        <div class="profile-public-card profile-public-card-media">
          <div class="profile-public-empty-state large">
            <i class="fab fa-youtube"></i>
            <span>Nenhum highlight publicado ainda.</span>
            <small>Adicione um vídeo em Perfil > Highlights para exibir aqui.</small>
          </div>
        </div>
      `;
    }

    return `
      <article class="profile-public-card profile-public-card-media">
        <div class="profile-public-media-single">
          ${this.renderHighlightPreviewCard(primaryLink, 1)}
        </div>
      </article>
    `;
  }

  renderPublicCompetitiveSnapshotCard(user, overview) {
    if (!user?.riot_id || !user?.riot_tag) {
      return '';
    }

    if (this.rankedLoading && !overview) {
      return `
        <article class="profile-public-card profile-public-card-competitive is-loading">
          <div class="profile-public-empty-state large">
            <i class="fas fa-chart-line"></i>
            <span>Carregando snapshot competitivo do ato atual...</span>
          </div>
        </article>
      `;
    }

    if (this.rankedError && !overview) {
      return `
        <article class="profile-public-card profile-public-card-competitive">
          <div class="profile-public-empty-state large">
            <i class="fas fa-triangle-exclamation"></i>
            <span>${this.rankedError}</span>
            <button type="button" class="btn btn-primary" onclick="profile.loadRankedOverview(true)">
              <i class="fas fa-rotate-right"></i> Atualizar
            </button>
          </div>
        </article>
      `;
    }

    if (!overview) {
      return `
        <article class="profile-public-card profile-public-card-competitive">
          <div class="profile-public-empty-state large">
            <i class="fas fa-chart-line"></i>
            <span>Sincronizando competitivo do ato atual...</span>
          </div>
        </article>
      `;
    }

    const period = overview?.periods?.act || overview?.periods?.all || {};
    const topAgent = period?.topAgents?.[0] || null;
    const agentKey = topAgent?.agent || '';
    const agentData = agentKey ? this.valorantAssets.agents?.[agentKey] : null;
    const roleLabel = agentData?.role?.displayName || overview?.primaryRoleLabel || 'Sem função';
    const agentImage = agentData?.displayIcon || agentData?.displayIconSmall || overview?.primaryAgentIcon || '/img/default-agent.png';
    const actLabel = period?.label || overview?.currentActLabel || 'Ato atual';
    const matchCount = String(period?.performance?.matchesLabel || '0');
    const metrics = this.buildPublicCompetitiveMetricEntries(overview, period);

    return `
      <article class="profile-public-card profile-public-card-competitive">
        <div class="profile-public-card-head">
          <div>
            <span class="profile-public-card-eyebrow">Ato Atual</span>
            <h3>Competitive Snapshot</h3>
          </div>
          <span class="profile-public-section-badge">${actLabel}</span>
        </div>
        <div class="profile-public-competitive-hero">
          <div class="profile-public-competitive-agent">
            <div class="profile-public-competitive-agent-portrait-wrap">
              <img src="${agentImage}" alt="${agentData?.displayName || overview?.primaryAgentLabel || 'Agente'}" class="profile-public-competitive-agent-portrait" onerror="this.src='/img/default-agent.png'">
            </div>
            <div class="profile-public-competitive-agent-copy">
              <strong>${agentData?.displayName || overview?.primaryAgentLabel || 'Sem agente principal'}</strong>
              <span>${roleLabel}</span>
            </div>
          </div>
          <div class="profile-public-competitive-rank-block">
            <div class="profile-public-competitive-rank-visual">
              ${overview?.mmr?.rankIcon
                ? `<img src="${overview.mmr.rankIcon}" alt="${overview?.mmr?.rankLabel || 'Rank'}" class="profile-public-competitive-rank-icon">`
                : '<i class="fas fa-shield-alt profile-public-competitive-rank-icon fallback"></i>'}
            </div>
            <div class="profile-public-competitive-rank-copy">
              <strong>${overview?.mmr?.rankLabel || '--'}</strong>
              <span>${matchCount} partida${matchCount === '1' ? '' : 's'} no ato</span>
            </div>
          </div>
        </div>
        <div class="profile-public-competitive-metrics">
          ${metrics.map((metric) => `
            <div class="profile-public-competitive-metric ${metric.accentClass || ''}">
              <span>${metric.label}</span>
              <strong>${metric.value}</strong>
            </div>
          `).join('')}
        </div>
      </article>
    `;
  }

  buildPublicCompetitiveMetricEntries(overview, period) {
    const performance = period?.performance || {};
    const detailed = period?.detailedStats || {};
    const scoutingStats = period?.scoutingStats || {};
    const hsValue = detailed?.headPercent ?? Math.round(Number(scoutingStats?.avg_hs || 0));
    const acsValue = detailed?.acs ?? Math.round(Number(scoutingStats?.avg_acs || 0));
    const adrValue = detailed?.adr ?? Math.round(Number(scoutingStats?.avg_adr || 0));

    return [
      { label: 'Match Rank', value: overview?.mmr?.rankLabel || '--', accentClass: 'accent-rank' },
      { label: 'TRS', value: overview?.mmr?.rrLabel || '--', accentClass: 'accent-rank' },
      { label: 'ACS', value: acsValue || '--', accentClass: 'accent-blue' },
      { label: 'K', value: scoutingStats?.kills ?? 0, accentClass: 'accent-green' },
      { label: 'D', value: scoutingStats?.deaths ?? 0, accentClass: 'accent-red' },
      { label: 'A', value: scoutingStats?.assists ?? 0, accentClass: 'accent-gold' },
      { label: '+/-', value: detailed?.plusMinusLabel || '--', accentClass: 'accent-green' },
      { label: 'K/D', value: detailed?.kd || performance?.kdLabel || '--', accentClass: 'accent-blue' },
      { label: 'DDΔ', value: detailed?.deltaPerMatchLabel || '--', accentClass: 'accent-violet' },
      { label: 'ADR', value: adrValue || '--', accentClass: 'accent-red' },
      { label: 'HS%', value: `${hsValue || 0}%`, accentClass: 'accent-gold' },
      { label: 'KAST', value: detailed?.kastLabel || '--', accentClass: 'accent-green' },
      { label: 'FK', value: detailed?.firstKillsTotal ?? 0, accentClass: 'accent-green' },
      { label: 'FD', value: detailed?.firstDeathsTotal ?? 0, accentClass: 'accent-red' },
      { label: 'MK', value: detailed?.multiKillsTotal ?? 0, accentClass: 'accent-violet' }
    ];
  }

  getRolePresentation(roleLabel) {
    const normalized = String(roleLabel || '').trim().toLowerCase();
    const roleMap = {
      duelista: { label: 'Duelista', icon: 'fas fa-bolt' },
      duelists: { label: 'Duelista', icon: 'fas fa-bolt' },
      controlador: { label: 'Controlador', icon: 'fas fa-cloud' },
      controllers: { label: 'Controlador', icon: 'fas fa-cloud' },
      iniciador: { label: 'Iniciador', icon: 'fas fa-bullseye' },
      initiators: { label: 'Iniciador', icon: 'fas fa-bullseye' },
      sentinela: { label: 'Sentinela', icon: 'fas fa-shield-alt' },
      sentinels: { label: 'Sentinela', icon: 'fas fa-shield-alt' }
    };

    return roleMap[normalized] || null;
  }

  escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }


  buildProfileTagline(user, overview) {
    const bioText = String(user?.bio || '')
      .replace(/\s+/g, ' ')
      .trim();

    if (bioText) {
      return bioText.length > 88 ? `${bioText.slice(0, 85).trimEnd()}...` : bioText;
    }

    const roleLabel = overview?.primaryRoleLabel || 'Player competitivo';
    const agentLabel = overview?.primaryAgentLabel || 'pool em construção';
    return `${roleLabel} • ${agentLabel}`;
  }

  buildHeroIdentity(user, overview = null) {
    const teams = user?.teams || auth?.user?.teams || [];
    const currentTeamId = app?.currentTeam?.id;
    const teamEntry = teams.find(t => t.id === currentTeamId) || teams[0];
    const memberRole = teamEntry?.member_role || teamEntry?.role || user?.role || 'player';

    const roleMap = {
      owner: { label: 'Owner', icon: 'fas fa-crown' },
      coach: { label: 'Coach', icon: 'fas fa-chalkboard-teacher' },
      analyst: { label: 'Analyst', icon: 'fas fa-chart-bar' },
      manager: { label: 'Manager', icon: 'fas fa-briefcase' },
      player: { label: 'Player', icon: 'fas fa-crosshairs' },
      super_admin: { label: 'Admin', icon: 'fas fa-shield-alt' }
    };
    const mapped = roleMap[memberRole] || { label: memberRole.charAt(0).toUpperCase() + memberRole.slice(1), icon: 'fas fa-user' };
    const isStaff = ['coach', 'analyst', 'manager', 'owner', 'super_admin'].includes(memberRole);

    const userCountry = user?.country || 'BR';
    const primaryRole = this.getRolePresentation(overview?.primaryRoleLabel);

    return {
      roleLabel: isStaff ? `Staff — ${mapped.label}` : mapped.label,
      roleIconClass: mapped.icon,
      nationalityLabel: countryName(userCountry),
      nationalityFlag: countryCodeToFlag(userCountry),
      nationalityCode: userCountry.toLowerCase(),
      riotIdLabel: user?.riot_id ? `${user.riot_id}${user?.riot_tag ? `#${user.riot_tag}` : ''}` : 'Riot ID não configurado',
      primaryRoleLabel: primaryRole?.label || overview?.primaryRoleLabel || '',
      primaryRoleIconClass: primaryRole?.icon || 'fas fa-shield-alt'
    };
  }

  renderHeroIdentityBadges(identity, user, overview) {
    const tagline = this.buildProfileTagline(user, overview);

    return `
      <div class="profile-player-hero-subline profile-player-identity-line">
        <span>${identity.riotIdLabel}</span>
      </div>
      <div class="profile-player-hero-subline profile-player-hero-tagline">
        <span>${this.escapeHtml(tagline)}</span>
      </div>
      <div class="profile-player-badges profile-player-badges-identity">
        <span class="profile-player-pill profile-player-pill-role">
          <i class="${identity.roleIconClass}"></i>
          <strong>${identity.roleLabel}</strong>
        </span>
        ${identity.primaryRoleLabel ? `
          <span class="profile-player-pill profile-player-pill-role-main">
            <i class="${identity.primaryRoleIconClass}"></i>
            <strong>${identity.primaryRoleLabel}</strong>
          </span>
        ` : ''}
        <span class="profile-player-pill profile-player-pill-nation">
          <img class="profile-player-pill-flag-img" src="https://flagcdn.com/24x18/${identity.nationalityCode}.png" alt="${identity.nationalityLabel}" width="24" height="18">
          <strong>${identity.nationalityLabel}</strong>
        </span>
      </div>
    `;
  }

  renderViewPanels(user, socialLinks, highlightLinks) {
    const overview = this.rankedOverview;
    const scouting = overview?.scouting || {};
    const teams = this.profileTeams || scouting.teams || [];

    return `
      <div class="profile-public-overview-layout profile-public-tab-panel ${this.activeViewTab === 'overview' ? 'is-active' : ''}" id="profilePublicOverviewSection">
        <div class="profile-public-overview-media-row">
          ${this.renderPublicMediaSection(highlightLinks)}
        </div>
        <div class="profile-public-overview-teams-row">
          ${this.renderTeamsHistoryCard(teams)}
        </div>
      </div>
      <div class="profile-public-showcase-grid profile-public-showcase-grid-wide profile-public-tab-panel ${this.activeViewTab === 'form' ? 'is-active' : ''}" id="profilePublicFormSection">
        ${this.renderRecentActivityCard(overview)}
      </div>

    `;
  }

  renderPlayerSignatureCard(overview, teams) {
    const currentTeam = teams.find(team => team.is_active) || teams[0] || null;
    const period = overview?.periods?.act || overview?.periods?.all || {};
    const detailed = period?.detailedStats || {};
    const acsValue = detailed?.acs ?? overview?.scouting?.stats?.avg_acs ?? null;
    const rankedItems = [
      { label: 'Win Rate', value: overview?.performance?.winRateLabel || '--', accent: 'accent-win' },
      { label: 'ACS Medio', value: acsValue !== null ? Number(acsValue).toFixed(0) : '--', accent: 'accent-acs' },
      { label: 'K/D', value: overview?.performance?.kdLabel || '--', accent: 'accent-kd' },
      { label: 'HS%', value: detailed?.headPercent ? `${detailed.headPercent}%` : '--', accent: 'accent-role' }
    ];

    return `
      <article class="profile-public-card profile-public-card-signature">
        <div class="profile-public-card-head">
          <div>
            <span class="profile-public-card-eyebrow">Assinatura Competitiva</span>
            <h3>Leitura rápida do ato atual</h3>
          </div>
          <span class="profile-public-section-badge">${currentTeam?.tag || 'Ranked'}</span>
        </div>
        <div class="profile-ranked-snapshot-grid">
          ${rankedItems.map(item => `
            <div class="profile-ranked-snapshot-item ${item.accent}">
              <span>${item.label}</span>
              <strong>${item.value}</strong>
            </div>
          `).join('')}
        </div>
      </article>
    `;
  }

  renderPublicBioCard(user, overview) {
    const bioText = String(user?.bio || '').trim();
    const tagline = this.buildProfileTagline(user, overview);

    return `
      <article class="profile-public-card profile-public-card-bio">
        <div class="profile-public-card-head">
          <div>
            <span class="profile-public-card-eyebrow">Bio</span>
            <h3>Identidade do player</h3>
          </div>
        </div>
        <p class="profile-public-bio">${this.escapeHtml(bioText || tagline)}</p>
      </article>
    `;
  }

  renderSocialPresenceCard(socialLinks, highlightLinks) {
    return `
      <article class="profile-public-card profile-public-card-presence">
        <div class="profile-public-card-head">
          <div>
            <span class="profile-public-card-eyebrow">Presença</span>
            <h3>Onde acompanhar esse player</h3>
          </div>
        </div>
        <div class="profile-presence-metrics">
          <div class="profile-presence-metric">
            <span>Redes</span>
            <strong>${socialLinks.length}</strong>
          </div>
          <div class="profile-presence-metric">
            <span>Highlights</span>
            <strong>${highlightLinks.length}/1</strong>
          </div>
        </div>
        ${socialLinks.length ? `
          <div class="profile-presence-links">
            ${socialLinks.map(link => `
              <a href="${link.href}" target="_blank" rel="noopener noreferrer" class="profile-player-social-link ${link.key} profile-player-social-card">
                <i class="${link.icon}"></i>
                <span>${link.label}</span>
              </a>
            `).join('')}
          </div>
        ` : `
          <div class="profile-public-empty-state">
            <i class="fas fa-share-nodes"></i>
            <span>Nenhuma rede conectada ainda.</span>
          </div>
        `}
      </article>
    `;
  }

  parseBirthDateParts(birthDate) {
    const normalized = String(birthDate || '').trim();
    const match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) {
      return { day: '', month: '', year: '' };
    }

    return {
      year: match[1],
      month: match[2],
      day: match[3]
    };
  }

  renderBirthDateOptions(type, selectedValue) {
    const normalizedSelected = String(selectedValue || '');
    if (type === 'day') {
      return Array.from({ length: 31 }, (_, index) => {
        const value = String(index + 1).padStart(2, '0');
        return `<option value="${value}" ${normalizedSelected === value ? 'selected' : ''}>${value}</option>`;
      }).join('');
    }

    if (type === 'month') {
      const months = ['Janeiro', 'Fevereiro', 'Marco', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
      return months.map((label, index) => {
        const value = String(index + 1).padStart(2, '0');
        return `<option value="${value}" ${normalizedSelected === value ? 'selected' : ''}>${label}</option>`;
      }).join('');
    }

    const currentYear = new Date().getFullYear();
    const minYear = 1900;
    const options = [];
    for (let year = currentYear; year >= minYear; year -= 1) {
      const value = String(year);
      options.push(`<option value="${value}" ${normalizedSelected === value ? 'selected' : ''}>${value}</option>`);
    }
    return options.join('');
  }

  buildBirthDateValue() {
    const day = document.getElementById('profileBirthDay')?.value || '';
    const month = document.getElementById('profileBirthMonth')?.value || '';
    const year = document.getElementById('profileBirthYear')?.value || '';

    if (!day && !month && !year) {
      return null;
    }

    if (!day || !month || !year) {
      toast.error('Erro', 'Selecione dia, mês e ano completos na data de nascimento');
      return false;
    }

    const isoDate = `${year}-${month}-${day}`;
    const parsed = new Date(`${isoDate}T00:00:00Z`);
    const isValid = parsed.getUTCFullYear() === Number(year)
      && String(parsed.getUTCMonth() + 1).padStart(2, '0') === month
      && String(parsed.getUTCDate()).padStart(2, '0') === day;

    if (!isValid) {
      toast.error('Erro', 'Data de nascimento inválida');
      return false;
    }

    return isoDate;
  }

  /**
   * Editor num card só: avatar, identidade, redes e highlight na mesma
   * superfície, com um único "Salvar alterações" no rodapé. Sem abas,
   * sem três formulários — um form, um submit, um payload por rota.
   */
  renderPublicHero(user, socialLinks, heroIdentity, eyebrow) {
    return `
      <div class="settings-section profile-section-card profile-player-hero profile-player-hero-public">
        <div class="settings-section-body profile-player-hero-body">
          <div class="profile-player-hero-main">
            <div class="settings-avatar-wrapper profile-player-hero-id">
              <div class="profile-player-hero-avatar-column">
                <div class="settings-avatar-box">
                  <img src="${this.escapeHtml(user.avatar_url || '/img/default-avatar.png')}"
                       alt="Avatar" class="settings-avatar-img" id="profileAvatar"
                       onerror="this.src='/img/default-avatar.png'">
                </div>
                ${this.renderHeroSocialIcons(socialLinks)}
              </div>
              <div class="settings-avatar-info profile-player-hero-copy">
                <span class="profile-player-eyebrow">${eyebrow}</span>
                <div class="profile-player-name-row">
                  <h3>${this.escapeHtml(user.display_name || 'Usuário')}</h3>
                  <img
                    src="https://img.freepik.com/psd-premium/verificacao-de-icone-3d_148391-180.jpg?semt=ais_hybrid&w=740&q=80"
                    alt="Verificado"
                    class="profile-player-verified-badge"
                    loading="lazy">
                </div>
                ${this.renderHeroIdentityBadges(heroIdentity, user, this.rankedOverview)}
              </div>
            </div>
          </div>
          ${this.renderViewSectionNav()}
        </div>
      </div>
    `;
  }

  renderEditPanels(user) {
    const rows = this.getSocialRows(user);
    const highlightUrl = user.youtube_highlight_1 || '';

    return `
      <form id="profileForm" class="pf-edit">
        <input type="hidden" id="profileRiotId" value="${this.escapeHtml(user.riot_id || '')}">
        <input type="hidden" id="profileRiotTag" value="${this.escapeHtml(user.riot_tag || '')}">
        <input type="hidden" id="profileRiotCardUrl" value="${this.escapeHtml(user.riot_card_url || '')}">
        <input type="hidden" id="profileHighlight1" value="${this.escapeHtml(highlightUrl)}">

        <header class="pf-head">
          <div class="pf-avatar">
            <img src="${this.escapeHtml(user.avatar_url || '/img/default-avatar.png')}"
                 alt="Avatar" id="profileAvatar" onerror="this.src='/img/default-avatar.png'">
            <label class="pf-avatar-cam" title="Trocar foto">
              <i class="fas fa-camera" aria-hidden="true"></i>
              <span class="sr-only">Trocar foto</span>
              <input type="file" accept="image/*" onchange="profile.uploadAvatar(this)" hidden>
            </label>
          </div>
          <div class="pf-head-copy">
            <span class="pf-eyebrow">Editor de perfil</span>
            <h2>${this.escapeHtml(user.display_name || 'Usuário')}</h2>
            <p>Foto, identidade, redes e highlight — tudo aqui, num salvamento só.</p>
            ${user.avatar_url ? `
              <button type="button" class="pf-link-danger" onclick="profile.clearAvatar()">
                <i class="fas fa-trash-alt" aria-hidden="true"></i> Remover foto
              </button>
            ` : ''}
          </div>
        </header>

        <section class="pf-block">
          <div class="pf-block-head"><h3>Identidade</h3></div>
          <div class="pf-grid">
            <label class="pf-field">
              <span class="pf-label">Nome de exibição</span>
              <span class="pf-input-wrap">
                <i class="fas fa-user" aria-hidden="true"></i>
                <input type="text" id="profileDisplayName" class="pf-input"
                       value="${this.escapeHtml(user.display_name || '')}" placeholder="Seu nome">
              </span>
            </label>

            <label class="pf-field">
              <span class="pf-label">E-mail</span>
              <span class="pf-input-wrap is-locked">
                <i class="fas fa-envelope" aria-hidden="true"></i>
                <input type="email" id="profileEmail" class="pf-input"
                       value="${this.escapeHtml(user.email || '')}" disabled>
              </span>
            </label>

            <label class="pf-field">
              <span class="pf-label">Nacionalidade</span>
              <span class="pf-input-wrap">
                <span class="pf-flag" id="profileCountryFlag">${countryCodeToFlag(user.country || 'BR')}</span>
                <select id="profileCountry" class="pf-input pf-select" onchange="profile.onCountryChange()">
                  ${COUNTRIES.map(c => `<option value="${c.code}" ${(user.country || 'BR') === c.code ? 'selected' : ''}>${this.escapeHtml(c.name)}</option>`).join('')}
                </select>
                <i class="fas fa-chevron-down pf-caret" aria-hidden="true"></i>
              </span>
            </label>

            <label class="pf-field">
              <span class="pf-label">Região</span>
              <span class="pf-input-wrap">
                <i class="fas fa-map-marker-alt" aria-hidden="true"></i>
                <select id="profileRegion" class="pf-input pf-select" onchange="profile.onRegionChange()">
                  <option value="" ${!user.region ? 'selected' : ''}>Selecione</option>
                  <option value="america-sul" ${user.region === 'america-sul' ? 'selected' : ''}>América do Sul</option>
                  <option value="america-norte" ${user.region === 'america-norte' ? 'selected' : ''}>América do Norte</option>
                  <option value="europa" ${user.region === 'europa' ? 'selected' : ''}>Europa</option>
                  <option value="asia" ${user.region === 'asia' ? 'selected' : ''}>Ásia</option>
                  <option value="oceania" ${user.region === 'oceania' ? 'selected' : ''}>Oceania</option>
                  <option value="africa" ${user.region === 'africa' ? 'selected' : ''}>África</option>
                  <option value="oriente-medio" ${user.region === 'oriente-medio' ? 'selected' : ''}>Oriente Médio</option>
                </select>
                <i class="fas fa-chevron-down pf-caret" aria-hidden="true"></i>
              </span>
            </label>

            <label class="pf-field pf-field--full">
              <span class="pf-label">Bio</span>
              <textarea id="profileBio" class="pf-input pf-textarea" rows="3" maxlength="200"
                        placeholder="Conte um pouco sobre você…">${this.escapeHtml(user.bio || '')}</textarea>
              <span class="pf-counter" data-bio-counter>${(user.bio || '').length}/200</span>
            </label>
          </div>
        </section>

        <section class="pf-block">
          <div class="pf-block-head">
            <h3>Redes</h3>
            <button type="button" class="pf-btn pf-btn--ghost" onclick="profile.addSocialRow()">
              <i class="fas fa-plus" aria-hidden="true"></i> Adicionar rede
            </button>
          </div>
          <div class="pf-social-list" id="profileSocialList">
            ${rows.length
              ? rows.map((row, i) => this.renderSocialRow(row.key, row.value, i)).join('')
              : this.renderSocialRow('', '', 0)}
          </div>
        </section>

        <section class="pf-block">
          <div class="pf-block-head">
            <h3>Highlight</h3>
            <div class="pf-block-actions">
              <button type="button" class="pf-btn pf-btn--ghost" onclick="profile.promptHighlightVideo()">
                <i class="fas fa-pen" aria-hidden="true"></i> <span id="profileHighlightCta">${highlightUrl ? 'Trocar vídeo' : 'Adicionar vídeo'}</span>
              </button>
              <button type="button" class="pf-icon-btn pf-icon-btn--danger" title="Remover vídeo"
                      id="profileHighlightRemove" aria-label="Remover vídeo"
                      onclick="profile.clearHighlightVideo()" ${highlightUrl ? '' : 'hidden'}>
                <i class="fas fa-trash" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="pf-highlight" id="profileHighlightPreview">
            ${this.renderHighlightPreviewCard(highlightUrl, 1)}
          </div>
        </section>

        <footer class="pf-foot">
          <button type="submit" class="pf-btn pf-btn--primary">
            <i class="fas fa-check" aria-hidden="true"></i> Salvar alterações
          </button>
        </footer>
      </form>
    `;
  }

  renderSocialRow(key, value, index) {
    const net = Profile.SOCIAL_NETWORKS.find(n => n.key === key) || null;
    return `
      <div class="pf-social-row" data-social-row data-row-index="${index}">
        <span class="pf-social-pick">
          <span class="pf-social-icon" data-social-icon style="${net ? `color:${net.color}` : ''}">
            <i class="${net ? net.icon : 'fas fa-share-nodes'}" aria-hidden="true"></i>
          </span>
          <select class="pf-input pf-select" data-social-key aria-label="Rede social"
                  onchange="profile.onSocialNetworkChange(this)">
            <option value="" ${!key ? 'selected' : ''}>Selecione a rede</option>
            ${Profile.SOCIAL_NETWORKS.map(n => `
              <option value="${n.key}" ${key === n.key ? 'selected' : ''}>${n.label}</option>
            `).join('')}
          </select>
          <i class="fas fa-chevron-down pf-caret" aria-hidden="true"></i>
        </span>

        <span class="pf-input-wrap pf-social-url">
          <i class="fas fa-link" aria-hidden="true"></i>
          <input type="text" class="pf-input" data-social-url
                 value="${this.escapeHtml(value || '')}"
                 placeholder="${net ? this.escapeHtml(net.placeholder) : 'https://…'}">
        </span>

        <button type="button" class="pf-icon-btn pf-icon-btn--danger" title="Remover"
                aria-label="Remover rede" onclick="profile.removeSocialRow(this)">
          <i class="fas fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    `;
  }

  getSocialLinks(user) {
    return [
      user?.twitch_username ? { key: 'twitch', icon: 'fab fa-twitch', label: 'Twitch', href: `https://twitch.tv/${user.twitch_username}` } : null,
      user?.twitter_url ? { key: 'twitter', icon: 'fab fa-twitter', label: 'Twitter / X', href: user.twitter_url } : null,
      user?.instagram_url ? { key: 'instagram', icon: 'fab fa-instagram', label: 'Instagram', href: user.instagram_url } : null,
      user?.tiktok_url ? { key: 'tiktok', icon: 'fab fa-tiktok', label: 'TikTok', href: user.tiktok_url } : null,
      user?.youtube_url ? { key: 'youtube', icon: 'fab fa-youtube', label: 'YouTube', href: user.youtube_url } : null,
      user?.facebook_url ? { key: 'facebook', icon: 'fab fa-facebook', label: 'Facebook', href: user.facebook_url } : null
    ].filter(Boolean);
  }

  getHighlightLinks(user) {
    return [user?.youtube_highlight_1].filter(Boolean);
  }

  renderQuickSocialLinks(links) {
    if (!links.length) {
      return `<span class="profile-player-empty-social">Conecte suas redes para exibir seu menu social.</span>`;
    }

    return links.map(link => `
      <a href="${link.href}" target="_blank" rel="noopener noreferrer" class="profile-player-social-link ${link.key}">
        <i class="${link.icon}"></i>
        <span>${link.label}</span>
      </a>
    `).join('');
  }

  renderHeroSocialIcons(links) {
    if (!links.length) {
      return '';
    }

    return `
      <div class="profile-player-avatar-socials">
        ${links.map(link => `
          <a href="${this.escapeHtml(link.href)}" target="_blank" rel="noopener noreferrer" class="profile-player-avatar-social ${link.key}" aria-label="${link.label}" title="${link.label}">
            <i class="${link.icon}"></i>
          </a>
        `).join('')}
      </div>
    `;
  }

  renderHighlightPreviewCard(url, index) {
    if (!url) {
      return `
        <div class="profile-highlight-preview is-empty">
          <i class="fab fa-youtube"></i>
          <span>Adicione um link para exibir a media ${index}</span>
        </div>
      `;
    }

    if (!this.isSupportedMediaLink(url)) {
      return `
        <div class="profile-highlight-preview is-invalid">
          <i class="fas fa-exclamation-triangle"></i>
          <span>Link invalido. Use YouTube, X, Instagram, Facebook ou video direto.</span>
        </div>
      `;
    }

    return `
      <div class="profile-highlight-preview">
        ${this.renderMediaEmbedHtml(url, index)}
      </div>
    `;
  }

  renderMediaEmbedHtml(url, index) {
    if (!url) return '';

    const normalizedUrl = String(url).trim();
    const yt = this.extractYouTubeVideoId(normalizedUrl);
    if (yt) {
      return `<iframe src="https://www.youtube.com/embed/${yt}?rel=0&modestbranding=1" title="Media ${index}" loading="lazy" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen class="lu-player-iframe"></iframe>`;
    }

    const tw = normalizedUrl.match(/(?:twitter\.com|x\.com)\/\w+\/status\/(\d+)/i);
    if (tw) {
      return `<div class="lu-tiktok-wrap profile-media-stream-wrap" data-profile-media-url="${normalizedUrl}">
        <div class="lu-tiktok-loading"><i class="fas fa-spinner fa-spin"></i> Carregando video...</div>
      </div>`;
    }

    const ig = normalizedUrl.match(/instagram\.com\/(?:reels?|p)\/([\w-]+)/i);
    if (ig) {
      const embedUrl = `https://www.instagram.com/reel/${ig[1]}/embed/`;
      const postUrl = `https://www.instagram.com/reel/${ig[1]}/`;
      return `<div class="lu-ig-wrap profile-ig-wrap" data-ig-src="${embedUrl}" data-ig-post="${postUrl}">
        <iframe src="${embedUrl}" frameborder="0" loading="lazy" sandbox="allow-scripts allow-same-origin allow-presentation" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" scrolling="no" class="lu-player-iframe lu-ig-player"></iframe>
        <div class="lu-ig-replay-overlay lu-ig-hidden">
          <i class="fas fa-redo-alt"></i>
          <span>Clique para repetir</span>
        </div>
        <div class="lu-ig-controls">
          <div class="lu-ig-ctrl-spacer"></div>
          <a class="lu-ig-ctrl-btn lu-ig-open" href="${postUrl}" target="_blank" rel="noopener noreferrer" title="Abrir no Instagram">
            <i class="fab fa-instagram"></i>
          </a>
          <button type="button" class="lu-ig-ctrl-btn profile-ig-reload" title="Repetir video">
            <i class="fas fa-redo-alt"></i>
          </button>
        </div>
      </div>`;
    }

    if (/(?:facebook\.com|fb\.watch)/i.test(normalizedUrl)) {
      const plugin = /(watch\?v=|\/videos\/|\/reel\/|fb\.watch)/i.test(normalizedUrl) ? 'video.php' : 'post.php';
      const query = plugin === 'video.php'
        ? `href=${encodeURIComponent(normalizedUrl)}&show_text=false&width=500`
        : `href=${encodeURIComponent(normalizedUrl)}&show_text=false&width=500`;
      return `<iframe src="https://www.facebook.com/plugins/${plugin}?${query}" title="Media ${index}" loading="lazy" frameborder="0" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowfullscreen class="lu-player-iframe"></iframe>`;
    }

    if (normalizedUrl.match(/\.(mp4|webm|ogg|mov)($|\?)/i) || normalizedUrl.includes('r2.') || normalizedUrl.includes('/uploads/')) {
      return `<video src="${normalizedUrl}" controls playsinline class="lu-player-video"></video>`;
    }

    return `<iframe src="${normalizedUrl}" title="Media ${index}" loading="lazy" frameborder="0" allowfullscreen class="lu-player-iframe"></iframe>`;
  }

  initProfileMediaEmbeds(root = document) {
    root.querySelectorAll('.profile-media-stream-wrap[data-profile-media-url]').forEach((wrap) => {
      const url = wrap.dataset.profileMediaUrl;
      if (!url || wrap.dataset.loaded === 'true') return;
      const streamUrl = `/api/video-stream?url=${encodeURIComponent(url)}`;
      wrap.innerHTML = `<video src="${streamUrl}" controls playsinline class="lu-player-video lu-tiktok-video"></video>`;
      wrap.dataset.loaded = 'true';
    });

    this.schedulePublicMediaCardSync(root);

    root.querySelectorAll('.profile-ig-wrap').forEach((wrap) => {
      if (wrap.dataset.initialized === 'true') return;
      wrap.dataset.initialized = 'true';

      const iframe = wrap.querySelector('iframe');
      const overlay = wrap.querySelector('.lu-ig-replay-overlay');
      const reloadBtn = wrap.querySelector('.profile-ig-reload');
      if (!iframe) return;

      if (reloadBtn) {
        reloadBtn.addEventListener('click', () => {
          iframe.src = wrap.dataset.igSrc;
          overlay?.classList.add('lu-ig-hidden');
        });
      }

      overlay?.addEventListener('click', () => {
        iframe.src = wrap.dataset.igSrc;
        overlay.classList.add('lu-ig-hidden');
      });
    });
  }

  isSupportedMediaLink(url) {
    if (!url) return false;
    return /youtube\.com|youtu\.be|twitter\.com|x\.com|instagram\.com\/(?:reels?|p)\/|facebook\.com|fb\.watch|\.mp4$|\.webm$|\.ogg$|\.mov$/i.test(String(url).trim());
  }

  extractYouTubeVideoId(url) {
    if (!url) return null;
    const normalizedUrl = String(url).trim();
    const patterns = [
      /(?:youtube\.com\/watch\?v=)([\w-]{11})/i,
      /(?:youtu\.be\/)([\w-]{11})/i,
      /(?:youtube\.com\/embed\/)([\w-]{11})/i,
      /(?:youtube\.com\/shorts\/)([\w-]{11})/i
    ];

    for (const pattern of patterns) {
      const match = normalizedUrl.match(pattern);
      if (match?.[1]) {
        return match[1];
      }
    }

    return null;
  }

  switchViewTab(tabId) {
    if (!['overview'].includes(tabId)) {
      return;
    }

    this.activeViewTab = tabId;
    this.pushRouteState();
    this.render();
  }

  syncRankedAutoRefresh() {
    if (this.rankedAutoRefreshTimer) {
      clearInterval(this.rankedAutoRefreshTimer);
      this.rankedAutoRefreshTimer = null;
    }

    const user = this.user || auth.user || {};
    const shouldRefresh = this.mode === 'view'
      && this.activeViewTab === 'overview'
      && app?.currentPage === 'profile'
      && user?.riot_id
      && user?.riot_tag;

    if (!shouldRefresh) {
      return;
    }

    this.rankedAutoRefreshTimer = setInterval(() => {
      if (this.rankedLoading || this.mode !== 'view' || this.activeViewTab !== 'overview' || app?.currentPage !== 'profile') {
        return;
      }

      this.loadRankedOverview(true);
    }, this.rankedAutoRefreshMs);
  }

  withRequestTimeout(promise, timeoutMs, timeoutMessage) {
    return Promise.race([
      promise,
      new Promise((_, reject) => {
        setTimeout(() => reject(new Error(timeoutMessage)), timeoutMs);
      })
    ]);
  }

  onCountryChange() {
    const sel = document.getElementById('profileCountry');
    const preview = document.querySelector('.profile-country-flag-preview');
    if (sel && preview) preview.textContent = countryCodeToFlag(sel.value);
    this.syncPhoneDialCode();
  }

  getCountryDialCode(countryCode) {
    const normalizedCode = String(countryCode || '').trim().toUpperCase();
    return COUNTRY_DIAL_CODE_FALLBACKS[normalizedCode] || COUNTRY_DIAL_CODE_FALLBACKS.BR;
  }

  normalizeValorantRegion(region) {
    const normalized = String(region || '').trim().toLowerCase();
    const regionMap = {
      'america-sul': 'br',
      'america-norte': 'na',
      europa: 'eu',
      asia: 'ap',
      oceania: 'ap',
      africa: 'eu',
      'oriente-medio': 'eu',
      br: 'br',
      na: 'na',
      eu: 'eu',
      ap: 'ap',
      kr: 'kr',
      latam: 'latam'
    };

    return regionMap[normalized] || 'br';
  }

  parsePhoneValue(phone, fallbackCountryCode = 'BR') {
    const fallbackDialCode = this.getCountryDialCode(fallbackCountryCode);
    const normalizedPhone = String(phone || '').trim();

    if (!normalizedPhone) {
      return {
        dialCode: fallbackDialCode,
        localNumber: ''
      };
    }

    if (!normalizedPhone.startsWith('+')) {
      return {
        dialCode: fallbackDialCode,
        localNumber: normalizedPhone
      };
    }

    const matchedDialCode = PHONE_DIAL_CODES_DESC.find((dialCode) => (
      normalizedPhone === dialCode || normalizedPhone.startsWith(`${dialCode} `) || normalizedPhone.startsWith(dialCode)
    )) || fallbackDialCode;

    return {
      dialCode: matchedDialCode,
      localNumber: normalizedPhone.slice(matchedDialCode.length).trimStart()
    };
  }

  renderPhoneDialCodeOptions(selectedDialCode) {
    return ALL_PHONE_DIAL_CODES.map((dialCode) => (
      `<option value="${dialCode}" ${selectedDialCode === dialCode ? 'selected' : ''}>${dialCode}</option>`
    )).join('');
  }

  onPhoneDialCodeChange() {}

  syncPhoneDialCode() {
    const countryEl = document.getElementById('profileCountry');
    const dialCodeEl = document.getElementById('profilePhoneDialCode');
    const phoneEl = document.getElementById('profilePhone');
    if (!countryEl || !dialCodeEl || !phoneEl) return;

    dialCodeEl.value = this.getCountryDialCode(countryEl.value || 'BR');
    phoneEl.placeholder = '11 99999-9999';
  }

  onRegionChange() {
    const regionEl = document.getElementById('profileRegion');
    const tzEl = document.getElementById('profileTimezone');
    if (!regionEl || !tzEl) return;
    const regionTzMap = {
      'america-sul': 'America/Sao_Paulo',
      'america-norte': 'America/New_York',
      'europa': 'Europe/London',
      'asia': 'Asia/Tokyo',
      'oceania': 'Australia/Sydney',
      'africa': 'Africa/Johannesburg',
      'oriente-medio': 'Asia/Dubai'
    };
    const suggested = regionTzMap[regionEl.value];
    if (suggested) tzEl.value = suggested;
  }

  renderTimezoneOptions(currentTz) {
    const detected = currentTz || Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Sao_Paulo';
    const timezones = [
      { value: 'America/Sao_Paulo', label: '(UTC-3) Brasília' },
      { value: 'America/Manaus', label: '(UTC-4) Manaus' },
      { value: 'America/Rio_Branco', label: '(UTC-5) Rio Branco' },
      { value: 'America/Noronha', label: '(UTC-2) Fernando de Noronha' },
      { value: 'America/New_York', label: '(UTC-5) Nova York' },
      { value: 'America/Chicago', label: '(UTC-6) Chicago' },
      { value: 'America/Denver', label: '(UTC-7) Denver' },
      { value: 'America/Los_Angeles', label: '(UTC-8) Los Angeles' },
      { value: 'America/Argentina/Buenos_Aires', label: '(UTC-3) Buenos Aires' },
      { value: 'America/Santiago', label: '(UTC-4) Santiago' },
      { value: 'America/Bogota', label: '(UTC-5) Bogotá' },
      { value: 'America/Mexico_City', label: '(UTC-6) Cidade do México' },
      { value: 'America/Toronto', label: '(UTC-5) Toronto' },
      { value: 'Europe/London', label: '(UTC+0) Londres' },
      { value: 'Europe/Paris', label: '(UTC+1) Paris' },
      { value: 'Europe/Berlin', label: '(UTC+1) Berlim' },
      { value: 'Europe/Madrid', label: '(UTC+1) Madri' },
      { value: 'Europe/Lisbon', label: '(UTC+0) Lisboa' },
      { value: 'Europe/Moscow', label: '(UTC+3) Moscou' },
      { value: 'Asia/Tokyo', label: '(UTC+9) Tóquio' },
      { value: 'Asia/Seoul', label: '(UTC+9) Seul' },
      { value: 'Asia/Shanghai', label: '(UTC+8) Xangai' },
      { value: 'Asia/Dubai', label: '(UTC+4) Dubai' },
      { value: 'Asia/Kolkata', label: '(UTC+5:30) Mumbai' },
      { value: 'Asia/Singapore', label: '(UTC+8) Singapura' },
      { value: 'Australia/Sydney', label: '(UTC+11) Sydney' },
      { value: 'Pacific/Auckland', label: '(UTC+13) Auckland' },
      { value: 'Africa/Johannesburg', label: '(UTC+2) Joanesburgo' },
      { value: 'Africa/Lagos', label: '(UTC+1) Lagos' }
    ];
    return timezones.map(tz =>
      `<option value="${tz.value}" ${detected === tz.value ? 'selected' : ''}>${tz.label}</option>`
    ).join('');
  }

  scrollToViewSection(sectionId) {
    const element = document.getElementById(sectionId);
    if (!element) return;
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  buildPublicHeroStats(user, overview) {
    const performance = overview?.performance || {};
    const scouting = overview?.scouting || {};
    const scoutingStats = scouting.stats || {};

    return [
      {
        label: 'Rank Atual',
        value: overview?.mmr?.rankLabel || '--',
        icon: 'fas fa-trophy',
        accentClass: 'accent-rank',
        imageUrl: overview?.mmr?.rankIcon || ''
      },
      {
        label: 'Win Rate',
        value: performance.winRateLabel || '--',
        icon: 'fas fa-percentage',
        accentClass: 'accent-win'
      },
      {
        label: 'ACS Médio',
        value: scoutingStats.avg_acs ? Number(scoutingStats.avg_acs).toFixed(0) : '--',
        icon: 'fas fa-bolt',
        accentClass: 'accent-rr'
      },
      {
        label: 'K/D',
        value: performance.kdLabel || '--',
        icon: 'fas fa-crosshairs',
        accentClass: 'accent-kd'
      },
      {
        label: 'Matches',
        value: performance.matchesLabel || '--',
        icon: 'fas fa-list',
        accentClass: 'accent-matches'
      },
      {
        label: 'Scout Rank',
        value: user?.scouting_rank ? `#${user.scouting_rank}` : '--',
        icon: 'fas fa-binoculars',
        accentClass: 'accent-scout'
      }
    ];
  }

  renderPublicKpiCard(stat) {
    return `
      <div class="profile-ranked-stat-card profile-public-kpi-card ${stat.accentClass || ''}">
        <div class="profile-ranked-stat-icon">
          ${stat.imageUrl ? `<img src="${stat.imageUrl}" alt="${stat.label}">` : `<i class="${stat.icon}"></i>`}
        </div>
        <div>
          <span class="profile-ranked-stat-label">${stat.label}</span>
          <strong class="profile-ranked-stat-value">${stat.value}</strong>
        </div>
      </div>
    `;
  }

  renderAgentPoolCard(topAgents = []) {

    return `
      <article class="profile-public-card profile-public-card-showcase">
        <div class="profile-public-card-head">
          <div>
            <span class="profile-public-card-eyebrow">Agent Pool</span>
            <h3>Agentes mais usados</h3>
          </div>
          <span class="profile-public-section-badge">${topAgents.length}</span>
        </div>
        ${topAgents.length ? `
          <div class="profile-public-agent-list">
            ${topAgents.map((agent, index) => this.renderAgentPoolItem(agent, index)).join('')}
          </div>
        ` : `
          <div class="profile-public-empty-state large">
            <i class="fas fa-user-ninja"></i>
            <span>Sem partidas suficientes para identificar agent pool.</span>
          </div>
        `}
      </article>
    `;
  }

  renderAgentPoolItem(agentData, index) {
    const agent = this.valorantAssets.agents?.[agentData.agent] || null;
    const agentName = agent?.displayName || this.capitalizeFirst(agentData.agent);
    const roleLabel = agent?.role?.displayName || 'Sem função';
    const icon = agent?.displayIcon || `/img/agents/${agentData.agent}.png`;

    return `
      <div class="profile-public-agent-item ${index === 0 ? 'is-primary' : ''}">
        <div class="profile-public-agent-rank">${index + 1}</div>
        <img src="${icon}" alt="${agentName}" class="profile-public-agent-icon" onerror="this.src='/img/default-agent.png'">
        <div class="profile-public-agent-meta">
          <strong>${agentName}</strong>
          <span>${roleLabel}</span>
        </div>
        <div class="profile-public-agent-usage">
          <strong>${agentData.percentage}%</strong>
          <span>${agentData.count} jogo${agentData.count === 1 ? '' : 's'}</span>
        </div>
      </div>
    `;
  }

  renderMapPoolCard(mapPool = []) {

    return `
      <article class="profile-public-card profile-public-card-showcase">
        <div class="profile-public-card-head">
          <div>
            <span class="profile-public-card-eyebrow">Map Pool</span>
            <h3>Mapas mais jogados</h3>
          </div>
          <span class="profile-public-section-badge">${mapPool.length}</span>
        </div>
        ${mapPool.length ? `
          <div class="profile-public-map-list">
            ${mapPool.map(map => this.renderMapPoolItem(map)).join('')}
          </div>
        ` : `
          <div class="profile-public-empty-state large">
            <i class="fas fa-map-marked-alt"></i>
            <span>Sem dados suficientes para destacar o map pool.</span>
          </div>
        `}
      </article>
    `;
  }

  renderMapPoolItem(mapData) {
    return `
      <div class="profile-public-map-item">
        <div class="profile-public-map-visual" ${mapData.image ? `style="background-image:url('${mapData.image}')"` : ''}></div>
        <div class="profile-public-map-meta">
          <strong>${mapData.name}</strong>
          <span>${mapData.games} jogo${mapData.games === 1 ? '' : 's'} • ${mapData.wins} vitória${mapData.wins === 1 ? '' : 's'}</span>
        </div>
        <div class="profile-public-map-usage ${mapData.winRate >= 50 ? 'positive' : ''}">
          <strong>${mapData.winRate}%</strong>
          <span>WR</span>
        </div>
      </div>
    `;
  }

  renderRecentActivityCard(overview) {
    const recentMatches = overview?.recentMatches || [];

    return `
      <article class="profile-public-card profile-public-card-showcase">
        <div class="profile-public-card-head">
          <div>
            <span class="profile-public-card-eyebrow">Atividade Recente</span>
            <h3>Últimas competitivas</h3>
          </div>
          <span class="profile-public-section-badge">${recentMatches.length}</span>
        </div>
        ${recentMatches.length ? `
          <div class="profile-public-recent-list">
            ${recentMatches.map(match => this.renderRecentMatchItem(match)).join('')}
          </div>
        ` : `
          <div class="profile-public-empty-state large">
            <i class="fas fa-clock-rotate-left"></i>
            <span>Nenhuma partida recente encontrada.</span>
          </div>
        `}
      </article>
    `;
  }

  renderRecentMatchItem(match) {
    return `
      <div class="profile-public-recent-item ${match.resultClass}">
        <div class="profile-public-recent-topline">
          <span class="profile-public-recent-result">${match.resultLabel}</span>
          <span class="profile-public-recent-date">${match.dateLabel}</span>
        </div>
        <div class="profile-public-recent-main">
          <div>
            <strong>${match.mapName}</strong>
            <span>${match.agentName}</span>
          </div>
          <div class="profile-public-recent-score">
            <strong>${match.kdaLabel}</strong>
            <span>ACS ${match.acs}</span>
          </div>
        </div>
      </div>
    `;
  }

  renderTeamsHistoryCard(teams) {
    const currentTeam = teams.find(team => team.is_active);
    const previousTeams = teams.filter(team => !team.is_active);

    return `
      <article class="profile-public-card profile-public-card-showcase profile-public-card-teams">
        <div class="profile-public-card-head">
          <div>
            <span class="profile-public-card-eyebrow">Times</span>
            <h3>Time atual e historico</h3>
          </div>
          <span class="profile-public-section-badge">${teams.length}</span>
        </div>
        ${teams.length ? `
          <div class="profile-public-team-list">
            ${currentTeam ? this.renderTeamHistoryItem(currentTeam, true) : ''}
            ${previousTeams.map(team => this.renderTeamHistoryItem(team, false)).join('')}
          </div>
        ` : `
          <div class="profile-public-empty-state large">
            <i class="fas fa-users"></i>
            <span>Nenhum time vinculado ao player.</span>
          </div>
        `}
      </article>
    `;
  }

  renderTeamHistoryItem(team, isCurrentTeam = false) {
    const statusLabel = isCurrentTeam ? 'Atual' : 'Anterior';
    const statusClass = isCurrentTeam ? 'is-current' : 'is-previous';
    const dateLabel = isCurrentTeam
      ? `Entrou em ${this.formatProfileDate(team.joined_at)}`
      : `Saiu em ${this.formatProfileDate(team.left_at || team.joined_at)}`;

    return `
      <div class="profile-public-team-item ${statusClass}">
        <img src="${team.logo_url || '/img/default-team.png'}" alt="${team.name}" class="profile-public-team-logo" onerror="this.src='/img/default-team.png'">
        <div class="profile-public-team-meta">
          <strong>${team.name}</strong>
          <span>${team.tag ? `${team.tag} • ` : ''}${team.role || 'player'}</span>
          <span class="profile-public-team-date">${dateLabel}</span>
        </div>
        <span class="profile-public-team-status ${statusClass}">${statusLabel}</span>
      </div>
    `;
  }

  formatTeamLabel(team) {
    if (!team) return 'Sem time';
    return team.tag ? `${team.name} (${team.tag})` : team.name;
  }

  formatProfileDate(value) {
    if (!value) return '--';

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '--';

    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(date);
  }

  syncProfileTabVisibility() {
    document.querySelectorAll('[data-view-tab]').forEach(panel => {
      panel.classList.toggle('active', panel.dataset.viewTab === this.activeViewTab && this.mode === 'view');
    });

    document.querySelectorAll('.profile-view-menu [data-tab-id]').forEach(button => {
      button.classList.toggle('active', button.dataset.tabId === this.activeViewTab);
    });
  }

  renderRankedPanel(user) {
    if (!user?.riot_id || !user?.riot_tag) {
      return `
        <div class="profile-ranked-empty-state">
          <div class="empty-icon"><i class="fas fa-gamepad"></i></div>
          <h3>Configure seu Riot ID</h3>
          <p>Defina Riot ID e Tag na aba Perfil para liberar o card de Ranked e o perfil de scouting.</p>
          <button type="button" class="btn btn-primary" onclick="profile.setMode('edit')">
            <i class="fas fa-user-edit"></i> Ir para Perfil
          </button>
        </div>
      `;
    }

    if (this.rankedLoading && !this.rankedOverview) {
      return `
        <div class="profile-ranked-loading">
          <div class="spinner"></div>
          <span>Carregando perfil de ranked e scouting...</span>
        </div>
      `;
    }

    if (this.rankedError) {
      return `
        <div class="profile-ranked-empty-state error">
          <div class="empty-icon"><i class="fas fa-exclamation-triangle"></i></div>
          <h3>Erro ao carregar Ranked</h3>
          <p>${this.rankedError}</p>
          <button type="button" class="btn btn-primary" onclick="profile.loadRankedOverview(true)">
            <i class="fas fa-rotate-right"></i> Tentar novamente
          </button>
        </div>
      `;
    }

    if (!this.rankedOverview) {
      return `
        <div class="profile-ranked-loading idle">
          <i class="fas fa-medal"></i>
          <span>Abra esta aba para carregar o perfil de ranked e scouting.</span>
        </div>
      `;
    }

    const overview = this.rankedOverview;
    const mmr = overview.mmr || {};
    const periodKey = this.rankedPeriod === 'all' ? 'all' : 'act';
    const periodData = overview.periods?.[periodKey] || overview.periods?.act || overview.periods?.all || {};
    const performance = periodData.performance || overview.performance || {};
    const scoutingStats = periodData.scoutingStats || overview.scouting?.stats || {};
    const currentActLabel = overview.currentActLabel || 'EP11 Ato 2';
    const currentActCompactLabel = this.getCompactActLabel(overview.currentActShort, currentActLabel);
    const allActsLabel = overview.allActsLabel || 'Todos os atos';
    const selectedPeriodLabel = periodData.label || (periodKey === 'all' ? allActsLabel : currentActLabel);

    return `
      <div class="profile-ranked-overview">
        <div class="profile-ranked-period-bar">
          <div class="profile-ranked-period-switcher ${this.rankedPeriodDropdownOpen ? 'menu-open' : ''}" id="profileRankedPeriodDropdown">
            <button class="profile-ranked-period-pill ${periodKey === 'all' ? 'is-active' : ''}" type="button" onclick="profile.selectRankedPeriod('all')">
              <span>${allActsLabel}</span>
            </button>
            <button class="profile-ranked-period-pill ${periodKey === 'act' ? 'is-active' : ''}" type="button" onclick="profile.selectRankedPeriod('act')">
              <span>${currentActCompactLabel}</span>
            </button>
            <button class="profile-ranked-period-menu-btn ${this.rankedPeriodDropdownOpen ? 'is-active' : ''}" type="button" onclick="profile.toggleRankedPeriodDropdown(event)" aria-label="Abrir opções de período" aria-expanded="${this.rankedPeriodDropdownOpen ? 'true' : 'false'}">
              <i class="fas fa-ellipsis-v"></i>
            </button>
            <div class="period-dropdown-menu profile-ranked-period-menu">
              <div class="period-dropdown-item ${periodKey === 'act' ? 'active' : ''}" data-period="act" onclick="profile.selectRankedPeriod('act')">
                <i class="fas fa-shield-alt"></i> ${currentActLabel}
              </div>
              <div class="period-dropdown-item ${periodKey === 'all' ? 'active' : ''}" data-period="all" onclick="profile.selectRankedPeriod('all')">
                <i class="fas fa-globe"></i> ${allActsLabel}
              </div>
            </div>
          </div>
        </div>
        ${this.renderRankedOverviewSection(mmr, performance, scoutingStats, periodData.detailedStats)}
      </div>
    `;
  }

  toggleRankedPeriodDropdown(event) {
    if (event) {
      event.stopPropagation();
    }
    this.rankedPeriodDropdownOpen = !this.rankedPeriodDropdownOpen;
    this.refreshRankedPanel();
  }

  selectRankedPeriod(period) {
    this.rankedPeriod = period === 'all' ? 'all' : 'act';
    this.rankedPeriodDropdownOpen = false;
    this.refreshRankedPanel();
  }

  getCompactActLabel(shortCode, fallbackLabel) {
    const normalizedShortCode = String(shortCode || '').toLowerCase();
    const shortMatch = normalizedShortCode.match(/e(\d+)a(\d+)/);
    if (shortMatch) {
      return `EP${shortMatch[1]}: A${shortMatch[2]}`;
    }

    const normalizedFallback = String(fallbackLabel || 'Ato atual');
    const fallbackMatch = normalizedFallback.match(/EP\s*(\d+)\s*Ato\s*(\d+)/i);
    if (fallbackMatch) {
      return `EP${fallbackMatch[1]}: A${fallbackMatch[2]}`;
    }

    return normalizedFallback;
  }

  renderWeaponsPrecisionCard(precision, weapons = []) {
    const data = precision || { headPercent: 0, bodyPercent: 0, legPercent: 0, totalShots: 0 };
    const headOpacity = Math.max(0.22, Math.min(0.95, data.headPercent / 100));
    const bodyOpacity = Math.max(0.22, Math.min(0.95, data.bodyPercent / 100));
    const legOpacity = Math.max(0.18, Math.min(0.8, data.legPercent / 100));

    return `
      <article class="profile-public-card profile-ranked-weapons-precision-card">
        <div class="profile-public-card-head">
          <div>
            <span class="profile-public-card-eyebrow">Armas e Precisão</span>
            <h3>Distribuição geral e impacto por arma</h3>
          </div>
          <span class="profile-public-section-badge">${data.totalShots || 0} tiros</span>
        </div>
        <div class="profile-ranked-precision-layout profile-ranked-precision-layout-combined">
          <div class="profile-ranked-precision-figure-wrap">
            <div class="profile-ranked-precision-stage" aria-hidden="true">
              <span class="profile-ranked-precision-ring ring-1"></span>
              <span class="profile-ranked-precision-ring ring-2"></span>
              <span class="profile-ranked-precision-ring ring-3"></span>
            </div>
            <div class="profile-ranked-precision-marker head">
              <span>Cabeça</span>
              <strong>${data.headPercent}%</strong>
            </div>
            <div class="profile-ranked-precision-marker body">
              <span>Corpo</span>
              <strong>${data.bodyPercent}%</strong>
            </div>
            <div class="profile-ranked-precision-marker legs">
              <span>Pernas</span>
              <strong>${data.legPercent}%</strong>
            </div>
            <div class="profile-ranked-precision-figure" aria-hidden="true">
              <svg viewBox="0 0 180 320" class="profile-ranked-precision-silhouette" role="presentation">
                <defs>
                  <linearGradient id="precisionBodyGlow" x1="0" x2="0" y1="0" y2="1">
                    <stop offset="0%" stop-color="rgba(255,255,255,0.16)" />
                    <stop offset="100%" stop-color="rgba(255,255,255,0.08)" />
                  </linearGradient>
                </defs>
                <circle class="precision-base head-base" cx="90" cy="42" r="24"></circle>
                <path class="precision-base torso-base" d="M71 72 C78 58,102 58,109 72 L122 142 C125 156,117 168,104 170 L101 212 L115 286 C117 297,111 304,101 304 L90 304 C81 304,76 297,78 287 L85 220 L95 220 L102 287 C104 297,99 304,89 304 L78 304 C68 304,62 297,64 286 L78 212 L75 170 C62 168,54 156,57 142 Z"></path>
                <path class="precision-base arm-left-base" d="M67 94 L36 134 C29 142,31 154,42 158 L50 161 C58 164,65 161,69 154 L81 126"></path>
                <path class="precision-base arm-right-base" d="M113 94 L144 134 C151 142,149 154,138 158 L130 161 C122 164,115 161,111 154 L99 126"></path>

                <circle class="precision-zone head-zone" cx="90" cy="42" r="22" style="opacity:${headOpacity}"></circle>
                <path class="precision-zone body-zone" d="M73 78 C80 66,100 66,107 78 L116 138 C118 148,112 157,103 159 L100 208 L80 208 L77 159 C68 157,62 148,64 138 Z" style="opacity:${bodyOpacity}"></path>
                <path class="precision-zone leg-zone" d="M80 208 L96 208 L106 290 C107 297,103 302,96 302 L90 302 C83 302,79 297,80 290 Z M84 208 L74 290 C73 297,77 302,84 302 L90 302 C97 302,101 297,100 290 L90 208 Z" style="opacity:${legOpacity}"></path>

                <circle class="precision-core" cx="90" cy="42" r="5"></circle>
                <circle class="precision-core" cx="90" cy="126" r="6"></circle>
                <circle class="precision-core" cx="90" cy="246" r="5"></circle>
              </svg>
            </div>
          </div>
        </div>
        <div class="profile-ranked-weapons-combined-section">
          <div class="profile-ranked-weapons-combined-head">
            <div>
              <span class="profile-public-card-eyebrow">Top Weapons</span>
              <h4>Armas com maior impacto</h4>
            </div>
            <span class="profile-public-section-badge">${weapons.length}</span>
          </div>
          ${weapons.length ? `
            <div class="profile-ranked-weapons-list">
              ${weapons.map((weapon) => `
                <div class="profile-ranked-weapon-row">
                  <div class="profile-ranked-weapon-info">
                    <div class="profile-ranked-weapon-silhouette-wrap">
                      ${weapon.imageUrl
                        ? `<img src="${weapon.imageUrl}" alt="${weapon.name}" class="profile-ranked-weapon-silhouette" loading="lazy">`
                        : '<span class="profile-ranked-weapon-fallback"><i class="fas fa-crosshairs"></i></span>'}
                    </div>
                    <div class="profile-ranked-weapon-copy">
                      <strong>${weapon.name}</strong>
                      <span>${weapon.typeLabel}</span>
                    </div>
                  </div>
                  <div class="profile-ranked-weapon-accuracy">
                    <div class="profile-ranked-weapon-dummy" aria-hidden="true">
                      <span class="head ${weapon.headPercent >= weapon.bodyPercent && weapon.headPercent >= weapon.legPercent ? 'dominant' : ''}"></span>
                      <span class="body ${weapon.bodyPercent >= weapon.headPercent && weapon.bodyPercent >= weapon.legPercent ? 'dominant' : ''}"></span>
                      <span class="legs ${weapon.legPercent > weapon.bodyPercent && weapon.legPercent > weapon.headPercent ? 'dominant' : ''}"></span>
                    </div>
                    <div class="profile-ranked-weapon-hits">
                      <span class="stat">${weapon.headPercent}%</span>
                      <span class="stat">${weapon.bodyPercent}%</span>
                      <span class="stat">${weapon.legPercent}%</span>
                    </div>
                  </div>
                  <div class="profile-ranked-weapon-main-stat">
                    <span class="label">Kills</span>
                    <span class="value">${weapon.kills}</span>
                  </div>
                </div>
              `).join('')}
            </div>
          ` : `
            <div class="profile-ranked-weapons-empty">Sem dados de armas suficientes neste período.</div>
          `}
        </div>
      </article>
    `;
  }

  renderRankedPrecisionCard(precision) {
    const data = precision || { headPercent: 0, bodyPercent: 0, legPercent: 0, totalShots: 0 };
    const headOpacity = Math.max(0.22, Math.min(0.95, data.headPercent / 100));
    const bodyOpacity = Math.max(0.22, Math.min(0.95, data.bodyPercent / 100));
    const legOpacity = Math.max(0.18, Math.min(0.8, data.legPercent / 100));

    return `
      <article class="profile-public-card profile-ranked-precision-card">
        <div class="profile-public-card-head">
          <div>
            <span class="profile-public-card-eyebrow">Precisão</span>
            <h3>Distribuição dos disparos</h3>
          </div>
          <span class="profile-public-section-badge">${data.totalShots || 0} tiros</span>
        </div>
        <div class="profile-ranked-precision-layout">
          <div class="profile-ranked-precision-figure-wrap">
            <div class="profile-ranked-precision-stage" aria-hidden="true">
              <span class="profile-ranked-precision-ring ring-1"></span>
              <span class="profile-ranked-precision-ring ring-2"></span>
              <span class="profile-ranked-precision-ring ring-3"></span>
            </div>
            <div class="profile-ranked-precision-marker head">
              <span>Cabeça</span>
              <strong>${data.headPercent}%</strong>
            </div>
            <div class="profile-ranked-precision-marker body">
              <span>Corpo</span>
              <strong>${data.bodyPercent}%</strong>
            </div>
            <div class="profile-ranked-precision-marker legs">
              <span>Pernas</span>
              <strong>${data.legPercent}%</strong>
            </div>
            <div class="profile-ranked-precision-figure" aria-hidden="true">
              <svg viewBox="0 0 180 320" class="profile-ranked-precision-silhouette" role="presentation">
                <defs>
                  <linearGradient id="precisionBodyGlow" x1="0" x2="0" y1="0" y2="1">
                    <stop offset="0%" stop-color="rgba(255,255,255,0.16)" />
                    <stop offset="100%" stop-color="rgba(255,255,255,0.08)" />
                  </linearGradient>
                </defs>
                <circle class="precision-base head-base" cx="90" cy="42" r="24"></circle>
                <path class="precision-base torso-base" d="M71 72 C78 58,102 58,109 72 L122 142 C125 156,117 168,104 170 L101 212 L115 286 C117 297,111 304,101 304 L90 304 C81 304,76 297,78 287 L85 220 L95 220 L102 287 C104 297,99 304,89 304 L78 304 C68 304,62 297,64 286 L78 212 L75 170 C62 168,54 156,57 142 Z"></path>
                <path class="precision-base arm-left-base" d="M67 94 L36 134 C29 142,31 154,42 158 L50 161 C58 164,65 161,69 154 L81 126"></path>
                <path class="precision-base arm-right-base" d="M113 94 L144 134 C151 142,149 154,138 158 L130 161 C122 164,115 161,111 154 L99 126"></path>

                <circle class="precision-zone head-zone" cx="90" cy="42" r="22" style="opacity:${headOpacity}"></circle>
                <path class="precision-zone body-zone" d="M73 78 C80 66,100 66,107 78 L116 138 C118 148,112 157,103 159 L100 208 L80 208 L77 159 C68 157,62 148,64 138 Z" style="opacity:${bodyOpacity}"></path>
                <path class="precision-zone leg-zone" d="M80 208 L96 208 L106 290 C107 297,103 302,96 302 L90 302 C83 302,79 297,80 290 Z M84 208 L74 290 C73 297,77 302,84 302 L90 302 C97 302,101 297,100 290 L90 208 Z" style="opacity:${legOpacity}"></path>

                <circle class="precision-core" cx="90" cy="42" r="5"></circle>
                <circle class="precision-core" cx="90" cy="126" r="6"></circle>
                <circle class="precision-core" cx="90" cy="246" r="5"></circle>
              </svg>
            </div>
          </div>
        </div>
      </article>
    `;
  }

  renderTopWeaponsCard(weapons = []) {
    if (!weapons.length) {
      return `
        <article class="profile-public-card profile-ranked-weapons-card">
          <div class="profile-public-card-head">
            <div>
              <span class="profile-public-card-eyebrow">Top Weapons</span>
              <h3>Armas com maior impacto</h3>
            </div>
          </div>
          <div class="profile-ranked-weapons-empty">Sem dados de armas suficientes neste período.</div>
        </article>
      `;
    }

    return `
      <article class="profile-public-card profile-ranked-weapons-card">
        <div class="profile-public-card-head">
          <div>
            <span class="profile-public-card-eyebrow">Top Weapons</span>
            <h3>Armas com maior impacto</h3>
          </div>
          <span class="profile-public-section-badge">${weapons.length}</span>
        </div>
        <div class="profile-ranked-weapons-list">
          ${weapons.map((weapon) => `
            <div class="profile-ranked-weapon-row">
              <div class="profile-ranked-weapon-info">
                <div class="profile-ranked-weapon-silhouette-wrap">
                  ${weapon.imageUrl
                    ? `<img src="${weapon.imageUrl}" alt="${weapon.name}" class="profile-ranked-weapon-silhouette" loading="lazy">`
                    : '<span class="profile-ranked-weapon-fallback"><i class="fas fa-crosshairs"></i></span>'}
                </div>
                <div class="profile-ranked-weapon-copy">
                  <strong>${weapon.name}</strong>
                  <span>${weapon.typeLabel}</span>
                </div>
              </div>
              <div class="profile-ranked-weapon-accuracy">
                <div class="profile-ranked-weapon-dummy" aria-hidden="true">
                  <span class="head ${weapon.headPercent >= weapon.bodyPercent && weapon.headPercent >= weapon.legPercent ? 'dominant' : ''}"></span>
                  <span class="body ${weapon.bodyPercent >= weapon.headPercent && weapon.bodyPercent >= weapon.legPercent ? 'dominant' : ''}"></span>
                  <span class="legs ${weapon.legPercent > weapon.bodyPercent && weapon.legPercent > weapon.headPercent ? 'dominant' : ''}"></span>
                </div>
                <div class="profile-ranked-weapon-hits">
                  <span class="stat">${weapon.headPercent}%</span>
                  <span class="stat">${weapon.bodyPercent}%</span>
                  <span class="stat">${weapon.legPercent}%</span>
                </div>
              </div>
              <div class="profile-ranked-weapon-main-stat">
                <span class="label">Kills</span>
                <span class="value">${weapon.kills}</span>
              </div>
            </div>
          `).join('')}
        </div>
      </article>
    `;
  }

  renderRankedOverviewSection(mmr, performance, scoutingStats, detailedStats) {
    const winRate = Number(String(performance?.winRateLabel || '0').replace('%', '')) || 0;
    const kd = parseFloat(performance?.kdLabel || '0') || 0;
    const hs = Number(scoutingStats?.avg_hs || 0);
    const acs = Math.round(Number(scoutingStats?.avg_acs || 0));
    const adr = Math.round(Number(scoutingStats?.avg_adr || 0));
    const matches = parseInt(String(performance?.matchesLabel || '0'), 10) || 0;

    return `
      <div class="ia-section ia-overview profile-ranked-overview-circles">
        <div class="ia-section-header">
          <i class="fas fa-chart-line"></i>
          <h3>Visão Geral</h3>
          <span class="ia-match-count">${matches} partidas</span>
        </div>

        <div class="ia-circles-row">
          <div class="profile-ranked-tier-inline">
            ${mmr?.rankIcon
              ? `<img src="${mmr.rankIcon}" alt="${mmr.rankLabel || 'Rank'}" class="profile-ranked-rank-icon">`
              : '<i class="fas fa-shield-alt profile-ranked-rank-icon fallback"></i>'}
            <div class="profile-ranked-tier-inline-copy">
              <strong>${mmr?.rankLabel || '--'}</strong>
              <span>${mmr?.rrLabel || '--'}</span>
            </div>
          </div>
          ${this.renderRankedCircularStat(winRate, 100, this.getWinRateColor(winRate), 'Win Rate', `${winRate}%`)}
          ${this.renderRankedCircularStat(kd * 50, 100, this.getKdColor(kd), 'K/D', performance?.kdLabel || '--')}
          ${this.renderRankedCircularStat(hs, 50, this.getHsColor(hs), 'HS%', hs ? `${hs.toFixed(0)}%` : '--')}
          ${this.renderRankedCircularStat(acs, 350, this.getAcsColor(acs), 'ACS', acs || '--')}
          ${this.renderRankedCircularStat(adr, 250, this.getAcsColor(adr), 'ADR', adr || '--')}
        </div>
      </div>
    `;
  }

  renderRankedDetailCard(title, icon, rows = []) {
    return `
      <article class="profile-ranked-detail-card">
        <div class="profile-ranked-detail-head">
          <span class="profile-ranked-detail-title"><i class="fas ${icon}"></i>${title}</span>
        </div>
        <div class="profile-ranked-detail-body">
          ${rows.map((row) => `
            <div class="profile-ranked-detail-row">
              <span class="profile-ranked-detail-label">${row.label}</span>
              <div class="profile-ranked-detail-bar-wrap">
                <span class="profile-ranked-detail-bar"><span class="profile-ranked-detail-bar-fill accent-${row.accent}" style="width:${Math.max(0, Math.min(row.ratio || 0, 100))}%"></span></span>
              </div>
              <strong class="profile-ranked-detail-value accent-${row.accent}">${row.value}</strong>
            </div>
          `).join('')}
        </div>
      </article>
    `;
  }

  renderRankedCircularStat(value, max, color, label, displayValue) {
    const pct = max > 0 ? Math.min((Number(value) / max) * 100, 100) : 0;
    const circ = 2 * Math.PI * 36;
    const offset = circ - (pct / 100) * circ;

    return `
      <div class="ia-circular-stat">
        <svg viewBox="0 0 80 80">
          <circle cx="40" cy="40" r="36" fill="none" stroke="rgba(255,255,255,0.06)" stroke-width="5"/>
          <circle cx="40" cy="40" r="36" fill="none" stroke="${color}" stroke-width="5"
                  stroke-dasharray="${circ}" stroke-dashoffset="${offset}"
                  stroke-linecap="round" transform="rotate(-90 40 40)"/>
        </svg>
        <div class="ia-circular-value" style="color:${color}">${displayValue}</div>
        <div class="ia-circular-label">${label}</div>
      </div>
    `;
  }

  getWinRateColor(value) {
    return value >= 55 ? '#10b981' : value >= 50 ? '#fbbf24' : '#ff4655';
  }

  getKdColor(value) {
    return value >= 1.5 ? '#10b981' : value >= 1.0 ? '#fbbf24' : '#ff4655';
  }

  getHsColor(value) {
    return value >= 30 ? '#10b981' : value >= 20 ? '#fbbf24' : '#ff4655';
  }

  getAcsColor(value) {
    return value >= 250 ? '#10b981' : value >= 200 ? '#fbbf24' : '#ff4655';
  }

  renderRankedSummaryStat(label, value, icon, accentClass, imageUrl = '') {
    return `
      <div class="profile-ranked-stat-card ${accentClass}">
        <div class="profile-ranked-stat-icon">
          ${imageUrl ? `<img src="${imageUrl}" alt="${label}">` : `<i class="${icon}"></i>`}
        </div>
        <div>
          <span class="profile-ranked-stat-label">${label}</span>
          <strong class="profile-ranked-stat-value">${value}</strong>
        </div>
      </div>
    `;
  }

  async loadRankedOverview(force = false) {
    const user = this.user || auth.user || {};
    if (!user?.riot_id || !user?.riot_tag) return;
    if (this.rankedLoading) return;
    if (this.rankedOverview && !force) return;

    this.rankedLoading = true;
    this.rankedError = null;
    this.refreshRankedPanel();

    try {
      const region = this.normalizeValorantRegion(user.region || 'br');
      const assetsPromise = this.withRequestTimeout(
        this.hydrateValorantAssets(),
        8000,
        'Timeout ao carregar assets do Valorant'
      ).catch(() => null);
      const [mmrRequest, matchesRequest, scoutingRequest] = await Promise.allSettled([
        this.withRequestTimeout(
          api.getValorantMMR(region, user.riot_id, user.riot_tag),
          this.rankedRequestTimeoutMs,
          'Timeout ao carregar o elo do jogador'
        ),
        this.withRequestTimeout(
          api.getValorantMatches(region, user.riot_id, user.riot_tag, 'competitive', 100),
          this.rankedRequestTimeoutMs,
          'Timeout ao carregar as partidas competitivas'
        ),
        this.withRequestTimeout(
          api.get(`/scouting/profile/${user.id}`, { silent: true }),
          10000,
          'Timeout ao carregar dados de scouting'
        )
      ]);

      await assetsPromise;

      const mmrResult = mmrRequest.status === 'fulfilled' ? mmrRequest.value : null;
      const matchesResult = matchesRequest.status === 'fulfilled' ? matchesRequest.value : null;
      const scoutingResult = scoutingRequest.status === 'fulfilled' ? scoutingRequest.value : null;

      if (!matchesResult?.success) {
        // 403 RSO_CONSENT_REQUIRED não é falha: é o jogador que ainda não
        // autorizou a zdval pela Riot. Mostra o motivo, não um erro genérico.
        if (matchesRequest.reason?.code === 'RSO_CONSENT_REQUIRED') {
          this.rankedError = matchesRequest.reason.message;
          return;
        }
        throw new Error(matchesRequest.status === 'rejected'
          ? (matchesRequest.reason?.message || 'Não foi possível buscar as partidas competitivas')
          : 'Não foi possível buscar as partidas competitivas');
      }

      const scoutingData = scoutingResult?.success ? scoutingResult.data : null;
      const matches = matchesResult.data?.matches || [];
      const sortedMatches = this.sortRankedMatches(matches);
      const currentAct = this.detectProfileCurrentAct(sortedMatches);
      const actMatches = currentAct
        ? sortedMatches.filter((match) => this.getMatchSeasonShort(match) === currentAct)
        : sortedMatches;
      const allPeriod = this.buildRankedPeriodSnapshot(sortedMatches, 'Todos os atos');
      const actPeriod = this.buildRankedPeriodSnapshot(
        actMatches.length ? actMatches : sortedMatches,
        currentAct ? this.formatRankedActLabel(currentAct) : 'Ato atual'
      );
      const availableActs = this.getAvailableActs(sortedMatches);
      const recentMatches = this.buildRecentMatches(sortedMatches);
      const topAgent = actPeriod.topAgents?.[0] || allPeriod.topAgents?.[0] || null;
      const topAgentData = topAgent ? this.valorantAssets.agents?.[topAgent.agent] : null;
      const fallbackTeams = (!scoutingData?.teams?.length && user?.id)
        ? await this.loadOwnTeamsFallback()
        : [];
      const rankLabel = (typeof rankedStats !== 'undefined' && typeof rankedStats.simplifyRank === 'function')
        ? rankedStats.simplifyRank(mmrResult?.data?.currenttierpatched)
        : (mmrResult?.data?.currenttierpatched || '--');

      this.rankedOverview = {
        mmr: {
          rankLongLabel: mmrResult?.data?.currenttierpatched || '--',
          rankLabel,
          rankIcon: mmrResult?.data?.images?.small || '',
          rrLabel: mmrResult?.data?.ranking_in_tier !== undefined ? `${mmrResult.data.ranking_in_tier} RR` : '--'
        },
        performance: allPeriod.performance,
        precision: allPeriod.precision,
        analysis: {
          _currentAct: currentAct,
          _actMatches: actMatches,
          act: { topAgents: actPeriod.topAgents || [] },
          all: { topAgents: allPeriod.topAgents || [] }
        },
        recentMatches,
        mapPool: allPeriod.mapPool,
        periods: {
          act: actPeriod,
          all: allPeriod
        },
        primaryAgentLabel: topAgentData?.displayName || (topAgent ? this.capitalizeFirst(topAgent.agent) : null),
        primaryAgentIcon: topAgentData?.displayIcon || topAgentData?.displayIconSmall || '',
        primaryRoleLabel: topAgentData?.role?.displayName || null,
        primaryRoleIcon: topAgentData?.role?.displayIcon || '',
        currentActLabel: currentAct ? this.formatRankedActLabel(currentAct) : 'Ato atual',
        currentActShort: currentAct || null,
        allActsLabel: 'Todos os atos',
        availableActs,
        scouting: scoutingData ? {
          ...scoutingData,
          teams: scoutingData?.teams?.length ? scoutingData.teams : fallbackTeams,
          player: scoutingData.player || user,
          stats: scoutingData.stats || {}
        } : {
          player: user,
          teams: fallbackTeams,
          stats: {}
        },
        fetchedAt: Date.now(),
        updatedAtLabel: new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
      };

      const resolvedTeams = this.rankedOverview.scouting.teams;
      if (resolvedTeams?.length) {
        this.profileTeams = resolvedTeams;
      }
      this.persistRankedOverviewCache(user, this.rankedOverview);
      this.rankedNeedsRefresh = false;
      this.rankedPeriod = 'act';
      this.rankedPeriodDropdownOpen = false;
    } catch (error) {
      this.rankedError = error.message || 'Não foi possível carregar os dados de ranked';
    } finally {
      this.rankedLoading = false;
      if (this.mode === 'view') {
        this.render();
      } else {
        this.refreshRankedPanel();
      }
    }
  }

  async loadOwnTeamsFallback() {
    try {
      const teamsResult = await api.get('/teams', { silent: true });
      const teams = teamsResult?.success ? (teamsResult.data?.teams || []) : [];
      return teams.map(team => ({
        name: team.name,
        tag: team.tag,
        logo_url: team.logo_url,
        role: team.member_role || team.role || 'player',
        joined_at: team.created_at || null,
        left_at: null,
        is_active: true
      }));
    } catch (error) {
      return [];
    }
  }

  async loadProfileTeams() {
    if (this._loadingTeams) return;
    const user = this.user || auth.user || {};
    if (!user?.id) return;
    this._loadingTeams = true;
    try {
      const result = await api.get(`/scouting/profile/${user.id}`, { silent: true });
      let teams = result?.success ? (result.data?.teams || []) : [];
      if (!teams.length) {
        teams = await this.loadOwnTeamsFallback();
      }
      this.profileTeams = teams;
      if (this.rankedOverview?.scouting) {
        this.rankedOverview.scouting.teams = teams;
      }
      this.render();
    } catch (error) {
      this.profileTeams = await this.loadOwnTeamsFallback();
      this.render();
    } finally {
      this._loadingTeams = false;
    }
  }

  async hydrateValorantAssets() {
    if (this.valorantAssets.agents && this.valorantAssets.maps) return;

    if (typeof rankedStats !== 'undefined' && rankedStats?.agentsData && rankedStats?.mapsData) {
      this.valorantAssets.agents = rankedStats.agentsData;
      this.valorantAssets.maps = rankedStats.mapsData;
      return;
    }

    const [agentsResult, mapsResult] = await Promise.all([
      api.getValorantAgents(),
      api.getValorantMaps()
    ]);

    this.valorantAssets.agents = (agentsResult?.data || []).reduce((acc, agent) => {
      acc[agent.displayName.toLowerCase()] = agent;
      return acc;
    }, {});

    this.valorantAssets.maps = (mapsResult?.data || []).reduce((acc, map) => {
      acc[map.displayName.toLowerCase()] = map;
      return acc;
    }, {});
  }

  getRankedOverviewCacheKey(user = {}) {
    if (!user?.id) return null;
    return `zdval_profile_ranked_overview:${user.id}`;
  }

  persistRankedOverviewCache(user, overview) {
    const cacheKey = this.getRankedOverviewCacheKey(user);
    if (!cacheKey || !overview) return;

    const payload = {
      version: this.rankedCacheVersion,
      savedAt: Date.now(),
      overview: {
        ...overview,
        periods: {
          act: {
            ...overview.periods?.act,
            matches: undefined
          },
          all: {
            ...overview.periods?.all,
            matches: undefined
          }
        }
      }
    };

    try {
      localStorage.setItem(cacheKey, JSON.stringify(payload));
    } catch (error) {
      console.warn('Failed to persist ranked overview cache:', error);
    }
  }

  restoreRankedOverviewCache(user) {
    const cacheKey = this.getRankedOverviewCacheKey(user);
    if (!cacheKey) return false;

    try {
      const raw = localStorage.getItem(cacheKey);
      if (!raw) return false;

      const payload = JSON.parse(raw);
      if (!payload?.overview || payload.version !== this.rankedCacheVersion) {
        localStorage.removeItem(cacheKey);
        return false;
      }

      if (!this.isRankedOverviewPayloadValid(payload.overview)) {
        localStorage.removeItem(cacheKey);
        return false;
      }

      this.rankedOverview = payload.overview;
      this.rankedNeedsRefresh = true;
      return true;
    } catch (error) {
      console.warn('Failed to restore ranked overview cache:', error);
      return false;
    }
  }

  isRankedOverviewPayloadValid(overview) {
    if (!overview || typeof overview !== 'object') return false;

    const actPeriod = overview.periods?.act;
    const allPeriod = overview.periods?.all;
    if (!actPeriod || !allPeriod) return false;

    return Boolean(
      actPeriod.performance
      && actPeriod.precision
      && actPeriod.scoutingStats
      && actPeriod.detailedStats
      && allPeriod.performance
      && allPeriod.precision
      && allPeriod.scoutingStats
      && allPeriod.detailedStats
    );
  }

  buildMatchAnalysis(matches) {
    if (typeof rankedStats !== 'undefined' && typeof rankedStats.analyzeMatches === 'function') {
      return rankedStats.analyzeMatches(matches);
    }

    return {
      act: {
        topAgents: [],
        agentsByMap: {}
      },
      _currentAct: null
    };
  }

  getMatchStartedAt(match) {
    const raw = match?.metadata?.started_at || match?.game_start_patched || null;
    if (raw) {
      const parsed = new Date(raw).getTime();
      if (!Number.isNaN(parsed)) return parsed;
    }

    if (match?.game_start) {
      const parsed = Number(match.game_start) * 1000;
      if (!Number.isNaN(parsed)) return parsed;
    }

    return 0;
  }

  getMatchSeasonShort(match) {
    return String(match?.metadata?.season?.short || '').toLowerCase() || null;
  }

  sortRankedMatches(matches = []) {
    return [...(Array.isArray(matches) ? matches : [])].sort((left, right) => {
      return this.getMatchStartedAt(right) - this.getMatchStartedAt(left);
    });
  }

  getAvailableActs(matches = []) {
    const acts = new Set();

    matches.forEach((match) => {
      const seasonShort = this.getMatchSeasonShort(match);
      if (seasonShort) {
        acts.add(seasonShort);
      }
    });

    return [...acts].sort((left, right) => {
      const parseAct = (value) => {
        const found = String(value || '').match(/e(\d+)a(\d+)/i);
        return found ? [Number(found[1]), Number(found[2])] : [0, 0];
      };

      const [leftEpisode, leftAct] = parseAct(left);
      const [rightEpisode, rightAct] = parseAct(right);

      return rightEpisode - leftEpisode || rightAct - leftAct;
    });
  }

  detectProfileCurrentAct(matches = []) {
    const sortedMatches = this.sortRankedMatches(matches);
    const latestMatchWithAct = sortedMatches.find((match) => this.getMatchSeasonShort(match));
    if (latestMatchWithAct) {
      return this.getMatchSeasonShort(latestMatchWithAct);
    }

    return this.getAvailableActs(sortedMatches)[0] || null;
  }

  formatRankedActLabel(shortCode) {
    if (typeof rankedStats !== 'undefined' && typeof rankedStats.formatActLabel === 'function') {
      return rankedStats.formatActLabel(shortCode);
    }

    const match = String(shortCode || '').match(/e(\d+)a(\d+)/i);
    if (match) {
      return `EP${match[1]} Ato ${match[2]}`;
    }

    return shortCode || 'Ato atual';
  }

  buildTopAgentsByUsage(matches = []) {
    const agentCount = {};
    const totalMatches = matches.length;

    matches.forEach((match) => {
      const player = match?.player || {};
      const agentRaw = player.agent?.name || player.agent || 'unknown';
      const agentKey = String(agentRaw || 'unknown').toLowerCase();
      agentCount[agentKey] = (agentCount[agentKey] || 0) + 1;
    });

    return Object.entries(agentCount)
      .sort((left, right) => right[1] - left[1])
      .slice(0, 5)
      .map(([agent, count]) => ({
        agent,
        count,
        percentage: totalMatches ? Math.round((count / totalMatches) * 100) : 0
      }));
  }

  buildRankedPeriodSnapshot(matches = [], label = '') {
    const sortedMatches = this.sortRankedMatches(matches);

    return {
      label,
      performance: this.buildRankedPerformanceSummary(sortedMatches),
      precision: this.buildPrecisionBreakdown(sortedMatches),
      scoutingStats: this.buildRankedScoutingSummary(sortedMatches),
      detailedStats: this.buildRankedDetailedStats(sortedMatches),
      topAgents: this.buildTopAgentsByUsage(sortedMatches),
      mapPool: this.buildMapPool(sortedMatches),
      topWeapons: this.buildTopWeapons(sortedMatches),
      matches: sortedMatches
    };
  }

  getMatchResult(match) {
    const player = match?.player || {};
    const playerTeamId = String(player.team_id || player.team || '').toLowerCase();
    if (!playerTeamId) {
      return 'unknown';
    }

    let playerTeam = null;
    let opponentTeam = null;

    if (Array.isArray(match?.teams)) {
      playerTeam = match.teams.find((entry) => String(entry?.team_id || '').toLowerCase() === playerTeamId) || null;
      opponentTeam = match.teams.find((entry) => String(entry?.team_id || '').toLowerCase() !== playerTeamId) || null;
    } else if (match?.teams) {
      playerTeam = match.teams[playerTeamId] || null;
      const opponentKey = Object.keys(match.teams).find((key) => String(key).toLowerCase() !== playerTeamId);
      opponentTeam = opponentKey ? match.teams[opponentKey] : null;
    }

    const playerWonFlag = playerTeam?.won === true || playerTeam?.has_won === true;
    const opponentWonFlag = opponentTeam?.won === true || opponentTeam?.has_won === true;
    if (playerWonFlag) return 'win';
    if (opponentWonFlag) return 'loss';

    const roundsWon = playerTeam?.rounds?.won ?? playerTeam?.rounds_won ?? 0;
    const roundsLost = playerTeam?.rounds?.lost ?? playerTeam?.rounds_lost ?? opponentTeam?.rounds?.won ?? opponentTeam?.rounds_won ?? 0;

    if (roundsWon > roundsLost) return 'win';
    if (roundsLost > roundsWon) return 'loss';
    if (roundsWon > 0 || roundsLost > 0) return 'draw';

    return 'unknown';
  }

  buildPrecisionBreakdown(matches) {
    const totals = matches.reduce((accumulator, match) => {
      const player = match.player || match.players?.[0] || {};
      const stats = player.stats || {};

      accumulator.headshots += Number(stats.headshots || 0);
      accumulator.bodyshots += Number(stats.bodyshots || 0);
      accumulator.legshots += Number(stats.legshots || 0);

      return accumulator;
    }, {
      headshots: 0,
      bodyshots: 0,
      legshots: 0
    });

    const totalShots = totals.headshots + totals.bodyshots + totals.legshots;

    return {
      ...totals,
      totalShots,
      headPercent: totalShots > 0 ? Math.round((totals.headshots / totalShots) * 100) : 0,
      bodyPercent: totalShots > 0 ? Math.round((totals.bodyshots / totalShots) * 100) : 0,
      legPercent: totalShots > 0 ? Math.round((totals.legshots / totalShots) * 100) : 0
    };
  }

  buildMapPool(matches) {
    const maps = {};

    matches.forEach(match => {
      const mapKey = (match.metadata?.map?.name || match.map || 'unknown').toLowerCase();
      if (!maps[mapKey]) {
        const mapData = this.valorantAssets.maps?.[mapKey] || null;
        maps[mapKey] = {
          key: mapKey,
          name: mapData?.displayName || this.capitalizeFirst(mapKey),
          image: mapData?.listViewIcon || mapData?.splash || '',
          games: 0,
          wins: 0
        };
      }

      maps[mapKey].games += 1;
      const result = this.getMatchResult(match);
      if (result !== 'draw' && result !== 'unknown') {
        maps[mapKey].decisiveGames = (maps[mapKey].decisiveGames || 0) + 1;
      }
      if (result === 'win') {
        maps[mapKey].wins += 1;
      }
    });

    return Object.values(maps)
      .map(map => ({
        ...map,
        winRate: map.decisiveGames ? Math.round((map.wins / map.decisiveGames) * 100) : 0
      }))
      .sort((a, b) => b.games - a.games)
      .slice(0, 5);
  }

  buildTopWeapons(matches) {
    const weapons = {};

    const ensureWeapon = (weapon) => {
      if (!weapon?.name) {
        return null;
      }

      const key = String(weapon.name).toLowerCase();
      if (!weapons[key]) {
        weapons[key] = {
          id: weapon.id || '',
          name: weapon.name,
          type: weapon.type || 'Weapon',
          typeLabel: this.getWeaponCategoryLabel(weapon.name),
          imageUrl: weapon.id ? this.getWeaponImageUrl(weapon.id) : '',
          kills: 0,
          headshots: 0,
          bodyshots: 0,
          legshots: 0
        };
      }

      return weapons[key];
    };

    matches.forEach((match) => {
      const playerPuuid = match.player?.puuid || '';
      const playerName = (match.player?.name || '').toLowerCase();
      const playerTag = (match.player?.tag || '').toLowerCase();

      (match.kills || []).forEach((kill) => {
        const killer = kill.killer || {};
        const killerMatches = playerPuuid
          ? killer.puuid === playerPuuid
          : ((killer.name || '').toLowerCase() === playerName && (killer.tag || '').toLowerCase() === playerTag);

        if (!killerMatches || !kill.weapon || kill.weapon.type !== 'Weapon') {
          return;
        }

        const entry = ensureWeapon(kill.weapon);
        if (entry) {
          entry.kills += 1;
        }
      });

      (match.rounds || []).forEach((round) => {
        const roundStats = Array.isArray(round.stats) ? round.stats : [];
        const playerRound = roundStats.find((entry) => {
          const roundPlayer = entry.player || {};
          if (playerPuuid && roundPlayer.puuid) {
            return roundPlayer.puuid === playerPuuid;
          }

          return (roundPlayer.name || '').toLowerCase() === playerName && (roundPlayer.tag || '').toLowerCase() === playerTag;
        });

        const weapon = playerRound?.economy?.weapon;
        if (!weapon || weapon.type !== 'Weapon') {
          return;
        }

        const entry = ensureWeapon(weapon);
        if (!entry) {
          return;
        }

        entry.headshots += Number(playerRound?.stats?.headshots || 0);
        entry.bodyshots += Number(playerRound?.stats?.bodyshots || 0);
        entry.legshots += Number(playerRound?.stats?.legshots || 0);

        if (!entry.kills) {
          entry.kills += Number(playerRound?.stats?.kills || 0);
        }
      });
    });

    return Object.values(weapons)
      .map((weapon) => {
        const totalHits = weapon.headshots + weapon.bodyshots + weapon.legshots;
        return {
          ...weapon,
          totalHits,
          headPercent: totalHits ? Math.round((weapon.headshots / totalHits) * 100) : 0,
          bodyPercent: totalHits ? Math.round((weapon.bodyshots / totalHits) * 100) : 0,
          legPercent: totalHits ? Math.round((weapon.legshots / totalHits) * 100) : 0
        };
      })
      .filter((weapon) => weapon.kills > 0 || weapon.totalHits > 0)
      .sort((left, right) => right.kills - left.kills || right.totalHits - left.totalHits)
      .slice(0, 3);
  }

  getWeaponCategoryLabel(weaponName = '') {
    const categories = {
      classic: 'Sidearms',
      shorty: 'Sidearms',
      frenzy: 'Sidearms',
      ghost: 'Sidearms',
      sheriff: 'Sidearms',
      stinger: 'SMGs',
      spectre: 'SMGs',
      bucky: 'Shotguns',
      judge: 'Shotguns',
      bulldog: 'Assault Rifles',
      guardian: 'Rifles',
      phantom: 'Assault Rifles',
      vandal: 'Assault Rifles',
      marshal: 'Sniper Rifles',
      outlaw: 'Sniper Rifles',
      operator: 'Sniper Rifles',
      ares: 'Machine Guns',
      odin: 'Machine Guns',
      knife: 'Melee'
    };

    return categories[String(weaponName).toLowerCase()] || 'Weapon';
  }

  getWeaponImageUrl(weaponId = '') {
    return weaponId ? `https://media.valorant-api.com/weapons/${weaponId}/shop/newimage.png` : '';
  }

  buildRecentMatches(matches) {
    return matches.slice(0, 3).map(match => {
      const player = match.player || match.players?.[0] || {};
      const stats = player.stats || {};
      const roundsWon = this.extractRoundsWon(match, player);
      const roundsPlayed = this.extractTotalRounds(match, player);
      const agentKey = (player.agent?.name || player.agent || 'desconhecido').toLowerCase();
      const agentData = this.valorantAssets.agents?.[agentKey] || null;
      const acs = roundsPlayed ? Math.round((stats.score || 0) / roundsPlayed) : 0;
      const result = this.getMatchResult(match);
      const resultMap = {
        win: { label: 'Vitória', className: 'victory' },
        loss: { label: 'Derrota', className: 'defeat' },
        draw: { label: 'Empate', className: 'draw' },
        unknown: { label: 'Indefinido', className: 'draw' }
      };
      const matchResult = resultMap[result] || resultMap.unknown;

      return {
        resultLabel: matchResult.label,
        resultClass: matchResult.className,
        dateLabel: this.formatMatchDate(match),
        mapName: this.getMapDisplayName(match),
        agentName: agentData?.displayName || this.capitalizeFirst(agentKey),
        kdaLabel: `${stats.kills || 0}/${stats.deaths || 0}/${stats.assists || 0}`,
        acs,
        roundsWon,
        roundsPlayed
      };
    });
  }

  didPlayerWin(match) {
    return this.getMatchResult(match) === 'win';
  }

  extractRoundsWon(match, player) {
    const playerTeamId = (player.team_id || player.team || '').toLowerCase();

    if (Array.isArray(match.teams)) {
      const team = match.teams.find(entry => entry.team_id?.toLowerCase() === playerTeamId) || {};
      return team.rounds?.won ?? team.rounds_won ?? 0;
    }

    if (match.teams && playerTeamId) {
      const team = match.teams[playerTeamId] || {};
      return team.rounds?.won ?? team.rounds_won ?? 0;
    }

    return 0;
  }

  extractTotalRounds(match, player) {
    const playerTeamId = (player.team_id || player.team || '').toLowerCase();

    if (Array.isArray(match.teams)) {
      const playerTeam = match.teams.find(entry => entry.team_id?.toLowerCase() === playerTeamId) || {};
      const enemyTeam = match.teams.find(entry => entry.team_id?.toLowerCase() !== playerTeamId) || {};
      const won = playerTeam.rounds?.won ?? playerTeam.rounds_won ?? 0;
      const lost = playerTeam.rounds?.lost ?? playerTeam.rounds_lost ?? enemyTeam.rounds?.won ?? enemyTeam.rounds_won ?? 0;
      return won + lost;
    }

    if (match.teams && playerTeamId) {
      const playerTeam = match.teams[playerTeamId] || {};
      const enemyKey = Object.keys(match.teams).find(key => key.toLowerCase() !== playerTeamId);
      const enemyTeam = enemyKey ? match.teams[enemyKey] : {};
      const won = playerTeam.rounds?.won ?? playerTeam.rounds_won ?? 0;
      const lost = playerTeam.rounds?.lost ?? playerTeam.rounds_lost ?? enemyTeam?.rounds?.won ?? enemyTeam?.rounds_won ?? 0;
      return won + lost;
    }

    return 0;
  }

  getMapDisplayName(match) {
    const mapKey = (match.metadata?.map?.name || match.map || 'desconhecido').toLowerCase();
    return this.valorantAssets.maps?.[mapKey]?.displayName || this.capitalizeFirst(mapKey);
  }

  formatMatchDate(match) {
    const startedAt = match.metadata?.started_at || match.game_start_patched || null;
    if (!startedAt) return 'Sem data';
    return new Date(startedAt).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
  }

  capitalizeFirst(value = '') {
    return String(value)
      .split(' ')
      .map(chunk => chunk ? chunk.charAt(0).toUpperCase() + chunk.slice(1) : chunk)
      .join(' ');
  }

  buildRankedPerformanceSummary(matches) {
    if (!matches?.length) {
      return {
        winRateLabel: '--',
        kdLabel: '--',
        matchesLabel: '0',
        recordLabel: '0W-0L',
        avgKills: 0,
        avgDeaths: 0,
        wins: 0,
        losses: 0,
        draws: 0
      };
    }

    const totals = matches.reduce((accumulator, match) => {
      const player = match.player || {};
      const stats = player.stats || {};
      const result = this.getMatchResult(match);

      accumulator.kills += Number(stats.kills || 0);
      accumulator.deaths += Number(stats.deaths || 0);
      accumulator.assists += Number(stats.assists || 0);

      if (result === 'win') accumulator.wins += 1;
      else if (result === 'loss') accumulator.losses += 1;
      else if (result === 'draw') accumulator.draws += 1;

      return accumulator;
    }, {
      kills: 0,
      deaths: 0,
      assists: 0,
      wins: 0,
      losses: 0,
      draws: 0
    });

    const decisiveMatches = totals.wins + totals.losses;
    const avgKills = (totals.kills / matches.length).toFixed(1);
    const avgDeaths = (totals.deaths / matches.length).toFixed(1);
    const kd = totals.deaths > 0 ? (totals.kills / totals.deaths).toFixed(2) : totals.kills.toFixed(2);
    const recordLabel = `${totals.wins}W-${totals.losses}L${totals.draws ? `-${totals.draws}D` : ''}`;

    return {
      winRateLabel: `${decisiveMatches ? Math.round((totals.wins / decisiveMatches) * 100) : 0}%`,
      kdLabel: kd,
      matchesLabel: `${matches.length}`,
      recordLabel,
      avgKills,
      avgDeaths,
      wins: totals.wins,
      losses: totals.losses,
      draws: totals.draws
    };
  }

  buildRankedScoutingSummary(matches) {
    if (!matches?.length) {
      return {
        avg_hs: 0,
        avg_acs: 0,
        avg_adr: 0,
        kills: 0,
        deaths: 0,
        assists: 0,
        total_rounds: 0
      };
    }

    const totals = matches.reduce((accumulator, match) => {
      const player = match.player || {};
      const stats = player.stats || {};
      const roundsPlayed = this.extractTotalRounds(match, player);

      accumulator.kills += Number(stats.kills || 0);
      accumulator.deaths += Number(stats.deaths || 0);
      accumulator.assists += Number(stats.assists || 0);
      accumulator.score += Number(stats.score || 0);
      accumulator.damage += Number(stats.damage?.dealt || 0);
      accumulator.headshots += Number(stats.headshots || 0);
      accumulator.bodyshots += Number(stats.bodyshots || 0);
      accumulator.legshots += Number(stats.legshots || 0);
      accumulator.rounds += Number(roundsPlayed || 0);

      return accumulator;
    }, {
      kills: 0,
      deaths: 0,
      assists: 0,
      score: 0,
      damage: 0,
      headshots: 0,
      bodyshots: 0,
      legshots: 0,
      rounds: 0
    });

    const totalShots = totals.headshots + totals.bodyshots + totals.legshots;

    return {
      avg_hs: totalShots ? Number(((totals.headshots / totalShots) * 100).toFixed(1)) : 0,
      avg_acs: totals.rounds ? Number((totals.score / totals.rounds).toFixed(1)) : 0,
      avg_adr: totals.rounds ? Number((totals.damage / totals.rounds).toFixed(1)) : 0,
      kills: totals.kills,
      deaths: totals.deaths,
      assists: totals.assists,
      total_rounds: totals.rounds
    };
  }

  buildRankedDetailedStats(matches) {
    if (!matches?.length) {
      return {
        kd: '0.00',
        kda: '0.00',
        avgKills: '0.0',
        avgDeaths: '0.0',
        avgAssists: '0.0',
        avgPlusMinus: 0,
        plusMinusLabel: '+0.0',
        headPercent: 0,
        bodyPercent: 0,
        legPercent: 0,
        acs: 0,
        adr: 0,
        damagePerMatch: 0,
        receivedPerMatch: 0,
        deltaPerMatch: 0,
        deltaPerMatchLabel: '+0',
        kastPercent: 0,
        kastLabel: '--',
        firstKillsPerMatch: '0.0',
        firstDeathsPerMatch: '0.0',
        firstKillsTotal: 0,
        firstDeathsTotal: 0,
        firstDelta: 0,
        firstDeltaLabel: '+0.0',
        multiKillsTotal: 0,
        plantsPerMatch: '0.0',
        defusesPerMatch: '0.0'
      };
    }

    const totals = matches.reduce((accumulator, match) => {
      const player = match.player || {};
      const stats = player.stats || {};
      const roundsPlayed = this.extractTotalRounds(match, player);
      const kills = Number(stats.kills || 0);
      const deaths = Number(stats.deaths || 0);
      const assists = Number(stats.assists || 0);
      const damageDealt = Number(stats.damage?.dealt || 0);
      const damageReceived = Number(stats.damage?.received || 0);

      accumulator.kills += kills;
      accumulator.deaths += deaths;
      accumulator.assists += assists;
      accumulator.score += Number(stats.score || 0);
      accumulator.damage += damageDealt;
      accumulator.received += damageReceived;
      accumulator.headshots += Number(stats.headshots || 0);
      accumulator.bodyshots += Number(stats.bodyshots || 0);
      accumulator.legshots += Number(stats.legshots || 0);
      accumulator.rounds += Number(roundsPlayed || 0);
      accumulator.plusMinus += kills - deaths;

      const firstActions = this.extractFirstActionStats(match);
      accumulator.firstKills += firstActions.firstKills;
      accumulator.firstDeaths += firstActions.firstDeaths;

      accumulator.kastRounds += this.extractKastRounds(match);
      accumulator.multiKills += this.extractMultiKillRounds(match);

      const objectiveStats = this.extractObjectiveStats(match);
      accumulator.plants += objectiveStats.plants;
      accumulator.defuses += objectiveStats.defuses;

      return accumulator;
    }, {
      kills: 0,
      deaths: 0,
      assists: 0,
      score: 0,
      damage: 0,
      received: 0,
      headshots: 0,
      bodyshots: 0,
      legshots: 0,
      rounds: 0,
      plusMinus: 0,
      firstKills: 0,
      firstDeaths: 0,
      kastRounds: 0,
      multiKills: 0,
      plants: 0,
      defuses: 0
    });

    const totalShots = totals.headshots + totals.bodyshots + totals.legshots;
    const matchCount = matches.length;
    const avgKills = totals.kills / matchCount;
    const avgDeaths = totals.deaths / matchCount;
    const avgAssists = totals.assists / matchCount;
    const avgPlusMinus = totals.plusMinus / matchCount;
    const damagePerMatch = totals.damage / matchCount;
    const receivedPerMatch = totals.received / matchCount;
    const deltaPerMatch = (totals.damage - totals.received) / matchCount;
    const firstKillsPerMatch = totals.firstKills / matchCount;
    const firstDeathsPerMatch = totals.firstDeaths / matchCount;
    const firstDelta = totals.firstKills - totals.firstDeaths;
    const kastPercent = totals.rounds ? (totals.kastRounds / totals.rounds) * 100 : 0;

    return {
      kd: totals.deaths > 0 ? (totals.kills / totals.deaths).toFixed(2) : totals.kills.toFixed(2),
      kda: totals.deaths > 0 ? ((totals.kills + totals.assists) / totals.deaths).toFixed(2) : (totals.kills + totals.assists).toFixed(2),
      avgKills: avgKills.toFixed(1),
      avgDeaths: avgDeaths.toFixed(1),
      avgAssists: avgAssists.toFixed(1),
      avgPlusMinus,
      plusMinusLabel: `${avgPlusMinus >= 0 ? '+' : ''}${avgPlusMinus.toFixed(1)}`,
      headPercent: totalShots ? Math.round((totals.headshots / totalShots) * 100) : 0,
      bodyPercent: totalShots ? Math.round((totals.bodyshots / totalShots) * 100) : 0,
      legPercent: totalShots ? Math.round((totals.legshots / totalShots) * 100) : 0,
      acs: totals.rounds ? Math.round(totals.score / totals.rounds) : 0,
      adr: totals.rounds ? Math.round(totals.damage / totals.rounds) : 0,
      damagePerMatch: Math.round(damagePerMatch),
      receivedPerMatch: Math.round(receivedPerMatch),
      deltaPerMatch,
      deltaPerMatchLabel: `${deltaPerMatch >= 0 ? '+' : ''}${Math.round(deltaPerMatch)}`,
      kastPercent,
      kastLabel: `${kastPercent.toFixed(0)}%`,
      firstKillsPerMatch: firstKillsPerMatch.toFixed(1),
      firstDeathsPerMatch: firstDeathsPerMatch.toFixed(1),
      firstKillsTotal: totals.firstKills,
      firstDeathsTotal: totals.firstDeaths,
      firstDelta,
      firstDeltaLabel: `${firstDelta >= 0 ? '+' : ''}${firstDelta}`,
      multiKillsTotal: totals.multiKills,
      plantsPerMatch: (totals.plants / matchCount).toFixed(1),
      defusesPerMatch: (totals.defuses / matchCount).toFixed(1)
    };
  }

  matchEntityToPlayer(entity, player, fallbackTeamId = '') {
    const playerPuuid = player?.puuid || '';
    const playerName = (player?.name || '').toLowerCase();
    const playerTag = (player?.tag || '').toLowerCase();
    const entityTeamId = String(entity?.team_id || entity?.team || '').toLowerCase();

    if (playerPuuid && entity?.puuid) {
      return entity.puuid === playerPuuid;
    }

    if (playerName && playerTag) {
      return (entity?.name || '').toLowerCase() === playerName && (entity?.tag || '').toLowerCase() === playerTag;
    }

    return Boolean(fallbackTeamId && entityTeamId && entityTeamId === fallbackTeamId);
  }

  extractKastRounds(match) {
    const player = match?.player || {};
    const playerTeamId = String(player?.team_id || player?.team || '').toLowerCase();
    const rounds = Array.isArray(match?.rounds) ? match.rounds : [];
    const killsByRound = {};

    (match?.kills || []).forEach((kill) => {
      const roundNumber = Number(kill?.round || 0);
      if (!killsByRound[roundNumber]) {
        killsByRound[roundNumber] = [];
      }
      killsByRound[roundNumber].push(kill);
    });

    return rounds.reduce((count, round) => {
      const entries = Array.isArray(round?.stats) ? round.stats : [];
      const playerRound = entries.find((entry) => this.matchEntityToPlayer(entry?.player || {}, player, playerTeamId)) || null;
      const kills = Number(playerRound?.stats?.kills || 0);
      const assists = Number(playerRound?.stats?.assists || 0);
      const deaths = Number(playerRound?.stats?.deaths || 0);
      const survived = deaths === 0;

      let traded = false;
      if (!survived) {
        const roundNumber = Number(round?.round_number || round?.round || 0);
        const roundKills = [...(killsByRound[roundNumber] || [])].sort((left, right) => Number(left?.time_in_round_in_ms || 0) - Number(right?.time_in_round_in_ms || 0));
        const deathEvent = roundKills.find((kill) => this.matchEntityToPlayer(kill?.victim || {}, player, playerTeamId));

        if (deathEvent) {
          const killer = deathEvent?.killer || {};
          const killerPuuid = killer?.puuid || '';
          const killerName = (killer?.name || '').toLowerCase();
          const killerTag = (killer?.tag || '').toLowerCase();
          const deathTime = Number(deathEvent?.time_in_round_in_ms || 0);

          traded = roundKills.some((kill) => {
            const eventTime = Number(kill?.time_in_round_in_ms || 0);
            if (eventTime <= deathTime || eventTime - deathTime > 5000) {
              return false;
            }

            const killerTeam = String(kill?.killer?.team_id || kill?.killer?.team || '').toLowerCase();
            const victim = kill?.victim || {};
            const victimMatches = killerPuuid
              ? victim?.puuid === killerPuuid
              : ((victim?.name || '').toLowerCase() === killerName && (victim?.tag || '').toLowerCase() === killerTag);

            return Boolean(playerTeamId && killerTeam === playerTeamId && victimMatches);
          });
        }
      }

      return count + (kills > 0 || assists > 0 || survived || traded ? 1 : 0);
    }, 0);
  }

  extractMultiKillRounds(match) {
    const player = match?.player || {};
    const playerTeamId = String(player?.team_id || player?.team || '').toLowerCase();

    return (Array.isArray(match?.rounds) ? match.rounds : []).reduce((count, round) => {
      const entries = Array.isArray(round?.stats) ? round.stats : [];
      const playerRound = entries.find((entry) => this.matchEntityToPlayer(entry?.player || {}, player, playerTeamId)) || null;
      const kills = Number(playerRound?.stats?.kills || 0);
      return count + (kills >= 2 ? 1 : 0);
    }, 0);
  }

  extractFirstActionStats(match) {
    const player = match.player || {};
    const playerPuuid = player.puuid || '';
    const playerName = (player.name || '').toLowerCase();
    const playerTag = (player.tag || '').toLowerCase();
    const killsByRound = {};

    (match.kills || []).forEach((kill) => {
      const round = Number(kill.round || 0);
      if (!killsByRound[round]) {
        killsByRound[round] = [];
      }
      killsByRound[round].push(kill);
    });

    let firstKills = 0;
    let firstDeaths = 0;

    Object.values(killsByRound).forEach((roundKills) => {
      roundKills.sort((left, right) => Number(left.time_in_round_in_ms || 0) - Number(right.time_in_round_in_ms || 0));
      const firstKill = roundKills[0];
      if (!firstKill) return;

      const killer = firstKill.killer || {};
      const victim = firstKill.victim || {};
      const killerMatches = playerPuuid
        ? killer.puuid === playerPuuid
        : ((killer.name || '').toLowerCase() === playerName && (killer.tag || '').toLowerCase() === playerTag);
      const victimMatches = playerPuuid
        ? victim.puuid === playerPuuid
        : ((victim.name || '').toLowerCase() === playerName && (victim.tag || '').toLowerCase() === playerTag);

      if (killerMatches) firstKills += 1;
      if (victimMatches) firstDeaths += 1;
    });

    return { firstKills, firstDeaths };
  }

  extractObjectiveStats(match) {
    const player = match.player || {};
    const playerPuuid = player.puuid || '';
    const playerName = (player.name || '').toLowerCase();
    const playerTag = (player.tag || '').toLowerCase();
    let plants = 0;
    let defuses = 0;

    (match.rounds || []).forEach((round) => {
      const planter = round.plant?.player || {};
      const defuser = round.defuse?.player || {};
      const planterMatches = playerPuuid
        ? planter.puuid === playerPuuid
        : ((planter.name || '').toLowerCase() === playerName && (planter.tag || '').toLowerCase() === playerTag);
      const defuserMatches = playerPuuid
        ? defuser.puuid === playerPuuid
        : ((defuser.name || '').toLowerCase() === playerName && (defuser.tag || '').toLowerCase() === playerTag);

      if (planterMatches) plants += 1;
      if (defuserMatches) defuses += 1;
    });

    return { plants, defuses };
  }

  refreshRankedPanel() {
    const panel = document.getElementById('profileRankedPanelBody');
    const user = this.user || auth.user || {};
    if (panel) {
      panel.innerHTML = this.renderRankedPanel(user);
    }
  }

  setupFormHandlers() {
    const profileForm = document.getElementById('profileForm');
    if (!profileForm) return;
    profileForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      await this.saveAll();
    });
  }

  async uploadAvatar(input) {
    if (!input.files || !input.files[0]) return;
    const file = input.files[0];
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Erro', 'A imagem deve ter no máximo 5MB');
      return;
    }

    const formData = new FormData();
    formData.append('avatar', file);

    try {
      toast.info('Enviando...', 'Fazendo upload da imagem');
      const result = await api.uploadAvatar(formData);
      if (result.success) {
        const avatarUrl = result.data.avatar_url;
        if (this.user) this.user.avatar_url = avatarUrl;
        const avatarImg = document.getElementById('profileAvatar');
        if (avatarImg) avatarImg.src = avatarUrl + '?t=' + Date.now();
        const headerAvatar = document.getElementById('headerAvatar');
        if (headerAvatar) headerAvatar.src = avatarUrl + '?t=' + Date.now();
        const userAvatar = document.getElementById('userAvatar');
        if (userAvatar) userAvatar.src = avatarUrl + '?t=' + Date.now();
        if (auth.user) auth.user.avatar_url = avatarUrl;
        toast.success('Sucesso', 'Avatar atualizado com sucesso');
      }
    } catch (error) {
      toast.error('Erro', error.message || 'Falha ao enviar imagem');
    }
  }

  async clearAvatar() {
    try {
      const result = await api.updateProfile({ avatar_url: '' });
      if (result.success) {
        if (this.user) this.user.avatar_url = null;
        if (auth.user) auth.user.avatar_url = null;
        toast.success('Sucesso', 'Foto removida com sucesso');
        this.render();
      }
    } catch (error) {
      toast.error('Erro', error.message || 'Falha ao remover a foto');
    }
  }

  /**
   * Um submit só: identidade vai pela rota de perfil, bio+redes e highlight
   * pela rota de scouting. Um toast no fim, um render no fim.
   */
  async saveAll() {
    const displayName = document.getElementById('profileDisplayName')?.value.trim() || '';
    if (!displayName) {
      toast.error('Erro', 'Nome de exibição é obrigatório');
      return;
    }

    const social = this.collectSocialPayload();
    if (!social) return;

    const highlight = document.getElementById('profileHighlight1')?.value.trim() || '';
    if (highlight && !this.isSupportedMediaLink(highlight)) {
      toast.error('Erro', 'Use um link válido do YouTube, X, Instagram, Facebook ou vídeo direto');
      return;
    }

    const identity = {
      display_name: displayName,
      riot_id: document.getElementById('profileRiotId')?.value.trim() || '',
      riot_tag: (document.getElementById('profileRiotTag')?.value.trim() || '').replace(/^#+/, ''),
      riot_card_url: document.getElementById('profileRiotCardUrl')?.value.trim() || '',
      country: document.getElementById('profileCountry')?.value || 'BR',
      region: document.getElementById('profileRegion')?.value || null
    };

    // O backend limpa o highlight só quando recebe string vazia.
    const scouting = {
      ...social,
      youtube_highlight_1: highlight,
      youtube_highlight_2: '',
      youtube_highlight_3: ''
    };

    try {
      const [profileResult] = await Promise.all([
        api.updateProfile(identity),
        api.put('/scouting/social', scouting)
      ]);

      this.user = {
        ...(this.user || auth.user || {}),
        ...(profileResult?.data?.user || {}),
        ...identity,
        ...social,
        youtube_highlight_1: highlight || null,
        youtube_highlight_2: null,
        youtube_highlight_3: null
      };
      if (auth.user) Object.assign(auth.user, this.user);

      toast.success('Sucesso', 'Perfil atualizado');
      this.rankedOverview = null;
      this.profileTeams = null;
      this.render();
    } catch (error) {
      toast.error('Erro', error.message || 'Falha ao salvar o perfil');
    }
  }

  // ---------------------------------------------------
  // Redes — lista de linhas (rede no seletor + URL)
  // ---------------------------------------------------

  /** Colunas preenchidas do usuário viram linhas do editor. */
  getSocialRows(user) {
    return Profile.SOCIAL_NETWORKS
      .map(n => {
        const raw = String(user?.[n.field] || '').trim();
        if (!raw) return null;
        // twitch_username guarda só o handle — mostra como URL completa.
        const value = (n.key === 'twitch' && !/^https?:\/\//i.test(raw)) ? n.base + raw : raw;
        return { key: n.key, value };
      })
      .filter(Boolean);
  }

  /** Troca do seletor: atualiza ícone e placeholder da linha. */
  onSocialNetworkChange(select) {
    const row = select.closest('[data-social-row]');
    if (!row) return;
    const net = Profile.SOCIAL_NETWORKS.find(n => n.key === select.value);
    const iconWrap = row.querySelector('[data-social-icon]');
    const url = row.querySelector('[data-social-url]');

    if (iconWrap) {
      iconWrap.innerHTML = `<i class="${net ? net.icon : 'fas fa-share-nodes'}" aria-hidden="true"></i>`;
      iconWrap.style.color = net ? net.color : '';
    }
    if (url) {
      url.placeholder = net ? net.placeholder : 'https://…';
      if (net && !url.value.trim()) url.focus();
    }
  }

  addSocialRow() {
    const list = document.getElementById('profileSocialList');
    if (!list) return;
    const used = [...list.querySelectorAll('[data-social-key]')].map(s => s.value).filter(Boolean);
    if (used.length >= Profile.SOCIAL_NETWORKS.length) {
      toast.info('Redes', 'Todas as redes disponíveis já estão na lista.');
      return;
    }
    list.insertAdjacentHTML('beforeend', this.renderSocialRow('', '', list.children.length));
    list.lastElementChild?.querySelector('[data-social-key]')?.focus();
  }

  removeSocialRow(btn) {
    const row = btn.closest('[data-social-row]');
    const list = document.getElementById('profileSocialList');
    if (!row || !list) return;
    row.remove();
    // A lista nunca fica vazia — sem linha não há como adicionar de volta.
    if (!list.children.length) list.insertAdjacentHTML('beforeend', this.renderSocialRow('', '', 0));
  }

  /** Lê as linhas de rede + bio. Retorna null se houver rede repetida. */
  collectSocialPayload() {
    const rows = [...document.querySelectorAll('#profileSocialList [data-social-row]')];
    const payload = {};
    Profile.SOCIAL_NETWORKS.forEach(n => { payload[n.field] = null; });

    const seen = new Set();
    for (const row of rows) {
      const key = row.querySelector('[data-social-key]')?.value || '';
      const value = row.querySelector('[data-social-url]')?.value.trim() || '';
      if (!key || !value) continue;

      const net = Profile.SOCIAL_NETWORKS.find(n => n.key === key);
      if (!net) continue;
      if (seen.has(key)) {
        toast.error('Erro', `${net.label} aparece mais de uma vez.`);
        return null;
      }
      seen.add(key);

      // Twitch continua guardando só o handle (o card público monta a URL).
      payload[net.field] = net.key === 'twitch'
        ? value.replace(/^https?:\/\/(www\.)?twitch\.tv\//i, '').replace(/\/+$/, '')
        : value;
    }

    payload.bio = document.getElementById('profileBio')?.value.trim() || null;
    return payload;
  }

  /** Só troca o valor em tela — quem persiste é o "Salvar alterações". */
  setHighlightValue(url) {
    const value = (url || '').trim();
    const input = document.getElementById('profileHighlight1');
    if (input) input.value = value;

    const preview = document.getElementById('profileHighlightPreview');
    if (preview) {
      preview.innerHTML = this.renderHighlightPreviewCard(value, 1);
      this.initProfileMediaEmbeds(preview);
    }

    const remove = document.getElementById('profileHighlightRemove');
    if (remove) remove.hidden = !value;

    const cta = document.getElementById('profileHighlightCta');
    if (cta) cta.textContent = value ? 'Trocar vídeo' : 'Adicionar vídeo';
  }

  clearHighlightVideo() {
    this.setHighlightValue('');
  }

  async promptHighlightVideo() {
    const modal = app.createModal('Video em destaque', `
      <form id="highlightVideoModalForm" class="profile-highlight-modal-form">
        <div class="profile-highlight-modal-copy">
          <span class="profile-highlight-modal-kicker">Perfil publico</span>
          <h4>Atualize o vídeo exibido no card do player</h4>
          <p>Cole uma URL suportada do YouTube, X, Instagram, Facebook ou vídeo direto.</p>
        </div>
        <div class="form-group">
          <label for="highlightVideoModalInput">URL DO VIDEO</label>
          <div class="input-icon profile-highlight-modal-input">
            <i class="fas fa-link"></i>
            <input type="url" id="highlightVideoModalInput" class="form-input"
                   value="${this.user?.youtube_highlight_1 || ''}"
                   placeholder="https://www.youtube.com/watch?v=..."
                   autocomplete="off">
          </div>
        </div>
        <div class="profile-highlight-modal-actions">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="submit" class="btn btn-primary btn-glow">
            <i class="fas fa-check"></i> Salvar vídeo
          </button>
        </div>
      </form>
    `, { size: 'medium' });

    const form = modal.querySelector('#highlightVideoModalForm');
    const modalInput = modal.querySelector('#highlightVideoModalInput');
    modalInput?.focus();
    modalInput?.select();

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.setHighlightValue(modalInput?.value.trim() || '');
      document.querySelector('.app-modal-overlay')?.remove();
    });
  }

  schedulePublicMediaCardSync(root = document) {
    if (this.publicMediaSyncFrame) {
      cancelAnimationFrame(this.publicMediaSyncFrame);
      this.publicMediaSyncFrame = null;
    }

    this.publicMediaSyncFrame = requestAnimationFrame(() => {
      this.publicMediaSyncFrame = null;
      this.syncPublicMediaCardHeight(root);
    });
  }

  syncPublicMediaCardHeight(root = document) {
    if (this.mode !== 'view') return;

    const scope = root instanceof Element ? root : document;
    const heroBody = scope.querySelector('.profile-player-hero-body');
    const mediaCard = scope.querySelector('.profile-public-card-media');
    const mediaSingle = scope.querySelector('.profile-public-media-single');
    const preview = scope.querySelector('.profile-public-media-single .profile-highlight-preview');

    if (!heroBody || !mediaCard || !mediaSingle || !preview) {
      return;
    }

    const heroHeight = Math.ceil(heroBody.getBoundingClientRect().height);
    const heroWidth = Math.ceil(heroBody.getBoundingClientRect().width);
    if (!heroHeight) {
      return;
    }

    const mediaCardStyles = window.getComputedStyle(mediaCard);
    const verticalPadding = parseFloat(mediaCardStyles.paddingTop || '0') + parseFloat(mediaCardStyles.paddingBottom || '0');
    const contentHeight = Math.max(heroHeight - verticalPadding, 0);

    mediaCard.style.width = `${heroWidth}px`;
    mediaCard.style.maxWidth = '100%';
    mediaCard.style.height = `${heroHeight}px`;
    mediaCard.style.minHeight = `${heroHeight}px`;
    mediaSingle.style.height = `${contentHeight}px`;
    preview.style.height = '100%';
  }

}

const profile = new Profile();


/* ===== js/maps.js ===== */
// =====================================================
// ZDVAL - Maps Management Module
// Gerenciamento de mapas ativos/inativos do sistema
// =====================================================

class MapsManager {
  constructor() {
    this.maps = [];
    this.filter = 'active'; // active, inactive, all
  }

  // =====================================================
  // INITIALIZATION
  // =====================================================
  
  async load() {
    console.log('Loading Maps Manager...');
    this.render();
    await this.loadMaps();
  }

  render() {
    const container = document.getElementById('page-maps');
    if (!container) return;

    container.innerHTML = `
      <div class="maps-page-premium">
        <!-- Controls Premium -->
        <div class="maps-controls-premium">
          <div class="maps-filter-group">
            <label class="filter-label">Filtrar por:</label>
            <div class="maps-tabs-premium">
              <button class="map-tab-premium active" data-filter="active" onclick="mapsManager.setFilter('active')">
                <span class="tab-icon">✓</span>
                <span>Ativos</span>
                <div class="tab-indicator"></div>
              </button>
              <button class="map-tab-premium" data-filter="inactive" onclick="mapsManager.setFilter('inactive')">
                <span class="tab-icon">✕</span>
                <span>Inativos</span>
                <div class="tab-indicator"></div>
              </button>
              <button class="map-tab-premium" data-filter="all" onclick="mapsManager.setFilter('all')">
                <span class="tab-icon">📊</span>
                <span>Todos</span>
                <div class="tab-indicator"></div>
              </button>
            </div>
          </div>

          <div class="maps-actions-premium">
            <button class="maps-action-btn activate" onclick="mapsManager.activateAll()" title="Ativar todos">
              <i class="fas fa-check-double"></i>
              <span>Ativar Todos</span>
            </button>
            <button class="maps-action-btn deactivate" onclick="mapsManager.deactivateAll()" title="Desativar todos">
              <i class="fas fa-times-circle"></i>
              <span>Desativar Todos</span>
            </button>
          </div>
        </div>

        <!-- Grid Premium -->
        <div class="maps-grid-premium" id="mapsGrid"></div>
      </div>
    `;

    this.injectStyles();
  }

  injectStyles() {
    if (document.getElementById('maps-manager-styles')) return;
    
    // O CSS mora em css/pages/maps-manager.css. Ficava aqui como template string,
    // somando peso ao bundle de JS e impedindo que a folha fosse cacheada
    // e minificada em separado. Segue carregando sob demanda, como antes.
    Utils.loadPageCss('maps-manager-styles', 'maps-manager.css');
  }

  // =====================================================
  // API CALLS
  // =====================================================
  
  async loadMaps() {
    try {
      const response = await api.get('/maps');
      
      if (response.success) {
        this.maps = response.data.maps;
        // Atualizar cache global do app
        if (typeof app !== 'undefined') {
          app.setMaps(this.maps);
        }
        this.updateStats();
        this.renderMaps();
      }
    } catch (error) {
      console.error('Erro ao carregar mapas:', error);
      // No /admin nao existe `app` (nem toast): sem esse aviso o grid ficava
      // simplesmente vazio e a falha passava despercebida.
      const grid = document.getElementById('mapsGrid');
      if (grid) {
        grid.innerHTML = `
          <div class="maps-empty">
            <i class="fas fa-triangle-exclamation"></i>
            <strong>Nao foi possivel carregar os mapas</strong>
            <span>${error?.message || 'Tente recarregar a pagina'}</span>
          </div>
        `;
      }
      if (typeof app !== 'undefined' && app.showToast) {
        app.showToast('Erro ao carregar mapas', 'error');
      }
    }
  }

  async toggleMap(mapId) {
    try {
      const response = await api.post(`/maps/${mapId}/toggle`);
      
      if (response.success) {
        // Update local state
        const map = this.maps.find(m => m.id === mapId);
        if (map) {
          map.is_active = response.data.map.is_active;
        }
        
        // Atualizar cache global do app
        if (typeof app !== 'undefined') {
          app.setMaps(this.maps);
        }
        
        this.updateStats();
        this.renderMaps();
        if (typeof app !== 'undefined' && app.showToast) {
          app.showToast(response.message, 'success');
        }
      }
    } catch (error) {
      console.error('Erro ao alterar status do mapa:', error);
      if (typeof app !== 'undefined' && app.showToast) {
        app.showToast('Erro ao alterar status do mapa', 'error');
      }
    }
  }

  async activateAll() {
    if (!confirm('Ativar todos os mapas?')) return;
    
    try {
      const mapIds = this.maps.map(m => m.id);
      const response = await api.post('/maps/bulk', { map_ids: mapIds, is_active: true });
      
      if (response.success) {
        this.maps.forEach(m => m.is_active = true);
        // Atualizar cache global do app
        if (typeof app !== 'undefined') {
          app.setMaps(this.maps);
        }
        this.updateStats();
        this.renderMaps();
        if (typeof app !== 'undefined' && app.showToast) {
          app.showToast('Todos os mapas ativados', 'success');
        }
      }
    } catch (error) {
      console.error('Erro ao ativar mapas:', error);
      if (typeof app !== 'undefined' && app.showToast) {
        app.showToast('Erro ao ativar mapas', 'error');
      }
    }
  }

  async deactivateAll() {
    if (!confirm('Desativar todos os mapas? Isso afetará todo o sistema.')) return;
    
    try {
      const mapIds = this.maps.map(m => m.id);
      const response = await api.post('/maps/bulk', { map_ids: mapIds, is_active: false });
      
      if (response.success) {
        this.maps.forEach(m => m.is_active = false);
        // Atualizar cache global do app
        if (typeof app !== 'undefined') {
          app.setMaps(this.maps);
        }
        this.updateStats();
        this.renderMaps();
        if (typeof app !== 'undefined' && app.showToast) {
          app.showToast('Todos os mapas desativados', 'success');
        }
      }
    } catch (error) {
      console.error('Erro ao desativar mapas:', error);
      if (typeof app !== 'undefined' && app.showToast) {
        app.showToast('Erro ao desativar mapas', 'error');
      }
    }
  }

  // Bulk action handler for dropdown
  bulkAction(action) {
    if (!action) return;
    
    switch(action) {
      case 'activateAll':
        this.activateAll();
        break;
      case 'deactivateAll':
        this.deactivateAll();
        break;
    }
  }

  async syncMaps() {
    try {
      if (typeof app !== 'undefined' && app.showToast) {
        app.showToast('Sincronizando mapas...', 'info');
      }
      const response = await api.post('/maps/sync');
      
      if (response.success) {
        if (typeof app !== 'undefined' && app.showToast) {
          app.showToast(response.message, 'success');
        }
        await this.loadMaps();
      }
    } catch (error) {
      console.error('Erro ao sincronizar mapas:', error);
      if (typeof app !== 'undefined' && app.showToast) {
        app.showToast('Erro ao sincronizar mapas', 'error');
      }
    }
  }

  // =====================================================
  // RENDER METHODS
  // =====================================================
  
  updateStats() {
    // Stats cards removed
  }

  setFilter(filter) {
    this.filter = filter;
    
    // Update active tab - suporta ambos os estilos
    document.querySelectorAll('.filter-tab, .map-tab-premium, .settings-map-tab').forEach(tab => {
      tab.classList.toggle('active', tab.dataset.filter === filter);
    });
    
    this.renderMaps();
  }

  renderMaps() {
    const grid = document.getElementById('mapsGrid');
    if (!grid) return;

    let filteredMaps = this.maps;
    
    if (this.filter === 'active') {
      filteredMaps = this.maps.filter(m => m.is_active);
    } else if (this.filter === 'inactive') {
      filteredMaps = this.maps.filter(m => !m.is_active);
    }

    if (filteredMaps.length === 0) {
      grid.innerHTML = `
        <div class="maps-empty">
          <i class="fas fa-map"></i>
          <strong>Nenhum mapa encontrado</strong>
          <span>Tente ajustar os filtros</span>
        </div>
      `;
      return;
    }

    grid.innerHTML = filteredMaps.map(map => this.renderMapCard(map)).join('');
  }

  renderMapCard(map) {
    const statusClass = map.is_active ? 'active' : 'inactive';
    const statusText = map.is_active ? 'ATIVO' : 'INATIVO';
    const buttonClass = map.is_active ? 'deactivate' : 'activate';
    const buttonText = map.is_active ? 'Desativar' : 'Ativar';
    const buttonIcon = map.is_active ? 'fa-times-circle' : 'fa-check-circle';
    const statusIcon = map.is_active ? 'fa-check' : 'fa-ban';
    
    const imageUrl = map.splash || map.image_url || MapCatalog.splash('ascent');
    
    return `
      <div class="map-card-premium ${statusClass}">
        <div class="map-card-image-premium">
          <img src="${imageUrl}" alt="${map.display_name}" loading="lazy">
          <div class="map-status-badge-premium ${statusClass}">
            <i class="fas ${statusIcon}"></i>
            ${statusText}
          </div>
        </div>
        
        <div class="map-card-content-premium">
          <h3 class="map-card-title-premium">
            <span>${map.display_name}</span>
          </h3>
          
          <div class="map-card-stats-premium">
            <div class="map-stat-item">
              <i class="fas fa-crosshairs"></i>
              <span class="map-stat-value">${map.lineup_count || 0}</span>
              <span>Lineups</span>
            </div>
            <div class="map-stat-item">
              <i class="fas fa-chess"></i>
              <span class="map-stat-value">${map.tactic_count || 0}</span>
              <span>Táticas</span>
            </div>
            <div class="map-stat-item">
              <span class="map-stat-value">${map.folder_count || 0}</span>
              <span>Pastas</span>
            </div>
          </div>
          
          <button class="map-toggle-btn-premium ${buttonClass}" onclick="mapsManager.toggleMap('${map.id}')">
            <i class="fas ${buttonIcon}"></i>
            <span>${buttonText} Mapa</span>
          </button>
        </div>
      </div>
    `;
  }
}

// Global instance
const mapsManager = new MapsManager();


/* ===== js/ranked.js ===== */
// =====================================================
// ZDVAL - Ranked Stats Module
// Análise de Ranqueadas Competitivas dos jogadores
// =====================================================

class RankedStats {
  constructor() {
    this.container = document.getElementById('page-ranked');
    this.teamMembers = [];
    this.agentsData = null;
    this.mapsData = null;
    this.mapsCallouts = {}; // Callouts por mapa para análise de regiões
    this.loading = false;
    this.selectedPeriod = 'act';
    this.playerAnalysis = new Map(); // Cache de análises
    this.refreshInterval = null;
    this.REFRESH_INTERVAL = 60000; // Atualizar a cada 60 segundos
    this._inlinePeriodData = null;
    this.activeMainTab = 'ranked';
    this.inlineActiveSection = 'history';
    this.individualSelectedAgentKey = null;
    this.inlineAnalysisLoading = false;
    this.inlineAnalysisRequestId = 0;
    this._matchDetailsSource = new Map();
    this._matchDetailsHtmlCache = new Map();
    this._individualAnalysisCache = new Map();
    this.valorantPremiumCardBackground = MapCatalog.splash('sunset');
    this.jettMainCardBackground = 'https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/fullportrait.png';

    // Close dropdown on outside click
    document.addEventListener('click', (e) => {
      const dd = document.getElementById('inlinePeriodDropdown');
      if (dd && !dd.contains(e.target)) dd.classList.remove('open');

      if (!e.target.closest('.ia-agent-rmc-card--toggle')) {
        document.querySelectorAll('.ia-agent-card-dropdown.open').forEach((item) => item.classList.remove('open'));
      }

      const agentDd = document.getElementById('iaIndividualAgentDropdown');
      if (agentDd && !agentDd.contains(e.target)) agentDd.classList.remove('open');
    });
  }

  async load(params) {
    // Folha desta pagina, sob demanda. Estava no <head> do index.html, ou seja,
    // baixada em toda visita a qualquer pagina do site.
    Utils.loadPageCss('ranked-page-css', 'ranked.css');

    // Limpar intervalo anterior se existir
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }

    // Visitante sem conta cai direto no Ranking ZDVAL — é a aba gratuita e a
    // única que não depende de conta Riot.
    if (!this.isLoggedIn()) this.activeMainTab = 'zdranking';

    this.renderMainTabs();

    if (this.activeMainTab === 'zdranking') {
      await this.loadZdRanking();
      return;
    }

    // Ranqueadas mostra histórico/estatísticas de partida — sem consentimento
    // RSO do dono da conta, nem chega a pedir dado pro backend.
    if (!this.hasRankedAccess()) {
      this.renderRankedGate();
      return;
    }

    this.render();
    await this.loadStaticData();
    await this.loadMembers();

    // Configurar atualização automática
    this.refreshInterval = setInterval(() => {
      if (app.currentPage === 'ranked' && this.activeMainTab === 'ranked') {
        this.refreshAllStats();
      }
    }, this.REFRESH_INTERVAL);
  }

  renderMainTabs() {
    this.container = document.getElementById('page-ranked');
    if (!this.container) return;

    // Remove app-level placeholder injected during navigation.
    // Ranked renders inside its own content container, so this placeholder
    // must be explicitly cleared to avoid a persistent "Carregando..." block.
    const staleLoader = this.container.querySelector('.loading-placeholder');
    if (staleLoader) staleLoader.remove();

    // Tab bar: "Ranqueadas" (dado da Riot, por jogador) e "Ranking ZDVAL"
    // (pontuação de scrim própria). As duas abas são gratuitas.
    let tabBar = this.container.querySelector('.ranked-main-tabs');
    if (!tabBar) {
      tabBar = document.createElement('div');
      tabBar.className = 'ranked-main-tabs';
      tabBar.innerHTML = `
        <button class="ranked-main-tab" data-main-tab="ranked">
          <i class="fas fa-chart-line"></i> Ranqueadas
        </button>
        <button class="ranked-main-tab" data-main-tab="zdranking">
          <i class="fas fa-trophy"></i> Ranking ZDVAL
          <span class="ranked-tab-badge">Grátis</span>
        </button>
      `;
      tabBar.querySelectorAll('.ranked-main-tab').forEach((btn) => {
        btn.addEventListener('click', () => this.switchMainTab(btn.dataset.mainTab));
      });
      this.container.prepend(tabBar);
    }
    this.syncTabButtons();

    // Ensure content container exists
    let content = this.container.querySelector('.ranked-tab-content');
    if (!content) {
      content = document.createElement('div');
      content.className = 'ranked-tab-content';
      content.id = 'rankedTabContent';
      this.container.appendChild(content);
    }
  }

  // =====================================================
  // ACESSO À ABA "RANQUEADAS" (política da Riot API)
  //
  // Histórico de partidas e estatísticas de jogador exigem OAuth com RSO. O
  // backend recusa em valorantRoutes; aqui o front explica o motivo em vez de
  // disparar chamada que já nasce 403.
  // =====================================================
  isLoggedIn() {
    return Boolean(typeof auth !== 'undefined' && auth && auth.isAuthenticated);
  }

  hasRankedAccess() {
    return this.isLoggedIn() && auth.user?.riot_link_method === 'rso';
  }

  renderRankedGate() {
    const content = document.getElementById('rankedTabContent') || this.container;
    const logged = this.isLoggedIn();

    const body = logged
      ? `
        <div class="empty-icon"><i class="fab fa-r-project"></i></div>
        <h3>Conecte sua conta da Riot</h3>
        <p>
          Histórico de partidas e estatísticas só aparecem depois que você
          autoriza a zdval pelo login da Riot (RSO). É exigência da Riot Games:
          nenhum dado de partida é exibido sem a autorização do dono da conta.
        </p>
        <button class="btn btn-primary" onclick="rankedStats.connectRiot()">
          <i class="fas fa-link"></i> Conectar conta da Riot
        </button>
      `
      : `
        <div class="empty-icon"><i class="fas fa-right-to-bracket"></i></div>
        <h3>Entre para ver suas ranqueadas</h3>
        <p>
          Esta aba mostra o histórico de partidas da sua conta da Riot e precisa
          da sua autorização. O <strong>Ranking ZDVAL</strong> ao lado é aberto e
          não exige conta.
        </p>
        <div class="empty-actions">
          <button class="btn btn-primary" onclick="auth.openAuth('login')">
            <i class="fas fa-right-to-bracket"></i> Entrar
          </button>
          <button class="btn btn-secondary" onclick="rankedStats.switchMainTab('zdranking')">
            <i class="fas fa-trophy"></i> Ver Ranking ZDVAL
          </button>
        </div>
      `;

    content.innerHTML = `
      <div class="ranked-container">
        <div class="ranked-page-header">
          <div class="ranked-title-row">
            <div class="ranked-title-block">
              <div>
                <h1>RANQUEADAS</h1>
                <span class="ranked-subtitle">Análise de partidas competitivas</span>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-state">${body}</div>
      </div>
    `;
  }

  async connectRiot() {
    // O RSO só liga depois que a Riot aprova o app e as credenciais entram no
    // ambiente. Antes disso o botão explica em vez de mandar pra um 500.
    if (typeof auth !== 'undefined' && await auth.isRiotSsoEnabled()) {
      window.location.href = '/api/auth/riot';
      return;
    }
    toast.warning(
      'Integração com a Riot em aprovação',
      'O login RSO ainda não foi liberado pra zdval. Assim que sair, esta aba abre sozinha.'
    );
  }

  syncTabButtons() {
    this.container.querySelectorAll('.ranked-main-tab').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.mainTab === this.activeMainTab);
    });
  }

  async switchMainTab(tab) {
    if (tab === this.activeMainTab) return;
    this.activeMainTab = tab;
    this.syncTabButtons();

    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }

    if (tab === 'zdranking') {
      await this.loadZdRanking();
      return;
    }

    if (!this.hasRankedAccess()) {
      this.renderRankedGate();
      return;
    }

    this.render();
    await this.loadStaticData();
    await this.loadMembers();
    this.refreshInterval = setInterval(() => {
      if (app.currentPage === 'ranked' && this.activeMainTab === 'ranked') {
        this.refreshAllStats();
      }
    }, this.REFRESH_INTERVAL);
  }

  // =====================================================
  // RANKING ZDVAL — pontuação de scrim, acesso livre
  //
  // Política da Riot: esta aba não é elo, não é ranqueada e não substitui o
  // ranking oficial de VALORANT. A pontuação sai dos scoreboards que os
  // próprios usuários sobem (player_stats.source = 'manual'). O aviso abaixo
  // é obrigatório e não deve ser removido.
  // =====================================================
  async loadZdRanking(page = 1) {
    const content = document.getElementById('rankedTabContent') || this.container;
    this.zdRankingPage = page;

    content.innerHTML = `
      <div class="zdranking">
        <div class="zdranking-header">
          <div>
            <h1>RANKING ZDVAL</h1>
            <span class="zdranking-subtitle">Desempenho em scrims — acesso gratuito para todos</span>
          </div>
          <div class="zdranking-search">
            <i class="fas fa-search"></i>
            <input type="text" id="zdRankingSearch" placeholder="Buscar jogador ou Riot ID...">
          </div>
        </div>

        <div class="zdranking-notice">
          <i class="fas fa-circle-info"></i>
          <p>
            <strong>Não é elo.</strong> A pontuação ZDVAL mede desempenho em scrims e é
            calculada a partir dos scoreboards que os próprios jogadores enviam para a
            plataforma. Não usa dados da API da Riot, não é uma classificação de
            habilidade e não substitui o ranqueado oficial de VALORANT.
          </p>
        </div>

        <div id="zdRankingList" class="zdranking-list">
          <div class="zdranking-loading"><i class="fas fa-spinner fa-spin"></i> Carregando ranking...</div>
        </div>
        <div id="zdRankingPager" class="zdranking-pager"></div>
      </div>
    `;

    const searchInput = document.getElementById('zdRankingSearch');
    if (searchInput) {
      let debounce = null;
      searchInput.value = this.zdRankingSearch || '';
      searchInput.addEventListener('input', (e) => {
        clearTimeout(debounce);
        this.zdRankingSearch = e.target.value.trim();
        debounce = setTimeout(() => this.fetchZdRanking(1), 400);
      });
    }

    await this.fetchZdRanking(page);
  }

  async fetchZdRanking(page = 1) {
    const list = document.getElementById('zdRankingList');
    if (!list) return;

    list.innerHTML = '<div class="zdranking-loading"><i class="fas fa-spinner fa-spin"></i> Carregando ranking...</div>';

    try {
      const result = await api.getScoutingRanking({
        page,
        limit: 50,
        search: this.zdRankingSearch || ''
      });

      const players = result?.data?.players || [];
      if (!players.length) {
        list.innerHTML = `
          <div class="empty-state">
            <div class="empty-icon"><i class="fas fa-trophy"></i></div>
            <h3>Nenhum jogador no ranking ainda</h3>
            <p>A pontuação aparece depois de pelo menos 3 scoreboards enviados.</p>
          </div>
        `;
        document.getElementById('zdRankingPager').innerHTML = '';
        return;
      }

      const offset = (page - 1) * 50;
      list.innerHTML = players.map((p, i) => this.renderZdRankingRow(p, offset + i + 1)).join('');
      this.renderZdRankingPager(result.data, page);
    } catch (error) {
      console.error('Erro ao carregar ranking ZDVAL:', error);
      list.innerHTML = `
        <div class="empty-state">
          <div class="empty-icon"><i class="fas fa-triangle-exclamation"></i></div>
          <h3>Não foi possível carregar o ranking</h3>
          <p>Tente novamente em instantes.</p>
        </div>
      `;
    }
  }

  renderZdRankingRow(player, position) {
    const name = player.display_name || player.username || 'Jogador';
    // riot_tag é gravado com e sem '#' conforme a origem do cadastro — normaliza
    // pra não renderizar 'prince##zudo'.
    const rawTag = String(player.riot_tag || '').replace(/^#+/, '');
    const riotLabel = player.riot_id ? `${player.riot_id}${rawTag ? `#${rawTag}` : ''}` : '';
    const avatar = player.avatar_url || '/img/default-avatar.png';
    const score = Number(player.scouting_score || 0).toFixed(1);
    const teams = Array.isArray(player.teams) ? player.teams : [];
    const teamLabel = teams.length ? (teams[0].team_tag || teams[0].team_name || '') : '';
    const medal = position <= 3 ? ` zdranking-row--top${position}` : '';

    return `
      <div class="zdranking-row${medal}" onclick="app.navigate('profile', { userId: '${this.escapeZd(player.id)}' })">
        <span class="zdranking-pos">${position}</span>
        <img class="zdranking-avatar" src="${this.escapeZd(avatar)}" alt="" onerror="this.src='/img/default-avatar.png'">
        <div class="zdranking-identity">
          <span class="zdranking-name">${this.escapeZd(name)}</span>
          ${riotLabel ? `<span class="zdranking-riot">${this.escapeZd(riotLabel)}</span>` : ''}
        </div>
        ${teamLabel ? `<span class="zdranking-team">${this.escapeZd(teamLabel)}</span>` : '<span class="zdranking-team"></span>'}
        ${player.is_live ? '<span class="zdranking-live">AO VIVO</span>' : ''}
        <span class="zdranking-score">${score}</span>
      </div>
    `;
  }

  renderZdRankingPager(data, page) {
    const pager = document.getElementById('zdRankingPager');
    if (!pager) return;

    const totalPages = data.total_pages || 1;
    if (totalPages <= 1) {
      pager.innerHTML = '';
      return;
    }

    pager.innerHTML = `
      <button class="btn btn-secondary" ${page <= 1 ? 'disabled' : ''} data-zd-page="${page - 1}">
        <i class="fas fa-chevron-left"></i> Anterior
      </button>
      <span class="zdranking-pager-info">Página ${page} de ${totalPages} · ${data.total} jogadores</span>
      <button class="btn btn-secondary" ${page >= totalPages ? 'disabled' : ''} data-zd-page="${page + 1}">
        Próxima <i class="fas fa-chevron-right"></i>
      </button>
    `;

    pager.querySelectorAll('[data-zd-page]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        this.fetchZdRanking(parseInt(btn.dataset.zdPage, 10));
      });
    });
  }

  escapeZd(value) {
    return String(value ?? '').replace(/[&<>"']/g, (c) => (
      { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
    ));
  }

  // Atualização silenciosa (sem recarregar toda a página)
  async refreshAllStats() {
    if (this.loading || this.inlineAnalysisLoading) return;
    console.log('Atualizando stats automaticamente...');
    const self = this.teamMembers.find(m => m._isSelf);
    if (self && self.riot_id && self.riot_tag) {
      await this.loadInlineAnalysis(self);
    }
  }

  async loadStaticData() {
    try {
      // Carregar dados de agentes e mapas em paralelo
      const [agentsResult, mapsResult] = await Promise.all([
        api.getValorantAgents(),
        api.getValorantMaps()
      ]);
      
      if (agentsResult.data) {
        this.agentsData = {};
        agentsResult.data.forEach(agent => {
          this.agentsData[agent.displayName.toLowerCase()] = agent;
        });
      }
      
      if (mapsResult.data) {
        this.mapsData = {};
        this.mapsCallouts = {};
        this.mapsMultipliers = {};
        
        mapsResult.data.forEach(map => {
          const mapKey = map.displayName.toLowerCase();
          this.mapsData[mapKey] = map;
          
          // Armazenar callouts para análise de regiões
          if (map.callouts) {
            this.mapsCallouts[mapKey] = map.callouts;
          }
          
          const xMult = map.xMultiplier || 0;
          const yMult = map.yMultiplier || 0;
          const xAdd = map.xScalarToAdd || 0;
          const yAdd = map.yScalarToAdd || 0;
          
          // Calcular bounds automaticamente a partir dos callouts
          // Os callouts definem a área jogável do mapa em coordenadas normalizadas
          let minX = Infinity, maxX = -Infinity;
          let minY = Infinity, maxY = -Infinity;
          
          if (map.callouts && map.callouts.length > 0 && xMult !== 0) {
            map.callouts.forEach(callout => {
              const loc = callout.location;
              if (loc && loc.x !== undefined && loc.y !== undefined) {
                const normX = loc.x * xMult + xAdd;
                const normY = loc.y * yMult + yAdd;
                minX = Math.min(minX, normX);
                maxX = Math.max(maxX, normX);
                minY = Math.min(minY, normY);
                maxY = Math.max(maxY, normY);
              }
            });
            
            // Adicionar uma margem pequena para acomodar eventos muito próximos das bordas
            // sem empurrar os pontos para fora do traçado útil do minimapa oficial.
            const rangeX = maxX - minX;
            const rangeY = maxY - minY;
            minX -= rangeX * 0.04;
            maxX += rangeX * 0.04;
            minY -= rangeY * 0.04;
            maxY += rangeY * 0.04;
          } else {
            // Fallback se não houver callouts
            minX = 0; maxX = 1; minY = 0; maxY = 1;
          }
          
          // Armazenar multiplicadores, bounds e displayIcon
          this.mapsMultipliers[mapKey] = {
            xMultiplier: xMult,
            yMultiplier: yMult,
            xScalarToAdd: xAdd,
            yScalarToAdd: yAdd,
            minX,
            maxX,
            minY,
            maxY,
            displayIcon: map.displayIcon
          };
        });
      }
    } catch (error) {
      console.warn('Could not load static data:', error);
    }
  }

  // Build member object from the currently logged-in user
  buildSelfMember() {
    const u = auth?.user;
    if (!u) return null;
    return {
      id: u.id,
      display_name: u.display_name || u.username,
      username: u.username,
      avatar_url: u.avatar_url,
      riot_id: u.riot_id || null,
      riot_tag: u.riot_tag || null,
      role: 'player',
      region: 'br',
      _isSelf: true
    };
  }

  render() {
    const content = document.getElementById('rankedTabContent') || this.container;
    const u = auth?.user;
    const avatarUrl = u?.avatar_url || '';
    const riotId = u?.riot_id || '';
    const riotTag = u?.riot_tag || '';
    const nameLabel = riotId ? `${riotId}#${riotTag}` : (u?.display_name || '');

    content.innerHTML = `
      <div class="ranked-inline-analysis" id="rankedInlineAnalysis">
        ${renderPremiumPreload('Carregando análise de ranqueadas...', nameLabel, avatarUrl)}
      </div>
    `;
  }

  async loadMembers() {
    try {
      const selfMember = this.buildSelfMember();
      let teamMembers = [];

      // If user has a team, also load teammates
      if (app.currentTeam) {
        const result = await api.getTeam(app.currentTeam.id);
        if (result.success) {
          const playerRoles = ['player', 'igl'];
          teamMembers = result.data.members.filter(m => playerRoles.includes(m.role));
        }
      }

      // Merge: self first (if not already in team list), then teammates
      const selfId = selfMember?.id;
      const others = teamMembers.filter(m => m.id !== selfId && m.user_id !== selfId);

      if (selfMember) {
        // Enrich self with team data if present (avatar, region, etc.)
        const teamSelf = teamMembers.find(m => m.id === selfId || m.user_id === selfId);
        if (teamSelf) {
          selfMember.role = teamSelf.role || selfMember.role;
          selfMember.region = teamSelf.region || selfMember.region;
          if (teamSelf.avatar_url) selfMember.avatar_url = teamSelf.avatar_url;
        }
        this.teamMembers = [selfMember, ...others];
      } else {
        this.teamMembers = others;
      }

      console.log('Ranked - Members loaded:', this.teamMembers.length);

      // Directly load analysis for self if has riot_id
      const self = this.teamMembers.find(m => m._isSelf);
      if (self && self.riot_id && self.riot_tag) {
        await this.loadInlineAnalysis(self);
      } else {
        // Show empty state - configure riot_id
        const container = document.getElementById('rankedInlineAnalysis');
        container.innerHTML = `
          <div class="ranked-container">
            <div class="ranked-page-header">
              <div class="ranked-title-row">
                <div class="ranked-title-block">
                  <div>
                    <h1>RANQUEADAS</h1>
                    <span class="ranked-subtitle">Análise de partidas competitivas</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="empty-state">
              <div class="empty-icon"><i class="fas fa-id-card"></i></div>
              <h3>Configure seu Riot ID</h3>
              <p>Adicione seu Riot ID no perfil para acompanhar suas ranqueadas</p>
              <button class="btn btn-primary" onclick="app.navigate('profile', { mode: 'edit', tab: 'profile' })">
                <i class="fas fa-user-edit"></i> Editar Perfil
              </button>
            </div>
          </div>
        `;
      }
    } catch (error) {
      console.error('Error loading members:', error);
      this.renderError();
    }
  }

  async loadAllPlayersStats() {
    // Buscar stats de cada jogador sequencialmente com delay maior
    for (const member of this.teamMembers) {
      if (member.riot_id && member.riot_tag) {
        await this.loadPlayerQuickStats(member);
        // Delay de 2.5 segundos entre requests para respeitar rate limit (30/min)
        await new Promise(resolve => setTimeout(resolve, 2500));
      }
    }
  }

  async loadPlayerQuickStats(member, retryCount = 0) {
    const maxRetries = 3;
    
    try {
      const region = this.normalizeValorantRegion(member.region || 'br');
      const name = member.riot_id;
      const tag = member.riot_tag;

      // Mostrar loading
      this.updateStatElement(`rank-${member.id}`, '...', 'loading');
      this.updateStatElement(`kd-${member.id}`, '...', 'loading');
      this.updateStatElement(`winrate-${member.id}`, '...', 'loading');

      // Buscar MMR primeiro, depois matches (sequencial para evitar rate limit)
      let mmrResult = null;
      let matchesResult = null;
      
      try {
        mmrResult = await api.getValorantMMR(region, name, tag);
      } catch (e) {
        console.log(`MMR fetch failed for ${name}: ${e.message}`);
      }
      
      // Pequeno delay entre as duas chamadas
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      try {
        matchesResult = await api.getValorantMatches(region, name, tag, 'competitive', 20);
      } catch (e) {
        console.log(`Matches fetch failed for ${name}: ${e.message}`);
      }

      // Atualizar Rank com imagem
      if (mmrResult?.success && mmrResult?.data?.currenttierpatched) {
        const rank = this.simplifyRank(mmrResult.data.currenttierpatched);
        const rankImage = mmrResult.data.images?.small || '';
        this.updateRankElement(`rank-${member.id}`, rank, rankImage);
      } else if (retryCount < maxRetries) {
        // Retry after delay
        console.log(`Retry ${retryCount + 1} for ${name}`);
        await new Promise(resolve => setTimeout(resolve, 5000));
        return this.loadPlayerQuickStats(member, retryCount + 1);
      } else {
        this.updateStatElement(`rank-${member.id}`, 'N/A', 'error');
      }

      // Calcular K/D e Win Rate das partidas
      if (matchesResult?.success && matchesResult?.data?.matches?.length > 0) {
        const matches = matchesResult.data.matches;
        let totalKills = 0;
        let totalDeaths = 0;
        let wins = 0;

        matches.forEach(match => {
          const player = match.player;
          if (!player) return;

          totalKills += player.stats?.kills || 0;
          totalDeaths += player.stats?.deaths || 0;

          // Verificar vitória - usar team_id do player
          const playerTeamId = (player.team_id || player.team || '').toLowerCase();
          
          // teams pode ser array ou objeto
          let playerWon = false;
          if (Array.isArray(match.teams)) {
            const playerTeamData = match.teams.find(t => t.team_id?.toLowerCase() === playerTeamId);
            playerWon = playerTeamData?.won === true;
          } else if (match.teams) {
            // Formato objeto {red: {...}, blue: {...}}
            const teamData = match.teams[playerTeamId];
            playerWon = teamData?.has_won === true || teamData?.won === true;
          }
          
          if (playerWon) {
            wins++;
          }
        });

        // Calcular e atualizar K/D
        const kd = totalDeaths > 0 ? (totalKills / totalDeaths).toFixed(2) : totalKills.toFixed(2);
        const kdColor = parseFloat(kd) >= 1.2 ? '#4ade80' : (parseFloat(kd) < 1.0 ? '#ef4444' : '#fbbf24');
        this.updateStatElement(`kd-${member.id}`, kd, 'success', kdColor);

        // Calcular e atualizar Win Rate
        const winRate = Math.round((wins / matches.length) * 100);
        const winColor = winRate >= 55 ? '#4ade80' : (winRate < 45 ? '#ef4444' : '#fbbf24');
        this.updateStatElement(`winrate-${member.id}`, `${winRate}%`, 'success', winColor);
      } else {
        this.updateStatElement(`kd-${member.id}`, 'N/A', 'error');
        this.updateStatElement(`winrate-${member.id}`, 'N/A', 'error');
      }
    } catch (error) {
      console.warn(`Failed to load stats for ${member.display_name}:`, error);
      this.updateStatElement(`rank-${member.id}`, 'Erro', 'error');
      this.updateStatElement(`kd-${member.id}`, 'Erro', 'error');
      this.updateStatElement(`winrate-${member.id}`, 'Erro', 'error');
    }
  }

  updateRankElement(id, rankText, rankImage) {
    const el = document.getElementById(id);
    if (!el) return;
    
    el.classList.remove('stat-pending', 'stat-loading', 'stat-error');
    
    if (rankImage) {
      el.innerHTML = `<img src="${rankImage}" alt="${rankText}" class="rank-icon" title="${rankText}"><span class="rank-text">${rankText}</span>`;
    } else {
      el.textContent = rankText;
    }
  }

  updateStatElement(id, value, status, color = null) {
    const el = document.getElementById(id);
    if (!el) return;
    
    el.textContent = value;
    el.classList.remove('stat-pending', 'stat-loading', 'stat-error');
    
    if (status === 'loading') {
      el.classList.add('stat-loading');
      el.style.color = '#888';
    } else if (status === 'error') {
      el.classList.add('stat-error');
      el.style.color = '#888';
    } else if (status === 'success' && color) {
      el.style.color = color;
    }
  }

  simplifyRank(rankName) {
    if (!rankName) return '--';
    
    // Mapeamento de ranks
    const rankMap = {
      'Iron': 'I',
      'Bronze': 'B',
      'Silver': 'S',
      'Gold': 'G',
      'Platinum': 'P',
      'Diamond': 'D',
      'Ascendant': 'A',
      'Immortal': 'IM',
      'Radiant': 'RAD'
    };

    // Ex: "Diamond 2" -> "D2", "Immortal 3" -> "IM3"
    const parts = rankName.split(' ');
    if (parts.length >= 2) {
      const tier = rankMap[parts[0]] || parts[0].charAt(0);
      return `${tier}${parts[1]}`;
    }
    
    return rankMap[rankName] || rankName;
  }

  normalizeValorantRegion(region) {
    const normalized = String(region || '').trim().toLowerCase();
    const regionMap = {
      'america-sul': 'br',
      'america-norte': 'na',
      europa: 'eu',
      asia: 'ap',
      oceania: 'ap',
      africa: 'eu',
      'oriente-medio': 'eu',
      br: 'br',
      na: 'na',
      eu: 'eu',
      ap: 'ap',
      kr: 'kr',
      latam: 'latam'
    };

    return regionMap[normalized] || 'br';
  }

  getMatchPlayers(match) {
    const rawPlayers = match?.players;

    if (Array.isArray(rawPlayers)) return rawPlayers;
    if (Array.isArray(rawPlayers?.all_players)) return rawPlayers.all_players;
    if (Array.isArray(rawPlayers?.players)) return rawPlayers.players;
    if (Array.isArray(match?.all_players)) return match.all_players;

    if (rawPlayers && typeof rawPlayers === 'object') {
      const groupedPlayers = Object.values(rawPlayers)
        .filter((value) => Array.isArray(value))
        .flat();

      if (groupedPlayers.length > 0) return groupedPlayers;
    }

    return [];
  }

  resolvePlayerAgentKey(player) {
    const normalizeAgentCandidate = (value) => {
      if (value === undefined || value === null) return '';
      const raw = String(value).trim();
      if (!raw) return '';

      const lower = raw.toLowerCase();
      if (this.agentsData?.[lower]) return lower;

      const compact = lower.replace(/[^a-z0-9]/g, '');
      if (compact && this.agentsData?.[compact]) return compact;

      const byDisplayName = Object.entries(this.agentsData || {}).find(([, agent]) => {
        const name = String(agent?.displayName || agent?.name || '').toLowerCase();
        return name && name === lower;
      });
      if (byDisplayName) return byDisplayName[0];

      const byId = Object.entries(this.agentsData || {}).find(([, agent]) => {
        const id = String(agent?.uuid || agent?.id || '').toLowerCase();
        return id && id === lower;
      });
      if (byId) return byId[0];

      return lower;
    };

    const candidates = [
      player?.agent?.name,
      player?.agent?.displayName,
      player?.agent,
      player?.character?.name,
      player?.character?.displayName,
      player?.character,
      player?.character_id,
      player?.agent_id
    ];

    for (const candidate of candidates) {
      if (candidate && typeof candidate === 'object') {
        const nested = [candidate?.name, candidate?.displayName, candidate?.id, candidate?.uuid];
        for (const nestedCandidate of nested) {
          const key = normalizeAgentCandidate(nestedCandidate);
          if (key) return key;
        }
        continue;
      }

      const key = normalizeAgentCandidate(candidate);
      if (key) return key;
    }

    return 'unknown';
  }

  resolvePlayerAgentLabel(player, fallbackKey = 'unknown') {
    const directLabel = player?.agent?.name
      || player?.agent?.displayName
      || player?.character?.name
      || player?.character?.displayName
      || (typeof player?.agent === 'string' ? player.agent : '')
      || (typeof player?.character === 'string' ? player.character : '');

    if (directLabel) {
      return directLabel;
    }

    const agentInfo = this.agentsData?.[fallbackKey] || null;
    return agentInfo?.displayName || this.capitalizeFirst(fallbackKey);
  }

  getAgentGradientStyle(agentKey) {
    const gc = this.agentsData?.[agentKey]?.backgroundGradientColors || [];
    const g0 = gc[0] ? '#' + gc[0].slice(0, 6) : '#1a1a2e';
    const g1 = gc[1] ? '#' + gc[1].slice(0, 6) : '#0f1923';
    const g2 = gc[2] ? '#' + gc[2].slice(0, 6) : '#1a1a2e';
    return `background:linear-gradient(160deg, ${g0} 0%, ${g1} 50%, ${g2} 100%)`;
  }

  getAgentGradientVars(agentKey) {
    const gc = this.agentsData?.[agentKey]?.backgroundGradientColors || [];
    const g0 = gc[0] ? '#' + gc[0].slice(0, 6) : '#1a1a2e';
    const g1 = gc[1] ? '#' + gc[1].slice(0, 6) : '#0f1923';
    const g2 = gc[2] ? '#' + gc[2].slice(0, 6) : '#1a1a2e';
    return { g0, g1, g2 };
  }

  renderPlayersGrid() {
    const grid = document.getElementById('rankedPlayersGrid');
    
    if (this.teamMembers.length === 0) {
      grid.innerHTML = `
        <div class="empty-state">
          <div class="empty-icon">
            <i class="fas fa-id-card"></i>
          </div>
          <h3>Configure seu Riot ID</h3>
          <p>Adicione seu Riot ID no perfil para acompanhar suas ranqueadas</p>
          <button class="btn btn-primary" onclick="app.navigate('profile', { mode: 'edit', tab: 'profile' })">
            <i class="fas fa-user-edit"></i>
            <span>Editar Perfil</span>
          </button>
        </div>
      `;
      return;
    }

    grid.innerHTML = this.teamMembers.map(member => this.renderPlayerCard(member)).join('');

    // If only self without riot id, show helpful message
    if (this.teamMembers.length === 1 && this.teamMembers[0]._isSelf && !this.teamMembers[0].riot_id) {
      grid.innerHTML = `
        <div class="empty-state">
          <div class="empty-icon">
            <i class="fas fa-id-card"></i>
          </div>
          <h3>Configure seu Riot ID</h3>
          <p>Adicione seu Riot ID no perfil para acompanhar suas ranqueadas</p>
          <button class="btn btn-primary" onclick="app.navigate('profile', { mode: 'edit', tab: 'profile' })">
            <i class="fas fa-user-edit"></i>
            <span>Editar Perfil</span>
          </button>
        </div>
      `;
    }
  }

  renderPlayerCard(member) {
    const hasAvatar = member.avatar_url && member.avatar_url !== '' && member.avatar_url !== 'null';
    const memberInitial = (member.display_name || member.username || '?').charAt(0).toUpperCase();
    const isIGL = member.role === 'igl';
    
    const roleLabels = {
      player: { label: 'Player', icon: '🎮', color: 'success' },
      igl: { label: 'IGL', icon: '👑', color: 'warning' }
    };
    
    const roleInfo = roleLabels[member.role] || { label: member.role, icon: '👤', color: 'secondary' };

    // Verifica se tem Riot ID configurado (riot_id e riot_tag são campos separados no banco)
    const hasRiotId = member.riot_id && member.riot_tag;
    const fullRiotId = hasRiotId ? `${member.riot_id}#${member.riot_tag}` : null;

    return `
      <div class="ranked-player-card ${isIGL ? 'is-igl' : ''} ${member._isSelf ? 'is-self' : ''}" data-member-id="${member.id}">
        <div class="ranked-card-glow"></div>
        <div class="ranked-card-content">
          ${member._isSelf ? '<div class="ranked-self-badge"><i class="fas fa-user"></i> Você</div>' : ''}
          
          <!-- Header com Avatar e Info Básica -->
          <div class="ranked-card-header">
            <div class="ranked-avatar-wrapper">
              <div class="ranked-avatar-ring ${isIGL ? 'ring-gold' : ''} ${member._isSelf ? 'ring-self' : ''}">
                ${hasAvatar ? `
                  <img src="${member.avatar_url}" 
                       alt="${member.display_name}" 
                       class="ranked-avatar-img"
                       onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
                  <div class="ranked-avatar-fallback" style="display:none;">
                    <span>${memberInitial}</span>
                  </div>
                ` : `
                  <div class="ranked-avatar-fallback">
                    <span>${memberInitial}</span>
                  </div>
                `}
              </div>
            </div>
            
            <div class="ranked-player-info">
              <h3 class="ranked-player-name">${member.display_name || member.username}</h3>
              ${hasRiotId ? `<span class="ranked-riot-id">${fullRiotId}</span>` : ''}
              <div class="ranked-role-badge badge-${roleInfo.color}">
                <span class="role-icon">${roleInfo.icon}</span>
                <span class="role-label">${roleInfo.label}</span>
              </div>
            </div>
          </div>
          
          <!-- Stats Preview -->
          <div class="ranked-stats-preview">
            <div class="ranked-stat-item">
              <i class="fas fa-trophy"></i>
              <span class="stat-label">Rank</span>
              <span class="stat-value stat-pending" id="rank-${member.id}">--</span>
            </div>
            <div class="ranked-stat-item">
              <i class="fas fa-crosshairs"></i>
              <span class="stat-label">K/D</span>
              <span class="stat-value stat-pending" id="kd-${member.id}">--</span>
            </div>
            <div class="ranked-stat-item">
              <i class="fas fa-percentage"></i>
              <span class="stat-label">Win%</span>
              <span class="stat-value stat-pending" id="winrate-${member.id}">--</span>
            </div>
          </div>
          
          <!-- Actions -->
          <div class="ranked-card-actions">
            ${hasRiotId ? `
              <button class="btn-ranked-action btn-view-profile" onclick="rankedStats.viewPlayerAnalysis('${member.id}')" title="Ver Análise Completa">
                <i class="fas fa-chart-line"></i>
                <span>Ver Análise</span>
              </button>
            ` : `
              <button class="btn-ranked-action btn-no-riot" disabled title="Riot ID não configurado">
                <i class="fas fa-exclamation-circle"></i>
                <span>Sem Riot ID</span>
              </button>
            `}
          </div>
          
        </div>
      </div>
    `;
  }

  async refreshAll() {
    if (this.loading) return;
    this.loading = true;
    toast.info('Atualizando...', 'Sincronizando dados de ranked');
    this.playerAnalysis.clear();
    
    // Reload inline analysis for self
    const self = this.teamMembers.find(m => m._isSelf);
    if (self && self.riot_id && self.riot_tag) {
      await this.loadInlineAnalysis(self);
    }
    
    this.loading = false;
    toast.success('Atualizado', 'Dados de ranked sincronizados');
  }

  // =====================================================
  // ANÁLISE INLINE (direto na página)
  // =====================================================

  async loadInlineAnalysis(member) {
    const container = document.getElementById('rankedInlineAnalysis');
    if (!container) return;

    if (this.inlineAnalysisLoading) {
      return;
    }

    this.inlineAnalysisLoading = true;
    const requestId = ++this.inlineAnalysisRequestId;

    try {
      const name = member.riot_id;
      const tag = member.riot_tag;
      const region = this.normalizeValorantRegion(member.region || 'br');

      // Fetch v4 (rich data, ~10 matches) + stored-matches (full act, 50/page) + MMR in parallel
      const [v4Result, storedResult, mmrResult] = await Promise.all([
        api.getValorantMatches(region, name, tag, 'competitive', 50),
        api.getValorantStoredMatches(region, name, tag, 'competitive', 50, 1).catch(() => null),
        api.getValorantMMR(region, name, tag).catch(() => null)
      ]);

      // Build combined match list
      const v4Matches = (v4Result?.success && v4Result?.data?.matches) ? v4Result.data.matches : [];
      const storedMatches = (storedResult?.success && storedResult?.data?.matches) ? storedResult.data.matches : [];

      // Detect current act from the most recent data available
      const allFetched = [...v4Matches, ...storedMatches];
      const currentAct = this.detectCurrentAct(allFetched);

      // Filter stored matches to current act only
      const storedActMatches = currentAct
        ? storedMatches.filter(m => (m.metadata?.season?.short) === currentAct)
        : storedMatches;

      // If stored page 1 has matches ALL from current act, we might need page 2
      let extraStoredMatches = [];
      if (currentAct && storedResult?.success && storedMatches.length >= 50) {
        const storedNonAct = storedMatches.filter(m => (m.metadata?.season?.short) !== currentAct);
        if (storedNonAct.length < 5) {
          // Almost all matches are current act — fetch page 2
          try {
            const page2 = await api.getValorantStoredMatches(region, name, tag, 'competitive', 50, 2);
            if (page2?.success && page2?.data?.matches) {
              extraStoredMatches = currentAct
                ? page2.data.matches.filter(m => (m.metadata?.season?.short) === currentAct)
                : page2.data.matches;
            }
          } catch (e) { /* ignore page 2 errors */ }
        }
      }

      // Merge: use v4 match (rich) when available, stored match as fallback
      const v4ById = new Map();
      v4Matches.forEach(m => {
        const id = m.metadata?.match_id || m.metadata?.id;
        if (id) v4ById.set(id, m);
      });

      const mergedById = new Map();
      // Add all v4 matches for current act
      v4Matches.forEach(m => {
        if (!currentAct || (m.metadata?.season?.short) === currentAct) {
          const id = m.metadata?.match_id || m.metadata?.id;
          if (id) mergedById.set(id, m);
        }
      });
      // Add stored matches that aren't already in v4
      [...storedActMatches, ...extraStoredMatches].forEach(m => {
        const id = m.metadata?.match_id || m.metadata?.id;
        if (id && !mergedById.has(id)) {
          mergedById.set(id, m);
        }
      });

      // Sort by date descending
      const matches = Array.from(mergedById.values()).sort((a, b) => {
        const da = new Date(a.metadata?.started_at || 0).getTime();
        const db = new Date(b.metadata?.started_at || 0).getTime();
        return db - da;
      });

      const isCached = (v4Result?.cached === true) && (!storedResult || storedResult?.cached === true);

      if (!matches.length) {
        container.innerHTML = `
          <div class="empty-state premium-empty">
            <div class="empty-icon"><i class="fas fa-gamepad"></i></div>
            <h3>Nenhuma partida encontrada</h3>
            <p>Não foram encontradas partidas ranqueadas recentes</p>
          </div>
        `;
        return;
      }

      console.log(`[Ranked] Loaded ${matches.length} matches for act ${currentAct} (v4: ${v4Matches.length}, stored: ${storedActMatches.length + extraStoredMatches.length})`);

      const analysis = this.analyzeMatches(matches, { includeExtendedPeriods: false });
      const rankSummary = this.buildRankedSummaryFromMmr(mmrResult?.success ? mmrResult.data : null);

      this._matchDetailsSource.clear();
      this._matchDetailsHtmlCache.clear();
      this._individualAnalysisCache.clear();

      ['all', 'act'].forEach((periodKey) => {
        if (analysis[periodKey]) {
          analysis[periodKey].currentRank = rankSummary;
        }
      });

      // Cache
      this.playerAnalysis.set(member.id, { ...analysis, rawMatches: matches, playerName: name });

      if (requestId !== this.inlineAnalysisRequestId) {
        return;
      }

      // Render inline
      container.innerHTML = this.renderInlineAnalysisContent(member, analysis, matches, name, isCached);

      // Setup tabs
      this.setupInlinePeriodTabs(member.id, matches, name);
      if (this.inlineActiveSection === 'individual') {
        this.ensureIndividualAnalysisRendered(true);
      }

      // Background: enrich stored-only matches with full v4 data for complete stats (FK/FD/KAST/plants)
      this.enrichStoredMatchesInBackground(member, matches, name, requestId);

    } catch (error) {
      if (requestId !== this.inlineAnalysisRequestId) {
        return;
      }

      if (!api.isTransientNetworkError?.(error)) {
        console.error('Error loading inline analysis:', error);
      }

      const message = error?.code === 'REQUEST_TIMEOUT'
        ? 'A API demorou demais para responder. Tentaremos novamente na próxima sincronização.'
        : (error.message || 'Tente novamente mais tarde');

      container.innerHTML = `
        <div class="empty-state error-state">
          <div class="empty-icon"><i class="fas fa-exclamation-triangle"></i></div>
          <h3>Erro ao carregar análise</h3>
          <p>${message}</p>
          <button class="btn btn-primary" onclick="rankedStats.load()">
            <i class="fas fa-redo"></i> Tentar Novamente
          </button>
        </div>
      `;
    } finally {
      if (requestId === this.inlineAnalysisRequestId) {
        this.inlineAnalysisLoading = false;
      }
    }
  }

  async enrichStoredMatchesInBackground(member, matches, playerName, requestId) {
    try {
      const storedMatches = matches.filter(m => m._source === 'stored' && (m.metadata?.match_id || m.metadata?.id));
      if (!storedMatches.length) return;

      const region = this.normalizeValorantRegion(member.region || 'br');
      const concurrency = 3;
      let index = 0;
      let changed = false;

      const worker = async () => {
        while (index < storedMatches.length) {
          const current = storedMatches[index++];
          if (requestId !== this.inlineAnalysisRequestId) return;

          const matchId = current.metadata?.match_id || current.metadata?.id;
          try {
            const result = await api.getValorantMatch(region, matchId);
            if (requestId !== this.inlineAnalysisRequestId) return;
            if (!result?.success || !result?.data) continue;

            const full = result.data;
            // Find player in full data
            const fullPlayer = (full.players || []).find(
              p => (p.name || '').toLowerCase() === playerName.toLowerCase()
            );
            if (!fullPlayer) continue;

            const enriched = {
              metadata: full.metadata || current.metadata,
              players: full.players || [],
              teams: full.teams || [],
              rounds: full.rounds || [],
              kills: full.kills || [],
              player: {
                puuid: fullPlayer.puuid,
                name: fullPlayer.name,
                tag: fullPlayer.tag,
                team_id: fullPlayer.team_id,
                agent: fullPlayer.agent,
                stats: fullPlayer.stats,
                economy: fullPlayer.economy,
                ability_casts: fullPlayer.ability_casts,
                behavior: fullPlayer.behavior,
                tier: fullPlayer.tier,
                account_level: fullPlayer.account_level
              }
            };

            // Replace in matches array
            const idx = matches.findIndex(m => (m.metadata?.match_id || m.metadata?.id) === matchId);
            if (idx >= 0) {
              matches[idx] = enriched;
              changed = true;
            }
          } catch (e) {
            // Silent - keep original stored version
          }
        }
      };

      // Run workers in parallel
      await Promise.all(Array.from({ length: concurrency }, () => worker()));

      if (requestId !== this.inlineAnalysisRequestId || !changed) return;

      // Re-analyze with enriched data
      const analysis = this.analyzeMatches(matches, { includeExtendedPeriods: false });
      const cached = this.playerAnalysis.get(member.id);
      const rankSummary = cached?.act?.currentRank || null;
      ['all', 'act'].forEach((periodKey) => {
        if (analysis[periodKey]) analysis[periodKey].currentRank = rankSummary;
      });

      this.playerAnalysis.set(member.id, { ...analysis, rawMatches: matches, playerName });

      // Clear caches so re-render uses fresh data
      this._matchDetailsSource.clear();
      this._matchDetailsHtmlCache.clear();
      this._individualAnalysisCache.clear();

      const container = document.getElementById('rankedInlineAnalysis');
      if (!container || requestId !== this.inlineAnalysisRequestId) return;

      container.innerHTML = this.renderInlineAnalysisContent(member, analysis, matches, playerName, false);
      this.setupInlinePeriodTabs(member.id, matches, playerName);
      if (this.inlineActiveSection === 'individual') {
        this.ensureIndividualAnalysisRendered(true);
      }

      console.log(`[Ranked] Enriched ${storedMatches.length} stored matches with full v4 data`);
    } catch (err) {
      console.warn('[Ranked] Background enrichment failed:', err);
    }
  }

  renderInlineAnalysisContent(member, analysis, rawMatches, playerName, isCached = false) {
    // Default to act data
    const actData = analysis.act;
    const actMatches = analysis._actMatches || rawMatches;
    const currentActLabel = this.formatActLabel(analysis._currentAct, rawMatches);
    const historyGeneralStatsHtml = this.renderGeneralStatsSection(
      this.computeIndividualAnalysis(actMatches, playerName),
      {
        currentRank: actData?.currentRank || null,
        actLabel: currentActLabel
      }
    );
    const activeInlineSection = this.inlineActiveSection === 'individual' ? 'individual' : 'history';
    const historySectionActive = activeInlineSection === 'history';
    const individualSectionActive = activeInlineSection === 'individual';

    const cachedBanner = isCached ? `
      <div class="ranked-cache-banner">
        <i class="fas fa-exclamation-triangle"></i>
        <span>API temporariamente indisponível — exibindo dados em cache. Algumas partidas podem não aparecer.</span>
        <button class="btn-retry-cache" onclick="rankedStats.load()"><i class="fas fa-redo"></i> Tentar novamente</button>
      </div>
    ` : '';

    return `
      <div class="ranked-container">
        ${cachedBanner}
        ${historyGeneralStatsHtml}

        <!-- Section Navigation -->
        <div class="ranked-nav">
          <button class="ranked-nav-btn${historySectionActive ? ' active' : ''}" onclick="rankedStats.switchSection('history')" data-section="history">
            <div class="ranked-nav-icon history"><i class="fas fa-list"></i></div>
            <span>Histórico de Partidas</span>
          </button>
          <button class="ranked-nav-btn${individualSectionActive ? ' active' : ''}" onclick="rankedStats.switchSection('individual')" data-section="individual">
            <div class="ranked-nav-icon individual"><i class="fas fa-chart-pie"></i></div>
            <span>Análise Individual</span>
          </button>
        </div>

        <!-- Dashboard Grid -->
        <div class="ranked-dashboard">
          <!-- Match History -->
          <div class="ranked-section-panel" id="section-history" style="display:${historySectionActive ? 'block' : 'none'}">
          <div class="ranked-section-card ranked-card-history">
            <div class="ranked-section-card-body" id="panel-history">
              <div class="matches-table-container" id="matchesTableContainer">
                ${this.renderMatchesTable(actMatches, playerName)}
              </div>
            </div>
          </div>
          </div>

          <!-- Individual Analysis -->
          <div class="ranked-section-panel" id="section-individual" style="display:${individualSectionActive ? 'block' : 'none'}">
          <div class="ranked-section-card ranked-card-individual">
            <div class="ranked-section-card-body" id="panel-individual">
              <div id="individualAnalysisContainer">
                  ${this.renderIndividualAnalysisPlaceholder()}
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    `;
  }

  setupInlinePeriodTabs(memberId, rawMatches, playerName) {
    // Store data for dropdown usage
    this._inlinePeriodData = { memberId, rawMatches, playerName };
  }

  renderIndividualAnalysisPlaceholder() {
    return `
      <div class="premium-empty-state">
        <i class="fas fa-chart-pie"></i>
        <p>Abra esta aba para carregar a análise individual.</p>
      </div>
    `;
  }

  ensureIndividualAnalysisRendered(force = false) {
    const container = document.getElementById('individualAnalysisContainer');
    const data = this._inlinePeriodData;
    if (!container || !data) return;

    const { memberId, rawMatches, playerName } = data;
    const analysis = this.playerAnalysis.get(memberId);
    if (!analysis) return;

    // Individual analysis is always act-scoped, independent from section toggles.
    const actMatches = analysis._actMatches || rawMatches;
    const selectedAgentCacheKey = this.individualSelectedAgentKey || 'auto';
    const cacheKey = `${memberId}:act:${actMatches.length}:agent:${selectedAgentCacheKey}`;

    if (!force && container.dataset.cacheKey === cacheKey) {
      return;
    }

    let html = this._individualAnalysisCache.get(cacheKey);
    if (!html) {
      const periodData = analysis.act || analysis.all || null;
      html = this.renderIndividualAnalysis(
        this.computeIndividualAnalysis(actMatches, playerName),
        {
          currentRank: periodData?.currentRank || null,
          actLabel: this.formatActLabel(analysis._currentAct, rawMatches)
        }
      );
      this._individualAnalysisCache.set(cacheKey, html);
    }

    container.innerHTML = html;
    container.dataset.cacheKey = cacheKey;
  }

  switchSection(sectionName) {
    if (sectionName === 'maps' || sectionName === 'agents') {
      sectionName = 'history';
    }

    const sections = ['history', 'individual'];
    if (!sections.includes(sectionName)) {
      sectionName = 'history';
    }

    this.inlineActiveSection = sectionName;

    sections.forEach(s => {
      const panel = document.getElementById(`section-${s}`);
      if (panel) panel.style.display = s === sectionName ? 'block' : 'none';
    });
    document.querySelectorAll('.ranked-nav-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.section === sectionName);
    });

    if (sectionName === 'individual') {
      this.ensureIndividualAnalysisRendered();
    }
  }

  togglePeriodDropdown() {
    const dropdown = document.getElementById('inlinePeriodDropdown');
    if (dropdown) dropdown.classList.toggle('open');
  }

  toggleAgentCardDropdown(dropdownId) {
    const dropdown = document.getElementById(dropdownId);
    if (!dropdown) return;

    const shouldOpen = !dropdown.classList.contains('open');
    document.querySelectorAll('.ia-agent-card-dropdown.open').forEach((item) => {
      if (item.id !== dropdownId) item.classList.remove('open');
    });

    dropdown.classList.toggle('open', shouldOpen);
  }

  selectPeriod(el) {
    const period = el.dataset.period;
    if (period !== 'act' && period !== 'all') return;
    const data = this._inlinePeriodData;
    if (!data) return;

    const { memberId, rawMatches, playerName } = data;
    const analysis = this.playerAnalysis.get(memberId);
    if (!analysis) return;

    const periodData = analysis[period];

    let periodMatches = rawMatches;
    if (period === 'act') {
      periodMatches = analysis._actMatches || rawMatches;
    } else if (period === 'all') {
      periodMatches = rawMatches;
    }

    // Update active state
    document.querySelectorAll('.period-dropdown-item').forEach(i => i.classList.remove('active'));
    el.classList.add('active');

    // Update label
    const label = document.getElementById('periodDropdownLabel');
    if (label) label.textContent = el.textContent.trim();

    // Update icon
    const btn = document.querySelector('.period-dropdown-btn > i:first-child');
    const itemIcon = el.querySelector('i');
    if (btn && itemIcon) btn.className = itemIcon.className;

    // Close dropdown
    const dropdown = document.getElementById('inlinePeriodDropdown');
    if (dropdown) dropdown.classList.remove('open');

    // Reset matches pagination
    this._matchesVisible = 15;

    // Update content
    const statsOverview = document.getElementById('analysisStatsOverview');
    if (statsOverview) {
      statsOverview.innerHTML = this.renderStatsOverviewPremium(periodData);
    }

    const topAgentsGrid = document.getElementById('topAgentsGrid');
    if (topAgentsGrid) {
      topAgentsGrid.innerHTML = this.renderTopAgentsPremium(periodData.topAgents);
    }

    const agentsByMapGrid = document.getElementById('agentsByMapGrid');
    if (agentsByMapGrid) {
      agentsByMapGrid.innerHTML = this.renderAgentsByMapPremium(periodData.agentsByMap);
    }

    const matchesTableContainer = document.getElementById('matchesTableContainer');
    if (matchesTableContainer) {
      matchesTableContainer.innerHTML = this.renderMatchesTable(periodMatches, playerName);
    }

    const indContainer = document.getElementById('individualAnalysisContainer');
    if (indContainer) {
      indContainer.dataset.cacheKey = '';
      const individualPanelVisible = document.getElementById('section-individual')?.style.display !== 'none';
      if (individualPanelVisible) {
        this.ensureIndividualAnalysisRendered(true);
      } else {
        indContainer.innerHTML = this.renderIndividualAnalysisPlaceholder();
      }
    }
  }

  showMoreMatches() {
    this._matchesVisible = (this._matchesVisible || 15) + 15;
    const container = document.getElementById('matchesTableContainer');
    if (!container) return;
    const data = this._inlinePeriodData;
    if (!data) return;
    const { memberId, rawMatches, playerName } = data;
    const analysis = this.playerAnalysis.get(memberId);
    if (!analysis) return;

    // Determine current period
    const activeItem = document.querySelector('.period-dropdown-item.active');
    const period = activeItem?.dataset?.period || 'act';
    let periodMatches = rawMatches;
    if (period === 'act') periodMatches = analysis._actMatches || rawMatches;

    container.innerHTML = this.renderMatchesTable(periodMatches, playerName);
  }

  // =====================================================
  // ANÁLISE DO JOGADOR (modal - usado por team members)
  // =====================================================

  async viewPlayerAnalysis(memberId) {
    const member = this.teamMembers.find(m => m.id === memberId);
    if (!member) return;

    // Verifica se tem riot_id e riot_tag (campos separados no banco)
    if (!member.riot_id || !member.riot_tag) {
      toast.error('Erro', 'Este jogador não possui Riot ID configurado');
      return;
    }

    const hasAvatar = member.avatar_url && member.avatar_url !== '' && member.avatar_url !== 'null';
    const memberInitial = (member.display_name || member.username || '?').charAt(0).toUpperCase();

    // Mostrar fullscreen view com loading
    const modal = document.getElementById('rankedAnalysisModal');
    const content = document.getElementById('rankedAnalysisContent');
    modal.style.display = 'flex';
    modal.classList.add('show');
    document.body.style.overflow = 'hidden';
    
    content.innerHTML = `
      <div class="fullscreen-loading-container">
        <div class="premium-loading-card">
          <div class="loading-avatar-wrapper">
            ${hasAvatar ? `
              <img src="${member.avatar_url}" alt="${member.display_name}" class="loading-avatar-img">
            ` : `
              <div class="loading-avatar-fallback"><span>${memberInitial}</span></div>
            `}
            <div class="loading-avatar-ring"></div>
          </div>
          <h2 class="loading-player-name">${member.display_name || member.username}</h2>
          <span class="loading-riot-id">${member.riot_id}#${member.riot_tag}</span>
          <div class="loading-progress-container">
            <div class="loading-progress-bar">
              <div class="loading-progress-fill"></div>
            </div>
            <p class="loading-status">Carregando dados de ranqueadas...</p>
          </div>
          <div class="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    `;

    try {
      // Usar riot_id e riot_tag separados
      const name = member.riot_id;
      const tag = member.riot_tag;
      const region = this.normalizeValorantRegion(member.region || 'br');

      // Buscar histórico de partidas
      const matchesResult = await api.getValorantMatches(region, name, tag, 'competitive', 50);
      
      if (!matchesResult.success || !matchesResult.data.matches.length) {
        content.innerHTML = this.renderNoMatchesFound(member);
        return;
      }

      const matches = matchesResult.data.matches;
      const analysis = this.analyzeMatches(matches);
      
      // Cache analysis com partidas brutas
      this.playerAnalysis.set(memberId, { ...analysis, rawMatches: matches, playerName: name });
      
      // Render analysis
      content.innerHTML = this.renderPlayerAnalysisContent(member, analysis, matches, name);
      
      // Setup period tabs
      this.setupPeriodTabs(memberId, matches, name);
      
    } catch (error) {
      console.error('Error loading player analysis:', error);
      const isRateLimit = error.message?.includes('429') || error.message?.includes('Muitas requisições');
      content.innerHTML = `
        <div class="fullscreen-analysis-header">
          <button class="btn-back-premium" onclick="rankedStats.closeAnalysisModal()">
            <i class="fas fa-arrow-left"></i>
            <span>Voltar</span>
          </button>
        </div>
        <div class="fullscreen-analysis-body">
          <div class="premium-empty-state error">
            <i class="fas fa-${isRateLimit ? 'clock' : 'exclamation-triangle'}"></i>
            <h3>${isRateLimit ? 'Limite de requisições atingido' : 'Erro ao carregar dados'}</h3>
            <p>${isRateLimit ? 'Aguarde alguns segundos e tente novamente.' : (error.message || 'Não foi possível buscar o histórico de partidas')}</p>
            <button class="btn btn-primary" style="margin-top: 15px;" onclick="rankedStats.openAnalysisModal('${memberId}')">
              <i class="fas fa-redo"></i> Tentar novamente
            </button>
          </div>
        </div>
      `;
    }
  }

  analyzeMatches(matches, options = {}) {
    const { includeExtendedPeriods = true } = options;
    const now = new Date();
    const dayAgo = new Date(now - 24 * 60 * 60 * 1000);
    const weekAgo = new Date(now - 7 * 24 * 60 * 60 * 1000);
    const monthAgo = new Date(now - 30 * 24 * 60 * 60 * 1000);

    // Helper para extrair data da partida (suporta vários formatos)
    const getMatchDate = (m) => {
      if (m.metadata?.started_at) {
        return new Date(m.metadata.started_at);
      }
      if (m.game_start) {
        return new Date(m.game_start * 1000);
      }
      if (m.game_start_patched) {
        return new Date(m.game_start_patched);
      }
      return new Date(0); // fallback
    };

    // Detect current act (most recent season)
    const currentAct = this.detectCurrentAct(matches);
    const actMatches = currentAct
      ? matches.filter(m => m.metadata?.season?.short === currentAct)
      : matches;

    const analysis = {
      all: this.processMatchesForPeriod(matches),
      act: this.processMatchesForPeriod(actMatches),
      _currentAct: currentAct,
      _actMatches: actMatches
    };

    if (includeExtendedPeriods) {
      analysis.day = this.processMatchesForPeriod(matches.filter(m => getMatchDate(m) >= dayAgo));
      analysis.week = this.processMatchesForPeriod(matches.filter(m => getMatchDate(m) >= weekAgo));
      analysis.month = this.processMatchesForPeriod(matches.filter(m => getMatchDate(m) >= monthAgo));
    } else {
      analysis.day = analysis.act;
      analysis.week = analysis.act;
      analysis.month = analysis.act;
    }

    return analysis;
  }

  // Detect the most recent act/season from match data
  detectCurrentAct(matches) {
    const actMap = {};
    matches.forEach(m => {
      const short = m.metadata?.season?.short;
      if (short) {
        actMap[short] = (actMap[short] || 0) + 1;
      }
    });

    // Sort by episode+act descending, pick the newest
    const acts = Object.keys(actMap).sort((a, b) => {
      const parseAct = (s) => {
        const match = s.match(/e(\d+)a(\d+)/);
        return match ? [parseInt(match[1]), parseInt(match[2])] : [0, 0];
      };
      const [ae, aa] = parseAct(a);
      const [be, ba] = parseAct(b);
      return be - ae || ba - aa;
    });

    return acts[0] || null;
  }

  // Format "e11a2" -> "V26:Ato 2" (V = year % 100 based on match dates, or current year)
  formatActLabel(short, matches = null) {
    if (!short) return 'Ato Atual';
    const m = short.match(/e(\d+)a(\d+)/);
    if (!m) return short.toUpperCase();

    const actNum = m[2];

    // Prefer the year from the most recent match in this act; fallback to current year
    let year = new Date().getFullYear();
    if (Array.isArray(matches)) {
      let latestTs = 0;
      for (const match of matches) {
        if (match?.metadata?.season?.short === short) {
          const ts = new Date(match.metadata?.started_at || 0).getTime();
          if (Number.isFinite(ts) && ts > latestTs) latestTs = ts;
        }
      }
      if (latestTs > 0) year = new Date(latestTs).getFullYear();
    }

    const v = year % 100;
    return `V${v}:Ato ${actNum}`;
  }

  buildRankedSummaryFromMmr(mmrData) {
    const fullRankLabel = mmrData?.currenttierpatched || '--';
    const rrValue = Number(mmrData?.ranking_in_tier ?? 0);

    return {
      fullRankLabel,
      rankLabel: this.simplifyRank(fullRankLabel),
      rankIcon: mmrData?.images?.small || mmrData?.images?.large || '',
      rrValue,
      rrLabel: Number.isFinite(rrValue) ? `${rrValue} RR` : '--'
    };
  }

  playerEntityMatches(entity, player, fallbackTeamId = '') {
    const playerPuuid = player?.puuid || '';
    const playerName = (player?.name || '').toLowerCase();
    const playerTag = (player?.tag || '').toLowerCase();
    const entityTeamId = String(entity?.team_id || entity?.team || '').toLowerCase();

    if (playerPuuid && entity?.puuid) {
      return entity.puuid === playerPuuid;
    }

    if (playerName && playerTag) {
      return (entity?.name || '').toLowerCase() === playerName && (entity?.tag || '').toLowerCase() === playerTag;
    }

    return Boolean(fallbackTeamId && entityTeamId && entityTeamId === fallbackTeamId);
  }

  extractPlayerTotalRounds(match, player) {
    const teams = match?.teams;
    const playerTeamId = String(player?.team_id || player?.team || '').toLowerCase();

    if (Array.isArray(teams)) {
      const playerTeam = teams.find((entry) => String(entry?.team_id || '').toLowerCase() === playerTeamId) || {};
      const enemyTeam = teams.find((entry) => String(entry?.team_id || '').toLowerCase() !== playerTeamId) || {};
      const won = Number(playerTeam?.rounds?.won ?? playerTeam?.rounds_won ?? 0);
      const lost = Number(playerTeam?.rounds?.lost ?? playerTeam?.rounds_lost ?? enemyTeam?.rounds?.won ?? enemyTeam?.rounds_won ?? 0);
      return won + lost;
    }

    if (teams && playerTeamId) {
      const playerTeam = teams[playerTeamId] || {};
      const enemyKey = Object.keys(teams).find((key) => String(key).toLowerCase() !== playerTeamId);
      const enemyTeam = enemyKey ? teams[enemyKey] : {};
      const won = Number(playerTeam?.rounds?.won ?? playerTeam?.rounds_won ?? 0);
      const lost = Number(playerTeam?.rounds?.lost ?? playerTeam?.rounds_lost ?? enemyTeam?.rounds?.won ?? enemyTeam?.rounds_won ?? 0);
      return won + lost;
    }

    return 0;
  }

  extractPlayerFirstActionStats(match, player) {
    const killsByRound = new Map();

    (match?.kills || []).forEach((kill) => {
      const roundNumber = Number(kill?.round || 0);
      if (!killsByRound.has(roundNumber)) {
        killsByRound.set(roundNumber, []);
      }
      killsByRound.get(roundNumber).push(kill);
    });

    let firstKills = 0;
    let firstDeaths = 0;

    killsByRound.forEach((roundKills) => {
      roundKills.sort((left, right) => Number(left?.time_in_round_in_ms || 0) - Number(right?.time_in_round_in_ms || 0));
      const firstKill = roundKills[0];
      if (!firstKill) return;

      if (this.playerEntityMatches(firstKill?.killer || {}, player)) firstKills += 1;
      if (this.playerEntityMatches(firstKill?.victim || {}, player)) firstDeaths += 1;
    });

    return { firstKills, firstDeaths };
  }

  extractPlayerKastRounds(match, player) {
    const playerTeamId = String(player?.team_id || player?.team || '').toLowerCase();
    const rounds = Array.isArray(match?.rounds) ? match.rounds : [];
    const killsByRound = new Map();

    (match?.kills || []).forEach((kill) => {
      const roundNumber = Number(kill?.round || 0);
      if (!killsByRound.has(roundNumber)) {
        killsByRound.set(roundNumber, []);
      }
      killsByRound.get(roundNumber).push(kill);
    });

    return rounds.reduce((count, round) => {
      const roundEntries = Array.isArray(round?.stats) ? round.stats : [];
      const playerRound = roundEntries.find((entry) => this.playerEntityMatches(entry?.player || {}, player, playerTeamId)) || null;
      const kills = Number(playerRound?.stats?.kills || 0);
      const assists = Number(playerRound?.stats?.assists || 0);
      const deaths = Number(playerRound?.stats?.deaths || 0);
      const survived = deaths === 0;

      let traded = false;
      if (!survived) {
        const roundNumber = Number(round?.round_number || round?.round || 0);
        const roundKills = [...(killsByRound.get(roundNumber) || [])].sort((left, right) => Number(left?.time_in_round_in_ms || 0) - Number(right?.time_in_round_in_ms || 0));
        const deathEvent = roundKills.find((kill) => this.playerEntityMatches(kill?.victim || {}, player, playerTeamId));

        if (deathEvent) {
          const killer = deathEvent?.killer || {};
          const killerPuuid = killer?.puuid || '';
          const killerName = (killer?.name || '').toLowerCase();
          const killerTag = (killer?.tag || '').toLowerCase();
          const deathTime = Number(deathEvent?.time_in_round_in_ms || 0);

          traded = roundKills.some((kill) => {
            const eventTime = Number(kill?.time_in_round_in_ms || 0);
            if (eventTime <= deathTime || eventTime - deathTime > 5000) {
              return false;
            }

            const killerTeam = String(kill?.killer?.team_id || kill?.killer?.team || '').toLowerCase();
            const victim = kill?.victim || {};
            const victimMatches = killerPuuid
              ? victim?.puuid === killerPuuid
              : ((victim?.name || '').toLowerCase() === killerName && (victim?.tag || '').toLowerCase() === killerTag);

            return Boolean(playerTeamId && killerTeam === playerTeamId && victimMatches);
          });
        }
      }

      return count + (kills > 0 || assists > 0 || survived || traded ? 1 : 0);
    }, 0);
  }

  normalizeKastPercentValue(value) {
    if (value === undefined || value === null || value === '') return null;

    const numeric = Number.parseFloat(String(value).replace('%', '').replace(',', '.'));
    if (!Number.isFinite(numeric)) return null;

    // Some providers return ratio (0-1), others already return percentage (0-100).
    if (numeric >= 0 && numeric <= 1) {
      return Math.round(numeric * 100);
    }

    return Math.round(numeric);
  }

  readKastPercentFromPlayerEntry(entry) {
    if (!entry || typeof entry !== 'object') return null;

    const candidates = [
      entry?.stats?.kast,
      entry?.stats?.kast_percent,
      entry?.stats?.kast_percentage,
      entry?.stats?.kastPercent,
      entry?.kast,
      entry?._derived?.kast
    ];

    for (const candidate of candidates) {
      const normalized = this.normalizeKastPercentValue(candidate);
      if (normalized !== null) {
        return normalized;
      }
    }

    return null;
  }

  getPlayerKastPercentFromMatchData(match, player, players = null) {
    const playerTeamId = String(player?.team_id || player?.team || '').toLowerCase();
    const roster = Array.isArray(players) && players.length
      ? players
      : (Array.isArray(match?.players) ? match.players : []);

    const byIdentity = roster.find((entry) => this.playerEntityMatches(entry || {}, player, playerTeamId));
    const candidates = [player, byIdentity, match?.player].filter(Boolean);

    for (const candidate of candidates) {
      const value = this.readKastPercentFromPlayerEntry(candidate);
      if (value !== null) {
        return value;
      }
    }

    return null;
  }

  computePlayerMatchKastPercentFromEvents(match, player) {
    const totalRounds = this.extractPlayerTotalRounds(match, player);
    if (!totalRounds) return 0;

    // If no kill/round event data available (e.g. stored matches), we cannot compute KAST
    const hasKillData = Array.isArray(match?.kills) && match.kills.length > 0;
    const hasRoundData = Array.isArray(match?.rounds) && match.rounds.length > 0;
    if (!hasKillData && !hasRoundData) return null;

    const playerTeamId = String(player?.team_id || player?.team || '').toLowerCase();
    const playerPuuid = player?.puuid || '';
    const killsByRound = new Map();

    (match?.kills || []).forEach((kill) => {
      const roundNumber = Number(kill?.round);
      if (!Number.isFinite(roundNumber)) return;

      if (!killsByRound.has(roundNumber)) {
        killsByRound.set(roundNumber, []);
      }
      killsByRound.get(roundNumber).push(kill);
    });

    const rounds = Array.isArray(match?.rounds) ? match.rounds : [];
    let orderedRoundKeys = rounds
      .map((round, index) => Number(round?.round_number ?? round?.round ?? (index + 1)))
      .filter((value) => Number.isFinite(value));

    if (orderedRoundKeys.length !== totalRounds) {
      const startRound = killsByRound.has(0) ? 0 : 1;
      orderedRoundKeys = Array.from({ length: totalRounds }, (_, index) => startRound + index);
    }

    let kastRounds = 0;
    orderedRoundKeys.forEach((roundKey) => {
      const roundKills = [...(killsByRound.get(roundKey) || [])]
        .sort((left, right) => Number(left?.time_in_round_in_ms || 0) - Number(right?.time_in_round_in_ms || 0));

      const gotKill = playerPuuid
        ? roundKills.some((kill) => kill?.killer?.puuid === playerPuuid)
        : roundKills.some((kill) => this.playerEntityMatches(kill?.killer || {}, player, playerTeamId));

      const gotAssist = playerPuuid
        ? roundKills.some((kill) => (kill?.assistants || []).some((assistant) => assistant?.puuid === playerPuuid))
        : roundKills.some((kill) => (kill?.assistants || []).some((assistant) => this.playerEntityMatches(assistant || {}, player, playerTeamId)));

      const deathEvent = playerPuuid
        ? roundKills.find((kill) => kill?.victim?.puuid === playerPuuid)
        : roundKills.find((kill) => this.playerEntityMatches(kill?.victim || {}, player, playerTeamId));

      const survived = !deathEvent;

      let traded = false;
      if (deathEvent) {
        const killer = deathEvent?.killer || {};
        const killerPuuid = killer?.puuid || '';
        const killerName = (killer?.name || '').toLowerCase();
        const killerTag = (killer?.tag || '').toLowerCase();
        const deathTime = Number(deathEvent?.time_in_round_in_ms || 0);

        traded = roundKills.some((kill) => {
          const eventTime = Number(kill?.time_in_round_in_ms || 0);
          if (eventTime <= deathTime || eventTime - deathTime > 5000) {
            return false;
          }

          const killerTeam = String(kill?.killer?.team_id || kill?.killer?.team || '').toLowerCase();
          if (playerTeamId && killerTeam !== playerTeamId) {
            return false;
          }

          const victim = kill?.victim || {};
          if (killerPuuid) {
            return victim?.puuid === killerPuuid;
          }

          return (victim?.name || '').toLowerCase() === killerName
            && (victim?.tag || '').toLowerCase() === killerTag;
        });
      }

      if (gotKill || gotAssist || survived || traded) {
        kastRounds += 1;
      }
    });

    return Math.round((kastRounds / totalRounds) * 100);
  }

  computePlayerMatchKastPercent(match, player, players = null) {
    const fromData = this.getPlayerKastPercentFromMatchData(match, player, players);
    if (fromData !== null) {
      return fromData;
    }

    return this.computePlayerMatchKastPercentFromEvents(match, player);
  }

  // Resolve map key robustly across Henrik payload variations
  resolveMatchMapKey(match) {
    const normalizeCandidate = (value) => {
      if (value === undefined || value === null) return '';
      if (typeof value !== 'string' && typeof value !== 'number') return '';
      const raw = String(value).trim();
      if (!raw) return '';

      const lower = raw.toLowerCase();
      if (this.mapsData?.[lower]) return lower;

      const byId = Object.entries(this.mapsData || {}).find(([, map]) => {
        const id = String(map?.uuid || map?.id || '').toLowerCase();
        return id && id === lower;
      });
      if (byId) return byId[0];

      const byName = Object.entries(this.mapsData || {}).find(([, map]) => {
        const name = String(map?.displayName || map?.name || '').toLowerCase();
        return name && name === lower;
      });
      if (byName) return byName[0];

      const tail = lower.split('/').pop();
      if (tail && this.mapsData?.[tail]) return tail;

      const tailById = Object.entries(this.mapsData || {}).find(([, map]) => {
        const id = String(map?.uuid || map?.id || '').toLowerCase();
        return id && id === tail;
      });
      if (tailById) return tailById[0];

      return lower;
    };

    const resolveCandidate = (value) => {
      if (value === undefined || value === null) return '';

      if (typeof value === 'object') {
        const nestedSources = [
          value?.name,
          value?.displayName,
          value?.id,
          value?.uuid,
          value?.mapName,
          value?.map
        ];

        for (const nested of nestedSources) {
          const key = resolveCandidate(nested);
          if (key) return key;
        }

        return '';
      }

      return normalizeCandidate(value);
    };

    const sources = [
      match?.metadata?.map?.name,
      match?.metadata?.map?.displayName,
      match?.metadata?.map?.id,
      match?.metadata?.map?.uuid,
      match?.metadata?.map,
      match?.map?.name,
      match?.map?.displayName,
      match?.map?.id,
      match?.map?.uuid,
      match?.map,
      match?.map_name,
      match?.mapName
    ];

    for (const source of sources) {
      const key = resolveCandidate(source);
      if (key) return key;
    }

    return 'unknown';
  }

  resolveMapBackgroundImage(mapIdentifier) {
    const normalized = String(mapIdentifier || '').trim().toLowerCase();
    if (!normalized) return '';

    const getMapByKey = (key) => this.mapsData?.[key] || this.mapsMultipliers?.[key] || null;
    let mapData = getMapByKey(normalized);

    if (!mapData) {
      const mapEntries = Object.entries(this.mapsData || {});
      const mapEntry = mapEntries.find(([key, map]) => {
        const candidates = [
          key,
          map?.displayName,
          map?.name,
          map?.id,
          map?.uuid
        ]
          .filter(Boolean)
          .map((value) => String(value).toLowerCase());

        return candidates.includes(normalized)
          || candidates.some((candidate) => candidate.split('/').pop() === normalized);
      });

      if (mapEntry) {
        mapData = mapEntry[1];
      }
    }

    return mapData?.splash
      || mapData?.stylizedBackgroundImage
      || mapData?.listViewIcon
      || mapData?.displayIcon
      || mapData?.displayIconSmall
      || '';
  }

  extractPlayerMultiKillRounds(match, player) {
    const playerTeamId = String(player?.team_id || player?.team || '').toLowerCase();

    return (Array.isArray(match?.rounds) ? match.rounds : []).reduce((count, round) => {
      const roundEntries = Array.isArray(round?.stats) ? round.stats : [];
      const playerRound = roundEntries.find((entry) => this.playerEntityMatches(entry?.player || {}, player, playerTeamId)) || null;
      const kills = Number(playerRound?.stats?.kills || 0);
      return count + (kills >= 2 ? 1 : 0);
    }, 0);
  }

  processMatchesForPeriod(matches) {
    if (!matches.length) {
      return {
        totalMatches: 0,
        wins: 0,
        losses: 0,
        winRate: 0,
        avgKills: 0,
        avgDeaths: 0,
        avgAssists: 0,
        kd: 0,
        currentRank: null,
        avgTrs: 0,
        avgAcs: 0,
        avgPlusMinus: 0,
        avgDamageDelta: 0,
        avgAdr: 0,
        avgHs: 0,
        avgKast: 0,
        firstKills: 0,
        firstDeaths: 0,
        multiKills: 0,
        topAgents: [],
        agentsByMap: {}
      };
    }

    let wins = 0;
    let totalKills = 0;
    let totalDeaths = 0;
    let totalAssists = 0;
    let totalScore = 0;
    let totalDamageDealt = 0;
    let totalDamageReceived = 0;
    let totalHeadshots = 0;
    let totalBodyshots = 0;
    let totalLegshots = 0;
    let totalRounds = 0;
    let totalPlusMinus = 0;
    let totalKastRounds = 0;
    let totalKastEligibleRounds = 0;
    let totalFirstKills = 0;
    let totalFirstDeaths = 0;
    let totalMultiKills = 0;
    const agentCount = {};
    const agentsByMap = {};

    matches.forEach(match => {
      const player = match.player;
      if (!player) return;

      // Win/Loss - usar team_id do player
      const playerTeamId = (player.team_id || player.team || '').toLowerCase();
      
      // teams pode ser array ou objeto
      let playerWon = false;
      if (Array.isArray(match.teams)) {
        const playerTeamData = match.teams.find(t => t.team_id?.toLowerCase() === playerTeamId);
        playerWon = playerTeamData?.won === true;
      } else if (match.teams) {
        // Formato objeto {red: {...}, blue: {...}}
        const teamData = match.teams[playerTeamId];
        playerWon = teamData?.has_won === true || teamData?.won === true;
      }
      
      if (playerWon) {
        wins++;
      }

      // Stats
      totalKills += player.stats?.kills || 0;
      totalDeaths += player.stats?.deaths || 0;
      totalAssists += player.stats?.assists || 0;
  totalScore += player.stats?.score || 0;
  totalDamageDealt += player.stats?.damage?.dealt || 0;
  totalDamageReceived += player.stats?.damage?.received || 0;
  totalHeadshots += player.stats?.headshots || 0;
  totalBodyshots += player.stats?.bodyshots || 0;
  totalLegshots += player.stats?.legshots || 0;
  totalPlusMinus += (player.stats?.kills || 0) - (player.stats?.deaths || 0);

  const roundsPlayed = this.extractPlayerTotalRounds(match, player);
  totalRounds += roundsPlayed;

  const firstActions = this.extractPlayerFirstActionStats(match, player);
  totalFirstKills += firstActions.firstKills;
  totalFirstDeaths += firstActions.firstDeaths;
  const kastRoundsForMatch = this.extractPlayerKastRounds(match, player);
  totalKastRounds += kastRoundsForMatch;
  // Only count rounds toward KAST if match has kill/round event data
  const hasEventData = (Array.isArray(match?.kills) && match.kills.length > 0) || (Array.isArray(match?.rounds) && match.rounds.length > 0);
  if (hasEventData) {
    totalKastEligibleRounds += roundsPlayed;
  }
  totalMultiKills += this.extractPlayerMultiKillRounds(match, player);

      // Agent usage - handle both string and object format
      const agent = this.resolvePlayerAgentKey(player);
      agentCount[agent] = (agentCount[agent] || 0) + 1;

      // Agents by map
      const map = this.resolveMatchMapKey(match);
      if (!agentsByMap[map]) {
        agentsByMap[map] = {};
      }
      agentsByMap[map][agent] = (agentsByMap[map][agent] || 0) + 1;
    });

    // Top 5 agents
    const topAgents = Object.entries(agentCount)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5)
      .map(([agent, count]) => ({
        agent,
        count,
        percentage: Math.round((count / matches.length) * 100)
      }));

    // Process agents by map
    const processedAgentsByMap = {};
    Object.entries(agentsByMap).forEach(([map, agents]) => {
      processedAgentsByMap[map] = Object.entries(agents)
        .sort((a, b) => b[1] - a[1])
        .map(([agent, count]) => ({
          agent,
          count,
          percentage: Math.round((count / Object.values(agents).reduce((a, b) => a + b, 0)) * 100)
        }));
    });

    const totalShots = totalHeadshots + totalBodyshots + totalLegshots;
    const avgDamageDelta = totalRounds ? Math.round((totalDamageDealt - totalDamageReceived) / totalRounds) : 0;

    return {
      totalMatches: matches.length,
      wins,
      losses: matches.length - wins,
      winRate: Math.round((wins / matches.length) * 100),
      avgKills: (totalKills / matches.length).toFixed(1),
      avgDeaths: (totalDeaths / matches.length).toFixed(1),
      avgAssists: (totalAssists / matches.length).toFixed(1),
      kd: totalDeaths > 0 ? (totalKills / totalDeaths).toFixed(2) : totalKills.toFixed(2),
      avgTrs: Math.round(totalScore / matches.length),
      avgAcs: totalRounds ? Math.round(totalScore / totalRounds) : 0,
      avgPlusMinus: Number((totalPlusMinus / matches.length).toFixed(1)),
      avgDamageDelta,
      avgAdr: totalRounds ? Math.round(totalDamageDealt / totalRounds) : 0,
      avgHs: totalShots ? Math.round((totalHeadshots / totalShots) * 100) : 0,
      avgKast: totalKastEligibleRounds ? Math.round((totalKastRounds / totalKastEligibleRounds) * 100) : 0,
      firstKills: totalFirstKills,
      firstDeaths: totalFirstDeaths,
      multiKills: totalMultiKills,
      topAgents,
      agentsByMap: processedAgentsByMap
    };
  }

  renderNoMatchesFound(member) {
    const hasAvatar = member.avatar_url && member.avatar_url !== '' && member.avatar_url !== 'null';
    const memberInitial = (member.display_name || member.username || '?').charAt(0).toUpperCase();
    
    return `
      <div class="fullscreen-analysis-header">
        <button class="btn-back-premium" onclick="rankedStats.closeAnalysisModal()">
          <i class="fas fa-arrow-left"></i>
          <span>Voltar</span>
        </button>
        <div class="fullscreen-player-info">
          <div class="fullscreen-avatar">
            ${hasAvatar ? `
              <img src="${member.avatar_url}" alt="${member.display_name}">
            ` : `
              <div class="avatar-fallback-lg"><span>${memberInitial}</span></div>
            `}
          </div>
          <div class="fullscreen-player-details">
            <h1>${member.display_name || member.username}</h1>
            <span class="fullscreen-riot-id">${member.riot_id}#${member.riot_tag}</span>
          </div>
        </div>
      </div>
      <div class="fullscreen-analysis-body">
        <div class="empty-state premium-empty">
          <div class="empty-icon"><i class="fas fa-gamepad"></i></div>
          <h3>Nenhuma partida encontrada</h3>
          <p>Não foram encontradas partidas ranqueadas recentes para este jogador</p>
        </div>
      </div>
    `;
  }

  renderPlayerAnalysisContent(member, analysis, rawMatches, playerName) {
    const hasAvatar = member.avatar_url && member.avatar_url !== '' && member.avatar_url !== 'null';
    const memberInitial = (member.display_name || member.username || '?').charAt(0).toUpperCase();
    const monthData = analysis.month;
    
    // Filtrar partidas do mês
    const now = new Date();
    const monthAgo = new Date(now - 30 * 24 * 60 * 60 * 1000);
    const monthMatches = rawMatches.filter(m => new Date(m.metadata?.started_at || m.game_start * 1000) >= monthAgo);

    return `
      <div class="fullscreen-analysis-header">
        <button class="btn-back-premium" onclick="rankedStats.closeAnalysisModal()">
          <i class="fas fa-arrow-left"></i>
          <span>Voltar</span>
        </button>
        <div class="fullscreen-player-info">
          <div class="fullscreen-avatar">
            ${hasAvatar ? `
              <img src="${member.avatar_url}" alt="${member.display_name}"
                   onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
              <div class="avatar-fallback-lg" style="display:none;"><span>${memberInitial}</span></div>
            ` : `
              <div class="avatar-fallback-lg"><span>${memberInitial}</span></div>
            `}
          </div>
          <div class="fullscreen-player-details">
            <h1>${member.display_name || member.username}</h1>
            <span class="fullscreen-riot-id">${member.riot_id}#${member.riot_tag}</span>
          </div>
        </div>
      </div>
      
      <div class="fullscreen-analysis-body">
        <!-- Period Tabs Premium -->
        <div class="period-tabs-premium">
          <button class="period-tab-premium active" data-period="month">
            <i class="fas fa-calendar-alt"></i>
            <span>Mês</span>
          </button>
          <button class="period-tab-premium" data-period="week">
            <i class="fas fa-calendar-week"></i>
            <span>Semana</span>
          </button>
          <button class="period-tab-premium" data-period="day">
            <i class="fas fa-sun"></i>
            <span>Hoje</span>
          </button>
        </div>
        
        <!-- Two Column Layout -->
        <div class="analysis-columns">
          <!-- Top Agents Column -->
          <div class="analysis-column">
            <div class="premium-section-header">
              <div class="section-icon"><i class="fas fa-user-ninja"></i></div>
              <h2>Top 5 Agentes</h2>
            </div>
            <div class="top-agents-premium" id="topAgentsGrid">
              ${this.renderTopAgentsPremium(monthData.topAgents)}
            </div>
          </div>
          
          <!-- Agents by Map Column -->
          <div class="analysis-column">
            <div class="premium-section-header">
              <div class="section-icon"><i class="fas fa-map-marked-alt"></i></div>
              <h2>Agentes por Mapa</h2>
            </div>
            <div class="agents-by-map-premium" id="agentsByMapGrid">
              ${this.renderAgentsByMapPremium(monthData.agentsByMap)}
            </div>
          </div>
        </div>
        
        <!-- Matches List -->
        <div class="matches-list-section">
          <div class="premium-section-header">
            <div class="section-icon"><i class="fas fa-list"></i></div>
            <h2>Histórico de Partidas</h2>
          </div>
          <div class="matches-table-container" id="matchesTableContainer">
            ${this.renderMatchesTable(monthMatches, playerName)}
          </div>
        </div>
      </div>
    `;
  }

  renderMatchesTable(matches, playerName) {
    // Reset de cache por render para evitar detalhes stale entre trocas de período/paginação.
    this._matchDetailsSource.clear();
    this._matchDetailsHtmlCache.clear();

    if (!matches.length) {
      return `<div class="premium-empty-state"><i class="fas fa-gamepad"></i><p>Sem partidas neste período</p></div>`;
    }

    const visible = this._matchesVisible || 15;
    const visibleMatches = matches.slice(0, visible);
    const hasMore = matches.length > visible;

    return `
      <div class="ranked-match-cards">
        ${visibleMatches.map((match) => this.renderMatchCard(match, playerName, { expanded: false })).join('')}
      </div>
      ${hasMore ? `
        <button class="btn-show-more-matches" onclick="rankedStats.showMoreMatches()">
          <i class="fas fa-chevron-down"></i>
          <span>Ver mais (${matches.length - visible} restantes)</span>
        </button>
      ` : ''}
    `;
  }

  renderMatchCard(match, playerName, options = {}) {
    // Find the player in this match (full player from players array has tier)
    const players = this.getMatchPlayers(match);
    const fullPlayer = players.find(p => p.name?.toLowerCase() === playerName?.toLowerCase());
    const player = fullPlayer || match.player;
    
    if (!player) return '';
    
    const stats = player.stats || {};
    const agentKey = this.resolvePlayerAgentKey(player);
    const agent = this.resolvePlayerAgentLabel(player, agentKey);
    const agentIcon = this.agentsData?.[agentKey]?.displayIcon || `/img/agents/${agentKey}.png`;
    const mapName = match.metadata?.map?.name || match.map || 'Desconhecido';
    
    // Rank/Tier info
    const tier = fullPlayer?.tier || player?.tier || null;
    const tierName = tier?.name || '';
    const tierId = tier?.id || 0;
    const tierImage = tierId > 0 ? `https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/${tierId}/smallicon.png` : '';
    
    // Calculate stats
    const kills = stats.kills || 0;
    const deaths = stats.deaths || 0;
    const assists = stats.assists || 0;
    const score = stats.score || 0;
    const headshots = stats.headshots || 0;
    const bodyshots = stats.bodyshots || 0;
    const legshots = stats.legshots || 0;
    const totalShots = headshots + bodyshots + legshots;
    const hsPercent = totalShots > 0 ? Math.round((headshots / totalShots) * 100) : 0;
    const damageDealt = stats.damage?.dealt || 0;
    const damageReceived = stats.damage?.received || 0;
    
    // Rounds info
    let teams = match.teams || [];
    if (!Array.isArray(teams)) {
      teams = Object.entries(teams).map(([key, value]) => ({
        team_id: key.charAt(0).toUpperCase() + key.slice(1),
        ...value
      }));
    }
    
    const playerTeamId = (player.team_id || player.team || '').toLowerCase();
    const playerTeam = teams.find(t => (t.team_id || '').toLowerCase() === playerTeamId) || {};
    const enemyTeam = teams.find(t => (t.team_id || '').toLowerCase() !== playerTeamId) || {};
    
    const roundsWon = playerTeam.rounds?.won ?? playerTeam.rounds_won ?? 0;
    const roundsLost = playerTeam.rounds?.lost ?? playerTeam.rounds_lost ?? enemyTeam.rounds?.won ?? 0;
    const totalRounds = roundsWon + roundsLost || 1;
    const won = playerTeam.won ?? playerTeam.has_won ?? false;
    const killEvents = match.kills || [];
    
    const acs = Math.round(score / totalRounds);
    const adr = Math.round(damageDealt / totalRounds);
    const kd = deaths > 0 ? (kills / deaths).toFixed(2) : kills.toFixed(2);
    const plusMinus = kills - deaths;
    const plusMinusStr = plusMinus >= 0 ? `+${plusMinus}` : `${plusMinus}`;
    const kast = this.computePlayerMatchKastPercent(match, player);
    
    // FK/FD
    const firstActionStats = this.extractPlayerFirstActionStats(match, player);
    const firstKills = firstActionStats.firstKills;
    const firstDeaths = firstActionStats.firstDeaths;
    
    // Plants and Defuses
    let plants = 0;
    let defuses = 0;
    const roundsData = match.rounds || [];
    roundsData.forEach(r => {
      if (r.plant?.player?.name?.toLowerCase() === playerName?.toLowerCase()) plants++;
      if (r.defuse?.player?.name?.toLowerCase() === playerName?.toLowerCase()) defuses++;
    });

    const matchId = match.metadata?.match_id || `match-${Math.random().toString(36).substr(2, 9)}`;
    this._matchDetailsSource.set(matchId, {
      match,
      allPlayers: players,
      playerName,
      playerTeamId,
      roundsWon,
      roundsLost,
      killEvents
    });

    const resultClass = won ? 'victory' : 'defeat';
    const startExpanded = options?.expanded === true;
    
    // Date from match metadata
    const matchDate = match.metadata?.started_at 
      ? new Date(match.metadata.started_at).toLocaleDateString('pt-BR')
      : '';
    const matchTime = match.metadata?.started_at
      ? new Date(match.metadata.started_at).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
      : '';

    // Build stat chips
    const statChips = [];
    statChips.push(`<span class="rmc-stat entry-pm"><strong>+/-</strong> <em class="${plusMinus >= 0 ? 'stat-high' : 'stat-low'}">${plusMinusStr}</em></span>`);
    statChips.push(`<span class="rmc-stat"><strong>ACS</strong> <em class="${acs >= 250 ? 'stat-high' : acs >= 200 ? 'stat-med' : ''}">${acs}</em></span>`);
    statChips.push(`<span class="rmc-stat"><strong>K/D/A</strong> <em>${kills}/${deaths}/${assists}</em></span>`);
    statChips.push(`<span class="rmc-stat"><strong>ADR</strong> <em class="${adr >= 160 ? 'stat-high' : adr >= 130 ? 'stat-med' : ''}">${adr}</em></span>`);
    statChips.push(`<span class="rmc-stat"><strong>HS%</strong> <em class="${hsPercent >= 30 ? 'stat-high' : hsPercent >= 20 ? 'stat-med' : ''}">${hsPercent}%</em></span>`);
    statChips.push(`<span class="rmc-stat kast"><strong>KAST</strong> <em class="${kast >= 75 ? 'stat-high' : kast >= 65 ? 'stat-med' : ''}">${kast}%</em></span>`);
    statChips.push(`<span class="rmc-stat fd"><strong>FD</strong> <em>${firstDeaths}</em></span>`);
    if (firstKills > 0) statChips.push(`<span class="rmc-stat fk"><strong>FK</strong> <em>${firstKills}</em></span>`);
    if (plants > 0) statChips.push(`<span class="rmc-stat plant"><strong>PL</strong> <em>${plants}</em></span>`);
    if (defuses > 0) statChips.push(`<span class="rmc-stat defuse"><strong>DF</strong> <em>${defuses}</em></span>`);

    // Map background (same visual priority used in Agents by Map)
    const mapKey = mapName?.toLowerCase();
    const mapData = this.mapsData?.[mapKey];
    const mapBackground = mapData?.splash
      || mapData?.stylizedBackgroundImage
      || mapData?.listViewIcon
      || mapData?.displayIcon
      || mapData?.displayIconSmall
      || this.mapsMultipliers?.[mapKey]?.displayIcon
      || '';

    let preloadedDetailsHtml = '';
    if (startExpanded) {
      const scoreboardData = {
        allPlayers: players,
        playerTeamId,
        roundsWon: Number(roundsWon || 0),
        roundsLost: Number(roundsLost || 0),
        killEvents
      };

      preloadedDetailsHtml = this.renderMatchDetails(
        matchId,
        null,
        null,
        0,
        null,
        mapName,
        killEvents,
        playerName,
        match?.rounds || [],
        scoreboardData
      );

      this._matchDetailsHtmlCache.set(matchId, preloadedDetailsHtml);
    }

    return `
      <div class="rmm-card ${resultClass} ${startExpanded ? 'expanded' : ''}" onclick="rankedStats.toggleMatchDetails('${matchId}')" style="cursor:pointer;">
        <div class="rmm-map-bg ${mapBackground ? '' : 'is-fallback'}" ${mapBackground ? `style="background-image:url('${mapBackground}')"` : ''}></div>
        <div class="rmm-map-shade"></div>
        <div class="rmm-overlay ${resultClass}"></div>
        <div class="rmm-strip ${resultClass}"></div>
        <div class="rmm-content rmc-layout">
          <div class="rmc-score-block ${resultClass}">
            <span class="rmc-score-value">${roundsWon}</span>
            <span class="rmc-score-sep">:</span>
            <span class="rmc-score-value">${roundsLost}</span>
          </div>
          <div class="rmc-agent">
            <div class="rmc-agent-icon-wrap" style="${this.getAgentGradientStyle(agentKey)}">
              <img src="${agentIcon}" alt="${agent}" class="rmc-agent-icon" onerror="this.style.display='none'">
            </div>
            <span class="rmc-agent-name">${agent}</span>
          </div>
          ${tierImage ? `
          <div class="rmc-rank">
            <img src="${tierImage}" alt="${tierName}" class="rmc-rank-icon" onerror="this.style.display='none'">
            <span class="rmc-rank-name">${this.simplifyRank(tierName)}</span>
          </div>
          ` : ''}
          <div class="rmc-kd-big">
            <span class="rmc-kd-value ${parseFloat(kd) >= 1.5 ? 'stat-high' : parseFloat(kd) >= 1.0 ? 'stat-med' : 'stat-low'}">${kd}</span>
            <span class="rmc-kd-label">K/D</span>
          </div>
          <div class="rmc-main">
            <div class="rmc-top-row">
              <span class="rmc-map-badge">${mapName}</span>
              ${matchDate ? `<span class="rmc-date"><i class="fas fa-calendar-alt"></i> ${matchDate} ${matchTime}</span>` : ''}
            </div>
            <div class="rmc-stats-row">
              ${statChips.join('')}
            </div>
          </div>
        </div>
      </div>
      <div class="rmc-details-panel" id="details-${matchId}" style="display: ${startExpanded ? 'block' : 'none'};" data-loaded="${startExpanded ? 'true' : 'false'}">${preloadedDetailsHtml}</div>
    `;
  }

  calculateSideStats(match, playerName, playerTeamId) {
    const killEvents = match.kills || [];
    const pName = playerName?.toLowerCase() || '';
    
    // Determine starting side based on team
    // Red team starts attacking, Blue team starts defending
    const startsAttacking = playerTeamId === 'red';
    
    let attackKills = 0, attackDeaths = 0, attackRounds = 0, attackFK = 0, attackFD = 0;
    let defenseKills = 0, defenseDeaths = 0, defenseRounds = 0, defenseFK = 0, defenseFD = 0;
    let pistolRound1 = { kills: 0, deaths: 0 };
    let pistolRound2 = { kills: 0, deaths: 0 };
    
    // Get total rounds
    const totalRounds = (match.rounds || []).length;
    
    // Group kills by round for first kill/death detection
    const killsByRound = {};
    killEvents.forEach(kill => {
      const round = kill.round ?? 0;
      if (!killsByRound[round]) {
        killsByRound[round] = [];
      }
      killsByRound[round].push(kill);
    });
    
    // Calculate first kills/deaths per side
    Object.entries(killsByRound).forEach(([roundStr, roundKills]) => {
      const round = parseInt(roundStr);
      const isFirstHalf = round < 12;
      const isAttacking = startsAttacking ? isFirstHalf : !isFirstHalf;
      
      // Sort by time to get first kill
      roundKills.sort((a, b) => (a.time_in_round_in_ms || 0) - (b.time_in_round_in_ms || 0));
      const firstKill = roundKills[0];
      
      if (firstKill) {
        const killerName = firstKill.killer?.name?.toLowerCase() || '';
        const victimName = firstKill.victim?.name?.toLowerCase() || '';
        
        if (killerName === pName) {
          if (isAttacking) attackFK++;
          else defenseFK++;
        }
        if (victimName === pName) {
          if (isAttacking) attackFD++;
          else defenseFD++;
        }
      }
    });
    
    // Process kills for totals
    killEvents.forEach(kill => {
      const round = kill.round ?? 0;
      const isFirstHalf = round < 12;
      const isAttacking = startsAttacking ? isFirstHalf : !isFirstHalf;
      
      const killerName = kill.killer?.name?.toLowerCase() || '';
      const victimName = kill.victim?.name?.toLowerCase() || '';
      
      if (killerName === pName) {
        if (isAttacking) attackKills++;
        else defenseKills++;
        
        // Pistol rounds
        if (round === 0) pistolRound1.kills++;
        if (round === 12) pistolRound2.kills++;
      }
      
      if (victimName === pName) {
        if (isAttacking) attackDeaths++;
        else defenseDeaths++;
        
        // Pistol rounds
        if (round === 0) pistolRound1.deaths++;
        if (round === 12) pistolRound2.deaths++;
      }
    });
    
    // Calculate rounds per side
    const firstHalfRounds = Math.min(totalRounds, 12);
    const secondHalfRounds = Math.max(0, totalRounds - 12);
    
    if (startsAttacking) {
      attackRounds = firstHalfRounds;
      defenseRounds = secondHalfRounds;
    } else {
      defenseRounds = firstHalfRounds;
      attackRounds = secondHalfRounds;
    }
    
    return {
      attack: { kills: attackKills, deaths: attackDeaths, rounds: attackRounds, fk: attackFK, fd: attackFD },
      defense: { kills: defenseKills, deaths: defenseDeaths, rounds: defenseRounds, fk: defenseFK, fd: defenseFD },
      pistol1: pistolRound1,
      pistol2: pistolRound2,
      startsAttacking
    };
  }

  calculateWeaponKills(match, playerName) {
    const killEvents = match.kills || [];
    const pName = playerName?.toLowerCase() || '';
    const weaponCounts = {};

    // Build a lookup: player name → agent name
    const playerAgentMap = {};
    const allPlayers = this.getMatchPlayers(match);
    (Array.isArray(allPlayers) ? allPlayers : []).forEach(p => {
      const n = (p.name || '').toLowerCase();
      const agentName = p.agent?.name || p.agent || '';
      if (n && agentName) playerAgentMap[n] = typeof agentName === 'string' ? agentName : '';
    });

    killEvents.forEach(kill => {
      const killerName = kill.killer?.name?.toLowerCase() || '';
      if (killerName === pName && kill.weapon) {
        let weaponName = kill.weapon.name || '';
        const weaponType = kill.weapon.type || '';

        // Debug: log unknown weapon kills
        if (!weaponName || weaponName === 'Unknown') {
          console.log('[WeaponDebug] Unknown weapon kill:', JSON.stringify({
            weapon: kill.weapon,
            killerName,
            agentMap: playerAgentMap,
            allKeys: Object.keys(kill)
          }));
        }

        // If weapon name is missing/Unknown, resolve to agent ability
        if (!weaponName || weaponName === 'Unknown') {
          const agentName = playerAgentMap[killerName] || '';
          if (agentName) {
            weaponName = `${agentName} (Hab.)`;
          } else {
            weaponName = 'Habilidade';
          }
        }
        
        if (!weaponCounts[weaponName]) {
          weaponCounts[weaponName] = { count: 0, type: weaponType || 'Ability' };
        }
        weaponCounts[weaponName].count++;
      }
    });
    
    // Sort by count descending
    return Object.entries(weaponCounts)
      .sort((a, b) => b[1].count - a[1].count)
      .map(([name, data]) => ({ name, count: data.count, type: data.type }));
  }

  calculateRegionStats(match, playerName, mapName) {
    const killEvents = match.kills || [];
    const rounds = match.rounds || [];
    const pName = playerName?.toLowerCase() || '';
    
    // Determinar se começa atacando
    const allPlayers = match.players?.all_players || [];
    const player = allPlayers.find(p => p.name?.toLowerCase() === pName);
    const playerTeam = player?.team?.toLowerCase();
    const startsAttacking = playerTeam === 'red';
    
    // Separar por lado
    const attackKillsByRegion = {};
    const attackDeathsByRegion = {};
    const defenseKillsByRegion = {};
    const defenseDeathsByRegion = {};
    
    killEvents.forEach(kill => {
      const killerName = kill.killer?.name?.toLowerCase() || '';
      const victimName = kill.victim?.name?.toLowerCase() || '';
      const location = kill.location;
      const roundNum = kill.round || 0;
      
      if (!location) return;
      
      // Determinar lado do jogador neste round
      const isFirstHalf = roundNum <= 12;
      const isAttacking = (startsAttacking && isFirstHalf) || (!startsAttacking && !isFirstHalf);
      
      const region = this.findNearestRegion(location.x, location.y, mapName);
      
      // Registrar kill
      if (killerName === pName) {
        if (isAttacking) {
          attackKillsByRegion[region] = (attackKillsByRegion[region] || 0) + 1;
        } else {
          defenseKillsByRegion[region] = (defenseKillsByRegion[region] || 0) + 1;
        }
      }
      
      // Registrar death
      if (victimName === pName) {
        if (isAttacking) {
          attackDeathsByRegion[region] = (attackDeathsByRegion[region] || 0) + 1;
        } else {
          defenseDeathsByRegion[region] = (defenseDeathsByRegion[region] || 0) + 1;
        }
      }
    });
    
    // Converter para arrays ordenados
    const toSortedArray = (obj) => Object.entries(obj)
      .sort((a, b) => b[1] - a[1])
      .map(([region, count]) => ({ region, count }));
    
    return {
      attack: {
        kills: toSortedArray(attackKillsByRegion),
        deaths: toSortedArray(attackDeathsByRegion)
      },
      defense: {
        kills: toSortedArray(defenseKillsByRegion),
        deaths: toSortedArray(defenseDeathsByRegion)
      }
    };
  }

  renderMatchDetails(matchId, sideStats, weaponKills, totalKills, regionStats, mapName, killEvents, playerName, rounds, extraData = {}) {
    const scoreboardHtml = this.renderScoreboardSection(extraData, playerName);

    return `
      <div class="match-details-content">
        ${scoreboardHtml}
      </div>
    `;
  }

  renderScoreboardSection(data, playerName) {
    const {
      allPlayers, playerTeamId, roundsWon, roundsLost, killEvents
    } = data || {};

    const players = Array.isArray(allPlayers) ? allPlayers : [];
    if (players.length === 0) {
      return `
        <div class="details-section full-width scoreboard-full">
          <div class="premium-empty-state">
            <i class="fas fa-users"></i>
            <p>Scoreboard indisponível para esta partida.</p>
          </div>
        </div>
      `;
    }

    const pName = playerName?.toLowerCase() || '';
    const totalRounds = (roundsWon + roundsLost) || 1;
    const teamPlayers = players.filter(p => (p.team_id || p.team || '').toLowerCase() === playerTeamId);
    const enemyPlayers = players.filter(p => (p.team_id || p.team || '').toLowerCase() !== playerTeamId);

    const getTierDisplayFromId = (tierId) => {
      const tierMap = {
        3: 'Iron 1', 4: 'Iron 2', 5: 'Iron 3',
        6: 'Bronze 1', 7: 'Bronze 2', 8: 'Bronze 3',
        9: 'Silver 1', 10: 'Silver 2', 11: 'Silver 3',
        12: 'Gold 1', 13: 'Gold 2', 14: 'Gold 3',
        15: 'Platinum 1', 16: 'Platinum 2', 17: 'Platinum 3',
        18: 'Diamond 1', 19: 'Diamond 2', 20: 'Diamond 3',
        21: 'Ascendant 1', 22: 'Ascendant 2', 23: 'Ascendant 3',
        24: 'Immortal 1', 25: 'Immortal 2', 26: 'Immortal 3',
        27: 'Radiant'
      };

      return tierMap[tierId] || '--';
    };

    const getTierIcon = (tierId) => tierId > 0
      ? `https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/${tierId}/smallicon.png`
      : '';

    const firstKillByRound = new Map();
    const playerRoundKills = new Map();
    const killsByRound = new Map();

    (killEvents || []).forEach((kill) => {
      const round = kill.round ?? 0;
      const killerPuuid = kill.killer?.puuid || '';
      const victimPuuid = kill.victim?.puuid || '';

      if (!killsByRound.has(round)) killsByRound.set(round, []);
      killsByRound.get(round).push(kill);

      if (!firstKillByRound.has(round)) {
        firstKillByRound.set(round, { killerPuuid, victimPuuid });
      }

      if (killerPuuid) {
        if (!playerRoundKills.has(killerPuuid)) {
          playerRoundKills.set(killerPuuid, new Map());
        }
        const roundKills = playerRoundKills.get(killerPuuid);
        roundKills.set(round, (roundKills.get(round) || 0) + 1);
      }
    });

    const computeKASTFromKillFeed = (puuid) => {
      if (!puuid) return 0;

      let kastRounds = 0;
      for (let r = 0; r < totalRounds; r++) {
        const rKills = killsByRound.get(r) || [];
        const gotKill = rKills.some((k) => k.killer?.puuid === puuid);
        const gotAssist = rKills.some((k) => (k.assistants || []).some((a) => a.puuid === puuid));
        const deathEvent = rKills.find((k) => k.victim?.puuid === puuid);
        const survived = !deathEvent;

        let traded = false;
        if (deathEvent) {
          const killerPuuid = deathEvent.killer?.puuid;
          const deathTime = deathEvent.time_in_round_in_ms || 0;
          const victimTeam = deathEvent.victim?.team;
          traded = rKills.some((k2) =>
            k2.victim?.puuid === killerPuuid
            && k2.killer?.team === victimTeam
            && (k2.time_in_round_in_ms || 0) > deathTime
            && (k2.time_in_round_in_ms || 0) - deathTime <= 5000
          );
        }

        if (gotKill || gotAssist || survived || traded) kastRounds += 1;
      }

      return totalRounds > 0 ? Math.round((kastRounds / totalRounds) * 100) : 0;
    };

    const enhancePlayer = (p) => {
      const stats = p.stats || {};
      const tierId = p.tier?.id || 0;
      const dealtDamage = stats.damage?.dealt || 0;
      const receivedDamage = stats.damage?.received || 0;
      const kills = stats.kills || 0;
      const deaths = stats.deaths || 0;
      const assists = stats.assists || 0;
      const score = stats.score || 0;
      const headshots = stats.headshots || 0;
      const bodyshots = stats.bodyshots || 0;
      const legshots = stats.legshots || 0;
      const totalShots = headshots + bodyshots + legshots;
      const hsPercent = totalShots > 0 ? Math.round((headshots / totalShots) * 100) : 0;
      const acs = Math.round(score / totalRounds);
      const kd = deaths > 0 ? (kills / deaths).toFixed(1) : kills.toFixed(1);
      const plusMinus = kills - deaths;
      const damageDeltaPerRound = Math.round((dealtDamage - receivedDamage) / totalRounds);
      const adr = (dealtDamage / totalRounds).toFixed(1);
      const roundKills = playerRoundKills.get(p.puuid) || new Map();
      const multiKillRounds = Array.from(roundKills.values()).filter((count) => count >= 2).length;

      let firstKills = 0;
      let firstDeaths = 0;
      firstKillByRound.forEach((firstKill) => {
        if (firstKill.killerPuuid && firstKill.killerPuuid === p.puuid) firstKills += 1;
        if (firstKill.victimPuuid && firstKill.victimPuuid === p.puuid) firstDeaths += 1;
      });

      const kastFromPayload = this.readKastPercentFromPlayerEntry(p);
      const kast = kastFromPayload !== null ? kastFromPayload : computeKASTFromKillFeed(p.puuid);

      return {
        ...p,
        _derived: {
          tierId,
          tierName: p.tier?.name || '--',
          tierIcon: getTierIcon(tierId),
          matchRank: 0,
          trs: score,
          acs,
          kills,
          deaths,
          assists,
          plusMinus,
          kd,
          damageDeltaPerRound,
          adr,
          hsPercent,
          kast,
          firstKills,
          firstDeaths,
          multiKillRounds
        }
      };
    };

    const enhancedPlayers = players.map(enhancePlayer)
      .sort((a, b) => b._derived.trs - a._derived.trs);

    enhancedPlayers.forEach((player, index) => {
      player._derived.matchRank = index + 1;
    });

    const enhancedTeamPlayers = enhancedPlayers.filter(p => (p.team_id || p.team || '').toLowerCase() === playerTeamId);
    const enhancedEnemyPlayers = enhancedPlayers.filter(p => (p.team_id || p.team || '').toLowerCase() !== playerTeamId);

    const getAverageRank = (team) => {
      if (team.length === 0) {
        return { label: '--', icon: '' };
      }

      const avgTierId = Math.round(team.reduce((sum, p) => sum + (p._derived.tierId || 0), 0) / team.length);
      return {
        label: this.simplifyRank(getTierDisplayFromId(avgTierId)),
        icon: getTierIcon(avgTierId)
      };
    };

    const teamAverageRank = getAverageRank(enhancedTeamPlayers);
    const enemyAverageRank = getAverageRank(enhancedEnemyPlayers);

    const renderPlayerRow = (p, isCurrentPlayer) => {
      const derived = p._derived;
      const pAgentKey = this.resolvePlayerAgentKey(p);
      const pAgent = this.resolvePlayerAgentLabel(p, pAgentKey);
      const pAgentIcon = this.agentsData?.[pAgentKey]?.displayIcon || '';
      const highlight = isCurrentPlayer ? 'current-player' : '';
      const accountLevel = p.account_level || '';
      
      return `
        <div class="sb-row ${highlight}">
          <div class="sb-agent">
            <div class="sb-agent-wrapper" style="${this.getAgentGradientStyle(pAgentKey)}">
              ${pAgentIcon ? `<img src="${pAgentIcon}" alt="${pAgent}" class="sb-agent-icon">` : ''}
              ${accountLevel ? `<span class="sb-agent-level">${accountLevel}</span>` : ''}
            </div>
            <div class="sb-player-meta">
              <span class="sb-name">${p.name || ''} <span class="sb-tag">#${p.tag || ''}</span></span>
              <span class="sb-rank-sub">${derived.tierName}</span>
            </div>
          </div>
          <span class="sb-rank-cell">${derived.tierIcon ? `<img src="${derived.tierIcon}" alt="${derived.tierName}" class="sb-rank-icon">` : ''}</span>
          <span class="sb-stat">${derived.trs}</span>
          <span class="sb-stat sb-stat-strong">${derived.acs}</span>
          <span class="sb-stat">${derived.kills}</span>
          <span class="sb-stat">${derived.deaths}</span>
          <span class="sb-stat">${derived.assists}</span>
          <span class="sb-stat ${derived.plusMinus >= 0 ? 'sb-pos' : 'sb-neg'}">${derived.plusMinus >= 0 ? '+' : ''}${derived.plusMinus}</span>
          <span class="sb-stat ${parseFloat(derived.kd) >= 1 ? 'sb-pos' : 'sb-neg'}">${derived.kd}</span>
          <span class="sb-stat ${derived.damageDeltaPerRound >= 0 ? 'sb-pos' : 'sb-neg'}">${derived.damageDeltaPerRound >= 0 ? '+' : ''}${derived.damageDeltaPerRound}</span>
          <span class="sb-stat">${derived.adr}</span>
          <span class="sb-stat">${derived.hsPercent}%</span>
          <span class="sb-stat">${derived.kast}%</span>
          <span class="sb-stat">${derived.firstKills}</span>
          <span class="sb-stat">${derived.firstDeaths}</span>
          <span class="sb-stat">${derived.multiKillRounds}</span>
        </div>
      `;
    };

    return `
      <div class="details-section full-width scoreboard-full">
        <div class="scoreboard-container">
          <div class="sb-team">
            <div class="sb-team-header ally">
              <span class="sb-team-line"><span class="sb-team-name">Seu Time</span><span class="sb-team-score">${roundsWon}</span></span>
              <span class="sb-team-rank">Avg Rank: ${teamAverageRank.icon ? `<img src="${teamAverageRank.icon}" alt="${teamAverageRank.label}" class="sb-team-rank-icon">` : ''}${teamAverageRank.label}</span>
            </div>
            <div class="sb-header-row">
              <span class="sb-agent-header">Jogador</span>
              <span class="sb-stat-header">Match Rank</span>
              <span class="sb-stat-header">TRS</span>
              <span class="sb-stat-header">ACS</span>
              <span class="sb-stat-header">K</span>
              <span class="sb-stat-header">D</span>
              <span class="sb-stat-header">A</span>
              <span class="sb-stat-header">+/-</span>
              <span class="sb-stat-header">K/D</span>
              <span class="sb-stat-header">DDΔ</span>
              <span class="sb-stat-header">ADR</span>
              <span class="sb-stat-header">HS%</span>
              <span class="sb-stat-header">KAST</span>
              <span class="sb-stat-header">FK</span>
              <span class="sb-stat-header">FD</span>
              <span class="sb-stat-header">MK</span>
            </div>
            ${enhancedTeamPlayers.map(p => renderPlayerRow(p, p.name?.toLowerCase() === pName)).join('')}
          </div>
          <div class="sb-team">
            <div class="sb-team-header enemy">
              <span class="sb-team-line"><span class="sb-team-name">Time Inimigo</span><span class="sb-team-score">${roundsLost}</span></span>
              <span class="sb-team-rank">Avg Rank: ${enemyAverageRank.icon ? `<img src="${enemyAverageRank.icon}" alt="${enemyAverageRank.label}" class="sb-team-rank-icon">` : ''}${enemyAverageRank.label}</span>
            </div>
            <div class="sb-header-row">
              <span class="sb-agent-header">Jogador</span>
              <span class="sb-stat-header">Match Rank</span>
              <span class="sb-stat-header">TRS</span>
              <span class="sb-stat-header">ACS</span>
              <span class="sb-stat-header">K</span>
              <span class="sb-stat-header">D</span>
              <span class="sb-stat-header">A</span>
              <span class="sb-stat-header">+/-</span>
              <span class="sb-stat-header">K/D</span>
              <span class="sb-stat-header">DDΔ</span>
              <span class="sb-stat-header">ADR</span>
              <span class="sb-stat-header">HS%</span>
              <span class="sb-stat-header">KAST</span>
              <span class="sb-stat-header">FK</span>
              <span class="sb-stat-header">FD</span>
              <span class="sb-stat-header">MK</span>
            </div>
            ${enhancedEnemyPlayers.map(p => renderPlayerRow(p, false)).join('')}
          </div>
        </div>
      </div>
    `;
  }

  // Calcular First Kills e First Deaths por round com lado (ATK/DEF)
  calculateFirstKillDeaths(killEvents, playerName, mapName, startsAttacking) {
    const pName = playerName?.toLowerCase() || '';
    const firstKillsAtk = [];
    const firstKillsDef = [];
    const firstDeathsAtk = [];
    const firstDeathsDef = [];
    
    // Agrupar kills por round
    const killsByRound = {};
    killEvents.forEach(kill => {
      const round = kill.round || 0;
      if (!killsByRound[round]) {
        killsByRound[round] = [];
      }
      killsByRound[round].push(kill);
    });
    
    // Para cada round, verificar se o jogador foi o primeiro a matar ou morrer
    Object.keys(killsByRound).forEach(roundStr => {
      const round = parseInt(roundStr);
      const roundKills = killsByRound[round];
      if (roundKills.length === 0) return;
      
      // Determinar se está atacando ou defendendo neste round
      // Rounds 1-12: primeiro lado, 13-24: segundo lado
      const isFirstHalf = round <= 12;
      const isAttacking = isFirstHalf ? startsAttacking : !startsAttacking;
      
      // Primeira kill do round
      const firstKill = roundKills[0];
      
      const killerName = firstKill.killer?.name?.toLowerCase() || '';
      const victimName = firstKill.victim?.name?.toLowerCase() || '';
      const location = firstKill.location;
      
      if (location && location.x !== undefined && location.y !== undefined) {
        const nearestCallout = this.getNearestCalloutDetails(location.x, location.y, mapName);
        if (!nearestCallout) return;

        const actualPoint = this.projectGameCoordinatesToMap(location.x, location.y, mapName);
        if (!actualPoint) return;

        const pointData = {
          round,
          region: nearestCallout.region,
          x: actualPoint.x,
          y: actualPoint.y
        };
        
        if (killerName === pName) {
          if (isAttacking) {
            firstKillsAtk.push(pointData);
          } else {
            firstKillsDef.push(pointData);
          }
        }
        
        if (victimName === pName) {
          if (isAttacking) {
            firstDeathsAtk.push(pointData);
          } else {
            firstDeathsDef.push(pointData);
          }
        }
      }
    });
    
    // Ordenar por round
    firstKillsAtk.sort((a, b) => a.round - b.round);
    firstKillsDef.sort((a, b) => a.round - b.round);
    firstDeathsAtk.sort((a, b) => a.round - b.round);
    firstDeathsDef.sort((a, b) => a.round - b.round);
    
    return { 
      attack: { firstKills: firstKillsAtk, firstDeaths: firstDeathsAtk },
      defense: { firstKills: firstKillsDef, firstDeaths: firstDeathsDef }
    };
  }

  isSpawnCallout(callout) {
    if (!callout) return false;

    const regionName = String(callout.regionName || '').trim().toLowerCase();
    const superRegion = String(callout.superRegion || '').trim().toLowerCase();
    const superRegionName = String(callout.superRegionName || '').trim().toLowerCase();

    return regionName === 'surgimento'
      || superRegion.includes('attackerside')
      || superRegion.includes('defenderside')
      || superRegionName.includes('lado atacante')
      || superRegionName.includes('lado defensor');
  }

  getNearestCalloutDetails(gameX, gameY, mapName, options = {}) {
    const { excludeSpawn = true } = options;
    const callouts = this.mapsCallouts[mapName?.toLowerCase()];
    if (!callouts || callouts.length === 0) return null;

    const candidateCallouts = excludeSpawn
      ? callouts.filter(callout => !this.isSpawnCallout(callout))
      : callouts;

    const searchableCallouts = candidateCallouts.length > 0 ? candidateCallouts : callouts;
    
    let nearestCallout = null;
    let minDistance = Infinity;
    
    searchableCallouts.forEach(callout => {
      const dx = gameX - callout.location.x;
      const dy = gameY - callout.location.y;
      const distance = Math.sqrt(dx * dx + dy * dy);
      
      if (distance < minDistance) {
        minDistance = distance;
        nearestCallout = callout;
      }
    });

    if (!nearestCallout) return null;

    const projectedPoint = this.projectGameCoordinatesToMap(
      nearestCallout.location.x,
      nearestCallout.location.y,
      mapName
    );

    if (!projectedPoint) return null;

    return {
      callout: nearestCallout,
      region: this.formatCalloutName(nearestCallout),
      projectedPoint
    };
  }

  // Encontrar a região mais próxima baseada nas coordenadas do jogo
  findNearestRegion(gameX, gameY, mapName) {
    const nearestCallout = this.getNearestCalloutDetails(gameX, gameY, mapName, { excludeSpawn: true });
    if (!nearestCallout) return 'Desconhecido';
    
    return nearestCallout.region;
  }

  formatCalloutName(callout) {
    if (!callout) return 'Desconhecido';

    const regionName = String(callout.regionName || '').trim();
    const superRegionName = String(callout.superRegionName || '').trim();

    if (!regionName && !superRegionName) return 'Desconhecido';
    if (!superRegionName) return regionName || 'Desconhecido';
    if (!regionName) return superRegionName;

    const normalizedRegion = regionName.toLowerCase();
    const normalizedSuperRegion = superRegionName.toLowerCase();

    if (normalizedRegion.includes(normalizedSuperRegion) || normalizedSuperRegion.includes(normalizedRegion)) {
      return regionName;
    }

    // Ex.: "Surgimento no Lado Atacante" soa mais natural do que "no Lado Atacante Surgimento".
    if (/^(no |na |do |da )/i.test(superRegionName)) {
      return `${regionName} ${superRegionName}`;
    }

    return `${superRegionName} ${regionName}`;
  }

  generateMapPoints(killEvents, playerName, mapName, rounds) {
    const pName = playerName?.toLowerCase() || '';
    const multipliers = this.mapsMultipliers[mapName?.toLowerCase()] || {};
    
    const kills = [];
    const deaths = [];
    
    if (!multipliers.xMultiplier) {
      return { kills, deaths };
    }
    
    killEvents.forEach(kill => {
      const killerName = kill.killer?.name?.toLowerCase() || '';
      const victimName = kill.victim?.name?.toLowerCase() || '';
      const location = kill.location;
      const round = kill.round || 0;
      
      if (!location || location.x === undefined || location.y === undefined) return;
      
      // Determinar o lado baseado no round
      const roundData = rounds?.find(r => r.round === round);
      const playerTeam = kill.killer?.team || kill.victim?.team;
      let side = 'unknown';
      if (roundData) {
        const isFirstHalf = round <= 12;
        // Determinar se o jogador estava atacando ou defendendo neste round
        if (killerName === pName) {
          side = roundData.attacking_team === kill.killer?.team ? 'attack' : 'defense';
        } else if (victimName === pName) {
          side = roundData.attacking_team === kill.victim?.team ? 'attack' : 'defense';
        }
      }
      
      // Encontrar a região mais próxima usando coordenadas do jogo
      const nearestCallout = this.getNearestCalloutDetails(location.x, location.y, mapName);
      if (!nearestCallout) return;

      const actualPoint = this.projectGameCoordinatesToMap(location.x, location.y, mapName);
      if (!actualPoint) return;
      
      if (killerName === pName) {
        kills.push({
          x: actualPoint.x,
          y: actualPoint.y,
          round,
          region: nearestCallout.region,
          side
        });
      }
      
      if (victimName === pName) {
        deaths.push({
          x: actualPoint.x,
          y: actualPoint.y,
          round,
          region: nearestCallout.region,
          side
        });
      }
    });
    
    return { kills, deaths };
  }

  projectGameCoordinatesToMap(gameX, gameY, mapName) {
    const multipliers = this.mapsMultipliers[mapName?.toLowerCase()] || {};
    const imageBounds = this.getMapImageBounds(mapName);
    const overlayAdjustment = this.getMapOverlayAdjustment(mapName);

    if (!multipliers.xMultiplier || !multipliers.yMultiplier) {
      return null;
    }

    const normalizedX = gameX * multipliers.xMultiplier + multipliers.xScalarToAdd;
    const normalizedY = gameY * multipliers.yMultiplier + multipliers.yScalarToAdd;

    const x = ((imageBounds.left + normalizedX * imageBounds.width) * overlayAdjustment.scaleX + overlayAdjustment.offsetX) * 100;
    const y = ((imageBounds.top + normalizedY * imageBounds.height) * overlayAdjustment.scaleY + overlayAdjustment.offsetY) * 100;

    return {
      x: Math.max(0, Math.min(100, x)),
      y: Math.max(0, Math.min(100, y))
    };
  }

  getMapImageBounds(mapName) {
    const presets = {
      ascent: { left: 82 / 2048, top: 94 / 2048, width: 1900 / 2048, height: 1780 / 2048 },
      bind: { left: 181 / 2048, top: 25 / 2048, width: 1839 / 2048, height: 1937 / 2048 },
      haven: { left: 70 / 2048, top: 171 / 2048, width: 1913 / 2048, height: 1717 / 2048 },
      split: { left: 106 / 2048, top: 92 / 2048, width: 1788 / 2048, height: 1901 / 2048 },
      breeze: { left: 32 / 1024, top: 32 / 1024, width: 960 / 1024, height: 942 / 1024 },
      fracture: { left: 44 / 2048, top: 138 / 2048, width: 1850 / 2048, height: 1762 / 2048 },
      icebox: { left: 126 / 2048, top: 157 / 2048, width: 1920 / 2048, height: 1694 / 2048 },
      lotus: { left: 112 / 2048, top: 242 / 2048, width: 1795 / 2048, height: 1595 / 2048 },
      sunset: { left: 92 / 2048, top: 18 / 2048, width: 1897 / 2048, height: 2006 / 2048 },
      pearl: { left: 3 / 1024, top: 36 / 1024, width: 1016 / 1024, height: 950 / 1024 },
      abyss: { left: 30 / 1024, top: 12 / 1024, width: 963 / 1024, height: 997 / 1024 }
    };

    return presets[mapName?.toLowerCase()] || { left: 0, top: 0, width: 1, height: 1 };
  }

  getMapOverlayAdjustment(mapName) {
    const presets = {
      // Validado contra a última partida real carregada em https://zdval.site/ranked.
      // O Abyss usa o minimapa oficial em orientação correta, mas o overlay precisa
      // ser levemente comprimido para dentro da área jogável visível.
      abyss: {
        scaleX: 0.92,
        scaleY: 0.96,
        offsetX: 0.04,
        offsetY: 0.02
      }
    };

    return presets[mapName?.toLowerCase()] || {
      scaleX: 1,
      scaleY: 1,
      offsetX: 0,
      offsetY: 0
    };
  }



  // Toggle para mostrar apenas o ponto selecionado no mapa
  toggleFirstKillPoint(element, matchId) {
    const mapWrapper = document.getElementById(`map-wrapper-${matchId}`);
    if (!mapWrapper) return;
    
    const allPoints = mapWrapper.querySelectorAll('.map-point');
    const allItems = document.querySelectorAll(`.first-stat-item[data-match="${matchId}"]`);
    const isSelected = element.classList.contains('selected');
    
    if (isSelected) {
      // Deselecionar - mostrar todos os pontos
      element.classList.remove('selected');
      allPoints.forEach(point => {
        point.classList.remove('hidden', 'highlighted');
      });
    } else {
      // Remover seleção anterior
      allItems.forEach(item => item.classList.remove('selected'));
      
      // Selecionar este item
      element.classList.add('selected');
      
      // Pegar coordenadas do item clicado e transformar
      const origX = parseFloat(element.dataset.x);
      const origY = parseFloat(element.dataset.y);
      const type = element.dataset.type;
      const mapName = mapWrapper.dataset.mapname;
      const transformed = this.transformPointForMap(origX, origY, mapName);
      
      // Esconder todos os pontos e mostrar apenas o selecionado
      allPoints.forEach(point => {
        point.classList.add('hidden');
        point.classList.remove('highlighted');
      });
      
      // Criar/mostrar o ponto destacado
      let highlightPoint = mapWrapper.querySelector('.map-point.highlight-selected');
      if (!highlightPoint) {
        highlightPoint = document.createElement('div');
        highlightPoint.className = 'map-point highlight-selected';
        mapWrapper.appendChild(highlightPoint);
      }
      
      const isKill = type.startsWith('fk');
      highlightPoint.className = `map-point highlight-selected ${isKill ? 'kill' : 'death'}`;
      highlightPoint.style.left = `${transformed.x}%`;
      highlightPoint.style.top = `${transformed.y}%`;
      highlightPoint.dataset.origX = origX;
      highlightPoint.dataset.origY = origY;
      highlightPoint.classList.remove('hidden');
    }
  }
  
  // Resetar mapa para mostrar todos os pontos
  resetMapPoints(matchId) {
    const mapWrapper = document.getElementById(`map-wrapper-${matchId}`);
    if (!mapWrapper) return;
    
    const allPoints = mapWrapper.querySelectorAll('.map-point');
    const allItems = document.querySelectorAll(`.first-stat-item[data-match="${matchId}"]`);
    
    // Remover seleções
    allItems.forEach(item => item.classList.remove('selected'));
    
    // Mostrar todos os pontos
    allPoints.forEach(point => {
      point.classList.remove('hidden', 'highlighted');
    });
    
    // Remover ponto destacado
    const highlightPoint = mapWrapper.querySelector('.map-point.highlight-selected');
    if (highlightPoint) {
      highlightPoint.remove();
    }
    
    // Remover seleção de headers de lado
    const detailsRow = document.getElementById(`details-${matchId}`);
    if (detailsRow) {
      detailsRow.querySelectorAll('.side-header').forEach(h => h.classList.remove('selected'));
    }
  }

  // Filtrar pontos por lado (attack/defense)
  filterMapBySide(matchId, side) {
    const mapWrapper = document.getElementById(`map-wrapper-${matchId}`);
    const detailsRow = document.getElementById(`details-${matchId}`);
    if (!mapWrapper || !detailsRow) return;
    
    const allPoints = mapWrapper.querySelectorAll('.map-point:not(.highlight-selected)');
    const sideHeaders = detailsRow.querySelectorAll('.side-header');
    const clickedHeader = detailsRow.querySelector(`.side-header.${side}`);
    
    // Verificar se já está selecionado (toggle)
    const isSelected = clickedHeader?.classList.contains('selected');
    
    // Remover seleção de todos os headers
    sideHeaders.forEach(h => h.classList.remove('selected'));
    
    // Remover seleção de itens individuais
    const allItems = document.querySelectorAll(`.first-stat-item[data-match="${matchId}"]`);
    allItems.forEach(item => item.classList.remove('selected'));
    
    // Remover ponto destacado
    const highlightPoint = mapWrapper.querySelector('.map-point.highlight-selected');
    if (highlightPoint) {
      highlightPoint.remove();
    }
    
    if (isSelected) {
      // Deselecionar - mostrar todos os pontos
      allPoints.forEach(point => {
        point.classList.remove('hidden');
      });
    } else {
      // Selecionar lado
      clickedHeader?.classList.add('selected');
      
      // Mostrar apenas pontos do lado selecionado
      allPoints.forEach(point => {
        const pointSide = point.dataset.side;
        if (pointSide === side) {
          point.classList.remove('hidden');
        } else {
          point.classList.add('hidden');
        }
      });
    }
  }

  renderMatchDetailsOnDemand(matchId, detailsPanel) {
    const cachedHtml = this._matchDetailsHtmlCache.get(matchId);
    if (cachedHtml) {
      detailsPanel.innerHTML = cachedHtml;
      detailsPanel.dataset.loaded = 'true';
      return;
    }

    const source = this._matchDetailsSource.get(matchId);
    if (!source) {
      detailsPanel.innerHTML = `
        <div class="premium-empty-state">
          <i class="fas fa-exclamation-circle"></i>
          <p>Detalhes indisponíveis para esta partida.</p>
        </div>
      `;
      detailsPanel.dataset.loaded = 'true';
      return;
    }

    const { match, allPlayers, playerName, playerTeamId, roundsWon, roundsLost, killEvents } = source;
    const scoreboardData = {
      allPlayers: Array.isArray(allPlayers) && allPlayers.length > 0 ? allPlayers : this.getMatchPlayers(match),
      playerTeamId: playerTeamId || String(match?.player?.team_id || match?.player?.team || '').toLowerCase(),
      roundsWon: Number(roundsWon || 0),
      roundsLost: Number(roundsLost || 0),
      killEvents: killEvents || match?.kills || []
    };

    const html = this.renderMatchDetails(
      matchId,
      null,
      null,
      0,
      null,
      '',
      scoreboardData.killEvents,
      playerName,
      match?.rounds || [],
      scoreboardData
    );

    this._matchDetailsHtmlCache.set(matchId, html);
    detailsPanel.innerHTML = html;
    detailsPanel.dataset.loaded = 'true';
  }

  toggleMatchDetails(matchId) {
    const detailsPanel = document.getElementById(`details-${matchId}`);
    if (detailsPanel) {
      const isHidden = detailsPanel.style.display === 'none';
      const hasScoreboardContent = detailsPanel.querySelector('.scoreboard-container');
      const shouldRenderDetails = detailsPanel.dataset.loaded !== 'true' || !hasScoreboardContent;

      if (isHidden && shouldRenderDetails) {
        detailsPanel.innerHTML = `
          <div class="premium-empty-state">
            <div class="spinner"></div>
            <p>Carregando detalhes da partida...</p>
          </div>
        `;
        requestAnimationFrame(() => this.renderMatchDetailsOnDemand(matchId, detailsPanel));
      }

      detailsPanel.style.display = isHidden ? 'block' : 'none';
      
      // Toggle active class on card
      const card = detailsPanel.previousElementSibling;
      if (card) {
        card.classList.toggle('expanded', isHidden);
      }
    }
  }

  // ==========================================================
  // INDIVIDUAL ANALYSIS: compute comprehensive stats per match
  // ==========================================================
  computeIndividualAnalysis(matches, playerName) {
    if (!matches || !matches.length) return { overall: null, byAgent: {} };

    const pName = (playerName || '').toLowerCase();

    const initBucket = () => ({
      matches: 0, wins: 0, kills: 0, deaths: 0, assists: 0, score: 0,
      headshots: 0, bodyshots: 0, legshots: 0,
      damageDealt: 0, damageReceived: 0,
      totalKastRounds: 0,
      kastPercentSum: 0,
      kastMatchCount: 0,
      matchRankSum: 0,
      matchRankCount: 0,
      firstKills: 0, firstDeaths: 0,
      matchesWithKillData: 0,
      plants: 0, defuses: 0,
      mk2: 0, mk3: 0, mk4: 0, mkAce: 0,
      totalRounds: 0,
      econSpent: 0, econLoadout: 0,
      abC: 0, abQ: 0, abE: 0, abX: 0,
      byMap: {},
      mapCount: {},
      latestMatchAt: null
    });

    const overall = initBucket();
    const byAgent = {};

    matches.forEach(match => {
      const players = this.getMatchPlayers(match);
      const fullPlayer = players.find(p => p.name?.toLowerCase() === pName);
      const player = fullPlayer || match.player;
      if (!player) return;

      const stats = player.stats || {};
      const agentKey = this.resolvePlayerAgentKey(player);

      if (!byAgent[agentKey]) byAgent[agentKey] = initBucket();
      const agentBucket = byAgent[agentKey];

      // Win
      const playerTeamId = (player.team_id || player.team || '').toLowerCase();
      let teams = match.teams || [];
      if (!Array.isArray(teams)) {
        teams = Object.entries(teams).map(([k, v]) => ({ team_id: k.charAt(0).toUpperCase() + k.slice(1), ...v }));
      }
      const playerTeam = teams.find(t => (t.team_id || '').toLowerCase() === playerTeamId) || {};
      const enemyTeam = teams.find(t => (t.team_id || '').toLowerCase() !== playerTeamId) || {};
      const roundsWon = playerTeam.rounds?.won ?? playerTeam.rounds_won ?? 0;
      const roundsLost = playerTeam.rounds?.lost ?? playerTeam.rounds_lost ?? enemyTeam.rounds?.won ?? 0;
      const totalRounds = roundsWon + roundsLost || 1;
      const won = playerTeam.won ?? playerTeam.has_won ?? false;

      const k = stats.kills || 0;
      const d = stats.deaths || 0;
      const a = stats.assists || 0;
      const sc = stats.score || 0;
      const hs = stats.headshots || 0;
      const bs = stats.bodyshots || 0;
      const ls = stats.legshots || 0;
      const dd = stats.damage?.dealt || 0;
      const dr = stats.damage?.received || 0;
      const kastRounds = this.extractPlayerKastRounds(match, player);
      const matchKastPercent = this.computePlayerMatchKastPercent(match, player);

      let matchRank = null;
      if (Array.isArray(players) && players.length > 0) {
        const rankedPlayers = [...players].sort((left, right) => Number(right?.stats?.score || 0) - Number(left?.stats?.score || 0));
        const byPuuid = player?.puuid
          ? rankedPlayers.findIndex((entry) => entry?.puuid && entry.puuid === player.puuid)
          : -1;

        if (byPuuid >= 0) {
          matchRank = byPuuid + 1;
        } else {
          const playerName = (player?.name || '').toLowerCase();
          const playerTag = (player?.tag || '').toLowerCase();
          const byNameTag = rankedPlayers.findIndex((entry) => {
            const sameName = (entry?.name || '').toLowerCase() === playerName;
            if (!sameName) return false;
            if (!playerTag) return true;
            return (entry?.tag || '').toLowerCase() === playerTag;
          });
          if (byNameTag >= 0) {
            matchRank = byNameTag + 1;
          }
        }
      }

      // FK/FD
      const killEvents = match.kills || [];
      const killsByRound = {};
      const playerKillsPerRound = {};
      killEvents.forEach(kill => {
        const round = kill.round ?? 0;
        if (!killsByRound[round]) killsByRound[round] = [];
        killsByRound[round].push(kill);
        if (kill.killer?.name?.toLowerCase() === pName) {
          playerKillsPerRound[round] = (playerKillsPerRound[round] || 0) + 1;
        }
      });
      let fk = 0, fd = 0;
      Object.values(killsByRound).forEach(roundKills => {
        roundKills.sort((a, b) => (a.time_in_round_in_ms || 0) - (b.time_in_round_in_ms || 0));
        const first = roundKills[0];
        if (first) {
          if (first.killer?.name?.toLowerCase() === pName) fk++;
          if (first.victim?.name?.toLowerCase() === pName) fd++;
        }
      });

      // Multi-kills
      let m2 = 0, m3 = 0, m4 = 0, mA = 0;
      Object.values(playerKillsPerRound).forEach(c => {
        if (c === 2) m2++;
        else if (c === 3) m3++;
        else if (c === 4) m4++;
        else if (c >= 5) mA++;
      });

      // Plants / Defuses
      let pl = 0, df = 0;
      (match.rounds || []).forEach(r => {
        if (r.plant?.player?.name?.toLowerCase() === pName) pl++;
        if (r.defuse?.player?.name?.toLowerCase() === pName) df++;
      });

      // Economy
      const eco = player.economy || fullPlayer?.economy || {};
      const spentTotal = eco.spent?.overall || 0;
      const loadoutTotal = eco.loadout_value?.overall || eco.loadout?.overall || 0;

      // Abilities
      const ab = player.ability_casts || fullPlayer?.ability_casts || {};
      const abC = ab.grenade || ab.c_cast || 0;
      const abQ = ab.ability1 || ab.q_cast || 0;
      const abE = ab.ability2 || ab.e_cast || 0;
      const abX = ab.ultimate || ab.x_cast || 0;

      const mapKey = this.resolveMatchMapKey(match);
      if (!agentBucket.byMap[mapKey]) {
        agentBucket.byMap[mapKey] = initBucket();
      }
      const mapBucket = agentBucket.byMap[mapKey];
      const startedAtCandidate = match.metadata?.started_at
        ? new Date(match.metadata.started_at).getTime()
        : (match.game_start
          ? Number(match.game_start) * 1000
          : (match.game_start_patched ? new Date(match.game_start_patched).getTime() : NaN));

      // Fill buckets
      const hasKillData = Array.isArray(match.kills) && match.kills.length > 0;
      [overall, agentBucket, mapBucket].forEach(b => {
        b.matches++;
        if (won) b.wins++;
        b.kills += k; b.deaths += d; b.assists += a; b.score += sc;
        b.headshots += hs; b.bodyshots += bs; b.legshots += ls;
        b.damageDealt += dd; b.damageReceived += dr;
        b.totalKastRounds += kastRounds;
        if (matchKastPercent !== null) {
          b.kastPercentSum += matchKastPercent;
          b.kastMatchCount += 1;
        }
        if (Number.isFinite(matchRank)) {
          b.matchRankSum += matchRank;
          b.matchRankCount += 1;
        }
        if (hasKillData) {
          b.matchesWithKillData += 1;
        }
        b.firstKills += fk; b.firstDeaths += fd;
        b.plants += pl; b.defuses += df;
        b.mk2 += m2; b.mk3 += m3; b.mk4 += m4; b.mkAce += mA;
        b.totalRounds += totalRounds;
        b.econSpent += spentTotal; b.econLoadout += loadoutTotal;
        b.abC += abC; b.abQ += abQ; b.abE += abE; b.abX += abX;
        b.mapCount[mapKey] = (b.mapCount[mapKey] || 0) + 1;
        if (Number.isFinite(startedAtCandidate) && (!b.latestMatchAt || startedAtCandidate > b.latestMatchAt)) {
          b.latestMatchAt = startedAtCandidate;
        }
      });
    });

    const finalize = (b) => {
      if (b.matches === 0) return b;
      const m = b.matches;
      const r = b.totalRounds || 1;
      const ts = b.headshots + b.bodyshots + b.legshots;
      b.winRate = Math.round((b.wins / m) * 100);
      b.lossRate = 100 - b.winRate;
      b.avgKills = (b.kills / m).toFixed(1);
      b.avgDeaths = (b.deaths / m).toFixed(1);
      b.avgAssists = (b.assists / m).toFixed(1);
      b.kd = b.deaths > 0 ? (b.kills / b.deaths).toFixed(2) : b.kills.toFixed(2);
      b.kda = b.deaths > 0 ? ((b.kills + b.assists) / b.deaths).toFixed(2) : (b.kills + b.assists).toFixed(2);
      b.avgACS = Math.round(b.score / r);
      b.avgADR = Math.round(b.damageDealt / r);
      b.hsPercent = ts > 0 ? Math.round((b.headshots / ts) * 100) : 0;
      b.bodyPercent = ts > 0 ? Math.round((b.bodyshots / ts) * 100) : 0;
      b.legPercent = ts > 0 ? Math.round((b.legshots / ts) * 100) : 0;
      b.avgDmgDealt = Math.round(b.damageDealt / m);
      b.avgDmgRecv = Math.round(b.damageReceived / m);
      b.dmgDelta = b.damageDealt - b.damageReceived;
      b.ddaPerRound = Math.round(b.dmgDelta / r);
      b.avgDmgDelta = Math.round(b.dmgDelta / m);
      b.kastPercent = b.kastMatchCount > 0 ? Math.round(b.kastPercentSum / b.kastMatchCount) : 0;
      b.avgMatchRank = b.matchRankCount > 0 ? (b.matchRankSum / b.matchRankCount) : null;
      b.avgMatchRankLabel = b.avgMatchRank !== null ? b.avgMatchRank.toFixed(1) : '--';
      const mKill = b.matchesWithKillData || m;
      b.fkPerMatch = (b.firstKills / mKill).toFixed(1);
      b.fdPerMatch = (b.firstDeaths / mKill).toFixed(1);
      b.fkFdDiff = b.firstKills - b.firstDeaths;
      b.plantsPerMatch = (b.plants / m).toFixed(1);
      b.defusesPerMatch = (b.defuses / m).toFixed(1);
      b.avgRounds = (r / m).toFixed(1);
      b.econSpentAvg = Math.round(b.econSpent / m);
      b.econLoadoutAvg = Math.round(b.econLoadout / m);
      b.totalMultiKills = b.mk2 + b.mk3 + b.mk4 + b.mkAce;
      b.multiKillsPerMatch = (b.totalMultiKills / m).toFixed(1);
      const favoriteMapEntry = Object.entries(b.mapCount || {}).sort((left, right) => right[1] - left[1])[0] || null;
      b.favoriteMapKey = favoriteMapEntry ? favoriteMapEntry[0] : null;
      b.favoriteMapCount = favoriteMapEntry ? favoriteMapEntry[1] : 0;
      b.favoriteMapRate = favoriteMapEntry ? Math.round((b.favoriteMapCount / m) * 100) : 0;
      return b;
    };

    finalize(overall);
    Object.values(byAgent).forEach((agentBucket) => {
      finalize(agentBucket);
      Object.values(agentBucket.byMap || {}).forEach(finalize);
    });

    return { overall, byAgent };
  }

  // ==========================================================
  // RENDER INDIVIDUAL ANALYSIS - premium layout
  // ==========================================================
  renderIndividualAnalysis(data, options = {}) {
    if (!data.overall || data.overall.matches === 0) {
      return '<div class="premium-empty-state"><i class="fas fa-chart-pie"></i><p>Sem dados para o ato atual</p></div>';
    }

    const o = data.overall;
    const currentRank = options?.currentRank || null;
    const actLabel = options?.actLabel || 'Ato atual';

    const killsTotal = Number(o.kills || 0);
    const deathsTotal = Number(o.deaths || 0);
    const assistsTotal = Number(o.assists || 0);
    const plusMinusTotal = killsTotal - deathsTotal;
    const kdValue = deathsTotal > 0 ? (killsTotal / deathsTotal).toFixed(2) : killsTotal.toFixed(2);
    const kdaRaw = deathsTotal > 0
      ? ((killsTotal + assistsTotal) / deathsTotal)
      : (killsTotal + assistsTotal);
    const kdaValue = this.formatDecimalWithoutTrailingZeros(kdaRaw, 2);

    const matchRankValue = o.avgMatchRankLabel === '--' ? '--' : `#${o.avgMatchRankLabel}`;
    const matchRankHtml = currentRank?.rankIcon
      ? `<span class="ia-act-rank-wrap"><img src="${currentRank.rankIcon}" alt="${currentRank.fullRankLabel || currentRank.rankLabel || 'Rank'}" class="ia-act-rank-icon" onerror="this.style.display='none'">${matchRankValue}</span>`
      : matchRankValue;

    const matchRankBadge = matchRankValue !== '--'
      ? `<span class="ia-match-rank-chip">${matchRankHtml}</span>`
      : '';

    const clamp = (value, min = 0, max = 100) => Math.min(Math.max(Number(value) || 0, min), max);
    const kdaNumeric = Number(kdaRaw) || 0;

    const mainStats = [
      { label: 'Win%', value: `${o.winRate || 0}%`, chartValue: clamp(o.winRate), color: '#10b981' },
      { label: 'KDA', value: kdaValue, chartValue: clamp((kdaNumeric / 3) * 100), color: '#22c55e' },
      { label: 'HS%', value: `${o.hsPercent || 0}%`, chartValue: clamp(o.hsPercent), color: '#f59e0b' },
      { label: 'KAST', value: `${o.kastPercent || 0}%`, chartValue: clamp(o.kastPercent), color: '#38bdf8' }
    ];

    const kdLineStats = [
      {
        label: 'K/D',
        value: kdValue,
        valueClass: parseFloat(kdValue) >= 1 ? 'is-pos' : 'is-neg'
      },
      {
        label: '+/-',
        value: `${plusMinusTotal >= 0 ? '+' : ''}${plusMinusTotal}`,
        valueClass: plusMinusTotal >= 0 ? 'is-pos' : 'is-neg'
      }
    ];

    const combatStats = [
      { label: 'ACS', value: Number(o.avgACS || 0), barValue: clamp((Number(o.avgACS || 0) / 400) * 100), color: '#ff4655' },
      { label: 'ADR', value: Number(o.avgADR || 0), barValue: clamp((Number(o.avgADR || 0) / 250) * 100), color: '#f59e0b' }
    ];

    const roleStats = [
      { label: 'FK', value: Number(o.firstKills || 0) },
      { label: 'FD', value: Number(o.firstDeaths || 0) },
      { label: 'Plants', value: Number(o.plants || 0) },
      { label: 'Defuses', value: Number(o.defuses || 0) }
    ];

    const mainMetricPills = [
      ...mainStats,
      ...kdLineStats
    ].map((stat) => `
      <span class="ia-overview-metric-pill ${stat.valueClass || ''}">
        <strong>${stat.label}</strong>${stat.value}
      </span>
    `).join('');

    const combatMetricPills = combatStats.map((stat) => `
      <span class="ia-overview-metric-pill ${stat.valueClass || ''}">
        <strong>${stat.label}</strong>${stat.value}
      </span>
    `).join('');

    const roleMetricPills = roleStats.map((stat) => `
      <span class="ia-overview-metric-pill">
        <strong>${stat.label}</strong>${stat.value}
      </span>
    `).join('');

    const mainDonutsHtml = mainStats.map((stat) => `
      <div class="ia-overview-donut">
        <div class="ia-overview-donut-ring" style="--ia-donut-fill:${stat.chartValue.toFixed(2)}%;--ia-donut-color:${stat.color}">
          <div class="ia-overview-donut-inner">
            <strong>${stat.value}</strong>
          </div>
        </div>
        <span class="ia-overview-donut-label">${stat.label}</span>
      </div>
    `).join('');

    const combatBarsHtml = combatStats.map((stat) => `
      <div class="ia-overview-bar-row">
        <span class="ia-overview-bar-label">${stat.label}</span>
        <div class="ia-overview-bar-track">
          <div class="ia-overview-bar-fill" style="width:${stat.barValue.toFixed(2)}%;--ia-bar-color:${stat.color}"></div>
        </div>
        <span class="ia-overview-bar-value ${stat.valueClass || ''}">${stat.value}</span>
      </div>
    `).join('');

    const radarCenter = 80;
    const radarRadius = 52;
    const roleMax = Math.max(...roleStats.map((stat) => stat.value), 1);
    const radarPoint = (index, ratio = 1) => {
      const angle = (-Math.PI / 2) + (index * (Math.PI / 2));
      return {
        x: radarCenter + (Math.cos(angle) * radarRadius * ratio),
        y: radarCenter + (Math.sin(angle) * radarRadius * ratio)
      };
    };

    const radarGridLevels = [0.25, 0.5, 0.75, 1];
    const radarGridHtml = radarGridLevels.map((level) => {
      const points = roleStats.map((_, idx) => {
        const p = radarPoint(idx, level);
        return `${p.x.toFixed(1)},${p.y.toFixed(1)}`;
      }).join(' ');
      return `<polygon class="ia-radar-grid" points="${points}"></polygon>`;
    }).join('');

    const radarAxesHtml = roleStats.map((_, idx) => {
      const p = radarPoint(idx, 1);
      return `<line class="ia-radar-axis" x1="${radarCenter}" y1="${radarCenter}" x2="${p.x.toFixed(1)}" y2="${p.y.toFixed(1)}"></line>`;
    }).join('');

    const radarDataPoints = roleStats.map((stat, idx) => {
      const p = radarPoint(idx, stat.value / roleMax);
      return `${p.x.toFixed(1)},${p.y.toFixed(1)}`;
    }).join(' ');

    const radarDotsHtml = roleStats.map((stat, idx) => {
      const p = radarPoint(idx, stat.value / roleMax);
      return `<circle class="ia-radar-dot" cx="${p.x.toFixed(1)}" cy="${p.y.toFixed(1)}" r="2.7"></circle>`;
    }).join('');

    const radarLabelsHtml = roleStats.map((stat, idx) => {
      const p = radarPoint(idx, 1.24);
      const anchor = idx === 1 ? 'start' : (idx === 3 ? 'end' : 'middle');
      const dy = idx === 0 ? -2 : (idx === 2 ? 10 : 4);
      return `<text class="ia-radar-label" x="${p.x.toFixed(1)}" y="${(p.y + dy).toFixed(1)}" text-anchor="${anchor}">${stat.label}</text>`;
    }).join('');

    const roleRadarHtml = `
      <div class="ia-overview-radar">
        <svg class="ia-overview-radar-svg" viewBox="0 0 160 160" aria-label="Radar com FK, FD, Plants e Defuses" role="img">
          ${radarGridHtml}
          ${radarAxesHtml}
          <polygon class="ia-radar-data" points="${radarDataPoints}"></polygon>
          ${radarDotsHtml}
          ${radarLabelsHtml}
        </svg>
      </div>
    `;

    // === OVERALL SECTION ===
    const overallHtml = `
      <div class="ia-section ia-overview">
        <div class="ia-section-header">
          <i class="fas fa-chart-line"></i>
          <h3>Visão Geral</h3>
          ${matchRankBadge}
          <span class="ia-match-count">${o.matches} partidas</span>
        </div>

        <div class="ia-overview-layout">
          <div class="ia-overview-row">
            <div class="ia-overview-title">Main Stats</div>
            <div class="ia-overview-metrics">${mainMetricPills}</div>
            <div class="ia-overview-visual ia-overview-donuts">${mainDonutsHtml}</div>
          </div>

          <div class="ia-overview-row">
            <div class="ia-overview-title">Combat Stats</div>
            <div class="ia-overview-metrics">${combatMetricPills}</div>
            <div class="ia-overview-visual ia-overview-bars">${combatBarsHtml}</div>
          </div>

          <div class="ia-overview-row">
            <div class="ia-overview-title">Role Stats</div>
            <div class="ia-overview-metrics">${roleMetricPills}</div>
            <div class="ia-overview-visual">${roleRadarHtml}</div>
          </div>
        </div>
      </div>
    `;

    // === PER AGENT SECTION ===
    const agentEntries = Object.entries(data.byAgent)
      .sort((a, b) => b[1].matches - a[1].matches);

    const topAgentEntries = agentEntries;

    const topAgentItems = topAgentEntries.map(([agentKey, agData], idx) => {
      const agentInfo = this.agentsData?.[agentKey];
      const icon = agentInfo?.displayIcon || `/img/agents/${agentKey}.png`;
      const name = agentInfo?.displayName || this.capitalizeFirst(agentKey);
      const pickRate = Math.round((agData.matches / o.matches) * 100);
      const favoriteMapKey = agData.favoriteMapKey || '';
      const favoriteMapData = favoriteMapKey
        ? (this.mapsData?.[favoriteMapKey] || this.mapsMultipliers?.[favoriteMapKey] || null)
        : null;
      const favoriteMapLabel = favoriteMapData?.displayName
        || favoriteMapData?.name
        || (favoriteMapKey ? this.capitalizeFirst(favoriteMapKey) : actLabel);
      const mapBadgeLabel = `${favoriteMapLabel}${agData.favoriteMapRate ? ` · ${agData.favoriteMapRate}%` : ''}`;
      const tabMetaLabel = `${agData.matches} partidas · ${pickRate}% pick`;
      return {
        idx,
        agentKey,
        agData,
        icon,
        name,
        pickRate,
        mapBadgeLabel,
        tabMetaLabel
      };
    });

    const agentCardsHtml = topAgentItems
      .map((item) => this.renderAgentAnalysisDetail(item.agentKey, item.agData, o, { actLabel }))
      .join('');

    const perAgentHtml = topAgentItems.length > 0 ? `
      <div class="ia-section ia-agents-breakdown">
        <div class="ia-section-header">
          <i class="fas fa-users"></i>
          <h3>Análise por Agente</h3>
          <span class="ia-match-count">${actLabel} · ${o.matches} partidas</span>
        </div>
        <div class="ia-agent-main-shell">
          ${agentCardsHtml}
        </div>
      </div>
    ` : '';

    return `
      <div class="ia-container">
        ${perAgentHtml}
      </div>
    `;
  }

  renderGeneralStatsSection(data, options = {}) {
    if (!data?.overall || data.overall.matches === 0) {
      return '';
    }

    const o = data.overall;
    const currentRank = options?.currentRank || null;
    const actLabel = options?.actLabel || 'Ato atual';
    const killsTotal = Number(o.kills || 0);
    const deathsTotal = Number(o.deaths || 0);
    const assistsTotal = Number(o.assists || 0);
    const plusMinusTotal = killsTotal - deathsTotal;
    const kdValue = deathsTotal > 0 ? (killsTotal / deathsTotal).toFixed(2) : killsTotal.toFixed(2);
    const kdaRaw = deathsTotal > 0
      ? ((killsTotal + assistsTotal) / deathsTotal)
      : (killsTotal + assistsTotal);
    const kdaValue = this.formatDecimalWithoutTrailingZeros(kdaRaw, 2);
    const kdaNumeric = Number(kdaRaw) || 0;
    const eloIcon = currentRank?.rankIcon || '';
    const eloLabel = currentRank?.fullRankLabel || '--';
    const rrLabel = currentRank?.rrLabel || '--';

    const gsKd = kdValue;
    const gsKdClass = parseFloat(gsKd) >= 1.5 ? 'stat-high' : parseFloat(gsKd) >= 1.0 ? 'stat-med' : 'stat-low';
    const gsPlusMinus = plusMinusTotal;
    const gsPlusMinusStr = `${gsPlusMinus >= 0 ? '+' : ''}${gsPlusMinus}`;
    const gsPmClass = gsPlusMinus >= 0 ? 'stat-high' : 'stat-low';
    const gsAcs = Number(o.avgACS || 0);
    const gsAcsClass = gsAcs >= 250 ? 'stat-high' : gsAcs >= 200 ? 'stat-med' : 'stat-low';
    const gsKda = kdaValue;
    const gsKdaClass = kdaNumeric >= 2 ? 'stat-high' : kdaNumeric >= 1.3 ? 'stat-med' : 'stat-low';
    const gsAdr = Number(o.avgADR || 0);
    const gsAdrClass = gsAdr >= 160 ? 'stat-high' : gsAdr >= 130 ? 'stat-med' : 'stat-low';
    const gsHs = Number(o.hsPercent || 0);
    const gsHsClass = gsHs >= 30 ? 'stat-high' : gsHs >= 20 ? 'stat-med' : '';
    const gsKast = Number(o.kastPercent || 0);
    const gsKastClass = gsKast >= 75 ? 'stat-high' : gsKast >= 65 ? 'stat-med' : '';
    const gsFk = Number(o.firstKills || 0);
    const gsFd = Number(o.firstDeaths || 0);
    const gsFkFd = gsFk - gsFd;
    const gsFkFdStr = `${gsFkFd >= 0 ? '+' : ''}${gsFkFd}`;
    const gsFkFdClass = gsFkFd > 0 ? 'stat-high' : gsFkFd < 0 ? 'stat-low' : '';
    const gsWr = Number(o.winRate || 0);
    const gsWrClass = gsWr >= 55 ? 'stat-high' : gsWr >= 50 ? 'stat-med' : 'stat-low';
    const gsWins = Number(o.wins || 0);
    const gsLosses = Math.max(Number(o.matches || 0) - gsWins, 0);

    const top3Agents = Object.entries(data.byAgent || {})
      .sort((a, b) => b[1].matches - a[1].matches)
      .slice(0, 3)
      .map(([agentKey, agData]) => {
        const agInfo = this.agentsData?.[agentKey];
        const agIcon = agInfo?.displayIcon || `/img/agents/${agentKey}.png`;
        const agName = agInfo?.displayName || this.capitalizeFirst(agentKey);
        const favMapKey = agData.favoriteMapKey || '';
        const favMapBg = this.resolveMapBackgroundImage(favMapKey);
        const favMapInfo = this.mapsData?.[favMapKey] || this.mapsMultipliers?.[favMapKey] || null;
        const favMapName = favMapInfo?.displayName || favMapInfo?.name || (favMapKey ? this.capitalizeFirst(favMapKey) : '');
        const agWr = Number(agData.winRate || 0);
        const agWrClass = agWr >= 55 ? 'stat-high' : agWr >= 50 ? 'stat-med' : 'stat-low';
        return { agentKey, agData, agIcon, agName, favMapBg, favMapName, agWr, agWrClass };
      });

    const top3Html = top3Agents.length > 0 ? `
      <div class="ia-gs-top3">
        <div class="ia-gs-top3-label">
          <i class="fas fa-gamepad"></i>
          <span>Agentes<br>Mais Jogados</span>
        </div>
        ${top3Agents.map((ag, i) => `
          <div class="ia-gs-top3-card">
            <div class="ia-gs-top3-bg" ${ag.favMapBg ? `style="background-image:url('${ag.favMapBg}')"` : ''}></div>
            <div class="ia-gs-top3-shade"></div>
            <div class="ia-gs-top3-content">
              <span class="ia-gs-top3-rank">#${i + 1}</span>
              <div class="ia-gs-top3-icon-wrap" style="${this.getAgentGradientStyle(ag.agentKey)}">
                <img src="${ag.agIcon}" alt="${ag.agName}" class="ia-gs-top3-icon" onerror="this.style.display='none'">
              </div>
              <div class="ia-gs-top3-info">
                <span class="ia-gs-top3-name">${ag.agName}</span>
                <span class="ia-gs-top3-meta">${ag.agData.matches}p · <em class="${ag.agWrClass}">${ag.agWr}%</em></span>
              </div>
              ${ag.favMapName ? `<span class="ia-gs-top3-map">${ag.favMapName}</span>` : ''}
            </div>
          </div>
        `).join('')}
      </div>
    ` : '';

    return `
      <div class="ia-section ia-general-stats">
        <div class="ia-section-header">
          <i class="fas fa-crosshairs"></i>
          <h3>Estatísticas Gerais</h3>
          <span class="ia-match-count">${actLabel} · ${o.matches} partidas</span>
        </div>
        <div class="ia-gs-card">
          <div class="ia-gs-card-inner">
            <div class="ia-gs-elo">
              ${eloIcon ? `<img src="${eloIcon}" alt="${eloLabel}" class="ia-gs-elo-icon" onerror="this.style.display='none'">` : ''}
              <div class="ia-gs-elo-info">
                <span class="ia-gs-elo-label">${eloLabel}</span>
                <span class="ia-gs-elo-rr">${rrLabel}</span>
              </div>
              <div class="ia-gs-elo-wr">
                <span class="ia-gs-elo-wr-value ${gsWrClass}">${gsWr}%</span>
                <span class="ia-gs-elo-wr-sub">WR · ${gsWins}V ${gsLosses}D</span>
              </div>
              <div class="ia-gs-elo-separator"></div>
              ${top3Html}
            </div>
            <div class="ia-gs-divider"></div>
            <div class="ia-gs-metrics">
              <div class="ia-gs-metric">
                <span class="ia-gs-metric-value ${gsKdClass}">${gsKd}</span>
                <span class="ia-gs-metric-label">K/D</span>
                <span class="ia-gs-metric-sub ${gsPmClass}">${gsPlusMinusStr}</span>
              </div>
              <div class="ia-gs-metric">
                <span class="ia-gs-metric-value ${gsAcsClass}">${gsAcs}</span>
                <span class="ia-gs-metric-label">ACS</span>
              </div>
              <div class="ia-gs-metric">
                <span class="ia-gs-metric-value ${gsKdaClass}">${gsKda}</span>
                <span class="ia-gs-metric-label">KDA</span>
                <span class="ia-gs-metric-sub">${killsTotal}/${deathsTotal}/${assistsTotal}</span>
              </div>
              <div class="ia-gs-metric">
                <span class="ia-gs-metric-value ${gsAdrClass}">${gsAdr}</span>
                <span class="ia-gs-metric-label">ADR</span>
              </div>
              <div class="ia-gs-metric">
                <span class="ia-gs-metric-value ${gsHsClass}">${gsHs}%</span>
                <span class="ia-gs-metric-label">HS%</span>
              </div>
              <div class="ia-gs-metric">
                <span class="ia-gs-metric-value ${gsKastClass}">${gsKast}%</span>
                <span class="ia-gs-metric-label">KAST</span>
              </div>
              <div class="ia-gs-metric ia-gs-metric-fk">
                <span class="ia-gs-metric-value">${gsFk}</span>
                <span class="ia-gs-metric-label">FK</span>
              </div>
              <div class="ia-gs-metric ia-gs-metric-fd">
                <span class="ia-gs-metric-value">${gsFd}</span>
                <span class="ia-gs-metric-label">FD</span>
              </div>
              <div class="ia-gs-metric">
                <span class="ia-gs-metric-value ${gsFkFdClass}">${gsFkFdStr}</span>
                <span class="ia-gs-metric-label">FK-FD</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // Render detail stats for a single agent
  renderAgentAnalysisDetail(agentKey, ag, overall, options = {}) {
    const showDropdown = options?.showDropdown !== false;
    const cardInteractive = options?.cardInteractive !== false;
    const forcedMapKey = options?.forceMapKey || '';

    const agentInfo = this.agentsData?.[agentKey];
    const icon = agentInfo?.displayIcon || `/img/agents/${agentKey}.png`;
    const name = agentInfo?.displayName || this.capitalizeFirst(agentKey);
    const pickRate = overall.matches > 0 ? Math.round((ag.matches / overall.matches) * 100) : 0;

    const wins = Number(ag.wins || 0);
    const losses = Math.max(Number(ag.matches || 0) - wins, 0);
    const wlRecordLabel = `${wins}/${losses}`;
    const resultClass = wins > losses ? 'victory' : wins < losses ? 'defeat' : 'draw';

    const plusMinus = Number(ag.kills || 0) - Number(ag.deaths || 0);
    const plusMinusStr = `${plusMinus >= 0 ? '+' : ''}${plusMinus}`;
    const kdClass = parseFloat(ag.kd) >= 1.5 ? 'stat-high' : parseFloat(ag.kd) >= 1.0 ? 'stat-med' : 'stat-low';
    const wrClass = Number(ag.winRate || 0) >= 55 ? 'stat-high' : Number(ag.winRate || 0) >= 50 ? 'stat-med' : 'stat-low';
    const acsClass = Number(ag.avgACS || 0) >= 250 ? 'stat-high' : Number(ag.avgACS || 0) >= 200 ? 'stat-med' : 'stat-low';
    const hsClass = Number(ag.hsPercent || 0) >= 30 ? 'stat-high' : Number(ag.hsPercent || 0) >= 20 ? 'stat-med' : '';
    const kastClass = Number(ag.kastPercent || 0) >= 75 ? 'stat-high' : Number(ag.kastPercent || 0) >= 65 ? 'stat-med' : '';

    const isMainAggregateCard = !forcedMapKey && showDropdown && cardInteractive;
    const cardBackground = isMainAggregateCard
      ? ''
      : this.resolveMapBackgroundImage(forcedMapKey || ag.favoriteMapKey || '');

    const latestTimestamp = Number(ag.latestMatchAt || 0);
    const latestDate = latestTimestamp
      ? new Date(latestTimestamp).toLocaleDateString('pt-BR')
      : '';
    const latestTime = latestTimestamp
      ? new Date(latestTimestamp).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
      : '';

    const totalKills = Number(ag.kills || 0);
    const totalDeaths = Number(ag.deaths || 0);
    const totalAssists = Number(ag.assists || 0);
    const totalKillsLabel = this.formatDecimalWithoutTrailingZeros(totalKills, 0);
    const totalDeathsLabel = this.formatDecimalWithoutTrailingZeros(totalDeaths, 0);
    const totalAssistsLabel = this.formatDecimalWithoutTrailingZeros(totalAssists, 0);
    const kdaLabel = this.formatDecimalWithoutTrailingZeros(ag.kda, 2);
    const kdaNumeric = Number.parseFloat(ag.kda || 0);
    const kdaClass = kdaNumeric >= 2 ? 'stat-high' : kdaNumeric >= 1.3 ? 'stat-med' : 'stat-low';
    const fkValue = Number(ag.firstKills || 0);
    const fdValue = Number(ag.firstDeaths || 0);
    const fkFdDelta = fkValue - fdValue;
    const fkFdDeltaStr = `${fkFdDelta >= 0 ? '+' : ''}${fkFdDelta}`;
    const fkFdDeltaClass = fkFdDelta > 0 ? 'stat-high' : (fkFdDelta < 0 ? 'stat-low' : '');
    const bodyPercent = Math.max(0, Math.round(Number(ag.bodyPercent || 0)));
    const legPercent = Math.max(0, Math.round(Number(ag.legPercent || 0)));

    const kdaMetricHtml = `
      <div class="rmc-kd-big ia-agent-metric-big">
        <span class="rmc-kd-value ${kdaClass}">${kdaLabel}</span>
        <span class="rmc-kd-label">KDA</span>
      </div>
    `;

    const kdaBreakdownUnderMetricHtml = `
      <span class="rmc-stat ia-agent-kda-breakdown">
        <strong>K/D/A</strong>
        <em>${totalKillsLabel}/${totalDeathsLabel}/${totalAssistsLabel}</em>
      </span>
    `;

    const fkFdMetricHtml = `
      <div class="rmc-kd-big ia-agent-metric-big">
        <span class="rmc-kd-value ${fkFdDeltaClass || ''}">${fkFdDeltaStr}</span>
        <span class="rmc-kd-label">FK-FD</span>
      </div>
    `;

    const fkFdBreakdownUnderMetricHtml = `
      <div class="ia-agent-fkfd-breakdown" aria-label="First kills e first deaths">
        <span class="ia-agent-fkfd-item fk"><strong>FK</strong> <em>${fkValue}</em></span>
        <span class="ia-agent-fkfd-item fd"><strong>FD</strong> <em>${fdValue}</em></span>
      </div>
    `;

    const hsBreakdownUnderMetricHtml = `
      <div class="ia-agent-hs-breakdown" aria-label="Distribuicao de hits">
        <span class="ia-agent-hs-item"><strong>CORPO</strong> <em>${bodyPercent}%</em></span>
        <span class="ia-agent-hs-item"><strong>PERNA</strong> <em>${legPercent}%</em></span>
      </div>
    `;

    const wrUnderAgentHtml = `
      <div class="ia-agent-wr-inline">
        <span class="rmc-kd-value ${wrClass}">${ag.winRate}%</span>
        <div class="ia-agent-wr-meta">
          <span class="rmc-kd-label">WR</span>
          <span class="ia-agent-wl-count">${wlRecordLabel}</span>
        </div>
      </div>
    `;

    const sideBigMetrics = [
      { label: 'ACS', value: `${ag.avgACS}`, valueClass: acsClass },
      { label: 'KAST', value: `${ag.kastPercent}%`, valueClass: kastClass },
      {
        label: 'HS%',
        value: `${ag.hsPercent}%`,
        valueClass: hsClass,
        stackClass: 'ia-agent-hs-stack',
        lowerHtml: hsBreakdownUnderMetricHtml
      }
    ];

    const sideBigMetricsHtml = sideBigMetrics.map((metric) => {
      const metricCardHtml = `
      <div class="rmc-kd-big ia-agent-metric-big">
        <span class="rmc-kd-value ${metric.valueClass || ''}">${metric.value}</span>
        <span class="rmc-kd-label">${metric.label}</span>
      </div>
      `;

      if (!metric.lowerHtml) {
        return metricCardHtml;
      }

      return `
      <div class="${metric.stackClass}">
        ${metricCardHtml}
        ${metric.lowerHtml}
      </div>
      `;
    }).join('');

    const plusMinusUnderKdHtml = `
      <span class="rmc-stat entry-pm ia-agent-kd-plusminus">
        <strong>+/-</strong>
        <em class="${plusMinus >= 0 ? 'stat-high' : 'stat-low'}">${plusMinusStr}</em>
      </span>
    `;

    const statRowHtml = '';

    const dropdownId = `iaAgentCardDropdown-${encodeURIComponent(agentKey)}`;
    const mapDropdownCardsHtml = showDropdown
      ? this.renderAgentMapDropdownCards(agentKey, ag, overall, options)
      : '';
    const cardInteractionHtml = (showDropdown && cardInteractive)
      ? `role="button" tabindex="0" onclick="rankedStats.toggleAgentCardDropdown('${dropdownId}')" onkeydown="if(event.key==='Enter'||event.key===' '){event.preventDefault(); rankedStats.toggleAgentCardDropdown('${dropdownId}');}"`
      : '';
    const cardClass = `rmm-card ${resultClass} ia-agent-rmc-card${showDropdown && cardInteractive ? ' ia-agent-rmc-card--toggle' : ' ia-agent-rmc-card--sub'}`;

    return `
      <div class="${cardClass}${isMainAggregateCard ? ' ia-agent-main-aggregate' : ''}" ${cardInteractionHtml}>
        <div class="rmm-map-bg ${cardBackground ? '' : 'is-fallback'}" ${cardBackground ? `style="background-image:url('${cardBackground}')"` : ''}></div>
        <div class="rmm-map-shade"></div>
        <div class="rmm-overlay ${resultClass}"></div>
        <div class="rmm-strip ${resultClass}"></div>
        <div class="rmm-content rmc-layout ia-agent-rmc-layout">
          <div class="rmc-agent">
            <div class="rmc-agent-icon-wrap" style="${this.getAgentGradientStyle(agentKey)}">
              <img src="${icon}" alt="${name}" class="rmc-agent-icon" onerror="this.style.display='none'">
            </div>
            ${wrUnderAgentHtml}
          </div>
          <div class="ia-agent-side-metrics" aria-label="Métricas principais do agente">
            <div class="ia-agent-kd-stack">
              <div class="rmc-kd-big ia-agent-metric-big">
                <span class="rmc-kd-value ${kdClass}">${ag.kd}</span>
                <span class="rmc-kd-label">K/D</span>
              </div>
              ${plusMinusUnderKdHtml}
            </div>
            <div class="ia-agent-kda-stack">
              ${kdaMetricHtml}
              ${kdaBreakdownUnderMetricHtml}
            </div>
            ${sideBigMetricsHtml}
            <div class="ia-agent-fkfd-stack">
              ${fkFdMetricHtml}
              ${fkFdBreakdownUnderMetricHtml}
            </div>
          </div>
          ${statRowHtml}
          ${showDropdown ? `
          <div class="ia-agent-card-dropdown period-dropdown" id="${dropdownId}" onclick="event.stopPropagation()">
            <div class="period-dropdown-menu" id="${dropdownId}-menu">
              ${mapDropdownCardsHtml}
            </div>
          </div>` : ''}
        </div>
      </div>
    `;
  }

  renderAgentMapDropdownCards(agentKey, ag, overall, options = {}) {
    const rawMapEntries = Object.entries(ag.byMap || {});
    const fallbackMapKey = ag.favoriteMapKey || 'unknown';
    const mapEntries = (rawMapEntries.length > 0 ? rawMapEntries : [[fallbackMapKey, ag]])
      .sort((left, right) => Number(right[1]?.matches || 0) - Number(left[1]?.matches || 0));

    if (!mapEntries.length) {
      return `
        <div class="premium-empty-state ia-agent-map-empty">
          <i class="fas fa-map"></i>
          <p>Sem dados por mapa para este agente.</p>
        </div>
      `;
    }

    const headerHtml = `
      <div class="ia-map-list-header">
        <span class="ia-ml-col ia-ml-col-map">Mapa</span>
        <span class="ia-ml-col">WR</span>
        <span class="ia-ml-col">K/D</span>
        <span class="ia-ml-col">KDA</span>
        <span class="ia-ml-col">ACS</span>
        <span class="ia-ml-col">ADR</span>
        <span class="ia-ml-col">HS%</span>
        <span class="ia-ml-col">KAST</span>
        <span class="ia-ml-col">FK-FD</span>
      </div>
    `;

    const rowsHtml = mapEntries.map(([mapKey, mapStats]) => {
      const mapInfo = this.mapsData?.[mapKey] || this.mapsMultipliers?.[mapKey] || null;
      const mapName = mapInfo?.displayName || mapInfo?.name || this.capitalizeFirst(mapKey);
      const mapBg = this.resolveMapBackgroundImage(mapKey);
      const mapRate = Number(ag.matches || 0) > 0
        ? Math.round((Number(mapStats.matches || 0) / Number(ag.matches || 0)) * 100)
        : 0;
      const m = Number(mapStats.matches || 0);
      const mapWins = Number(mapStats.wins || 0);
      const mapLosses = Math.max(m - mapWins, 0);
      const mapWr = m > 0 ? Math.round((mapWins / m) * 100) : 0;
      const wrClass = mapWr >= 55 ? 'stat-high' : mapWr >= 50 ? 'stat-med' : 'stat-low';

      const kd = Number(mapStats.kd || 0);
      const kdClass = kd >= 1.2 ? 'stat-high' : kd >= 1.0 ? 'stat-med' : 'stat-low';
      const kda = Number(mapStats.kda || 0);
      const kdaClass = kda >= 1.5 ? 'stat-high' : kda >= 1.0 ? 'stat-med' : 'stat-low';
      const acs = Number(mapStats.avgACS || 0);
      const acsClass = acs >= 230 ? 'stat-high' : acs >= 180 ? 'stat-med' : 'stat-low';
      const adr = Number(mapStats.avgADR || 0);
      const adrClass = adr >= 160 ? 'stat-high' : adr >= 130 ? 'stat-med' : 'stat-low';
      const hs = Number(mapStats.hsPercent || 0);
      const hsClass = hs >= 30 ? 'stat-high' : hs >= 20 ? 'stat-med' : 'stat-low';
      const kast = Number(mapStats.kastPercent || 0);
      const kastClass = kast >= 75 ? 'stat-high' : kast >= 65 ? 'stat-med' : 'stat-low';
      const fkfd = Number(mapStats.fkFdDiff || 0);
      const fkfdClass = fkfd > 0 ? 'stat-high' : fkfd === 0 ? 'stat-med' : 'stat-low';
      const fkfdStr = fkfd > 0 ? `+${fkfd}` : `${fkfd}`;

      return `
        <div class="ia-map-list-row">
          <span class="ia-ml-col ia-ml-col-map">
            <div class="ia-ml-thumb-wrap">
              <img class="ia-ml-thumb" src="${mapBg || ''}" alt="${mapName}" onerror="this.style.display='none'">
              <span class="ia-ml-thumb-name">${mapName}</span>
            </div>
            <span class="ia-ml-map-meta">${m}p · ${mapWins}V ${mapLosses}D · ${mapRate}%</span>
          </span>
          <span class="ia-ml-col ia-ml-val ${wrClass}">${mapWr}%</span>
          <span class="ia-ml-col ia-ml-val ${kdClass}">${kd}</span>
          <span class="ia-ml-col ia-ml-val ${kdaClass}">${kda}</span>
          <span class="ia-ml-col ia-ml-val ${acsClass}">${acs}</span>
          <span class="ia-ml-col ia-ml-val ${adrClass}">${adr}</span>
          <span class="ia-ml-col ia-ml-val ${hsClass}">${hs}%</span>
          <span class="ia-ml-col ia-ml-val ${kastClass}">${kast}%</span>
          <span class="ia-ml-col ia-ml-val ${fkfdClass}">${fkfdStr}</span>
        </div>
      `;
    }).join('');

    return `<div class="ia-map-list">${headerHtml}${rowsHtml}</div>`;
  }

  renderAgentAnalysisRow(item, overall, options = {}) {
    const { actLabel = 'Ato atual', open = false } = options;
    const rowId = `ia-agent-dropdown-${item.agentKey}`;
    const cardHtml = this.renderAgentAnalysisDetail(item.agentKey, item.agData, overall, { actLabel });

    return `
      <div class="ia-agent-row${open ? ' open' : ''}" data-agent-key="${item.agentKey}">
        <button
          type="button"
          class="ia-agent-tab ia-agent-row-trigger"
          data-agent-key="${item.agentKey}"
          aria-expanded="${open ? 'true' : 'false'}"
          aria-controls="${rowId}"
          aria-label="Abrir detalhes de ${item.name}"
          onclick="rankedStats.toggleIndividualAgentRow(this)"
        >
          <span class="ia-agent-tab-rank">${String(item.idx + 1).padStart(2, '0')}</span>
          <div class="ia-agent-tab-icon-wrap" style="${this.getAgentGradientStyle(item.agentKey)}">
            <img src="${item.icon}" alt="${item.name}" class="ia-agent-tab-icon" onerror="this.style.display='none'">
          </div>
          <span class="ia-agent-tab-name">${item.name}</span>
          <span class="ia-agent-tab-map-badge">${item.mapBadgeLabel}</span>
          <span class="ia-agent-tab-meta"><i class="fas fa-chart-line"></i>${item.tabMetaLabel}</span>
          <i class="fas fa-chevron-down ia-agent-tab-caret"></i>
        </button>
        <div class="ia-agent-row-dropdown" id="${rowId}" aria-hidden="${open ? 'false' : 'true'}">
          <div class="ia-agent-row-dropdown-inner">
            ${cardHtml}
          </div>
        </div>
      </div>
    `;
  }

  toggleIndividualAgentDropdown() {
    const dropdown = document.getElementById('iaIndividualAgentDropdown');
    if (!dropdown) return;
    dropdown.classList.toggle('open');
  }

  toggleIndividualAgentRow(triggerEl) {
    const row = triggerEl?.closest('.ia-agent-row');
    if (!row) return;

    const shell = row.closest('.ia-agent-main-shell') || this.container;
    const shouldOpen = !row.classList.contains('open');

    if (shouldOpen) {
      shell.querySelectorAll('.ia-agent-row.open').forEach((openRow) => {
        if (openRow === row) return;
        openRow.classList.remove('open');
        const openTrigger = openRow.querySelector('.ia-agent-row-trigger');
        if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
        const openDropdown = openRow.querySelector('.ia-agent-row-dropdown');
        if (openDropdown) openDropdown.setAttribute('aria-hidden', 'true');
      });

      this.individualSelectedAgentKey = row.dataset.agentKey || null;
    }

    row.classList.toggle('open', shouldOpen);
    triggerEl.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

    const dropdown = row.querySelector('.ia-agent-row-dropdown');
    if (dropdown) dropdown.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');

    if (!shouldOpen && this.individualSelectedAgentKey === row.dataset.agentKey) {
      this.individualSelectedAgentKey = null;
    }
  }

  selectIndividualAgent(agentKey) {
    if (!agentKey) return;
    this.individualSelectedAgentKey = agentKey;

    const dropdown = document.getElementById('iaIndividualAgentDropdown');
    if (dropdown) dropdown.classList.remove('open');

    this.ensureIndividualAnalysisRendered(true);
  }

  switchIndividualAgent(agentKey) {
    this.selectIndividualAgent(agentKey);
  }

  renderStatsOverviewPremium(data) {
    const rank = data.currentRank || {};
    const kdColor = parseFloat(data.kd) >= 1.3 ? '#10b981' : parseFloat(data.kd) >= 1.0 ? '#f59e0b' : '#ef4444';
    const pmValue = Number(data.avgPlusMinus || 0);
    const ddaValue = Number(data.avgDamageDelta || 0);
    const metrics = [
      {
        label: 'Match Rank',
        value: rank.rankLabel || '--',
        iconHtml: rank.rankIcon ? `<img src="${rank.rankIcon}" alt="${rank.fullRankLabel || rank.rankLabel || 'Rank'}" class="pso-rank-icon">` : '<i class="fas fa-shield-alt pso-rank-fallback"></i>',
        title: rank.fullRankLabel || 'Rank atual',
        accentClass: 'is-rank'
      },
      { label: 'TRS', value: data.avgTrs || 0, accentClass: 'is-violet' },
      { label: 'ACS', value: data.avgAcs || 0, accentClass: 'is-blue' },
      { label: 'K', value: data.avgKills || '0.0', accentClass: 'is-green' },
      { label: 'D', value: data.avgDeaths || '0.0', accentClass: 'is-red' },
      { label: 'A', value: data.avgAssists || '0.0', accentClass: 'is-cyan' },
      { label: '+/-', value: `${pmValue >= 0 ? '+' : ''}${pmValue.toFixed(1)}`, accentClass: pmValue >= 0 ? 'is-green' : 'is-red' },
      { label: 'K/D', value: data.kd || '0.00', accentClass: 'is-kd', valueColor: kdColor },
      { label: 'DDA', value: `${ddaValue >= 0 ? '+' : ''}${ddaValue}`, accentClass: ddaValue >= 0 ? 'is-green' : 'is-red' },
      { label: 'ADR', value: data.avgAdr || 0, accentClass: 'is-red' },
      { label: 'HS%', value: `${data.avgHs || 0}%`, accentClass: 'is-gold' },
      { label: 'KAST', value: `${data.avgKast || 0}%`, accentClass: 'is-green' },
      { label: 'FK', value: data.firstKills ?? 0, accentClass: 'is-green' },
      { label: 'FD', value: data.firstDeaths ?? 0, accentClass: 'is-red' },
      { label: 'MK', value: data.multiKills ?? 0, accentClass: 'is-violet' }
    ];

    return `
      <div class="pso-metrics-strip" role="list" aria-label="Resumo competitivo">
        ${metrics.map((metric) => `
          <div class="pso-metric-card ${metric.accentClass || ''}" role="listitem" title="${metric.title || metric.label}">
            <span class="pso-metric-label">${metric.label}</span>
            <div class="pso-metric-value-row ${metric.iconHtml ? 'has-icon' : ''}">
              ${metric.iconHtml || ''}
              <strong class="pso-metric-value" ${metric.valueColor ? `style="color:${metric.valueColor}"` : ''}>${metric.value}</strong>
            </div>
          </div>
        `).join('')}
      </div>
      <div class="pso-summary-meta">
        <span>${data.totalMatches} partida${data.totalMatches === 1 ? '' : 's'}</span>
        <span>${data.winRate}% WR</span>
        <span>${data.wins}V · ${data.losses}D</span>
        ${rank.rrLabel ? `<span>${rank.rrLabel}</span>` : ''}
      </div>
    `;
  }

  renderTopAgentsPremium(topAgents) {
    if (!topAgents || topAgents.length === 0) {
      return `
        <div class="premium-empty-state">
          <i class="fas fa-user-slash"></i>
          <p>Sem dados para este período</p>
        </div>
      `;
    }

    return topAgents.map((agentData, index) => {
      const agent = this.agentsData?.[agentData.agent];
      const agentIcon = agent?.displayIcon || `/img/agents/${agentData.agent}.png`;
      const agentName = agent?.displayName || this.capitalizeFirst(agentData.agent);
      const rankClass = index === 0 ? 'gold' : index === 1 ? 'silver' : index === 2 ? 'bronze' : '';

      return `
        <div class="premium-agent-card ${rankClass}">
          <div class="premium-agent-rank">${index + 1}</div>
          <div class="premium-agent-avatar" style="${this.getAgentGradientStyle(agentData.agent)}">
            <img src="${agentIcon}" alt="${agentName}" 
                 onerror="this.src='/img/default-agent.png'">
          </div>
          <div class="premium-agent-info">
            <span class="premium-agent-name">${agentName}</span>
          </div>
          <div class="premium-agent-stats">
            <div class="premium-agent-bar">
              <div class="premium-agent-bar-fill" style="width: ${agentData.percentage}%"></div>
            </div>
            <span class="premium-agent-percentage">${agentData.percentage}%</span>
            <span class="premium-agent-games">${agentData.count} jogos</span>
          </div>
        </div>
      `;
    }).join('');
  }

  renderAgentsByMapPremium(agentsByMap) {
    if (!agentsByMap || Object.keys(agentsByMap).length === 0) {
      return `
        <div class="premium-empty-state">
          <i class="fas fa-map"></i>
          <p>Sem dados para este período</p>
        </div>
      `;
    }

    return Object.entries(agentsByMap).map(([mapName, agents]) => {
      const map = this.mapsData?.[mapName];
      const mapBackground = map?.splash || map?.stylizedBackgroundImage || map?.listViewIcon || map?.displayIcon || map?.displayIconSmall || '';
      
      // Renderizar TODOS os agentes usados neste mapa
      const agentsHtml = agents.map(agent => {
        const agentData = this.agentsData?.[agent.agent];
        const agentIcon = agentData?.displayIcon || `/img/agents/${agent.agent || 'unknown'}.png`;
        const agentName = agentData?.displayName || this.capitalizeFirst(agent.agent || 'Unknown');

        return `
          <div class="map-agent-item">
            <div class="map-agent-icon-wrap" style="${this.getAgentGradientStyle(agent.agent)}">
              <img src="${agentIcon}" alt="${agentName}" class="map-agent-icon" 
                   onerror="this.src='/img/default-agent.png'" title="${agentName}">
            </div>
            <div class="map-agent-info">
              <span class="map-agent-name">${agentName}</span>
              <div class="map-agent-stats">
                <span class="map-agent-percentage">${agent.percentage || 0}%</span>
                <span class="map-agent-games">${agent.count || 0} jogos</span>
              </div>
            </div>
          </div>
        `;
      }).join('');

      return `
        <div class="premium-map-card-compact">
          <div class="map-card-bg ${mapBackground ? '' : 'is-fallback'}" ${mapBackground ? `style="background-image:url('${mapBackground}')"` : ''}></div>
          <div class="map-card-bg-overlay"></div>
          <div class="map-card-right map-card-agents-list">
            ${agentsHtml}
          </div>
        </div>
      `;
    }).join('');
  }

  formatDecimalWithoutTrailingZeros(value, decimals = 2) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
      return value == null ? '0' : String(value);
    }

    return numeric
      .toFixed(decimals)
      .replace(/\.0+$/, '')
      .replace(/(\.\d*?[1-9])0+$/, '$1');
  }

  capitalizeFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  setupPeriodTabs(memberId, rawMatches, playerName) {
    const tabs = document.querySelectorAll('.period-tab-premium');
    const analysis = this.playerAnalysis.get(memberId);
    
    const now = new Date();
    const dayAgo = new Date(now - 24 * 60 * 60 * 1000);
    const weekAgo = new Date(now - 7 * 24 * 60 * 60 * 1000);
    const monthAgo = new Date(now - 30 * 24 * 60 * 60 * 1000);
    
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        
        const period = tab.dataset.period;
        const data = analysis[period];
        
        // Filter matches for this period
        let periodMatches = rawMatches;
        if (period === 'day') {
          periodMatches = rawMatches.filter(m => new Date(m.metadata?.started_at || m.game_start * 1000) >= dayAgo);
        } else if (period === 'week') {
          periodMatches = rawMatches.filter(m => new Date(m.metadata?.started_at || m.game_start * 1000) >= weekAgo);
        } else if (period === 'month') {
          periodMatches = rawMatches.filter(m => new Date(m.metadata?.started_at || m.game_start * 1000) >= monthAgo);
        }
        
        const statsOverview = document.getElementById('analysisStatsOverview');
        if (statsOverview) {
          statsOverview.innerHTML = this.renderStatsOverviewPremium(data);
        }
        const topAgentsGrid = document.getElementById('topAgentsGrid');
        if (topAgentsGrid) {
          topAgentsGrid.innerHTML = this.renderTopAgentsPremium(data.topAgents);
        }

        const agentsByMapGrid = document.getElementById('agentsByMapGrid');
        if (agentsByMapGrid) {
          agentsByMapGrid.innerHTML = this.renderAgentsByMapPremium(data.agentsByMap);
        }

        const matchesTableContainer = document.getElementById('matchesTableContainer');
        if (matchesTableContainer) {
          matchesTableContainer.innerHTML = this.renderMatchesTable(periodMatches, playerName);
        }
      });
    });
  }

  closeAnalysisModal() {
    const modal = document.getElementById('rankedAnalysisModal');
    modal.style.display = 'none';
    modal.classList.remove('show');
    document.body.style.overflow = '';
  }

  // Configurações padrão de rotação e flip para cada mapa
  // Defaults do Ranked podem ser ajustados por mapa e sobrescritos pelo usuário.
  getDefaultMapSettings() {
    return {
      abyss: { rotation: 90, flip: false }
    };
  }

  // Funções de rotação do mapa
  getMapRotation(mapName) {
    const key = `ranked_map_rotation_${mapName?.toLowerCase()}`;
    const stored = localStorage.getItem(key);
    if (stored !== null) {
      const parsed = parseInt(stored, 10);
      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }

    return this.getDefaultMapSettings()[mapName?.toLowerCase()]?.rotation || 0;
  }

  getMapFlip(mapName) {
    const key = `ranked_map_flip_${mapName?.toLowerCase()}`;
    const stored = localStorage.getItem(key);
    if (stored !== null) {
      return stored === 'true';
    }

    return this.getDefaultMapSettings()[mapName?.toLowerCase()]?.flip || false;
  }

  // Transforma coordenadas de um ponto baseado na rotação e flip do mapa
  transformPointForMap(x, y, mapName) {
    const rotation = this.getMapRotation(mapName);
    const flip = this.getMapFlip(mapName);
    
    let newX = x;
    let newY = y;
    
    // Aplicar rotação (em torno do centro 50%, 50%)
    if (rotation === 90) {
      newX = 100 - y;
      newY = x;
    } else if (rotation === 180) {
      newX = 100 - x;
      newY = 100 - y;
    } else if (rotation === 270) {
      newX = y;
      newY = 100 - x;
    }
    
    // Aplicar flip horizontal (após rotação)
    if (flip) {
      newX = 100 - newX;
    }
    
    return { x: newX, y: newY };
  }

  // Atualiza as posições de todos os pontos do overlay no mapa
  updateMapPointsPositions(matchId) {
    const mapWrapper = document.getElementById(`map-wrapper-${matchId}`);
    if (!mapWrapper) return;
    
    const mapName = mapWrapper.dataset.mapname;
    const mapImage = document.getElementById(`map-img-${matchId}`);
    const points = mapWrapper.querySelectorAll('.map-point');

    if (mapImage) {
      mapImage.style.cssText = this.getMapTransformStyle(mapName);
    }
    
    points.forEach(point => {
      const origX = parseFloat(point.dataset.origX);
      const origY = parseFloat(point.dataset.origY);
      const transformed = this.transformPointForMap(origX, origY, mapName);
      point.style.left = `${transformed.x}%`;
      point.style.top = `${transformed.y}%`;
    });
  }

  getMapTransformStyle(mapName) {
    const rotation = this.getMapRotation(mapName);
    const flip = this.getMapFlip(mapName);
    const transforms = [];
    
    if (rotation !== 0) {
      transforms.push(`rotate(${rotation}deg)`);
    }
    if (flip) {
      transforms.push('scaleX(-1)');
    }
    
    return transforms.length > 0 ? `transform: ${transforms.join(' ')};` : '';
  }

  setMapRotation(mapName, degrees, matchId) {
    const key = `ranked_map_rotation_${mapName?.toLowerCase()}`;
    localStorage.setItem(key, degrees.toString());
    
    // Atualizar posições dos pontos no mapa
    this.updateMapPointsPositions(matchId);
    
    // Atualizar botões ativos
    this.updateRotationButtons(mapName, matchId);
  }

  toggleMapFlip(mapName, matchId) {
    const key = `ranked_map_flip_${mapName?.toLowerCase()}`;
    const currentFlip = this.getMapFlip(mapName);
    localStorage.setItem(key, (!currentFlip).toString());
    
    // Atualizar posições dos pontos no mapa
    this.updateMapPointsPositions(matchId);
    
    // Atualizar botões ativos
    this.updateRotationButtons(mapName, matchId);
  }

  updateRotationButtons(mapName, matchId) {
    const rotation = this.getMapRotation(mapName);
    const flip = this.getMapFlip(mapName);
    
    // Encontrar todos os controles para este mapa
    const detailsRow = document.getElementById(`details-${matchId}`);
    if (!detailsRow) return;
    
    const rotateButtons = detailsRow.querySelectorAll('.btn-rotate');
    rotateButtons.forEach(btn => {
      btn.classList.remove('active');
      const btnDegrees = parseInt(btn.textContent.replace('°', ''), 10);
      if (btnDegrees === rotation) {
        btn.classList.add('active');
      }
    });
    
    const flipButton = detailsRow.querySelector('.btn-flip');
    if (flipButton) {
      flipButton.classList.toggle('active', flip);
    }
  }

  cycleMapRotation(matchId) {
    const mapWrapper = document.getElementById(`map-wrapper-${matchId}`);
    if (!mapWrapper) return;

    const mapName = mapWrapper.dataset.mapname;
    const currentRotation = this.getMapRotation(mapName);
    const nextRotation = (currentRotation + 90) % 360;

    this.setMapRotation(mapName, nextRotation, matchId);
    this.resetMapPoints(matchId);
  }

  renderError() {
    const grid = document.getElementById('rankedPlayersGrid');
    grid.innerHTML = `
      <div class="empty-state error-state">
        <div class="empty-icon">
          <i class="fas fa-exclamation-triangle"></i>
        </div>
        <h3>Erro ao carregar dados</h3>
        <p>Não foi possível carregar os jogadores do time</p>
        <button class="btn btn-primary" onclick="rankedStats.load()">
          <i class="fas fa-redo"></i>
          <span>Tentar Novamente</span>
        </button>
      </div>
    `;
  }
}

// Initialize
const rankedStats = new RankedStats();


/* ===== js/analise/format.js ===== */
// =====================================================
// ZDVAL — /analise · format
// Helpers puros de formatação e derivação. Sem DOM, sem fetch de dados
// da aplicação — só normalização de nomes, índices de imagem e os números
// que a UI mostra.
//
// Os derivados (MVP, adversário, round diff) existem aqui porque o banco
// não os guarda: são calculados a partir do que analysis_matches e
// analysis_players já têm.
// =====================================================

window.AnaliseFormat = {
  _agentIconIndex: null,
  _agentGradients: null,
  _mapImageIndex: null,

  // ── Agentes ──────────────────────────────────────────

  normalizeAgentName(name) {
    return (name || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  },

  async ensureAgentIconIndex() {
    if (this._agentIconIndex) return;
    this._agentIconIndex = {};
    this._agentGradients = {};

    const urls = [
      'https://valorant-api.com/v1/agents?isPlayableCharacter=true&language=pt-BR',
      'https://valorant-api.com/v1/agents?isPlayableCharacter=true&language=en-US'
    ];

    for (const url of urls) {
      try {
        const res = await fetch(url);
        if (!res.ok) continue;
        const json = await res.json();
        (json.data || []).forEach(agent => {
          const key = this.normalizeAgentName(agent.displayName);
          const icon = agent.displayIconSmall || agent.displayIcon;
          if (key && icon && !this._agentIconIndex[key]) this._agentIconIndex[key] = icon;

          const gc = agent.backgroundGradientColors || [];
          if (key && !this._agentGradients[key]) {
            this._agentGradients[key] = {
              g0: gc[0] ? '#' + gc[0].slice(0, 6) : '#1a1a2e',
              g1: gc[1] ? '#' + gc[1].slice(0, 6) : '#0f1923',
              g2: gc[2] ? '#' + gc[2].slice(0, 6) : '#1a1a2e'
            };
          }
        });
      } catch (_) {
        // Rede fora ou API mudou: segue para a próxima URL, e no pior caso
        // getAgentIcon devolve o placeholder local.
      }
      if (Object.keys(this._agentIconIndex).length) break;
    }
  },

  getAgentIcon(agentName) {
    const key = this.normalizeAgentName(agentName);
    return this._agentIconIndex?.[key] || '/img/default-agent.png';
  },


  // ── Mapas ────────────────────────────────────────────

  normalizeMapName(name) {
    return (name || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  },

  async ensureMapImageIndex() {
    if (this._mapImageIndex) return;
    this._mapImageIndex = {};

    // O backend já entrega URLs corrigidas; preferir sempre.
    if (typeof app !== 'undefined' && app.getMaps) {
      const appMaps = app.getMaps();
      if (appMaps && appMaps.length) {
        appMaps.forEach(map => {
          const key = this.normalizeMapName(map.display_name || map.name);
          const img = map.splash || map.listViewIcon || map.image_url;
          if (key && img && !this._mapImageIndex[key]) this._mapImageIndex[key] = img;
        });
        if (Object.keys(this._mapImageIndex).length) return;
      }
    }

    const urls = [
      'https://valorant-api.com/v1/maps?language=pt-BR',
      'https://valorant-api.com/v1/maps?language=en-US'
    ];

    for (const url of urls) {
      try {
        const res = await fetch(url);
        if (!res.ok) continue;
        const json = await res.json();
        (json.data || []).forEach(map => {
          const key = this.normalizeMapName(map.displayName);
          const img = map.stylizedBackgroundImage || map.splash || map.listViewIcon || map.displayIcon;
          if (key && img && !this._mapImageIndex[key]) this._mapImageIndex[key] = img;
        });
      } catch (_) {
        // idem agentes: cai no preview local
      }
      if (Object.keys(this._mapImageIndex).length) break;
    }
  },

  getMapImage(mapName) {
    const key = this.normalizeMapName(mapName);

    if (this._mapImageIndex?.[key]) return this._mapImageIndex[key];

    // Preview local antes de tudo: e arquivo proprio, leve, e nao depende do
    // valorant-api. Corrode e Summit nao tem preview local.
    const localPreviews = new Set([
      'abyss', 'ascent', 'bind', 'breeze', 'fracture',
      'haven', 'icebox', 'lotus', 'pearl', 'split', 'sunset'
    ]);
    if (localPreviews.has(key)) return `/img/maps/${key}-preview.jpg`;

    // Sem preview local, cai no splash do valorant-api. A URL vinha escrita a
    // mao aqui para esses dois mapas, e a de corrode apontava para o UUID do
    // Split — o /analise mostrava a arte do Split nas partidas de Corrode.
    const doCatalogo = MapCatalog.splash(key);
    if (doCatalogo) return doCatalogo;

    return '/img/maps/default-preview.jpg';
  },


  // ── Resultado de lado e pistol ───────────────────────


  getPistolOutcomeLabel(value) {
    if (!value) return '—';
    return value === 'won' ? 'V' : 'X';
  },



  getHalfScoreLabel(won, lost) {
    const wins = Number(won || 0);
    const losses = Number(lost || 0);
    if ((wins + losses) <= 0) return '—';
    return `${wins}-${losses}`;
  },

  resultLabel(result) {
    if (result === 'win') return 'Vitória';
    if (result === 'loss') return 'Derrota';
    if (result === 'draw') return 'Empate';
    return '—';
  },

  resultChipClass(result) {
    if (result === 'win') return 'an-chip an-chip-win';
    if (result === 'loss') return 'an-chip an-chip-loss';
    return 'an-chip';
  },

  // ── Função ───────────────────────────────────────────
  // As quatro funções do Valorant, na ordem que lineups.js e valoplant já usam.
  // Guardamos a chave em inglês (é o que está no banco) e exibimos em PT.

  ROLES: [
    { value: 'duelist',    label: 'Duelista' },
    { value: 'initiator',  label: 'Iniciador' },
    { value: 'controller', label: 'Controlador' },
    { value: 'sentinel',   label: 'Sentinela' }
  ],

  /** Aceita o que já está gravado (pt ou en, caixa livre) e devolve a chave. */
  normalizeRole(role) {
    const r = String(role || '').trim().toLowerCase();
    if (!r) return '';
    const map = {
      duelist: 'duelist', duelista: 'duelist',
      initiator: 'initiator', iniciador: 'initiator',
      controller: 'controller', controlador: 'controller',
      sentinel: 'sentinel', sentinela: 'sentinel',
      flex: 'flex'
    };
    return map[r] || '';
  },

  roleLabel(role) {
    const key = this.normalizeRole(role);
    if (key === 'flex') return 'Flex';
    return this.ROLES.find(r => r.value === key)?.label || '';
  },

  // ── VOD ──────────────────────────────────────────────

  sanitizeVodUrl(raw) {
    const value = (raw || '').trim();
    if (!value) return '';

    // Aceita snippet de embed colado ou texto solto: extrai a primeira URL.
    const srcMatch = value.match(/src=["']([^"']+)["']/i);
    const urlMatch = value.match(/https?:\/\/[^\s"'<>]+/i);
    const candidate = (srcMatch && srcMatch[1]) || (urlMatch && urlMatch[0]) || value;

    try {
      const parsed = new URL(candidate);
      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return '';
      return parsed.toString();
    } catch (_) {
      return '';
    }
  },

  /**
   * Colar link de VOD é o mesmo gesto no upload e na edição da partida, e
   * cada tela tinha a sua versão — a do upload nem normalizava o que colava.
   */
  bindVodInput(input) {
    if (!input) return;
    input.addEventListener('paste', (e) => {
      const normalized = this.sanitizeVodUrl(e.clipboardData?.getData('text') || '');
      if (!normalized) return;
      e.preventDefault();
      input.value = normalized;
    });
    input.addEventListener('blur', () => {
      const normalized = this.sanitizeVodUrl(input.value);
      if (normalized || !input.value) input.value = normalized;
    });
  },

  async pasteVod(input) {
    if (!input) return;
    try {
      const normalized = this.sanitizeVodUrl(await navigator.clipboard.readText());
      if (!normalized) {
        AnaliseShell.toast('A área de transferência não tem um link válido', 'error');
        return;
      }
      input.value = normalized;
    } catch (_) {
      AnaliseShell.toast('O navegador bloqueou a leitura da área de transferência', 'error');
    }
  },

  // ── Números ──────────────────────────────────────────

  winRate(wins, total) {
    const t = Number(total) || 0;
    if (!t) return 0;
    return Math.round((Number(wins) || 0) / t * 100);
  },

  /** Win rate de um lado a partir dos rounds ganhos/perdidos daquele lado. */
  sideRate(won, lost) {
    const w = Number(won) || 0;
    const l = Number(lost) || 0;
    return this.winRate(w, w + l);
  },

  roundDiff(match) {
    return (Number(match?.score_team) || 0) - (Number(match?.score_opponent) || 0);
  },

  fmtNum(value, digits = 0) {
    const n = Number(value);
    if (value === null || value === undefined || Number.isNaN(n)) return '—';
    return n.toFixed(digits);
  },

  /** Sinal explícito e casas fixas, para a coluna não misturar "+3" com "+4.8". */
  fmtSigned(value, digits = 0) {
    const n = Number(value);
    if (value === null || value === undefined || Number.isNaN(n)) return '—';
    const text = n.toFixed(digits);
    return n > 0 ? `+${text}` : text;
  },

  /**
   * Formatadores de data criados uma vez.
   *
   * `toLocaleDateString(locale, options)` constroi um Intl.DateTimeFormat novo
   * a cada chamada, e isso e caro: no historico com 300 partidas o fmtDate
   * sozinho levava 32.7ms dos 65.6ms de montagem da tabela. Reusando a
   * instancia a saida e identica — e a mesma API por baixo.
   *
   * match_date vem como DATE puro; usar UTC evita voltar um dia em BRT.
   */
  _dataCurta: new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }),
  _diaMes: new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', timeZone: 'UTC' }),

  fmtDate(value) {
    if (!value) return '—';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '—';
    return AnaliseFormat._dataCurta.format(d);
  },

  // ── Derivados (o banco não guarda) ───────────────────

  /** Jogador do nosso time com maior ACS na partida. */
  matchMvp(players) {
    const ours = (players || []).filter(p => p.is_our_team);
    if (!ours.length) return null;
    return ours.reduce((best, p) => (Number(p.acs) || 0) > (Number(best.acs) || 0) ? p : best, ours[0]);
  },

  /** Tag do time adversário, lida da própria escalação extraída. */
  opponentTag(players) {
    const foe = (players || []).find(p => !p.is_our_team && p.team_tag);
    return foe?.team_tag || '—';
  },

  // ── Roster ───────────────────────────────────────────

  isRosterPlayer(playerName, roster) {
    if (!playerName || !roster?.length) return false;
    const name = playerName.toLowerCase();
    return roster.some(r => {
      const nick = (r.nickname || '').toLowerCase();
      if (!nick) return false;
      if (nick === name) return true;
      if (name.includes(nick)) return true;
      if (nick.includes(name) && name.length >= 3) return true;
      if (r.aliases?.length) {
        return r.aliases.some(a => {
          const alias = (a || '').toLowerCase();
          if (!alias) return false;
          return alias === name || name.includes(alias) || (alias.includes(name) && name.length >= 3);
        });
      }
      return false;
    });
  },

  // ── HTML ─────────────────────────────────────────────

  escape(value) {
    return (value ?? '').toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  },

  /**
   * A barra de metades: ataque cresce da esquerda, defesa da direita,
   * o vazio no centro é o que o time perdeu. Uma leitura dá força no
   * mapa e viés de lado ao mesmo tempo.
   */
  halfBar(atkWon, atkLost, defWon, defLost, { small = false, legend = false } = {}) {
    const atk = this.sideRate(atkWon, atkLost);
    const def = this.sideRate(defWon, defLost);
    const cls = small ? 'an-halfbar an-halfbar-sm' : 'an-halfbar';
    const bar = `
      <div class="${cls}" role="img"
           aria-label="Ataque ${atk}%, defesa ${def}%">
        <div class="an-halfbar-atk" style="--fill:${atk}%"></div>
        <div class="an-halfbar-def" style="--fill:${def}%"></div>
      </div>`;
    if (!legend) return bar;
    return `${bar}
      <div class="an-halfbar-legend">
        <span class="atk">ATK ${this.getHalfScoreLabel(atkWon, atkLost)}</span>
        <span class="def">DEF ${this.getHalfScoreLabel(defWon, defLost)}</span>
      </div>`;
  }
};


/* ===== js/analise/report.js ===== */
// =====================================================
// ZDVAL — /analise · leitura das partidas
//
// Todo cálculo que vira decisão mora aqui: filtro de recorte, agrupamento por
// sessão, leitura de uma partida e os agregados por mapa/lado/pistol. As views
// só desenham. Antes cada tela refazia a sua conta — e elas divergiam.
//
// Vocabulário do banco (analysis_matches):
//   half_attack_won/lost   → rounds ganhos/perdidos jogando de ataque
//   half_defense_won/lost  → idem na defesa
//   pistol_attack/defense  → 'won' | 'lost' | null (não informado)
//   match_type             → 'treino' | 'campeonato'
// =====================================================

window.AnaliseReport = {
  /** Volume mínimo para um mapa entrar em recomendação de veto/pick. */
  MIN_SAMPLE: 3,

  // ── Recorte ──────────────────────────────────────────

  filter(matches, { scope = 'all', period = 'all', map = '', from = '', to = '' } = {}) {
    const list = Array.isArray(matches) ? matches : [];
    // Intervalo explícito manda no atalho de período: quem escolheu "de/até"
    // não quer que "30 dias" corte a ponta.
    const usaIntervalo = Boolean(from || to);
    const limit = usaIntervalo ? null : this._periodStart(period);
    const inicio = from ? this._parse(from) : null;
    const fim = to ? this._parse(to) : null;

    return list.filter(m => {
      if (scope !== 'all') {
        const type = String(m.match_type || 'treino').toLowerCase();
        if (type !== scope) return false;
      }
      if (map && String(m.map || '') !== map) return false;

      const data = this._date(m);
      if (limit && data < limit) return false;
      if (inicio && data < inicio) return false;
      if (fim && data > fim) return false;
      return true;
    });
  },

  _parse(iso) {
    const [y, mo, d] = String(iso).slice(0, 10).split('-').map(Number);
    return (y && mo && d) ? new Date(y, mo - 1, d) : null;
  },

  /** Mapas presentes nos dados — alimenta o filtro sem lista fixa. */
  mapOptions(matches) {
    return [...new Set((matches || []).map(m => m.map).filter(Boolean))].sort();
  },

  _periodStart(period) {
    const days = Number(period);
    if (!days || !Number.isFinite(days)) return null;
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() - days);
    return d;
  },

  _date(m) {
    // match_date vem como 'YYYY-MM-DD': o construtor com string ISO curta é
    // interpretado como UTC e volta um dia em fuso negativo.
    const raw = String(m.match_date || '').slice(0, 10);
    const [y, mo, d] = raw.split('-').map(Number);
    return (y && mo && d) ? new Date(y, mo - 1, d) : new Date(0);
  },

  // ── Uma partida ──────────────────────────────────────

  readMatch(m) {
    const atkWon = Number(m.half_attack_won) || 0;
    const atkLost = Number(m.half_attack_lost) || 0;
    const defWon = Number(m.half_defense_won) || 0;
    const defLost = Number(m.half_defense_lost) || 0;

    const pistols = [
      { side: 'ATK', state: this._pistolState(m.pistol_attack) },
      { side: 'DEF', state: this._pistolState(m.pistol_defense) }
    ];

    return {
      result: String(m.result || '').toLowerCase(),
      typeLabel: String(m.match_type || 'treino').toLowerCase() === 'campeonato' ? 'Campeonato' : 'Treino',
      atkWon, atkLost, defWon, defLost,
      pistols
    };
  },

  _pistolState(value) {
    const v = String(value || '').toLowerCase();
    if (v === 'won' || v === 'win' || v === 'ganho') return 'is-won';
    if (v === 'lost' || v === 'loss' || v === 'perdido') return 'is-lost';
    return 'is-unknown';
  },

  // ── Sessões (um dia de treino) ───────────────────────

  groupByDay(matches) {
    const byDay = new Map();

    [...matches]
      .sort((a, b) => this._date(b) - this._date(a))
      .forEach(m => {
        const key = String(m.match_date || '').slice(0, 10);
        if (!byDay.has(key)) byDay.set(key, []);
        byDay.get(key).push(m);
      });

    return [...byDay.entries()].map(([key, list]) => ({
      key,
      label: this._dayLabel(key),
      matches: list,
      wins: list.filter(m => String(m.result).toLowerCase() === 'win').length,
      losses: list.filter(m => String(m.result).toLowerCase() === 'loss').length
    }));
  },

  _dayLabel(key) {
    const [y, mo, d] = key.split('-').map(Number);
    if (!y) return 'Sem data';
    const date = new Date(y, mo - 1, d);

    const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
    const diff = Math.round((hoje - date) / 86400000);
    if (diff === 0) return 'Hoje';
    if (diff === 1) return 'Ontem';

    const texto = date.toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'short' });
    return texto.charAt(0).toUpperCase() + texto.slice(1);
  },

  // ── Agregados do recorte ─────────────────────────────

  summarize(matches) {
    const acc = {
      total: matches.length, wins: 0, losses: 0, draws: 0,
      atkWon: 0, atkLost: 0, defWon: 0, defLost: 0,
      pistolWon: 0, pistolTotal: 0
    };

    matches.forEach(m => {
      const r = String(m.result || '').toLowerCase();
      if (r === 'win') acc.wins++;
      else if (r === 'loss') acc.losses++;
      else acc.draws++;

      acc.atkWon += Number(m.half_attack_won) || 0;
      acc.atkLost += Number(m.half_attack_lost) || 0;
      acc.defWon += Number(m.half_defense_won) || 0;
      acc.defLost += Number(m.half_defense_lost) || 0;

      [m.pistol_attack, m.pistol_defense].forEach(p => {
        const state = this._pistolState(p);
        if (state === 'is-unknown') return;
        acc.pistolTotal++;
        if (state === 'is-won') acc.pistolWon++;
      });
    });

    return {
      ...acc,
      winRate: this._rate(acc.wins, acc.total),
      atkWinRate: this._rate(acc.atkWon, acc.atkWon + acc.atkLost),
      defWinRate: this._rate(acc.defWon, acc.defWon + acc.defLost),
      pistolRate: this._rate(acc.pistolWon, acc.pistolTotal)
    };
  },

  /**
   * Um agregado por mapa. É o relatório que decide veto: winrate por lado,
   * saldo de rounds e aproveitamento de pistol, com o volume à vista para
   * ninguém tirar conclusão de dois jogos.
   */
  byMap(matches) {
    const byMap = new Map();

    matches.forEach(m => {
      const name = m.map || '—';
      if (!byMap.has(name)) {
        byMap.set(name, {
          map: name, played: 0, wins: 0, losses: 0,
          atkWon: 0, atkLost: 0, defWon: 0, defLost: 0,
          pistolWon: 0, pistolTotal: 0,
          roundsWon: 0, roundsLost: 0
        });
      }
      const e = byMap.get(name);
      const r = String(m.result || '').toLowerCase();

      e.played++;
      if (r === 'win') e.wins++;
      else if (r === 'loss') e.losses++;

      e.atkWon += Number(m.half_attack_won) || 0;
      e.atkLost += Number(m.half_attack_lost) || 0;
      e.defWon += Number(m.half_defense_won) || 0;
      e.defLost += Number(m.half_defense_lost) || 0;
      e.roundsWon += Number(m.score_team) || 0;
      e.roundsLost += Number(m.score_opponent) || 0;

      [m.pistol_attack, m.pistol_defense].forEach(p => {
        const state = this._pistolState(p);
        if (state === 'is-unknown') return;
        e.pistolTotal++;
        if (state === 'is-won') e.pistolWon++;
      });
    });

    return [...byMap.values()].map(e => {
      const atkRate = this._rate(e.atkWon, e.atkWon + e.atkLost);
      const defRate = this._rate(e.defWon, e.defWon + e.defLost);
      return {
        ...e,
        winRate: this._rate(e.wins, e.played),
        atkWinRate: atkRate,
        defWinRate: defRate,
        pistolRate: this._rate(e.pistolWon, e.pistolTotal),
        roundDiff: e.roundsWon - e.roundsLost,
        strongSide: Math.abs(atkRate - defRate) < 5 ? null : (atkRate > defRate ? 'atk' : 'def'),
        reliable: e.played >= this.MIN_SAMPLE
      };
    }).sort((a, b) => b.played - a.played);
  },

  /**
   * Leitura em texto do mapa — o que dizer no review. Sai da tabela e vira
   * frase porque é isso que o coach leva para a call.
   */
  readMapRow(row) {
    if (!row.reliable) {
      return `Amostra curta (${row.played} ${row.played === 1 ? 'jogo' : 'jogos'}): ainda não dá para concluir.`;
    }

    const partes = [];

    if (row.winRate >= 60) partes.push('Mapa forte — bom candidato a pick.');
    else if (row.winRate <= 35) partes.push('Mapa fraco — candidato a veto.');
    else partes.push('Mapa equilibrado.');

    if (row.strongSide === 'atk') {
      partes.push(`Ataque carrega (${Math.round(row.atkWinRate)}% contra ${Math.round(row.defWinRate)}% na defesa): treinar retake e pós-plant.`);
    } else if (row.strongSide === 'def') {
      partes.push(`Defesa segura (${Math.round(row.defWinRate)}% contra ${Math.round(row.atkWinRate)}% no ataque): treinar execute e entrada.`);
    }

    if (row.pistolTotal >= 4 && row.pistolRate <= 35) {
      partes.push(`Pistol ruim (${row.pistolWon}/${row.pistolTotal}): custa os rounds de bônus.`);
    } else if (row.pistolTotal >= 4 && row.pistolRate >= 65) {
      partes.push(`Pistol dominante (${row.pistolWon}/${row.pistolTotal}).`);
    }

    return partes.join(' ');
  },

  _rate(part, total) {
    return total > 0 ? (part / total) * 100 : 0;
  },
};


/* ===== js/analise/store.js ===== */
// =====================================================
// ZDVAL — /analise · store
// Cache em memória dos quatro conjuntos de dados da página.
//
// A página inteira depende disso para trocar de view sem refazer fetch.
// Guardamos a *promise*, não o valor: duas views pedindo 'stats' ao mesmo
// tempo compartilham uma requisição só. Só mutação invalida.
// =====================================================

class AnaliseStoreImpl {
  static ENDPOINTS = {
    stats:   '/scoreboard/stats',
    players: '/scoreboard/stats/players',
    matches: '/scoreboard/matches?limit=500',
    roster:  '/scoreboard/roster'
  };

  constructor() {
    this.cache = new Map();
    this.listeners = new Map();
  }

  /**
   * Os quatro endpoints sao do dono dos dados: sem token o backend responde 401
   * e a view estourava com "Nao foi possivel carregar" — a pagina inteira
   * morria para visitante deslogado. Aqui devolvemos null, e como toda view ja
   * trata dado vazio (`|| []`), a pagina abre no estado vazio em vez de erro.
   * Os dados continuam privados: quem nao tem token nao ve partida de ninguem.
   */
  async get(key) {
    if (this.cache.has(key)) return this.cache.get(key);

    const endpoint = AnaliseStoreImpl.ENDPOINTS[key];
    if (!endpoint) throw new Error(`AnaliseStore: chave desconhecida "${key}"`);

    if (!api.token) return null;

    const promise = api.request(endpoint)
      .then(res => res?.data ?? null)
      .catch(err => {
        // Falha não pode ficar cacheada: a próxima tentativa precisa refazer.
        this.cache.delete(key);
        throw err;
      });

    this.cache.set(key, promise);
    return promise;
  }

  /**
   * Um pedido cacheado por chave. Os tres metodos abaixo eram o mesmo corpo
   * copiado, e nenhum deles tinha a guarda de token que o `get()` tem: aberto
   * o detalhe deslogado, o backend respondia 401 e o erro subia ate a view.
   * Aqui vale a mesma regra do `get()` — sem token, null, e a view cai no
   * estado vazio que ja sabe tratar.
   */
  _cachear(key, endpoint) {
    if (this.cache.has(key)) return this.cache.get(key);
    if (!api.token) return null;

    const promise = api
      .request(endpoint)
      .then(res => res?.data ?? null)
      .catch(err => {
        // Falha não pode ficar cacheada: a próxima tentativa precisa refazer.
        this.cache.delete(key);
        throw err;
      });

    this.cache.set(key, promise);
    return promise;
  }

  /** Detalhe por jogador — cacheado por nickname. */
  async getPlayerDetail(nickname) {
    return this._cachear(`player:${nickname}`, `/scoreboard/stats/players/${encodeURIComponent(nickname)}`);
  }

  /** Detalhe de uma partida (inclui os jogadores). Sem cache: muda ao editar. */
  async getMatch(matchId) {
    if (!api.token) return null;
    const res = await api.request(`/scoreboard/matches/${matchId}`);
    return res?.data ?? null;
  }

  /**
   * Sem argumentos limpa tudo, inclusive os detalhes por jogador e por mapa —
   * é o que salvar uma partida exige.
   */
  invalidate(...keys) {
    if (!keys.length) {
      this.cache.clear();
    } else {
      keys.forEach(k => {
        this.cache.delete(k);
        // 'players' invalida junto os detalhes por jogador.
        if (k === 'players') {
          [...this.cache.keys()]
            .filter(ck => typeof ck === 'string' && ck.startsWith('player:'))
            .forEach(ck => this.cache.delete(ck));
        }
      });
    }
    this.emit('invalidated', keys);
  }

  on(event, fn) {
    if (!this.listeners.has(event)) this.listeners.set(event, new Set());
    this.listeners.get(event).add(fn);
  }


  emit(event, payload) {
    this.listeners.get(event)?.forEach(fn => {
      try { fn(payload); } catch (err) { console.error('AnaliseStore listener:', err); }
    });
  }
}

// A classe fica com outro nome porque `class AnaliseStore` criaria um binding
// léxico global que sombreia window.AnaliseStore — os outros módulos pegariam
// a classe no lugar da instância.
window.AnaliseStore = new AnaliseStoreImpl();


/* ===== js/analise/shell.js ===== */
// =====================================================
// ZDVAL — /analise · shell
// Sidebar, header sticky, drawer lateral e confirmação.
//
// O shell é montado uma vez e sobrevive à troca de views: só o conteúdo
// de #anMain é substituído. Isso é o que permite navegar sem refetch.
// =====================================================

window.AnaliseShell = {
  container: null,
  _drawerReturnFocus: null,
  _onKeydown: null,

  render(container, { views, active }) {
    this.container = container;

    container.innerHTML = `
      <div class="an-shell">
        <aside class="an-side">
          <div class="an-side-brand">
            <span class="an-side-mark" aria-hidden="true"></span>
            <h1>Análise</h1>
            <span class="an-badge-pro">PRO</span>
          </div>
          <nav class="an-side-nav" id="anSideNav" aria-label="Seções da análise">
            ${views.map(v => this._navItem(v, active)).join('')}
          </nav>
          <div class="an-side-foot" id="anSideFoot"></div>
        </aside>

        <div class="an-col">
          <main class="an-main" id="anMain" tabindex="-1"></main>
        </div>
      </div>
      <div class="an-drawer-host" id="anDrawerHost" hidden></div>
      <div id="anConfirmMount"></div>
    `;
  },

  _navItem(v, active) {
    const isActive = v.id === active ? ' is-active' : '';
    return `
      <button type="button" class="an-side-item${isActive}" data-view="${v.id}"
              aria-current="${v.id === active ? 'page' : 'false'}">
        <i class="${v.icon}" aria-hidden="true"></i><span>${v.label}</span>
      </button>`;
  },

  /**
   * Escopo e "Nova VOD" viviam numa barra sticky própria, uma linha inteira
   * acima do título da view. Agora são as ações do próprio cabeçalho da view:
   * uma linha a menos e o botão fica junto do que ele afeta.
   * `extra` entra à esquerda — é onde cada view põe as ações que são só dela.
   */
  headActions(extra = '') {
    return `
      <div class="an-view-head-actions">
        ${extra}
        <span class="an-chip" id="anHeadScope"><i class="fas fa-users"></i> Meu time</span>
        <button type="button" class="an-btn an-btn-primary" id="anImportBtn">
          <i class="fas fa-plus"></i> Nova VOD
        </button>
      </div>`;
  },

  /** O título da view vive no corpo (h2 de cada tela), não no cabeçalho. */
  setActive(viewId) {
    this.container?.querySelectorAll('.an-side-item').forEach(btn => {
      const on = btn.dataset.view === viewId;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-current', on ? 'page' : 'false');
    });
  },

  setFooter({ players = 0, matches = 0 } = {}) {
    const el = this.container?.querySelector('#anSideFoot');
    if (!el) return;
    el.innerHTML = `<b>${players}</b> jogadores<br><b>${matches}</b> partidas`;
  },

  /**
   * Mesmo vazio em Minhas Partidas e em Mapas — era o mesmo bloco copiado nas
   * duas views, diferindo só no respiro de dentro do card.
   */
  emptyPeriod({ padded = false } = {}) {
    return `
      <div class="an-empty"${padded ? ' style="padding:44px 24px"' : ''}>
        <i class="fas fa-calendar-day"></i>
        <h3>Nenhuma partida neste recorte</h3>
        <p>Troque o período ou o tipo de partida no filtro acima.</p>
      </div>`;
  },

  get main() {
    return this.container?.querySelector('#anMain') || null;
  },

  // ── Drawer ───────────────────────────────────────────

  /** Abre o drawer e devolve o elemento do corpo, para quem chamou preencher. */
  /**
   * `centered: true` troca o painel lateral por um modal no meio da tela.
   * O upload usa isso: é um formulário curto, com começo e fim, não um
   * detalhe que se lê ao lado da lista.
   */
  openDrawer({ title, width = 560, footer = '', centered = false } = {}) {
    const host = this.container?.querySelector('#anDrawerHost');
    if (!host) return null;

    this._drawerReturnFocus = document.activeElement;

    host.hidden = false;
    host.classList.toggle('is-centered', Boolean(centered));
    host.style.setProperty('--an-drawer-w', `${width}px`);
    host.innerHTML = `
      <div class="an-drawer-backdrop" data-drawer-close></div>
      <aside class="an-drawer" role="dialog" aria-modal="true" aria-label="${AnaliseFormat.escape(title)}">
        <div class="an-drawer-head">
          <h2>${AnaliseFormat.escape(title)}</h2>
          <button type="button" class="an-drawer-close" data-drawer-close aria-label="Fechar">
            <i class="fas fa-xmark"></i>
          </button>
        </div>
        <div class="an-drawer-body" id="anDrawerBody"></div>
        ${footer ? `<div class="an-drawer-foot" id="anDrawerFoot">${footer}</div>` : ''}
      </aside>`;

    host.querySelectorAll('[data-drawer-close]').forEach(el => {
      el.addEventListener('click', () => this.closeDrawer());
    });

    // Abrir um drawer por cima de outro (partida -> upload) sobrescrevia a
    // referencia e deixava o Escape antigo pendurado no document para sempre.
    if (this._onKeydown) document.removeEventListener('keydown', this._onKeydown);
    this._onKeydown = (e) => { if (e.key === 'Escape') this.closeDrawer(); };
    document.addEventListener('keydown', this._onKeydown);

    host.querySelector('.an-drawer-close')?.focus();
    return host.querySelector('#anDrawerBody');
  },


  /**
   * Toda ação de escrita da análise exige sessão. Sem esta guarda, o clique
   * ia até o servidor e voltava 401 cru no console ("Token de acesso não
   * fornecido") — erro de servidor aparecendo como se fosse bug da tela.
   * Devolve false quando não há sessão, já avisando o usuário.
   */
  requireSession(acao = 'continuar') {
    if (typeof api !== 'undefined' && api?.token) return true;
    this.toast(`Entre na sua conta para ${acao}.`, 'error');
    if (typeof auth !== 'undefined' && auth?.openAuth) auth.openAuth('login');
    return false;
  },

  setDrawerFooter(html) {
    const drawer = this.container?.querySelector('.an-drawer');
    if (!drawer) return;
    let foot = drawer.querySelector('#anDrawerFoot');
    if (!foot) {
      foot = document.createElement('div');
      foot.className = 'an-drawer-foot';
      foot.id = 'anDrawerFoot';
      drawer.appendChild(foot);
    }
    foot.innerHTML = html;
    return foot;
  },

  closeDrawer() {
    const host = this.container?.querySelector('#anDrawerHost');
    if (!host || host.hidden) return;
    host.hidden = true;
    host.innerHTML = '';
    if (this._onKeydown) {
      document.removeEventListener('keydown', this._onKeydown);
      this._onKeydown = null;
    }
    // Devolver o foco a quem abriu; sem isso o teclado cai no topo da página.
    this._drawerReturnFocus?.focus?.();
    this._drawerReturnFocus = null;
  },


  // ── Confirmação ──────────────────────────────────────

  confirm({
    title = 'Confirmar ação',
    message = 'Tem certeza?',
    confirmLabel = 'Confirmar',
    cancelLabel = 'Cancelar',
    danger = false
  } = {}) {
    return new Promise(resolve => {
      const mount = this.container?.querySelector('#anConfirmMount');
      if (!mount) return resolve(false);

      const returnFocus = document.activeElement;
      mount.innerHTML = `
        <div class="an-confirm-host" role="dialog" aria-modal="true">
          <div class="an-confirm">
            <h3>${AnaliseFormat.escape(title)}</h3>
            <p>${AnaliseFormat.escape(message)}</p>
            <div class="an-confirm-actions">
              <button type="button" class="an-btn" data-confirm="0">${AnaliseFormat.escape(cancelLabel)}</button>
              <button type="button" class="an-btn ${danger ? 'an-btn-danger' : 'an-btn-primary'}"
                      data-confirm="1">${AnaliseFormat.escape(confirmLabel)}</button>
            </div>
          </div>
        </div>`;

      const finish = (value) => {
        document.removeEventListener('keydown', onKey);
        mount.innerHTML = '';
        returnFocus?.focus?.();
        resolve(value);
      };
      const onKey = (e) => {
        if (e.key === 'Escape') finish(false);
        if (e.key === 'Enter') finish(true);
      };

      mount.querySelectorAll('[data-confirm]').forEach(btn => {
        btn.addEventListener('click', () => finish(btn.dataset.confirm === '1'));
      });
      mount.querySelector('.an-confirm-host')?.addEventListener('click', (e) => {
        if (e.target.classList.contains('an-confirm-host')) finish(false);
      });
      document.addEventListener('keydown', onKey);
      mount.querySelector('[data-confirm="1"]')?.focus();
    });
  },

  toast(message, type = 'success') {
    if (typeof app !== 'undefined' && app.showToast) app.showToast(message, type);
    else if (typeof showToast === 'function') showToast(message, type);
    else console.log(`[${type}]`, message);
  }
};


/* ===== js/analise/view-dashboard.js ===== */
// =====================================================
// ZDVAL — /analise · view Minhas Partidas
//
// A porta de entrada da análise: a lista das VODs do time, agrupada por dia
// de treino. Cada bloco é uma sessão ("terça, 4 mapas, 3V 1D") e cada linha
// é um mapa, com o que decide conversa de review: resultado, saldo por lado
// e pistols. Em cima, o resumo do período filtrado.
//
// Escopo padrão é treino: scrim e campeonato têm peso diferente, e misturar
// os dois distorce o winrate por mapa.
// =====================================================

window.AnaliseViewDashboard = {
  _scope: 'treino',
  _period: '30',
  _map: '',
  _from: '',
  _to: '',

  PERIODS: [
    { id: '7',   label: '7 dias' },
    { id: '30',  label: '30 dias' },
    { id: '90',  label: '3 meses' },
    { id: 'all', label: 'Tudo' }
  ],

  SCOPES: [
    { id: 'treino',     label: 'Treino' },
    { id: 'campeonato', label: 'Campeonato' },
    { id: 'all',        label: 'Tudo' }
  ],

  async mount(host) {
    this._all = (await AnaliseStore.get('matches')) || [];

    if (!this._all.length) {
      host.innerHTML = this._empty();
      host.querySelector('#anEmptyImport')?.addEventListener('click', () => AnaliseDrawerUpload.open());
      host.querySelector('#anEmptyLogin')?.addEventListener('click', () => {
        if (typeof auth !== 'undefined' && auth?.openAuth) auth.openAuth('login');
      });
      return;
    }

    this._host = host;
    this._paint();
  },

  // ── Render ───────────────────────────────────────────

  _paint() {
    const host = this._host;
    const matches = this._filtered();

    host.innerHTML = `
      <div class="an-view-head">
        <div>
          <h2>Minhas Partidas</h2>
          <p>As VODs do time, agrupadas por dia de treino.</p>
        </div>
        ${AnaliseShell.headActions()}
      </div>

      <div class="an-toolbar">
        <div class="an-seg" id="anScope" role="group" aria-label="Tipo de partida">
          ${this.SCOPES.map(s => `
            <button type="button" data-scope="${s.id}" class="${s.id === this._scope ? 'is-active' : ''}">${s.label}</button>
          `).join('')}
        </div>

        <div class="an-seg" id="anPeriod" role="group" aria-label="Período">
          ${this.PERIODS.map(p => `
            <button type="button" data-period="${p.id}" class="${p.id === this._period ? 'is-active' : ''}">${p.label}</button>
          `).join('')}
        </div>

        <span class="an-toolbar-div" aria-hidden="true"></span>

        <label class="an-inline-field">
          <span>Mapa</span>
          <select class="an-select" id="anFilterMap">
            <option value="">Todos</option>
            ${AnaliseReport.mapOptions(this._all).map(m => `
              <option value="${AnaliseFormat.escape(m)}"${m === this._map ? ' selected' : ''}>${AnaliseFormat.escape(m)}</option>
            `).join('')}
          </select>
        </label>

        <label class="an-inline-field">
          <span>De</span>
          <input type="date" class="an-input" id="anFilterFrom" value="${this._from}">
        </label>

        <label class="an-inline-field">
          <span>Até</span>
          <input type="date" class="an-input" id="anFilterTo" value="${this._to}">
        </label>

        ${(this._map || this._from || this._to) ? `
          <button type="button" class="an-btn an-btn-sm" id="anFilterClear">
            <i class="fas fa-xmark"></i> Limpar
          </button>
        ` : ''}
      </div>

      ${this._summary(matches)}
      ${matches.length ? this._sessions(matches) : AnaliseShell.emptyPeriod()}
    `;

    this._bind(host);
  },

  /** Resumo do recorte: o que o coach lê antes de abrir qualquer partida. */
  _summary(matches) {
    const f = AnaliseFormat;
    const s = AnaliseReport.summarize(matches);

    if (!matches.length) return '';

    const cards = [
      {
        label: 'Mapas jogados',
        value: s.total,
        sub: `${s.wins}V · ${s.losses}D${s.draws ? ` · ${s.draws}E` : ''}`
      },
      {
        label: 'Win rate',
        value: `${f.fmtNum(s.winRate, 0)}%`,
        sub: s.winRate >= 50 ? 'acima da linha' : 'abaixo da linha',
        tone: s.winRate >= 50 ? 'ok' : 'bad'
      },
      {
        label: 'Ataque',
        value: `${f.fmtNum(s.atkWinRate, 0)}%`,
        sub: `${s.atkWon}–${s.atkLost} rounds`,
        tone: this._sideTone(s.atkWinRate)
      },
      {
        label: 'Defesa',
        value: `${f.fmtNum(s.defWinRate, 0)}%`,
        sub: `${s.defWon}–${s.defLost} rounds`,
        tone: this._sideTone(s.defWinRate)
      },
      {
        label: 'Pistols',
        value: `${f.fmtNum(s.pistolRate, 0)}%`,
        sub: `${s.pistolWon} de ${s.pistolTotal}`,
        tone: this._sideTone(s.pistolRate)
      }
    ];

    return `
      <div class="an-kpis">
        ${cards.map(c => `
          <div class="an-kpi${c.tone ? ' is-' + c.tone : ''}">
            <span class="an-kpi-label">${c.label}</span>
            <strong class="an-kpi-value">${c.value}</strong>
            <span class="an-kpi-sub">${c.sub}</span>
          </div>
        `).join('')}
      </div>`;
  },

  _sideTone(rate) {
    if (rate >= 55) return 'ok';
    if (rate < 45) return 'bad';
    return '';
  },

  /** Uma sessão por dia: é assim que o time treina e assim que revisa. */
  _sessions(matches) {
    const groups = AnaliseReport.groupByDay(matches);

    return `
      <div class="an-sessions">
        ${groups.map(g => `
          <section class="an-session">
            <header class="an-session-head">
              <div class="an-session-date">
                <strong>${AnaliseFormat.escape(g.label)}</strong>
                <span>${g.matches.length} ${g.matches.length === 1 ? 'mapa' : 'mapas'}</span>
              </div>
              <div class="an-session-score">
                <span class="an-session-record">${g.wins}V · ${g.losses}D</span>
                <span class="an-session-bar" aria-hidden="true">
                  <span style="width:${g.matches.length ? (g.wins / g.matches.length) * 100 : 0}%"></span>
                </span>
              </div>
            </header>
            <div class="an-session-list">
              ${this._columnsHead()}
              ${g.matches.map(m => this._row(m)).join('')}
            </div>
          </section>
        `).join('')}
      </div>`;
  },

  /**
   * Rótulo de cada coluna. A linha da partida virou tabela: sem o cabeçalho,
   * "12–0" e "7–5" soltos não dizem qual é ataque e qual é defesa.
   */
  _columnsHead() {
    const cols = ['Mapa', 'Resultado', 'Placar', 'Ataque', 'Defesa', 'Pist. ATK', 'Pist. DEF', 'VOD', 'Imagem', 'Hora', 'Data', ''];
    return `
      <div class="an-match-head" aria-hidden="true">
        ${cols.map(c => `<span>${c}</span>`).join('')}
      </div>`;
  },

  _row(m) {
    const f = AnaliseFormat;
    const r = AnaliseReport.readMatch(m);
    const resultCls = r.result === 'win' ? 'is-win' : r.result === 'loss' ? 'is-loss' : 'is-draw';
    const pistol = (side) => {
      const p = r.pistols.find(x => x.side === side);
      return `<span class="an-pistol ${p.state}">${p.state === 'is-won' ? 'V' : p.state === 'is-lost' ? 'D' : '—'}</span>`;
    };

    return `
      <article class="an-match ${resultCls}" data-match-item="${f.escape(m.id)}">
        <div class="an-match-row" data-match="${f.escape(m.id)}" role="button" tabindex="0"
             aria-expanded="false" aria-controls="anPanel${f.escape(m.id)}"
             aria-label="${f.escape(m.map)} ${m.score_team}–${m.score_opponent}">
          <div class="an-match-map">
            <span class="an-match-map-img" style="background-image:url('${f.getMapImage(m.map)}')" aria-hidden="true"></span>
            <div class="an-match-map-text">
              <strong>${f.escape(m.map || '—')}</strong>
              <span>${f.escape(r.typeLabel)}</span>
            </div>
          </div>

          <span class="${f.resultChipClass(m.result)}">${f.resultLabel(m.result)}</span>

          <div class="an-match-score">
            <strong>${m.score_team}</strong><span>–</span><strong>${m.score_opponent}</strong>
          </div>

          <span class="an-side-val is-atk" title="Rounds ganhos no ataque">
            <i class="fas fa-crosshairs" aria-hidden="true"></i>${r.atkWon}–${r.atkLost}
          </span>
          <span class="an-side-val is-def" title="Rounds ganhos na defesa">
            <i class="fas fa-shield-halved" aria-hidden="true"></i>${r.defWon}–${r.defLost}
          </span>

          ${pistol('ATK')}
          ${pistol('DEF')}

          ${m.vod_url ? `
            <button type="button" class="an-match-media-btn" data-vod="${f.escape(m.vod_url)}"
                    data-title="${f.escape(m.map)} — VOD" title="Assistir a VOD">
              <i class="fas fa-circle-play" aria-hidden="true"></i>
            </button>` : '<span class="an-match-cell is-empty">—</span>'}

          ${m.screenshot_url ? `
            <button type="button" class="an-match-shot" data-shot="${f.escape(m.screenshot_url)}"
                    data-title="${f.escape(m.map)} — scoreboard" title="Ver o scoreboard"
                    style="background-image:url('${f.escape(m.screenshot_url)}')">
              <span class="an-sr-only">Ver o scoreboard</span>
            </button>` : '<span class="an-match-cell is-empty">—</span>'}

          <span class="an-match-cell">${f.escape(this._hora(m))}</span>
          <span class="an-match-cell">${f.escape(f.fmtDate(m.match_date))}</span>

          <div class="an-match-tail">
            <button type="button" class="an-match-media-btn" data-detail="${f.escape(m.id)}"
                    title="Editar partida"><i class="fas fa-pen" aria-hidden="true"></i></button>
            <i class="fas fa-chevron-down an-match-arrow" aria-hidden="true"></i>
          </div>
        </div>

        <div class="an-match-panel" id="anPanel${f.escape(m.id)}" hidden></div>
      </article>`;
  },

  _hora(m) {
    const raw = String(m.match_time || '').slice(0, 5);
    return /^\d{2}:\d{2}$/.test(raw) ? raw : '—';
  },

  // ── Dropdown da partida ──────────────────────────────

  /**
   * O detalhe abre na própria lista, não num drawer: ver o scoreboard de uma
   * partida quase sempre leva a comparar com a de cima. Os jogadores só são
   * buscados quando a linha abre pela primeira vez.
   */
  async _toggle(row) {
    const item = row.closest('.an-match');
    const panel = item?.querySelector('.an-match-panel');
    if (!panel) return;

    const abrindo = panel.hidden;
    panel.hidden = !abrindo;
    item.classList.toggle('is-open', abrindo);
    row.setAttribute('aria-expanded', String(abrindo));
    if (!abrindo || panel.dataset.loaded) return;

    panel.innerHTML = '<div class="an-loading"><i class="fas fa-spinner fa-spin"></i> Carregando…</div>';
    try {
      const data = await AnaliseStore.getMatch(row.dataset.match);
      const match = data?.match;
      if (!match) throw new Error(api?.token ? 'Partida não encontrada' : 'Entre na sua conta para ver o detalhe.');

      await AnaliseFormat.ensureAgentIconIndex().catch(() => {});
      panel.innerHTML = this._panel(match, data.players || []);
      panel.dataset.loaded = '1';
    } catch (err) {
      panel.innerHTML = `<div class="an-empty" style="padding:24px">
        <i class="fas fa-triangle-exclamation"></i>
        <p>${AnaliseFormat.escape(err.message)}</p></div>`;
    }
  },

  /**
   * Só o scoreboard, e os dois times pintados pelo resultado da partida: o
   * nosso lado leva a cor do placar (verde na vitória, vermelho na derrota) e
   * o adversário fica com a oposta. É a mesma leitura da linha fechada.
   */
  _panel(match, players) {
    const f = AnaliseFormat;
    const res = String(match?.result || '').toLowerCase();
    const nosso = res === 'win' ? 'is-ok' : res === 'loss' ? 'is-bad' : '';
    const deles = res === 'win' ? 'is-bad' : res === 'loss' ? 'is-ok' : '';

    return this._scoreboardCard('Nosso time', players.filter(p => p.is_our_team), nosso)
         + this._scoreboardCard(f.opponentTag(players), players.filter(p => !p.is_our_team), deles);
  },

  /** `tone` é 'is-ok' | 'is-bad' | '': a cor do resultado, não a do time. */
  _scoreboardCard(title, players, tone = '') {
    const f = AnaliseFormat;
    if (!players.length) return '';

    const rows = [...players]
      .sort((a, b) => (Number(b.acs) || 0) - (Number(a.acs) || 0))
      .map(p => `
        <tr>
          <td>
            <span class="an-cell-lead">
              <img class="an-agent-icon" src="${f.getAgentIcon(p.agent)}" alt="${f.escape(p.agent)}"
                   title="${f.escape(p.agent)}" loading="lazy" onerror="this.src='/img/default-agent.png'">
              ${f.escape(p.player_name)}
            </span>
          </td>
          <td>${f.fmtNum(p.acs, 0)}</td>
          <td>${p.kills}/${p.deaths}/${p.assists}</td>
          <td>${f.fmtNum(p.first_bloods, 0)}</td>
          <td>${f.fmtNum(p.plants, 0)}/${f.fmtNum(p.defuses, 0)}</td>
          <td>${f.fmtNum(p.econ, 0)}</td>
        </tr>`).join('');

    return `
      <div class="an-card an-sb-card ${tone}">
        <div class="an-card-head">
          <span class="an-card-title">${f.escape(title || 'Time')}</span>
        </div>
        <div class="an-card-body" style="padding:0 14px 10px">
          <table class="an-sb">
            <thead>
              <tr>
                <th>Jogador</th><th>ACS</th><th>K/D/A</th>
                <th title="First kills">FK</th><th title="Plants / defuses">PL/DF</th><th>Econ</th>
              </tr>
            </thead>
            <tbody>${rows}</tbody>
          </table>
        </div>
      </div>`;
  },

  /**
   * Vídeo e imagem abrem no modal central: em painel lateral de 560px o
   * scoreboard fica ilegível e o player, minúsculo.
   */
  _openMedia({ title, vod, shot }) {
    const f = AnaliseFormat;
    const body = AnaliseShell.openDrawer({ title, width: 960, centered: true });
    if (!body) return;

    if (shot) {
      body.innerHTML = `<img class="an-media-full" src="${f.escape(shot)}" alt="${f.escape(title)}">`;
      return;
    }

    const embed = this._embedUrl(vod);
    body.innerHTML = embed
      ? `<iframe class="an-media-frame" src="${f.escape(embed)}" title="${f.escape(title)}"
                 allow="accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture"
                 allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>`
      : `<div class="an-empty" style="padding:32px">
           <i class="fas fa-link"></i>
           <p>Esta VOD não é do YouTube, então abre em outra aba.</p>
           <a class="an-btn an-btn-primary" href="${f.escape(vod)}" target="_blank" rel="noopener noreferrer">
             <i class="fas fa-arrow-up-right-from-square"></i> Abrir VOD
           </a>
         </div>`;
  },

  /** Só YouTube toca embutido; o resto vira link. */
  _embedUrl(url) {
    try {
      const u = new URL(url);
      const host = u.hostname.replace(/^www\./, '');
      let id = '';
      if (host === 'youtu.be') id = u.pathname.slice(1);
      else if (host.endsWith('youtube.com') || host.endsWith('youtube-nocookie.com')) {
        id = u.searchParams.get('v') || u.pathname.split('/').filter(Boolean).pop() || '';
      }
      return /^[\w-]{6,}$/.test(id) ? `https://www.youtube-nocookie.com/embed/${id}` : '';
    } catch (_) {
      return '';
    }
  },

  _empty() {
    // Sem sessão a lista também vem vazia — mas por outro motivo. Convidar a
    // importar quem nem está logado leva direto a um 401.
    if (typeof api === 'undefined' || !api?.token) {
      return `
        <div class="an-empty">
          <i class="fas fa-lock"></i>
          <h3>Entre na sua conta</h3>
          <p>As VODs e as estatísticas ficam guardadas na conta do time.</p>
          <button type="button" class="an-btn an-btn-primary" id="anEmptyLogin">
            <i class="fas fa-right-to-bracket"></i> Entrar
          </button>
        </div>`;
    }

    return `
      <div class="an-empty">
        <i class="fas fa-chart-simple"></i>
        <h3>Nenhuma VOD importada</h3>
        <p>Suba os screenshots do scoreboard e a análise se monta sozinha:
           sessões, mapas, lados, pistols e jogadores.</p>
        <button type="button" class="an-btn an-btn-primary" id="anEmptyImport">
          <i class="fas fa-plus"></i> Nova VOD
        </button>
      </div>`;
  },

  // ── Dados ────────────────────────────────────────────

  _filtered() {
    return AnaliseReport.filter(this._all, {
      scope: this._scope,
      period: this._period,
      map: this._map,
      from: this._from,
      to: this._to
    });
  },

  // ── Eventos ──────────────────────────────────────────

  _bind(host) {
    host.querySelector('#anScope')?.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-scope]');
      if (!btn || btn.dataset.scope === this._scope) return;
      this._scope = btn.dataset.scope;
      this._paint();
    });

    host.querySelector('#anPeriod')?.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-period]');
      if (!btn || btn.dataset.period === this._period) return;
      this._period = btn.dataset.period;
      this._paint();
    });

    host.querySelector('#anFilterMap')?.addEventListener('change', (e) => {
      this._map = e.target.value;
      this._paint();
    });

    // Intervalo explícito: ao usar "de/até", o atalho de período sai do caminho
    // (quem escolheu a janela não quer que "30 dias" corte a ponta).
    host.querySelector('#anFilterFrom')?.addEventListener('change', (e) => {
      this._from = e.target.value;
      this._period = 'all';
      this._paint();
    });

    host.querySelector('#anFilterTo')?.addEventListener('change', (e) => {
      this._to = e.target.value;
      this._period = 'all';
      this._paint();
    });

    host.querySelector('#anFilterClear')?.addEventListener('click', () => {
      this._map = '';
      this._from = '';
      this._to = '';
      this._period = '30';
      this._paint();
    });


    host.querySelectorAll('.an-match-row[data-match]').forEach(row => {
      row.addEventListener('click', (e) => {
        // VOD, print e edição têm o clique deles: não alternam o dropdown.
        if (e.target.closest('[data-vod], [data-shot], [data-detail]')) return;
        this._toggle(row);
      });
      row.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        this._toggle(row);
      });
    });

    // O conteúdo do painel nasce depois do clique: delegação na lista.
    host.querySelector('.an-sessions')?.addEventListener('click', (e) => {
      const media = e.target.closest('[data-vod], [data-shot]');
      if (media) {
        this._openMedia({
          title: media.dataset.title || 'Partida',
          vod: media.dataset.vod,
          shot: media.dataset.shot
        });
        return;
      }

      const editar = e.target.closest('[data-detail]');
      if (editar) AnaliseDrawerMatch.openEdit(editar.dataset.detail);
    });
  }
};


/* ===== js/analise/view-maps.js ===== */
// =====================================================
// ZDVAL — /analise · view Mapas
//
// O relatório que decide veto e o que treinar: por mapa, winrate total e por
// lado, saldo de rounds e aproveitamento de pistol — com o volume à vista,
// porque conclusão tirada de dois jogos é chute.
//
// Toda a conta vive em AnaliseReport; aqui só desenha.
// =====================================================

window.AnaliseViewMaps = {
  _scope: 'treino',
  _period: '90',

  async mount(host) {
    this._all = (await AnaliseStore.get('matches')) || [];
    this._host = host;

    // Sem sessão a lista vem vazia por falta de acesso, não por falta de dado.
    const temSessao = typeof api !== 'undefined' && Boolean(api?.token);

    if (!this._all.length) {
      host.innerHTML = `
        <div class="an-empty">
          <i class="${temSessao ? 'fas fa-map' : 'fas fa-lock'}"></i>
          <h3>${temSessao ? 'Nenhuma VOD importada' : 'Entre na sua conta'}</h3>
          <p>${temSessao
            ? 'Importe VODs para ver a força do time mapa a mapa.'
            : 'As VODs e as estatísticas ficam guardadas na conta do time.'}</p>
        </div>`;
      return;
    }

    await AnaliseFormat.ensureMapImageIndex().catch(() => {});
    this._paint();
  },

  _paint() {
    const host = this._host;
    const matches = AnaliseReport.filter(this._all, { scope: this._scope, period: this._period });
    const rows = AnaliseReport.byMap(matches);

    host.innerHTML = `
      <div class="an-view-head">
        <div>
          <h2>Mapas</h2>
          <p>Onde o time ganha, de que lado ganha e o que isso manda vetar.</p>
        </div>
        ${AnaliseShell.headActions(`
          <button type="button" class="an-btn an-btn-sm" id="anMapsPng">
            <i class="fas fa-image"></i> Salvar imagem
          </button>`)}
      </div>

      <div class="an-toolbar">
        <div class="an-seg" id="anMapsScope" role="group" aria-label="Tipo de partida">
          ${AnaliseViewDashboard.SCOPES.map(s => `
            <button type="button" data-scope="${s.id}" class="${s.id === this._scope ? 'is-active' : ''}">${s.label}</button>
          `).join('')}
        </div>
        <div class="an-seg" id="anMapsPeriod" role="group" aria-label="Período">
          ${AnaliseViewDashboard.PERIODS.map(p => `
            <button type="button" data-period="${p.id}" class="${p.id === this._period ? 'is-active' : ''}">${p.label}</button>
          `).join('')}
        </div>
      </div>

      ${rows.length ? this._picks(rows) : ''}

      <div class="an-card" id="anMapsCard">
        <div class="an-card-head">
          <span class="an-card-title"><i class="fas fa-map"></i> Mapa a mapa</span>
          <span class="an-mute" style="font-size:12px">
            ${matches.length} ${matches.length === 1 ? 'partida' : 'partidas'} no recorte
          </span>
        </div>
        <div class="an-card-body" style="padding:0">
          ${rows.length ? this._table(rows) : AnaliseShell.emptyPeriod({ padded: true })}
        </div>
      </div>`;

    this._bind(host);
  },

  /**
   * A conclusão em cima da tabela: os dois mapas mais fortes e os dois mais
   * fracos com volume suficiente. É o que se leva para a mesa de veto.
   */
  _picks(rows) {
    const confiaveis = rows.filter(r => r.reliable);
    if (confiaveis.length < 2) {
      return `
        <div class="an-note">
          <i class="fas fa-circle-info" aria-hidden="true"></i>
          <span>Ainda faltam jogos para recomendar pick e veto: são precisos ao menos
                ${AnaliseReport.MIN_SAMPLE} jogos no mesmo mapa.</span>
        </div>`;
    }

    const ordenados = [...confiaveis].sort((a, b) => b.winRate - a.winRate);
    // Com 2 ou 3 mapas confiáveis, pegar 2 de cada ponta repetia o do meio nas
    // duas listas: o mesmo mapa aparecia como pick e como veto.
    const quantos = Math.min(2, Math.floor(ordenados.length / 2));
    const picks = ordenados.slice(0, quantos);
    const vetos = ordenados.slice(-quantos).reverse();

    const bloco = (titulo, icone, lista, tone) => `
      <div class="an-pick-card is-${tone}">
        <span class="an-pick-title"><i class="${icone}" aria-hidden="true"></i> ${titulo}</span>
        <div class="an-pick-list">
          ${lista.map(r => `
            <div class="an-pick-item">
              <span class="an-pick-map">${AnaliseFormat.escape(r.map)}</span>
              <span class="an-pick-rate">${Math.round(r.winRate)}%</span>
              <span class="an-pick-vol">${r.played} ${r.played === 1 ? 'jogo' : 'jogos'}</span>
            </div>
          `).join('')}
        </div>
      </div>`;

    return `
      <div class="an-picks">
        ${bloco('Bons para pick', 'fas fa-thumbs-up', picks, 'ok')}
        ${bloco('Candidatos a veto', 'fas fa-ban', vetos, 'bad')}
      </div>`;
  },

  _table(rows) {
    return `
      <div class="an-table-wrap">
        <table class="an-table an-table-maps">
          <thead>
            <tr>
              <th>Mapa</th>
              <th class="an-num" title="Partidas no recorte">Jogos</th>
              <th class="an-num">Win rate</th>
              <th>Ataque × Defesa</th>
              <th class="an-num" title="Rounds ganhos menos perdidos">Saldo</th>
              <th class="an-num" title="Pistols ganhos de pistols jogados">Pistol</th>
            </tr>
          </thead>
          <tbody>
            ${rows.map(r => this._row(r)).join('')}
          </tbody>
        </table>
      </div>`;
  },

  _row(r) {
    const f = AnaliseFormat;
    const wrTone = r.winRate >= 60 ? 'is-ok' : r.winRate <= 35 ? 'is-bad' : '';
    const saldo = r.roundDiff > 0 ? `+${r.roundDiff}` : String(r.roundDiff);

    return `
      <tr class="${r.reliable ? '' : 'is-thin'}">
        <td>
          <div class="an-map-cell">
            <span class="an-map-thumb" style="background-image:url('${f.getMapImage(r.map)}')" aria-hidden="true"></span>
            <div class="an-map-cell-text">
              <strong>${f.escape(r.map)}</strong>
              <span class="an-mute">${AnaliseReport.readMapRow(r)}</span>
            </div>
          </div>
        </td>
        <td class="an-num">${r.played}</td>
        <td class="an-num ${wrTone}"><strong>${Math.round(r.winRate)}%</strong><span class="an-mute"> ${r.wins}V·${r.losses}D</span></td>
        <td>${this._sideBar(r)}</td>
        <td class="an-num ${r.roundDiff > 0 ? 'is-ok' : r.roundDiff < 0 ? 'is-bad' : ''}">${saldo}</td>
        <td class="an-num">${r.pistolTotal ? `${Math.round(r.pistolRate)}%<span class="an-mute"> ${r.pistolWon}/${r.pistolTotal}</span>` : '<span class="an-mute">—</span>'}</td>
      </tr>`;
  },

  /**
   * Barra que abre do centro: ataque para a esquerda, defesa para a direita.
   * Lado curto é lado fraco — dá para ler a tabela inteira sem parar em número.
   */
  _sideBar(r) {
    const atk = Math.round(r.atkWinRate);
    const def = Math.round(r.defWinRate);

    return `
      <div class="an-sidebar-cell" title="Ataque ${atk}% · Defesa ${def}%">
        <span class="an-sidebar-num">${atk}%</span>
        <span class="an-sidebar-track">
          <span class="an-sidebar-atk" style="width:${atk / 2}%"></span>
          <span class="an-sidebar-def" style="width:${def / 2}%"></span>
        </span>
        <span class="an-sidebar-num">${def}%</span>
      </div>`;
  },

  _bind(host) {
    host.querySelector('#anMapsScope')?.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-scope]');
      if (!btn || btn.dataset.scope === this._scope) return;
      this._scope = btn.dataset.scope;
      this._paint();
    });

    host.querySelector('#anMapsPeriod')?.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-period]');
      if (!btn || btn.dataset.period === this._period) return;
      this._period = btn.dataset.period;
      this._paint();
    });

    host.querySelector('#anMapsPng')?.addEventListener('click', () => this._exportImage(host));
  },

  /** Captura da tabela para colar no Discord. Vivia em Configurações. */
  async _exportImage(host) {
    if (typeof html2canvas === 'undefined') {
      AnaliseShell.toast('A biblioteca de captura não carregou', 'error');
      return;
    }
    const target = host.querySelector('#anMapsCard');
    if (!target) {
      AnaliseShell.toast('Nada para exportar ainda', 'error');
      return;
    }

    try {
      const canvas = await html2canvas(target, {
        backgroundColor: '#1a1a1d',
        scale: 2,
        useCORS: true,
        logging: false
      });
      const link = document.createElement('a');
      link.download = `zdval-mapas-${new Date().toISOString().slice(0, 10)}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
      AnaliseShell.toast('Imagem salva', 'success');
    } catch (_) {
      AnaliseShell.toast('Não foi possível gerar a imagem', 'error');
    }
  }
};


/* ===== js/analise/view-players.js ===== */
// =====================================================
// ZDVAL — /analise · view Jogadores
// Tabela ordenável do elenco, detalhe por mapa/agente ao expandir, e
// comparação direta entre dois jogadores no topo.
// =====================================================

window.AnaliseViewPlayers = {
  _sort: { key: 'avg_acs', dir: 'desc' },
  _players: [],
  // 'time' mostra a média do elenco somada; 'individual' abre por jogador.
  // O mesmo dado, nas duas leituras que o coach pede.
  _view: 'time',

  COLUMNS: [
    { key: 'player_name', label: 'Jogador', sortable: true,  type: 'text' },
    { key: 'role',        label: 'Função',  sortable: true,  type: 'text' },
    { key: 'matches',     label: 'Partidas',sortable: true,  type: 'num', digits: 0 },
    { key: 'avg_acs',     label: 'ACS',     sortable: true,  type: 'num', digits: 0 },
    { key: 'kda',         label: 'K/D/A',   sortable: false, type: 'custom' },
    { key: 'kd_ratio',    label: 'K/D',     sortable: true,  type: 'num', digits: 2 },
    { key: 'avg_fb',      label: 'FK',      sortable: true,  type: 'num', digits: 1, title: 'First kills por partida' },
    { key: 'plants',      label: 'PL/DF',   sortable: false, type: 'custom', title: 'Plants / defuses por partida' },
    { key: 'avg_econ',    label: 'Econ',    sortable: true,  type: 'num', digits: 0 },
    { key: 'top_agents',  label: 'Agentes', sortable: false, type: 'custom' }
  ],

  async mount(host) {
    const players = await AnaliseStore.get('players');
    this._players = players || [];

    if (!this._players.length) {
      host.innerHTML = `
        <div class="an-view-head">
          <div>
            <h2>Jogadores</h2>
            <p>Cadastre o elenco: o vínculo entre o nick do scoreboard e o jogador é automático.</p>
          </div>
          ${AnaliseShell.headActions()}
        </div>
        <div id="anRosterSection"></div>`;
      await AnaliseViewRoster.mount(host.querySelector('#anRosterSection'), { embedded: true });
      return;
    }

    await AnaliseFormat.ensureAgentIconIndex();

    host.innerHTML = `
      <div class="an-view-head">
        <div>
          <h2>Jogadores</h2>
          <p>Quem é do time e como cada um vem jogando. Clique numa linha para abrir o detalhe por mapa e agente.</p>
        </div>
        ${AnaliseShell.headActions(`
          <div class="an-seg" id="anStatsView" role="group" aria-label="Visão das estatísticas">
            <button type="button" data-view="time" class="${this._view === 'time' ? 'is-active' : ''}">Time</button>
            <button type="button" data-view="individual" class="${this._view === 'individual' ? 'is-active' : ''}">Individual</button>
          </div>
          <button type="button" class="an-btn an-btn-sm" id="anCompareToggle">
            <i class="fas fa-code-compare"></i> Comparar dois jogadores
          </button>`)}
      </div>

      ${this._teamCard()}

      <div class="an-card" id="anCompareCard" hidden style="margin-bottom:16px">
        <div class="an-card-head">
          <span class="an-card-title"><i class="fas fa-code-compare"></i> Comparação</span>
        </div>
        <div class="an-card-body">
          <div class="an-filters">
            <select class="an-select" id="anCmpA" aria-label="Primeiro jogador">
              ${this._options(this._players, 0)}
            </select>
            <span class="an-mute">contra</span>
            <select class="an-select" id="anCmpB" aria-label="Segundo jogador">
              ${this._options(this._players, 1)}
            </select>
          </div>
          <div id="anCompareOut"></div>
        </div>
      </div>

      <div id="anRosterSection"></div>

      <div class="an-card">
        <div class="an-card-head">
          <span class="an-card-title"><i class="fas fa-chart-simple"></i> Desempenho</span>
          <span class="an-mute" style="font-size:12px">médias por partida</span>
        </div>
        <div class="an-table-wrap">
          <table class="an-table" id="anPlayersTable">
            <thead><tr>${this._headers()}<th></th></tr></thead>
            <tbody>${this._rows()}</tbody>
          </table>
        </div>
      </div>`;

    // Elenco e estatísticas eram duas telas com a mesma cara para o usuário.
    // O cadastro (fonte do vínculo nick → jogador) passa a viver aqui, no topo.
    await AnaliseViewRoster.mount(host.querySelector('#anRosterSection'), { embedded: true });

    this._bind(host);
  },

  /**
   * Visão do time: a soma do elenco em uma linha. Média de médias distorce
   * quem jogou menos, então o peso é o número de partidas de cada um.
   */
  _teamCard() {
    if (this._view !== 'time') return '';

    const f = AnaliseFormat;
    const list = this._players.filter(p => Number(p.matches) > 0);
    if (!list.length) return '';

    const peso = list.reduce((acc, p) => acc + Number(p.matches || 0), 0);
    const media = (campo) => peso
      ? list.reduce((acc, p) => acc + (Number(p[campo]) || 0) * Number(p.matches || 0), 0) / peso
      : 0;

    const kills = media('avg_kills');
    const deaths = media('avg_deaths');

    const itens = [
      { label: 'Jogadores', value: list.length, sub: `${peso} participações` },
      { label: 'ACS do time', value: f.fmtNum(media('avg_acs'), 0), sub: 'média ponderada' },
      { label: 'K/D do time', value: f.fmtNum(deaths ? kills / deaths : 0, 2), sub: `${f.fmtNum(kills, 1)} / ${f.fmtNum(deaths, 1)}` },
      { label: 'First kills', value: f.fmtNum(media('avg_fb'), 1), sub: 'por jogador/partida' },
      { label: 'Econ', value: f.fmtNum(media('avg_econ'), 0), sub: 'rating do scoreboard' }
    ];

    return `
      <div class="an-kpis">
        ${itens.map(i => `
          <div class="an-kpi">
            <span class="an-kpi-label">${i.label}</span>
            <strong class="an-kpi-value">${i.value}</strong>
            <span class="an-kpi-sub">${i.sub}</span>
          </div>
        `).join('')}
      </div>`;
  },

  _options(players, selectedIndex) {
    return players.map((p, i) => {
      const name = AnaliseFormat.escape(p.player_name || p.nickname);
      return `<option value="${name}"${i === selectedIndex ? ' selected' : ''}>${name}</option>`;
    }).join('');
  },

  _headers() {
    return this.COLUMNS.map(c => {
      const sorted = this._sort.key === c.key;
      const aria = sorted ? (this._sort.dir === 'desc' ? 'descending' : 'ascending') : 'none';
      const cls = c.sortable ? ' class="an-sortable"' : '';
      const title = c.title ? ` title="${c.title}"` : '';
      return `<th${cls}${title} data-sort="${c.sortable ? c.key : ''}" aria-sort="${aria}">${c.label}</th>`;
    }).join('');
  },

  _rows() {
    const f = AnaliseFormat;
    const sorted = this._sorted();

    return sorted.map(p => {
      const name = f.escape(p.player_name || p.nickname);
      const agents = (p.top_agents || '')
        .split(',')
        .map(a => a.trim())
        .filter(Boolean)
        .slice(0, 3)
        .map(a => `<img class="an-agent-icon" src="${f.getAgentIcon(a)}" alt="${f.escape(a)}"
                        title="${f.escape(a)}" loading="lazy" onerror="this.src='/img/default-agent.png'">`)
        .join('');

      return `
        <tr class="an-row" data-player="${name}" tabindex="0" role="button" aria-expanded="false">
          <td><span class="an-cell-lead">${name}</span></td>
          <td class="an-mute">${f.escape(f.roleLabel(p.role) || '—')}</td>
          <td class="an-n">${f.fmtNum(p.matches, 0)}</td>
          <td class="an-n">${f.fmtNum(p.avg_acs, 0)}</td>
          <td class="an-n">${f.fmtNum(p.avg_kills, 1)}/${f.fmtNum(p.avg_deaths, 1)}/${f.fmtNum(p.avg_assists, 1)}</td>
          <td class="an-n ${Number(p.kd_ratio) >= 1 ? 'an-pos' : 'an-neg'}">${f.fmtNum(p.kd_ratio, 2)}</td>
          <td class="an-n">${f.fmtNum(p.avg_fb, 1)}</td>
          <td class="an-n">${f.fmtNum(p.avg_plants, 1)}/${f.fmtNum(p.avg_defuses, 1)}</td>
          <td class="an-n">${f.fmtNum(p.avg_econ, 0)}</td>
          <td><span class="an-agent-stack">${agents || '<span class="an-mute">—</span>'}</span></td>
          <td><i class="fas fa-chevron-down an-mute" style="font-size:11px"></i></td>
        </tr>
        <tr class="an-detail-row" data-detail="${name}" hidden><td colspan="11"></td></tr>`;
    }).join('');
  },

  _sorted() {
    const { key, dir } = this._sort;
    const mult = dir === 'desc' ? -1 : 1;
    return [...this._players].sort((a, b) => {
      const va = a[key];
      const vb = b[key];
      const na = Number(va);
      const nb = Number(vb);
      if (!Number.isNaN(na) && !Number.isNaN(nb)) return (na - nb) * mult;
      return String(va ?? '').localeCompare(String(vb ?? ''), 'pt-BR') * mult;
    });
  },

  // ── Comportamento ────────────────────────────────────

  _bind(host) {
    host.querySelector('#anStatsView')?.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-view]');
      if (!btn || btn.dataset.view === this._view) return;
      this._view = btn.dataset.view;
      this.mount(host);
    });

    host.querySelector('#anCompareToggle')?.addEventListener('click', () => {
      const card = host.querySelector('#anCompareCard');
      card.hidden = !card.hidden;
      if (!card.hidden) this._compare(host);
    });

    ['#anCmpA', '#anCmpB'].forEach(sel => {
      host.querySelector(sel)?.addEventListener('change', () => this._compare(host));
    });

    host.querySelector('#anPlayersTable thead')?.addEventListener('click', (e) => {
      const th = e.target.closest('th[data-sort]');
      const key = th?.dataset.sort;
      if (!key) return;
      this._sort = {
        key,
        dir: this._sort.key === key && this._sort.dir === 'desc' ? 'asc' : 'desc'
      };
      host.querySelector('#anPlayersTable thead tr').innerHTML = this._headers() + '<th></th>';
      host.querySelector('#anPlayersTable tbody').innerHTML = this._rows();
      this._bindRows(host);
    });

    this._bindRows(host);
  },

  _bindRows(host) {
    host.querySelectorAll('tr.an-row[data-player]').forEach(row => {
      const open = () => this._toggle(host, row);
      row.addEventListener('click', open);
      row.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      });
    });
  },

  async _toggle(host, row) {
    const name = row.dataset.player;
    const detail = host.querySelector(`tr[data-detail="${CSS.escape(name)}"]`);
    if (!detail) return;

    const isOpen = !detail.hidden;

    host.querySelectorAll('tr.an-detail-row').forEach(d => { d.hidden = true; });
    host.querySelectorAll('tr.an-row[data-player]').forEach(r => {
      r.classList.remove('is-open');
      r.setAttribute('aria-expanded', 'false');
      r.querySelector('.fa-chevron-down')?.style.setProperty('transform', '');
    });

    if (isOpen) return;

    detail.hidden = false;
    row.classList.add('is-open');
    row.setAttribute('aria-expanded', 'true');
    row.querySelector('.fa-chevron-down')?.style.setProperty('transform', 'rotate(180deg)');

    const cell = detail.querySelector('td');
    cell.innerHTML = '<div class="an-loading"><i class="fas fa-spinner fa-spin"></i></div>';

    try {
      const data = await AnaliseStore.getPlayerDetail(name);
      await Promise.all([
        AnaliseFormat.ensureAgentIconIndex(),
        AnaliseFormat.ensureMapImageIndex()
      ]);
      cell.innerHTML = this._detail(data);
    } catch (_) {
      cell.innerHTML = '<p class="an-mute" style="padding:12px 0">Não foi possível carregar o detalhe deste jogador.</p>';
    }
  },

  _detail(data) {
    const f = AnaliseFormat;
    const maps = data?.maps || [];
    const agentMaps = data?.agentMaps || [];

    if (!maps.length) {
      return '<p class="an-mute" style="padding:12px 0">Sem dados por mapa para este jogador.</p>';
    }

    const byMap = new Map();
    agentMaps.forEach(am => {
      if (!byMap.has(am.map)) byMap.set(am.map, []);
      byMap.get(am.map).push(am);
    });

    const sections = [...maps]
      .sort((a, b) => Number(b.matches) - Number(a.matches))
      .map(m => {
        const total = Number(m.matches) || 0;
        const wr = f.winRate(m.wins, total);
        const agents = (byMap.get(m.map) || []).map(a => {
          const use = total ? Math.round(Number(a.matches) / total * 100) : 0;
          return `
            <tr>
              <td>
                <span class="an-cell-lead">
                  <img class="an-agent-icon" src="${f.getAgentIcon(a.agent)}" alt=""
                       loading="lazy" onerror="this.src='/img/default-agent.png'">
                  ${f.escape(a.agent)}
                </span>
              </td>
              <td class="an-n">${use}%</td>
              <td class="an-n">${a.matches}</td>
              <td class="an-n">${f.fmtNum(a.avg_acs, 0)}</td>
              <td class="an-n">${f.fmtNum(a.avg_kills, 1)}/${f.fmtNum(a.avg_deaths, 1)}/${f.fmtNum(a.avg_assists, 1)}</td>
              <td class="an-n">${f.fmtNum(a.kd_ratio, 2)}</td>
              <td class="an-n">${f.fmtNum(a.avg_fb, 1)}</td>
              <td class="an-n">${f.fmtNum(a.avg_econ, 0)}</td>
            </tr>`;
        }).join('');

        return `
          <div style="margin:14px 0">
            <div class="an-filters" style="margin-bottom:6px">
              <img class="an-map-thumb" src="${f.getMapImage(m.map)}" alt="" loading="lazy"
                   onerror="this.src='/img/maps/default-preview.jpg'">
              <strong>${f.escape(m.map)}</strong>
              <span class="an-chip">${total} ${total === 1 ? 'partida' : 'partidas'}</span>
              <span class="an-chip ${wr >= 50 ? 'an-chip-win' : 'an-chip-loss'}">${wr}% WR</span>
            </div>
            <div class="an-table-wrap">
              <table class="an-table">
                <thead>
                  <tr>
                    <th>Agente</th><th title="Uso neste mapa">Uso</th><th>Partidas</th>
                    <th>ACS</th><th>K/D/A</th><th>K/D</th><th>FK</th><th>Econ</th>
                  </tr>
                </thead>
                <tbody>${agents || '<tr><td colspan="8" class="an-mute">Sem agentes registrados.</td></tr>'}</tbody>
              </table>
            </div>
          </div>`;
      }).join('');

    return sections;
  },

  _compare(host) {
    const f = AnaliseFormat;
    const out = host.querySelector('#anCompareOut');
    const nameA = host.querySelector('#anCmpA')?.value;
    const nameB = host.querySelector('#anCmpB')?.value;
    if (!out) return;

    const find = (n) => this._players.find(p => (p.player_name || p.nickname) === n);
    const a = find(nameA);
    const b = find(nameB);

    if (!a || !b) {
      out.innerHTML = '<p class="an-mute">Escolha dois jogadores.</p>';
      return;
    }
    if (nameA === nameB) {
      out.innerHTML = '<p class="an-mute">Escolha jogadores diferentes para comparar.</p>';
      return;
    }

    const rows = [
      { label: 'Partidas', key: 'matches',  digits: 0 },
      { label: 'ACS',      key: 'avg_acs',  digits: 0 },
      { label: 'K/D',      key: 'kd_ratio', digits: 2 },
      { label: 'Kills',    key: 'avg_kills',digits: 1 },
      { label: 'Deaths',   key: 'avg_deaths', digits: 1, lowerIsBetter: true },
      { label: 'Assists',  key: 'avg_assists', digits: 1 },
      { label: 'First kills', key: 'avg_fb', digits: 1 },
      { label: 'Econ',     key: 'avg_econ', digits: 0 }
    ].map(r => {
      const va = Number(a[r.key]) || 0;
      const vb = Number(b[r.key]) || 0;
      const diff = va - vb;
      const better = r.lowerIsBetter ? diff < 0 : diff > 0;
      const cls = diff === 0 ? 'an-mute' : better ? 'an-pos' : 'an-neg';
      return `
        <tr>
          <td>${r.label}</td>
          <td class="an-n">${f.fmtNum(va, r.digits)}</td>
          <td class="an-n">${f.fmtNum(vb, r.digits)}</td>
          <td class="an-n ${cls}">${diff === 0 ? '—' : f.fmtSigned(diff, r.digits)}</td>
        </tr>`;
    }).join('');

    out.innerHTML = `
      <div class="an-table-wrap">
        <table class="an-table">
          <thead>
            <tr>
              <th></th>
              <th>${f.escape(nameA)}</th>
              <th>${f.escape(nameB)}</th>
              <th>Diferença</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      </div>`;
  }
};


/* ===== js/analise/view-roster.js ===== */
// =====================================================
// ZDVAL — /analise · view Elenco
// Quem é do time. Esta lista é o que liga o nick do scoreboard ao jogador,
// então mexer aqui invalida as estatísticas em cache.
// =====================================================

window.AnaliseViewRoster = {
  async mount(host, options = {}) {
    const roster = await AnaliseStore.get('roster');
    this._roster = roster || [];

    // Embutido dentro de Jogadores: o cabeçalho da view já foi desenhado lá.
    host.innerHTML = `
      ${options.embedded ? '' : `
        <div class="an-view-head">
          <div>
            <h2>Elenco</h2>
            <p>Os jogadores daqui são reconhecidos automaticamente nos screenshots importados.</p>
          </div>
        </div>
      `}

      <div class="an-card" style="margin-bottom:16px">
        <div class="an-card-head">
          <span class="an-card-title"><i class="fab fa-riot-games"></i> Adicionar por Riot ID</span>
          <span class="an-chip">busca automática</span>
        </div>
        <div class="an-card-body">
          <div class="an-filters">
            <input type="text" class="an-input" id="anRosterInput" style="flex:1;max-width:340px"
                   placeholder="prince#zudo" aria-label="Riot ID do jogador">
            <button type="button" class="an-btn an-btn-primary" id="anRosterSearch">
              <i class="fas fa-magnifying-glass"></i> Buscar
            </button>
          </div>
          <div id="anRosterResult"></div>
        </div>
      </div>

      <div class="an-card">
        <div class="an-card-head">
          <span class="an-card-title"><i class="fas fa-users"></i> Elenco atual</span>
          <span class="an-mute" style="font-size:12px">${this._roster.length} ${this._roster.length === 1 ? 'jogador' : 'jogadores'}</span>
        </div>
        <div class="an-card-body" style="padding:0">
          ${this._list()}
        </div>
      </div>`;

    this._bind(host);
  },

  _list() {
    const f = AnaliseFormat;
    if (!this._roster.length) {
      const temSessao = typeof api !== 'undefined' && Boolean(api?.token);
      return `<div class="an-empty" style="padding:44px 24px">
        <i class="${temSessao ? 'fas fa-user-plus' : 'fas fa-lock'}"></i>
        <h3>${temSessao ? 'Elenco vazio' : 'Entre na sua conta'}</h3>
        <p>${temSessao
          ? 'Adicione os jogadores pelo Riot ID. Sem elenco, o sistema não sabe qual lado do scoreboard é o seu time.'
          : 'O elenco fica guardado na conta do time.'}</p>
      </div>`;
    }

    const selfId = typeof auth !== 'undefined' ? auth?.user?.id : null;

    return `<div class="an-table-wrap"><table class="an-table">
      <thead>
        <tr>
          <th>Jogador</th>
          <th>Função</th>
          <th>Status</th>
          <th><span class="an-sr-only">Ações</span></th>
        </tr>
      </thead>
      <tbody>
      ${this._roster.map(p => {
        const idx = (p.nickname || '').lastIndexOf('#');
        const name = idx >= 0 ? p.nickname.slice(0, idx) : p.nickname;
        const tag = idx >= 0 ? p.nickname.slice(idx + 1) : '';
        const isSelf = selfId && String(p.linked_user_id) === String(selfId);

        return `
          <tr>
            <td>
              <span class="an-cell-lead">
                <img class="an-agent-icon" style="width:30px;height:30px"
                     src="${f.escape(p.avatar_url || '/img/default-avatar.png')}" alt=""
                     onerror="this.src='/img/default-avatar.png'">
                <span>
                  ${f.escape(name)}${tag ? `<span class="an-mute">#${f.escape(tag)}</span>` : ''}
                  ${isSelf ? '<span class="an-chip" style="margin-left:6px">você</span>' : ''}
                  ${p.aliases?.length ? `<br><span class="an-mute" style="font-size:11px">também: ${f.escape(p.aliases.join(', '))}</span>` : ''}
                </span>
              </span>
            </td>
            <td>
              <select class="an-select an-role-select" data-role-for="${p.id}"
                      aria-label="Função de ${f.escape(name)}">
                <option value=""${f.normalizeRole(p.role) ? '' : ' selected'}>— sem função</option>
                ${f.ROLES.map(r => `
                  <option value="${r.value}"${f.normalizeRole(p.role) === r.value ? ' selected' : ''}>${r.label}</option>
                `).join('')}
              </select>
            </td>
            <td>${p.active === false ? '<span class="an-chip">inativo</span>' : ''}</td>
            <td>
              ${isSelf ? '' : `
                <button type="button" class="an-btn an-btn-ghost an-btn-sm" data-remove="${p.id}"
                        aria-label="Remover ${f.escape(name)} do elenco">
                  <i class="fas fa-trash"></i>
                </button>`}
            </td>
          </tr>`;
      }).join('')}
    </tbody></table></div>`;
  },

  _bind(host) {
    const input = host.querySelector('#anRosterInput');

    host.querySelector('#anRosterSearch')?.addEventListener('click', () => this._search(host));
    input?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); this._search(host); }
    });

    host.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', () => this._remove(btn.dataset.remove));
    });

    host.querySelectorAll('[data-role-for]').forEach(sel => {
      sel.addEventListener('change', () => this._setRole(sel.dataset.roleFor, sel));
    });
  },

  /** Salva a função escolhida. A função é rótulo do elenco: não mexe em
      estatística nenhuma, então invalida só 'roster' e 'players' (que a
      exibem) em vez de derrubar todo o cache de stats. */
  async _setRole(id, select) {
    const player = this._roster.find(p => String(p.id) === String(id));
    if (!player) return;

    const previous = player.role || '';
    const role = select.value || null;

    if (!AnaliseShell.requireSession('alterar a função')) {
      select.value = previous;
      return;
    }

    select.disabled = true;
    try {
      const res = await api.request(`/scoreboard/roster/${id}`, {
        method: 'PUT',
        body: JSON.stringify({
          nickname: player.nickname,
          aliases: player.aliases || [],
          role,
          active: player.active !== false
        })
      });
      if (!res.success) throw new Error(res.message || 'Falha ao salvar função');

      player.role = role;
      AnaliseStore.invalidate('roster', 'players');
      AnaliseShell.toast(
        role ? `${player.nickname}: ${AnaliseFormat.roleLabel(role)}` : `${player.nickname} sem função`,
        'success'
      );
    } catch (err) {
      select.value = AnaliseFormat.normalizeRole(previous);
      AnaliseShell.toast(err.message || 'Não foi possível salvar a função', 'error');
    } finally {
      select.disabled = false;
    }
  },

  async _search(host) {
    const out = host.querySelector('#anRosterResult');
    const raw = host.querySelector('#anRosterInput')?.value?.trim() || '';

    const hash = raw.lastIndexOf('#');
    const riotId = hash >= 0 ? raw.slice(0, hash).trim() : '';
    const riotTag = hash >= 0 ? raw.slice(hash + 1).trim() : '';

    if (!riotId || !riotTag) {
      out.innerHTML = `<p class="an-neg" style="font-size:12px;margin-top:10px">
        Use o formato nick#tag, como prince#zudo.</p>`;
      return;
    }

    if (!AnaliseShell.requireSession('buscar jogadores')) {
      out.innerHTML = '';
      return;
    }

    out.innerHTML = '<div class="an-loading" style="padding:20px"><i class="fas fa-spinner fa-spin"></i> Procurando…</div>';

    try {
      const res = await api.request(
        `/scoreboard/roster/lookup?riot_id=${encodeURIComponent(riotId)}&riot_tag=${encodeURIComponent(riotTag)}`
      );
      if (!res.success) throw new Error(res.message || 'Falha na busca');

      if (!res.data?.found) {
        out.innerHTML = `<p class="an-neg" style="font-size:12px;margin-top:10px">
          Nenhuma conta zdval com esse Riot ID. Peça para o jogador se cadastrar primeiro.</p>`;
        return;
      }

      const user = res.data.user;
      const f = AnaliseFormat;
      out.innerHTML = `
        <div class="an-star" style="margin-top:12px">
          <img class="an-agent-icon" style="width:30px;height:30px"
               src="${f.escape(user.avatar_url || '/img/default-avatar.png')}" alt=""
               onerror="this.src='/img/default-avatar.png'">
          <span class="an-star-name">${f.escape(user.riot_id)}<span class="an-mute">#${f.escape(user.riot_tag)}</span></span>
          <button type="button" class="an-btn an-btn-primary an-btn-sm" id="anRosterAdd">
            <i class="fas fa-plus"></i> Adicionar ao elenco
          </button>
        </div>`;

      out.querySelector('#anRosterAdd')?.addEventListener('click', () => this._add(user.riot_id, user.riot_tag));
    } catch (err) {
      out.innerHTML = `<p class="an-neg" style="font-size:12px;margin-top:10px">
        ${AnaliseFormat.escape(err.message || 'Erro ao buscar jogador')}</p>`;
    }
  },

  async _add(riotId, riotTag) {
    if (!AnaliseShell.requireSession('adicionar ao elenco')) return;
    try {
      const res = await api.request('/scoreboard/roster', {
        method: 'POST',
        body: JSON.stringify({ riot_id: riotId, riot_tag: riotTag })
      });
      if (!res.success) throw new Error(res.message || 'Falha ao adicionar');

      // Mudar o elenco muda quem é "nosso time" em toda estatística.
      AnaliseStore.invalidate('roster', 'players', 'stats');
      AnaliseShell.toast(`${riotId}#${riotTag} entrou no elenco`, 'success');
      await analise.refresh();
    } catch (err) {
      AnaliseShell.toast(err.message || 'Não foi possível adicionar', 'error');
    }
  },

  async _remove(id) {
    const ok = await AnaliseShell.confirm({
      title: 'Remover do elenco',
      message: 'As partidas continuam salvas, mas este jogador deixa de ser reconhecido como do time.',
      confirmLabel: 'Remover',
      danger: true
    });
    if (!ok) return;
    if (!AnaliseShell.requireSession('remover do elenco')) return;

    try {
      const res = await api.request(`/scoreboard/roster/${id}`, { method: 'DELETE' });
      if (!res.success) throw new Error(res.message || 'Falha ao remover');

      AnaliseStore.invalidate('roster', 'players', 'stats');
      AnaliseShell.toast('Jogador removido do elenco', 'success');
      await analise.refresh();
    } catch (err) {
      AnaliseShell.toast(err.message || 'Não foi possível remover', 'error');
    }
  }
};


/* ===== js/analise/drawer-match.js ===== */
// =====================================================
// ZDVAL — /analise · modal de edição da partida
// Corrigir o que a leitura da imagem errou: placar, rounds por lado, pistols
// e link da VOD. O detalhe da partida vive no dropdown da lista — manter as
// duas telas era mostrar o mesmo scoreboard em dois lugares.
// =====================================================

window.AnaliseDrawerMatch = {
  async openEdit(matchId) {
    const body = AnaliseShell.openDrawer({ title: 'Editar partida', width: 640, centered: true });
    if (!body) return;
    body.innerHTML = '<div class="an-loading"><i class="fas fa-spinner fa-spin"></i> Carregando…</div>';

    let match;
    try {
      const [data] = await Promise.all([
        AnaliseStore.getMatch(matchId),
        AnaliseFormat.ensureMapImageIndex().catch(() => {})
      ]);
      match = data?.match;
      if (!match) throw new Error('Partida não encontrada');
    } catch (err) {
      body.innerHTML = `<div class="an-empty"><h3>Não foi possível abrir</h3>
        <p>${AnaliseFormat.escape(err.message)}</p></div>`;
      return;
    }

    body.innerHTML = this._editForm(match);
    AnaliseShell.setDrawerFooter(`
      <button type="button" class="an-btn an-btn-danger" data-act="delete">
        <i class="fas fa-trash"></i> Excluir
      </button>
      <button type="button" class="an-btn" data-act="cancel">Cancelar</button>
      <button type="submit" form="anEditForm" class="an-btn an-btn-primary" id="anEditSave">
        <i class="fas fa-check"></i> Salvar alterações
      </button>`);

    const drawer = document.querySelector('#page-analise .an-drawer');
    drawer?.querySelector('[data-act="cancel"]')?.addEventListener('click', () => AnaliseShell.closeDrawer());
    drawer?.querySelector('[data-act="delete"]')?.addEventListener('click', () => this._delete(matchId));

    this._bindEdit(body, drawer, matchId);
  },

  _editForm(match) {
    const f = AnaliseFormat;
    const n = (v) => Number(v || 0);

    const pistolBtns = (field, current) => `
      <div class="an-toggle-pair" data-pistol="${field}">
        <button type="button" data-value="won"  class="${current === 'won' ? 'is-active' : ''}"
                title="Ganhamos"><i class="fas fa-check"></i></button>
        <button type="button" data-value="lost" class="${current === 'lost' ? 'is-active' : ''}"
                title="Perdemos"><i class="fas fa-xmark"></i></button>
        <button type="button" data-value=""     class="${!current ? 'is-active' : ''}"
                title="Sem registro">—</button>
      </div>`;

    const lado = (nome, classe, campoWon, campoLost, pistolField, pistolValue) => `
      <section class="an-edit-side ${classe}">
        <header>
          <span class="an-edit-side-name">${nome}</span>
          ${pistolBtns(pistolField, pistolValue)}
        </header>
        <div class="an-edit-pair">
          <label>
            <span>Ganhos</span>
            <input type="number" min="0" class="an-input an-num" name="${campoWon}" value="${n(match[campoWon])}">
          </label>
          <label>
            <span>Perdidos</span>
            <input type="number" min="0" class="an-input an-num" name="${campoLost}" value="${n(match[campoLost])}">
          </label>
        </div>
      </section>`;

    return `
      <form id="anEditForm" class="an-edit">
        <header class="an-edit-head">
          <span class="an-edit-map" style="background-image:url('${f.getMapImage(match.map)}')" aria-hidden="true"></span>
          <div>
            <strong>${f.escape(match.map || '—')}</strong>
            <span>${f.escape(f.fmtDate(match.match_date))}</span>
          </div>
        </header>

        <section class="an-edit-block">
          <h4>Placar final</h4>
          <div class="an-edit-score">
            <input type="number" min="0" class="an-input an-num" name="score_team"
                   value="${n(match.score_team)}" aria-label="Nosso placar">
            <span class="an-mute">×</span>
            <input type="number" min="0" class="an-input an-num" name="score_opponent"
                   value="${n(match.score_opponent)}" aria-label="Placar adversário">
            <span id="anEditResult" class="an-chip"></span>
          </div>
        </section>

        <section class="an-edit-block">
          <h4>Rounds e pistol por lado</h4>
          <div class="an-edit-sides">
            ${lado('Ataque', 'is-atk', 'half_attack_won', 'half_attack_lost', 'pistol_attack', match.pistol_attack)}
            ${lado('Defesa', 'is-def', 'half_defense_won', 'half_defense_lost', 'pistol_defense', match.pistol_defense)}
          </div>
          <p id="anEditWarn" class="an-neg an-edit-warn" aria-live="polite"></p>
        </section>

        <section class="an-edit-block">
          <h4><label for="anEditVod">Link da VOD</label></h4>
          <div class="an-edit-vod">
            <input type="url" id="anEditVod" name="vod_url" class="an-input"
                   value="${f.escape(match.vod_url || '')}" placeholder="https://youtube.com/watch?v=…">
            <button type="button" class="an-btn an-btn-sm" id="anEditPaste">
              <i class="far fa-clipboard"></i> Colar
            </button>
          </div>
        </section>

        <input type="hidden" name="pistol_attack"  value="${f.escape(match.pistol_attack || '')}">
        <input type="hidden" name="pistol_defense" value="${f.escape(match.pistol_defense || '')}">
      </form>`;
  },

  _bindEdit(body, drawer, matchId) {
    const form = body.querySelector('#anEditForm');
    const warn = body.querySelector('#anEditWarn');
    const saveBtn = drawer?.querySelector('#anEditSave');

    const num = (name) => Number(form.querySelector(`[name="${name}"]`)?.value) || 0;

    /**
     * A soma das metades tem que bater com o placar — ou ficar tudo zerado.
     * Sem isso o win rate por lado mente, e é ele que decide veto de mapa.
     */
    const validate = () => {
      const total = num('score_team') + num('score_opponent');
      const halves = num('half_attack_won') + num('half_attack_lost')
                   + num('half_defense_won') + num('half_defense_lost');
      const allZero = halves === 0;
      const ok = allZero || halves === total;

      const chip = body.querySelector('#anEditResult');
      const st = num('score_team');
      const so = num('score_opponent');
      chip.className = st > so ? 'an-chip an-chip-win' : st < so ? 'an-chip an-chip-loss' : 'an-chip';
      chip.textContent = st > so ? 'Vitória' : st < so ? 'Derrota' : 'Empate';

      warn.textContent = ok ? '' :
        `Ataque + defesa somam ${halves} rounds, mas o placar dá ${total}. Ajuste, ou zere as quatro caixas.`;
      if (saveBtn) saveBtn.disabled = !ok;
      return ok;
    };

    form.querySelectorAll('input[type="number"]').forEach(i => i.addEventListener('input', validate));

    form.querySelectorAll('[data-pistol]').forEach(group => {
      group.addEventListener('click', (e) => {
        const btn = e.target.closest('button[data-value]');
        if (!btn) return;
        group.querySelectorAll('button').forEach(b => b.classList.toggle('is-active', b === btn));
        const hidden = form.querySelector(`input[type="hidden"][name="${group.dataset.pistol}"]`);
        if (hidden) hidden.value = btn.dataset.value;
      });
    });

    const vod = body.querySelector('#anEditVod');
    AnaliseFormat.bindVodInput(vod);
    body.querySelector('#anEditPaste')?.addEventListener('click', () => AnaliseFormat.pasteVod(vod));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!validate()) return;

      const fd = new FormData(form);
      const payload = {
        score_team:        Number(fd.get('score_team') || 0),
        score_opponent:    Number(fd.get('score_opponent') || 0),
        pistol_attack:     fd.get('pistol_attack') || null,
        pistol_defense:    fd.get('pistol_defense') || null,
        half_attack_won:   Number(fd.get('half_attack_won') || 0),
        half_attack_lost:  Number(fd.get('half_attack_lost') || 0),
        half_defense_won:  Number(fd.get('half_defense_won') || 0),
        half_defense_lost: Number(fd.get('half_defense_lost') || 0),
        vod_url:           AnaliseFormat.sanitizeVodUrl(fd.get('vod_url')) || null
      };

      if (saveBtn) {
        saveBtn.disabled = true;
        saveBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Salvando…';
      }

      try {
        if (!AnaliseShell.requireSession('salvar a partida')) return;
        const res = await api.request(`/scoreboard/matches/${matchId}`, {
          method: 'PUT',
          body: JSON.stringify(payload)
        });
        if (!res.success) throw new Error(res.message || 'Falha ao salvar');

        AnaliseStore.invalidate();
        AnaliseShell.closeDrawer();
        AnaliseShell.toast('Partida atualizada', 'success');
        await analise.refresh();
      } catch (err) {
        AnaliseShell.toast(err.message || 'Não foi possível salvar', 'error');
        if (saveBtn) {
          saveBtn.disabled = false;
          saveBtn.innerHTML = '<i class="fas fa-check"></i> Salvar alterações';
        }
      }
    });

    validate();
  },

  async _delete(matchId) {
    const ok = await AnaliseShell.confirm({
      title: 'Excluir partida',
      message: 'A partida sai do histórico e todas as estatísticas são recalculadas. Não dá para desfazer.',
      confirmLabel: 'Excluir',
      danger: true
    });
    if (!ok) return;

    try {
      if (!AnaliseShell.requireSession('excluir a partida')) return;
      const res = await api.request(`/scoreboard/matches/${matchId}`, { method: 'DELETE' });
      if (!res.success) throw new Error(res.message || 'Falha ao excluir');

      AnaliseStore.invalidate();
      AnaliseShell.closeDrawer();
      AnaliseShell.toast('Partida excluída', 'success');
      await analise.refresh();
    } catch (err) {
      AnaliseShell.toast(err.message || 'Não foi possível excluir', 'error');
    }
  }
};


/* ===== js/analise/drawer-upload.js ===== */
// =====================================================
// ZDVAL — /analise · drawer de upload
// Sobe screenshots, a IA extrai o scoreboard, o usuário confere e salva.
// Um arquivo abre a tela de revisão; vários entram na fila e são salvos
// automaticamente.
//
// Ao salvar, o store é invalidado e a view atual se redesenha: o
// dashboard nunca fica desatualizado depois de uma importação.
// =====================================================

window.AnaliseDrawerUpload = {
  _data: null,        // scoreboard extraído, ainda não salvo
  _mode: 'treino',    // treino | campeonato
  _pistol: { attack: null, defense: null },
  _body: null,
  // A VOD é o começo de tudo: link, dia e horário são informados antes do
  // print e seguem para a tela de conferência já preenchidos.
  _vod: { url: '', date: '', time: '' },

  open() {
    this._data = null;
    this._pistol = { attack: null, defense: null };
    this._mode = localStorage.getItem('analise:mode') === 'campeonato' ? 'campeonato' : 'treino';
    this._vod = { url: '', date: this._today(), time: '' };

    this._body = AnaliseShell.openDrawer({ title: 'Nova VOD', width: 720, centered: true });
    if (!this._body) return;

    if (!api.token) {
      this._renderSignedOut();
      return;
    }

    this._renderDrop();
  },

  close() {
    AnaliseShell.closeDrawer();
  },

  // ── Passo 1: dropzone ────────────────────────────────

  /**
   * Horário de hora em hora. O <input type="time"> abre o seletor do sistema
   * (com AM/PM e minuto a minuto) e ninguém anota VOD em 10:28 — a sessão é
   * "às 20h". Guarda 'HH:00', que é o formato que o backend grava.
   */
  _hourOptions(selected) {
    const atual = String(selected || '').slice(0, 2);
    return Array.from({ length: 24 }, (_, h) => {
      const value = `${String(h).padStart(2, '0')}:00`;
      const marcado = atual === String(h).padStart(2, '0') ? ' selected' : '';
      return `<option value="${value}"${marcado}>${h}h</option>`;
    }).join('');
  },

  /**
   * O fluxo inteiro depende de sessão: /scoreboard/analyze e /save exigem
   * token. Sem isso a pessoa preenchia a VOD, soltava o print e só então
   * levava um 401 cru ("Token de acesso não fornecido"). Agora o drawer
   * abre já explicando e com o caminho para entrar.
   */
  _renderSignedOut() {
    this._body.innerHTML = `
      <div class="an-empty">
        <i class="fas fa-lock"></i>
        <h3>Entre na sua conta para importar</h3>
        <p>As VODs e os scoreboards ficam guardados na conta do time.
           Faça login e a importação continua daqui.</p>
        <button type="button" class="an-btn an-btn-primary" id="anUploadLogin">
          <i class="fas fa-right-to-bracket"></i> Entrar
        </button>
      </div>`;

    this._body.querySelector('#anUploadLogin')?.addEventListener('click', () => {
      AnaliseShell.closeDrawer();
      if (typeof auth !== 'undefined' && auth?.openAuth) auth.openAuth('login');
    });
  },

  _today() {
    const d = new Date();
    const p = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
  },

  _renderDrop() {
    this._body.innerHTML = `
      <div class="an-card" style="margin-bottom:16px">
        <div class="an-card-head">
          <span class="an-card-title"><i class="fas fa-video"></i> Dados da VOD</span>
        </div>
        <div class="an-card-body">
          <div class="an-field">
            <label for="anVodUrlTop">Link da VOD</label>
            <div class="an-filters">
              <input type="url" id="anVodUrlTop" class="an-input" style="flex:1"
                     placeholder="https://youtube.com/watch?v=… ou twitch.tv/videos/…"
                     value="${AnaliseFormat.escape(this._vod.url)}">
              <button type="button" class="an-btn an-btn-sm" id="anVodPasteTop">
                <i class="fas fa-paste"></i> Colar
              </button>
            </div>
          </div>

          <div class="an-field-row">
            <div class="an-field">
              <label for="anVodDate">Dia</label>
              <input type="date" id="anVodDate" class="an-input" value="${this._vod.date}">
            </div>
            <div class="an-field">
              <label for="anVodTime">Horário</label>
              <select id="anVodTime" class="an-select">
                <option value="">--</option>
                ${this._hourOptions(this._vod.time)}
              </select>
            </div>
            <div class="an-field">
              <label>Tipo</label>
              <div class="an-seg" id="anVodMode">
                <button type="button" data-mode="treino" class="${this._mode === 'treino' ? 'is-active' : ''}">Treino</button>
                <button type="button" data-mode="campeonato" class="${this._mode === 'campeonato' ? 'is-active' : ''}">Campeonato</button>
              </div>
            </div>
          </div>
          <p class="an-mute" style="font-size:11px;margin:0">
            O dia já vem preenchido com hoje. Mapa, placar e estatísticas saem do print.
          </p>
        </div>
      </div>

      <div class="an-drop" id="anDrop" role="button" tabindex="0"
           aria-label="Selecionar screenshots do scoreboard">
        <i class="fas fa-cloud-arrow-up"></i>
        <strong>Arraste os screenshots do scoreboard</strong>
        <span>ou clique para escolher os arquivos</span>
        <small>PNG, JPG ou WEBP · vários arquivos de uma vez</small>
        <input type="file" id="anFileInput" accept="image/*" multiple hidden>
      </div>
      <p class="an-mute" style="font-size:12px;margin-top:12px">
        Um arquivo abre a tela de conferência antes de salvar.
        Vários arquivos entram na fila e são salvos automaticamente.
      </p>
      <div id="anQueue"></div>`;

    // Campos da VOD: guardam no estado a cada digitação, para sobreviver à
    // troca de passo (o print substitui o corpo do drawer).
    const vodUrl = this._body.querySelector('#anVodUrlTop');
    const vodDate = this._body.querySelector('#anVodDate');
    const vodTime = this._body.querySelector('#anVodTime');

    vodUrl?.addEventListener('input', () => { this._vod.url = vodUrl.value.trim(); });
    vodDate?.addEventListener('change', () => { this._vod.date = vodDate.value; });
    vodTime?.addEventListener('change', () => { this._vod.time = vodTime.value; });

    AnaliseFormat.bindVodInput(vodUrl);
    this._body.querySelector('#anVodPasteTop')?.addEventListener('click', async () => {
      await AnaliseFormat.pasteVod(vodUrl);
      this._vod.url = vodUrl.value.trim();
    });

    this._body.querySelector('#anVodMode')?.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-mode]');
      if (!btn) return;
      this._mode = btn.dataset.mode;
      localStorage.setItem('analise:mode', this._mode);
      this._body.querySelectorAll('#anVodMode button')
        .forEach(b => b.classList.toggle('is-active', b === btn));
    });

    const drop = this._body.querySelector('#anDrop');
    const input = this._body.querySelector('#anFileInput');

    const pick = () => { if (!drop.classList.contains('is-loading')) input.click(); };
    drop.addEventListener('click', pick);
    drop.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
    });

    ['dragenter', 'dragover'].forEach(ev => drop.addEventListener(ev, (e) => {
      e.preventDefault();
      drop.classList.add('is-over');
    }));
    ['dragleave', 'drop'].forEach(ev => drop.addEventListener(ev, (e) => {
      e.preventDefault();
      drop.classList.remove('is-over');
    }));

    drop.addEventListener('drop', (e) => {
      const files = [...(e.dataTransfer?.files || [])].filter(f => f.type.startsWith('image/'));
      if (files.length) this._handleFiles(files);
    });

    input.addEventListener('change', () => {
      const files = [...input.files].filter(f => f.type.startsWith('image/'));
      if (files.length) this._handleFiles(files);
      input.value = '';
    });
  },

  _handleFiles(files) {
    if (files.length === 1) this._analyzeOne(files[0]);
    else this._runBatch(files);
  },

  // ── Otimização de imagem ─────────────────────────────

  _canvasToBlob(canvas, mimeType, quality) {
    return new Promise(resolve => canvas.toBlob(blob => resolve(blob), mimeType, quality));
  },

  /**
   * Screenshot de 4K vira 8MB e estoura o timeout da IA. Reduzimos para
   * 1920px no lado maior e ~1.6MB antes de subir. Arquivo pequeno passa direto.
   */
  async _optimize(file) {
    if (!file || !file.type?.startsWith('image/')) return file;

    const FAST_PATH_MAX_BYTES = 900 * 1024;
    const TARGET_MAX_BYTES = 1600 * 1024;
    const MAX_SIDE = 1920;
    if (file.size <= FAST_PATH_MAX_BYTES) return file;

    let objectUrl = '';
    try {
      objectUrl = URL.createObjectURL(file);
      const img = await new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = objectUrl;
      });

      const srcW = img.naturalWidth || img.width;
      const srcH = img.naturalHeight || img.height;
      const longSide = Math.max(srcW, srcH);
      const scale = longSide > MAX_SIDE ? (MAX_SIDE / longSide) : 1;
      const targetW = Math.max(1, Math.round(srcW * scale));
      const targetH = Math.max(1, Math.round(srcH * scale));

      if (scale === 1 && file.size <= TARGET_MAX_BYTES) return file;

      const canvas = document.createElement('canvas');
      canvas.width = targetW;
      canvas.height = targetH;
      const ctx = canvas.getContext('2d', { alpha: false });
      if (!ctx) return file;

      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, 0, 0, targetW, targetH);

      let quality = file.size > (7 * 1024 * 1024) ? 0.72 : 0.82;
      let blob = await this._canvasToBlob(canvas, 'image/jpeg', quality);
      while (blob && blob.size > TARGET_MAX_BYTES && quality > 0.56) {
        quality -= 0.08;
        blob = await this._canvasToBlob(canvas, 'image/jpeg', quality);
      }

      if (!blob) return file;
      if (blob.size >= file.size * 0.96 && scale === 1) return file;

      const baseName = (file.name || 'scoreboard').replace(/\.[^.]+$/, '');
      return new File([blob], `${baseName}-fast.jpg`, { type: 'image/jpeg', lastModified: Date.now() });
    } catch (_) {
      return file;
    } finally {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    }
  },

  _friendlyError(error) {
    const msg = String(error?.message || '').toLowerCase();
    if (error?.code === 'REQUEST_TIMEOUT') {
      return 'A análise demorou demais. Tente de novo em alguns segundos.';
    }
    if (msg.includes('quota') || msg.includes('limite da gemini') || msg.includes('resource_exhausted')) {
      return 'O limite da Gemini foi atingido. Aguarde a cota renovar ou ajuste o plano.';
    }
    // 401 do backend chega como "Token de acesso não fornecido" — mensagem de
    // servidor, não de usuário. Acontece quando a sessão expira no meio do
    // envio (na abertura do drawer isso já é barrado).
    if (error?.status === 401 || msg.includes('token de acesso') || msg.includes('token inválido') ||
        msg.includes('não autorizado') || msg.includes('unauthorized')) {
      return 'Sua sessão expirou. Entre de novo para importar a VOD.';
    }
    return error?.message || 'Não foi possível analisar a imagem.';
  },

  // ── Um arquivo: analisar e revisar ───────────────────

  async _analyzeOne(file) {
    const drop = this._body.querySelector('#anDrop');
    drop?.classList.add('is-loading');
    drop?.setAttribute('aria-busy', 'true');

    const queue = this._body.querySelector('#anQueue');
    queue.innerHTML = `<div class="an-loading"><i class="fas fa-spinner fa-spin"></i>
      Lendo o scoreboard com a IA…</div>`;

    try {
      const optimized = await this._optimize(file);
      const form = new FormData();
      form.append('screenshot', optimized);

      const res = await api.upload('/scoreboard/analyze', form, { timeoutMs: 120000 });
      if (!res.success) throw new Error(res.message || 'Erro na análise');

      this._data = res.data;
      await this._renderReview();
    } catch (err) {
      queue.innerHTML = `<div class="an-insight" style="border-left-color:var(--zd-danger)">
        <i class="fas fa-triangle-exclamation"></i>
        <span>${AnaliseFormat.escape(this._friendlyError(err))}</span></div>`;
    } finally {
      drop?.classList.remove('is-loading');
      drop?.removeAttribute('aria-busy');
    }
  },

  // ── Vários arquivos: fila com salvamento automático ──

  async _runBatch(files) {
    const roster = await AnaliseStore.get('roster').catch(() => []);

    this._body.innerHTML = `
      <div class="an-queue">
        <div class="an-card-title"><i class="fas fa-layer-group"></i>
          Fila de importação <span class="an-num" id="anQueueCount">0/${files.length}</span></div>
        <div class="an-queue-bar"><div class="an-queue-fill" id="anQueueFill"></div></div>
        <div id="anQueueItems">
          ${files.map((f, i) => `
            <div class="an-queue-item" id="anQi${i}">
              <i class="fas fa-clock an-mute"></i>
              <span class="name">${AnaliseFormat.escape(f.name)}</span>
              <span class="an-mute status">na fila</span>
            </div>`).join('')}
        </div>
      </div>`;

    let done = 0;
    let saved = 0;

    for (let i = 0; i < files.length; i++) {
      const item = this._body.querySelector(`#anQi${i}`);
      const status = item?.querySelector('.status');
      const icon = item?.querySelector('i');

      const setStatus = (text, cls = '') => {
        if (status) status.textContent = text;
        if (item) item.className = `an-queue-item ${cls}`;
      };

      try {
        setStatus('otimizando…');
        if (icon) icon.className = 'fas fa-spinner fa-spin an-mute';
        const optimized = await this._optimize(files[i]);

        setStatus('lendo com a IA…');
        const form = new FormData();
        form.append('screenshot', optimized);
        const res = await api.upload('/scoreboard/analyze', form, { timeoutMs: 120000 });
        if (!res.success) throw new Error(res.message || 'Erro na análise');

        setStatus('salvando…');
        const payload = this._buildPayload(res.data, roster, { autoHalves: true });
        const save = await api.request('/scoreboard/save', {
          method: 'POST',
          body: JSON.stringify(payload)
        });
        if (!save.success) throw new Error(save.message || 'Erro ao salvar');

        setStatus(`${payload.map} ${payload.score_team}–${payload.score_opponent}`, 'is-ok');
        if (icon) icon.className = 'fas fa-check';
        saved++;
      } catch (err) {
        setStatus(this._friendlyError(err), 'is-fail');
        if (icon) icon.className = 'fas fa-xmark';
      }

      done++;
      const count = this._body.querySelector('#anQueueCount');
      const fill = this._body.querySelector('#anQueueFill');
      if (count) count.textContent = `${done}/${files.length}`;
      if (fill) fill.style.width = `${(done / files.length) * 100}%`;
    }

    AnaliseShell.setDrawerFooter(`
      <button type="button" class="an-btn an-btn-primary" id="anQueueDone">Concluir</button>`);
    document.querySelector('#page-analise #anQueueDone')?.addEventListener('click', async () => {
      AnaliseShell.closeDrawer();
      await analise.refresh('dashboard');
    });

    if (saved) {
      AnaliseStore.invalidate();
      AnaliseShell.toast(`${saved} de ${files.length} partidas importadas`, 'success');
    } else {
      AnaliseShell.toast('Nenhuma partida foi importada', 'error');
    }
  },

  // ── Tela de conferência ──────────────────────────────

  async _renderReview() {
    const f = AnaliseFormat;
    const d = this._data;
    const roster = await AnaliseStore.get('roster').catch(() => []);
    await Promise.all([f.ensureMapImageIndex(), f.ensureAgentIconIndex()]);

    const { ours, foes } = this._splitTeams(d.players || [], roster);
    const scoreTeam = Number(d.team_score ?? d.score_left ?? 0);
    const scoreOpp = Number(d.opponent_score ?? d.score_right ?? 0);
    const result = scoreTeam === scoreOpp ? 'draw' : scoreTeam > scoreOpp ? 'win' : 'loss';

    this._body.innerHTML = `
      <div class="an-filters" style="margin-bottom:16px">
        <img class="an-map-thumb" src="${f.getMapImage(d.map)}" alt="" loading="lazy"
             onerror="this.src='/img/maps/default-preview.jpg'" style="width:72px;height:44px">
        <div>
          <div style="font-size:20px;font-weight:800;letter-spacing:-.02em">
            ${f.escape(d.map || '—')}
            <span class="an-num" style="margin-left:8px">${scoreTeam}–${scoreOpp}</span>
          </div>
          <div class="an-mute" style="font-size:12px">
            ${f.fmtDate(d.match_date)}${d.duration ? ` · ${f.escape(d.duration)}` : ''}
          </div>
        </div>
        <span class="${f.resultChipClass(result)}" style="margin-left:auto">${f.resultLabel(result)}</span>
      </div>

      <div class="an-insight" style="margin-bottom:16px">
        <i class="fas fa-wand-magic-sparkles"></i>
        <span>Confira os números antes de salvar. Se a leitura errou algum valor,
        troque a imagem por um print mais nítido.</span>
      </div>

      ${this._reviewTable('Nosso time', ours, result === 'win' ? 'is-ok' : result === 'loss' ? 'is-bad' : '')}
      ${this._reviewTable(foes[0]?.team_tag || 'Adversário', foes, result === 'win' ? 'is-bad' : result === 'loss' ? 'is-ok' : '')}

      <div class="an-card" style="margin-top:16px">
        <div class="an-card-head"><span class="an-card-title"><i class="fas fa-sliders"></i> Informações da partida</span></div>
        <div class="an-card-body">
          <div class="an-field">
            <label>Tipo</label>
            <div class="an-seg" id="anModeSeg">
              <button type="button" data-mode="treino" class="${this._mode === 'treino' ? 'is-active' : ''}">Treino</button>
              <button type="button" data-mode="campeonato" class="${this._mode === 'campeonato' ? 'is-active' : ''}">Campeonato</button>
            </div>
          </div>

          <div class="an-field" id="anHalvesField">
            <label for="anAtkWon">Rounds ganhos por lado</label>
            <div class="an-filters">
              <label class="an-field" style="margin:0">
                <span class="an-mute" style="font-size:11px">Ataque</span>
                <input type="number" min="0" max="12" id="anAtkWon" class="an-input an-num" style="width:84px" placeholder="—">
              </label>
              <label class="an-field" style="margin:0">
                <span class="an-mute" style="font-size:11px">Defesa</span>
                <input type="number" min="0" max="12" id="anDefWon" class="an-input an-num" style="width:84px" placeholder="auto">
              </label>
            </div>
            <p class="an-mute" id="anHalvesHint" style="font-size:11px" aria-live="polite"></p>
            <div style="max-width:280px">${f.halfBar(0, 0, 0, 0, { legend: true })}</div>
          </div>

          <div class="an-field">
            <label>Pistols</label>
            <div class="an-filters">
              <span class="an-chip an-chip-atk">Ataque</span>
              <div class="an-toggle-pair" data-pistol="attack">
                <button type="button" data-value="won"><i class="fas fa-check"></i></button>
                <button type="button" data-value="lost"><i class="fas fa-xmark"></i></button>
              </div>
              <span class="an-chip an-chip-def" style="margin-left:12px">Defesa</span>
              <div class="an-toggle-pair" data-pistol="defense">
                <button type="button" data-value="won"><i class="fas fa-check"></i></button>
                <button type="button" data-value="lost"><i class="fas fa-xmark"></i></button>
              </div>
            </div>
          </div>

          <div class="an-field">
            <label for="anVod">Link da VOD</label>
            <div class="an-filters">
              <input type="url" id="anVod" class="an-input" style="flex:1"
                     placeholder="https://youtube.com/watch?v=…"
                     value="${f.escape(this._vod.url || '')}">
              <button type="button" class="an-btn an-btn-sm" id="anVodPaste">
                <i class="far fa-clipboard"></i> Colar
              </button>
            </div>
          </div>

          <div class="an-field-row">
            <div class="an-field">
              <label for="anReviewDate">Dia da VOD</label>
              <input type="date" id="anReviewDate" class="an-input"
                     value="${this._vod.date || String(d.match_date || '').slice(0, 10) || this._today()}">
            </div>
            <div class="an-field">
              <label for="anReviewTime">Horário</label>
              <select id="anReviewTime" class="an-select">
                <option value="">--</option>
                ${this._hourOptions(this._vod.time)}
              </select>
            </div>
          </div>
        </div>
      </div>`;

    AnaliseShell.setDrawerFooter(`
      <button type="button" class="an-btn" id="anReviewBack">Trocar imagem</button>
      <button type="button" class="an-btn an-btn-primary" id="anReviewSave">
        <i class="fas fa-check"></i> Salvar partida
      </button>`);

    this._bindReview(roster);
  },

  /**
   * A cor da linha no scoreboard é o sinal mais confiável de time (o modelo
   * devolve is_enemy). Sem ela, o elenco decide; sem elenco, a primeira tag.
   */
  _splitTeams(players, roster) {
    const hasSideFlag = players.some(p => p?.is_enemy === true || p?.is_enemy === false
      || p?.is_enemy === 'true' || p?.is_enemy === 'false');

    if (hasSideFlag) {
      const isFoe = (p) => p?.is_enemy === true || p?.is_enemy === 'true';
      return { ours: players.filter(p => !isFoe(p)), foes: players.filter(isFoe) };
    }

    if (roster?.length) {
      const mine = (p) => AnaliseFormat.isRosterPlayer(p.player_name || p.name, roster);
      return { ours: players.filter(mine), foes: players.filter(p => !mine(p)) };
    }

    const firstTag = players[0]?.team_tag || '';
    return {
      ours: players.filter(p => p.team_tag === firstTag),
      foes: players.filter(p => p.team_tag !== firstTag)
    };
  },

  /** Mesmo código de cor da lista: o tom é o do resultado, não o do time. */
  _reviewTable(title, players, tone = '') {
    const f = AnaliseFormat;
    if (!players.length) return '';

    const rows = players.map((p) => {
      const idx = (this._data.players || []).indexOf(p);
      const name = f.escape(p.player_name || p.name || '');
      return `
        <tr data-player-index="${idx}">
          <td>
            <span class="an-cell-lead">
              <img class="an-agent-icon" src="${f.getAgentIcon(p.agent)}" alt="${f.escape(p.agent)}"
                   title="${f.escape(p.agent)}" loading="lazy" onerror="this.src='/img/default-agent.png'">
              <span>${name}</span>
            </span>
          </td>
          <td>${Number(p.acs) || 0}</td>
          <td>${Number(p.kills) || 0}</td>
          <td>${Number(p.deaths) || 0}</td>
          <td>${Number(p.assists) || 0}</td>
          <td>${Number(p.first_bloods) || 0}</td>
          <td>${Number(p.econ) || 0}</td>
        </tr>`;
    }).join('');

    return `
      <div class="an-card an-sb-card ${tone}">
        <div class="an-card-head"><span class="an-card-title">${f.escape(title)}</span></div>
        <div class="an-card-body" style="padding:0 14px 10px">
          <table class="an-sb">
            <thead>
              <tr><th>Jogador</th><th>ACS</th><th>K</th><th>D</th><th>A</th>
                  <th title="First kills">FK</th><th>Econ</th></tr>
            </thead>
            <tbody>${rows}</tbody>
          </table>
        </div>
      </div>`;
  },

  _bindReview(roster) {
    const body = this._body;
    const drawer = document.querySelector('#page-analise .an-drawer');

    // O scoreboard é somente leitura: os números vêm da imagem e não são
    // editáveis, então não há listener de correção por célula aqui.

    body.querySelector('#anModeSeg')?.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-mode]');
      if (!btn) return;
      this._mode = btn.dataset.mode;
      localStorage.setItem('analise:mode', this._mode);
      body.querySelectorAll('#anModeSeg button').forEach(b => b.classList.toggle('is-active', b === btn));
    });

    const atk = body.querySelector('#anAtkWon');
    const def = body.querySelector('#anDefWon');
    atk?.addEventListener('input', () => this._applyHalves('attack'));
    def?.addEventListener('input', () => this._applyHalves('defense'));
    this._applyHalves('attack');

    body.querySelectorAll('[data-pistol]').forEach(group => {
      group.addEventListener('click', (e) => {
        const btn = e.target.closest('button[data-value]');
        if (!btn) return;
        const side = group.dataset.pistol;
        // Clicar de novo no mesmo botão limpa: registrar errado é pior que não registrar.
        const next = this._pistol[side] === btn.dataset.value ? null : btn.dataset.value;
        this._pistol[side] = next;
        group.querySelectorAll('button').forEach(b =>
          b.classList.toggle('is-active', next !== null && b === btn));
      });
    });

    const vod = body.querySelector('#anVod');
    AnaliseFormat.bindVodInput(vod);
    body.querySelector('#anVodPaste')?.addEventListener('click', () => AnaliseFormat.pasteVod(vod));

    drawer?.querySelector('#anReviewBack')?.addEventListener('click', () => {
      this._data = null;
      this._renderDrop();
      AnaliseShell.setDrawerFooter('');
    });
    drawer?.querySelector('#anReviewSave')?.addEventListener('click', () => this._save(roster));
  },

  /**
   * MR12: cada lado joga 12 rounds, então informar os ganhos de um lado
   * determina o outro. Só vale quando a partida somou 24 rounds — overtime
   * ou treino curto quebram a conta, e aí os campos ficam livres.
   */
  _applyHalves(source) {
    const body = this._body;
    const d = this._data;
    const atkInput = body.querySelector('#anAtkWon');
    const defInput = body.querySelector('#anDefWon');
    const hint = body.querySelector('#anHalvesHint');
    if (!atkInput || !defInput || !hint || !d) return;

    const teamScore = Number(d.team_score ?? d.score_left ?? 0);
    const oppScore = Number(d.opponent_score ?? d.score_right ?? 0);
    const totalRounds = teamScore + oppScore;

    const setBar = (aw, al, dw, dl) => {
      const wrap = body.querySelector('.an-halfbar')?.parentElement;
      if (wrap) wrap.innerHTML = AnaliseFormat.halfBar(aw, al, dw, dl, { legend: true });
    };

    // Fora de MR12 (overtime, treino curto) não dá para inferir os rounds
    // perdidos de cada lado a partir dos ganhos. Deixamos em branco: os quatro
    // campos existem no drawer de edição da partida.
    if (totalRounds !== 24) {
      atkInput.disabled = true;
      defInput.disabled = true;
      d.half_attack_won = null;
      d.half_attack_lost = null;
      d.half_defense_won = null;
      d.half_defense_lost = null;
      hint.textContent = `O placar deu ${teamScore}×${oppScore} (${totalRounds} rounds), fora do MR12. Salve a partida e preencha os lados no histórico, onde dá para informar ganhos e perdidos.`;
      setBar(0, 0, 0, 0);
      return;
    }

    const atkRaw = atkInput.value.trim();
    const defRaw = defInput.value.trim();

    if (!atkRaw && !defRaw) {
      d.half_attack_won = null;
      d.half_attack_lost = null;
      d.half_defense_won = null;
      d.half_defense_lost = null;
      hint.textContent = 'Informe os rounds ganhos de um lado — o outro é calculado sozinho.';
      setBar(0, 0, 0, 0);
      return;
    }

    let atkWon;
    let defWon;
    if (source === 'defense') {
      const raw = Number(defRaw || 0);
      defWon = Math.min(Math.min(12, teamScore), Math.max(Math.max(0, teamScore - 12), raw));
      atkWon = teamScore - defWon;
    } else {
      const raw = Number(atkRaw || 0);
      atkWon = Math.min(Math.min(12, teamScore), Math.max(Math.max(0, teamScore - 12), raw));
      defWon = teamScore - atkWon;
    }

    const atkLost = 12 - atkWon;
    const defLost = 12 - defWon;

    atkInput.value = String(atkWon);
    defInput.value = String(defWon);

    d.half_attack_won = atkWon;
    d.half_attack_lost = atkLost;
    d.half_defense_won = defWon;
    d.half_defense_lost = defLost;

    hint.textContent = `Ataque ${atkWon}–${atkLost} · Defesa ${defWon}–${defLost}`;
    setBar(atkWon, atkLost, defWon, defLost);
  },

  // ── Salvar ───────────────────────────────────────────

  /**
   * A Gemini devolve o campo como `player_name`; aceitamos `name` só por
   * segurança caso o formato do extrator mude.
   */
  _buildPayload(d, roster, { autoHalves = false } = {}) {
    const scoreTeam = Number(d.team_score ?? d.score_left ?? 0);
    const scoreOpp = Number(d.opponent_score ?? d.score_right ?? 0);
    const result = scoreTeam === scoreOpp ? 'draw' : scoreTeam > scoreOpp ? 'win' : 'loss';

    // A cor da linha é o que separa os times, e ela só existe na leitura da
    // imagem: `is_enemy` morria aqui, e o backend acabava adivinhando pelo
    // elenco. Com elenco vazio ninguém era "nosso" e os 10 jogadores caíam na
    // tabela do adversário. Agora o lado viaja junto de cada jogador.
    const { ours } = this._splitTeams(d.players || [], roster);
    const nosso = new Set(ours);

    const players = (d.players || []).map(p => ({
      is_our_team: nosso.has(p),
      player_name: p.player_name || p.name || 'Desconhecido',
      agent: p.agent || 'Unknown',
      team_tag: p.team_tag || p.team || null,
      acs: Number(p.acs || 0),
      kills: Number(p.kills || 0),
      deaths: Number(p.deaths || 0),
      assists: Number(p.assists || 0),
      econ: Number(p.econ || 0),
      first_bloods: Number(p.first_bloods || 0),
      plants: Number(p.plants || 0),
      defuses: Number(p.defuses || 0)
    }));

    // Tag do nosso time = a mais frequente do nosso lado. Era contada só entre
    // quem está no elenco, então time sem elenco cadastrado ficava sem tag.
    const tally = {};
    players.filter(p => p.is_our_team).forEach(p => {
      const tag = (p.team_tag || '').trim();
      if (tag) tally[tag] = (tally[tag] || 0) + 1;
    });
    const ourTag = Object.entries(tally).sort((a, b) => b[1] - a[1])[0]?.[0] || '';

    return {
      map: d.map || 'Unknown',
      score_team: scoreTeam,
      score_opponent: scoreOpp,
      result,
      match_type: autoHalves
        ? (d.match_type || null)
        : (this._mode === 'campeonato' ? 'CAMPEONATO' : 'TREINO'),
      screenshot_url: d.screenshot_url || null,
      duration: d.duration || null,
      our_team_tag: ourTag,
      players,
      pistol_attack: autoHalves ? null : this._pistol.attack,
      pistol_defense: autoHalves ? null : this._pistol.defense,
      half_attack_won: Number(d.half_attack_won ?? 0),
      half_attack_lost: Number(d.half_attack_lost ?? 0),
      half_defense_won: Number(d.half_defense_won ?? 0),
      half_defense_lost: Number(d.half_defense_lost ?? 0),
      notes: null,
      vod_url: autoHalves
        ? null
        : (AnaliseFormat.sanitizeVodUrl(this._body.querySelector('#anVod')?.value) || null),
      // Dia e horário informados na abertura da VOD; sem edição na revisão,
      // valem os do passo 1 (dia = hoje por padrão).
      match_date: autoHalves
        ? (d.match_date || null)
        : (this._body.querySelector('#anReviewDate')?.value || this._vod.date || d.match_date || null),
      match_time: autoHalves
        ? (this._vod.time || null)
        : (this._body.querySelector('#anReviewTime')?.value || this._vod.time || null)
    };
  },

  async _save(roster) {
    if (!this._data) return;
    const btn = document.querySelector('#page-analise #anReviewSave');
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Salvando…';
    }

    try {
      const payload = this._buildPayload(this._data, roster);
      if (!payload.players.length) throw new Error('Nenhum jogador foi lido no scoreboard');

      const res = await api.request('/scoreboard/save', {
        method: 'POST',
        body: JSON.stringify(payload)
      });
      if (!res.success) throw new Error(res.message || 'Erro ao salvar');

      this._data = null;
      AnaliseStore.invalidate();
      AnaliseShell.closeDrawer();
      AnaliseShell.toast(`${payload.map} ${payload.score_team}–${payload.score_opponent} salva`, 'success');
      // A VOD salva "desce" para a lista: é lá que ela passa a viver.
      await analise.refresh('dashboard');
    } catch (err) {
      AnaliseShell.toast(err.message || 'Não foi possível salvar', 'error');
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = '<i class="fas fa-check"></i> Salvar partida';
      }
    }
  }
};


/* ===== js/analise/analise.js ===== */
// =====================================================
// ZDVAL — /analise · bootstrap e roteador de views
//
// Monta o shell uma vez e troca só o conteúdo de #anMain. O store guarda
// os dados, então voltar para uma view já visitada não refaz fetch.
//
// window.analise mantém load/render/switchTab porque o dropdown do nav
// global (index.html) chama analise.switchTab() inline.
// =====================================================

class Analise {
  static VIEWS = [
    { id: 'dashboard', label: 'Minhas Partidas', icon: 'fas fa-list-check', module: 'AnaliseViewDashboard' },
    { id: 'mapas',     label: 'Mapas',           icon: 'fas fa-map',        module: 'AnaliseViewMaps' },
    { id: 'jogadores', label: 'Jogadores',       icon: 'fas fa-user-group', module: 'AnaliseViewPlayers' }
  ];

  // Rotas que deixaram de existir continuam abrindo algo em vez de 404:
  // 'elenco' virou uma seção dentro de Jogadores e 'config' foi removida —
  // suas duas funções úteis foram para Histórico (CSV) e Mapas (imagem).
  // 'historico' virou a própria tela inicial (a lista de partidas por dia),
  // 'elenco' é uma seção dentro de Jogadores e 'config' deixou de existir.
  static LEGACY = {
    // 'nova-vod' saiu do menu: importar já é o botão do cabeçalho. Quem chega
    // pelo link antigo cai na lista, que é onde a VOD recém-salva aparece.
    'nova-vod': 'dashboard',
    roster: 'jogadores',
    elenco: 'jogadores',
    config: 'dashboard',
    historico: 'dashboard',
    stats: 'dashboard',
    matches: 'dashboard'
  };

  constructor() {
    this.currentView = null;
    this.pendingView = null;
    this.mounted = false;
  }

  get views() { return Analise.VIEWS; }

  async load(params) {
    // Folha desta pagina, sob demanda. Estava no <head> do index.html, ou seja,
    // baixada em toda visita a qualquer pagina do site.
    Utils.loadPageCss('analise-page-css', 'analise.css');

    const container = document.getElementById('page-analise');
    if (!container) return;

    // app.navigate() passa null quando a rota não tem parâmetros, e default de
    // parâmetro só cobre undefined.
    const query = params || {};
    const requested = this._resolveView(query.v || this.pendingView || this._viewFromUrl());
    this.pendingView = null;

    if (!this.mounted || !container.querySelector('.an-shell')) {
      this.render(container, requested);
    }

    // Índices de imagem aquecem em background; a primeira tabela já aparece.
    AnaliseFormat.ensureMapImageIndex().catch(() => {});
    AnaliseFormat.ensureAgentIconIndex().catch(() => {});

    await this.goTo(requested);
    this._refreshFooter();
  }

  render(container, active = 'dashboard') {
    AnaliseShell.render(container, { views: Analise.VIEWS, active });
    this.mounted = true;
    this._bindShell();

    AnaliseStore.on('invalidated', () => this._refreshFooter());
  }

  /**
   * Delegação no document, uma vez só.
   *
   * Os cliques estavam presos ao nó #anSideNav daquele render: qualquer coisa
   * que substitua o HTML do #page-analise (o placeholder de "Carregando..." do
   * app.navigate, um segundo render do shell) troca o nó e leva os listeners
   * junto — a barra continua pintada na tela e nenhum clique responde.
   * No document não há nó para perder: o alvo é resolvido no momento do clique.
   */
  _bindShell() {
    if (Analise._delegated) return;
    Analise._delegated = true;

    document.addEventListener('click', (e) => {
      if (!e.target.closest?.('#page-analise')) return;

      const item = e.target.closest('.an-side-item');
      if (item) {
        this.goTo(item.dataset.view);
        return;
      }

      if (e.target.closest('#anImportBtn')) AnaliseDrawerUpload.open();
    });
  }

  /** Chamado pelo dropdown do nav global. Aceita os nomes de aba antigos. */
  switchTab(name) {
    if (!name) return;

    if (name === 'matches') {
      this.pendingView = 'dashboard';
      if (this.mounted) {
        this.goTo('dashboard').then(() => AnaliseDrawerUpload.open());
      }
      return;
    }

    const view = this._resolveView(name);
    if (this.mounted) this.goTo(view);
    else this.pendingView = view;
  }

  async goTo(viewId) {
    const view = Analise.VIEWS.find(v => v.id === this._resolveView(viewId));
    if (!view) return;

    const host = AnaliseShell.main;
    if (!host) return;

    // Trocar de view fecha qualquer drawer aberto — senão fica um detalhe de
    // partida flutuando sobre a tela de configurações.
    AnaliseShell.closeDrawer();

    const previous = Analise.VIEWS.find(v => v.id === this.currentView);
    if (previous && window[previous.module]?.unmount) {
      try { window[previous.module].unmount(host); } catch (err) { console.error(err); }
    }

    this.currentView = view.id;
    AnaliseShell.setActive(view.id);
    this._syncUrl(view.id);

    host.innerHTML = '<div class="an-loading"><i class="fas fa-spinner fa-spin"></i> Carregando…</div>';

    const mod = window[view.module];
    if (!mod?.mount) {
      host.innerHTML = '<div class="an-empty"><h3>Seção indisponível</h3></div>';
      return;
    }

    try {
      await mod.mount(host);
    } catch (err) {
      console.error(`Análise: falha ao montar "${view.id}"`, err);
      host.innerHTML = `
        <div class="an-empty">
          <i class="fas fa-triangle-exclamation"></i>
          <h3>Não foi possível carregar</h3>
          <p>Tente recarregar a página. Se continuar, o servidor pode estar fora do ar.</p>
        </div>`;
    }
  }

  /**
   * Re-renderiza uma view — usado depois de salvar ou excluir. Com `viewId`
   * também troca de tela: era `goTo(x)` seguido de `refresh()`, o que montava
   * a view duas vezes e refazia o fetch da lista inteira à toa.
   */
  async refresh(viewId) {
    const alvo = viewId || this.currentView;
    if (alvo) await this.goTo(alvo);
    this._refreshFooter();
  }

  async _refreshFooter() {
    try {
      const [roster, matches] = await Promise.all([
        AnaliseStore.get('roster').catch(() => []),
        AnaliseStore.get('matches').catch(() => [])
      ]);
      AnaliseShell.setFooter({
        players: (roster || []).filter(r => r.active !== false).length,
        matches: (matches || []).length
      });
    } catch (_) {
      // rodapé é informativo; falha não quebra a página
    }
  }

  _resolveView(name) {
    if (!name) return 'dashboard';
    if (Analise.LEGACY[name]) return Analise.LEGACY[name];
    return Analise.VIEWS.some(v => v.id === name) ? name : 'dashboard';
  }

  _viewFromUrl() {
    try {
      return new URLSearchParams(window.location.search).get('v');
    } catch (_) {
      return null;
    }
  }

  _syncUrl(viewId) {
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.get('v') === viewId) return;
      url.searchParams.set('v', viewId);
      history.replaceState(null, '', url);
    } catch (_) {
      // history bloqueado (harness em file://) não pode derrubar a navegação
    }
  }
}

window.analise = new Analise();


/* ===== js/scrim.js ===== */
// =====================================================
// ZDVAL - Scrim Arena Module
// Sistema de marcação de treinos entre times
// =====================================================

// Compatibility shim — wraps global toast system
const utils = {
  toast(message, type = 'info') {
    const titles = { success: 'Sucesso', error: 'Erro', warning: 'Atenção', info: 'Info' };
    if (typeof toast !== 'undefined' && toast[type]) {
      toast[type](titles[type] || 'Aviso', message);
    } else {
      console.warn('[utils.toast]', type, message);
    }
  }
};

// ── Global Premium Notification ──────────────────────
function showPremiumNotification({ type = 'received', title, subtitle, team1, team2, maps = [], hour, date, duration = 6000, onAction, actionLabel }) {
  try {
    // Remove any existing premium notification
    const existing = document.querySelector('.premium-notif-overlay');
    if (existing) existing.remove();

    const overlay = document.createElement('div');
    overlay.className = 'premium-notif-overlay';
    overlay.onclick = (e) => { if (e.target === overlay) closePremiumNotification(overlay); };

    const variant = type === 'sent' ? 'premium-notif-sent' : 'premium-notif-received';
    const iconClass = type === 'sent' ? 'fa-paper-plane' : 'fa-bolt';
    const mapsStr = maps.length > 0 ? maps.join(', ') : '';
    const hourStr = hour != null ? String(hour).padStart(2, '0') + ':00' : '';
    const dateStr = date || '';

    // Generate random particles
    let particlesHtml = '';
    for (let i = 0; i < 12; i++) {
      const px = (Math.random() - 0.5) * 200;
      const py = -(Math.random() * 120 + 30);
      const delay = Math.random() * 0.5;
      particlesHtml += `<div class="premium-notif-particle" style="left:50%;top:50%;--px:${px}px;--py:${py}px;animation-delay:${delay}s"></div>`;
    }

    overlay.innerHTML = `
      <div class="premium-notif ${variant}" style="--notif-duration:${duration}ms">
        <div class="premium-notif-glow"></div>
        <div class="premium-notif-particles">${particlesHtml}</div>
        <div class="premium-notif-header">
          <div class="premium-notif-icon"><i class="fas ${iconClass}"></i></div>
          <div class="premium-notif-title">${title}</div>
          <div class="premium-notif-subtitle">${subtitle}</div>
        </div>
        <div class="premium-notif-teams">
          <div class="premium-notif-team">
            <img src="${team1?.logo || '/img/default-team.png'}" alt="" class="premium-notif-team-logo">
            <div class="premium-notif-team-name">${team1?.name || 'Time'}<span class="premium-notif-team-tag">${team1?.tag ? ' [' + team1.tag + ']' : ''}</span></div>
          </div>
          <div class="premium-notif-vs">VS</div>
          <div class="premium-notif-team">
            <img src="${team2?.logo || '/img/default-team.png'}" alt="" class="premium-notif-team-logo">
            <div class="premium-notif-team-name">${team2?.name || 'Time'}<span class="premium-notif-team-tag">${team2?.tag ? ' [' + team2.tag + ']' : ''}</span></div>
          </div>
        </div>
        ${(mapsStr || hourStr || dateStr) ? `
        <div class="premium-notif-details">
          ${hourStr ? `<div class="premium-notif-detail"><i class="fas fa-clock"></i>${hourStr}</div>` : ''}
          ${dateStr ? `<div class="premium-notif-detail"><i class="fas fa-calendar-alt"></i>${dateStr}</div>` : ''}
          ${mapsStr ? `<div class="premium-notif-detail"><i class="fas fa-map"></i>${mapsStr}</div>` : ''}
        </div>` : ''}
        <div class="premium-notif-footer">
          ${onAction ? `<button class="premium-notif-btn premium-notif-btn-primary" id="premiumNotifAction"><i class="fas fa-check"></i> ${actionLabel || 'Ver'}</button>` : ''}
          <button class="premium-notif-btn ${onAction ? 'premium-notif-btn-ghost' : 'premium-notif-btn-primary'}" id="premiumNotifClose">${onAction ? 'Fechar' : 'Entendido'}</button>
        </div>
        <div class="premium-notif-progress"></div>
      </div>
    `;

    document.body.appendChild(overlay);

    // Double-rAF ensures DOM insertion is committed before triggering transition
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        overlay.classList.add('active');
      });
    });

    // Button handlers
    const closeBtn = overlay.querySelector('#premiumNotifClose');
    if (closeBtn) closeBtn.onclick = () => closePremiumNotification(overlay);
    if (onAction) {
      const actionBtn = overlay.querySelector('#premiumNotifAction');
      if (actionBtn) actionBtn.onclick = () => { closePremiumNotification(overlay); onAction(); };
    }

    // Auto-close
    if (window._premiumNotifTimer) clearTimeout(window._premiumNotifTimer);
    window._premiumNotifTimer = setTimeout(() => closePremiumNotification(overlay), duration);
  } catch (err) {
    console.error('[PremiumNotif] Error showing notification:', err);
  }
}

function closePremiumNotification(overlay) {
  if (!overlay || !overlay.parentNode) return;
  if (window._premiumNotifTimer) { clearTimeout(window._premiumNotifTimer); window._premiumNotifTimer = null; }
  overlay.classList.remove('active');
  setTimeout(() => { if (overlay.parentNode) overlay.remove(); }, 500);
}

// Make globally accessible
window.showPremiumNotification = showPremiumNotification;
window.closePremiumNotification = closePremiumNotification;

class ScrimArena {
  /**
   * Formatadores de data criados uma vez.
   *
   * `toLocaleDateString(locale, options)` constroi um Intl.DateTimeFormat novo
   * a cada chamada: medido nesta pagina, 98,4 us contra 1,6 us do formatador
   * reusado — 61x. Onze das dezessete chamadas ficavam dentro de laco (board
   * do dia, agenda, pool de mapas, historico), entao numa lista de 200 itens
   * eram 19,7 ms jogados fora por render. A saida e identica: e a mesma API
   * por baixo, so sem reconstruir o formatador.
   */
  static FMT = {
    diaSemanaLongo: new Intl.DateTimeFormat('pt-BR', { weekday: 'long', day: '2-digit', month: 'long' }),
    hora:           new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit' }),
    diaMes:         new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit' }),
    diaMesAno:      new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }),
    diaMesLongoAno: new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' }),
    mesLongo:       new Intl.DateTimeFormat('pt-BR', { month: 'long' }),
    mesCurto:       new Intl.DateTimeFormat('pt-BR', { month: 'short' }),
    diaSemanaCurto: new Intl.DateTimeFormat('pt-BR', { weekday: 'short' })
  };

  constructor() {
    this.scrims = [];
    this.publicScrims = [];
    this.myPublicScrims = [];
    this.availability = [];
    this.weeklySchedule = {};
    this.currentTab = 'board';
    this.currentFilter = 'all';
    this.maps = [];
    this.detailScrim = null;
    this.messages = [];
    this.agendaView = 'list';
    this.calendarDate = new Date();
    this._saving = false;
  }

  // ── Load ──────────────────────────────────────────

  async load() {
    const container = document.getElementById('page-scrim');
    if (!container) return;

    container.innerHTML = `
      <div class="scrim-loading">
        <div class="scrim-loading-spinner"></div>
        <span>Carregando Scrim Arena...</span>
      </div>`;

    try {
      this.maps = (typeof app.getMaps === 'function' ? app.getMaps() : app.maps) || [];
      // Only fetch what the default tab (board) needs + scrims for badge count
      await Promise.all([this.fetchScrims(), this.fetchBoardAvailability()]);
      this.render();
    } catch (err) {
      console.error('Scrim load error:', err);
      container.innerHTML = `<div class="scrim-error"><i class="fas fa-exclamation-triangle"></i> Erro ao carregar Scrim Arena</div>`;
    }
  }

  async fetchScrims() {
    if (!app.currentTeam) return;
    const res = await api.get(`/scrims/team/${app.currentTeam.id}?limit=100`);
    if (res.success) this.scrims = res.data.scrims;
  }

  async fetchAvailability() {
    if (!app.currentTeam) return;
    const res = await api.get(`/scrims/availability/${app.currentTeam.id}`);
    if (res.success) this.availability = res.data.slots;
  }

  async fetchPublicScrims() {
    if (!app.currentTeam) return;
    const res = await api.get(`/scrims/public?teamId=${app.currentTeam.id}`);
    if (res.success) this.publicScrims = res.data.scrims;
  }

  async fetchMyPublicScrims() {
    if (!app.currentTeam) return;
    const res = await api.get(`/scrims/my-public/${app.currentTeam.id}`);
    if (res.success) this.myPublicScrims = res.data.scrims;
  }

  async fetchBoardAvailability() {
    if (!app.currentTeam) return;
    const res = await api.get(`/scrims/board-availability?teamId=${app.currentTeam.id}&days=30`);
    if (res.success) this.boardAvailability = res.data.entries || [];
  }

  // ── Main Render ──────────────────────────────────

  render() {
    const container = document.getElementById('page-scrim');
    if (!container) return;

    const pendingReceived = this.scrims.filter(s =>
      s.status === 'pending' && s.opponent_team_id === app.currentTeam?.id
    ).length;

    container.innerHTML = `
      <div class="scrim-container">
        <!-- Tabs -->
        <div class="scrim-tabs">
          <button class="scrim-tab ${this.currentTab === 'board' ? 'active' : ''}" data-tab="board" onclick="scrimArena.switchTab('board')">
            <i class="fas fa-globe"></i> Board Público
          </button>
          <button class="scrim-tab ${this.currentTab === 'schedule' ? 'active' : ''}" data-tab="schedule" onclick="scrimArena.switchTab('schedule')">
            <i class="fas fa-calendar-check"></i> Disponibilidade
          </button>
          <button class="scrim-tab ${this.currentTab === 'agenda' ? 'active' : ''}" data-tab="agenda" onclick="scrimArena.switchTab('agenda')">
            <i class="fas fa-calendar-alt"></i> Agenda
            ${pendingReceived > 0 ? `<span class="scrim-tab-badge">${pendingReceived}</span>` : ''}
          </button>
          <button class="scrim-tab ${this.currentTab === 'matches' ? 'active' : ''}" data-tab="matches" onclick="scrimArena.switchTab('matches')">
            <i class="fas fa-gamepad"></i> Partidas
          </button>
          <button class="scrim-tab ${this.currentTab === 'my-team' ? 'active' : ''}" data-tab="my-team" onclick="scrimArena.switchTab('my-team')">
            <i class="fas fa-users"></i> Meu Time
          </button>
        </div>

        <div id="scrimDaysBar">${this.currentTab === 'board' ? this.renderBoardDaysBar() : ''}</div>

        <!-- Tab Content -->
        <div class="scrim-content" id="scrimContent">
          ${this.renderTabContent()}
        </div>
      </div>
    `;

    this.setupSocketListeners();
  }

  // ── Tab switching ─────────────────────────────────

  async switchTab(tab) {
    this.currentTab = tab;

    // Update active tab immediately for responsiveness
    document.querySelectorAll('.scrim-tab').forEach(t => t.classList.remove('active'));
    document.querySelector(`.scrim-tab[data-tab="${tab}"]`)?.classList.add('active');

    const content = document.getElementById('scrimContent');
    if (!content) return;

    // Lazy-fetch only the data each tab needs
    if (tab === 'schedule') {
      await this.fetchDateAvailability();
    } else if (tab === 'board') {
      await this.fetchBoardAvailability();
    } else if (tab === 'agenda') {
      if (!this._agendaLoaded) {
        await this.fetchScrims();
        this._agendaLoaded = true;
      }
    } else if (tab === 'my-team') {
      if (typeof team !== 'undefined') {
        await team.loadTeamData();
      }
    }

    // Update days bar (only board uses external days bar)
    const daysBar = document.getElementById('scrimDaysBar');
    if (daysBar) daysBar.innerHTML = tab === 'board' ? this.renderBoardDaysBar() : '';

    if (tab === 'my-team' && typeof team !== 'undefined') {
      content.innerHTML = team.renderPageContent('scrim-team-page-content');
      return;
    }

    content.innerHTML = this.renderTabContent();
  }

  renderTabContent() {
    switch (this.currentTab) {
      case 'my-team':
        return typeof team !== 'undefined' ? team.renderPageContent('scrim-team-page-content') : '';
      case 'agenda': return this.renderAgenda();
      case 'board': return this.renderBoard();
      case 'schedule': return this.renderSchedule();
      case 'matches': return this.renderMatches();
      default: return '';
    }
  }

  // ── Agenda Tab ────────────────────────────────────

  renderAgenda() {
    const myTeamId = app.currentTeam?.id;
    if (!this._agendaSubTab) this._agendaSubTab = 'confirmed';

    const allScrims = this.scrims.filter(s =>
      ['pending', 'accepted', 'ready'].includes(s.status)
    );

    // Classify scrims
    const getHour = s => s.hour_start != null ? s.hour_start : new Date(s.scheduled_at).getHours();
    const confirmedAll = allScrims.filter(s => ['accepted', 'ready'].includes(s.status)).sort((a, b) => getHour(a) - getHour(b));
    const receivedAll = allScrims.filter(s => s.status === 'pending' && s.opponent_team_id === myTeamId).sort((a, b) => getHour(a) - getHour(b));
    const sentAll = allScrims.filter(s => s.status === 'pending' && s.challenger_team_id === myTeamId).sort((a, b) => getHour(a) - getHour(b));

    // Sub-tabs
    const tabs = [
      { key: 'confirmed', label: 'Confirmados', icon: 'fa-check-circle', count: confirmedAll.length, color: '#10b981' },
      { key: 'received',  label: 'Pendentes',   icon: 'fa-inbox',        count: receivedAll.length,  color: '#f59e0b' },
      { key: 'sent',      label: 'Enviados',    icon: 'fa-paper-plane',  count: sentAll.length,      color: '#3b82f6' }
    ];

    let html = `<div class="ag-subtabs">`;
    for (const tab of tabs) {
      const isActive = this._agendaSubTab === tab.key;
      html += `<button class="ag-subtab ${isActive ? 'active' : ''}" style="--tab-color: ${tab.color}" onclick="scrimArena.selectAgendaSubTab('${tab.key}')">
        <i class="fas ${tab.icon}"></i>
        <span class="ag-subtab-label">${tab.label}</span>
        ${tab.count > 0 ? `<span class="ag-subtab-badge" style="background: ${tab.color}">${tab.count}</span>` : ''}
      </button>`;
    }
    html += `</div>`;

    // Get scrims for current sub-tab
    let currentScrims;
    if (this._agendaSubTab === 'confirmed') currentScrims = confirmedAll;
    else if (this._agendaSubTab === 'received') currentScrims = receivedAll;
    else currentScrims = sentAll;

    if (currentScrims.length === 0) {
      const emptyMessages = {
        confirmed: { icon: 'fa-check-circle', title: 'Nenhum treino confirmado', desc: 'Treinos aceitos aparecerão aqui.' },
        received:  { icon: 'fa-inbox',        title: 'Nenhum treino pendente',   desc: 'Solicitações recebidas aparecerão aqui.' },
        sent:      { icon: 'fa-paper-plane',  title: 'Nenhum treino enviado',    desc: 'Envie treinos pelo Board Público.' }
      };
      const msg = emptyMessages[this._agendaSubTab];
      html += `<div class="scrim-empty">
        <div class="scrim-empty-icon"><i class="fas ${msg.icon}"></i></div>
        <h3>${msg.title}</h3>
        <p>${msg.desc}</p>
      </div>`;
      return html;
    }

    // Group by date
    const dateGroups = new Map();
    for (const s of currentScrims) {
      const d = new Date(s.scheduled_at);
      const dk = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
      if (!dateGroups.has(dk)) dateGroups.set(dk, []);
      dateGroups.get(dk).push(s);
    }

    const sortedDateKeys = [...dateGroups.keys()].sort();

    for (const dk of sortedDateKeys) {
      const scrims = dateGroups.get(dk);
      const selDate = new Date(dk + 'T12:00:00');
      const dateLabel = ScrimArena.FMT.diaSemanaLongo.format(selDate);

      html += `<div class="ag-date-header">
        <div class="ag-date-label"><i class="fas fa-calendar"></i> ${dateLabel}</div>
        <span class="ag-date-count">${scrims.length} treino${scrims.length !== 1 ? 's' : ''}</span>
      </div>`;

      html += `<div class="ag-cards-grid">`;
      for (const s of scrims) {
        if (this._agendaSubTab === 'confirmed') {
          html += this.renderConfirmedCard(s);
        } else if (this._agendaSubTab === 'received') {
          html += this.renderReceivedCard(s);
        } else {
          html += this.renderSentCard(s);
        }
      }
      html += `</div>`;
    }

    return html;
  }

  renderConfirmedCard(s) {
    const myTeamId = app.currentTeam?.id;
    const isChallenger = s.challenger_team_id === myTeamId;
    const oppName = isChallenger ? s.opponent_name : s.challenger_name;
    const oppTag = isChallenger ? s.opponent_tag : s.challenger_tag;
    const oppLogo = isChallenger ? s.opponent_logo : s.challenger_logo;

    const d = new Date(s.scheduled_at);
    const displayHour = s.hour_start != null ? s.hour_start : d.getHours();
    const timeLabel = `${String(displayHour).padStart(2, '0')}h00`;

    let mapItems = [];
    if (s.maps_pool && s.maps_pool.length > 0 && this.maps.length > 0) {
      mapItems = s.maps_pool.map(mid => this.maps.find(m => m.id === mid)).filter(Boolean);
    }
    if (mapItems.length === 0 && s.map_name) {
      mapItems = [{ name: s.map_name, image_url: s.map_image }];
    }
    const mapsStr = mapItems.length > 0 ? mapItems.map(m => m.name).join(', ') : 'Todos os Mapas';

    return `
      <div class="ag-card ag-card-confirmed" onclick="scrimArena.openDetail('${s.id}')">
        <div class="ag-card-top">
          <img src="${oppLogo || '/img/default-team.png'}" alt="" class="ag-card-logo">
          <div class="ag-card-details">
            <span class="ag-card-info"><strong>${oppName || '???'}</strong><span class="ag-card-tag">[${oppTag || ''}]</span><span class="ag-card-hour">${timeLabel}</span></span>
            <div class="ag-card-maps">${mapsStr}</div>
          </div>
          <button class="ag-card-chat-btn" onclick="event.stopPropagation(); scrimArena.openScrimChat('${s.id}')" title="Chat">
            <i class="fas fa-comment-dots"></i>
          </button>
        </div>
        <div class="ag-card-footer ag-card-footer-actions">
          <div class="ag-card-btn-confirmed">
            <i class="fas fa-check-circle"></i> Confirmado
          </div>
          <button class="ag-card-btn-outline" onclick="event.stopPropagation(); scrimArena.openCancelModal('${s.id}')">
            <i class="fas fa-calendar-xmark"></i> Desmarcar
          </button>
        </div>
      </div>`;
  }

  renderReceivedCard(s) {
    const oppName = s.challenger_name;
    const oppTag = s.challenger_tag;
    const oppLogo = s.challenger_logo;

    const d = new Date(s.scheduled_at);
    const displayHour = s.hour_start != null ? s.hour_start : d.getHours();
    const timeLabel = `${String(displayHour).padStart(2, '0')}h00`;

    let mapItems = [];
    if (s.maps_pool && s.maps_pool.length > 0 && this.maps.length > 0) {
      mapItems = s.maps_pool.map(mid => this.maps.find(m => m.id === mid)).filter(Boolean);
    }
    if (mapItems.length === 0 && s.map_name) {
      mapItems = [{ name: s.map_name, image_url: s.map_image }];
    }
    const mapsStr = mapItems.length > 0 ? mapItems.map(m => m.name).join(', ') : 'Mapas não definidos';

    return `
      <div class="ag-card ag-card-received">
        <div class="ag-card-top" onclick="scrimArena.openDetail('${s.id}')" style="cursor:pointer">
          <img src="${oppLogo || '/img/default-team.png'}" alt="" class="ag-card-logo">
          <div class="ag-card-details">
            <span class="ag-card-info"><strong>${oppName || '???'}</strong><span class="ag-card-tag">[${oppTag || ''}]</span><span class="ag-card-hour">${timeLabel}</span></span>
            <div class="ag-card-maps">${mapsStr}</div>
          </div>
          <button class="ag-card-chat-btn" onclick="event.stopPropagation(); scrimArena.openScrimChat('${s.id}')" title="Chat">
            <i class="fas fa-comment-dots"></i>
          </button>
        </div>
        <div class="ag-card-footer ag-card-footer-actions">
          <button class="ag-card-btn-accept" onclick="scrimArena.acceptScrim('${s.id}')">
            <i class="fas fa-check"></i> Aceitar
          </button>
          <button class="ag-card-btn-decline" onclick="scrimArena.openDeclineModal('${s.id}')">
            <i class="fas fa-times"></i> Recusar
          </button>
        </div>
      </div>`;
  }

  renderSentCard(s) {
    const oppName = s.opponent_name;
    const oppTag = s.opponent_tag;
    const oppLogo = s.opponent_logo;

    const d = new Date(s.scheduled_at);
    const displayHour = s.hour_start != null ? s.hour_start : d.getHours();
    const timeLabel = `${String(displayHour).padStart(2, '0')}h00`;

    let mapItems = [];
    if (s.maps_pool && s.maps_pool.length > 0 && this.maps.length > 0) {
      mapItems = s.maps_pool.map(mid => this.maps.find(m => m.id === mid)).filter(Boolean);
    }
    if (mapItems.length === 0 && s.map_name) {
      mapItems = [{ name: s.map_name, image_url: s.map_image }];
    }
    const mapsStr = mapItems.length > 0 ? mapItems.map(m => m.name).join(', ') : 'Mapas não definidos';

    return `
      <div class="ag-card ag-card-sent">
        <div class="ag-card-top" onclick="scrimArena.openDetail('${s.id}')" style="cursor:pointer">
          <img src="${oppLogo || '/img/default-team.png'}" alt="" class="ag-card-logo">
          <div class="ag-card-details">
            <span class="ag-card-info"><strong>${oppName || '???'}</strong><span class="ag-card-tag">[${oppTag || ''}]</span><span class="ag-card-hour">${timeLabel}</span></span>
            <div class="ag-card-maps">${mapsStr}</div>
          </div>
          <button class="ag-card-chat-btn" onclick="event.stopPropagation(); scrimArena.openScrimChat('${s.id}')" title="Chat">
            <i class="fas fa-comment-dots"></i>
          </button>
        </div>
        <div class="ag-card-footer ag-card-footer-actions">
          <div class="ag-card-btn-sent">
            <i class="fas fa-paper-plane"></i> Enviado
          </div>
          <button class="ag-card-btn-outline" onclick="event.stopPropagation(); scrimArena.openCancelModal('${s.id}')">
            <i class="fas fa-undo"></i> Desfazer
          </button>
        </div>
      </div>`;
  }

  openDeclineModal(id) {
    const scrim = this.scrims.find(s => s.id === id);
    if (!scrim) return;

    const oppName = scrim.challenger_name || '???';
    const oppTag = scrim.challenger_tag || '';
    const oppLogo = scrim.challenger_logo || '/img/default-team.png';

    const overlay = document.createElement('div');
    overlay.id = 'scrimDeclineOverlay';
    overlay.className = 'scrim-cancel-overlay';
    overlay.innerHTML = `
      <div class="scrim-cancel-card">
        <div class="scrim-cancel-icon" style="background: rgba(239,68,68,0.15);">
          <i class="fas fa-times-circle" style="color: #ef4444;"></i>
        </div>
        <h3 class="scrim-cancel-title">Recusar Treino</h3>
        <div class="scrim-cancel-team">
          <img src="${oppLogo}" alt="" class="scrim-cancel-team-logo">
          <span class="scrim-cancel-team-name">${oppName} <span style="color: rgba(255,255,255,0.3)">[${oppTag}]</span></span>
        </div>
        <textarea id="declineReasonText" class="scrim-cancel-textarea" placeholder="Motivo da recusa (opcional)..." maxlength="200"></textarea>
        <div class="scrim-cancel-actions">
          <button class="scrim-cancel-btn-secondary" onclick="scrimArena.closeDeclineModal()">
            <i class="fas fa-arrow-left"></i> Voltar
          </button>
          <button class="scrim-cancel-btn-danger" onclick="scrimArena.confirmDeclineScrim('${id}')">
            <i class="fas fa-times"></i> Recusar Treino
          </button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
    requestAnimationFrame(() => overlay.classList.add('active'));
  }

  closeDeclineModal() {
    const overlay = document.getElementById('scrimDeclineOverlay');
    if (overlay) {
      overlay.classList.remove('active');
      setTimeout(() => overlay.remove(), 300);
    }
  }

  async confirmDeclineScrim(id) {
    const textarea = document.getElementById('declineReasonText');
    const reason = textarea ? textarea.value.trim() : '';
    try {
      const res = await api.put(`/scrims/${id}/decline`, { reason });
      if (res.success) {
        if (typeof utils !== 'undefined') utils.toast('Treino recusado', 'info');
        const scrim = this.scrims.find(s => s.id === id) || this.detailScrim;
        if (scrim && socket.socket) {
          socket.socket.emit('scrim:declined', { scrimId: id, challengerTeamId: scrim.challenger_team_id });
        }
        this.closeDeclineModal();
        await this.fetchScrims();
        this.render();
      }
    } catch (err) {
      console.error('Decline error:', err);
      if (typeof utils !== 'undefined') utils.toast('Erro ao recusar treino', 'error');
    }
  }

  selectAgendaSubTab(tab) {
    this._agendaSubTab = tab;
    const content = document.getElementById('scrimContent');
    if (content) content.innerHTML = this.renderAgenda();
  }

  selectAgendaDate(dk) {
    this._agendaSelectedDate = dk;
    const content = document.getElementById('scrimContent');
    if (content) content.innerHTML = this.renderAgenda();
  }

  // ── Scrim Chat (opens detail modal and scrolls to chat) ──
  async openScrimChat(scrimId) {
    await this.openDetail(scrimId);
    // Scroll to chat and focus input
    setTimeout(() => {
      const chatEl = document.getElementById('scrimChatMessages');
      if (chatEl) chatEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const input = document.getElementById('scrimChatInput');
      if (input) input.focus();
    }, 350);
  }

  renderGroupedByDate(scrims) {
    // Group scrims by date only
    const groups = {};
    scrims.forEach(s => {
      const d = new Date(s.scheduled_at);
      const dateLabel = ScrimArena.FMT.diaSemanaLongo.format(d);
      const sortKey = d.toISOString().slice(0, 10);
      const timeStr = ScrimArena.FMT.hora.format(d);
      if (!groups[sortKey]) groups[sortKey] = { dateLabel, items: [] };
      groups[sortKey].items.push({ scrim: s, time: timeStr });
    });

    // Sort groups by date
    const sortedKeys = Object.keys(groups).sort();

    let html = '';
    for (const key of sortedKeys) {
      const group = groups[key];
      // Sort items within the day by time
      group.items.sort((a, b) => a.time.localeCompare(b.time));
      html += `
        <div class="scrim-date-group">
          <div class="scrim-date-header">
            <i class="fas fa-calendar"></i> ${group.dateLabel}
          </div>
          <div class="scrim-list">
            ${group.items.map(item => this.renderScrimRow(item.scrim)).join('')}
          </div>
        </div>`;
    }
    return html;
  }

  renderScrimRow(s) {
    const myTeamId = app.currentTeam?.id;
    const isChallenger = s.challenger_team_id === myTeamId;
    const oppName = isChallenger ? s.opponent_name : s.challenger_name;
    const oppTag = isChallenger ? s.opponent_tag : s.challenger_tag;
    const oppLogo = isChallenger ? s.opponent_logo : s.challenger_logo;

    const statusConfig = {
      pending:   { label: 'Pendente',   color: '#f59e0b', icon: 'fa-clock' },
      accepted:  { label: 'Confirmado', color: '#10b981', icon: 'fa-check-circle' },
      ready:     { label: 'Pronto',     color: '#3b82f6', icon: 'fa-play-circle' },
      completed: { label: 'Finalizado', color: '#6b7280', icon: 'fa-flag-checkered' },
      cancelled: { label: 'Cancelado',  color: '#ef4444', icon: 'fa-times-circle' },
      declined:  { label: 'Recusado',   color: '#ef4444', icon: 'fa-ban' },
      expired:   { label: 'Expirado',   color: '#6b7280', icon: 'fa-hourglass-end' }
    };
    const st = statusConfig[s.status] || statusConfig.pending;

    const isReceived = s.status === 'pending' && s.opponent_team_id === myTeamId;
    const won = s.status === 'completed' && s.winner_team_id === myTeamId;
    const lost = s.status === 'completed' && s.winner_team_id && s.winner_team_id !== myTeamId;

    const scoreStr = s.status === 'completed' && s.score_challenger != null
      ? `<span class="scrim-row-score ${won ? 'win' : lost ? 'loss' : ''}">${isChallenger ? s.score_challenger : s.score_opponent} - ${isChallenger ? s.score_opponent : s.score_challenger}</span>`
      : '';

    const borderClass = isReceived ? 'scrim-row-received' : won ? 'scrim-row-won' : lost ? 'scrim-row-lost' : '';

    const d = new Date(s.scheduled_at);
    const displayHour = s.hour_start != null ? s.hour_start : d.getHours();
    const timeLabel = `${String(displayHour).padStart(2, '0')}:00`;

    return `
      <div class="scrim-row ${borderClass}" onclick="scrimArena.openDetail('${s.id}')">
        <div class="scrim-row-status" style="--status-color: ${st.color}">
          <i class="fas ${st.icon}"></i> ${st.label}
        </div>

        <span class="scrim-row-time"><i class="fas fa-clock"></i> ${timeLabel}</span>

        <div class="scrim-row-teams">
          <div class="scrim-row-team scrim-row-team-my">
            <img src="${app.currentTeam?.logo_url || '/img/default-team.png'}" alt="" class="scrim-row-logo">
            <span>${app.currentTeam?.tag || 'MEU'}</span>
          </div>
          <span class="scrim-row-vs">${scoreStr || 'VS'}</span>
          <div class="scrim-row-team">
            <img src="${oppLogo || '/img/default-team.png'}" alt="" class="scrim-row-logo">
            <span>${oppTag || oppName || '???'}</span>
          </div>
        </div>

        <div class="scrim-row-meta">
          ${(() => {
            // Resolve maps from maps_pool (array of UUIDs) or fallback to single map_id
            let mapItems = [];
            if (s.maps_pool && s.maps_pool.length > 0 && this.maps.length > 0) {
              mapItems = s.maps_pool.map(mid => this.maps.find(m => m.id === mid)).filter(Boolean);
            }
            if (mapItems.length === 0 && s.map_name) {
              mapItems = [{ name: s.map_name, image_url: s.map_image }];
            }
            return mapItems.map(m => `<div class="scrim-row-map-img"><img src="${m.image_url || '/img/maps/' + (m.name?.toLowerCase() || 'default') + '-preview.jpg'}" alt="${m.name}"><span>${m.name}</span></div>`).join('');
          })()}
          <span class="scrim-row-bo">MD${s.best_of || 1}</span>
        </div>

        ${isReceived ? `
        <div class="scrim-row-actions" onclick="event.stopPropagation()">
          <button class="scrim-btn-accept" onclick="scrimArena.acceptScrim('${s.id}')"><i class="fas fa-check"></i> Aceitar Treino</button>
          <button class="scrim-btn-decline" onclick="scrimArena.declineScrim('${s.id}')"><i class="fas fa-times"></i> Recusar</button>
        </div>` : `
        <div class="scrim-row-actions-right" onclick="event.stopPropagation()">
          <button class="scrim-btn-unschedule" onclick="scrimArena.openCancelModal('${s.id}')"><i class="fas fa-calendar-xmark"></i> Desmarcar</button>
          <i class="fas fa-chevron-right scrim-row-arrow-icon" onclick="scrimArena.openDetail('${s.id}')"></i>
        </div>`}
      </div>
    `;
  }

  filterScrims(filter) {
    this.currentFilter = filter;
    const content = document.getElementById('scrimContent');
    if (content) content.innerHTML = this.renderAgenda();
  }

  // ── Disponibilidade Tab (Date-based) ──────────────

  async fetchDateAvailability() {
    if (!app.currentTeam) return;
    try {
      const m = this.scheduleCalendarDate || new Date();
      const month = `${m.getFullYear()}-${String(m.getMonth() + 1).padStart(2, '0')}`;
      const res = await api.get(`/scrims/date-availability/${app.currentTeam.id}?month=${month}`);
      if (res.success) {
        this.dateAvailability = {};
        this.dateHourMaps = {};
        for (const row of res.data.dates) {
          const key = row.avail_date.slice(0, 10);
          this.dateAvailability[key] = row.hours || [];
          this.dateHourMaps[key] = row.hour_maps || {};
        }
      }
    } catch (err) {
      console.error('Fetch date availability error:', err);
    }
  }

  renderSchedule() {
    if (!this.scheduleCalendarDate) this.scheduleCalendarDate = new Date();
    if (!this.scheduleSelectedDate) this.scheduleSelectedDate = new Date();
    if (!this.dateAvailability) this.dateAvailability = {};
    if (!this.dateHourMaps) this.dateHourMaps = {};

    const cal = this.scheduleCalendarDate;
    const sel = this.scheduleSelectedDate;
    const selKey = `${sel.getFullYear()}-${String(sel.getMonth() + 1).padStart(2, '0')}-${String(sel.getDate()).padStart(2, '0')}`;

    const monthNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
    const year = cal.getFullYear();
    const month = cal.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const today = new Date();
    const todayKey = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    const selDateDisplay = ScrimArena.FMT.diaSemanaLongo.format(sel);
    const selectedHours = this.dateAvailability[selKey] || [];
    const hourMaps = this.dateHourMaps[selKey] || {};
    const allMaps = this.maps || [];
    const allMapIds = allMaps.map(m => m.id);

    // Calendar cells
    const startDay = (firstDay + 6) % 7;
    let calCells = '';
    for (let i = 0; i < startDay; i++) calCells += `<div class="sdcal-cell sdcal-cell-empty"></div>`;
    for (let d = 1; d <= daysInMonth; d++) {
      const dateKey = `${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
      const isToday = dateKey === todayKey;
      const isSelected = dateKey === selKey;
      const isPast = dateKey < todayKey;
      const hasAvail = !isPast && this.dateAvailability[dateKey] && this.dateAvailability[dateKey].length > 0;
      let cls = 'sdcal-cell';
      if (isPast) cls += ' sdcal-past';
      if (isToday) cls += ' sdcal-today';
      if (isSelected && !isPast) cls += ' sdcal-selected';
      if (isPast) {
        calCells += `<div class="${cls}"><span>${d}</span></div>`;
      } else {
        calCells += `<div class="${cls}" onclick="scrimArena.selectScheduleDate(${year}, ${month}, ${d})">
          <span>${d}</span>${hasAvail ? '<div class="sdcal-dot"></div>' : ''}</div>`;
      }
    }

    // Check if all hours are selected (for global toggle)
    const allHoursRange = [];
    for (let h = 0; h <= 23; h++) allHoursRange.push(h);
    const allHoursSelected = allHoursRange.every(h => selectedHours.includes(h));

    // Time pills (compact grid)
    let hourPillsHtml = '';
    for (let h = 0; h <= 23; h++) {
      const isActive = selectedHours.includes(h);
      const isPastHour = this._isHourPast(selKey, h);
      if (isPastHour) {
        hourPillsHtml += `<button class="sd-hour-pill sd-hour-past" disabled>${String(h).padStart(2, '0')}h00</button>`;
      } else {
        hourPillsHtml += `<button class="sd-hour-pill ${isActive ? 'active' : ''}" onclick="scrimArena.toggleDateHour('${selKey}', ${h})">${String(h).padStart(2, '0')}h00</button>`;
      }
    }

    // Map rows for active hours only (exclude past hours)
    let activeMapRows = '';
    const activeHours = selectedHours.filter(h => !this._isHourPast(selKey, h)).sort((a, b) => a - b);
    if (activeHours.length > 0) {
      activeMapRows = activeHours.map(h => {
        const hKey = String(h);
        const hMaps = hourMaps[hKey] || [];
        return `
          <div class="sd-map-row">
            <div class="sd-map-row-hour">${String(h).padStart(2, '0')}h</div>
            <div class="sd-map-row-cards">
              ${allMaps.map(m => {
                const isSel = hMaps.includes(m.id);
                const splash = m.splash || m.listViewIcon || m.image_url;
                return `<div class="sd-map-card ${isSel ? 'active' : ''}" onclick="scrimArena.toggleDateHourMap('${selKey}', ${h}, '${m.id}')">
                  <img src="${splash}" alt="${m.name}">
                  <div class="sd-map-card-overlay"></div>
                  <span class="sd-map-card-name">${(m.display_name || m.name).toUpperCase()}</span>
                  ${isSel ? '<div class="sd-map-card-check"><i class="fas fa-check"></i></div>' : ''}
                </div>`;
              }).join('')}
            </div>
          </div>`;
      }).join('');
    }

    return `
      <div class="sd-container">
        <div class="sd-panel sd-panel-calendar">
          <div class="sd-panel-label">DATA SELECIONADA</div>
          <div class="sd-selected-date">${selDateDisplay}</div>
          
          <div class="sd-cal-header">
            <div class="sd-cal-month">${monthNames[month]} de ${year}</div>
            <div class="sd-cal-nav">
              <button onclick="scrimArena.scheduleCalendarPrev()"><i class="fas fa-chevron-left"></i></button>
              <button onclick="scrimArena.scheduleCalendarNext()"><i class="fas fa-chevron-right"></i></button>
            </div>
          </div>
          <div class="sdcal-grid">
            <div class="sdcal-header">S</div><div class="sdcal-header">T</div><div class="sdcal-header">Q</div><div class="sdcal-header">Q</div><div class="sdcal-header">S</div><div class="sdcal-header">S</div><div class="sdcal-header">D</div>
            ${calCells}
          </div>
        </div>

        <div class="sd-panel sd-panel-times">
          <div class="sd-times-header">
            <div class="sd-times-title"><i class="fas fa-clock"></i> Horários Disponíveis</div>
            <p class="sd-times-desc">Selecione os horários e mapas que seu time está disponível para treinar neste dia.</p>
          </div>

          <div class="sd-hour-grid">
            ${hourPillsHtml}
          </div>

          ${activeMapRows ? `
          <div class="sd-map-section">
            <div class="sd-map-section-title"><i class="fas fa-map-marked-alt"></i> Mapas por Horário</div>
            ${activeMapRows}
          </div>` : ''}


        </div>
      </div>`;
  }

  selectScheduleDate(year, month, day) {
    const today = new Date();
    today.setHours(0,0,0,0);
    const target = new Date(year, month, day);
    if (target < today) return;
    this.scheduleSelectedDate = target;
    const content = document.getElementById('scrimContent');
    if (content) content.innerHTML = this.renderSchedule();
  }

  // Check if an hour slot is in the past (with 15 min grace before next hour)
  _isHourPast(dateKey, hour) {
    const now = new Date();
    const todayKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    if (dateKey > todayKey) return false;
    if (dateKey < todayKey) return true;
    // Today: hour is past if current time >= hour:00 minus 15 min
    const nowMinutes = now.getHours() * 60 + now.getMinutes();
    const hourStart = hour * 60;
    return nowMinutes >= (hourStart - 15);
  }

  scheduleCalendarPrev() {
    const d = this.scheduleCalendarDate || new Date();
    d.setMonth(d.getMonth() - 1);
    this.scheduleCalendarDate = d;
    this.fetchDateAvailability().then(() => {
      const content = document.getElementById('scrimContent');
      if (content) content.innerHTML = this.renderSchedule();
    });
  }

  scheduleCalendarNext() {
    const d = this.scheduleCalendarDate || new Date();
    d.setMonth(d.getMonth() + 1);
    this.scheduleCalendarDate = d;
    this.fetchDateAvailability().then(() => {
      const content = document.getElementById('scrimContent');
      if (content) content.innerHTML = this.renderSchedule();
    });
  }

  toggleDateHour(dateKey, hour) {
    if (this._isHourPast(dateKey, hour)) return;
    if (!this.dateAvailability[dateKey]) this.dateAvailability[dateKey] = [];
    if (!this.dateHourMaps[dateKey]) this.dateHourMaps[dateKey] = {};
    const arr = this.dateAvailability[dateKey];
    const hKey = String(hour);
    const idx = arr.indexOf(hour);
    if (idx >= 0) {
      arr.splice(idx, 1);
      delete this.dateHourMaps[dateKey][hKey];
    } else {
      arr.push(hour);
      arr.sort((a, b) => a - b);
      // Auto-select all maps  
      this.dateHourMaps[dateKey][hKey] = (this.maps || []).map(m => m.id);
    }
    if (arr.length === 0) {
      delete this.dateAvailability[dateKey];
      delete this.dateHourMaps[dateKey];
    }
    const content = document.getElementById('scrimContent');
    if (content) content.innerHTML = this.renderSchedule();
    this._autoSave(dateKey);
  }

  toggleDateHourMap(dateKey, hour, mapId) {
    if (!this.dateHourMaps[dateKey]) this.dateHourMaps[dateKey] = {};
    const hKey = String(hour);
    if (!this.dateHourMaps[dateKey][hKey]) this.dateHourMaps[dateKey][hKey] = [];
    const arr = this.dateHourMaps[dateKey][hKey];
    const idx = arr.indexOf(mapId);
    if (idx >= 0) {
      arr.splice(idx, 1);
    } else {
      arr.push(mapId);
    }
    const content = document.getElementById('scrimContent');
    if (content) content.innerHTML = this.renderSchedule();
    this._autoSave(dateKey);
  }

  toggleAllHours(dateKey) {
    const allHours = [];
    for (let h = 0; h <= 23; h++) allHours.push(h);
    const current = this.dateAvailability[dateKey] || [];
    const allSelected = allHours.every(h => current.includes(h));
    
    if (allSelected) {
      delete this.dateAvailability[dateKey];
      delete this.dateHourMaps[dateKey];
    } else {
      this.dateAvailability[dateKey] = [...allHours];
      if (!this.dateHourMaps[dateKey]) this.dateHourMaps[dateKey] = {};
      const allMapIds = (this.maps || []).map(m => m.id);
      for (const h of allHours) {
        if (!this.dateHourMaps[dateKey][String(h)]) {
          this.dateHourMaps[dateKey][String(h)] = [...allMapIds];
        }
      }
    }
    const content = document.getElementById('scrimContent');
    if (content) content.innerHTML = this.renderSchedule();
    this._autoSave(dateKey);
  }

  selectAllMapsForDate(dateKey) {
    const hours = this.dateAvailability[dateKey] || [];
    if (hours.length === 0) return utils.toast('Selecione pelo menos um horário primeiro', 'error');
    if (!this.dateHourMaps[dateKey]) this.dateHourMaps[dateKey] = {};
    const allMapIds = (this.maps || []).map(m => m.id);
    for (const h of hours) {
      this.dateHourMaps[dateKey][String(h)] = [...allMapIds];
    }
    const content = document.getElementById('scrimContent');
    if (content) content.innerHTML = this.renderSchedule();
    this._autoSave(dateKey);
  }

  _autoSave(dateKey) {
    if (this._saveTimer) clearTimeout(this._saveTimer);
    this._saveTimer = setTimeout(() => {
      if (!this._saving) {
        this.saveDateAvailability(dateKey);
      } else {
        // Queue save for when current save finishes
        this._pendingSave = dateKey;
      }
    }, 200);
  }

  async saveDateAvailability(dateKey) {
    if (!app.currentTeam) return;
    // If already saving, queue this save for later
    if (this._saving) {
      this._pendingSave = dateKey;
      return;
    }
    this._saving = true;
    const hours = this.dateAvailability[dateKey] || [];
    const hour_maps = this.dateHourMaps[dateKey] || {};
    try {
      const res = await api.put(`/scrims/date-availability/${app.currentTeam.id}`, { 
        date: dateKey, hours, hour_maps, weekly: false 
      });
      if (res.success) {
        utils.toast('Salvo!', 'success');
        // Refresh board data so Board Público is instantly up-to-date
        this.fetchBoardAvailability().catch(() => {});
      } else {
        utils.toast(res.error || 'Erro ao salvar', 'error');
      }
    } catch (err) {
      console.error('Save date availability error:', err);
      utils.toast('Erro ao salvar disponibilidade', 'error');
    } finally {
      this._saving = false;
      // Process queued save if any
      if (this._pendingSave) {
        const pendingKey = this._pendingSave;
        this._pendingSave = null;
        this.saveDateAvailability(pendingKey);
      }
    }
  }

  // ── Board Tab (Public Scrims) ─────────────────────

  renderBoardDaysBar() {
    // No external days bar needed — calendar is inside renderBoard sidebar
    return '';
  }

  _buildCalendarMonth(year, month, selKey, todayKey, availDates) {
    const firstDay = new Date(year, month, 1).getDay(); // 0=Sun
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const monthName = ScrimArena.FMT.mesLongo.format(new Date(year, month));
    const weekdays = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];

    let html = `<div class="bcs-cal-header">
      <button class="bcs-cal-nav" onclick="scrimArena.boardCalNav(-1)"><i class="fas fa-chevron-left"></i></button>
      <span class="bcs-cal-month">${monthName} ${year}</span>
      <button class="bcs-cal-nav" onclick="scrimArena.boardCalNav(1)"><i class="fas fa-chevron-right"></i></button>
    </div>`;
    html += '<div class="bcs-cal-grid">';
    for (const w of weekdays) html += `<span class="bcs-cal-wk">${w}</span>`;
    for (let i = 0; i < firstDay; i++) html += '<span class="bcs-cal-empty"></span>';
    for (let d = 1; d <= daysInMonth; d++) {
      const dk = `${year}-${String(month+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
      const isSel = dk === selKey;
      const isToday = dk === todayKey;
      const hasData = availDates.has(dk);
      const isPast = dk < todayKey;
      let cls = 'bcs-cal-day';
      if (isSel) cls += ' sel';
      if (isToday) cls += ' today';
      if (hasData) cls += ' has-data';
      if (isPast) cls += ' past';
      html += `<button class="${cls}" ${(!isPast && hasData) ? `onclick="scrimArena.selectBoardDate(${year}, ${month}, ${d})"` : 'disabled'}>${d}</button>`;
    }
    html += '</div>';
    return html;
  }

  boardCalNav(delta) {
    if (!this._boardCalMonth) {
      const now = new Date();
      this._boardCalMonth = { year: now.getFullYear(), month: now.getMonth() };
    }
    this._boardCalMonth.month += delta;
    if (this._boardCalMonth.month > 11) { this._boardCalMonth.month = 0; this._boardCalMonth.year++; }
    if (this._boardCalMonth.month < 0) { this._boardCalMonth.month = 11; this._boardCalMonth.year--; }
    const content = document.getElementById('scrimContent');
    if (content) content.innerHTML = this.renderBoard();
  }

  renderBoard() {
    const myTeamId = app.currentTeam?.id;
    const allMaps = this.maps || [];
    const entries = this.boardAvailability || [];

    if (!this.boardSelectedDate) this.boardSelectedDate = new Date();

    const today = new Date();
    const todayKey = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`;

    // Collect available dates
    const availDates = new Set();
    for (const e of entries) {
      const dk = (e.avail_date || '').slice(0, 10);
      if (dk && dk >= todayKey) availDates.add(dk);
    }

    // Auto-select first available date if current selection has no data
    let sel = this.boardSelectedDate;
    let selKey = `${sel.getFullYear()}-${String(sel.getMonth()+1).padStart(2,'0')}-${String(sel.getDate()).padStart(2,'0')}`;
    if (!availDates.has(selKey) && availDates.size > 0) {
      const firstAvail = [...availDates].sort()[0];
      const parts = firstAvail.split('-');
      sel = new Date(+parts[0], +parts[1] - 1, +parts[2]);
      this.boardSelectedDate = sel;
      selKey = firstAvail;
    }

    // Calendar month state
    if (!this._boardCalMonth) this._boardCalMonth = { year: sel.getFullYear(), month: sel.getMonth() };
    const calHtml = this._buildCalendarMonth(this._boardCalMonth.year, this._boardCalMonth.month, selKey, todayKey, availDates);

    // Upcoming dates list (next dates with availability)
    const upcomingDates = [...availDates].sort().slice(0, 7);
    let upcomingHtml = '';
    for (const dk of upcomingDates) {
      const dd = new Date(dk + 'T12:00:00');
      const dayName = ScrimArena.FMT.diaSemanaCurto.format(dd).replace('.', '');
      const dayNum = dd.getDate();
      const monthShort = ScrimArena.FMT.mesCurto.format(dd).replace('.', '');
      // Count unique teams on this date
      const teamsOnDate = new Set();
      for (const e of entries) {
        if ((e.avail_date || '').slice(0, 10) === dk) teamsOnDate.add(e.team_id);
      }
      const isSel = dk === selKey;
      upcomingHtml += `<button class="bcs-upcoming-item ${isSel ? 'sel' : ''}" onclick="scrimArena.selectBoardDate(${dd.getFullYear()}, ${dd.getMonth()}, ${dd.getDate()})">
        <div class="bcs-upcoming-date">
          <span class="bcs-upcoming-day">${dayNum}</span>
          <div class="bcs-upcoming-meta">
            <span class="bcs-upcoming-weekday">${dayName}</span>
            <span class="bcs-upcoming-month">${monthShort}</span>
          </div>
        </div>
        <span class="bcs-upcoming-teams"><i class="fas fa-users"></i> ${teamsOnDate.size}</span>
      </button>`;
    }

    // ── RIGHT PANEL: Build entries grouped by date → hour → teams ──
    const dateGroups = {};
    for (const entry of entries) {
      const dateKey = (entry.avail_date || '').slice(0, 10);
      if (!dateKey) continue;
      const isMine = entry.team_id === myTeamId;
      const hours = entry.hours || [];
      const hourMaps = entry.hour_maps || {};
      for (const h of hours) {
        if (!dateGroups[dateKey]) dateGroups[dateKey] = {};
        if (!dateGroups[dateKey][h]) dateGroups[dateKey][h] = [];
        const hKey = String(h);
        const mapIds = hourMaps[hKey] || [];
        const mapNames = mapIds.map(id => allMaps.find(m => m.id === id)).filter(Boolean);
        dateGroups[dateKey][h].push({
          team_id: entry.team_id, team_name: entry.team_name,
          team_tag: entry.team_tag, team_logo: entry.team_logo,
          maps: mapNames, isMine
        });
      }
    }

    const hoursObj = dateGroups[selKey] || {};
    const sortedHours = Object.keys(hoursObj).map(Number).sort((a,b) => a - b).filter(h => !this._isHourPast(selKey, h));

    const uniqueTeams = new Set();
    for (const h of sortedHours) { for (const t of hoursObj[h]) uniqueTeams.add(t.team_id); }

    if (!this._boardSelectedHour && sortedHours.length > 0) this._boardSelectedHour = sortedHours[0];
    const selHour = this._boardSelectedHour;
    const selHourValid = sortedHours.includes(selHour);
    const activeHour = selHourValid ? selHour : (sortedHours.length > 0 ? sortedHours[0] : null);

    // Hour pills
    let hourPillsHtml = '';
    if (sortedHours.length === 0) {
      hourPillsHtml = `<div class="bc-empty"><i class="fas fa-calendar-xmark"></i><p>Nenhum time disponível neste dia</p></div>`;
    } else {
      hourPillsHtml = '<div class="bc-hour-grid">';
      for (const h of sortedHours) {
        const isActive = h === activeHour;
        const teamCount = hoursObj[h].length;
        hourPillsHtml += `<button class="bc-hour-pill ${isActive ? 'active' : ''}" onclick="scrimArena.selectBoardHour(${h})">
          <span class="bc-pill-time">${String(h).padStart(2,'0')}h00</span>
          <span class="bc-pill-count">${teamCount} Time${teamCount !== 1 ? 's' : ''}</span>
        </button>`;
      }
      hourPillsHtml += '</div>';
    }

    // Team cards — 3-column grid layout
    let teamsHtml = '';
    if (activeHour !== null && hoursObj[activeHour]) {
      const teams = [...hoursObj[activeHour]].sort((a, b) => (b.isMine ? 1 : 0) - (a.isMine ? 1 : 0));
      teamsHtml = `<div class="bc-teams-section">
        <div class="bc-teams-title"><i class="fas fa-gamepad"></i> Treinos Disponíveis</div>
        <div class="bc-teams-grid">`;
      for (const team of teams) {
        const isMine = team.isMine;
        const mapsHtml = team.maps.length > 0
          ? team.maps.map(m => {
              const splash = m.splash || m.listViewIcon || m.image_url || '';
              return `<div class="bc-map-card">
                <img src="${splash}" alt="${m.name}">
                <div class="bc-map-card-overlay"></div>
                <span class="bc-map-card-name">${(m.display_name || m.name).toUpperCase()}</span>
              </div>`;
            }).join('')
          : '<div class="bc-map-card bc-map-card-all"><span class="bc-map-card-name">TODOS</span></div>';
        teamsHtml += `<div class="bc-team-card ${isMine ? 'bc-team-mine' : ''}">
          <div class="bc-card-section bc-card-header-section">
            <img src="${team.team_logo || '/img/default-team.png'}" alt="" class="bc-team-card-logo">
            <div class="bc-team-card-details">
              <span class="bc-team-card-info"><strong>${team.team_name}</strong><span class="bc-team-card-tag">[${team.team_tag || ''}]</span></span>
              <span class="bc-team-card-hour-badge"><i class="fas fa-clock"></i> ${String(activeHour).padStart(2,'0')}h00</span>
            </div>
          </div>
          <div class="bc-card-section bc-card-maps-section">
            <div class="bc-card-maps-label"><i class="fas fa-map"></i> Mapas</div>
            <div class="bc-card-maps-list">${mapsHtml}</div>
          </div>
          <div class="bc-team-card-footer">
            ${(() => {
              if (isMine) return '<span class="bc-team-card-mine"><i class="fas fa-star"></i> Meu Time</span>';
              const pendingChallenge = this.scrims.find(s =>
                s.status === 'pending' &&
                s.challenger_team_id === myTeamId &&
                s.opponent_team_id === team.team_id &&
                (s.scheduled_at || '').slice(0, 10) === selKey
              );
              if (pendingChallenge) {
                return `<div class="bc-team-card-sent">
                  <div class="bc-sent-badge">
                    <div class="bc-sent-badge-icon"><i class="fas fa-check"></i></div>
                    <div class="bc-sent-badge-text">
                      <span class="bc-sent-badge-title">Treino Enviado</span>
                      <span class="bc-sent-badge-sub">Aguardando resposta</span>
                    </div>
                  </div>
                  <button class="bc-team-card-cancel" onclick="event.stopPropagation(); scrimArena.cancelScrim('${pendingChallenge.id}')"><i class="fas fa-undo"></i> Desfazer</button>
                </div>`;
              }
              return `<button class="bc-team-card-btn" onclick="scrimArena.challengeTeam('${team.team_id}', '${selKey}', ${activeHour})">Solicitar</button>`;
            })()}
          </div>
        </div>`;
      }
      teamsHtml += `</div></div>`;
    }

    const selDateDisplay = ScrimArena.FMT.diaSemanaLongo.format(sel);

    return `
      <div class="bcs-layout">
        <!-- SIDEBAR -->
        <aside class="bcs-sidebar">
          <div class="bcs-cal-card">
            ${calHtml}
          </div>

          ${sortedHours.length > 0 ? `
          <div class="bcs-upcoming-card">
            <div class="bcs-upcoming-title"><i class="fas fa-clock"></i> Horários Disponíveis</div>
            <div class="bcs-upcoming-list">
              ${sortedHours.map(h => {
                const teamCount = hoursObj[h].length;
                const isActive = h === activeHour;
                return `<button class="bcs-upcoming-item ${isActive ? 'sel' : ''}" onclick="scrimArena.selectBoardHour(${h})">
                  <div class="bcs-upcoming-date">
                    <span class="bcs-upcoming-day" style="font-size:1.1rem">${String(h).padStart(2,'0')}h</span>
                  </div>
                  <span class="bcs-upcoming-teams"><i class="fas fa-users"></i> ${teamCount} ${teamCount === 1 ? 'time' : 'times'}</span>
                </button>`;
              }).join('')}
            </div>
          </div>` : ''}

        </aside>

        <!-- MAIN PANEL -->
        <main class="bcs-main">
          <div class="bcs-main-date">${selDateDisplay}</div>
          ${teamsHtml}
        </main>
      </div>`;
  }

  renderApplicationRow(a, scrim) {
    const wr = a.total_scrims > 0 ? ((a.total_wins / a.total_scrims) * 100).toFixed(0) : '—';
    const slots = a.slots || [];

    let slotsHtml = '';
    if (slots.length > 0) {
      slotsHtml = `
        <div class="scrim-app-slots">
          <span class="scrim-app-slots-label"><i class="fas fa-layer-group"></i> Slots solicitados:</span>
          <div class="scrim-app-slots-list">
            ${slots.map(slot => {
              const hourStr = String(slot.hour).padStart(2, '0') + ':00';
              const mapName = slot.map_name || 'Mapa não definido';
              const statusClass = slot.status === 'accepted' ? 'slot-accepted' : slot.status === 'declined' ? 'slot-declined' : 'slot-pending';
              const statusIcon = slot.status === 'accepted' ? 'check-circle' : slot.status === 'declined' ? 'times-circle' : 'clock';
              return `
                <div class="scrim-app-slot-item ${statusClass}">
                  <div class="scrim-app-slot-info">
                    <span class="scrim-app-slot-hour"><i class="fas fa-clock"></i> ${hourStr}</span>
                    <span class="scrim-app-slot-map"><i class="fas fa-map"></i> ${mapName}</span>
                    <span class="scrim-app-slot-status"><i class="fas fa-${statusIcon}"></i> ${slot.status === 'accepted' ? 'Aceito' : slot.status === 'declined' ? 'Recusado' : 'Pendente'}</span>
                  </div>
                  ${slot.status === 'pending' ? `
                  <div class="scrim-app-slot-actions">
                    <button class="scrim-btn-slot-accept" onclick="event.stopPropagation(); scrimArena.acceptSlot('${slot.id}')"><i class="fas fa-check"></i></button>
                    <button class="scrim-btn-slot-decline" onclick="event.stopPropagation(); scrimArena.declineSlot('${slot.id}')"><i class="fas fa-times"></i></button>
                  </div>` : ''}
                </div>`;
            }).join('')}
          </div>
        </div>`;
    }

    // Fallback: show old preferred_maps if no slots exist
    const prefMaps = a.preferred_maps_names || [];
    let legacyMapsHtml = '';
    if (slots.length === 0 && prefMaps.length > 0) {
      legacyMapsHtml = `
        <div class="scrim-app-maps">
          <span class="scrim-app-maps-label"><i class="fas fa-map"></i> Mapas desejados:</span>
          <div class="scrim-app-maps-tags">
            ${prefMaps.map(m => `<span class="scrim-map-tag">${m.name}</span>`).join('')}
          </div>
        </div>`;
    }

    const hasPendingSlots = slots.some(s => s.status === 'pending');

    return `
      <div class="scrim-app-row">
        <div class="scrim-app-team">
          <img src="${a.team_logo || '/img/default-team.png'}" alt="" class="scrim-row-logo">
          <div>
            <strong>${a.team_name}</strong> <span class="scrim-opp-tag">[${a.team_tag || ''}]</span>
            <div class="scrim-app-team-meta">
              <span><i class="fas fa-users"></i> ${a.member_count}</span>
              <span><i class="fas fa-gamepad"></i> ${a.total_scrims} scrims</span>
              <span><i class="fas fa-percentage"></i> ${wr}% WR</span>
              <span><i class="fas fa-trophy"></i> MD${slots.length || a.preferred_best_of}</span>
            </div>
          </div>
        </div>
        ${slotsHtml}
        ${legacyMapsHtml}
        ${a.message ? `<div class="scrim-app-msg"><i class="fas fa-comment"></i> ${SecurityUtils.escapeHtml(a.message)}</div>` : ''}
        ${a.status === 'pending' && slots.length === 0 ? `
        <div class="scrim-app-actions">
          <button class="scrim-btn-accept" onclick="scrimArena.acceptApplication('${a.id}')"><i class="fas fa-check"></i> Aceitar Tudo</button>
          <button class="scrim-btn-decline" onclick="scrimArena.declineApplication('${a.id}')"><i class="fas fa-times"></i> Recusar Tudo</button>
        </div>` : ''}
        ${a.status === 'pending' && hasPendingSlots ? `
        <div class="scrim-app-actions scrim-app-actions-bulk">
          <button class="scrim-btn-accept" onclick="scrimArena.acceptApplication('${a.id}')"><i class="fas fa-check-double"></i> Aceitar Tudo</button>
          <button class="scrim-btn-decline" onclick="scrimArena.declineApplication('${a.id}')"><i class="fas fa-times"></i> Recusar Tudo</button>
        </div>` : ''}
        ${a.status !== 'pending' ? `<span class="scrim-app-status-${a.status}">${a.status === 'accepted' ? 'Aceito' : a.status === 'declined' ? 'Recusado' : a.status}</span>` : ''}
      </div>
    `;
  }

  selectBoardDate(year, month, day) {
    const today = new Date(); today.setHours(0,0,0,0);
    const target = new Date(year, month, day);
    if (target < today) return;
    this.boardSelectedDate = target;
    this._boardSelectedHour = null;
    this._boardCalMonth = { year, month };
    const content = document.getElementById('scrimContent');
    if (content) content.innerHTML = this.renderBoard();
  }

  selectBoardHour(h) {
    this._boardSelectedHour = h;
    const content = document.getElementById('scrimContent');
    if (content) content.innerHTML = this.renderBoard();
  }

  async goToBoardHour(year, month, day, hour) {
    this.boardSelectedDate = new Date(year, month, day);
    this._boardSelectedHour = hour;
    this.currentTab = 'board';
    await this.fetchBoardAvailability();
    this.render();
  }

  toggleBoardHour(hourId) {
    const container = document.getElementById(hourId);
    const arrow = document.getElementById('arrow-' + hourId);
    if (!container) return;
    container.classList.toggle('scrim-board-hour-collapsed');
    if (arrow) arrow.classList.toggle('scrim-board-hour-arrow-open');
  }

  toggleBoardMap(el) {
    el.classList.toggle('selected');
    const entryKey = el.dataset.entryKey;
    // Show/hide send button based on selection for this specific entry
    const btn = document.querySelector(`.scrim-board-send-btn[data-entry-key="${entryKey}"]`);
    const selected = document.querySelectorAll(`.scrim-map-selectable.selected[data-entry-key="${entryKey}"]`);
    if (btn) btn.style.display = selected.length > 0 ? 'flex' : 'none';
  }

  async sendBoardProposal(entryKey) {
    const selected = document.querySelectorAll(`.scrim-map-selectable.selected[data-entry-key="${entryKey}"]`);
    if (selected.length === 0) return utils.toast('Selecione pelo menos um mapa', 'error');

    const btn = document.querySelector(`.scrim-board-send-btn[data-entry-key="${entryKey}"]`);
    const scrimId = btn?.dataset.scrimId;
    const hour = parseInt(btn?.dataset.hour);
    if (!scrimId || isNaN(hour)) return;

    const slots = [];
    selected.forEach(el => {
      slots.push({ hour, map_id: el.dataset.mapId });
    });

    try {
      const res = await api.post(`/scrims/apply/${scrimId}`, {
        team_id: app.currentTeam.id,
        slots,
        message: ''
      });

      if (res.success) {
        utils.toast('Treino enviado com sucesso!', 'success');
        await this.fetchPublicScrims();
        const content = document.getElementById('scrimContent');
        if (content) content.innerHTML = this.renderBoard();
      } else {
        utils.toast(res.error || 'Erro ao enviar proposta', 'error');
      }
    } catch (err) {
      console.error('Send board proposal error:', err);
      utils.toast('Erro ao enviar proposta', 'error');
    }
  }

  showMyPublicDetail(scrimId) {
    const s = this.myPublicScrims.find(x => x.id === scrimId);
    if (!s) return;
    // Scroll to the applications section
    const el = document.getElementById(`scrimApps-${scrimId}`);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  challengeTeam(teamId, dateKey, hour) {
    if (!app.currentTeam) return utils.toast('Selecione um time primeiro', 'error');
    if (teamId === app.currentTeam.id) return utils.toast('Você não pode enviar treino para seu próprio time', 'error');
    this.openChallengeModal(teamId, dateKey, hour);
  }

  async openChallengeModal(teamId, dateKey, clickedHour) {
    const entries = this.boardAvailability || [];
    const allMaps = this.maps || [];

    // Find entries for this team on this date
    const teamEntries = entries.filter(e => e.team_id === teamId && (e.avail_date || '').slice(0, 10) === dateKey);
    const teamInfo = teamEntries[0] || {};

    // Get maps for the clicked hour
    let hourMaps = [];
    for (const entry of teamEntries) {
      const hours = entry.hours || [];
      const hm = entry.hour_maps || {};
      if (hours.includes(clickedHour)) {
        const mapIds = hm[String(clickedHour)] || [];
        hourMaps = mapIds.length > 0
          ? mapIds.map(id => allMaps.find(m => m.id === id)).filter(Boolean)
          : [...allMaps];
        break;
      }
    }

    if (hourMaps.length === 0) return utils.toast('Nenhum mapa disponível', 'error');

    // Fetch team roster
    let rosterHtml = '';
    try {
      const res = await api.getTeamRoster(teamId);
      const members = res.data?.members || [];
      if (members.length > 0) {
        const roleLabels = { owner: 'Owner', coach: 'Coach', analyst: 'Analista', igl: 'IGL', player: 'Player' };
        const staff = members.filter(m => ['owner', 'coach', 'analyst'].includes(m.role));
        const players = members.filter(m => !['owner', 'coach', 'analyst'].includes(m.role));

        const renderMember = (m) => {
          const name = m.display_name || m.riot_id || 'Jogador';
          const avatar = m.avatar_url || '/img/default-avatar.png';
          const roleLabel = roleLabels[m.role] || m.role;
          return `<div class="scrim-solicitar-member">
            <img src="${avatar}" alt="" class="scrim-solicitar-member-avatar">
            <div class="scrim-solicitar-member-info">
              <span class="scrim-solicitar-member-name">${name}</span>
              <span class="scrim-solicitar-member-role">${roleLabel}</span>
            </div>
          </div>`;
        };

        if (players.length > 0) {
          rosterHtml += `<div class="scrim-solicitar-roster-section">
            <div class="scrim-solicitar-roster-label"><i class="fas fa-crosshairs"></i> Jogadores</div>
            ${players.map(renderMember).join('')}
          </div>`;
        }
        if (staff.length > 0) {
          rosterHtml += `<div class="scrim-solicitar-roster-section">
            <div class="scrim-solicitar-roster-label"><i class="fas fa-user-tie"></i> Staff</div>
            ${staff.map(renderMember).join('')}
          </div>`;
        }
      }
    } catch (e) {
      console.warn('Could not fetch team roster:', e);
    }

    // Store state
    this._challengeData = {
      teamId, dateKey, hour: clickedHour,
      selectedMaps: new Set()
    };

    const hourStr = String(clickedHour).padStart(2, '0') + 'h00';

    const modal = document.createElement('div');
    modal.className = 'scrim-modal-overlay';
    modal.id = 'scrimChallengeModal';
    modal.onclick = (e) => { if (e.target === modal) modal.remove(); };

    modal.innerHTML = `
      <div class="scrim-modal scrim-solicitar-modal">
        <div class="scrim-solicitar-content">
          <!-- Left: Hour + Maps -->
          <div class="scrim-solicitar-left">
            <div class="scrim-solicitar-hour-label">Treino</div>
            <div class="scrim-solicitar-hour">${hourStr}</div>
            <div class="scrim-solicitar-maps-label">Map selecção</div>
            <div class="scrim-solicitar-maps-grid">
              ${hourMaps.map(m => `
                <div class="scrim-solicitar-map" data-map-id="${m.id}" onclick="scrimArena.toggleSolicitarMap(this, '${m.id}')">
                  <img src="${m.image_url}" alt="${m.name}">
                  <span>${m.name}</span>
                </div>
              `).join('')}
            </div>
          </div>

          <!-- Right: Team Info + Roster + Actions -->
          <div class="scrim-solicitar-right">
            <button class="scrim-solicitar-close" onclick="document.getElementById('scrimChallengeModal').remove()"><i class="fas fa-times"></i></button>
            <div class="scrim-solicitar-team-label">Equipo info</div>
            <div class="scrim-solicitar-team">
              <img src="${teamInfo.team_logo || '/img/default-team.png'}" alt="" class="scrim-solicitar-team-logo">
              <div class="scrim-solicitar-team-info">
                <strong>${teamInfo.team_name || 'Time'}[${teamInfo.team_tag || ''}]</strong>
                <span>Equipo</span>
              </div>
            </div>
            ${rosterHtml}
            <div class="scrim-solicitar-bottom">
              <button class="scrim-solicitar-send-btn" onclick="scrimArena.submitSolicitar()">Enviar Treino</button>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(modal);
    requestAnimationFrame(() => modal.classList.add('active'));
  }

  toggleSolicitarMap(el, mapId) {
    const data = this._challengeData;
    if (!data) return;
    if (data.selectedMaps.has(mapId)) {
      data.selectedMaps.delete(mapId);
      el.classList.remove('selected');
    } else {
      data.selectedMaps.add(mapId);
      el.classList.add('selected');
    }
  }

  async submitSolicitar() {
    if (this._submittingChallenge) return;
    const data = this._challengeData;
    if (!data) return;

    const teamId = app.currentTeam?.id;
    if (!teamId) return utils.toast('Time não encontrado', 'error');

    const selectedMaps = [...data.selectedMaps];
    if (selectedMaps.length === 0) return utils.toast('Selecione pelo menos um mapa', 'error');

    // Gather team info for premium notification BEFORE closing modal
    const entries = this.boardAvailability || [];
    const oppEntry = entries.find(e => e.team_id === data.teamId);
    const oppTeam = {
      name: oppEntry?.team_name || 'Time',
      tag: oppEntry?.team_tag || '',
      logo: oppEntry?.team_logo || '/img/default-team.png'
    };
    const myTeam = {
      name: app.currentTeam?.name || 'Meu Time',
      tag: app.currentTeam?.tag || '',
      logo: app.currentTeam?.logo_url || '/img/default-team.png'
    };
    const mapNames = selectedMaps.map(id => {
      const m = (this.maps || []).find(mp => mp.id === id);
      return m ? m.name : '';
    }).filter(Boolean);
    const dateFormatted = data.dateKey ? ScrimArena.FMT.diaMes.format(new Date(data.dateKey + 'T12:00:00')) : '';

    this._submittingChallenge = true;

    // Close modal
    const modal = document.getElementById('scrimChallengeModal');
    if (modal) modal.remove();

    try {
      const res = await api.post('/scrims/challenge', {
        challenger_team_id: teamId,
        opponent_team_id: data.teamId,
        date: data.dateKey,
        hour: data.hour,
        maps_pool: selectedMaps,
        message: ''
      });

      if (res?.success) {
        // Premium notification for SENDER
        showPremiumNotification({
          type: 'sent',
          title: 'Treino Enviado!',
          subtitle: `Sua solicitação foi enviada para ${oppTeam.name}`,
          team1: myTeam,
          team2: oppTeam,
          maps: mapNames,
          hour: data.hour,
          date: dateFormatted,
          duration: 5000
        });

        // Emit socket event with full data for RECEIVER notification
        if (socket.socket) {
          socket.socket.emit('scrim:challenge', {
            opponentTeamId: data.teamId,
            challengerTeam: myTeam,
            opponentTeam: oppTeam,
            maps: mapNames,
            hour: data.hour,
            date: dateFormatted,
            dateKey: data.dateKey
          });
        }
      } else {
        utils.toast(res?.error || 'Erro ao enviar treino', 'error');
      }
    } catch (err) {
      utils.toast(err.message || 'Erro ao enviar treino', 'error');
    }

    this._submittingChallenge = false;
    this._challengeData = null;

    await Promise.all([
      this.fetchScrims().catch(() => {}),
      this.fetchBoardAvailability().catch(() => {})
    ]);
    const content = document.getElementById('scrimContent');
    if (content) content.innerHTML = this.renderBoard();
  }

  showMatchModal(scrimId, bestOfOptions) {
    const scrim = this.publicScrims.find(s => s.id === scrimId);
    if (!scrim) return;

    const ownerMaps = scrim?.maps_pool_names || [];
    const hourStart = scrim?.hour_start ?? 0;
    const hourEnd = scrim?.hour_end ?? 24;

    // Build hour options
    const hourOpts = [];
    for (let h = hourStart; h < hourEnd; h++) {
      hourOpts.push(`<option value="${h}">${String(h).padStart(2,'0')}:00</option>`);
    }

    // Build map options (from owner's pool or all maps)
    const availableMaps = ownerMaps.length > 0 ? ownerMaps : this.maps;
    const mapOpts = availableMaps.map(m => `<option value="${m.id}">${m.name}</option>`).join('');

    const modal = document.createElement('div');
    modal.className = 'scrim-modal-overlay';
    modal.id = 'scrimMatchModal';
    modal.onclick = (e) => { if (e.target === modal) modal.remove(); };

    modal.innerHTML = `
      <div class="scrim-modal scrim-modal-sm">
        <div class="scrim-modal-header scrim-modal-header-compact">
          <div class="scrim-modal-header-content">
            <h2><i class="fas fa-handshake"></i> Solicitar Treino</h2>
            <button class="scrim-modal-close" onclick="document.getElementById('scrimMatchModal').remove()"><i class="fas fa-times"></i></button>
          </div>
        </div>
        <div class="scrim-modal-body">
          ${ownerMaps.length > 0 ? `
          <div class="scrim-match-owner-maps">
            <span class="scrim-match-label"><i class="fas fa-map-marker-alt"></i> Mapas do adversário:</span>
            <div class="scrim-match-tags">${ownerMaps.map(m => `<span class="scrim-map-tag">${m.name}</span>`).join('')}</div>
          </div>` : ''}

          <div class="scrim-match-owner-maps">
            <span class="scrim-match-label"><i class="fas fa-clock"></i> Disponibilidade:</span>
            <div class="scrim-match-tags"><span class="scrim-map-tag">${String(hourStart).padStart(2,'0')}:00 — ${String(hourEnd).padStart(2,'0')}:00</span></div>
          </div>

          <div class="scrim-form-group">
            <label><i class="fas fa-layer-group"></i> Monte seus slots (cada slot = 1 jogo)</label>
            <div id="scrimMatchSlots" class="scrim-match-slots-container">
              <div class="scrim-match-slot-row" data-slot-idx="0">
                <select class="scrim-input scrim-slot-hour">
                  ${hourOpts.join('')}
                </select>
                <select class="scrim-input scrim-slot-map">
                  ${mapOpts}
                </select>
                <button type="button" class="scrim-slot-remove" onclick="this.closest('.scrim-match-slot-row').remove()" title="Remover"><i class="fas fa-trash"></i></button>
              </div>
            </div>
            <button type="button" class="scrim-slot-add-btn" onclick="scrimArena.addMatchSlotRow()">
              <i class="fas fa-plus"></i> Adicionar Slot
            </button>
          </div>

          <div class="scrim-form-group">
            <label><i class="fas fa-comment"></i> Mensagem (opcional)</label>
            <textarea id="scrimMatchMsg" class="scrim-input scrim-textarea" rows="2" placeholder="Algo que queira comunicar..."></textarea>
          </div>
          <button class="scrim-btn-challenge scrim-btn-full" onclick="scrimArena.submitMatch('${scrimId}')">
            <i class="fas fa-handshake"></i> Enviar Solicitação
          </button>
        </div>
      </div>
    `;

    // Store data for addMatchSlotRow
    modal.dataset.hourOpts = JSON.stringify(hourOpts);
    modal.dataset.mapOpts = mapOpts;

    document.body.appendChild(modal);
    requestAnimationFrame(() => modal.classList.add('active'));
  }

  addMatchSlotRow() {
    const container = document.getElementById('scrimMatchSlots');
    if (!container) return;
    const modal = document.getElementById('scrimMatchModal');
    const hourOpts = JSON.parse(modal.dataset.hourOpts || '[]');
    const mapOpts = modal.dataset.mapOpts || '';
    const idx = container.children.length;

    const row = document.createElement('div');
    row.className = 'scrim-match-slot-row';
    row.dataset.slotIdx = idx;
    row.innerHTML = `
      <select class="scrim-input scrim-slot-hour">
        ${hourOpts.join('')}
      </select>
      <select class="scrim-input scrim-slot-map">
        ${mapOpts}
      </select>
      <button type="button" class="scrim-slot-remove" onclick="this.closest('.scrim-match-slot-row').remove()" title="Remover"><i class="fas fa-trash"></i></button>
    `;
    container.appendChild(row);
  }

  async submitMatch(scrimId) {
    const message = document.getElementById('scrimMatchMsg')?.value || '';
    const slotRows = document.querySelectorAll('#scrimMatchSlots .scrim-match-slot-row');

    if (slotRows.length === 0) return utils.toast('Adicione pelo menos um slot', 'error');

    const slots = [];
    for (const row of slotRows) {
      const hour = parseInt(row.querySelector('.scrim-slot-hour')?.value);
      const map_id = row.querySelector('.scrim-slot-map')?.value;
      if (isNaN(hour)) return utils.toast('Selecione um horário para cada slot', 'error');
      if (!map_id) return utils.toast('Selecione um mapa para cada slot', 'error');
      slots.push({ hour, map_id });
    }

    // Check for duplicate hour+map combos
    const keys = slots.map(s => `${s.hour}-${s.map_id}`);
    if (new Set(keys).size !== keys.length) return utils.toast('Remova slots duplicados', 'error');

    try {
      const res = await api.post(`/scrims/apply/${scrimId}`, {
        team_id: app.currentTeam.id,
        slots,
        message
      });

      if (res.success) {
        utils.toast('Solicitação enviada! Aguardando resposta.', 'success');
        document.getElementById('scrimMatchModal')?.remove();
        await this.fetchPublicScrims();
        const content = document.getElementById('scrimContent');
        if (content) content.innerHTML = this.renderBoard();
      } else {
        utils.toast(res.error || 'Erro ao enviar match', 'error');
      }
    } catch (err) {
      console.error('Submit match error:', err);
      utils.toast('Erro ao enviar match', 'error');
    }
  }

  async acceptApplication(appId) {
    try {
      const res = await api.put(`/scrims/application/${appId}/accept`);
      if (res.success) {
        utils.toast('Todos os slots aceitos! Scrim confirmado.', 'success');
        await Promise.all([this.fetchMyPublicScrims(), this.fetchScrims()]);
      }
    } catch (err) {
      console.error('Accept application error:', err);
    }
  }

  async declineApplication(appId) {
    try {
      const res = await api.put(`/scrims/application/${appId}/decline`);
      if (res.success) {
        utils.toast('Aplicação recusada', 'info');
        await this.fetchMyPublicScrims();
        const content = document.getElementById('scrimContent');
        if (content) content.innerHTML = this.renderBoard();
      }
    } catch (err) {
      console.error('Decline application error:', err);
    }
  }

  async acceptSlot(slotId) {
    try {
      const res = await api.put(`/scrims/slot/${slotId}/accept`);
      if (res.success) {
        utils.toast('Slot aceito!', 'success');
        if (res.allResolved) {
          await Promise.all([this.fetchMyPublicScrims(), this.fetchScrims()]);
          this.render();
        } else {
          await this.fetchMyPublicScrims();
          const content = document.getElementById('scrimContent');
          if (content) content.innerHTML = this.renderBoard();
        }
      } else {
        utils.toast(res.error || 'Erro', 'error');
      }
    } catch (err) {
      console.error('Accept slot error:', err);
    }
  }

  async declineSlot(slotId) {
    try {
      const res = await api.put(`/scrims/slot/${slotId}/decline`);
      if (res.success) {
        utils.toast('Slot recusado', 'info');
        if (res.allResolved) {
          await Promise.all([this.fetchMyPublicScrims(), this.fetchScrims()]);
          this.render();
        } else {
          await this.fetchMyPublicScrims();
          const content = document.getElementById('scrimContent');
          if (content) content.innerHTML = this.renderBoard();
        }
      } else {
        utils.toast(res.error || 'Erro', 'error');
      }
    } catch (err) {
      console.error('Decline slot error:', err);
    }
  }

  // ── Detail Modal ──────────────────────────────────

  async openDetail(scrimId) {
    try {
      const res = await api.get(`/scrims/${scrimId}`);
      if (!res.success) return;

      this.detailScrim = res.data.scrim;
      this.messages = res.data.messages;
      this._proposals = [];

      // Fetch proposals
      try {
        const pRes = await api.get(`/scrims/${scrimId}/proposals`);
        if (pRes.success) this._proposals = pRes.data.proposals || [];
      } catch (e) { /* ignore */ }

      // Join socket room
      if (socket.socket) socket.socket.emit('scrim:join', scrimId);

      this.renderDetailModal();
    } catch (err) {
      console.error('Open scrim detail error:', err);
    }
  }

  renderDetailModal() {
    const s = this.detailScrim;
    if (!s) return;

    const myTeamId = app.currentTeam?.id;
    const isChallenger = s.challenger_team_id === myTeamId;
    const date = new Date(s.scheduled_at);

    const statusConfig = {
      pending:   { label: 'Pendente',   color: '#f59e0b', icon: 'fa-clock' },
      accepted:  { label: 'Confirmado', color: '#10b981', icon: 'fa-check-circle' },
      ready:     { label: 'Pronto',     color: '#3b82f6', icon: 'fa-play-circle' },
      completed: { label: 'Finalizado', color: '#6b7280', icon: 'fa-flag-checkered' },
      cancelled: { label: 'Cancelado',  color: '#ef4444', icon: 'fa-times-circle' },
      declined:  { label: 'Recusado',   color: '#ef4444', icon: 'fa-ban' },
    };
    const st = statusConfig[s.status] || { label: s.status, color: '#6b7280', icon: 'fa-question' };

    const isReceivedPending = s.status === 'pending' && s.opponent_team_id === myTeamId;
    const canCancel = s.status === 'pending' && s.challenger_team_id === myTeamId;
    const canComplete = ['accepted', 'ready'].includes(s.status);
    const canReschedule = !['completed', 'cancelled'].includes(s.status);

    const modal = document.createElement('div');
    modal.className = 'scrim-modal-overlay';
    modal.id = 'scrimDetailModal';
    modal.onclick = (e) => { if (e.target === modal) this.closeDetailModal(); };

    modal.innerHTML = `
      <div class="scrim-modal">
        <div class="scrim-modal-header">
          ${s.map_image ? `<div class="scrim-modal-map-bg" style="background-image:url('${s.map_image}')"></div>` : ''}
          <div class="scrim-modal-header-overlay"></div>
          <div class="scrim-modal-header-content">
            <span class="scrim-modal-status" style="--status-color:${st.color}"><i class="fas ${st.icon}"></i> ${st.label}</span>
            <button class="scrim-modal-close" onclick="scrimArena.closeDetailModal()"><i class="fas fa-times"></i></button>
          </div>
        </div>

        <div class="scrim-modal-body">
          <!-- Versus Section -->
          <div class="scrim-modal-versus">
            <div class="scrim-modal-team">
              <img src="${s.challenger_logo || '/img/default-team.png'}" alt="" class="scrim-modal-team-logo">
              <span class="scrim-modal-team-name">${s.challenger_name}</span>
              <span class="scrim-modal-team-tag">[${s.challenger_tag || ''}]</span>
            </div>
            <div class="scrim-modal-vs-center">
              ${s.status === 'completed' && s.score_challenger != null
                ? `<div class="scrim-modal-score">${s.score_challenger} — ${s.score_opponent}</div>`
                : `<div class="scrim-modal-vs-text">VS</div>`}
            </div>
            <div class="scrim-modal-team">
              <img src="${s.opponent_logo || '/img/default-team.png'}" alt="" class="scrim-modal-team-logo">
              <span class="scrim-modal-team-name">${s.opponent_name}</span>
              <span class="scrim-modal-team-tag">[${s.opponent_tag || ''}]</span>
            </div>
          </div>

          <!-- Chat -->
          <div class="scrim-modal-chat">
            <h4 class="scrim-modal-chat-title"><i class="fas fa-comments"></i> Chat do Scrim</h4>

            ${this._renderProposalBanner(s, myTeamId)}

            <div class="scrim-modal-chat-messages" id="scrimChatMessages">
              ${this.messages.length === 0 ? '<p class="scrim-chat-empty">Nenhuma mensagem ainda</p>' : ''}
              ${this.messages.map(m => this.renderMessage(m)).join('')}
            </div>
            <div class="scrim-modal-chat-input-row">
              ${['accepted','ready'].includes(s.status) ? `
              <div class="scrim-proposal-actions">
                <button class="scrim-proposal-btn scrim-proposal-btn-map" onclick="scrimArena.openProposalModal('map')" title="Trocar Mapa">
                  <i class="fas fa-map"></i>
                </button>
                <button class="scrim-proposal-btn scrim-proposal-btn-time" onclick="scrimArena.openProposalModal('reschedule')" title="Reagendar Horário">
                  <i class="fas fa-clock"></i>
                </button>
              </div>
              ` : ''}
              <div class="scrim-modal-chat-input">
                <input type="text" id="scrimChatInput" placeholder="Escreva uma mensagem..." onkeydown="if(event.key==='Enter')scrimArena.sendMessage()">
                <button onclick="scrimArena.sendMessage()"><i class="fas fa-paper-plane"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(modal);
    requestAnimationFrame(() => modal.classList.add('active'));

    // Scroll chat to bottom
    const chatEl = document.getElementById('scrimChatMessages');
    if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
  }

  renderMessage(m) {
    const isMine = m.team_id === app.currentTeam?.id;
    const time = ScrimArena.FMT.hora.format(new Date(m.created_at));
    return `
      <div class="scrim-chat-msg ${isMine ? 'scrim-chat-msg-mine' : ''}">
        <img src="${m.avatar_url || '/img/default-avatar.png'}" alt="" class="scrim-chat-avatar">
        <div class="scrim-chat-bubble">
          <span class="scrim-chat-name">${SecurityUtils.escapeHtml(m.display_name)} <span class="scrim-chat-team-tag">[${SecurityUtils.escapeHtml(m.team_tag || '')}]</span></span>
          <p>${SecurityUtils.escapeHtml(m.message)}</p>
          <span class="scrim-chat-time">${time}</span>
        </div>
      </div>
    `;
  }

  // ── Proposals (map change / reschedule) ──────────────

  _renderProposalBanner(s, myTeamId) {
    const pending = this._proposals.find(p => p.status === 'pending');
    if (!pending) return '';

    const isMine = pending.proposer_team_id === myTeamId;
    const proposerName = pending.proposer_name || 'Time';
    const proposerTag = pending.proposer_tag ? `[${pending.proposer_tag}]` : '';

    let changeDesc = '';
    if (pending.change_type === 'map') {
      const mapNames = (pending.new_maps_pool || []).map(mid => {
        const m = this.maps.find(x => x.id === mid);
        return m ? m.name : mid;
      }).join(', ');
      changeDesc = `<i class="fas fa-map"></i> Trocar mapa para: <strong>${mapNames}</strong>`;
    } else {
      const d = new Date(pending.new_scheduled_at);
      const dateStr = ScrimArena.FMT.diaMes.format(d);
      const timeStr = ScrimArena.FMT.hora.format(d);
      changeDesc = `<i class="fas fa-clock"></i> Reagendar para: <strong>${dateStr} às ${timeStr}</strong>`;
    }

    if (isMine) {
      return `
        <div class="scrim-proposal-banner scrim-proposal-banner-sent">
          <div class="scrim-proposal-banner-content">
            <div class="scrim-proposal-banner-title"><i class="fas fa-paper-plane"></i> Proposta enviada</div>
            <div class="scrim-proposal-banner-desc">${changeDesc}</div>
            <div class="scrim-proposal-banner-note">Aguardando resposta do adversário...</div>
          </div>
        </div>`;
    }

    return `
      <div class="scrim-proposal-banner scrim-proposal-banner-received">
        <div class="scrim-proposal-banner-content">
          <div class="scrim-proposal-banner-title"><i class="fas fa-bell"></i> ${proposerName} ${proposerTag} propôs uma alteração</div>
          <div class="scrim-proposal-banner-desc">${changeDesc}</div>
          <div class="scrim-proposal-banner-note">Se recusar, o treino será <strong>cancelado</strong>.</div>
        </div>
        <div class="scrim-proposal-banner-actions">
          <button class="scrim-proposal-banner-accept" onclick="scrimArena.acceptProposal('${pending.id}')">
            <i class="fas fa-check"></i> Aceitar
          </button>
          <button class="scrim-proposal-banner-reject" onclick="scrimArena.rejectProposal('${pending.id}')">
            <i class="fas fa-times"></i> Recusar
          </button>
        </div>
      </div>`;
  }

  openProposalModal(type) {
    // Check if there's already a pending proposal
    const pending = this._proposals.find(p => p.status === 'pending');
    if (pending) {
      if (typeof utils !== 'undefined') utils.toast('Já existe uma proposta pendente', 'error');
      return;
    }

    let overlay = document.getElementById('proposalModalOverlay');
    if (overlay) overlay.remove();

    overlay = document.createElement('div');
    overlay.id = 'proposalModalOverlay';
    overlay.className = 'scrim-proposal-overlay';
    overlay.onclick = (e) => { if (e.target === overlay) overlay.remove(); };

    const isMap = type === 'map';
    const title = isMap ? 'Trocar Mapa' : 'Reagendar Horário';
    const icon = isMap ? 'fa-map' : 'fa-clock';

    let bodyHtml = '';
    if (isMap) {
      const currentPool = this.detailScrim?.maps_pool || [];
      const mapCards = this.maps.map(m => {
        const isSelected = currentPool.includes(m.id);
        const splash = m.splash || m.image_url || '/img/maps/' + (m.name?.toLowerCase() || 'default') + '-preview.jpg';
        return `
          <div class="spm-card ${isSelected ? 'spm-card-current' : ''}" onclick="this.classList.toggle('spm-card-selected')" data-map-id="${m.id}">
            <img src="${splash}" alt="${m.name}" class="spm-card-bg">
            <div class="spm-card-overlay"></div>
            <div class="spm-card-content">
              <span class="spm-card-name">${m.name}</span>
              ${isSelected ? '<span class="spm-card-badge">atual</span>' : ''}
            </div>
            <div class="spm-card-check"><i class="fas fa-check"></i></div>
          </div>`;
      }).join('');
      bodyHtml = `
        <p class="scrim-proposal-modal-note">Selecione os novos mapas para o treino:</p>
        <div class="spm-grid">${mapCards}</div>
      `;
    } else {
      // Time-only picker (same day)
      const scrimDate = new Date(this.detailScrim.scheduled_at);
      const currentHour = scrimDate.getHours().toString().padStart(2, '0');
      const currentMin = scrimDate.getMinutes().toString().padStart(2, '0');
      const dateLabel = ScrimArena.FMT.diaSemanaLongo.format(scrimDate);

      const hourOptions = [];
      for (let h = 0; h < 24; h++) {
        const hStr = h.toString().padStart(2, '0');
        const sel = hStr === currentHour ? 'selected' : '';
        hourOptions.push(`<option value="${hStr}" ${sel}>${hStr}</option>`);
      }
      const minOptions = [];
      for (let m = 0; m < 60; m += 5) {
        const mStr = m.toString().padStart(2, '0');
        const sel = mStr === currentMin ? 'selected' : '';
        minOptions.push(`<option value="${mStr}" ${sel}>${mStr}</option>`);
      }

      bodyHtml = `
        <p class="scrim-proposal-modal-note">Altere o horário do treino:</p>
        <div class="spm-date-label"><i class="fas fa-calendar"></i> ${dateLabel}</div>
        <div class="spm-time-row">
          <div class="spm-time-group">
            <label>Hora</label>
            <select id="proposalHour" class="spm-time-select">${hourOptions.join('')}</select>
          </div>
          <span class="spm-time-sep">:</span>
          <div class="spm-time-group">
            <label>Minuto</label>
            <select id="proposalMinute" class="spm-time-select">${minOptions.join('')}</select>
          </div>
        </div>
        <div class="spm-current-time"><i class="fas fa-clock"></i> Horário atual: ${currentHour}:${currentMin}</div>
      `;
    }

    overlay.innerHTML = `
      <div class="scrim-proposal-modal">
        <div class="scrim-proposal-modal-header">
          <i class="fas ${icon}"></i> ${title}
        </div>
        <div class="scrim-proposal-modal-body">
          ${bodyHtml}
          <p class="scrim-proposal-modal-warning"><i class="fas fa-exclamation-triangle"></i> Se o adversário recusar, o treino será cancelado.</p>
        </div>
        <div class="scrim-proposal-modal-footer">
          <button class="scrim-proposal-modal-cancel" onclick="document.getElementById('proposalModalOverlay').remove()">Cancelar</button>
          <button class="scrim-proposal-modal-submit" onclick="scrimArena.submitProposal('${type}')">
            <i class="fas fa-paper-plane"></i> Enviar Proposta
          </button>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
  }

  async submitProposal(type) {
    if (!this.detailScrim) return;
    const scrimId = this.detailScrim.id;

    let body = { change_type: type };

    if (type === 'map') {
      const checked = [...document.querySelectorAll('.spm-card-selected')].map(c => c.dataset.mapId);
      if (checked.length === 0) {
        if (typeof utils !== 'undefined') utils.toast('Selecione pelo menos um mapa', 'error');
        return;
      }
      body.new_maps_pool = checked;
    } else {
      const hour = document.getElementById('proposalHour')?.value;
      const minute = document.getElementById('proposalMinute')?.value;
      if (hour == null || minute == null) {
        if (typeof utils !== 'undefined') utils.toast('Selecione um horário', 'error');
        return;
      }
      // Keep same date, just change time
      const scrimDate = new Date(this.detailScrim.scheduled_at);
      scrimDate.setHours(parseInt(hour), parseInt(minute), 0, 0);
      body.new_scheduled_at = scrimDate.toISOString();
    }

    try {
      const res = await api.post(`/scrims/${scrimId}/proposals`, body);
      if (res.success) {
        if (typeof utils !== 'undefined') utils.toast('Proposta enviada!', 'success');
        document.getElementById('proposalModalOverlay')?.remove();
        // Refresh detail
        await this.openDetail(scrimId);
      } else {
        if (typeof utils !== 'undefined') utils.toast(res.error || 'Erro ao enviar', 'error');
      }
    } catch (err) {
      console.error('Submit proposal error:', err);
      if (typeof utils !== 'undefined') utils.toast('Erro ao enviar proposta', 'error');
    }
  }

  async acceptProposal(proposalId) {
    if (!this.detailScrim) return;
    const scrimId = this.detailScrim.id;
    try {
      const res = await api.put(`/scrims/${scrimId}/proposals/${proposalId}/accept`);
      if (res.success) {
        if (typeof utils !== 'undefined') utils.toast('Proposta aceita! Scrim atualizado.', 'success');
        await this.openDetail(scrimId);
        await this.fetchScrims();
        this.render();
      } else {
        if (typeof utils !== 'undefined') utils.toast(res.error || 'Erro', 'error');
      }
    } catch (err) {
      console.error('Accept proposal error:', err);
    }
  }

  async rejectProposal(proposalId) {
    if (!this.detailScrim) return;
    const scrimId = this.detailScrim.id;

    const confirmed = await this.showConfirm(
      'Recusar proposta',
      'Se recusar, o treino será <strong>cancelado</strong>. Tem certeza?',
      'Recusar e Cancelar',
      'Voltar',
      'fas fa-exclamation-triangle',
      '#ef4444'
    );
    if (!confirmed) return;

    try {
      const res = await api.put(`/scrims/${scrimId}/proposals/${proposalId}/reject`);
      if (res.success) {
        if (typeof utils !== 'undefined') utils.toast('Proposta recusada. Treino cancelado.', 'error');
        this.closeDetailModal();
        await this.fetchScrims();
        this.render();
      } else {
        if (typeof utils !== 'undefined') utils.toast(res.error || 'Erro', 'error');
      }
    } catch (err) {
      console.error('Reject proposal error:', err);
    }
  }

  closeDetailModal() {
    const modal = document.getElementById('scrimDetailModal');
    if (modal) {
      modal.classList.remove('active');
      setTimeout(() => modal.remove(), 300);
    }
  }

  // ── Actions ───────────────────────────────────────

  async acceptScrim(id) {
    try {
      const res = await api.put(`/scrims/${id}/accept`);
      if (res.success) {
        if (typeof utils !== 'undefined') utils.toast('Treino aceito!', 'success');
        // Notify via socket
        const scrim = this.scrims.find(s => s.id === id) || this.detailScrim;
        if (scrim && socket.socket) {
          socket.socket.emit('scrim:accepted', { scrimId: id, challengerTeamId: scrim.challenger_team_id });
        }
        this.closeDetailModal();
        await this.fetchScrims();
        this.render();
      }
    } catch (err) {
      console.error('Accept error:', err);
    }
  }

  async declineScrim(id) {
    this.openDeclineModal(id);
  }

  showConfirm(title, message, confirmText = 'Confirmar', cancelText = 'Cancelar', icon = 'fas fa-exclamation-triangle', color = '#ff4655') {
    return new Promise(resolve => {
      const existing = document.getElementById('scrimConfirmOverlay');
      if (existing) existing.remove();

      const overlay = document.createElement('div');
      overlay.id = 'scrimConfirmOverlay';
      overlay.className = 'scrim-confirm-overlay';
      overlay.innerHTML = `
        <div class="scrim-confirm-card">
          <div class="scrim-confirm-glow" style="background:radial-gradient(circle,${color}15 0%,transparent 70%)"></div>
          <div class="scrim-confirm-icon-ring" style="border-color:${color}40;background:linear-gradient(135deg,${color}18,${color}08)">
            <i class="${icon}" style="color:${color}"></i>
          </div>
          <h3 class="scrim-confirm-title">${title}</h3>
          <p class="scrim-confirm-msg">${message}</p>
          <div class="scrim-confirm-actions">
            <button class="scrim-confirm-btn scrim-confirm-cancel" id="scrimConfirmCancel">
              <i class="fas fa-times"></i> ${cancelText}
            </button>
            <button class="scrim-confirm-btn scrim-confirm-ok" id="scrimConfirmOk" style="background:linear-gradient(135deg,${color},${color}cc);box-shadow:0 4px 20px ${color}40">
              <i class="${icon}" style="font-size:.85rem"></i> ${confirmText}
            </button>
          </div>
        </div>
      `;

      document.body.appendChild(overlay);
      requestAnimationFrame(() => overlay.classList.add('visible'));

      const cleanup = (val) => {
        overlay.classList.remove('visible');
        setTimeout(() => overlay.remove(), 250);
        resolve(val);
      };
      document.getElementById('scrimConfirmOk').addEventListener('click', () => cleanup(true));
      document.getElementById('scrimConfirmCancel').addEventListener('click', () => cleanup(false));
      overlay.addEventListener('click', (e) => { if (e.target === overlay) cleanup(false); });
    });
  }

  openCancelModal(id) {
    const scrim = this.scrims.find(s => s.id === id);
    if (!scrim) return;

    const myTeamId = app.currentTeam?.id;
    const isChallenger = scrim.challenger_team_id === myTeamId;
    const oppName = isChallenger ? scrim.opponent_name : scrim.challenger_name;
    const oppTag = isChallenger ? scrim.opponent_tag : scrim.challenger_tag;
    const oppLogo = isChallenger ? scrim.opponent_logo : scrim.challenger_logo;

    const d = new Date(scrim.scheduled_at);
    const h = scrim.hour_start != null ? scrim.hour_start : d.getHours();
    const timeLabel = `${String(h).padStart(2,'0')}:00`;
    const dateLabel = ScrimArena.FMT.diaMes.format(d);

    const existing = document.getElementById('scrimCancelModal');
    if (existing) existing.remove();

    const overlay = document.createElement('div');
    overlay.className = 'scrim-modal-overlay';
    overlay.id = 'scrimCancelModal';
    overlay.onclick = (e) => { if (e.target === overlay) { overlay.classList.remove('active'); setTimeout(() => overlay.remove(), 300); } };

    overlay.innerHTML = `
      <div class="scrim-cancel-card">
        <div class="scrim-cancel-header">
          <div class="scrim-cancel-icon"><i class="fas fa-calendar-xmark"></i></div>
          <h3>Desmarcar Treino</h3>
          <p class="scrim-cancel-sub">vs ${oppName || 'Time'} [${oppTag || ''}] — ${timeLabel} • ${dateLabel}</p>
        </div>
        <div class="scrim-cancel-opp">
          <img src="${oppLogo || '/img/default-team.png'}" alt="" class="scrim-cancel-opp-logo">
          <div class="scrim-cancel-opp-info">
            <strong>${oppName || 'Time'}</strong>
            <span>[${oppTag || ''}]</span>
          </div>
        </div>
        <div class="scrim-cancel-body">
          <label class="scrim-cancel-label"><i class="fas fa-pen"></i> Motivo da desmarcação</label>
          <textarea id="scrimCancelReason" class="scrim-cancel-textarea" placeholder="Ex: Jogador indisponível, conflito de horário..." rows="3"></textarea>
        </div>
        <div class="scrim-cancel-actions">
          <button class="scrim-cancel-btn-ghost" onclick="document.getElementById('scrimCancelModal').classList.remove('active'); setTimeout(() => document.getElementById('scrimCancelModal')?.remove(), 300)">
            <i class="fas fa-arrow-left"></i> Voltar
          </button>
          <button class="scrim-cancel-btn-danger" onclick="scrimArena.confirmCancelScrim('${id}')">
            <i class="fas fa-calendar-xmark"></i> Desmarcar Treino
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    requestAnimationFrame(() => { requestAnimationFrame(() => overlay.classList.add('active')); });
  }

  async confirmCancelScrim(id) {
    const reason = document.getElementById('scrimCancelReason')?.value?.trim() || '';
    const overlay = document.getElementById('scrimCancelModal');

    try {
      const res = await api.put(`/scrims/${id}/cancel`, { reason });
      if (res.success) {
        utils.toast('Treino desmarcado', 'info');
        const scrim = this.scrims.find(s => s.id === id) || this.detailScrim;
        if (scrim && socket.socket) {
          const myTeamId = app.currentTeam?.id;
          const targetTeamId = scrim.challenger_team_id === myTeamId ? scrim.opponent_team_id : scrim.challenger_team_id;
          socket.socket.emit('scrim:cancelled', { scrimId: id, targetTeamId });
        }
        if (overlay) { overlay.classList.remove('active'); setTimeout(() => overlay.remove(), 300); }
        this.closeDetailModal();
        await this.fetchScrims();
        this.render();
      } else {
        utils.toast(res?.error || 'Erro ao desmarcar', 'error');
      }
    } catch (err) {
      console.error('Cancel error:', err);
      utils.toast('Erro ao desmarcar treino', 'error');
    }
  }

  async cancelScrim(id) {
    this.openCancelModal(id);
  }

  async sendMessage() {
    const input = document.getElementById('scrimChatInput');
    if (!input || !input.value.trim() || !this.detailScrim) return;

    const message = input.value.trim();
    input.value = '';

    try {
      const res = await api.post(`/scrims/${this.detailScrim.id}/messages`, { message });
      if (res.success) {
        this.messages.push(res.data.message);
        const chatEl = document.getElementById('scrimChatMessages');
        if (chatEl) {
          const emptyEl = chatEl.querySelector('.scrim-chat-empty');
          if (emptyEl) emptyEl.remove();
          chatEl.insertAdjacentHTML('beforeend', this.renderMessage(res.data.message));
          chatEl.scrollTop = chatEl.scrollHeight;
        }
        // Notify via socket
        if (socket.socket) {
          socket.socket.emit('scrim:message', { scrimId: this.detailScrim.id, message: res.data.message });
        }
      }
    } catch (err) {
      console.error('Send message error:', err);
    }
  }

  // ── Partidas Tab ──────────────────────────────────

  renderMatches() {
    const myTeamId = app.currentTeam?.id;
    if (!myTeamId) return '<div class="scrim-empty"><h3>Selecione um time</h3></div>';

    const now = new Date();

    // Past accepted/ready scrims → waiting for result
    const pendingResult = this.scrims.filter(s =>
      ['accepted', 'ready'].includes(s.status) && new Date(s.scheduled_at) < now
    ).sort((a, b) => new Date(b.scheduled_at) - new Date(a.scheduled_at));

    // Completed scrims → already have result
    const completed = this.scrims.filter(s => s.status === 'completed')
      .sort((a, b) => new Date(b.scheduled_at) - new Date(a.scheduled_at));

    if (pendingResult.length === 0 && completed.length === 0) {
      return `
        <div class="scrim-empty">
          <div class="scrim-empty-icon"><i class="fas fa-gamepad"></i></div>
          <h3>Nenhuma partida ainda</h3>
          <p>Quando seus scrims confirmados passarem do horário agendado, eles aparecerão aqui para registrar o resultado.</p>
        </div>`;
    }

    let html = '';

    if (pendingResult.length > 0) {
      html += `<div class="scrim-section-label"><i class="fas fa-exclamation-circle" style="color:#f59e0b"></i> Aguardando Resultado (${pendingResult.length})</div>`;
      html += `<div class="scrim-matches-grid">`;
      html += pendingResult.map(s => this.renderMatchCard(s, false)).join('');
      html += `</div>`;
    }

    if (completed.length > 0) {
      html += `<div class="scrim-section-label" style="margin-top:24px"><i class="fas fa-flag-checkered" style="color:#10b981"></i> Finalizadas (${completed.length})</div>`;
      html += `<div class="scrim-matches-grid">`;
      html += completed.map(s => this.renderMatchCard(s, true)).join('');
      html += `</div>`;
    }

    return html;
  }

  renderMatchCard(s, isCompleted) {
    const myTeamId = app.currentTeam?.id;
    const isChallenger = s.challenger_team_id === myTeamId;
    const oppName = isChallenger ? s.opponent_name : s.challenger_name;
    const oppTag = isChallenger ? s.opponent_tag : s.challenger_tag;
    const oppLogo = isChallenger ? s.opponent_logo : s.challenger_logo;

    const d = new Date(s.scheduled_at);
    const dateStr = ScrimArena.FMT.diaMesAno.format(d);
    const timeStr = ScrimArena.FMT.hora.format(d);

    // Map info
    let mapHtml = '';
    let mapItems = [];
    if (s.maps_pool && s.maps_pool.length > 0 && this.maps.length > 0) {
      mapItems = s.maps_pool.map(mid => this.maps.find(m => m.id === mid)).filter(Boolean);
    }
    if (mapItems.length === 0 && s.map_name) {
      mapItems = [{ name: s.map_name, image_url: s.map_image }];
    }
    if (mapItems.length > 0) {
      mapHtml = `<div class="scrim-match-maps">${mapItems.map(m =>
        `<div class="scrim-match-map-badge"><img src="${m.image_url || '/img/maps/' + (m.name?.toLowerCase() || 'default') + '-preview.jpg'}" alt="${m.name}"><span>${m.name}</span></div>`
      ).join('')}</div>`;
    }

    if (isCompleted) {
      const won = s.winner_team_id === myTeamId;
      const lost = s.winner_team_id && s.winner_team_id !== myTeamId;
      const myScore = isChallenger ? s.score_challenger : s.score_opponent;
      const oppScore = isChallenger ? s.score_opponent : s.score_challenger;
      const resultClass = won ? 'match-win' : lost ? 'match-loss' : 'match-draw';
      const resultLabel = won ? 'VITÓRIA' : lost ? 'DERROTA' : 'EMPATE';

      return `
        <div class="scrim-match-card ${resultClass}">
          <div class="scrim-match-card-header">
            <span class="scrim-match-date"><i class="fas fa-calendar"></i> ${dateStr} às ${timeStr}</span>
            <span class="scrim-match-result-badge ${resultClass}">${resultLabel}</span>
          </div>
          <div class="scrim-match-versus">
            <div class="scrim-match-team">
              <img src="${app.currentTeam?.logo_url || '/img/default-team.png'}" alt="" class="scrim-match-logo">
              <span>${app.currentTeam?.tag || 'MEU'}</span>
            </div>
            <div class="scrim-match-score-block ${resultClass}">
              <span class="scrim-match-score">${myScore ?? 0}</span>
              <span class="scrim-match-score-sep">×</span>
              <span class="scrim-match-score">${oppScore ?? 0}</span>
            </div>
            <div class="scrim-match-team">
              <img src="${oppLogo || '/img/default-team.png'}" alt="" class="scrim-match-logo">
              <span>${oppTag || oppName || '???'}</span>
            </div>
          </div>
          ${mapHtml}
        </div>`;
    }

    // Pending result card
    return `
      <div class="scrim-match-card match-pending">
        <div class="scrim-match-card-header">
          <span class="scrim-match-date"><i class="fas fa-calendar"></i> ${dateStr} às ${timeStr}</span>
          <span class="scrim-match-result-badge match-pending-badge"><i class="fas fa-clock"></i> Pendente</span>
        </div>
        <div class="scrim-match-versus">
          <div class="scrim-match-team">
            <img src="${app.currentTeam?.logo_url || '/img/default-team.png'}" alt="" class="scrim-match-logo">
            <span>${app.currentTeam?.tag || 'MEU'}</span>
          </div>
          <span class="scrim-match-vs-text">VS</span>
          <div class="scrim-match-team">
            <img src="${oppLogo || '/img/default-team.png'}" alt="" class="scrim-match-logo">
            <span>${oppTag || oppName || '???'}</span>
          </div>
        </div>
        ${mapHtml}
        <button class="scrim-btn-register-match" onclick="event.stopPropagation(); scrimArena.showRegisterMatchModal('${s.id}')">
          <i class="fas fa-upload"></i> Registrar Resultado
        </button>
      </div>`;
  }

  showRegisterMatchModal(scrimId) {
    const s = this.scrims.find(x => x.id === scrimId);
    if (!s) return;

    const myTeamId = app.currentTeam?.id;
    const isChallenger = s.challenger_team_id === myTeamId;
    const myName = app.currentTeam?.tag || app.currentTeam?.name || 'Meu Time';
    const oppName = isChallenger ? (s.opponent_tag || s.opponent_name) : (s.challenger_tag || s.challenger_name);

    const d = new Date(s.scheduled_at);
    const dateStr = ScrimArena.FMT.diaMesLongoAno.format(d);

    // Map info
    let mapItems = [];
    if (s.maps_pool && s.maps_pool.length > 0 && this.maps.length > 0) {
      mapItems = s.maps_pool.map(mid => this.maps.find(m => m.id === mid)).filter(Boolean);
    }
    if (mapItems.length === 0 && s.map_name) {
      mapItems = [{ name: s.map_name }];
    }
    const mapLabel = mapItems.length > 0 ? mapItems.map(m => m.name).join(', ') : 'Não definido';

    const modal = document.createElement('div');
    modal.className = 'scrim-modal-overlay';
    modal.id = 'scrimRegisterMatchModal';
    modal.onclick = (e) => { if (e.target === modal) modal.remove(); };

    modal.innerHTML = `
      <div class="scrim-modal scrim-register-modal">
        <div class="scrim-modal-header scrim-modal-header-compact">
          <div class="scrim-modal-header-content">
            <h2><i class="fas fa-upload"></i> Registrar Partida</h2>
            <button class="scrim-modal-close" onclick="document.getElementById('scrimRegisterMatchModal').remove()"><i class="fas fa-times"></i></button>
          </div>
        </div>
        <div class="scrim-modal-body">
          <!-- Match info (auto-filled) -->
          <div class="scrim-register-info">
            <div class="scrim-register-info-item">
              <i class="fas fa-calendar"></i> <span>${dateStr}</span>
            </div>
            <div class="scrim-register-info-item">
              <i class="fas fa-map"></i> <span>${mapLabel}</span>
            </div>
          </div>

          <!-- Score -->
          <div class="scrim-register-section-title">Placar</div>
          <div class="scrim-complete-versus">
            <div class="scrim-complete-team">
              <span>${myName}</span>
              <input type="number" id="regScoreMy" min="0" max="99" value="0" class="scrim-score-input">
            </div>
            <span class="scrim-complete-x">×</span>
            <div class="scrim-complete-team">
              <span>${oppName || 'Adversário'}</span>
              <input type="number" id="regScoreOpp" min="0" max="99" value="0" class="scrim-score-input">
            </div>
          </div>

          <!-- Side results -->
          <div class="scrim-register-section-title">Resultado por Lado</div>
          <div class="scrim-register-row">
            <div class="scrim-register-field">
              <label><i class="fas fa-crosshairs"></i> Ataque</label>
              <select id="regAttackResult" class="scrim-input">
                <option value="win">Vitória</option>
                <option value="draw">Empate</option>
                <option value="lose" selected>Derrota</option>
              </select>
            </div>
            <div class="scrim-register-field">
              <label><i class="fas fa-shield-alt"></i> Defesa</label>
              <select id="regDefenseResult" class="scrim-input">
                <option value="win">Vitória</option>
                <option value="draw">Empate</option>
                <option value="lose" selected>Derrota</option>
              </select>
            </div>
          </div>

          <!-- Pistol rounds -->
          <div class="scrim-register-section-title">Pistol Rounds</div>
          <div class="scrim-register-row">
            <label class="scrim-register-check">
              <input type="checkbox" id="regPistolAttack"> Ganhou Pistol (Ataque)
            </label>
            <label class="scrim-register-check">
              <input type="checkbox" id="regPistolDefense"> Ganhou Pistol (Defesa)
            </label>
          </div>

          <!-- Upload -->
          <div class="scrim-register-section-title">Upload & Links</div>
          <div class="scrim-register-field">
            <label><i class="fab fa-youtube"></i> Link do YouTube / VOD</label>
            <input type="url" id="regYoutubeUrl" class="scrim-input" placeholder="https://youtube.com/watch?v=...">
          </div>
          <div class="scrim-register-field">
            <label><i class="fas fa-image"></i> Screenshot do Resultado</label>
            <div class="scrim-register-upload-area" id="regUploadArea" onclick="document.getElementById('regScreenshotFile').click()">
              <input type="file" id="regScreenshotFile" accept="image/*" style="display:none" onchange="scrimArena.previewScreenshot(this)">
              <div id="regUploadPreview" class="scrim-register-upload-preview">
                <i class="fas fa-cloud-upload-alt"></i>
                <span>Clique para upload ou arraste aqui</span>
              </div>
            </div>
          </div>

          <!-- Notes -->
          <div class="scrim-register-field">
            <label><i class="fas fa-sticky-note"></i> Observações</label>
            <textarea id="regNotes" class="scrim-input" rows="2" placeholder="Anotações sobre a partida..."></textarea>
          </div>

          <button class="scrim-btn-challenge scrim-btn-full" id="regSubmitBtn" onclick="scrimArena.submitRegisterMatch('${scrimId}')">
            <i class="fas fa-check"></i> Registrar Partida
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);
    requestAnimationFrame(() => modal.classList.add('active'));

    // Drag-and-drop
    const uploadArea = modal.querySelector('#regUploadArea');
    uploadArea.addEventListener('dragover', e => { e.preventDefault(); uploadArea.classList.add('dragover'); });
    uploadArea.addEventListener('dragleave', () => uploadArea.classList.remove('dragover'));
    uploadArea.addEventListener('drop', e => {
      e.preventDefault();
      uploadArea.classList.remove('dragover');
      const file = e.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) {
        const input = modal.querySelector('#regScreenshotFile');
        const dt = new DataTransfer();
        dt.items.add(file);
        input.files = dt.files;
        this.previewScreenshot(input);
      }
    });
  }

  previewScreenshot(input) {
    const preview = document.getElementById('regUploadPreview');
    if (!preview) return;
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        preview.innerHTML = `<img src="${e.target.result}" alt="Preview" style="max-width:100%;max-height:200px;border-radius:8px;">`;
      };
      reader.readAsDataURL(input.files[0]);
    }
  }

  async submitRegisterMatch(scrimId) {
    const btn = document.getElementById('regSubmitBtn');
    if (btn) { btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Registrando...'; }

    const s = this.scrims.find(x => x.id === scrimId);
    const isChallenger = s && s.challenger_team_id === app.currentTeam?.id;

    const scoreMy = parseInt(document.getElementById('regScoreMy')?.value) || 0;
    const scoreOpp = parseInt(document.getElementById('regScoreOpp')?.value) || 0;

    // Map to challenger/opponent perspective
    const score_challenger = isChallenger ? scoreMy : scoreOpp;
    const score_opponent = isChallenger ? scoreOpp : scoreMy;

    const formData = new FormData();
    formData.append('score_challenger', score_challenger);
    formData.append('score_opponent', score_opponent);
    formData.append('attack_side_result', document.getElementById('regAttackResult')?.value || 'lose');
    formData.append('defense_side_result', document.getElementById('regDefenseResult')?.value || 'lose');
    formData.append('won_pistol_attack', document.getElementById('regPistolAttack')?.checked || false);
    formData.append('won_pistol_defense', document.getElementById('regPistolDefense')?.checked || false);
    formData.append('youtube_url', document.getElementById('regYoutubeUrl')?.value || '');
    formData.append('notes', document.getElementById('regNotes')?.value || '');

    const fileInput = document.getElementById('regScreenshotFile');
    if (fileInput?.files[0]) {
      formData.append('screenshot', fileInput.files[0]);
    }

    try {
      const token = localStorage.getItem('zdval_token');
      const resp = await fetch(`/api/scrims/${scrimId}/register-match`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });
      const result = await resp.json();

      if (result.success) {
        utils.toast('Partida registrada com sucesso!', 'success');
        document.getElementById('scrimRegisterMatchModal')?.remove();

        if (socket.socket && s) {
          socket.socket.emit('scrim:completed', {
            scrimId, challengerTeamId: s.challenger_team_id, opponentTeamId: s.opponent_team_id
          });
        }

        await this.fetchScrims();
        this.switchTab('matches');
      } else {
        utils.toast(result.error || 'Erro ao registrar partida', 'error');
        if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fas fa-check"></i> Registrar Partida'; }
      }
    } catch (err) {
      console.error('Register match error:', err);
      utils.toast('Erro ao registrar partida', 'error');
      if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fas fa-check"></i> Registrar Partida'; }
    }
  }

  // ── Complete Modal ────────────────────────────────

  showCompleteModal(scrimId) {
    const modal = document.createElement('div');
    modal.className = 'scrim-modal-overlay';
    modal.id = 'scrimCompleteModal';
    modal.onclick = (e) => { if (e.target === modal) modal.remove(); };

    const s = this.detailScrim || this.scrims.find(x => x.id === scrimId);

    modal.innerHTML = `
      <div class="scrim-modal scrim-modal-sm">
        <div class="scrim-modal-header scrim-modal-header-compact">
          <div class="scrim-modal-header-content">
            <h2><i class="fas fa-flag-checkered"></i> Registrar Resultado</h2>
            <button class="scrim-modal-close" onclick="document.getElementById('scrimCompleteModal').remove()"><i class="fas fa-times"></i></button>
          </div>
        </div>
        <div class="scrim-modal-body">
          <div class="scrim-complete-versus">
            <div class="scrim-complete-team">
              <span>${s?.challenger_name || 'Desafiante'}</span>
              <input type="number" id="scrimScoreChallenger" min="0" max="99" value="0" class="scrim-score-input">
            </div>
            <span class="scrim-complete-x">×</span>
            <div class="scrim-complete-team">
              <span>${s?.opponent_name || 'Adversário'}</span>
              <input type="number" id="scrimScoreOpponent" min="0" max="99" value="0" class="scrim-score-input">
            </div>
          </div>
          <button class="scrim-btn-challenge scrim-btn-full" onclick="scrimArena.submitComplete('${scrimId}')">
            <i class="fas fa-check"></i> Confirmar Resultado
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);
    requestAnimationFrame(() => modal.classList.add('active'));
  }

  async submitComplete(scrimId) {
    const score_challenger = parseInt(document.getElementById('scrimScoreChallenger')?.value) || 0;
    const score_opponent = parseInt(document.getElementById('scrimScoreOpponent')?.value) || 0;

    try {
      const res = await api.put(`/scrims/${scrimId}/complete`, { score_challenger, score_opponent });
      if (res.success) {
        utils.toast('Resultado registrado!', 'success');
        document.getElementById('scrimCompleteModal')?.remove();
        this.closeDetailModal();

        if (socket.socket) {
          const s = this.detailScrim || this.scrims.find(x => x.id === scrimId);
          if (s) socket.socket.emit('scrim:completed', { scrimId, challengerTeamId: s.challenger_team_id, opponentTeamId: s.opponent_team_id });
        }

        await this.fetchScrims();
        this.render();
      } else {
        utils.toast(res.error || 'Erro ao registrar resultado', 'error');
      }
    } catch (err) {
      console.error('Complete error:', err);
    }
  }

  // ── Reschedule Modal ──────────────────────────────

  showRescheduleModal(scrimId) {
    const modal = document.createElement('div');
    modal.className = 'scrim-modal-overlay';
    modal.id = 'scrimRescheduleModal';
    modal.onclick = (e) => { if (e.target === modal) modal.remove(); };

    const mapOptions = this.maps.map(m => `<option value="${m.id}">${m.name}</option>`).join('');

    modal.innerHTML = `
      <div class="scrim-modal scrim-modal-sm">
        <div class="scrim-modal-header scrim-modal-header-compact">
          <div class="scrim-modal-header-content">
            <h2><i class="fas fa-calendar-alt"></i> Reagendar Scrim</h2>
            <button class="scrim-modal-close" onclick="document.getElementById('scrimRescheduleModal').remove()"><i class="fas fa-times"></i></button>
          </div>
        </div>
        <div class="scrim-modal-body">
          <div class="scrim-form-row">
            <div class="scrim-form-group">
              <label><i class="fas fa-calendar"></i> Nova Data</label>
              <input type="date" id="scrimRescheduleDate" class="scrim-input">
            </div>
            <div class="scrim-form-group">
              <label><i class="fas fa-clock"></i> Horário</label>
              <select id="scrimRescheduleHour" class="scrim-input">
                ${Array.from({length: 24}, (_, i) => `<option value="${i}" ${i === 20 ? 'selected' : ''}>${String(i).padStart(2,'0')}:00</option>`).join('')}
              </select>
            </div>
          </div>
          <div class="scrim-form-group">
            <label><i class="fas fa-map"></i> Mapa (opcional)</label>
            <select id="scrimRescheduleMap" class="scrim-input">
              <option value="">Manter atual</option>
              ${mapOptions}
            </select>
          </div>
          <button class="scrim-btn-challenge scrim-btn-full" onclick="scrimArena.submitReschedule('${scrimId}')">
            <i class="fas fa-calendar-check"></i> Confirmar Reagendamento
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);
    requestAnimationFrame(() => modal.classList.add('active'));
  }

  async submitReschedule(scrimId) {
    const rescDate = document.getElementById('scrimRescheduleDate')?.value;
    const rescHour = document.getElementById('scrimRescheduleHour')?.value || '20';
    const scheduled_at = rescDate ? `${rescDate}T${String(rescHour).padStart(2,'0')}:00` : null;
    const map_id = document.getElementById('scrimRescheduleMap')?.value || null;
    if (!scheduled_at) return utils.toast('Selecione uma data', 'error');

    try {
      const res = await api.put(`/scrims/${scrimId}/reschedule`, { scheduled_at, map_id });
      if (res.success) {
        utils.toast('Scrim reagendado!', 'success');
        document.getElementById('scrimRescheduleModal')?.remove();
        this.closeDetailModal();
        await this.fetchScrims();
        this.render();
      }
    } catch (err) {
      console.error('Reschedule error:', err);
    }
  }

  // ── Socket Listeners ──────────────────────────────

  setupSocketListeners() {
    if (!socket.socket) return;

    // Remove old scrim-page-specific listeners (using stored refs to avoid removing global listeners)
    if (this._socketHandlers) {
      socket.socket.off('scrim:challenge', this._socketHandlers.challenge);
      socket.socket.off('scrim:accepted', this._socketHandlers.accepted);
      socket.socket.off('scrim:declined', this._socketHandlers.declined);
      socket.socket.off('scrim:cancelled', this._socketHandlers.cancelled);
      socket.socket.off('scrim:completed', this._socketHandlers.completed);
      socket.socket.off('scrim:message', this._socketHandlers.message);
    }

    // Store named handlers for clean removal
    this._socketHandlers = {
      challenge: (data) => {
        // Data refresh only — premium notification is handled globally in socket.js
        this.fetchScrims().then(() => {
          if (this.currentTab === 'agenda') {
            const content = document.getElementById('scrimContent');
            if (content) content.innerHTML = this.renderAgenda();
          }
        });
      },
      accepted: () => {
        utils.toast('Seu treino foi aceito!', 'success');
        this.fetchScrims().then(() => this.render());
      },
      declined: () => {
        utils.toast('Seu treino foi recusado', 'warning');
        this.fetchScrims().then(() => this.render());
      },
      cancelled: () => {
        utils.toast('Um scrim foi cancelado', 'info');
        this.fetchScrims().then(() => this.render());
      },
      completed: () => {
        this.fetchScrims().then(() => this.render());
      },
      message: (msg) => {
        if (this.detailScrim) {
          this.messages.push(msg);
          const chatEl = document.getElementById('scrimChatMessages');
          if (chatEl) {
            const emptyEl = chatEl.querySelector('.scrim-chat-empty');
            if (emptyEl) emptyEl.remove();
            chatEl.insertAdjacentHTML('beforeend', this.renderMessage(msg));
            chatEl.scrollTop = chatEl.scrollHeight;
          }
        }
      }
    };

    socket.socket.on('scrim:challenge', this._socketHandlers.challenge);
    socket.socket.on('scrim:accepted', this._socketHandlers.accepted);
    socket.socket.on('scrim:declined', this._socketHandlers.declined);
    socket.socket.on('scrim:cancelled', this._socketHandlers.cancelled);
    socket.socket.on('scrim:completed', this._socketHandlers.completed);
    socket.socket.on('scrim:message', this._socketHandlers.message);
  }
}

// ── Initialize ──────────────────────────────────────
const scrimArena = new ScrimArena();


/* ===== js/academy.js ===== */
// =====================================================
// ZDACADEMY - Frontend Module
// Mount target: #page-academy
// Views: browse | course | my-courses | live | live-room
//        coaches | become-coach | coach (dashboard) | admin
// =====================================================
/* global api, app, io, utils */

const academy = (() => {
  const STATE = {
    bootstrap: null,     // { role, isAdmin, isCoach, counts, ... }
    currentView: 'browse',
    currentParams: null,
    categories: [],
    socket: null,
    roomSocket: null,    // active live room socket ref
    roomState: null
  };

  // ─────────────────────────────────────────────────────
  // ICONS / UTILS
  // ─────────────────────────────────────────────────────
  const DIFF_META = {
    iron:       { label: 'Iniciante',     color: '#8a8f98' },
    bronze:     { label: 'Bronze',        color: '#c08558' },
    silver:     { label: 'Silver',        color: '#c9ccd4' },
    gold:       { label: 'Gold',          color: '#ffbd4a' },
    platinum:   { label: 'Platinum',      color: '#4ae0d5' },
    diamond:    { label: 'Diamond',       color: '#b57cff' },
    ascendant:  { label: 'Ascendant',     color: '#52d4a4' },
    immortal:   { label: 'Immortal',      color: '#ff4655' },
    radiant:    { label: 'Radiant',       color: '#fff6a8' }
  };

  const STATUS_META = {
    draft:          { label: 'Rascunho',    color: '#8a8f98' },
    pending_review: { label: 'Em análise',  color: '#ffbd4a' },
    published:      { label: 'Publicado',   color: '#52d4a4' },
    archived:       { label: 'Arquivado',   color: '#6b7280' }
  };

  const fmtDuration = (sec) => {
    sec = Math.max(0, Math.floor(sec || 0));
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    if (h > 0) return `${h}h ${m.toString().padStart(2, '0')}min`;
    return `${m}min`;
  };
  const fmtMoney = (cents) => (cents || 0) === 0 ? 'Grátis' : `R$ ${(cents / 100).toFixed(2).replace('.', ',')}`;
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));
  const fmtRelTime = (dt) => {
    if (!dt) return '';
    const d = new Date(dt);
    const diff = (d - Date.now()) / 1000;
    const abs = Math.abs(diff);
    const fut = diff > 0;
    if (abs < 60) return fut ? 'em instantes' : 'agora';
    if (abs < 3600) { const m = Math.round(abs / 60); return fut ? `em ${m}min` : `há ${m}min`; }
    if (abs < 86400) { const h = Math.round(abs / 3600); return fut ? `em ${h}h` : `há ${h}h`; }
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
  };

  function parseYouTubeId(url) {
    const m = String(url || '').match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return m ? m[1] : null;
  }

  function renderVideoPlayer(url, type) {
    if (!url) return `<div class="az-player-empty"><i class="fas fa-video-slash"></i> Vídeo não disponível</div>`;
    if (type === 'youtube') {
      const id = parseYouTubeId(url);
      if (id) {
        // Custom minimal player (play/pause, volume, seek only) — reuses the
        // global helper defined in /js/home.js, loaded on every page.
        if (typeof window.renderHomeMinimalYoutube === 'function') {
          return window.renderHomeMinimalYoutube({
            ytId: id,
            wrapperClass: 'az-player-minimal',
            mediaClass: 'az-player-frame',
            alt: 'Aula',
            autoplay: false,
            muted: false,
            loop: false
          });
        }
        return `<iframe class="az-player-frame" src="https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&autoplay=0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
      }
    }
    if (type === 'vimeo') {
      const id = (url.match(/vimeo\.com\/(\d+)/) || [])[1];
      if (id) return `<iframe class="az-player-frame" src="https://player.vimeo.com/video/${id}" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
    }
    return `<video class="az-player-frame" src="${esc(url)}" controls playsinline></video>`;
  }

  // ─────────────────────────────────────────────────────
  // API
  // ─────────────────────────────────────────────────────
  const AZ = {
    bootstrap:    () => api.get('/academy/bootstrap'),
    categories:   () => api.get('/academy/categories'),
    courses:      (qs = {}) => api.get('/academy/courses?' + new URLSearchParams(qs).toString()),
    course:       (slug) => api.get(`/academy/courses/${encodeURIComponent(slug)}`),
    liveList:     () => api.get('/academy/live'),
    liveRoom:     (id) => api.get(`/academy/live/${id}`),
    liveRegister: (id) => api.post(`/academy/live/${id}/register`, {}),
    coaches:      () => api.get('/academy/coaches'),
    coachApply:   (data) => api.post('/academy/coach-application', data),
    notifications: () => api.get('/academy/notifications'),
    readNotifications: () => api.post('/academy/notifications/read-all', {}),

    // Coach
    coachDash:    () => api.get('/academy/coach/dashboard'),
    coachCourses: () => api.get('/academy/coach/courses'),
    createCourse: (data) => api.post('/academy/coach/courses', data),
    updateCourse: (id, data) => api.put(`/academy/coach/courses/${id}`, data),
    submitCourse: (id) => api.post(`/academy/coach/courses/${id}/submit`, {}),
    addLesson:    (cid, data) => api.post(`/academy/coach/courses/${cid}/lessons`, data),
    updateLesson: (lid, data) => api.put(`/academy/coach/lessons/${lid}`, data),
    deleteLesson: (lid) => api.delete(`/academy/coach/lessons/${lid}`),
    reorderLessons: (cid, ids) => api.post(`/academy/coach/courses/${cid}/lessons/reorder`, { lessonIds: ids }),
    coachLive:    () => api.get('/academy/coach/live-rooms'),
    createLive:   (data) => api.post('/academy/coach/live-rooms', data),
    updateLive:   (id, data) => api.put(`/academy/coach/live-rooms/${id}`, data),
    startLive:    (id) => api.post(`/academy/coach/live-rooms/${id}/start`, {}),
    endLive:      (id) => api.post(`/academy/coach/live-rooms/${id}/end`, {}),
    deleteLive:   (id) => api.delete(`/academy/coach/live-rooms/${id}`),
    coachProfile: (data) => api.put('/academy/coach/profile', data),

    // v2 — 10 new features
    myStats:         () => api.get('/academy/me/stats'),
    leaderboard:     () => api.get('/academy/leaderboard'),
    search:          (q) => api.get('/academy/search?q=' + encodeURIComponent(q)),
    continueWatching:() => api.get('/academy/continue-watching'),
    certificates:    () => api.get('/academy/certificates/me'),
    verifyCert:      (code) => api.get(`/academy/certificates/verify/${encodeURIComponent(code)}`),

    savePosition:    (lid, sec) => api.post(`/academy/lessons/${lid}/position`, { position_sec: sec }),
    notes:           (lid) => api.get(`/academy/lessons/${lid}/notes`),
    noteAdd:         (lid, ts, content) => api.post(`/academy/lessons/${lid}/notes`, { timestamp_sec: ts, content }),
    noteDel:         (id) => api.delete(`/academy/notes/${id}`),
    quiz:            (lid) => api.get(`/academy/lessons/${lid}/quiz`),
    quizAttempt:     (qid, answers) => api.post(`/academy/quizzes/${qid}/attempt`, { answers }),
    attachments:     (lid) => api.get(`/academy/lessons/${lid}/attachments`),
    couponApply:     (code, courseId) => api.post('/academy/coupons/apply', { code, course_id: courseId }),
    followCoach:     (uid) => api.post(`/academy/coaches/${uid}/follow`, {}),
    unfollowCoach:   (uid) => api.delete(`/academy/coaches/${uid}/follow`),
    followStatus:    (uid) => api.get(`/academy/coaches/${uid}/follow-status`),
    myFollowing:     () => api.get('/academy/my/following')
  };

  // ─────────────────────────────────────────────────────
  // ENTRY — called by app.js router
  // ─────────────────────────────────────────────────────
  async function load(params) {
    // Folha desta pagina, sob demanda. Estava no <head> do index.html, ou seja,
    // baixada em toda visita a qualquer pagina do site.
    Utils.loadPageCss('academy-page-css', 'academy.css');

    STATE.currentParams = params || {};
    const container = document.getElementById('page-academy');
    if (!container) return;

    container.innerHTML = `<div class="az-loading"><div class="az-spinner"></div><span>Carregando ZDAcademy…</span></div>`;

    try {
      if (!STATE.bootstrap) {
        const [boot, cats, stats] = await Promise.all([
          AZ.bootstrap(),
          AZ.categories(),
          AZ.myStats().catch(() => ({ data: null }))
        ]);
        STATE.bootstrap = boot.data;
        STATE.categories = cats.data || [];
        STATE.myStats = stats?.data || null;
      }
    } catch (err) {
      container.innerHTML = `<div class="az-error"><i class="fas fa-triangle-exclamation"></i><h2>Não foi possível iniciar a Academy</h2><p>${esc(err.message || 'Erro desconhecido')}</p></div>`;
      return;
    }

    const view = STATE.currentParams.view || 'browse';
    STATE.currentView = view;

    container.innerHTML = renderShell(view);
    attachShellEvents();
    await renderView(view, STATE.currentParams);
  }

  // ─────────────────────────────────────────────────────
  // SHELL (hero + sidebar)
  // ─────────────────────────────────────────────────────
  function renderShell(view = 'browse') {
    const b = STATE.bootstrap;
    const st = STATE.myStats || {};
    const tabs = [];
    if (!b.isCoach) tabs.push({ key: 'become-coach', icon: 'fa-rocket', label: 'Seja Coach' });

    const lvl = st.level || 1;
    const xpInLv = st.xp_in_level || 0;
    const xpNext = st.xp_to_next || 1000;
    const pctLv = Math.min(100, (xpInLv / 10));
    const streak = st.streak_days || 0;
    const badgeCount = (st.badges || []).length;

    return `
      <div class="academy-wrap ${view === 'course' ? 'academy-wrap--course' : ''}">
        <main id="academyViewport" class="academy-viewport"></main>
      </div>
    `;
  }

  function attachShellEvents() {
    document.getElementById('academyNav')?.querySelectorAll('.az-tab').forEach(btn => {
      btn.addEventListener('click', () => {
        const view = btn.dataset.view;
        navigate({ view });
      });
    });
    attachGlobalSearch();
  }

  // ─────────────────────────────────────────────────────
  // GLOBAL SEARCH (autocomplete dropdown)
  // ─────────────────────────────────────────────────────
  let _searchTimer = null;
  function attachGlobalSearch() {
    const input = document.getElementById('azGlobalSearch');
    const drop = document.getElementById('azSearchResults');
    if (!input || !drop) return;

    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(_searchTimer);
      if (q.length < 2) { drop.classList.remove('open'); drop.innerHTML = ''; return; }
      _searchTimer = setTimeout(async () => {
        try {
          const res = await AZ.search(q);
          renderSearchResults(drop, res.data || { courses: [], coaches: [], lives: [] });
        } catch (_) {}
      }, 220);
    });
    input.addEventListener('focus', () => { if (drop.innerHTML) drop.classList.add('open'); });
    document.addEventListener('click', (e) => {
      if (!drop.contains(e.target) && e.target !== input) drop.classList.remove('open');
    });
  }

  function renderSearchResults(drop, d) {
    const empty = !d.courses?.length && !d.coaches?.length && !d.lives?.length;
    if (empty) {
      drop.innerHTML = `<div class="az-search-empty"><i class="fas fa-magnifying-glass"></i> Nada encontrado</div>`;
      drop.classList.add('open');
      return;
    }
    let html = '';
    if (d.courses?.length) {
      html += `<div class="az-search-group"><div class="az-search-group-h"><i class="fas fa-book"></i> Cursos</div>`;
      html += d.courses.slice(0, 5).map(c => `
        <a class="az-search-row" data-view="course" data-slug="${esc(c.slug)}">
          <div class="az-search-thumb" style="background-image:url('${esc(c.thumbnail_url || '')}')"></div>
          <div class="az-search-info">
            <div class="az-search-title">${esc(c.title)}</div>
            <div class="az-search-sub">${esc(c.coach_name || '')} · ${fmtMoney(c.price_cents)}</div>
          </div>
        </a>`).join('');
      html += `</div>`;
    }
    if (d.coaches?.length) {
      html += `<div class="az-search-group"><div class="az-search-group-h"><i class="fas fa-user-tie"></i> Coaches</div>`;
      html += d.coaches.slice(0, 5).map(c => `
        <a class="az-search-row" data-view="coaches">
          <div class="az-search-thumb round" style="background-image:url('${esc(c.avatar_url || '')}')"></div>
          <div class="az-search-info">
            <div class="az-search-title">${esc(c.display_name || c.username)}</div>
            <div class="az-search-sub">${esc(c.headline || 'Coach verificado')}</div>
          </div>
        </a>`).join('');
      html += `</div>`;
    }
    drop.innerHTML = html;
    drop.classList.add('open');
    drop.querySelectorAll('.az-search-row').forEach(a => {
      a.addEventListener('click', () => {
        const v = a.dataset.view;
        const p = { view: v };
        if (a.dataset.slug) p.courseSlug = a.dataset.slug;
        if (a.dataset.id) p.id = a.dataset.id;
        drop.classList.remove('open');
        navigate(p);
      });
    });
  }

  function navigate(params = {}) {
    const merged = { ...STATE.currentParams, ...params };
    // When switching views, clear stale view-specific params
    if (params.view && params.view !== STATE.currentParams.view) {
      delete merged.section;
      delete merged.courseId;
      delete merged.roomId;
      delete merged.lessonId;
      if (!params.courseSlug) delete merged.courseSlug;
    } else if (!params.courseSlug && STATE.currentParams.courseSlug && !params.view?.startsWith('course')) {
      delete merged.courseSlug;
    }
    // Already on /academy: update in place instead of round-tripping through
    // app.navigate, which resets scroll + rebuilds the whole page shell and
    // makes the sidebar/menu visibly jump on every tab click.
    if (app.currentPage === 'academy' && STATE.bootstrap) {
      STATE.currentParams = merged;
      const qs = new URLSearchParams(merged).toString();
      const url = `/academy${qs ? '?' + qs : ''}`;
      window.history.pushState({ page: 'academy', params: merged }, '', url);
      const view = merged.view || 'browse';
      STATE.currentView = view;
      renderView(view, merged);
      return;
    }
    app.navigate('academy', merged);
  }

  // ─────────────────────────────────────────────────────
  // VIEW ROUTER
  // ─────────────────────────────────────────────────────
  async function renderView(view, params) {
    const vp = document.getElementById('academyViewport');
    if (!vp) return;

    // Update active tab
    document.querySelectorAll('#academyNav .az-tab').forEach(b => {
      b.classList.toggle('active', b.dataset.view === view);
    });

    vp.innerHTML = `<div class="az-loading"><div class="az-spinner"></div><span>Carregando…</span></div>`;

    try {
      switch (view) {
        case 'browse':       return await renderBrowse(vp, params);
        case 'course':       return await renderCourse(vp, params);
        case 'become-coach': return await renderBecomeCoach(vp);
        default:             return await renderBrowse(vp, params);
      }
    } catch (err) {
      console.error('[academy] view error:', err);
      vp.innerHTML = `<div class="az-error"><i class="fas fa-triangle-exclamation"></i><h2>Erro</h2><p>${esc(err.message || 'Erro ao carregar')}</p></div>`;
    }
  }

  // ─────────────────────────────────────────────────────
  // BROWSE
  // ─────────────────────────────────────────────────────
  async function renderBrowse(vp, params) {
    const browseTab = ['courses', 'lessons', 'coach'].includes(params.browseTab) ? params.browseTab : 'courses';
    const [courses, cont, liveRes] = await Promise.all([
      AZ.courses({ sort: params.sort || 'popular', category: params.category || '', difficulty: params.difficulty || '', q: params.q || '' }),
      AZ.continueWatching().catch(() => ({ data: [] })),
      browseTab === 'coach' ? AZ.liveList().catch(() => ({ data: [] })) : Promise.resolve({ data: [] })
    ]);

    const courseList = courses.data || [];
    const cw = (cont?.data || []).slice(0, 8);
    const coachLives = liveRes.data || [];
    const lessonList = browseTab === 'lessons' ? await buildBrowseLessons(courseList) : [];

    const browseTitles = {
      courses: 'Cursos disponíveis',
      lessons: 'Aulas disponíveis',
      coach: 'Aulas com coach'
    };

    const browseDescriptions = {
      courses: 'Todos os módulos publicados da ZDAcademy em uma grade principal centralizada.',
      lessons: 'Aulas individuais extraídas dos cursos publicados, prontas para abrir direto no ponto certo.',
      coach: 'Sessões ao vivo e encontros com coach disponíveis na Academy.'
    };

    const contentHtml = (() => {
      if (browseTab === 'lessons') {
        return lessonList.length
          ? `<div class="az-browse-grid az-browse-lessons-grid">${lessonList.map(renderBrowseLessonCard).join('')}</div>`
          : `<div class="az-empty"><i class="fas fa-box-open"></i><p>Nenhuma aula disponível.</p></div>`;
      }

      if (browseTab === 'coach') {
        return coachLives.length
          ? `<div class="az-browse-live-grid">${coachLives.map(renderBrowseLiveCard).join('')}</div>`
          : `<div class="az-empty"><i class="fas fa-video"></i><p>Nenhuma aula com coach disponível no momento.</p></div>`;
      }

      return courseList.length
        ? `<div class="az-playlist-grid">${courseList.map(renderCourseCard).join('')}</div>`
        : `<div class="az-empty"><i class="fas fa-box-open"></i><p>Nenhum curso encontrado.</p></div>`;
    })();

    vp.innerHTML = `
      <div class="az-browse-shell">
        <aside class="az-browse-sidebar">
          <div class="az-browse-menu">
            <button class="az-browse-menu-btn ${browseTab === 'courses' ? 'active' : ''}" data-browse-tab="courses" type="button">
              <span class="az-browse-menu-icon"><i class="fas fa-layer-group"></i></span>
              <span class="az-browse-menu-copy">
                <strong>Cursos disponíveis</strong>
                <small>Visão geral dos módulos publicados</small>
              </span>
            </button>
            <button class="az-browse-menu-btn ${browseTab === 'lessons' ? 'active' : ''}" data-browse-tab="lessons" type="button">
              <span class="az-browse-menu-icon"><i class="fas fa-list-ul"></i></span>
              <span class="az-browse-menu-copy">
                <strong>Aulas disponíveis</strong>
                <small>Abra aulas individuais direto da listagem</small>
              </span>
            </button>
            <button class="az-browse-menu-btn ${browseTab === 'coach' ? 'active' : ''}" data-browse-tab="coach" type="button">
              <span class="az-browse-menu-icon"><i class="fas fa-chalkboard-user"></i></span>
              <span class="az-browse-menu-copy">
                <strong>Aulas com coach</strong>
                <small>Sessões ao vivo e encontros guiados</small>
              </span>
            </button>
          </div>
        </aside>

        <div class="az-browse-main">
          ${browseTab === 'courses' && cw.length ? `
            <section class="az-section">
              <div class="az-section-head"><h2><i class="fas fa-play-circle"></i> Continuar assistindo</h2></div>
              <div class="az-continue-strip">${cw.map(renderContinueCard).join('')}</div>
            </section>
          ` : ''}

          <section class="az-section az-browse-stage">
            <div class="az-browse-panel-head">
              <div>
                <h2>${browseTitles[browseTab]}</h2>
                <p>${browseDescriptions[browseTab]}</p>
              </div>
            </div>
            ${contentHtml}
          </section>
        </div>
      </div>
    `;

    vp.querySelectorAll('[data-browse-tab]').forEach(el => {
      el.addEventListener('click', () => navigate({ browseTab: el.dataset.browseTab }));
    });

    vp.querySelectorAll('[data-course-slug]').forEach(el => {
      el.addEventListener('click', (ev) => {
        ev.preventDefault();
        const lessonId = el.dataset.lessonId ? parseInt(el.dataset.lessonId, 10) : null;
        navigate({ view: 'course', courseSlug: el.dataset.courseSlug, ...(lessonId ? { lessonId } : {}) });
      });
    });
    vp.querySelectorAll('[data-live-id]').forEach(el => {
      el.addEventListener('click', () => navigate({ view: 'live-room', roomId: el.dataset.liveId }));
    });
    vp.querySelectorAll('.az-cw-card').forEach(el => {
      el.addEventListener('click', () => navigate({ view: 'course', courseSlug: el.dataset.courseSlug, lessonId: el.dataset.lessonId }));
    });
  }

  async function buildBrowseLessons(courses) {
    const detailList = await Promise.all(
      (courses || []).slice(0, 18).map(course => AZ.course(course.slug).catch(() => ({ data: null })))
    );

    return detailList
      .flatMap(res => {
        const course = res.data?.course;
        const lessons = res.data?.lessons || [];
        if (!course) return [];
        return lessons.map((lesson, index) => ({
          ...lesson,
          lessonIndex: index + 1,
          courseSlug: course.slug,
          courseTitle: course.title,
          courseCover: course.cover_url || '/img/preload-bg.png',
          categoryName: course.category_name || 'Aula',
          categoryColor: course.category_color || '#00d4ff'
        }));
      })
      .slice(0, 36);
  }

  function renderBrowseLessonCard(lesson) {
    return `
      <article class="az-browse-lesson-card" data-course-slug="${esc(lesson.courseSlug)}" data-lesson-id="${lesson.id}">
        <div class="az-browse-lesson-cover" style="background-image:url('${esc(lesson.courseCover)}')">
          <div class="az-browse-lesson-shade"></div>
          <span class="az-browse-lesson-cat" style="color:${esc(lesson.categoryColor)}">${esc(lesson.categoryName)}</span>
          <span class="az-browse-lesson-order">Aula ${String(lesson.lessonIndex || 0).padStart(2, '0')}</span>
        </div>
        <div class="az-browse-lesson-body">
          <div class="az-browse-lesson-course">${esc(lesson.courseTitle || 'Curso')}</div>
          <h3>${esc(lesson.title || 'Aula')}</h3>
          <p>${esc(lesson.description || 'Abrir aula diretamente no curso.')}</p>
          <div class="az-browse-lesson-cta">
            <span><i class="fas fa-play-circle"></i> Abrir aula</span>
            <span>${fmtDuration(lesson.duration_sec)}</span>
          </div>
        </div>
      </article>
    `;
  }

  function renderBrowseLiveCard(room) {
    const liveNow = room.status === 'live';
    return `
      <article class="az-live-mini az-browse-live-card" data-live-id="${room.id}">
        <div class="az-live-mini-cover">
          <img src="${esc(room.cover_url || '/img/preload-bg.png')}" alt="">
          <span class="az-live-badge">${liveNow ? '<span class="az-live-dot"></span> AO VIVO' : 'COM COACH'}</span>
          <span class="az-live-time">${esc(fmtRelTime(liveNow ? room.started_at : room.scheduled_at))}</span>
          ${room.peak_viewers ? `<span class="az-live-viewers"><i class="fas fa-eye"></i> ${room.peak_viewers}</span>` : ''}
        </div>
        <div class="az-live-mini-body">
          <div class="az-live-mini-coach">
            <img src="${esc(room.coach_avatar || '/img/default-avatar.png')}" alt="">
            <span>${esc(room.coach_name || 'Coach')}</span>
            ${room.coach_verified ? '<i class="fas fa-badge-check az-verified"></i>' : ''}
          </div>
          <div class="az-browse-live-title">${esc(room.title || 'Sessão com coach')}</div>
          <div class="az-browse-live-sub">${esc(room.course_title || room.description || 'Sessão disponível na ZDAcademy')}</div>
        </div>
      </article>
    `;
  }

  function splitTitle(title) {
    const words = String(title || '').trim().split(/\s+/);
    if (words.length <= 1) return { top: '', bottom: title || '' };
    // Last 1-2 words bold (2 if last word is very short)
    const lastCount = (words[words.length - 1].length <= 3 && words.length >= 3) ? 2 : 1;
    const top = words.slice(0, words.length - lastCount).join(' ');
    const bottom = words.slice(-lastCount).join(' ');
    return { top, bottom };
  }

  function renderCourseCard(c) {
    const diff = DIFF_META[c.difficulty] || DIFF_META.iron;
    const { top, bottom } = splitTitle(c.title);
    const lessonCount = c.lessons_count || c.total_lessons || null;
    return `
      <article class="az-playlist-card" data-course-slug="${esc(c.slug)}">
        <div class="az-plc-accent"></div>
        <div class="az-plc-art" style="background-image:url('${esc(c.cover_url || '/img/preload-bg.png')}')">
          <div class="az-plc-shade"></div>
          <div class="az-plc-top">
            <span class="az-plc-cat" style="color:${esc(c.category_color || '#00d4ff')}"><i class="fas fa-play"></i> ${esc(c.category_name || 'Video-aulas')}</span>
          </div>
          <div class="az-plc-heading">
            ${top ? `<div class="az-plc-top-line">${esc(top)}</div>` : ''}
            <div class="az-plc-bot-line">${esc(bottom)}</div>
          </div>
        </div>
        <div class="az-plc-body">
          <div class="az-plc-cta">
            <span><i class="fas fa-play-circle"></i> Assistir agora</span>
            <i class="fas fa-arrow-right"></i>
          </div>
        </div>
      </article>
    `;
  }

  function renderContinueCard(c) {
    const pct = Math.min(100, Math.max(0, Number(c.progress_pct || 0)));
    return `
      <article class="az-cw-card" data-course-slug="${esc(c.course_slug || c.slug)}" data-lesson-id="${c.lesson_id || ''}">
        <div class="az-cw-cover" style="background-image:url('${esc(c.cover_url || '/img/preload-bg.png')}')">
          <div class="az-cw-play"><i class="fas fa-play"></i></div>
          <div class="az-cw-progress"><span style="width:${pct}%"></span></div>
        </div>
        <div class="az-cw-body">
          <div class="az-cw-course">${esc(c.course_title || c.title || '')}</div>
          <div class="az-cw-lesson">${esc(c.lesson_title || 'Continuar')}</div>
          <div class="az-cw-meta">${pct.toFixed(0)}% · ${fmtDuration(c.duration_sec)}</div>
        </div>
      </article>
    `;
  }



  // ─────────────────────────────────────────────────────
  // COURSE DETAIL (certificates section removed)
  // ─────────────────────────────────────────────────────
  async function renderCertificates_REMOVED(vp) {
    const [certRes, lbRes] = await Promise.all([
      AZ.certificates(),
      AZ.leaderboard().catch(() => ({ data: [] }))
    ]);
    const items = certRes.data || [];
    const lb = lbRes.data || [];
    vp.innerHTML = `
      <section class="az-section">
        <div class="az-section-head"><h2><i class="fas fa-certificate"></i> Meus certificados</h2></div>
        ${items.length === 0
          ? `<div class="az-empty"><i class="fas fa-certificate"></i><p>Conclua um curso para ganhar seu primeiro certificado.</p></div>`
          : `<div class="az-cert-grid">${items.map(renderCertificateCard).join('')}</div>`}
      </section>

      ${lb.length ? `
        <section class="az-section">
          <div class="az-section-head"><h2><i class="fas fa-ranking-star"></i> Ranking geral</h2><span class="az-section-sub">Top 10 alunos por XP</span></div>
          <div class="az-leaderboard">
            ${lb.slice(0, 10).map((r, i) => `
              <div class="az-lb-row ${i < 3 ? 'top-' + (i+1) : ''}">
                <div class="az-lb-rank">${i === 0 ? '<i class="fas fa-crown"></i>' : `#${i+1}`}</div>
                <img class="az-lb-avatar" src="${esc(r.avatar_url || '/img/default-avatar.png')}" alt="">
                <div class="az-lb-info">
                  <div class="az-lb-name">${esc(r.display_name || r.username)}</div>
                  <div class="az-lb-sub">Nível ${r.level || 1} · ${r.streak_days || 0} dias seguidos</div>
                </div>
                <div class="az-lb-xp"><b>${Number(r.xp || 0).toLocaleString('pt-BR')}</b> XP</div>
              </div>
            `).join('')}
          </div>
        </section>` : ''}
    `;
    vp.querySelectorAll('.az-cert-share').forEach(b => b.addEventListener('click', (e) => {
      e.stopPropagation();
      const code = b.dataset.code;
      const url = `${location.origin}/api/academy/certificates/verify/${encodeURIComponent(code)}`;
      navigator.clipboard?.writeText(url);
      b.innerHTML = '<i class="fas fa-check"></i> Link copiado';
      setTimeout(() => { b.innerHTML = '<i class="fas fa-share-nodes"></i> Compartilhar'; }, 1800);
    }));
    vp.querySelectorAll('.az-cert-print').forEach(b => b.addEventListener('click', () => window.print()));
  }

  function renderCertificateCard(c) {
    const dt = c.issued_at ? new Date(c.issued_at).toLocaleDateString('pt-BR') : '';
    return `
      <article class="az-cert-card">
        <div class="az-cert-ribbon"><i class="fas fa-medal"></i> Certificado de Conclusão</div>
        <div class="az-cert-title">${esc(c.course_title)}</div>
        <div class="az-cert-student">Concedido a <strong>${esc(c.student_name || 'Aluno')}</strong></div>
        <div class="az-cert-coach">Coach: ${esc(c.coach_name || '')}</div>
        <div class="az-cert-foot">
          <div class="az-cert-date"><small>Emitido em</small>${esc(dt)}</div>
          <div class="az-cert-code"><small>Código de verificação</small><code>${esc(c.verification_code || '')}</code></div>
        </div>
        <div class="az-cert-actions">
          <button class="az-btn az-cert-share" data-code="${esc(c.verification_code)}"><i class="fas fa-share-nodes"></i> Compartilhar</button>
          <button class="az-btn ghost az-cert-print"><i class="fas fa-print"></i> Imprimir</button>
        </div>
      </article>
    `;
  }

  // ─────────────────────────────────────────────────────
  // COURSE DETAIL
  // ─────────────────────────────────────────────────────
  async function renderCourse(vp, params) {
    const slug = params.courseSlug;
    if (!slug) return navigate({ view: 'browse' });

    const res = await AZ.course(slug);
    const { course, lessons, isOwner } = res.data;
    const canWatchAll = true;
    const diff = DIFF_META[course.difficulty] || DIFF_META.iron;

    // Active lesson selection
    const firstPlayable = lessons.find(l => l.video_url) || lessons[0];
    const activeLessonId = parseInt(params.lessonId) || (firstPlayable?.id);
    const activeLesson = lessons.find(l => l.id === activeLessonId) || firstPlayable;

    // v2 — parallel fetches for lesson extras and follow state
    const coachUid = course.coach_user_id || course.coach_id;
    const [followRes, attRes, notesRes, quizRes] = await Promise.all([
      coachUid ? AZ.followStatus(coachUid).catch(() => ({ data: { following: false } })) : Promise.resolve({ data: { following: false } }),
      activeLesson ? AZ.attachments(activeLesson.id).catch(() => ({ data: [] })) : Promise.resolve({ data: [] }),
      (activeLesson && canWatchAll) ? AZ.notes(activeLesson.id).catch(() => ({ data: [] })) : Promise.resolve({ data: [] }),
      (activeLesson && canWatchAll) ? AZ.quiz(activeLesson.id).catch(() => ({ data: null })) : Promise.resolve({ data: null })
    ]);
    const isFollowing = !!followRes.data?.following;
    const attachments = attRes.data || [];
    const notesList = notesRes.data || [];
    const quiz = quizRes.data || null;
    const courseSummary = `
      <div class="az-course-summary">
        <div class="az-cd-coach">
          <img src="${esc(course.coach_avatar || '/img/default-avatar.png')}" alt="">
          <div>
            <div class="az-cd-coach-name">${esc(course.coach_name)} ${course.coach_verified ? '<i class="fas fa-badge-check az-verified"></i>' : ''}</div>
            <div class="az-cd-coach-headline">${esc(course.coach_headline || 'Coach ZDAcademy')}</div>
          </div>
          ${coachUid && !isOwner ? `
            <button class="az-follow-btn ${isFollowing ? 'on' : ''}" id="azFollowCoach" data-uid="${esc(coachUid)}">
              <i class="fas ${isFollowing ? 'fa-user-check' : 'fa-user-plus'}"></i>
              <span>${isFollowing ? 'Seguindo' : 'Seguir'}</span>
            </button>` : ''}
        </div>
        <p class="az-cd-tag">${esc(course.tagline || '')}</p>
      </div>
    `;
    vp.innerHTML = `
      <div class="az-course-detail">
        <div class="az-course-body-grid">
          <div class="az-course-player-col">
            <div class="az-player">${renderVideoPlayer(activeLesson?.video_url, activeLesson?.video_type)}</div>
            ${courseSummary}
            ${activeLesson ? `
              <div class="az-lesson-info">
                <h2>${esc(activeLesson.title)}</h2>
                <p>${esc(activeLesson.description || '')}</p>
              </div>

              ${attachments.length ? `
                <section class="az-attachments">
                  <h3><i class="fas fa-paperclip"></i> Materiais da aula</h3>
                  <div class="az-attach-list">
                    ${attachments.map(a => `
                      <a class="az-attach-row" href="${esc(a.url)}" target="_blank" rel="noopener">
                        <div class="az-attach-icn"><i class="fas ${iconForAttachment(a.file_type || a.name)}"></i></div>
                        <div class="az-attach-info">
                          <div class="az-attach-name">${esc(a.name)}</div>
                          <div class="az-attach-meta">${esc((a.file_type || '').toUpperCase())}${a.size_bytes ? ` · ${fmtBytes(a.size_bytes)}` : ''}</div>
                        </div>
                        <i class="fas fa-download az-attach-dl"></i>
                      </a>
                    `).join('')}
                  </div>
                </section>` : ''}

              ${quiz ? `
                <section class="az-quiz-block" data-quiz-id="${quiz.id}">
                  <div class="az-quiz-head">
                    <h3><i class="fas fa-clipboard-question"></i> ${esc(quiz.title || 'Quiz da aula')}</h3>
                    <span class="az-quiz-sub">${quiz.questions?.length || 0} perguntas · nota mínima ${quiz.passing_score || 70}%</span>
                  </div>
                  <div class="az-quiz-questions">
                    ${(quiz.questions || []).map((q, qi) => `
                      <div class="az-quiz-q" data-qid="${q.id}">
                        <div class="az-quiz-q-title"><b>${qi+1}.</b> ${esc(q.question)}</div>
                        <div class="az-quiz-options">
                          ${(q.options || []).map((op, oi) => `
                            <label class="az-quiz-opt">
                              <input type="radio" name="q_${q.id}" value="${oi}">
                              <span>${esc(op)}</span>
                            </label>
                          `).join('')}
                        </div>
                      </div>
                    `).join('')}
                  </div>
                  <button class="az-btn az-btn-primary" id="azQuizSubmit"><i class="fas fa-paper-plane"></i> Enviar respostas</button>
                  <div class="az-quiz-result" id="azQuizResult"></div>
                </section>` : ''}
            ` : ''}

            <section class="az-cd-about">
              <h3>Sobre o curso</h3>
              <div class="az-cd-description">${esc(course.description || '').replace(/\n/g, '<br>')}</div>
            </section>

          </div>

          <aside class="az-course-lessons-col">
            <div class="az-playlist-panel">
              <div class="az-playlist-panel-rail"></div>
              <div class="az-playlist-panel-head">
                ${(() => { const {top, bottom} = splitTitle(course.title); return `
                  <div class="az-pp-title-line">
                    ${top ? `<div class="az-pp-top">${esc(top)}</div>` : ''}
                    <div class="az-pp-bot">${esc(bottom)}</div>
                  </div>
                `; })()}
                <div class="az-pp-meta">
                  <span class="az-cd-diff" style="border-color:${diff.color};color:${diff.color}"><i class="fas fa-chess-knight"></i> ${diff.label}</span>
                  <span><i class="fas fa-list-ol"></i> ${lessons.length} aulas</span>
                  <span><i class="fas fa-clock"></i> ${fmtDuration(course.total_duration_sec)}</span>
                </div>
              </div>
              <ol class="az-pp-lessons">
                ${lessons.map((l, i) => {
                  const isActive = l.id === activeLesson?.id;
                  return `
                    <li class="az-pp-lesson ${isActive ? 'active' : ''}" data-lesson-id="${l.id}">
                      <span class="az-pp-num">${String(i+1).padStart(2,'0')}</span>
                      <span class="az-pp-dash">–</span>
                      <span class="az-pp-title">${esc(l.title)}</span>
                      <span class="az-pp-icn">
                        ${isActive ? '<i class="fas fa-volume-high"></i>' : '<i class="fas fa-play"></i>'}
                      </span>
                      <span class="az-pp-dur">${fmtDuration(l.duration_sec)}</span>
                    </li>
                  `;
                }).join('')}
              </ol>
            </div>
          </aside>
        </div>

        <aside class="az-notes-drawer" id="azNotesDrawer" aria-hidden="true">
          <div class="az-notes-head">
            <h3><i class="fas fa-pen-to-square"></i> Minhas notas</h3>
            <button class="az-notes-close" id="azNotesClose"><i class="fas fa-xmark"></i></button>
          </div>
          <div class="az-notes-list" id="azNotesList">${renderNotesList(notesList)}</div>
        </aside>
      </div>
    `;

    // Events

    // Initialise the custom minimal YouTube player (play/pause, volume, seek)
    if (typeof window.initHomeMinimalYoutube === 'function') {
      window.initHomeMinimalYoutube(vp);
    }

    vp.querySelectorAll('.az-pp-lesson').forEach(li => {
      li.addEventListener('click', () => {
        const lid = parseInt(li.dataset.lessonId);
        const l = lessons.find(x => x.id === lid);
        if (!l) return;
        if (!l.video_url) return;
        navigate({ view: 'course', courseSlug: slug, lessonId: lid });
      });
    });

    // v2 — Follow coach
    vp.querySelector('#azFollowCoach')?.addEventListener('click', async (e) => {
      const btn = e.currentTarget;
      const uid = btn.dataset.uid;
      const on = btn.classList.contains('on');
      try {
        if (on) { await AZ.unfollowCoach(uid); btn.classList.remove('on'); btn.innerHTML = '<i class="fas fa-user-plus"></i><span>Seguir</span>'; }
        else    { await AZ.followCoach(uid);   btn.classList.add('on');    btn.innerHTML = '<i class="fas fa-user-check"></i><span>Seguindo</span>'; toast('Coach seguido!'); }
      } catch (err) { toast(err.message || 'Erro', 'error'); }
    });

    // v2 — Coupon apply
    vp.querySelector('#azCouponApply')?.addEventListener('click', async () => {
      const code = (vp.querySelector('#azCouponInput')?.value || '').trim();
      const msg = vp.querySelector('#azCouponMsg');
      if (!code) { msg.textContent = 'Digite um código'; msg.className = 'az-coupon-msg err'; return; }
      try {
        const r = await AZ.couponApply(code, course.id);
        const d = r.data || {};
        const newCents = Math.max(0, (course.price_cents || 0) - (d.discount_cents || 0));
        vp.querySelector('#azCdPrice').innerHTML = `<s class="az-cd-oldprice">${fmtMoney(course.price_cents)}</s> ${newCents === 0 ? 'GRÁTIS' : fmtMoney(newCents)}`;
        msg.textContent = `✓ Desconto de ${d.discount_pct ? d.discount_pct + '%' : fmtMoney(d.discount_cents)} aplicado`;
        msg.className = 'az-coupon-msg ok';
      } catch (err) {
        msg.textContent = err.message || 'Cupom inválido';
        msg.className = 'az-coupon-msg err';
      }
    });

    const videoEl = vp.querySelector('video.az-player-frame');

    // v2 — Notes drawer
    const drawer = vp.querySelector('#azNotesDrawer');
    vp.querySelector('#azToggleNotes')?.addEventListener('click', () => {
      drawer?.classList.toggle('open');
    });
    vp.querySelector('#azNotesClose')?.addEventListener('click', () => drawer?.classList.remove('open'));
    vp.querySelector('#azNoteCapture')?.addEventListener('click', () => {
      const sec = Math.floor(videoEl?.currentTime || 0);
      vp.querySelector('#azNoteTs').value = fmtTs(sec);
      vp.querySelector('#azNoteTs').dataset.sec = sec;
    });
    vp.querySelector('#azNotesForm')?.addEventListener('submit', async (e) => {
      e.preventDefault();
      const sec = parseInt(vp.querySelector('#azNoteTs').dataset.sec) || Math.floor(videoEl?.currentTime || 0);
      const content = vp.querySelector('#azNoteContent').value.trim();
      if (!content || !activeLesson) return;
      try {
        await AZ.noteAdd(activeLesson.id, sec, content);
        const fresh = await AZ.notes(activeLesson.id);
        vp.querySelector('#azNotesList').innerHTML = renderNotesList(fresh.data || []);
        wireNoteRows(vp, videoEl, activeLesson);
        vp.querySelector('#azNoteContent').value = '';
        toast('Nota salva');
      } catch (err) { toast(err.message || 'Erro', 'error'); }
    });
    wireNoteRows(vp, videoEl, activeLesson);

    // v2 — Quiz submit
    vp.querySelector('#azQuizSubmit')?.addEventListener('click', async () => {
      if (!quiz) return;
      const answers = {};
      let unanswered = 0;
      (quiz.questions || []).forEach(q => {
        const sel = vp.querySelector(`input[name="q_${q.id}"]:checked`);
        if (!sel) unanswered++;
        else answers[q.id] = parseInt(sel.value);
      });
      if (unanswered > 0) return toast(`Responda todas as perguntas (${unanswered} faltando)`, 'error');
      try {
        const r = await AZ.quizAttempt(quiz.id, answers);
        const d = r.data || {};
        const passed = d.passed;
        const result = vp.querySelector('#azQuizResult');
        result.innerHTML = `
          <div class="az-quiz-verdict ${passed ? 'pass' : 'fail'}">
            <i class="fas ${passed ? 'fa-trophy' : 'fa-circle-xmark'}"></i>
            <div>
              <strong>${passed ? 'Aprovado!' : 'Não passou dessa vez'}</strong>
              <div>Sua nota: <b>${d.score}%</b> · Mínimo: ${quiz.passing_score || 70}%</div>
              ${d.xp_awarded ? `<div class="az-quiz-xp">+${d.xp_awarded} XP</div>` : ''}
            </div>
          </div>`;
        result.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (err) { toast(err.message || 'Erro', 'error'); }
    });
  }

  // v2 — helpers
  function fmtTs(sec) {
    sec = Math.max(0, Math.floor(sec || 0));
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    if (h > 0) return `${h}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
    return `${m}:${String(s).padStart(2,'0')}`;
  }
  function fmtBytes(b) {
    if (!b) return '';
    const u = ['B','KB','MB','GB']; let i = 0; let v = b;
    while (v >= 1024 && i < u.length - 1) { v /= 1024; i++; }
    return `${v.toFixed(v < 10 ? 1 : 0)} ${u[i]}`;
  }
  function iconForAttachment(t) {
    const s = String(t || '').toLowerCase();
    if (/pdf/.test(s)) return 'fa-file-pdf';
    if (/zip|rar|7z/.test(s)) return 'fa-file-zipper';
    if (/png|jpe?g|gif|webp/.test(s)) return 'fa-file-image';
    if (/mp4|mov|webm|mkv/.test(s)) return 'fa-file-video';
    if (/xls|csv/.test(s)) return 'fa-file-excel';
    if (/doc/.test(s)) return 'fa-file-word';
    return 'fa-file';
  }
  function renderNotesList(notes) {
    if (!notes.length) return '';
    return notes.map(n => `
      <div class="az-note-row" data-id="${n.id}">
        <button class="az-note-ts" data-sec="${n.timestamp_sec || 0}"><i class="fas fa-play"></i> ${fmtTs(n.timestamp_sec || 0)}</button>
        <div class="az-note-content">${esc(n.content)}</div>
        <button class="az-note-del" data-id="${n.id}" title="Excluir"><i class="fas fa-trash"></i></button>
      </div>
    `).join('');
  }
  function wireNoteRows(vp, videoEl, activeLesson) {
    vp.querySelectorAll('.az-note-ts').forEach(b => b.addEventListener('click', () => {
      const s = parseInt(b.dataset.sec) || 0;
      if (videoEl) { try { videoEl.currentTime = s; videoEl.play?.(); } catch(_) {} }
    }));
    vp.querySelectorAll('.az-note-del').forEach(b => b.addEventListener('click', async (e) => {
      e.stopPropagation();
      if (!confirm('Excluir esta nota?')) return;
      try {
        await AZ.noteDel(b.dataset.id);
        b.closest('.az-note-row').remove();
      } catch (err) { toast(err.message || 'Erro', 'error'); }
    }));
  }

  // ─────────────────────────────────────────────────────
  // COACHES directory
  // ─────────────────────────────────────────────────────
  async function renderCoaches(vp) {
    const r = await AZ.coaches();
    const coaches = r.data || [];
    vp.innerHTML = `
      <section class="az-section">
        <div class="az-section-head"><h2><i class="fas fa-user-tie"></i> Nossos coaches</h2></div>
        ${coaches.length === 0
          ? `<div class="az-empty"><i class="fas fa-user-group"></i><p>Em breve mais coaches.</p></div>`
          : `<div class="az-coach-grid">${coaches.map(c => `
              <article class="az-coach-card">
                <div class="az-coach-cover" style="background-image:url('${esc(c.cover_url || '')}')">
                  <img class="az-coach-avatar" src="${esc(c.avatar_url || '/img/default-avatar.png')}" alt="">
                </div>
                <div class="az-coach-body">
                  <h3>${esc(c.display_name)} ${c.verified ? '<i class="fas fa-badge-check az-verified"></i>' : ''}</h3>
                  <p class="az-coach-headline">${esc(c.headline || 'Coach ZDAcademy')}</p>
                  <div class="az-coach-stats">
                    <span><i class="fas fa-star"></i> ${Number(c.rating_avg || 0).toFixed(1)}</span>
                    <span><i class="fas fa-users"></i> ${c.students_count || 0}</span>
                    <span><i class="fas fa-layer-group"></i> ${c.courses_count || 0} cursos</span>
                  </div>
                </div>
              </article>
            `).join('')}</div>`}
      </section>
    `;
  }

  // ─────────────────────────────────────────────────────
  // BECOME COACH (application form)
  // ─────────────────────────────────────────────────────
  async function renderBecomeCoach(vp) {
    vp.innerHTML = `
      <section class="az-section az-apply-section">
        <div class="az-apply-hero">
          <div class="az-apply-hero-icon"><i class="fas fa-rocket"></i></div>
          <h2>Seja um coach na ZDAcademy</h2>
          <p>Ensine o que você sabe, construa sua audiência e monetize seu conhecimento.</p>
        </div>
        <form class="az-form az-apply-form" id="azApplyForm">
          <div class="az-form-row">
            <label>Rank atual <input name="rank_current" placeholder="Ex: Imortal 2"></label>
            <label>Rank pico <input name="rank_peak" placeholder="Ex: Radiant"></label>
            <label>Anos jogando <input name="years_playing" type="number" min="0" max="20" placeholder="5"></label>
          </div>
          <label>Especialidades (separe com vírgula)
            <input name="specialties" placeholder="Controller, IGL, mira, review de partida">
          </label>
          <label>Motivação <span class="req">*</span>
            <textarea name="motivation" rows="4" required minlength="30" placeholder="Conte por que você seria um ótimo coach…"></textarea>
          </label>
          <label>Experiência
            <textarea name="experience" rows="3" placeholder="Times em que jogou, títulos, experiência prévia como coach…"></textarea>
          </label>
          <label>Links de vídeos (gameplay / highlight) — separe por vírgula
            <input name="video_links" placeholder="https://youtu.be/… , https://youtu.be/…">
          </label>
          <button class="az-btn az-btn-primary az-btn-lg" type="submit"><i class="fas fa-paper-plane"></i> Enviar candidatura</button>
        </form>
      </section>
    `;
    vp.querySelector('#azApplyForm').addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(e.target);
      const data = {
        rank_current: fd.get('rank_current')?.trim(),
        rank_peak: fd.get('rank_peak')?.trim(),
        years_playing: fd.get('years_playing'),
        specialties: (fd.get('specialties') || '').split(',').map(s => s.trim()).filter(Boolean),
        motivation: fd.get('motivation')?.trim(),
        experience: fd.get('experience')?.trim(),
        video_links: (fd.get('video_links') || '').split(',').map(s => s.trim()).filter(Boolean)
      };
      try {
        await AZ.coachApply(data);
        toast('Candidatura enviada! Aguarde a revisão do administrador.');
        navigate({ view: 'browse' });
      } catch (err) {
        toast(err.message || 'Erro ao enviar', 'error');
      }
    });
  }

  // ─────────────────────────────────────────────────────
  // COACH DASHBOARD
  // ─────────────────────────────────────────────────────
  async function renderCoachDashboard(vp, params) {
    const section = params.section || 'overview';

    if (section === 'course') {
      return renderCoachCourseEditor(vp, parseInt(params.courseId));
    }

    const [dash, courses] = await Promise.all([AZ.coachDash(), AZ.coachCourses()]);
    const { stats, recentCourses, pendingReview } = dash.data;

    vp.innerHTML = `
      <div class="az-dash">
        <header class="az-dash-head">
          <h2><i class="fas fa-chalkboard-teacher"></i> Painel do Coach</h2>
          <div class="az-dash-actions">
            <button class="az-btn az-btn-primary" id="azNewCourse"><i class="fas fa-plus"></i> Novo curso</button>
          </div>
        </header>

        <div class="az-stats-grid">
          ${statCard('fa-book', stats.total_courses, 'Cursos', stats.published_courses + ' publicados')}
          ${statCard('fa-user-group', stats.total_students, 'Alunos')}
          ${statCard('fa-star', Number(stats.avg_rating).toFixed(1), 'Avaliação média')}
        </div>

        <section class="az-dash-section">
          <div class="az-section-head">
            <h3><i class="fas fa-book"></i> Meus cursos</h3>
            ${pendingReview > 0 ? `<span class="az-badge-warn">${pendingReview} em análise</span>` : ''}
          </div>
          ${courses.data.length === 0
            ? `<div class="az-empty"><i class="fas fa-book-open"></i><p>Crie seu primeiro curso.</p><button class="az-btn az-btn-primary" id="azNewCourse2"><i class="fas fa-plus"></i> Novo curso</button></div>`
            : `<div class="az-coach-courses">${courses.data.map(c => `
                <div class="az-coach-course-row" data-course-id="${c.id}">
                  <div class="az-ccr-cover" style="background-image:url('${esc(c.cover_url || '/img/preload-bg.png')}')"></div>
                  <div class="az-ccr-main">
                    <div class="az-ccr-title">${esc(c.title)}</div>
                    <div class="az-ccr-tag">${esc(c.tagline || '')}</div>
                  </div>
                  <div class="az-ccr-stat"><span>${c.lessons_count || 0}</span><em>aulas</em></div>
                  <div class="az-ccr-stat"><span>${c.students_count || 0}</span><em>alunos</em></div>
                  <div class="az-ccr-stat"><span>${Number(c.rating_avg || 0).toFixed(1)}</span><em>★</em></div>
                  <span class="az-ccr-status" style="color:${STATUS_META[c.status].color}">${STATUS_META[c.status].label}</span>
                  <button class="az-btn az-btn-sm az-btn-primary az-ccr-edit"><i class="fas fa-pen"></i> Editar</button>
                </div>
              `).join('')}</div>`}
        </section>

      </div>
    `;

    const openNewCourse = () => openCourseModal();
    vp.querySelector('#azNewCourse')?.addEventListener('click', openNewCourse);
    vp.querySelector('#azNewCourse2')?.addEventListener('click', openNewCourse);

    vp.querySelectorAll('.az-coach-course-row').forEach(row => {
      row.querySelector('.az-ccr-edit')?.addEventListener('click', (e) => {
        e.stopPropagation();
        navigate({ view: 'coach', section: 'course', courseId: row.dataset.courseId });
      });
    });
  }

  function statCard(icon, value, label, sub) {
    return `
      <div class="az-stat-card">
        <div class="az-stat-icn"><i class="fas ${icon}"></i></div>
        <div class="az-stat-body">
          <div class="az-stat-value">${value}</div>
          <div class="az-stat-label">${label}</div>
          ${sub ? `<div class="az-stat-sub">${sub}</div>` : ''}
        </div>
      </div>
    `;
  }

  // ── Course editor (lessons management) ──
  async function renderCoachCourseEditor(vp, courseId) {
    if (!courseId) return navigate({ view: 'coach' });
    // Load course + lessons via public endpoint (works because isOwner in backend)
    const [coursesRes, catsRes] = await Promise.all([AZ.coachCourses(), Promise.resolve({ data: STATE.categories })]);
    const course = coursesRes.data.find(c => c.id === courseId);
    if (!course) return navigate({ view: 'coach' });

    const detail = await AZ.course(course.slug);
    const lessons = detail.data.lessons;
    const full = detail.data.course;

    const sm = STATUS_META[full.status] || STATUS_META.draft;
    vp.innerHTML = `
      <div class="az-editor">

        <!-- Top bar -->
        <div class="az-editor-topbar">
          <button class="az-editor-back" id="azBack">
            <i class="fas fa-arrow-left"></i> Voltar
          </button>
          <div class="az-editor-topbar-center">
            <span class="az-editor-breadcrumb">Painel Coach</span>
            <i class="fas fa-chevron-right az-editor-bc-sep"></i>
            <span class="az-editor-breadcrumb active">${esc(full.title)}</span>
          </div>
          <span class="az-editor-status-badge" style="--sc:${esc(sm.color)}">
            <span class="az-esb-dot"></span>${sm.label}
          </span>
        </div>

        <!-- Hero cover strip -->
        <div class="az-editor-hero" id="azEditorHero" style="background-image:url('${esc(full.cover_url || '/img/preload-bg.png')}')">
          <div class="az-editor-hero-shade"></div>
          <div class="az-editor-hero-info">
            <h1 class="az-editor-title">${esc(full.title)}</h1>
            ${full.tagline ? `<p class="az-editor-tagline">${esc(full.tagline)}</p>` : ''}
            <div class="az-editor-hero-meta">
              ${full.category_name ? `<span><i class="fas fa-tag"></i> ${esc(full.category_name)}</span>` : ''}
              <span><i class="fas fa-layer-group"></i> ${(DIFF_META[full.difficulty] || DIFF_META.iron).label}</span>
              <span><i class="fas fa-list-ul"></i> ${lessons.length} aula${lessons.length !== 1 ? 's' : ''}</span>
            </div>
          </div>
        </div>

        <!-- Body — 2 column -->
        <div class="az-editor-body">

          <!-- LEFT: settings form -->
          <div class="az-editor-col-form">

            <div class="az-editor-card">
              <div class="az-editor-card-head">
                <span class="az-editor-card-icon"><i class="fas fa-sliders"></i></span>
                <div>
                  <div class="az-editor-card-title">Informações da trilha</div>
                  <div class="az-editor-card-sub">Edite os detalhes visíveis pelos alunos</div>
                </div>
              </div>

              <form class="az-form" id="azCourseForm">
                <div class="az-form-row">
                  <label>Título</label>
                  <input name="title" value="${esc(full.title)}" maxlength="180" required placeholder="Nome da trilha">
                </div>
                <div class="az-form-row">
                  <label>Descrição</label>
                  <textarea name="description" rows="5" placeholder="O que o aluno vai aprender?">${esc(full.description || '')}</textarea>
                </div>
                <div class="az-form-row">
                  <label>Capa (URL)</label>
                  <input name="cover_url" id="azCoverUrl" value="${esc(full.cover_url || '')}" placeholder="https://…" maxlength="500">
                </div>
                <div class="az-form-cols">
                  <div class="az-form-row">
                    <label>Categoria</label>
                    <select name="category_id">
                      <option value="">—</option>
                      ${STATE.categories.map(c => `<option value="${c.id}" ${full.category_id===c.id?'selected':''}>${esc(c.name)}</option>`).join('')}
                    </select>
                  </div>
                  <div class="az-form-row">
                    <label>Dificuldade</label>
                    <select name="difficulty">
                      ${Object.entries(DIFF_META).map(([k, v]) => `<option value="${k}" ${full.difficulty===k?'selected':''}>${v.label}</option>`).join('')}
                    </select>
                  </div>
                </div>
                <div class="az-editor-form-actions">
                  <button class="az-btn az-btn-primary az-btn-full" type="submit">
                    <i class="fas fa-save"></i> Salvar alterações
                  </button>
                  ${full.status === 'draft' ? `
                    <button class="az-btn az-btn-ghost" type="button" id="azSubmit">
                      <i class="fas fa-paper-plane"></i> Enviar para revisão
                    </button>` : ''}
                </div>
              </form>
            </div>

          </div>

          <!-- RIGHT: lessons list -->
          <div class="az-editor-col-lessons">

            <div class="az-editor-card">
              <div class="az-editor-card-head">
                <span class="az-editor-card-icon az-editor-card-icon--cyan"><i class="fas fa-play-circle"></i></span>
                <div>
                  <div class="az-editor-card-title">Aulas da trilha</div>
                  <div class="az-editor-card-sub">${lessons.length} aula${lessons.length !== 1 ? 's' : ''} cadastrada${lessons.length !== 1 ? 's' : ''}</div>
                </div>
                <button class="az-btn az-btn-primary az-btn-sm az-editor-add-lesson" id="azAddLesson">
                  <i class="fas fa-plus"></i> Nova aula
                </button>
              </div>

              ${lessons.length === 0 ? `
                <div class="az-editor-empty-lessons">
                  <i class="fas fa-video"></i>
                  <p>Nenhuma aula ainda. Adicione a primeira!</p>
                </div>
              ` : `
                <ol class="az-editor-lessons" id="azLessonsList">
                  ${lessons.map((l, i) => `
                    <li class="az-editor-lesson" data-lesson-id="${l.id}">
                      <span class="az-el-num">${String(i+1).padStart(2,'0')}</span>
                      ${l.thumb_url
                        ? `<img class="az-el-thumb" src="${esc(l.thumb_url)}" alt="">`
                        : `<span class="az-el-thumb-empty"><i class="fas fa-play"></i></span>`}
                      <div class="az-el-main">
                        <div class="az-el-title">${esc(l.title)}</div>
                        <div class="az-el-pills">
                          ${l.is_preview ? '<span class="az-el-pill preview">PRÉVIA</span>' : ''}
                          <span class="az-el-pill"><i class="fas fa-clock"></i> ${fmtDuration(l.duration_sec)}</span>
                          ${l.video_type ? `<span class="az-el-pill">${esc(l.video_type)}</span>` : ''}
                        </div>
                      </div>
                      <div class="az-el-actions">
                        <button class="az-el-btn az-el-edit" title="Editar"><i class="fas fa-pen"></i></button>
                        <button class="az-el-btn az-el-del" title="Excluir"><i class="fas fa-trash"></i></button>
                      </div>
                    </li>
                  `).join('')}
                </ol>
              `}
            </div>

          </div>
        </div>
      </div>
    `;

    vp.querySelector('#azBack')?.addEventListener('click', () => navigate({ view: 'coach' }));
    vp.querySelector('#azCourseForm').addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(e.target);
      try {
        await AZ.updateCourse(full.id, {
          title: fd.get('title'),
          description: fd.get('description'),
          cover_url: fd.get('cover_url') || null,
          category_id: fd.get('category_id') ? parseInt(fd.get('category_id')) : null,
          difficulty: fd.get('difficulty'),
          is_free: true
        });
        toast('Curso atualizado');
      } catch (err) { toast(err.message || 'Erro', 'error'); }
    });
    vp.querySelector('#azSubmit')?.addEventListener('click', async () => {
      try { await AZ.submitCourse(full.id); toast('Enviado para revisão'); navigate({ view: 'coach', section: 'course', courseId: full.id }); }
      catch (err) { toast(err.message || 'Erro', 'error'); }
    });
    vp.querySelector('#azAddLesson')?.addEventListener('click', () => openLessonModal(full.id, null));

    // Live cover preview
    const coverInput = vp.querySelector('#azCoverUrl');
    const heroEl = vp.querySelector('#azEditorHero');
    if (coverInput && heroEl) {
      let debT;
      coverInput.addEventListener('input', () => {
        clearTimeout(debT);
        debT = setTimeout(() => {
          const url = coverInput.value.trim();
          if (url) heroEl.style.backgroundImage = `url('${url.replace(/'/g,"\\'")}')`;
        }, 600);
      });
    }

    vp.querySelectorAll('.az-editor-lesson').forEach(li => {
      li.querySelector('.az-el-edit')?.addEventListener('click', () => {
        const l = lessons.find(x => x.id === parseInt(li.dataset.lessonId));
        openLessonModal(full.id, l);
      });
      li.querySelector('.az-el-del')?.addEventListener('click', async () => {
        if (!confirm('Excluir esta aula?')) return;
        try { await AZ.deleteLesson(li.dataset.lessonId); toast('Aula excluída'); navigate({ view: 'coach', section: 'course', courseId: full.id }); }
        catch (err) { toast(err.message, 'error'); }
      });
    });
  }

  // ─────────────────────────────────────────────────────
  // MODALS — Course / Lesson / Live
  // ─────────────────────────────────────────────────────
  function openModal(html, onReady) {
    const wrap = document.getElementById('modals') || document.body;
    const el = document.createElement('div');
    el.className = 'az-modal-overlay';
    el.innerHTML = `<div class="az-modal">${html}</div>`;
    wrap.appendChild(el);
    const close = () => el.remove();
    el.addEventListener('click', (e) => { if (e.target === el) close(); });
    el.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click', close));
    onReady?.(el, close);
    return { el, close };
  }

  function openCourseModal() {
    const html = `
      <div class="az-modal-head">
        <div class="az-modal-head-inner">
          <span class="az-modal-icon"><i class="fas fa-graduation-cap"></i></span>
          <div><h3>Nova Trilha</h3><p class="az-modal-sub">Configure os detalhes da trilha de aprendizado</p></div>
        </div>
        <button data-close class="az-modal-x"><i class="fas fa-times"></i></button>
      </div>
      <form class="az-form" id="azCourseNew">
        <div class="az-form-row">
          <label>Título</label>
          <input name="title" required minlength="5" maxlength="180" placeholder="Ex: Do Ferro ao Radiante">
        </div>
        <div class="az-form-cols">
          <div class="az-form-row">
            <label>Categoria</label>
            <select name="category_id">
              ${STATE.categories.map(c => `<option value="${c.id}">${esc(c.name)}</option>`).join('')}
            </select>
          </div>
          <div class="az-form-row">
            <label>Dificuldade</label>
            <select name="difficulty">
              ${Object.entries(DIFF_META).map(([k, v]) => `<option value="${k}">${v.label}</option>`).join('')}
            </select>
          </div>
        </div>
        <div class="az-form-row">
          <label>Capa (URL)</label>
          <input name="cover_url" placeholder="https://…">
        </div>
        <div class="az-form-row">
          <label>Descrição</label>
          <textarea name="description" rows="4" placeholder="Do que se trata esta trilha?"></textarea>
        </div>
        <div class="az-modal-actions">
          <button type="button" data-close class="az-btn az-btn-ghost">Cancelar</button>
          <button type="submit" class="az-btn az-btn-primary"><i class="fas fa-plus"></i> Criar trilha</button>
        </div>
      </form>`;
    openModal(html, (el, close) => {
      el.querySelector('#azCourseNew').addEventListener('submit', async (e) => {
        e.preventDefault();
        const fd = new FormData(e.target);
        try {
          const r = await AZ.createCourse({
            title: fd.get('title'),
            category_id: parseInt(fd.get('category_id')) || null,
            difficulty: fd.get('difficulty'),
            cover_url: fd.get('cover_url') || null,
            description: fd.get('description'),
            is_free: true
          });
          toast('Curso criado');
          close();
          navigate({ view: 'coach', section: 'course', courseId: r.data.id });
        } catch (err) { toast(err.message || 'Erro', 'error'); }
      });
    });
  }

  function openLessonModal(courseId, lesson) {
    const editing = !!lesson;
    const html = `
      <div class="az-modal-head">
        <div class="az-modal-head-inner">
          <span class="az-modal-icon"><i class="fas fa-play-circle"></i></span>
          <div><h3>${editing ? 'Editar aula' : 'Nova aula'}</h3><p class="az-modal-sub">${editing ? 'Atualize os dados da aula' : 'Adicione uma nova vídeo-aula à trilha'}</p></div>
        </div>
        <button data-close class="az-modal-x"><i class="fas fa-times"></i></button>
      </div>
      <form class="az-form" id="azLessonForm">
        <div class="az-form-row">
          <label>Título</label>
          <input name="title" required minlength="3" maxlength="180" value="${esc(lesson?.title || '')}" placeholder="Ex: Introdução ao Crosshair Placement">
        </div>
        <div class="az-form-row">
          <label>URL do vídeo <span class="az-form-hint">YouTube, Vimeo, .mp4, .m3u8</span></label>
          <input name="video_url" required value="${esc(lesson?.video_url || '')}" placeholder="https://youtu.be/…">
        </div>
        <div class="az-form-cols">
          <div class="az-form-row">
            <label>Duração (segundos)</label>
            <input name="duration_sec" type="number" min="0" value="${lesson?.duration_sec || 0}">
          </div>
          <label class="az-check" style="align-self:end;margin-bottom:12px"><input type="checkbox" name="is_preview" ${lesson?.is_preview?'checked':''}> <span>Liberar como prévia</span></label>
        </div>
        <div class="az-form-row">
          <label>Descrição</label>
          <textarea name="description" rows="3" placeholder="Opcional">${esc(lesson?.description || '')}</textarea>
        </div>
        <div class="az-modal-actions">
          <button type="button" data-close class="az-btn az-btn-ghost">Cancelar</button>
          <button type="submit" class="az-btn az-btn-primary"><i class="fas fa-${editing ? 'save' : 'plus'}"></i> ${editing ? 'Salvar' : 'Adicionar aula'}</button>
        </div>
      </form>`;
    openModal(html, (el, close) => {
      el.querySelector('#azLessonForm').addEventListener('submit', async (e) => {
        e.preventDefault();
        const fd = new FormData(e.target);
        const data = {
          title: fd.get('title'),
          video_url: fd.get('video_url'),
          duration_sec: parseInt(fd.get('duration_sec')) || 0,
          is_preview: fd.get('is_preview') === 'on',
          description: fd.get('description')
        };
        try {
          if (editing) await AZ.updateLesson(lesson.id, data);
          else await AZ.addLesson(courseId, data);
          toast('OK');
          close();
          navigate({ view: 'coach', section: 'course', courseId });
        } catch (err) { toast(err.message || 'Erro', 'error'); }
      });
    });
  }

  // ─────────────────────────────────────────────────────
  // TOAST
  // ─────────────────────────────────────────────────────
  function toast(msg, type = 'info') {
    if (window.utils?.showToast) return window.utils.showToast(msg, type);
    const c = document.getElementById('toastContainer') || document.body;
    const t = document.createElement('div');
    t.className = `toast toast-${type}`;
    t.textContent = msg;
    c.appendChild(t);
    setTimeout(() => t.remove(), 3500);
  }

  return { load };
})();

if (typeof window !== 'undefined') window.academy = academy;

